
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb8be"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb8be"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gbZaU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $59a9e860c82ab4df$export$2e2bcd8739ae039; });
parcelRequire("hQJKw");
var $esfUo = parcelRequire("esfUo");
parcelRequire("6x6HK");
var $6AdLA = parcelRequire("6AdLA");
var $59a9e860c82ab4df$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $esfUo.defineComponent)({
    __name: "App",
    setup (__props, { expose: expose }) {
        expose();
        (0, $6AdLA.useRecaptchaProvider)();
        const __returned__ = {};
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("hQJKw", function(module, exports) {
$parcel$export(module.exports, "computed", function () { return (parcelRequire("esfUo")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("esfUo")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("esfUo")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("esfUo")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("esfUo")).createElementVNode; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("esfUo")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("esfUo")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("esfUo")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("esfUo")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("esfUo")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("esfUo")).getCurrentInstance; });
$parcel$export(module.exports, "guardReactiveProps", function () { return (parcelRequire("esfUo")).guardReactiveProps; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("esfUo")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("esfUo")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("esfUo")).inject; });
$parcel$export(module.exports, "isReactive", function () { return (parcelRequire("am4TS")).isReactive; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("am4TS")).isRef; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("esfUo")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("8ENGG")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("8ENGG")).normalizeStyle; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("esfUo")).onActivated; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("esfUo")).onBeforeMount; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("esfUo")).onBeforeUnmount; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("esfUo")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("esfUo")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("esfUo")).onUnmounted; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("esfUo")).openBlock; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("esfUo")).popScopeId; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("esfUo")).provide; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("esfUo")).pushScopeId; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("am4TS")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("am4TS")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("esfUo")).renderList; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("esfUo")).renderSlot; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("esfUo")).resolveComponent; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return (parcelRequire("esfUo")).resolveDynamicComponent; });
$parcel$export(module.exports, "version", function () { return (parcelRequire("esfUo")).version; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("esfUo")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("esfUo")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("esfUo")).watchEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("esfUo")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("esfUo")).withDirectives; });
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("NPJVB")).createApp; });
$parcel$export(module.exports, "vModelText", function () { return (parcelRequire("NPJVB")).vModelText; });
$parcel$export(module.exports, "withModifiers", function () { return (parcelRequire("NPJVB")).withModifiers; });
$parcel$export(module.exports, "customRef", function () { return (parcelRequire("am4TS")).customRef; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("am4TS")).effectScope; });
$parcel$export(module.exports, "getCurrentScope", function () { return (parcelRequire("am4TS")).getCurrentScope; });
$parcel$export(module.exports, "onScopeDispose", function () { return (parcelRequire("am4TS")).onScopeDispose; });
$parcel$export(module.exports, "readonly", function () { return (parcelRequire("am4TS")).readonly; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("am4TS")).shallowRef; });
$parcel$export(module.exports, "toRef", function () { return (parcelRequire("am4TS")).toRef; });
$parcel$export(module.exports, "toRefs", function () { return (parcelRequire("am4TS")).toRefs; });
$parcel$export(module.exports, "unref", function () { return (parcelRequire("am4TS")).unref; });
$parcel$export(module.exports, "normalizeProps", function () { return (parcelRequire("8ENGG")).normalizeProps; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("8ENGG")).toDisplayString; });

var $esfUo = parcelRequire("esfUo");parcelRequire("NPJVB");parcelRequire("am4TS");parcelRequire("8ENGG");
function $cfeac7dfc2e77acb$var$initDev() {
    (0, $esfUo.initCustomFormatter)();
}
const $cfeac7dfc2e77acb$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("esfUo", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $a8600556d6c14ba3$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $a8600556d6c14ba3$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $a8600556d6c14ba3$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "Fragment", function () { return $a8600556d6c14ba3$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Static", function () { return $a8600556d6c14ba3$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "pushScopeId", function () { return $a8600556d6c14ba3$export$ac020265ca2cc4cd; });
$parcel$export(module.exports, "popScopeId", function () { return $a8600556d6c14ba3$export$f2dc6805dc11834e; });
$parcel$export(module.exports, "withCtx", function () { return $a8600556d6c14ba3$export$694b237e827a3d23; });
$parcel$export(module.exports, "createVNode", function () { return $a8600556d6c14ba3$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "openBlock", function () { return $a8600556d6c14ba3$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "provide", function () { return $a8600556d6c14ba3$export$abe1e183e22e10ad; });
$parcel$export(module.exports, "inject", function () { return $a8600556d6c14ba3$export$a976684a0efeb93f; });
$parcel$export(module.exports, "watchEffect", function () { return $a8600556d6c14ba3$export$ede35fc0e5500309; });
$parcel$export(module.exports, "watchPostEffect", function () { return $a8600556d6c14ba3$export$b7f27ea67102d543; });
$parcel$export(module.exports, "watch", function () { return $a8600556d6c14ba3$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "useTransitionState", function () { return $a8600556d6c14ba3$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $a8600556d6c14ba3$export$6d1641039221b5cb; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return $a8600556d6c14ba3$export$40c420df62d2614; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $a8600556d6c14ba3$export$f13e630aa3915748; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $a8600556d6c14ba3$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $a8600556d6c14ba3$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $a8600556d6c14ba3$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $a8600556d6c14ba3$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "defineComponent", function () { return $a8600556d6c14ba3$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "onUpdated", function () { return $a8600556d6c14ba3$export$5876c47052fb88b1; });
$parcel$export(module.exports, "onActivated", function () { return $a8600556d6c14ba3$export$ba52d824b95a2154; });
$parcel$export(module.exports, "onDeactivated", function () { return $a8600556d6c14ba3$export$bf1440eeaf5fa709; });
$parcel$export(module.exports, "onUnmounted", function () { return $a8600556d6c14ba3$export$13348a43ccacfe58; });
$parcel$export(module.exports, "onBeforeMount", function () { return $a8600556d6c14ba3$export$23b7aeb0d671f804; });
$parcel$export(module.exports, "withDirectives", function () { return $a8600556d6c14ba3$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "resolveComponent", function () { return $a8600556d6c14ba3$export$681d65eec9d1d1e8; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return $a8600556d6c14ba3$export$b44c564a05ca975; });
$parcel$export(module.exports, "renderList", function () { return $a8600556d6c14ba3$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "renderSlot", function () { return $a8600556d6c14ba3$export$4abee4c34694ada1; });
$parcel$export(module.exports, "createBlock", function () { return $a8600556d6c14ba3$export$9f2dfe8048dfb22b; });
$parcel$export(module.exports, "computed", function () { return $a8600556d6c14ba3$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "version", function () { return $a8600556d6c14ba3$export$83d89fbfd8236492; });
$parcel$export(module.exports, "createTextVNode", function () { return $a8600556d6c14ba3$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "createRenderer", function () { return $a8600556d6c14ba3$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $a8600556d6c14ba3$export$200524cf0d997ff0; });
$parcel$export(module.exports, "createElementBlock", function () { return $a8600556d6c14ba3$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $a8600556d6c14ba3$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "guardReactiveProps", function () { return $a8600556d6c14ba3$export$1f1be0e0e384d7d2; });
$parcel$export(module.exports, "createStaticVNode", function () { return $a8600556d6c14ba3$export$33a9f6dd2840e6bb; });
$parcel$export(module.exports, "createCommentVNode", function () { return $a8600556d6c14ba3$export$49553837c7236d3c; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $a8600556d6c14ba3$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "h", function () { return $a8600556d6c14ba3$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $a8600556d6c14ba3$export$aed4979be6a60047; });
$parcel$export(module.exports, "isReactive", function () { return (parcelRequire("am4TS")).isReactive; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("am4TS")).isRef; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("am4TS")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("am4TS")).ref; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("am4TS")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("8ENGG")).camelize; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("8ENGG")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("8ENGG")).normalizeStyle; });

var $am4TS = parcelRequire("am4TS");

var $8ENGG = parcelRequire("8ENGG");
const $a8600556d6c14ba3$var$stack = [];
function $a8600556d6c14ba3$var$pushWarningContext(vnode) {
    $a8600556d6c14ba3$var$stack.push(vnode);
}
function $a8600556d6c14ba3$var$popWarningContext() {
    $a8600556d6c14ba3$var$stack.pop();
}
function $a8600556d6c14ba3$export$c106dd0671a0fc2d(msg, ...args) {
    // avoid props formatting or warn handler tracking deps that might be mutated
    // during patch, leading to infinite recursion.
    (0, $am4TS.pauseTracking)();
    const instance = $a8600556d6c14ba3$var$stack.length ? $a8600556d6c14ba3$var$stack[$a8600556d6c14ba3$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $a8600556d6c14ba3$var$getComponentTrace();
    if (appWarnHandler) $a8600556d6c14ba3$export$b22fcaf88446e9bf(appWarnHandler, instance, 11 /* ErrorCodes.APP_WARN_HANDLER */ , [
        msg + args.join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$a8600556d6c14ba3$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        /* istanbul ignore if */ if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`\n`, ...$a8600556d6c14ba3$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $am4TS.resetTracking)();
}
function $a8600556d6c14ba3$var$getComponentTrace() {
    let currentVNode = $a8600556d6c14ba3$var$stack[$a8600556d6c14ba3$var$stack.length - 1];
    if (!currentVNode) return [];
    // we can't just use the stack because it will be incomplete during updates
    // that did not start from the root. Re-construct the parent chain using
    // instance parent pointers.
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
/* istanbul ignore next */ function $a8600556d6c14ba3$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `\n`
        ], ...$a8600556d6c14ba3$var$formatTraceEntry(entry));
    });
    return logs;
}
function $a8600556d6c14ba3$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$a8600556d6c14ba3$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$a8600556d6c14ba3$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
/* istanbul ignore next */ function $a8600556d6c14ba3$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$a8600556d6c14ba3$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
/* istanbul ignore next */ function $a8600556d6c14ba3$var$formatProp(key, value, raw) {
    if ((0, $8ENGG.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $am4TS.isRef)(value)) {
        value = $a8600556d6c14ba3$var$formatProp(key, (0, $am4TS.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8ENGG.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $am4TS.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
const $a8600556d6c14ba3$var$ErrorTypeStrings = {
    ["sp" /* LifecycleHooks.SERVER_PREFETCH */ ]: "serverPrefetch hook",
    ["bc" /* LifecycleHooks.BEFORE_CREATE */ ]: "beforeCreate hook",
    ["c" /* LifecycleHooks.CREATED */ ]: "created hook",
    ["bm" /* LifecycleHooks.BEFORE_MOUNT */ ]: "beforeMount hook",
    ["m" /* LifecycleHooks.MOUNTED */ ]: "mounted hook",
    ["bu" /* LifecycleHooks.BEFORE_UPDATE */ ]: "beforeUpdate hook",
    ["u" /* LifecycleHooks.UPDATED */ ]: "updated",
    ["bum" /* LifecycleHooks.BEFORE_UNMOUNT */ ]: "beforeUnmount hook",
    ["um" /* LifecycleHooks.UNMOUNTED */ ]: "unmounted hook",
    ["a" /* LifecycleHooks.ACTIVATED */ ]: "activated hook",
    ["da" /* LifecycleHooks.DEACTIVATED */ ]: "deactivated hook",
    ["ec" /* LifecycleHooks.ERROR_CAPTURED */ ]: "errorCaptured hook",
    ["rtc" /* LifecycleHooks.RENDER_TRACKED */ ]: "renderTracked hook",
    ["rtg" /* LifecycleHooks.RENDER_TRIGGERED */ ]: "renderTriggered hook",
    [0 /* ErrorCodes.SETUP_FUNCTION */ ]: "setup function",
    [1 /* ErrorCodes.RENDER_FUNCTION */ ]: "render function",
    [2 /* ErrorCodes.WATCH_GETTER */ ]: "watcher getter",
    [3 /* ErrorCodes.WATCH_CALLBACK */ ]: "watcher callback",
    [4 /* ErrorCodes.WATCH_CLEANUP */ ]: "watcher cleanup function",
    [5 /* ErrorCodes.NATIVE_EVENT_HANDLER */ ]: "native event handler",
    [6 /* ErrorCodes.COMPONENT_EVENT_HANDLER */ ]: "component event handler",
    [7 /* ErrorCodes.VNODE_HOOK */ ]: "vnode hook",
    [8 /* ErrorCodes.DIRECTIVE_HOOK */ ]: "directive hook",
    [9 /* ErrorCodes.TRANSITION_HOOK */ ]: "transition hook",
    [10 /* ErrorCodes.APP_ERROR_HANDLER */ ]: "app errorHandler",
    [11 /* ErrorCodes.APP_WARN_HANDLER */ ]: "app warnHandler",
    [12 /* ErrorCodes.FUNCTION_REF */ ]: "ref function",
    [13 /* ErrorCodes.ASYNC_COMPONENT_LOADER */ ]: "async component loader",
    [14 /* ErrorCodes.SCHEDULER */ ]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function $a8600556d6c14ba3$export$b22fcaf88446e9bf(fn, instance, type, args) {
    let res;
    try {
        res = args ? fn(...args) : fn();
    } catch (err) {
        $a8600556d6c14ba3$export$d3da1ecaf1206c58(err, instance, type);
    }
    return res;
}
function $a8600556d6c14ba3$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8ENGG.isFunction)(fn)) {
        const res = $a8600556d6c14ba3$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8ENGG.isPromise)(res)) res.catch((err)=>{
            $a8600556d6c14ba3$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    const values = [];
    for(let i = 0; i < fn.length; i++)values.push($a8600556d6c14ba3$export$dae85862a8d94378(fn[i], instance, type, args));
    return values;
}
function $a8600556d6c14ba3$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        // the exposed instance is the render proxy to keep it consistent with 2.x
        const exposedInstance = instance.proxy;
        // in production the hook receives only the error code
        const errorInfo = type;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        // app-level handling
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            $a8600556d6c14ba3$export$b22fcaf88446e9bf(appErrorHandler, null, 10 /* ErrorCodes.APP_ERROR_HANDLER */ , [
                err,
                exposedInstance,
                errorInfo
            ]);
            return;
        }
    }
    $a8600556d6c14ba3$var$logError(err, type, contextVNode, throwInDev);
}
function $a8600556d6c14ba3$var$logError(err, type, contextVNode, throwInDev = true) {
    // recover in prod to reduce the impact on end-user
    console.error(err);
}
let $a8600556d6c14ba3$var$isFlushing = false;
let $a8600556d6c14ba3$var$isFlushPending = false;
const $a8600556d6c14ba3$var$queue = [];
let $a8600556d6c14ba3$var$flushIndex = 0;
const $a8600556d6c14ba3$var$pendingPostFlushCbs = [];
let $a8600556d6c14ba3$var$activePostFlushCbs = null;
let $a8600556d6c14ba3$var$postFlushIndex = 0;
const $a8600556d6c14ba3$var$resolvedPromise = /*#__PURE__*/ Promise.resolve();
let $a8600556d6c14ba3$var$currentFlushPromise = null;
const $a8600556d6c14ba3$var$RECURSION_LIMIT = 100;
function $a8600556d6c14ba3$export$bdd553fddd433dcb(fn) {
    const p = $a8600556d6c14ba3$var$currentFlushPromise || $a8600556d6c14ba3$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
// #2768
// Use binary-search to find a suitable position in the queue,
// so that the queue maintains the increasing order of job's id,
// which can prevent the job from being skipped and also can avoid repeated patching.
function $a8600556d6c14ba3$var$findInsertionIndex(id) {
    // the start index should be `flushIndex + 1`
    let start = $a8600556d6c14ba3$var$flushIndex + 1;
    let end = $a8600556d6c14ba3$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJobId = $a8600556d6c14ba3$var$getId($a8600556d6c14ba3$var$queue[middle]);
        middleJobId < id ? start = middle + 1 : end = middle;
    }
    return start;
}
function $a8600556d6c14ba3$var$queueJob(job) {
    // the dedupe search uses the startIndex argument of Array.includes()
    // by default the search index includes the current job that is being run
    // so it cannot recursively trigger itself again.
    // if the job is a watch() callback, the search will start with a +1 index to
    // allow it recursively trigger itself - it is the user's responsibility to
    // ensure it doesn't end up in an infinite loop.
    if (!$a8600556d6c14ba3$var$queue.length || !$a8600556d6c14ba3$var$queue.includes(job, $a8600556d6c14ba3$var$isFlushing && job.allowRecurse ? $a8600556d6c14ba3$var$flushIndex + 1 : $a8600556d6c14ba3$var$flushIndex)) {
        if (job.id == null) $a8600556d6c14ba3$var$queue.push(job);
        else $a8600556d6c14ba3$var$queue.splice($a8600556d6c14ba3$var$findInsertionIndex(job.id), 0, job);
        $a8600556d6c14ba3$var$queueFlush();
    }
}
function $a8600556d6c14ba3$var$queueFlush() {
    if (!$a8600556d6c14ba3$var$isFlushing && !$a8600556d6c14ba3$var$isFlushPending) {
        $a8600556d6c14ba3$var$isFlushPending = true;
        $a8600556d6c14ba3$var$currentFlushPromise = $a8600556d6c14ba3$var$resolvedPromise.then($a8600556d6c14ba3$var$flushJobs);
    }
}
function $a8600556d6c14ba3$var$invalidateJob(job) {
    const i = $a8600556d6c14ba3$var$queue.indexOf(job);
    if (i > $a8600556d6c14ba3$var$flushIndex) $a8600556d6c14ba3$var$queue.splice(i, 1);
}
function $a8600556d6c14ba3$export$59536a0199721cab(cb) {
    if (!(0, $8ENGG.isArray)(cb)) {
        if (!$a8600556d6c14ba3$var$activePostFlushCbs || !$a8600556d6c14ba3$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $a8600556d6c14ba3$var$postFlushIndex + 1 : $a8600556d6c14ba3$var$postFlushIndex)) $a8600556d6c14ba3$var$pendingPostFlushCbs.push(cb);
    } else // if cb is an array, it is a component lifecycle hook which can only be
    // triggered by a job, which is already deduped in the main queue, so
    // we can skip duplicate check here to improve perf
    $a8600556d6c14ba3$var$pendingPostFlushCbs.push(...cb);
    $a8600556d6c14ba3$var$queueFlush();
}
function $a8600556d6c14ba3$var$flushPreFlushCbs(seen, // if currently flushing, skip the current job itself
i = $a8600556d6c14ba3$var$isFlushing ? $a8600556d6c14ba3$var$flushIndex + 1 : 0) {
    for(; i < $a8600556d6c14ba3$var$queue.length; i++){
        const cb = $a8600556d6c14ba3$var$queue[i];
        if (cb && cb.pre) {
            $a8600556d6c14ba3$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $a8600556d6c14ba3$var$flushPostFlushCbs(seen) {
    if ($a8600556d6c14ba3$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($a8600556d6c14ba3$var$pendingPostFlushCbs)
        ];
        $a8600556d6c14ba3$var$pendingPostFlushCbs.length = 0;
        // #1947 already has active queue, nested flushPostFlushCbs call
        if ($a8600556d6c14ba3$var$activePostFlushCbs) {
            $a8600556d6c14ba3$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $a8600556d6c14ba3$var$activePostFlushCbs = deduped;
        $a8600556d6c14ba3$var$activePostFlushCbs.sort((a, b)=>$a8600556d6c14ba3$var$getId(a) - $a8600556d6c14ba3$var$getId(b));
        for($a8600556d6c14ba3$var$postFlushIndex = 0; $a8600556d6c14ba3$var$postFlushIndex < $a8600556d6c14ba3$var$activePostFlushCbs.length; $a8600556d6c14ba3$var$postFlushIndex++)$a8600556d6c14ba3$var$activePostFlushCbs[$a8600556d6c14ba3$var$postFlushIndex]();
        $a8600556d6c14ba3$var$activePostFlushCbs = null;
        $a8600556d6c14ba3$var$postFlushIndex = 0;
    }
}
const $a8600556d6c14ba3$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $a8600556d6c14ba3$var$comparator = (a, b)=>{
    const diff = $a8600556d6c14ba3$var$getId(a) - $a8600556d6c14ba3$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $a8600556d6c14ba3$var$flushJobs(seen) {
    $a8600556d6c14ba3$var$isFlushPending = false;
    $a8600556d6c14ba3$var$isFlushing = true;
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child so its render effect will have smaller
    //    priority number)
    // 2. If a component is unmounted during a parent component's update,
    //    its update can be skipped.
    $a8600556d6c14ba3$var$queue.sort($a8600556d6c14ba3$var$comparator);
    // conditional usage of checkRecursiveUpdate must be determined out of
    // try ... catch block since Rollup by default de-optimizes treeshaking
    // inside try-catch. This can leave all warning code unshaked. Although
    // they would get eventually shaken by a minifier like terser, some minifiers
    // would fail to do that (e.g. https://github.com/evanw/esbuild/issues/1610)
    const check = (0, $8ENGG.NOOP);
    try {
        for($a8600556d6c14ba3$var$flushIndex = 0; $a8600556d6c14ba3$var$flushIndex < $a8600556d6c14ba3$var$queue.length; $a8600556d6c14ba3$var$flushIndex++){
            const job = $a8600556d6c14ba3$var$queue[$a8600556d6c14ba3$var$flushIndex];
            if (job && job.active !== false) // console.log(`running:`, job.id)
            $a8600556d6c14ba3$export$b22fcaf88446e9bf(job, null, 14 /* ErrorCodes.SCHEDULER */ );
        }
    } finally{
        $a8600556d6c14ba3$var$flushIndex = 0;
        $a8600556d6c14ba3$var$queue.length = 0;
        $a8600556d6c14ba3$var$flushPostFlushCbs(seen);
        $a8600556d6c14ba3$var$isFlushing = false;
        $a8600556d6c14ba3$var$currentFlushPromise = null;
        // some postFlushCb queued jobs!
        // keep flushing until it drains.
        if ($a8600556d6c14ba3$var$queue.length || $a8600556d6c14ba3$var$pendingPostFlushCbs.length) $a8600556d6c14ba3$var$flushJobs(seen);
    }
}
function $a8600556d6c14ba3$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $a8600556d6c14ba3$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $a8600556d6c14ba3$var$getComponentName(instance.type);
            $a8600556d6c14ba3$export$c106dd0671a0fc2d(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. ` + `This means you have a reactive effect that is mutating its own ` + `dependencies and thus recursively triggering itself. Possible sources ` + `include component template, render function, updated hook or ` + `watcher source function.`);
            return true;
        } else seen.set(fn, count + 1);
    }
}
/* eslint-disable no-restricted-globals */ let $a8600556d6c14ba3$var$isHmrUpdating = false;
const $a8600556d6c14ba3$var$hmrDirtyComponents = new Set();
const $a8600556d6c14ba3$var$map = new Map();
function $a8600556d6c14ba3$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $a8600556d6c14ba3$var$map.get(id);
    if (!record) {
        $a8600556d6c14ba3$var$createRecord(id, instance.type);
        record = $a8600556d6c14ba3$var$map.get(id);
    }
    record.instances.add(instance);
}
function $a8600556d6c14ba3$var$unregisterHMR(instance) {
    $a8600556d6c14ba3$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $a8600556d6c14ba3$var$createRecord(id, initialDef) {
    if ($a8600556d6c14ba3$var$map.has(id)) return false;
    $a8600556d6c14ba3$var$map.set(id, {
        initialDef: $a8600556d6c14ba3$var$normalizeClassComponent(initialDef),
        instances: new Set()
    });
    return true;
}
function $a8600556d6c14ba3$var$normalizeClassComponent(component) {
    return $a8600556d6c14ba3$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $a8600556d6c14ba3$var$rerender(id, newRender) {
    const record = $a8600556d6c14ba3$var$map.get(id);
    if (!record) return;
    // update initial record (for not-yet-rendered component)
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $a8600556d6c14ba3$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        // this flag forces child components with slot content to update
        $a8600556d6c14ba3$var$isHmrUpdating = true;
        instance.update();
        $a8600556d6c14ba3$var$isHmrUpdating = false;
    });
}
function $a8600556d6c14ba3$var$reload(id, newComp) {
    const record = $a8600556d6c14ba3$var$map.get(id);
    if (!record) return;
    newComp = $a8600556d6c14ba3$var$normalizeClassComponent(newComp);
    // update initial def (for not-yet-rendered components)
    $a8600556d6c14ba3$var$updateComponentDef(record.initialDef, newComp);
    // create a snapshot which avoids the set being mutated during updates
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $a8600556d6c14ba3$var$normalizeClassComponent(instance.type);
        if (!$a8600556d6c14ba3$var$hmrDirtyComponents.has(oldComp)) {
            // 1. Update existing comp definition to match new one
            if (oldComp !== record.initialDef) $a8600556d6c14ba3$var$updateComponentDef(oldComp, newComp);
            // 2. mark definition dirty. This forces the renderer to replace the
            // component on patch.
            $a8600556d6c14ba3$var$hmrDirtyComponents.add(oldComp);
        }
        // 3. invalidate options resolution cache
        instance.appContext.optionsCache.delete(instance.type);
        // 4. actually update
        if (instance.ceReload) {
            // custom element
            $a8600556d6c14ba3$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $a8600556d6c14ba3$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) {
            // 4. Force the parent instance to re-render. This will cause all updated
            // components to be unmounted and re-mounted. Queue the update so that we
            // don't end up forcing the same parent to re-render multiple times.
            $a8600556d6c14ba3$var$queueJob(instance.parent.update);
            // instance is the inner component of an async custom element
            // invoke to reset styles
            if (instance.parent.type.__asyncLoader && instance.parent.ceReload) instance.parent.ceReload(newComp.styles);
        } else if (instance.appContext.reload) // root instance mounted via createApp() has a reload method
        instance.appContext.reload();
        else if (typeof window !== "undefined") // root instance inside tree created via raw render(). Force reload.
        window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    // 5. make sure to cleanup dirty hmr components after update
    $a8600556d6c14ba3$export$59536a0199721cab(()=>{
        for (const instance of instances)$a8600556d6c14ba3$var$hmrDirtyComponents.delete($a8600556d6c14ba3$var$normalizeClassComponent(instance.type));
    });
}
function $a8600556d6c14ba3$var$updateComponentDef(oldComp, newComp) {
    (0, $8ENGG.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $a8600556d6c14ba3$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. ` + `Full reload required.`);
        }
    };
}
let $a8600556d6c14ba3$export$6922d3b3a607469e;
let $a8600556d6c14ba3$var$buffer = [];
let $a8600556d6c14ba3$var$devtoolsNotInstalled = false;
function $a8600556d6c14ba3$var$emit(event, ...args) {
    if ($a8600556d6c14ba3$export$6922d3b3a607469e) $a8600556d6c14ba3$export$6922d3b3a607469e.emit(event, ...args);
    else if (!$a8600556d6c14ba3$var$devtoolsNotInstalled) $a8600556d6c14ba3$var$buffer.push({
        event: event,
        args: args
    });
}
function $a8600556d6c14ba3$export$b0c258b32c26c785(hook, target) {
    var _a, _b;
    $a8600556d6c14ba3$export$6922d3b3a607469e = hook;
    if ($a8600556d6c14ba3$export$6922d3b3a607469e) {
        $a8600556d6c14ba3$export$6922d3b3a607469e.enabled = true;
        $a8600556d6c14ba3$var$buffer.forEach(({ event: event, args: args })=>$a8600556d6c14ba3$export$6922d3b3a607469e.emit(event, ...args));
        $a8600556d6c14ba3$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) === null || _b === void 0 ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $a8600556d6c14ba3$export$b0c258b32c26c785(newHook, target);
        });
        // clear buffer after 3s - the user probably doesn't have devtools installed
        // at all, and keeping the buffer will cause memory leaks (#4738)
        setTimeout(()=>{
            if (!$a8600556d6c14ba3$export$6922d3b3a607469e) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $a8600556d6c14ba3$var$devtoolsNotInstalled = true;
                $a8600556d6c14ba3$var$buffer = [];
            }
        }, 3000);
    } else {
        // non-browser env, assume not installed
        $a8600556d6c14ba3$var$devtoolsNotInstalled = true;
        $a8600556d6c14ba3$var$buffer = [];
    }
}
function $a8600556d6c14ba3$var$devtoolsInitApp(app, version) {
    $a8600556d6c14ba3$var$emit("app:init" /* DevtoolsHooks.APP_INIT */ , app, version, {
        Fragment: $a8600556d6c14ba3$export$ffb0004e005737fa,
        Text: $a8600556d6c14ba3$export$5f1af8db9871e1d6,
        Comment: $a8600556d6c14ba3$export$4d299b491347818a,
        Static: $a8600556d6c14ba3$export$c1b9a1d3af45b7b6
    });
}
function $a8600556d6c14ba3$var$devtoolsUnmountApp(app) {
    $a8600556d6c14ba3$var$emit("app:unmount" /* DevtoolsHooks.APP_UNMOUNT */ , app);
}
const $a8600556d6c14ba3$var$devtoolsComponentAdded = /*#__PURE__*/ $a8600556d6c14ba3$var$createDevtoolsComponentHook("component:added" /* DevtoolsHooks.COMPONENT_ADDED */ );
const $a8600556d6c14ba3$var$devtoolsComponentUpdated = /*#__PURE__*/ $a8600556d6c14ba3$var$createDevtoolsComponentHook("component:updated" /* DevtoolsHooks.COMPONENT_UPDATED */ );
const $a8600556d6c14ba3$var$_devtoolsComponentRemoved = /*#__PURE__*/ $a8600556d6c14ba3$var$createDevtoolsComponentHook("component:removed" /* DevtoolsHooks.COMPONENT_REMOVED */ );
const $a8600556d6c14ba3$var$devtoolsComponentRemoved = (component)=>{
    if ($a8600556d6c14ba3$export$6922d3b3a607469e && typeof $a8600556d6c14ba3$export$6922d3b3a607469e.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$a8600556d6c14ba3$export$6922d3b3a607469e.cleanupBuffer(component)) $a8600556d6c14ba3$var$_devtoolsComponentRemoved(component);
};
function $a8600556d6c14ba3$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $a8600556d6c14ba3$var$emit(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : undefined, component);
    };
}
const $a8600556d6c14ba3$var$devtoolsPerfStart = /*#__PURE__*/ $a8600556d6c14ba3$var$createDevtoolsPerformanceHook("perf:start" /* DevtoolsHooks.PERFORMANCE_START */ );
const $a8600556d6c14ba3$var$devtoolsPerfEnd = /*#__PURE__*/ $a8600556d6c14ba3$var$createDevtoolsPerformanceHook("perf:end" /* DevtoolsHooks.PERFORMANCE_END */ );
function $a8600556d6c14ba3$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $a8600556d6c14ba3$var$emit(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $a8600556d6c14ba3$var$devtoolsComponentEmit(component, event, params) {
    $a8600556d6c14ba3$var$emit("component:emit" /* DevtoolsHooks.COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $a8600556d6c14ba3$var$emit$1(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8ENGG.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    // for v-model update:xxx events, apply modifiers on args
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $8ENGG.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>a.trim());
        if (number) args = rawArgs.map((0, $8ENGG.toNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $a8600556d6c14ba3$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8ENGG.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8ENGG.toHandlerKey)((0, $8ENGG.camelize)(event))];
    // for v-model update:xxx events, also trigger kebab-case equivalent
    // for props passed via kebab-case
    if (!handler && isModelListener) handler = props[handlerName = (0, $8ENGG.toHandlerKey)((0, $8ENGG.hyphenate)(event))];
    if (handler) $a8600556d6c14ba3$export$dae85862a8d94378(handler, instance, 6 /* ErrorCodes.COMPONENT_EVENT_HANDLER */ , args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $a8600556d6c14ba3$export$dae85862a8d94378(onceHandler, instance, 6 /* ErrorCodes.COMPONENT_EVENT_HANDLER */ , args);
    }
}
function $a8600556d6c14ba3$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== undefined) return cached;
    const raw = comp.emits;
    let normalized = {};
    // apply mixin/extends props
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8ENGG.isFunction)(comp)) {
        const extendEmits = (raw)=>{
            const normalizedFromExtend = $a8600556d6c14ba3$var$normalizeEmitsOptions(raw, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8ENGG.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8ENGG.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8ENGG.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8ENGG.extend)(normalized, raw);
    if ((0, $8ENGG.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
// Check if an incoming prop key is a declared emit event listener.
// e.g. With `emits: { click: null }`, props named `onClick` and `onclick` are
// both considered matched listeners.
function $a8600556d6c14ba3$var$isEmitListener(options, key) {
    if (!options || !(0, $8ENGG.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $8ENGG.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8ENGG.hasOwn)(options, (0, $8ENGG.hyphenate)(key)) || (0, $8ENGG.hasOwn)(options, key);
}
/**
 * mark the current rendering instance for asset resolution (e.g.
 * resolveComponent, resolveDirective) during render
 */ let $a8600556d6c14ba3$var$currentRenderingInstance = null;
let $a8600556d6c14ba3$var$currentScopeId = null;
/**
 * Note: rendering calls maybe nested. The function returns the parent rendering
 * instance if present, which should be restored after the render is done:
 *
 * ```js
 * const prev = setCurrentRenderingInstance(i)
 * // ...render
 * setCurrentRenderingInstance(prev)
 * ```
 */ function $a8600556d6c14ba3$var$setCurrentRenderingInstance(instance) {
    const prev = $a8600556d6c14ba3$var$currentRenderingInstance;
    $a8600556d6c14ba3$var$currentRenderingInstance = instance;
    $a8600556d6c14ba3$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
/**
 * Set scope id when creating hoisted vnodes.
 * @private compiler helper
 */ function $a8600556d6c14ba3$export$ac020265ca2cc4cd(id) {
    $a8600556d6c14ba3$var$currentScopeId = id;
}
/**
 * Technically we no longer need this after 3.0.8 but we need to keep the same
 * API for backwards compat w/ code generated by compilers.
 * @private
 */ function $a8600556d6c14ba3$export$f2dc6805dc11834e() {
    $a8600556d6c14ba3$var$currentScopeId = null;
}
/**
 * Only for backwards compat
 * @private
 */ const $a8600556d6c14ba3$export$15ba313e13f3dd04 = (_id)=>$a8600556d6c14ba3$export$694b237e827a3d23;
/**
 * Wrap a slot function to memoize current rendering instance
 * @private compiler helper
 */ function $a8600556d6c14ba3$export$694b237e827a3d23(fn, ctx = $a8600556d6c14ba3$var$currentRenderingInstance, isNonScopedSlot // false only
) {
    if (!ctx) return fn;
    // already normalized
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        // If a user calls a compiled slot inside a template expression (#1745), it
        // can mess up block tracking, so by default we disable block tracking and
        // force bail out when invoking a compiled slot (indicated by the ._d flag).
        // This isn't necessary if rendering a compiled `<slot>`, so we flip the
        // ._d flag off when invoking the wrapped fn inside `renderSlot`.
        if (renderFnWithContext._d) $a8600556d6c14ba3$export$c20bee82f26f1e27(-1);
        const prevInstance = $a8600556d6c14ba3$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $a8600556d6c14ba3$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $a8600556d6c14ba3$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $a8600556d6c14ba3$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    // mark normalized to avoid duplicated wrapping
    renderFnWithContext._n = true;
    // mark this as compiled by default
    // this is used in vnode.ts -> normalizeChildren() to set the slot
    // rendering flag.
    renderFnWithContext._c = true;
    // disable block tracking by default
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
/**
 * dev only flag to track whether $attrs was used during render.
 * If $attrs was used during render then the warning for failed attrs
 * fallthrough can be suppressed.
 */ let $a8600556d6c14ba3$var$accessedAttrs = false;
function $a8600556d6c14ba3$var$markAttrsAccessed() {
    $a8600556d6c14ba3$var$accessedAttrs = true;
}
function $a8600556d6c14ba3$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, props: props, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev = $a8600556d6c14ba3$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4 /* ShapeFlags.STATEFUL_COMPONENT */ ) {
            // withProxy is a proxy with a different `has` trap only for
            // runtime-compiled render functions using `with` block.
            const proxyToUse = withProxy || proxy;
            result = $a8600556d6c14ba3$var$normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            // functional
            const render = Component;
            result = $a8600556d6c14ba3$var$normalizeVNode(render.length > 1 ? render(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render(props, null));
            fallthroughAttrs = Component.props ? attrs : $a8600556d6c14ba3$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $a8600556d6c14ba3$var$blockStack.length = 0;
        $a8600556d6c14ba3$export$d3da1ecaf1206c58(err, instance, 1 /* ErrorCodes.RENDER_FUNCTION */ );
        result = $a8600556d6c14ba3$export$bf5c4cf060303d58($a8600556d6c14ba3$export$4d299b491347818a);
    }
    // attr merging
    // in dev mode, comments are preserved, and it's possible for a template
    // to have comments along side the root element which makes it a fragment
    let root = result;
    let setRoot = undefined;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7 /* ShapeFlags.COMPONENT */ ) {
                if (propsOptions && keys.some((0, $8ENGG.isModelListener))) // If a v-model listener (onUpdate:xxx) has a corresponding declared
                // prop, it indicates this component expects to handle v-model and
                // it should not fallthrough.
                // related: #1543, #1643, #1989
                fallthroughAttrs = $a8600556d6c14ba3$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $a8600556d6c14ba3$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    // inherit directives
    if (vnode.dirs) {
        // clone before mutating since the root may be a hoisted vnode
        root = $a8600556d6c14ba3$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    // inherit transition data
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $a8600556d6c14ba3$var$setCurrentRenderingInstance(prev);
    return result;
}
/**
 * dev only
 * In dev mode, template root level comments are rendered, which turns the
 * template into a fragment root, but we need to locate the single element
 * root for attrs and scope id processing.
 */ const $a8600556d6c14ba3$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $a8600556d6c14ba3$var$filterSingleRoot(rawChildren);
    if (!childRoot) return [
        vnode,
        undefined
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $a8600556d6c14ba3$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $a8600556d6c14ba3$var$filterSingleRoot(children) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($a8600556d6c14ba3$export$3868d13f8734ae81(child)) // ignore user comment
        {
            if (child.type !== $a8600556d6c14ba3$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) // has more than 1 non-comment child, return now
                return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $a8600556d6c14ba3$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8ENGG.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $a8600556d6c14ba3$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8ENGG.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $a8600556d6c14ba3$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 /* ShapeFlags.ELEMENT */  || vnode.type === $a8600556d6c14ba3$export$4d299b491347818a // potential v-if branch switch
    ;
};
function $a8600556d6c14ba3$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    // force child update for runtime directive or transition on component vnode.
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024 /* PatchFlags.DYNAMIC_SLOTS */ ) // slot content that references values that might have changed,
        // e.g. in a v-for
        return true;
        if (patchFlag & 16 /* PatchFlags.FULL_PROPS */ ) {
            if (!prevProps) return !!nextProps;
            // presence of this flag indicates props are always non-null
            return $a8600556d6c14ba3$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8 /* PatchFlags.PROPS */ ) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$a8600556d6c14ba3$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        // this path is only taken by manually written render functions
        // so presence of any children leads to a forced update
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $a8600556d6c14ba3$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $a8600556d6c14ba3$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$a8600556d6c14ba3$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $a8600556d6c14ba3$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el // HostNode
) {
    while(parent && parent.subTree === vnode){
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
    }
}
const $a8600556d6c14ba3$var$isSuspense = (type)=>type.__isSuspense;
// Suspense exposes a component-like API, and is treated like a component
// in the compiler, but internally it's a special built-in type that hooks
// directly into the renderer.
const $a8600556d6c14ba3$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, // platform-specific impl passed from renderer
    rendererInternals) {
        if (n1 == null) $a8600556d6c14ba3$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals);
        else $a8600556d6c14ba3$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, rendererInternals);
    },
    hydrate: $a8600556d6c14ba3$var$hydrateSuspense,
    create: $a8600556d6c14ba3$var$createSuspenseBoundary,
    normalize: $a8600556d6c14ba3$var$normalizeSuspenseChildren
};
// Force-casted public typing for h and TSX props inference
const $a8600556d6c14ba3$export$74bf444e3cd11ea5 = $a8600556d6c14ba3$var$SuspenseImpl;
function $a8600556d6c14ba3$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8ENGG.isFunction)(eventListener)) eventListener();
}
function $a8600556d6c14ba3$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $a8600556d6c14ba3$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals);
    // start mounting the content subtree in an off-dom container
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds);
    // now check if we have encountered any async deps
    if (suspense.deps > 0) {
        // has async
        // invoke @fallback event
        $a8600556d6c14ba3$var$triggerEvent(vnode, "onPending");
        $a8600556d6c14ba3$var$triggerEvent(vnode, "onFallback");
        // mount the fallback tree
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds);
        $a8600556d6c14ba3$var$setActiveBranch(suspense, vnode.ssFallback);
    } else // Suspense has no async deps. Just resolve.
    suspense.resolve();
}
function $a8600556d6c14ba3$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($a8600556d6c14ba3$var$isSameVNodeType(newBranch, pendingBranch)) {
            // same root type but content may have changed.
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                patch(activeBranch, newFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                $a8600556d6c14ba3$var$setActiveBranch(suspense, newFallback);
            }
        } else {
            // toggled before pending tree is resolved
            suspense.pendingId++;
            if (isHydrating) {
                // if toggled before hydration is finished, the current DOM tree is
                // no longer valid. set it as the active branch so it will be unmounted
                // when resolved
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            // increment pending ID. this is used to invalidate async callbacks
            // reset suspense state
            suspense.deps = 0;
            // discard effects from pending branch
            suspense.effects.length = 0;
            // discard previous container
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                // already in fallback state
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                    $a8600556d6c14ba3$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $a8600556d6c14ba3$var$isSameVNodeType(newBranch, activeBranch)) {
                // toggled "back" to current active branch
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                // force resolve
                suspense.resolve(true);
            } else {
                // switched to a 3rd branch
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $a8600556d6c14ba3$var$isSameVNodeType(newBranch, activeBranch)) {
        // root did not change, just normal patch
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        $a8600556d6c14ba3$var$setActiveBranch(suspense, newBranch);
    } else {
        // root node toggled
        // invoke @pending event
        $a8600556d6c14ba3$var$triggerEvent(n2, "onPending");
        // mount pending branch in off-dom container
        suspense.pendingBranch = newBranch;
        suspense.pendingId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        if (suspense.deps <= 0) // incoming branch has no async deps, resolve now.
        suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $a8600556d6c14ba3$var$hasWarned = false;
function $a8600556d6c14ba3$var$createSuspenseBoundary(vnode, parent, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    const timeout = (0, $8ENGG.toNumber)(vnode.props && vnode.props.timeout);
    const suspense = {
        vnode: vnode,
        parent: parent,
        parentComponent: parentComponent,
        isSVG: isSVG,
        container: container,
        hiddenContainer: hiddenContainer,
        anchor: anchor,
        deps: 0,
        pendingId: 0,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: true,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false) {
            const { vnode: vnode, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent, container: container } = suspense;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                const delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) move(pendingBranch, container, anchor, 0 /* MoveType.ENTER */ );
                };
                // this is initial anchor on mount
                let { anchor: anchor } = suspense;
                // unmount current active tree
                if (activeBranch) {
                    // if the fallback tree was mounted, it may have been moved
                    // as part of a parent suspense. get the latest anchor for insertion
                    anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent, suspense, true);
                }
                if (!delayEnter) // move content from off-dom container to actual container
                move(pendingBranch, container, anchor, 0 /* MoveType.ENTER */ );
            }
            $a8600556d6c14ba3$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            // flush buffered effects
            // check if there is a pending parent suspense
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    // found a pending parent suspense, merge buffered post jobs
                    // into that parent
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            // no pending parent suspense, flush all jobs
            if (!hasUnresolvedAncestor) $a8600556d6c14ba3$export$59536a0199721cab(effects);
            suspense.effects = [];
            // invoke @resolve event
            $a8600556d6c14ba3$var$triggerEvent(vnode, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode, activeBranch: activeBranch, parentComponent: parentComponent, container: container, isSVG: isSVG } = suspense;
            // invoke @fallback event
            $a8600556d6c14ba3$var$triggerEvent(vnode, "onFallback");
            const anchor = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                // mount the fallback tree
                patch(null, fallbackVNode, container, anchor, parentComponent, null, isSVG, slotScopeIds, optimized);
                $a8600556d6c14ba3$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            // unmount current active branch
            unmount(activeBranch, parentComponent, null, true // shouldRemove
            );
            if (!delayEnter) mountFallback();
        },
        move (container, anchor, type) {
            suspense.activeBranch && move(suspense.activeBranch, container, anchor, type);
            suspense.container = container;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $a8600556d6c14ba3$export$d3da1ecaf1206c58(err, instance, 0 /* ErrorCodes.SETUP_FUNCTION */ );
            }).then((asyncSetupResult)=>{
                // retry when the setup() promise resolves.
                // component may have been unmounted before resolve.
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                // retry from this component
                instance.asyncResolved = true;
                const { vnode: vnode } = instance;
                $a8600556d6c14ba3$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) // vnode may have been replaced if an update happened before the
                // async dep is resolved.
                vnode.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
                if (placeholder) remove(placeholder);
                $a8600556d6c14ba3$var$updateHOCHostEl(instance, vnode.el);
                // only decrease deps count if suspense is not already resolved
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense, doRemove);
        }
    };
    return suspense;
}
function $a8600556d6c14ba3$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    /* eslint-disable no-restricted-globals */ const suspense = vnode.suspense = $a8600556d6c14ba3$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement("div"), null, isSVG, slotScopeIds, optimized, rendererInternals, true);
    // there are two possible scenarios for server-rendered suspense:
    // - success: ssr content should be fully resolved
    // - failure: ssr content should be the fallback branch.
    // however, on the client we don't really know if it has failed or not
    // attempt to hydrate the DOM assuming it has succeeded, but we still
    // need to construct a suspense boundary first
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve();
    return result;
/* eslint-enable no-restricted-globals */ }
function $a8600556d6c14ba3$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32 /* ShapeFlags.SLOTS_CHILDREN */ ;
    vnode.ssContent = $a8600556d6c14ba3$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $a8600556d6c14ba3$var$normalizeSuspenseSlot(children.fallback) : $a8600556d6c14ba3$export$bf5c4cf060303d58($a8600556d6c14ba3$export$4d299b491347818a);
}
function $a8600556d6c14ba3$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8ENGG.isFunction)(s)) {
        const trackBlock = $a8600556d6c14ba3$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            // disableTracking: false
            // allow block tracking for compiled slots
            // (see ./componentRenderContext.ts)
            s._d = false;
            $a8600556d6c14ba3$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $a8600556d6c14ba3$var$currentBlock;
            $a8600556d6c14ba3$var$closeBlock();
        }
    }
    if ((0, $8ENGG.isArray)(s)) {
        const singleChild = $a8600556d6c14ba3$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $a8600556d6c14ba3$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $a8600556d6c14ba3$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8ENGG.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $a8600556d6c14ba3$export$59536a0199721cab(fn);
}
function $a8600556d6c14ba3$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    const el = vnode.el = branch.el;
    // in case suspense is the root node of a component,
    // recursively update the HOC el
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $a8600556d6c14ba3$var$updateHOCHostEl(parentComponent, el);
    }
}
function $a8600556d6c14ba3$export$abe1e183e22e10ad(key, value) {
    if (!$a8600556d6c14ba3$var$currentInstance) ;
    else {
        let provides = $a8600556d6c14ba3$var$currentInstance.provides;
        // by default an instance inherits its parent's provides object
        // but when it needs to provide values of its own, it creates its
        // own provides object using parent provides object as prototype.
        // this way in `inject` we can simply look up injections from direct
        // parent and let the prototype chain do the work.
        const parentProvides = $a8600556d6c14ba3$var$currentInstance.parent && $a8600556d6c14ba3$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $a8600556d6c14ba3$var$currentInstance.provides = Object.create(parentProvides);
        // TS doesn't allow symbol as index type
        provides[key] = value;
    }
}
function $a8600556d6c14ba3$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    const instance = $a8600556d6c14ba3$var$currentInstance || $a8600556d6c14ba3$var$currentRenderingInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the instance is at root
        const provides = instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides;
        if (provides && key in provides) // TS doesn't allow symbol as index type
        return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8ENGG.isFunction)(defaultValue) ? defaultValue.call(instance.proxy) : defaultValue;
    }
}
// Simple effect.
function $a8600556d6c14ba3$export$ede35fc0e5500309(effect, options) {
    return $a8600556d6c14ba3$var$doWatch(effect, null, options);
}
function $a8600556d6c14ba3$export$b7f27ea67102d543(effect, options) {
    return $a8600556d6c14ba3$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $a8600556d6c14ba3$export$2035654f31b0e555(effect, options) {
    return $a8600556d6c14ba3$var$doWatch(effect, null, {
        flush: "sync"
    });
}
// initial value for watchers to trigger on undefined initial values
const $a8600556d6c14ba3$var$INITIAL_WATCHER_VALUE = {};
// implementation
function $a8600556d6c14ba3$export$3db5d71bdb2d5499(source, cb, options) {
    return $a8600556d6c14ba3$var$doWatch(source, cb, options);
}
function $a8600556d6c14ba3$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, onTrack: onTrack, onTrigger: onTrigger } = (0, $8ENGG.EMPTY_OBJ)) {
    const warnInvalidSource = (s)=>{
        $a8600556d6c14ba3$export$c106dd0671a0fc2d(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, ` + `a reactive object, or an array of these types.`);
    };
    const instance = $a8600556d6c14ba3$var$currentInstance;
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $am4TS.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $am4TS.isShallow)(source);
    } else if ((0, $am4TS.isReactive)(source)) {
        getter = ()=>source;
        deep = true;
    } else if ((0, $8ENGG.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $am4TS.isReactive)(s) || (0, $am4TS.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $am4TS.isRef)(s)) return s.value;
                else if ((0, $am4TS.isReactive)(s)) return $a8600556d6c14ba3$var$traverse(s);
                else if ((0, $8ENGG.isFunction)(s)) return $a8600556d6c14ba3$export$b22fcaf88446e9bf(s, instance, 2 /* ErrorCodes.WATCH_GETTER */ );
            });
    } else if ((0, $8ENGG.isFunction)(source)) {
        if (cb) // getter with cb
        getter = ()=>$a8600556d6c14ba3$export$b22fcaf88446e9bf(source, instance, 2 /* ErrorCodes.WATCH_GETTER */ );
        else // no cb -> simple effect
        getter = ()=>{
            if (instance && instance.isUnmounted) return;
            if (cleanup) cleanup();
            return $a8600556d6c14ba3$export$dae85862a8d94378(source, instance, 3 /* ErrorCodes.WATCH_CALLBACK */ , [
                onCleanup
            ]);
        };
    } else getter = (0, $8ENGG.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$a8600556d6c14ba3$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $a8600556d6c14ba3$export$b22fcaf88446e9bf(fn, instance, 4 /* ErrorCodes.WATCH_CLEANUP */ );
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if ($a8600556d6c14ba3$var$isInSSRComponentSetup) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onCleanup = (0, $8ENGG.NOOP);
        if (!cb) getter();
        else if (immediate) $a8600556d6c14ba3$export$dae85862a8d94378(cb, instance, 3 /* ErrorCodes.WATCH_CALLBACK */ , [
            getter(),
            isMultiSource ? [] : undefined,
            onCleanup
        ]);
        return 0, $8ENGG.NOOP;
    }
    let oldValue = isMultiSource ? [] : $a8600556d6c14ba3$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active) return;
        if (cb) {
            // watch(source, cb)
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $8ENGG.hasChanged)(v1, oldValue[i])) : (0, $8ENGG.hasChanged)(newValue, oldValue)) || false) {
                // cleanup before running cb again
                if (cleanup) cleanup();
                $a8600556d6c14ba3$export$dae85862a8d94378(cb, instance, 3 /* ErrorCodes.WATCH_CALLBACK */ , [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $a8600556d6c14ba3$var$INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else // watchEffect
        effect.run();
    };
    // important: mark the job as a watcher callback so that scheduler knows
    // it is allowed to self-trigger (#1727)
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job; // the scheduler function gets called directly
    else if (flush === "post") scheduler = ()=>$a8600556d6c14ba3$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        // default: 'pre'
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$a8600556d6c14ba3$var$queueJob(job);
    }
    const effect = new (0, $am4TS.ReactiveEffect)(getter, scheduler);
    // initial run
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $a8600556d6c14ba3$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    return ()=>{
        effect.stop();
        if (instance && instance.scope) (0, $8ENGG.remove)(instance.scope.effects, effect);
    };
}
// this.$watch
function $a8600556d6c14ba3$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8ENGG.isString)(source) ? source.includes(".") ? $a8600556d6c14ba3$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8ENGG.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const cur = $a8600556d6c14ba3$var$currentInstance;
    $a8600556d6c14ba3$var$setCurrentInstance(this);
    const res = $a8600556d6c14ba3$var$doWatch(getter, cb.bind(publicThis), options);
    if (cur) $a8600556d6c14ba3$var$setCurrentInstance(cur);
    else $a8600556d6c14ba3$var$unsetCurrentInstance();
    return res;
}
function $a8600556d6c14ba3$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $a8600556d6c14ba3$var$traverse(value, seen) {
    if (!(0, $8ENGG.isObject)(value) || value["__v_skip" /* ReactiveFlags.SKIP */ ]) return value;
    seen = seen || new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    if ((0, $am4TS.isRef)(value)) $a8600556d6c14ba3$var$traverse(value.value, seen);
    else if ((0, $8ENGG.isArray)(value)) for(let i = 0; i < value.length; i++)$a8600556d6c14ba3$var$traverse(value[i], seen);
    else if ((0, $8ENGG.isSet)(value) || (0, $8ENGG.isMap)(value)) value.forEach((v1)=>{
        $a8600556d6c14ba3$var$traverse(v1, seen);
    });
    else if ((0, $8ENGG.isPlainObject)(value)) for(const key in value)$a8600556d6c14ba3$var$traverse(value[key], seen);
    return value;
}
function $a8600556d6c14ba3$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: new Map()
    };
    $a8600556d6c14ba3$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $a8600556d6c14ba3$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $a8600556d6c14ba3$var$TransitionHookValidator = [
    Function,
    Array
];
const $a8600556d6c14ba3$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: {
        mode: String,
        appear: Boolean,
        persisted: Boolean,
        // enter
        onBeforeEnter: $a8600556d6c14ba3$var$TransitionHookValidator,
        onEnter: $a8600556d6c14ba3$var$TransitionHookValidator,
        onAfterEnter: $a8600556d6c14ba3$var$TransitionHookValidator,
        onEnterCancelled: $a8600556d6c14ba3$var$TransitionHookValidator,
        // leave
        onBeforeLeave: $a8600556d6c14ba3$var$TransitionHookValidator,
        onLeave: $a8600556d6c14ba3$var$TransitionHookValidator,
        onAfterLeave: $a8600556d6c14ba3$var$TransitionHookValidator,
        onLeaveCancelled: $a8600556d6c14ba3$var$TransitionHookValidator,
        // appear
        onBeforeAppear: $a8600556d6c14ba3$var$TransitionHookValidator,
        onAppear: $a8600556d6c14ba3$var$TransitionHookValidator,
        onAfterAppear: $a8600556d6c14ba3$var$TransitionHookValidator,
        onAppearCancelled: $a8600556d6c14ba3$var$TransitionHookValidator
    },
    setup (props, { slots: slots }) {
        const instance = $a8600556d6c14ba3$export$f13e630aa3915748();
        const state = $a8600556d6c14ba3$export$d2a0a1bc267c90f6();
        let prevTransitionKey;
        return ()=>{
            const children = slots.default && $a8600556d6c14ba3$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                // locate first non-comment child
                for (const c of children)if (c.type !== $a8600556d6c14ba3$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            // there's no need to track reactivity for these props so use the raw
            // props for a bit better perf
            const rawProps = (0, $am4TS.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $a8600556d6c14ba3$var$emptyPlaceholder(child);
            // in the case of <transition><keep-alive/></transition>, we need to
            // compare the type of the kept-alive children.
            const innerChild = $a8600556d6c14ba3$var$getKeepAliveChild(child);
            if (!innerChild) return $a8600556d6c14ba3$var$emptyPlaceholder(child);
            const enterHooks = $a8600556d6c14ba3$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $a8600556d6c14ba3$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $a8600556d6c14ba3$var$getKeepAliveChild(oldChild);
            let transitionKeyChanged = false;
            const { getTransitionKey: getTransitionKey } = innerChild.type;
            if (getTransitionKey) {
                const key = getTransitionKey();
                if (prevTransitionKey === undefined) prevTransitionKey = key;
                else if (key !== prevTransitionKey) {
                    prevTransitionKey = key;
                    transitionKeyChanged = true;
                }
            }
            // handle mode
            if (oldInnerChild && oldInnerChild.type !== $a8600556d6c14ba3$export$4d299b491347818a && (!$a8600556d6c14ba3$var$isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
                const leavingHooks = $a8600556d6c14ba3$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                // update old tree's hooks in case of dynamic transition
                $a8600556d6c14ba3$export$7770a22486565649(oldInnerChild, leavingHooks);
                // switching between different views
                if (mode === "out-in") {
                    state.isLeaving = true;
                    // return placeholder node and queue update when leave finishes
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        instance.update();
                    };
                    return $a8600556d6c14ba3$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $a8600556d6c14ba3$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $a8600556d6c14ba3$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    // early removal callback
                    el._leaveCb = ()=>{
                        earlyRemove();
                        el._leaveCb = undefined;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
const $a8600556d6c14ba3$export$abd95b5f5e8a8837 = $a8600556d6c14ba3$var$BaseTransitionImpl;
function $a8600556d6c14ba3$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
// The transition hooks are attached to the vnode as vnode.transition
// and will be called at appropriate timing in the renderer.
function $a8600556d6c14ba3$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $a8600556d6c14ba3$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $a8600556d6c14ba3$export$dae85862a8d94378(hook, instance, 9 /* ErrorCodes.TRANSITION_HOOK */ , args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8ENGG.isArray)(hook)) {
            if (hook.every((hook)=>hook.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            // for same element (v-show)
            if (el._leaveCb) el._leaveCb(true);
            // for toggled element with same key (v-if)
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $a8600556d6c14ba3$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) // force early removal (not cancelled)
            leavingVNode.el._leaveCb();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el._enterCb = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el._enterCb = undefined;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key = String(vnode.key);
            if (el._enterCb) el._enterCb(true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el._leaveCb = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el._leaveCb = undefined;
                if (leavingVNodesCache[key] === vnode) delete leavingVNodesCache[key];
            };
            leavingVNodesCache[key] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode) {
            return $a8600556d6c14ba3$export$76ac1779589cd824(vnode, props, state, instance);
        }
    };
    return hooks;
}
// the placeholder really only handles one special case: KeepAlive
// in the case of a KeepAlive in a leave phase we need to return a KeepAlive
// placeholder with empty content to avoid the KeepAlive instance from being
// unmounted.
function $a8600556d6c14ba3$var$emptyPlaceholder(vnode) {
    if ($a8600556d6c14ba3$var$isKeepAlive(vnode)) {
        vnode = $a8600556d6c14ba3$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $a8600556d6c14ba3$var$getKeepAliveChild(vnode) {
    return $a8600556d6c14ba3$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : undefined : vnode;
}
function $a8600556d6c14ba3$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 /* ShapeFlags.COMPONENT */  && vnode.component) $a8600556d6c14ba3$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $a8600556d6c14ba3$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        // #5360 inherit parent key in case of <template v-for>
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        // handle fragment children case, e.g. v-for
        if (child.type === $a8600556d6c14ba3$export$ffb0004e005737fa) {
            if (child.patchFlag & 128 /* PatchFlags.KEYED_FRAGMENT */ ) keyedFragmentCount++;
            ret = ret.concat($a8600556d6c14ba3$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $a8600556d6c14ba3$export$4d299b491347818a) ret.push(key != null ? $a8600556d6c14ba3$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    // #1126 if a transition children list contains multiple sub fragments, these
    // fragments will be merged into a flat children array. Since each v-for
    // fragment may contain different static bindings inside, we need to de-op
    // these children to force full diffs to ensure correct behavior.
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2 /* PatchFlags.BAIL */ ;
    return ret;
}
// implementation, close to no-op
function $a8600556d6c14ba3$export$afa64b67e5a01c3b(options) {
    return (0, $8ENGG.isFunction)(options) ? {
        setup: options,
        name: options.name
    } : options;
}
const $a8600556d6c14ba3$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
function $a8600556d6c14ba3$export$d75d499b4c16cf21(source) {
    if ((0, $8ENGG.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            // interop module default
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $a8600556d6c14ba3$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $a8600556d6c14ba3$var$currentInstance;
            // already resolved
            if (resolvedComp) return ()=>$a8600556d6c14ba3$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $a8600556d6c14ba3$export$d3da1ecaf1206c58(err, instance, 13 /* ErrorCodes.ASYNC_COMPONENT_LOADER */ , !errorComponent /* do not throw in dev if user provided error component */ );
            };
            // suspense-controlled or SSR.
            if (suspensible && instance.suspense || $a8600556d6c14ba3$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$a8600556d6c14ba3$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $a8600556d6c14ba3$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $am4TS.ref)(false);
            const error = (0, $am4TS.ref)();
            const delayed = (0, $am4TS.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $a8600556d6c14ba3$var$isKeepAlive(instance.parent.vnode)) // parent is keep-alive, force update so the loaded component's
                // name is taken into account
                $a8600556d6c14ba3$var$queueJob(instance.parent.update);
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $a8600556d6c14ba3$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $a8600556d6c14ba3$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $a8600556d6c14ba3$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $a8600556d6c14ba3$var$createInnerComp(comp, { vnode: { ref: ref, props: props, children: children, shapeFlag: shapeFlag }, parent: parent }) {
    const vnode = $a8600556d6c14ba3$export$bf5c4cf060303d58(comp, props, children);
    // ensure inner component inherits the async wrapper's ref owner
    vnode.ref = ref;
    return vnode;
}
const $a8600556d6c14ba3$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $a8600556d6c14ba3$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $a8600556d6c14ba3$export$f13e630aa3915748();
        // KeepAlive communicates with the instantiated renderer via the
        // ctx where the renderer passes in its internals,
        // and the KeepAlive instance exposes activate/deactivate implementations.
        // The whole point of this is to avoid importing KeepAlive directly in the
        // renderer to facilitate tree-shaking.
        const sharedContext = instance.ctx;
        // if the internal renderer is not registered, it indicates that this is server-side rendering,
        // for KeepAlive, we just need to render its children
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = new Map();
        const keys = new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, isSVG, optimized)=>{
            const instance = vnode.component;
            move(vnode, container, anchor, 0 /* MoveType.ENTER */ , parentSuspense);
            // in case props have changed
            patch(instance.vnode, vnode, container, anchor, instance, parentSuspense, isSVG, vnode.slotScopeIds, optimized);
            $a8600556d6c14ba3$var$queuePostRenderEffect(()=>{
                instance.isDeactivated = false;
                if (instance.a) (0, $8ENGG.invokeArrayFns)(instance.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $a8600556d6c14ba3$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) // Update components tree
            $a8600556d6c14ba3$var$devtoolsComponentAdded(instance);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance = vnode.component;
            move(vnode, storageContainer, null, 1 /* MoveType.LEAVE */ , parentSuspense);
            $a8600556d6c14ba3$var$queuePostRenderEffect(()=>{
                if (instance.da) (0, $8ENGG.invokeArrayFns)(instance.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $a8600556d6c14ba3$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
                instance.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) // Update components tree
            $a8600556d6c14ba3$var$devtoolsComponentAdded(instance);
        };
        function unmount(vnode) {
            // reset the shapeFlag so it can be properly unmounted
            $a8600556d6c14ba3$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $a8600556d6c14ba3$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || cached.type !== current.type) unmount(cached);
            else if (current) // current active instance should no longer be kept-alive.
            // we can't unmount it now but it might be later, so reset its flag now.
            $a8600556d6c14ba3$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        // prune cache on include/exclude prop change
        $a8600556d6c14ba3$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$a8600556d6c14ba3$var$matches(include, name));
            exclude && pruneCache((name)=>!$a8600556d6c14ba3$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        // cache sub tree after render
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            // fix #1621, the pendingCacheKey could be 0
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $a8600556d6c14ba3$var$getInnerChild(instance.subTree));
        };
        $a8600556d6c14ba3$export$6d1641039221b5cb(cacheSubtree);
        $a8600556d6c14ba3$export$5876c47052fb88b1(cacheSubtree);
        $a8600556d6c14ba3$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $a8600556d6c14ba3$var$getInnerChild(subTree);
                if (cached.type === vnode.type) {
                    // current instance will be unmounted as part of keep-alive's unmount
                    $a8600556d6c14ba3$var$resetShapeFlag(vnode);
                    // but invoke its deactivated hook here
                    const da = vnode.component.da;
                    da && $a8600556d6c14ba3$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$a8600556d6c14ba3$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4 /* ShapeFlags.STATEFUL_COMPONENT */ ) && !(rawVNode.shapeFlag & 128 /* ShapeFlags.SUSPENSE */ )) {
                current = null;
                return rawVNode;
            }
            let vnode = $a8600556d6c14ba3$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            // for async components, name check should be based in its loaded
            // inner component if available
            const name = $a8600556d6c14ba3$var$getComponentName($a8600556d6c14ba3$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$a8600556d6c14ba3$var$matches(include, name)) || exclude && name && $a8600556d6c14ba3$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            // clone vnode if it's reused because we are going to mutate it
            if (vnode.el) {
                vnode = $a8600556d6c14ba3$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) rawVNode.ssContent = vnode;
            }
            // #1513 it's possible for the returned vnode to be cloned due to attr
            // fallthrough or scopeId, so the vnode here may not be the final vnode
            // that is mounted. Instead of caching it directly, we store the pending
            // key and cache `instance.subTree` (the normalized vnode) in
            // beforeMount/beforeUpdate hooks.
            pendingCacheKey = key;
            if (cachedVNode) {
                // copy over mounted state
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) // recursively update transition hooks on subTree
                $a8600556d6c14ba3$export$7770a22486565649(vnode, vnode.transition);
                // avoid vnode being mounted as fresh
                vnode.shapeFlag |= 512 /* ShapeFlags.COMPONENT_KEPT_ALIVE */ ;
                // make this key the freshest
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                // prune oldest entry
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            // avoid vnode being unmounted
            vnode.shapeFlag |= 256 /* ShapeFlags.COMPONENT_SHOULD_KEEP_ALIVE */ ;
            current = vnode;
            return $a8600556d6c14ba3$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
const $a8600556d6c14ba3$export$70eb8a58709972df = $a8600556d6c14ba3$var$KeepAliveImpl;
function $a8600556d6c14ba3$var$matches(pattern, name) {
    if ((0, $8ENGG.isArray)(pattern)) return pattern.some((p)=>$a8600556d6c14ba3$var$matches(p, name));
    else if ((0, $8ENGG.isString)(pattern)) return pattern.split(",").includes(name);
    else if (pattern.test) return pattern.test(name);
    /* istanbul ignore next */ return false;
}
function $a8600556d6c14ba3$export$ba52d824b95a2154(hook, target) {
    $a8600556d6c14ba3$var$registerKeepAliveHook(hook, "a" /* LifecycleHooks.ACTIVATED */ , target);
}
function $a8600556d6c14ba3$export$bf1440eeaf5fa709(hook, target) {
    $a8600556d6c14ba3$var$registerKeepAliveHook(hook, "da" /* LifecycleHooks.DEACTIVATED */ , target);
}
function $a8600556d6c14ba3$var$registerKeepAliveHook(hook, type, target = $a8600556d6c14ba3$var$currentInstance) {
    // cache the deactivate branch check wrapper for injected hooks so the same
    // hook can be properly deduped by the scheduler. "__wdc" stands for "with
    // deactivation check".
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        // only fire the hook if the target instance is NOT in a deactivated branch.
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $a8600556d6c14ba3$var$injectHook(type, wrappedHook, target);
    // In addition to registering it on the target instance, we walk up the parent
    // chain and register it on all ancestor instances that are keep-alive roots.
    // This avoids the need to walk the entire component tree when invoking these
    // hooks, and more importantly, avoids the need to track child components in
    // arrays.
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($a8600556d6c14ba3$var$isKeepAlive(current.parent.vnode)) $a8600556d6c14ba3$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $a8600556d6c14ba3$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    // injectHook wraps the original for error handling, so make sure to remove
    // the wrapped version.
    const injected = $a8600556d6c14ba3$var$injectHook(type, hook, keepAliveRoot, true);
    $a8600556d6c14ba3$export$13348a43ccacfe58(()=>{
        (0, $8ENGG.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $a8600556d6c14ba3$var$resetShapeFlag(vnode) {
    let shapeFlag = vnode.shapeFlag;
    if (shapeFlag & 256 /* ShapeFlags.COMPONENT_SHOULD_KEEP_ALIVE */ ) shapeFlag -= 256 /* ShapeFlags.COMPONENT_SHOULD_KEEP_ALIVE */ ;
    if (shapeFlag & 512 /* ShapeFlags.COMPONENT_KEPT_ALIVE */ ) shapeFlag -= 512 /* ShapeFlags.COMPONENT_KEPT_ALIVE */ ;
    vnode.shapeFlag = shapeFlag;
}
function $a8600556d6c14ba3$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 /* ShapeFlags.SUSPENSE */  ? vnode.ssContent : vnode;
}
function $a8600556d6c14ba3$var$injectHook(type, hook, target = $a8600556d6c14ba3$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        // cache the error handling wrapper for injected hooks so the same hook
        // can be properly deduped by the scheduler. "__weh" stands for "with error
        // handling".
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            // disable tracking inside all lifecycle hooks
            // since they can potentially be called inside effects.
            (0, $am4TS.pauseTracking)();
            // Set currentInstance during hook invocation.
            // This assumes the hook does not synchronously trigger other hooks, which
            // can only be false when the user does something really funky.
            $a8600556d6c14ba3$var$setCurrentInstance(target);
            const res = $a8600556d6c14ba3$export$dae85862a8d94378(hook, target, type, args);
            $a8600556d6c14ba3$var$unsetCurrentInstance();
            (0, $am4TS.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $a8600556d6c14ba3$var$createHook = (lifecycle)=>(hook, target = $a8600556d6c14ba3$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$a8600556d6c14ba3$var$isInSSRComponentSetup || lifecycle === "sp" /* LifecycleHooks.SERVER_PREFETCH */ ) && $a8600556d6c14ba3$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $a8600556d6c14ba3$export$23b7aeb0d671f804 = $a8600556d6c14ba3$var$createHook("bm" /* LifecycleHooks.BEFORE_MOUNT */ );
const $a8600556d6c14ba3$export$6d1641039221b5cb = $a8600556d6c14ba3$var$createHook("m" /* LifecycleHooks.MOUNTED */ );
const $a8600556d6c14ba3$export$ab91988a13872e4c = $a8600556d6c14ba3$var$createHook("bu" /* LifecycleHooks.BEFORE_UPDATE */ );
const $a8600556d6c14ba3$export$5876c47052fb88b1 = $a8600556d6c14ba3$var$createHook("u" /* LifecycleHooks.UPDATED */ );
const $a8600556d6c14ba3$export$40c420df62d2614 = $a8600556d6c14ba3$var$createHook("bum" /* LifecycleHooks.BEFORE_UNMOUNT */ );
const $a8600556d6c14ba3$export$13348a43ccacfe58 = $a8600556d6c14ba3$var$createHook("um" /* LifecycleHooks.UNMOUNTED */ );
const $a8600556d6c14ba3$export$ebf0c601f267bceb = $a8600556d6c14ba3$var$createHook("sp" /* LifecycleHooks.SERVER_PREFETCH */ );
const $a8600556d6c14ba3$export$898295a813d662eb = $a8600556d6c14ba3$var$createHook("rtg" /* LifecycleHooks.RENDER_TRIGGERED */ );
const $a8600556d6c14ba3$export$2b41f4235363e921 = $a8600556d6c14ba3$var$createHook("rtc" /* LifecycleHooks.RENDER_TRACKED */ );
function $a8600556d6c14ba3$export$6a3a15856e50ad19(hook, target = $a8600556d6c14ba3$var$currentInstance) {
    $a8600556d6c14ba3$var$injectHook("ec" /* LifecycleHooks.ERROR_CAPTURED */ , hook, target);
}
/**
Runtime helper for applying directives to a vnode. Example usage:

const comp = resolveComponent('comp')
const foo = resolveDirective('foo')
const bar = resolveDirective('bar')

return withDirectives(h(comp), [
  [foo, this.x],
  [bar, this.y]
])
*/ function $a8600556d6c14ba3$var$validateDirectiveName(name) {
    if ((0, $8ENGG.isBuiltInDirective)(name)) $a8600556d6c14ba3$export$c106dd0671a0fc2d("Do not use built-in directive ids as custom directive id: " + name);
}
/**
 * Adds directives to a VNode.
 */ function $a8600556d6c14ba3$export$49729353e7c1e6c5(vnode, directives) {
    const internalInstance = $a8600556d6c14ba3$var$currentRenderingInstance;
    if (internalInstance === null) return vnode;
    const instance = $a8600556d6c14ba3$var$getExposeProxy(internalInstance) || internalInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8ENGG.EMPTY_OBJ)] = directives[i];
        if ((0, $8ENGG.isFunction)(dir)) dir = {
            mounted: dir,
            updated: dir
        };
        if (dir.deep) $a8600556d6c14ba3$var$traverse(value);
        bindings.push({
            dir: dir,
            instance: instance,
            value: value,
            oldValue: void 0,
            arg: arg,
            modifiers: modifiers
        });
    }
    return vnode;
}
function $a8600556d6c14ba3$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            // disable tracking inside all lifecycle hooks
            // since they can potentially be called inside effects.
            (0, $am4TS.pauseTracking)();
            $a8600556d6c14ba3$export$dae85862a8d94378(hook, instance, 8 /* ErrorCodes.DIRECTIVE_HOOK */ , [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $am4TS.resetTracking)();
        }
    }
}
const $a8600556d6c14ba3$var$COMPONENTS = "components";
const $a8600556d6c14ba3$var$DIRECTIVES = "directives";
/**
 * @private
 */ function $a8600556d6c14ba3$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $a8600556d6c14ba3$var$resolveAsset($a8600556d6c14ba3$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $a8600556d6c14ba3$var$NULL_DYNAMIC_COMPONENT = Symbol();
/**
 * @private
 */ function $a8600556d6c14ba3$export$b44c564a05ca975(component) {
    if ((0, $8ENGG.isString)(component)) return $a8600556d6c14ba3$var$resolveAsset($a8600556d6c14ba3$var$COMPONENTS, component, false) || component;
    else // invalid types will fallthrough to createVNode and raise warning
    return component || $a8600556d6c14ba3$var$NULL_DYNAMIC_COMPONENT;
}
/**
 * @private
 */ function $a8600556d6c14ba3$export$a1989e995cd481be(name) {
    return $a8600556d6c14ba3$var$resolveAsset($a8600556d6c14ba3$var$DIRECTIVES, name);
}
// implementation
function $a8600556d6c14ba3$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $a8600556d6c14ba3$var$currentRenderingInstance || $a8600556d6c14ba3$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        // explicit self name has highest priority
        if (type === $a8600556d6c14ba3$var$COMPONENTS) {
            const selfName = $a8600556d6c14ba3$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8ENGG.camelize)(name) || selfName === (0, $8ENGG.capitalize)((0, $8ENGG.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $a8600556d6c14ba3$var$resolve(instance[type] || Component[type], name) || // global registration
        $a8600556d6c14ba3$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) // fallback to implicit self-reference
        return Component;
        return res;
    }
}
function $a8600556d6c14ba3$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8ENGG.camelize)(name)] || registry[(0, $8ENGG.capitalize)((0, $8ENGG.camelize)(name))]);
}
/**
 * Actual implementation
 */ function $a8600556d6c14ba3$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $8ENGG.isArray)(source) || (0, $8ENGG.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, undefined, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, undefined, cached && cached[i]);
    } else if ((0, $8ENGG.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, undefined, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
/**
 * Compiler runtime helper for creating dynamic slots object
 * @private
 */ function $a8600556d6c14ba3$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        // array of dynamic slot generated by <template v-for="..." #[...]>
        if ((0, $8ENGG.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) // conditional single slot generated by <template v-if="..." #foo>
        slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            // attach branch key so each conditional branch is considered a
            // different fragment
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
/**
 * Compiler runtime helper for rendering `<slot/>`
 * @private
 */ function $a8600556d6c14ba3$export$4abee4c34694ada1(slots, name, props = {}, // this is not a user-facing function, so the fallback is always generated by
// the compiler and guaranteed to be a function returning an array
fallback, noSlotted) {
    if ($a8600556d6c14ba3$var$currentRenderingInstance.isCE || $a8600556d6c14ba3$var$currentRenderingInstance.parent && $a8600556d6c14ba3$var$isAsyncWrapper($a8600556d6c14ba3$var$currentRenderingInstance.parent) && $a8600556d6c14ba3$var$currentRenderingInstance.parent.isCE) return $a8600556d6c14ba3$export$bf5c4cf060303d58("slot", name === "default" ? null : {
        name: name
    }, fallback && fallback());
    let slot = slots[name];
    // a compiled slot disables block tracking by default to avoid manual
    // invocation interfering with template-based block tracking, but in
    // `renderSlot` we can be sure that it's template-based so we can force
    // enable it.
    if (slot && slot._c) slot._d = false;
    $a8600556d6c14ba3$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $a8600556d6c14ba3$var$ensureValidVNode(slot(props));
    const rendered = $a8600556d6c14ba3$export$9f2dfe8048dfb22b($a8600556d6c14ba3$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 /* SlotFlags.STABLE */  ? 64 /* PatchFlags.STABLE_FRAGMENT */  : -2 /* PatchFlags.BAIL */ );
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $a8600556d6c14ba3$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$a8600556d6c14ba3$export$3868d13f8734ae81(child)) return true;
        if (child.type === $a8600556d6c14ba3$export$4d299b491347818a) return false;
        if (child.type === $a8600556d6c14ba3$export$ffb0004e005737fa && !$a8600556d6c14ba3$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
/**
 * For prefixing keys in v-on="obj" with "on"
 * @private
 */ function $a8600556d6c14ba3$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8ENGG.toHandlerKey)(key)] = obj[key];
    return ret;
}
/**
 * #2437 In Vue 3, functional components do not have a public instance proxy but
 * they exist in the internal parent chain. For code that relies on traversing
 * public $parent chains, skip functional ones and go to the parent instead.
 */ const $a8600556d6c14ba3$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($a8600556d6c14ba3$var$isStatefulComponent(i)) return $a8600556d6c14ba3$var$getExposeProxy(i) || i.proxy;
    return $a8600556d6c14ba3$var$getPublicInstance(i.parent);
};
const $a8600556d6c14ba3$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/*#__PURE__*/ (0, $8ENGG.extend)(Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$a8600556d6c14ba3$var$getPublicInstance(i.parent),
    $root: (i)=>$a8600556d6c14ba3$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $a8600556d6c14ba3$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>$a8600556d6c14ba3$var$queueJob(i.update)),
    $nextTick: (i)=>i.n || (i.n = $a8600556d6c14ba3$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $a8600556d6c14ba3$var$instanceWatch.bind(i) : (0, $8ENGG.NOOP)
});
const $a8600556d6c14ba3$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $a8600556d6c14ba3$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        // data / props / ctx
        // This getter gets called for every property access on the render context
        // during render and is a major hotspot. The most expensive part of this
        // is the multiple hasOwn() calls. It's much faster to do a simple property
        // access on a plain object, so we use an accessCache object (with null
        // prototype) to memoize what access type a key corresponds to.
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== undefined) switch(n){
                case 1 /* AccessTypes.SETUP */ :
                    return setupState[key];
                case 2 /* AccessTypes.DATA */ :
                    return data[key];
                case 4 /* AccessTypes.CONTEXT */ :
                    return ctx[key];
                case 3 /* AccessTypes.PROPS */ :
                    return props[key];
            }
            else if (setupState !== (0, $8ENGG.EMPTY_OBJ) && (0, $8ENGG.hasOwn)(setupState, key)) {
                accessCache[key] = 1 /* AccessTypes.SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $8ENGG.EMPTY_OBJ) && (0, $8ENGG.hasOwn)(data, key)) {
                accessCache[key] = 2 /* AccessTypes.DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $8ENGG.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* AccessTypes.PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8ENGG.EMPTY_OBJ) && (0, $8ENGG.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* AccessTypes.CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $a8600556d6c14ba3$var$shouldCacheAccess) accessCache[key] = 0 /* AccessTypes.OTHER */ ;
        }
        const publicGetter = $a8600556d6c14ba3$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        // public $xxx properties
        if (publicGetter) {
            if (key === "$attrs") (0, $am4TS.track)(instance, "get" /* TrackOpTypes.GET */ , key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8ENGG.EMPTY_OBJ) && (0, $8ENGG.hasOwn)(ctx, key)) {
            // user may set custom properties to `this` that start with `$`
            accessCache[key] = 4 /* AccessTypes.CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8ENGG.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if (setupState !== (0, $8ENGG.EMPTY_OBJ) && (0, $8ENGG.hasOwn)(setupState, key)) {
            setupState[key] = value;
            return true;
        } else if (data !== (0, $8ENGG.EMPTY_OBJ) && (0, $8ENGG.hasOwn)(data, key)) {
            data[key] = value;
            return true;
        } else if ((0, $8ENGG.hasOwn)(instance.props, key)) return false;
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $8ENGG.EMPTY_OBJ) && (0, $8ENGG.hasOwn)(data, key) || setupState !== (0, $8ENGG.EMPTY_OBJ) && (0, $8ENGG.hasOwn)(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $8ENGG.hasOwn)(normalizedProps, key) || (0, $8ENGG.hasOwn)(ctx, key) || (0, $8ENGG.hasOwn)($a8600556d6c14ba3$var$publicPropertiesMap, key) || (0, $8ENGG.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) // invalidate key cache of a getter based property #5417
        target._.accessCache[key] = 0;
        else if ((0, $8ENGG.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $a8600556d6c14ba3$var$target;
const $a8600556d6c14ba3$var$RuntimeCompiledPublicInstanceProxyHandlers = /*#__PURE__*/ (0, $8ENGG.extend)({}, $a8600556d6c14ba3$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        // fast path for unscopables when using `with` block
        if (key === Symbol.unscopables) return;
        return $a8600556d6c14ba3$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8ENGG.isGloballyWhitelisted)(key);
        return has;
    }
});
// dev only
// In dev mode, the proxy target exposes the same properties as seen on `this`
// for easier console inspection. In prod mode it will be an empty object so
// these properties definitions can be skipped.
function $a8600556d6c14ba3$var$createDevRenderContext(instance) {
    const target = {};
    // expose internal instance for proxy handlers
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    // expose public properties
    Object.keys($a8600556d6c14ba3$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$a8600556d6c14ba3$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8ENGG.NOOP)
        });
    });
    return target;
}
// dev only
function $a8600556d6c14ba3$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8ENGG.NOOP)
        });
    });
}
// dev only
function $a8600556d6c14ba3$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $am4TS.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($a8600556d6c14ba3$var$isReservedPrefix(key[0])) {
                $a8600556d6c14ba3$export$c106dd0671a0fc2d(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" ` + `which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8ENGG.NOOP)
            });
        }
    });
}
function $a8600556d6c14ba3$var$createDuplicateChecker() {
    const cache = Object.create(null);
    return (type, key)=>{
        if (cache[key]) $a8600556d6c14ba3$export$c106dd0671a0fc2d(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $a8600556d6c14ba3$var$shouldCacheAccess = true;
function $a8600556d6c14ba3$var$applyOptions(instance) {
    const options = $a8600556d6c14ba3$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    // do not cache property access on public proxy during state initialization
    $a8600556d6c14ba3$var$shouldCacheAccess = false;
    // call beforeCreate first before accessing other options since
    // the hook may mutate resolved options (#2791)
    if (options.beforeCreate) $a8600556d6c14ba3$var$callHook(options.beforeCreate, instance, "bc" /* LifecycleHooks.BEFORE_CREATE */ );
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    // options initialization order (to be consistent with Vue 2):
    // - props (already done outside of this function)
    // - inject
    // - methods
    // - data (deferred since it relies on `this` access)
    // - computed
    // - watch (deferred since it relies on `this` access)
    if (injectOptions) $a8600556d6c14ba3$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties, instance.appContext.config.unwrapInjectedRef);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8ENGG.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8ENGG.isObject)(data)) ;
        else instance.data = (0, $am4TS.reactive)(data);
    }
    // state initialization complete at this point - start caching access
    $a8600556d6c14ba3$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8ENGG.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8ENGG.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8ENGG.NOOP);
        const set = !(0, $8ENGG.isFunction)(opt) && (0, $8ENGG.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8ENGG.NOOP);
        const c = $a8600556d6c14ba3$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$a8600556d6c14ba3$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8ENGG.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $a8600556d6c14ba3$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $a8600556d6c14ba3$var$callHook(created, instance, "c" /* LifecycleHooks.CREATED */ );
    function registerLifecycleHook(register, hook) {
        if ((0, $8ENGG.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($a8600556d6c14ba3$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($a8600556d6c14ba3$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($a8600556d6c14ba3$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($a8600556d6c14ba3$export$5876c47052fb88b1, updated);
    registerLifecycleHook($a8600556d6c14ba3$export$ba52d824b95a2154, activated);
    registerLifecycleHook($a8600556d6c14ba3$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($a8600556d6c14ba3$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($a8600556d6c14ba3$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($a8600556d6c14ba3$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($a8600556d6c14ba3$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($a8600556d6c14ba3$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($a8600556d6c14ba3$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8ENGG.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    // options that are handled when creating the instance but also need to be
    // applied from mixins
    if (render && instance.render === (0, $8ENGG.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    // asset options.
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $a8600556d6c14ba3$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8ENGG.NOOP), unwrapRef = false) {
    if ((0, $8ENGG.isArray)(injectOptions)) injectOptions = $a8600556d6c14ba3$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8ENGG.isObject)(opt)) {
            if ("default" in opt) injected = $a8600556d6c14ba3$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $a8600556d6c14ba3$export$a976684a0efeb93f(opt.from || key);
        } else injected = $a8600556d6c14ba3$export$a976684a0efeb93f(opt);
        if ((0, $am4TS.isRef)(injected)) {
            // TODO remove the check in 3.3
            if (unwrapRef) Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>injected.value,
                set: (v1)=>injected.value = v1
            });
            else ctx[key] = injected;
        } else ctx[key] = injected;
    }
}
function $a8600556d6c14ba3$var$callHook(hook, instance, type) {
    $a8600556d6c14ba3$export$dae85862a8d94378((0, $8ENGG.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $a8600556d6c14ba3$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $a8600556d6c14ba3$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8ENGG.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8ENGG.isFunction)(handler)) $a8600556d6c14ba3$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8ENGG.isFunction)(raw)) $a8600556d6c14ba3$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8ENGG.isObject)(raw)) {
        if ((0, $8ENGG.isArray)(raw)) raw.forEach((r)=>$a8600556d6c14ba3$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8ENGG.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8ENGG.isFunction)(handler)) $a8600556d6c14ba3$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
/**
 * Resolve merged options and cache it on the component.
 * This is done only once per-component since the merging does not involve
 * instances.
 */ function $a8600556d6c14ba3$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$a8600556d6c14ba3$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $a8600556d6c14ba3$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8ENGG.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $a8600556d6c14ba3$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $a8600556d6c14ba3$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$a8600556d6c14ba3$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $a8600556d6c14ba3$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $a8600556d6c14ba3$var$internalOptionMergeStrats = {
    data: $a8600556d6c14ba3$var$mergeDataFn,
    props: $a8600556d6c14ba3$var$mergeObjectOptions,
    emits: $a8600556d6c14ba3$var$mergeObjectOptions,
    // objects
    methods: $a8600556d6c14ba3$var$mergeObjectOptions,
    computed: $a8600556d6c14ba3$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $a8600556d6c14ba3$var$mergeAsArray,
    created: $a8600556d6c14ba3$var$mergeAsArray,
    beforeMount: $a8600556d6c14ba3$var$mergeAsArray,
    mounted: $a8600556d6c14ba3$var$mergeAsArray,
    beforeUpdate: $a8600556d6c14ba3$var$mergeAsArray,
    updated: $a8600556d6c14ba3$var$mergeAsArray,
    beforeDestroy: $a8600556d6c14ba3$var$mergeAsArray,
    beforeUnmount: $a8600556d6c14ba3$var$mergeAsArray,
    destroyed: $a8600556d6c14ba3$var$mergeAsArray,
    unmounted: $a8600556d6c14ba3$var$mergeAsArray,
    activated: $a8600556d6c14ba3$var$mergeAsArray,
    deactivated: $a8600556d6c14ba3$var$mergeAsArray,
    errorCaptured: $a8600556d6c14ba3$var$mergeAsArray,
    serverPrefetch: $a8600556d6c14ba3$var$mergeAsArray,
    // assets
    components: $a8600556d6c14ba3$var$mergeObjectOptions,
    directives: $a8600556d6c14ba3$var$mergeObjectOptions,
    // watch
    watch: $a8600556d6c14ba3$var$mergeWatchOptions,
    // provide / inject
    provide: $a8600556d6c14ba3$var$mergeDataFn,
    inject: $a8600556d6c14ba3$var$mergeInject
};
function $a8600556d6c14ba3$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8ENGG.extend)((0, $8ENGG.isFunction)(to) ? to.call(this, this) : to, (0, $8ENGG.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $a8600556d6c14ba3$var$mergeInject(to, from) {
    return $a8600556d6c14ba3$var$mergeObjectOptions($a8600556d6c14ba3$var$normalizeInject(to), $a8600556d6c14ba3$var$normalizeInject(from));
}
function $a8600556d6c14ba3$var$normalizeInject(raw) {
    if ((0, $8ENGG.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $a8600556d6c14ba3$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $a8600556d6c14ba3$var$mergeObjectOptions(to, from) {
    return to ? (0, $8ENGG.extend)((0, $8ENGG.extend)(Object.create(null), to), from) : from;
}
function $a8600556d6c14ba3$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8ENGG.extend)(Object.create(null), to);
    for(const key in from)merged[key] = $a8600556d6c14ba3$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $a8600556d6c14ba3$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = {};
    (0, $8ENGG.def)(attrs, $a8600556d6c14ba3$var$InternalObjectKey, 1);
    instance.propsDefaults = Object.create(null);
    $a8600556d6c14ba3$var$setFullProps(instance, rawProps, props, attrs);
    // ensure all declared prop keys are present
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = undefined;
    if (isStateful) // stateful
    instance.props = isSSR ? props : (0, $am4TS.shallowReactive)(props);
    else if (!instance.type.props) // functional w/ optional props, props === attrs
    instance.props = attrs;
    else // functional w/ declared props
    instance.props = props;
    instance.attrs = attrs;
}
function $a8600556d6c14ba3$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $a8600556d6c14ba3$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $am4TS.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16 /* PatchFlags.FULL_PROPS */ )) {
        if (patchFlag & 8 /* PatchFlags.PROPS */ ) {
            // Compiler-generated props & no keys change, just set the updated
            // the props.
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                // skip if the prop key is a declared emit event listener
                if ($a8600556d6c14ba3$var$isEmitListener(instance.emitsOptions, key)) continue;
                // PROPS flag guarantees rawProps to be non-null
                const value = rawProps[key];
                if (options) {
                    // attr / props separation was done on init and will be consistent
                    // in this code path, so just check if attrs have it.
                    if ((0, $8ENGG.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8ENGG.camelize)(key);
                        props[camelizedKey] = $a8600556d6c14ba3$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        // full props update.
        if ($a8600556d6c14ba3$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        // in case of dynamic props, check if we need to delete keys from
        // the props object
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8ENGG.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8ENGG.hyphenate)(key)) === key || !(0, $8ENGG.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== undefined || // for kebab-case
                rawPrevProps[kebabKey] !== undefined)) props[key] = $a8600556d6c14ba3$var$resolvePropValue(options, rawCurrentProps, key, undefined, instance, true);
            } else delete props[key];
        }
        // in the case of functional component w/o props declaration, props and
        // attrs point to the same object so it should already have been updated.
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8ENGG.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    // trigger updates for $attrs in case it's used in component slots
    if (hasAttrsChanged) (0, $am4TS.trigger)(instance, "set" /* TriggerOpTypes.SET */ , "$attrs");
}
function $a8600556d6c14ba3$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        // key, ref are reserved and never passed down
        if ((0, $8ENGG.isReservedProp)(key)) continue;
        const value = rawProps[key];
        // prop option names are camelized during normalization, so to support
        // kebab -> camel conversion here we need to camelize the key.
        let camelKey;
        if (options && (0, $8ENGG.hasOwn)(options, camelKey = (0, $8ENGG.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$a8600556d6c14ba3$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $am4TS.toRaw)(props);
        const castValues = rawCastValues || (0, $8ENGG.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $a8600556d6c14ba3$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8ENGG.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $a8600556d6c14ba3$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8ENGG.hasOwn)(opt, "default");
        // default values
        if (hasDefault && value === undefined) {
            const defaultValue = opt.default;
            if (opt.type !== Function && (0, $8ENGG.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    $a8600556d6c14ba3$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    $a8600556d6c14ba3$var$unsetCurrentInstance();
                }
            } else value = defaultValue;
        }
        // boolean casting
        if (opt[0 /* BooleanFlags.shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* BooleanFlags.shouldCastTrue */ ] && (value === "" || value === (0, $8ENGG.hyphenate)(key))) value = true;
        }
    }
    return value;
}
function $a8600556d6c14ba3$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    // apply mixin/extends props
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8ENGG.isFunction)(comp)) {
        const extendProps = (raw)=>{
            hasExtends = true;
            const [props, keys] = $a8600556d6c14ba3$var$normalizePropsOptions(raw, appContext, true);
            (0, $8ENGG.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8ENGG.isObject)(comp)) cache.set(comp, (0, $8ENGG.EMPTY_ARR));
        return 0, $8ENGG.EMPTY_ARR;
    }
    if ((0, $8ENGG.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8ENGG.camelize)(raw[i]);
        if ($a8600556d6c14ba3$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8ENGG.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8ENGG.camelize)(key);
        if ($a8600556d6c14ba3$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8ENGG.isArray)(opt) || (0, $8ENGG.isFunction)(opt) ? {
                type: opt
            } : opt;
            if (prop) {
                const booleanIndex = $a8600556d6c14ba3$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $a8600556d6c14ba3$var$getTypeIndex(String, prop.type);
                prop[0 /* BooleanFlags.shouldCast */ ] = booleanIndex > -1;
                prop[1 /* BooleanFlags.shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                // if the prop needs boolean casting or default value
                if (booleanIndex > -1 || (0, $8ENGG.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8ENGG.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $a8600556d6c14ba3$var$validatePropName(key) {
    if (key[0] !== "$") return true;
    return false;
}
// use function string name to check type constructors
// so that it works across vms / iframes.
function $a8600556d6c14ba3$var$getType(ctor) {
    const match = ctor && ctor.toString().match(/^\s*function (\w+)/);
    return match ? match[1] : ctor === null ? "null" : "";
}
function $a8600556d6c14ba3$var$isSameType(a, b) {
    return $a8600556d6c14ba3$var$getType(a) === $a8600556d6c14ba3$var$getType(b);
}
function $a8600556d6c14ba3$var$getTypeIndex(type, expectedTypes) {
    if ((0, $8ENGG.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$a8600556d6c14ba3$var$isSameType(t, type));
    else if ((0, $8ENGG.isFunction)(expectedTypes)) return $a8600556d6c14ba3$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
/**
 * dev only
 */ function $a8600556d6c14ba3$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $am4TS.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $a8600556d6c14ba3$var$validateProp(key, resolvedValues[key], opt, !(0, $8ENGG.hasOwn)(rawProps, key) && !(0, $8ENGG.hasOwn)(rawProps, (0, $8ENGG.hyphenate)(key)));
    }
}
/**
 * dev only
 */ function $a8600556d6c14ba3$var$validateProp(name, value, prop, isAbsent) {
    const { type: type, required: required, validator: validator } = prop;
    // required!
    if (required && isAbsent) {
        $a8600556d6c14ba3$export$c106dd0671a0fc2d('Missing required prop: "' + name + '"');
        return;
    }
    // missing but optional
    if (value == null && !prop.required) return;
    // type check
    if (type != null && type !== true) {
        let isValid = false;
        const types = (0, $8ENGG.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        // value is valid as long as one of the specified types match
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $a8600556d6c14ba3$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $a8600556d6c14ba3$export$c106dd0671a0fc2d($a8600556d6c14ba3$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    // custom validator
    if (validator && !validator(value)) $a8600556d6c14ba3$export$c106dd0671a0fc2d('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $a8600556d6c14ba3$var$isSimpleType = /*#__PURE__*/ (0, $8ENGG.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
/**
 * dev only
 */ function $a8600556d6c14ba3$var$assertType(value, type) {
    let valid;
    const expectedType = $a8600556d6c14ba3$var$getType(type);
    if ($a8600556d6c14ba3$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $8ENGG.isObject)(value);
    else if (expectedType === "Array") valid = (0, $8ENGG.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
/**
 * dev only
 */ function $a8600556d6c14ba3$var$getInvalidTypeMessage(name, value, expectedTypes) {
    let message = `Invalid prop: type check failed for prop "${name}".` + ` Expected ${expectedTypes.map((0, $8ENGG.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8ENGG.toRawType)(value);
    const expectedValue = $a8600556d6c14ba3$var$styleValue(value, expectedType);
    const receivedValue = $a8600556d6c14ba3$var$styleValue(value, receivedType);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 && $a8600556d6c14ba3$var$isExplicable(expectedType) && !$a8600556d6c14ba3$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    // check if we need to specify received value
    if ($a8600556d6c14ba3$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
/**
 * dev only
 */ function $a8600556d6c14ba3$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
/**
 * dev only
 */ function $a8600556d6c14ba3$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
/**
 * dev only
 */ function $a8600556d6c14ba3$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $a8600556d6c14ba3$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $a8600556d6c14ba3$var$normalizeSlotValue = (value)=>(0, $8ENGG.isArray)(value) ? value.map($a8600556d6c14ba3$var$normalizeVNode) : [
        $a8600556d6c14ba3$var$normalizeVNode(value)
    ];
const $a8600556d6c14ba3$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) // already normalized - #5353
    return rawSlot;
    const normalized = $a8600556d6c14ba3$export$694b237e827a3d23((...args)=>{
        return $a8600556d6c14ba3$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $a8600556d6c14ba3$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($a8600556d6c14ba3$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8ENGG.isFunction)(value)) slots[key] = $a8600556d6c14ba3$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $a8600556d6c14ba3$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $a8600556d6c14ba3$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $a8600556d6c14ba3$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $a8600556d6c14ba3$var$initSlots = (instance, children)=>{
    if (instance.vnode.shapeFlag & 32 /* ShapeFlags.SLOTS_CHILDREN */ ) {
        const type = children._;
        if (type) {
            // users can get the shallow readonly version of the slots object through `this.$slots`,
            // we should avoid the proxy object polluting the slots of the internal instance
            instance.slots = (0, $am4TS.toRaw)(children);
            // make compiler marker non-enumerable
            (0, $8ENGG.def)(children, "_", type);
        } else $a8600556d6c14ba3$var$normalizeObjectSlots(children, instance.slots = {});
    } else {
        instance.slots = {};
        if (children) $a8600556d6c14ba3$var$normalizeVNodeSlots(instance, children);
    }
    (0, $8ENGG.def)(instance.slots, $a8600556d6c14ba3$var$InternalObjectKey, 1);
};
const $a8600556d6c14ba3$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8ENGG.EMPTY_OBJ);
    if (vnode.shapeFlag & 32 /* ShapeFlags.SLOTS_CHILDREN */ ) {
        const type = children._;
        if (type) {
            if (optimized && type === 1 /* SlotFlags.STABLE */ ) // compiled AND stable.
            // no need to update, and skip stale slots removal.
            needDeletionCheck = false;
            else {
                // compiled but dynamic (v-if/v-for on slots) - update slots, but skip
                // normalization.
                (0, $8ENGG.extend)(slots, children);
                // #2893
                // when rendering the optimized slots by manually written render function,
                // we need to delete the `slots._` flag if necessary to make subsequent updates reliable,
                // i.e. let the `renderSlot` create the bailed Fragment
                if (!optimized && type === 1 /* SlotFlags.STABLE */ ) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $a8600556d6c14ba3$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        // non slot object children (direct value) passed to a component
        $a8600556d6c14ba3$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    // delete stale slots
    if (needDeletionCheck) {
        for(const key in slots)if (!$a8600556d6c14ba3$var$isInternalKey(key) && !(key in deletionComparisonTarget)) delete slots[key];
    }
};
function $a8600556d6c14ba3$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8ENGG.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: undefined,
            warnHandler: undefined,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: Object.create(null),
        optionsCache: new WeakMap(),
        propsCache: new WeakMap(),
        emitsCache: new WeakMap()
    };
}
let $a8600556d6c14ba3$var$uid = 0;
function $a8600556d6c14ba3$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8ENGG.isFunction)(rootComponent)) rootComponent = Object.assign({}, rootComponent);
        if (rootProps != null && !(0, $8ENGG.isObject)(rootProps)) rootProps = null;
        const context = $a8600556d6c14ba3$var$createAppContext();
        const installedPlugins = new Set();
        let isMounted = false;
        const app = context.app = {
            _uid: $a8600556d6c14ba3$var$uid++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $a8600556d6c14ba3$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8ENGG.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8ENGG.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, isSVG) {
                if (!isMounted) {
                    const vnode = $a8600556d6c14ba3$export$bf5c4cf060303d58(rootComponent, rootProps);
                    // store app context on the root VNode.
                    // this will be set on the root instance on initial mount.
                    vnode.appContext = context;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, isSVG);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $a8600556d6c14ba3$var$devtoolsInitApp(app, $a8600556d6c14ba3$export$83d89fbfd8236492);
                    }
                    return $a8600556d6c14ba3$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $a8600556d6c14ba3$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            }
        };
        return app;
    };
}
/**
 * Function for handling a template ref
 */ function $a8600556d6c14ba3$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8ENGG.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$a8600556d6c14ba3$var$setRef(r, oldRawRef && ((0, $8ENGG.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($a8600556d6c14ba3$var$isAsyncWrapper(vnode) && !isUnmount) // when mounting async components, nothing needs to be done,
    // because the template ref is forwarded to inner component
    return;
    const refValue = vnode.shapeFlag & 4 /* ShapeFlags.STATEFUL_COMPONENT */  ? $a8600556d6c14ba3$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8ENGG.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    // dynamic ref changed. unset old ref
    if (oldRef != null && oldRef !== ref) {
        if ((0, $8ENGG.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $8ENGG.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $am4TS.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $8ENGG.isFunction)(ref)) $a8600556d6c14ba3$export$b22fcaf88446e9bf(ref, owner, 12 /* ErrorCodes.FUNCTION_REF */ , [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8ENGG.isString)(ref);
        const _isRef = (0, $am4TS.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $8ENGG.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $8ENGG.isArray)(existing) && (0, $8ENGG.remove)(existing, refValue);
                    else {
                        if (!(0, $8ENGG.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $8ENGG.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, $8ENGG.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $a8600556d6c14ba3$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $a8600556d6c14ba3$var$hasMismatch = false;
const $a8600556d6c14ba3$var$isSVGContainer = (container)=>/svg/.test(container.namespaceURI) && container.tagName !== "foreignObject";
const $a8600556d6c14ba3$var$isComment = (node)=>node.nodeType === 8 /* DOMNodeTypes.COMMENT */ ;
// Note: hydration is DOM-specific
// But we have to place it in core due to tight coupling with core - splitting
// it out creates a ton of unnecessary complexity.
// Hydration also depends on some renderer internal logic which needs to be
// passed in via arguments.
function $a8600556d6c14ba3$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            patch(null, vnode, container);
            $a8600556d6c14ba3$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $a8600556d6c14ba3$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $a8600556d6c14ba3$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($a8600556d6c14ba3$var$hasMismatch && true) // this error should show up in production
        console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        const isFragmentStart = $a8600556d6c14ba3$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (patchFlag === -2 /* PatchFlags.BAIL */ ) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $a8600556d6c14ba3$export$5f1af8db9871e1d6:
                if (domType !== 3 /* DOMNodeTypes.TEXT */ ) {
                    // #5728 empty text node inside a slot can cause hydration failure
                    // because the server rendered HTML won't contain a text node
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $a8600556d6c14ba3$var$hasMismatch = true;
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $a8600556d6c14ba3$export$4d299b491347818a:
                if (domType !== 8 /* DOMNodeTypes.COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $a8600556d6c14ba3$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    // entire template is static but SSRed as a fragment
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* DOMNodeTypes.ELEMENT */  || domType === 3 /* DOMNodeTypes.TEXT */ ) {
                    // determine anchor, adopt content
                    nextNode = node;
                    // if the static vnode has its content stripped during build,
                    // adopt it from the server-rendered HTML.
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* DOMNodeTypes.ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $a8600556d6c14ba3$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1 /* ShapeFlags.ELEMENT */ ) {
                    if (domType !== 1 /* DOMNodeTypes.ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6 /* ShapeFlags.COMPONENT */ ) {
                    // when setting up the render effect, if the initial vnode already
                    // has .el set, the component will perform hydration instead of mount
                    // on its sub-tree.
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $a8600556d6c14ba3$var$isSVGContainer(container), optimized);
                    // component may be async, so in the case of fragments we cannot rely
                    // on component's rendered output to determine the end of the fragment
                    // instead, we do a lookahead to find the end anchor node.
                    nextNode = isFragmentStart ? locateClosingAsyncAnchor(node) : nextSibling(node);
                    // #4293 teleport as component root
                    if (nextNode && $a8600556d6c14ba3$var$isComment(nextNode) && nextNode.data === "teleport end") nextNode = nextSibling(nextNode);
                    // #3787
                    // if component is async, it may get moved / unmounted before its
                    // inner component is loaded, so we need to give it a placeholder
                    // vnode that matches its adopted DOM.
                    if ($a8600556d6c14ba3$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $a8600556d6c14ba3$export$bf5c4cf060303d58($a8600556d6c14ba3$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $a8600556d6c14ba3$export$22f9b5ffd89dac9("") : $a8600556d6c14ba3$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64 /* ShapeFlags.TELEPORT */ ) {
                    if (domType !== 8 /* DOMNodeTypes.COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $a8600556d6c14ba3$var$isSVGContainer(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
        }
        if (ref != null) $a8600556d6c14ba3$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs } = vnode;
        // #4006 for form elements with non-string v-model value bindings
        // e.g. <option :value="obj">, <input type="checkbox" :true-value="1">
        const forcePatchValue = type === "input" && dirs || type === "option";
        // skip props & children if this is hoisted static nodes
        // #5405 in dev, always hydrate children for HMR
        if (forcePatchValue || patchFlag !== -1 /* PatchFlags.HOISTED */ ) {
            if (dirs) $a8600556d6c14ba3$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            // props
            if (props) {
                if (forcePatchValue || !optimized || patchFlag & 48 /* PatchFlags.HYDRATE_EVENTS */ ) {
                    for(const key in props)if (forcePatchValue && key.endsWith("value") || (0, $8ENGG.isOn)(key) && !(0, $8ENGG.isReservedProp)(key)) patchProp(el, key, null, props[key], false, undefined, parentComponent);
                } else if (props.onClick) // Fast path for click listeners (which is most often) to avoid
                // iterating through props.
                patchProp(el, "onClick", null, props.onClick, false, undefined, parentComponent);
            }
            // vnode / directive hooks
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $a8600556d6c14ba3$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $a8600556d6c14ba3$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs) $a8600556d6c14ba3$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $a8600556d6c14ba3$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                dirs && $a8600556d6c14ba3$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
            // children
            if (shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */  && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $a8600556d6c14ba3$var$hasMismatch = true;
                    // The SSRed DOM contains more nodes than it should. Remove them.
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8 /* ShapeFlags.TEXT_CHILDREN */ ) {
                if (el.textContent !== vnode.children) {
                    $a8600556d6c14ba3$var$hasMismatch = true;
                    el.textContent = vnode.children;
                }
            }
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $a8600556d6c14ba3$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $a8600556d6c14ba3$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $a8600556d6c14ba3$var$hasMismatch = true;
                // the SSRed DOM didn't contain enough nodes. Mount the missing ones.
                patch(null, vnode, container, null, parentComponent, parentSuspense, $a8600556d6c14ba3$var$isSVGContainer(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $a8600556d6c14ba3$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            // fragment didn't hydrate successfully, since we didn't get a end anchor
            // back. This should have led to node/children mismatch warnings.
            $a8600556d6c14ba3$var$hasMismatch = true;
            // since the anchor is missing, we need to create one and insert it
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $a8600556d6c14ba3$var$hasMismatch = true;
        vnode.el = null;
        if (isFragment) {
            // remove excessive fragment nodes
            const end = locateClosingAsyncAnchor(node);
            while(true){
                const next = nextSibling(node);
                if (next && next !== end) remove(next);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $a8600556d6c14ba3$var$isSVGContainer(container), slotScopeIds);
        return next;
    };
    const locateClosingAsyncAnchor = (node)=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $a8600556d6c14ba3$var$isComment(node)) {
                if (node.data === "[") match++;
                if (node.data === "]") {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    return [
        hydrate,
        hydrateNode
    ];
}
/* eslint-disable no-restricted-globals */ let $a8600556d6c14ba3$var$supported;
let $a8600556d6c14ba3$var$perf;
function $a8600556d6c14ba3$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $a8600556d6c14ba3$var$isSupported()) $a8600556d6c14ba3$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $a8600556d6c14ba3$var$devtoolsPerfStart(instance, type, $a8600556d6c14ba3$var$isSupported() ? $a8600556d6c14ba3$var$perf.now() : Date.now());
}
function $a8600556d6c14ba3$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $a8600556d6c14ba3$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $a8600556d6c14ba3$var$perf.mark(endTag);
        $a8600556d6c14ba3$var$perf.measure(`<${$a8600556d6c14ba3$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $a8600556d6c14ba3$var$perf.clearMarks(startTag);
        $a8600556d6c14ba3$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $a8600556d6c14ba3$var$devtoolsPerfEnd(instance, type, $a8600556d6c14ba3$var$isSupported() ? $a8600556d6c14ba3$var$perf.now() : Date.now());
}
function $a8600556d6c14ba3$var$isSupported() {
    if ($a8600556d6c14ba3$var$supported !== undefined) return $a8600556d6c14ba3$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $a8600556d6c14ba3$var$supported = true;
        $a8600556d6c14ba3$var$perf = window.performance;
    } else $a8600556d6c14ba3$var$supported = false;
    return $a8600556d6c14ba3$var$supported;
}
/**
 * This is only called in esm-bundler builds.
 * It is called when a renderer is created, in `baseCreateRenderer` so that
 * importing runtime-core is side-effects free.
 *
 * istanbul-ignore-next
 */ function $a8600556d6c14ba3$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $8ENGG.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $8ENGG.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
}
const $a8600556d6c14ba3$var$queuePostRenderEffect = $a8600556d6c14ba3$var$queueEffectWithSuspense;
/**
 * The createRenderer function accepts two generic arguments:
 * HostNode and HostElement, corresponding to Node and Element types in the
 * host environment. For example, for runtime-dom, HostNode would be the DOM
 * `Node` interface and HostElement would be the DOM `Element` interface.
 *
 * Custom renderers can pass in the platform specific types like this:
 *
 * ``` js
 * const { render, createApp } = createRenderer<Node, Element>({
 *   patchProp,
 *   ...nodeOps
 * })
 * ```
 */ function $a8600556d6c14ba3$export$53ae2f996c64e9a(options) {
    return $a8600556d6c14ba3$var$baseCreateRenderer(options);
}
// Separate API for creating hydration-enabled renderer.
// Hydration logic is only used when calling this function, making it
// tree-shakable.
function $a8600556d6c14ba3$export$200524cf0d997ff0(options) {
    return $a8600556d6c14ba3$var$baseCreateRenderer(options, $a8600556d6c14ba3$var$createHydrationFunctions);
}
// implementation
function $a8600556d6c14ba3$var$baseCreateRenderer(options, createHydrationFns) {
    $a8600556d6c14ba3$var$initFeatureFlags();
    const target = (0, $8ENGG.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $a8600556d6c14ba3$export$b0c258b32c26c785(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8ENGG.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    // Note: functions inside this closure should use `const xxx = () => {}`
    // style in order to prevent being inlined by minifiers.
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        // patching & not same type, unmount old tree
        if (n1 && !$a8600556d6c14ba3$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2 /* PatchFlags.BAIL */ ) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $a8600556d6c14ba3$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $a8600556d6c14ba3$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $a8600556d6c14ba3$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, isSVG);
                break;
            case $a8600556d6c14ba3$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1 /* ShapeFlags.ELEMENT */ ) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 6 /* ShapeFlags.COMPONENT */ ) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 64 /* ShapeFlags.TELEPORT */ ) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        }
        // set ref
        if (ref != null && parentComponent) $a8600556d6c14ba3$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else // there's no support for dynamic comments
        n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, isSVG)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor);
    };
    /**
     * Dev / HMR only
     */ const patchStaticNode = (n1, n2, container, isSVG)=>{
        // static nodes are only patched during dev for HMR
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            // remove existing
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        isSVG = isSVG || n2.type === "svg";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { type: type, props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
        // mount children first, since some props may rely on child content
        // being already rendered, e.g. `<select value>`
        if (shapeFlag & 8 /* ShapeFlags.TEXT_CHILDREN */ ) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
        if (dirs) $a8600556d6c14ba3$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        // props
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8ENGG.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            /**
             * Special case for setting value on DOM elements:
             * - it can be order-sensitive (e.g. should be set *after* min/max, #2325, #4024)
             * - it needs to be forced (#1471)
             * #2353 proposes adding another renderer option to configure this, but
             * the properties affects are so finite it is worth special casing it
             * here to reduce the complexity. (Special casing it also should not
             * affect non-DOM renderers)
             */ if ("value" in props) hostPatchProp(el, "value", null, props.value);
            if (vnodeHook = props.onVnodeBeforeMount) $a8600556d6c14ba3$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        // scopeId
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $a8600556d6c14ba3$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        // #1583 For inside suspense + suspense not resolved case, enter hook should call when suspense resolved
        // #1689 For inside suspense + suspense resolved case, just call it
        const needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $a8600556d6c14ba3$var$queuePostRenderEffect(()=>{
            vnodeHook && $a8600556d6c14ba3$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $a8600556d6c14ba3$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $a8600556d6c14ba3$var$cloneIfMounted(children[i]) : $a8600556d6c14ba3$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        // #1426 take the old vnode's patch flag into account since user may clone a
        // compiler-generated vnode, which de-opts to FULL_PROPS
        patchFlag |= n1.patchFlag & 16 /* PatchFlags.FULL_PROPS */ ;
        const oldProps = n1.props || (0, $8ENGG.EMPTY_OBJ);
        const newProps = n2.props || (0, $8ENGG.EMPTY_OBJ);
        let vnodeHook;
        // disable recurse in beforeUpdate hooks
        parentComponent && $a8600556d6c14ba3$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $a8600556d6c14ba3$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $a8600556d6c14ba3$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $a8600556d6c14ba3$var$toggleRecurse(parentComponent, true);
        const areChildrenSVG = isSVG && n2.type !== "foreignObject";
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
        else if (!optimized) // full diff
        patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
        if (patchFlag > 0) {
            // the presence of a patchFlag means this element's render code was
            // generated by the compiler and can take the fast path.
            // in this path old node and new node are guaranteed to have the same shape
            // (i.e. at the exact same position in the source template)
            if (patchFlag & 16 /* PatchFlags.FULL_PROPS */ ) // element props contain dynamic keys, full diff needed
            patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
            else {
                // class
                // this flag is matched when the element has dynamic class bindings.
                if (patchFlag & 2 /* PatchFlags.CLASS */ ) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, isSVG);
                }
                // style
                // this flag is matched when the element has dynamic style bindings
                if (patchFlag & 4 /* PatchFlags.STYLE */ ) hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
                // props
                // This flag is matched when the element has dynamic prop/attr bindings
                // other than class and style. The keys of dynamic prop/attrs are saved for
                // faster iteration.
                // Note dynamic keys like :[foo]="bar" will cause this optimization to
                // bail out and go through a full diff because we need to unset the old key
                if (patchFlag & 8 /* PatchFlags.PROPS */ ) {
                    // if the flag is present then dynamicProps must be non-null
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        // #1471 force patch value
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            // text
            // This flag is matched when the element has only dynamic text children.
            if (patchFlag & 1 /* PatchFlags.TEXT */ ) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) // unoptimized, full diff
        patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $a8600556d6c14ba3$var$queuePostRenderEffect(()=>{
            vnodeHook && $a8600556d6c14ba3$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $a8600556d6c14ba3$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    // The fast path for blocks.
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            // Determine the container (parent element) for the patch.
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $a8600556d6c14ba3$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$a8600556d6c14ba3$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70 /* ShapeFlags.TELEPORT */ ) ? hostParentNode(oldVNode.el) : // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8ENGG.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8ENGG.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                // empty string is not valid prop
                if ((0, $8ENGG.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                // defer patching value
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        // check if this is a slot fragment with :slotted scope ids
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            // a fragment can only have array children
            // since they are either generated by the compiler, or implicitly created
            // from arrays.
            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 /* PatchFlags.STABLE_FRAGMENT */  && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            // a stable fragment (template root or <template v-for>) doesn't need to
            // patch children order, but it may contain dynamicChildren.
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $a8600556d6c14ba3$var$traverseStaticChildren(n1, n2, true);
        } else // keyed / unkeyed, or manual fragments.
        // for keyed & unkeyed, since they are compiler generated from v-for,
        // each child is guaranteed to be a block so the fragment will never
        // have dynamicChildren.
        patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512 /* ShapeFlags.COMPONENT_KEPT_ALIVE */ ) parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized)=>{
        const instance = initialVNode.component = $a8600556d6c14ba3$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        // inject renderer internals for keepAlive
        if ($a8600556d6c14ba3$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $a8600556d6c14ba3$var$setupComponent(instance);
        // setup() is async. This component relies on async logic to be resolved
        // before proceeding
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            // Give it a placeholder if this is not hydration
            // TODO handle self-defined fallback
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $a8600556d6c14ba3$export$bf5c4cf060303d58($a8600556d6c14ba3$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
            return;
        }
        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($a8600556d6c14ba3$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                // normal update
                instance.next = n2;
                // in case the child component is also queued, remove it to avoid
                // double updating the same child component in the same flush.
                $a8600556d6c14ba3$var$invalidateJob(instance.update);
                // instance.update is the reactive effect.
                instance.update();
            }
        } else {
            // no update needed. just copy over properties
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $a8600556d6c14ba3$var$isAsyncWrapper(initialVNode);
                $a8600556d6c14ba3$var$toggleRecurse(instance, false);
                // beforeMount hook
                if (bm) (0, $8ENGG.invokeArrayFns)(bm);
                // onVnodeBeforeMount
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $a8600556d6c14ba3$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $a8600556d6c14ba3$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    // vnode has adopted host node - perform hydration instead of mount.
                    const hydrateSubTree = ()=>{
                        instance.subTree = $a8600556d6c14ba3$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $a8600556d6c14ba3$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
                    initialVNode.el = subTree.el;
                }
                // mounted hook
                if (m) $a8600556d6c14ba3$var$queuePostRenderEffect(m, parentSuspense);
                // onVnodeMounted
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $a8600556d6c14ba3$var$queuePostRenderEffect(()=>$a8600556d6c14ba3$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                // activated hook for keep-alive roots.
                // #1742 activated hook must be accessed after first render
                // since the hook may be injected by a child keep-alive
                if (initialVNode.shapeFlag & 256 /* ShapeFlags.COMPONENT_SHOULD_KEEP_ALIVE */  || parent && $a8600556d6c14ba3$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256 /* ShapeFlags.COMPONENT_SHOULD_KEEP_ALIVE */ ) instance.a && $a8600556d6c14ba3$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $a8600556d6c14ba3$var$devtoolsComponentAdded(instance);
                // #2458: deference mount-only object parameters to prevent memleaks
                initialVNode = container = anchor = null;
            } else {
                // updateComponent
                // This is triggered by mutation of component's own state (next: null)
                // OR parent calling processComponent (next: VNode)
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                let originNext = next;
                let vnodeHook;
                // Disallow component effect recursion during pre-lifecycle hooks.
                $a8600556d6c14ba3$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                // beforeUpdate hook
                if (bu) (0, $8ENGG.invokeArrayFns)(bu);
                // onVnodeBeforeUpdate
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $a8600556d6c14ba3$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $a8600556d6c14ba3$var$toggleRecurse(instance, true);
                const nextTree = $a8600556d6c14ba3$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
                next.el = nextTree.el;
                if (originNext === null) // self-triggered update. In case of HOC, update parent component
                // vnode el. HOC is indicated by parent instance's subTree pointing
                // to child component's vnode
                $a8600556d6c14ba3$var$updateHOCHostEl(instance, nextTree.el);
                // updated hook
                if (u) $a8600556d6c14ba3$var$queuePostRenderEffect(u, parentSuspense);
                // onVnodeUpdated
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $a8600556d6c14ba3$var$queuePostRenderEffect(()=>$a8600556d6c14ba3$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $a8600556d6c14ba3$var$devtoolsComponentUpdated(instance);
            }
        };
        // create reactive effect for rendering
        const effect = instance.effect = new (0, $am4TS.ReactiveEffect)(componentUpdateFn, ()=>$a8600556d6c14ba3$var$queueJob(update), instance.scope // track it in component's effect scope
        );
        const update = instance.update = ()=>effect.run();
        update.id = instance.uid;
        // allowRecurse
        // #1801, #2043 component render effects should allow recursive updates
        $a8600556d6c14ba3$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $a8600556d6c14ba3$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $a8600556d6c14ba3$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $am4TS.pauseTracking)();
        // props update may have triggered pre-flush watchers.
        // flush them before the render update.
        $a8600556d6c14ba3$var$flushPreFlushCbs();
        (0, $am4TS.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        // fast path
        if (patchFlag > 0) {
            if (patchFlag & 128 /* PatchFlags.KEYED_FRAGMENT */ ) {
                // this could be either fully-keyed or mixed (some keyed some not)
                // presence of patchFlag means children are guaranteed to be arrays
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256 /* PatchFlags.UNKEYED_FRAGMENT */ ) {
                // unkeyed
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
        }
        // children has 3 possibilities: text, array or no children.
        if (shapeFlag & 8 /* ShapeFlags.TEXT_CHILDREN */ ) {
            // text children fast path
            if (prevShapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) {
            // prev children was array
            if (shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) // two arrays, cannot assume anything, do full diff
            patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else // no new children, just unmount old
            unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            // prev children was text OR null
            // new children is array OR null
            if (prevShapeFlag & 8 /* ShapeFlags.TEXT_CHILDREN */ ) hostSetElementText(container, "");
            // mount new if array
            if (shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8ENGG.EMPTY_ARR);
        c2 = c2 || (0, $8ENGG.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $a8600556d6c14ba3$var$cloneIfMounted(c2[i]) : $a8600556d6c14ba3$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        if (oldLength > newLength) // remove old
        unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else // mount new
        mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    };
    // can be all-keyed or mixed
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1; // prev ending index
        let e2 = l2 - 1; // next ending index
        // 1. sync from start
        // (a b) c
        // (a b) d e
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $a8600556d6c14ba3$var$cloneIfMounted(c2[i]) : $a8600556d6c14ba3$var$normalizeVNode(c2[i]);
            if ($a8600556d6c14ba3$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            i++;
        }
        // 2. sync from end
        // a (b c)
        // d e (b c)
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $a8600556d6c14ba3$var$cloneIfMounted(c2[e2]) : $a8600556d6c14ba3$var$normalizeVNode(c2[e2]);
            if ($a8600556d6c14ba3$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        // 3. common sequence + mount
        // (a b)
        // (a b) c
        // i = 2, e1 = 1, e2 = 2
        // (a b)
        // c (a b)
        // i = 0, e1 = -1, e2 = 0
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $a8600556d6c14ba3$var$cloneIfMounted(c2[i]) : $a8600556d6c14ba3$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i; // prev starting index
            const s2 = i; // next starting index
            // 5.1 build key:index map for newChildren
            const keyToNewIndexMap = new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $a8600556d6c14ba3$var$cloneIfMounted(c2[i]) : $a8600556d6c14ba3$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            // 5.2 loop through old children left to be patched and try to patch
            // matching nodes & remove nodes that are no longer present
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            // used to track whether any node has moved
            let maxNewIndexSoFar = 0;
            // works as Map<newIndex, oldIndex>
            // Note that oldIndex is offset by +1
            // and oldIndex = 0 is a special value indicating the new node has
            // no corresponding old node.
            // used for determining longest stable subsequence
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    // all new children have been patched so this can only be a removal
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    // key-less node, try to locate a key-less node of the same type
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $a8600556d6c14ba3$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === undefined) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    patched++;
                }
            }
            // 5.3 move and mount
            // generate longest stable subsequence only when nodes have moved
            const increasingNewIndexSequence = moved ? $a8600556d6c14ba3$var$getSequence(newIndexToOldIndexMap) : (0, $8ENGG.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            // looping backwards so that we can use last patched node as anchor
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) // mount new
                patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (moved) {
                    // move if:
                    // There is no stable subsequence (e.g. a reverse)
                    // OR current node is not among the stable sequence
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2 /* MoveType.REORDER */ );
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6 /* ShapeFlags.COMPONENT */ ) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64 /* ShapeFlags.TELEPORT */ ) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $a8600556d6c14ba3$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $a8600556d6c14ba3$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        // single nodes
        const needTransition = moveType !== 2 /* MoveType.REORDER */  && shapeFlag & 1 /* ShapeFlags.ELEMENT */  && transition;
        if (needTransition) {
            if (moveType === 0 /* MoveType.ENTER */ ) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $a8600556d6c14ba3$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        // unset ref
        if (ref != null) $a8600556d6c14ba3$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256 /* ShapeFlags.COMPONENT_SHOULD_KEEP_ALIVE */ ) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 /* ShapeFlags.ELEMENT */  && dirs;
        const shouldInvokeVnodeHook = !$a8600556d6c14ba3$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $a8600556d6c14ba3$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6 /* ShapeFlags.COMPONENT */ ) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $a8600556d6c14ba3$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64 /* ShapeFlags.TELEPORT */ ) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $a8600556d6c14ba3$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64 /* PatchFlags.STABLE_FRAGMENT */ )) // fast path for block nodes: only need to unmount dynamic children.
            unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $a8600556d6c14ba3$export$ffb0004e005737fa && patchFlag & 384 /* PatchFlags.UNKEYED_FRAGMENT */  || !optimized && shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $a8600556d6c14ba3$var$queuePostRenderEffect(()=>{
            vnodeHook && $a8600556d6c14ba3$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $a8600556d6c14ba3$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $a8600556d6c14ba3$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $a8600556d6c14ba3$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 /* ShapeFlags.ELEMENT */  && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        // For fragments, directly remove all contained DOM nodes.
        // (fragment child nodes cannot have transition)
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        // beforeUnmount hook
        if (bum) (0, $8ENGG.invokeArrayFns)(bum);
        // stop effects in component scope
        scope.stop();
        // update may be null if a component is unmounted before its async
        // setup has resolved.
        if (update) {
            // so that scheduler will no longer invoke it
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        // unmounted hook
        if (um) $a8600556d6c14ba3$var$queuePostRenderEffect(um, parentSuspense);
        $a8600556d6c14ba3$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        // A component with async dep inside a pending suspense is unmounted before
        // its async dep resolves. This should remove the dep from the suspense, and
        // cause the suspense to resolve immediately if that was the last dep.
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $a8600556d6c14ba3$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6 /* ShapeFlags.COMPONENT */ ) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    const render = (vnode, container, isSVG)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, isSVG);
        $a8600556d6c14ba3$var$flushPreFlushCbs();
        $a8600556d6c14ba3$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $a8600556d6c14ba3$var$createAppAPI(render, hydrate)
    };
}
function $a8600556d6c14ba3$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
/**
 * #1156
 * When a component is HMR-enabled, we need to make sure that all static nodes
 * inside a block also inherit the DOM element from the previous tree so that
 * HMR updates (which are full updates) can retrieve the element for patching.
 *
 * #2080
 * Inside keyed `template` fragment static children, if a fragment is moved,
 * the children will always be moved. Therefore, in order to ensure correct move
 * position, el should be inherited from previous nodes.
 */ function $a8600556d6c14ba3$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8ENGG.isArray)(ch1) && (0, $8ENGG.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        // this is only called in the optimized path so array children are
        // guaranteed to be vnodes
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 /* ShapeFlags.ELEMENT */  && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32 /* PatchFlags.HYDRATE_EVENTS */ ) {
                c2 = ch2[i] = $a8600556d6c14ba3$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $a8600556d6c14ba3$var$traverseStaticChildren(c1, c2);
        }
    }
}
// https://en.wikipedia.org/wiki/Longest_increasing_subsequence
function $a8600556d6c14ba3$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
const $a8600556d6c14ba3$var$isTeleport = (type)=>type.__isTeleport;
const $a8600556d6c14ba3$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $a8600556d6c14ba3$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $a8600556d6c14ba3$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8ENGG.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $a8600556d6c14ba3$var$TeleportImpl = {
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $a8600556d6c14ba3$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            // insert anchors in the main view
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $a8600556d6c14ba3$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                // #2652 we could be teleporting from a non-SVG tree into an SVG tree
                isSVG = isSVG || $a8600556d6c14ba3$var$isTargetSVG(target);
            }
            const mount = (container, anchor)=>{
                // Teleport *always* has Array children. This is enforced in both the
                // compiler and vnode children normalization.
                if (shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) mountChildren(children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            // update content
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $a8600556d6c14ba3$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            isSVG = isSVG || $a8600556d6c14ba3$var$isTargetSVG(target);
            if (dynamicChildren) {
                // fast path when the teleport happens to be a block root
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
                // even in block tree mode we need to make sure all root-level nodes
                // in the teleport inherit previous DOM references so that they can
                // be moved in future patches.
                $a8600556d6c14ba3$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) // enabled -> disabled
                // move into main container
                $a8600556d6c14ba3$var$moveTeleport(n2, container, mainAnchor, internals, 1 /* TeleportMoveTypes.TOGGLE */ );
            } else {
                // target changed
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $a8600556d6c14ba3$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $a8600556d6c14ba3$var$moveTeleport(n2, nextTarget, null, internals, 0 /* TeleportMoveTypes.TARGET_CHANGE */ );
                } else if (wasDisabled) // disabled -> enabled
                // move into teleport target
                $a8600556d6c14ba3$var$moveTeleport(n2, target, targetAnchor, internals, 1 /* TeleportMoveTypes.TOGGLE */ );
            }
        }
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        // an unmounted teleport should always remove its children if not disabled
        if (doRemove || !$a8600556d6c14ba3$var$isTeleportDisabled(props)) {
            hostRemove(anchor);
            if (shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
            }
        }
    },
    move: $a8600556d6c14ba3$var$moveTeleport,
    hydrate: $a8600556d6c14ba3$var$hydrateTeleport
};
function $a8600556d6c14ba3$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2 /* TeleportMoveTypes.REORDER */ ) {
    // move target anchor if this is a target change.
    if (moveType === 0 /* TeleportMoveTypes.TARGET_CHANGE */ ) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2 /* TeleportMoveTypes.REORDER */ ;
    // move main view anchor if this is a re-order.
    if (isReorder) insert(el, container, parentAnchor);
    // if this is a re-order and teleport is enabled (content is in target)
    // do not move children. So the opposite is: only move children if this
    // is not a reorder, or the teleport is disabled
    if (!isReorder || $a8600556d6c14ba3$var$isTeleportDisabled(props)) {
        // Teleport has either Array children or no children.
        if (shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2 /* MoveType.REORDER */ );
    }
    // move main view anchor if this is a re-order.
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $a8600556d6c14ba3$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $a8600556d6c14ba3$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        // if multiple teleports rendered to the same target element, we need to
        // pick up from where the last teleport finished instead of the first node
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16 /* ShapeFlags.ARRAY_CHILDREN */ ) {
            if ($a8600556d6c14ba3$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                // lookahead until we find the target anchor
                // we cannot rely on return value of hydrateChildren() because there
                // could be nested teleports
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
// Force-casted public typing for h and TSX props inference
const $a8600556d6c14ba3$export$76d55a0304a371f4 = $a8600556d6c14ba3$var$TeleportImpl;
const $a8600556d6c14ba3$export$ffb0004e005737fa = Symbol(undefined);
const $a8600556d6c14ba3$export$5f1af8db9871e1d6 = Symbol(undefined);
const $a8600556d6c14ba3$export$4d299b491347818a = Symbol(undefined);
const $a8600556d6c14ba3$export$c1b9a1d3af45b7b6 = Symbol(undefined);
// Since v-if and v-for are the two possible ways node structure can dynamically
// change, once we consider v-if branches and each v-for fragment a block, we
// can divide a template into nested blocks, and within each block the node
// structure would be stable. This allows us to skip most children diffing
// and only worry about the dynamic nodes (indicated by patch flags).
const $a8600556d6c14ba3$var$blockStack = [];
let $a8600556d6c14ba3$var$currentBlock = null;
/**
 * Open a block.
 * This must be called before `createBlock`. It cannot be part of `createBlock`
 * because the children of the block are evaluated before `createBlock` itself
 * is called. The generated code typically looks like this:
 *
 * ```js
 * function render() {
 *   return (openBlock(),createBlock('div', null, [...]))
 * }
 * ```
 * disableTracking is true when creating a v-for fragment block, since a v-for
 * fragment always diffs its children.
 *
 * @private
 */ function $a8600556d6c14ba3$export$e7eaa45e502fe5cc(disableTracking = false) {
    $a8600556d6c14ba3$var$blockStack.push($a8600556d6c14ba3$var$currentBlock = disableTracking ? null : []);
}
function $a8600556d6c14ba3$var$closeBlock() {
    $a8600556d6c14ba3$var$blockStack.pop();
    $a8600556d6c14ba3$var$currentBlock = $a8600556d6c14ba3$var$blockStack[$a8600556d6c14ba3$var$blockStack.length - 1] || null;
}
// Whether we should be tracking dynamic child nodes inside a block.
// Only tracks when this value is > 0
// We are not using a simple boolean because this value may need to be
// incremented/decremented by nested usage of v-once (see below)
let $a8600556d6c14ba3$var$isBlockTreeEnabled = 1;
/**
 * Block tracking sometimes needs to be disabled, for example during the
 * creation of a tree that needs to be cached by v-once. The compiler generates
 * code like this:
 *
 * ``` js
 * _cache[1] || (
 *   setBlockTracking(-1),
 *   _cache[1] = createVNode(...),
 *   setBlockTracking(1),
 *   _cache[1]
 * )
 * ```
 *
 * @private
 */ function $a8600556d6c14ba3$export$c20bee82f26f1e27(value) {
    $a8600556d6c14ba3$var$isBlockTreeEnabled += value;
}
function $a8600556d6c14ba3$var$setupBlock(vnode) {
    // save current block children on the block vnode
    vnode.dynamicChildren = $a8600556d6c14ba3$var$isBlockTreeEnabled > 0 ? $a8600556d6c14ba3$var$currentBlock || (0, $8ENGG.EMPTY_ARR) : null;
    // close block
    $a8600556d6c14ba3$var$closeBlock();
    // a block is always going to be patched, so track it as a child of its
    // parent block
    if ($a8600556d6c14ba3$var$isBlockTreeEnabled > 0 && $a8600556d6c14ba3$var$currentBlock) $a8600556d6c14ba3$var$currentBlock.push(vnode);
    return vnode;
}
/**
 * @private
 */ function $a8600556d6c14ba3$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $a8600556d6c14ba3$var$setupBlock($a8600556d6c14ba3$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
/**
 * Create a block root vnode. Takes the same exact arguments as `createVNode`.
 * A block root keeps track of dynamic nodes within the block in the
 * `dynamicChildren` array.
 *
 * @private
 */ function $a8600556d6c14ba3$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $a8600556d6c14ba3$var$setupBlock($a8600556d6c14ba3$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $a8600556d6c14ba3$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $a8600556d6c14ba3$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $a8600556d6c14ba3$var$vnodeArgsTransformer;
/**
 * Internal API for registering an arguments transform for createVNode
 * used for creating stubs in the test-utils
 * It is *internal* but needs to be exposed for test-utils to pick up proper
 * typings
 */ function $a8600556d6c14ba3$export$83beccd3afeeb809(transformer) {
    $a8600556d6c14ba3$var$vnodeArgsTransformer = transformer;
}
const $a8600556d6c14ba3$var$createVNodeWithArgsTransform = (...args)=>{
    return $a8600556d6c14ba3$var$_createVNode(...$a8600556d6c14ba3$var$vnodeArgsTransformer ? $a8600556d6c14ba3$var$vnodeArgsTransformer(args, $a8600556d6c14ba3$var$currentRenderingInstance) : args);
};
const $a8600556d6c14ba3$var$InternalObjectKey = `__vInternal`;
const $a8600556d6c14ba3$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $a8600556d6c14ba3$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    return ref != null ? (0, $8ENGG.isString)(ref) || (0, $am4TS.isRef)(ref) || (0, $8ENGG.isFunction)(ref) ? {
        i: $a8600556d6c14ba3$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $a8600556d6c14ba3$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $a8600556d6c14ba3$export$ffb0004e005737fa ? 0 : 1 /* ShapeFlags.ELEMENT */ , isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $a8600556d6c14ba3$var$normalizeKey(props),
        ref: props && $a8600556d6c14ba3$var$normalizeRef(props),
        scopeId: $a8600556d6c14ba3$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null
    };
    if (needFullChildrenNormalization) {
        $a8600556d6c14ba3$var$normalizeChildren(vnode, children);
        // normalize suspense children
        if (shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) type.normalize(vnode);
    } else if (children) // compiled element vnode - if children is passed, only possible types are
    // string or Array.
    vnode.shapeFlag |= (0, $8ENGG.isString)(children) ? 8 /* ShapeFlags.TEXT_CHILDREN */  : 16 /* ShapeFlags.ARRAY_CHILDREN */ ;
    // track vnode for block tree
    if ($a8600556d6c14ba3$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $a8600556d6c14ba3$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6 /* ShapeFlags.COMPONENT */ ) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32 /* PatchFlags.HYDRATE_EVENTS */ ) $a8600556d6c14ba3$var$currentBlock.push(vnode);
    return vnode;
}
const $a8600556d6c14ba3$export$bf5c4cf060303d58 = $a8600556d6c14ba3$var$_createVNode;
function $a8600556d6c14ba3$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $a8600556d6c14ba3$var$NULL_DYNAMIC_COMPONENT) type = $a8600556d6c14ba3$export$4d299b491347818a;
    if ($a8600556d6c14ba3$export$3868d13f8734ae81(type)) {
        // createVNode receiving an existing vnode. This happens in cases like
        // <component :is="vnode"/>
        // #2078 make sure to merge refs during the clone instead of overwriting it
        const cloned = $a8600556d6c14ba3$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $a8600556d6c14ba3$var$normalizeChildren(cloned, children);
        if ($a8600556d6c14ba3$var$isBlockTreeEnabled > 0 && !isBlockNode && $a8600556d6c14ba3$var$currentBlock) {
            if (cloned.shapeFlag & 6 /* ShapeFlags.COMPONENT */ ) $a8600556d6c14ba3$var$currentBlock[$a8600556d6c14ba3$var$currentBlock.indexOf(type)] = cloned;
            else $a8600556d6c14ba3$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2 /* PatchFlags.BAIL */ ;
        return cloned;
    }
    // class component normalization.
    if ($a8600556d6c14ba3$var$isClassComponent(type)) type = type.__vccOpts;
    // class & style normalization.
    if (props) {
        // for reactive or proxy objects, we need to clone it to enable mutation.
        props = $a8600556d6c14ba3$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8ENGG.isString)(klass)) props.class = (0, $8ENGG.normalizeClass)(klass);
        if ((0, $8ENGG.isObject)(style)) {
            // reactive state objects need to be cloned since they are likely to be
            // mutated
            if ((0, $am4TS.isProxy)(style) && !(0, $8ENGG.isArray)(style)) style = (0, $8ENGG.extend)({}, style);
            props.style = (0, $8ENGG.normalizeStyle)(style);
        }
    }
    // encode the vnode type information into a bitmap
    const shapeFlag = (0, $8ENGG.isString)(type) ? 1 /* ShapeFlags.ELEMENT */  : $a8600556d6c14ba3$var$isSuspense(type) ? 128 /* ShapeFlags.SUSPENSE */  : $a8600556d6c14ba3$var$isTeleport(type) ? 64 /* ShapeFlags.TELEPORT */  : (0, $8ENGG.isObject)(type) ? 4 /* ShapeFlags.STATEFUL_COMPONENT */  : (0, $8ENGG.isFunction)(type) ? 2 /* ShapeFlags.FUNCTIONAL_COMPONENT */  : 0;
    return $a8600556d6c14ba3$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $a8600556d6c14ba3$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $am4TS.isProxy)(props) || $a8600556d6c14ba3$var$InternalObjectKey in props ? (0, $8ENGG.extend)({}, props) : props;
}
function $a8600556d6c14ba3$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false) {
    // This is intentionally NOT using spread or extend to avoid the runtime
    // key enumeration cost.
    const { props: props, ref: ref, patchFlag: patchFlag, children: children } = vnode;
    const mergedProps = extraProps ? $a8600556d6c14ba3$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $a8600556d6c14ba3$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8ENGG.isArray)(ref) ? ref.concat($a8600556d6c14ba3$var$normalizeRef(extraProps)) : [
            ref,
            $a8600556d6c14ba3$var$normalizeRef(extraProps)
        ] : $a8600556d6c14ba3$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $a8600556d6c14ba3$export$ffb0004e005737fa ? patchFlag === -1 // hoisted node
         ? 16 /* PatchFlags.FULL_PROPS */  : patchFlag | 16 /* PatchFlags.FULL_PROPS */  : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $a8600556d6c14ba3$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $a8600556d6c14ba3$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor
    };
    return cloned;
}
/**
 * Dev only, for HMR of hoisted vnodes reused in v-for
 * https://github.com/vitejs/vite/issues/2022
 */ function $a8600556d6c14ba3$var$deepCloneVNode(vnode) {
    const cloned = $a8600556d6c14ba3$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8ENGG.isArray)(vnode.children)) cloned.children = vnode.children.map($a8600556d6c14ba3$var$deepCloneVNode);
    return cloned;
}
/**
 * @private
 */ function $a8600556d6c14ba3$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $a8600556d6c14ba3$export$bf5c4cf060303d58($a8600556d6c14ba3$export$5f1af8db9871e1d6, null, text, flag);
}
/**
 * @private
 */ function $a8600556d6c14ba3$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    // A static vnode can contain multiple stringified elements, and the number
    // of elements is necessary for hydration.
    const vnode = $a8600556d6c14ba3$export$bf5c4cf060303d58($a8600556d6c14ba3$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
/**
 * @private
 */ function $a8600556d6c14ba3$export$49553837c7236d3c(text = "", // when used as the v-else branch, the comment node must be created as a
// block to ensure correct updates.
asBlock = false) {
    return asBlock ? ($a8600556d6c14ba3$export$e7eaa45e502fe5cc(), $a8600556d6c14ba3$export$9f2dfe8048dfb22b($a8600556d6c14ba3$export$4d299b491347818a, null, text)) : $a8600556d6c14ba3$export$bf5c4cf060303d58($a8600556d6c14ba3$export$4d299b491347818a, null, text);
}
function $a8600556d6c14ba3$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") // empty placeholder
    return $a8600556d6c14ba3$export$bf5c4cf060303d58($a8600556d6c14ba3$export$4d299b491347818a);
    else if ((0, $8ENGG.isArray)(child)) // fragment
    return $a8600556d6c14ba3$export$bf5c4cf060303d58($a8600556d6c14ba3$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") // already vnode, this should be the most common since compiled templates
    // always produce all-vnode children arrays
    return $a8600556d6c14ba3$var$cloneIfMounted(child);
    else // strings and numbers
    return $a8600556d6c14ba3$export$bf5c4cf060303d58($a8600556d6c14ba3$export$5f1af8db9871e1d6, null, String(child));
}
// optimized normalization for template-compiled render fns
function $a8600556d6c14ba3$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 /* PatchFlags.HOISTED */  || child.memo ? child : $a8600556d6c14ba3$export$ee4f9e12c0a92a1a(child);
}
function $a8600556d6c14ba3$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8ENGG.isArray)(children)) type = 16 /* ShapeFlags.ARRAY_CHILDREN */ ;
    else if (typeof children === "object") {
        if (shapeFlag & 65 /* ShapeFlags.TELEPORT */ ) {
            // Normalize slot to plain children for plain element and Teleport
            const slot = children.default;
            if (slot) {
                // _c marker is added by withCtx() indicating this is a compiled slot
                slot._c && (slot._d = false);
                $a8600556d6c14ba3$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32 /* ShapeFlags.SLOTS_CHILDREN */ ;
            const slotFlag = children._;
            if (!slotFlag && !($a8600556d6c14ba3$var$InternalObjectKey in children)) children._ctx = $a8600556d6c14ba3$var$currentRenderingInstance;
            else if (slotFlag === 3 /* SlotFlags.FORWARDED */  && $a8600556d6c14ba3$var$currentRenderingInstance) {
                // a child component receives forwarded slots from the parent.
                // its slot type is determined by its parent's slot type.
                if ($a8600556d6c14ba3$var$currentRenderingInstance.slots._ === 1 /* SlotFlags.STABLE */ ) children._ = 1 /* SlotFlags.STABLE */ ;
                else {
                    children._ = 2 /* SlotFlags.DYNAMIC */ ;
                    vnode.patchFlag |= 1024 /* PatchFlags.DYNAMIC_SLOTS */ ;
                }
            }
        }
    } else if ((0, $8ENGG.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $a8600556d6c14ba3$var$currentRenderingInstance
        };
        type = 32 /* ShapeFlags.SLOTS_CHILDREN */ ;
    } else {
        children = String(children);
        // force teleport children to array so it can be moved around
        if (shapeFlag & 64 /* ShapeFlags.TELEPORT */ ) {
            type = 16 /* ShapeFlags.ARRAY_CHILDREN */ ;
            children = [
                $a8600556d6c14ba3$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8 /* ShapeFlags.TEXT_CHILDREN */ ;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $a8600556d6c14ba3$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8ENGG.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8ENGG.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8ENGG.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8ENGG.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $a8600556d6c14ba3$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $a8600556d6c14ba3$export$dae85862a8d94378(hook, instance, 7 /* ErrorCodes.VNODE_HOOK */ , [
        vnode,
        prevVNode
    ]);
}
const $a8600556d6c14ba3$var$emptyAppContext = $a8600556d6c14ba3$var$createAppContext();
let $a8600556d6c14ba3$var$uid$1 = 0;
function $a8600556d6c14ba3$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    // inherit parent app context - or - if root, adopt from root vnode
    const appContext = (parent ? parent.appContext : vnode.appContext) || $a8600556d6c14ba3$var$emptyAppContext;
    const instance = {
        uid: $a8600556d6c14ba3$var$uid$1++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        next: null,
        subTree: null,
        effect: null,
        update: null,
        scope: new (0, $am4TS.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $a8600556d6c14ba3$var$normalizePropsOptions(type, appContext),
        emitsOptions: $a8600556d6c14ba3$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        emitted: null,
        // props default value
        propsDefaults: (0, $8ENGG.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8ENGG.EMPTY_OBJ),
        data: (0, $8ENGG.EMPTY_OBJ),
        props: (0, $8ENGG.EMPTY_OBJ),
        attrs: (0, $8ENGG.EMPTY_OBJ),
        slots: (0, $8ENGG.EMPTY_OBJ),
        refs: (0, $8ENGG.EMPTY_OBJ),
        setupState: (0, $8ENGG.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $a8600556d6c14ba3$var$emit$1.bind(null, instance);
    // apply custom element special handling
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $a8600556d6c14ba3$var$currentInstance = null;
const $a8600556d6c14ba3$export$f13e630aa3915748 = ()=>$a8600556d6c14ba3$var$currentInstance || $a8600556d6c14ba3$var$currentRenderingInstance;
const $a8600556d6c14ba3$var$setCurrentInstance = (instance)=>{
    $a8600556d6c14ba3$var$currentInstance = instance;
    instance.scope.on();
};
const $a8600556d6c14ba3$var$unsetCurrentInstance = ()=>{
    $a8600556d6c14ba3$var$currentInstance && $a8600556d6c14ba3$var$currentInstance.scope.off();
    $a8600556d6c14ba3$var$currentInstance = null;
};
const $a8600556d6c14ba3$var$isBuiltInTag = /*#__PURE__*/ (0, $8ENGG.makeMap)("slot,component");
function $a8600556d6c14ba3$var$validateComponentName(name, config) {
    const appIsNativeTag = config.isNativeTag || (0, $8ENGG.NO);
    if ($a8600556d6c14ba3$var$isBuiltInTag(name) || appIsNativeTag(name)) $a8600556d6c14ba3$export$c106dd0671a0fc2d("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $a8600556d6c14ba3$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4 /* ShapeFlags.STATEFUL_COMPONENT */ ;
}
let $a8600556d6c14ba3$var$isInSSRComponentSetup = false;
function $a8600556d6c14ba3$var$setupComponent(instance, isSSR = false) {
    $a8600556d6c14ba3$var$isInSSRComponentSetup = isSSR;
    const { props: props, children: children } = instance.vnode;
    const isStateful = $a8600556d6c14ba3$var$isStatefulComponent(instance);
    $a8600556d6c14ba3$var$initProps(instance, props, isStateful, isSSR);
    $a8600556d6c14ba3$var$initSlots(instance, children);
    const setupResult = isStateful ? $a8600556d6c14ba3$var$setupStatefulComponent(instance, isSSR) : undefined;
    $a8600556d6c14ba3$var$isInSSRComponentSetup = false;
    return setupResult;
}
function $a8600556d6c14ba3$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    // 0. create render proxy property access cache
    instance.accessCache = Object.create(null);
    // 1. create public instance / render proxy
    // also mark it raw so it's never observed
    instance.proxy = (0, $am4TS.markRaw)(new Proxy(instance.ctx, $a8600556d6c14ba3$var$PublicInstanceProxyHandlers));
    // 2. call setup()
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $a8600556d6c14ba3$var$createSetupContext(instance) : null;
        $a8600556d6c14ba3$var$setCurrentInstance(instance);
        (0, $am4TS.pauseTracking)();
        const setupResult = $a8600556d6c14ba3$export$b22fcaf88446e9bf(setup, instance, 0 /* ErrorCodes.SETUP_FUNCTION */ , [
            (0, instance.props),
            setupContext
        ]);
        (0, $am4TS.resetTracking)();
        $a8600556d6c14ba3$var$unsetCurrentInstance();
        if ((0, $8ENGG.isPromise)(setupResult)) {
            setupResult.then($a8600556d6c14ba3$var$unsetCurrentInstance, $a8600556d6c14ba3$var$unsetCurrentInstance);
            if (isSSR) // return the promise so server-renderer can wait on it
            return setupResult.then((resolvedResult)=>{
                $a8600556d6c14ba3$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $a8600556d6c14ba3$export$d3da1ecaf1206c58(e, instance, 0 /* ErrorCodes.SETUP_FUNCTION */ );
            });
            else // async setup returned Promise.
            // bail here and wait for re-entry.
            instance.asyncDep = setupResult;
        } else $a8600556d6c14ba3$var$handleSetupResult(instance, setupResult, isSSR);
    } else $a8600556d6c14ba3$var$finishComponentSetup(instance, isSSR);
}
function $a8600556d6c14ba3$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8ENGG.isFunction)(setupResult)) {
        // setup returned an inline render function
        if (instance.type.__ssrInlineRender) // when the function's name is `ssrRender` (compiled by SFC inline mode),
        // set it as ssrRender instead.
        instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8ENGG.isObject)(setupResult)) {
        // setup returned bindings.
        // assuming a render function compiled from template is present.
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $am4TS.proxyRefs)(setupResult);
    }
    $a8600556d6c14ba3$var$finishComponentSetup(instance, isSSR);
}
let $a8600556d6c14ba3$var$compile;
let $a8600556d6c14ba3$var$installWithProxy;
/**
 * For runtime-dom to register the compiler.
 * Note the exported method uses any to avoid d.ts relying on the compiler types.
 */ function $a8600556d6c14ba3$export$667bb5a67822b941(_compile) {
    $a8600556d6c14ba3$var$compile = _compile;
    $a8600556d6c14ba3$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $a8600556d6c14ba3$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
// dev only
const $a8600556d6c14ba3$export$c93a9c496c5211fa = ()=>!$a8600556d6c14ba3$var$compile;
function $a8600556d6c14ba3$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    // template / render function normalization
    // could be already set when returned from setup()
    if (!instance.render) {
        // only do on-the-fly compile if not in SSR - SSR on-the-fly compilation
        // is done by server-renderer
        if (!isSSR && $a8600556d6c14ba3$var$compile && !Component.render) {
            const template = Component.template || $a8600556d6c14ba3$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8ENGG.extend)((0, $8ENGG.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $a8600556d6c14ba3$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8ENGG.NOOP);
        // for runtime-compiled render functions using `with` blocks, the render
        // proxy used needs a different `has` handler which is more performant and
        // also only allows a whitelist of globals to fallthrough.
        if ($a8600556d6c14ba3$var$installWithProxy) $a8600556d6c14ba3$var$installWithProxy(instance);
    }
    // support for 2.x options
    if (__VUE_OPTIONS_API__ && true) {
        $a8600556d6c14ba3$var$setCurrentInstance(instance);
        (0, $am4TS.pauseTracking)();
        $a8600556d6c14ba3$var$applyOptions(instance);
        (0, $am4TS.resetTracking)();
        $a8600556d6c14ba3$var$unsetCurrentInstance();
    }
}
function $a8600556d6c14ba3$var$createAttrsProxy(instance) {
    return new Proxy(instance.attrs, {
        get (target, key) {
            (0, $am4TS.track)(instance, "get" /* TrackOpTypes.GET */ , "$attrs");
            return target[key];
        }
    });
}
function $a8600556d6c14ba3$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    let attrs;
    var event, args;
    return {
        get attrs () {
            return attrs || (attrs = $a8600556d6c14ba3$var$createAttrsProxy(instance));
        },
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $a8600556d6c14ba3$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $am4TS.proxyRefs)((0, $am4TS.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $a8600556d6c14ba3$var$publicPropertiesMap) return $a8600556d6c14ba3$var$publicPropertiesMap[key](instance);
        }
    }));
}
const $a8600556d6c14ba3$var$classifyRE = /(?:^|[-_])(\w)/g;
const $a8600556d6c14ba3$var$classify = (str)=>str.replace($a8600556d6c14ba3$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $a8600556d6c14ba3$var$getComponentName(Component, includeInferred = true) {
    return (0, $8ENGG.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
/* istanbul ignore next */ function $a8600556d6c14ba3$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $a8600556d6c14ba3$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        // try to infer the name based on reverse resolution
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $a8600556d6c14ba3$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $a8600556d6c14ba3$var$isClassComponent(value) {
    return (0, $8ENGG.isFunction)(value) && "__vccOpts" in value;
}
const $a8600556d6c14ba3$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    // @ts-ignore
    return (0, $am4TS.computed)(getterOrOptions, debugOptions, $a8600556d6c14ba3$var$isInSSRComponentSetup);
};
// dev only
const $a8600556d6c14ba3$var$warnRuntimeUsage = (method)=>$a8600556d6c14ba3$export$c106dd0671a0fc2d(`${method}() is a compiler-hint helper that is only usable inside ` + `<script setup> of a single file component. Its arguments should be ` + `compiled away and passing it at runtime has no effect.`);
// implementation
function $a8600556d6c14ba3$export$80b33eababae110e() {
    return null;
}
// implementation
function $a8600556d6c14ba3$export$51ecece22fc17ddc() {
    return null;
}
/**
 * Vue `<script setup>` compiler macro for declaring a component's exposed
 * instance properties when it is accessed by a parent component via template
 * refs.
 *
 * `<script setup>` components are closed by default - i.e. variables inside
 * the `<script setup>` scope is not exposed to parent unless explicitly exposed
 * via `defineExpose`.
 *
 * This is only usable inside `<script setup>`, is compiled away in the
 * output and should **not** be actually called at runtime.
 */ function $a8600556d6c14ba3$export$da25b65ca24b518a(exposed) {}
/**
 * Vue `<script setup>` compiler macro for providing props default values when
 * using type-based `defineProps` declaration.
 *
 * Example usage:
 * ```ts
 * withDefaults(defineProps<{
 *   size?: number
 *   labels?: string[]
 * }>(), {
 *   size: 3,
 *   labels: () => ['default label']
 * })
 * ```
 *
 * This is only usable inside `<script setup>`, is compiled away in the output
 * and should **not** be actually called at runtime.
 */ function $a8600556d6c14ba3$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $a8600556d6c14ba3$export$9203a8e84125433c() {
    return $a8600556d6c14ba3$var$getContext().slots;
}
function $a8600556d6c14ba3$export$75e29435042cd2ea() {
    return $a8600556d6c14ba3$var$getContext().attrs;
}
function $a8600556d6c14ba3$var$getContext() {
    const i = $a8600556d6c14ba3$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $a8600556d6c14ba3$var$createSetupContext(i));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */ function $a8600556d6c14ba3$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = (0, $8ENGG.isArray)(raw) ? raw.reduce((normalized, p)=>(normalized[p] = {}, normalized), {}) : raw;
    for(const key in defaults){
        const opt = props[key];
        if (opt) {
            if ((0, $8ENGG.isArray)(opt) || (0, $8ENGG.isFunction)(opt)) props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) props[key] = {
            default: defaults[key]
        };
    }
    return props;
}
/**
 * Used to create a proxy for the rest element when destructuring props with
 * defineProps().
 * @internal
 */ function $a8600556d6c14ba3$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
/**
 * `<script setup>` helper for persisting the current instance context over
 * async/await flows.
 *
 * `@vue/compiler-sfc` converts the following:
 *
 * ```ts
 * const x = await foo()
 * ```
 *
 * into:
 *
 * ```ts
 * let __temp, __restore
 * const x = (([__temp, __restore] = withAsyncContext(() => foo())),__temp=await __temp,__restore(),__temp)
 * ```
 * @internal
 */ function $a8600556d6c14ba3$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $a8600556d6c14ba3$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $a8600556d6c14ba3$var$unsetCurrentInstance();
    if ((0, $8ENGG.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $a8600556d6c14ba3$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$a8600556d6c14ba3$var$setCurrentInstance(ctx)
    ];
}
// Actual implementation
function $a8600556d6c14ba3$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $8ENGG.isObject)(propsOrChildren) && !(0, $8ENGG.isArray)(propsOrChildren)) {
            // single vnode without props
            if ($a8600556d6c14ba3$export$3868d13f8734ae81(propsOrChildren)) return $a8600556d6c14ba3$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            // props without children
            return $a8600556d6c14ba3$export$bf5c4cf060303d58(type, propsOrChildren);
        } else // omit props
        return $a8600556d6c14ba3$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $a8600556d6c14ba3$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $a8600556d6c14ba3$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
const $a8600556d6c14ba3$export$f2549a27e18acf2d = Symbol(``);
const $a8600556d6c14ba3$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $a8600556d6c14ba3$export$a976684a0efeb93f($a8600556d6c14ba3$export$f2549a27e18acf2d);
        if (!ctx) $a8600556d6c14ba3$export$c106dd0671a0fc2d(`Server rendering context not provided. Make sure to only call ` + `useSSRContext() conditionally in the server build.`);
        return ctx;
    }
};
function $a8600556d6c14ba3$var$isShallow(value) {
    return !!(value && value["__v_isShallow" /* ReactiveFlags.IS_SHALLOW */ ]);
}
function $a8600556d6c14ba3$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $am4TS.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8ENGG.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8ENGG.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $am4TS.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8ENGG.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8ENGG.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $am4TS.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8ENGG.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8ENGG.isArray)(opts) && opts.includes(key) || (0, $8ENGG.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ($a8600556d6c14ba3$var$isShallow(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $a8600556d6c14ba3$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $a8600556d6c14ba3$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    // shallow clone
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $a8600556d6c14ba3$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8ENGG.hasChanged)(prev[i], memo[i])) return false;
    }
    // make sure to let parent block track it when returning cached
    if ($a8600556d6c14ba3$var$isBlockTreeEnabled > 0 && $a8600556d6c14ba3$var$currentBlock) $a8600556d6c14ba3$var$currentBlock.push(cached);
    return true;
}
// Core API ------------------------------------------------------------------
const $a8600556d6c14ba3$export$83d89fbfd8236492 = "3.2.41";
const $a8600556d6c14ba3$var$_ssrUtils = {
    createComponentInstance: $a8600556d6c14ba3$var$createComponentInstance,
    setupComponent: $a8600556d6c14ba3$var$setupComponent,
    renderComponentRoot: $a8600556d6c14ba3$var$renderComponentRoot,
    setCurrentRenderingInstance: $a8600556d6c14ba3$var$setCurrentRenderingInstance,
    isVNode: $a8600556d6c14ba3$export$3868d13f8734ae81,
    normalizeVNode: $a8600556d6c14ba3$var$normalizeVNode
};
/**
 * SSR utils for \@vue/server-renderer. Only exposed in ssr-possible builds.
 * @internal
 */ const $a8600556d6c14ba3$export$a9679033567b336d = $a8600556d6c14ba3$var$_ssrUtils;
/**
 * @internal only exposed in compat builds
 */ const $a8600556d6c14ba3$export$83cf26e06ea620e1 = null;
/**
 * @internal only exposed in compat builds.
 */ const $a8600556d6c14ba3$export$dc678eddf276286e = null;

});
parcelRegister("am4TS", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return $789fc288f6b69314$export$1168ed9dbc71ddbd; });
$parcel$export(module.exports, "effectScope", function () { return $789fc288f6b69314$export$7056603ea81600be; });
$parcel$export(module.exports, "getCurrentScope", function () { return $789fc288f6b69314$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "onScopeDispose", function () { return $789fc288f6b69314$export$a780418acd4762da; });
$parcel$export(module.exports, "ReactiveEffect", function () { return $789fc288f6b69314$export$28352bb4dd362521; });
$parcel$export(module.exports, "pauseTracking", function () { return $789fc288f6b69314$export$938a971395fef855; });
$parcel$export(module.exports, "resetTracking", function () { return $789fc288f6b69314$export$c39176b1babaa8b8; });
$parcel$export(module.exports, "track", function () { return $789fc288f6b69314$export$6b2a7d5132615086; });
$parcel$export(module.exports, "trigger", function () { return $789fc288f6b69314$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "toRaw", function () { return $789fc288f6b69314$export$ab18938b9fc5f28e; });
$parcel$export(module.exports, "isRef", function () { return $789fc288f6b69314$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "readonly", function () { return $789fc288f6b69314$export$6ec456bd5b7b3c51; });
$parcel$export(module.exports, "reactive", function () { return $789fc288f6b69314$export$90a44edba14e47be; });
$parcel$export(module.exports, "isShallow", function () { return $789fc288f6b69314$export$7f3fe6025abfa26e; });
$parcel$export(module.exports, "shallowReactive", function () { return $789fc288f6b69314$export$8d81cefd22d22260; });
$parcel$export(module.exports, "isReactive", function () { return $789fc288f6b69314$export$352205f445242f02; });
$parcel$export(module.exports, "isProxy", function () { return $789fc288f6b69314$export$5f3ca29d057519b3; });
$parcel$export(module.exports, "markRaw", function () { return $789fc288f6b69314$export$995ab8b13ad7a9d0; });
$parcel$export(module.exports, "ref", function () { return $789fc288f6b69314$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "shallowRef", function () { return $789fc288f6b69314$export$9b7bc5fe3b17c8b3; });
$parcel$export(module.exports, "unref", function () { return $789fc288f6b69314$export$a239a76781616204; });
$parcel$export(module.exports, "proxyRefs", function () { return $789fc288f6b69314$export$f353fd1b97db3fa0; });
$parcel$export(module.exports, "customRef", function () { return $789fc288f6b69314$export$a20c2dd6199824cb; });
$parcel$export(module.exports, "toRefs", function () { return $789fc288f6b69314$export$2e9533675e5e70e0; });
$parcel$export(module.exports, "toRef", function () { return $789fc288f6b69314$export$1f60508e4f47b4b7; });
$parcel$export(module.exports, "computed", function () { return $789fc288f6b69314$export$2983e091f1a1e8e2; });

var $8ENGG = parcelRequire("8ENGG");
function $789fc288f6b69314$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $789fc288f6b69314$var$activeEffectScope;
class $789fc288f6b69314$export$1168ed9dbc71ddbd {
    run(fn) {
        if (this.active) {
            const currentEffectScope = $789fc288f6b69314$var$activeEffectScope;
            try {
                $789fc288f6b69314$var$activeEffectScope = this;
                return fn();
            } finally{
                $789fc288f6b69314$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */ on() {
        $789fc288f6b69314$var$activeEffectScope = this;
    }
    /**
     * This should only be called on non-detached scopes
     * @internal
     */ off() {
        $789fc288f6b69314$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this.active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            // nested scope, dereference from parent to avoid memory leaks
            if (!this.detached && this.parent && !fromParent) {
                // optimized O(1) removal
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = undefined;
            this.active = false;
        }
    }
    constructor(detached = false){
        this.detached = detached;
        /**
         * @internal
         */ this.active = true;
        /**
         * @internal
         */ this.effects = [];
        /**
         * @internal
         */ this.cleanups = [];
        this.parent = $789fc288f6b69314$var$activeEffectScope;
        if (!detached && $789fc288f6b69314$var$activeEffectScope) this.index = ($789fc288f6b69314$var$activeEffectScope.scopes || ($789fc288f6b69314$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
}
function $789fc288f6b69314$export$7056603ea81600be(detached) {
    return new $789fc288f6b69314$export$1168ed9dbc71ddbd(detached);
}
function $789fc288f6b69314$var$recordEffectScope(effect, scope = $789fc288f6b69314$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $789fc288f6b69314$export$c7be4b0125a10cba() {
    return $789fc288f6b69314$var$activeEffectScope;
}
function $789fc288f6b69314$export$a780418acd4762da(fn) {
    if ($789fc288f6b69314$var$activeEffectScope) $789fc288f6b69314$var$activeEffectScope.cleanups.push(fn);
}
const $789fc288f6b69314$var$createDep = (effects)=>{
    const dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
};
const $789fc288f6b69314$var$wasTracked = (dep)=>(dep.w & $789fc288f6b69314$var$trackOpBit) > 0;
const $789fc288f6b69314$var$newTracked = (dep)=>(dep.n & $789fc288f6b69314$var$trackOpBit) > 0;
const $789fc288f6b69314$var$initDepMarkers = ({ deps: deps })=>{
    if (deps.length) for(let i = 0; i < deps.length; i++)deps[i].w |= $789fc288f6b69314$var$trackOpBit; // set was tracked
};
const $789fc288f6b69314$var$finalizeDepMarkers = (effect)=>{
    const { deps: deps } = effect;
    if (deps.length) {
        let ptr = 0;
        for(let i = 0; i < deps.length; i++){
            const dep = deps[i];
            if ($789fc288f6b69314$var$wasTracked(dep) && !$789fc288f6b69314$var$newTracked(dep)) dep.delete(effect);
            else deps[ptr++] = dep;
            // clear bits
            dep.w &= ~$789fc288f6b69314$var$trackOpBit;
            dep.n &= ~$789fc288f6b69314$var$trackOpBit;
        }
        deps.length = ptr;
    }
};
const $789fc288f6b69314$var$targetMap = new WeakMap();
// The number of effects currently being tracked recursively.
let $789fc288f6b69314$var$effectTrackDepth = 0;
let $789fc288f6b69314$var$trackOpBit = 1;
/**
 * The bitwise track markers support at most 30 levels of recursion.
 * This value is chosen to enable modern JS engines to use a SMI on all platforms.
 * When recursion depth is greater, fall back to using a full cleanup.
 */ const $789fc288f6b69314$var$maxMarkerBits = 30;
let $789fc288f6b69314$var$activeEffect;
const $789fc288f6b69314$export$3c41b1a4e06acc14 = Symbol("");
const $789fc288f6b69314$var$MAP_KEY_ITERATE_KEY = Symbol("");
class $789fc288f6b69314$export$28352bb4dd362521 {
    run() {
        if (!this.active) return this.fn();
        let parent = $789fc288f6b69314$var$activeEffect;
        let lastShouldTrack = $789fc288f6b69314$var$shouldTrack;
        while(parent){
            if (parent === this) return;
            parent = parent.parent;
        }
        try {
            this.parent = $789fc288f6b69314$var$activeEffect;
            $789fc288f6b69314$var$activeEffect = this;
            $789fc288f6b69314$var$shouldTrack = true;
            $789fc288f6b69314$var$trackOpBit = 1 << ++$789fc288f6b69314$var$effectTrackDepth;
            if ($789fc288f6b69314$var$effectTrackDepth <= $789fc288f6b69314$var$maxMarkerBits) $789fc288f6b69314$var$initDepMarkers(this);
            else $789fc288f6b69314$var$cleanupEffect(this);
            return this.fn();
        } finally{
            if ($789fc288f6b69314$var$effectTrackDepth <= $789fc288f6b69314$var$maxMarkerBits) $789fc288f6b69314$var$finalizeDepMarkers(this);
            $789fc288f6b69314$var$trackOpBit = 1 << --$789fc288f6b69314$var$effectTrackDepth;
            $789fc288f6b69314$var$activeEffect = this.parent;
            $789fc288f6b69314$var$shouldTrack = lastShouldTrack;
            this.parent = undefined;
            if (this.deferStop) this.stop();
        }
    }
    stop() {
        // stopped while running itself - defer the cleanup
        if ($789fc288f6b69314$var$activeEffect === this) this.deferStop = true;
        else if (this.active) {
            $789fc288f6b69314$var$cleanupEffect(this);
            if (this.onStop) this.onStop();
            this.active = false;
        }
    }
    constructor(fn, scheduler = null, scope){
        this.fn = fn;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        this.parent = undefined;
        $789fc288f6b69314$var$recordEffectScope(this, scope);
    }
}
function $789fc288f6b69314$var$cleanupEffect(effect) {
    const { deps: deps } = effect;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect);
        deps.length = 0;
    }
}
function $789fc288f6b69314$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect) fn = fn.effect.fn;
    const _effect = new $789fc288f6b69314$export$28352bb4dd362521(fn);
    if (options) {
        (0, $8ENGG.extend)(_effect, options);
        if (options.scope) $789fc288f6b69314$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $789fc288f6b69314$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $789fc288f6b69314$var$shouldTrack = true;
const $789fc288f6b69314$var$trackStack = [];
function $789fc288f6b69314$export$938a971395fef855() {
    $789fc288f6b69314$var$trackStack.push($789fc288f6b69314$var$shouldTrack);
    $789fc288f6b69314$var$shouldTrack = false;
}
function $789fc288f6b69314$export$1f8ffc6fd33b1d16() {
    $789fc288f6b69314$var$trackStack.push($789fc288f6b69314$var$shouldTrack);
    $789fc288f6b69314$var$shouldTrack = true;
}
function $789fc288f6b69314$export$c39176b1babaa8b8() {
    const last = $789fc288f6b69314$var$trackStack.pop();
    $789fc288f6b69314$var$shouldTrack = last === undefined ? true : last;
}
function $789fc288f6b69314$export$6b2a7d5132615086(target, type, key) {
    if ($789fc288f6b69314$var$shouldTrack && $789fc288f6b69314$var$activeEffect) {
        let depsMap = $789fc288f6b69314$var$targetMap.get(target);
        if (!depsMap) $789fc288f6b69314$var$targetMap.set(target, depsMap = new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $789fc288f6b69314$var$createDep());
        const eventInfo = undefined;
        $789fc288f6b69314$var$trackEffects(dep, eventInfo);
    }
}
function $789fc288f6b69314$var$trackEffects(dep, debuggerEventExtraInfo) {
    let shouldTrack = false;
    if ($789fc288f6b69314$var$effectTrackDepth <= $789fc288f6b69314$var$maxMarkerBits) {
        if (!$789fc288f6b69314$var$newTracked(dep)) {
            dep.n |= $789fc288f6b69314$var$trackOpBit; // set newly tracked
            shouldTrack = !$789fc288f6b69314$var$wasTracked(dep);
        }
    } else // Full cleanup mode.
    shouldTrack = !dep.has($789fc288f6b69314$var$activeEffect);
    if (shouldTrack) {
        dep.add($789fc288f6b69314$var$activeEffect);
        $789fc288f6b69314$var$activeEffect.deps.push(dep);
    }
}
function $789fc288f6b69314$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $789fc288f6b69314$var$targetMap.get(target);
    if (!depsMap) // never been tracked
    return;
    let deps = [];
    if (type === "clear" /* TriggerOpTypes.CLEAR */ ) // collection being cleared
    // trigger all effects for target
    deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $8ENGG.isArray)(target)) depsMap.forEach((dep, key)=>{
        if (key === "length" || key >= newValue) deps.push(dep);
    });
    else {
        // schedule runs for SET | ADD | DELETE
        if (key !== void 0) deps.push(depsMap.get(key));
        // also run for iteration key on ADD | DELETE | Map.SET
        switch(type){
            case "add" /* TriggerOpTypes.ADD */ :
                if (!(0, $8ENGG.isArray)(target)) {
                    deps.push(depsMap.get($789fc288f6b69314$export$3c41b1a4e06acc14));
                    if ((0, $8ENGG.isMap)(target)) deps.push(depsMap.get($789fc288f6b69314$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $8ENGG.isIntegerKey)(key)) // new index added to array -> length changes
                deps.push(depsMap.get("length"));
                break;
            case "delete" /* TriggerOpTypes.DELETE */ :
                if (!(0, $8ENGG.isArray)(target)) {
                    deps.push(depsMap.get($789fc288f6b69314$export$3c41b1a4e06acc14));
                    if ((0, $8ENGG.isMap)(target)) deps.push(depsMap.get($789fc288f6b69314$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set" /* TriggerOpTypes.SET */ :
                if ((0, $8ENGG.isMap)(target)) deps.push(depsMap.get($789fc288f6b69314$export$3c41b1a4e06acc14));
                break;
        }
    }
    const eventInfo = undefined;
    if (deps.length === 1) {
        if (deps[0]) $789fc288f6b69314$var$triggerEffects(deps[0]);
    } else {
        const effects = [];
        for (const dep of deps)if (dep) effects.push(...dep);
        $789fc288f6b69314$var$triggerEffects($789fc288f6b69314$var$createDep(effects));
    }
}
function $789fc288f6b69314$var$triggerEffects(dep, debuggerEventExtraInfo) {
    // spread into array for stabilization
    const effects = (0, $8ENGG.isArray)(dep) ? dep : [
        ...dep
    ];
    for (const effect of effects)if (effect.computed) $789fc288f6b69314$var$triggerEffect(effect, debuggerEventExtraInfo);
    for (const effect of effects)if (!effect.computed) $789fc288f6b69314$var$triggerEffect(effect, debuggerEventExtraInfo);
}
function $789fc288f6b69314$var$triggerEffect(effect, debuggerEventExtraInfo) {
    if (effect !== $789fc288f6b69314$var$activeEffect || effect.allowRecurse) {
        if (effect.scheduler) effect.scheduler();
        else effect.run();
    }
}
const $789fc288f6b69314$var$isNonTrackableKeys = /*#__PURE__*/ (0, $8ENGG.makeMap)(`__proto__,__v_isRef,__isVue`);
const $789fc288f6b69314$var$builtInSymbols = new Set(/*#__PURE__*/ Object.getOwnPropertyNames(Symbol)// ios10.x Object.getOwnPropertyNames(Symbol) can enumerate 'arguments' and 'caller'
// but accessing them on Symbol leads to TypeError because Symbol is a strict mode
// function
.filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $8ENGG.isSymbol)));
const $789fc288f6b69314$var$get = /*#__PURE__*/ $789fc288f6b69314$var$createGetter();
const $789fc288f6b69314$var$shallowGet = /*#__PURE__*/ $789fc288f6b69314$var$createGetter(false, true);
const $789fc288f6b69314$var$readonlyGet = /*#__PURE__*/ $789fc288f6b69314$var$createGetter(true);
const $789fc288f6b69314$var$shallowReadonlyGet = /*#__PURE__*/ $789fc288f6b69314$var$createGetter(true, true);
const $789fc288f6b69314$var$arrayInstrumentations = /*#__PURE__*/ $789fc288f6b69314$var$createArrayInstrumentations();
function $789fc288f6b69314$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $789fc288f6b69314$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$789fc288f6b69314$export$6b2a7d5132615086(arr, "get" /* TrackOpTypes.GET */ , i + "");
            // we run the method using the original args first (which may be reactive)
            const res = arr[key](...args);
            if (res === -1 || res === false) // if that didn't work, run it again using raw values.
            return arr[key](...args.map($789fc288f6b69314$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $789fc288f6b69314$export$938a971395fef855();
            const res = $789fc288f6b69314$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $789fc288f6b69314$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $789fc288f6b69314$var$createGetter(isReadonly = false, shallow = false) {
    return function get(target, key, receiver) {
        if (key === "__v_isReactive" /* ReactiveFlags.IS_REACTIVE */ ) return !isReadonly;
        else if (key === "__v_isReadonly" /* ReactiveFlags.IS_READONLY */ ) return isReadonly;
        else if (key === "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */ ) return shallow;
        else if (key === "__v_raw" /* ReactiveFlags.RAW */  && receiver === (isReadonly ? shallow ? $789fc288f6b69314$var$shallowReadonlyMap : $789fc288f6b69314$var$readonlyMap : shallow ? $789fc288f6b69314$var$shallowReactiveMap : $789fc288f6b69314$var$reactiveMap).get(target)) return target;
        const targetIsArray = (0, $8ENGG.isArray)(target);
        if (!isReadonly && targetIsArray && (0, $8ENGG.hasOwn)($789fc288f6b69314$var$arrayInstrumentations, key)) return Reflect.get($789fc288f6b69314$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ((0, $8ENGG.isSymbol)(key) ? $789fc288f6b69314$var$builtInSymbols.has(key) : $789fc288f6b69314$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $789fc288f6b69314$export$6b2a7d5132615086(target, "get" /* TrackOpTypes.GET */ , key);
        if (shallow) return res;
        if ($789fc288f6b69314$export$4f9f5282de18fc69(res)) // ref unwrapping - skip unwrap for Array + integer key.
        return targetIsArray && (0, $8ENGG.isIntegerKey)(key) ? res : res.value;
        if ((0, $8ENGG.isObject)(res)) // Convert returned value into a proxy as well. we do the isObject check
        // here to avoid invalid value warning. Also need to lazy access readonly
        // and reactive here to avoid circular dependency.
        return isReadonly ? $789fc288f6b69314$export$6ec456bd5b7b3c51(res) : $789fc288f6b69314$export$90a44edba14e47be(res);
        return res;
    };
}
const $789fc288f6b69314$var$set = /*#__PURE__*/ $789fc288f6b69314$var$createSetter();
const $789fc288f6b69314$var$shallowSet = /*#__PURE__*/ $789fc288f6b69314$var$createSetter(true);
function $789fc288f6b69314$var$createSetter(shallow = false) {
    return function set(target, key, value, receiver) {
        let oldValue = target[key];
        if ($789fc288f6b69314$export$92d09b48637741e7(oldValue) && $789fc288f6b69314$export$4f9f5282de18fc69(oldValue) && !$789fc288f6b69314$export$4f9f5282de18fc69(value)) return false;
        if (!shallow) {
            if (!$789fc288f6b69314$export$7f3fe6025abfa26e(value) && !$789fc288f6b69314$export$92d09b48637741e7(value)) {
                oldValue = $789fc288f6b69314$export$ab18938b9fc5f28e(oldValue);
                value = $789fc288f6b69314$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $8ENGG.isArray)(target) && $789fc288f6b69314$export$4f9f5282de18fc69(oldValue) && !$789fc288f6b69314$export$4f9f5282de18fc69(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = (0, $8ENGG.isArray)(target) && (0, $8ENGG.isIntegerKey)(key) ? Number(key) < target.length : (0, $8ENGG.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        // don't trigger if target is something up in the prototype chain of original
        if (target === $789fc288f6b69314$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $789fc288f6b69314$export$e614dc9140f7ae71(target, "add" /* TriggerOpTypes.ADD */ , key, value);
            else if ((0, $8ENGG.hasChanged)(value, oldValue)) $789fc288f6b69314$export$e614dc9140f7ae71(target, "set" /* TriggerOpTypes.SET */ , key, value, oldValue);
        }
        return result;
    };
}
function $789fc288f6b69314$var$deleteProperty(target, key) {
    const hadKey = (0, $8ENGG.hasOwn)(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $789fc288f6b69314$export$e614dc9140f7ae71(target, "delete" /* TriggerOpTypes.DELETE */ , key, undefined, oldValue);
    return result;
}
function $789fc288f6b69314$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!(0, $8ENGG.isSymbol)(key) || !$789fc288f6b69314$var$builtInSymbols.has(key)) $789fc288f6b69314$export$6b2a7d5132615086(target, "has" /* TrackOpTypes.HAS */ , key);
    return result;
}
function $789fc288f6b69314$var$ownKeys(target) {
    $789fc288f6b69314$export$6b2a7d5132615086(target, "iterate" /* TrackOpTypes.ITERATE */ , (0, $8ENGG.isArray)(target) ? "length" : $789fc288f6b69314$export$3c41b1a4e06acc14);
    return Reflect.ownKeys(target);
}
const $789fc288f6b69314$var$mutableHandlers = {
    get: $789fc288f6b69314$var$get,
    set: $789fc288f6b69314$var$set,
    deleteProperty: $789fc288f6b69314$var$deleteProperty,
    has: $789fc288f6b69314$var$has,
    ownKeys: $789fc288f6b69314$var$ownKeys
};
const $789fc288f6b69314$var$readonlyHandlers = {
    get: $789fc288f6b69314$var$readonlyGet,
    set (target, key) {
        return true;
    },
    deleteProperty (target, key) {
        return true;
    }
};
const $789fc288f6b69314$var$shallowReactiveHandlers = /*#__PURE__*/ (0, $8ENGG.extend)({}, $789fc288f6b69314$var$mutableHandlers, {
    get: $789fc288f6b69314$var$shallowGet,
    set: $789fc288f6b69314$var$shallowSet
});
// Props handlers are special in the sense that it should not unwrap top-level
// refs (in order to allow refs to be explicitly passed down), but should
// retain the reactivity of the normal readonly object.
const $789fc288f6b69314$var$shallowReadonlyHandlers = /*#__PURE__*/ (0, $8ENGG.extend)({}, $789fc288f6b69314$var$readonlyHandlers, {
    get: $789fc288f6b69314$var$shallowReadonlyGet
});
const $789fc288f6b69314$var$toShallow = (value)=>value;
const $789fc288f6b69314$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $789fc288f6b69314$var$get$1(target, key, isReadonly = false, isShallow = false) {
    // #1772: readonly(reactive(Map)) should return readonly + reactive version
    // of the value
    target = target["__v_raw" /* ReactiveFlags.RAW */ ];
    const rawTarget = $789fc288f6b69314$export$ab18938b9fc5f28e(target);
    const rawKey = $789fc288f6b69314$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $789fc288f6b69314$export$6b2a7d5132615086(rawTarget, "get" /* TrackOpTypes.GET */ , key);
        $789fc288f6b69314$export$6b2a7d5132615086(rawTarget, "get" /* TrackOpTypes.GET */ , rawKey);
    }
    const { has: has } = $789fc288f6b69314$var$getProto(rawTarget);
    const wrap = isShallow ? $789fc288f6b69314$var$toShallow : isReadonly ? $789fc288f6b69314$var$toReadonly : $789fc288f6b69314$var$toReactive;
    if (has.call(rawTarget, key)) return wrap(target.get(key));
    else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) // #3602 readonly(reactive(Map))
    // ensure that the nested reactive `Map` can do tracking for itself
    target.get(key);
}
function $789fc288f6b69314$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw" /* ReactiveFlags.RAW */ ];
    const rawTarget = $789fc288f6b69314$export$ab18938b9fc5f28e(target);
    const rawKey = $789fc288f6b69314$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $789fc288f6b69314$export$6b2a7d5132615086(rawTarget, "has" /* TrackOpTypes.HAS */ , key);
        $789fc288f6b69314$export$6b2a7d5132615086(rawTarget, "has" /* TrackOpTypes.HAS */ , rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $789fc288f6b69314$var$size(target, isReadonly = false) {
    target = target["__v_raw" /* ReactiveFlags.RAW */ ];
    !isReadonly && $789fc288f6b69314$export$6b2a7d5132615086($789fc288f6b69314$export$ab18938b9fc5f28e(target), "iterate" /* TrackOpTypes.ITERATE */ , $789fc288f6b69314$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $789fc288f6b69314$var$add(value) {
    value = $789fc288f6b69314$export$ab18938b9fc5f28e(value);
    const target = $789fc288f6b69314$export$ab18938b9fc5f28e(this);
    const proto = $789fc288f6b69314$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $789fc288f6b69314$export$e614dc9140f7ae71(target, "add" /* TriggerOpTypes.ADD */ , value, value);
    }
    return this;
}
function $789fc288f6b69314$var$set$1(key, value) {
    value = $789fc288f6b69314$export$ab18938b9fc5f28e(value);
    const target = $789fc288f6b69314$export$ab18938b9fc5f28e(this);
    const { has: has, get: get } = $789fc288f6b69314$var$getProto(target);
    let hadKey = has.call(target, key);
    if (!hadKey) {
        key = $789fc288f6b69314$export$ab18938b9fc5f28e(key);
        hadKey = has.call(target, key);
    }
    const oldValue = get.call(target, key);
    target.set(key, value);
    if (!hadKey) $789fc288f6b69314$export$e614dc9140f7ae71(target, "add" /* TriggerOpTypes.ADD */ , key, value);
    else if ((0, $8ENGG.hasChanged)(value, oldValue)) $789fc288f6b69314$export$e614dc9140f7ae71(target, "set" /* TriggerOpTypes.SET */ , key, value, oldValue);
    return this;
}
function $789fc288f6b69314$var$deleteEntry(key) {
    const target = $789fc288f6b69314$export$ab18938b9fc5f28e(this);
    const { has: has, get: get } = $789fc288f6b69314$var$getProto(target);
    let hadKey = has.call(target, key);
    if (!hadKey) {
        key = $789fc288f6b69314$export$ab18938b9fc5f28e(key);
        hadKey = has.call(target, key);
    }
    const oldValue = get ? get.call(target, key) : undefined;
    // forward the operation before queueing reactions
    const result = target.delete(key);
    if (hadKey) $789fc288f6b69314$export$e614dc9140f7ae71(target, "delete" /* TriggerOpTypes.DELETE */ , key, undefined, oldValue);
    return result;
}
function $789fc288f6b69314$var$clear() {
    const target = $789fc288f6b69314$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = undefined;
    // forward the operation before queueing reactions
    const result = target.clear();
    if (hadItems) $789fc288f6b69314$export$e614dc9140f7ae71(target, "clear" /* TriggerOpTypes.CLEAR */ , undefined, undefined, oldTarget);
    return result;
}
function $789fc288f6b69314$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw" /* ReactiveFlags.RAW */ ];
        const rawTarget = $789fc288f6b69314$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $789fc288f6b69314$var$toShallow : isReadonly ? $789fc288f6b69314$var$toReadonly : $789fc288f6b69314$var$toReactive;
        !isReadonly && $789fc288f6b69314$export$6b2a7d5132615086(rawTarget, "iterate" /* TrackOpTypes.ITERATE */ , $789fc288f6b69314$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            // important: make sure the callback is
            // 1. invoked with the reactive map as `this` and 3rd arg
            // 2. the value received should be a corresponding reactive/readonly.
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $789fc288f6b69314$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw" /* ReactiveFlags.RAW */ ];
        const rawTarget = $789fc288f6b69314$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $8ENGG.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $789fc288f6b69314$var$toShallow : isReadonly ? $789fc288f6b69314$var$toReadonly : $789fc288f6b69314$var$toReactive;
        !isReadonly && $789fc288f6b69314$export$6b2a7d5132615086(rawTarget, "iterate" /* TrackOpTypes.ITERATE */ , isKeyOnly ? $789fc288f6b69314$var$MAP_KEY_ITERATE_KEY : $789fc288f6b69314$export$3c41b1a4e06acc14);
        // return a wrapped iterator which returns observed versions of the
        // values emitted from the real iterator
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $789fc288f6b69314$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" /* TriggerOpTypes.DELETE */  ? false : this;
    };
}
function $789fc288f6b69314$var$createInstrumentations() {
    const mutableInstrumentations = {
        get (key) {
            return $789fc288f6b69314$var$get$1(this, key);
        },
        get size () {
            return $789fc288f6b69314$var$size(this);
        },
        has: $789fc288f6b69314$var$has$1,
        add: $789fc288f6b69314$var$add,
        set: $789fc288f6b69314$var$set$1,
        delete: $789fc288f6b69314$var$deleteEntry,
        clear: $789fc288f6b69314$var$clear,
        forEach: $789fc288f6b69314$var$createForEach(false, false)
    };
    const shallowInstrumentations = {
        get (key) {
            return $789fc288f6b69314$var$get$1(this, key, false, true);
        },
        get size () {
            return $789fc288f6b69314$var$size(this);
        },
        has: $789fc288f6b69314$var$has$1,
        add: $789fc288f6b69314$var$add,
        set: $789fc288f6b69314$var$set$1,
        delete: $789fc288f6b69314$var$deleteEntry,
        clear: $789fc288f6b69314$var$clear,
        forEach: $789fc288f6b69314$var$createForEach(false, true)
    };
    const readonlyInstrumentations = {
        get (key) {
            return $789fc288f6b69314$var$get$1(this, key, true);
        },
        get size () {
            return $789fc288f6b69314$var$size(this, true);
        },
        has (key) {
            return $789fc288f6b69314$var$has$1.call(this, key, true);
        },
        add: $789fc288f6b69314$var$createReadonlyMethod("add" /* TriggerOpTypes.ADD */ ),
        set: $789fc288f6b69314$var$createReadonlyMethod("set" /* TriggerOpTypes.SET */ ),
        delete: $789fc288f6b69314$var$createReadonlyMethod("delete" /* TriggerOpTypes.DELETE */ ),
        clear: $789fc288f6b69314$var$createReadonlyMethod("clear" /* TriggerOpTypes.CLEAR */ ),
        forEach: $789fc288f6b69314$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations = {
        get (key) {
            return $789fc288f6b69314$var$get$1(this, key, true, true);
        },
        get size () {
            return $789fc288f6b69314$var$size(this, true);
        },
        has (key) {
            return $789fc288f6b69314$var$has$1.call(this, key, true);
        },
        add: $789fc288f6b69314$var$createReadonlyMethod("add" /* TriggerOpTypes.ADD */ ),
        set: $789fc288f6b69314$var$createReadonlyMethod("set" /* TriggerOpTypes.SET */ ),
        delete: $789fc288f6b69314$var$createReadonlyMethod("delete" /* TriggerOpTypes.DELETE */ ),
        clear: $789fc288f6b69314$var$createReadonlyMethod("clear" /* TriggerOpTypes.CLEAR */ ),
        forEach: $789fc288f6b69314$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations[method] = $789fc288f6b69314$var$createIterableMethod(method, false, false);
        readonlyInstrumentations[method] = $789fc288f6b69314$var$createIterableMethod(method, true, false);
        shallowInstrumentations[method] = $789fc288f6b69314$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations[method] = $789fc288f6b69314$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations,
        readonlyInstrumentations,
        shallowInstrumentations,
        shallowReadonlyInstrumentations
    ];
}
const [$789fc288f6b69314$var$mutableInstrumentations, $789fc288f6b69314$var$readonlyInstrumentations, $789fc288f6b69314$var$shallowInstrumentations, $789fc288f6b69314$var$shallowReadonlyInstrumentations] = /* #__PURE__*/ $789fc288f6b69314$var$createInstrumentations();
function $789fc288f6b69314$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $789fc288f6b69314$var$shallowReadonlyInstrumentations : $789fc288f6b69314$var$shallowInstrumentations : isReadonly ? $789fc288f6b69314$var$readonlyInstrumentations : $789fc288f6b69314$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive" /* ReactiveFlags.IS_REACTIVE */ ) return !isReadonly;
        else if (key === "__v_isReadonly" /* ReactiveFlags.IS_READONLY */ ) return isReadonly;
        else if (key === "__v_raw" /* ReactiveFlags.RAW */ ) return target;
        return Reflect.get((0, $8ENGG.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $789fc288f6b69314$var$mutableCollectionHandlers = {
    get: /*#__PURE__*/ $789fc288f6b69314$var$createInstrumentationGetter(false, false)
};
const $789fc288f6b69314$var$shallowCollectionHandlers = {
    get: /*#__PURE__*/ $789fc288f6b69314$var$createInstrumentationGetter(false, true)
};
const $789fc288f6b69314$var$readonlyCollectionHandlers = {
    get: /*#__PURE__*/ $789fc288f6b69314$var$createInstrumentationGetter(true, false)
};
const $789fc288f6b69314$var$shallowReadonlyCollectionHandlers = {
    get: /*#__PURE__*/ $789fc288f6b69314$var$createInstrumentationGetter(true, true)
};
function $789fc288f6b69314$var$checkIdentityKeys(target, has, key) {
    const rawKey = $789fc288f6b69314$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $8ENGG.toRawType)(target);
        console.warn(`Reactive ${type} contains both the raw and reactive ` + `versions of the same object${type === `Map` ? ` as keys` : ``}, ` + `which can lead to inconsistencies. ` + `Avoid differentiating between the raw and reactive versions ` + `of an object and only use the reactive version if possible.`);
    }
}
const $789fc288f6b69314$var$reactiveMap = new WeakMap();
const $789fc288f6b69314$var$shallowReactiveMap = new WeakMap();
const $789fc288f6b69314$var$readonlyMap = new WeakMap();
const $789fc288f6b69314$var$shallowReadonlyMap = new WeakMap();
function $789fc288f6b69314$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* TargetType.COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* TargetType.COLLECTION */ ;
        default:
            return 0 /* TargetType.INVALID */ ;
    }
}
function $789fc288f6b69314$var$getTargetType(value) {
    return value["__v_skip" /* ReactiveFlags.SKIP */ ] || !Object.isExtensible(value) ? 0 /* TargetType.INVALID */  : $789fc288f6b69314$var$targetTypeMap((0, $8ENGG.toRawType)(value));
}
function $789fc288f6b69314$export$90a44edba14e47be(target) {
    // if trying to observe a readonly proxy, return the readonly version.
    if ($789fc288f6b69314$export$92d09b48637741e7(target)) return target;
    return $789fc288f6b69314$var$createReactiveObject(target, false, $789fc288f6b69314$var$mutableHandlers, $789fc288f6b69314$var$mutableCollectionHandlers, $789fc288f6b69314$var$reactiveMap);
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */ function $789fc288f6b69314$export$8d81cefd22d22260(target) {
    return $789fc288f6b69314$var$createReactiveObject(target, false, $789fc288f6b69314$var$shallowReactiveHandlers, $789fc288f6b69314$var$shallowCollectionHandlers, $789fc288f6b69314$var$shallowReactiveMap);
}
/**
 * Creates a readonly copy of the original object. Note the returned copy is not
 * made reactive, but `readonly` can be called on an already reactive object.
 */ function $789fc288f6b69314$export$6ec456bd5b7b3c51(target) {
    return $789fc288f6b69314$var$createReactiveObject(target, true, $789fc288f6b69314$var$readonlyHandlers, $789fc288f6b69314$var$readonlyCollectionHandlers, $789fc288f6b69314$var$readonlyMap);
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */ function $789fc288f6b69314$export$7c4b5f2b50f09f6b(target) {
    return $789fc288f6b69314$var$createReactiveObject(target, true, $789fc288f6b69314$var$shallowReadonlyHandlers, $789fc288f6b69314$var$shallowReadonlyCollectionHandlers, $789fc288f6b69314$var$shallowReadonlyMap);
}
function $789fc288f6b69314$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $8ENGG.isObject)(target)) return target;
    // target is already a Proxy, return it.
    // exception: calling readonly() on a reactive object
    if (target["__v_raw" /* ReactiveFlags.RAW */ ] && !(isReadonly && target["__v_isReactive" /* ReactiveFlags.IS_REACTIVE */ ])) return target;
    // target already has corresponding Proxy
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    // only specific value types can be observed.
    const targetType = $789fc288f6b69314$var$getTargetType(target);
    if (targetType === 0 /* TargetType.INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* TargetType.COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $789fc288f6b69314$export$352205f445242f02(value) {
    if ($789fc288f6b69314$export$92d09b48637741e7(value)) return $789fc288f6b69314$export$352205f445242f02(value["__v_raw" /* ReactiveFlags.RAW */ ]);
    return !!(value && value["__v_isReactive" /* ReactiveFlags.IS_REACTIVE */ ]);
}
function $789fc288f6b69314$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly" /* ReactiveFlags.IS_READONLY */ ]);
}
function $789fc288f6b69314$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow" /* ReactiveFlags.IS_SHALLOW */ ]);
}
function $789fc288f6b69314$export$5f3ca29d057519b3(value) {
    return $789fc288f6b69314$export$352205f445242f02(value) || $789fc288f6b69314$export$92d09b48637741e7(value);
}
function $789fc288f6b69314$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw" /* ReactiveFlags.RAW */ ];
    return raw ? $789fc288f6b69314$export$ab18938b9fc5f28e(raw) : observed;
}
function $789fc288f6b69314$export$995ab8b13ad7a9d0(value) {
    (0, $8ENGG.def)(value, "__v_skip" /* ReactiveFlags.SKIP */ , true);
    return value;
}
const $789fc288f6b69314$var$toReactive = (value)=>(0, $8ENGG.isObject)(value) ? $789fc288f6b69314$export$90a44edba14e47be(value) : value;
const $789fc288f6b69314$var$toReadonly = (value)=>(0, $8ENGG.isObject)(value) ? $789fc288f6b69314$export$6ec456bd5b7b3c51(value) : value;
function $789fc288f6b69314$var$trackRefValue(ref) {
    if ($789fc288f6b69314$var$shouldTrack && $789fc288f6b69314$var$activeEffect) {
        ref = $789fc288f6b69314$export$ab18938b9fc5f28e(ref);
        $789fc288f6b69314$var$trackEffects(ref.dep || (ref.dep = $789fc288f6b69314$var$createDep()));
    }
}
function $789fc288f6b69314$var$triggerRefValue(ref, newVal) {
    ref = $789fc288f6b69314$export$ab18938b9fc5f28e(ref);
    if (ref.dep) $789fc288f6b69314$var$triggerEffects(ref.dep);
}
function $789fc288f6b69314$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $789fc288f6b69314$export$eff4d24c3ff7876e(value) {
    return $789fc288f6b69314$var$createRef(value, false);
}
function $789fc288f6b69314$export$9b7bc5fe3b17c8b3(value) {
    return $789fc288f6b69314$var$createRef(value, true);
}
function $789fc288f6b69314$var$createRef(rawValue, shallow) {
    if ($789fc288f6b69314$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $789fc288f6b69314$var$RefImpl(rawValue, shallow);
}
class $789fc288f6b69314$var$RefImpl {
    get value() {
        $789fc288f6b69314$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $789fc288f6b69314$export$7f3fe6025abfa26e(newVal) || $789fc288f6b69314$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $789fc288f6b69314$export$ab18938b9fc5f28e(newVal);
        if ((0, $8ENGG.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $789fc288f6b69314$var$toReactive(newVal);
            $789fc288f6b69314$var$triggerRefValue(this, newVal);
        }
    }
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = undefined;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $789fc288f6b69314$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $789fc288f6b69314$var$toReactive(value);
    }
}
function $789fc288f6b69314$export$f402f86588575ccc(ref) {
    $789fc288f6b69314$var$triggerRefValue(ref, void 0);
}
function $789fc288f6b69314$export$a239a76781616204(ref) {
    return $789fc288f6b69314$export$4f9f5282de18fc69(ref) ? ref.value : ref;
}
const $789fc288f6b69314$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$789fc288f6b69314$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($789fc288f6b69314$export$4f9f5282de18fc69(oldValue) && !$789fc288f6b69314$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $789fc288f6b69314$export$f353fd1b97db3fa0(objectWithRefs) {
    return $789fc288f6b69314$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $789fc288f6b69314$var$shallowUnwrapHandlers);
}
class $789fc288f6b69314$var$CustomRefImpl {
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
    constructor(factory){
        this.dep = undefined;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$789fc288f6b69314$var$trackRefValue(this), ()=>$789fc288f6b69314$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
}
function $789fc288f6b69314$export$a20c2dd6199824cb(factory) {
    return new $789fc288f6b69314$var$CustomRefImpl(factory);
}
function $789fc288f6b69314$export$2e9533675e5e70e0(object) {
    const ret = (0, $8ENGG.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $789fc288f6b69314$export$1f60508e4f47b4b7(object, key);
    return ret;
}
class $789fc288f6b69314$var$ObjectRefImpl {
    get value() {
        const val = this._object[this._key];
        return val === undefined ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
}
function $789fc288f6b69314$export$1f60508e4f47b4b7(object, key, defaultValue) {
    const val = object[key];
    return $789fc288f6b69314$export$4f9f5282de18fc69(val) ? val : new $789fc288f6b69314$var$ObjectRefImpl(object, key, defaultValue);
}
var $789fc288f6b69314$var$_a;
class $789fc288f6b69314$var$ComputedRefImpl {
    get value() {
        // the computed ref may get wrapped by other proxies e.g. readonly() #3376
        const self = $789fc288f6b69314$export$ab18938b9fc5f28e(this);
        $789fc288f6b69314$var$trackRefValue(self);
        if (self._dirty || !self._cacheable) {
            self._dirty = false;
            self._value = self.effect.run();
        }
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
    constructor(getter, _setter, isReadonly, isSSR){
        this._setter = _setter;
        this.dep = undefined;
        this.__v_isRef = true;
        this[$789fc288f6b69314$var$_a] = false;
        this._dirty = true;
        this.effect = new $789fc288f6b69314$export$28352bb4dd362521(getter, ()=>{
            if (!this._dirty) {
                this._dirty = true;
                $789fc288f6b69314$var$triggerRefValue(this);
            }
        });
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly" /* ReactiveFlags.IS_READONLY */ ] = isReadonly;
    }
}
$789fc288f6b69314$var$_a = "__v_isReadonly" /* ReactiveFlags.IS_READONLY */ ;
function $789fc288f6b69314$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $8ENGG.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $8ENGG.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $789fc288f6b69314$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
var $789fc288f6b69314$var$_a$1;
const $789fc288f6b69314$var$tick = /*#__PURE__*/ Promise.resolve();
const $789fc288f6b69314$var$queue = [];
let $789fc288f6b69314$var$queued = false;
const $789fc288f6b69314$var$scheduler = (fn)=>{
    $789fc288f6b69314$var$queue.push(fn);
    if (!$789fc288f6b69314$var$queued) {
        $789fc288f6b69314$var$queued = true;
        $789fc288f6b69314$var$tick.then($789fc288f6b69314$var$flush);
    }
};
const $789fc288f6b69314$var$flush = ()=>{
    for(let i = 0; i < $789fc288f6b69314$var$queue.length; i++)$789fc288f6b69314$var$queue[i]();
    $789fc288f6b69314$var$queue.length = 0;
    $789fc288f6b69314$var$queued = false;
};
class $789fc288f6b69314$var$DeferredComputedRefImpl {
    _get() {
        if (this._dirty) {
            this._dirty = false;
            return this._value = this.effect.run();
        }
        return this._value;
    }
    get value() {
        $789fc288f6b69314$var$trackRefValue(this);
        // the computed ref may get wrapped by other proxies e.g. readonly() #3376
        return $789fc288f6b69314$export$ab18938b9fc5f28e(this)._get();
    }
    constructor(getter){
        this.dep = undefined;
        this._dirty = true;
        this.__v_isRef = true;
        this[$789fc288f6b69314$var$_a$1] = true;
        let compareTarget;
        let hasCompareTarget = false;
        let scheduled = false;
        this.effect = new $789fc288f6b69314$export$28352bb4dd362521(getter, (computedTrigger)=>{
            if (this.dep) {
                if (computedTrigger) {
                    compareTarget = this._value;
                    hasCompareTarget = true;
                } else if (!scheduled) {
                    const valueToCompare = hasCompareTarget ? compareTarget : this._value;
                    scheduled = true;
                    hasCompareTarget = false;
                    $789fc288f6b69314$var$scheduler(()=>{
                        if (this.effect.active && this._get() !== valueToCompare) $789fc288f6b69314$var$triggerRefValue(this);
                        scheduled = false;
                    });
                }
                // chained upstream computeds are notified synchronously to ensure
                // value invalidation in case of sync access; normal effects are
                // deferred to be triggered in scheduler.
                for (const e of this.dep)if (e.computed instanceof $789fc288f6b69314$var$DeferredComputedRefImpl) e.scheduler(true);
            }
            this._dirty = true;
        });
        this.effect.computed = this;
    }
}
$789fc288f6b69314$var$_a$1 = "__v_isReadonly" /* ReactiveFlags.IS_READONLY */ ;
function $789fc288f6b69314$export$483264c4ec4c46ce(getter) {
    return new $789fc288f6b69314$var$DeferredComputedRefImpl(getter);
}

});
parcelRegister("8ENGG", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $64d89a05f85c33c4$export$b41394a5437791c8; });
$parcel$export(module.exports, "isGloballyWhitelisted", function () { return $64d89a05f85c33c4$export$d6571a1911e4f27e; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $64d89a05f85c33c4$export$d186f5eb2e810715; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $64d89a05f85c33c4$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "normalizeStyle", function () { return $64d89a05f85c33c4$export$8756898546458274; });
$parcel$export(module.exports, "isArray", function () { return $64d89a05f85c33c4$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isString", function () { return $64d89a05f85c33c4$export$844ec244b1367d54; });
$parcel$export(module.exports, "isObject", function () { return $64d89a05f85c33c4$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "hyphenate", function () { return $64d89a05f85c33c4$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "normalizeClass", function () { return $64d89a05f85c33c4$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "normalizeProps", function () { return $64d89a05f85c33c4$export$601abcd8103db5e4; });
$parcel$export(module.exports, "isHTMLTag", function () { return $64d89a05f85c33c4$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $64d89a05f85c33c4$export$6328ce7565ea1049; });
$parcel$export(module.exports, "looseEqual", function () { return $64d89a05f85c33c4$export$ae8015769846262c; });
$parcel$export(module.exports, "isSymbol", function () { return $64d89a05f85c33c4$export$a244864fd9645c7f; });
$parcel$export(module.exports, "looseIndexOf", function () { return $64d89a05f85c33c4$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $64d89a05f85c33c4$export$b5b1545233b45293; });
$parcel$export(module.exports, "isFunction", function () { return $64d89a05f85c33c4$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isMap", function () { return $64d89a05f85c33c4$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $64d89a05f85c33c4$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isPlainObject", function () { return $64d89a05f85c33c4$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $64d89a05f85c33c4$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $64d89a05f85c33c4$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $64d89a05f85c33c4$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $64d89a05f85c33c4$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $64d89a05f85c33c4$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $64d89a05f85c33c4$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $64d89a05f85c33c4$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $64d89a05f85c33c4$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $64d89a05f85c33c4$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isPromise", function () { return $64d89a05f85c33c4$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $64d89a05f85c33c4$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isIntegerKey", function () { return $64d89a05f85c33c4$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $64d89a05f85c33c4$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $64d89a05f85c33c4$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $64d89a05f85c33c4$export$161d051f5dd25de7; });
$parcel$export(module.exports, "capitalize", function () { return $64d89a05f85c33c4$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $64d89a05f85c33c4$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $64d89a05f85c33c4$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $64d89a05f85c33c4$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $64d89a05f85c33c4$export$8afb76124cf08683; });
$parcel$export(module.exports, "toNumber", function () { return $64d89a05f85c33c4$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $64d89a05f85c33c4$export$ff5f2eeb11fc7e14; });
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 * IMPORTANT: all calls of this function must be prefixed with
 * \/\*#\_\_PURE\_\_\*\/
 * So that rollup can tree-shake them if necessary.
 */ function $64d89a05f85c33c4$export$b41394a5437791c8(str, expectsLowerCase) {
    const map = Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
/**
 * dev only flag -> name mapping
 */ const $64d89a05f85c33c4$export$def7dc2c2e95a08a = {
    [1 /* PatchFlags.TEXT */ ]: `TEXT`,
    [2 /* PatchFlags.CLASS */ ]: `CLASS`,
    [4 /* PatchFlags.STYLE */ ]: `STYLE`,
    [8 /* PatchFlags.PROPS */ ]: `PROPS`,
    [16 /* PatchFlags.FULL_PROPS */ ]: `FULL_PROPS`,
    [32 /* PatchFlags.HYDRATE_EVENTS */ ]: `HYDRATE_EVENTS`,
    [64 /* PatchFlags.STABLE_FRAGMENT */ ]: `STABLE_FRAGMENT`,
    [128 /* PatchFlags.KEYED_FRAGMENT */ ]: `KEYED_FRAGMENT`,
    [256 /* PatchFlags.UNKEYED_FRAGMENT */ ]: `UNKEYED_FRAGMENT`,
    [512 /* PatchFlags.NEED_PATCH */ ]: `NEED_PATCH`,
    [1024 /* PatchFlags.DYNAMIC_SLOTS */ ]: `DYNAMIC_SLOTS`,
    [2048 /* PatchFlags.DEV_ROOT_FRAGMENT */ ]: `DEV_ROOT_FRAGMENT`,
    [-1 /* PatchFlags.HOISTED */ ]: `HOISTED`,
    [-2 /* PatchFlags.BAIL */ ]: `BAIL`
};
/**
 * Dev only
 */ const $64d89a05f85c33c4$export$624972196ed3745f = {
    [1 /* SlotFlags.STABLE */ ]: "STABLE",
    [2 /* SlotFlags.DYNAMIC */ ]: "DYNAMIC",
    [3 /* SlotFlags.FORWARDED */ ]: "FORWARDED"
};
const $64d89a05f85c33c4$var$GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt";
const $64d89a05f85c33c4$export$d6571a1911e4f27e = /*#__PURE__*/ $64d89a05f85c33c4$export$b41394a5437791c8($64d89a05f85c33c4$var$GLOBALS_WHITE_LISTED);
const $64d89a05f85c33c4$var$range = 2;
function $64d89a05f85c33c4$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    // Split the content into individual lines but capture the newline sequence
    // that separated each line. This is important because the actual sequence is
    // needed to properly take into account the full line length for offset
    // comparison
    let lines = source.split(/(\r?\n)/);
    // Separate the lines and newline sequences into separate arrays for easier referencing
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $64d89a05f85c33c4$var$range; j <= i + $64d89a05f85c33c4$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    // push underline
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
/**
 * On the client we only need to offer special cases for boolean attributes that
 * have different names from their corresponding dom properties:
 * - itemscope -> N/A
 * - allowfullscreen -> allowFullscreen
 * - formnovalidate -> formNoValidate
 * - ismap -> isMap
 * - nomodule -> noModule
 * - novalidate -> noValidate
 * - readonly -> readOnly
 */ const $64d89a05f85c33c4$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $64d89a05f85c33c4$export$d186f5eb2e810715 = /*#__PURE__*/ $64d89a05f85c33c4$export$b41394a5437791c8($64d89a05f85c33c4$var$specialBooleanAttrs);
/**
 * The full list is needed during SSR to produce the correct initial markup.
 */ const $64d89a05f85c33c4$export$f763ba3b84e9cd8c = /*#__PURE__*/ $64d89a05f85c33c4$export$b41394a5437791c8($64d89a05f85c33c4$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,` + `loop,open,required,reversed,scoped,seamless,` + `checked,muted,multiple,selected`);
/**
 * Boolean attributes should be included if the value is truthy or ''.
 * e.g. `<select multiple>` compiles to `{ multiple: '' }`
 */ function $64d89a05f85c33c4$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $64d89a05f85c33c4$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $64d89a05f85c33c4$var$attrValidationCache = {};
function $64d89a05f85c33c4$export$d55ef77660f30d12(name) {
    if ($64d89a05f85c33c4$var$attrValidationCache.hasOwnProperty(name)) return $64d89a05f85c33c4$var$attrValidationCache[name];
    const isUnsafe = $64d89a05f85c33c4$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $64d89a05f85c33c4$var$attrValidationCache[name] = !isUnsafe;
}
const $64d89a05f85c33c4$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
/**
 * CSS properties that accept plain numbers
 */ const $64d89a05f85c33c4$export$84da53524c6b1314 = /*#__PURE__*/ $64d89a05f85c33c4$export$b41394a5437791c8(`animation-iteration-count,border-image-outset,border-image-slice,` + `border-image-width,box-flex,box-flex-group,box-ordinal-group,column-count,` + `columns,flex,flex-grow,flex-positive,flex-shrink,flex-negative,flex-order,` + `grid-row,grid-row-end,grid-row-span,grid-row-start,grid-column,` + `grid-column-end,grid-column-span,grid-column-start,font-weight,line-clamp,` + `line-height,opacity,order,orphans,tab-size,widows,z-index,zoom,` + // SVG
`fill-opacity,flood-opacity,stop-opacity,stroke-dasharray,stroke-dashoffset,` + `stroke-miterlimit,stroke-opacity,stroke-width`);
/**
 * Known attributes, this is used for stringification of runtime static nodes
 * so that we don't stringify bindings that cannot be set from HTML.
 * Don't also forget to allow `data-*` and `aria-*`!
 * Generated from https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes
 */ const $64d89a05f85c33c4$export$f7e7a1cc7da8d5e9 = /*#__PURE__*/ $64d89a05f85c33c4$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,` + `autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,` + `border,buffered,capture,challenge,charset,checked,cite,class,code,` + `codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,` + `coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,` + `disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,` + `formaction,formenctype,formmethod,formnovalidate,formtarget,headers,` + `height,hidden,high,href,hreflang,http-equiv,icon,id,importance,integrity,` + `ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,` + `manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,` + `open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,` + `referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,` + `selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,` + `start,step,style,summary,tabindex,target,title,translate,type,usemap,` + `value,width,wrap`);
/**
 * Generated from https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute
 */ const $64d89a05f85c33c4$export$80da416f43933831 = /*#__PURE__*/ $64d89a05f85c33c4$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,` + `arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,` + `baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,` + `clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,` + `color-interpolation-filters,color-profile,color-rendering,` + `contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,` + `descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,` + `dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,` + `fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,` + `font-family,font-size,font-size-adjust,font-stretch,font-style,` + `font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,` + `glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,` + `gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,` + `horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,` + `k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,` + `lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,` + `marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,` + `mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,` + `name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,` + `overflow,overline-position,overline-thickness,panose-1,paint-order,path,` + `pathLength,patternContentUnits,patternTransform,patternUnits,ping,` + `pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,` + `preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,` + `rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,` + `restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,` + `specularConstant,specularExponent,speed,spreadMethod,startOffset,` + `stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,` + `strikethrough-position,strikethrough-thickness,string,stroke,` + `stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,` + `stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,` + `systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,` + `text-decoration,text-rendering,textLength,to,transform,transform-origin,` + `type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,` + `unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,` + `v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,` + `vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,` + `writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,` + `xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,` + `xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function $64d89a05f85c33c4$export$8756898546458274(value) {
    if ($64d89a05f85c33c4$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $64d89a05f85c33c4$export$844ec244b1367d54(item) ? $64d89a05f85c33c4$export$76a205ce979d066a(item) : $64d89a05f85c33c4$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($64d89a05f85c33c4$export$844ec244b1367d54(value)) return value;
    else if ($64d89a05f85c33c4$export$a6cdc56e425d0d0a(value)) return value;
}
const $64d89a05f85c33c4$var$listDelimiterRE = /;(?![^(]*\))/g;
const $64d89a05f85c33c4$var$propertyDelimiterRE = /:(.+)/;
function $64d89a05f85c33c4$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.split($64d89a05f85c33c4$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($64d89a05f85c33c4$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $64d89a05f85c33c4$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $64d89a05f85c33c4$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $64d89a05f85c33c4$export$6e6a0a3676c4b8bb(key);
        if ($64d89a05f85c33c4$export$844ec244b1367d54(value) || typeof value === "number" && $64d89a05f85c33c4$export$84da53524c6b1314(normalizedKey)) // only render valid values
        ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $64d89a05f85c33c4$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($64d89a05f85c33c4$export$844ec244b1367d54(value)) res = value;
    else if ($64d89a05f85c33c4$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $64d89a05f85c33c4$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($64d89a05f85c33c4$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $64d89a05f85c33c4$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$64d89a05f85c33c4$export$844ec244b1367d54(klass)) props.class = $64d89a05f85c33c4$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $64d89a05f85c33c4$export$8756898546458274(style);
    return props;
}
// These tag configs are shared between compiler-dom and runtime-dom, so they
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element
const $64d89a05f85c33c4$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
// https://developer.mozilla.org/en-US/docs/Web/SVG/Element
const $64d89a05f85c33c4$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistanceLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $64d89a05f85c33c4$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $64d89a05f85c33c4$export$1ccf854a0984f890 = /*#__PURE__*/ $64d89a05f85c33c4$export$b41394a5437791c8($64d89a05f85c33c4$var$HTML_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $64d89a05f85c33c4$export$6328ce7565ea1049 = /*#__PURE__*/ $64d89a05f85c33c4$export$b41394a5437791c8($64d89a05f85c33c4$var$SVG_TAGS);
/**
 * Compiler only.
 * Do NOT use in runtime code paths unless behind `(process.env.NODE_ENV !== 'production')` flag.
 */ const $64d89a05f85c33c4$export$e5f2d3d97d9367a4 = /*#__PURE__*/ $64d89a05f85c33c4$export$b41394a5437791c8($64d89a05f85c33c4$var$VOID_TAGS);
const $64d89a05f85c33c4$var$escapeRE = /["'&<>]/;
function $64d89a05f85c33c4$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $64d89a05f85c33c4$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
// https://www.w3.org/TR/html52/syntax.html#comments
const $64d89a05f85c33c4$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $64d89a05f85c33c4$export$7b105034a53bde5f(src) {
    return src.replace($64d89a05f85c33c4$var$commentStripRE, "");
}
function $64d89a05f85c33c4$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $64d89a05f85c33c4$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $64d89a05f85c33c4$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $64d89a05f85c33c4$export$871608497c498473(a);
    let bValidType = $64d89a05f85c33c4$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $64d89a05f85c33c4$export$a244864fd9645c7f(a);
    bValidType = $64d89a05f85c33c4$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $64d89a05f85c33c4$export$43bee75e5e14138e(a);
    bValidType = $64d89a05f85c33c4$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $64d89a05f85c33c4$var$looseCompareArrays(a, b) : false;
    aValidType = $64d89a05f85c33c4$export$a6cdc56e425d0d0a(a);
    bValidType = $64d89a05f85c33c4$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        /* istanbul ignore if: this if will probably never be called */ if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$64d89a05f85c33c4$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $64d89a05f85c33c4$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$64d89a05f85c33c4$export$ae8015769846262c(item, val));
}
/**
 * For converting {{ interpolation }} values to displayed strings.
 * @private
 */ const $64d89a05f85c33c4$export$b5b1545233b45293 = (val)=>{
    return $64d89a05f85c33c4$export$844ec244b1367d54(val) ? val : val == null ? "" : $64d89a05f85c33c4$export$43bee75e5e14138e(val) || $64d89a05f85c33c4$export$a6cdc56e425d0d0a(val) && (val.toString === $64d89a05f85c33c4$export$830c053460e5ddf6 || !$64d89a05f85c33c4$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $64d89a05f85c33c4$var$replacer, 2) : String(val);
};
const $64d89a05f85c33c4$var$replacer = (_key, val)=>{
    // can't use isRef here since @vue/shared has no deps
    if (val && val.__v_isRef) return $64d89a05f85c33c4$var$replacer(_key, val.value);
    else if ($64d89a05f85c33c4$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val])=>{
            entries[`${key} =>`] = val;
            return entries;
        }, {})
    };
    else if ($64d89a05f85c33c4$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ]
    };
    else if ($64d89a05f85c33c4$export$a6cdc56e425d0d0a(val) && !$64d89a05f85c33c4$export$43bee75e5e14138e(val) && !$64d89a05f85c33c4$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $64d89a05f85c33c4$export$cf583d23ab39677c = {};
const $64d89a05f85c33c4$export$6bd8558f433f1cc1 = [];
const $64d89a05f85c33c4$export$5702a91a6f42969f = ()=>{};
/**
 * Always return false.
 */ const $64d89a05f85c33c4$export$c01351c0af048e39 = ()=>false;
const $64d89a05f85c33c4$var$onRE = /^on[^a-z]/;
const $64d89a05f85c33c4$export$1a2d97de39ecbb75 = (key)=>$64d89a05f85c33c4$var$onRE.test(key);
const $64d89a05f85c33c4$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $64d89a05f85c33c4$export$8b58be045bf06082 = Object.assign;
const $64d89a05f85c33c4$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $64d89a05f85c33c4$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $64d89a05f85c33c4$export$b5a638e9b3fff9f3 = (val, key)=>$64d89a05f85c33c4$var$hasOwnProperty.call(val, key);
const $64d89a05f85c33c4$export$43bee75e5e14138e = Array.isArray;
const $64d89a05f85c33c4$export$5c90113a285f2241 = (val)=>$64d89a05f85c33c4$export$1dccc787cc36538b(val) === "[object Map]";
const $64d89a05f85c33c4$export$6750766a7c7ec627 = (val)=>$64d89a05f85c33c4$export$1dccc787cc36538b(val) === "[object Set]";
const $64d89a05f85c33c4$export$871608497c498473 = (val)=>$64d89a05f85c33c4$export$1dccc787cc36538b(val) === "[object Date]";
const $64d89a05f85c33c4$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $64d89a05f85c33c4$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $64d89a05f85c33c4$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $64d89a05f85c33c4$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $64d89a05f85c33c4$export$4369c812aac99591 = (val)=>{
    return $64d89a05f85c33c4$export$a6cdc56e425d0d0a(val) && $64d89a05f85c33c4$export$f6e2535fb5126e54(val.then) && $64d89a05f85c33c4$export$f6e2535fb5126e54(val.catch);
};
const $64d89a05f85c33c4$export$830c053460e5ddf6 = Object.prototype.toString;
const $64d89a05f85c33c4$export$1dccc787cc36538b = (value)=>$64d89a05f85c33c4$export$830c053460e5ddf6.call(value);
const $64d89a05f85c33c4$export$5ad0a3c360b8fbb5 = (value)=>{
    // extract "RawType" from strings like "[object RawType]"
    return $64d89a05f85c33c4$export$1dccc787cc36538b(value).slice(8, -1);
};
const $64d89a05f85c33c4$export$53b83ca8eaab0383 = (val)=>$64d89a05f85c33c4$export$1dccc787cc36538b(val) === "[object Object]";
const $64d89a05f85c33c4$export$e2a2b93446ec9fe = (key)=>$64d89a05f85c33c4$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $64d89a05f85c33c4$export$bf7d3c0236f0aa85 = /*#__PURE__*/ $64d89a05f85c33c4$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $64d89a05f85c33c4$export$a9c1fdb3030c2a6b = /*#__PURE__*/ $64d89a05f85c33c4$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $64d89a05f85c33c4$var$cacheStringFunction = (fn)=>{
    const cache = Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $64d89a05f85c33c4$var$camelizeRE = /-(\w)/g;
/**
 * @private
 */ const $64d89a05f85c33c4$export$161d051f5dd25de7 = $64d89a05f85c33c4$var$cacheStringFunction((str)=>{
    return str.replace($64d89a05f85c33c4$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $64d89a05f85c33c4$var$hyphenateRE = /\B([A-Z])/g;
/**
 * @private
 */ const $64d89a05f85c33c4$export$6e6a0a3676c4b8bb = $64d89a05f85c33c4$var$cacheStringFunction((str)=>str.replace($64d89a05f85c33c4$var$hyphenateRE, "-$1").toLowerCase());
/**
 * @private
 */ const $64d89a05f85c33c4$export$9a00dee1beb8f576 = $64d89a05f85c33c4$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
/**
 * @private
 */ const $64d89a05f85c33c4$export$8c022799eeaaefcd = $64d89a05f85c33c4$var$cacheStringFunction((str)=>str ? `on${$64d89a05f85c33c4$export$9a00dee1beb8f576(str)}` : ``);
// compare whether a value has changed, accounting for NaN.
const $64d89a05f85c33c4$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $64d89a05f85c33c4$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $64d89a05f85c33c4$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $64d89a05f85c33c4$export$a0a81dc3380ce7d3 = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
let $64d89a05f85c33c4$var$_globalThis;
const $64d89a05f85c33c4$export$ff5f2eeb11fc7e14 = ()=>{
    return $64d89a05f85c33c4$var$_globalThis || ($64d89a05f85c33c4$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $64d89a05f85c33c4$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $64d89a05f85c33c4$export$53d5e12f9a1d3cde(name) {
    return $64d89a05f85c33c4$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}

});



parcelRegister("NPJVB", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("esfUo")).BaseTransition; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("esfUo")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("8ENGG")).camelize; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("esfUo")).computed; });
$parcel$export(module.exports, "createBlock", function () { return (parcelRequire("esfUo")).createBlock; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("esfUo")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("esfUo")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("esfUo")).createElementVNode; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("esfUo")).createHydrationRenderer; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("esfUo")).createRenderer; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("esfUo")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("esfUo")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("esfUo")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("esfUo")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("esfUo")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("esfUo")).getCurrentInstance; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("esfUo")).getTransitionRawChildren; });
$parcel$export(module.exports, "guardReactiveProps", function () { return (parcelRequire("esfUo")).guardReactiveProps; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("esfUo")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("esfUo")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("esfUo")).inject; });
$parcel$export(module.exports, "isReactive", function () { return (parcelRequire("am4TS")).isReactive; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("am4TS")).isRef; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("esfUo")).isRuntimeOnly; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("esfUo")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("8ENGG")).normalizeClass; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("8ENGG")).normalizeStyle; });
$parcel$export(module.exports, "onActivated", function () { return (parcelRequire("esfUo")).onActivated; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("esfUo")).onBeforeMount; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("esfUo")).onBeforeUnmount; });
$parcel$export(module.exports, "onDeactivated", function () { return (parcelRequire("esfUo")).onDeactivated; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("esfUo")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("esfUo")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("esfUo")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("esfUo")).openBlock; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("esfUo")).popScopeId; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("esfUo")).provide; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("esfUo")).pushScopeId; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("am4TS")).reactive; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("am4TS")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("esfUo")).renderList; });
$parcel$export(module.exports, "renderSlot", function () { return (parcelRequire("esfUo")).renderSlot; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("esfUo")).resolveComponent; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return (parcelRequire("esfUo")).resolveDynamicComponent; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("esfUo")).resolveTransitionHooks; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("esfUo")).setTransitionHooks; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("esfUo")).Static; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("am4TS")).toRaw; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("esfUo")).useTransitionState; });
$parcel$export(module.exports, "version", function () { return (parcelRequire("esfUo")).version; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("esfUo")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("esfUo")).watch; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("esfUo")).watchEffect; });
$parcel$export(module.exports, "watchPostEffect", function () { return (parcelRequire("esfUo")).watchPostEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("esfUo")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("esfUo")).withDirectives; });
$parcel$export(module.exports, "customRef", function () { return (parcelRequire("am4TS")).customRef; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("am4TS")).effectScope; });
$parcel$export(module.exports, "getCurrentScope", function () { return (parcelRequire("am4TS")).getCurrentScope; });
$parcel$export(module.exports, "onScopeDispose", function () { return (parcelRequire("am4TS")).onScopeDispose; });
$parcel$export(module.exports, "readonly", function () { return (parcelRequire("am4TS")).readonly; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("am4TS")).shallowRef; });
$parcel$export(module.exports, "toRef", function () { return (parcelRequire("am4TS")).toRef; });
$parcel$export(module.exports, "toRefs", function () { return (parcelRequire("am4TS")).toRefs; });
$parcel$export(module.exports, "unref", function () { return (parcelRequire("am4TS")).unref; });
$parcel$export(module.exports, "normalizeProps", function () { return (parcelRequire("8ENGG")).normalizeProps; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("8ENGG")).toDisplayString; });

$parcel$export(module.exports, "vModelText", function () { return $095cb628e10db226$export$f1f88689f5728478; });
$parcel$export(module.exports, "withModifiers", function () { return $095cb628e10db226$export$26bd3b8e29e6f273; });
$parcel$export(module.exports, "createApp", function () { return $095cb628e10db226$export$4e373c34abfa8c68; });

var $esfUo = parcelRequire("esfUo");
var $8ENGG = parcelRequire("8ENGG");
var $am4TS = parcelRequire("am4TS");parcelRequire("am4TS");parcelRequire("8ENGG");

var $8ENGG = parcelRequire("8ENGG");
const $095cb628e10db226$var$svgNS = "http://www.w3.org/2000/svg";
const $095cb628e10db226$var$doc = typeof document !== "undefined" ? document : null;
const $095cb628e10db226$var$templateContainer = $095cb628e10db226$var$doc && /*#__PURE__*/ $095cb628e10db226$var$doc.createElement("template");
const $095cb628e10db226$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, isSVG, is, props)=>{
        const el = isSVG ? $095cb628e10db226$var$doc.createElementNS($095cb628e10db226$var$svgNS, tag) : $095cb628e10db226$var$doc.createElement(tag, is ? {
            is: is
        } : undefined);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$095cb628e10db226$var$doc.createTextNode(text),
    createComment: (text)=>$095cb628e10db226$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$095cb628e10db226$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, isSVG, start, end) {
        // <parent> before | first ... last | anchor </parent>
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        // #5308 can only take cached path if:
        // - has a single root node
        // - nextSibling info is still available
        if (start && (start === end || start.nextSibling)) // cached
        while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            // fresh insert
            $095cb628e10db226$var$templateContainer.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
            const template = $095cb628e10db226$var$templateContainer.content;
            if (isSVG) {
                // remove outer svg wrapper
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
// compiler should normalize class + :class bindings on the same element
// into a single binding ['staticClass', dynamic]
function $095cb628e10db226$var$patchClass(el, value, isSVG) {
    // directly setting className should be faster than setAttribute in theory
    // if this is an element during a transition, take the temporary transition
    // classes into account.
    const transitionClasses = el._vtc;
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
function $095cb628e10db226$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $8ENGG.isString)(next);
    if (next && !isCssString) {
        for(const key in next)$095cb628e10db226$var$setStyle(style, key, next[key]);
        if (prev && !(0, $8ENGG.isString)(prev)) {
            for(const key in prev)if (next[key] == null) $095cb628e10db226$var$setStyle(style, key, "");
        }
    } else {
        const currentDisplay = style.display;
        if (isCssString) {
            if (prev !== next) style.cssText = next;
        } else if (prev) el.removeAttribute("style");
        // indicates that the `display` of the element is controlled by `v-show`,
        // so we always keep the current `display` value regardless of the `style`
        // value, thus handing over control to `v-show`.
        if ("_vod" in el) style.display = currentDisplay;
    }
}
const $095cb628e10db226$var$importantRE = /\s*!important$/;
function $095cb628e10db226$var$setStyle(style, name, val) {
    if ((0, $8ENGG.isArray)(val)) val.forEach((v)=>$095cb628e10db226$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) // custom property definition
        style.setProperty(name, val);
        else {
            const prefixed = $095cb628e10db226$var$autoPrefix(style, name);
            if ($095cb628e10db226$var$importantRE.test(val)) // !important
            style.setProperty((0, $8ENGG.hyphenate)(prefixed), val.replace($095cb628e10db226$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $095cb628e10db226$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $095cb628e10db226$var$prefixCache = {};
function $095cb628e10db226$var$autoPrefix(style, rawName) {
    const cached = $095cb628e10db226$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8ENGG.camelize)(rawName);
    if (name !== "filter" && name in style) return $095cb628e10db226$var$prefixCache[rawName] = name;
    name = (0, $8ENGG.capitalize)(name);
    for(let i = 0; i < $095cb628e10db226$var$prefixes.length; i++){
        const prefixed = $095cb628e10db226$var$prefixes[i] + name;
        if (prefixed in style) return $095cb628e10db226$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $095cb628e10db226$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $095cb628e10db226$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($095cb628e10db226$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($095cb628e10db226$var$xlinkNS, key, value);
    } else {
        // note we are only checking boolean attributes that don't have a
        // corresponding dom prop of the same name here.
        const isBoolean = (0, $8ENGG.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $8ENGG.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
// __UNSAFE__
// functions. The user is responsible for using them with only trusted content.
function $095cb628e10db226$var$patchDOMProp(el, key, value, // the following args are passed only due to potential innerHTML/textContent
// overriding existing VNodes, in which case the old tree must be properly
// unmounted.
prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    if (key === "value" && el.tagName !== "PROGRESS" && // custom elements may use _value internally
    !el.tagName.includes("-")) {
        // store value as _value as well since
        // non-string values will be stringified.
        el._value = value;
        const newValue = value == null ? "" : value;
        if (el.value !== newValue || // #4956: always set for OPTION elements because its value falls back to
        // textContent if no value attribute is present. And setting .value for
        // OPTION has no side effect
        el.tagName === "OPTION") el.value = newValue;
        if (value == null) el.removeAttribute(key);
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") // e.g. <select multiple> compiles to { multiple: '' }
        value = (0, $8ENGG.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            // e.g. <div :id="null">
            value = "";
            needRemove = true;
        } else if (type === "number") {
            // e.g. <img :width="null">
            value = 0;
            needRemove = true;
        }
    }
    // some properties perform value validation and throw,
    // some properties has getter, no setter, will error in 'use strict'
    // eg. <select :type="null"></select> <select :willValidate="null"></select>
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $095cb628e10db226$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $095cb628e10db226$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
function $095cb628e10db226$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    // vei = vue event invokers
    const invokers = el._vei || (el._vei = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) // patch
    existingInvoker.value = nextValue;
    else {
        const [name, options] = $095cb628e10db226$var$parseName(rawName);
        if (nextValue) {
            // add
            const invoker = invokers[rawName] = $095cb628e10db226$var$createInvoker(nextValue, instance);
            $095cb628e10db226$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            // remove
            $095cb628e10db226$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = undefined;
        }
    }
}
const $095cb628e10db226$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $095cb628e10db226$var$parseName(name) {
    let options;
    if ($095cb628e10db226$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($095cb628e10db226$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $8ENGG.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
// To avoid the overhead of repeatedly calling Date.now(), we cache
// and use the same timestamp for all event listeners attached in the same tick.
let $095cb628e10db226$var$cachedNow = 0;
const $095cb628e10db226$var$p = /*#__PURE__*/ Promise.resolve();
const $095cb628e10db226$var$getNow = ()=>$095cb628e10db226$var$cachedNow || ($095cb628e10db226$var$p.then(()=>$095cb628e10db226$var$cachedNow = 0), $095cb628e10db226$var$cachedNow = Date.now());
function $095cb628e10db226$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        // async edge case vuejs/vue#6566
        // inner click event triggers patch, event handler
        // attached to outer element during patch, and triggered again. This
        // happens because browsers fire microtask ticks between event propagation.
        // this no longer happens for templates in Vue 3, but could still be
        // theoretically possible for hand-written render functions.
        // the solution: we save the timestamp when a handler is attached,
        // and also attach the timestamp to any event that was handled by vue
        // for the first time (to avoid inconsistent event timestamp implementations
        // or events fired from iframes, e.g. #2513)
        // The handler would only fire if the event passed to it was fired
        // AFTER it was attached.
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $esfUo.callWithAsyncErrorHandling)($095cb628e10db226$var$patchStopImmediatePropagation(e, invoker.value), instance, 5 /* ErrorCodes.NATIVE_EVENT_HANDLER */ , [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $095cb628e10db226$var$getNow();
    return invoker;
}
function $095cb628e10db226$var$patchStopImmediatePropagation(e, value) {
    if ((0, $8ENGG.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e)=>!e._stopped && fn && fn(e));
    } else return value;
}
const $095cb628e10db226$var$nativeOnRE = /^on[a-z]/;
const $095cb628e10db226$var$patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    if (key === "class") $095cb628e10db226$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $095cb628e10db226$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $8ENGG.isOn)(key)) // ignore v-model listeners
    {
        if (!(0, $8ENGG.isModelListener)(key)) $095cb628e10db226$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $095cb628e10db226$var$shouldSetAsProp(el, key, nextValue, isSVG)) $095cb628e10db226$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        // special case for <input v-model type="checkbox"> with
        // :true-value & :false-value
        // store value as dom properties since non-string values will be
        // stringified.
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $095cb628e10db226$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $095cb628e10db226$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        // most keys must be set as attribute on svg elements to work
        // ...except innerHTML & textContent
        if (key === "innerHTML" || key === "textContent") return true;
        // or native onclick with function values
        if (key in el && $095cb628e10db226$var$nativeOnRE.test(key) && (0, $8ENGG.isFunction)(value)) return true;
        return false;
    }
    // these are enumerated attrs, however their corresponding DOM properties
    // are actually booleans - this leads to setting it with a string "false"
    // value leading it to be coerced to `true`, so we need to always treat
    // them as attributes.
    // Note that `contentEditable` doesn't have this problem: its DOM
    // property is also enumerated string values.
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    // #1787, #2840 form property on form elements is readonly and must be set as
    // attribute.
    if (key === "form") return false;
    // #1526 <input list> must be set as attribute
    if (key === "list" && el.tagName === "INPUT") return false;
    // #2766 <textarea type> must be set as attribute
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    // native onclick with string value, must be set as attribute
    if ($095cb628e10db226$var$nativeOnRE.test(key) && (0, $8ENGG.isString)(value)) return false;
    return key in el;
}
function $095cb628e10db226$export$a00e2346eabbdbef(options, hydrate) {
    const Comp = (0, $esfUo.defineComponent)(options);
    class VueCustomElement extends $095cb628e10db226$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $095cb628e10db226$export$6debb2e68f212638 = (options)=>{
    // @ts-ignore
    return $095cb628e10db226$export$a00e2346eabbdbef(options, $095cb628e10db226$export$fa8d919ba61d84db);
};
const $095cb628e10db226$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $095cb628e10db226$export$b337c1a55163dbe3 extends $095cb628e10db226$var$BaseClass {
    connectedCallback() {
        this._connected = true;
        if (!this._instance) this._resolveDef();
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $esfUo.nextTick)(()=>{
            if (!this._connected) {
                $095cb628e10db226$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
     * resolve inner component definition (handle possible async component)
     */ _resolveDef() {
        if (this._resolved) return;
        this._resolved = true;
        // set initial attrs
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        // watch future attr changes
        new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        }).observe(this, {
            attributes: true
        });
        const resolve = (def)=>{
            const { props: props, styles: styles } = def;
            const hasOptions = !(0, $8ENGG.isArray)(props);
            const rawKeys = props ? hasOptions ? Object.keys(props) : props : [];
            // cast Number-type props set before resolve
            let numberProps;
            if (hasOptions) for(const key in this._props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    this._props[key] = (0, $8ENGG.toNumber)(this._props[key]);
                    (numberProps || (numberProps = Object.create(null)))[key] = true;
                }
            }
            this._numberProps = numberProps;
            // check if there are props set pre-upgrade or connect
            for (const key of Object.keys(this))if (key[0] !== "_") this._setProp(key, this[key], true, false);
            // defining getter/setters on prototype
            for (const key of rawKeys.map((0, $8ENGG.camelize)))Object.defineProperty(this, key, {
                get () {
                    return this._getProp(key);
                },
                set (val) {
                    this._setProp(key, val);
                }
            });
            // apply CSS
            this._applyStyles(styles);
            // initial render
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then(resolve);
        else resolve(this._def);
    }
    _setAttr(key) {
        let value = this.getAttribute(key);
        if (this._numberProps && this._numberProps[key]) value = (0, $8ENGG.toNumber)(value);
        this._setProp((0, $8ENGG.camelize)(key), value, false);
    }
    /**
     * @internal
     */ _getProp(key) {
        return this._props[key];
    }
    /**
     * @internal
     */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            // reflect
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $8ENGG.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $8ENGG.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $8ENGG.hyphenate)(key));
            }
        }
    }
    _update() {
        $095cb628e10db226$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $esfUo.createVNode)(this._def, (0, $8ENGG.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            // intercept emit
            instance.emit = (event, ...args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            // locate nearest Vue custom element parent for provide/inject
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $095cb628e10db226$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
    constructor(_def, _props = {}, hydrate){
        super();
        this._def = _def;
        this._props = _props;
        /**
         * @internal
         */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        if (this.shadowRoot && hydrate) hydrate(this._createVNode(), this.shadowRoot);
        else this.attachShadow({
            mode: "open"
        });
    }
}
function $095cb628e10db226$export$9300d5b90d56e3d1(name = "$style") {
    /* istanbul ignore else */ {
        const instance = (0, $esfUo.getCurrentInstance)();
        if (!instance) return 0, $8ENGG.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $8ENGG.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $8ENGG.EMPTY_OBJ;
        return mod;
    }
}
/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */ function $095cb628e10db226$export$ef28b76f07940108(getter) {
    const instance = (0, $esfUo.getCurrentInstance)();
    /* istanbul ignore next */ if (!instance) return;
    const setVars = ()=>$095cb628e10db226$var$setVarsOnVNode(instance.subTree, getter(instance.proxy));
    (0, $esfUo.watchPostEffect)(setVars);
    (0, $esfUo.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $esfUo.onUnmounted)(()=>ob.disconnect());
    });
}
function $095cb628e10db226$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128 /* ShapeFlags.SUSPENSE */ ) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $095cb628e10db226$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    // drill down HOCs until it's a non-component vnode
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 /* ShapeFlags.ELEMENT */  && vnode.el) $095cb628e10db226$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $esfUo.Fragment)) vnode.children.forEach((c)=>$095cb628e10db226$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $esfUo.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $095cb628e10db226$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $095cb628e10db226$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        for(const key in vars)style.setProperty(`--${key}`, vars[key]);
    }
}
const $095cb628e10db226$var$TRANSITION = "transition";
const $095cb628e10db226$var$ANIMATION = "animation";
// DOM Transition is a higher-order-component based on the platform-agnostic
// base Transition component, with DOM-specific logic.
const $095cb628e10db226$export$be58926105124dd4 = (props, { slots: slots })=>(0, $esfUo.h)((0, $esfUo.BaseTransition), $095cb628e10db226$var$resolveTransitionProps(props), slots);
$095cb628e10db226$export$be58926105124dd4.displayName = "Transition";
const $095cb628e10db226$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $095cb628e10db226$var$TransitionPropsValidators = $095cb628e10db226$export$be58926105124dd4.props = /*#__PURE__*/ (0, $8ENGG.extend)({}, (0, $esfUo.BaseTransition).props, $095cb628e10db226$var$DOMTransitionPropsValidators);
/**
 * #3227 Incoming hooks may be merged into arrays when wrapping Transition
 * with custom HOCs.
 */ const $095cb628e10db226$var$callHook = (hook, args = [])=>{
    if ((0, $8ENGG.isArray)(hook)) hook.forEach((h)=>h(...args));
    else if (hook) hook(...args);
};
/**
 * Check if a hook expects a callback (2nd arg), which means the user
 * intends to explicitly control the end of the transition.
 */ const $095cb628e10db226$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $8ENGG.isArray)(hook) ? hook.some((h)=>h.length > 1) : hook.length > 1 : false;
};
function $095cb628e10db226$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $095cb628e10db226$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $095cb628e10db226$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $095cb628e10db226$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $095cb628e10db226$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $095cb628e10db226$var$removeTransitionClass(el, leaveFromClass);
        $095cb628e10db226$var$removeTransitionClass(el, leaveToClass);
        $095cb628e10db226$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $095cb628e10db226$var$callHook(hook, [
                el,
                resolve
            ]);
            $095cb628e10db226$var$nextFrame(()=>{
                $095cb628e10db226$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $095cb628e10db226$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$095cb628e10db226$var$hasExplicitCallback(hook)) $095cb628e10db226$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $8ENGG.extend)(baseProps, {
        onBeforeEnter (el) {
            $095cb628e10db226$var$callHook(onBeforeEnter, [
                el
            ]);
            $095cb628e10db226$var$addTransitionClass(el, enterFromClass);
            $095cb628e10db226$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $095cb628e10db226$var$callHook(onBeforeAppear, [
                el
            ]);
            $095cb628e10db226$var$addTransitionClass(el, appearFromClass);
            $095cb628e10db226$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $095cb628e10db226$var$addTransitionClass(el, leaveFromClass);
            // force reflow so *-leave-from classes immediately take effect (#2593)
            $095cb628e10db226$var$forceReflow();
            $095cb628e10db226$var$addTransitionClass(el, leaveActiveClass);
            $095cb628e10db226$var$nextFrame(()=>{
                if (!el._isLeaving) // cancelled
                return;
                $095cb628e10db226$var$removeTransitionClass(el, leaveFromClass);
                $095cb628e10db226$var$addTransitionClass(el, leaveToClass);
                if (!$095cb628e10db226$var$hasExplicitCallback(onLeave)) $095cb628e10db226$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $095cb628e10db226$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $095cb628e10db226$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $095cb628e10db226$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $095cb628e10db226$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $095cb628e10db226$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $8ENGG.isObject)(duration)) return [
        $095cb628e10db226$var$NumberOf(duration.enter),
        $095cb628e10db226$var$NumberOf(duration.leave)
    ];
    else {
        const n = $095cb628e10db226$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $095cb628e10db226$var$NumberOf(val) {
    const res = (0, $8ENGG.toNumber)(val);
    return res;
}
function $095cb628e10db226$var$validateDuration(val) {
    if (typeof val !== "number") (0, $esfUo.warn)(`<transition> explicit duration is not a valid number - ` + `got ${JSON.stringify(val)}.`);
    else if (isNaN(val)) (0, $esfUo.warn)(`<transition> explicit duration is NaN - ` + "the duration expression might be incorrect.");
}
function $095cb628e10db226$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el._vtc || (el._vtc = new Set())).add(cls);
}
function $095cb628e10db226$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const { _vtc: _vtc } = el;
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el._vtc = undefined;
    }
}
function $095cb628e10db226$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $095cb628e10db226$var$endId = 0;
function $095cb628e10db226$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$095cb628e10db226$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $095cb628e10db226$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $095cb628e10db226$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties($095cb628e10db226$var$TRANSITION + "Delay");
    const transitionDurations = getStyleProperties($095cb628e10db226$var$TRANSITION + "Duration");
    const transitionTimeout = $095cb628e10db226$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties($095cb628e10db226$var$ANIMATION + "Delay");
    const animationDurations = getStyleProperties($095cb628e10db226$var$ANIMATION + "Duration");
    const animationTimeout = $095cb628e10db226$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    /* istanbul ignore if */ if (expectedType === $095cb628e10db226$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $095cb628e10db226$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $095cb628e10db226$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $095cb628e10db226$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $095cb628e10db226$var$TRANSITION : $095cb628e10db226$var$ANIMATION : null;
        propCount = type ? type === $095cb628e10db226$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $095cb628e10db226$var$TRANSITION && /\b(transform|all)(,|$)/.test(styles[$095cb628e10db226$var$TRANSITION + "Property"]);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $095cb628e10db226$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$095cb628e10db226$var$toMs(d) + $095cb628e10db226$var$toMs(delays[i])));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer
// numbers in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down
// (i.e. acting as a floor function) causing unexpected behaviors
function $095cb628e10db226$var$toMs(s) {
    return Number(s.slice(0, -1).replace(",", ".")) * 1000;
}
// synchronously force layout to put elements into a certain state
function $095cb628e10db226$var$forceReflow() {
    return document.body.offsetHeight;
}
const $095cb628e10db226$var$positionMap = new WeakMap();
const $095cb628e10db226$var$newPositionMap = new WeakMap();
const $095cb628e10db226$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /*#__PURE__*/ (0, $8ENGG.extend)({}, $095cb628e10db226$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $esfUo.getCurrentInstance)();
        const state = (0, $esfUo.useTransitionState)();
        let prevChildren;
        let children;
        (0, $esfUo.onUpdated)(()=>{
            // children is guaranteed to exist after initial render
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$095cb628e10db226$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            // we divide the work into three loops to avoid mixing DOM reads and writes
            // in each iteration - which helps prevent layout thrashing.
            prevChildren.forEach($095cb628e10db226$var$callPendingCbs);
            prevChildren.forEach($095cb628e10db226$var$recordPosition);
            const movedChildren = prevChildren.filter($095cb628e10db226$var$applyTranslation);
            // force reflow to put everything in position
            $095cb628e10db226$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $095cb628e10db226$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el._moveCb = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el._moveCb = null;
                        $095cb628e10db226$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $am4TS.toRaw)(props);
            const cssTransitionProps = $095cb628e10db226$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $esfUo.Fragment);
            prevChildren = children;
            children = slots.default ? (0, $esfUo.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $esfUo.setTransitionHooks)(child, (0, $esfUo.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren) for(let i = 0; i < prevChildren.length; i++){
                const child = prevChildren[i];
                (0, $esfUo.setTransitionHooks)(child, (0, $esfUo.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                $095cb628e10db226$var$positionMap.set(child, child.el.getBoundingClientRect());
            }
            return (0, $esfUo.createVNode)(tag, null, children);
        };
    }
};
const $095cb628e10db226$export$19ffa8f511f7bc2e = $095cb628e10db226$var$TransitionGroupImpl;
function $095cb628e10db226$var$callPendingCbs(c) {
    const el = c.el;
    if (el._moveCb) el._moveCb();
    if (el._enterCb) el._enterCb();
}
function $095cb628e10db226$var$recordPosition(c) {
    $095cb628e10db226$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $095cb628e10db226$var$applyTranslation(c) {
    const oldPos = $095cb628e10db226$var$positionMap.get(c);
    const newPos = $095cb628e10db226$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $095cb628e10db226$var$hasCSSTransform(el, root, moveClass) {
    // Detect whether an element with the move class applied has
    // CSS transitions. Since the element may be inside an entering
    // transition at this very moment, we make a clone of it and remove
    // all other transition classes applied to ensure only the move class
    // is applied.
    const clone = el.cloneNode();
    if (el._vtc) el._vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $095cb628e10db226$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $095cb628e10db226$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $8ENGG.isArray)(fn) ? (value)=>(0, $8ENGG.invokeArrayFns)(fn, value) : fn;
};
function $095cb628e10db226$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $095cb628e10db226$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
// We are exporting the v-model runtime directly as vnode hooks so that it can
// be tree-shaken in case v-model is never used.
const $095cb628e10db226$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $095cb628e10db226$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $095cb628e10db226$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $8ENGG.toNumber)(domValue);
            el._assign(domValue);
        });
        if (trim) $095cb628e10db226$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $095cb628e10db226$var$addEventListener(el, "compositionstart", $095cb628e10db226$var$onCompositionStart);
            $095cb628e10db226$var$addEventListener(el, "compositionend", $095cb628e10db226$var$onCompositionEnd);
            // Safari < 10.2 & UIWebView doesn't fire compositionend when
            // switching focus before confirming composition choice
            // this also fixes the issue where some browsers e.g. iOS Chrome
            // fires "change" instead of "input" on autocomplete.
            $095cb628e10db226$var$addEventListener(el, "change", $095cb628e10db226$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $095cb628e10db226$var$getModelAssigner(vnode);
        // avoid clearing unresolved text. #2302
        if (el.composing) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === value) return;
            if ((number || el.type === "number") && (0, $8ENGG.toNumber)(el.value) === value) return;
        }
        const newValue = value == null ? "" : value;
        if (el.value !== newValue) el.value = newValue;
    }
};
const $095cb628e10db226$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el._assign = $095cb628e10db226$var$getModelAssigner(vnode);
        $095cb628e10db226$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $095cb628e10db226$var$getValue(el);
            const checked = el.checked;
            const assign = el._assign;
            if ((0, $8ENGG.isArray)(modelValue)) {
                const index = (0, $8ENGG.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $8ENGG.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($095cb628e10db226$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $095cb628e10db226$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el._assign = $095cb628e10db226$var$getModelAssigner(vnode);
        $095cb628e10db226$var$setChecked(el, binding, vnode);
    }
};
function $095cb628e10db226$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $8ENGG.isArray)(value)) el.checked = (0, $8ENGG.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $8ENGG.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $8ENGG.looseEqual)(value, $095cb628e10db226$var$getCheckboxValue(el, true));
}
const $095cb628e10db226$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $8ENGG.looseEqual)(value, vnode.props.value);
        el._assign = $095cb628e10db226$var$getModelAssigner(vnode);
        $095cb628e10db226$var$addEventListener(el, "change", ()=>{
            el._assign($095cb628e10db226$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el._assign = $095cb628e10db226$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $8ENGG.looseEqual)(value, vnode.props.value);
    }
};
const $095cb628e10db226$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $8ENGG.isSet)(value);
        $095cb628e10db226$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $8ENGG.toNumber)($095cb628e10db226$var$getValue(o)) : $095cb628e10db226$var$getValue(o));
            el._assign(el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
        });
        el._assign = $095cb628e10db226$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $095cb628e10db226$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el._assign = $095cb628e10db226$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        $095cb628e10db226$var$setSelected(el, value);
    }
};
function $095cb628e10db226$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    if (isMultiple && !(0, $8ENGG.isArray)(value) && !(0, $8ENGG.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $095cb628e10db226$var$getValue(option);
        if (isMultiple) {
            if ((0, $8ENGG.isArray)(value)) option.selected = (0, $8ENGG.looseIndexOf)(value, optionValue) > -1;
            else option.selected = value.has(optionValue);
        } else if ((0, $8ENGG.looseEqual)($095cb628e10db226$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
// retrieve raw value set via :value bindings
function $095cb628e10db226$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
// retrieve raw value for true-value and false-value set via :true-value or :false-value bindings
function $095cb628e10db226$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $095cb628e10db226$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $095cb628e10db226$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $095cb628e10db226$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $095cb628e10db226$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $095cb628e10db226$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $095cb628e10db226$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $095cb628e10db226$export$87d227567b51ca39;
        case "TEXTAREA":
            return $095cb628e10db226$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $095cb628e10db226$export$8847c2e532b35714;
                case "radio":
                    return $095cb628e10db226$export$b4356c59b38b7aa9;
                default:
                    return $095cb628e10db226$export$f1f88689f5728478;
            }
    }
}
function $095cb628e10db226$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $095cb628e10db226$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
// SSR vnode transforms, only used when user includes client-oriented render
// function in SSR
function $095cb628e10db226$var$initVModelForSSR() {
    $095cb628e10db226$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $095cb628e10db226$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $8ENGG.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $095cb628e10db226$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $8ENGG.isArray)(value)) {
            if (vnode.props && (0, $8ENGG.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $8ENGG.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $095cb628e10db226$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $095cb628e10db226$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $095cb628e10db226$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $095cb628e10db226$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$095cb628e10db226$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
/**
 * @private
 */ const $095cb628e10db226$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    return (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $095cb628e10db226$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    };
};
// Kept for 2.x compat.
// Note: IE11 compat for `spacebar` and `del` is removed for now.
const $095cb628e10db226$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
/**
 * @private
 */ const $095cb628e10db226$export$f691a8759658f782 = (fn, modifiers)=>{
    return (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $8ENGG.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $095cb628e10db226$var$keyNames[k] === eventKey)) return fn(event);
    };
};
const $095cb628e10db226$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el._vod = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $095cb628e10db226$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $095cb628e10db226$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $095cb628e10db226$var$setDisplay(el, false);
            });
        } else $095cb628e10db226$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $095cb628e10db226$var$setDisplay(el, value);
    }
};
function $095cb628e10db226$var$setDisplay(el, value) {
    el.style.display = value ? el._vod : "none";
}
// SSR vnode transforms, only used when user includes client-oriented render
// function in SSR
function $095cb628e10db226$var$initVShowForSSR() {
    $095cb628e10db226$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $095cb628e10db226$var$rendererOptions = /*#__PURE__*/ (0, $8ENGG.extend)({
    patchProp: $095cb628e10db226$var$patchProp
}, $095cb628e10db226$var$nodeOps);
// lazy create the renderer - this makes core renderer logic tree-shakable
// in case the user only imports reactivity utilities from Vue.
let $095cb628e10db226$var$renderer;
let $095cb628e10db226$var$enabledHydration = false;
function $095cb628e10db226$var$ensureRenderer() {
    return $095cb628e10db226$var$renderer || ($095cb628e10db226$var$renderer = (0, $esfUo.createRenderer)($095cb628e10db226$var$rendererOptions));
}
function $095cb628e10db226$var$ensureHydrationRenderer() {
    $095cb628e10db226$var$renderer = $095cb628e10db226$var$enabledHydration ? $095cb628e10db226$var$renderer : (0, $esfUo.createHydrationRenderer)($095cb628e10db226$var$rendererOptions);
    $095cb628e10db226$var$enabledHydration = true;
    return $095cb628e10db226$var$renderer;
}
// use explicit type casts here to avoid import() calls in rolled-up d.ts
const $095cb628e10db226$export$b3890eb0ae9dca99 = (...args)=>{
    $095cb628e10db226$var$ensureRenderer().render(...args);
};
const $095cb628e10db226$export$fa8d919ba61d84db = (...args)=>{
    $095cb628e10db226$var$ensureHydrationRenderer().hydrate(...args);
};
const $095cb628e10db226$export$4e373c34abfa8c68 = (...args)=>{
    const app = $095cb628e10db226$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $095cb628e10db226$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $8ENGG.isFunction)(component) && !component.render && !component.template) // __UNSAFE__
        // Reason: potential execution of JS expressions in in-DOM template.
        // The user must make sure the in-DOM template is trusted. If it's
        // rendered by the server, the template should not contain any user data.
        component.template = container.innerHTML;
        // clear content before mounting
        container.innerHTML = "";
        const proxy = mount(container, false, container instanceof SVGElement);
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $095cb628e10db226$export$35800275c0037383 = (...args)=>{
    const app = $095cb628e10db226$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $095cb628e10db226$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, container instanceof SVGElement);
    };
    return app;
};
function $095cb628e10db226$var$injectNativeTagCheck(app) {
    // Inject `isNativeTag`
    // this is used for component name validation (dev only)
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $8ENGG.isHTMLTag)(tag) || (0, $8ENGG.isSVGTag)(tag),
        writable: false
    });
}
// dev only
function $095cb628e10db226$var$injectCompilerOptionsCheck(app) {
    if ((0, $esfUo.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $esfUo.warn)(`The \`isCustomElement\` config option is deprecated. Use ` + `\`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using ` + `a build of Vue.js that includes the runtime compiler (aka "full build"). ` + `Since you are using the runtime-only build, \`compilerOptions\` ` + `must be passed to \`@vue/compiler-dom\` in the build setup instead.\n` + `- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.\n` + `- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n` + `- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-dom`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $esfUo.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $esfUo.warn)(msg);
            }
        });
    }
}
function $095cb628e10db226$var$normalizeContainer(container) {
    if ((0, $8ENGG.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $095cb628e10db226$var$ssrDirectiveInitialized = false;
/**
 * @internal
 */ const $095cb628e10db226$export$800b28255aa678d9 = ()=>{
    if (!$095cb628e10db226$var$ssrDirectiveInitialized) {
        $095cb628e10db226$var$ssrDirectiveInitialized = true;
        $095cb628e10db226$var$initVModelForSSR();
        $095cb628e10db226$var$initVShowForSSR();
    }
};

});


parcelRegister("6x6HK", function(module, exports) {
$parcel$export(module.exports, "ChallengeV3", function () { return (parcelRequire("b6AyC")).default; });
$parcel$export(module.exports, "useRecaptchaProvider", function () { return (parcelRequire("6AdLA")).useRecaptchaProvider; });

$parcel$export(module.exports, "VueRecaptchaPlugin", function () { return $e55d687e335f6742$export$2e2bcd8739ae039; });

var $5wEd6 = parcelRequire("5wEd6");

var $7lIEB = parcelRequire("7lIEB");
parcelRequire("fiqmz");
const $e55d687e335f6742$export$2e2bcd8739ae039 = (0, $5wEd6.createPlugin)((0, $7lIEB.createUnheadRecaptcha));

});
parcelRegister("5wEd6", function(module, exports) {

$parcel$export(module.exports, "createPlugin", function () { return $d614c71925680ad1$export$ae829ec7b2625219; });
parcelRequire("jwRyC");
var $am4TS = parcelRequire("am4TS");

var $i4Q9n = parcelRequire("i4Q9n");

var $2HCkv = parcelRequire("2HCkv");

var $17Esm = parcelRequire("17Esm");
function $d614c71925680ad1$export$ae829ec7b2625219(scriptManagerFactory) {
    return {
        install (app, options) {
            const isReady = (0, $am4TS.ref)(false);
            async function waitLoaded() {
                await (0, $17Esm.recaptchaLoaded).promise;
                isReady.value = true;
            }
            waitLoaded();
            (0, $17Esm.checkRecaptchaLoad)();
            const opt = (0, $i4Q9n.normalizeOptions)(options);
            app.provide((0, $i4Q9n.RecaptchaContextKey), {
                isReady: isReady,
                scriptInjected: false,
                proxy: (0, $2HCkv.createRecaptchaProxy)(isReady),
                useScriptProvider: scriptManagerFactory(opt.params),
                options: opt
            });
        }
    };
}

});
parcelRegister("jwRyC", function(module, exports) {
$parcel$export(module.exports, "ref", function () { return (parcelRequire("am4TS")).ref; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("esfUo")).onMounted; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("esfUo")).inject; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("esfUo")).warn; });
$parcel$export(module.exports, "toRef", function () { return (parcelRequire("am4TS")).toRef; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("am4TS")).computed; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("esfUo")).watch; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("am4TS")).shallowRef; });
$parcel$export(module.exports, "watchEffect", function () { return (parcelRequire("esfUo")).watchEffect; });
$parcel$export(module.exports, "readonly", function () { return (parcelRequire("am4TS")).readonly; });
$parcel$export(module.exports, "unref", function () { return (parcelRequire("am4TS")).unref; });
$parcel$export(module.exports, "version", function () { return (parcelRequire("esfUo")).version; });
$parcel$export(module.exports, "customRef", function () { return (parcelRequire("am4TS")).customRef; });
$parcel$export(module.exports, "getCurrentScope", function () { return (parcelRequire("am4TS")).getCurrentScope; });
$parcel$export(module.exports, "onScopeDispose", function () { return (parcelRequire("am4TS")).onScopeDispose; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("am4TS")).effectScope; });
$parcel$export(module.exports, "provide", function () { return (parcelRequire("esfUo")).provide; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("am4TS")).isRef; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("am4TS")).reactive; });
$parcel$export(module.exports, "toRefs", function () { return (parcelRequire("am4TS")).toRefs; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("esfUo")).getCurrentInstance; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("esfUo")).onBeforeMount; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("esfUo")).nextTick; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return (parcelRequire("esfUo")).onBeforeUnmount; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("esfUo")).onUnmounted; });
$parcel$export(module.exports, "isReactive", function () { return (parcelRequire("am4TS")).isReactive; });

$parcel$export(module.exports, "isVue2", function () { return $b4df40f495d82c89$export$1da84e343e81ceb9; });
$parcel$export(module.exports, "isVue3", function () { return $b4df40f495d82c89$export$34b222e3d4733e48; });
$parcel$export(module.exports, "set", function () { return $b4df40f495d82c89$export$adaa4cf7ef1b65be; });
parcelRequire("hQJKw");
var $b4df40f495d82c89$export$1da84e343e81ceb9 = false;
var $b4df40f495d82c89$export$34b222e3d4733e48 = true;
var $b4df40f495d82c89$export$a8cb34872e7d8b79 = undefined;
function $b4df40f495d82c89$export$4b3e715f166fdd78() {}
function $b4df40f495d82c89$export$adaa4cf7ef1b65be(target, key, val) {
    if (Array.isArray(target)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        return val;
    }
    target[key] = val;
    return val;
}
function $b4df40f495d82c89$export$1d2f21e549771e67(target, key) {
    if (Array.isArray(target)) {
        target.splice(key, 1);
        return;
    }
    delete target[key];
}

});

parcelRegister("i4Q9n", function(module, exports) {

$parcel$export(module.exports, "RecaptchaContextKey", function () { return $e3bd5851cd60268c$export$e19a3da4a75bc338; });
$parcel$export(module.exports, "useRecaptchaContext", function () { return $e3bd5851cd60268c$export$744a1a543fe96347; });
$parcel$export(module.exports, "useRecaptchaProxy", function () { return $e3bd5851cd60268c$export$822b0e467365bb; });
$parcel$export(module.exports, "useAssertV2SiteKey", function () { return $e3bd5851cd60268c$export$7d9850c50e5e3e06; });
$parcel$export(module.exports, "useAssertV3SiteKey", function () { return $e3bd5851cd60268c$export$c8ea70b425d9f945; });
$parcel$export(module.exports, "normalizeOptions", function () { return $e3bd5851cd60268c$export$eb806c0b85b62f7a; });
parcelRequire("jwRyC");
var $esfUo = parcelRequire("esfUo");

var $bS1Ya = parcelRequire("bS1Ya");
const $e3bd5851cd60268c$export$e19a3da4a75bc338 = Symbol("vue-recaptcha-context");
function $e3bd5851cd60268c$export$744a1a543fe96347() {
    const context = (0, $esfUo.inject)($e3bd5851cd60268c$export$e19a3da4a75bc338);
    if (!context) {
        (0, $bS1Ya.warn)("You may forget to `use` vue-recaptcha plugin");
        throw new Error("useRecaptcha() is called without provider.");
    }
    return context;
}
function $e3bd5851cd60268c$export$822b0e467365bb() {
    const ctx = $e3bd5851cd60268c$export$744a1a543fe96347();
    return ctx.proxy;
}
function $e3bd5851cd60268c$export$7d9850c50e5e3e06() {
    const ctx = $e3bd5851cd60268c$export$744a1a543fe96347();
    (0, $bS1Ya.invariant)(ctx.options.v2SiteKey, "Your config is not compatible with recaptcha v2, please provide v2SiteKey");
    return ctx.options.v2SiteKey;
}
function $e3bd5851cd60268c$export$c8ea70b425d9f945() {
    const ctx = $e3bd5851cd60268c$export$744a1a543fe96347();
    (0, $bS1Ya.invariant)(ctx.options.v3SiteKey, "Your config is not compatible with recaptcha v3, please provide v3SiteKey");
    return ctx.options.v3SiteKey;
}
function $e3bd5851cd60268c$export$eb806c0b85b62f7a(input) {
    (0, $bS1Ya.invariant)(input.v2SiteKey || input.v3SiteKey, "You didn't pass v2SiteKey or v3SiteKey to plugin, which may be a mistake");
    var _input_v3SiteKey;
    return {
        ...input,
        params: {
            ...input.params,
            render: (_input_v3SiteKey = input.v3SiteKey) !== null && _input_v3SiteKey !== void 0 ? _input_v3SiteKey : "explicit"
        }
    };
}

});
parcelRegister("bS1Ya", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $af5de009074a3479$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "invariant", function () { return $af5de009074a3479$export$f5708dca728d7177; });
parcelRequire("jwRyC");
var $esfUo = parcelRequire("esfUo");
function $af5de009074a3479$export$c106dd0671a0fc2d(msg, ...params) {
    (0, $esfUo.warn)(`[vue-recaptcha]: ${msg}`, ...params);
}
function $af5de009074a3479$export$f5708dca728d7177(condition, msg) {
    if (!condition) {
        $af5de009074a3479$export$c106dd0671a0fc2d(msg);
        throw new Error(`Invariant violation: ${msg}`);
    }
}

});


parcelRegister("2HCkv", function(module, exports) {

$parcel$export(module.exports, "createRecaptchaProxy", function () { return $4d01b655639ec888$export$da7e8d22c091836b; });

var $bS1Ya = parcelRequire("bS1Ya");

var $17Esm = parcelRequire("17Esm");
function $4d01b655639ec888$export$da7e8d22c091836b(isReady) {
    function assertLoaded() {
        (0, $bS1Ya.invariant)(isReady.value, "ReCAPTCHA is not loaded");
    }
    async function wait() {
        await (0, $17Esm.recaptchaLoaded).promise;
        isReady.value = true;
    }
    return {
        async render (ele, options) {
            await wait();
            return window.grecaptcha.render(ele, options);
        },
        reset (widgetId) {
            if (typeof widgetId === "undefined") return;
            assertLoaded();
            window.grecaptcha.reset(widgetId);
        },
        async execute (widgetId, options) {
            if (typeof widgetId === "undefined") return;
            await wait();
            return window.grecaptcha.execute(widgetId, options);
        }
    };
}

});
parcelRegister("17Esm", function(module, exports) {

$parcel$export(module.exports, "recaptchaLoaded", function () { return $79d5e63d10d24385$export$b97b16bc7fe47920; });
$parcel$export(module.exports, "toQueryString", function () { return $79d5e63d10d24385$export$249cc09c933c4d7a; });
$parcel$export(module.exports, "checkRecaptchaLoad", function () { return $79d5e63d10d24385$export$855305cc95630c8d; });

var $aGIlZ = parcelRequire("aGIlZ");

var $bS1Ya = parcelRequire("bS1Ya");

var $94ISK = parcelRequire("94ISK");
const $79d5e63d10d24385$export$b97b16bc7fe47920 = (0, $aGIlZ.default)();
const $79d5e63d10d24385$var$ONLOAD_KEY = "__vueRecaptchaLoaded";
if (typeof window !== "undefined") window[$79d5e63d10d24385$var$ONLOAD_KEY] = ()=>{
    $79d5e63d10d24385$export$b97b16bc7fe47920.resolve();
};
function $79d5e63d10d24385$export$249cc09c933c4d7a(params) {
    return new URLSearchParams($79d5e63d10d24385$export$d6b7b25dfacfd300(params)).toString();
}
function $79d5e63d10d24385$export$d6b7b25dfacfd300(raw) {
    const params = (0, $94ISK.default)(raw, {
        onload: $79d5e63d10d24385$var$ONLOAD_KEY,
        render: "explicit"
    });
    if (params.render === "onload") {
        (0, $bS1Ya.warn)("passing `onload` as `render` param is not allowed");
        params.render = "explicit";
    }
    if (params.onload !== $79d5e63d10d24385$var$ONLOAD_KEY) {
        (0, $bS1Ya.warn)("passing `onload` param with other value is not allowed");
        params.onload = $79d5e63d10d24385$var$ONLOAD_KEY;
    }
    return $79d5e63d10d24385$export$f1cdb815ae2ac7d9(params);
}
function $79d5e63d10d24385$export$f1cdb815ae2ac7d9(params) {
    return Object.entries(params).filter((pair)=>typeof pair[1] === "string");
}
function $79d5e63d10d24385$export$855305cc95630c8d() {
    if (typeof window === "undefined") return false;
    const isLoaded = Object.hasOwn(window, "grecaptcha") && Object.hasOwn(window.grecaptcha, "execute");
    if (isLoaded) $79d5e63d10d24385$export$b97b16bc7fe47920.resolve();
    return isLoaded;
}

});
parcelRegister("aGIlZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c803b58ed324320$export$2e2bcd8739ae039; });
function $7c803b58ed324320$export$2e2bcd8739ae039() {
    const deferred = {};
    deferred.promise = new Promise((resolve, reject)=>{
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}

});

parcelRegister("94ISK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d89fabe4621a204$export$2e2bcd8739ae039; });
function $8d89fabe4621a204$var$isObject(value) {
    return value !== null && typeof value === "object";
}
function $8d89fabe4621a204$var$_defu(baseObject, defaults, namespace = ".", merger) {
    if (!$8d89fabe4621a204$var$isObject(defaults)) return $8d89fabe4621a204$var$_defu(baseObject, {}, namespace, merger);
    const object = Object.assign({}, defaults);
    for(const key in baseObject){
        if (key === "__proto__" || key === "constructor") continue;
        const value = baseObject[key];
        if (value === null || value === void 0) continue;
        if (merger && merger(object, key, value, namespace)) continue;
        if (Array.isArray(value) && Array.isArray(object[key])) object[key] = [
            ...value,
            ...object[key]
        ];
        else if ($8d89fabe4621a204$var$isObject(value) && $8d89fabe4621a204$var$isObject(object[key])) object[key] = $8d89fabe4621a204$var$_defu(value, object[key], (namespace ? `${namespace}.` : "") + key.toString(), merger);
        else object[key] = value;
    }
    return object;
}
function $8d89fabe4621a204$export$8a02f3fb863c5766(merger) {
    return (...arguments_)=>// eslint-disable-next-line unicorn/no-array-reduce
        arguments_.reduce((p, c)=>$8d89fabe4621a204$var$_defu(p, c, "", merger), {});
}
const $8d89fabe4621a204$export$2e2bcd8739ae039 = $8d89fabe4621a204$export$8a02f3fb863c5766();
const $8d89fabe4621a204$export$cab93adf4450876b = $8d89fabe4621a204$export$8a02f3fb863c5766((object, key, currentValue)=>{
    if (typeof object[key] !== "undefined" && typeof currentValue === "function") {
        object[key] = currentValue(object[key]);
        return true;
    }
});
const $8d89fabe4621a204$export$5268887ec16c1c0b = $8d89fabe4621a204$export$8a02f3fb863c5766((object, key, currentValue)=>{
    if (Array.isArray(object[key]) && typeof currentValue === "function") {
        object[key] = currentValue(object[key]);
        return true;
    }
});

});




parcelRegister("7lIEB", function(module, exports) {

$parcel$export(module.exports, "createUnheadRecaptcha", function () { return $7cda94b3bd4b7474$export$8061fd5f05a37199; });
parcelRequire("d44Ue");
var $4PQtJ = parcelRequire("4PQtJ");

var $17Esm = parcelRequire("17Esm");
function $7cda94b3bd4b7474$export$8061fd5f05a37199(params) {
    return ()=>{
        (0, $4PQtJ.u)({
            link: [
                {
                    key: "vue-recaptcha-google",
                    rel: "preconnect",
                    href: "https://www.google.com"
                },
                {
                    key: "vue-recaptcha-gstatic",
                    rel: "preconnect",
                    href: "https://www.gstatic.com",
                    crossorigin: ""
                }
            ],
            script: [
                {
                    key: "vue-recaptcha",
                    src: `https://www.google.com/recaptcha/api.js?${(0, $17Esm.toQueryString)(params)}`,
                    async: true,
                    defer: true
                }
            ]
        });
    };
}

});
parcelRegister("d44Ue", function(module, exports) {

$parcel$export(module.exports, "useHead", function () { return (parcelRequire("4PQtJ")).u; });

var $1ZeEE = parcelRequire("1ZeEE");

var $4PQtJ = parcelRequire("4PQtJ");
parcelRequire("hQJKw");
var $esfUo = parcelRequire("esfUo");
var $am4TS = parcelRequire("am4TS");

var $cHHQH = parcelRequire("cHHQH");
const $dff303e66c9999bd$export$d31792aba7052304 = {
    created () {
        const instance = (0, $esfUo.getCurrentInstance)();
        if (!instance) return;
        const options = instance.type;
        if (!options || !("head" in options)) return;
        const source = typeof options.head === "function" ? ()=>options.head.call(instance.proxy) : options.head;
        (0, $4PQtJ.u)(source);
    }
};
const $dff303e66c9999bd$export$e78934e23be1bca0 = function(_Vue, head) {
    _Vue.mixin({
        beforeCreate () {
            const options = this.$options;
            const origProvide = options.provide;
            options.provide = function() {
                let origProvideResult;
                if (typeof origProvide === "function") origProvideResult = origProvide.call(this);
                else origProvideResult = origProvide || {};
                return {
                    ...origProvideResult,
                    [(0, $4PQtJ.h)]: head
                };
            };
        }
    });
};
function $dff303e66c9999bd$export$f1e6716961cde60d(input, options = {}) {
    return (0, $4PQtJ.u)(input, {
        ...options,
        transform: (0, $1ZeEE.whitelistSafeInput)
    });
}
function $dff303e66c9999bd$export$5634b39f93cf91fe(input, options) {
    const headInput = (0, $am4TS.ref)({});
    (0, $esfUo.watchEffect)(()=>{
        const resolvedMeta = (0, $4PQtJ.r)(input);
        const { title: title, titleTemplate: titleTemplate, ...meta } = resolvedMeta;
        headInput.value = {
            title: title,
            titleTemplate: titleTemplate,
            meta: (0, $1ZeEE.unpackMeta)(meta)
        };
    });
    return (0, $4PQtJ.u)(headInput, options);
}
function $dff303e66c9999bd$export$f0462339a176e133(input, options = {}) {
    return (0, $4PQtJ.s)(input, {
        ...options,
        mode: "server"
    });
}
function $dff303e66c9999bd$export$4f19bd43f7a50bae(input, options = {}) {
    return $dff303e66c9999bd$export$f1e6716961cde60d(input, {
        ...options,
        mode: "server"
    });
}
function $dff303e66c9999bd$export$12a3b0ba181293b3(input, options) {
    return $dff303e66c9999bd$export$5634b39f93cf91fe(input, {
        ...options || {},
        mode: "server"
    });
}
function $dff303e66c9999bd$export$c37d4b9b1414299e(title) {
    return (0, $4PQtJ.u)({
        title: title
    });
}
function $dff303e66c9999bd$export$636cb0babb2895e6(titleTemplate) {
    return (0, $4PQtJ.u)({
        titleTemplate: titleTemplate
    });
}
function $dff303e66c9999bd$export$650b09068ff5d230(meta) {
    return (0, $4PQtJ.u)({
        meta: (0, $cHHQH.asArray)(meta)
    });
}
function $dff303e66c9999bd$export$8129fe48e12c2dcb(meta) {
    const input = (0, $am4TS.ref)({});
    (0, $esfUo.watchEffect)(()=>{
        input.value = (0, $1ZeEE.unpackMeta)((0, $4PQtJ.r)(meta));
    });
    return (0, $4PQtJ.u)({
        meta: input
    });
}
function $dff303e66c9999bd$export$c09da45034302c3f(link) {
    return (0, $4PQtJ.u)({
        link: (0, $cHHQH.asArray)(link)
    });
}
function $dff303e66c9999bd$export$346d223623de6726(script) {
    return (0, $4PQtJ.u)({
        script: (0, $cHHQH.asArray)(script)
    });
}
function $dff303e66c9999bd$export$d6858bbd4790113c(style) {
    return (0, $4PQtJ.u)({
        style: (0, $cHHQH.asArray)(style)
    });
}
function $dff303e66c9999bd$export$4e2399d6f63d4705(noscript) {
    return (0, $4PQtJ.u)({
        noscript: (0, $cHHQH.asArray)(noscript)
    });
}
function $dff303e66c9999bd$export$bf4c0fc0d3d2028(base) {
    return (0, $4PQtJ.u)({
        base: base
    });
}
function $dff303e66c9999bd$export$fddbdf3009bfd57(attrs) {
    return (0, $4PQtJ.u)({
        htmlAttrs: attrs
    });
}
function $dff303e66c9999bd$export$27a1a43657db1fb4(attrs) {
    return (0, $4PQtJ.u)({
        bodyAttrs: attrs
    });
}
function $dff303e66c9999bd$export$a49a916c914ae380(title) {
    return $dff303e66c9999bd$export$f0462339a176e133({
        title: title
    });
}
function $dff303e66c9999bd$export$f4150f3a43754e8f(titleTemplate) {
    return $dff303e66c9999bd$export$f0462339a176e133({
        titleTemplate: titleTemplate
    });
}
function $dff303e66c9999bd$export$6508418b9e6dbae7(meta) {
    return $dff303e66c9999bd$export$f0462339a176e133({
        meta: (0, $cHHQH.asArray)(meta)
    });
}
function $dff303e66c9999bd$export$ba54faf3e9f2c76a(meta) {
    const input = (0, $am4TS.ref)({});
    (0, $esfUo.watchEffect)(()=>{
        input.value = (0, $1ZeEE.unpackMeta)((0, $4PQtJ.r)(meta));
    });
    return $dff303e66c9999bd$export$f0462339a176e133({
        meta: input
    });
}
function $dff303e66c9999bd$export$110973b572fab194(link) {
    return $dff303e66c9999bd$export$f0462339a176e133({
        link: (0, $cHHQH.asArray)(link)
    });
}
function $dff303e66c9999bd$export$f6f7b9bddd3037f0(script) {
    return $dff303e66c9999bd$export$f0462339a176e133({
        script: (0, $cHHQH.asArray)(script)
    });
}
function $dff303e66c9999bd$export$7ee75b87ace5c385(style) {
    return $dff303e66c9999bd$export$f0462339a176e133({
        style: (0, $cHHQH.asArray)(style)
    });
}
function $dff303e66c9999bd$export$7db0e7837d4c8952(noscript) {
    return $dff303e66c9999bd$export$f0462339a176e133({
        noscript: (0, $cHHQH.asArray)(noscript)
    });
}
function $dff303e66c9999bd$export$16d5a23c3a211119(base) {
    return $dff303e66c9999bd$export$f0462339a176e133({
        base: base
    });
}
function $dff303e66c9999bd$export$bfad714deb19c4a7(attrs) {
    return $dff303e66c9999bd$export$f0462339a176e133({
        htmlAttrs: attrs
    });
}
function $dff303e66c9999bd$export$b0276c2f86ed98a6(attrs) {
    return (0, $4PQtJ.u)({
        bodyAttrs: attrs
    });
}
const $dff303e66c9999bd$var$coreComposableNames = [
    "injectHead"
];
const $dff303e66c9999bd$export$b15adce96ca46f01 = {
    "@unhead/vue": [
        ...$dff303e66c9999bd$var$coreComposableNames,
        ...(0, $1ZeEE.composableNames)
    ]
};

});
parcelRegister("1ZeEE", function(module, exports) {

$parcel$export(module.exports, "getActiveHead", function () { return $7911134eb44f243e$export$3e27d2333d50ff97; });
$parcel$export(module.exports, "whitelistSafeInput", function () { return $7911134eb44f243e$export$ea383fee2ff14773; });
$parcel$export(module.exports, "unpackMeta", function () { return $7911134eb44f243e$export$6e43afe40d816a2; });
$parcel$export(module.exports, "createHead", function () { return $7911134eb44f243e$export$b87bd21e0602bd96; });
$parcel$export(module.exports, "createServerHead", function () { return $7911134eb44f243e$export$ec9e942f80c1a308; });
$parcel$export(module.exports, "composableNames", function () { return $7911134eb44f243e$export$7ba4dee55662e312; });

var $bAcqe = parcelRequire("bAcqe");

var $kNcBH = parcelRequire("kNcBH");

var $cHHQH = parcelRequire("cHHQH");
const $7911134eb44f243e$export$eb9bd52feab3814b = {
    // tags
    base: -1,
    title: 1
};
const $7911134eb44f243e$export$62ab732ac8faddab = {
    // relative scores to their default values
    critical: -8,
    high: -1,
    low: 2
};
function $7911134eb44f243e$export$10379d77e1a3ac37(tag) {
    let weight = 10;
    const priority = tag.tagPriority;
    if (typeof priority === "number") return priority;
    if (tag.tag === "meta") {
        if (tag.props.charset) weight = -2;
        if (tag.props["http-equiv"] === "content-security-policy") weight = 0;
    } else if (tag.tag in $7911134eb44f243e$export$eb9bd52feab3814b) weight = $7911134eb44f243e$export$eb9bd52feab3814b[tag.tag];
    if (typeof priority === "string" && priority in $7911134eb44f243e$export$62ab732ac8faddab) return weight + $7911134eb44f243e$export$62ab732ac8faddab[priority];
    return weight;
}
const $7911134eb44f243e$export$41925d1300244487 = [
    {
        prefix: "before:",
        offset: -1
    },
    {
        prefix: "after:",
        offset: 1
    }
];
function $7911134eb44f243e$export$d2400ce037511efe() {
    return (0, $cHHQH.defineHeadPlugin)({
        hooks: {
            "tags:resolve": (ctx)=>{
                const tagPositionForKey = (key)=>{
                    var _ctx_tags_find;
                    return (_ctx_tags_find = ctx.tags.find((tag)=>tag._d === key)) === null || _ctx_tags_find === void 0 ? void 0 : _ctx_tags_find._p;
                };
                for (const { prefix: prefix, offset: offset } of $7911134eb44f243e$export$41925d1300244487)for (const tag of ctx.tags.filter((tag2)=>typeof tag2.tagPriority === "string" && tag2.tagPriority.startsWith(prefix))){
                    const position = tagPositionForKey(tag.tagPriority.replace(prefix, ""));
                    if (typeof position !== "undefined") tag._p = position + offset;
                }
                ctx.tags.sort((a, b)=>a._p - b._p).sort((a, b)=>$7911134eb44f243e$export$10379d77e1a3ac37(a) - $7911134eb44f243e$export$10379d77e1a3ac37(b));
            }
        }
    });
}
function $7911134eb44f243e$export$abe40b42dde2c43b() {
    return (0, $cHHQH.defineHeadPlugin)({
        hooks: {
            "tags:resolve": (ctx)=>{
                const { tags: tags } = ctx;
                let titleTemplateIdx = tags.findIndex((i)=>i.tag === "titleTemplate");
                const titleIdx = tags.findIndex((i)=>i.tag === "title");
                if (titleIdx !== -1 && titleTemplateIdx !== -1) {
                    const newTitle = (0, $cHHQH.resolveTitleTemplate)(tags[titleTemplateIdx].textContent, tags[titleIdx].textContent);
                    if (newTitle !== null) tags[titleIdx].textContent = newTitle || tags[titleIdx].textContent;
                    else delete tags[titleIdx];
                } else if (titleTemplateIdx !== -1) {
                    const newTitle = (0, $cHHQH.resolveTitleTemplate)(tags[titleTemplateIdx].textContent);
                    if (newTitle !== null) {
                        tags[titleTemplateIdx].textContent = newTitle;
                        tags[titleTemplateIdx].tag = "title";
                        titleTemplateIdx = -1;
                    }
                }
                if (titleTemplateIdx !== -1) delete tags[titleTemplateIdx];
                ctx.tags = tags.filter(Boolean);
            }
        }
    });
}
function $7911134eb44f243e$export$37c6adce760d5784() {
    return (0, $cHHQH.defineHeadPlugin)({
        hooks: {
            "tag:normalise": function({ tag: tag }) {
                if (typeof tag.props.body !== "undefined") {
                    tag.tagPosition = "bodyClose";
                    delete tag.props.body;
                }
            }
        }
    });
}
const $7911134eb44f243e$var$DupeableTags = [
    "link",
    "style",
    "script",
    "noscript"
];
function $7911134eb44f243e$export$acb282d94c4320bd() {
    return (0, $cHHQH.defineHeadPlugin)({
        hooks: {
            "tag:normalise": ({ tag: tag, resolvedOptions: resolvedOptions })=>{
                if (resolvedOptions.experimentalHashHydration === true) tag._h = (0, $cHHQH.hashTag)(tag);
                if (tag.key && $7911134eb44f243e$var$DupeableTags.includes(tag.tag)) {
                    tag._h = (0, $cHHQH.hashCode)(tag.key);
                    tag.props[`data-h-${tag._h}`] = "";
                }
            }
        }
    });
}
const $7911134eb44f243e$var$ValidEventTags = [
    "script",
    "link",
    "bodyAttrs"
];
function $7911134eb44f243e$export$d8935ef140f38f69() {
    const stripEventHandlers = (mode, tag)=>{
        const props = {};
        const eventHandlers = {};
        Object.entries(tag.props).forEach(([key, value])=>{
            if (key.startsWith("on") && typeof value === "function") eventHandlers[key] = value;
            else props[key] = value;
        });
        let delayedSrc;
        if (mode === "dom" && tag.tag === "script" && typeof props.src === "string" && typeof eventHandlers.onload !== "undefined") {
            delayedSrc = props.src;
            delete props.src;
        }
        return {
            props: props,
            eventHandlers: eventHandlers,
            delayedSrc: delayedSrc
        };
    };
    return (0, $cHHQH.defineHeadPlugin)({
        hooks: {
            "ssr:render": function(ctx) {
                ctx.tags = ctx.tags.map((tag)=>{
                    if (!$7911134eb44f243e$var$ValidEventTags.includes(tag.tag)) return tag;
                    if (!Object.entries(tag.props).find(([key, value])=>key.startsWith("on") && typeof value === "function")) return tag;
                    tag.props = stripEventHandlers("ssr", tag).props;
                    return tag;
                });
            },
            "dom:beforeRenderTag": function(ctx) {
                if (!$7911134eb44f243e$var$ValidEventTags.includes(ctx.tag.tag)) return;
                if (!Object.entries(ctx.tag.props).find(([key, value])=>key.startsWith("on") && typeof value === "function")) return;
                const { props: props, eventHandlers: eventHandlers, delayedSrc: delayedSrc } = stripEventHandlers("dom", ctx.tag);
                if (!Object.keys(eventHandlers).length) return;
                ctx.tag.props = props;
                ctx.tag._eventHandlers = eventHandlers;
                ctx.tag._delayedSrc = delayedSrc;
            },
            "dom:renderTag": function(ctx) {
                const $el = ctx.$el;
                if (!ctx.tag._eventHandlers || !$el) return;
                const $eventListenerTarget = ctx.tag.tag === "bodyAttrs" && typeof window !== "undefined" ? window : $el;
                Object.entries(ctx.tag._eventHandlers).forEach(([k, value])=>{
                    const sdeKey = `${ctx.tag._d || ctx.tag._p}:${k}`;
                    const eventName = k.slice(2).toLowerCase();
                    const eventDedupeKey = `data-h-${eventName}`;
                    ctx.markSideEffect(sdeKey, ()=>{});
                    if ($el.hasAttribute(eventDedupeKey)) return;
                    const handler = value;
                    $el.setAttribute(eventDedupeKey, "");
                    $eventListenerTarget.addEventListener(eventName, handler);
                    if (ctx.entry) ctx.entry._sde[sdeKey] = ()=>{
                        $eventListenerTarget.removeEventListener(eventName, handler);
                        $el.removeAttribute(eventDedupeKey);
                    };
                });
                if (ctx.tag._delayedSrc) $el.setAttribute("src", ctx.tag._delayedSrc);
            }
        }
    });
}
const $7911134eb44f243e$var$UsesMergeStrategy = [
    "templateParams",
    "htmlAttrs",
    "bodyAttrs"
];
function $7911134eb44f243e$export$a99256fcf65008fc() {
    return (0, $cHHQH.defineHeadPlugin)({
        hooks: {
            "tag:normalise": function({ tag: tag }) {
                [
                    "hid",
                    "vmid",
                    "key"
                ].forEach((key)=>{
                    if (tag.props[key]) {
                        tag.key = tag.props[key];
                        delete tag.props[key];
                    }
                });
                const generatedKey = (0, $cHHQH.tagDedupeKey)(tag);
                const dedupe = generatedKey || (tag.key ? `${tag.tag}:${tag.key}` : false);
                if (dedupe) tag._d = dedupe;
            },
            "tags:resolve": function(ctx) {
                const deduping = {};
                ctx.tags.forEach((tag)=>{
                    const dedupeKey = (tag.key ? `${tag.tag}:${tag.key}` : tag._d) || tag._p;
                    const dupedTag = deduping[dedupeKey];
                    if (dupedTag) {
                        let strategy = tag === null || tag === void 0 ? void 0 : tag.tagDuplicateStrategy;
                        if (!strategy && $7911134eb44f243e$var$UsesMergeStrategy.includes(tag.tag)) strategy = "merge";
                        if (strategy === "merge") {
                            const oldProps = dupedTag.props;
                            [
                                "class",
                                "style"
                            ].forEach((key)=>{
                                if (tag.props[key] && oldProps[key]) {
                                    if (key === "style" && !oldProps[key].endsWith(";")) oldProps[key] += ";";
                                    tag.props[key] = `${oldProps[key]} ${tag.props[key]}`;
                                }
                            });
                            deduping[dedupeKey].props = {
                                ...oldProps,
                                ...tag.props
                            };
                            return;
                        } else if (tag._e === dupedTag._e) {
                            dupedTag._duped = dupedTag._duped || [];
                            tag._d = `${dupedTag._d}:${dupedTag._duped.length + 1}`;
                            dupedTag._duped.push(tag);
                            return;
                        } else if ($7911134eb44f243e$export$10379d77e1a3ac37(tag) > $7911134eb44f243e$export$10379d77e1a3ac37(dupedTag)) return;
                    }
                    const propCount = Object.keys(tag.props).length + (tag.innerHTML ? 1 : 0) + (tag.textContent ? 1 : 0);
                    if ((0, $cHHQH.HasElementTags).includes(tag.tag) && propCount === 0) {
                        delete deduping[dedupeKey];
                        return;
                    }
                    deduping[dedupeKey] = tag;
                });
                const newTags = [];
                Object.values(deduping).forEach((tag)=>{
                    const dupes = tag._duped;
                    delete tag._duped;
                    newTags.push(tag);
                    if (dupes) newTags.push(...dupes);
                });
                ctx.tags = newTags;
            }
        }
    });
}
function $7911134eb44f243e$export$c4bbe208d56e9566(s, config) {
    function sub(token) {
        if ([
            "s",
            "pageTitle"
        ].includes(token)) return config.pageTitle;
        let val;
        if (token.includes(".")) val = token.split(".").reduce((acc, key)=>acc ? acc[key] || void 0 : void 0, config);
        else val = config[token];
        return typeof val !== "undefined" ? val || "" : false;
    }
    let decoded = s;
    try {
        decoded = decodeURI(s);
    } catch  {}
    const tokens = (decoded.match(/%(\w+\.+\w+)|%(\w+)/g) || []).sort().reverse();
    tokens.forEach((token)=>{
        const re = sub(token.slice(1));
        if (typeof re === "string") s = s.replace(new RegExp(`\\${token}(\\W|$)`, "g"), `${re}$1`).trim();
    });
    if (config.separator) {
        if (s.endsWith(config.separator)) s = s.slice(0, -config.separator.length).trim();
        if (s.startsWith(config.separator)) s = s.slice(config.separator.length).trim();
        s = s.replace(new RegExp(`\\${config.separator}\\s*\\${config.separator}`, "g"), config.separator);
    }
    return s;
}
function $7911134eb44f243e$export$f4ff9d0be7b60b02() {
    return (0, $cHHQH.defineHeadPlugin)({
        hooks: {
            "tags:resolve": (ctx)=>{
                var _tags_find;
                const { tags: tags } = ctx;
                const title = (_tags_find = tags.find((tag)=>tag.tag === "title")) === null || _tags_find === void 0 ? void 0 : _tags_find.textContent;
                const idx = tags.findIndex((tag)=>tag.tag === "templateParams");
                const params = idx !== -1 ? tags[idx].props : {};
                params.pageTitle = params.pageTitle || title || "";
                for (const tag of tags){
                    if ([
                        "titleTemplate",
                        "title"
                    ].includes(tag.tag) && typeof tag.textContent === "string") tag.textContent = $7911134eb44f243e$export$c4bbe208d56e9566(tag.textContent, params);
                    else if (tag.tag === "meta" && typeof tag.props.content === "string") tag.props.content = $7911134eb44f243e$export$c4bbe208d56e9566(tag.props.content, params);
                    else if (tag.tag === "link" && typeof tag.props.href === "string") tag.props.href = $7911134eb44f243e$export$c4bbe208d56e9566(tag.props.href, params);
                    else if (tag.tag === "script" && [
                        "application/json",
                        "application/ld+json"
                    ].includes(tag.props.type) && typeof tag.innerHTML === "string") try {
                        tag.innerHTML = JSON.stringify(JSON.parse(tag.innerHTML), (key, val)=>{
                            if (typeof val === "string") return $7911134eb44f243e$export$c4bbe208d56e9566(val, params);
                            return val;
                        });
                    } catch  {}
                }
                ctx.tags = tags.filter((tag)=>tag.tag !== "templateParams");
            }
        }
    });
}
const $7911134eb44f243e$var$IsBrowser = typeof window !== "undefined";
let $7911134eb44f243e$export$38a70a74175e02f5;
function $7911134eb44f243e$export$7b6ce1173bcfcb3b(head) {
    return $7911134eb44f243e$export$38a70a74175e02f5 = head;
}
function $7911134eb44f243e$export$3e27d2333d50ff97() {
    return $7911134eb44f243e$export$38a70a74175e02f5;
}
function $7911134eb44f243e$export$b4700892323c0caf(input, options = {}) {
    const head = $7911134eb44f243e$export$3e27d2333d50ff97();
    if (head) {
        var _head_resolvedOptions;
        const isBrowser = $7911134eb44f243e$var$IsBrowser || ((_head_resolvedOptions = head.resolvedOptions) === null || _head_resolvedOptions === void 0 ? void 0 : _head_resolvedOptions.document);
        if (options.mode === "server" && isBrowser || options.mode === "client" && !isBrowser) return;
        return head.push(input, options);
    }
}
function $7911134eb44f243e$export$f1e6716961cde60d(input, options = {}) {
    return $7911134eb44f243e$export$b4700892323c0caf(input, {
        ...options || {},
        transform: $7911134eb44f243e$export$ea383fee2ff14773
    });
}
function $7911134eb44f243e$export$f0462339a176e133(input, options = {}) {
    return $7911134eb44f243e$export$b4700892323c0caf(input, {
        ...options,
        mode: "server"
    });
}
function $7911134eb44f243e$export$4f19bd43f7a50bae(input, options = {}) {
    return $7911134eb44f243e$export$f1e6716961cde60d(input, {
        ...options,
        mode: "server"
    });
}
function $7911134eb44f243e$export$5634b39f93cf91fe(input, options) {
    const { title: title, titleTemplate: titleTemplate, ...meta } = input;
    return $7911134eb44f243e$export$b4700892323c0caf({
        title: title,
        titleTemplate: titleTemplate,
        meta: $7911134eb44f243e$export$6e43afe40d816a2(meta)
    }, options);
}
function $7911134eb44f243e$export$12a3b0ba181293b3(input, options) {
    return $7911134eb44f243e$export$5634b39f93cf91fe(input, {
        ...options || {},
        mode: "server"
    });
}
function $7911134eb44f243e$export$c37d4b9b1414299e(title) {
    return $7911134eb44f243e$export$b4700892323c0caf({
        title: title
    });
}
function $7911134eb44f243e$export$bf4c0fc0d3d2028(base) {
    return $7911134eb44f243e$export$b4700892323c0caf({
        base: base
    });
}
function $7911134eb44f243e$export$650b09068ff5d230(meta) {
    return $7911134eb44f243e$export$b4700892323c0caf({
        meta: (0, $cHHQH.asArray)(meta)
    });
}
function $7911134eb44f243e$export$8129fe48e12c2dcb(meta) {
    return $7911134eb44f243e$export$650b09068ff5d230($7911134eb44f243e$export$6e43afe40d816a2(meta));
}
function $7911134eb44f243e$export$c09da45034302c3f(link) {
    return $7911134eb44f243e$export$b4700892323c0caf({
        link: (0, $cHHQH.asArray)(link)
    });
}
function $7911134eb44f243e$export$346d223623de6726(script) {
    return $7911134eb44f243e$export$b4700892323c0caf({
        script: (0, $cHHQH.asArray)(script)
    });
}
function $7911134eb44f243e$export$d6858bbd4790113c(style) {
    return $7911134eb44f243e$export$b4700892323c0caf({
        style: (0, $cHHQH.asArray)(style)
    });
}
function $7911134eb44f243e$export$4e2399d6f63d4705(noscript) {
    return $7911134eb44f243e$export$b4700892323c0caf({
        noscript: (0, $cHHQH.asArray)(noscript)
    });
}
function $7911134eb44f243e$export$fddbdf3009bfd57(attrs) {
    return $7911134eb44f243e$export$b4700892323c0caf({
        htmlAttrs: attrs
    });
}
function $7911134eb44f243e$export$27a1a43657db1fb4(attrs) {
    return $7911134eb44f243e$export$b4700892323c0caf({
        bodyAttrs: attrs
    });
}
function $7911134eb44f243e$export$636cb0babb2895e6(titleTemplate) {
    return $7911134eb44f243e$export$b4700892323c0caf({
        titleTemplate: titleTemplate
    });
}
function $7911134eb44f243e$export$a49a916c914ae380(title) {
    return $7911134eb44f243e$export$f0462339a176e133({
        title: title
    });
}
function $7911134eb44f243e$export$16d5a23c3a211119(base) {
    return $7911134eb44f243e$export$f0462339a176e133({
        base: base
    });
}
function $7911134eb44f243e$export$6508418b9e6dbae7(meta) {
    return $7911134eb44f243e$export$f0462339a176e133({
        meta: (0, $cHHQH.asArray)(meta)
    });
}
function $7911134eb44f243e$export$ba54faf3e9f2c76a(meta) {
    return $7911134eb44f243e$export$6508418b9e6dbae7($7911134eb44f243e$export$6e43afe40d816a2(meta));
}
function $7911134eb44f243e$export$110973b572fab194(link) {
    return $7911134eb44f243e$export$f0462339a176e133({
        link: (0, $cHHQH.asArray)(link)
    });
}
function $7911134eb44f243e$export$f6f7b9bddd3037f0(script) {
    return $7911134eb44f243e$export$f0462339a176e133({
        script: (0, $cHHQH.asArray)(script)
    });
}
function $7911134eb44f243e$export$7ee75b87ace5c385(style) {
    return $7911134eb44f243e$export$f0462339a176e133({
        style: (0, $cHHQH.asArray)(style)
    });
}
function $7911134eb44f243e$export$7db0e7837d4c8952(noscript) {
    return $7911134eb44f243e$export$f0462339a176e133({
        noscript: (0, $cHHQH.asArray)(noscript)
    });
}
function $7911134eb44f243e$export$bfad714deb19c4a7(attrs) {
    return $7911134eb44f243e$export$f0462339a176e133({
        htmlAttrs: attrs
    });
}
function $7911134eb44f243e$export$b0276c2f86ed98a6(attrs) {
    return $7911134eb44f243e$export$f0462339a176e133({
        bodyAttrs: attrs
    });
}
function $7911134eb44f243e$export$f4150f3a43754e8f(titleTemplate) {
    return $7911134eb44f243e$export$f0462339a176e133({
        titleTemplate: titleTemplate
    });
}
function $7911134eb44f243e$var$asArray(input) {
    return Array.isArray(input) ? input : [
        input
    ];
}
const $7911134eb44f243e$var$InternalKeySymbol = "_$key";
function $7911134eb44f243e$var$packObject(input, options) {
    const keys = Object.keys(input);
    let [k, v] = keys;
    options = options || {};
    options.key = options.key || k;
    options.value = options.value || v;
    options.resolveKey = options.resolveKey || ((k2)=>k2);
    const resolveKey = (index)=>{
        const arr = $7911134eb44f243e$var$asArray(options === null || options === void 0 ? void 0 : options[index]);
        return arr.find((k2)=>{
            if (typeof k2 === "string" && k2.includes(".")) return k2;
            return k2 && keys.includes(k2);
        });
    };
    const resolveValue = (k2, input2)=>{
        if (k2.includes(".")) {
            const paths = k2.split(".");
            let val = input2;
            for (const path of paths)val = val[path];
            return val;
        }
        return input2[k2];
    };
    k = resolveKey("key") || k;
    v = resolveKey("value") || v;
    const dedupeKeyPrefix = input.key ? `${$7911134eb44f243e$var$InternalKeySymbol}${input.key}-` : "";
    let keyValue = resolveValue(k, input);
    keyValue = options.resolveKey(keyValue);
    return {
        [`${dedupeKeyPrefix}${keyValue}`]: resolveValue(v, input)
    };
}
function $7911134eb44f243e$var$packArray(input, options) {
    const packed = {};
    for (const i of input){
        const packedObj = $7911134eb44f243e$var$packObject(i, options);
        const pKey = Object.keys(packedObj)[0];
        const isDedupeKey = pKey.startsWith($7911134eb44f243e$var$InternalKeySymbol);
        if (!isDedupeKey && packed[pKey]) {
            packed[pKey] = Array.isArray(packed[pKey]) ? packed[pKey] : [
                packed[pKey]
            ];
            packed[pKey].push(Object.values(packedObj)[0]);
        } else packed[isDedupeKey ? pKey.split("-").slice(1).join("-") || pKey : pKey] = packedObj[pKey];
    }
    return packed;
}
function $7911134eb44f243e$var$unpackToArray(input, options) {
    const unpacked = [];
    const kFn = options.resolveKeyData || ((ctx)=>ctx.key);
    const vFn = options.resolveValueData || ((ctx)=>ctx.value);
    for (const [k, v] of Object.entries(input))unpacked.push(...(Array.isArray(v) ? v : [
        v
    ]).map((i)=>{
        const ctx = {
            key: k,
            value: i
        };
        const val = vFn(ctx);
        if (typeof val === "object") return $7911134eb44f243e$var$unpackToArray(val, options);
        if (Array.isArray(val)) return val;
        return {
            [typeof options.key === "function" ? options.key(ctx) : options.key]: kFn(ctx),
            [typeof options.value === "function" ? options.value(ctx) : options.value]: val
        };
    }).flat());
    return unpacked;
}
function $7911134eb44f243e$var$unpackToString(value, options) {
    return Object.entries(value).map(([key, value2])=>{
        if (typeof value2 === "object") value2 = $7911134eb44f243e$var$unpackToString(value2, options);
        if (options.resolve) {
            const resolved = options.resolve({
                key: key,
                value: value2
            });
            if (resolved) return resolved;
        }
        if (typeof value2 === "number") value2 = value2.toString();
        if (typeof value2 === "string" && options.wrapValue) {
            value2 = value2.replace(new RegExp(options.wrapValue, "g"), `\\${options.wrapValue}`);
            value2 = `${options.wrapValue}${value2}${options.wrapValue}`;
        }
        return `${key}${options.keyValueSeparator || ""}${value2}`;
    }).join(options.entrySeparator || "");
}
const $7911134eb44f243e$var$MetaPackingSchema = {
    robots: {
        unpack: {
            keyValueSeparator: ":"
        }
    },
    // Pragma directives
    contentSecurityPolicy: {
        unpack: {
            keyValueSeparator: " ",
            entrySeparator: "; "
        },
        metaKey: "http-equiv"
    },
    fbAppId: {
        keyValue: "fb:app_id",
        metaKey: "property"
    },
    ogSiteName: {
        keyValue: "og:site_name"
    },
    msapplicationTileImage: {
        keyValue: "msapplication-TileImage"
    },
    /**
   * Tile colour for windows
   */ msapplicationTileColor: {
        keyValue: "msapplication-TileColor"
    },
    /**
   * URL of a config for windows tile.
   */ msapplicationConfig: {
        keyValue: "msapplication-Config"
    },
    charset: {
        metaKey: "charset"
    },
    contentType: {
        metaKey: "http-equiv"
    },
    defaultStyle: {
        metaKey: "http-equiv"
    },
    xUaCompatible: {
        metaKey: "http-equiv"
    },
    refresh: {
        metaKey: "http-equiv"
    }
};
function $7911134eb44f243e$export$f6d5301994665c55(inputs) {
    const mappedPackingSchema = Object.entries($7911134eb44f243e$var$MetaPackingSchema).map(([key, value])=>[
            key,
            value.keyValue
        ]);
    return $7911134eb44f243e$var$packArray(inputs, {
        key: [
            "name",
            "property",
            "httpEquiv",
            "http-equiv",
            "charset"
        ],
        value: [
            "content",
            "charset"
        ],
        resolveKey (k) {
            var _mappedPackingSchema_filter_, _mappedPackingSchema_filter;
            let key = ((_mappedPackingSchema_filter = mappedPackingSchema.filter((sk)=>sk[1] === k)) === null || _mappedPackingSchema_filter === void 0 ? void 0 : (_mappedPackingSchema_filter_ = _mappedPackingSchema_filter[0]) === null || _mappedPackingSchema_filter_ === void 0 ? void 0 : _mappedPackingSchema_filter_[0]) || k;
            const replacer = (_, letter)=>letter === null || letter === void 0 ? void 0 : letter.toUpperCase();
            key = key.replace(/:([a-z])/g, replacer).replace(/-([a-z])/g, replacer);
            return key;
        }
    });
}
const $7911134eb44f243e$var$OpenGraphInputs = [
    "Image",
    "Video",
    "Audio"
];
const $7911134eb44f243e$var$SimpleArrayUnpackMetas = [
    "themeColor"
];
const $7911134eb44f243e$var$ColonPrefixKeys = /^(og|twitter|fb)/;
const $7911134eb44f243e$var$PropertyPrefixKeys = /^(og|fb)/;
function $7911134eb44f243e$export$1d8ed01ac74d5608(key) {
    var _MetaPackingSchema_key;
    return $7911134eb44f243e$var$PropertyPrefixKeys.test(key) ? "property" : ((_MetaPackingSchema_key = $7911134eb44f243e$var$MetaPackingSchema[key]) === null || _MetaPackingSchema_key === void 0 ? void 0 : _MetaPackingSchema_key.metaKey) || "name";
}
function $7911134eb44f243e$export$7c3cf9f581d497e4(key) {
    var _MetaPackingSchema_key;
    return ((_MetaPackingSchema_key = $7911134eb44f243e$var$MetaPackingSchema[key]) === null || _MetaPackingSchema_key === void 0 ? void 0 : _MetaPackingSchema_key.keyValue) || $7911134eb44f243e$var$fixKeyCase(key);
}
function $7911134eb44f243e$var$fixKeyCase(key) {
    key = key.replace(/([A-Z])/g, "-$1").toLowerCase();
    if ($7911134eb44f243e$var$ColonPrefixKeys.test(key)) key = key.replace("secure-url", "secure_url").replace(/-/g, ":");
    return key;
}
function $7911134eb44f243e$var$changeKeyCasingDeep(input) {
    if (Array.isArray(input)) return input.map((entry)=>$7911134eb44f243e$var$changeKeyCasingDeep(entry));
    if (typeof input !== "object" || Array.isArray(input)) return input;
    const output = {};
    for (const [key, value] of Object.entries(input))output[$7911134eb44f243e$var$fixKeyCase(key)] = $7911134eb44f243e$var$changeKeyCasingDeep(value);
    return output;
}
function $7911134eb44f243e$export$6e43afe40d816a2(input) {
    const extras = [];
    $7911134eb44f243e$var$OpenGraphInputs.forEach((key)=>{
        const ogKey = `og:${key.toLowerCase()}`;
        const inputKey = `og${key}`;
        const val = input[inputKey];
        if (typeof val === "object") {
            (Array.isArray(val) ? val : [
                val
            ]).forEach((entry)=>{
                if (!entry) return;
                const unpackedEntry = $7911134eb44f243e$var$unpackToArray(entry, {
                    key: "property",
                    value: "content",
                    resolveKeyData ({ key: key2 }) {
                        return $7911134eb44f243e$var$fixKeyCase(`${ogKey}${key2 !== "url" ? `:${key2}` : ""}`);
                    },
                    resolveValueData ({ value: value }) {
                        return typeof value === "number" ? value.toString() : value;
                    }
                });
                extras.push(...unpackedEntry.sort((a, b)=>a.property === ogKey ? -1 : b.property === ogKey ? 1 : 0));
            });
            delete input[inputKey];
        }
    });
    $7911134eb44f243e$var$SimpleArrayUnpackMetas.forEach((meta2)=>{
        if (input[meta2]) {
            const val = Array.isArray(input[meta2]) ? input[meta2] : [
                input[meta2]
            ];
            delete input[meta2];
            val.forEach((entry)=>{
                extras.push({
                    name: $7911134eb44f243e$var$fixKeyCase(meta2),
                    ...entry
                });
            });
        }
    });
    const meta = $7911134eb44f243e$var$unpackToArray(input, {
        key ({ key: key }) {
            return $7911134eb44f243e$export$1d8ed01ac74d5608(key);
        },
        value ({ key: key }) {
            return key === "charset" ? "charset" : "content";
        },
        resolveKeyData ({ key: key }) {
            return $7911134eb44f243e$export$7c3cf9f581d497e4(key);
        },
        resolveValueData ({ value: value, key: key }) {
            if (value === null) return "_null";
            if (typeof value === "object") return $7911134eb44f243e$export$5ad0fe49bd34066e(value, key);
            return typeof value === "number" ? value.toString() : value;
        }
    });
    return [
        ...extras,
        ...meta
    ].filter((v)=>typeof v.content === "undefined" || v.content !== "_null");
}
function $7911134eb44f243e$export$5ad0fe49bd34066e(value, key) {
    const definition = $7911134eb44f243e$var$MetaPackingSchema[key];
    if (key === "refresh") return `${value.seconds};url=${value.url}`;
    return $7911134eb44f243e$var$unpackToString($7911134eb44f243e$var$changeKeyCasingDeep(value), {
        entrySeparator: ", ",
        keyValueSeparator: "=",
        resolve ({ value: value2, key: key2 }) {
            if (value2 === null) return "";
            if (typeof value2 === "boolean") return `${key2}`;
        },
        ...definition === null || definition === void 0 ? void 0 : definition.unpack
    });
}
async function $7911134eb44f243e$export$1e393e50010e5072(tagName, input) {
    const tag = {
        tag: tagName,
        props: {}
    };
    if (input instanceof Promise) input = await input;
    if (tagName === "templateParams") {
        tag.props = input;
        return tag;
    }
    if ([
        "title",
        "titleTemplate"
    ].includes(tagName)) {
        if (input && typeof input === "object") {
            tag.textContent = input.textContent;
            if (input.tagPriority) tag.tagPriority = input.tagPriority;
        } else tag.textContent = input;
        return tag;
    }
    if (typeof input === "string") {
        if (![
            "script",
            "noscript",
            "style"
        ].includes(tagName)) return false;
        if (tagName === "script" && (/^(https?:)?\/\//.test(input) || input.startsWith("/"))) tag.props.src = input;
        else tag.innerHTML = input;
        return tag;
    }
    tag.props = await $7911134eb44f243e$export$473215fa5865a004(tagName, {
        ...input
    });
    if (tag.props.children) tag.props.innerHTML = tag.props.children;
    delete tag.props.children;
    Object.keys(tag.props).filter((k)=>(0, $cHHQH.TagConfigKeys).includes(k)).forEach((k)=>{
        if (![
            "innerHTML",
            "textContent"
        ].includes(k) || (0, $cHHQH.TagsWithInnerContent).includes(tag.tag)) tag[k] = tag.props[k];
        delete tag.props[k];
    });
    [
        "innerHTML",
        "textContent"
    ].forEach((k)=>{
        if (tag.tag === "script" && typeof tag[k] === "string" && [
            "application/ld+json",
            "application/json"
        ].includes(tag.props.type)) try {
            tag[k] = JSON.parse(tag[k]);
        } catch (e) {
            tag[k] = "";
        }
        if (typeof tag[k] === "object") tag[k] = JSON.stringify(tag[k]);
    });
    if (tag.props.class) tag.props.class = $7911134eb44f243e$export$e13b17751eb3c226(tag.props.class);
    if (tag.props.content && Array.isArray(tag.props.content)) return tag.props.content.map((v)=>({
            ...tag,
            props: {
                ...tag.props,
                content: v
            }
        }));
    return tag;
}
function $7911134eb44f243e$export$e13b17751eb3c226(v) {
    if (typeof v === "object" && !Array.isArray(v)) v = Object.keys(v).filter((k)=>v[k]);
    return (Array.isArray(v) ? v.join(" ") : v).split(" ").filter((c)=>c.trim()).filter(Boolean).join(" ");
}
async function $7911134eb44f243e$export$473215fa5865a004(tagName, props) {
    for (const k of Object.keys(props)){
        const isDataKey = k.startsWith("data-");
        if (props[k] instanceof Promise) props[k] = await props[k];
        if (String(props[k]) === "true") props[k] = isDataKey ? "true" : "";
        else if (String(props[k]) === "false") {
            if (isDataKey) props[k] = "false";
            else delete props[k];
        }
    }
    return props;
}
const $7911134eb44f243e$export$ff923ea3ba93a23b = 10;
async function $7911134eb44f243e$export$fd36b5aaf0651b0c(e) {
    const tagPromises = [];
    Object.entries(e.resolvedInput).filter(([k, v])=>typeof v !== "undefined" && (0, $cHHQH.ValidHeadTags).includes(k)).forEach(([k, value])=>{
        const v = (0, $cHHQH.asArray)(value);
        tagPromises.push(...v.map((props)=>$7911134eb44f243e$export$1e393e50010e5072(k, props)).flat());
    });
    return (await Promise.all(tagPromises)).flat().filter(Boolean).map((t, i)=>{
        t._e = e._i;
        t._p = (e._i << $7911134eb44f243e$export$ff923ea3ba93a23b) + i;
        return t;
    });
}
const $7911134eb44f243e$var$WhitelistAttributes = {
    htmlAttrs: [
        "id",
        "class",
        "lang",
        "dir"
    ],
    bodyAttrs: [
        "id",
        "class"
    ],
    meta: [
        "id",
        "name",
        "property",
        "charset",
        "content"
    ],
    noscript: [
        "id",
        "textContent"
    ],
    script: [
        "id",
        "type",
        "textContent"
    ],
    link: [
        "id",
        "color",
        "crossorigin",
        "fetchpriority",
        "href",
        "hreflang",
        "imagesrcset",
        "imagesizes",
        "integrity",
        "media",
        "referrerpolicy",
        "rel",
        "sizes",
        "type"
    ]
};
function $7911134eb44f243e$export$ea383fee2ff14773(input) {
    const filtered = {};
    Object.keys(input).forEach((key)=>{
        const tagValue = input[key];
        if (!tagValue) return;
        switch(key){
            case "title":
            case "titleTemplate":
            case "templateParams":
                filtered[key] = tagValue;
                break;
            case "htmlAttrs":
            case "bodyAttrs":
                filtered[key] = {};
                $7911134eb44f243e$var$WhitelistAttributes[key].forEach((a)=>{
                    if (tagValue[a]) filtered[key][a] = tagValue[a];
                });
                Object.keys(tagValue || {}).filter((a)=>a.startsWith("data-")).forEach((a)=>{
                    filtered[key][a] = tagValue[a];
                });
                break;
            case "meta":
                if (Array.isArray(tagValue)) filtered[key] = tagValue.map((meta)=>{
                    const safeMeta = {};
                    $7911134eb44f243e$var$WhitelistAttributes.meta.forEach((key2)=>{
                        if (meta[key2] || key2.startsWith("data-")) safeMeta[key2] = meta[key2];
                    });
                    return safeMeta;
                }).filter((meta)=>Object.keys(meta).length > 0);
                break;
            case "link":
                if (Array.isArray(tagValue)) filtered[key] = tagValue.map((meta)=>{
                    const link = {};
                    $7911134eb44f243e$var$WhitelistAttributes.link.forEach((key2)=>{
                        const val = meta[key2];
                        if (key2 === "rel" && [
                            "stylesheet",
                            "canonical",
                            "modulepreload",
                            "prerender",
                            "preload",
                            "prefetch"
                        ].includes(val)) return;
                        if (key2 === "href") {
                            if (val.includes("javascript:") || val.includes("data:")) return;
                            link[key2] = val;
                        } else if (val || key2.startsWith("data-")) link[key2] = val;
                    });
                    return link;
                }).filter((link)=>Object.keys(link).length > 1 && !!link.rel);
                break;
            case "noscript":
                if (Array.isArray(tagValue)) filtered[key] = tagValue.map((meta)=>{
                    const noscript = {};
                    $7911134eb44f243e$var$WhitelistAttributes.noscript.forEach((key2)=>{
                        if (meta[key2] || key2.startsWith("data-")) noscript[key2] = meta[key2];
                    });
                    return noscript;
                }).filter((meta)=>Object.keys(meta).length > 0);
                break;
            case "script":
                if (Array.isArray(tagValue)) filtered[key] = tagValue.map((script)=>{
                    const safeScript = {};
                    $7911134eb44f243e$var$WhitelistAttributes.script.forEach((s)=>{
                        if (script[s] || s.startsWith("data-")) {
                            if (s === "textContent") try {
                                const jsonVal = typeof script[s] === "string" ? JSON.parse(script[s]) : script[s];
                                safeScript[s] = JSON.stringify(jsonVal, null, 0);
                            } catch (e) {}
                            else safeScript[s] = script[s];
                        }
                    });
                    return safeScript;
                }).filter((meta)=>Object.keys(meta).length > 0);
                break;
        }
    });
    return filtered;
}
function $7911134eb44f243e$export$7f202eec0f243156() {
    return [
        // dedupe needs to come first
        $7911134eb44f243e$export$a99256fcf65008fc(),
        $7911134eb44f243e$export$d2400ce037511efe(),
        $7911134eb44f243e$export$f4ff9d0be7b60b02(),
        $7911134eb44f243e$export$abe40b42dde2c43b(),
        $7911134eb44f243e$export$acb282d94c4320bd(),
        $7911134eb44f243e$export$d8935ef140f38f69(),
        $7911134eb44f243e$export$37c6adce760d5784()
    ];
}
function $7911134eb44f243e$export$ba7bfb26e0dfe00c(options = {}) {
    return [
        (0, $kNcBH.PatchDomOnEntryUpdatesPlugin)({
            document: options === null || options === void 0 ? void 0 : options.document,
            delayFn: options === null || options === void 0 ? void 0 : options.domDelayFn
        })
    ];
}
function $7911134eb44f243e$export$b87bd21e0602bd96(options = {}) {
    const head = $7911134eb44f243e$export$2b578d4af20cf01f({
        ...options,
        plugins: [
            ...$7911134eb44f243e$export$ba7bfb26e0dfe00c(options),
            ...(options === null || options === void 0 ? void 0 : options.plugins) || []
        ]
    });
    if (options.experimentalHashHydration && head.resolvedOptions.document) head._hash = (0, $kNcBH.maybeGetSSRHash)(head.resolvedOptions.document);
    $7911134eb44f243e$export$7b6ce1173bcfcb3b(head);
    return head;
}
function $7911134eb44f243e$export$ec9e942f80c1a308(options = {}) {
    const head = $7911134eb44f243e$export$2b578d4af20cf01f(options);
    $7911134eb44f243e$export$7b6ce1173bcfcb3b(head);
    return head;
}
function $7911134eb44f243e$export$2b578d4af20cf01f(options = {}) {
    let entries = [];
    let _sde = {};
    let _eid = 0;
    const hooks = (0, $bAcqe.createHooks)();
    if (options === null || options === void 0 ? void 0 : options.hooks) hooks.addHooks(options.hooks);
    options.plugins = [
        ...$7911134eb44f243e$export$7f202eec0f243156(),
        ...(options === null || options === void 0 ? void 0 : options.plugins) || []
    ];
    options.plugins.forEach((p)=>p.hooks && hooks.addHooks(p.hooks));
    options.document = options.document || ($7911134eb44f243e$var$IsBrowser ? document : void 0);
    const updated = ()=>hooks.callHook("entries:updated", head);
    const head = {
        resolvedOptions: options,
        headEntries () {
            return entries;
        },
        get hooks () {
            return hooks;
        },
        use (plugin) {
            if (plugin.hooks) hooks.addHooks(plugin.hooks);
        },
        push (input, options2) {
            const activeEntry = {
                _i: _eid++,
                input: input,
                _sde: {}
            };
            if (options2 === null || options2 === void 0 ? void 0 : options2.mode) activeEntry._m = options2 === null || options2 === void 0 ? void 0 : options2.mode;
            if (options2 === null || options2 === void 0 ? void 0 : options2.transform) activeEntry._t = options2 === null || options2 === void 0 ? void 0 : options2.transform;
            entries.push(activeEntry);
            updated();
            return {
                dispose () {
                    entries = entries.filter((e)=>{
                        if (e._i !== activeEntry._i) return true;
                        _sde = {
                            ..._sde,
                            ...e._sde || {}
                        };
                        e._sde = {};
                        updated();
                        return false;
                    });
                },
                // a patch is the same as creating a new entry, just a nice DX
                patch (input2) {
                    entries = entries.map((e)=>{
                        if (e._i === activeEntry._i) {
                            activeEntry.input = e.input = input2;
                            updated();
                        }
                        return e;
                    });
                }
            };
        },
        async resolveTags () {
            const resolveCtx = {
                tags: [],
                entries: [
                    ...entries
                ]
            };
            await hooks.callHook("entries:resolve", resolveCtx);
            for (const entry of resolveCtx.entries){
                const transformer = entry._t || ((i)=>i);
                entry.resolvedInput = transformer(entry.resolvedInput || entry.input);
                if (entry.resolvedInput) for (const tag of (await $7911134eb44f243e$export$fd36b5aaf0651b0c(entry))){
                    const tagCtx = {
                        tag: tag,
                        entry: entry,
                        resolvedOptions: head.resolvedOptions
                    };
                    await hooks.callHook("tag:normalise", tagCtx);
                    resolveCtx.tags.push(tagCtx.tag);
                }
            }
            await hooks.callHook("tags:resolve", resolveCtx);
            return resolveCtx.tags;
        },
        _popSideEffectQueue () {
            const sde = {
                ..._sde
            };
            _sde = {};
            return sde;
        },
        _elMap: {}
    };
    head.hooks.callHook("init", head);
    return head;
}
const $7911134eb44f243e$var$coreComposableNames = [
    "getActiveHead"
];
const $7911134eb44f243e$export$7ba4dee55662e312 = [
    "useHead",
    "useSeoMeta",
    "useHeadSafe",
    "useServerHead",
    "useServerSeoMeta",
    "useServerHeadSafe",
    // deprecated
    "useTagTitle",
    "useTagBase",
    "useTagMeta",
    "useTagMetaFlat",
    "useTagLink",
    "useTagScript",
    "useTagStyle",
    "useTagNoscript",
    "useHtmlAttrs",
    "useBodyAttrs",
    "useTitleTemplate",
    "useServerTagTitle",
    "useServerTagBase",
    "useServerTagMeta",
    "useServerTagMetaFlat",
    "useServerTagLink",
    "useServerTagScript",
    "useServerTagStyle",
    "useServerTagNoscript",
    "useServerHtmlAttrs",
    "useServerBodyAttrs",
    "useServerTitleTemplate"
];
const $7911134eb44f243e$export$6d85adeefec67fa9 = [
    {
        from: "unhead",
        imports: [
            ...$7911134eb44f243e$var$coreComposableNames,
            ...$7911134eb44f243e$export$7ba4dee55662e312
        ]
    }
];

});
parcelRegister("bAcqe", function(module, exports) {

$parcel$export(module.exports, "createHooks", function () { return $1d08a6e6d888c780$export$39c6a2b4dbabca5d; });
function $1d08a6e6d888c780$export$9089e2fc8ae509cd(configHooks, hooks = {}, parentName) {
    for(const key in configHooks){
        const subHook = configHooks[key];
        const name = parentName ? `${parentName}:${key}` : key;
        if (typeof subHook === "object" && subHook !== null) $1d08a6e6d888c780$export$9089e2fc8ae509cd(subHook, hooks, name);
        else if (typeof subHook === "function") hooks[name] = subHook;
    }
    return hooks;
}
function $1d08a6e6d888c780$export$3de1ffbf114b9f2d(...hooks) {
    const finalHooks = {};
    for (const hook of hooks){
        const flatenHook = $1d08a6e6d888c780$export$9089e2fc8ae509cd(hook);
        for(const key in flatenHook)if (finalHooks[key]) finalHooks[key].push(flatenHook[key]);
        else finalHooks[key] = [
            flatenHook[key]
        ];
    }
    for(const key in finalHooks)if (finalHooks[key].length > 1) {
        const array = finalHooks[key];
        finalHooks[key] = (...arguments_)=>$1d08a6e6d888c780$export$6c2c9a00e27c07e8(array, (function_)=>function_(...arguments_));
    } else finalHooks[key] = finalHooks[key][0];
    return finalHooks;
}
function $1d08a6e6d888c780$export$6c2c9a00e27c07e8(tasks, function_) {
    return tasks.reduce((promise, task)=>promise.then(()=>function_(task)), Promise.resolve());
}
const $1d08a6e6d888c780$var$defaultTask = {
    run: (function_)=>function_()
};
const $1d08a6e6d888c780$var$_createTask = ()=>$1d08a6e6d888c780$var$defaultTask;
const $1d08a6e6d888c780$var$createTask = typeof console.createTask !== "undefined" ? console.createTask : $1d08a6e6d888c780$var$_createTask;
function $1d08a6e6d888c780$var$serialTaskCaller(hooks, args) {
    const name = args.shift();
    const task = $1d08a6e6d888c780$var$createTask(name);
    return hooks.reduce((promise, hookFunction)=>promise.then(()=>task.run(()=>hookFunction(...args))), Promise.resolve());
}
function $1d08a6e6d888c780$var$parallelTaskCaller(hooks, args) {
    const name = args.shift();
    const task = $1d08a6e6d888c780$var$createTask(name);
    return Promise.all(hooks.map((hook)=>task.run(()=>hook(...args))));
}
function $1d08a6e6d888c780$export$e1dd809e3137c513(hooks, arguments_) {
    return hooks.reduce((promise, hookFunction)=>promise.then(()=>hookFunction(...arguments_ || [])), Promise.resolve());
}
function $1d08a6e6d888c780$export$23b1f1c6efb4a44a(hooks, args) {
    return Promise.all(hooks.map((hook)=>hook(...args || [])));
}
function $1d08a6e6d888c780$var$callEachWith(callbacks, arg0) {
    for (const callback of [
        ...callbacks
    ])callback(arg0);
}
class $1d08a6e6d888c780$export$f26845e0fc859724 {
    hook(name, function_, options = {}) {
        if (!name || typeof function_ !== "function") return ()=>{};
        const originalName = name;
        let dep;
        while(this._deprecatedHooks[name]){
            dep = this._deprecatedHooks[name];
            name = dep.to;
        }
        if (dep && !options.allowDeprecated) {
            let message = dep.message;
            if (!message) message = `${originalName} hook has been deprecated` + (dep.to ? `, please use ${dep.to}` : "");
            if (!this._deprecatedMessages) this._deprecatedMessages = /* @__PURE__ */ new Set();
            if (!this._deprecatedMessages.has(message)) {
                console.warn(message);
                this._deprecatedMessages.add(message);
            }
        }
        if (!function_.name) try {
            Object.defineProperty(function_, "name", {
                get: ()=>"_" + name.replace(/\W+/g, "_") + "_hook_cb",
                configurable: true
            });
        } catch  {}
        this._hooks[name] = this._hooks[name] || [];
        this._hooks[name].push(function_);
        return ()=>{
            if (function_) {
                this.removeHook(name, function_);
                function_ = void 0;
            }
        };
    }
    hookOnce(name, function_) {
        let _unreg;
        let _function = (...arguments_)=>{
            if (typeof _unreg === "function") _unreg();
            _unreg = void 0;
            _function = void 0;
            return function_(...arguments_);
        };
        _unreg = this.hook(name, _function);
        return _unreg;
    }
    removeHook(name, function_) {
        if (this._hooks[name]) {
            const index = this._hooks[name].indexOf(function_);
            if (index !== -1) this._hooks[name].splice(index, 1);
            if (this._hooks[name].length === 0) delete this._hooks[name];
        }
    }
    deprecateHook(name, deprecated) {
        this._deprecatedHooks[name] = typeof deprecated === "string" ? {
            to: deprecated
        } : deprecated;
        const _hooks = this._hooks[name] || [];
        delete this._hooks[name];
        for (const hook of _hooks)this.hook(name, hook);
    }
    deprecateHooks(deprecatedHooks) {
        Object.assign(this._deprecatedHooks, deprecatedHooks);
        for(const name in deprecatedHooks)this.deprecateHook(name, deprecatedHooks[name]);
    }
    addHooks(configHooks) {
        const hooks = $1d08a6e6d888c780$export$9089e2fc8ae509cd(configHooks);
        const removeFns = Object.keys(hooks).map((key)=>this.hook(key, hooks[key]));
        return ()=>{
            for (const unreg of removeFns.splice(0, removeFns.length))unreg();
        };
    }
    removeHooks(configHooks) {
        const hooks = $1d08a6e6d888c780$export$9089e2fc8ae509cd(configHooks);
        for(const key in hooks)this.removeHook(key, hooks[key]);
    }
    removeAllHooks() {
        for(const key in this._hooks)delete this._hooks[key];
    }
    callHook(name, ...arguments_) {
        arguments_.unshift(name);
        return this.callHookWith($1d08a6e6d888c780$var$serialTaskCaller, name, ...arguments_);
    }
    callHookParallel(name, ...arguments_) {
        arguments_.unshift(name);
        return this.callHookWith($1d08a6e6d888c780$var$parallelTaskCaller, name, ...arguments_);
    }
    callHookWith(caller, name, ...arguments_) {
        const event = this._before || this._after ? {
            name: name,
            args: arguments_,
            context: {}
        } : void 0;
        if (this._before) $1d08a6e6d888c780$var$callEachWith(this._before, event);
        const result = caller(name in this._hooks ? [
            ...this._hooks[name]
        ] : [], arguments_);
        if (result instanceof Promise) return result.finally(()=>{
            if (this._after && event) $1d08a6e6d888c780$var$callEachWith(this._after, event);
        });
        if (this._after && event) $1d08a6e6d888c780$var$callEachWith(this._after, event);
        return result;
    }
    beforeEach(function_) {
        this._before = this._before || [];
        this._before.push(function_);
        return ()=>{
            if (this._before !== void 0) {
                const index = this._before.indexOf(function_);
                if (index !== -1) this._before.splice(index, 1);
            }
        };
    }
    afterEach(function_) {
        this._after = this._after || [];
        this._after.push(function_);
        return ()=>{
            if (this._after !== void 0) {
                const index = this._after.indexOf(function_);
                if (index !== -1) this._after.splice(index, 1);
            }
        };
    }
    constructor(){
        this._hooks = {};
        this._before = void 0;
        this._after = void 0;
        this._deprecatedMessages = void 0;
        this._deprecatedHooks = {};
        this.hook = this.hook.bind(this);
        this.callHook = this.callHook.bind(this);
        this.callHookWith = this.callHookWith.bind(this);
    }
}
function $1d08a6e6d888c780$export$39c6a2b4dbabca5d() {
    return new $1d08a6e6d888c780$export$f26845e0fc859724();
}
const $1d08a6e6d888c780$var$isBrowser = typeof window !== "undefined";
function $1d08a6e6d888c780$export$acfdf6f45fa21f5e(hooks, _options = {}) {
    const options = {
        inspect: $1d08a6e6d888c780$var$isBrowser,
        group: $1d08a6e6d888c780$var$isBrowser,
        filter: ()=>true,
        ..._options
    };
    const _filter = options.filter;
    const filter = typeof _filter === "string" ? (name)=>name.startsWith(_filter) : _filter;
    const _tag = options.tag ? `[${options.tag}] ` : "";
    const logPrefix = (event)=>_tag + event.name + "".padEnd(event._id, "\0");
    const _idCtr = {};
    const unsubscribeBefore = hooks.beforeEach((event)=>{
        if (filter !== void 0 && !filter(event.name)) return;
        _idCtr[event.name] = _idCtr[event.name] || 0;
        event._id = _idCtr[event.name]++;
        console.time(logPrefix(event));
    });
    const unsubscribeAfter = hooks.afterEach((event)=>{
        if (filter !== void 0 && !filter(event.name)) return;
        if (options.group) console.groupCollapsed(event.name);
        if (options.inspect) console.timeLog(logPrefix(event), event.args);
        else console.timeEnd(logPrefix(event));
        if (options.group) console.groupEnd();
        _idCtr[event.name]--;
    });
    return {
        /** Stop debugging and remove listeners */ close: ()=>{
            unsubscribeBefore();
            unsubscribeAfter();
        }
    };
}

});

parcelRegister("kNcBH", function(module, exports) {

$parcel$export(module.exports, "PatchDomOnEntryUpdatesPlugin", function () { return $57fd11f0339bdebb$export$616e983de35b355c; });
$parcel$export(module.exports, "maybeGetSSRHash", function () { return $57fd11f0339bdebb$export$87391fe41a533c2e; });

var $cHHQH = parcelRequire("cHHQH");
function $57fd11f0339bdebb$export$7e45664a2081efb1(ctx, newEntry = false, markSideEffect) {
    const { tag: tag, $el: $el } = ctx;
    if (!$el) return;
    Object.entries(tag.props).forEach(([k, value])=>{
        value = String(value);
        const attrSdeKey = `attr:${k}`;
        if (k === "class") {
            if (!value) return;
            for (const c of value.split(" ")){
                const classSdeKey = `${attrSdeKey}:${c}`;
                if (markSideEffect) markSideEffect(ctx, classSdeKey, ()=>$el.classList.remove(c));
                if (!$el.classList.contains(c)) $el.classList.add(c);
            }
            return;
        }
        if (markSideEffect && !k.startsWith("data-h-")) markSideEffect(ctx, attrSdeKey, ()=>$el.removeAttribute(k));
        if (newEntry || $el.getAttribute(k) !== value) $el.setAttribute(k, value);
    });
    if ((0, $cHHQH.TagsWithInnerContent).includes(tag.tag)) {
        if (tag.textContent && tag.textContent !== $el.textContent) $el.textContent = tag.textContent;
        else if (tag.innerHTML && tag.innerHTML !== $el.innerHTML) $el.innerHTML = tag.innerHTML;
    }
}
let $57fd11f0339bdebb$var$prevHash = false;
async function $57fd11f0339bdebb$export$2ac63036dd9f4a48(head, options = {}) {
    const beforeRenderCtx = {
        shouldRender: true
    };
    await head.hooks.callHook("dom:beforeRender", beforeRenderCtx);
    if (!beforeRenderCtx.shouldRender) return;
    const dom = options.document || head.resolvedOptions.document || window.document;
    const tagContexts = (await head.resolveTags()).map(setupTagRenderCtx);
    if (head.resolvedOptions.experimentalHashHydration) {
        $57fd11f0339bdebb$var$prevHash = $57fd11f0339bdebb$var$prevHash || head._hash || false;
        if ($57fd11f0339bdebb$var$prevHash) {
            const hash = (0, $cHHQH.computeHashes)(tagContexts.map((ctx)=>ctx.tag._h));
            if ($57fd11f0339bdebb$var$prevHash === hash) return;
            $57fd11f0339bdebb$var$prevHash = hash;
        }
    }
    const staleSideEffects = head._popSideEffectQueue();
    head.headEntries().map((entry)=>entry._sde).forEach((sde)=>{
        Object.entries(sde).forEach(([key, fn])=>{
            staleSideEffects[key] = fn;
        });
    });
    const markSideEffect = (ctx, key, fn)=>{
        key = `${ctx.renderId}:${key}`;
        if (ctx.entry) ctx.entry._sde[key] = fn;
        delete staleSideEffects[key];
    };
    function setupTagRenderCtx(tag) {
        const entry = head.headEntries().find((e)=>e._i === tag._e);
        const renderCtx = {
            renderId: tag._d || (0, $cHHQH.hashTag)(tag),
            $el: null,
            shouldRender: true,
            tag: tag,
            entry: entry,
            markSideEffect: (key, fn)=>markSideEffect(renderCtx, key, fn)
        };
        return renderCtx;
    }
    const renders = [];
    const pendingRenders = {
        body: [],
        head: []
    };
    const markEl = (ctx)=>{
        head._elMap[ctx.renderId] = ctx.$el;
        renders.push(ctx);
        markSideEffect(ctx, "el", ()=>{
            var _ctx_$el;
            (_ctx_$el = ctx.$el) === null || _ctx_$el === void 0 ? void 0 : _ctx_$el.remove();
            delete head._elMap[ctx.renderId];
        });
    };
    for (const ctx of tagContexts){
        var _tag_tagPosition, _tag_tagPosition1;
        await head.hooks.callHook("dom:beforeRenderTag", ctx);
        if (!ctx.shouldRender) continue;
        const { tag: tag } = ctx;
        if (tag.tag === "title") {
            dom.title = tag.textContent || "";
            renders.push(ctx);
            continue;
        }
        if (tag.tag === "htmlAttrs" || tag.tag === "bodyAttrs") {
            ctx.$el = dom[tag.tag === "htmlAttrs" ? "documentElement" : "body"];
            $57fd11f0339bdebb$export$7e45664a2081efb1(ctx, false, markSideEffect);
            renders.push(ctx);
            continue;
        }
        ctx.$el = head._elMap[ctx.renderId];
        if (!ctx.$el && tag.key) ctx.$el = dom.querySelector(`${((_tag_tagPosition = tag.tagPosition) === null || _tag_tagPosition === void 0 ? void 0 : _tag_tagPosition.startsWith("body")) ? "body" : "head"} > ${tag.tag}[data-h-${tag._h}]`);
        if (ctx.$el) {
            if (ctx.tag._d) $57fd11f0339bdebb$export$7e45664a2081efb1(ctx);
            markEl(ctx);
            continue;
        }
        pendingRenders[((_tag_tagPosition1 = tag.tagPosition) === null || _tag_tagPosition1 === void 0 ? void 0 : _tag_tagPosition1.startsWith("body")) ? "body" : "head"].push(ctx);
    }
    const fragments = {
        bodyClose: void 0,
        bodyOpen: void 0,
        head: void 0
    };
    Object.entries(pendingRenders).forEach(([pos, queue])=>{
        var _dom_pos;
        if (!queue.length) return;
        const children = dom === null || dom === void 0 ? void 0 : (_dom_pos = dom[pos]) === null || _dom_pos === void 0 ? void 0 : _dom_pos.children;
        if (!children) return;
        for (const $el of [
            ...children
        ].reverse()){
            const elTag = $el.tagName.toLowerCase();
            if (!(0, $cHHQH.HasElementTags).includes(elTag)) continue;
            const props = $el.getAttributeNames().reduce((props2, name)=>({
                    ...props2,
                    [name]: $el.getAttribute(name)
                }), {});
            const tmpTag = {
                tag: elTag,
                props: props
            };
            if ($el.innerHTML) tmpTag.innerHTML = $el.innerHTML;
            const tmpRenderId = (0, $cHHQH.hashTag)(tmpTag);
            let matchIdx = queue.findIndex((ctx)=>(ctx === null || ctx === void 0 ? void 0 : ctx.renderId) === tmpRenderId);
            if (matchIdx === -1) {
                const tmpDedupeKey = (0, $cHHQH.tagDedupeKey)(tmpTag);
                matchIdx = queue.findIndex((ctx)=>(ctx === null || ctx === void 0 ? void 0 : ctx.tag._d) && ctx.tag._d === tmpDedupeKey);
            }
            if (matchIdx !== -1) {
                const ctx = queue[matchIdx];
                ctx.$el = $el;
                $57fd11f0339bdebb$export$7e45664a2081efb1(ctx);
                markEl(ctx);
                delete queue[matchIdx];
            }
        }
        queue.forEach((ctx)=>{
            const pos2 = ctx.tag.tagPosition || "head";
            fragments[pos2] = fragments[pos2] || dom.createDocumentFragment();
            if (!ctx.$el) {
                ctx.$el = dom.createElement(ctx.tag.tag);
                $57fd11f0339bdebb$export$7e45664a2081efb1(ctx, true);
            }
            fragments[pos2].appendChild(ctx.$el);
            markEl(ctx);
        });
    });
    if (fragments.head) dom.head.appendChild(fragments.head);
    if (fragments.bodyOpen) dom.body.insertBefore(fragments.bodyOpen, dom.body.firstChild);
    if (fragments.bodyClose) dom.body.appendChild(fragments.bodyClose);
    for (const ctx of renders)await head.hooks.callHook("dom:renderTag", ctx);
    Object.values(staleSideEffects).forEach((fn)=>fn());
}
let $57fd11f0339bdebb$export$545a976aeb2a3572 = null;
async function $57fd11f0339bdebb$export$8d5d66ab90d144d5(head, options = {}) {
    function doDomUpdate() {
        $57fd11f0339bdebb$export$545a976aeb2a3572 = null;
        return $57fd11f0339bdebb$export$2ac63036dd9f4a48(head, options);
    }
    const delayFn = options.delayFn || ((fn)=>setTimeout(fn, 10));
    return $57fd11f0339bdebb$export$545a976aeb2a3572 = $57fd11f0339bdebb$export$545a976aeb2a3572 || new Promise((resolve)=>delayFn(()=>resolve(doDomUpdate())));
}
function $57fd11f0339bdebb$export$616e983de35b355c(options) {
    return (0, $cHHQH.defineHeadPlugin)({
        hooks: {
            "entries:updated": function(head) {
                if (typeof (options === null || options === void 0 ? void 0 : options.document) === "undefined" && typeof window === "undefined") return;
                let delayFn = options === null || options === void 0 ? void 0 : options.delayFn;
                if (!delayFn && typeof requestAnimationFrame !== "undefined") delayFn = requestAnimationFrame;
                $57fd11f0339bdebb$export$8d5d66ab90d144d5(head, {
                    document: (options === null || options === void 0 ? void 0 : options.document) || window.document,
                    delayFn: delayFn
                });
            }
        }
    });
}
function $57fd11f0339bdebb$export$87391fe41a533c2e(document) {
    var _document_head_querySelector;
    return (document === null || document === void 0 ? void 0 : (_document_head_querySelector = document.head.querySelector('meta[name="unhead:ssr"]')) === null || _document_head_querySelector === void 0 ? void 0 : _document_head_querySelector.getAttribute("content")) || false;
}

});
parcelRegister("cHHQH", function(module, exports) {

$parcel$export(module.exports, "asArray", function () { return $075ae7b822167e97$export$75093a47a9fa838d; });
$parcel$export(module.exports, "TagsWithInnerContent", function () { return $075ae7b822167e97$export$2b3786de3107f8f4; });
$parcel$export(module.exports, "HasElementTags", function () { return $075ae7b822167e97$export$2d34de101d167dc2; });
$parcel$export(module.exports, "ValidHeadTags", function () { return $075ae7b822167e97$export$14868efc55455374; });
$parcel$export(module.exports, "TagConfigKeys", function () { return $075ae7b822167e97$export$f1d1fd065b6ba29; });
$parcel$export(module.exports, "defineHeadPlugin", function () { return $075ae7b822167e97$export$17b18cff550a6a23; });
$parcel$export(module.exports, "hashCode", function () { return $075ae7b822167e97$export$d41d9ab3de2def3d; });
$parcel$export(module.exports, "hashTag", function () { return $075ae7b822167e97$export$533e693c6437fd18; });
$parcel$export(module.exports, "computeHashes", function () { return $075ae7b822167e97$export$2ddd2815ccf9ddd7; });
$parcel$export(module.exports, "tagDedupeKey", function () { return $075ae7b822167e97$export$7b50f9be0d99bd5; });
$parcel$export(module.exports, "resolveTitleTemplate", function () { return $075ae7b822167e97$export$d988e62b4edcb557; });
function $075ae7b822167e97$export$75093a47a9fa838d(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
const $075ae7b822167e97$export$d23e8dd333c9e39c = [
    "meta",
    "link",
    "base"
];
const $075ae7b822167e97$export$2b3786de3107f8f4 = [
    "title",
    "script",
    "style",
    "noscript"
];
const $075ae7b822167e97$export$2d34de101d167dc2 = [
    "base",
    "meta",
    "link",
    "style",
    "script",
    "noscript"
];
const $075ae7b822167e97$export$14868efc55455374 = [
    "title",
    "titleTemplate",
    "templateParams",
    "base",
    "htmlAttrs",
    "bodyAttrs",
    "meta",
    "link",
    "style",
    "script",
    "noscript"
];
const $075ae7b822167e97$export$553f45a7be03c3b3 = [
    "base",
    "title",
    "titleTemplate",
    "bodyAttrs",
    "htmlAttrs",
    "templateParams"
];
const $075ae7b822167e97$export$f1d1fd065b6ba29 = [
    "tagPosition",
    "tagPriority",
    "tagDuplicateStrategy",
    "innerHTML",
    "textContent"
];
function $075ae7b822167e97$export$17b18cff550a6a23(plugin) {
    return plugin;
}
function $075ae7b822167e97$export$d41d9ab3de2def3d(s) {
    let h = 9;
    for(let i = 0; i < s.length;)h = Math.imul(h ^ s.charCodeAt(i++), 9 ** 9);
    return ((h ^ h >>> 9) + 65536).toString(16).substring(1, 8).toLowerCase();
}
function $075ae7b822167e97$export$533e693c6437fd18(tag) {
    return $075ae7b822167e97$export$d41d9ab3de2def3d(`${tag.tag}:${tag.textContent || tag.innerHTML || ""}:${Object.entries(tag.props).map(([key, value])=>`${key}:${String(value)}`).join(",")}`);
}
function $075ae7b822167e97$export$2ddd2815ccf9ddd7(hashes) {
    let h = 9;
    for (const s of hashes)for(let i = 0; i < s.length;)h = Math.imul(h ^ s.charCodeAt(i++), 9 ** 9);
    return ((h ^ h >>> 9) + 65536).toString(16).substring(1, 8).toLowerCase();
}
function $075ae7b822167e97$export$7b50f9be0d99bd5(tag, fn) {
    const { props: props, tag: tagName } = tag;
    if ($075ae7b822167e97$export$553f45a7be03c3b3.includes(tagName)) return tagName;
    if (tagName === "link" && props.rel === "canonical") return "canonical";
    if (props.charset) return "charset";
    const name = [
        "id"
    ];
    if (tagName === "meta") name.push(...[
        "name",
        "property",
        "http-equiv"
    ]);
    for (const n of name)if (typeof props[n] !== "undefined") {
        const val = String(props[n]);
        if (fn && !fn(val)) return false;
        return `${tagName}:${n}:${val}`;
    }
    return false;
}
function $075ae7b822167e97$export$d988e62b4edcb557(template, title) {
    if (template == null) return title || null;
    if (typeof template === "function") return template(title);
    return template;
}

});



parcelRegister("4PQtJ", function(module, exports) {

$parcel$export(module.exports, "r", function () { return $d989e7413f6efc00$export$43caf9889c228507; });
$parcel$export(module.exports, "h", function () { return $d989e7413f6efc00$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "a", function () { return $d989e7413f6efc00$export$407448d2b89b1813; });
$parcel$export(module.exports, "s", function () { return $d989e7413f6efc00$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "u", function () { return $d989e7413f6efc00$export$3b14a55fb2447963; });
parcelRequire("hQJKw");
var $am4TS = parcelRequire("am4TS");
var $esfUo = parcelRequire("esfUo");

var $1ZeEE = parcelRequire("1ZeEE");

var $cHHQH = parcelRequire("cHHQH");
function $d989e7413f6efc00$var$resolveUnref(r) {
    return typeof r === "function" ? r() : (0, $am4TS.unref)(r);
}
function $d989e7413f6efc00$export$43caf9889c228507(ref, lastKey = "") {
    if (ref instanceof Promise) return ref;
    const root = $d989e7413f6efc00$var$resolveUnref(ref);
    if (!ref || !root) return root;
    if (Array.isArray(root)) return root.map((r)=>$d989e7413f6efc00$export$43caf9889c228507(r, lastKey));
    if (typeof root === "object") return Object.fromEntries(Object.entries(root).map(([k, v])=>{
        if (k === "titleTemplate" || k.startsWith("on")) return [
            k,
            (0, $am4TS.unref)(v)
        ];
        return [
            k,
            $d989e7413f6efc00$export$43caf9889c228507(v, k)
        ];
    }));
    return root;
}
const $d989e7413f6efc00$var$Vue3 = (0, $esfUo.version).startsWith("3");
const $d989e7413f6efc00$var$IsBrowser = typeof window !== "undefined";
const $d989e7413f6efc00$export$dda1d9f60106f0e9 = "usehead";
function $d989e7413f6efc00$export$23f2a1d2818174ef() {
    return (0, $esfUo.getCurrentInstance)() && (0, $esfUo.inject)($d989e7413f6efc00$export$dda1d9f60106f0e9) || (0, $1ZeEE.getActiveHead)();
}
function $d989e7413f6efc00$var$vueInstall(head) {
    const plugin = {
        install (app) {
            if ($d989e7413f6efc00$var$Vue3) {
                app.config.globalProperties.$unhead = head;
                app.config.globalProperties.$head = head;
                app.provide($d989e7413f6efc00$export$dda1d9f60106f0e9, head);
            }
        }
    };
    return plugin.install;
}
function $d989e7413f6efc00$export$db3b6bfb95261072(options = {}) {
    const head = (0, $1ZeEE.createServerHead)({
        ...options,
        plugins: [
            $d989e7413f6efc00$export$e7c866399fa523f5(),
            ...(options === null || options === void 0 ? void 0 : options.plugins) || []
        ]
    });
    head.install = $d989e7413f6efc00$var$vueInstall(head);
    return head;
}
function $d989e7413f6efc00$export$407448d2b89b1813(options = {}) {
    const head = (0, $1ZeEE.createHead)({
        ...options,
        // arbitrary delay the dom update for batch updates
        domDelayFn: (fn)=>setTimeout(()=>(0, $esfUo.nextTick)(()=>fn()), 10),
        plugins: [
            $d989e7413f6efc00$export$e7c866399fa523f5(),
            ...(options === null || options === void 0 ? void 0 : options.plugins) || []
        ]
    });
    head.install = $d989e7413f6efc00$var$vueInstall(head);
    return head;
}
function $d989e7413f6efc00$export$e7c866399fa523f5() {
    return (0, $cHHQH.defineHeadPlugin)({
        hooks: {
            "entries:resolve": function(ctx) {
                for (const entry of ctx.entries)entry.resolvedInput = $d989e7413f6efc00$export$43caf9889c228507(entry.input);
            }
        }
    });
}
function $d989e7413f6efc00$var$clientUseHead(input, options = {}) {
    const head = $d989e7413f6efc00$export$23f2a1d2818174ef();
    const deactivated = (0, $am4TS.ref)(false);
    const resolvedInput = (0, $am4TS.ref)({});
    (0, $esfUo.watchEffect)(()=>{
        resolvedInput.value = deactivated.value ? {} : $d989e7413f6efc00$export$43caf9889c228507(input);
    });
    const entry = head.push(resolvedInput.value, options);
    (0, $esfUo.watch)(resolvedInput, (e)=>{
        entry.patch(e);
    });
    const vm = (0, $esfUo.getCurrentInstance)();
    if (vm) {
        (0, $esfUo.onBeforeUnmount)(()=>{
            entry.dispose();
        });
        (0, $esfUo.onDeactivated)(()=>{
            deactivated.value = true;
        });
        (0, $esfUo.onActivated)(()=>{
            deactivated.value = false;
        });
    }
    return entry;
}
function $d989e7413f6efc00$export$2408f22a0fab9ae5(input, options = {}) {
    const head = $d989e7413f6efc00$export$23f2a1d2818174ef();
    return head.push(input, options);
}
function $d989e7413f6efc00$export$3b14a55fb2447963(input, options = {}) {
    const head = $d989e7413f6efc00$export$23f2a1d2818174ef();
    if (head) {
        var _head_resolvedOptions;
        const isBrowser = $d989e7413f6efc00$var$IsBrowser || !!((_head_resolvedOptions = head.resolvedOptions) === null || _head_resolvedOptions === void 0 ? void 0 : _head_resolvedOptions.document);
        if (options.mode === "server" && isBrowser || options.mode === "client" && !isBrowser) return;
        return isBrowser ? $d989e7413f6efc00$var$clientUseHead(input, options) : $d989e7413f6efc00$export$2408f22a0fab9ae5(input, options);
    }
}

});



parcelRegister("fiqmz", function(module, exports) {

$parcel$export(module.exports, "useRecaptchaProvider", function () { return (parcelRequire("6AdLA")).useRecaptchaProvider; });
$parcel$export(module.exports, "ChallengeV3", function () { return (parcelRequire("b6AyC")).default; });

var $i4Q9n = parcelRequire("i4Q9n");

var $l2opB = parcelRequire("l2opB");

var $kdzRz = parcelRequire("kdzRz");

var $6AdLA = parcelRequire("6AdLA");

var $ksyNw = parcelRequire("ksyNw");

var $b6AyC = parcelRequire("b6AyC");

var $aqxf5 = parcelRequire("aqxf5");

var $5wEd6 = parcelRequire("5wEd6");

});
parcelRegister("l2opB", function(module, exports) {

$parcel$export(module.exports, "RecaptchaV2State", function () { return $1187cce9e5bc2c68$export$1e474f70b07d86cc; });
$parcel$export(module.exports, "useChallengeV2", function () { return $1187cce9e5bc2c68$export$91ec1818fc03119a; });

var $hmbgm = parcelRequire("hmbgm");
parcelRequire("jwRyC");
var $am4TS = parcelRequire("am4TS");

var $i4Q9n = parcelRequire("i4Q9n");
var $1187cce9e5bc2c68$export$1e474f70b07d86cc = /* @__PURE__ */ ((RecaptchaV2State2)=>{
    RecaptchaV2State2["Init"] = "init";
    RecaptchaV2State2["Verified"] = "verified";
    RecaptchaV2State2["Expired"] = "expired";
    RecaptchaV2State2["Error"] = "error";
    return RecaptchaV2State2;
})($1187cce9e5bc2c68$export$1e474f70b07d86cc || {});
function $1187cce9e5bc2c68$export$91ec1818fc03119a({ root: root = (0, $am4TS.ref)(), options: options = {} }) {
    const siteKey = (0, $i4Q9n.useAssertV2SiteKey)();
    const widgetID = (0, $am4TS.ref)();
    const proxy = (0, $i4Q9n.useRecaptchaProxy)();
    const verify = (0, $hmbgm.createEventHook)();
    const expired = (0, $hmbgm.createEventHook)();
    const error = (0, $hmbgm.createEventHook)();
    const rootRef = (0, $hmbgm.resolveRef)(root);
    const state = (0, $am4TS.ref)("init" /* Init */ );
    (0, $hmbgm.whenever)(rootRef, async (el)=>{
        const id = await proxy.render(el, {
            ...options,
            sitekey: siteKey,
            callback: verify.trigger,
            "expired-callback": expired.trigger,
            "error-callback": error.trigger
        });
        widgetID.value = id;
    });
    verify.on(()=>{
        state.value = "verified" /* Verified */ ;
    });
    expired.on(()=>{
        state.value = "expired" /* Expired */ ;
    });
    error.on(()=>{
        state.value = "error" /* Error */ ;
    });
    return {
        root: rootRef,
        widgetID: widgetID,
        execute () {
            if (typeof widgetID.value !== "undefined") proxy.execute(widgetID.value);
        },
        reset () {
            state.value = "init" /* Init */ ;
            if (typeof widgetID.value !== "undefined") proxy.reset(widgetID.value);
        },
        state: state,
        onVerify: verify.on,
        onExpired: expired.on,
        onError: error.on
    };
}

});
parcelRegister("hmbgm", function(module, exports) {

$parcel$export(module.exports, "createEventHook", function () { return $78bd828b180e977b$export$c8b3b0996d763ee; });
$parcel$export(module.exports, "resolveRef", function () { return $78bd828b180e977b$export$fb2b8a41d9966b32; });
$parcel$export(module.exports, "whenever", function () { return $78bd828b180e977b$export$909eba9696cc3445; });
parcelRequire("jwRyC");
var $am4TS = parcelRequire("am4TS");
var $esfUo = parcelRequire("esfUo");
var $jwRyC = parcelRequire("jwRyC");
var $78bd828b180e977b$var$__defProp$9 = Object.defineProperty;
var $78bd828b180e977b$var$__defProps$6 = Object.defineProperties;
var $78bd828b180e977b$var$__getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
var $78bd828b180e977b$var$__getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var $78bd828b180e977b$var$__hasOwnProp$b = Object.prototype.hasOwnProperty;
var $78bd828b180e977b$var$__propIsEnum$b = Object.prototype.propertyIsEnumerable;
var $78bd828b180e977b$var$__defNormalProp$9 = (obj, key, value)=>key in obj ? $78bd828b180e977b$var$__defProp$9(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $78bd828b180e977b$var$__spreadValues$9 = (a, b)=>{
    for(var prop in b || (b = {}))if ($78bd828b180e977b$var$__hasOwnProp$b.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$9(a, prop, b[prop]);
    if ($78bd828b180e977b$var$__getOwnPropSymbols$b) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols$b(b))if ($78bd828b180e977b$var$__propIsEnum$b.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$9(a, prop, b[prop]);
    }
    return a;
};
var $78bd828b180e977b$var$__spreadProps$6 = (a, b)=>$78bd828b180e977b$var$__defProps$6(a, $78bd828b180e977b$var$__getOwnPropDescs$6(b));
function $78bd828b180e977b$export$c92323792c35f5f1(fn, options) {
    var _a;
    const result = (0, $am4TS.shallowRef)();
    (0, $esfUo.watchEffect)(()=>{
        result.value = fn();
    }, $78bd828b180e977b$var$__spreadProps$6($78bd828b180e977b$var$__spreadValues$9({}, options), {
        flush: (_a = options == null ? void 0 : options.flush) != null ? _a : "sync"
    }));
    return (0, $am4TS.readonly)(result);
}
var $78bd828b180e977b$var$_a;
const $78bd828b180e977b$export$7383f122bf48ec30 = typeof window !== "undefined";
const $78bd828b180e977b$export$7b816c9b8ecf71b4 = (val)=>typeof val !== "undefined";
const $78bd828b180e977b$export$a7a9523472993e97 = (condition, ...infos)=>{
    if (!condition) console.warn(...infos);
};
const $78bd828b180e977b$var$toString = Object.prototype.toString;
const $78bd828b180e977b$export$f9ce7b637dfbe238 = (val)=>typeof val === "boolean";
const $78bd828b180e977b$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $78bd828b180e977b$export$7e4aa119212bc614 = (val)=>typeof val === "number";
const $78bd828b180e977b$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $78bd828b180e977b$export$a6cdc56e425d0d0a = (val)=>$78bd828b180e977b$var$toString.call(val) === "[object Object]";
const $78bd828b180e977b$export$5a096129d439f843 = (val)=>typeof window !== "undefined" && $78bd828b180e977b$var$toString.call(val) === "[object Window]";
const $78bd828b180e977b$export$461939dd4422153 = ()=>Date.now();
const $78bd828b180e977b$export$fc00ee57782020aa = ()=>+Date.now();
const $78bd828b180e977b$export$7d15b64cf5a3a4c4 = (n, min, max)=>Math.min(max, Math.max(min, n));
const $78bd828b180e977b$export$8793edee2d425525 = ()=>{};
const $78bd828b180e977b$export$bb0a9c36cf454ea0 = (min, max)=>{
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
const $78bd828b180e977b$export$fedb369cb70207f1 = $78bd828b180e977b$export$7383f122bf48ec30 && (($78bd828b180e977b$var$_a = window == null ? void 0 : window.navigator) == null ? void 0 : $78bd828b180e977b$var$_a.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
const $78bd828b180e977b$export$b5a638e9b3fff9f3 = (val, key)=>Object.prototype.hasOwnProperty.call(val, key);
function $78bd828b180e977b$export$13fbab860e8afb41(r) {
    return typeof r === "function" ? r() : (0, $am4TS.unref)(r);
}
function $78bd828b180e977b$export$a1f1cf91007f23bf(filter, fn) {
    function wrapper(...args) {
        return new Promise((resolve, reject)=>{
            Promise.resolve(filter(()=>fn.apply(this, args), {
                fn: fn,
                thisArg: this,
                args: args
            })).then(resolve).catch(reject);
        });
    }
    return wrapper;
}
const $78bd828b180e977b$export$8cc0e33a27868391 = (invoke)=>{
    return invoke();
};
function $78bd828b180e977b$export$fca2c450ae03b38e(ms, options = {}) {
    let timer;
    let maxTimer;
    let lastRejector = $78bd828b180e977b$export$8793edee2d425525;
    const _clearTimeout = (timer2)=>{
        clearTimeout(timer2);
        lastRejector();
        lastRejector = $78bd828b180e977b$export$8793edee2d425525;
    };
    const filter = (invoke)=>{
        const duration = $78bd828b180e977b$export$13fbab860e8afb41(ms);
        const maxDuration = $78bd828b180e977b$export$13fbab860e8afb41(options.maxWait);
        if (timer) _clearTimeout(timer);
        if (duration <= 0 || maxDuration !== void 0 && maxDuration <= 0) {
            if (maxTimer) {
                _clearTimeout(maxTimer);
                maxTimer = null;
            }
            return Promise.resolve(invoke());
        }
        return new Promise((resolve, reject)=>{
            lastRejector = options.rejectOnCancel ? reject : resolve;
            if (maxDuration && !maxTimer) maxTimer = setTimeout(()=>{
                if (timer) _clearTimeout(timer);
                maxTimer = null;
                resolve(invoke());
            }, maxDuration);
            timer = setTimeout(()=>{
                if (maxTimer) _clearTimeout(maxTimer);
                maxTimer = null;
                resolve(invoke());
            }, duration);
        });
    };
    return filter;
}
function $78bd828b180e977b$export$cd62e9dbf204fd92(ms, trailing = true, leading = true, rejectOnCancel = false) {
    let lastExec = 0;
    let timer;
    let isLeading = true;
    let lastRejector = $78bd828b180e977b$export$8793edee2d425525;
    let lastValue;
    const clear = ()=>{
        if (timer) {
            clearTimeout(timer);
            timer = void 0;
            lastRejector();
            lastRejector = $78bd828b180e977b$export$8793edee2d425525;
        }
    };
    const filter = (_invoke)=>{
        const duration = $78bd828b180e977b$export$13fbab860e8afb41(ms);
        const elapsed = Date.now() - lastExec;
        const invoke = ()=>{
            return lastValue = _invoke();
        };
        clear();
        if (duration <= 0) {
            lastExec = Date.now();
            return invoke();
        }
        if (elapsed > duration && (leading || !isLeading)) {
            lastExec = Date.now();
            invoke();
        } else if (trailing) lastValue = new Promise((resolve, reject)=>{
            lastRejector = rejectOnCancel ? reject : resolve;
            timer = setTimeout(()=>{
                lastExec = Date.now();
                isLeading = true;
                resolve(invoke());
                clear();
            }, Math.max(0, duration - elapsed));
        });
        if (!leading && !timer) timer = setTimeout(()=>isLeading = true, duration);
        isLeading = false;
        return lastValue;
    };
    return filter;
}
function $78bd828b180e977b$export$8d46ce8e0ead9c2b(extendFilter = $78bd828b180e977b$export$8cc0e33a27868391) {
    const isActive = (0, $am4TS.ref)(true);
    function pause() {
        isActive.value = false;
    }
    function resume() {
        isActive.value = true;
    }
    const eventFilter = (...args)=>{
        if (isActive.value) extendFilter(...args);
    };
    return {
        isActive: (0, $am4TS.readonly)(isActive),
        pause: pause,
        resume: resume,
        eventFilter: eventFilter
    };
}
function $78bd828b180e977b$export$7875201a188d1637(name = "this function") {
    if (0, $jwRyC.isVue3) return;
    throw new Error(`[VueUse] ${name} is only works on Vue 3.`);
}
function $78bd828b180e977b$export$d8e2c8dfdc49101(name = "this function") {
    if ((0, $jwRyC.isVue3) || (0, $esfUo.version).startsWith("2.7.")) return;
    throw new Error(`[VueUse] ${name} is only works on Vue 2.7 or above.`);
}
const $78bd828b180e977b$export$2161f27fc78b6ab2 = {
    mounted: (0, $jwRyC.isVue3) ? "mounted" : "inserted",
    updated: (0, $jwRyC.isVue3) ? "updated" : "componentUpdated",
    unmounted: (0, $jwRyC.isVue3) ? "unmounted" : "unbind"
};
function $78bd828b180e977b$export$69e8b3daf72c74b7(ms, throwOnTimeout = false, reason = "Timeout") {
    return new Promise((resolve, reject)=>{
        if (throwOnTimeout) setTimeout(()=>reject(reason), ms);
        else setTimeout(resolve, ms);
    });
}
function $78bd828b180e977b$export$f0954fd7d5368655(arg) {
    return arg;
}
function $78bd828b180e977b$export$7a0c7c93e8e22bce(fn) {
    let _promise;
    function wrapper() {
        if (!_promise) _promise = fn();
        return _promise;
    }
    wrapper.reset = async ()=>{
        const _prev = _promise;
        _promise = void 0;
        if (_prev) await _prev;
    };
    return wrapper;
}
function $78bd828b180e977b$export$468cda29b159ee5d(fn) {
    return fn();
}
function $78bd828b180e977b$export$d138bf93e1dfa23f(obj, ...props) {
    return props.some((k)=>k in obj);
}
function $78bd828b180e977b$export$f5c97f6a04b90212(target, delta) {
    var _a;
    if (typeof target === "number") return target + delta;
    const value = ((_a = target.match(/^-?[0-9]+\.?[0-9]*/)) == null ? void 0 : _a[0]) || "";
    const unit = target.slice(value.length);
    const result = parseFloat(value) + delta;
    if (Number.isNaN(result)) return target;
    return result + unit;
}
function $78bd828b180e977b$export$5f2d71bd504be1ec(obj, keys, omitUndefined = false) {
    return keys.reduce((n, k)=>{
        if (k in obj) {
            if (!omitUndefined || obj[k] !== void 0) n[k] = obj[k];
        }
        return n;
    }, {});
}
function $78bd828b180e977b$export$220dfb31330e2956(source, fn) {
    let v = void 0;
    let track;
    let trigger;
    const dirty = (0, $am4TS.ref)(true);
    const update = ()=>{
        dirty.value = true;
        trigger();
    };
    (0, $esfUo.watch)(source, update, {
        flush: "sync"
    });
    const get = $78bd828b180e977b$export$f6e2535fb5126e54(fn) ? fn : fn.get;
    const set = $78bd828b180e977b$export$f6e2535fb5126e54(fn) ? void 0 : fn.set;
    const result = (0, $am4TS.customRef)((_track, _trigger)=>{
        track = _track;
        trigger = _trigger;
        return {
            get () {
                if (dirty.value) {
                    v = get();
                    dirty.value = false;
                }
                track();
                return v;
            },
            set (v2) {
                set == null || set(v2);
            }
        };
    });
    if (Object.isExtensible(result)) result.trigger = update;
    return result;
}
function $78bd828b180e977b$export$c3d49ae4e58d3d9d(fn) {
    if ((0, $am4TS.getCurrentScope)()) {
        (0, $am4TS.onScopeDispose)(fn);
        return true;
    }
    return false;
}
function $78bd828b180e977b$export$c8b3b0996d763ee() {
    const fns = [];
    const off = (fn)=>{
        const index = fns.indexOf(fn);
        if (index !== -1) fns.splice(index, 1);
    };
    const on = (fn)=>{
        fns.push(fn);
        const offFn = ()=>off(fn);
        $78bd828b180e977b$export$c3d49ae4e58d3d9d(offFn);
        return {
            off: offFn
        };
    };
    const trigger = (param)=>{
        fns.forEach((fn)=>fn(param));
    };
    return {
        on: on,
        off: off,
        trigger: trigger
    };
}
function $78bd828b180e977b$export$aa9aac23b3959ee1(stateFactory) {
    let initialized = false;
    let state;
    const scope = (0, $am4TS.effectScope)(true);
    return ()=>{
        if (!initialized) {
            state = scope.run(stateFactory);
            initialized = true;
        }
        return state;
    };
}
function $78bd828b180e977b$export$91b9c7550061230e(composable) {
    const key = Symbol("InjectionState");
    const useProvidingState = (...args)=>{
        const state = composable(...args);
        (0, $esfUo.provide)(key, state);
        return state;
    };
    const useInjectedState = ()=>(0, $esfUo.inject)(key);
    return [
        useProvidingState,
        useInjectedState
    ];
}
function $78bd828b180e977b$export$9e8d4b001a1bb310(composable) {
    let subscribers = 0;
    let state;
    let scope;
    const dispose = ()=>{
        subscribers -= 1;
        if (scope && subscribers <= 0) {
            scope.stop();
            state = void 0;
            scope = void 0;
        }
    };
    return (...args)=>{
        subscribers += 1;
        if (!state) {
            scope = (0, $am4TS.effectScope)(true);
            state = scope.run(()=>composable(...args));
        }
        $78bd828b180e977b$export$c3d49ae4e58d3d9d(dispose);
        return state;
    };
}
function $78bd828b180e977b$export$ecda8b07a1b5deab(ref, extend, { enumerable: enumerable = false, unwrap: unwrap = true } = {}) {
    $78bd828b180e977b$export$d8e2c8dfdc49101();
    for (const [key, value] of Object.entries(extend)){
        if (key === "value") continue;
        if ((0, $am4TS.isRef)(value) && unwrap) Object.defineProperty(ref, key, {
            get () {
                return value.value;
            },
            set (v) {
                value.value = v;
            },
            enumerable: enumerable
        });
        else Object.defineProperty(ref, key, {
            value: value,
            enumerable: enumerable
        });
    }
    return ref;
}
function $78bd828b180e977b$export$3988ae62b71be9a3(obj, key) {
    if (key == null) return (0, $am4TS.unref)(obj);
    return (0, $am4TS.unref)(obj)[key];
}
function $78bd828b180e977b$export$4e62c701997796c1(v) {
    return (0, $am4TS.unref)(v) != null;
}
var $78bd828b180e977b$var$__defProp$8 = Object.defineProperty;
var $78bd828b180e977b$var$__getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var $78bd828b180e977b$var$__hasOwnProp$a = Object.prototype.hasOwnProperty;
var $78bd828b180e977b$var$__propIsEnum$a = Object.prototype.propertyIsEnumerable;
var $78bd828b180e977b$var$__defNormalProp$8 = (obj, key, value)=>key in obj ? $78bd828b180e977b$var$__defProp$8(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $78bd828b180e977b$var$__spreadValues$8 = (a, b)=>{
    for(var prop in b || (b = {}))if ($78bd828b180e977b$var$__hasOwnProp$a.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$8(a, prop, b[prop]);
    if ($78bd828b180e977b$var$__getOwnPropSymbols$a) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols$a(b))if ($78bd828b180e977b$var$__propIsEnum$a.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$8(a, prop, b[prop]);
    }
    return a;
};
function $78bd828b180e977b$export$d50fdd10db75504e(obj, arr) {
    if (typeof Symbol !== "undefined") {
        const clone = $78bd828b180e977b$var$__spreadValues$8({}, obj);
        Object.defineProperty(clone, Symbol.iterator, {
            enumerable: false,
            value () {
                let index = 0;
                return {
                    next: ()=>({
                            value: arr[index++],
                            done: index > arr.length
                        })
                };
            }
        });
        return clone;
    } else return Object.assign([
        ...arr
    ], obj);
}
function $78bd828b180e977b$export$4ba03523724ba2d7(fn, options) {
    const unrefFn = (options == null ? void 0 : options.computedGetter) === false ? (0, $am4TS.unref) : $78bd828b180e977b$export$13fbab860e8afb41;
    return function(...args) {
        return (0, $am4TS.computed)(()=>fn.apply(this, args.map((i)=>unrefFn(i))));
    };
}
function $78bd828b180e977b$export$1ff2e29423610e60(obj, optionsOrKeys = {}) {
    let keys = [];
    let options;
    if (Array.isArray(optionsOrKeys)) keys = optionsOrKeys;
    else {
        options = optionsOrKeys;
        const { includeOwnProperties: includeOwnProperties = true } = optionsOrKeys;
        keys.push(...Object.keys(obj));
        if (includeOwnProperties) keys.push(...Object.getOwnPropertyNames(obj));
    }
    return Object.fromEntries(keys.map((key)=>{
        const value = obj[key];
        return [
            key,
            typeof value === "function" ? $78bd828b180e977b$export$4ba03523724ba2d7(value.bind(obj), options) : value
        ];
    }));
}
function $78bd828b180e977b$export$45c769cf449a508c(objectRef) {
    if (!(0, $am4TS.isRef)(objectRef)) return (0, $am4TS.reactive)(objectRef);
    const proxy = new Proxy({}, {
        get (_, p, receiver) {
            return (0, $am4TS.unref)(Reflect.get(objectRef.value, p, receiver));
        },
        set (_, p, value) {
            if ((0, $am4TS.isRef)(objectRef.value[p]) && !(0, $am4TS.isRef)(value)) objectRef.value[p].value = value;
            else objectRef.value[p] = value;
            return true;
        },
        deleteProperty (_, p) {
            return Reflect.deleteProperty(objectRef.value, p);
        },
        has (_, p) {
            return Reflect.has(objectRef.value, p);
        },
        ownKeys () {
            return Object.keys(objectRef.value);
        },
        getOwnPropertyDescriptor () {
            return {
                enumerable: true,
                configurable: true
            };
        }
    });
    return (0, $am4TS.reactive)(proxy);
}
function $78bd828b180e977b$export$35298289c11958e1(fn) {
    return $78bd828b180e977b$export$45c769cf449a508c((0, $am4TS.computed)(fn));
}
function $78bd828b180e977b$export$797deb43a681bdd1(obj, ...keys) {
    const flatKeys = keys.flat();
    return $78bd828b180e977b$export$35298289c11958e1(()=>Object.fromEntries(Object.entries((0, $am4TS.toRefs)(obj)).filter((e)=>!flatKeys.includes(e[0]))));
}
function $78bd828b180e977b$export$afd74972d99a820f(obj, ...keys) {
    const flatKeys = keys.flat();
    return (0, $am4TS.reactive)(Object.fromEntries(flatKeys.map((k)=>[
            k,
            (0, $am4TS.toRef)(obj, k)
        ])));
}
function $78bd828b180e977b$export$c1f1e286df6cc58f(defaultValue, afterMs = 1e4) {
    return (0, $am4TS.customRef)((track, trigger)=>{
        let value = defaultValue;
        let timer;
        const resetAfter = ()=>setTimeout(()=>{
                value = defaultValue;
                trigger();
            }, $78bd828b180e977b$export$13fbab860e8afb41(afterMs));
        $78bd828b180e977b$export$c3d49ae4e58d3d9d(()=>{
            clearTimeout(timer);
        });
        return {
            get () {
                track();
                return value;
            },
            set (newValue) {
                value = newValue;
                trigger();
                clearTimeout(timer);
                timer = resetAfter();
            }
        };
    });
}
function $78bd828b180e977b$export$ddf8f1aa96b8ea88(fn, ms = 200, options = {}) {
    return $78bd828b180e977b$export$a1f1cf91007f23bf($78bd828b180e977b$export$fca2c450ae03b38e(ms, options), fn);
}
function $78bd828b180e977b$export$179967fbe3ecb41a(value, ms = 200, options = {}) {
    const debounced = (0, $am4TS.ref)(value.value);
    const updater = $78bd828b180e977b$export$ddf8f1aa96b8ea88(()=>{
        debounced.value = value.value;
    }, ms, options);
    (0, $esfUo.watch)(value, ()=>updater());
    return debounced;
}
function $78bd828b180e977b$export$52a73c0b6dcfe111(source, defaultValue) {
    return (0, $am4TS.computed)({
        get () {
            var _a;
            return (_a = source.value) != null ? _a : defaultValue;
        },
        set (value) {
            source.value = value;
        }
    });
}
function $78bd828b180e977b$export$8ed85856108010bc(fn, ms = 200, trailing = false, leading = true, rejectOnCancel = false) {
    return $78bd828b180e977b$export$a1f1cf91007f23bf($78bd828b180e977b$export$cd62e9dbf204fd92(ms, trailing, leading, rejectOnCancel), fn);
}
function $78bd828b180e977b$export$4d1d638ad6b48495(value, delay = 200, trailing = true, leading = true) {
    if (delay <= 0) return value;
    const throttled = (0, $am4TS.ref)(value.value);
    const updater = $78bd828b180e977b$export$8ed85856108010bc(()=>{
        throttled.value = value.value;
    }, delay, trailing, leading);
    (0, $esfUo.watch)(value, ()=>updater());
    return throttled;
}
function $78bd828b180e977b$export$4b7f2010e13474b2(initial, options = {}) {
    let source = initial;
    let track;
    let trigger;
    const ref = (0, $am4TS.customRef)((_track, _trigger)=>{
        track = _track;
        trigger = _trigger;
        return {
            get () {
                return get();
            },
            set (v) {
                set(v);
            }
        };
    });
    function get(tracking = true) {
        if (tracking) track();
        return source;
    }
    function set(value, triggering = true) {
        var _a, _b;
        if (value === source) return;
        const old = source;
        if (((_a = options.onBeforeChange) == null ? void 0 : _a.call(options, value, old)) === false) return;
        source = value;
        (_b = options.onChanged) == null || _b.call(options, value, old);
        if (triggering) trigger();
    }
    const untrackedGet = ()=>get(false);
    const silentSet = (v)=>set(v, false);
    const peek = ()=>get(false);
    const lay = (v)=>set(v, false);
    return $78bd828b180e977b$export$ecda8b07a1b5deab(ref, {
        get: get,
        set: set,
        untrackedGet: untrackedGet,
        silentSet: silentSet,
        peek: peek,
        lay: lay
    }, {
        enumerable: true
    });
}
const $78bd828b180e977b$export$6b6db3af7a80e2d2 = $78bd828b180e977b$export$4b7f2010e13474b2;
function $78bd828b180e977b$export$fb2b8a41d9966b32(r) {
    return typeof r === "function" ? (0, $am4TS.computed)(r) : (0, $am4TS.ref)(r);
}
function $78bd828b180e977b$export$adaa4cf7ef1b65be(...args) {
    if (args.length === 2) {
        const [ref, value] = args;
        ref.value = value;
    }
    if (args.length === 3) {
        if (0, $jwRyC.isVue2) (0, $jwRyC.set)(...args);
        else {
            const [target, key, value] = args;
            target[key] = value;
        }
    }
}
function $78bd828b180e977b$export$d43743c1df800be0(left, right, options = {}) {
    var _a, _b;
    const { flush: flush = "sync", deep: deep = false, immediate: immediate = true, direction: direction = "both", transform: transform = {} } = options;
    let watchLeft;
    let watchRight;
    const transformLTR = (_a = transform.ltr) != null ? _a : (v)=>v;
    const transformRTL = (_b = transform.rtl) != null ? _b : (v)=>v;
    if (direction === "both" || direction === "ltr") watchLeft = (0, $esfUo.watch)(left, (newValue)=>right.value = transformLTR(newValue), {
        flush: flush,
        deep: deep,
        immediate: immediate
    });
    if (direction === "both" || direction === "rtl") watchRight = (0, $esfUo.watch)(right, (newValue)=>left.value = transformRTL(newValue), {
        flush: flush,
        deep: deep,
        immediate: immediate
    });
    return ()=>{
        watchLeft == null || watchLeft();
        watchRight == null || watchRight();
    };
}
function $78bd828b180e977b$export$16a582ae8a437df6(source, targets, options = {}) {
    const { flush: flush = "sync", deep: deep = false, immediate: immediate = true } = options;
    if (!Array.isArray(targets)) targets = [
        targets
    ];
    return (0, $esfUo.watch)(source, (newValue)=>targets.forEach((target)=>target.value = newValue), {
        flush: flush,
        deep: deep,
        immediate: immediate
    });
}
var $78bd828b180e977b$var$__defProp$7 = Object.defineProperty;
var $78bd828b180e977b$var$__defProps$5 = Object.defineProperties;
var $78bd828b180e977b$var$__getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
var $78bd828b180e977b$var$__getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var $78bd828b180e977b$var$__hasOwnProp$9 = Object.prototype.hasOwnProperty;
var $78bd828b180e977b$var$__propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var $78bd828b180e977b$var$__defNormalProp$7 = (obj, key, value)=>key in obj ? $78bd828b180e977b$var$__defProp$7(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $78bd828b180e977b$var$__spreadValues$7 = (a, b)=>{
    for(var prop in b || (b = {}))if ($78bd828b180e977b$var$__hasOwnProp$9.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$7(a, prop, b[prop]);
    if ($78bd828b180e977b$var$__getOwnPropSymbols$9) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols$9(b))if ($78bd828b180e977b$var$__propIsEnum$9.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$7(a, prop, b[prop]);
    }
    return a;
};
var $78bd828b180e977b$var$__spreadProps$5 = (a, b)=>$78bd828b180e977b$var$__defProps$5(a, $78bd828b180e977b$var$__getOwnPropDescs$5(b));
function $78bd828b180e977b$export$2e9533675e5e70e0(objectRef) {
    if (!(0, $am4TS.isRef)(objectRef)) return (0, $am4TS.toRefs)(objectRef);
    const result = Array.isArray(objectRef.value) ? new Array(objectRef.value.length) : {};
    for(const key in objectRef.value)result[key] = (0, $am4TS.customRef)(()=>({
            get () {
                return objectRef.value[key];
            },
            set (v) {
                if (Array.isArray(objectRef.value)) {
                    const copy = [
                        ...objectRef.value
                    ];
                    copy[key] = v;
                    objectRef.value = copy;
                } else {
                    const newObject = $78bd828b180e977b$var$__spreadProps$5($78bd828b180e977b$var$__spreadValues$7({}, objectRef.value), {
                        [key]: v
                    });
                    Object.setPrototypeOf(newObject, objectRef.value);
                    objectRef.value = newObject;
                }
            }
        }));
    return result;
}
function $78bd828b180e977b$export$25180f6b7105226e(fn, sync = true) {
    if ((0, $esfUo.getCurrentInstance)()) (0, $esfUo.onBeforeMount)(fn);
    else if (sync) fn();
    else (0, $esfUo.nextTick)(fn);
}
function $78bd828b180e977b$export$7b037ce8d7969c15(fn) {
    if ((0, $esfUo.getCurrentInstance)()) (0, $esfUo.onBeforeUnmount)(fn);
}
function $78bd828b180e977b$export$cf1be5b643f0827(fn, sync = true) {
    if ((0, $esfUo.getCurrentInstance)()) (0, $esfUo.onMounted)(fn);
    else if (sync) fn();
    else (0, $esfUo.nextTick)(fn);
}
function $78bd828b180e977b$export$9fa6e59ca833c930(fn) {
    if ((0, $esfUo.getCurrentInstance)()) (0, $esfUo.onUnmounted)(fn);
}
function $78bd828b180e977b$var$createUntil(r, isNot = false) {
    function toMatch(condition, { flush: flush = "sync", deep: deep = false, timeout: timeout, throwOnTimeout: throwOnTimeout } = {}) {
        let stop = null;
        const watcher = new Promise((resolve)=>{
            stop = (0, $esfUo.watch)(r, (v)=>{
                if (condition(v) !== isNot) {
                    stop == null || stop();
                    resolve(v);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        const promises = [
            watcher
        ];
        if (timeout != null) promises.push($78bd828b180e977b$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(()=>$78bd828b180e977b$export$13fbab860e8afb41(r)).finally(()=>stop == null ? void 0 : stop()));
        return Promise.race(promises);
    }
    function toBe(value, options) {
        if (!(0, $am4TS.isRef)(value)) return toMatch((v)=>v === value, options);
        const { flush: flush = "sync", deep: deep = false, timeout: timeout, throwOnTimeout: throwOnTimeout } = options != null ? options : {};
        let stop = null;
        const watcher = new Promise((resolve)=>{
            stop = (0, $esfUo.watch)([
                r,
                value
            ], ([v1, v2])=>{
                if (isNot !== (v1 === v2)) {
                    stop == null || stop();
                    resolve(v1);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        const promises = [
            watcher
        ];
        if (timeout != null) promises.push($78bd828b180e977b$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(()=>$78bd828b180e977b$export$13fbab860e8afb41(r)).finally(()=>{
            stop == null || stop();
            return $78bd828b180e977b$export$13fbab860e8afb41(r);
        }));
        return Promise.race(promises);
    }
    function toBeTruthy(options) {
        return toMatch((v)=>Boolean(v), options);
    }
    function toBeNull(options) {
        return toBe(null, options);
    }
    function toBeUndefined(options) {
        return toBe(void 0, options);
    }
    function toBeNaN(options) {
        return toMatch(Number.isNaN, options);
    }
    function toContains(value, options) {
        return toMatch((v)=>{
            const array = Array.from(v);
            return array.includes(value) || array.includes($78bd828b180e977b$export$13fbab860e8afb41(value));
        }, options);
    }
    function changed(options) {
        return changedTimes(1, options);
    }
    function changedTimes(n = 1, options) {
        let count = -1;
        return toMatch(()=>{
            count += 1;
            return count >= n;
        }, options);
    }
    if (Array.isArray($78bd828b180e977b$export$13fbab860e8afb41(r))) {
        const instance = {
            toMatch: toMatch,
            toContains: toContains,
            changed: changed,
            changedTimes: changedTimes,
            get not () {
                return $78bd828b180e977b$var$createUntil(r, !isNot);
            }
        };
        return instance;
    } else {
        const instance = {
            toMatch: toMatch,
            toBe: toBe,
            toBeTruthy: toBeTruthy,
            toBeNull: toBeNull,
            toBeNaN: toBeNaN,
            toBeUndefined: toBeUndefined,
            changed: changed,
            changedTimes: changedTimes,
            get not () {
                return $78bd828b180e977b$var$createUntil(r, !isNot);
            }
        };
        return instance;
    }
}
function $78bd828b180e977b$export$a40009bd2c363351(r) {
    return $78bd828b180e977b$var$createUntil(r);
}
function $78bd828b180e977b$export$1e5a400faddb345f(list, fn) {
    return (0, $am4TS.computed)(()=>$78bd828b180e977b$export$13fbab860e8afb41(list).every((element, index, array)=>fn($78bd828b180e977b$export$13fbab860e8afb41(element), index, array)));
}
function $78bd828b180e977b$export$d62e4083f0a2d244(list, fn) {
    return (0, $am4TS.computed)(()=>$78bd828b180e977b$export$13fbab860e8afb41(list).map((i)=>$78bd828b180e977b$export$13fbab860e8afb41(i)).filter(fn));
}
function $78bd828b180e977b$export$ace4ef07c63f605e(list, fn) {
    return (0, $am4TS.computed)(()=>$78bd828b180e977b$export$13fbab860e8afb41($78bd828b180e977b$export$13fbab860e8afb41(list).find((element, index, array)=>fn($78bd828b180e977b$export$13fbab860e8afb41(element), index, array))));
}
function $78bd828b180e977b$export$3ec066cdb63e2970(list, fn) {
    return (0, $am4TS.computed)(()=>$78bd828b180e977b$export$13fbab860e8afb41(list).findIndex((element, index, array)=>fn($78bd828b180e977b$export$13fbab860e8afb41(element), index, array)));
}
function $78bd828b180e977b$var$findLast(arr, cb) {
    let index = arr.length;
    while(index-- > 0){
        if (cb(arr[index], index, arr)) return arr[index];
    }
    return void 0;
}
function $78bd828b180e977b$export$b59cd47693a134f7(list, fn) {
    return (0, $am4TS.computed)(()=>$78bd828b180e977b$export$13fbab860e8afb41(!Array.prototype.findLast ? $78bd828b180e977b$var$findLast($78bd828b180e977b$export$13fbab860e8afb41(list), (element, index, array)=>fn($78bd828b180e977b$export$13fbab860e8afb41(element), index, array)) : $78bd828b180e977b$export$13fbab860e8afb41(list).findLast((element, index, array)=>fn($78bd828b180e977b$export$13fbab860e8afb41(element), index, array))));
}
function $78bd828b180e977b$export$4a02928bbff39848(list, separator) {
    return (0, $am4TS.computed)(()=>$78bd828b180e977b$export$13fbab860e8afb41(list).map((i)=>$78bd828b180e977b$export$13fbab860e8afb41(i)).join($78bd828b180e977b$export$13fbab860e8afb41(separator)));
}
function $78bd828b180e977b$export$8cc4758f083c4ffe(list, fn) {
    return (0, $am4TS.computed)(()=>$78bd828b180e977b$export$13fbab860e8afb41(list).map((i)=>$78bd828b180e977b$export$13fbab860e8afb41(i)).map(fn));
}
function $78bd828b180e977b$export$2a4c0ee40e3400de(list, reducer, ...args) {
    const reduceCallback = (sum, value, index)=>reducer($78bd828b180e977b$export$13fbab860e8afb41(sum), $78bd828b180e977b$export$13fbab860e8afb41(value), index);
    return (0, $am4TS.computed)(()=>{
        const resolved = $78bd828b180e977b$export$13fbab860e8afb41(list);
        return args.length ? resolved.reduce(reduceCallback, $78bd828b180e977b$export$13fbab860e8afb41(args[0])) : resolved.reduce(reduceCallback);
    });
}
function $78bd828b180e977b$export$53834b0e1a20e7a3(list, fn) {
    return (0, $am4TS.computed)(()=>$78bd828b180e977b$export$13fbab860e8afb41(list).some((element, index, array)=>fn($78bd828b180e977b$export$13fbab860e8afb41(element), index, array)));
}
function $78bd828b180e977b$export$1b97ec936c2f7d03(list) {
    return (0, $am4TS.computed)(()=>[
            ...new Set($78bd828b180e977b$export$13fbab860e8afb41(list).map((element)=>$78bd828b180e977b$export$13fbab860e8afb41(element)))
        ]);
}
function $78bd828b180e977b$export$70c4067197c60e2d(initialValue = 0, options = {}) {
    const count = (0, $am4TS.ref)(initialValue);
    const { max: max = Infinity, min: min = -Infinity } = options;
    const inc = (delta = 1)=>count.value = Math.min(max, count.value + delta);
    const dec = (delta = 1)=>count.value = Math.max(min, count.value - delta);
    const get = ()=>count.value;
    const set = (val)=>count.value = Math.max(min, Math.min(max, val));
    const reset = (val = initialValue)=>{
        initialValue = val;
        return set(val);
    };
    return {
        count: count,
        inc: inc,
        dec: dec,
        get: get,
        set: set,
        reset: reset
    };
}
const $78bd828b180e977b$var$REGEX_PARSE = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/;
const $78bd828b180e977b$var$REGEX_FORMAT = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a{1,2}|A{1,2}|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
const $78bd828b180e977b$var$defaultMeridiem = (hours, minutes, isLowercase, hasPeriod)=>{
    let m = hours < 12 ? "AM" : "PM";
    if (hasPeriod) m = m.split("").reduce((acc, curr)=>acc += `${curr}.`, "");
    return isLowercase ? m.toLowerCase() : m;
};
const $78bd828b180e977b$export$3ae94a2503e890a1 = (date, formatStr, options = {})=>{
    var _a;
    const years = date.getFullYear();
    const month = date.getMonth();
    const days = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const milliseconds = date.getMilliseconds();
    const day = date.getDay();
    const meridiem = (_a = options.customMeridiem) != null ? _a : $78bd828b180e977b$var$defaultMeridiem;
    const matches = {
        YY: ()=>String(years).slice(-2),
        YYYY: ()=>years,
        M: ()=>month + 1,
        MM: ()=>`${month + 1}`.padStart(2, "0"),
        MMM: ()=>date.toLocaleDateString(options.locales, {
                month: "short"
            }),
        MMMM: ()=>date.toLocaleDateString(options.locales, {
                month: "long"
            }),
        D: ()=>String(days),
        DD: ()=>`${days}`.padStart(2, "0"),
        H: ()=>String(hours),
        HH: ()=>`${hours}`.padStart(2, "0"),
        h: ()=>`${hours % 12 || 12}`.padStart(1, "0"),
        hh: ()=>`${hours % 12 || 12}`.padStart(2, "0"),
        m: ()=>String(minutes),
        mm: ()=>`${minutes}`.padStart(2, "0"),
        s: ()=>String(seconds),
        ss: ()=>`${seconds}`.padStart(2, "0"),
        SSS: ()=>`${milliseconds}`.padStart(3, "0"),
        d: ()=>day,
        dd: ()=>date.toLocaleDateString(options.locales, {
                weekday: "narrow"
            }),
        ddd: ()=>date.toLocaleDateString(options.locales, {
                weekday: "short"
            }),
        dddd: ()=>date.toLocaleDateString(options.locales, {
                weekday: "long"
            }),
        A: ()=>meridiem(hours, minutes),
        AA: ()=>meridiem(hours, minutes, false, true),
        a: ()=>meridiem(hours, minutes, true),
        aa: ()=>meridiem(hours, minutes, true, true)
    };
    return formatStr.replace($78bd828b180e977b$var$REGEX_FORMAT, (match, $1)=>$1 || matches[match]());
};
const $78bd828b180e977b$export$fcc71269590ba0a8 = (date)=>{
    if (date === null) return new Date(NaN);
    if (date === void 0) return new Date();
    if (date instanceof Date) return new Date(date);
    if (typeof date === "string" && !/Z$/i.test(date)) {
        const d = date.match($78bd828b180e977b$var$REGEX_PARSE);
        if (d) {
            const m = d[2] - 1 || 0;
            const ms = (d[7] || "0").substring(0, 3);
            return new Date(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms);
        }
    }
    return new Date(date);
};
function $78bd828b180e977b$export$6d181172004bc6fc(date, formatStr = "HH:mm:ss", options = {}) {
    return (0, $am4TS.computed)(()=>$78bd828b180e977b$export$3ae94a2503e890a1($78bd828b180e977b$export$fcc71269590ba0a8($78bd828b180e977b$export$13fbab860e8afb41(date)), $78bd828b180e977b$export$13fbab860e8afb41(formatStr), options));
}
function $78bd828b180e977b$export$35ee30a05e4f2223(cb, interval = 1e3, options = {}) {
    const { immediate: immediate = true, immediateCallback: immediateCallback = false } = options;
    let timer = null;
    const isActive = (0, $am4TS.ref)(false);
    function clean() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }
    function pause() {
        isActive.value = false;
        clean();
    }
    function resume() {
        const intervalValue = $78bd828b180e977b$export$13fbab860e8afb41(interval);
        if (intervalValue <= 0) return;
        isActive.value = true;
        if (immediateCallback) cb();
        clean();
        timer = setInterval(cb, intervalValue);
    }
    if (immediate && $78bd828b180e977b$export$7383f122bf48ec30) resume();
    if ((0, $am4TS.isRef)(interval) || $78bd828b180e977b$export$f6e2535fb5126e54(interval)) {
        const stopWatch = (0, $esfUo.watch)(interval, ()=>{
            if (isActive.value && $78bd828b180e977b$export$7383f122bf48ec30) resume();
        });
        $78bd828b180e977b$export$c3d49ae4e58d3d9d(stopWatch);
    }
    $78bd828b180e977b$export$c3d49ae4e58d3d9d(pause);
    return {
        isActive: isActive,
        pause: pause,
        resume: resume
    };
}
var $78bd828b180e977b$var$__defProp$6 = Object.defineProperty;
var $78bd828b180e977b$var$__getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var $78bd828b180e977b$var$__hasOwnProp$8 = Object.prototype.hasOwnProperty;
var $78bd828b180e977b$var$__propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var $78bd828b180e977b$var$__defNormalProp$6 = (obj, key, value)=>key in obj ? $78bd828b180e977b$var$__defProp$6(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $78bd828b180e977b$var$__spreadValues$6 = (a, b)=>{
    for(var prop in b || (b = {}))if ($78bd828b180e977b$var$__hasOwnProp$8.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$6(a, prop, b[prop]);
    if ($78bd828b180e977b$var$__getOwnPropSymbols$8) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols$8(b))if ($78bd828b180e977b$var$__propIsEnum$8.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$6(a, prop, b[prop]);
    }
    return a;
};
function $78bd828b180e977b$export$f4b266cd2aae9cb1(interval = 1e3, options = {}) {
    const { controls: exposeControls = false, immediate: immediate = true, callback: callback } = options;
    const counter = (0, $am4TS.ref)(0);
    const update = ()=>counter.value += 1;
    const reset = ()=>{
        counter.value = 0;
    };
    const controls = $78bd828b180e977b$export$35ee30a05e4f2223(callback ? ()=>{
        update();
        callback(counter.value);
    } : update, interval, {
        immediate: immediate
    });
    if (exposeControls) return $78bd828b180e977b$var$__spreadValues$6({
        counter: counter,
        reset: reset
    }, controls);
    else return counter;
}
function $78bd828b180e977b$export$de385d6f89d6db3c(source, options = {}) {
    var _a;
    const ms = (0, $am4TS.ref)((_a = options.initialValue) != null ? _a : null);
    (0, $esfUo.watch)(source, ()=>ms.value = $78bd828b180e977b$export$fc00ee57782020aa(), options);
    return ms;
}
function $78bd828b180e977b$export$14705c14c13d528a(cb, interval, options = {}) {
    const { immediate: immediate = true } = options;
    const isPending = (0, $am4TS.ref)(false);
    let timer = null;
    function clear() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    function stop() {
        isPending.value = false;
        clear();
    }
    function start(...args) {
        clear();
        isPending.value = true;
        timer = setTimeout(()=>{
            isPending.value = false;
            timer = null;
            cb(...args);
        }, $78bd828b180e977b$export$13fbab860e8afb41(interval));
    }
    if (immediate) {
        isPending.value = true;
        if ($78bd828b180e977b$export$7383f122bf48ec30) start();
    }
    $78bd828b180e977b$export$c3d49ae4e58d3d9d(stop);
    return {
        isPending: (0, $am4TS.readonly)(isPending),
        start: start,
        stop: stop
    };
}
var $78bd828b180e977b$var$__defProp$5 = Object.defineProperty;
var $78bd828b180e977b$var$__getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var $78bd828b180e977b$var$__hasOwnProp$7 = Object.prototype.hasOwnProperty;
var $78bd828b180e977b$var$__propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var $78bd828b180e977b$var$__defNormalProp$5 = (obj, key, value)=>key in obj ? $78bd828b180e977b$var$__defProp$5(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $78bd828b180e977b$var$__spreadValues$5 = (a, b)=>{
    for(var prop in b || (b = {}))if ($78bd828b180e977b$var$__hasOwnProp$7.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$5(a, prop, b[prop]);
    if ($78bd828b180e977b$var$__getOwnPropSymbols$7) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols$7(b))if ($78bd828b180e977b$var$__propIsEnum$7.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$5(a, prop, b[prop]);
    }
    return a;
};
function $78bd828b180e977b$export$d8e6abf214c9ec0f(interval = 1e3, options = {}) {
    const { controls: exposeControls = false, callback: callback } = options;
    const controls = $78bd828b180e977b$export$14705c14c13d528a(callback != null ? callback : $78bd828b180e977b$export$8793edee2d425525, interval, options);
    const ready = (0, $am4TS.computed)(()=>!controls.isPending.value);
    if (exposeControls) return $78bd828b180e977b$var$__spreadValues$5({
        ready: ready
    }, controls);
    else return ready;
}
function $78bd828b180e977b$export$1ee6bb1f922f50b3(value, options = {}) {
    const { method: method = "parseFloat", radix: radix, nanToZero: nanToZero } = options;
    return (0, $am4TS.computed)(()=>{
        let resolved = $78bd828b180e977b$export$13fbab860e8afb41(value);
        if (typeof resolved === "string") resolved = Number[method](resolved, radix);
        if (nanToZero && isNaN(resolved)) resolved = 0;
        return resolved;
    });
}
function $78bd828b180e977b$export$8906942fea47e698(value) {
    return (0, $am4TS.computed)(()=>`${$78bd828b180e977b$export$13fbab860e8afb41(value)}`);
}
function $78bd828b180e977b$export$cbe85ee05b554577(initialValue = false, options = {}) {
    const { truthyValue: truthyValue = true, falsyValue: falsyValue = false } = options;
    const valueIsRef = (0, $am4TS.isRef)(initialValue);
    const _value = (0, $am4TS.ref)(initialValue);
    function toggle(value) {
        if (arguments.length) {
            _value.value = value;
            return _value.value;
        } else {
            const truthy = $78bd828b180e977b$export$13fbab860e8afb41(truthyValue);
            _value.value = _value.value === truthy ? $78bd828b180e977b$export$13fbab860e8afb41(falsyValue) : truthy;
            return _value.value;
        }
    }
    if (valueIsRef) return toggle;
    else return [
        _value,
        toggle
    ];
}
function $78bd828b180e977b$export$8ebd2befe4deaa6b(source, cb, options) {
    let oldList = (options == null ? void 0 : options.immediate) ? [] : [
        ...source instanceof Function ? source() : Array.isArray(source) ? source : (0, $am4TS.unref)(source)
    ];
    return (0, $esfUo.watch)(source, (newList, _, onCleanup)=>{
        const oldListRemains = new Array(oldList.length);
        const added = [];
        for (const obj of newList){
            let found = false;
            for(let i = 0; i < oldList.length; i++)if (!oldListRemains[i] && obj === oldList[i]) {
                oldListRemains[i] = true;
                found = true;
                break;
            }
            if (!found) added.push(obj);
        }
        const removed = oldList.filter((_2, i)=>!oldListRemains[i]);
        cb(newList, oldList, added, removed, onCleanup);
        oldList = [
            ...newList
        ];
    }, options);
}
var $78bd828b180e977b$var$__getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var $78bd828b180e977b$var$__hasOwnProp$6 = Object.prototype.hasOwnProperty;
var $78bd828b180e977b$var$__propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var $78bd828b180e977b$var$__objRest$5 = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($78bd828b180e977b$var$__hasOwnProp$6.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $78bd828b180e977b$var$__getOwnPropSymbols$6) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols$6(source))if (exclude.indexOf(prop) < 0 && $78bd828b180e977b$var$__propIsEnum$6.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $78bd828b180e977b$export$3955c00bb6715986(source, cb, options = {}) {
    const _a = options, { eventFilter: eventFilter = $78bd828b180e977b$export$8cc0e33a27868391 } = _a, watchOptions = $78bd828b180e977b$var$__objRest$5(_a, [
        "eventFilter"
    ]);
    return (0, $esfUo.watch)(source, $78bd828b180e977b$export$a1f1cf91007f23bf(eventFilter, cb), watchOptions);
}
var $78bd828b180e977b$var$__getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var $78bd828b180e977b$var$__hasOwnProp$5 = Object.prototype.hasOwnProperty;
var $78bd828b180e977b$var$__propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var $78bd828b180e977b$var$__objRest$4 = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($78bd828b180e977b$var$__hasOwnProp$5.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $78bd828b180e977b$var$__getOwnPropSymbols$5) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols$5(source))if (exclude.indexOf(prop) < 0 && $78bd828b180e977b$var$__propIsEnum$5.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $78bd828b180e977b$export$a121c3bc1a97f0b4(source, cb, options) {
    const _a = options, { count: count } = _a, watchOptions = $78bd828b180e977b$var$__objRest$4(_a, [
        "count"
    ]);
    const current = (0, $am4TS.ref)(0);
    const stop = $78bd828b180e977b$export$3955c00bb6715986(source, (...args)=>{
        current.value += 1;
        if (current.value >= $78bd828b180e977b$export$13fbab860e8afb41(count)) (0, $esfUo.nextTick)(()=>stop());
        cb(...args);
    }, watchOptions);
    return {
        count: current,
        stop: stop
    };
}
var $78bd828b180e977b$var$__defProp$4 = Object.defineProperty;
var $78bd828b180e977b$var$__defProps$4 = Object.defineProperties;
var $78bd828b180e977b$var$__getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var $78bd828b180e977b$var$__getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var $78bd828b180e977b$var$__hasOwnProp$4 = Object.prototype.hasOwnProperty;
var $78bd828b180e977b$var$__propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var $78bd828b180e977b$var$__defNormalProp$4 = (obj, key, value)=>key in obj ? $78bd828b180e977b$var$__defProp$4(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $78bd828b180e977b$var$__spreadValues$4 = (a, b)=>{
    for(var prop in b || (b = {}))if ($78bd828b180e977b$var$__hasOwnProp$4.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$4(a, prop, b[prop]);
    if ($78bd828b180e977b$var$__getOwnPropSymbols$4) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols$4(b))if ($78bd828b180e977b$var$__propIsEnum$4.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$4(a, prop, b[prop]);
    }
    return a;
};
var $78bd828b180e977b$var$__spreadProps$4 = (a, b)=>$78bd828b180e977b$var$__defProps$4(a, $78bd828b180e977b$var$__getOwnPropDescs$4(b));
var $78bd828b180e977b$var$__objRest$3 = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($78bd828b180e977b$var$__hasOwnProp$4.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $78bd828b180e977b$var$__getOwnPropSymbols$4) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols$4(source))if (exclude.indexOf(prop) < 0 && $78bd828b180e977b$var$__propIsEnum$4.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $78bd828b180e977b$export$578b5d9cbe132cee(source, cb, options = {}) {
    const _a = options, { debounce: debounce = 0, maxWait: maxWait } = _a, watchOptions = $78bd828b180e977b$var$__objRest$3(_a, [
        "debounce",
        "maxWait"
    ]);
    return $78bd828b180e977b$export$3955c00bb6715986(source, cb, $78bd828b180e977b$var$__spreadProps$4($78bd828b180e977b$var$__spreadValues$4({}, watchOptions), {
        eventFilter: $78bd828b180e977b$export$fca2c450ae03b38e(debounce, {
            maxWait: maxWait
        })
    }));
}
var $78bd828b180e977b$var$__defProp$3 = Object.defineProperty;
var $78bd828b180e977b$var$__defProps$3 = Object.defineProperties;
var $78bd828b180e977b$var$__getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var $78bd828b180e977b$var$__getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var $78bd828b180e977b$var$__hasOwnProp$3 = Object.prototype.hasOwnProperty;
var $78bd828b180e977b$var$__propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var $78bd828b180e977b$var$__defNormalProp$3 = (obj, key, value)=>key in obj ? $78bd828b180e977b$var$__defProp$3(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $78bd828b180e977b$var$__spreadValues$3 = (a, b)=>{
    for(var prop in b || (b = {}))if ($78bd828b180e977b$var$__hasOwnProp$3.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$3(a, prop, b[prop]);
    if ($78bd828b180e977b$var$__getOwnPropSymbols$3) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols$3(b))if ($78bd828b180e977b$var$__propIsEnum$3.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$3(a, prop, b[prop]);
    }
    return a;
};
var $78bd828b180e977b$var$__spreadProps$3 = (a, b)=>$78bd828b180e977b$var$__defProps$3(a, $78bd828b180e977b$var$__getOwnPropDescs$3(b));
var $78bd828b180e977b$var$__objRest$2 = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($78bd828b180e977b$var$__hasOwnProp$3.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $78bd828b180e977b$var$__getOwnPropSymbols$3) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols$3(source))if (exclude.indexOf(prop) < 0 && $78bd828b180e977b$var$__propIsEnum$3.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $78bd828b180e977b$export$63ac06655f58d92a(source, cb, options = {}) {
    const _a = options, { eventFilter: eventFilter = $78bd828b180e977b$export$8cc0e33a27868391 } = _a, watchOptions = $78bd828b180e977b$var$__objRest$2(_a, [
        "eventFilter"
    ]);
    const filteredCb = $78bd828b180e977b$export$a1f1cf91007f23bf(eventFilter, cb);
    let ignoreUpdates;
    let ignorePrevAsyncUpdates;
    let stop;
    if (watchOptions.flush === "sync") {
        const ignore = (0, $am4TS.ref)(false);
        ignorePrevAsyncUpdates = ()=>{};
        ignoreUpdates = (updater)=>{
            ignore.value = true;
            updater();
            ignore.value = false;
        };
        stop = (0, $esfUo.watch)(source, (...args)=>{
            if (!ignore.value) filteredCb(...args);
        }, watchOptions);
    } else {
        const disposables = [];
        const ignoreCounter = (0, $am4TS.ref)(0);
        const syncCounter = (0, $am4TS.ref)(0);
        ignorePrevAsyncUpdates = ()=>{
            ignoreCounter.value = syncCounter.value;
        };
        disposables.push((0, $esfUo.watch)(source, ()=>{
            syncCounter.value++;
        }, $78bd828b180e977b$var$__spreadProps$3($78bd828b180e977b$var$__spreadValues$3({}, watchOptions), {
            flush: "sync"
        })));
        ignoreUpdates = (updater)=>{
            const syncCounterPrev = syncCounter.value;
            updater();
            ignoreCounter.value += syncCounter.value - syncCounterPrev;
        };
        disposables.push((0, $esfUo.watch)(source, (...args)=>{
            const ignore = ignoreCounter.value > 0 && ignoreCounter.value === syncCounter.value;
            ignoreCounter.value = 0;
            syncCounter.value = 0;
            if (ignore) return;
            filteredCb(...args);
        }, watchOptions));
        stop = ()=>{
            disposables.forEach((fn)=>fn());
        };
    }
    return {
        stop: stop,
        ignoreUpdates: ignoreUpdates,
        ignorePrevAsyncUpdates: ignorePrevAsyncUpdates
    };
}
function $78bd828b180e977b$export$95d4a8ca30b80ae0(source, cb, options) {
    const stop = (0, $esfUo.watch)(source, (...args)=>{
        (0, $esfUo.nextTick)(()=>stop());
        return cb(...args);
    }, options);
}
var $78bd828b180e977b$var$__defProp$2 = Object.defineProperty;
var $78bd828b180e977b$var$__defProps$2 = Object.defineProperties;
var $78bd828b180e977b$var$__getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var $78bd828b180e977b$var$__getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var $78bd828b180e977b$var$__hasOwnProp$2 = Object.prototype.hasOwnProperty;
var $78bd828b180e977b$var$__propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var $78bd828b180e977b$var$__defNormalProp$2 = (obj, key, value)=>key in obj ? $78bd828b180e977b$var$__defProp$2(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $78bd828b180e977b$var$__spreadValues$2 = (a, b)=>{
    for(var prop in b || (b = {}))if ($78bd828b180e977b$var$__hasOwnProp$2.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$2(a, prop, b[prop]);
    if ($78bd828b180e977b$var$__getOwnPropSymbols$2) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols$2(b))if ($78bd828b180e977b$var$__propIsEnum$2.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$2(a, prop, b[prop]);
    }
    return a;
};
var $78bd828b180e977b$var$__spreadProps$2 = (a, b)=>$78bd828b180e977b$var$__defProps$2(a, $78bd828b180e977b$var$__getOwnPropDescs$2(b));
var $78bd828b180e977b$var$__objRest$1 = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($78bd828b180e977b$var$__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $78bd828b180e977b$var$__getOwnPropSymbols$2) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols$2(source))if (exclude.indexOf(prop) < 0 && $78bd828b180e977b$var$__propIsEnum$2.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $78bd828b180e977b$export$37fdf671f882195e(source, cb, options = {}) {
    const _a = options, { eventFilter: filter } = _a, watchOptions = $78bd828b180e977b$var$__objRest$1(_a, [
        "eventFilter"
    ]);
    const { eventFilter: eventFilter, pause: pause, resume: resume, isActive: isActive } = $78bd828b180e977b$export$8d46ce8e0ead9c2b(filter);
    const stop = $78bd828b180e977b$export$3955c00bb6715986(source, cb, $78bd828b180e977b$var$__spreadProps$2($78bd828b180e977b$var$__spreadValues$2({}, watchOptions), {
        eventFilter: eventFilter
    }));
    return {
        stop: stop,
        pause: pause,
        resume: resume,
        isActive: isActive
    };
}
var $78bd828b180e977b$var$__defProp$1 = Object.defineProperty;
var $78bd828b180e977b$var$__defProps$1 = Object.defineProperties;
var $78bd828b180e977b$var$__getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var $78bd828b180e977b$var$__getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var $78bd828b180e977b$var$__hasOwnProp$1 = Object.prototype.hasOwnProperty;
var $78bd828b180e977b$var$__propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var $78bd828b180e977b$var$__defNormalProp$1 = (obj, key, value)=>key in obj ? $78bd828b180e977b$var$__defProp$1(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $78bd828b180e977b$var$__spreadValues$1 = (a, b)=>{
    for(var prop in b || (b = {}))if ($78bd828b180e977b$var$__hasOwnProp$1.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$1(a, prop, b[prop]);
    if ($78bd828b180e977b$var$__getOwnPropSymbols$1) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols$1(b))if ($78bd828b180e977b$var$__propIsEnum$1.call(b, prop)) $78bd828b180e977b$var$__defNormalProp$1(a, prop, b[prop]);
    }
    return a;
};
var $78bd828b180e977b$var$__spreadProps$1 = (a, b)=>$78bd828b180e977b$var$__defProps$1(a, $78bd828b180e977b$var$__getOwnPropDescs$1(b));
var $78bd828b180e977b$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($78bd828b180e977b$var$__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $78bd828b180e977b$var$__getOwnPropSymbols$1) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols$1(source))if (exclude.indexOf(prop) < 0 && $78bd828b180e977b$var$__propIsEnum$1.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $78bd828b180e977b$export$2768dce732d5eb3(source, cb, options = {}) {
    const _a = options, { throttle: throttle = 0, trailing: trailing = true, leading: leading = true } = _a, watchOptions = $78bd828b180e977b$var$__objRest(_a, [
        "throttle",
        "trailing",
        "leading"
    ]);
    return $78bd828b180e977b$export$3955c00bb6715986(source, cb, $78bd828b180e977b$var$__spreadProps$1($78bd828b180e977b$var$__spreadValues$1({}, watchOptions), {
        eventFilter: $78bd828b180e977b$export$cd62e9dbf204fd92(throttle, trailing, leading)
    }));
}
var $78bd828b180e977b$var$__defProp = Object.defineProperty;
var $78bd828b180e977b$var$__defProps = Object.defineProperties;
var $78bd828b180e977b$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $78bd828b180e977b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $78bd828b180e977b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $78bd828b180e977b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $78bd828b180e977b$var$__defNormalProp = (obj, key, value)=>key in obj ? $78bd828b180e977b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $78bd828b180e977b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($78bd828b180e977b$var$__hasOwnProp.call(b, prop)) $78bd828b180e977b$var$__defNormalProp(a, prop, b[prop]);
    if ($78bd828b180e977b$var$__getOwnPropSymbols) {
        for (var prop of $78bd828b180e977b$var$__getOwnPropSymbols(b))if ($78bd828b180e977b$var$__propIsEnum.call(b, prop)) $78bd828b180e977b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $78bd828b180e977b$var$__spreadProps = (a, b)=>$78bd828b180e977b$var$__defProps(a, $78bd828b180e977b$var$__getOwnPropDescs(b));
function $78bd828b180e977b$export$b75c094d1092c205(source, cb, options = {}) {
    let cleanupFn;
    function onEffect() {
        if (!cleanupFn) return;
        const fn = cleanupFn;
        cleanupFn = void 0;
        fn();
    }
    function onCleanup(callback) {
        cleanupFn = callback;
    }
    const _cb = (value, oldValue)=>{
        onEffect();
        return cb(value, oldValue, onCleanup);
    };
    const res = $78bd828b180e977b$export$63ac06655f58d92a(source, _cb, options);
    const { ignoreUpdates: ignoreUpdates } = res;
    const trigger = ()=>{
        let res2;
        ignoreUpdates(()=>{
            res2 = _cb($78bd828b180e977b$var$getWatchSources(source), $78bd828b180e977b$var$getOldValue(source));
        });
        return res2;
    };
    return $78bd828b180e977b$var$__spreadProps($78bd828b180e977b$var$__spreadValues({}, res), {
        trigger: trigger
    });
}
function $78bd828b180e977b$var$getWatchSources(sources) {
    if ((0, $am4TS.isReactive)(sources)) return sources;
    if (Array.isArray(sources)) return sources.map((item)=>$78bd828b180e977b$var$getOneWatchSource(item));
    return $78bd828b180e977b$var$getOneWatchSource(sources);
}
function $78bd828b180e977b$var$getOneWatchSource(source) {
    return typeof source === "function" ? source() : (0, $am4TS.unref)(source);
}
function $78bd828b180e977b$var$getOldValue(source) {
    return Array.isArray(source) ? source.map(()=>void 0) : void 0;
}
function $78bd828b180e977b$export$909eba9696cc3445(source, cb, options) {
    return (0, $esfUo.watch)(source, (v, ov, onInvalidate)=>{
        if (v) cb(v, ov, onInvalidate);
    }, options);
}

});


parcelRegister("kdzRz", function(module, exports) {

$parcel$export(module.exports, "useChallengeV3", function () { return $5a80fbf851097d3d$export$943d8578953ee2a2; });
parcelRequire("jwRyC");
var $am4TS = parcelRequire("am4TS");

var $i4Q9n = parcelRequire("i4Q9n");
function $5a80fbf851097d3d$export$943d8578953ee2a2(action) {
    const siteKey = (0, $i4Q9n.useAssertV3SiteKey)();
    const proxy = (0, $i4Q9n.useRecaptchaProxy)();
    const response = (0, $am4TS.ref)();
    return {
        response: response,
        async execute () {
            return response.value = await proxy.execute(siteKey, {
                action: action
            });
        }
    };
}

});

parcelRegister("6AdLA", function(module, exports) {

$parcel$export(module.exports, "useRecaptchaProvider", function () { return $1406b2ecaf59fd9c$export$dff50aacb899926e; });
parcelRequire("jwRyC");
var $esfUo = parcelRequire("esfUo");

var $i4Q9n = parcelRequire("i4Q9n");

var $17Esm = parcelRequire("17Esm");

var $bS1Ya = parcelRequire("bS1Ya");
function $1406b2ecaf59fd9c$export$dff50aacb899926e() {
    const ctx = (0, $i4Q9n.useRecaptchaContext)();
    if (ctx.scriptInjected) (0, $bS1Ya.warn)("`useRecaptchaProvider` is used multiple time");
    else {
        ctx.scriptInjected = true;
        ctx.useScriptProvider();
        (0, $esfUo.onMounted)(()=>{
            (0, $17Esm.checkRecaptchaLoad)();
        });
    }
}

});

parcelRegister("ksyNw", function(module, exports) {
let $ee516a4b2c8514ea$var$script;



let $ee516a4b2c8514ea$var$initialize = ()=>{
    $ee516a4b2c8514ea$var$script = (parcelRequire("jXukF"));
    if ($ee516a4b2c8514ea$var$script.__esModule) $ee516a4b2c8514ea$var$script = $ee516a4b2c8514ea$var$script.default;
    $ee516a4b2c8514ea$var$script.render = (parcelRequire("1v8e6")).render;
    (parcelRequire("dZqL0")).default($ee516a4b2c8514ea$var$script);
    $ee516a4b2c8514ea$var$script.__scopeId = "data-v-999a75";
    $ee516a4b2c8514ea$var$script.__file = "ChallengeV2.vue";
};
$ee516a4b2c8514ea$var$initialize();
var $ee516a4b2c8514ea$export$2e2bcd8739ae039 = $ee516a4b2c8514ea$var$script;

});
parcelRegister("jXukF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f217e98f82163964$export$2e2bcd8739ae039; });
parcelRequire("hQJKw");
var $esfUo = parcelRequire("esfUo");
parcelRequire("jwRyC");
var $am4TS = parcelRequire("am4TS");

var $a99rn = parcelRequire("a99rn");
var $f217e98f82163964$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $esfUo.defineComponent)({
    __name: "ChallengeV2",
    props: {
        as: {
            default: "div"
        },
        widgetId: null,
        badge: {
            default: "bottomright"
        },
        tabindex: null,
        autoExecute: {
            type: Boolean,
            default: true
        },
        modelValue: null
    },
    emits: [
        "load",
        "error",
        "expired",
        "success",
        "update:widgetId",
        "update:modelValue"
    ],
    setup (__props, { expose: expose, emit: emit }) {
        const props = __props;
        const { root: root, reset: reset, widgetID: widgetID, state: state, execute: execute, isError: isError, isExpired: isExpired, isVerified: isVerified } = (0, $a99rn.useComponentV2)({
            size: "invisible",
            badge: props.badge,
            tabindex: props.tabindex
        }, (0, $am4TS.toRef)(props, "modelValue"), emit);
        const slotApi = (0, $am4TS.reactive)({
            execute: execute,
            widgetId: widgetID,
            state: state,
            reset: reset,
            isError: isError,
            isExpired: isExpired,
            isVerified: isVerified
        });
        function onClick() {
            if (props.autoExecute) execute();
        }
        expose({
            execute: execute,
            reset: reset
        });
        const __returned__ = {
            props: props,
            emit: emit,
            root: root,
            reset: reset,
            widgetID: widgetID,
            state: state,
            execute: execute,
            isError: isError,
            isExpired: isExpired,
            isVerified: isVerified,
            slotApi: slotApi,
            onClick: onClick
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("a99rn", function(module, exports) {

$parcel$export(module.exports, "useComponentV2", function () { return $d8b7cf4aebe85af7$export$4ad78092c4032cd8; });

var $hmbgm = parcelRequire("hmbgm");
parcelRequire("jwRyC");
var $am4TS = parcelRequire("am4TS");
var $esfUo = parcelRequire("esfUo");

var $l2opB = parcelRequire("l2opB");
function $d8b7cf4aebe85af7$export$4ad78092c4032cd8(options, modelValue, emit) {
    const { root: root, state: state, widgetID: widgetID, onError: onError, onExpired: onExpired, onVerify: onVerify, reset: reset, execute: execute } = (0, $l2opB.useChallengeV2)({
        options: options || {}
    });
    const isExpired = (0, $am4TS.computed)(()=>state.value === (0, $l2opB.RecaptchaV2State).Expired);
    const isError = (0, $am4TS.computed)(()=>state.value === (0, $l2opB.RecaptchaV2State).Error);
    const isVerified = (0, $am4TS.computed)(()=>state.value === (0, $l2opB.RecaptchaV2State).Verified);
    (0, $hmbgm.whenever)(widgetID, (id)=>{
        emit("load", id);
        emit("update:widgetId", id);
    });
    (0, $esfUo.watch)(modelValue, (res, old)=>{
        if (!res && old && !isExpired.value) callReset();
    });
    onExpired(()=>{
        emit("update:modelValue", null);
        emit("expired", widgetID.value);
    });
    onError((err)=>{
        emit("error", err);
    });
    onVerify((response)=>{
        emit("success", response);
        emit("update:modelValue", response);
    });
    return {
        root: root,
        widgetID: widgetID,
        state: state,
        isError: isError,
        isExpired: isExpired,
        isVerified: isVerified,
        reset: callReset,
        execute: execute
    };
    function callReset() {
        reset();
        resetState();
    }
    function resetState() {
        emit("update:modelValue", null);
    }
}

});


parcelRegister("1v8e6", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $117f114928281d07$export$b3890eb0ae9dca99; });
parcelRequire("hQJKw");
var $esfUo = parcelRequire("esfUo");
var $8ENGG = parcelRequire("8ENGG");
const $117f114928281d07$var$_hoisted_1 = {
    ref: "root"
};
function $117f114928281d07$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $esfUo.openBlock)(), (0, $esfUo.createBlock)((0, $esfUo.resolveDynamicComponent)($props.as), {
        onClick: $setup.onClick
    }, {
        default: (0, $esfUo.withCtx)(()=>[
                (0, $esfUo.renderSlot)(_ctx.$slots, "default", (0, $8ENGG.normalizeProps)((0, $esfUo.guardReactiveProps)($setup.slotApi))),
                (0, $esfUo.createElementVNode)("div", $117f114928281d07$var$_hoisted_1, null, 512)
            ]),
        _: 3
    });
}

});

parcelRegister("dZqL0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2f5ba4c8c3e0f6f$export$2e2bcd8739ae039; });
let $a2f5ba4c8c3e0f6f$var$NOOP = ()=>{};
var $a2f5ba4c8c3e0f6f$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("b6AyC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $815c9ccb4f8332f6$export$2e2bcd8739ae039; });
let $815c9ccb4f8332f6$var$script;



let $815c9ccb4f8332f6$var$initialize = ()=>{
    $815c9ccb4f8332f6$var$script = (parcelRequire("bndUb"));
    if ($815c9ccb4f8332f6$var$script.__esModule) $815c9ccb4f8332f6$var$script = $815c9ccb4f8332f6$var$script.default;
    $815c9ccb4f8332f6$var$script.render = (parcelRequire("jTtcm")).render;
    (parcelRequire("5AKVP")).default($815c9ccb4f8332f6$var$script);
    $815c9ccb4f8332f6$var$script.__scopeId = "data-v-c5a7a9";
    $815c9ccb4f8332f6$var$script.__file = "ChallengeV3.vue";
};
$815c9ccb4f8332f6$var$initialize();
var $815c9ccb4f8332f6$export$2e2bcd8739ae039 = $815c9ccb4f8332f6$var$script;

});
parcelRegister("bndUb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $70ba382f945ffba3$export$2e2bcd8739ae039; });
parcelRequire("hQJKw");
var $esfUo = parcelRequire("esfUo");

var $hmbgm = parcelRequire("hmbgm");
parcelRequire("jwRyC");
var $am4TS = parcelRequire("am4TS");

var $kdzRz = parcelRequire("kdzRz");
var $70ba382f945ffba3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $esfUo.defineComponent)({
    __name: "ChallengeV3",
    props: {
        action: null,
        as: {
            default: "div"
        },
        autoExecute: {
            type: Boolean,
            default: true
        },
        modelValue: null
    },
    emits: [
        "update:modelValue"
    ],
    setup (__props, { expose: expose, emit: emit }) {
        expose();
        const props = __props;
        const { response: response, execute: execute } = (0, $kdzRz.useChallengeV3)(props.action);
        const slotApi = (0, $am4TS.reactive)({
            response: response,
            execute: execute
        });
        (0, $hmbgm.whenever)(response, (res)=>{
            emit("update:modelValue", res);
        });
        function onClick() {
            if (props.autoExecute) execute();
        }
        const __returned__ = {
            props: props,
            emit: emit,
            response: response,
            execute: execute,
            slotApi: slotApi,
            onClick: onClick
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("jTtcm", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $e7b9cd89931a15b7$export$b3890eb0ae9dca99; });
parcelRequire("hQJKw");
var $esfUo = parcelRequire("esfUo");
var $8ENGG = parcelRequire("8ENGG");
function $e7b9cd89931a15b7$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $esfUo.openBlock)(), (0, $esfUo.createBlock)((0, $esfUo.resolveDynamicComponent)($props.as), {
        onClick: $setup.onClick
    }, {
        default: (0, $esfUo.withCtx)(()=>[
                (0, $esfUo.renderSlot)(_ctx.$slots, "default", (0, $8ENGG.normalizeProps)((0, $esfUo.guardReactiveProps)($setup.slotApi)))
            ]),
        _: 3
    });
}

});

parcelRegister("5AKVP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4124b83ab02a4289$export$2e2bcd8739ae039; });
let $4124b83ab02a4289$var$NOOP = ()=>{};
var $4124b83ab02a4289$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("aqxf5", function(module, exports) {
let $79761e4cebaffc0f$var$script;



let $79761e4cebaffc0f$var$initialize = ()=>{
    $79761e4cebaffc0f$var$script = (parcelRequire("fY3L9"));
    if ($79761e4cebaffc0f$var$script.__esModule) $79761e4cebaffc0f$var$script = $79761e4cebaffc0f$var$script.default;
    $79761e4cebaffc0f$var$script.render = (parcelRequire("gEnDc")).render;
    (parcelRequire("8Gd61")).default($79761e4cebaffc0f$var$script);
    $79761e4cebaffc0f$var$script.__scopeId = "data-v-691f17";
    $79761e4cebaffc0f$var$script.__file = "Checkbox.vue";
};
$79761e4cebaffc0f$var$initialize();
var $79761e4cebaffc0f$export$2e2bcd8739ae039 = $79761e4cebaffc0f$var$script;

});
parcelRegister("fY3L9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $fcc1a36fd6b3fa0e$export$2e2bcd8739ae039; });
parcelRequire("hQJKw");
var $esfUo = parcelRequire("esfUo");

var $a99rn = parcelRequire("a99rn");
parcelRequire("jwRyC");
var $am4TS = parcelRequire("am4TS");
var $fcc1a36fd6b3fa0e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $esfUo.defineComponent)({
    __name: "Checkbox",
    props: {
        as: {
            default: "div"
        },
        widgetId: null,
        size: {
            default: "normal"
        },
        theme: {
            default: "light"
        },
        tabindex: null,
        modelValue: null
    },
    emits: [
        "load",
        "error",
        "expired",
        "success",
        "update:widgetId",
        "update:modelValue"
    ],
    setup (__props, { expose: expose, emit: emit }) {
        expose();
        const props = __props;
        const { root: root } = (0, $a99rn.useComponentV2)({
            theme: props.theme,
            size: props.size,
            tabindex: props.tabindex
        }, (0, $am4TS.toRef)(props, "modelValue"), emit);
        const __returned__ = {
            props: props,
            emit: emit,
            root: root
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("gEnDc", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $c1f2b66fdb4e3fba$export$b3890eb0ae9dca99; });
parcelRequire("hQJKw");
var $esfUo = parcelRequire("esfUo");
function $c1f2b66fdb4e3fba$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $esfUo.openBlock)(), (0, $esfUo.createBlock)((0, $esfUo.resolveDynamicComponent)($props.as), {
        ref: "root"
    }, null, 512);
}

});

parcelRegister("8Gd61", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $651c67926673c7e2$export$2e2bcd8739ae039; });
let $651c67926673c7e2$var$NOOP = ()=>{};
var $651c67926673c7e2$export$2e2bcd8739ae039 = (script)=>{};

});





parcelRegister("3d9Ls", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $256a2901950356e3$export$b3890eb0ae9dca99; });
parcelRequire("hQJKw");
var $esfUo = parcelRequire("esfUo");
const $256a2901950356e3$var$_withScopeId = (n)=>((0, $esfUo.pushScopeId)("data-v-77cbc5"), n = n(), (0, $esfUo.popScopeId)(), n);
const $256a2901950356e3$var$_hoisted_1 = /*#__PURE__*/ (0, $esfUo.createStaticVNode)('<div class="bg-secondary d-none d-lg-block" data-v-77cbc5><div class="container" data-v-77cbc5><div class="row justify-content-center" data-v-77cbc5><div class="col-md-10 my-3" data-v-77cbc5><a href="https://tw.nextapple.com" target="_blank" data-v-77cbc5><img class="nextapple-logo" src="https://static.nextapple.tw/web/layout/img/logo1201.svg" alt="\u58F9\u860B\u65B0\u805E\u7DB2" data-v-77cbc5></a></div></div></div></div>', 1);
const $256a2901950356e3$var$_hoisted_2 = {
    class: "bg-primary"
};
const $256a2901950356e3$var$_hoisted_3 = {
    class: "container"
};
const $256a2901950356e3$var$_hoisted_4 = {
    key: 0,
    class: "row justify-content-center"
};
const $256a2901950356e3$var$_hoisted_5 = {
    class: "col-md-10 d-flex"
};
const $256a2901950356e3$var$_hoisted_6 = {
    class: "container"
};
function $256a2901950356e3$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $esfUo.resolveComponent)("router-link");
    const _component_router_view = (0, $esfUo.resolveComponent)("router-view");
    return (0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)((0, $esfUo.Fragment), null, [
        $256a2901950356e3$var$_hoisted_1,
        (0, $esfUo.createElementVNode)("div", $256a2901950356e3$var$_hoisted_2, [
            (0, $esfUo.createElementVNode)("div", $256a2901950356e3$var$_hoisted_3, [
                _ctx.$route.path !== "/data-safety" ? ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $256a2901950356e3$var$_hoisted_4, [
                    (0, $esfUo.createElementVNode)("div", $256a2901950356e3$var$_hoisted_5, [
                        (0, $esfUo.createVNode)(_component_router_link, {
                            class: "router-link me-4",
                            to: "/"
                        }, {
                            default: (0, $esfUo.withCtx)(()=>[
                                    (0, $esfUo.createTextVNode)("\u6295\u8A34\u7206\u6599")
                                ]),
                            _: 1
                        })
                    ])
                ])) : (0, $esfUo.createCommentVNode)("", true)
            ])
        ]),
        (0, $esfUo.createElementVNode)("div", $256a2901950356e3$var$_hoisted_6, [
            (0, $esfUo.createVNode)(_component_router_view)
        ])
    ], 64);
}

});

parcelRegister("g1h0m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba99ee2053f00c9e$export$2e2bcd8739ae039; });
let $ba99ee2053f00c9e$var$NOOP = ()=>{};
var $ba99ee2053f00c9e$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("3UbMi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2d7fbced2c68d826$export$2e2bcd8739ae039; });

var $dmLO6 = parcelRequire("dmLO6");
var $2d7fbced2c68d826$export$2e2bcd8739ae039 = {
    data () {
        return {
            titleMaxLength: 15,
            message: "Ready",
            files: [],
            success: false,
            submitted: false,
            shouldCheck: false,
            loading: false,
            form: {
                title: "",
                name: "",
                tel: "",
                email: "",
                description: "",
                location: "",
                files: []
            }
        };
    },
    mounted () {},
    computed: {
        submitBtnText () {
            if (this.uploading) return "\u8ACB\u7B49\u5F85\u4E0A\u50B3\u5B8C\u6210";
            if (this.loading) return "\u63D0\u4EA4\u4E2D...";
            return "\u63D0\u4EA4";
        },
        uploading () {
            let ready = true;
            for(var i = 0; i < this.files.length; i++)ready = ready && this.files[i].ready;
            return !ready;
        },
        canSubmit () {
            return !this.uploading;
        },
        titleTooLong () {
            return this.form.title.length > this.titleMaxLength;
        },
        isValid () {
            let valid = true;
            valid = valid && this.validDesc;
            valid = valid && this.validEmail;
            valid = valid && this.validName;
            valid = valid && this.validTitle;
            valid = valid && this.validTel;
            valid = valid && !this.uploading;
            return valid;
        },
        validTitle () {
            return !this.shouldCheck || !this.titleTooLong;
        },
        validName () {
            return !this.shouldCheck || this.form.name.length;
        },
        validDesc () {
            return !this.shouldCheck || this.form.description.length;
        },
        validEmail () {
            if (!this.shouldCheck && !this.form.email) return true;
            return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i.test(this.form.email);
        },
        validTel () {
            if (!this.form.tel) return true;
            return /09\d{2}\-?\d{3}\-?\d{3}/.test(this.form.tel);
        }
    },
    methods: {
        submitForm () {
            this.shouldCheck = true;
            if (!this.isValid || this.loading) return;
            this.loading = true;
            this.submitted = true;
            const files = [];
            for(var i = 0; i < this.files.length; i++){
                const file = this.files[i];
                files.push({
                    key: file.key,
                    name: file.name,
                    isImage: file.isImage
                });
            }
            this.form.files = files;
            (0, (/*@__PURE__*/$parcel$interopDefault($dmLO6))).post("/api/upload", this.form).then(()=>{
                this.success = true;
                this.shouldCheck = false;
                this.form = {
                    title: "",
                    name: "",
                    tel: "",
                    email: "",
                    description: "",
                    location: "",
                    files: []
                };
                this.loading = false;
            }).catch(()=>{
                this.submitted = false;
                this.loading = false;
            });
        },
        uploadFiles (e) {
            const files = e.target.files;
            if (files) {
                var filesAmount = files.length;
                for(let i = 0; i < filesAmount; i++){
                    var reader = new FileReader();
                    reader.onload = (event)=>{
                        const dataUrl = event.target.result;
                        const ext = "." + files[i].name.split(".").pop();
                        (0, (/*@__PURE__*/$parcel$interopDefault($dmLO6))).get("/api/upload/pre-sign", {
                            params: {
                                ext: ext
                            }
                        }).then((resp)=>{
                            const url = resp.data.url;
                            const key = resp.data.key;
                            var formData = new FormData();
                            const isImage = dataUrl && dataUrl.startsWith("data:image");
                            formData.append("file", files[i]);
                            const result = {
                                preview: isImage ? dataUrl : "",
                                isImage: isImage,
                                key: key,
                                progress: 0,
                                ready: false,
                                name: files[i].name
                            };
                            this.files.push(result);
                            return (0, (/*@__PURE__*/$parcel$interopDefault($dmLO6))).put(url, files[i], {
                                headers: {
                                    "Content-Type": files[i].type
                                },
                                onUploadProgress: (progressEvent)=>{
                                    const progress = parseInt(Math.round(progressEvent.loaded / progressEvent.total * 100));
                                    const staging = this.files;
                                    for(var j = 0; j < staging.length; j++)if (staging[j].key === key) staging[j].progress = progress;
                                }
                            }).then(()=>{
                                const staging = this.files;
                                for(var j = 0; j < staging.length; j++)if (staging[j].key === key) staging[j].ready = true;
                            });
                        });
                    };
                    reader.readAsDataURL(files[i]);
                }
            }
        }
    }
};

});
parcelRegister("dmLO6", function(module, exports) {

module.exports = (parcelRequire("g56fq"));

});
parcelRegister("g56fq", function(module, exports) {
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");

var $2nOFy = parcelRequire("2nOFy");

var $imKR4 = parcelRequire("imKR4");

var $dBLbq = parcelRequire("dBLbq");

var $iTGwa = parcelRequire("iTGwa");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $bb51f5ad8d5e8349$var$createInstance(defaultConfig) {
    var context = new $imKR4(defaultConfig);
    var instance = $2nOFy($imKR4.prototype.request, context);
    // Copy axios.prototype to instance
    $9XE1Y.extend(instance, $imKR4.prototype, context);
    // Copy context to instance
    $9XE1Y.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $bb51f5ad8d5e8349$var$createInstance($dBLbq(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $bb51f5ad8d5e8349$var$axios = $bb51f5ad8d5e8349$var$createInstance($iTGwa);
// Expose Axios class to allow class inheritance
$bb51f5ad8d5e8349$var$axios.Axios = $imKR4;

// Expose Cancel & CancelToken
$bb51f5ad8d5e8349$var$axios.CanceledError = (parcelRequire("goZQA"));

$bb51f5ad8d5e8349$var$axios.CancelToken = (parcelRequire("8OXTg"));

$bb51f5ad8d5e8349$var$axios.isCancel = (parcelRequire("auXtX"));

$bb51f5ad8d5e8349$var$axios.VERSION = (parcelRequire("98AaB")).version;

$bb51f5ad8d5e8349$var$axios.toFormData = (parcelRequire("9FFhi"));

// Expose AxiosError class
$bb51f5ad8d5e8349$var$axios.AxiosError = (parcelRequire("8ybyJ"));
// alias for CanceledError for backward compatibility
$bb51f5ad8d5e8349$var$axios.Cancel = $bb51f5ad8d5e8349$var$axios.CanceledError;
// Expose all/spread
$bb51f5ad8d5e8349$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$bb51f5ad8d5e8349$var$axios.spread = (parcelRequire("3hRgJ"));

// Expose isAxiosError
$bb51f5ad8d5e8349$var$axios.isAxiosError = (parcelRequire("3uPXy"));
module.exports = $bb51f5ad8d5e8349$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $bb51f5ad8d5e8349$var$axios;

});
parcelRegister("9XE1Y", function(module, exports) {
"use strict";

var $2nOFy = parcelRequire("2nOFy");
// utils is a library of generic helper functions non-specific to axios
var $7408ad082c855a86$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $7408ad082c855a86$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $7408ad082c855a86$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $7408ad082c855a86$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $7408ad082c855a86$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $7408ad082c855a86$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $7408ad082c855a86$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $7408ad082c855a86$var$isBuffer(val) {
    return val !== null && !$7408ad082c855a86$var$isUndefined(val) && val.constructor !== null && !$7408ad082c855a86$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $7408ad082c855a86$var$isArrayBuffer = $7408ad082c855a86$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $7408ad082c855a86$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $7408ad082c855a86$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $7408ad082c855a86$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $7408ad082c855a86$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $7408ad082c855a86$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $7408ad082c855a86$var$isPlainObject(val) {
    if ($7408ad082c855a86$var$kindOf(val) !== "object") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $7408ad082c855a86$var$isDate = $7408ad082c855a86$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $7408ad082c855a86$var$isFile = $7408ad082c855a86$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $7408ad082c855a86$var$isBlob = $7408ad082c855a86$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $7408ad082c855a86$var$isFileList = $7408ad082c855a86$var$kindOfTest("FileList");
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $7408ad082c855a86$var$isFunction(val) {
    return $7408ad082c855a86$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $7408ad082c855a86$var$isStream(val) {
    return $7408ad082c855a86$var$isObject(val) && $7408ad082c855a86$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $7408ad082c855a86$var$isFormData(thing) {
    var pattern = "[object FormData]";
    return thing && (typeof FormData === "function" && thing instanceof FormData || $7408ad082c855a86$var$toString.call(thing) === pattern || $7408ad082c855a86$var$isFunction(thing.toString) && thing.toString() === pattern);
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $7408ad082c855a86$var$isURLSearchParams = $7408ad082c855a86$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $7408ad082c855a86$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $7408ad082c855a86$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $7408ad082c855a86$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($7408ad082c855a86$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $7408ad082c855a86$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($7408ad082c855a86$var$isPlainObject(result[key]) && $7408ad082c855a86$var$isPlainObject(val)) result[key] = $7408ad082c855a86$var$merge(result[key], val);
        else if ($7408ad082c855a86$var$isPlainObject(val)) result[key] = $7408ad082c855a86$var$merge({}, val);
        else if ($7408ad082c855a86$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$7408ad082c855a86$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $7408ad082c855a86$var$extend(a, b, thisArg) {
    $7408ad082c855a86$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $2nOFy(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $7408ad082c855a86$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $7408ad082c855a86$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */ function $7408ad082c855a86$var$toFlatObject(sourceObj, destObj, filter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if (!merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $7408ad082c855a86$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */ function $7408ad082c855a86$var$toArray(thing) {
    if (!thing) return null;
    var i = thing.length;
    if ($7408ad082c855a86$var$isUndefined(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $7408ad082c855a86$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
module.exports = {
    isArray: $7408ad082c855a86$var$isArray,
    isArrayBuffer: $7408ad082c855a86$var$isArrayBuffer,
    isBuffer: $7408ad082c855a86$var$isBuffer,
    isFormData: $7408ad082c855a86$var$isFormData,
    isArrayBufferView: $7408ad082c855a86$var$isArrayBufferView,
    isString: $7408ad082c855a86$var$isString,
    isNumber: $7408ad082c855a86$var$isNumber,
    isObject: $7408ad082c855a86$var$isObject,
    isPlainObject: $7408ad082c855a86$var$isPlainObject,
    isUndefined: $7408ad082c855a86$var$isUndefined,
    isDate: $7408ad082c855a86$var$isDate,
    isFile: $7408ad082c855a86$var$isFile,
    isBlob: $7408ad082c855a86$var$isBlob,
    isFunction: $7408ad082c855a86$var$isFunction,
    isStream: $7408ad082c855a86$var$isStream,
    isURLSearchParams: $7408ad082c855a86$var$isURLSearchParams,
    isStandardBrowserEnv: $7408ad082c855a86$var$isStandardBrowserEnv,
    forEach: $7408ad082c855a86$var$forEach,
    merge: $7408ad082c855a86$var$merge,
    extend: $7408ad082c855a86$var$extend,
    trim: $7408ad082c855a86$var$trim,
    stripBOM: $7408ad082c855a86$var$stripBOM,
    inherits: $7408ad082c855a86$var$inherits,
    toFlatObject: $7408ad082c855a86$var$toFlatObject,
    kindOf: $7408ad082c855a86$var$kindOf,
    kindOfTest: $7408ad082c855a86$var$kindOfTest,
    endsWith: $7408ad082c855a86$var$endsWith,
    toArray: $7408ad082c855a86$var$toArray,
    isTypedArray: $7408ad082c855a86$var$isTypedArray,
    isFileList: $7408ad082c855a86$var$isFileList
};

});
parcelRegister("2nOFy", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("imKR4", function(module, exports) {
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");

var $hqpcB = parcelRequire("hqpcB");

var $e253i = parcelRequire("e253i");

var $9P3Be = parcelRequire("9P3Be");

var $dBLbq = parcelRequire("dBLbq");

var $jFnSJ = parcelRequire("jFnSJ");

var $bmim6 = parcelRequire("bmim6");
var $d5eea07915edcd3d$var$validators = $bmim6.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $d5eea07915edcd3d$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $e253i(),
        response: new $e253i()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $d5eea07915edcd3d$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $dBLbq(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $bmim6.assertOptions(transitional, {
        silentJSONParsing: $d5eea07915edcd3d$var$validators.transitional($d5eea07915edcd3d$var$validators.boolean),
        forcedJSONParsing: $d5eea07915edcd3d$var$validators.transitional($d5eea07915edcd3d$var$validators.boolean),
        clarifyTimeoutError: $d5eea07915edcd3d$var$validators.transitional($d5eea07915edcd3d$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $9P3Be,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $9P3Be(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$d5eea07915edcd3d$var$Axios.prototype.getUri = function getUri(config) {
    config = $dBLbq(this.defaults, config);
    var fullPath = $jFnSJ(config.baseURL, config.url);
    return $hqpcB(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$9XE1Y.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $d5eea07915edcd3d$var$Axios.prototype[method] = function(url, config) {
        return this.request($dBLbq(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$9XE1Y.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($dBLbq(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $d5eea07915edcd3d$var$Axios.prototype[method] = generateHTTPMethod();
    $d5eea07915edcd3d$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
module.exports = $d5eea07915edcd3d$var$Axios;

});
parcelRegister("hqpcB", function(module, exports) {
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");
function $caf86a08b206cebd$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($9XE1Y.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $9XE1Y.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($9XE1Y.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $9XE1Y.forEach(val, function parseValue(v) {
                if ($9XE1Y.isDate(v)) v = v.toISOString();
                else if ($9XE1Y.isObject(v)) v = JSON.stringify(v);
                parts.push($caf86a08b206cebd$var$encode(key) + "=" + $caf86a08b206cebd$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("e253i", function(module, exports) {
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");
function $a3752bdb0583a6b9$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $a3752bdb0583a6b9$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $a3752bdb0583a6b9$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $a3752bdb0583a6b9$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $9XE1Y.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $a3752bdb0583a6b9$var$InterceptorManager;

});

parcelRegister("9P3Be", function(module, exports) {
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");

var $2mJkL = parcelRequire("2mJkL");

var $auXtX = parcelRequire("auXtX");

var $iTGwa = parcelRequire("iTGwa");

var $goZQA = parcelRequire("goZQA");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $726bab3f45d7960a$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $goZQA();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $726bab3f45d7960a$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $2mJkL.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $9XE1Y.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $9XE1Y.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $iTGwa.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $726bab3f45d7960a$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $2mJkL.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$auXtX(reason)) {
            $726bab3f45d7960a$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $2mJkL.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("2mJkL", function(module, exports) {
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");

var $iTGwa = parcelRequire("iTGwa");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $iTGwa;
    /*eslint no-param-reassign:0*/ $9XE1Y.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("iTGwa", function(module, exports) {

var $kB8J2 = parcelRequire("kB8J2");
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");

var $3goCO = parcelRequire("3goCO");

var $8ybyJ = parcelRequire("8ybyJ");

var $8Iw2D = parcelRequire("8Iw2D");

var $9FFhi = parcelRequire("9FFhi");
var $dc1e583588619cb1$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $dc1e583588619cb1$var$setContentTypeIfUnset(headers, value) {
    if (!$9XE1Y.isUndefined(headers) && $9XE1Y.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $dc1e583588619cb1$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("i1zbc"));
    else if (typeof $kB8J2 !== "undefined" && Object.prototype.toString.call($kB8J2) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("i1zbc"));
    return adapter;
}
function $dc1e583588619cb1$var$stringifySafely(rawValue, parser, encoder) {
    if ($9XE1Y.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $9XE1Y.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}

var $dc1e583588619cb1$var$defaults = {
    transitional: $8Iw2D,
    adapter: $dc1e583588619cb1$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $3goCO(headers, "Accept");
            $3goCO(headers, "Content-Type");
            if ($9XE1Y.isFormData(data) || $9XE1Y.isArrayBuffer(data) || $9XE1Y.isBuffer(data) || $9XE1Y.isStream(data) || $9XE1Y.isFile(data) || $9XE1Y.isBlob(data)) return data;
            if ($9XE1Y.isArrayBufferView(data)) return data.buffer;
            if ($9XE1Y.isURLSearchParams(data)) {
                $dc1e583588619cb1$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            var isObjectPayload = $9XE1Y.isObject(data);
            var contentType = headers && headers["Content-Type"];
            var isFileList;
            if ((isFileList = $9XE1Y.isFileList(data)) || isObjectPayload && contentType === "multipart/form-data") {
                var _FormData = this.env && this.env.FormData;
                return $9FFhi(isFileList ? {
                    "files[]": data
                } : data, _FormData && new _FormData());
            } else if (isObjectPayload || contentType === "application/json") {
                $dc1e583588619cb1$var$setContentTypeIfUnset(headers, "application/json");
                return $dc1e583588619cb1$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $dc1e583588619cb1$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $9XE1Y.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $8ybyJ.from(e, $8ybyJ.ERR_BAD_RESPONSE, this, null, this.response);
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (parcelRequire("4Zmth"))
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$9XE1Y.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $dc1e583588619cb1$var$defaults.headers[method] = {};
});
$9XE1Y.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $dc1e583588619cb1$var$defaults.headers[method] = $9XE1Y.merge($dc1e583588619cb1$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $dc1e583588619cb1$var$defaults;

});
parcelRegister("kB8J2", function(module, exports) {
// shim for using process in browser
var $efee0805b4b1b52f$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $efee0805b4b1b52f$var$cachedSetTimeout;
var $efee0805b4b1b52f$var$cachedClearTimeout;
function $efee0805b4b1b52f$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $efee0805b4b1b52f$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $efee0805b4b1b52f$var$cachedSetTimeout = setTimeout;
        else $efee0805b4b1b52f$var$cachedSetTimeout = $efee0805b4b1b52f$var$defaultSetTimout;
    } catch (e) {
        $efee0805b4b1b52f$var$cachedSetTimeout = $efee0805b4b1b52f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $efee0805b4b1b52f$var$cachedClearTimeout = clearTimeout;
        else $efee0805b4b1b52f$var$cachedClearTimeout = $efee0805b4b1b52f$var$defaultClearTimeout;
    } catch (e) {
        $efee0805b4b1b52f$var$cachedClearTimeout = $efee0805b4b1b52f$var$defaultClearTimeout;
    }
})();
function $efee0805b4b1b52f$var$runTimeout(fun) {
    if ($efee0805b4b1b52f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($efee0805b4b1b52f$var$cachedSetTimeout === $efee0805b4b1b52f$var$defaultSetTimout || !$efee0805b4b1b52f$var$cachedSetTimeout) && setTimeout) {
        $efee0805b4b1b52f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $efee0805b4b1b52f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $efee0805b4b1b52f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $efee0805b4b1b52f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $efee0805b4b1b52f$var$runClearTimeout(marker) {
    if ($efee0805b4b1b52f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($efee0805b4b1b52f$var$cachedClearTimeout === $efee0805b4b1b52f$var$defaultClearTimeout || !$efee0805b4b1b52f$var$cachedClearTimeout) && clearTimeout) {
        $efee0805b4b1b52f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $efee0805b4b1b52f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $efee0805b4b1b52f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $efee0805b4b1b52f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $efee0805b4b1b52f$var$queue = [];
var $efee0805b4b1b52f$var$draining = false;
var $efee0805b4b1b52f$var$currentQueue;
var $efee0805b4b1b52f$var$queueIndex = -1;
function $efee0805b4b1b52f$var$cleanUpNextTick() {
    if (!$efee0805b4b1b52f$var$draining || !$efee0805b4b1b52f$var$currentQueue) return;
    $efee0805b4b1b52f$var$draining = false;
    if ($efee0805b4b1b52f$var$currentQueue.length) $efee0805b4b1b52f$var$queue = $efee0805b4b1b52f$var$currentQueue.concat($efee0805b4b1b52f$var$queue);
    else $efee0805b4b1b52f$var$queueIndex = -1;
    if ($efee0805b4b1b52f$var$queue.length) $efee0805b4b1b52f$var$drainQueue();
}
function $efee0805b4b1b52f$var$drainQueue() {
    if ($efee0805b4b1b52f$var$draining) return;
    var timeout = $efee0805b4b1b52f$var$runTimeout($efee0805b4b1b52f$var$cleanUpNextTick);
    $efee0805b4b1b52f$var$draining = true;
    var len = $efee0805b4b1b52f$var$queue.length;
    while(len){
        $efee0805b4b1b52f$var$currentQueue = $efee0805b4b1b52f$var$queue;
        $efee0805b4b1b52f$var$queue = [];
        while(++$efee0805b4b1b52f$var$queueIndex < len)if ($efee0805b4b1b52f$var$currentQueue) $efee0805b4b1b52f$var$currentQueue[$efee0805b4b1b52f$var$queueIndex].run();
        $efee0805b4b1b52f$var$queueIndex = -1;
        len = $efee0805b4b1b52f$var$queue.length;
    }
    $efee0805b4b1b52f$var$currentQueue = null;
    $efee0805b4b1b52f$var$draining = false;
    $efee0805b4b1b52f$var$runClearTimeout(timeout);
}
$efee0805b4b1b52f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $efee0805b4b1b52f$var$queue.push(new $efee0805b4b1b52f$var$Item(fun, args));
    if ($efee0805b4b1b52f$var$queue.length === 1 && !$efee0805b4b1b52f$var$draining) $efee0805b4b1b52f$var$runTimeout($efee0805b4b1b52f$var$drainQueue);
};
// v8 likes predictible objects
function $efee0805b4b1b52f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$efee0805b4b1b52f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$efee0805b4b1b52f$var$process.title = "browser";
$efee0805b4b1b52f$var$process.browser = true;
$efee0805b4b1b52f$var$process.env = {};
$efee0805b4b1b52f$var$process.argv = [];
$efee0805b4b1b52f$var$process.version = ""; // empty string to avoid regexp issues
$efee0805b4b1b52f$var$process.versions = {};
function $efee0805b4b1b52f$var$noop() {}
$efee0805b4b1b52f$var$process.on = $efee0805b4b1b52f$var$noop;
$efee0805b4b1b52f$var$process.addListener = $efee0805b4b1b52f$var$noop;
$efee0805b4b1b52f$var$process.once = $efee0805b4b1b52f$var$noop;
$efee0805b4b1b52f$var$process.off = $efee0805b4b1b52f$var$noop;
$efee0805b4b1b52f$var$process.removeListener = $efee0805b4b1b52f$var$noop;
$efee0805b4b1b52f$var$process.removeAllListeners = $efee0805b4b1b52f$var$noop;
$efee0805b4b1b52f$var$process.emit = $efee0805b4b1b52f$var$noop;
$efee0805b4b1b52f$var$process.prependListener = $efee0805b4b1b52f$var$noop;
$efee0805b4b1b52f$var$process.prependOnceListener = $efee0805b4b1b52f$var$noop;
$efee0805b4b1b52f$var$process.listeners = function(name) {
    return [];
};
$efee0805b4b1b52f$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$efee0805b4b1b52f$var$process.cwd = function() {
    return "/";
};
$efee0805b4b1b52f$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$efee0805b4b1b52f$var$process.umask = function() {
    return 0;
};

});

parcelRegister("3goCO", function(module, exports) {
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $9XE1Y.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("8ybyJ", function(module, exports) {
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $639a7721c386cf51$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$9XE1Y.inherits($639a7721c386cf51$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $639a7721c386cf51$var$prototype = $639a7721c386cf51$var$AxiosError.prototype;
var $639a7721c386cf51$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED"
].forEach(function(code) {
    $639a7721c386cf51$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($639a7721c386cf51$var$AxiosError, $639a7721c386cf51$var$descriptors);
Object.defineProperty($639a7721c386cf51$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$639a7721c386cf51$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($639a7721c386cf51$var$prototype);
    $9XE1Y.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $639a7721c386cf51$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $639a7721c386cf51$var$AxiosError;

});

parcelRegister("8Iw2D", function(module, exports) {
"use strict";
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("9FFhi", function(module, exports) {

var $5FW4p = parcelRequire("5FW4p");
var $70a7f6521984c27d$require$Buffer = $5FW4p.Buffer;
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/ function $70a7f6521984c27d$var$toFormData(obj, formData) {
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    var stack = [];
    function convertValue(value) {
        if (value === null) return "";
        if ($9XE1Y.isDate(value)) return value.toISOString();
        if ($9XE1Y.isArrayBuffer(value) || $9XE1Y.isTypedArray(value)) return typeof Blob === "function" ? new Blob([
            value
        ]) : $70a7f6521984c27d$require$Buffer.from(value);
        return value;
    }
    function build(data, parentKey) {
        if ($9XE1Y.isPlainObject(data) || $9XE1Y.isArray(data)) {
            if (stack.indexOf(data) !== -1) throw Error("Circular reference detected in " + parentKey);
            stack.push(data);
            $9XE1Y.forEach(data, function each(value, key) {
                if ($9XE1Y.isUndefined(value)) return;
                var fullKey = parentKey ? parentKey + "." + key : key;
                var arr;
                if (value && !parentKey && typeof value === "object") {
                    if ($9XE1Y.endsWith(key, "{}")) // eslint-disable-next-line no-param-reassign
                    value = JSON.stringify(value);
                    else if ($9XE1Y.endsWith(key, "[]") && (arr = $9XE1Y.toArray(value))) {
                        // eslint-disable-next-line func-names
                        arr.forEach(function(el) {
                            !$9XE1Y.isUndefined(el) && formData.append(fullKey, convertValue(el));
                        });
                        return;
                    }
                }
                build(value, fullKey);
            });
            stack.pop();
        } else formData.append(parentKey, convertValue(data));
    }
    build(obj);
    return formData;
}
module.exports = $70a7f6521984c27d$var$toFormData;

});
parcelRegister("5FW4p", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $421dd39e26be894d$export$a143d493d941bafc; }, function (v) { return $421dd39e26be894d$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $421dd39e26be894d$export$f99ded8fe4b79145; }, function (v) { return $421dd39e26be894d$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $421dd39e26be894d$export$a143d493d941bafc;
var $421dd39e26be894d$export$e4cf37d7f6fb9e0a;
var $421dd39e26be894d$export$f99ded8fe4b79145;
var $421dd39e26be894d$export$599f31c3813fae4d;
"use strict";

var $jaObs = parcelRequire("jaObs");

var $2OrBb = parcelRequire("2OrBb");
const $421dd39e26be894d$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$421dd39e26be894d$export$a143d493d941bafc = $421dd39e26be894d$var$Buffer;
$421dd39e26be894d$export$e4cf37d7f6fb9e0a = $421dd39e26be894d$var$SlowBuffer;
$421dd39e26be894d$export$f99ded8fe4b79145 = 50;
const $421dd39e26be894d$var$K_MAX_LENGTH = 0x7fffffff;
$421dd39e26be894d$export$599f31c3813fae4d = $421dd39e26be894d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $421dd39e26be894d$var$Buffer.TYPED_ARRAY_SUPPORT = $421dd39e26be894d$var$typedArraySupport();
if (!$421dd39e26be894d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $421dd39e26be894d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($421dd39e26be894d$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$421dd39e26be894d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($421dd39e26be894d$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$421dd39e26be894d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $421dd39e26be894d$var$createBuffer(length) {
    if (length > $421dd39e26be894d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $421dd39e26be894d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $421dd39e26be894d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $421dd39e26be894d$var$allocUnsafe(arg);
    }
    return $421dd39e26be894d$var$from(arg, encodingOrOffset, length);
}
$421dd39e26be894d$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $421dd39e26be894d$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $421dd39e26be894d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $421dd39e26be894d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($421dd39e26be894d$var$isInstance(value, ArrayBuffer) || value && $421dd39e26be894d$var$isInstance(value.buffer, ArrayBuffer)) return $421dd39e26be894d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($421dd39e26be894d$var$isInstance(value, SharedArrayBuffer) || value && $421dd39e26be894d$var$isInstance(value.buffer, SharedArrayBuffer))) return $421dd39e26be894d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $421dd39e26be894d$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $421dd39e26be894d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $421dd39e26be894d$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $421dd39e26be894d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $421dd39e26be894d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($421dd39e26be894d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($421dd39e26be894d$var$Buffer, Uint8Array);
function $421dd39e26be894d$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $421dd39e26be894d$var$alloc(size, fill, encoding) {
    $421dd39e26be894d$var$assertSize(size);
    if (size <= 0) return $421dd39e26be894d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $421dd39e26be894d$var$createBuffer(size).fill(fill, encoding) : $421dd39e26be894d$var$createBuffer(size).fill(fill);
    return $421dd39e26be894d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $421dd39e26be894d$var$Buffer.alloc = function(size, fill, encoding) {
    return $421dd39e26be894d$var$alloc(size, fill, encoding);
};
function $421dd39e26be894d$var$allocUnsafe(size) {
    $421dd39e26be894d$var$assertSize(size);
    return $421dd39e26be894d$var$createBuffer(size < 0 ? 0 : $421dd39e26be894d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $421dd39e26be894d$var$Buffer.allocUnsafe = function(size) {
    return $421dd39e26be894d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $421dd39e26be894d$var$Buffer.allocUnsafeSlow = function(size) {
    return $421dd39e26be894d$var$allocUnsafe(size);
};
function $421dd39e26be894d$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$421dd39e26be894d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $421dd39e26be894d$var$byteLength(string, encoding) | 0;
    let buf = $421dd39e26be894d$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $421dd39e26be894d$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $421dd39e26be894d$var$checked(array.length) | 0;
    const buf = $421dd39e26be894d$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $421dd39e26be894d$var$fromArrayView(arrayView) {
    if ($421dd39e26be894d$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $421dd39e26be894d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $421dd39e26be894d$var$fromArrayLike(arrayView);
}
function $421dd39e26be894d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $421dd39e26be894d$var$Buffer.prototype);
    return buf;
}
function $421dd39e26be894d$var$fromObject(obj) {
    if ($421dd39e26be894d$var$Buffer.isBuffer(obj)) {
        const len = $421dd39e26be894d$var$checked(obj.length) | 0;
        const buf = $421dd39e26be894d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $421dd39e26be894d$var$numberIsNaN(obj.length)) return $421dd39e26be894d$var$createBuffer(0);
        return $421dd39e26be894d$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $421dd39e26be894d$var$fromArrayLike(obj.data);
}
function $421dd39e26be894d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $421dd39e26be894d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $421dd39e26be894d$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $421dd39e26be894d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $421dd39e26be894d$var$Buffer.alloc(+length);
}
$421dd39e26be894d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $421dd39e26be894d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$421dd39e26be894d$var$Buffer.compare = function compare(a, b) {
    if ($421dd39e26be894d$var$isInstance(a, Uint8Array)) a = $421dd39e26be894d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($421dd39e26be894d$var$isInstance(b, Uint8Array)) b = $421dd39e26be894d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$421dd39e26be894d$var$Buffer.isBuffer(a) || !$421dd39e26be894d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$421dd39e26be894d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$421dd39e26be894d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $421dd39e26be894d$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $421dd39e26be894d$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($421dd39e26be894d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$421dd39e26be894d$var$Buffer.isBuffer(buf)) buf = $421dd39e26be894d$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$421dd39e26be894d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $421dd39e26be894d$var$byteLength(string, encoding) {
    if ($421dd39e26be894d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $421dd39e26be894d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $421dd39e26be894d$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $421dd39e26be894d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $421dd39e26be894d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$421dd39e26be894d$var$Buffer.byteLength = $421dd39e26be894d$var$byteLength;
function $421dd39e26be894d$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $421dd39e26be894d$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $421dd39e26be894d$var$utf8Slice(this, start, end);
        case "ascii":
            return $421dd39e26be894d$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $421dd39e26be894d$var$latin1Slice(this, start, end);
        case "base64":
            return $421dd39e26be894d$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $421dd39e26be894d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$421dd39e26be894d$var$Buffer.prototype._isBuffer = true;
function $421dd39e26be894d$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$421dd39e26be894d$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$421dd39e26be894d$var$swap(this, i, i + 1);
    return this;
};
$421dd39e26be894d$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $421dd39e26be894d$var$swap(this, i, i + 3);
        $421dd39e26be894d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$421dd39e26be894d$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $421dd39e26be894d$var$swap(this, i, i + 7);
        $421dd39e26be894d$var$swap(this, i + 1, i + 6);
        $421dd39e26be894d$var$swap(this, i + 2, i + 5);
        $421dd39e26be894d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$421dd39e26be894d$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $421dd39e26be894d$var$utf8Slice(this, 0, length);
    return $421dd39e26be894d$var$slowToString.apply(this, arguments);
};
$421dd39e26be894d$var$Buffer.prototype.toLocaleString = $421dd39e26be894d$var$Buffer.prototype.toString;
$421dd39e26be894d$var$Buffer.prototype.equals = function equals(b) {
    if (!$421dd39e26be894d$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $421dd39e26be894d$var$Buffer.compare(this, b) === 0;
};
$421dd39e26be894d$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $421dd39e26be894d$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($421dd39e26be894d$var$customInspectSymbol) $421dd39e26be894d$var$Buffer.prototype[$421dd39e26be894d$var$customInspectSymbol] = $421dd39e26be894d$var$Buffer.prototype.inspect;
$421dd39e26be894d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($421dd39e26be894d$var$isInstance(target, Uint8Array)) target = $421dd39e26be894d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$421dd39e26be894d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $421dd39e26be894d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($421dd39e26be894d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $421dd39e26be894d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($421dd39e26be894d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $421dd39e26be894d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $421dd39e26be894d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $421dd39e26be894d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$421dd39e26be894d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$421dd39e26be894d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $421dd39e26be894d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$421dd39e26be894d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $421dd39e26be894d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $421dd39e26be894d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($421dd39e26be894d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $421dd39e26be894d$var$utf8Write(buf, string, offset, length) {
    return $421dd39e26be894d$var$blitBuffer($421dd39e26be894d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $421dd39e26be894d$var$asciiWrite(buf, string, offset, length) {
    return $421dd39e26be894d$var$blitBuffer($421dd39e26be894d$var$asciiToBytes(string), buf, offset, length);
}
function $421dd39e26be894d$var$base64Write(buf, string, offset, length) {
    return $421dd39e26be894d$var$blitBuffer($421dd39e26be894d$var$base64ToBytes(string), buf, offset, length);
}
function $421dd39e26be894d$var$ucs2Write(buf, string, offset, length) {
    return $421dd39e26be894d$var$blitBuffer($421dd39e26be894d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$421dd39e26be894d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $421dd39e26be894d$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $421dd39e26be894d$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $421dd39e26be894d$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $421dd39e26be894d$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $421dd39e26be894d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$421dd39e26be894d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $421dd39e26be894d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $jaObs.fromByteArray(buf);
    else return $jaObs.fromByteArray(buf.slice(start, end));
}
function $421dd39e26be894d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $421dd39e26be894d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $421dd39e26be894d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $421dd39e26be894d$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $421dd39e26be894d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $421dd39e26be894d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $421dd39e26be894d$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $421dd39e26be894d$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $421dd39e26be894d$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $421dd39e26be894d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $421dd39e26be894d$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$421dd39e26be894d$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $421dd39e26be894d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $421dd39e26be894d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$421dd39e26be894d$var$Buffer.prototype.readUintLE = $421dd39e26be894d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$421dd39e26be894d$var$Buffer.prototype.readUintBE = $421dd39e26be894d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$421dd39e26be894d$var$Buffer.prototype.readUint8 = $421dd39e26be894d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$421dd39e26be894d$var$Buffer.prototype.readUint16LE = $421dd39e26be894d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$421dd39e26be894d$var$Buffer.prototype.readUint16BE = $421dd39e26be894d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$421dd39e26be894d$var$Buffer.prototype.readUint32LE = $421dd39e26be894d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$421dd39e26be894d$var$Buffer.prototype.readUint32BE = $421dd39e26be894d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$421dd39e26be894d$var$Buffer.prototype.readBigUInt64LE = $421dd39e26be894d$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $421dd39e26be894d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $421dd39e26be894d$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$421dd39e26be894d$var$Buffer.prototype.readBigUInt64BE = $421dd39e26be894d$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $421dd39e26be894d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $421dd39e26be894d$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$421dd39e26be894d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$421dd39e26be894d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$421dd39e26be894d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$421dd39e26be894d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$421dd39e26be894d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$421dd39e26be894d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$421dd39e26be894d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$421dd39e26be894d$var$Buffer.prototype.readBigInt64LE = $421dd39e26be894d$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $421dd39e26be894d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $421dd39e26be894d$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$421dd39e26be894d$var$Buffer.prototype.readBigInt64BE = $421dd39e26be894d$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $421dd39e26be894d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $421dd39e26be894d$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$421dd39e26be894d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, 4, this.length);
    return $2OrBb.read(this, offset, true, 23, 4);
};
$421dd39e26be894d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, 4, this.length);
    return $2OrBb.read(this, offset, false, 23, 4);
};
$421dd39e26be894d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, 8, this.length);
    return $2OrBb.read(this, offset, true, 52, 8);
};
$421dd39e26be894d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkOffset(offset, 8, this.length);
    return $2OrBb.read(this, offset, false, 52, 8);
};
function $421dd39e26be894d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$421dd39e26be894d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$421dd39e26be894d$var$Buffer.prototype.writeUintLE = $421dd39e26be894d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $421dd39e26be894d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$421dd39e26be894d$var$Buffer.prototype.writeUintBE = $421dd39e26be894d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $421dd39e26be894d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$421dd39e26be894d$var$Buffer.prototype.writeUint8 = $421dd39e26be894d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$421dd39e26be894d$var$Buffer.prototype.writeUint16LE = $421dd39e26be894d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$421dd39e26be894d$var$Buffer.prototype.writeUint16BE = $421dd39e26be894d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$421dd39e26be894d$var$Buffer.prototype.writeUint32LE = $421dd39e26be894d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$421dd39e26be894d$var$Buffer.prototype.writeUint32BE = $421dd39e26be894d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $421dd39e26be894d$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $421dd39e26be894d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $421dd39e26be894d$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $421dd39e26be894d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$421dd39e26be894d$var$Buffer.prototype.writeBigUInt64LE = $421dd39e26be894d$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $421dd39e26be894d$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$421dd39e26be894d$var$Buffer.prototype.writeBigUInt64BE = $421dd39e26be894d$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $421dd39e26be894d$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$421dd39e26be894d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $421dd39e26be894d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$421dd39e26be894d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $421dd39e26be894d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$421dd39e26be894d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$421dd39e26be894d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$421dd39e26be894d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$421dd39e26be894d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$421dd39e26be894d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$421dd39e26be894d$var$Buffer.prototype.writeBigInt64LE = $421dd39e26be894d$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $421dd39e26be894d$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$421dd39e26be894d$var$Buffer.prototype.writeBigInt64BE = $421dd39e26be894d$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $421dd39e26be894d$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $421dd39e26be894d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $421dd39e26be894d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $2OrBb.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$421dd39e26be894d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $421dd39e26be894d$var$writeFloat(this, value, offset, true, noAssert);
};
$421dd39e26be894d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $421dd39e26be894d$var$writeFloat(this, value, offset, false, noAssert);
};
function $421dd39e26be894d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $421dd39e26be894d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $2OrBb.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$421dd39e26be894d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $421dd39e26be894d$var$writeDouble(this, value, offset, true, noAssert);
};
$421dd39e26be894d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $421dd39e26be894d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$421dd39e26be894d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$421dd39e26be894d$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$421dd39e26be894d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$421dd39e26be894d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $421dd39e26be894d$var$Buffer.isBuffer(val) ? val : $421dd39e26be894d$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $421dd39e26be894d$var$errors = {};
function $421dd39e26be894d$var$E(sym, getMessage, Base) {
    $421dd39e26be894d$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$421dd39e26be894d$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$421dd39e26be894d$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$421dd39e26be894d$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $421dd39e26be894d$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $421dd39e26be894d$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $421dd39e26be894d$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $421dd39e26be894d$var$checkBounds(buf, offset, byteLength) {
    $421dd39e26be894d$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $421dd39e26be894d$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $421dd39e26be894d$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $421dd39e26be894d$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $421dd39e26be894d$var$checkBounds(buf, offset, byteLength);
}
function $421dd39e26be894d$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $421dd39e26be894d$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $421dd39e26be894d$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $421dd39e26be894d$var$validateNumber(value, type);
        throw new $421dd39e26be894d$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $421dd39e26be894d$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $421dd39e26be894d$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $421dd39e26be894d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $421dd39e26be894d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($421dd39e26be894d$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $421dd39e26be894d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $421dd39e26be894d$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $421dd39e26be894d$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $421dd39e26be894d$var$base64ToBytes(str) {
    return $jaObs.toByteArray($421dd39e26be894d$var$base64clean(str));
}
function $421dd39e26be894d$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $421dd39e26be894d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $421dd39e26be894d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $421dd39e26be894d$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $421dd39e26be894d$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $421dd39e26be894d$var$BufferBigIntNotDefined : fn;
}
function $421dd39e26be894d$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("jaObs", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $df55e0f5d3d73975$export$d622b2ad8d90c771; }, function (v) { return $df55e0f5d3d73975$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $df55e0f5d3d73975$export$6100ba28696e12de; }, function (v) { return $df55e0f5d3d73975$export$6100ba28696e12de = v; });
var $df55e0f5d3d73975$export$a48f0734ac7c2329;
var $df55e0f5d3d73975$export$d622b2ad8d90c771;
var $df55e0f5d3d73975$export$6100ba28696e12de;
"use strict";
$df55e0f5d3d73975$export$a48f0734ac7c2329 = $df55e0f5d3d73975$var$byteLength;
$df55e0f5d3d73975$export$d622b2ad8d90c771 = $df55e0f5d3d73975$var$toByteArray;
$df55e0f5d3d73975$export$6100ba28696e12de = $df55e0f5d3d73975$var$fromByteArray;
var $df55e0f5d3d73975$var$lookup = [];
var $df55e0f5d3d73975$var$revLookup = [];
var $df55e0f5d3d73975$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $df55e0f5d3d73975$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $df55e0f5d3d73975$var$i = 0, $df55e0f5d3d73975$var$len = $df55e0f5d3d73975$var$code.length; $df55e0f5d3d73975$var$i < $df55e0f5d3d73975$var$len; ++$df55e0f5d3d73975$var$i){
    $df55e0f5d3d73975$var$lookup[$df55e0f5d3d73975$var$i] = $df55e0f5d3d73975$var$code[$df55e0f5d3d73975$var$i];
    $df55e0f5d3d73975$var$revLookup[$df55e0f5d3d73975$var$code.charCodeAt($df55e0f5d3d73975$var$i)] = $df55e0f5d3d73975$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$df55e0f5d3d73975$var$revLookup["-".charCodeAt(0)] = 62;
$df55e0f5d3d73975$var$revLookup["_".charCodeAt(0)] = 63;
function $df55e0f5d3d73975$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $df55e0f5d3d73975$var$byteLength(b64) {
    var lens = $df55e0f5d3d73975$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $df55e0f5d3d73975$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $df55e0f5d3d73975$var$toByteArray(b64) {
    var tmp;
    var lens = $df55e0f5d3d73975$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $df55e0f5d3d73975$var$Arr($df55e0f5d3d73975$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $df55e0f5d3d73975$var$revLookup[b64.charCodeAt(i)] << 18 | $df55e0f5d3d73975$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $df55e0f5d3d73975$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $df55e0f5d3d73975$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $df55e0f5d3d73975$var$revLookup[b64.charCodeAt(i)] << 2 | $df55e0f5d3d73975$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $df55e0f5d3d73975$var$revLookup[b64.charCodeAt(i)] << 10 | $df55e0f5d3d73975$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $df55e0f5d3d73975$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $df55e0f5d3d73975$var$tripletToBase64(num) {
    return $df55e0f5d3d73975$var$lookup[num >> 18 & 0x3F] + $df55e0f5d3d73975$var$lookup[num >> 12 & 0x3F] + $df55e0f5d3d73975$var$lookup[num >> 6 & 0x3F] + $df55e0f5d3d73975$var$lookup[num & 0x3F];
}
function $df55e0f5d3d73975$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($df55e0f5d3d73975$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $df55e0f5d3d73975$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($df55e0f5d3d73975$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($df55e0f5d3d73975$var$lookup[tmp >> 2] + $df55e0f5d3d73975$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($df55e0f5d3d73975$var$lookup[tmp >> 10] + $df55e0f5d3d73975$var$lookup[tmp >> 4 & 0x3F] + $df55e0f5d3d73975$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("2OrBb", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $20c5a8d4fb848043$export$aafa59e2e03f2942; }, function (v) { return $20c5a8d4fb848043$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $20c5a8d4fb848043$export$68d8715fc104d294; }, function (v) { return $20c5a8d4fb848043$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $20c5a8d4fb848043$export$aafa59e2e03f2942;
var $20c5a8d4fb848043$export$68d8715fc104d294;
$20c5a8d4fb848043$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$20c5a8d4fb848043$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("i1zbc", function(module, exports) {
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");

var $a44a0 = parcelRequire("a44a0");

var $8Nvu1 = parcelRequire("8Nvu1");

var $hqpcB = parcelRequire("hqpcB");

var $jFnSJ = parcelRequire("jFnSJ");

var $de32o = parcelRequire("de32o");

var $467nO = parcelRequire("467nO");

var $8Iw2D = parcelRequire("8Iw2D");

var $8ybyJ = parcelRequire("8ybyJ");

var $goZQA = parcelRequire("goZQA");

var $4UZ8h = parcelRequire("4UZ8h");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($9XE1Y.isFormData(requestData) && $9XE1Y.isStandardBrowserEnv()) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $jFnSJ(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $hqpcB(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $de32o(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $a44a0(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $8ybyJ("Request aborted", $8ybyJ.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $8ybyJ("Network Error", $8ybyJ.ERR_NETWORK, config, request, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $8Iw2D;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $8ybyJ(timeoutErrorMessage, transitional.clarifyTimeoutError ? $8ybyJ.ETIMEDOUT : $8ybyJ.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($9XE1Y.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $467nO(fullPath)) && config.xsrfCookieName ? $8Nvu1.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $9XE1Y.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$9XE1Y.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $goZQA() : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        var protocol = $4UZ8h(fullPath);
        if (protocol && [
            "http",
            "https",
            "file"
        ].indexOf(protocol) === -1) {
            reject(new $8ybyJ("Unsupported protocol " + protocol + ":", $8ybyJ.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("a44a0", function(module, exports) {
"use strict";

var $8ybyJ = parcelRequire("8ybyJ");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $8ybyJ("Request failed with status code " + response.status, [
        $8ybyJ.ERR_BAD_REQUEST,
        $8ybyJ.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRegister("8Nvu1", function(module, exports) {
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");
module.exports = $9XE1Y.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($9XE1Y.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($9XE1Y.isString(path)) cookie.push("path=" + path);
            if ($9XE1Y.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("jFnSJ", function(module, exports) {
"use strict";

var $kcOsT = parcelRequire("kcOsT");

var $lMKzg = parcelRequire("lMKzg");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$kcOsT(requestedURL)) return $lMKzg(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("kcOsT", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("lMKzg", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("de32o", function(module, exports) {
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $9a0ef05ef3d5c580$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $9XE1Y.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $9XE1Y.trim(line.substr(0, i)).toLowerCase();
        val = $9XE1Y.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $9a0ef05ef3d5c580$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("467nO", function(module, exports) {
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");
module.exports = $9XE1Y.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $9XE1Y.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("goZQA", function(module, exports) {
"use strict";

var $8ybyJ = parcelRequire("8ybyJ");

var $9XE1Y = parcelRequire("9XE1Y");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $bf0edcc6089ef38f$var$CanceledError(message) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $8ybyJ.call(this, message == null ? "canceled" : message, $8ybyJ.ERR_CANCELED);
    this.name = "CanceledError";
}
$9XE1Y.inherits($bf0edcc6089ef38f$var$CanceledError, $8ybyJ, {
    __CANCEL__: true
});
module.exports = $bf0edcc6089ef38f$var$CanceledError;

});

parcelRegister("4UZ8h", function(module, exports) {
"use strict";
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
};

});


parcelRegister("4Zmth", function(module, exports) {
// eslint-disable-next-line strict
module.exports = null;

});



parcelRegister("auXtX", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("dBLbq", function(module, exports) {
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($9XE1Y.isPlainObject(target) && $9XE1Y.isPlainObject(source)) return $9XE1Y.merge(target, source);
        else if ($9XE1Y.isPlainObject(source)) return $9XE1Y.merge({}, source);
        else if ($9XE1Y.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$9XE1Y.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$9XE1Y.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$9XE1Y.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$9XE1Y.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$9XE1Y.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "beforeRedirect": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $9XE1Y.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $9XE1Y.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("bmim6", function(module, exports) {
"use strict";

var $98AaB = parcelRequire("98AaB");
var $844ffcd1c028e26b$require$VERSION = $98AaB.version;

var $8ybyJ = parcelRequire("8ybyJ");
var $844ffcd1c028e26b$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $844ffcd1c028e26b$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $844ffcd1c028e26b$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $844ffcd1c028e26b$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $844ffcd1c028e26b$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $8ybyJ(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), $8ybyJ.ERR_DEPRECATED);
        if (version && !$844ffcd1c028e26b$var$deprecatedWarnings[opt]) {
            $844ffcd1c028e26b$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $844ffcd1c028e26b$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new $8ybyJ("options must be an object", $8ybyJ.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $8ybyJ("option " + opt + " must be " + result, $8ybyJ.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $8ybyJ("Unknown option " + opt, $8ybyJ.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $844ffcd1c028e26b$var$assertOptions,
    validators: $844ffcd1c028e26b$var$validators
};

});
parcelRegister("98AaB", function(module, exports) {
module.exports = {
    "version": "0.27.2"
};

});



parcelRegister("8OXTg", function(module, exports) {
"use strict";

var $goZQA = parcelRequire("goZQA");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $66c1733ba0469a16$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $goZQA(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $66c1733ba0469a16$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $66c1733ba0469a16$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $66c1733ba0469a16$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $66c1733ba0469a16$var$CancelToken.source = function source() {
    var cancel;
    var token = new $66c1733ba0469a16$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $66c1733ba0469a16$var$CancelToken;

});

parcelRegister("3hRgJ", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("3uPXy", function(module, exports) {
"use strict";

var $9XE1Y = parcelRequire("9XE1Y");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $9XE1Y.isObject(payload) && payload.isAxiosError === true;
};

});




parcelRegister("fd4jk", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $b12b69ea494e2394$export$b3890eb0ae9dca99; });
parcelRequire("hQJKw");
var $esfUo = parcelRequire("esfUo");
var $NPJVB = parcelRequire("NPJVB");
var $8ENGG = parcelRequire("8ENGG");
const $b12b69ea494e2394$var$_hoisted_1 = {
    class: "content"
};
const $b12b69ea494e2394$var$_hoisted_2 = {
    key: 0,
    class: "pop-up"
};
const $b12b69ea494e2394$var$_hoisted_3 = {
    class: "message"
};
const $b12b69ea494e2394$var$_hoisted_4 = {
    class: "row justify-content-center"
};
const $b12b69ea494e2394$var$_hoisted_5 = {
    class: "col-md-10"
};
const $b12b69ea494e2394$var$_hoisted_6 = {
    class: "row justify-content-center"
};
const $b12b69ea494e2394$var$_hoisted_7 = /*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
    class: "col-md-6"
}, [
    /*#__PURE__*/ (0, $esfUo.createElementVNode)("h3", {
        class: "heading mb-4"
    }, "\u58F9\u860B\u65B0\u805E\u7DB2\u7206\u6599\u5C08\u7DDA"),
    /*#__PURE__*/ (0, $esfUo.createElementVNode)("p", null, [
        /*#__PURE__*/ (0, $esfUo.createElementVNode)("img", {
            src: "https://static.nextapple.tw/large__494d3ba94f.jpg",
            alt: "Image",
            class: "img-fluid"
        })
    ]),
    /*#__PURE__*/ (0, $esfUo.createElementVNode)("p", null, " \u4F60\u6562\u7206\u3001\u6211\u6562\u885D\uFF0C\u300A\u58F9\u860B\u65B0\u805E\u7DB2\u300B\u7DDA\u4E0A\u7206\u6599\u6700\u65B9\u4FBF\uFF0C\u8DEF\u898B\u4E0D\u5E73\u5FEB\u4F86\u4FE1\uFF0C\u300A\u58F9\u860B\u300B\u8207\u4F60\u4E00\u8D77\u70BA\u516C\u7FA9\u800C\u6230\uFF01 ")
], -1);
const $b12b69ea494e2394$var$_hoisted_8 = {
    class: "col-md-6"
};
const $b12b69ea494e2394$var$_hoisted_9 = {
    class: "row"
};
const $b12b69ea494e2394$var$_hoisted_10 = {
    class: "col-md-12 form-group"
};
const $b12b69ea494e2394$var$_hoisted_11 = [
    "placeholder"
];
const $b12b69ea494e2394$var$_hoisted_12 = {
    class: "invalid-feedback"
};
const $b12b69ea494e2394$var$_hoisted_13 = {
    class: "row"
};
const $b12b69ea494e2394$var$_hoisted_14 = {
    class: "col-md-12 form-group"
};
const $b12b69ea494e2394$var$_hoisted_15 = /*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
    class: "invalid-feedback"
}, " \u8ACB\u8F38\u5165 \u7206\u6599\u6295\u8A34\u5167\u5BB9 ", -1);
const $b12b69ea494e2394$var$_hoisted_16 = {
    class: "row"
};
const $b12b69ea494e2394$var$_hoisted_17 = {
    class: "col-md-12 form-group"
};
const $b12b69ea494e2394$var$_hoisted_18 = {
    class: "btn btn-primary"
};
const $b12b69ea494e2394$var$_hoisted_19 = {
    class: "gallery"
};
const $b12b69ea494e2394$var$_hoisted_20 = [
    "id"
];
const $b12b69ea494e2394$var$_hoisted_21 = {
    class: "progress"
};
const $b12b69ea494e2394$var$_hoisted_22 = {
    key: 0,
    class: "text-center"
};
const $b12b69ea494e2394$var$_hoisted_23 = {
    style: {
        "font-size": "12px"
    }
};
const $b12b69ea494e2394$var$_hoisted_24 = {
    key: 0
};
const $b12b69ea494e2394$var$_hoisted_25 = {
    key: 0
};
const $b12b69ea494e2394$var$_hoisted_26 = {
    key: 1,
    class: "text-success"
};
const $b12b69ea494e2394$var$_hoisted_27 = {
    class: "row"
};
const $b12b69ea494e2394$var$_hoisted_28 = {
    class: "col-md-12 form-group"
};
const $b12b69ea494e2394$var$_hoisted_29 = /*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
    class: "invalid-feedback"
}, " \u8ACB\u8F38\u5165 \u59D3\u540D ", -1);
const $b12b69ea494e2394$var$_hoisted_30 = {
    class: "row"
};
const $b12b69ea494e2394$var$_hoisted_31 = {
    class: "col-md-12 form-group"
};
const $b12b69ea494e2394$var$_hoisted_32 = /*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
    class: "invalid-feedback"
}, " \u8ACB\u8F38\u5165\u6B63\u78BA\u7684 E-mail \u4FE1\u7BB1 ", -1);
const $b12b69ea494e2394$var$_hoisted_33 = {
    class: "row"
};
const $b12b69ea494e2394$var$_hoisted_34 = {
    class: "col-md-12 form-group"
};
const $b12b69ea494e2394$var$_hoisted_35 = /*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
    class: "invalid-feedback"
}, " \u8ACB\u8F38\u5165\u6B63\u78BA\u7684 \u806F\u7E6B\u96FB\u8A71 ", -1);
const $b12b69ea494e2394$var$_hoisted_36 = {
    class: "row"
};
const $b12b69ea494e2394$var$_hoisted_37 = {
    class: "col-md-12 form-group"
};
const $b12b69ea494e2394$var$_hoisted_38 = /*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
    class: "row"
}, [
    /*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
        class: "col-12"
    }, "* \u5FC5\u586B")
], -1);
const $b12b69ea494e2394$var$_hoisted_39 = {
    class: "row"
};
const $b12b69ea494e2394$var$_hoisted_40 = {
    class: "col-12"
};
const $b12b69ea494e2394$var$_hoisted_41 = [
    "disabled",
    "value"
];
const $b12b69ea494e2394$var$_hoisted_42 = /*#__PURE__*/ (0, $esfUo.createElementVNode)("span", {
    class: "submitting"
}, null, -1);
const $b12b69ea494e2394$var$_hoisted_43 = {
    key: 0,
    id: "form-message-success"
};
function $b12b69ea494e2394$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_font_awesome_icon = (0, $esfUo.resolveComponent)("font-awesome-icon");
    return (0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $b12b69ea494e2394$var$_hoisted_1, [
        $data.success ? ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $b12b69ea494e2394$var$_hoisted_2, [
            (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_3, [
                (0, $esfUo.createTextVNode)(" \u8B1D\u8B1D\u60A8\u6240\u63D0\u4F9B\u7684\u7206\u6599\u8A0A\u606F\uFF01 "),
                (0, $esfUo.createElementVNode)("div", {
                    class: "btn btn-primary rounded-0 py-3 px-4 h-auto d-block mt-2",
                    onClick: _cache[0] || (_cache[0] = ($event)=>$data.success = false)
                }, " \u78BA\u5B9A ")
            ])
        ])) : (0, $esfUo.createCommentVNode)("", true),
        (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_4, [
            (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_5, [
                (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_6, [
                    $b12b69ea494e2394$var$_hoisted_7,
                    (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_8, [
                        (0, $esfUo.createElementVNode)("form", {
                            class: "mb-5",
                            method: "post",
                            id: "contactForm",
                            name: "contactForm",
                            onSubmit: _cache[8] || (_cache[8] = (0, $NPJVB.withModifiers)((...args)=>$options.submitForm && $options.submitForm(...args), [
                                "prevent"
                            ])),
                            ref: "form"
                        }, [
                            (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_9, [
                                (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_10, [
                                    (0, $esfUo.withDirectives)((0, $esfUo.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.form.title = $event),
                                        type: "text",
                                        class: (0, $8ENGG.normalizeClass)([
                                            "form-control",
                                            {
                                                "is-invalid": !$options.validTitle
                                            }
                                        ]),
                                        name: "name",
                                        id: "name",
                                        placeholder: `\u{7206}\u{6599}\u{4E3B}\u{65E8} (${$data.titleMaxLength}\u{5B57}\u{4EE5}\u{5167})`
                                    }, null, 10, $b12b69ea494e2394$var$_hoisted_11), [
                                        [
                                            (0, $NPJVB.vModelText),
                                            $data.form.title
                                        ]
                                    ]),
                                    (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_12, (0, $8ENGG.toDisplayString)($options.titleTooLong ? `\u{8ACB}\u{628A} \u{7206}\u{6599}\u{4E3B}\u{65E8} \u{4FDD}\u{6301}\u{5728}${$data.titleMaxLength}\u{5B57}\u{4EE5}\u{5167}` : "\u8ACB\u8F38\u5165 \u7206\u6599\u4E3B\u65E8"), 1)
                                ])
                            ]),
                            (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_13, [
                                (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_14, [
                                    (0, $esfUo.withDirectives)((0, $esfUo.createElementVNode)("textarea", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.form.description = $event),
                                        class: (0, $8ENGG.normalizeClass)([
                                            "form-control",
                                            {
                                                "is-invalid": !$options.validDesc
                                            }
                                        ]),
                                        name: "description",
                                        id: "description",
                                        style: {
                                            height: "180px"
                                        },
                                        placeholder: "\u7206\u6599\u6295\u8A34\u5167\u5BB9 *"
                                    }, null, 2), [
                                        [
                                            (0, $NPJVB.vModelText),
                                            $data.form.description
                                        ]
                                    ]),
                                    $b12b69ea494e2394$var$_hoisted_15
                                ])
                            ]),
                            (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_16, [
                                (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_17, [
                                    (0, $esfUo.createElementVNode)("label", $b12b69ea494e2394$var$_hoisted_18, [
                                        (0, $esfUo.createVNode)(_component_font_awesome_icon, {
                                            icon: "fa-solid fa-image"
                                        }),
                                        (0, $esfUo.createTextVNode)(" \u6A94\u6848\u4E0A\u50B3 "),
                                        (0, $esfUo.createElementVNode)("input", {
                                            type: "file",
                                            style: {
                                                "display": "none"
                                            },
                                            id: "mediaupload",
                                            name: "mediaupload",
                                            multiple: "",
                                            accept: "image/*, video/*",
                                            onChange: _cache[3] || (_cache[3] = (...args)=>$options.uploadFiles && $options.uploadFiles(...args))
                                        }, null, 32)
                                    ]),
                                    (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_19, [
                                        ((0, $esfUo.openBlock)(true), (0, $esfUo.createElementBlock)((0, $esfUo.Fragment), null, (0, $esfUo.renderList)($data.files, (file, i)=>{
                                            return (0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", {
                                                id: i
                                            }, [
                                                (0, $esfUo.createElementVNode)("div", {
                                                    class: "preview",
                                                    style: (0, $8ENGG.normalizeStyle)({
                                                        backgroundImage: file.isImage ? "url(" + file.preview + ")" : null
                                                    })
                                                }, [
                                                    (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_21, [
                                                        (0, $esfUo.createElementVNode)("div", {
                                                            class: "progress-bar bg-info",
                                                            role: "progressbar",
                                                            style: (0, $8ENGG.normalizeStyle)({
                                                                width: file.progress + "%"
                                                            })
                                                        }, null, 4)
                                                    ]),
                                                    !file.isImage ? ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $b12b69ea494e2394$var$_hoisted_22, [
                                                        (0, $esfUo.createVNode)(_component_font_awesome_icon, {
                                                            icon: "fa-solid fa-file-video"
                                                        }),
                                                        (0, $esfUo.createTextVNode)(" \u5F71\u7247 "),
                                                        (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_23, (0, $8ENGG.toDisplayString)(file.name), 1)
                                                    ])) : (0, $esfUo.createCommentVNode)("", true)
                                                ], 4)
                                            ], 8, $b12b69ea494e2394$var$_hoisted_20);
                                        }), 256))
                                    ]),
                                    $data.files.length ? ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $b12b69ea494e2394$var$_hoisted_24, [
                                        $options.uploading ? ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $b12b69ea494e2394$var$_hoisted_25, "\u4E0A\u50B3\u4E2D...")) : ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $b12b69ea494e2394$var$_hoisted_26, [
                                            (0, $esfUo.createVNode)(_component_font_awesome_icon, {
                                                icon: "fa-solid fa-check"
                                            }),
                                            (0, $esfUo.createTextVNode)("\u4E0A\u50B3\u5B8C\u6210")
                                        ]))
                                    ])) : (0, $esfUo.createCommentVNode)("", true)
                                ])
                            ]),
                            (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_27, [
                                (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_28, [
                                    (0, $esfUo.withDirectives)((0, $esfUo.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$data.form.name = $event),
                                        type: "text",
                                        class: (0, $8ENGG.normalizeClass)([
                                            "form-control",
                                            {
                                                "is-invalid": !$options.validName
                                            }
                                        ]),
                                        name: "name",
                                        id: "name",
                                        placeholder: "\u59D3\u540D *"
                                    }, null, 2), [
                                        [
                                            (0, $NPJVB.vModelText),
                                            $data.form.name
                                        ]
                                    ]),
                                    $b12b69ea494e2394$var$_hoisted_29
                                ])
                            ]),
                            (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_30, [
                                (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_31, [
                                    (0, $esfUo.withDirectives)((0, $esfUo.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.form.email = $event),
                                        type: "text",
                                        class: (0, $8ENGG.normalizeClass)([
                                            "form-control",
                                            {
                                                "is-invalid": !$options.validEmail
                                            }
                                        ]),
                                        name: "email",
                                        id: "email",
                                        placeholder: "E-mail\u4FE1\u7BB1 *"
                                    }, null, 2), [
                                        [
                                            (0, $NPJVB.vModelText),
                                            $data.form.email
                                        ]
                                    ]),
                                    $b12b69ea494e2394$var$_hoisted_32
                                ])
                            ]),
                            (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_33, [
                                (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_34, [
                                    (0, $esfUo.withDirectives)((0, $esfUo.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$data.form.tel = $event),
                                        type: "text",
                                        class: (0, $8ENGG.normalizeClass)([
                                            "form-control",
                                            {
                                                "is-invalid": !$options.validTel
                                            }
                                        ]),
                                        name: "tel",
                                        id: "tel",
                                        placeholder: "\u806F\u7E6B\u96FB\u8A71"
                                    }, null, 2), [
                                        [
                                            (0, $NPJVB.vModelText),
                                            $data.form.tel
                                        ]
                                    ]),
                                    $b12b69ea494e2394$var$_hoisted_35
                                ])
                            ]),
                            (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_36, [
                                (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_37, [
                                    (0, $esfUo.withDirectives)((0, $esfUo.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$data.form.location = $event),
                                        type: "text",
                                        class: "form-control",
                                        name: "location",
                                        id: "location",
                                        placeholder: "\u6240\u5728\u7E23\u5E02"
                                    }, null, 512), [
                                        [
                                            (0, $NPJVB.vModelText),
                                            $data.form.location
                                        ]
                                    ])
                                ])
                            ]),
                            $b12b69ea494e2394$var$_hoisted_38,
                            (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_39, [
                                (0, $esfUo.createElementVNode)("div", $b12b69ea494e2394$var$_hoisted_40, [
                                    (0, $esfUo.createElementVNode)("input", {
                                        disabled: !$options.canSubmit,
                                        type: "submit",
                                        value: $options.submitBtnText,
                                        class: "btn btn-primary rounded-0 py-2 px-4"
                                    }, null, 8, $b12b69ea494e2394$var$_hoisted_41),
                                    $b12b69ea494e2394$var$_hoisted_42
                                ])
                            ])
                        ], 544),
                        $data.success ? ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $b12b69ea494e2394$var$_hoisted_43, "\u8B1D\u8B1D\u60A8")) : (0, $esfUo.createCommentVNode)("", true)
                    ])
                ])
            ])
        ])
    ]);
}

});

parcelRegister("9RJcM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72ec2115b8e4199b$export$2e2bcd8739ae039; });
let $72ec2115b8e4199b$var$NOOP = ()=>{};
var $72ec2115b8e4199b$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("04FHs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $00e0b88fbd186d2f$export$2e2bcd8739ae039; });

var $dmLO6 = parcelRequire("dmLO6");
parcelRequire("6x6HK");
var $b6AyC = parcelRequire("b6AyC");
var $00e0b88fbd186d2f$export$2e2bcd8739ae039 = {
    components: {
        ChallengeV3: $b6AyC.default
    },
    data () {
        return {
            titleMaxLength: 15,
            message: "Ready",
            files: [],
            success: false,
            submitted: false,
            shouldCheck: false,
            credential: null,
            form: {
                title: "",
                name: "",
                tel: "",
                email: "",
                reason: "",
                location: "",
                files: []
            },
            submitting: false
        };
    },
    mounted () {
    //   google.accounts.id.initialize({
    //   client_id: '852836185297-n0nap0s10s17927937ofbuag5009234n.apps.googleusercontent.com',
    //   callback: function(resp) {
    //     this.credential = resp.credential;
    //   }
    // });
    //   const parent = document.getElementById('google_btn');
    //   google.accounts.id.renderButton(this.$refs.loginBtn, { 
    //     theme: "outline",
    //     width: 400,
    //     logo_alignment: 'center',
    //   });
    //   google.accounts.id.prompt(function(noti) {
    //   });
    },
    computed: {
        submitBtnText () {
            if (this.uploading) return "\u8ACB\u7B49\u5F85\u4E0A\u50B3\u5B8C\u6210";
            if (this.submitting) return "\u63D0\u4EA4\u4E2D...";
            return "\u63D0\u4EA4";
        },
        uploading () {
            let ready = true;
            for(var i = 0; i < this.files.length; i++)ready = ready && this.files[i].ready;
            return !ready;
        },
        canSubmit () {
            return !this.uploading && !this.submitting;
        },
        titleTooLong () {
            return this.form.title.length > this.titleMaxLength;
        },
        isValid () {
            let valid = true;
            valid = valid && this.validEmail;
            valid = valid && this.validEmail;
            return valid;
        },
        validTitle () {
            return !this.shouldCheck || this.form.title.length && !this.titleTooLong;
        },
        validName () {
            return !this.shouldCheck || this.form.name.length;
        },
        validDesc () {
            return true;
        },
        validEmail () {
            if (!this.shouldCheck && !this.form.email) return true;
            return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i.test(this.form.email);
        },
        validTel () {
            if (!this.form.tel) return true;
            return /09\d{2}\-?\d{3}\-?\d{3}/.test(this.form.tel);
        }
    },
    methods: {
        async submitForm (recaptcha) {
            this.shouldCheck = true;
            if (!this.isValid) return;
            this.submitting = true;
            this.submitted = true;
            const captchaResp = await recaptcha.execute();
            this.form.recaptcha = captchaResp;
            (0, (/*@__PURE__*/$parcel$interopDefault($dmLO6))).post("/api/data-safety", this.form).then(()=>{
                this.submitting = false;
                this.success = true;
                this.shouldCheck = false;
                this.form = {
                    email: "",
                    reason: "",
                    name: ""
                };
            }).catch(()=>{
                this.submitting = false;
                this.submitted = false;
            });
        },
        uploadFiles (e) {
            const files = e.target.files;
            if (files) {
                var filesAmount = files.length;
                for(let i = 0; i < filesAmount; i++){
                    var reader = new FileReader();
                    reader.onload = (event)=>{
                        const dataUrl = event.target.result;
                        const ext = "." + files[i].name.split(".").pop();
                        (0, (/*@__PURE__*/$parcel$interopDefault($dmLO6))).get("/api/upload/pre-sign", {
                            params: {
                                ext: ext
                            }
                        }).then((resp)=>{
                            const url = resp.data.url;
                            const key = resp.data.key;
                            var formData = new FormData();
                            const isImage = dataUrl && dataUrl.startsWith("data:image");
                            formData.append("file", files[i]);
                            const result = {
                                preview: isImage ? dataUrl : "",
                                isImage: isImage,
                                key: key,
                                progress: 0,
                                ready: false,
                                name: files[i].name
                            };
                            this.files.push(result);
                            return (0, (/*@__PURE__*/$parcel$interopDefault($dmLO6))).put(url, files[i], {
                                headers: {
                                    "Content-Type": files[i].type
                                },
                                onUploadProgress: (progressEvent)=>{
                                    const progress = parseInt(Math.round(progressEvent.loaded / progressEvent.total * 100));
                                    const staging = this.files;
                                    for(var j = 0; j < staging.length; j++)if (staging[j].key === key) staging[j].progress = progress;
                                }
                            }).then(()=>{
                                const staging = this.files;
                                for(var j = 0; j < staging.length; j++)if (staging[j].key === key) staging[j].ready = true;
                            });
                        });
                    };
                    reader.readAsDataURL(files[i]);
                }
            }
        }
    }
};

});

parcelRegister("adGup", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $770c13d06d9fb793$export$b3890eb0ae9dca99; });
parcelRequire("hQJKw");
var $esfUo = parcelRequire("esfUo");
var $NPJVB = parcelRequire("NPJVB");
var $8ENGG = parcelRequire("8ENGG");
const $770c13d06d9fb793$var$_hoisted_1 = {
    class: "content"
};
const $770c13d06d9fb793$var$_hoisted_2 = {
    key: 0,
    class: "pop-up"
};
const $770c13d06d9fb793$var$_hoisted_3 = {
    class: "message"
};
const $770c13d06d9fb793$var$_hoisted_4 = {
    class: "row justify-content-center"
};
const $770c13d06d9fb793$var$_hoisted_5 = {
    class: "col-md-6"
};
const $770c13d06d9fb793$var$_hoisted_6 = {
    class: "row justify-content-center"
};
const $770c13d06d9fb793$var$_hoisted_7 = /*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
    class: "col-md-12"
}, [
    /*#__PURE__*/ (0, $esfUo.createElementVNode)("h4", null, "\u522A\u9664\u300A\u58F9\u860B\u65B0\u805E\u7DB2\u300B\u5E33\u6236\u548C\u76F8\u95DC\u8CC7\u6599"),
    /*#__PURE__*/ (0, $esfUo.createElementVNode)("p", null, [
        /*#__PURE__*/ (0, $esfUo.createElementVNode)("ul", null, [
            /*#__PURE__*/ (0, $esfUo.createElementVNode)("li", null, "\u6B32\u79FB\u9664\u958B\u653E\u5E73\u53F0\u8CC7\u6599\u53EF\u65BC\u300A\u58F9\u860B\u65B0\u805E\u7DB2\u300BAPP \u767B\u5165\u5F8C\u5728\u6703\u54E1\u9801\u9762\u4E2D\u9EDE\u9078\u201C\u79FB\u9664\u5E33\u865F\u201D "),
            /*#__PURE__*/ (0, $esfUo.createElementVNode)("li", null, "\u6216\uFF0C\u586B\u5BEB\u4EE5\u4E0B\u8868\u683C\u7533\u8ACB")
        ])
    ])
], -1);
const $770c13d06d9fb793$var$_hoisted_8 = {
    class: "col-md-12"
};
const $770c13d06d9fb793$var$_hoisted_9 = {
    class: "row"
};
const $770c13d06d9fb793$var$_hoisted_10 = {
    class: "col-md-12 form-group"
};
const $770c13d06d9fb793$var$_hoisted_11 = /*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
    class: "invalid-feedback"
}, " \u8ACB\u8F38\u5165\u6B63\u78BA\u7684 E-mail \u4FE1\u7BB1 ", -1);
const $770c13d06d9fb793$var$_hoisted_12 = {
    class: "row"
};
const $770c13d06d9fb793$var$_hoisted_13 = {
    class: "col-md-12 form-group"
};
const $770c13d06d9fb793$var$_hoisted_14 = /*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
    class: "invalid-feedback"
}, " \u8ACB\u8F38\u5165 \u59D3\u540D ", -1);
const $770c13d06d9fb793$var$_hoisted_15 = {
    class: "row"
};
const $770c13d06d9fb793$var$_hoisted_16 = {
    class: "col-md-12 form-group"
};
const $770c13d06d9fb793$var$_hoisted_17 = /*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
    class: "invalid-feedback"
}, " \u8ACB\u8F38\u5165 \u539F\u56E0 ", -1);
const $770c13d06d9fb793$var$_hoisted_18 = /*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
    class: "row"
}, [
    /*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
        class: "col-12"
    }, "* \u5FC5\u586B")
], -1);
const $770c13d06d9fb793$var$_hoisted_19 = {
    class: "row"
};
const $770c13d06d9fb793$var$_hoisted_20 = {
    class: "col-12"
};
const $770c13d06d9fb793$var$_hoisted_21 = [
    "disabled",
    "onClick"
];
const $770c13d06d9fb793$var$_hoisted_22 = /*#__PURE__*/ (0, $esfUo.createElementVNode)("span", {
    class: "submitting"
}, null, -1);
const $770c13d06d9fb793$var$_hoisted_23 = {
    key: 0,
    id: "form-message-success"
};
function $770c13d06d9fb793$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ChallengeV3 = (0, $esfUo.resolveComponent)("ChallengeV3");
    return (0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $770c13d06d9fb793$var$_hoisted_1, [
        $data.success ? ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $770c13d06d9fb793$var$_hoisted_2, [
            (0, $esfUo.createElementVNode)("div", $770c13d06d9fb793$var$_hoisted_3, [
                (0, $esfUo.createTextVNode)(" \u5DF2\u63D0\u4EA4\u7533\u8ACB\u3002 "),
                (0, $esfUo.createElementVNode)("div", {
                    class: "btn btn-primary rounded-0 py-3 px-4 h-auto d-block mt-2",
                    onClick: _cache[0] || (_cache[0] = ($event)=>$data.success = false)
                }, " \u78BA\u5B9A ")
            ])
        ])) : (0, $esfUo.createCommentVNode)("", true),
        (0, $esfUo.createElementVNode)("div", $770c13d06d9fb793$var$_hoisted_4, [
            (0, $esfUo.createElementVNode)("div", $770c13d06d9fb793$var$_hoisted_5, [
                (0, $esfUo.createElementVNode)("div", $770c13d06d9fb793$var$_hoisted_6, [
                    $770c13d06d9fb793$var$_hoisted_7,
                    (0, $esfUo.createElementVNode)("div", $770c13d06d9fb793$var$_hoisted_8, [
                        (0, $esfUo.createElementVNode)("form", {
                            class: "mb-5",
                            method: "post",
                            id: "contactForm",
                            name: "contactForm",
                            onSubmit: _cache[5] || (_cache[5] = (0, $NPJVB.withModifiers)((...args)=>$options.submitForm && $options.submitForm(...args), [
                                "prevent"
                            ])),
                            ref: "form"
                        }, [
                            (0, $esfUo.createElementVNode)("div", $770c13d06d9fb793$var$_hoisted_9, [
                                (0, $esfUo.createElementVNode)("div", $770c13d06d9fb793$var$_hoisted_10, [
                                    (0, $esfUo.withDirectives)((0, $esfUo.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.form.email = $event),
                                        type: "text",
                                        class: (0, $8ENGG.normalizeClass)([
                                            "form-control",
                                            {
                                                "is-invalid": !$options.validEmail
                                            }
                                        ]),
                                        name: "email",
                                        id: "email",
                                        placeholder: "\u5E33\u6236E-mail\u4FE1\u7BB1 *"
                                    }, null, 2), [
                                        [
                                            (0, $NPJVB.vModelText),
                                            $data.form.email
                                        ]
                                    ]),
                                    $770c13d06d9fb793$var$_hoisted_11
                                ])
                            ]),
                            (0, $esfUo.createElementVNode)("div", $770c13d06d9fb793$var$_hoisted_12, [
                                (0, $esfUo.createElementVNode)("div", $770c13d06d9fb793$var$_hoisted_13, [
                                    (0, $esfUo.withDirectives)((0, $esfUo.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.form.name = $event),
                                        type: "text",
                                        class: (0, $8ENGG.normalizeClass)([
                                            "form-control",
                                            {
                                                "is-invalid": !$options.validName
                                            }
                                        ]),
                                        name: "name",
                                        id: "name",
                                        placeholder: "\u59D3\u540D *"
                                    }, null, 2), [
                                        [
                                            (0, $NPJVB.vModelText),
                                            $data.form.name
                                        ]
                                    ]),
                                    $770c13d06d9fb793$var$_hoisted_14
                                ])
                            ]),
                            (0, $esfUo.createElementVNode)("div", $770c13d06d9fb793$var$_hoisted_15, [
                                (0, $esfUo.createElementVNode)("div", $770c13d06d9fb793$var$_hoisted_16, [
                                    (0, $esfUo.withDirectives)((0, $esfUo.createElementVNode)("textarea", {
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.form.reason = $event),
                                        class: (0, $8ENGG.normalizeClass)([
                                            "form-control",
                                            {
                                                "is-invalid": !$options.validDesc
                                            }
                                        ]),
                                        name: "description",
                                        id: "description",
                                        style: {
                                            height: "180px"
                                        },
                                        placeholder: "\u539F\u56E0"
                                    }, null, 2), [
                                        [
                                            (0, $NPJVB.vModelText),
                                            $data.form.reason
                                        ]
                                    ]),
                                    $770c13d06d9fb793$var$_hoisted_17
                                ])
                            ]),
                            $770c13d06d9fb793$var$_hoisted_18,
                            (0, $esfUo.createElementVNode)("div", $770c13d06d9fb793$var$_hoisted_19, [
                                (0, $esfUo.createElementVNode)("div", $770c13d06d9fb793$var$_hoisted_20, [
                                    (0, $esfUo.createVNode)(_component_ChallengeV3, {
                                        modelValue: _ctx.response,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>_ctx.response = $event),
                                        action: "submit",
                                        autoExecute: false
                                    }, {
                                        default: (0, $esfUo.withCtx)((slotProps)=>[
                                                (0, $esfUo.createElementVNode)("div", {
                                                    disabled: !$options.canSubmit,
                                                    onClick: ($event)=>$options.submitForm(slotProps),
                                                    class: "btn btn-primary rounded-0 py-3 px-4 h-auto"
                                                }, (0, $8ENGG.toDisplayString)($options.submitBtnText), 9, $770c13d06d9fb793$var$_hoisted_21)
                                            ]),
                                        _: 1
                                    }, 8, [
                                        "modelValue"
                                    ]),
                                    $770c13d06d9fb793$var$_hoisted_22
                                ])
                            ])
                        ], 544),
                        $data.success ? ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $770c13d06d9fb793$var$_hoisted_23, "\u8B1D\u8B1D\u60A8")) : (0, $esfUo.createCommentVNode)("", true)
                    ])
                ])
            ])
        ])
    ]);
}

});

parcelRegister("9Ihej", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7125969639350f86$export$2e2bcd8739ae039; });
let $7125969639350f86$var$NOOP = ()=>{};
var $7125969639350f86$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRegister("4ph75", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3356c595283ff890$export$2e2bcd8739ae039; });

var $dmLO6 = parcelRequire("dmLO6");
parcelRequire("6x6HK");
var $b6AyC = parcelRequire("b6AyC");
parcelRequire("hQJKw");
var $am4TS = parcelRequire("am4TS");
const $3356c595283ff890$var$__default__ = {
    data () {
        return {
            message: "Ready",
            files: [],
            success: false,
            submitted: false,
            shouldCheck: false,
            loading: false,
            hasProfanity: false,
            form: {
                name: "",
                tel: "",
                title: "",
                email: "",
                description: "",
                location: "",
                files: [],
                recaptcha: ""
            }
        };
    },
    components: {
        ChallengeV3: $b6AyC.default
    },
    mounted () {
    // this.$refs.container.removeAttribute("style");
    },
    computed: {
        submitBtnText () {
            if (this.uploading) return "\u8ACB\u7B49\u5F85\u4E0A\u50B3\u5B8C\u6210";
            if (this.loading) return "\u63D0\u4EA4\u4E2D...";
            return "\u63D0\u4EA4";
        },
        uploading () {
            let ready = true;
            for(var i = 0; i < this.files.length; i++)ready = ready && this.files[i].ready;
            return !ready;
        },
        canSubmit () {
            return !this.uploading;
        },
        isValid () {
            let valid = true;
            valid = valid && this.validDesc;
            valid = valid && this.validEmail;
            valid = valid && this.validName;
            valid = valid && this.validTitle;
            valid = valid && !this.uploading;
            return valid;
        },
        validTitle () {
            return !this.shouldCheck || this.form.title.length;
        },
        validName () {
            return !this.shouldCheck || this.form.name.length;
        },
        validDesc () {
            return !this.shouldCheck || this.form.description.length;
        },
        validEmail () {
            if (!this.shouldCheck && !this.form.email) return true;
            return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i.test(this.form.email);
        },
        validTel () {
            if (!this.form.tel) return true;
            return /09\d{2}\-?\d{3}\-?\d{3}/.test(this.form.tel);
        }
    },
    methods: {
        remove (file) {
            this.files = this.files.filter((f)=>f !== file);
        },
        async submitForm (recaptcha) {
            this.shouldCheck = true;
            const captchaResp = await recaptcha.execute();
            this.form.recaptcha = captchaResp;
            if (!this.isValid || this.loading) return;
            console.log("form is", this.form);
            this.submitted = true;
            const files = [];
            for(var i = 0; i < this.files.length; i++){
                const file = this.files[i];
                files.push({
                    key: file.key,
                    name: file.name,
                    isImage: file.isImage
                });
            }
            this.form.files = files;
            this.loading = true;
            (0, (/*@__PURE__*/$parcel$interopDefault($dmLO6))).post("/api/upload/ugc", this.form).then(({ data: data })=>{
                if (data && !data.success && data.reason === "profanity") {
                    this.hasProfanity = true;
                    this.loading = false;
                    return;
                }
                this.success = true;
                this.shouldCheck = false;
                this.form = {
                    name: "",
                    tel: "",
                    title: "",
                    email: "",
                    description: "",
                    location: "",
                    files: [],
                    recaptcha: ""
                };
            }).catch(()=>{
                this.loading = false;
                this.submitted = false;
            });
        },
        uploadFiles (e) {
            const files = e.target.files;
            const nFilesAllowed = 5;
            if (files) {
                var filesAmount = Math.min(nFilesAllowed - this.files.length, files.length);
                console.log("file amount", filesAmount);
                for(let i = 0; i < filesAmount; i++){
                    var reader = new FileReader();
                    reader.onload = (event)=>{
                        const dataUrl = event.target.result;
                        const ext = "." + files[i].name.split(".").pop();
                        (0, (/*@__PURE__*/$parcel$interopDefault($dmLO6))).get("/api/upload/pre-sign", {
                            params: {
                                ext: ext,
                                ugc: 1
                            }
                        }).then((resp)=>{
                            const url = resp.data.url;
                            const key = resp.data.key;
                            var formData = new FormData();
                            const isImage = dataUrl && dataUrl.startsWith("data:image");
                            formData.append("file", files[i]);
                            const result = {
                                preview: isImage ? dataUrl : "",
                                isImage: isImage,
                                key: key,
                                progress: 0,
                                ready: false,
                                name: files[i].name
                            };
                            this.files.push(result);
                            return (0, (/*@__PURE__*/$parcel$interopDefault($dmLO6))).put(url, files[i], {
                                headers: {
                                    "Content-Type": files[i].type
                                },
                                onUploadProgress: (progressEvent)=>{
                                    const progress = parseInt(Math.round(progressEvent.loaded / progressEvent.total * 100));
                                    const staging = this.files;
                                    for(var j = 0; j < staging.length; j++)if (staging[j].key === key) staging[j].progress = progress;
                                }
                            }).then(()=>{
                                const staging = this.files;
                                for(var j = 0; j < staging.length; j++)if (staging[j].key === key) staging[j].ready = true;
                            });
                        });
                    };
                    reader.readAsDataURL(files[i]);
                }
            }
        }
    }
};
var $3356c595283ff890$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.assign($3356c595283ff890$var$__default__, {
    __name: "UGC",
    setup (__props, { expose: expose }) {
        expose();
        const response = (0, $am4TS.ref)();
        const __returned__ = {
            response: response,
            axios: (/*@__PURE__*/$parcel$interopDefault($dmLO6)),
            ChallengeV3: $b6AyC.default,
            ref: $am4TS.ref
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});

parcelRegister("liPsa", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $f82330f373636e83$export$b3890eb0ae9dca99; });
parcelRequire("hQJKw");
var $esfUo = parcelRequire("esfUo");
var $8ENGG = parcelRequire("8ENGG");
var $NPJVB = parcelRequire("NPJVB");
const $f82330f373636e83$var$_withScopeId = (n)=>((0, $esfUo.pushScopeId)("data-v-e10464"), n = n(), (0, $esfUo.popScopeId)(), n);
const $f82330f373636e83$var$_hoisted_1 = {
    class: "content"
};
const $f82330f373636e83$var$_hoisted_2 = {
    key: 0,
    class: "pop-up"
};
const $f82330f373636e83$var$_hoisted_3 = {
    class: "message"
};
const $f82330f373636e83$var$_hoisted_4 = {
    key: 1,
    class: "pop-up"
};
const $f82330f373636e83$var$_hoisted_5 = {
    class: "message warning"
};
const $f82330f373636e83$var$_hoisted_6 = {
    class: "row justify-content-center"
};
const $f82330f373636e83$var$_hoisted_7 = {
    class: "col-md-10"
};
const $f82330f373636e83$var$_hoisted_8 = {
    class: "row justify-content-center"
};
const $f82330f373636e83$var$_hoisted_9 = /*#__PURE__*/ $f82330f373636e83$var$_withScopeId(()=>/*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
        class: "col-md-6"
    }, [
        /*#__PURE__*/ (0, $esfUo.createElementVNode)("h3", {
            class: "heading mb-4"
        }, "\u5168\u6C11\u6295\u7A3F"),
        /*#__PURE__*/ (0, $esfUo.createElementVNode)("p", null, [
            /*#__PURE__*/ (0, $esfUo.createElementVNode)("img", {
                src: "https://static.nextapple.tw/large__494d3ba94f.jpg",
                alt: "Image",
                class: "img-fluid"
            })
        ]),
        /*#__PURE__*/ (0, $esfUo.createElementVNode)("p", null, " \u4F60\u6562\u7206\u3001\u6211\u6562\u885D\uFF0C\u300A\u58F9\u860B\u65B0\u805E\u7DB2\u300B\u7DDA\u4E0A\u7206\u6599\u6700\u65B9\u4FBF\uFF0C\u8DEF\u898B\u4E0D\u5E73\u5FEB\u4F86\u4FE1\uFF0C\u300A\u58F9\u860B\u300B\u8207\u4F60\u4E00\u8D77\u70BA\u516C\u7FA9\u800C\u6230\uFF01 ")
    ], -1));
const $f82330f373636e83$var$_hoisted_10 = {
    class: "col-md-6"
};
const $f82330f373636e83$var$_hoisted_11 = {
    class: "row"
};
const $f82330f373636e83$var$_hoisted_12 = {
    class: "col-md-12 form-group"
};
const $f82330f373636e83$var$_hoisted_13 = /*#__PURE__*/ $f82330f373636e83$var$_withScopeId(()=>/*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
        class: "invalid-feedback"
    }, " \u8ACB\u8F38\u5165\u6A19\u984C ", -1));
const $f82330f373636e83$var$_hoisted_14 = {
    class: "row"
};
const $f82330f373636e83$var$_hoisted_15 = {
    class: "col-md-12 form-group"
};
const $f82330f373636e83$var$_hoisted_16 = /*#__PURE__*/ $f82330f373636e83$var$_withScopeId(()=>/*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
        class: "invalid-feedback"
    }, " \u8ACB\u8F38\u5165 \u6295\u7A3F\u5167\u5BB9 ", -1));
const $f82330f373636e83$var$_hoisted_17 = {
    class: "row"
};
const $f82330f373636e83$var$_hoisted_18 = {
    class: "col-md-12 form-group"
};
const $f82330f373636e83$var$_hoisted_19 = {
    class: "btn btn-primary"
};
const $f82330f373636e83$var$_hoisted_20 = /*#__PURE__*/ $f82330f373636e83$var$_withScopeId(()=>/*#__PURE__*/ (0, $esfUo.createElementVNode)("div", null, " - \u9650\u4E94\u5F35\u914D\u5716 ", -1));
const $f82330f373636e83$var$_hoisted_21 = {
    class: "gallery"
};
const $f82330f373636e83$var$_hoisted_22 = [
    "id"
];
const $f82330f373636e83$var$_hoisted_23 = {
    class: "progress"
};
const $f82330f373636e83$var$_hoisted_24 = {
    class: "preview-actions"
};
const $f82330f373636e83$var$_hoisted_25 = [
    "onClick"
];
const $f82330f373636e83$var$_hoisted_26 = {
    key: 0,
    class: "text-center"
};
const $f82330f373636e83$var$_hoisted_27 = {
    style: {
        "font-size": "12px"
    }
};
const $f82330f373636e83$var$_hoisted_28 = {
    key: 0
};
const $f82330f373636e83$var$_hoisted_29 = {
    key: 0
};
const $f82330f373636e83$var$_hoisted_30 = {
    key: 1,
    class: "text-success"
};
const $f82330f373636e83$var$_hoisted_31 = {
    class: "row"
};
const $f82330f373636e83$var$_hoisted_32 = {
    class: "col-md-12 form-group"
};
const $f82330f373636e83$var$_hoisted_33 = /*#__PURE__*/ $f82330f373636e83$var$_withScopeId(()=>/*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
        class: "invalid-feedback"
    }, " \u8ACB\u8F38\u5165 \u7B46\u540D ", -1));
const $f82330f373636e83$var$_hoisted_34 = {
    class: "row"
};
const $f82330f373636e83$var$_hoisted_35 = {
    class: "col-md-12 form-group"
};
const $f82330f373636e83$var$_hoisted_36 = /*#__PURE__*/ $f82330f373636e83$var$_withScopeId(()=>/*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
        class: "invalid-feedback"
    }, " \u8ACB\u8F38\u5165\u6B63\u78BA\u7684 E-mail \u4FE1\u7BB1 ", -1));
const $f82330f373636e83$var$_hoisted_37 = /*#__PURE__*/ $f82330f373636e83$var$_withScopeId(()=>/*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
        class: "row"
    }, [
        /*#__PURE__*/ (0, $esfUo.createElementVNode)("div", {
            class: "col-12"
        }, "* \u5FC5\u586B")
    ], -1));
const $f82330f373636e83$var$_hoisted_38 = {
    class: "row"
};
const $f82330f373636e83$var$_hoisted_39 = {
    class: "col-12"
};
const $f82330f373636e83$var$_hoisted_40 = [
    "disabled",
    "onClick"
];
const $f82330f373636e83$var$_hoisted_41 = /*#__PURE__*/ $f82330f373636e83$var$_withScopeId(()=>/*#__PURE__*/ (0, $esfUo.createElementVNode)("span", {
        class: "submitting"
    }, null, -1));
const $f82330f373636e83$var$_hoisted_42 = {
    key: 0,
    id: "form-message-success"
};
function $f82330f373636e83$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_font_awesome_icon = (0, $esfUo.resolveComponent)("font-awesome-icon");
    return (0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $f82330f373636e83$var$_hoisted_1, [
        $data.success ? ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $f82330f373636e83$var$_hoisted_2, [
            (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_3, [
                (0, $esfUo.createTextVNode)(" \u611F\u8B1D\u60A8\u7684\u6295\u7A3F\uFF01 "),
                (0, $esfUo.createElementVNode)("div", {
                    class: "btn btn-primary rounded-0 py-3 px-4 h-auto d-block mt-2",
                    onClick: _cache[0] || (_cache[0] = ($event)=>$data.success = false)
                }, " \u78BA\u5B9A ")
            ])
        ])) : (0, $esfUo.createCommentVNode)("", true),
        $data.hasProfanity ? ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $f82330f373636e83$var$_hoisted_4, [
            (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_5, [
                (0, $esfUo.createTextVNode)(" \u6295\u7A3F\u5167\u5BB9\u542B\u6709\u4E0D\u96C5\u5B57\u773C, \u8ACB\u4FEE\u6539 "),
                (0, $esfUo.createElementVNode)("div", {
                    class: "btn btn-primary rounded-0 py-3 px-4 h-auto d-block mt-2",
                    onClick: _cache[1] || (_cache[1] = ($event)=>$data.hasProfanity = false)
                }, " \u78BA\u5B9A ")
            ])
        ])) : (0, $esfUo.createCommentVNode)("", true),
        (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_6, [
            (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_7, [
                (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_8, [
                    $f82330f373636e83$var$_hoisted_9,
                    (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_10, [
                        (0, $esfUo.createElementVNode)("form", {
                            class: "mb-5",
                            method: "post",
                            id: "contactForm",
                            name: "contactForm",
                            onSubmit: _cache[8] || (_cache[8] = (0, $NPJVB.withModifiers)((...args)=>$options.submitForm && $options.submitForm(...args), [
                                "prevent"
                            ])),
                            ref: "form"
                        }, [
                            (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_11, [
                                (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_12, [
                                    (0, $esfUo.withDirectives)((0, $esfUo.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$data.form.title = $event),
                                        type: "text",
                                        class: (0, $8ENGG.normalizeClass)([
                                            "form-control",
                                            {
                                                "is-invalid": !$options.validTitle
                                            }
                                        ]),
                                        placeholder: "\u6295\u7A3F\u6A19\u984C *"
                                    }, null, 2), [
                                        [
                                            (0, $NPJVB.vModelText),
                                            $data.form.title
                                        ]
                                    ]),
                                    $f82330f373636e83$var$_hoisted_13
                                ])
                            ]),
                            (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_14, [
                                (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_15, [
                                    (0, $esfUo.withDirectives)((0, $esfUo.createElementVNode)("textarea", {
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$data.form.description = $event),
                                        class: (0, $8ENGG.normalizeClass)([
                                            "form-control",
                                            {
                                                "is-invalid": !$options.validDesc
                                            }
                                        ]),
                                        name: "description",
                                        id: "description",
                                        style: {
                                            height: "180px"
                                        },
                                        placeholder: "\u6295\u7A3F\u5167\u5BB9 *"
                                    }, null, 2), [
                                        [
                                            (0, $NPJVB.vModelText),
                                            $data.form.description
                                        ]
                                    ]),
                                    $f82330f373636e83$var$_hoisted_16
                                ])
                            ]),
                            (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_17, [
                                (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_18, [
                                    (0, $esfUo.createElementVNode)("label", $f82330f373636e83$var$_hoisted_19, [
                                        (0, $esfUo.createVNode)(_component_font_awesome_icon, {
                                            icon: "fa-solid fa-image"
                                        }),
                                        (0, $esfUo.createTextVNode)(" \u6A94\u6848\u4E0A\u50B3 "),
                                        (0, $esfUo.createElementVNode)("input", {
                                            type: "file",
                                            style: {
                                                "display": "none"
                                            },
                                            id: "mediaupload",
                                            name: "mediaupload",
                                            multiple: "",
                                            accept: "image/*",
                                            onChange: _cache[4] || (_cache[4] = (...args)=>$options.uploadFiles && $options.uploadFiles(...args))
                                        }, null, 32)
                                    ]),
                                    $f82330f373636e83$var$_hoisted_20,
                                    (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_21, [
                                        ((0, $esfUo.openBlock)(true), (0, $esfUo.createElementBlock)((0, $esfUo.Fragment), null, (0, $esfUo.renderList)($data.files, (file, i)=>{
                                            return (0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", {
                                                id: i
                                            }, [
                                                (0, $esfUo.createElementVNode)("div", {
                                                    class: "preview",
                                                    style: (0, $8ENGG.normalizeStyle)({
                                                        backgroundImage: file.isImage ? "url(" + file.preview + ")" : null
                                                    })
                                                }, [
                                                    (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_23, [
                                                        (0, $esfUo.createElementVNode)("div", {
                                                            class: "progress-bar bg-info",
                                                            role: "progressbar",
                                                            style: (0, $8ENGG.normalizeStyle)({
                                                                width: file.progress + "%"
                                                            })
                                                        }, null, 4)
                                                    ]),
                                                    (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_24, [
                                                        (0, $esfUo.createElementVNode)("div", {
                                                            onClick: ($event)=>$options.remove(file)
                                                        }, [
                                                            (0, $esfUo.createVNode)(_component_font_awesome_icon, {
                                                                icon: "fa-solid fa-trash-can"
                                                            })
                                                        ], 8, $f82330f373636e83$var$_hoisted_25)
                                                    ]),
                                                    !file.isImage ? ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $f82330f373636e83$var$_hoisted_26, [
                                                        (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_27, (0, $8ENGG.toDisplayString)(file.name), 1)
                                                    ])) : (0, $esfUo.createCommentVNode)("", true)
                                                ], 4)
                                            ], 8, $f82330f373636e83$var$_hoisted_22);
                                        }), 256))
                                    ]),
                                    $data.files.length ? ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $f82330f373636e83$var$_hoisted_28, [
                                        $options.uploading ? ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $f82330f373636e83$var$_hoisted_29, "\u4E0A\u50B3\u4E2D...")) : ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $f82330f373636e83$var$_hoisted_30, [
                                            (0, $esfUo.createVNode)(_component_font_awesome_icon, {
                                                icon: "fa-solid fa-check"
                                            }),
                                            (0, $esfUo.createTextVNode)("\u4E0A\u50B3\u5B8C\u6210")
                                        ]))
                                    ])) : (0, $esfUo.createCommentVNode)("", true)
                                ])
                            ]),
                            (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_31, [
                                (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_32, [
                                    (0, $esfUo.withDirectives)((0, $esfUo.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$data.form.name = $event),
                                        type: "text",
                                        class: (0, $8ENGG.normalizeClass)([
                                            "form-control",
                                            {
                                                "is-invalid": !$options.validName
                                            }
                                        ]),
                                        name: "name",
                                        id: "name",
                                        placeholder: "\u7B46\u540D *"
                                    }, null, 2), [
                                        [
                                            (0, $NPJVB.vModelText),
                                            $data.form.name
                                        ]
                                    ]),
                                    $f82330f373636e83$var$_hoisted_33
                                ])
                            ]),
                            (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_34, [
                                (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_35, [
                                    (0, $esfUo.withDirectives)((0, $esfUo.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$data.form.email = $event),
                                        type: "text",
                                        class: (0, $8ENGG.normalizeClass)([
                                            "form-control",
                                            {
                                                "is-invalid": !$options.validEmail
                                            }
                                        ]),
                                        name: "email",
                                        id: "email",
                                        placeholder: "E-mail\u4FE1\u7BB1 *"
                                    }, null, 2), [
                                        [
                                            (0, $NPJVB.vModelText),
                                            $data.form.email
                                        ]
                                    ]),
                                    $f82330f373636e83$var$_hoisted_36
                                ])
                            ]),
                            $f82330f373636e83$var$_hoisted_37,
                            (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_38, [
                                (0, $esfUo.createElementVNode)("div", $f82330f373636e83$var$_hoisted_39, [
                                    (0, $esfUo.createVNode)($setup["ChallengeV3"], {
                                        modelValue: $setup.response,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.response = $event),
                                        action: "submit",
                                        autoExecute: false
                                    }, {
                                        default: (0, $esfUo.withCtx)((slotProps)=>[
                                                (0, $esfUo.createElementVNode)("div", {
                                                    disabled: !$options.canSubmit,
                                                    onClick: ($event)=>$options.submitForm(slotProps),
                                                    class: "btn btn-primary rounded-0 py-3 px-4 h-auto"
                                                }, (0, $8ENGG.toDisplayString)($options.submitBtnText), 9, $f82330f373636e83$var$_hoisted_40)
                                            ]),
                                        _: 1
                                    }, 8, [
                                        "modelValue"
                                    ]),
                                    $f82330f373636e83$var$_hoisted_41
                                ])
                            ])
                        ], 544),
                        $data.success ? ((0, $esfUo.openBlock)(), (0, $esfUo.createElementBlock)("div", $f82330f373636e83$var$_hoisted_42, "\u8B1D\u8B1D\u60A8")) : (0, $esfUo.createCommentVNode)("", true)
                    ])
                ])
            ])
        ])
    ]);
}

});

parcelRegister("41yyH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ee21009d793bff1$export$2e2bcd8739ae039; });
let $2ee21009d793bff1$var$NOOP = ()=>{};
var $2ee21009d793bff1$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("hQJKw");
var $NPJVB = parcelRequire("NPJVB");
let $121eff3ddb6a1cde$var$script;




let $121eff3ddb6a1cde$var$initialize = ()=>{
    $121eff3ddb6a1cde$var$script = (parcelRequire("gbZaU"));
    if ($121eff3ddb6a1cde$var$script.__esModule) $121eff3ddb6a1cde$var$script = $121eff3ddb6a1cde$var$script.default;
    $121eff3ddb6a1cde$var$script.render = (parcelRequire("3d9Ls")).render;
    $121eff3ddb6a1cde$var$script.__cssModules = {};
    (parcelRequire("g1h0m")).default($121eff3ddb6a1cde$var$script);
    $121eff3ddb6a1cde$var$script.__scopeId = "data-v-77cbc5";
    $121eff3ddb6a1cde$var$script.__file = "App.vue";
};
$121eff3ddb6a1cde$var$initialize();
var $121eff3ddb6a1cde$export$2e2bcd8739ae039 = $121eff3ddb6a1cde$var$script;


let $fda6e9655def196e$var$script;



let $fda6e9655def196e$var$initialize = ()=>{
    $fda6e9655def196e$var$script = (parcelRequire("3UbMi"));
    if ($fda6e9655def196e$var$script.__esModule) $fda6e9655def196e$var$script = $fda6e9655def196e$var$script.default;
    $fda6e9655def196e$var$script.render = (parcelRequire("fd4jk")).render;
    (parcelRequire("9RJcM")).default($fda6e9655def196e$var$script);
    $fda6e9655def196e$var$script.__scopeId = "data-v-eff5d0";
    $fda6e9655def196e$var$script.__file = "NewsTip.vue";
};
$fda6e9655def196e$var$initialize();
var $fda6e9655def196e$export$2e2bcd8739ae039 = $fda6e9655def196e$var$script;


let $f011be922a1a6f1f$var$script;



let $f011be922a1a6f1f$var$initialize = ()=>{
    $f011be922a1a6f1f$var$script = (parcelRequire("04FHs"));
    if ($f011be922a1a6f1f$var$script.__esModule) $f011be922a1a6f1f$var$script = $f011be922a1a6f1f$var$script.default;
    $f011be922a1a6f1f$var$script.render = (parcelRequire("adGup")).render;
    (parcelRequire("9Ihej")).default($f011be922a1a6f1f$var$script);
    $f011be922a1a6f1f$var$script.__scopeId = "data-v-af6304";
    $f011be922a1a6f1f$var$script.__file = "DataSafety.vue";
};
$f011be922a1a6f1f$var$initialize();
var $f011be922a1a6f1f$export$2e2bcd8739ae039 = $f011be922a1a6f1f$var$script;


let $adf9be45d142e894$var$script;




let $adf9be45d142e894$var$initialize = ()=>{
    $adf9be45d142e894$var$script = (parcelRequire("4ph75"));
    if ($adf9be45d142e894$var$script.__esModule) $adf9be45d142e894$var$script = $adf9be45d142e894$var$script.default;
    $adf9be45d142e894$var$script.render = (parcelRequire("liPsa")).render;
    $adf9be45d142e894$var$script.__cssModules = {};
    (parcelRequire("41yyH")).default($adf9be45d142e894$var$script);
    $adf9be45d142e894$var$script.__scopeId = "data-v-e10464";
    $adf9be45d142e894$var$script.__file = "UGC.vue";
};
$adf9be45d142e894$var$initialize();
var $adf9be45d142e894$export$2e2bcd8739ae039 = $adf9be45d142e894$var$script;


/*!
  * vue-router v4.2.2
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */ parcelRequire("hQJKw");
var $esfUo = parcelRequire("esfUo");
var $am4TS = parcelRequire("am4TS");
function $4389df47bbaa9548$export$5a2d366b2d9f38f6() {
    return $4389df47bbaa9548$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $4389df47bbaa9548$export$c22522a4dfa48e9c() {
    // @ts-ignore
    return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
}
const $4389df47bbaa9548$export$bc32a04c49ed7464 = typeof Proxy === "function";


const $21b3851cf84648a4$export$b1499c3bd2a3f4df = "devtools-plugin:setup";
const $21b3851cf84648a4$export$a0897f44accbe922 = "plugin:settings:set";



let $83389cdab3e63a08$var$supported;
let $83389cdab3e63a08$var$perf;
function $83389cdab3e63a08$export$70d26280bc1ca547() {
    var _a;
    if ($83389cdab3e63a08$var$supported !== undefined) return $83389cdab3e63a08$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $83389cdab3e63a08$var$supported = true;
        $83389cdab3e63a08$var$perf = window.performance;
    } else if (typeof $parcel$global !== "undefined" && ((_a = $parcel$global.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $83389cdab3e63a08$var$supported = true;
        $83389cdab3e63a08$var$perf = $parcel$global.perf_hooks.performance;
    } else $83389cdab3e63a08$var$supported = false;
    return $83389cdab3e63a08$var$supported;
}
function $83389cdab3e63a08$export$461939dd4422153() {
    return $83389cdab3e63a08$export$70d26280bc1ca547() ? $83389cdab3e63a08$var$perf.now() : Date.now();
}


class $b8ee1ffd4579198b$export$5728f3776e9b2ac1 {
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $83389cdab3e63a08$export$461939dd4422153)();
            }
        };
        if (hook) hook.on((0, $21b3851cf84648a4$export$a0897f44accbe922), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === "on") return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
}





function $90cb27801a0b9533$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $4389df47bbaa9548$export$c22522a4dfa48e9c)();
    const hook = (0, $4389df47bbaa9548$export$5a2d366b2d9f38f6)();
    const enableProxy = (0, $4389df47bbaa9548$export$bc32a04c49ed7464) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $21b3851cf84648a4$export$b1499c3bd2a3f4df), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $b8ee1ffd4579198b$export$5728f3776e9b2ac1)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}


const $689dddd804f8aa0f$var$isBrowser = typeof window !== "undefined";
function $689dddd804f8aa0f$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module";
}
const $689dddd804f8aa0f$var$assign = Object.assign;
function $689dddd804f8aa0f$var$applyToParams(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $689dddd804f8aa0f$var$isArray(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $689dddd804f8aa0f$var$noop = ()=>{};
/**
 * Typesafe alternative to Array.isArray
 * https://github.com/microsoft/TypeScript/pull/48228
 */ const $689dddd804f8aa0f$var$isArray = Array.isArray;
function $689dddd804f8aa0f$var$warn(msg) {
    // avoid using ...args as it breaks in older Edge builds
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
const $689dddd804f8aa0f$var$TRAILING_SLASH_RE = /\/$/;
const $689dddd804f8aa0f$var$removeTrailingSlash = (path)=>path.replace($689dddd804f8aa0f$var$TRAILING_SLASH_RE, "");
/**
 * Transforms a URI into a normalized history location
 *
 * @param parseQuery
 * @param location - URI to normalize
 * @param currentLocation - current absolute location. Allows resolving relative
 * paths. Must start with `/`. Defaults to `/`
 * @returns a normalized history location
 */ function $689dddd804f8aa0f$var$parseURL(parseQuery, location1, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    // Could use URL and URLSearchParams but IE 11 doesn't support it
    // TODO: move to new URL()
    const hashPos = location1.indexOf("#");
    let searchPos = location1.indexOf("?");
    // the hash appears before the search, so it's not part of the search string
    if (hashPos < searchPos && hashPos >= 0) searchPos = -1;
    if (searchPos > -1) {
        path = location1.slice(0, searchPos);
        searchString = location1.slice(searchPos + 1, hashPos > -1 ? hashPos : location1.length);
        query = parseQuery(searchString);
    }
    if (hashPos > -1) {
        path = path || location1.slice(0, hashPos);
        // keep the # character
        hash = location1.slice(hashPos, location1.length);
    }
    // no search and no query
    path = $689dddd804f8aa0f$var$resolveRelativePath(path != null ? path : location1, currentLocation);
    // empty path means a relative query or hash `?foo=f`, `#thing`
    return {
        fullPath: path + (searchString && "?") + searchString + hash,
        path: path,
        query: query,
        hash: hash
    };
}
/**
 * Stringifies a URL object
 *
 * @param stringifyQuery
 * @param location
 */ function $689dddd804f8aa0f$var$stringifyURL(stringifyQuery, location1) {
    const query = location1.query ? stringifyQuery(location1.query) : "";
    return location1.path + (query && "?") + query + (location1.hash || "");
}
/**
 * Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
 *
 * @param pathname - location.pathname
 * @param base - base to strip off
 */ function $689dddd804f8aa0f$var$stripBase(pathname, base) {
    // no base or base is not found at the beginning
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
 * Checks if two RouteLocation are equal. This means that both locations are
 * pointing towards the same {@link RouteRecord} and that all `params`, `query`
 * parameters and `hash` are the same
 *
 * @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
 * @param a - first {@link RouteLocation}
 * @param b - second {@link RouteLocation}
 */ function $689dddd804f8aa0f$var$isSameRouteLocation(stringifyQuery, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $689dddd804f8aa0f$var$isSameRouteRecord(a.matched[aLastIndex], b.matched[bLastIndex]) && $689dddd804f8aa0f$var$isSameRouteLocationParams(a.params, b.params) && stringifyQuery(a.query) === stringifyQuery(b.query) && a.hash === b.hash;
}
/**
 * Check if two `RouteRecords` are equal. Takes into account aliases: they are
 * considered equal to the `RouteRecord` they are aliasing.
 *
 * @param a - first {@link RouteRecord}
 * @param b - second {@link RouteRecord}
 */ function $689dddd804f8aa0f$var$isSameRouteRecord(a, b) {
    // since the original record has an undefined value for aliasOf
    // but all aliases point to the original record, this will always compare
    // the original record
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $689dddd804f8aa0f$var$isSameRouteLocationParams(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (!$689dddd804f8aa0f$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    }
    return true;
}
function $689dddd804f8aa0f$var$isSameRouteLocationParamsValue(a, b) {
    return $689dddd804f8aa0f$var$isArray(a) ? $689dddd804f8aa0f$var$isEquivalentArray(a, b) : $689dddd804f8aa0f$var$isArray(b) ? $689dddd804f8aa0f$var$isEquivalentArray(b, a) : a === b;
}
/**
 * Check if two arrays are the same or if an array with one single entry is the
 * same as another primitive value. Used to check query and parameters
 *
 * @param a - array of values
 * @param b - array of values or a single value
 */ function $689dddd804f8aa0f$var$isEquivalentArray(a, b) {
    return $689dddd804f8aa0f$var$isArray(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
 * Resolves a relative path that starts with `.`.
 *
 * @param to - path location we are resolving
 * @param from - currentLocation.path, should start with `/`
 */ function $689dddd804f8aa0f$var$resolveRelativePath(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    // make . and ./ the same (../ === .., ../../ === ../..)
    // this is the same behavior as new URL()
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        // we stay on the same position
        if (segment === ".") continue;
        // go up in the from array
        if (segment === "..") // we can't go below zero, but we still need to increment toPosition
        {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments// ensure we use at least the last element in the toSegments
    .slice(toPosition - (toPosition === toSegments.length ? 1 : 0)).join("/");
}
var $689dddd804f8aa0f$var$NavigationType;
(function(NavigationType) {
    NavigationType["pop"] = "pop";
    NavigationType["push"] = "push";
})($689dddd804f8aa0f$var$NavigationType || ($689dddd804f8aa0f$var$NavigationType = {}));
var $689dddd804f8aa0f$var$NavigationDirection;
(function(NavigationDirection) {
    NavigationDirection["back"] = "back";
    NavigationDirection["forward"] = "forward";
    NavigationDirection["unknown"] = "";
})($689dddd804f8aa0f$var$NavigationDirection || ($689dddd804f8aa0f$var$NavigationDirection = {}));
/**
 * Starting location for Histories
 */ const $689dddd804f8aa0f$var$START = "";
// Generic utils
/**
 * Normalizes a base by removing any trailing slash and reading the base tag if
 * present.
 *
 * @param base - base to normalize
 */ function $689dddd804f8aa0f$var$normalizeBase(base) {
    if (!base) {
        if ($689dddd804f8aa0f$var$isBrowser) {
            // respect <base> tag
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            // strip full URL origin
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    // ensure leading slash when it was removed by the regex above avoid leading
    // slash with hash because the file could be read from the disk like file://
    // and the leading slash would cause problems
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    // remove the trailing slash so all other method can just do `base + fullPath`
    // to build an href
    return $689dddd804f8aa0f$var$removeTrailingSlash(base);
}
// remove any character before the hash
const $689dddd804f8aa0f$var$BEFORE_HASH_RE = /^[^#]+#/;
function $689dddd804f8aa0f$var$createHref(base, location1) {
    return base.replace($689dddd804f8aa0f$var$BEFORE_HASH_RE, "#") + location1;
}
function $689dddd804f8aa0f$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $689dddd804f8aa0f$var$computeScrollPosition = ()=>({
        left: window.pageXOffset,
        top: window.pageYOffset
    });
function $689dddd804f8aa0f$var$scrollToPosition(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $689dddd804f8aa0f$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.pageXOffset, scrollToOptions.top != null ? scrollToOptions.top : window.pageYOffset);
}
function $689dddd804f8aa0f$var$getScrollKey(path, delta) {
    const position = history.state ? history.state.position - delta : -1;
    return position + path;
}
const $689dddd804f8aa0f$var$scrollPositions = new Map();
function $689dddd804f8aa0f$var$saveScrollPosition(key, scrollPosition) {
    $689dddd804f8aa0f$var$scrollPositions.set(key, scrollPosition);
}
function $689dddd804f8aa0f$var$getSavedScrollPosition(key) {
    const scroll = $689dddd804f8aa0f$var$scrollPositions.get(key);
    // consume it so it's not used again
    $689dddd804f8aa0f$var$scrollPositions.delete(key);
    return scroll;
}
// TODO: RFC about how to save scroll position
/**
 * ScrollBehavior instance used by the router to compute and restore the scroll
 * position when navigating.
 */ // export interface ScrollHandler<ScrollPositionEntry extends HistoryStateValue, ScrollPosition extends ScrollPositionEntry> {
//   // returns a scroll position that can be saved in history
//   compute(): ScrollPositionEntry
//   // can take an extended ScrollPositionEntry
//   scroll(position: ScrollPosition): void
// }
// export const scrollHandler: ScrollHandler<ScrollPosition> = {
//   compute: computeScroll,
//   scroll: scrollToPosition,
// }
let $689dddd804f8aa0f$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
 * Creates a normalized history location from a window.location object
 * @param base - The base path
 * @param location - The window.location object
 */ function $689dddd804f8aa0f$var$createCurrentLocation(base, location1) {
    const { pathname: pathname, search: search, hash: hash } = location1;
    // allows hash bases like #, /#, #/, #!, #!/, /#!/, or even /folder#end
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        // prepend the starting slash to hash so the url starts with /#
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return $689dddd804f8aa0f$var$stripBase(pathFromHash, "");
    }
    const path = $689dddd804f8aa0f$var$stripBase(pathname, base);
    return path + search + hash;
}
function $689dddd804f8aa0f$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    // TODO: should it be a stack? a Dict. Check if the popstate listener
    // can trigger twice
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $689dddd804f8aa0f$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            // ignore the popstate and reset the pauseState
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        // console.log({ deltaFromCurrent })
        // Here we could also revert the navigation by calling history.go(-delta)
        // this listener will have to be adapted to not trigger again and to wait for the url
        // to be updated before triggering the listeners. Some kind of validation function would also
        // need to be passed to the listeners so the navigation can be accepted
        // call all listeners
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: $689dddd804f8aa0f$var$NavigationType.pop,
                direction: delta ? delta > 0 ? $689dddd804f8aa0f$var$NavigationDirection.forward : $689dddd804f8aa0f$var$NavigationDirection.back : $689dddd804f8aa0f$var$NavigationDirection.unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        // set up the listener and prepare teardown callbacks
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        const { history: history1 } = window;
        if (!history1.state) return;
        history1.replaceState($689dddd804f8aa0f$var$assign({}, history1.state, {
            scroll: $689dddd804f8aa0f$var$computeScrollPosition()
        }), "");
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("beforeunload", beforeUnloadListener);
    }
    // set up the listeners and prepare teardown callbacks
    window.addEventListener("popstate", popStateHandler);
    // TODO: could we use 'pagehide' or 'visibilitychange' instead?
    // https://developer.chrome.com/blog/page-lifecycle-api/
    window.addEventListener("beforeunload", beforeUnloadListener, {
        passive: true
    });
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
 * Creates a state object
 */ function $689dddd804f8aa0f$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? $689dddd804f8aa0f$var$computeScrollPosition() : null
    };
}
function $689dddd804f8aa0f$var$useHistoryStateNavigation(base) {
    const { history: history1, location: location1 } = window;
    // private variables
    const currentLocation = {
        value: $689dddd804f8aa0f$var$createCurrentLocation(base, location1)
    };
    const historyState = {
        value: history1.state
    };
    // build current history entry as this is a fresh navigation
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        // the length is off by one, we need to decrease it
        position: history1.length - 1,
        replaced: true,
        // don't add a scroll as the user may have an anchor, and we want
        // scrollBehavior to be triggered without a saved position
        scroll: null
    }, true);
    function changeLocation(to, state, replace) {
        /**
         * if a base tag is provided, and we are on a normal domain, we have to
         * respect the provided `base` attribute because pushState() will use it and
         * potentially erase anything before the `#` like at
         * https://github.com/vuejs/router/issues/685 where a base of
         * `/folder/#` but a base of `/` would erase the `/folder/` section. If
         * there is no host, the `<base>` tag makes no sense and if there isn't a
         * base tag we can just use everything after the `#`.
         */ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $689dddd804f8aa0f$var$createBaseLocation() + base + to;
        try {
            // BROWSER QUIRK
            // NOTE: Safari throws a SecurityError when calling this function 100 times in 30 seconds
            history1[replace ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            // Force the navigation, this also resets the call count
            location1[replace ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        const state = $689dddd804f8aa0f$var$assign({}, history1.state, $689dddd804f8aa0f$var$buildState(historyState.value.back, // keep back and forward entries but override current position
        to, historyState.value.forward, true), data, {
            position: historyState.value.position
        });
        changeLocation(to, state, true);
        currentLocation.value = to;
    }
    function push(to, data) {
        // Add to current entry the information of where we are going
        // as well as saving the current position
        const currentState = $689dddd804f8aa0f$var$assign({}, // use current history state to gracefully handle a wrong call to
        // history.replaceState
        // https://github.com/vuejs/router/issues/366
        historyState.value, history1.state, {
            forward: to,
            scroll: $689dddd804f8aa0f$var$computeScrollPosition()
        });
        changeLocation(currentState.current, currentState, true);
        const state = $689dddd804f8aa0f$var$assign({}, $689dddd804f8aa0f$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data);
        changeLocation(to, state, false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
 * Creates an HTML5 history. Most common history for single page applications.
 *
 * @param base -
 */ function $689dddd804f8aa0f$export$7b4942f78e7b8a49(base) {
    base = $689dddd804f8aa0f$var$normalizeBase(base);
    const historyNavigation = $689dddd804f8aa0f$var$useHistoryStateNavigation(base);
    const historyListeners = $689dddd804f8aa0f$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = $689dddd804f8aa0f$var$assign({
        // it's overridden right after
        location: "",
        base: base,
        go: go,
        createHref: $689dddd804f8aa0f$var$createHref.bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
/**
 * Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
 * It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
 *
 * @param base - Base applied to all urls, defaults to '/'
 * @returns a history object that can be passed to the router constructor
 */ function $689dddd804f8aa0f$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        $689dddd804f8aa0f$var$START
    ];
    let position = 0;
    base = $689dddd804f8aa0f$var$normalizeBase(base);
    function setLocation(location1) {
        position++;
        if (position === queue.length) // we are at the end, we can simply append a new entry
        queue.push(location1);
        else {
            // we are in the middle, we remove everything from here in the queue
            queue.splice(position);
            queue.push(location1);
        }
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: $689dddd804f8aa0f$var$NavigationType.pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        // rewritten by Object.defineProperty
        location: $689dddd804f8aa0f$var$START,
        // TODO: should be kept in queue
        state: {},
        base: base,
        createHref: $689dddd804f8aa0f$var$createHref.bind(null, base),
        replace (to) {
            // remove current entry and decrement position
            queue.splice(position--, 1);
            setLocation(to);
        },
        push (to, data) {
            setLocation(to);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                $689dddd804f8aa0f$var$START
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = // we are considering delta === 0 going forward, but in abstract mode
            // using 0 for the delta doesn't make sense like it does in html5 where
            // it reloads the page
            delta < 0 ? $689dddd804f8aa0f$var$NavigationDirection.back : $689dddd804f8aa0f$var$NavigationDirection.forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position]
    });
    return routerHistory;
}
/**
 * Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
 * handle any URL is not possible.
 *
 * @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
 * in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
 * calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
 * after the `#`).
 *
 * @example
 * ```js
 * // at https://example.com/folder
 * createWebHashHistory() // gives a url of `https://example.com/folder#`
 * createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
 * // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
 * createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
 * // you should avoid doing this because it changes the original url and breaks copying urls
 * createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
 *
 * // at file:///usr/etc/folder/index.html
 * // for locations with no `host`, the base is ignored
 * createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
 * ```
 */ function $689dddd804f8aa0f$export$542bc3a76486c94d(base) {
    // Make sure this implementation is fine in terms of encoding, specially for IE11
    // for `file://`, directly use the pathname and ignore the base
    // location.pathname contains an initial `/` even at the root: `https://example.com`
    base = location.host ? base || location.pathname + location.search : "";
    // allow the user to provide a `#` in the middle: `/base/#/app`
    if (!base.includes("#")) base += "#";
    return $689dddd804f8aa0f$export$7b4942f78e7b8a49(base);
}
function $689dddd804f8aa0f$var$isRouteLocation(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $689dddd804f8aa0f$var$isRouteName(name) {
    return typeof name === "string" || typeof name === "symbol";
}
/**
 * Initial route location where the router is. Can be used in navigation guards
 * to differentiate the initial navigation.
 *
 * @example
 * ```js
 * import { START_LOCATION } from 'vue-router'
 *
 * router.beforeEach((to, from) => {
 *   if (from === START_LOCATION) {
 *     // initial navigation
 *   }
 * })
 * ```
 */ const $689dddd804f8aa0f$export$e44be9a9779c480b = {
    path: "/",
    name: undefined,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: undefined
};
const $689dddd804f8aa0f$var$NavigationFailureSymbol = Symbol("");
/**
 * Enumeration with all possible types for navigation failures. Can be passed to
 * {@link isNavigationFailure} to check for specific failures.
 */ var $689dddd804f8aa0f$export$35710516f95d6a57;
(function(NavigationFailureType) {
    /**
     * An aborted navigation is a navigation that failed because a navigation
     * guard returned `false` or called `next(false)`
     */ NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
     * A cancelled navigation is a navigation that failed because a more recent
     * navigation finished started (not necessarily finished).
     */ NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
     * A duplicated navigation is a navigation that failed because it was
     * initiated while already being at the exact same location.
     */ NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
})($689dddd804f8aa0f$export$35710516f95d6a57 || ($689dddd804f8aa0f$export$35710516f95d6a57 = {}));
// DEV only debug messages
const $689dddd804f8aa0f$var$ErrorTypeMessages = {
    [1 /* ErrorTypes.MATCHER_NOT_FOUND */ ] ({ location: location1, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location1)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$689dddd804f8aa0f$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [4 /* ErrorTypes.NAVIGATION_ABORTED */ ] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [8 /* ErrorTypes.NAVIGATION_CANCELLED */ ] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [16 /* ErrorTypes.NAVIGATION_DUPLICATED */ ] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
function $689dddd804f8aa0f$var$createRouterError(type, params) {
    return $689dddd804f8aa0f$var$assign(new Error(), {
        type: type,
        [$689dddd804f8aa0f$var$NavigationFailureSymbol]: true
    }, params);
}
function $689dddd804f8aa0f$export$873de56207a30e5a(error, type) {
    return error instanceof Error && $689dddd804f8aa0f$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $689dddd804f8aa0f$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $689dddd804f8aa0f$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if ("path" in to) return to.path;
    const location1 = {};
    for (const key of $689dddd804f8aa0f$var$propertiesToLog)if (key in to) location1[key] = to[key];
    return JSON.stringify(location1, null, 2);
}
// default pattern for a param: non-greedy everything but /
const $689dddd804f8aa0f$var$BASE_PARAM_PATTERN = "[^/]+?";
const $689dddd804f8aa0f$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
// Special Regex characters that must be escaped in static tokens
const $689dddd804f8aa0f$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
 * Creates a path parser from an array of Segments (a segment is an array of Tokens)
 *
 * @param segments - array of segments returned by tokenizePath
 * @param extraOptions - optional options for the regexp
 * @returns a PathParser
 */ function $689dddd804f8aa0f$var$tokensToParser(segments, extraOptions) {
    const options = $689dddd804f8aa0f$var$assign({}, $689dddd804f8aa0f$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    // the amount of scores is the same as the length of segments except for the root segment "/"
    const score = [];
    // the regexp as a string
    let pattern = options.start ? "^" : "";
    // extracted keys
    const keys = [];
    for (const segment of segments){
        // the root segment needs special treatment
        const segmentScores = segment.length ? [] : [
            90 /* PathScore.Root */ 
        ];
        // allow trailing slash
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            // resets the score if we are inside a sub-segment /:a-other-:b
            let subSegmentScore = 40 /* PathScore.Segment */  + (options.sensitive ? 0.25 /* PathScore.BonusCaseSensitive */  : 0);
            if (token.type === 0 /* TokenType.Static */ ) {
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($689dddd804f8aa0f$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += 40 /* PathScore.Static */ ;
            } else if (token.type === 1 /* TokenType.Param */ ) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re = regexp ? regexp : $689dddd804f8aa0f$var$BASE_PARAM_PATTERN;
                // the user provided a custom regexp /:id(\\d+)
                if (re !== $689dddd804f8aa0f$var$BASE_PARAM_PATTERN) {
                    subSegmentScore += 10 /* PathScore.BonusCustomRegExp */ ;
                    // make sure the regexp is valid before using it
                    try {
                        new RegExp(`(${re})`);
                    } catch (err) {
                        throw new Error(`Invalid custom RegExp for param "${value}" (${re}): ` + err.message);
                    }
                }
                // when we repeat we must take care of the repeating leading slash
                let subPattern = repeatable ? `((?:${re})(?:/(?:${re}))*)` : `(${re})`;
                // prepend the slash if we are starting a new segment
                if (!tokenIndex) subPattern = // avoid an optional / if there are more segments e.g. /:p?-static
                // or /:p?-:p2
                optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += 20 /* PathScore.Dynamic */ ;
                if (optional) subSegmentScore += -8 /* PathScore.BonusOptional */ ;
                if (repeatable) subSegmentScore += -20 /* PathScore.BonusRepeatable */ ;
                if (re === ".*") subSegmentScore += -50 /* PathScore.BonusWildcard */ ;
            }
            segmentScores.push(subSegmentScore);
        }
        // an empty array like /home/ -> [[{home}], []]
        // if (!segment.length) pattern += '/'
        score.push(segmentScores);
    }
    // only apply the strict bonus to the last score
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += 0.7000000000000001 /* PathScore.BonusStrict */ ;
    }
    // TODO: dev only warn double trailing slash
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        // for optional parameters to allow to be empty
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment){
                if (token.type === 0 /* TokenType.Static */ ) path += token.value;
                else if (token.type === 1 /* TokenType.Param */ ) {
                    const { value: value, repeatable: repeatable, optional: optional } = token;
                    const param = value in params ? params[value] : "";
                    if ($689dddd804f8aa0f$var$isArray(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                    const text = $689dddd804f8aa0f$var$isArray(param) ? param.join("/") : param;
                    if (!text) {
                        if (optional) // if we have more than one optional param like /:a?-static we don't need to care about the optional param
                        {
                            if (segment.length < 2) {
                                // remove the last slash as we could be at the end
                                if (path.endsWith("/")) path = path.slice(0, -1);
                                else avoidDuplicatedSlash = true;
                            }
                        } else throw new Error(`Missing required param "${value}"`);
                    }
                    path += text;
                }
            }
        }
        // avoid empty path when we have multiple optional params
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
 * Compares an array of numbers as used in PathParser.score and returns a
 * number. This function can be used to `sort` an array
 *
 * @param a - first array of numbers
 * @param b - second array of numbers
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 * should be sorted first
 */ function $689dddd804f8aa0f$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        // only keep going if diff === 0
        if (diff) return diff;
        i++;
    }
    // if the last subsegment was Static, the shorter segments should be sorted first
    // otherwise sort the longest segment first
    if (a.length < b.length) return a.length === 1 && a[0] === 80 /* PathScore.Segment */  ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === 80 /* PathScore.Segment */  ? 1 : -1;
    return 0;
}
/**
 * Compare function that can be used with `sort` to sort an array of PathParser
 *
 * @param a - first PathParser
 * @param b - second PathParser
 * @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
 */ function $689dddd804f8aa0f$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $689dddd804f8aa0f$var$compareScoreArray(aScore[i], bScore[i]);
        // do not return if both are equal
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($689dddd804f8aa0f$var$isLastScoreNegative(aScore)) return 1;
        if ($689dddd804f8aa0f$var$isLastScoreNegative(bScore)) return -1;
    }
    // if a and b share the same score entries but b has more, sort b first
    return bScore.length - aScore.length;
// this is the ternary version
// return aScore.length < bScore.length
//   ? 1
//   : aScore.length > bScore.length
//   ? -1
//   : 0
}
/**
 * This allows detecting splats at the end of a path: /home/:id(.*)*
 *
 * @param score - score to check
 * @returns true if the last entry is negative
 */ function $689dddd804f8aa0f$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $689dddd804f8aa0f$var$ROOT_TOKEN = {
    type: 0 /* TokenType.Static */ ,
    value: ""
};
const $689dddd804f8aa0f$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
// After some profiling, the cache seems to be unnecessary because tokenizePath
// (the slowest part of adding a route) is very fast
// const tokenCache = new Map<string, Token[][]>()
function $689dddd804f8aa0f$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $689dddd804f8aa0f$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error(`Invalid path "${path}"`);
    // if (tokenCache.has(path)) return tokenCache.get(path)!
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = 0 /* TokenizerState.Static */ ;
    let previousState = state;
    const tokens = [];
    // the segment will always be valid because we get into the initial state
    // with the leading /
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    // index on the path
    let i = 0;
    // char at index
    let char;
    // buffer of the value read
    let buffer = "";
    // custom regexp for a param
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === 0 /* TokenizerState.Static */ ) segment.push({
            type: 0 /* TokenType.Static */ ,
            value: buffer
        });
        else if (state === 1 /* TokenizerState.Param */  || state === 2 /* TokenizerState.ParamRegExp */  || state === 3 /* TokenizerState.ParamRegExpEnd */ ) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: 1 /* TokenType.Param */ ,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== 2 /* TokenizerState.ParamRegExp */ ) {
            previousState = state;
            state = 4 /* TokenizerState.EscapeNext */ ;
            continue;
        }
        switch(state){
            case 0 /* TokenizerState.Static */ :
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = 1 /* TokenizerState.Param */ ;
                } else addCharToBuffer();
                break;
            case 4 /* TokenizerState.EscapeNext */ :
                addCharToBuffer();
                state = previousState;
                break;
            case 1 /* TokenizerState.Param */ :
                if (char === "(") state = 2 /* TokenizerState.ParamRegExp */ ;
                else if ($689dddd804f8aa0f$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = 0 /* TokenizerState.Static */ ;
                    // go back one character if we were not modifying
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case 2 /* TokenizerState.ParamRegExp */ :
                // TODO: is it worth handling nested regexp? like :p(?:prefix_([^/]+)_suffix)
                // it already works by escaping the closing )
                // https://paths.esm.dev/?p=AAMeJbiAwQEcDKbAoAAkP60PG2R6QAvgNaA6AFACM2ABuQBB#
                // is this really something people need since you can also write
                // /prefix_:p()_suffix
                if (char === ")") {
                    // handle the escaped )
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = 3 /* TokenizerState.ParamRegExpEnd */ ;
                } else customRe += char;
                break;
            case 3 /* TokenizerState.ParamRegExpEnd */ :
                // same as finalizing a param
                consumeBuffer();
                state = 0 /* TokenizerState.Static */ ;
                // go back one character if we were not modifying
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === 2 /* TokenizerState.ParamRegExp */ ) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    // tokenCache.set(path, tokens)
    return tokens;
}
function $689dddd804f8aa0f$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $689dddd804f8aa0f$var$tokensToParser($689dddd804f8aa0f$var$tokenizePath(record.path), options);
    const matcher = $689dddd804f8aa0f$var$assign(parser, {
        record: record,
        parent: parent,
        // these needs to be populated by the parent
        children: [],
        alias: []
    });
    if (parent) // both are aliases or both are not aliases
    // we don't want to mix them because the order is used when
    // passing originalRecord in Matcher.addRoute
    {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
/**
 * Creates a Router Matcher.
 *
 * @internal
 * @param routes - array of initial routes
 * @param globalOptions - global route options
 */ function $689dddd804f8aa0f$export$36302c85fdcc95a8(routes, globalOptions) {
    // normalized ordered array of matchers
    const matchers = [];
    const matcherMap = new Map();
    globalOptions = $689dddd804f8aa0f$var$mergeOptions({
        strict: false,
        end: true,
        sensitive: false
    }, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        // used later on to remove by name
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $689dddd804f8aa0f$var$normalizeRouteRecord(record);
        // we might be the child of an alias
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = $689dddd804f8aa0f$var$mergeOptions(globalOptions, record);
        // generate an array of records to correctly handle aliases
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($689dddd804f8aa0f$var$assign({}, mainNormalizedRecord, {
                // this allows us to hold a copy of the `components` option
                // so that async components cache is hold on the original record
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                // we might be the child of an alias
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            }));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            // Build up the path for nested routes if the child isn't an absolute
            // route. Only add the / delimiter if the child path isn't empty and if the
            // parent path doesn't have a trailing slash
            if (parent && path[0] !== "/") {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            // create the object beforehand, so it can be passed to children
            matcher = $689dddd804f8aa0f$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            // if we are an alias we must tell the original record that we exist,
            // so we can be removed
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                // otherwise, the first record is the original and others are aliases
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                // remove the route if named and only for the top record (avoid in nested calls)
                // this works because the original record is the first one
                if (isRootAdd && record.name && !$689dddd804f8aa0f$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            // if there was no original record, then the first one was not an alias and all
            // other aliases (if any) need to reference this record when adding children
            originalRecord = originalRecord || matcher;
            // TODO: add normalized records for more flexibility
            // if (parent && isAliasRecord(originalRecord)) {
            //   parent.children.push(originalRecord)
            // }
            // Avoid adding a record that doesn't display anything. This allows passing through records without a component to
            // not be reached and pass through the catch all route
            if (matcher.record.components && Object.keys(matcher.record.components).length || matcher.record.name || matcher.record.redirect) insertMatcher(matcher);
        }
        return originalMatcher ? ()=>{
            // since other matchers are aliases, they should be removed by the original matcher
            removeRoute(originalMatcher);
        } : $689dddd804f8aa0f$var$noop;
    }
    function removeRoute(matcherRef) {
        if ($689dddd804f8aa0f$var$isRouteName(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        let i = 0;
        while(i < matchers.length && $689dddd804f8aa0f$var$comparePathParserScore(matcher, matchers[i]) >= 0 && // Adding children with empty path should still appear before the parent
        // https://github.com/vuejs/router/issues/1124
        (matcher.record.path !== matchers[i].record.path || !$689dddd804f8aa0f$var$isRecordChildOf(matcher, matchers[i])))i++;
        matchers.splice(i, 0, matcher);
        // only add the original record to the name map
        if (matcher.record.name && !$689dddd804f8aa0f$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location1 && location1.name) {
            matcher = matcherMap.get(location1.name);
            if (!matcher) throw $689dddd804f8aa0f$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1
            });
            name = matcher.record.name;
            params = $689dddd804f8aa0f$var$assign(// paramsFromLocation is a new object
            $689dddd804f8aa0f$var$paramsFromLocation(currentLocation.params, // only keep params that exist in the resolved location
            // TODO: only keep optional params coming from a parent record
            matcher.keys.filter((k)=>!k.optional).map((k)=>k.name)), // discard any existing params in the current location that do not exist here
            // #1497 this ensures better active/exact matching
            location1.params && $689dddd804f8aa0f$var$paramsFromLocation(location1.params, matcher.keys.map((k)=>k.name)));
            // throws if cannot be stringified
            path = matcher.stringify(params);
        } else if ("path" in location1) {
            // no need to resolve the path with the matcher as it was provided
            // this also allows the user to control the encoding
            path = location1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            // matcher should have a value after the loop
            if (matcher) {
                // we know the matcher works because we tested the regexp
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        // location is a relative path
        } else {
            // match by name or path of current route
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw $689dddd804f8aa0f$var$createRouterError(1 /* ErrorTypes.MATCHER_NOT_FOUND */ , {
                location: location1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            // since we are navigating to the same location, we don't need to pick the
            // params like when `name` is provided
            params = $689dddd804f8aa0f$var$assign({}, currentLocation.params, location1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            // reversed order so parents are at the beginning
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $689dddd804f8aa0f$var$mergeMetaFields(matched)
        };
    }
    // add initial routes
    routes.forEach((route)=>addRoute(route));
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
function $689dddd804f8aa0f$var$paramsFromLocation(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
 * Normalizes a RouteRecordRaw. Creates a copy
 *
 * @param record
 * @returns the normalized version
 */ function $689dddd804f8aa0f$var$normalizeRouteRecord(record) {
    return {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: undefined,
        beforeEnter: record.beforeEnter,
        props: $689dddd804f8aa0f$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: new Set(),
        updateGuards: new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
}
/**
 * Normalize the optional `props` in a record to always be an object similar to
 * components. Also accept a boolean for components.
 * @param record
 */ function $689dddd804f8aa0f$var$normalizeRecordProps(record) {
    const propsObject = {};
    // props does not exist on redirect records, but we can set false directly
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else // NOTE: we could also allow a function to be applied to every component.
    // Would need user feedback for use cases
    for(const name in record.components)propsObject[name] = typeof props === "boolean" ? props : props[name];
    return propsObject;
}
/**
 * Checks if a record or any of its parent is an alias
 * @param record
 */ function $689dddd804f8aa0f$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
 * Merge meta fields of an array of records
 *
 * @param matched - array of matched records
 */ function $689dddd804f8aa0f$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>$689dddd804f8aa0f$var$assign(meta, record.meta), {});
}
function $689dddd804f8aa0f$var$mergeOptions(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
function $689dddd804f8aa0f$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
 * Check if a path and its alias have the same required params
 *
 * @param a - original record
 * @param b - alias record
 */ function $689dddd804f8aa0f$var$checkSameParams(a, b) {
    for (const key of a.keys){
        if (!key.optional && !b.keys.find($689dddd804f8aa0f$var$isSameParam.bind(null, key))) return $689dddd804f8aa0f$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
    for (const key of b.keys){
        if (!key.optional && !a.keys.find($689dddd804f8aa0f$var$isSameParam.bind(null, key))) return $689dddd804f8aa0f$var$warn(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    }
}
/**
 * A route with a name and a child with an empty path without a name should warn when adding the route
 *
 * @param mainNormalizedRecord - RouteRecordNormalized
 * @param parent - RouteRecordMatcher
 */ function $689dddd804f8aa0f$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) $689dddd804f8aa0f$var$warn(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $689dddd804f8aa0f$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys){
        if (!record.keys.find($689dddd804f8aa0f$var$isSameParam.bind(null, key))) return $689dddd804f8aa0f$var$warn(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
    }
}
function $689dddd804f8aa0f$var$isRecordChildOf(record, parent) {
    return parent.children.some((child)=>child === record || $689dddd804f8aa0f$var$isRecordChildOf(record, child));
}
/**
 * Encoding Rules ␣ = Space Path: ␣ " < > # ? { } Query: ␣ " < > # & = Hash: ␣ "
 * < > `
 *
 * On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
 * defines some extra characters to be encoded. Most browsers do not encode them
 * in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
 * also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
 * plus `-._~`. This extra safety should be applied to query by patching the
 * string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
 * should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
 * into a `/` if directly typed in. The _backtick_ (`````) should also be
 * encoded everywhere because some browsers like FF encode it when directly
 * written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
 */ // const EXTRA_RESERVED_RE = /[!'()*]/g
// const encodeReservedReplacer = (c: string) => '%' + c.charCodeAt(0).toString(16)
const $689dddd804f8aa0f$var$HASH_RE = /#/g; // %23
const $689dddd804f8aa0f$var$AMPERSAND_RE = /&/g; // %26
const $689dddd804f8aa0f$var$SLASH_RE = /\//g; // %2F
const $689dddd804f8aa0f$var$EQUAL_RE = /=/g; // %3D
const $689dddd804f8aa0f$var$IM_RE = /\?/g; // %3F
const $689dddd804f8aa0f$var$PLUS_RE = /\+/g; // %2B
/**
 * NOTE: It's not clear to me if we should encode the + symbol in queries, it
 * seems to be less flexible than not doing so and I can't find out the legacy
 * systems requiring this for regular requests like text/html. In the standard,
 * the encoding of the plus character is only mentioned for
 * application/x-www-form-urlencoded
 * (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
 * leave the plus character as is in queries. To be more flexible, we allow the
 * plus character on the query, but it can also be manually encoded by the user.
 *
 * Resources:
 * - https://url.spec.whatwg.org/#urlencoded-parsing
 * - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
 */ const $689dddd804f8aa0f$var$ENC_BRACKET_OPEN_RE = /%5B/g; // [
const $689dddd804f8aa0f$var$ENC_BRACKET_CLOSE_RE = /%5D/g; // ]
const $689dddd804f8aa0f$var$ENC_CARET_RE = /%5E/g; // ^
const $689dddd804f8aa0f$var$ENC_BACKTICK_RE = /%60/g; // `
const $689dddd804f8aa0f$var$ENC_CURLY_OPEN_RE = /%7B/g; // {
const $689dddd804f8aa0f$var$ENC_PIPE_RE = /%7C/g; // |
const $689dddd804f8aa0f$var$ENC_CURLY_CLOSE_RE = /%7D/g; // }
const $689dddd804f8aa0f$var$ENC_SPACE_RE = /%20/g; // }
/**
 * Encode characters that need to be encoded on the path, search and hash
 * sections of the URL.
 *
 * @internal
 * @param text - string to encode
 * @returns encoded string
 */ function $689dddd804f8aa0f$var$commonEncode(text) {
    return encodeURI("" + text).replace($689dddd804f8aa0f$var$ENC_PIPE_RE, "|").replace($689dddd804f8aa0f$var$ENC_BRACKET_OPEN_RE, "[").replace($689dddd804f8aa0f$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
 * Encode characters that need to be encoded on the hash section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $689dddd804f8aa0f$var$encodeHash(text) {
    return $689dddd804f8aa0f$var$commonEncode(text).replace($689dddd804f8aa0f$var$ENC_CURLY_OPEN_RE, "{").replace($689dddd804f8aa0f$var$ENC_CURLY_CLOSE_RE, "}").replace($689dddd804f8aa0f$var$ENC_CARET_RE, "^");
}
/**
 * Encode characters that need to be encoded query values on the query
 * section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $689dddd804f8aa0f$var$encodeQueryValue(text) {
    return $689dddd804f8aa0f$var$commonEncode(text)// Encode the space as +, encode the + to differentiate it from the space
    .replace($689dddd804f8aa0f$var$PLUS_RE, "%2B").replace($689dddd804f8aa0f$var$ENC_SPACE_RE, "+").replace($689dddd804f8aa0f$var$HASH_RE, "%23").replace($689dddd804f8aa0f$var$AMPERSAND_RE, "%26").replace($689dddd804f8aa0f$var$ENC_BACKTICK_RE, "`").replace($689dddd804f8aa0f$var$ENC_CURLY_OPEN_RE, "{").replace($689dddd804f8aa0f$var$ENC_CURLY_CLOSE_RE, "}").replace($689dddd804f8aa0f$var$ENC_CARET_RE, "^");
}
/**
 * Like `encodeQueryValue` but also encodes the `=` character.
 *
 * @param text - string to encode
 */ function $689dddd804f8aa0f$var$encodeQueryKey(text) {
    return $689dddd804f8aa0f$var$encodeQueryValue(text).replace($689dddd804f8aa0f$var$EQUAL_RE, "%3D");
}
/**
 * Encode characters that need to be encoded on the path section of the URL.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $689dddd804f8aa0f$var$encodePath(text) {
    return $689dddd804f8aa0f$var$commonEncode(text).replace($689dddd804f8aa0f$var$HASH_RE, "%23").replace($689dddd804f8aa0f$var$IM_RE, "%3F");
}
/**
 * Encode characters that need to be encoded on the path section of the URL as a
 * param. This function encodes everything {@link encodePath} does plus the
 * slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
 * string instead.
 *
 * @param text - string to encode
 * @returns encoded string
 */ function $689dddd804f8aa0f$var$encodeParam(text) {
    return text == null ? "" : $689dddd804f8aa0f$var$encodePath(text).replace($689dddd804f8aa0f$var$SLASH_RE, "%2F");
}
/**
 * Decode text using `decodeURIComponent`. Returns the original text if it
 * fails.
 *
 * @param text - string to decode
 * @returns decoded string
 */ function $689dddd804f8aa0f$var$decode(text) {
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
/**
 * Transforms a queryString into a {@link LocationQuery} object. Accept both, a
 * version with the leading `?` and without Should work as URLSearchParams

 * @internal
 *
 * @param search - search string to parse
 * @returns a query object
 */ function $689dddd804f8aa0f$export$1e8473eaf75b0d10(search) {
    const query = {};
    // avoid creating an object with an empty key and empty value
    // because of split('&')
    if (search === "" || search === "?") return query;
    const hasLeadingIM = search[0] === "?";
    const searchParams = (hasLeadingIM ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        // pre decode the + into space
        const searchParam = searchParams[i].replace($689dddd804f8aa0f$var$PLUS_RE, " ");
        // allow the = character
        const eqPos = searchParam.indexOf("=");
        const key = $689dddd804f8aa0f$var$decode(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $689dddd804f8aa0f$var$decode(searchParam.slice(eqPos + 1));
        if (key in query) {
            // an extra variable for ts types
            let currentValue = query[key];
            if (!$689dddd804f8aa0f$var$isArray(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
 * Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
 * doesn't prepend a `?`
 *
 * @internal
 *
 * @param query - query object to stringify
 * @returns string version of the query without the leading `?`
 */ function $689dddd804f8aa0f$export$d33b45a8f796a30(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $689dddd804f8aa0f$var$encodeQueryKey(key);
        if (value == null) {
            // only null adds the value
            if (value !== undefined) search += (search.length ? "&" : "") + key;
            continue;
        }
        // keep null values
        const values = $689dddd804f8aa0f$var$isArray(value) ? value.map((v)=>v && $689dddd804f8aa0f$var$encodeQueryValue(v)) : [
            value && $689dddd804f8aa0f$var$encodeQueryValue(value)
        ];
        values.forEach((value)=>{
            // skip undefined values in arrays as if they were not present
            // smaller code than using filter
            if (value !== undefined) {
                // only append & with non-empty search
                search += (search.length ? "&" : "") + key;
                if (value != null) search += "=" + value;
            }
        });
    }
    return search;
}
/**
 * Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
 * numbers into strings, removing keys with an undefined value and replacing
 * undefined with null in arrays
 *
 * @param query - query object to normalize
 * @returns a normalized query object
 */ function $689dddd804f8aa0f$var$normalizeQuery(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== undefined) normalizedQuery[key] = $689dddd804f8aa0f$var$isArray(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
/**
 * RouteRecord being rendered by the closest ancestor Router View. Used for
 * `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
 * Location Matched
 *
 * @internal
 */ const $689dddd804f8aa0f$export$7f4879db1558672d = Symbol("");
/**
 * Allows overriding the router view depth to control which component in
 * `matched` is rendered. rvd stands for Router View Depth
 *
 * @internal
 */ const $689dddd804f8aa0f$export$9b3825c34ca1427a = Symbol("");
/**
 * Allows overriding the router instance returned by `useRouter` in tests. r
 * stands for router
 *
 * @internal
 */ const $689dddd804f8aa0f$export$b6c0da8b9dae491f = Symbol("");
/**
 * Allows overriding the current route returned by `useRoute` in tests. rl
 * stands for route location
 *
 * @internal
 */ const $689dddd804f8aa0f$export$3aca783e9a3e6e9e = Symbol("");
/**
 * Allows overriding the current route used by router-view. Internally this is
 * used when the `route` prop is passed.
 *
 * @internal
 */ const $689dddd804f8aa0f$export$54c8124bead129f8 = Symbol("");
/**
 * Create a list of callbacks that can be reset. Used to create before and after navigation guards list
 */ function $689dddd804f8aa0f$var$useCallbacks() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers,
        reset: reset
    };
}
function $689dddd804f8aa0f$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $esfUo.onUnmounted)(removeFromList);
    (0, $esfUo.onDeactivated)(removeFromList);
    (0, $esfUo.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
 * Add a navigation guard that triggers whenever the component for the current
 * location is about to be left. Similar to {@link beforeRouteLeave} but can be
 * used in any component. The guard is removed when the component is unmounted.
 *
 * @param leaveGuard - {@link NavigationGuard}
 */ function $689dddd804f8aa0f$export$d7fcdd004b009a9e(leaveGuard) {
    const activeRecord = (0, $esfUo.inject)($689dddd804f8aa0f$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $689dddd804f8aa0f$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
 * Add a navigation guard that triggers whenever the current location is about
 * to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
 * component. The guard is removed when the component is unmounted.
 *
 * @param updateGuard - {@link NavigationGuard}
 */ function $689dddd804f8aa0f$export$46b4cb99461f4cc7(updateGuard) {
    const activeRecord = (0, $esfUo.inject)($689dddd804f8aa0f$export$7f4879db1558672d, // to avoid warning
    {}).value;
    if (!activeRecord) return;
    $689dddd804f8aa0f$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $689dddd804f8aa0f$var$guardToPromiseFn(guard, to, from, record, name) {
    // keep a reference to the enterCallbackArray to prevent pushing callbacks if a new navigation took place
    const enterCallbackArray = record && // name is defined if record is because of the function overload
    (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($689dddd804f8aa0f$var$createRouterError(4 /* ErrorTypes.NAVIGATION_ABORTED */ , {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($689dddd804f8aa0f$var$isRouteLocation(valid)) reject($689dddd804f8aa0f$var$createRouterError(2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ , {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && // since enterCallbackArray is truthy, both record and name also are
                    record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            // wrapping with Promise.resolve allows it to work with both async and sync guards
            const guardReturn = guard.call(record && record.instances[name], to, from, next);
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $689dddd804f8aa0f$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $689dddd804f8aa0f$var$warn(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        // @ts-expect-error: we put it in the original one because it's easier to check
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $689dddd804f8aa0f$var$extractComponentsGuards(matched, guardType, to, from) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        // skip update and leave guards if the route component is not mounted
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ($689dddd804f8aa0f$var$isRouteComponent(rawComponent)) {
            // __vccOpts is added by vue-class-component and contain the regular options
            const options = rawComponent.__vccOpts || rawComponent;
            const guard = options[guardType];
            guard && guards.push($689dddd804f8aa0f$var$guardToPromiseFn(guard, to, from, record, name));
        } else {
            // start requesting the chunk already
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}"`));
                    const resolvedComponent = $689dddd804f8aa0f$var$isESModule(resolved) ? resolved.default : resolved;
                    // replace the function with the resolved component
                    // cannot be null or undefined because we went into the for loop
                    record.components[name] = resolvedComponent;
                    // __vccOpts is added by vue-class-component and contain the regular options
                    const options = resolvedComponent.__vccOpts || resolvedComponent;
                    const guard = options[guardType];
                    return guard && $689dddd804f8aa0f$var$guardToPromiseFn(guard, to, from, record, name)();
                }));
        }
    }
    return guards;
}
/**
 * Allows differentiating lazy components from functional components and vue-class-component
 * @internal
 *
 * @param component
 */ function $689dddd804f8aa0f$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
/**
 * Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
 *
 * @param route - resolved route to load
 */ function $689dddd804f8aa0f$export$d092a02cbf0deea7(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $689dddd804f8aa0f$var$isESModule(resolved) ? resolved.default : resolved;
                // replace the function with the resolved component
                // cannot be null or undefined because we went into the for loop
                record.components[name] = resolvedComponent;
                return;
            }));
            return promises;
        }, [])))).then(()=>route);
}
// TODO: we could allow currentRoute as a prop to expose `isActive` and
// `isExactActive` behavior should go through an RFC
function $689dddd804f8aa0f$export$dcf14c9974fe2767(props) {
    const router = (0, $esfUo.inject)($689dddd804f8aa0f$export$b6c0da8b9dae491f);
    const currentRoute = (0, $esfUo.inject)($689dddd804f8aa0f$export$3aca783e9a3e6e9e);
    const route = (0, $am4TS.computed)(()=>router.resolve((0, $am4TS.unref)(props.to)));
    const activeRecordIndex = (0, $am4TS.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex($689dddd804f8aa0f$var$isSameRouteRecord.bind(null, routeMatched));
        if (index > -1) return index;
        // possible parent record
        const parentRecordPath = $689dddd804f8aa0f$var$getOriginalPath(matched[length - 2]);
        return(// we are dealing with nested routes
        length > 1 && // if the parent and matched route have the same path, this link is
        // referring to the empty child. Or we currently are on a different
        // child of the same parent
        $689dddd804f8aa0f$var$getOriginalPath(routeMatched) === parentRecordPath && // avoid comparing the child with its parent
        currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex($689dddd804f8aa0f$var$isSameRouteRecord.bind(null, matched[length - 2])) : index);
    });
    const isActive = (0, $am4TS.computed)(()=>activeRecordIndex.value > -1 && $689dddd804f8aa0f$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $am4TS.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && $689dddd804f8aa0f$var$isSameRouteLocationParams(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($689dddd804f8aa0f$var$guardEvent(e)) return router[(0, $am4TS.unref)(props.replace) ? "replace" : "push"]((0, $am4TS.unref)(props.to)).catch($689dddd804f8aa0f$var$noop);
        return Promise.resolve();
    }
    // devtools only
    if (__VUE_PROD_DEVTOOLS__ && $689dddd804f8aa0f$var$isBrowser) {
        const instance = (0, $esfUo.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value
            };
            // @ts-expect-error: this is internal
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            // @ts-expect-error: this is internal
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $esfUo.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
            }, {
                flush: "post"
            });
        }
    }
    /**
     * NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
     */ return {
        route: route,
        href: (0, $am4TS.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
const $689dddd804f8aa0f$var$RouterLinkImpl = /*#__PURE__*/ (0, $esfUo.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        // inactiveClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        }
    },
    useLink: $689dddd804f8aa0f$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $am4TS.reactive)($689dddd804f8aa0f$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $esfUo.inject)($689dddd804f8aa0f$export$b6c0da8b9dae491f);
        const elClass = (0, $am4TS.computed)(()=>({
                [$689dddd804f8aa0f$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                // [getLinkClass(
                //   props.inactiveClass,
                //   options.linkInactiveClass,
                //   'router-link-inactive'
                // )]: !link.isExactActive,
                [$689dddd804f8aa0f$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && slots.default(link);
            return props.custom ? children : (0, $esfUo.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                // this would override user added attrs but Vue will still add
                // the listener, so we end up triggering both
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to render a link that triggers a navigation on click.
 */ const $689dddd804f8aa0f$export$fce709ebdac448ed = $689dddd804f8aa0f$var$RouterLinkImpl;
function $689dddd804f8aa0f$var$guardEvent(e) {
    // don't redirect with control keys
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    // don't redirect when preventDefault called
    if (e.defaultPrevented) return;
    // don't redirect on right click
    if (e.button !== undefined && e.button !== 0) return;
    // don't redirect if `target="_blank"`
    // @ts-expect-error getAttribute does exist
    if (e.currentTarget && e.currentTarget.getAttribute) {
        // @ts-expect-error getAttribute exists
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    // this may be a Weex event which doesn't have this method
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $689dddd804f8aa0f$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else {
            if (!$689dddd804f8aa0f$var$isArray(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value !== outerValue[i])) return false;
        }
    }
    return true;
}
/**
 * Get the original path value of a record by following its aliasOf
 * @param record
 */ function $689dddd804f8aa0f$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
 * Utility class to get the active class based on defaults.
 * @param propClass
 * @param globalClass
 * @param defaultClass
 */ const $689dddd804f8aa0f$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
const $689dddd804f8aa0f$var$RouterViewImpl = /*#__PURE__*/ (0, $esfUo.defineComponent)({
    name: "RouterView",
    // #674 we manually inherit them
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    // Better compat for @vue/compat users
    // https://github.com/vuejs/router/issues/1315
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $esfUo.inject)($689dddd804f8aa0f$export$54c8124bead129f8);
        const routeToDisplay = (0, $am4TS.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $esfUo.inject)($689dddd804f8aa0f$export$9b3825c34ca1427a, 0);
        // The depth changes based on empty components option, which allows passthrough routes e.g. routes with children
        // that are used to reuse the `path` property
        const depth = (0, $am4TS.computed)(()=>{
            let initialDepth = (0, $am4TS.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $am4TS.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $esfUo.provide)($689dddd804f8aa0f$export$9b3825c34ca1427a, (0, $am4TS.computed)(()=>depth.value + 1));
        (0, $esfUo.provide)($689dddd804f8aa0f$export$7f4879db1558672d, matchedRouteRef);
        (0, $esfUo.provide)($689dddd804f8aa0f$export$54c8124bead129f8, routeToDisplay);
        const viewRef = (0, $am4TS.ref)();
        // watch at the same time the component instance, the route record we are
        // rendering, and the name
        (0, $esfUo.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            // copy reused instances
            if (to) {
                // this will update the instance for new instances as well as reused
                // instances when navigating to a new route
                to.instances[name] = instance;
                // the component instance is reused for a different route or name, so
                // we copy any saved update or leave guards. With async setup, the
                // mounting component will mount before the matchedRoute changes,
                // making instance === oldInstance, so we check if guards have been
                // added before. This works because we remove guards when
                // unmounting/deactivating components
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            // trigger beforeRouteEnter next callbacks
            if (instance && to && // if there is no instance but to and from are the same this might be
            // the first visit
            (!from || !$689dddd804f8aa0f$var$isSameRouteRecord(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            // we need the value at the time we render because when we unmount, we
            // navigated to a different location so the value is different
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $689dddd804f8aa0f$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            // props from route configuration
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                // remove the instance reference to prevent leak
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $esfUo.h)(ViewComponent, $689dddd804f8aa0f$var$assign({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && $689dddd804f8aa0f$var$isBrowser && component.ref) {
                // TODO: can display if it's an alias, its props
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                const internalInstances = $689dddd804f8aa0f$var$isArray(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ];
                internalInstances.forEach((instance)=>{
                    // @ts-expect-error
                    instance.__vrv_devtools = info;
                });
            }
            return(// pass the vnode to the slot as a prop.
            // h and <component :is="..."> both accept vnodes
            $689dddd804f8aa0f$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component);
        };
    }
});
function $689dddd804f8aa0f$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
// export the public type for h/tsx inference
// also to avoid inline import() in generated d.ts files
/**
 * Component to display the current route the user is at.
 */ const $689dddd804f8aa0f$export$d941f00e9b9a537 = $689dddd804f8aa0f$var$RouterViewImpl;
// warn against deprecated usage with <transition> & <keep-alive>
// due to functional component being no longer eager in Vue 3
function $689dddd804f8aa0f$var$warnDeprecatedUsage() {
    const instance = (0, $esfUo.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && typeof parentSubTreeType === "object" && parentSubTreeType.name === "RouterView") {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        $689dddd804f8aa0f$var$warn(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.\n` + `Use slot props instead:\n\n` + `<router-view v-slot="{ Component }">\n` + `  <${comp}>\n` + `    <component :is="Component" />\n` + `  </${comp}>\n` + `</router-view>`);
    }
}
/**
 * Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
 *
 * @param routeLocation - routeLocation to format
 * @param tooltip - optional tooltip
 * @returns a copy of the routeLocation
 */ function $689dddd804f8aa0f$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $689dddd804f8aa0f$var$assign({}, routeLocation, {
        // remove variables that can contain vue instances
        matched: routeLocation.matched.map((matched)=>$689dddd804f8aa0f$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $689dddd804f8aa0f$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
// to support multiple router instances
let $689dddd804f8aa0f$var$routerId = 0;
function $689dddd804f8aa0f$var$addDevtools(app, router, matcher) {
    // Take over router.beforeEach and afterEach
    // make sure we are not registering the devtool twice
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    // increment to support multiple router instances
    const id = $689dddd804f8aa0f$var$routerId++;
    (0, $90cb27801a0b9533$export$63b9a9bba9f20f3e)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") console.warn("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        // display state added by the router
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $689dddd804f8aa0f$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        // mark router-link as active and display tags on router views
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $689dddd804f8aa0f$var$PINK_500
                });
            }
            // if multiple useLink are used
            if ($689dddd804f8aa0f$var$isArray(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let backgroundColor = $689dddd804f8aa0f$var$ORANGE_400;
                    let tooltip = "";
                    if (devtoolsData.isExactActive) {
                        backgroundColor = $689dddd804f8aa0f$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $689dddd804f8aa0f$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: devtoolsData.route.path,
                        textColor: 0,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $esfUo.watch)(router.currentRoute, ()=>{
            // refresh active state
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 0x40a8c4
        });
        // const errorsLayerId = 'router:errors'
        // api.addTimelineLayer({
        //   id: errorsLayerId,
        //   label: 'Router Errors',
        //   color: 0xea5455,
        // })
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        // attached to `meta` and used to group events
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $689dddd804f8aa0f$var$formatDisplay("beforeEach"),
                from: $689dddd804f8aa0f$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $689dddd804f8aa0f$var$formatRouteLocation(to, "Target location")
            };
            // Used to group navigations together, hide from devtools
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $689dddd804f8aa0f$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $689dddd804f8aa0f$var$formatDisplay("\u274C");
            } else data.status = $689dddd804f8aa0f$var$formatDisplay("\u2705");
            // we set here to have the right order
            data.from = $689dddd804f8aa0f$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $689dddd804f8aa0f$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
         * Inspector of Existing routes
         */ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            // the routes view isn't active
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            // children routes will appear as nested
            let routes = matcher.getRoutes().filter((route)=>!route.parent);
            // reset match state to false
            routes.forEach($689dddd804f8aa0f$var$resetMatchStateOnRouteRecord);
            // apply a match state if there is a payload
            if (payload.filter) routes = routes.filter((route)=>// save matches state based on the payload
                $689dddd804f8aa0f$var$isRouteMatching(route, payload.filter.toLowerCase()));
            // mark active routes
            routes.forEach((route)=>$689dddd804f8aa0f$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($689dddd804f8aa0f$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
         * Display information about the currently selected route record
         */ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const routes = matcher.getRoutes();
                const route = routes.find((route)=>route.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $689dddd804f8aa0f$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $689dddd804f8aa0f$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $689dddd804f8aa0f$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$689dddd804f8aa0f$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
 * Extracted from tailwind palette
 */ const $689dddd804f8aa0f$var$PINK_500 = 0xec4899;
const $689dddd804f8aa0f$var$BLUE_600 = 0x2563eb;
const $689dddd804f8aa0f$var$LIME_500 = 0x84cc16;
const $689dddd804f8aa0f$var$CYAN_400 = 0x22d3ee;
const $689dddd804f8aa0f$var$ORANGE_400 = 0xfb923c;
// const GRAY_100 = 0xf4f4f5
const $689dddd804f8aa0f$var$DARK = 0x666666;
function $689dddd804f8aa0f$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $689dddd804f8aa0f$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $689dddd804f8aa0f$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $689dddd804f8aa0f$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $689dddd804f8aa0f$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $689dddd804f8aa0f$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 0xffffff,
        backgroundColor: $689dddd804f8aa0f$var$DARK
    });
    // add an id to be able to select it. Using the `path` is not possible because
    // empty path children would collide with their parents
    let id = record.__vd_id;
    if (id == null) {
        id = String($689dddd804f8aa0f$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($689dddd804f8aa0f$var$formatRouteRecordForInspector)
    };
}
//  incremental id for route records and inspector state
let $689dddd804f8aa0f$var$routeRecordId = 0;
const $689dddd804f8aa0f$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $689dddd804f8aa0f$var$markRouteRecordActive(route, currentRoute) {
    // no route will be active if matched is empty
    // reset the matching state
    const isExactActive = currentRoute.matched.length && $689dddd804f8aa0f$var$isSameRouteRecord(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$689dddd804f8aa0f$var$isSameRouteRecord(match, route.record));
    route.children.forEach((childRoute)=>$689dddd804f8aa0f$var$markRouteRecordActive(childRoute, currentRoute));
}
function $689dddd804f8aa0f$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($689dddd804f8aa0f$var$resetMatchStateOnRouteRecord);
}
function $689dddd804f8aa0f$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($689dddd804f8aa0f$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    // use a regexp without $ at the end to match nested routes better
    const nonEndingRE = new RegExp(found[1].replace(/\$$/, ""), found[2]);
    if (nonEndingRE.test(filter)) {
        // mark children as matches
        route.children.forEach((child)=>$689dddd804f8aa0f$var$isRouteMatching(child, filter));
        // exception case: `/`
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        // hide the / route
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $689dddd804f8aa0f$var$decode(path);
    // also allow partial matching on the path
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$689dddd804f8aa0f$var$isRouteMatching(child, filter));
}
function $689dddd804f8aa0f$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) // @ts-expect-error
    ret[key] = obj[key];
    return ret;
}
/**
 * Creates a Router instance that can be used by a Vue app.
 *
 * @param options - {@link RouterOptions}
 */ function $689dddd804f8aa0f$export$baddd0131ee8c05b(options) {
    const matcher = $689dddd804f8aa0f$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || $689dddd804f8aa0f$export$1e8473eaf75b0d10;
    const stringifyQuery$1 = options.stringifyQuery || $689dddd804f8aa0f$export$d33b45a8f796a30;
    const routerHistory = options.history;
    const beforeGuards = $689dddd804f8aa0f$var$useCallbacks();
    const beforeResolveGuards = $689dddd804f8aa0f$var$useCallbacks();
    const afterGuards = $689dddd804f8aa0f$var$useCallbacks();
    const currentRoute = (0, $am4TS.shallowRef)($689dddd804f8aa0f$export$e44be9a9779c480b);
    let pendingLocation = $689dddd804f8aa0f$export$e44be9a9779c480b;
    // leave the scrollRestoration if no scrollBehavior is provided
    if ($689dddd804f8aa0f$var$isBrowser && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = $689dddd804f8aa0f$var$applyToParams.bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = $689dddd804f8aa0f$var$applyToParams.bind(null, $689dddd804f8aa0f$var$encodeParam);
    const decodeParams = // @ts-expect-error: intentionally avoid the type check
    $689dddd804f8aa0f$var$applyToParams.bind(null, $689dddd804f8aa0f$var$decode);
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ($689dddd804f8aa0f$var$isRouteName(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        // const objectLocation = routerLocationAsObject(rawLocation)
        // we create a copy to modify it later
        currentLocation = $689dddd804f8aa0f$var$assign({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            const locationNormalized = $689dddd804f8aa0f$var$parseURL(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href = routerHistory.createHref(locationNormalized.fullPath);
            // locationNormalized is always a new object
            return $689dddd804f8aa0f$var$assign(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                hash: $689dddd804f8aa0f$var$decode(locationNormalized.hash),
                redirectedFrom: undefined,
                href: href
            });
        }
        let matcherLocation;
        // path could be relative in object as well
        if ("path" in rawLocation) matcherLocation = $689dddd804f8aa0f$var$assign({}, rawLocation, {
            path: $689dddd804f8aa0f$var$parseURL(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            // remove any nullish param
            const targetParams = $689dddd804f8aa0f$var$assign({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            // pass encoded values to the matcher, so it can produce encoded path and fullPath
            matcherLocation = $689dddd804f8aa0f$var$assign({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            // current location params are decoded, we need to encode them in case the
            // matcher merges the params
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        // the matcher might have merged current location params, so
        // we need to run the decoding again
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = $689dddd804f8aa0f$var$stringifyURL(stringifyQuery$1, $689dddd804f8aa0f$var$assign({}, rawLocation, {
            hash: $689dddd804f8aa0f$var$encodeHash(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return $689dddd804f8aa0f$var$assign({
            fullPath: fullPath,
            hash: // keep the hash encoded so fullPath is effectively path + encodedQuery +
            // hash
            hash,
            query: // if the user is using a custom query lib like qs, we might have
            // nested objects, so we keep the query as is, meaning it can contain
            // numbers at `$route.query`, but at the point, the user will have to
            // use their own type anyway.
            // https://github.com/vuejs/router/issues/328#issuecomment-649481567
            stringifyQuery$1 === $689dddd804f8aa0f$export$d33b45a8f796a30 ? $689dddd804f8aa0f$var$normalizeQuery(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: undefined,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? $689dddd804f8aa0f$var$parseURL(parseQuery$1, to, currentRoute.value.path) : $689dddd804f8aa0f$var$assign({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return $689dddd804f8aa0f$var$createRouterError(8 /* ErrorTypes.NAVIGATION_CANCELLED */ , {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push($689dddd804f8aa0f$var$assign(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                // @ts-expect-error: force empty params when a string is passed to let
                // the router parse them again
                newTargetLocation.params = {};
            }
            return $689dddd804f8aa0f$var$assign({
                query: to.query,
                hash: to.hash,
                // avoid transferring params if the redirect has a path
                params: "path" in newTargetLocation ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        // to could be a string where `replace` is a function
        const replace = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation);
        if (shouldRedirect) return pushWithRedirect($689dddd804f8aa0f$var$assign(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? $689dddd804f8aa0f$var$assign({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace
        }), // keep original redirectedFrom if it exists
        redirectedFrom || targetLocation);
        // if it was a redirect we already called `pushWithRedirect` above
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && $689dddd804f8aa0f$var$isSameRouteLocation(stringifyQuery$1, from, targetLocation)) {
            failure = $689dddd804f8aa0f$var$createRouterError(16 /* ErrorTypes.NAVIGATION_DUPLICATED */ , {
                to: toLocation,
                from: from
            });
            // trigger scroll to allow scrolling to the same anchor
            handleScroll(from, from, // this is a push, the only way for it to be triggered from a
            // history.listen is with a redirect, which makes it become a push
            true, // This cannot be the first navigation because the initial location
            // cannot be manually navigated to
            false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>$689dddd804f8aa0f$export$873de56207a30e5a(error) ? $689dddd804f8aa0f$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ ) ? error : markAsReady(error) // also returns the error
             : triggerError(error, toLocation, from)).then((failure)=>{
            if (failure) {
                if ($689dddd804f8aa0f$export$873de56207a30e5a(failure, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) return pushWithRedirect(// keep options
                $689dddd804f8aa0f$var$assign({
                    replace: // preserve an existing replacement but allow the redirect to override it
                    replace
                }, locationAsObject(failure.to), {
                    state: typeof failure.to === "object" ? $689dddd804f8aa0f$var$assign({}, data, failure.to.state) : data,
                    force: force
                }), // preserve the original redirectedFrom if any
                redirectedFrom || toLocation);
            } else // if we fail we don't finalize the navigation
            failure = finalizeNavigation(toLocation, from, true, replace, data);
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
     * Helper to reject and skip all navigation guards if a new navigation happened
     * @param to
     * @param from
     */ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        // support Vue < 3.3
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    // TODO: refactor the whole before guards by internally using router.beforeEach
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = $689dddd804f8aa0f$var$extractChangingRecords(to, from);
        // all components here have been resolved once because we are leaving
        guards = $689dddd804f8aa0f$var$extractComponentsGuards(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        // leavingRecords is already reversed
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push($689dddd804f8aa0f$var$guardToPromiseFn(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        // run the queue of per route beforeRouteLeave guards
        return runGuardQueue(guards).then(()=>{
            // check global guards beforeEach
            guards = [];
            for (const guard of beforeGuards.list())guards.push($689dddd804f8aa0f$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            // check in components beforeRouteUpdate
            guards = $689dddd804f8aa0f$var$extractComponentsGuards(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push($689dddd804f8aa0f$var$guardToPromiseFn(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check the route beforeEnter
            guards = [];
            for (const record of to.matched)// do not trigger beforeEnter on reused views
            if (record.beforeEnter && !from.matched.includes(record)) {
                if ($689dddd804f8aa0f$var$isArray(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push($689dddd804f8aa0f$var$guardToPromiseFn(beforeEnter, to, from));
                else guards.push($689dddd804f8aa0f$var$guardToPromiseFn(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // NOTE: at this point to.matched is normalized and does not contain any () => Promise<Component>
            // clear existing enterCallbacks, these are added by extractComponentsGuards
            to.matched.forEach((record)=>record.enterCallbacks = {});
            // check in-component beforeRouteEnter
            guards = $689dddd804f8aa0f$var$extractComponentsGuards(enteringRecords, "beforeRouteEnter", to, from);
            guards.push(canceledNavigationCheck);
            // run the queue of per route beforeEnter guards
            return runGuardQueue(guards);
        }).then(()=>{
            // check global guards beforeResolve
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push($689dddd804f8aa0f$var$guardToPromiseFn(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        })// catch any navigation canceled
        .catch((err)=>$689dddd804f8aa0f$export$873de56207a30e5a(err, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ ) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        // navigation is confirmed, call afterGuards
        // TODO: wrap with error handlers
        for (const guard of afterGuards.list())runWithContext(()=>guard(to, from, failure));
    }
    /**
     * - Cleans up any navigation guards
     * - Changes the url if necessary
     * - Calls the scrollBehavior
     */ function finalizeNavigation(toLocation, from, isPush, replace, data) {
        // a more recent navigation took place
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        // only consider as push if it's not the first navigation
        const isFirstNavigation = from === $689dddd804f8aa0f$export$e44be9a9779c480b;
        const state = !$689dddd804f8aa0f$var$isBrowser ? {} : history.state;
        // change URL only if the user did a push/replace and if it's not the initial navigation because
        // it's just reflecting the url
        if (isPush) {
            // on the initial navigation, we want to reuse the scroll position from
            // history state if it exists
            if (replace || isFirstNavigation) routerHistory.replace(toLocation.fullPath, $689dddd804f8aa0f$var$assign({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        // accept current navigation
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    // attach listener to history to trigger navigations
    function setupListeners() {
        // avoid setting up listeners twice due to an invalid first navigation
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            // cannot be a redirect route because it was in history
            const toLocation = resolve(to);
            // due to dynamic routing, and to hash history with manual navigation
            // (manually changing the url or calling history.hash = '#/somewhere'),
            // there could be a redirect record in history
            const shouldRedirect = handleRedirectRecord(toLocation);
            if (shouldRedirect) {
                pushWithRedirect($689dddd804f8aa0f$var$assign(shouldRedirect, {
                    replace: true
                }), toLocation).catch($689dddd804f8aa0f$var$noop);
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            // TODO: should be moved to web history?
            if ($689dddd804f8aa0f$var$isBrowser) $689dddd804f8aa0f$var$saveScrollPosition($689dddd804f8aa0f$var$getScrollKey(from.fullPath, info.delta), $689dddd804f8aa0f$var$computeScrollPosition());
            navigate(toLocation, from).catch((error)=>{
                if ($689dddd804f8aa0f$export$873de56207a30e5a(error, 12 /* ErrorTypes.NAVIGATION_CANCELLED */ )) return error;
                if ($689dddd804f8aa0f$export$873de56207a30e5a(error, 2 /* ErrorTypes.NAVIGATION_GUARD_REDIRECT */ )) {
                    // Here we could call if (info.delta) routerHistory.go(-info.delta,
                    // false) but this is bug prone as we have no way to wait the
                    // navigation to be finished before calling pushWithRedirect. Using
                    // a setTimeout of 16ms seems to work but there is no guarantee for
                    // it to work on every browser. So instead we do not restore the
                    // history entry and trigger a new navigation as requested by the
                    // navigation guard.
                    // the error is already handled by router.push we just want to avoid
                    // logging the error
                    pushWithRedirect(error.to, toLocation).then((failure)=>{
                        // manual change in hash history #916 ending up in the URL not
                        // changing, but it was changed by the manual url change, so we
                        // need to manually change it ourselves
                        if ($689dddd804f8aa0f$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ ) && !info.delta && info.type === $689dddd804f8aa0f$var$NavigationType.pop) routerHistory.go(-1, false);
                    }).catch($689dddd804f8aa0f$var$noop);
                    // avoid the then branch
                    return Promise.reject();
                }
                // do not restore history on unknown direction
                if (info.delta) routerHistory.go(-info.delta, false);
                // unrecognized error, transfer to the global handler
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(// after navigation, all matched components are resolved
                toLocation, from, false);
                // revert the navigation
                if (failure) {
                    if (info.delta && // a new navigation has been triggered, so we do not want to revert, that will change the current history
                    // entry while a different route is displayed
                    !$689dddd804f8aa0f$export$873de56207a30e5a(failure, 8 /* ErrorTypes.NAVIGATION_CANCELLED */ )) routerHistory.go(-info.delta, false);
                    else if (info.type === $689dddd804f8aa0f$var$NavigationType.pop && $689dddd804f8aa0f$export$873de56207a30e5a(failure, 20 /* ErrorTypes.NAVIGATION_DUPLICATED */ )) // manual change in hash history #916
                    // it's like a push but lacks the information of the direction
                    routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            }).catch($689dddd804f8aa0f$var$noop);
        });
    }
    // Initialization and Errors
    let readyHandlers = $689dddd804f8aa0f$var$useCallbacks();
    let errorHandlers = $689dddd804f8aa0f$var$useCallbacks();
    let ready;
    /**
     * Trigger errorHandlers added via onError and throws the error as well
     *
     * @param error - error to throw
     * @param to - location we were navigating to when the error happened
     * @param from - location we were navigating from when the error happened
     * @returns the error as a rejected promise
     */ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorHandlers.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== $689dddd804f8aa0f$export$e44be9a9779c480b) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            readyHandlers.add([
                resolve,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            // still not ready if an error happened
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve, reject])=>err ? reject(err) : resolve());
            readyHandlers.reset();
        }
        return err;
    }
    // Scroll behavior
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!$689dddd804f8aa0f$var$isBrowser || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && $689dddd804f8aa0f$var$getSavedScrollPosition($689dddd804f8aa0f$var$getScrollKey(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $esfUo.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && $689dddd804f8aa0f$var$scrollToPosition(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorHandlers.add,
        isReady: isReady,
        install (app) {
            const router = this;
            app.component("RouterLink", $689dddd804f8aa0f$export$fce709ebdac448ed);
            app.component("RouterView", $689dddd804f8aa0f$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $am4TS.unref)(currentRoute)
            });
            // this initial navigation is only necessary on client, on server it doesn't
            // make sense because it will create an extra unnecessary navigation and could
            // lead to problems
            if ($689dddd804f8aa0f$var$isBrowser && // used for the initial navigation client side to avoid pushing
            // multiple times when the router is used in multiple apps
            !started && currentRoute.value === $689dddd804f8aa0f$export$e44be9a9779c480b) {
                // see above
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in $689dddd804f8aa0f$export$e44be9a9779c480b)// @ts-expect-error: the key matches
            reactiveRoute[key] = (0, $am4TS.computed)(()=>currentRoute.value[key]);
            app.provide($689dddd804f8aa0f$export$b6c0da8b9dae491f, router);
            app.provide($689dddd804f8aa0f$export$3aca783e9a3e6e9e, (0, $am4TS.reactive)(reactiveRoute));
            app.provide($689dddd804f8aa0f$export$54c8124bead129f8, currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                // the router is not attached to an app anymore
                if (installedApps.size < 1) {
                    // invalidate the current navigation
                    pendingLocation = $689dddd804f8aa0f$export$e44be9a9779c480b;
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = $689dddd804f8aa0f$export$e44be9a9779c480b;
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            // TODO: this probably needs to be updated so it can be used by vue-termui
            if (__VUE_PROD_DEVTOOLS__ && $689dddd804f8aa0f$var$isBrowser) $689dddd804f8aa0f$var$addDevtools(app, router, matcher);
        }
    };
    // TODO: type this as NavigationGuardReturn or similar instead of any
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
function $689dddd804f8aa0f$var$extractChangingRecords(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$689dddd804f8aa0f$var$isSameRouteRecord(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) // the type doesn't matter because we are comparing per reference
        {
            if (!from.matched.find((record)=>$689dddd804f8aa0f$var$isSameRouteRecord(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
/**
 * Returns the router instance. Equivalent to using `$router` inside
 * templates.
 */ function $689dddd804f8aa0f$export$9a302a45f65d0572() {
    return (0, $esfUo.inject)($689dddd804f8aa0f$export$b6c0da8b9dae491f);
}
/**
 * Returns the current route location. Equivalent to using `$route` inside
 * templates.
 */ function $689dddd804f8aa0f$export$3f79f0b98112cf57() {
    return (0, $esfUo.inject)($689dddd804f8aa0f$export$3aca783e9a3e6e9e);
}



var $6x6HK = parcelRequire("6x6HK");

var $4PQtJ = parcelRequire("4PQtJ");
function $3eb82f4a8c2ab734$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3eb82f4a8c2ab734$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3eb82f4a8c2ab734$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3eb82f4a8c2ab734$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3eb82f4a8c2ab734$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3eb82f4a8c2ab734$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3eb82f4a8c2ab734$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3eb82f4a8c2ab734$var$_typeof(obj);
}
function $3eb82f4a8c2ab734$var$_wrapRegExp() {
    $3eb82f4a8c2ab734$var$_wrapRegExp = function(re, groups) {
        return new BabelRegExp(re, void 0, groups);
    };
    var _super = RegExp.prototype, _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = new RegExp(re, flags);
        return _groups.set(_this, groups || _groups.get(re)), $3eb82f4a8c2ab734$var$_setPrototypeOf(_this, BabelRegExp.prototype);
    }
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            return groups[name] = result[g[name]], groups;
        }, Object.create(null));
    }
    return $3eb82f4a8c2ab734$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        return result && (result.groups = buildGroups(result, this)), result;
    }, BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if ("string" == typeof substitution) {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        }
        if ("function" == typeof substitution) {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = arguments;
                return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
            });
        }
        return _super[Symbol.replace].call(this, str, substitution);
    }, $3eb82f4a8c2ab734$var$_wrapRegExp.apply(this, arguments);
}
function $3eb82f4a8c2ab734$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3eb82f4a8c2ab734$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3eb82f4a8c2ab734$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3eb82f4a8c2ab734$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3eb82f4a8c2ab734$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3eb82f4a8c2ab734$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3eb82f4a8c2ab734$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3eb82f4a8c2ab734$var$_setPrototypeOf(subClass, superClass);
}
function $3eb82f4a8c2ab734$var$_setPrototypeOf(o, p) {
    $3eb82f4a8c2ab734$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3eb82f4a8c2ab734$var$_setPrototypeOf(o, p);
}
function $3eb82f4a8c2ab734$var$_slicedToArray(arr, i) {
    return $3eb82f4a8c2ab734$var$_arrayWithHoles(arr) || $3eb82f4a8c2ab734$var$_iterableToArrayLimit(arr, i) || $3eb82f4a8c2ab734$var$_unsupportedIterableToArray(arr, i) || $3eb82f4a8c2ab734$var$_nonIterableRest();
}
function $3eb82f4a8c2ab734$var$_toConsumableArray(arr) {
    return $3eb82f4a8c2ab734$var$_arrayWithoutHoles(arr) || $3eb82f4a8c2ab734$var$_iterableToArray(arr) || $3eb82f4a8c2ab734$var$_unsupportedIterableToArray(arr) || $3eb82f4a8c2ab734$var$_nonIterableSpread();
}
function $3eb82f4a8c2ab734$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3eb82f4a8c2ab734$var$_arrayLikeToArray(arr);
}
function $3eb82f4a8c2ab734$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3eb82f4a8c2ab734$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3eb82f4a8c2ab734$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3eb82f4a8c2ab734$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3eb82f4a8c2ab734$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3eb82f4a8c2ab734$var$_arrayLikeToArray(o, minLen);
}
function $3eb82f4a8c2ab734$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3eb82f4a8c2ab734$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3eb82f4a8c2ab734$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $3eb82f4a8c2ab734$var$noop = function noop() {};
var $3eb82f4a8c2ab734$var$_WINDOW = {};
var $3eb82f4a8c2ab734$var$_DOCUMENT = {};
var $3eb82f4a8c2ab734$var$_MUTATION_OBSERVER = null;
var $3eb82f4a8c2ab734$var$_PERFORMANCE = {
    mark: $3eb82f4a8c2ab734$var$noop,
    measure: $3eb82f4a8c2ab734$var$noop
};
try {
    if (typeof window !== "undefined") $3eb82f4a8c2ab734$var$_WINDOW = window;
    if (typeof document !== "undefined") $3eb82f4a8c2ab734$var$_DOCUMENT = document;
    if (typeof MutationObserver !== "undefined") $3eb82f4a8c2ab734$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== "undefined") $3eb82f4a8c2ab734$var$_PERFORMANCE = performance;
} catch (e) {}
var $3eb82f4a8c2ab734$var$_ref = $3eb82f4a8c2ab734$var$_WINDOW.navigator || {}, $3eb82f4a8c2ab734$var$_ref$userAgent = $3eb82f4a8c2ab734$var$_ref.userAgent, $3eb82f4a8c2ab734$var$userAgent = $3eb82f4a8c2ab734$var$_ref$userAgent === void 0 ? "" : $3eb82f4a8c2ab734$var$_ref$userAgent;
var $3eb82f4a8c2ab734$var$WINDOW = $3eb82f4a8c2ab734$var$_WINDOW;
var $3eb82f4a8c2ab734$var$DOCUMENT = $3eb82f4a8c2ab734$var$_DOCUMENT;
var $3eb82f4a8c2ab734$var$MUTATION_OBSERVER = $3eb82f4a8c2ab734$var$_MUTATION_OBSERVER;
var $3eb82f4a8c2ab734$var$PERFORMANCE = $3eb82f4a8c2ab734$var$_PERFORMANCE;
var $3eb82f4a8c2ab734$var$IS_BROWSER = !!$3eb82f4a8c2ab734$var$WINDOW.document;
var $3eb82f4a8c2ab734$var$IS_DOM = !!$3eb82f4a8c2ab734$var$DOCUMENT.documentElement && !!$3eb82f4a8c2ab734$var$DOCUMENT.head && typeof $3eb82f4a8c2ab734$var$DOCUMENT.addEventListener === "function" && typeof $3eb82f4a8c2ab734$var$DOCUMENT.createElement === "function";
var $3eb82f4a8c2ab734$var$IS_IE = ~$3eb82f4a8c2ab734$var$userAgent.indexOf("MSIE") || ~$3eb82f4a8c2ab734$var$userAgent.indexOf("Trident/");
var $3eb82f4a8c2ab734$var$_familyProxy, $3eb82f4a8c2ab734$var$_familyProxy2, $3eb82f4a8c2ab734$var$_familyProxy3, $3eb82f4a8c2ab734$var$_familyProxy4, $3eb82f4a8c2ab734$var$_familyProxy5;
var $3eb82f4a8c2ab734$var$NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var $3eb82f4a8c2ab734$var$UNITS_IN_GRID = 16;
var $3eb82f4a8c2ab734$var$DEFAULT_CSS_PREFIX = "fa";
var $3eb82f4a8c2ab734$var$DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var $3eb82f4a8c2ab734$var$DATA_FA_I2SVG = "data-fa-i2svg";
var $3eb82f4a8c2ab734$var$DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var $3eb82f4a8c2ab734$var$DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var $3eb82f4a8c2ab734$var$DATA_PREFIX = "data-prefix";
var $3eb82f4a8c2ab734$var$DATA_ICON = "data-icon";
var $3eb82f4a8c2ab734$var$HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var $3eb82f4a8c2ab734$var$MUTATION_APPROACH_ASYNC = "async";
var $3eb82f4a8c2ab734$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
];
var $3eb82f4a8c2ab734$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var $3eb82f4a8c2ab734$var$FAMILY_CLASSIC = "classic";
var $3eb82f4a8c2ab734$var$FAMILY_SHARP = "sharp";
var $3eb82f4a8c2ab734$var$FAMILIES = [
    $3eb82f4a8c2ab734$var$FAMILY_CLASSIC,
    $3eb82f4a8c2ab734$var$FAMILY_SHARP
];
function $3eb82f4a8c2ab734$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get: function get(target, prop) {
            return prop in target ? target[prop] : target[$3eb82f4a8c2ab734$var$FAMILY_CLASSIC];
        }
    });
}
var $3eb82f4a8c2ab734$var$PREFIX_TO_STYLE = $3eb82f4a8c2ab734$var$familyProxy(($3eb82f4a8c2ab734$var$_familyProxy = {}, $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_familyProxy, $3eb82f4a8c2ab734$var$FAMILY_CLASSIC, {
    "fa": "solid",
    "fas": "solid",
    "fa-solid": "solid",
    "far": "regular",
    "fa-regular": "regular",
    "fal": "light",
    "fa-light": "light",
    "fat": "thin",
    "fa-thin": "thin",
    "fad": "duotone",
    "fa-duotone": "duotone",
    "fab": "brands",
    "fa-brands": "brands",
    "fak": "kit",
    "fa-kit": "kit"
}), $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_familyProxy, $3eb82f4a8c2ab734$var$FAMILY_SHARP, {
    "fa": "solid",
    "fass": "solid",
    "fa-solid": "solid"
}), $3eb82f4a8c2ab734$var$_familyProxy));
var $3eb82f4a8c2ab734$var$STYLE_TO_PREFIX = $3eb82f4a8c2ab734$var$familyProxy(($3eb82f4a8c2ab734$var$_familyProxy2 = {}, $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_familyProxy2, $3eb82f4a8c2ab734$var$FAMILY_CLASSIC, {
    "solid": "fas",
    "regular": "far",
    "light": "fal",
    "thin": "fat",
    "duotone": "fad",
    "brands": "fab",
    "kit": "fak"
}), $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_familyProxy2, $3eb82f4a8c2ab734$var$FAMILY_SHARP, {
    "solid": "fass"
}), $3eb82f4a8c2ab734$var$_familyProxy2));
var $3eb82f4a8c2ab734$var$PREFIX_TO_LONG_STYLE = $3eb82f4a8c2ab734$var$familyProxy(($3eb82f4a8c2ab734$var$_familyProxy3 = {}, $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_familyProxy3, $3eb82f4a8c2ab734$var$FAMILY_CLASSIC, {
    "fab": "fa-brands",
    "fad": "fa-duotone",
    "fak": "fa-kit",
    "fal": "fa-light",
    "far": "fa-regular",
    "fas": "fa-solid",
    "fat": "fa-thin"
}), $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_familyProxy3, $3eb82f4a8c2ab734$var$FAMILY_SHARP, {
    "fass": "fa-solid"
}), $3eb82f4a8c2ab734$var$_familyProxy3));
var $3eb82f4a8c2ab734$var$LONG_STYLE_TO_PREFIX = $3eb82f4a8c2ab734$var$familyProxy(($3eb82f4a8c2ab734$var$_familyProxy4 = {}, $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_familyProxy4, $3eb82f4a8c2ab734$var$FAMILY_CLASSIC, {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-kit": "fak",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
}), $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_familyProxy4, $3eb82f4a8c2ab734$var$FAMILY_SHARP, {
    "fa-solid": "fass"
}), $3eb82f4a8c2ab734$var$_familyProxy4));
var $3eb82f4a8c2ab734$var$ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss)?[\-\ ]/; // eslint-disable-line no-useless-escape
var $3eb82f4a8c2ab734$var$LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var $3eb82f4a8c2ab734$var$FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i; // TODO: this needs to support fass
// TODO: do we need to handle font-weight for kit SVG pseudo-elements?
var $3eb82f4a8c2ab734$var$FONT_WEIGHT_TO_PREFIX = $3eb82f4a8c2ab734$var$familyProxy(($3eb82f4a8c2ab734$var$_familyProxy5 = {}, $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_familyProxy5, $3eb82f4a8c2ab734$var$FAMILY_CLASSIC, {
    "900": "fas",
    "400": "far",
    "normal": "far",
    "300": "fal",
    "100": "fat"
}), $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_familyProxy5, $3eb82f4a8c2ab734$var$FAMILY_SHARP, {
    "900": "fass"
}), $3eb82f4a8c2ab734$var$_familyProxy5));
var $3eb82f4a8c2ab734$var$oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $3eb82f4a8c2ab734$var$oneToTwenty = $3eb82f4a8c2ab734$var$oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var $3eb82f4a8c2ab734$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
];
var $3eb82f4a8c2ab734$var$DUOTONE_CLASSES = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
};
var $3eb82f4a8c2ab734$var$prefixes = new Set();
Object.keys($3eb82f4a8c2ab734$var$STYLE_TO_PREFIX[$3eb82f4a8c2ab734$var$FAMILY_CLASSIC]).map($3eb82f4a8c2ab734$var$prefixes.add.bind($3eb82f4a8c2ab734$var$prefixes));
Object.keys($3eb82f4a8c2ab734$var$STYLE_TO_PREFIX[$3eb82f4a8c2ab734$var$FAMILY_SHARP]).map($3eb82f4a8c2ab734$var$prefixes.add.bind($3eb82f4a8c2ab734$var$prefixes));
var $3eb82f4a8c2ab734$var$RESERVED_CLASSES = [].concat($3eb82f4a8c2ab734$var$FAMILIES, $3eb82f4a8c2ab734$var$_toConsumableArray($3eb82f4a8c2ab734$var$prefixes), [
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    $3eb82f4a8c2ab734$var$DUOTONE_CLASSES.GROUP,
    $3eb82f4a8c2ab734$var$DUOTONE_CLASSES.SWAP_OPACITY,
    $3eb82f4a8c2ab734$var$DUOTONE_CLASSES.PRIMARY,
    $3eb82f4a8c2ab734$var$DUOTONE_CLASSES.SECONDARY
]).concat($3eb82f4a8c2ab734$var$oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat($3eb82f4a8c2ab734$var$oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var $3eb82f4a8c2ab734$var$initial = $3eb82f4a8c2ab734$var$WINDOW.FontAwesomeConfig || {};
function $3eb82f4a8c2ab734$var$getAttrConfig(attr) {
    var element = $3eb82f4a8c2ab734$var$DOCUMENT.querySelector("script[" + attr + "]");
    if (element) return element.getAttribute(attr);
}
function $3eb82f4a8c2ab734$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === "") return true;
    if (val === "false") return false;
    if (val === "true") return true;
    return val;
}
if ($3eb82f4a8c2ab734$var$DOCUMENT && typeof $3eb82f4a8c2ab734$var$DOCUMENT.querySelector === "function") {
    var $3eb82f4a8c2ab734$var$attrs = [
        [
            "data-family-prefix",
            "familyPrefix"
        ],
        [
            "data-css-prefix",
            "cssPrefix"
        ],
        [
            "data-family-default",
            "familyDefault"
        ],
        [
            "data-style-default",
            "styleDefault"
        ],
        [
            "data-replacement-class",
            "replacementClass"
        ],
        [
            "data-auto-replace-svg",
            "autoReplaceSvg"
        ],
        [
            "data-auto-add-css",
            "autoAddCss"
        ],
        [
            "data-auto-a11y",
            "autoA11y"
        ],
        [
            "data-search-pseudo-elements",
            "searchPseudoElements"
        ],
        [
            "data-observe-mutations",
            "observeMutations"
        ],
        [
            "data-mutate-approach",
            "mutateApproach"
        ],
        [
            "data-keep-original-source",
            "keepOriginalSource"
        ],
        [
            "data-measure-performance",
            "measurePerformance"
        ],
        [
            "data-show-missing-icons",
            "showMissingIcons"
        ]
    ];
    $3eb82f4a8c2ab734$var$attrs.forEach(function(_ref) {
        var _ref2 = $3eb82f4a8c2ab734$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $3eb82f4a8c2ab734$var$coerce($3eb82f4a8c2ab734$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $3eb82f4a8c2ab734$var$initial[key] = val;
    });
}
var $3eb82f4a8c2ab734$var$_default = {
    styleDefault: "solid",
    familyDefault: "classic",
    cssPrefix: $3eb82f4a8c2ab734$var$DEFAULT_CSS_PREFIX,
    replacementClass: $3eb82f4a8c2ab734$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: "async",
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present
if ($3eb82f4a8c2ab734$var$initial.familyPrefix) $3eb82f4a8c2ab734$var$initial.cssPrefix = $3eb82f4a8c2ab734$var$initial.familyPrefix;
var $3eb82f4a8c2ab734$var$_config = $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, $3eb82f4a8c2ab734$var$_default), $3eb82f4a8c2ab734$var$initial);
if (!$3eb82f4a8c2ab734$var$_config.autoReplaceSvg) $3eb82f4a8c2ab734$var$_config.observeMutations = false;
var $3eb82f4a8c2ab734$var$config = {};
Object.keys($3eb82f4a8c2ab734$var$_default).forEach(function(key) {
    Object.defineProperty($3eb82f4a8c2ab734$var$config, key, {
        enumerable: true,
        set: function set(val) {
            $3eb82f4a8c2ab734$var$_config[key] = val;
            $3eb82f4a8c2ab734$var$_onChangeCb.forEach(function(cb) {
                return cb($3eb82f4a8c2ab734$var$config);
            });
        },
        get: function get() {
            return $3eb82f4a8c2ab734$var$_config[key];
        }
    });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($3eb82f4a8c2ab734$var$config, "familyPrefix", {
    enumerable: true,
    set: function set(val) {
        $3eb82f4a8c2ab734$var$_config.cssPrefix = val;
        $3eb82f4a8c2ab734$var$_onChangeCb.forEach(function(cb) {
            return cb($3eb82f4a8c2ab734$var$config);
        });
    },
    get: function get() {
        return $3eb82f4a8c2ab734$var$_config.cssPrefix;
    }
});
$3eb82f4a8c2ab734$var$WINDOW.FontAwesomeConfig = $3eb82f4a8c2ab734$var$config;
var $3eb82f4a8c2ab734$var$_onChangeCb = [];
function $3eb82f4a8c2ab734$var$onChange(cb) {
    $3eb82f4a8c2ab734$var$_onChangeCb.push(cb);
    return function() {
        $3eb82f4a8c2ab734$var$_onChangeCb.splice($3eb82f4a8c2ab734$var$_onChangeCb.indexOf(cb), 1);
    };
}
var $3eb82f4a8c2ab734$var$d = $3eb82f4a8c2ab734$var$UNITS_IN_GRID;
var $3eb82f4a8c2ab734$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $3eb82f4a8c2ab734$var$insertCss(css) {
    if (!css || !$3eb82f4a8c2ab734$var$IS_DOM) return;
    var style = $3eb82f4a8c2ab734$var$DOCUMENT.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    var headChildren = $3eb82f4a8c2ab734$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || "").toUpperCase();
        if ([
            "STYLE",
            "LINK"
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $3eb82f4a8c2ab734$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $3eb82f4a8c2ab734$var$idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function $3eb82f4a8c2ab734$var$nextUniqueId() {
    var size = 12;
    var id = "";
    while(size-- > 0)id += $3eb82f4a8c2ab734$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $3eb82f4a8c2ab734$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $3eb82f4a8c2ab734$var$classArray(node) {
    if (node.classList) return $3eb82f4a8c2ab734$var$toArray(node.classList);
    else return (node.getAttribute("class") || "").split(" ").filter(function(i) {
        return i;
    });
}
function $3eb82f4a8c2ab734$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $3eb82f4a8c2ab734$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, '="').concat($3eb82f4a8c2ab734$var$htmlEscape(attributes[attributeName]), '" ');
    }, "").trim();
}
function $3eb82f4a8c2ab734$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, "");
}
function $3eb82f4a8c2ab734$var$transformIsMeaningful(transform) {
    return transform.size !== $3eb82f4a8c2ab734$var$meaninglessTransform.size || transform.x !== $3eb82f4a8c2ab734$var$meaninglessTransform.x || transform.y !== $3eb82f4a8c2ab734$var$meaninglessTransform.y || transform.rotate !== $3eb82f4a8c2ab734$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $3eb82f4a8c2ab734$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $3eb82f4a8c2ab734$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $3eb82f4a8c2ab734$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $3eb82f4a8c2ab734$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = "";
    if (startCentered && $3eb82f4a8c2ab734$var$IS_IE) val += "translate(".concat(transform.x / $3eb82f4a8c2ab734$var$d - width / 2, "em, ").concat(transform.y / $3eb82f4a8c2ab734$var$d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $3eb82f4a8c2ab734$var$d, "em), calc(-50% + ").concat(transform.y / $3eb82f4a8c2ab734$var$d, "em)) ");
    else val += "translate(".concat(transform.x / $3eb82f4a8c2ab734$var$d, "em, ").concat(transform.y / $3eb82f4a8c2ab734$var$d, "em) ");
    val += "scale(".concat(transform.size / $3eb82f4a8c2ab734$var$d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $3eb82f4a8c2ab734$var$d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $3eb82f4a8c2ab734$var$baseStyles = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
function $3eb82f4a8c2ab734$var$css() {
    var dcp = $3eb82f4a8c2ab734$var$DEFAULT_CSS_PREFIX;
    var drc = $3eb82f4a8c2ab734$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $3eb82f4a8c2ab734$var$config.cssPrefix;
    var rc = $3eb82f4a8c2ab734$var$config.replacementClass;
    var s = $3eb82f4a8c2ab734$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dcp, "\\-"), "g");
        var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), "g");
        var rPatt = new RegExp("\\.".concat(drc), "g");
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $3eb82f4a8c2ab734$var$_cssInserted = false;
function $3eb82f4a8c2ab734$var$ensureCss() {
    if ($3eb82f4a8c2ab734$var$config.autoAddCss && !$3eb82f4a8c2ab734$var$_cssInserted) {
        $3eb82f4a8c2ab734$var$insertCss($3eb82f4a8c2ab734$var$css());
        $3eb82f4a8c2ab734$var$_cssInserted = true;
    }
}
var $3eb82f4a8c2ab734$var$InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: $3eb82f4a8c2ab734$var$css,
                insertCss: $3eb82f4a8c2ab734$var$ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                $3eb82f4a8c2ab734$var$ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                $3eb82f4a8c2ab734$var$ensureCss();
            }
        };
    }
};
var $3eb82f4a8c2ab734$var$w = $3eb82f4a8c2ab734$var$WINDOW || {};
if (!$3eb82f4a8c2ab734$var$w[$3eb82f4a8c2ab734$var$NAMESPACE_IDENTIFIER]) $3eb82f4a8c2ab734$var$w[$3eb82f4a8c2ab734$var$NAMESPACE_IDENTIFIER] = {};
if (!$3eb82f4a8c2ab734$var$w[$3eb82f4a8c2ab734$var$NAMESPACE_IDENTIFIER].styles) $3eb82f4a8c2ab734$var$w[$3eb82f4a8c2ab734$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$3eb82f4a8c2ab734$var$w[$3eb82f4a8c2ab734$var$NAMESPACE_IDENTIFIER].hooks) $3eb82f4a8c2ab734$var$w[$3eb82f4a8c2ab734$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$3eb82f4a8c2ab734$var$w[$3eb82f4a8c2ab734$var$NAMESPACE_IDENTIFIER].shims) $3eb82f4a8c2ab734$var$w[$3eb82f4a8c2ab734$var$NAMESPACE_IDENTIFIER].shims = [];
var $3eb82f4a8c2ab734$var$namespace = $3eb82f4a8c2ab734$var$w[$3eb82f4a8c2ab734$var$NAMESPACE_IDENTIFIER];
var $3eb82f4a8c2ab734$var$functions = [];
var $3eb82f4a8c2ab734$var$listener = function listener() {
    $3eb82f4a8c2ab734$var$DOCUMENT.removeEventListener("DOMContentLoaded", listener);
    $3eb82f4a8c2ab734$var$loaded = 1;
    $3eb82f4a8c2ab734$var$functions.map(function(fn) {
        return fn();
    });
};
var $3eb82f4a8c2ab734$var$loaded = false;
if ($3eb82f4a8c2ab734$var$IS_DOM) {
    $3eb82f4a8c2ab734$var$loaded = ($3eb82f4a8c2ab734$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($3eb82f4a8c2ab734$var$DOCUMENT.readyState);
    if (!$3eb82f4a8c2ab734$var$loaded) $3eb82f4a8c2ab734$var$DOCUMENT.addEventListener("DOMContentLoaded", $3eb82f4a8c2ab734$var$listener);
}
function $3eb82f4a8c2ab734$var$domready(fn) {
    if (!$3eb82f4a8c2ab734$var$IS_DOM) return;
    $3eb82f4a8c2ab734$var$loaded ? setTimeout(fn, 0) : $3eb82f4a8c2ab734$var$functions.push(fn);
}
function $3eb82f4a8c2ab734$var$toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === "string") return $3eb82f4a8c2ab734$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($3eb82f4a8c2ab734$var$joinAttributes(attributes), ">").concat(children.map($3eb82f4a8c2ab734$var$toHtml).join(""), "</").concat(tag, ">");
}
function $3eb82f4a8c2ab734$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $3eb82f4a8c2ab734$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $3eb82f4a8c2ab734$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $3eb82f4a8c2ab734$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $3eb82f4a8c2ab734$var$ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            var extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $3eb82f4a8c2ab734$var$toHex(unicode) {
    var decoded = $3eb82f4a8c2ab734$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $3eb82f4a8c2ab734$var$codePointAt(string, index) {
    var size = string.length;
    var first = string.charCodeAt(index);
    var second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $3eb82f4a8c2ab734$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $3eb82f4a8c2ab734$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = $3eb82f4a8c2ab734$var$normalizeIcons(icons);
    if (typeof $3eb82f4a8c2ab734$var$namespace.hooks.addPack === "function" && !skipHooks) $3eb82f4a8c2ab734$var$namespace.hooks.addPack(prefix, $3eb82f4a8c2ab734$var$normalizeIcons(icons));
    else $3eb82f4a8c2ab734$var$namespace.styles[prefix] = $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, $3eb82f4a8c2ab734$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === "fas") $3eb82f4a8c2ab734$var$defineIcons("fa", icons);
}
var $3eb82f4a8c2ab734$var$duotonePathRe = [
    /*#__PURE__*/ $3eb82f4a8c2ab734$var$_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ $3eb82f4a8c2ab734$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ $3eb82f4a8c2ab734$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2
    })
];
var $3eb82f4a8c2ab734$var$_LONG_STYLE, $3eb82f4a8c2ab734$var$_PREFIXES, $3eb82f4a8c2ab734$var$_PREFIXES_FOR_FAMILY;
var $3eb82f4a8c2ab734$var$styles = $3eb82f4a8c2ab734$var$namespace.styles, $3eb82f4a8c2ab734$var$shims = $3eb82f4a8c2ab734$var$namespace.shims;
var $3eb82f4a8c2ab734$var$LONG_STYLE = ($3eb82f4a8c2ab734$var$_LONG_STYLE = {}, $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_LONG_STYLE, $3eb82f4a8c2ab734$var$FAMILY_CLASSIC, Object.values($3eb82f4a8c2ab734$var$PREFIX_TO_LONG_STYLE[$3eb82f4a8c2ab734$var$FAMILY_CLASSIC])), $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_LONG_STYLE, $3eb82f4a8c2ab734$var$FAMILY_SHARP, Object.values($3eb82f4a8c2ab734$var$PREFIX_TO_LONG_STYLE[$3eb82f4a8c2ab734$var$FAMILY_SHARP])), $3eb82f4a8c2ab734$var$_LONG_STYLE);
var $3eb82f4a8c2ab734$var$_defaultUsablePrefix = null;
var $3eb82f4a8c2ab734$var$_byUnicode = {};
var $3eb82f4a8c2ab734$var$_byLigature = {};
var $3eb82f4a8c2ab734$var$_byOldName = {};
var $3eb82f4a8c2ab734$var$_byOldUnicode = {};
var $3eb82f4a8c2ab734$var$_byAlias = {};
var $3eb82f4a8c2ab734$var$PREFIXES = ($3eb82f4a8c2ab734$var$_PREFIXES = {}, $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_PREFIXES, $3eb82f4a8c2ab734$var$FAMILY_CLASSIC, Object.keys($3eb82f4a8c2ab734$var$PREFIX_TO_STYLE[$3eb82f4a8c2ab734$var$FAMILY_CLASSIC])), $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_PREFIXES, $3eb82f4a8c2ab734$var$FAMILY_SHARP, Object.keys($3eb82f4a8c2ab734$var$PREFIX_TO_STYLE[$3eb82f4a8c2ab734$var$FAMILY_SHARP])), $3eb82f4a8c2ab734$var$_PREFIXES);
function $3eb82f4a8c2ab734$var$isReserved(name) {
    return ~$3eb82f4a8c2ab734$var$RESERVED_CLASSES.indexOf(name);
}
function $3eb82f4a8c2ab734$var$getIconName(cssPrefix, cls) {
    var parts = cls.split("-");
    var prefix = parts[0];
    var iconName = parts.slice(1).join("-");
    if (prefix === cssPrefix && iconName !== "" && !$3eb82f4a8c2ab734$var$isReserved(iconName)) return iconName;
    else return null;
}
var $3eb82f4a8c2ab734$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $3eb82f4a8c2ab734$var$reduce($3eb82f4a8c2ab734$var$styles, function(o, style, prefix) {
            o[prefix] = $3eb82f4a8c2ab734$var$reduce(style, reducer, {});
            return o;
        }, {});
    };
    $3eb82f4a8c2ab734$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "number";
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $3eb82f4a8c2ab734$var$_byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === "string";
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $3eb82f4a8c2ab734$var$_byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = "far" in $3eb82f4a8c2ab734$var$styles || $3eb82f4a8c2ab734$var$config.autoFetchSvg;
    var shimLookups = $3eb82f4a8c2ab734$var$reduce($3eb82f4a8c2ab734$var$shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === "far" && !hasRegular) prefix = "fas";
        if (typeof maybeNameMaybeUnicode === "string") acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === "number") acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $3eb82f4a8c2ab734$var$_byOldName = shimLookups.names;
    $3eb82f4a8c2ab734$var$_byOldUnicode = shimLookups.unicodes;
    $3eb82f4a8c2ab734$var$_defaultUsablePrefix = $3eb82f4a8c2ab734$var$getCanonicalPrefix($3eb82f4a8c2ab734$var$config.styleDefault, {
        family: $3eb82f4a8c2ab734$var$config.familyDefault
    });
};
$3eb82f4a8c2ab734$var$onChange(function(c) {
    $3eb82f4a8c2ab734$var$_defaultUsablePrefix = $3eb82f4a8c2ab734$var$getCanonicalPrefix(c.styleDefault, {
        family: $3eb82f4a8c2ab734$var$config.familyDefault
    });
});
$3eb82f4a8c2ab734$var$build();
function $3eb82f4a8c2ab734$var$byUnicode(prefix, unicode) {
    return ($3eb82f4a8c2ab734$var$_byUnicode[prefix] || {})[unicode];
}
function $3eb82f4a8c2ab734$var$byLigature(prefix, ligature) {
    return ($3eb82f4a8c2ab734$var$_byLigature[prefix] || {})[ligature];
}
function $3eb82f4a8c2ab734$var$byAlias(prefix, alias) {
    return ($3eb82f4a8c2ab734$var$_byAlias[prefix] || {})[alias];
}
function $3eb82f4a8c2ab734$var$byOldName(name) {
    return $3eb82f4a8c2ab734$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $3eb82f4a8c2ab734$var$byOldUnicode(unicode) {
    var oldUnicode = $3eb82f4a8c2ab734$var$_byOldUnicode[unicode];
    var newUnicode = $3eb82f4a8c2ab734$var$byUnicode("fas", unicode);
    return oldUnicode || (newUnicode ? {
        prefix: "fas",
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $3eb82f4a8c2ab734$var$getDefaultUsablePrefix() {
    return $3eb82f4a8c2ab734$var$_defaultUsablePrefix;
}
var $3eb82f4a8c2ab734$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $3eb82f4a8c2ab734$var$getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$family = params.family, family = _params$family === void 0 ? $3eb82f4a8c2ab734$var$FAMILY_CLASSIC : _params$family;
    var style = $3eb82f4a8c2ab734$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    var prefix = $3eb82f4a8c2ab734$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $3eb82f4a8c2ab734$var$STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in $3eb82f4a8c2ab734$var$namespace.styles ? styleOrPrefix : null;
    return prefix || defined || null;
}
var $3eb82f4a8c2ab734$var$PREFIXES_FOR_FAMILY = ($3eb82f4a8c2ab734$var$_PREFIXES_FOR_FAMILY = {}, $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_PREFIXES_FOR_FAMILY, $3eb82f4a8c2ab734$var$FAMILY_CLASSIC, Object.keys($3eb82f4a8c2ab734$var$PREFIX_TO_LONG_STYLE[$3eb82f4a8c2ab734$var$FAMILY_CLASSIC])), $3eb82f4a8c2ab734$var$_defineProperty($3eb82f4a8c2ab734$var$_PREFIXES_FOR_FAMILY, $3eb82f4a8c2ab734$var$FAMILY_SHARP, Object.keys($3eb82f4a8c2ab734$var$PREFIX_TO_LONG_STYLE[$3eb82f4a8c2ab734$var$FAMILY_SHARP])), $3eb82f4a8c2ab734$var$_PREFIXES_FOR_FAMILY);
function $3eb82f4a8c2ab734$var$getCanonicalIcon(values) {
    var _famProps;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var famProps = (_famProps = {}, $3eb82f4a8c2ab734$var$_defineProperty(_famProps, $3eb82f4a8c2ab734$var$FAMILY_CLASSIC, "".concat($3eb82f4a8c2ab734$var$config.cssPrefix, "-").concat($3eb82f4a8c2ab734$var$FAMILY_CLASSIC)), $3eb82f4a8c2ab734$var$_defineProperty(_famProps, $3eb82f4a8c2ab734$var$FAMILY_SHARP, "".concat($3eb82f4a8c2ab734$var$config.cssPrefix, "-").concat($3eb82f4a8c2ab734$var$FAMILY_SHARP)), _famProps);
    var givenPrefix = null;
    var family = $3eb82f4a8c2ab734$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$3eb82f4a8c2ab734$var$FAMILY_CLASSIC]) || values.some(function(v) {
        return $3eb82f4a8c2ab734$var$PREFIXES_FOR_FAMILY[$3eb82f4a8c2ab734$var$FAMILY_CLASSIC].includes(v);
    })) family = $3eb82f4a8c2ab734$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$3eb82f4a8c2ab734$var$FAMILY_SHARP]) || values.some(function(v) {
        return $3eb82f4a8c2ab734$var$PREFIXES_FOR_FAMILY[$3eb82f4a8c2ab734$var$FAMILY_SHARP].includes(v);
    })) family = $3eb82f4a8c2ab734$var$FAMILY_SHARP;
    var canonical = values.reduce(function(acc, cls) {
        var iconName = $3eb82f4a8c2ab734$var$getIconName($3eb82f4a8c2ab734$var$config.cssPrefix, cls);
        if ($3eb82f4a8c2ab734$var$styles[cls]) {
            cls = $3eb82f4a8c2ab734$var$LONG_STYLE[family].includes(cls) ? $3eb82f4a8c2ab734$var$LONG_STYLE_TO_PREFIX[family][cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if ($3eb82f4a8c2ab734$var$PREFIXES[family].indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = $3eb82f4a8c2ab734$var$getCanonicalPrefix(cls, {
                family: family
            });
        } else if (iconName) acc.iconName = iconName;
        else if (cls !== $3eb82f4a8c2ab734$var$config.replacementClass && cls !== famProps[$3eb82f4a8c2ab734$var$FAMILY_CLASSIC] && cls !== famProps[$3eb82f4a8c2ab734$var$FAMILY_SHARP]) acc.rest.push(cls);
        if (!skipLookups && acc.prefix && acc.iconName) {
            var shim = givenPrefix === "fa" ? $3eb82f4a8c2ab734$var$byOldName(acc.iconName) : {};
            var aliasIconName = $3eb82f4a8c2ab734$var$byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) givenPrefix = null;
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === "far" && !$3eb82f4a8c2ab734$var$styles["far"] && $3eb82f4a8c2ab734$var$styles["fas"] && !$3eb82f4a8c2ab734$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
            // but only if we aren't auto-fetching SVGs
            acc.prefix = "fas";
        }
        return acc;
    }, $3eb82f4a8c2ab734$var$emptyCanonicalIcon());
    if (values.includes("fa-brands") || values.includes("fab")) canonical.prefix = "fab";
    if (values.includes("fa-duotone") || values.includes("fad")) canonical.prefix = "fad";
    if (!canonical.prefix && family === $3eb82f4a8c2ab734$var$FAMILY_SHARP && ($3eb82f4a8c2ab734$var$styles["fass"] || $3eb82f4a8c2ab734$var$config.autoFetchSvg)) {
        canonical.prefix = "fass";
        canonical.iconName = $3eb82f4a8c2ab734$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
    if (canonical.prefix === "fa" || givenPrefix === "fa") // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $3eb82f4a8c2ab734$var$getDefaultUsablePrefix() || "fas";
    return canonical;
}
var $3eb82f4a8c2ab734$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $3eb82f4a8c2ab734$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    $3eb82f4a8c2ab734$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    $3eb82f4a8c2ab734$var$defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
                    var longPrefix = $3eb82f4a8c2ab734$var$PREFIX_TO_LONG_STYLE[$3eb82f4a8c2ab734$var$FAMILY_CLASSIC][key];
                    if (longPrefix) $3eb82f4a8c2ab734$var$defineIcons(longPrefix, additions[key]);
                    $3eb82f4a8c2ab734$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === "string") additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
var $3eb82f4a8c2ab734$var$_plugins = [];
var $3eb82f4a8c2ab734$var$_hooks = {};
var $3eb82f4a8c2ab734$var$providers = {};
var $3eb82f4a8c2ab734$var$defaultProviderKeys = Object.keys($3eb82f4a8c2ab734$var$providers);
function $3eb82f4a8c2ab734$var$registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    $3eb82f4a8c2ab734$var$_plugins = nextPlugins;
    $3eb82f4a8c2ab734$var$_hooks = {};
    Object.keys($3eb82f4a8c2ab734$var$providers).forEach(function(k) {
        if ($3eb82f4a8c2ab734$var$defaultProviderKeys.indexOf(k) === -1) delete $3eb82f4a8c2ab734$var$providers[k];
    });
    $3eb82f4a8c2ab734$var$_plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === "function") obj[tk] = mixout[tk];
            if ($3eb82f4a8c2ab734$var$_typeof(mixout[tk]) === "object") Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!$3eb82f4a8c2ab734$var$_hooks[hook]) $3eb82f4a8c2ab734$var$_hooks[hook] = [];
                $3eb82f4a8c2ab734$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($3eb82f4a8c2ab734$var$providers);
    });
    return obj;
}
function $3eb82f4a8c2ab734$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = $3eb82f4a8c2ab734$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args)); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $3eb82f4a8c2ab734$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = $3eb82f4a8c2ab734$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function $3eb82f4a8c2ab734$var$callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return $3eb82f4a8c2ab734$var$providers[hook] ? $3eb82f4a8c2ab734$var$providers[hook].apply(null, args) : undefined;
}
function $3eb82f4a8c2ab734$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === "fa") iconLookup.prefix = "fas";
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || $3eb82f4a8c2ab734$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $3eb82f4a8c2ab734$var$byAlias(prefix, iconName) || iconName;
    return $3eb82f4a8c2ab734$var$iconFromMapping($3eb82f4a8c2ab734$var$library.definitions, prefix, iconName) || $3eb82f4a8c2ab734$var$iconFromMapping($3eb82f4a8c2ab734$var$namespace.styles, prefix, iconName);
}
var $3eb82f4a8c2ab734$var$library = new $3eb82f4a8c2ab734$var$Library();
var $3eb82f4a8c2ab734$var$noAuto = function noAuto() {
    $3eb82f4a8c2ab734$var$config.autoReplaceSvg = false;
    $3eb82f4a8c2ab734$var$config.observeMutations = false;
    $3eb82f4a8c2ab734$var$callHooks("noAuto");
};
var $3eb82f4a8c2ab734$var$dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($3eb82f4a8c2ab734$var$IS_DOM) {
            $3eb82f4a8c2ab734$var$callHooks("beforeI2svg", params);
            $3eb82f4a8c2ab734$var$callProvided("pseudoElements2svg", params);
            return $3eb82f4a8c2ab734$var$callProvided("i2svg", params);
        } else return Promise.reject("Operation requires a DOM of some kind.");
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if ($3eb82f4a8c2ab734$var$config.autoReplaceSvg === false) $3eb82f4a8c2ab734$var$config.autoReplaceSvg = true;
        $3eb82f4a8c2ab734$var$config.observeMutations = true;
        $3eb82f4a8c2ab734$var$domready(function() {
            $3eb82f4a8c2ab734$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $3eb82f4a8c2ab734$var$callHooks("watch", params);
        });
    }
};
var $3eb82f4a8c2ab734$var$parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if ($3eb82f4a8c2ab734$var$_typeof(_icon) === "object" && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: $3eb82f4a8c2ab734$var$byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf("fa-") === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = $3eb82f4a8c2ab734$var$getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: $3eb82f4a8c2ab734$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === "string" && (_icon.indexOf("".concat($3eb82f4a8c2ab734$var$config.cssPrefix, "-")) > -1 || _icon.match($3eb82f4a8c2ab734$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = $3eb82f4a8c2ab734$var$getCanonicalIcon(_icon.split(" "), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $3eb82f4a8c2ab734$var$getDefaultUsablePrefix(),
                iconName: $3eb82f4a8c2ab734$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === "string") {
            var _prefix = $3eb82f4a8c2ab734$var$getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: $3eb82f4a8c2ab734$var$byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var $3eb82f4a8c2ab734$export$644d8ea042df96a6 = {
    noAuto: $3eb82f4a8c2ab734$var$noAuto,
    config: $3eb82f4a8c2ab734$var$config,
    dom: $3eb82f4a8c2ab734$var$dom,
    parse: $3eb82f4a8c2ab734$var$parse,
    library: $3eb82f4a8c2ab734$var$library,
    findIconDefinition: $3eb82f4a8c2ab734$var$findIconDefinition,
    toHtml: $3eb82f4a8c2ab734$var$toHtml
};
var $3eb82f4a8c2ab734$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $3eb82f4a8c2ab734$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($3eb82f4a8c2ab734$var$namespace.styles).length > 0 || $3eb82f4a8c2ab734$var$config.autoFetchSvg) && $3eb82f4a8c2ab734$var$IS_DOM && $3eb82f4a8c2ab734$var$config.autoReplaceSvg) $3eb82f4a8c2ab734$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $3eb82f4a8c2ab734$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, "abstract", {
        get: abstractCreator
    });
    Object.defineProperty(val, "html", {
        get: function get() {
            return val.abstract.map(function(a) {
                return $3eb82f4a8c2ab734$var$toHtml(a);
            });
        }
    });
    Object.defineProperty(val, "node", {
        get: function get() {
            if (!$3eb82f4a8c2ab734$var$IS_DOM) return;
            var container = $3eb82f4a8c2ab734$var$DOCUMENT.createElement("div");
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $3eb82f4a8c2ab734$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($3eb82f4a8c2ab734$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes["style"] = $3eb82f4a8c2ab734$var$joinStyles($3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, styles), {}, {
            "transform-origin": "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: "svg",
            attributes: attributes,
            children: children
        }
    ];
}
function $3eb82f4a8c2ab734$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($3eb82f4a8c2ab734$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: "svg",
            attributes: {
                style: "display: none;"
            },
            children: [
                {
                    tag: "symbol",
                    attributes: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $3eb82f4a8c2ab734$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === "fak";
    var attrClass = [
        $3eb82f4a8c2ab734$var$config.replacementClass,
        iconName ? "".concat($3eb82f4a8c2ab734$var$config.cssPrefix, "-").concat(iconName) : ""
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== "" || !!c;
    }).concat(extra.classes).join(" ");
    var content = {
        children: [],
        attributes: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, extra.attributes), {}, {
            "data-prefix": prefix,
            "data-icon": iconName,
            "class": attrClass,
            "role": extra.attributes.role || "img",
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$3eb82f4a8c2ab734$var$DATA_FA_I2SVG] = "";
    if (title) {
        content.children.push({
            tag: "title",
            attributes: {
                id: content.attributes["aria-labelledby"] || "title-".concat(titleId || $3eb82f4a8c2ab734$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    var args = $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    var _ref2 = mask.found && main.found ? $3eb82f4a8c2ab734$var$callProvided("generateAbstractMask", args) || {
        children: [],
        attributes: {}
    } : $3eb82f4a8c2ab734$var$callProvided("generateAbstractIcon", args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $3eb82f4a8c2ab734$var$asSymbol(args);
    else return $3eb82f4a8c2ab734$var$asIcon(args);
}
function $3eb82f4a8c2ab734$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    if (watchable) attributes[$3eb82f4a8c2ab734$var$DATA_FA_I2SVG] = "";
    var styles = $3eb82f4a8c2ab734$var$_objectSpread2({}, extra.styles);
    if ($3eb82f4a8c2ab734$var$transformIsMeaningful(transform)) {
        styles["transform"] = $3eb82f4a8c2ab734$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles["-webkit-transform"] = styles["transform"];
    }
    var styleString = $3eb82f4a8c2ab734$var$joinStyles(styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
function $3eb82f4a8c2ab734$var$makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, extra.attributes), title ? {
        "title": title
    } : {}), {}, {
        "class": extra.classes.join(" ")
    });
    var styleString = $3eb82f4a8c2ab734$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes["style"] = styleString;
    var val = [];
    val.push({
        tag: "span",
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            title
        ]
    });
    return val;
}
var $3eb82f4a8c2ab734$var$styles$1 = $3eb82f4a8c2ab734$var$namespace.styles;
function $3eb82f4a8c2ab734$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $3eb82f4a8c2ab734$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: "g",
        attributes: {
            class: "".concat($3eb82f4a8c2ab734$var$config.cssPrefix, "-").concat($3eb82f4a8c2ab734$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    class: "".concat($3eb82f4a8c2ab734$var$config.cssPrefix, "-").concat($3eb82f4a8c2ab734$var$DUOTONE_CLASSES.SECONDARY),
                    fill: "currentColor",
                    d: vectorData[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    class: "".concat($3eb82f4a8c2ab734$var$config.cssPrefix, "-").concat($3eb82f4a8c2ab734$var$DUOTONE_CLASSES.PRIMARY),
                    fill: "currentColor",
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var $3eb82f4a8c2ab734$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $3eb82f4a8c2ab734$var$maybeNotifyMissing(iconName, prefix) {
    if (!$3eb82f4a8c2ab734$var$PRODUCTION && !$3eb82f4a8c2ab734$var$config.showMissingIcons && iconName) console.error('Icon with name "'.concat(iconName, '" and prefix "').concat(prefix, '" is missing.'));
}
function $3eb82f4a8c2ab734$var$findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === "fa" && $3eb82f4a8c2ab734$var$config.styleDefault !== null) prefix = $3eb82f4a8c2ab734$var$getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: $3eb82f4a8c2ab734$var$callProvided("missingIconAbstract") || {}
        };
        if (givenPrefix === "fa") {
            var shim = $3eb82f4a8c2ab734$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $3eb82f4a8c2ab734$var$styles$1[prefix] && $3eb82f4a8c2ab734$var$styles$1[prefix][iconName]) {
            var icon = $3eb82f4a8c2ab734$var$styles$1[prefix][iconName];
            return resolve($3eb82f4a8c2ab734$var$asFoundIcon(icon));
        }
        $3eb82f4a8c2ab734$var$maybeNotifyMissing(iconName, prefix);
        resolve($3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, $3eb82f4a8c2ab734$var$missingIconResolutionMixin), {}, {
            icon: $3eb82f4a8c2ab734$var$config.showMissingIcons && iconName ? $3eb82f4a8c2ab734$var$callProvided("missingIconAbstract") || {} : {}
        }));
    });
}
var $3eb82f4a8c2ab734$var$noop$1 = function noop() {};
var $3eb82f4a8c2ab734$var$p = $3eb82f4a8c2ab734$var$config.measurePerformance && $3eb82f4a8c2ab734$var$PERFORMANCE && $3eb82f4a8c2ab734$var$PERFORMANCE.mark && $3eb82f4a8c2ab734$var$PERFORMANCE.measure ? $3eb82f4a8c2ab734$var$PERFORMANCE : {
    mark: $3eb82f4a8c2ab734$var$noop$1,
    measure: $3eb82f4a8c2ab734$var$noop$1
};
var $3eb82f4a8c2ab734$var$preamble = 'FA "6.2.0"';
var $3eb82f4a8c2ab734$var$begin = function begin(name) {
    $3eb82f4a8c2ab734$var$p.mark("".concat($3eb82f4a8c2ab734$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $3eb82f4a8c2ab734$var$end(name);
    };
};
var $3eb82f4a8c2ab734$var$end = function end(name) {
    $3eb82f4a8c2ab734$var$p.mark("".concat($3eb82f4a8c2ab734$var$preamble, " ").concat(name, " ends"));
    $3eb82f4a8c2ab734$var$p.measure("".concat($3eb82f4a8c2ab734$var$preamble, " ").concat(name), "".concat($3eb82f4a8c2ab734$var$preamble, " ").concat(name, " begins"), "".concat($3eb82f4a8c2ab734$var$preamble, " ").concat(name, " ends"));
};
var $3eb82f4a8c2ab734$var$perf = {
    begin: $3eb82f4a8c2ab734$var$begin,
    end: $3eb82f4a8c2ab734$var$end
};
var $3eb82f4a8c2ab734$var$noop$2 = function noop() {};
function $3eb82f4a8c2ab734$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($3eb82f4a8c2ab734$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === "string";
}
function $3eb82f4a8c2ab734$var$hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute($3eb82f4a8c2ab734$var$DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute($3eb82f4a8c2ab734$var$DATA_ICON) : null;
    return prefix && icon;
}
function $3eb82f4a8c2ab734$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($3eb82f4a8c2ab734$var$config.replacementClass);
}
function $3eb82f4a8c2ab734$var$getMutator() {
    if ($3eb82f4a8c2ab734$var$config.autoReplaceSvg === true) return $3eb82f4a8c2ab734$var$mutators.replace;
    var mutator = $3eb82f4a8c2ab734$var$mutators[$3eb82f4a8c2ab734$var$config.autoReplaceSvg];
    return mutator || $3eb82f4a8c2ab734$var$mutators.replace;
}
function $3eb82f4a8c2ab734$var$createElementNS(tag) {
    return $3eb82f4a8c2ab734$var$DOCUMENT.createElementNS("http://www.w3.org/2000/svg", tag);
}
function $3eb82f4a8c2ab734$var$createElement(tag) {
    return $3eb82f4a8c2ab734$var$DOCUMENT.createElement(tag);
}
function $3eb82f4a8c2ab734$var$convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === "svg" ? $3eb82f4a8c2ab734$var$createElementNS : $3eb82f4a8c2ab734$var$createElement : _params$ceFn;
    if (typeof abstractObj === "string") return $3eb82f4a8c2ab734$var$DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($3eb82f4a8c2ab734$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $3eb82f4a8c2ab734$var$nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var $3eb82f4a8c2ab734$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(abstract) {
                node.parentNode.insertBefore($3eb82f4a8c2ab734$var$convertSVG(abstract), node);
            });
            if (node.getAttribute($3eb82f4a8c2ab734$var$DATA_FA_I2SVG) === null && $3eb82f4a8c2ab734$var$config.keepOriginalSource) {
                var comment = $3eb82f4a8c2ab734$var$DOCUMENT.createComment($3eb82f4a8c2ab734$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$3eb82f4a8c2ab734$var$classArray(node).indexOf($3eb82f4a8c2ab734$var$config.replacementClass)) return $3eb82f4a8c2ab734$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($3eb82f4a8c2ab734$var$config.cssPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            var splitClasses = abstract[0].attributes.class.split(" ").reduce(function(acc, cls) {
                if (cls === $3eb82f4a8c2ab734$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(" ");
            if (splitClasses.toNode.length === 0) node.removeAttribute("class");
            else node.setAttribute("class", splitClasses.toNode.join(" "));
        }
        var newInnerHTML = abstract.map(function(a) {
            return $3eb82f4a8c2ab734$var$toHtml(a);
        }).join("\n");
        node.setAttribute($3eb82f4a8c2ab734$var$DATA_FA_I2SVG, "");
        node.innerHTML = newInnerHTML;
    }
};
function $3eb82f4a8c2ab734$var$performOperationSync(op) {
    op();
}
function $3eb82f4a8c2ab734$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === "function" ? callback : $3eb82f4a8c2ab734$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $3eb82f4a8c2ab734$var$performOperationSync;
        if ($3eb82f4a8c2ab734$var$config.mutateApproach === $3eb82f4a8c2ab734$var$MUTATION_APPROACH_ASYNC) frame = $3eb82f4a8c2ab734$var$WINDOW.requestAnimationFrame || $3eb82f4a8c2ab734$var$performOperationSync;
        frame(function() {
            var mutator = $3eb82f4a8c2ab734$var$getMutator();
            var mark = $3eb82f4a8c2ab734$var$perf.begin("mutate");
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $3eb82f4a8c2ab734$var$disabled = false;
function $3eb82f4a8c2ab734$var$disableObservation() {
    $3eb82f4a8c2ab734$var$disabled = true;
}
function $3eb82f4a8c2ab734$var$enableObservation() {
    $3eb82f4a8c2ab734$var$disabled = false;
}
var $3eb82f4a8c2ab734$var$mo = null;
function $3eb82f4a8c2ab734$var$observe(options) {
    if (!$3eb82f4a8c2ab734$var$MUTATION_OBSERVER) return;
    if (!$3eb82f4a8c2ab734$var$config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? $3eb82f4a8c2ab734$var$noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? $3eb82f4a8c2ab734$var$noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? $3eb82f4a8c2ab734$var$noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $3eb82f4a8c2ab734$var$DOCUMENT : _options$observeMutat;
    $3eb82f4a8c2ab734$var$mo = new $3eb82f4a8c2ab734$var$MUTATION_OBSERVER(function(objects) {
        if ($3eb82f4a8c2ab734$var$disabled) return;
        var defaultPrefix = $3eb82f4a8c2ab734$var$getDefaultUsablePrefix();
        $3eb82f4a8c2ab734$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !$3eb82f4a8c2ab734$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($3eb82f4a8c2ab734$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && $3eb82f4a8c2ab734$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === "attributes" && $3eb82f4a8c2ab734$var$isWatched(mutationRecord.target) && ~$3eb82f4a8c2ab734$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === "class" && $3eb82f4a8c2ab734$var$hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = $3eb82f4a8c2ab734$var$getCanonicalIcon($3eb82f4a8c2ab734$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute($3eb82f4a8c2ab734$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($3eb82f4a8c2ab734$var$DATA_ICON, iconName);
                } else if ($3eb82f4a8c2ab734$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$3eb82f4a8c2ab734$var$IS_DOM) return;
    $3eb82f4a8c2ab734$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $3eb82f4a8c2ab734$var$disconnect() {
    if (!$3eb82f4a8c2ab734$var$mo) return;
    $3eb82f4a8c2ab734$var$mo.disconnect();
}
function $3eb82f4a8c2ab734$var$styleParser(node) {
    var style = node.getAttribute("style");
    var val = [];
    if (style) val = style.split(";").reduce(function(acc, style) {
        var styles = style.split(":");
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(":").trim();
        return acc;
    }, {});
    return val;
}
function $3eb82f4a8c2ab734$var$classParser(node) {
    var existingPrefix = node.getAttribute("data-prefix");
    var existingIconName = node.getAttribute("data-icon");
    var innerText = node.innerText !== undefined ? node.innerText.trim() : "";
    var val = $3eb82f4a8c2ab734$var$getCanonicalIcon($3eb82f4a8c2ab734$var$classArray(node));
    if (!val.prefix) val.prefix = $3eb82f4a8c2ab734$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $3eb82f4a8c2ab734$var$byLigature(val.prefix, node.innerText) || $3eb82f4a8c2ab734$var$byUnicode(val.prefix, $3eb82f4a8c2ab734$var$toHex(node.innerText));
    if (!val.iconName && $3eb82f4a8c2ab734$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $3eb82f4a8c2ab734$var$attributesParser(node) {
    var extraAttributes = $3eb82f4a8c2ab734$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== "class" && acc.name !== "style") acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute("title");
    var titleId = node.getAttribute("data-fa-title-id");
    if ($3eb82f4a8c2ab734$var$config.autoA11y) {
        if (title) extraAttributes["aria-labelledby"] = "".concat($3eb82f4a8c2ab734$var$config.replacementClass, "-title-").concat(titleId || $3eb82f4a8c2ab734$var$nextUniqueId());
        else {
            extraAttributes["aria-hidden"] = "true";
            extraAttributes["focusable"] = "false";
        }
    }
    return extraAttributes;
}
function $3eb82f4a8c2ab734$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $3eb82f4a8c2ab734$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $3eb82f4a8c2ab734$var$parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = $3eb82f4a8c2ab734$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = $3eb82f4a8c2ab734$var$attributesParser(node);
    var pluginMeta = $3eb82f4a8c2ab734$var$chainHooks("parseNodeAttributes", {}, node);
    var extraStyles = parser.styleParser ? $3eb82f4a8c2ab734$var$styleParser(node) : [];
    return $3eb82f4a8c2ab734$var$_objectSpread2({
        iconName: iconName,
        title: node.getAttribute("title"),
        titleId: node.getAttribute("data-fa-title-id"),
        prefix: prefix,
        transform: $3eb82f4a8c2ab734$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var $3eb82f4a8c2ab734$var$styles$2 = $3eb82f4a8c2ab734$var$namespace.styles;
function $3eb82f4a8c2ab734$var$generateMutation(node) {
    var nodeMeta = $3eb82f4a8c2ab734$var$config.autoReplaceSvg === "nest" ? $3eb82f4a8c2ab734$var$parseMeta(node, {
        styleParser: false
    }) : $3eb82f4a8c2ab734$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($3eb82f4a8c2ab734$var$LAYERS_TEXT_CLASSNAME)) return $3eb82f4a8c2ab734$var$callProvided("generateLayersText", node, nodeMeta);
    else return $3eb82f4a8c2ab734$var$callProvided("generateSvgReplacementMutation", node, nodeMeta);
}
var $3eb82f4a8c2ab734$var$knownPrefixes = new Set();
$3eb82f4a8c2ab734$var$FAMILIES.map(function(family) {
    $3eb82f4a8c2ab734$var$knownPrefixes.add("fa-".concat(family));
});
Object.keys($3eb82f4a8c2ab734$var$PREFIX_TO_STYLE[$3eb82f4a8c2ab734$var$FAMILY_CLASSIC]).map($3eb82f4a8c2ab734$var$knownPrefixes.add.bind($3eb82f4a8c2ab734$var$knownPrefixes));
Object.keys($3eb82f4a8c2ab734$var$PREFIX_TO_STYLE[$3eb82f4a8c2ab734$var$FAMILY_SHARP]).map($3eb82f4a8c2ab734$var$knownPrefixes.add.bind($3eb82f4a8c2ab734$var$knownPrefixes));
$3eb82f4a8c2ab734$var$knownPrefixes = $3eb82f4a8c2ab734$var$_toConsumableArray($3eb82f4a8c2ab734$var$knownPrefixes);
function $3eb82f4a8c2ab734$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$3eb82f4a8c2ab734$var$IS_DOM) return Promise.resolve();
    var htmlClassList = $3eb82f4a8c2ab734$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($3eb82f4a8c2ab734$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($3eb82f4a8c2ab734$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $3eb82f4a8c2ab734$var$config.autoFetchSvg ? $3eb82f4a8c2ab734$var$knownPrefixes : $3eb82f4a8c2ab734$var$FAMILIES.map(function(f) {
        return "fa-".concat(f);
    }).concat(Object.keys($3eb82f4a8c2ab734$var$styles$2));
    if (!prefixes.includes("fa")) prefixes.push("fa");
    var prefixesDomQuery = [
        ".".concat($3eb82f4a8c2ab734$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($3eb82f4a8c2ab734$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat($3eb82f4a8c2ab734$var$DATA_FA_I2SVG, "])");
    })).join(", ");
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = $3eb82f4a8c2ab734$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd("pending");
        hclRemove("complete");
    } else return Promise.resolve();
    var mark = $3eb82f4a8c2ab734$var$perf.begin("onTree");
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $3eb82f4a8c2ab734$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!$3eb82f4a8c2ab734$var$PRODUCTION) {
                if (e.name === "MissingIcon") console.error(e);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            $3eb82f4a8c2ab734$var$perform(resolvedMutations, function() {
                hclAdd("active");
                hclAdd("complete");
                hclRemove("pending");
                if (typeof callback === "function") callback();
                mark();
                resolve();
            });
        }).catch(function(e) {
            mark();
            reject(e);
        });
    });
}
function $3eb82f4a8c2ab734$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $3eb82f4a8c2ab734$var$generateMutation(node).then(function(mutation) {
        if (mutation) $3eb82f4a8c2ab734$var$perform([
            mutation
        ], callback);
    });
}
function $3eb82f4a8c2ab734$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $3eb82f4a8c2ab734$var$findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $3eb82f4a8c2ab734$var$findIconDefinition(mask || {});
        return next(iconDefinition, $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var $3eb82f4a8c2ab734$var$render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $3eb82f4a8c2ab734$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $3eb82f4a8c2ab734$var$domVariants($3eb82f4a8c2ab734$var$_objectSpread2({
        type: "icon"
    }, iconDefinition), function() {
        $3eb82f4a8c2ab734$var$callHooks("beforeDOMElementCreation", {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($3eb82f4a8c2ab734$var$config.autoA11y) {
            if (title) attributes["aria-labelledby"] = "".concat($3eb82f4a8c2ab734$var$config.replacementClass, "-title-").concat(titleId || $3eb82f4a8c2ab734$var$nextUniqueId());
            else {
                attributes["aria-hidden"] = "true";
                attributes["focusable"] = "false";
            }
        }
        return $3eb82f4a8c2ab734$var$makeInlineSvgAbstract({
            icons: {
                main: $3eb82f4a8c2ab734$var$asFoundIcon(icon),
                mask: mask ? $3eb82f4a8c2ab734$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, $3eb82f4a8c2ab734$var$meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $3eb82f4a8c2ab734$var$ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: $3eb82f4a8c2ab734$var$resolveIcons($3eb82f4a8c2ab734$var$render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = $3eb82f4a8c2ab734$var$onTree;
                accumulator.nodeCallback = $3eb82f4a8c2ab734$var$onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $3eb82f4a8c2ab734$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
            return $3eb82f4a8c2ab734$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    $3eb82f4a8c2ab734$var$findIcon(iconName, prefix),
                    mask.iconName ? $3eb82f4a8c2ab734$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = $3eb82f4a8c2ab734$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        $3eb82f4a8c2ab734$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = $3eb82f4a8c2ab734$var$joinStyles(styles);
            if (styleString.length > 0) attributes["style"] = styleString;
            var nextChild;
            if ($3eb82f4a8c2ab734$var$transformIsMeaningful(transform)) nextChild = $3eb82f4a8c2ab734$var$callProvided("generateAbstractTransformGrouping", {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $3eb82f4a8c2ab734$var$Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return $3eb82f4a8c2ab734$var$domVariants({
                    type: "layer"
                }, function() {
                    $3eb82f4a8c2ab734$var$callHooks("beforeDOMElementCreation", {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: "span",
                            attributes: {
                                class: [
                                    "".concat($3eb82f4a8c2ab734$var$config.cssPrefix, "-layers")
                                ].concat($3eb82f4a8c2ab734$var$_toConsumableArray(classes)).join(" ")
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $3eb82f4a8c2ab734$var$LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $3eb82f4a8c2ab734$var$domVariants({
                    type: "counter",
                    content: content
                }, function() {
                    $3eb82f4a8c2ab734$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $3eb82f4a8c2ab734$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($3eb82f4a8c2ab734$var$config.cssPrefix, "-layers-counter")
                            ].concat($3eb82f4a8c2ab734$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var $3eb82f4a8c2ab734$var$LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? $3eb82f4a8c2ab734$var$meaninglessTransform : _params$transform, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $3eb82f4a8c2ab734$var$domVariants({
                    type: "text",
                    content: content
                }, function() {
                    $3eb82f4a8c2ab734$var$callHooks("beforeDOMElementCreation", {
                        content: content,
                        params: params
                    });
                    return $3eb82f4a8c2ab734$var$makeLayersTextAbstract({
                        content: content,
                        transform: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, $3eb82f4a8c2ab734$var$meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($3eb82f4a8c2ab734$var$config.cssPrefix, "-layers-text")
                            ].concat($3eb82f4a8c2ab734$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if ($3eb82f4a8c2ab734$var$IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($3eb82f4a8c2ab734$var$config.autoA11y && !title) extra.attributes["aria-hidden"] = "true";
            return Promise.resolve([
                node,
                $3eb82f4a8c2ab734$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var $3eb82f4a8c2ab734$var$CLEAN_CONTENT_PATTERN = new RegExp('"', "ug");
var $3eb82f4a8c2ab734$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
function $3eb82f4a8c2ab734$var$hexValueFromContent(content) {
    var cleaned = content.replace($3eb82f4a8c2ab734$var$CLEAN_CONTENT_PATTERN, "");
    var codePoint = $3eb82f4a8c2ab734$var$codePointAt(cleaned, 0);
    var isPrependTen = codePoint >= $3eb82f4a8c2ab734$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $3eb82f4a8c2ab734$var$SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $3eb82f4a8c2ab734$var$toHex(cleaned[0]) : $3eb82f4a8c2ab734$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $3eb82f4a8c2ab734$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($3eb82f4a8c2ab734$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $3eb82f4a8c2ab734$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute($3eb82f4a8c2ab734$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $3eb82f4a8c2ab734$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue("font-family").match($3eb82f4a8c2ab734$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue("font-weight");
        var content = styles.getPropertyValue("content");
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== "none" && content !== "") {
            var _content = styles.getPropertyValue("content");
            var family = ~[
                "Sharp"
            ].indexOf(fontFamily[2]) ? $3eb82f4a8c2ab734$var$FAMILY_SHARP : $3eb82f4a8c2ab734$var$FAMILY_CLASSIC;
            var prefix = ~[
                "Solid",
                "Regular",
                "Light",
                "Thin",
                "Duotone",
                "Brands",
                "Kit"
            ].indexOf(fontFamily[2]) ? $3eb82f4a8c2ab734$var$STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : $3eb82f4a8c2ab734$var$FONT_WEIGHT_TO_PREFIX[family][fontWeight];
            var _hexValueFromContent = $3eb82f4a8c2ab734$var$hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
            var isV4 = fontFamily[0].startsWith("FontAwesome");
            var iconName = $3eb82f4a8c2ab734$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = $3eb82f4a8c2ab734$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($3eb82f4a8c2ab734$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($3eb82f4a8c2ab734$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $3eb82f4a8c2ab734$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$3eb82f4a8c2ab734$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $3eb82f4a8c2ab734$var$findIcon(iconName, prefix).then(function(main) {
                    var abstract = $3eb82f4a8c2ab734$var$makeInlineSvgAbstract($3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $3eb82f4a8c2ab734$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $3eb82f4a8c2ab734$var$DOCUMENT.createElement("svg");
                    if (position === "::before") node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map(function(a) {
                        return $3eb82f4a8c2ab734$var$toHtml(a);
                    }).join("\n");
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $3eb82f4a8c2ab734$var$replace(node) {
    return Promise.all([
        $3eb82f4a8c2ab734$var$replaceForPosition(node, "::before"),
        $3eb82f4a8c2ab734$var$replaceForPosition(node, "::after")
    ]);
}
function $3eb82f4a8c2ab734$var$processable(node) {
    return node.parentNode !== document.head && !~$3eb82f4a8c2ab734$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($3eb82f4a8c2ab734$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function $3eb82f4a8c2ab734$var$searchPseudoElements(root) {
    if (!$3eb82f4a8c2ab734$var$IS_DOM) return;
    return new Promise(function(resolve, reject) {
        var operations = $3eb82f4a8c2ab734$var$toArray(root.querySelectorAll("*")).filter($3eb82f4a8c2ab734$var$processable).map($3eb82f4a8c2ab734$var$replace);
        var end = $3eb82f4a8c2ab734$var$perf.begin("searchPseudoElements");
        $3eb82f4a8c2ab734$var$disableObservation();
        Promise.all(operations).then(function() {
            end();
            $3eb82f4a8c2ab734$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $3eb82f4a8c2ab734$var$enableObservation();
            reject();
        });
    });
}
var $3eb82f4a8c2ab734$var$PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = $3eb82f4a8c2ab734$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $3eb82f4a8c2ab734$var$DOCUMENT : _params$node;
            if ($3eb82f4a8c2ab734$var$config.searchPseudoElements) $3eb82f4a8c2ab734$var$searchPseudoElements(node);
        };
    }
};
var $3eb82f4a8c2ab734$var$_unwatched = false;
var $3eb82f4a8c2ab734$var$MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    $3eb82f4a8c2ab734$var$disableObservation();
                    $3eb82f4a8c2ab734$var$_unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                $3eb82f4a8c2ab734$var$observe($3eb82f4a8c2ab734$var$chainHooks("mutationObserverCallbacks", {}));
            },
            noAuto: function noAuto() {
                $3eb82f4a8c2ab734$var$disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if ($3eb82f4a8c2ab734$var$_unwatched) $3eb82f4a8c2ab734$var$enableObservation();
                else $3eb82f4a8c2ab734$var$observe($3eb82f4a8c2ab734$var$chainHooks("mutationObserverCallbacks", {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var $3eb82f4a8c2ab734$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(" ").reduce(function(acc, n) {
        var parts = n.toLowerCase().split("-");
        var first = parts[0];
        var rest = parts.slice(1).join("-");
        if (first && rest === "h") {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === "v") {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case "grow":
                acc.size = acc.size + rest;
                break;
            case "shrink":
                acc.size = acc.size - rest;
                break;
            case "left":
                acc.x = acc.x - rest;
                break;
            case "right":
                acc.x = acc.x + rest;
                break;
            case "up":
                acc.y = acc.y - rest;
                break;
            case "down":
                acc.y = acc.y + rest;
                break;
            case "rotate":
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $3eb82f4a8c2ab734$var$PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return $3eb82f4a8c2ab734$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute("data-fa-transform");
                if (transformString) accumulator.transform = $3eb82f4a8c2ab734$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: "g",
                attributes: $3eb82f4a8c2ab734$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: "g",
                        attributes: $3eb82f4a8c2ab734$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var $3eb82f4a8c2ab734$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function $3eb82f4a8c2ab734$var$fillBlack(abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = "black";
    return abstract;
}
function $3eb82f4a8c2ab734$var$deGroup(abstract) {
    if (abstract.tag === "g") return abstract.children;
    else return [
        abstract
    ];
}
var $3eb82f4a8c2ab734$var$Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute("data-fa-mask");
                var mask = !maskData ? $3eb82f4a8c2ab734$var$emptyCanonicalIcon() : $3eb82f4a8c2ab734$var$getCanonicalIcon(maskData.split(" ").map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = $3eb82f4a8c2ab734$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute("data-fa-mask-id");
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = $3eb82f4a8c2ab734$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: "rect",
                attributes: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, $3eb82f4a8c2ab734$var$ALL_SPACE), {}, {
                    fill: "white"
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($3eb82f4a8c2ab734$var$fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: "g",
                attributes: $3eb82f4a8c2ab734$var$_objectSpread2({}, trans.inner),
                children: [
                    $3eb82f4a8c2ab734$var$fillBlack($3eb82f4a8c2ab734$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: "g",
                attributes: $3eb82f4a8c2ab734$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || $3eb82f4a8c2ab734$var$nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || $3eb82f4a8c2ab734$var$nextUniqueId());
            var maskTag = {
                tag: "mask",
                attributes: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, $3eb82f4a8c2ab734$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: "userSpaceOnUse",
                    maskContentUnits: "userSpaceOnUse"
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: "defs",
                children: [
                    {
                        tag: "clipPath",
                        attributes: {
                            id: clipId
                        },
                        children: $3eb82f4a8c2ab734$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: "rect",
                attributes: $3eb82f4a8c2ab734$var$_objectSpread2({
                    fill: "currentColor",
                    "clip-path": "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, $3eb82f4a8c2ab734$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $3eb82f4a8c2ab734$var$MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if ($3eb82f4a8c2ab734$var$WINDOW.matchMedia) reduceMotion = $3eb82f4a8c2ab734$var$WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: "currentColor"
            };
            var ANIMATION_BASE = {
                attributeType: "XML",
                repeatCount: "indefinite",
                dur: "2s"
            }; // Ring
            gChildren.push({
                tag: "path",
                attributes: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, FILL), {}, {
                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                })
            });
            var OPACITY_ANIMATE = $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: "opacity"
            });
            var dot = {
                tag: "circle",
                attributes: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, FILL), {}, {
                    cx: "256",
                    cy: "364",
                    r: "28"
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: "animate",
                attributes: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: "r",
                    values: "28;14;28;28;14;28;"
                })
            }, {
                tag: "animate",
                attributes: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: "1;0;1;1;0;1;"
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: "path",
                attributes: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, FILL), {}, {
                    opacity: "1",
                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: "animate",
                        attributes: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "1;0;0;0;0;1;"
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: "path",
                attributes: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, FILL), {}, {
                    opacity: "0",
                    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                }),
                children: [
                    {
                        tag: "animate",
                        attributes: $3eb82f4a8c2ab734$var$_objectSpread2($3eb82f4a8c2ab734$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: "0;0;1;1;0;0;"
                        })
                    }
                ]
            });
            return {
                tag: "g",
                attributes: {
                    "class": "missing"
                },
                children: gChildren
            };
        };
    }
};
var $3eb82f4a8c2ab734$var$SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute("data-fa-symbol");
                var symbol = symbolData === null ? false : symbolData === "" ? true : symbolData;
                accumulator["symbol"] = symbol;
                return accumulator;
            }
        };
    }
};
var $3eb82f4a8c2ab734$var$plugins = [
    $3eb82f4a8c2ab734$var$InjectCSS,
    $3eb82f4a8c2ab734$var$ReplaceElements,
    $3eb82f4a8c2ab734$var$Layers,
    $3eb82f4a8c2ab734$var$LayersCounter,
    $3eb82f4a8c2ab734$var$LayersText,
    $3eb82f4a8c2ab734$var$PseudoElements,
    $3eb82f4a8c2ab734$var$MutationObserver$1,
    $3eb82f4a8c2ab734$var$PowerTransforms,
    $3eb82f4a8c2ab734$var$Masks,
    $3eb82f4a8c2ab734$var$MissingIconIndicator,
    $3eb82f4a8c2ab734$var$SvgSymbols
];
$3eb82f4a8c2ab734$var$registerPlugins($3eb82f4a8c2ab734$var$plugins, {
    mixoutsTo: $3eb82f4a8c2ab734$export$644d8ea042df96a6
});
var $3eb82f4a8c2ab734$export$4f8e844b2782642c = $3eb82f4a8c2ab734$export$644d8ea042df96a6.noAuto;
var $3eb82f4a8c2ab734$export$e506a1d27d1eaa20 = $3eb82f4a8c2ab734$export$644d8ea042df96a6.config;
var $3eb82f4a8c2ab734$export$b839f963c7dc0e34 = $3eb82f4a8c2ab734$export$644d8ea042df96a6.library;
var $3eb82f4a8c2ab734$export$df3a06d6289f983e = $3eb82f4a8c2ab734$export$644d8ea042df96a6.dom;
var $3eb82f4a8c2ab734$export$98e6a39c04603d36 = $3eb82f4a8c2ab734$export$644d8ea042df96a6.parse;
var $3eb82f4a8c2ab734$export$221fed4a47f597a5 = $3eb82f4a8c2ab734$export$644d8ea042df96a6.findIconDefinition;
var $3eb82f4a8c2ab734$export$a10125c086a4df16 = $3eb82f4a8c2ab734$export$644d8ea042df96a6.toHtml;
var $3eb82f4a8c2ab734$export$1ca1ec8b29a4ce27 = $3eb82f4a8c2ab734$export$644d8ea042df96a6.icon;
var $3eb82f4a8c2ab734$export$50a222d9023da98b = $3eb82f4a8c2ab734$export$644d8ea042df96a6.layer;
var $3eb82f4a8c2ab734$export$6f093cfa640b7166 = $3eb82f4a8c2ab734$export$644d8ea042df96a6.text;
var $3eb82f4a8c2ab734$export$e575061ef2a070eb = $3eb82f4a8c2ab734$export$644d8ea042df96a6.counter;


parcelRequire("hQJKw");
var $esfUo = parcelRequire("esfUo");
var $am4TS = parcelRequire("am4TS");
function $04a335241c34e8c3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $04a335241c34e8c3$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $04a335241c34e8c3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $04a335241c34e8c3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $04a335241c34e8c3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $04a335241c34e8c3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $04a335241c34e8c3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $04a335241c34e8c3$var$_typeof(obj);
}
function $04a335241c34e8c3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $04a335241c34e8c3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $04a335241c34e8c3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $04a335241c34e8c3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $04a335241c34e8c3$var$_toConsumableArray(arr) {
    return $04a335241c34e8c3$var$_arrayWithoutHoles(arr) || $04a335241c34e8c3$var$_iterableToArray(arr) || $04a335241c34e8c3$var$_unsupportedIterableToArray(arr) || $04a335241c34e8c3$var$_nonIterableSpread();
}
function $04a335241c34e8c3$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $04a335241c34e8c3$var$_arrayLikeToArray(arr);
}
function $04a335241c34e8c3$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $04a335241c34e8c3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $04a335241c34e8c3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $04a335241c34e8c3$var$_arrayLikeToArray(o, minLen);
}
function $04a335241c34e8c3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $04a335241c34e8c3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $04a335241c34e8c3$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $04a335241c34e8c3$var$humps$1 = {
    exports: {}
};
(function(module) {
    (function(global1) {
        var _processKeys = function(convert, obj, options) {
            if (!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) return obj;
            var output, i = 0, l = 0;
            if (_isArray(obj)) {
                output = [];
                for(l = obj.length; i < l; i++)output.push(_processKeys(convert, obj[i], options));
            } else {
                output = {};
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) output[convert(key, options)] = _processKeys(convert, obj[key], options);
            }
            return output;
        };
        // String conversion methods
        var separateWords = function(string, options) {
            options = options || {};
            var separator = options.separator || "_";
            var split = options.split || /(?=[A-Z])/;
            return string.split(split).join(separator);
        };
        var camelize = function(string) {
            if (_isNumerical(string)) return string;
            string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
                return chr ? chr.toUpperCase() : "";
            });
            // Ensure 1st char is always lowercase
            return string.substr(0, 1).toLowerCase() + string.substr(1);
        };
        var pascalize = function(string) {
            var camelized = camelize(string);
            // Ensure 1st char is always uppercase
            return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
        };
        var decamelize = function(string, options) {
            return separateWords(string, options).toLowerCase();
        };
        // Utilities
        // Taken from Underscore.js
        var toString = Object.prototype.toString;
        var _isFunction = function(obj) {
            return typeof obj === "function";
        };
        var _isObject = function(obj) {
            return obj === Object(obj);
        };
        var _isArray = function(obj) {
            return toString.call(obj) == "[object Array]";
        };
        var _isDate = function(obj) {
            return toString.call(obj) == "[object Date]";
        };
        var _isRegExp = function(obj) {
            return toString.call(obj) == "[object RegExp]";
        };
        var _isBoolean = function(obj) {
            return toString.call(obj) == "[object Boolean]";
        };
        // Performant way to determine if obj coerces to a number
        var _isNumerical = function(obj) {
            obj = obj - 0;
            return obj === obj;
        };
        // Sets up function which handles processing keys
        // allowing the convert function to be modified by a callback
        var _processor = function(convert, options) {
            var callback = options && "process" in options ? options.process : options;
            if (typeof callback !== "function") return convert;
            return function(string, options) {
                return callback(string, convert, options);
            };
        };
        var humps = {
            camelize: camelize,
            decamelize: decamelize,
            pascalize: pascalize,
            depascalize: decamelize,
            camelizeKeys: function(object, options) {
                return _processKeys(_processor(camelize, options), object);
            },
            decamelizeKeys: function(object, options) {
                return _processKeys(_processor(decamelize, options), object, options);
            },
            pascalizeKeys: function(object, options) {
                return _processKeys(_processor(pascalize, options), object);
            },
            depascalizeKeys: function() {
                return this.decamelizeKeys.apply(this, arguments);
            }
        };
        if (module.exports) module.exports = humps;
        else global1.humps = humps;
    })($04a335241c34e8c3$var$commonjsGlobal);
})($04a335241c34e8c3$var$humps$1);
var $04a335241c34e8c3$var$humps = $04a335241c34e8c3$var$humps$1.exports;
var $04a335241c34e8c3$var$_excluded = [
    "class",
    "style"
];
/**
 * Converts a CSS style into a plain Javascript object.
 * @param {String} style The style to converts into a plain Javascript object.
 * @returns {Object}
 */ function $04a335241c34e8c3$var$styleToObject(style) {
    return style.split(";").map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(output, pair) {
        var idx = pair.indexOf(":");
        var prop = $04a335241c34e8c3$var$humps.camelize(pair.slice(0, idx));
        var value = pair.slice(idx + 1).trim();
        output[prop] = value;
        return output;
    }, {});
}
/**
 * Converts a CSS class list into a plain Javascript object.
 * @param {Array<String>} classes The class list to convert.
 * @returns {Object}
 */ function $04a335241c34e8c3$var$classToObject(classes) {
    return classes.split(/\s+/).reduce(function(output, className) {
        output[className] = true;
        return output;
    }, {});
}
/**
 * Converts a FontAwesome abstract element of an icon into a Vue VNode.
 * @param {AbstractElement | String} abstractElement The element to convert.
 * @param {Object} props The user-defined props.
 * @param {Object} attrs The user-defined native HTML attributes.
 * @returns {VNode}
 */ function $04a335241c34e8c3$var$convert(abstractElement) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // If the abstract element is a string, we'll just return a string render function
    if (typeof abstractElement === "string") return abstractElement;
     // Converting abstract element children into Vue VNodes
    var children = (abstractElement.children || []).map(function(child) {
        return $04a335241c34e8c3$var$convert(child);
    }); // Converting abstract element attributes into valid Vue format
    var mixins = Object.keys(abstractElement.attributes || {}).reduce(function(mixins, key) {
        var value = abstractElement.attributes[key];
        switch(key){
            case "class":
                mixins.class = $04a335241c34e8c3$var$classToObject(value);
                break;
            case "style":
                mixins.style = $04a335241c34e8c3$var$styleToObject(value);
                break;
            default:
                mixins.attrs[key] = value;
        }
        return mixins;
    }, {
        attrs: {},
        class: {},
        style: {}
    }); // Now, we'll return the VNode
    attrs.class;
    var _attrs$style = attrs.style, aStyle = _attrs$style === void 0 ? {} : _attrs$style, otherAttrs = $04a335241c34e8c3$var$_objectWithoutProperties(attrs, $04a335241c34e8c3$var$_excluded);
    return (0, $esfUo.h)(abstractElement.tag, $04a335241c34e8c3$var$_objectSpread2($04a335241c34e8c3$var$_objectSpread2($04a335241c34e8c3$var$_objectSpread2({}, props), {}, {
        class: mixins.class,
        style: $04a335241c34e8c3$var$_objectSpread2($04a335241c34e8c3$var$_objectSpread2({}, mixins.style), aStyle)
    }, mixins.attrs), otherAttrs), children);
}
var $04a335241c34e8c3$var$PRODUCTION = false;
try {
    $04a335241c34e8c3$var$PRODUCTION = true;
} catch (e) {}
function $04a335241c34e8c3$var$log() {
    if (!$04a335241c34e8c3$var$PRODUCTION && console && typeof console.error === "function") {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function $04a335241c34e8c3$var$objectWithKey(key, value) {
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? $04a335241c34e8c3$var$_defineProperty({}, key, value) : {};
}
function $04a335241c34e8c3$var$classList(props) {
    var _classes;
    var classes = (_classes = {
        "fa-spin": props.spin,
        "fa-pulse": props.pulse,
        "fa-fw": props.fixedWidth,
        "fa-border": props.border,
        "fa-li": props.listItem,
        "fa-inverse": props.inverse,
        "fa-flip": props.flip === true,
        "fa-flip-horizontal": props.flip === "horizontal" || props.flip === "both",
        "fa-flip-vertical": props.flip === "vertical" || props.flip === "both"
    }, $04a335241c34e8c3$var$_defineProperty(_classes, "fa-".concat(props.size), props.size !== null), $04a335241c34e8c3$var$_defineProperty(_classes, "fa-rotate-".concat(props.rotation), props.rotation !== null), $04a335241c34e8c3$var$_defineProperty(_classes, "fa-pull-".concat(props.pull), props.pull !== null), $04a335241c34e8c3$var$_defineProperty(_classes, "fa-swap-opacity", props.swapOpacity), $04a335241c34e8c3$var$_defineProperty(_classes, "fa-bounce", props.bounce), $04a335241c34e8c3$var$_defineProperty(_classes, "fa-shake", props.shake), $04a335241c34e8c3$var$_defineProperty(_classes, "fa-beat", props.beat), $04a335241c34e8c3$var$_defineProperty(_classes, "fa-fade", props.fade), $04a335241c34e8c3$var$_defineProperty(_classes, "fa-beat-fade", props.beatFade), $04a335241c34e8c3$var$_defineProperty(_classes, "fa-flash", props.flash), $04a335241c34e8c3$var$_defineProperty(_classes, "fa-spin-pulse", props.spinPulse), $04a335241c34e8c3$var$_defineProperty(_classes, "fa-spin-reverse", props.spinReverse), _classes);
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
function $04a335241c34e8c3$var$normalizeIconArgs(icon) {
    if (icon && $04a335241c34e8c3$var$_typeof(icon) === "object" && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, $3eb82f4a8c2ab734$export$98e6a39c04603d36).icon) return (0, $3eb82f4a8c2ab734$export$98e6a39c04603d36).icon(icon);
    if (icon === null) return null;
    if ($04a335241c34e8c3$var$_typeof(icon) === "object" && icon.prefix && icon.iconName) return icon;
    if (Array.isArray(icon) && icon.length === 2) return {
        prefix: icon[0],
        iconName: icon[1]
    };
    if (typeof icon === "string") return {
        prefix: "fas",
        iconName: icon
    };
}
var $04a335241c34e8c3$export$2b9260d4a45c8710 = (0, $esfUo.defineComponent)({
    name: "FontAwesomeIcon",
    props: {
        border: {
            type: Boolean,
            default: false
        },
        fixedWidth: {
            type: Boolean,
            default: false
        },
        flip: {
            type: [
                Boolean,
                String
            ],
            default: false,
            validator: function validator(value) {
                return [
                    true,
                    false,
                    "horizontal",
                    "vertical",
                    "both"
                ].indexOf(value) > -1;
            }
        },
        icon: {
            type: [
                Object,
                Array,
                String
            ],
            required: true
        },
        mask: {
            type: [
                Object,
                Array,
                String
            ],
            default: null
        },
        listItem: {
            type: Boolean,
            default: false
        },
        pull: {
            type: String,
            default: null,
            validator: function validator(value) {
                return [
                    "right",
                    "left"
                ].indexOf(value) > -1;
            }
        },
        pulse: {
            type: Boolean,
            default: false
        },
        rotation: {
            type: [
                String,
                Number
            ],
            default: null,
            validator: function validator(value) {
                return [
                    90,
                    180,
                    270
                ].indexOf(Number.parseInt(value, 10)) > -1;
            }
        },
        swapOpacity: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: null,
            validator: function validator(value) {
                return [
                    "2xs",
                    "xs",
                    "sm",
                    "lg",
                    "xl",
                    "2xl",
                    "1x",
                    "2x",
                    "3x",
                    "4x",
                    "5x",
                    "6x",
                    "7x",
                    "8x",
                    "9x",
                    "10x"
                ].indexOf(value) > -1;
            }
        },
        spin: {
            type: Boolean,
            default: false
        },
        transform: {
            type: [
                String,
                Object
            ],
            default: null
        },
        symbol: {
            type: [
                Boolean,
                String
            ],
            default: false
        },
        title: {
            type: String,
            default: null
        },
        inverse: {
            type: Boolean,
            default: false
        },
        bounce: {
            type: Boolean,
            default: false
        },
        shake: {
            type: Boolean,
            default: false
        },
        beat: {
            type: Boolean,
            default: false
        },
        fade: {
            type: Boolean,
            default: false
        },
        beatFade: {
            type: Boolean,
            default: false
        },
        flash: {
            type: Boolean,
            default: false
        },
        spinPulse: {
            type: Boolean,
            default: false
        },
        spinReverse: {
            type: Boolean,
            default: false
        }
    },
    setup: function setup(props, _ref) {
        var attrs = _ref.attrs;
        var icon$1 = (0, $am4TS.computed)(function() {
            return $04a335241c34e8c3$var$normalizeIconArgs(props.icon);
        });
        var classes = (0, $am4TS.computed)(function() {
            return $04a335241c34e8c3$var$objectWithKey("classes", $04a335241c34e8c3$var$classList(props));
        });
        var transform = (0, $am4TS.computed)(function() {
            return $04a335241c34e8c3$var$objectWithKey("transform", typeof props.transform === "string" ? (0, $3eb82f4a8c2ab734$export$98e6a39c04603d36).transform(props.transform) : props.transform);
        });
        var mask = (0, $am4TS.computed)(function() {
            return $04a335241c34e8c3$var$objectWithKey("mask", $04a335241c34e8c3$var$normalizeIconArgs(props.mask));
        });
        var renderedIcon = (0, $am4TS.computed)(function() {
            return (0, $3eb82f4a8c2ab734$export$1ca1ec8b29a4ce27)(icon$1.value, $04a335241c34e8c3$var$_objectSpread2($04a335241c34e8c3$var$_objectSpread2($04a335241c34e8c3$var$_objectSpread2($04a335241c34e8c3$var$_objectSpread2({}, classes.value), transform.value), mask.value), {}, {
                symbol: props.symbol,
                title: props.title
            }));
        });
        (0, $esfUo.watch)(renderedIcon, function(value) {
            if (!value) return $04a335241c34e8c3$var$log("Could not find one or more icon(s)", icon$1.value, mask.value);
        }, {
            immediate: true
        });
        var vnode = (0, $am4TS.computed)(function() {
            return renderedIcon.value ? $04a335241c34e8c3$var$convert(renderedIcon.value.abstract[0], {}, attrs) : null;
        });
        return function() {
            return vnode.value;
        };
    }
});
var $04a335241c34e8c3$export$9ef6be9fed098e07 = (0, $esfUo.defineComponent)({
    name: "FontAwesomeLayers",
    props: {
        fixedWidth: {
            type: Boolean,
            default: false
        }
    },
    setup: function setup(props, _ref) {
        var slots = _ref.slots;
        var familyPrefix = (0, $3eb82f4a8c2ab734$export$e506a1d27d1eaa20).familyPrefix;
        var className = (0, $am4TS.computed)(function() {
            return [
                "".concat(familyPrefix, "-layers")
            ].concat($04a335241c34e8c3$var$_toConsumableArray(props.fixedWidth ? [
                "".concat(familyPrefix, "-fw")
            ] : []));
        });
        return function() {
            return (0, $esfUo.h)("div", {
                class: className.value
            }, slots.default ? slots.default() : []);
        };
    }
});
var $04a335241c34e8c3$export$776b20e54831c68e = (0, $esfUo.defineComponent)({
    name: "FontAwesomeLayersText",
    props: {
        value: {
            type: [
                String,
                Number
            ],
            default: ""
        },
        transform: {
            type: [
                String,
                Object
            ],
            default: null
        },
        counter: {
            type: Boolean,
            default: false
        },
        position: {
            type: String,
            default: null,
            validator: function validator(value) {
                return [
                    "bottom-left",
                    "bottom-right",
                    "top-left",
                    "top-right"
                ].indexOf(value) > -1;
            }
        }
    },
    setup: function setup(props, _ref) {
        var attrs = _ref.attrs;
        var familyPrefix = (0, $3eb82f4a8c2ab734$export$e506a1d27d1eaa20).familyPrefix;
        var classes = (0, $am4TS.computed)(function() {
            return $04a335241c34e8c3$var$objectWithKey("classes", [].concat($04a335241c34e8c3$var$_toConsumableArray(props.counter ? [
                "".concat(familyPrefix, "-layers-counter")
            ] : []), $04a335241c34e8c3$var$_toConsumableArray(props.position ? [
                "".concat(familyPrefix, "-layers-").concat(props.position)
            ] : [])));
        });
        var transform = (0, $am4TS.computed)(function() {
            return $04a335241c34e8c3$var$objectWithKey("transform", typeof props.transform === "string" ? (0, $3eb82f4a8c2ab734$export$98e6a39c04603d36).transform(props.transform) : props.transform);
        });
        var abstractElement = (0, $am4TS.computed)(function() {
            var _text = (0, $3eb82f4a8c2ab734$export$6f093cfa640b7166)(props.value.toString(), $04a335241c34e8c3$var$_objectSpread2($04a335241c34e8c3$var$_objectSpread2({}, transform.value), classes.value)), abstract = _text.abstract;
            if (props.counter) abstract[0].attributes.class = abstract[0].attributes.class.replace("fa-layers-text", "");
            return abstract[0];
        });
        var vnode = (0, $am4TS.computed)(function() {
            return $04a335241c34e8c3$var$convert(abstractElement.value, {}, attrs);
        });
        return function() {
            return vnode.value;
        };
    }
});



var $8063e68b12ef6db0$export$82e9f45cca5ba907 = "fas";
var $8063e68b12ef6db0$export$f22454595d96c106 = {
    prefix: "fas",
    iconName: "0",
    icon: [
        320,
        512,
        [],
        "30",
        "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 96c-53 0-96 43-96 96V320c0 53 43 96 96 96s96-43 96-96V192c0-53-43-96-96-96z"
    ]
};
var $8063e68b12ef6db0$export$8398cb2addc9e182 = {
    prefix: "fas",
    iconName: "1",
    icon: [
        256,
        512,
        [],
        "31",
        "M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V64z"
    ]
};
var $8063e68b12ef6db0$export$ed1a0ff7bd680a1d = {
    prefix: "fas",
    iconName: "2",
    icon: [
        320,
        512,
        [],
        "32",
        "M142.9 96c-21.5 0-42.2 8.5-57.4 23.8L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L40.2 74.5C67.5 47.3 104.4 32 142.9 32C223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L200.2 234.5c15.2-15.2 23.8-35.9 23.8-57.4c0-44.8-36.3-81.1-81.1-81.1z"
    ]
};
var $8063e68b12ef6db0$export$74b7ff79ce1818d6 = {
    prefix: "fas",
    iconName: "3",
    icon: [
        448,
        512,
        [],
        "33",
        "M64 64c0-17.7 14.3-32 32-32H336c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L226.3 208H248c75.1 0 136 60.9 136 136s-60.9 136-136 136H169.4c-42.4 0-81.2-24-100.2-61.9l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5H248c39.8 0 72-32.2 72-72s-32.2-72-72-72H144c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L253.7 96H96C78.3 96 64 81.7 64 64z"
    ]
};
var $8063e68b12ef6db0$export$969b2215780d58fd = {
    prefix: "fas",
    iconName: "4",
    icon: [
        384,
        512,
        [],
        "34",
        "M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368H256v80c0 17.7 14.3 32 32 32s32-14.3 32-32V368h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V304H82.4L189 77.6z"
    ]
};
var $8063e68b12ef6db0$export$3919f68a5b3825a9 = {
    prefix: "fas",
    iconName: "5",
    icon: [
        320,
        512,
        [],
        "35",
        "M32.5 58.3C35.3 43.1 48.5 32 64 32H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H90.7L70.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H100.5c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H32c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z"
    ]
};
var $8063e68b12ef6db0$export$580ac17b31ffb5c3 = {
    prefix: "fas",
    iconName: "6",
    icon: [
        320,
        512,
        [],
        "36",
        "M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4 .1 315.2c0 1.4-.1 2.9-.1 4.3c0 .2 0 .3 0 .5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM64 320c0-53 43-96 96-96s96 43 96 96s-43 96-96 96s-96-43-96-96z"
    ]
};
var $8063e68b12ef6db0$export$ee79cab31be16d23 = {
    prefix: "fas",
    iconName: "7",
    icon: [
        320,
        512,
        [],
        "37",
        "M0 64C0 46.3 14.3 32 32 32H288c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $8063e68b12ef6db0$export$45d84c4b2c560d2f = {
    prefix: "fas",
    iconName: "8",
    icon: [
        320,
        512,
        [],
        "38",
        "M304 160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288H192c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h15.9c0 0 .1 0 .1 0h32c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0H144c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z"
    ]
};
var $8063e68b12ef6db0$export$a120f1e4223629f2 = {
    prefix: "fas",
    iconName: "9",
    icon: [
        320,
        512,
        [],
        "39",
        "M64 192c0 53 43 96 96 96s96-43 96-96s-43-96-96-96s-96 43-96 96zm87.5 159.8C67.1 347.4 0 277.5 0 192C0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9c-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z"
    ]
};
var $8063e68b12ef6db0$export$38320138fc0262d0 = {
    prefix: "fas",
    iconName: "fill-drip",
    icon: [
        576,
        512,
        [],
        "f576",
        "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4L168 90.7l53.1-53.1c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L122.7 136 41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm176 221.3L168 181.3 75.9 273.4c-4.2 4.2-7 9.3-8.4 14.6H386.7l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3L277.7 82.9c-3.1-3.1-8.2-3.1-11.3 0L213.3 136l49.4 49.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"
    ]
};
var $8063e68b12ef6db0$export$917a3d30f6cd766 = {
    prefix: "fas",
    iconName: "arrows-to-circle",
    icon: [
        640,
        512,
        [],
        "e4bd",
        "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM384 256c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM114.7 352H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1v0V96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320v0c0 0 0-.1 0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4c0 0 .1 0 .1 0h0 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H525.3z"
    ]
};
var $8063e68b12ef6db0$export$a39bab13d51abfd0 = {
    prefix: "fas",
    iconName: "circle-chevron-right",
    icon: [
        512,
        512,
        [
            "chevron-circle-right"
        ],
        "f138",
        "M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"
    ]
};
var $8063e68b12ef6db0$export$2a5db4f6eba6f2b = $8063e68b12ef6db0$export$a39bab13d51abfd0;
var $8063e68b12ef6db0$export$c115e8063ee02632 = {
    prefix: "fas",
    iconName: "at",
    icon: [
        512,
        512,
        [
            61946
        ],
        "40",
        "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32v80 32c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-106-86-192-192-192zm64 192c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $8063e68b12ef6db0$export$864bb8d6c21fb792 = {
    prefix: "fas",
    iconName: "trash-can",
    icon: [
        448,
        512,
        [
            61460,
            "trash-alt"
        ],
        "f2ed",
        "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
    ]
};
var $8063e68b12ef6db0$export$88df7ff7eb32f9dc = $8063e68b12ef6db0$export$864bb8d6c21fb792;
var $8063e68b12ef6db0$export$3313bce3924ea7da = {
    prefix: "fas",
    iconName: "text-height",
    icon: [
        576,
        512,
        [],
        "f034",
        "M32 32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64l0 320H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H192l0-320h64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H160 32zm470.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V352H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H512V160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
    ]
};
var $8063e68b12ef6db0$export$e585697127cda27 = {
    prefix: "fas",
    iconName: "user-xmark",
    icon: [
        640,
        512,
        [
            "user-times"
        ],
        "f235",
        "M352 128c0 70.7-57.3 128-128 128s-128-57.3-128-128S153.3 0 224 0s128 57.3 128 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $8063e68b12ef6db0$export$45b996d071667753 = $8063e68b12ef6db0$export$e585697127cda27;
var $8063e68b12ef6db0$export$acb2d72d28cd92d9 = {
    prefix: "fas",
    iconName: "stethoscope",
    icon: [
        576,
        512,
        [
            129658
        ],
        "f0f1",
        "M142.4 21.9c5.6 16.8-3.5 34.9-20.2 40.5L96 71.1V192c0 53 43 96 96 96s96-43 96-96V71.1l-26.1-8.7c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l26.1 8.7C334.4 19.1 352 43.5 352 71.1V192c0 77.2-54.6 141.6-127.3 156.7C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112V265.3c-28.3-12.3-48-40.5-48-73.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V336c0 97.2-78.8 176-176 176c-92.9 0-168.9-71.9-175.5-163.1C87.2 334.2 32 269.6 32 192V71.1c0-27.5 17.6-52 43.8-60.7l26.1-8.7c16.8-5.6 34.9 3.5 40.5 20.2zM480 224c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$6563a67224e7f879 = {
    prefix: "fas",
    iconName: "message",
    icon: [
        512,
        512,
        [
            "comment-alt"
        ],
        "f27a",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"
    ]
};
var $8063e68b12ef6db0$export$6e96904d9af0ec4a = $8063e68b12ef6db0$export$6563a67224e7f879;
var $8063e68b12ef6db0$export$d469b770895f47ac = {
    prefix: "fas",
    iconName: "info",
    icon: [
        192,
        512,
        [],
        "f129",
        "M144 80c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V256H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $8063e68b12ef6db0$export$d56736f5800b3f0d = {
    prefix: "fas",
    iconName: "down-left-and-up-right-to-center",
    icon: [
        512,
        512,
        [
            "compress-alt"
        ],
        "f422",
        "M473 7c-9.4-9.4-24.6-9.4-33.9 0l-87 87L313 55c-6.9-6.9-17.2-8.9-26.2-5.2S272 62.3 272 72V216c0 13.3 10.7 24 24 24H440c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-39-39 87-87c9.4-9.4 9.4-24.6 0-33.9L473 7zM216 272H72c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39L7 439c-9.4 9.4-9.4 24.6 0 33.9l32 32c9.4 9.4 24.6 9.4 33.9 0l87-87 39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V296c0-13.3-10.7-24-24-24z"
    ]
};
var $8063e68b12ef6db0$export$a05650ebe54bede = $8063e68b12ef6db0$export$d56736f5800b3f0d;
var $8063e68b12ef6db0$export$36b5fbeae4855055 = {
    prefix: "fas",
    iconName: "explosion",
    icon: [
        576,
        512,
        [],
        "e4e9",
        "M499.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L404.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-87 87H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H117.8L42.3 363.7c-9.7-6.7-13.1-19.6-7.9-30.3s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.7 9.4-11.3L107.4 236.3c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1 .1L246 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7s22.7 9.4 23.9 21.7l13.5 141.9L499.6 11.3zM64 448v0H512v0h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64zM288 0c13.3 0 24 10.7 24 24V72c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"
    ]
};
var $8063e68b12ef6db0$export$ef565d07efe2b5e9 = {
    prefix: "fas",
    iconName: "file-lines",
    icon: [
        384,
        512,
        [
            128441,
            128462,
            61686,
            "file-alt",
            "file-text"
        ],
        "f15c",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$243b47dca32bf0b8 = $8063e68b12ef6db0$export$ef565d07efe2b5e9;
var $8063e68b12ef6db0$export$f466100bf9bf37a5 = $8063e68b12ef6db0$export$ef565d07efe2b5e9;
var $8063e68b12ef6db0$export$c38cf504b3bc58a2 = {
    prefix: "fas",
    iconName: "wave-square",
    icon: [
        640,
        512,
        [],
        "f83e",
        "M128 64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32V416h96V256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V96H192V256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V64z"
    ]
};
var $8063e68b12ef6db0$export$a95486586631edc7 = {
    prefix: "fas",
    iconName: "ring",
    icon: [
        512,
        512,
        [],
        "f70b",
        "M64 208c0 7.8 4.4 18.7 17.1 30.3C126.5 214.1 188.9 200 256 200s129.5 14.1 174.9 38.3C443.6 226.7 448 215.8 448 208c0-12.3-10.8-32-47.9-50.6C364.9 139.8 314 128 256 128s-108.9 11.8-144.1 29.4C74.8 176 64 195.7 64 208zm192 40c-47 0-89.3 7.6-122.9 19.7C166.3 280.2 208.8 288 256 288s89.7-7.8 122.9-20.3C345.3 255.6 303 248 256 248zM0 208c0-49.6 39.4-85.8 83.3-107.8C129.1 77.3 190.3 64 256 64s126.9 13.3 172.7 36.2c43.9 22 83.3 58.2 83.3 107.8v96c0 49.6-39.4 85.8-83.3 107.8C382.9 434.7 321.7 448 256 448s-126.9-13.3-172.7-36.2C39.4 389.8 0 353.6 0 304V208z"
    ]
};
var $8063e68b12ef6db0$export$fbbc7601eb465ac7 = {
    prefix: "fas",
    iconName: "building-un",
    icon: [
        384,
        512,
        [],
        "e4d9",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$221059e0d5fd8958 = {
    prefix: "fas",
    iconName: "dice-three",
    icon: [
        448,
        512,
        [
            9858
        ],
        "f527",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 160c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm128 64c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm64 128c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$31c6cf6f5d38dc0 = {
    prefix: "fas",
    iconName: "calendar-days",
    icon: [
        448,
        512,
        [
            "calendar-alt"
        ],
        "f073",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"
    ]
};
var $8063e68b12ef6db0$export$cbc139f33cff356 = $8063e68b12ef6db0$export$31c6cf6f5d38dc0;
var $8063e68b12ef6db0$export$8bce49e6ae597af8 = {
    prefix: "fas",
    iconName: "anchor-circle-check",
    icon: [
        640,
        512,
        [],
        "e4aa",
        "M256 96c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm85.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM640 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $8063e68b12ef6db0$export$37584b1a5e175b47 = {
    prefix: "fas",
    iconName: "building-circle-arrow-right",
    icon: [
        640,
        512,
        [],
        "e4d1",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V232.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM640 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM492.7 300.7c-6.2 6.2-6.2 16.4 0 22.6L521.4 352H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"
    ]
};
var $8063e68b12ef6db0$export$cc519c9529a46c5c = {
    prefix: "fas",
    iconName: "volleyball",
    icon: [
        512,
        512,
        [
            127952,
            "volleyball-ball"
        ],
        "f45f",
        "M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.5-204.2-103.2-272.4C434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4zm-3.9 34.7c-5.8 32-17.6 62-34.2 88.7c-97.5 48.5-217.7 42.6-311.9-24.5c23.7-36.2 55.4-67.7 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5c-2.5-90.9-41.1-172.7-101.9-231.7C196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9C2.5 297.4 0 277 0 256C0 157.2 56 71.5 138 28.8zm69.6 90.5c19.5 38.6 31 81.9 32.3 127.7C162.5 294.6 110.9 368.9 90.2 451C66 430.4 45.6 405.4 30.4 377.2c6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c-46 44-108.3 71-177 71z"
    ]
};
var $8063e68b12ef6db0$export$a15e6fc8e68a76b0 = $8063e68b12ef6db0$export$cc519c9529a46c5c;
var $8063e68b12ef6db0$export$159982ce2622211e = {
    prefix: "fas",
    iconName: "arrows-up-to-line",
    icon: [
        640,
        512,
        [],
        "e4c2",
        "M64 96l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32C46.3 32 32 46.3 32 64s14.3 32 32 32zM41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 237.3 128 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96zm320 45.3c12.5 12.5 32.8 12.5 45.3 0L448 237.3 448 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3z"
    ]
};
var $8063e68b12ef6db0$export$58e2577a373e7d4 = {
    prefix: "fas",
    iconName: "sort-down",
    icon: [
        320,
        512,
        [
            "sort-desc"
        ],
        "f0dd",
        "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"
    ]
};
var $8063e68b12ef6db0$export$e24f016f5f78af6a = $8063e68b12ef6db0$export$58e2577a373e7d4;
var $8063e68b12ef6db0$export$d0163707993a8110 = {
    prefix: "fas",
    iconName: "circle-minus",
    icon: [
        512,
        512,
        [
            "minus-circle"
        ],
        "f056",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $8063e68b12ef6db0$export$f3979b49bf57313c = $8063e68b12ef6db0$export$d0163707993a8110;
var $8063e68b12ef6db0$export$41821b9a6fd703de = {
    prefix: "fas",
    iconName: "door-open",
    icon: [
        576,
        512,
        [],
        "f52b",
        "M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 288h32V480 32zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128h96V480v32h32 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V128c0-35.3-28.7-64-64-64H352v64z"
    ]
};
var $8063e68b12ef6db0$export$122a80ae0f87f726 = {
    prefix: "fas",
    iconName: "right-from-bracket",
    icon: [
        512,
        512,
        [
            "sign-out-alt"
        ],
        "f2f5",
        "M160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96C43 32 0 75 0 128V384c0 53 43 96 96 96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32h64zM504.5 273.4c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22v72H192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32H320v72c0 9.6 5.7 18.2 14.5 22s19 2 26-4.6l144-136z"
    ]
};
var $8063e68b12ef6db0$export$c844d6923b7096c2 = $8063e68b12ef6db0$export$122a80ae0f87f726;
var $8063e68b12ef6db0$export$b5bb295e8ad4ab31 = {
    prefix: "fas",
    iconName: "atom",
    icon: [
        448,
        512,
        [
            9883
        ],
        "f5d2",
        "M258.9 412.3c-16.7 33.8-31 35.7-34.9 35.7s-18.1-1.9-34.9-35.7c11.4-3.9 23.1-8.4 34.9-13.5c11.8 5.1 23.4 9.7 34.9 13.5zM252.8 312c-9.7 5.8-19.3 11.2-28.8 16c-9.4-4.8-19-10.2-28.8-16c-12.1-7.3-23.6-14.8-34.2-22.4c-.7-10.8-1-22-1-33.6s.4-22.7 1-33.6c10.6-7.6 22.1-15.1 34.2-22.4c9.7-5.8 19.3-11.2 28.8-16c9.4 4.8 19 10.2 28.8 16c12.1 7.3 23.6 14.8 34.2 22.4c.7 10.8 1 22 1 33.6s-.4 22.7-1 33.6c-10.6 7.6-22.1 15.1-34.2 22.4zm184.8 72c20.7-37.1 9.4-82.8-23.6-128c33-45.2 44.3-90.9 23.6-128c-20.2-36.3-62.5-49.3-115.2-43.2C300.4 32.7 266.8 0 224 0s-76.4 32.7-98.4 84.8c-52.7-6.1-95 6.8-115.2 43.2C-10.3 165.1 1 210.8 34 256C1 301.2-10.3 346.9 10.4 384c20.2 36.3 62.5 49.3 115.2 43.2c22 52.1 55.7 84.8 98.4 84.8s76.4-32.7 98.4-84.8c52.7 6.1 95-6.8 115.2-43.2zm-67.8-79.2c18.9 30.2 14.2 44 11.9 48.1c-1.6 2.9-8.4 13-40.2 11.7c2.8-13.1 5-26.9 6.7-41.2c7.6-6.1 14.8-12.3 21.6-18.6zm11.9-145.7c2.3 4.2 7 17.9-11.9 48.1c-6.8-6.3-14-12.5-21.6-18.6c-1.7-14.3-3.9-28-6.7-41.2c31.8-1.4 38.6 8.7 40.2 11.7zM224 64c3.9 0 18.1 1.9 34.9 35.7c-11.4 3.9-23.1 8.4-34.9 13.5c-11.8-5.1-23.4-9.7-34.9-13.5C205.9 65.9 220.1 64 224 64zM106.5 147.5c-2.8 13.1-5 26.9-6.7 41.2c-7.6 6.1-14.8 12.3-21.6 18.6C59.4 177 64 163.3 66.3 159.1c1.6-2.9 8.4-13 40.2-11.7zM66.3 352.9c-2.3-4.2-7-17.9 11.9-48.1c6.8 6.3 14 12.5 21.6 18.6c1.7 14.2 3.9 28 6.7 41.2c-31.8 1.4-38.6-8.7-40.2-11.7zM224 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$64f1c53b21f310ac = {
    prefix: "fas",
    iconName: "soap",
    icon: [
        512,
        512,
        [
            129532
        ],
        "e06e",
        "M208 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM320 256c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zM416 32c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm0 160c0 27.6-11.7 52.5-30.4 70.1C422.1 275.7 448 310.8 448 352c0 53-43 96-96 96H160c-53 0-96-43-96-96s43-96 96-96h88.4c-15.2-17-24.4-39.4-24.4-64H96c-53 0-96 43-96 96V416c0 53 43 96 96 96H416c53 0 96-43 96-96V288c0-53-43-96-96-96zM160 288c-35.3 0-64 28.7-64 64s28.7 64 64 64H352c35.3 0 64-28.7 64-64s-28.7-64-64-64H320 160z"
    ]
};
var $8063e68b12ef6db0$export$7fe2894454d8eb8a = {
    prefix: "fas",
    iconName: "icons",
    icon: [
        576,
        512,
        [
            "heart-music-camera-bolt"
        ],
        "f86d",
        "M532.3 7.3C539.7 13.3 544 22.4 544 32V176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V71L384 90.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM106.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2h61.7c10.7 0 20.7 5.3 26.6 14.2L245.3 304H272c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48h26.7zM224 408c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM510.7 278.3L472.3 368H528c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9 .9s-8.2-12.4-5.3-19.2L423.7 400H368c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112c5.6-4.9 13.9-5.3 19.9-.9s8.2 12.4 5.3 19.2zm-339-59.2c-6.5 6.5-17 6.5-23 0L51.9 119.2c-28-29-26.5-76.9 5-103.9c27-23.5 68.4-19 93.4 6.5l10 10.5 9.5-10.5c25-25.5 65.9-30 93.9-6.5c31 27 32.5 74.9 4.5 103.9l-96.4 99.9z"
    ]
};
var $8063e68b12ef6db0$export$ec74c13cedb0791d = $8063e68b12ef6db0$export$7fe2894454d8eb8a;
var $8063e68b12ef6db0$export$4be1b324ac8a71ba = {
    prefix: "fas",
    iconName: "microphone-lines-slash",
    icon: [
        640,
        512,
        [
            "microphone-alt-slash"
        ],
        "f539",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24 16c0 21.2-5.1 41.1-14.2 58.7L416 300.8V256H358.9l-34.5-27c2.9-3.1 7-5 11.6-5h80V192H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zm362.5 407l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2z"
    ]
};
var $8063e68b12ef6db0$export$d2a53a388f30780 = $8063e68b12ef6db0$export$4be1b324ac8a71ba;
var $8063e68b12ef6db0$export$ea908d3d80c57d08 = {
    prefix: "fas",
    iconName: "bridge-circle-check",
    icon: [
        640,
        512,
        [],
        "e4c9",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM640 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $8063e68b12ef6db0$export$f1b881c73328720c = {
    prefix: "fas",
    iconName: "pump-medical",
    icon: [
        448,
        512,
        [],
        "e06a",
        "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM216 280v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$614dc068d88655af = {
    prefix: "fas",
    iconName: "fingerprint",
    icon: [
        512,
        512,
        [],
        "f577",
        "M48 256C48 141.1 141.1 48 256 48c69.3 0 130.6 33.8 168.5 86c7.8 10.7 22.8 13.1 33.5 5.3s13.1-22.8 5.3-33.5C416.8 41.7 341.3 0 256 0C114.6 0 0 114.6 0 256v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c0-18.1-1.9-35.8-5.5-52.9zM222.1 128.2c10.8-2.9 22.1-4.4 33.9-4.4c73 0 132.2 59.2 132.2 132.2c0 31.1-1.9 62.4-3.9 86c-1 11.8-2 21.6-2.7 28.4c-.4 3.4-.7 6.1-.9 7.9l-.2 2-.1 .5 0 .1 0 0 0 0c-1.6 13.2 7.7 25.1 20.8 26.8s25.1-7.7 26.8-20.8l-23.8-3c23.8 3 23.8 3 23.8 3l0 0 0 0 0 0 0-.2 .1-.6 .3-2.2c.2-1.9 .5-4.8 .9-8.3c.8-7.2 1.8-17.4 2.8-29.6c2-24.4 4.1-57.1 4.1-90c0-99.5-80.7-180.2-180.2-180.2c-15.9 0-31.4 2.1-46.2 6c-12.8 3.4-20.5 16.5-17.1 29.3s16.5 20.5 29.3 17.1zm-74.5 52.1c7.6-10.9 5-25.8-5.9-33.4s-25.8-5-33.4 5.9C87.9 182 75.8 217.6 75.8 256c0 30.1-3.8 58.6-7.6 79.7c-1.9 10.5-3.8 19.1-5.2 24.9c-.7 2.9-1.3 5.2-1.7 6.7c-.2 .7-.3 1.3-.4 1.6l-.1 .4 0 .1 0 0c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5L83.8 376c23.1 6.6 23.1 6.6 23.1 6.6l0 0 0 0 0-.1 0-.2 .2-.6c.1-.5 .3-1.2 .6-2.1c.5-1.8 1.2-4.4 1.9-7.7c1.6-6.6 3.7-16.1 5.8-27.6c4.2-22.9 8.4-54.4 8.4-88.3c0-28.2 8.8-54.3 23.8-75.7zM256 200c30.9 0 56 25.1 56 56c0 47.1-2.7 86.3-5.5 113.6c-1.4 13.7-2.7 24.3-3.7 31.6c-.5 3.6-.9 6.3-1.2 8.1c-.1 .9-.2 1.6-.3 2l-.1 .5 0 .1 0 0 0 0 0 0c-2.3 13.1 6.5 25.5 19.5 27.8s25.5-6.4 27.8-19.5L324.8 416c23.6 4.1 23.6 4.1 23.6 4.1l0 0 0 0 0-.1 0-.2 .1-.7c.1-.6 .2-1.4 .4-2.4c.3-2.1 .8-5.1 1.3-9c1.1-7.8 2.5-19.1 4-33.4c2.9-28.7 5.7-69.5 5.7-118.4c0-57.4-46.6-104-104-104s-104 46.6-104 104c0 46.7-3.9 83.4-7.7 108.4c-1.9 12.5-3.8 21.9-5.2 28.2c-.7 3.1-1.3 5.5-1.6 6.9c-.2 .7-.3 1.3-.4 1.6l-.1 .3c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5L160 408c23.1 6.6 23.1 6.6 23.1 6.6l0 0 0 0 0-.1 .1-.2 .2-.7c.1-.5 .3-1.3 .6-2.3c.5-2 1.2-4.8 2-8.4c1.6-7.2 3.7-17.8 5.8-31.3c3-19.2 5.9-44.6 7.3-75.3c.6-12.6 .9-26 .9-40.3c0-30.9 25.1-56 56-56zm24 56c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 45.4-2.6 83.4-6.3 114.5L202 478.3l0 0c-5.3 12.1 .1 26.2 12.2 31.6c12.1 5.4 26.3-.1 31.7-12.2L224 488c21.9 9.7 21.9 9.7 21.9 9.7l0 0 0 0 0-.1 .1-.3 .4-.9c.3-.8 .7-1.8 1.2-3.1c1-2.7 2.4-6.5 4-11.5c3.3-10.1 7.5-24.9 11.7-44.7C271.8 397.3 280 337.6 280 256zM225.7 370.5s0 0 0 0L256 232 225.7 370.5zm0 0c-2.7 22.5-5.9 41.3-9.2 56.6c-3.8 18.2-7.6 31.3-10.3 39.8c-1.4 4.2-2.5 7.3-3.2 9.2c-.4 .9-.6 1.6-.8 2l-.1 .4 23.6-107.9z"
    ]
};
var $8063e68b12ef6db0$export$f7bc8714c970afa4 = {
    prefix: "fas",
    iconName: "hand-point-right",
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0 0-64 208 0zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32h64zm64-64c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h48c17.7 0 32 14.3 32 32zM288 384c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64zm-88-96l.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 13.2 4 25.4 10.8 35.6C177.9 364.3 160 388.1 160 416c0 11.7 3.1 22.6 8.6 32H160C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64v88c0 22.1-17.9 40-40 40s-40-17.9-40-40V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v56c0 39.8 32.2 72 72 72z"
    ]
};
var $8063e68b12ef6db0$export$234a18b2b4d530a3 = {
    prefix: "fas",
    iconName: "magnifying-glass-location",
    icon: [
        512,
        512,
        [
            "search-location"
        ],
        "f689",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-48 0c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$c33aba6c251a898a = $8063e68b12ef6db0$export$234a18b2b4d530a3;
var $8063e68b12ef6db0$export$908d699be6717adc = {
    prefix: "fas",
    iconName: "forward-step",
    icon: [
        320,
        512,
        [
            "step-forward"
        ],
        "f051",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4l192 160L256 241V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V271l-11.5 9.6-192 160z"
    ]
};
var $8063e68b12ef6db0$export$b303329afce5de18 = $8063e68b12ef6db0$export$908d699be6717adc;
var $8063e68b12ef6db0$export$e3c56ed54f074063 = {
    prefix: "fas",
    iconName: "face-smile-beam",
    icon: [
        512,
        512,
        [
            128522,
            "smile-beam"
        ],
        "f5b8",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm53.5-96.7l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $8063e68b12ef6db0$export$54ada6dc9690e0ca = $8063e68b12ef6db0$export$e3c56ed54f074063;
var $8063e68b12ef6db0$export$92fad97e19a9fea = {
    prefix: "fas",
    iconName: "flag-checkered",
    icon: [
        512,
        512,
        [
            127937
        ],
        "f11e",
        "M32 0C46.3 0 58.4 9.4 62.5 22.3l.1 0-.1 .1 .1 .3 0-.4C89.8 11.5 128.1 0 168 0c38.8 0 74.6 9.1 105.7 17C306 25.2 332.9 32 360 32c26.8 0 52.9-6.8 73-14.1c9.9-3.6 17.9-7.2 23.4-9.8c2.7-1.3 4.8-2.4 6.2-3.1c.7-.4 1.1-.6 1.4-.8l.2-.1c9.9-5.6 22.1-5.6 31.9 .2S512 20.6 512 32V320c0 12.1-6.8 23.2-17.7 28.6L480 320c14.3 28.6 14.3 28.6 14.3 28.6l0 0 0 0-.1 0-.2 .1-.7 .4c-.6 .3-1.5 .7-2.5 1.2c-2.2 1-5.2 2.4-9 4c-7.7 3.3-18.5 7.6-31.5 11.9C424.5 374.9 388.8 384 352 384c-37 0-65.2-9.4-89-17.3l-1-.3c-24-8-43.7-14.4-70-14.4c-27.9 0-64.7 7.2-96.2 15c-12.1 3-23 6-31.8 8.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352 72 32C0 14.3 14.3 0 32 0zM64 158.4c17.5-4.9 40.4-10.7 64-15.2V68.8c-15 3.3-29.3 8.1-42 13c-8.5 3.4-16 6.7-22 9.6v67zm0 80v70.8c5.1-1.4 10.6-2.8 16.2-4.2c14.3-3.6 30.8-7.3 47.8-10.4V223.1c21.9-4.2 44.4-7.1 64-7.1c5.6 0 10.9 .2 16 .7v71.9c29.5 2.2 53 10 73.3 16.8l.9 .3c2 .7 3.9 1.3 5.8 1.9v-69-1.4c19 5.9 39.1 10.8 64 10.8c5.3 0 10.7-.2 16-.6v71.9c22-2 43.9-7.6 61.9-13.6c6.8-2.3 12.9-4.6 18.1-6.6V229.2c-20.9 7.5-49.9 15.8-80 18.1v-80c30.1-2.3 59.1-10.6 80-18.1V80.5c-21.6 7.3-49.5 14.3-80 15.4v71.5c-5.3 .4-10.7 .6-16 .6c-24.9 0-45-4.9-64-10.8V86.5c-9.3-2.1-18.3-4.4-27-6.7l-3.1-.8c-17.4-4.4-33.8-8.5-49.9-11.3v69c-5.1-.4-10.4-.7-16-.7c-19.6 0-42.1 3-64 7.1v80c-23.6 4.5-46.5 10.3-64 15.2zM208 136.7v80c24.4 2.1 44.3 8.7 64.2 15.3l0 0c5.2 1.7 10.5 3.5 15.8 5.2v-80c-5.3-1.7-10.6-3.4-15.8-5.2l0 0c-19.9-6.6-39.8-13.2-64.2-15.3z"
    ]
};
var $8063e68b12ef6db0$export$e15f65e77f717c29 = {
    prefix: "fas",
    iconName: "football",
    icon: [
        512,
        512,
        [
            127944,
            "football-ball"
        ],
        "f44e",
        "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6c-18.3 29.8-30.9 62.3-39.2 95.4L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4c-2.7-12.9-13-22.9-26.1-25.1c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4c2.7 12.9 13 22.9 26.1 25.1c58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
var $8063e68b12ef6db0$export$e8fd664711e31704 = $8063e68b12ef6db0$export$e15f65e77f717c29;
var $8063e68b12ef6db0$export$f629fdee00932a01 = {
    prefix: "fas",
    iconName: "school-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e56c",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4l-139 92.7L37.6 126C15.6 130.9 0 150.3 0 172.8V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V172.8c0-22.5-15.6-42-37.6-46.9L476.8 98.1 337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$afa58590dfb6fca2 = {
    prefix: "fas",
    iconName: "crop",
    icon: [
        512,
        512,
        [],
        "f125",
        "M448 109.3l54.6-54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L402.7 64 160 64v64l178.7 0L128 338.7V32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H173.3L384 173.3 384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-274.7z"
    ]
};
var $8063e68b12ef6db0$export$52783a541b1bb03 = {
    prefix: "fas",
    iconName: "angles-down",
    icon: [
        448,
        512,
        [
            "angle-double-down"
        ],
        "f103",
        "M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 361.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
    ]
};
var $8063e68b12ef6db0$export$fd504117f273ca92 = $8063e68b12ef6db0$export$52783a541b1bb03;
var $8063e68b12ef6db0$export$a28757068b9a3a9a = {
    prefix: "fas",
    iconName: "users-rectangle",
    icon: [
        640,
        512,
        [],
        "e594",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H544c53 0 96-43 96-96V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zm159.8 80c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3C119.9 256 96 279.9 96 309.3zM461.2 336h56.1c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6zM372 289c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-8.6-24.3-29.9-42.6-55.9-47zM512 176c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM320 256c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64z"
    ]
};
var $8063e68b12ef6db0$export$b96e695bdcf3f3f5 = {
    prefix: "fas",
    iconName: "people-roof",
    icon: [
        640,
        512,
        [],
        "e537",
        "M335.5 4l288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4c9.7-5.4 21.4-5.4 31.1 0zM320 240c-22.1 0-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40zM144 336c-22.1 0-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40zm392-40c0 22.1-17.9 40-40 40s-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40zM226.9 491.4L200 441.5V480c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V441.5L61.1 491.4c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8L552 441.5V480c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V441.5l-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8L376 345.5V400c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V345.5l-26.9 49.9c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8z"
    ]
};
var $8063e68b12ef6db0$export$d12c2d6def120efe = {
    prefix: "fas",
    iconName: "people-line",
    icon: [
        640,
        512,
        [],
        "e534",
        "M360 72c0-22.1-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40s40-17.9 40-40zM144 208c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM496 208c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40zM200 313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 217.5V272c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V217.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5z"
    ]
};
var $8063e68b12ef6db0$export$b957c27bc5330472 = {
    prefix: "fas",
    iconName: "beer-mug-empty",
    icon: [
        512,
        512,
        [
            "beer"
        ],
        "f0fc",
        "M32 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V96h51.2c42.4 0 76.8 34.4 76.8 76.8V274.9c0 30.4-17.9 57.9-45.6 70.2L384 381.7V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM384 311.6l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7V172.8c0-7.1-5.7-12.8-12.8-12.8H384V311.6zM160 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"
    ]
};
var $8063e68b12ef6db0$export$f74725691538983b = $8063e68b12ef6db0$export$b957c27bc5330472;
var $8063e68b12ef6db0$export$1852c99deca7bee8 = {
    prefix: "fas",
    iconName: "diagram-predecessor",
    icon: [
        512,
        512,
        [],
        "e477",
        "M448 416l0-64L64 352l0 64 384 0zm0 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l144 0 16 0 144 0c44.2 0 80 35.8 80 80l0 16 38.1 0c21.4 0 32.1 25.9 17 41L433 239c-9.4 9.4-24.6 9.4-33.9 0L329 169c-15.1-15.1-4.4-41 17-41l38.1 0 0-16c0-8.8-7.2-16-16-16l-80 0 0 64z"
    ]
};
var $8063e68b12ef6db0$export$92c58defe6e4c5a7 = {
    prefix: "fas",
    iconName: "arrow-up-long",
    icon: [
        384,
        512,
        [
            "long-arrow-up"
        ],
        "f176",
        "M214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"
    ]
};
var $8063e68b12ef6db0$export$ede1d50ec4b01670 = $8063e68b12ef6db0$export$92c58defe6e4c5a7;
var $8063e68b12ef6db0$export$9ebfff5c90672059 = {
    prefix: "fas",
    iconName: "fire-flame-simple",
    icon: [
        384,
        512,
        [
            "burn"
        ],
        "f46a",
        "M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zm-90.8 49.5c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"
    ]
};
var $8063e68b12ef6db0$export$80ed4535efc60402 = $8063e68b12ef6db0$export$9ebfff5c90672059;
var $8063e68b12ef6db0$export$e6619e43cb090a16 = {
    prefix: "fas",
    iconName: "person",
    icon: [
        320,
        512,
        [
            129485,
            "male"
        ],
        "f183",
        "M208 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM152 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152z"
    ]
};
var $8063e68b12ef6db0$export$2e21f9dba1630651 = $8063e68b12ef6db0$export$e6619e43cb090a16;
var $8063e68b12ef6db0$export$c2dee3bd177275a2 = {
    prefix: "fas",
    iconName: "laptop",
    icon: [
        640,
        512,
        [
            128187
        ],
        "f109",
        "M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z"
    ]
};
var $8063e68b12ef6db0$export$82cea4f586f6ec9 = {
    prefix: "fas",
    iconName: "file-csv",
    icon: [
        384,
        512,
        [],
        "f6dd",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 224H96c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H80c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8H96c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H80c-22.1 0-40-17.9-40-40V264c0-22.1 17.9-40 40-40zm72 46.4c0-25.6 20.8-46.4 46.4-46.4H216c8.8 0 16 7.2 16 16s-7.2 16-16 16H198.4c-7.9 0-14.4 6.4-14.4 14.4c0 5.2 2.8 9.9 7.2 12.5l25.4 14.5c14.4 8.3 23.4 23.6 23.4 40.3c0 25.6-20.8 46.4-46.4 46.4H168c-8.8 0-16-7.2-16-16s7.2-16 16-16h25.6c7.9 0 14.4-6.4 14.4-14.4c0-5.2-2.8-9.9-7.2-12.5l-25.4-14.5C160.9 302.4 152 287 152 270.4zM280 240v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V240c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$232452c59d77c56e = {
    prefix: "fas",
    iconName: "menorah",
    icon: [
        640,
        512,
        [],
        "f676",
        "M20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64V62.8c0-4.5 .9-8.9 2.7-13.1L20.8 7.4zm96 0C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L116.8 7.4zm77.8 42.4L212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L308.8 7.4zm77.8 42.4L404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L500.8 7.4zm77.8 42.4L596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM32 128c17.7 0 32 14.3 32 32V288c0 17.7 14.3 32 32 32H288V160c0-17.7 14.3-32 32-32s32 14.3 32 32V320H544c17.7 0 32-14.3 32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 53-43 96-96 96H352v64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V384H96c-53 0-96-43-96-96V160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H96V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H192V256 160c0-17.7 14.3-32 32-32zm192 0c17.7 0 32 14.3 32 32v96 32H384V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H480V256 160c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$e1d5ceed99060d76 = {
    prefix: "fas",
    iconName: "truck-plane",
    icon: [
        640,
        512,
        [],
        "e58f",
        "M200 0c-30.6 0-56 54.7-56 86.1V192.5L7.8 274.3C2.9 277.2 0 282.4 0 288v64c0 5.1 2.4 9.8 6.4 12.8s9.3 3.9 14.1 2.5l123.4-37v81.2l-50 40c-3.8 3-6 7.6-6 12.5v32c0 5.1 2.5 10 6.6 13s9.5 3.8 14.4 2.2L200 480.9 290.4 511c-1.6-4.7-2.4-9.8-2.4-15V463.4c-18.2-10.5-30.7-29.7-31.9-51.8l-.1-.1V408 325.5 184l0-1.1 0 0V86.1C256 54.7 231.5 0 200 0zm88 176V400c0 20.9 13.4 38.7 32 45.3V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V448H544v40c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V445.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zm79.8 78.7c3.3-8.7 11.2-14.7 20.5-14.7H539.7c9.2 0 17.2 6 20.5 14.7L576 304H352l15.8-49.3zM568 400c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zM384 376c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$fe2d5012d9982673 = {
    prefix: "fas",
    iconName: "record-vinyl",
    icon: [
        512,
        512,
        [],
        "f8d9",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM256 352c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96zm0 32c70.7 0 128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128zm0-96c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$1d1fbac384a76a12 = {
    prefix: "fas",
    iconName: "face-grin-stars",
    icon: [
        512,
        512,
        [
            129321,
            "grin-stars"
        ],
        "f587",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM403 336.5c5.1-11.8-6.9-22.4-19.2-18.7C345.3 329.4 301.9 336 256 336s-89.3-6.6-127.8-18.2c-12.3-3.7-24.3 7-19.2 18.7c24.5 56.9 81.1 96.7 147 96.7s122.5-39.8 147-96.7zM160 120c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L160 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L226.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6zm192 0c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L352 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L418.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6z"
    ]
};
var $8063e68b12ef6db0$export$64347a5c8c402ef4 = $8063e68b12ef6db0$export$1d1fbac384a76a12;
var $8063e68b12ef6db0$export$e74974fac77c468e = {
    prefix: "fas",
    iconName: "bong",
    icon: [
        512,
        512,
        [],
        "f55c",
        "M192 208.5c0 29.1-15.6 53.9-37.2 67.8c-17.2 11.1-31.5 26.1-41.7 43.7H334.9c-10.2-17.6-24.5-32.6-41.7-43.7c-21.6-13.9-37.2-38.7-37.2-67.8V64H192V208.5zM320 64V208.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L398.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C406 314.1 416 347.9 416 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5H108.1c-17.3 0-34.2-7.1-43.8-21.5C43.9 460.1 32 423.4 32 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h16H304h16c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$3c8d5c62d76c33b8 = {
    prefix: "fas",
    iconName: "spaghetti-monster-flying",
    icon: [
        640,
        512,
        [
            "pastafarianism"
        ],
        "f67b",
        "M208 64c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3C390 95.1 384 80.2 384 64c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4c7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4C527.3 262.3 532.7 264 536 264c2.5 0 4.3-.6 7.1-3.3c3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7c9.7-9.3 22.9-16.7 40.4-16.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.5 0-4.3 .6-7.1 3.3c-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7c-9.7 9.3-22.9 16.7-40.4 16.7c-18.5 0-32.9-8.5-44.3-18.6c-3.1 4-6.6 8.3-10.5 12.7c1.4 4.3 2.8 8.5 4 12.5c.9 3 1.8 5.8 2.6 8.6c3 9.8 5.5 18.2 8.6 25.9c3.9 9.8 7.4 15.4 10.8 18.5c2.6 2.4 5.9 4.3 12.8 4.3c8.7 0 16.9-4.2 33.7-13.2c15-8 35.7-18.8 62.3-18.8c13.3 0 24 10.7 24 24s-10.7 24-24 24c-13.4 0-24.7 5.2-39.7 13.2c-1 .6-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-18.4 0-33.6-6.1-45.5-17.2c-11.1-10.3-17.9-23.7-22.7-36c-3.6-9-6.7-19.1-9.5-28.5c-16.4 12.3-36.1 23.6-58.9 31.3c3.6 10.8 8.4 23.5 14.4 36.2c7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464c13.3 0 24 10.7 24 24s-10.7 24-24 24c-25.2 0-45-13.5-59.5-28.8c-14.5-15.4-25.7-34.9-34.2-53c-8-17-14.1-33.8-18.3-46.9c-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9c-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.8 0 15-3.5 24.5-13.7c9.5-10.1 18.3-24.6 25.8-40.5c5.9-12.6 10.7-25.4 14.4-36.2c-22.8-7.7-42.5-19-58.9-31.3c-2.9 9.4-6 19.5-9.5 28.5c-4.8 12.2-11.6 25.6-22.7 36C153.6 417.9 138.4 424 120 424c-21.4 0-39.9-10-53.1-17.1l0 0c-1.1-.6-2.2-1.2-3.2-1.7c-15-8-26.3-13.2-39.7-13.2c-13.3 0-24-10.7-24-24s10.7-24 24-24c26.6 0 47.3 10.8 62.3 18.8c16.8 9 25 13.2 33.7 13.2c6.8 0 10.2-1.9 12.8-4.3c3.4-3.2 7-8.8 10.8-18.5c3-7.7 5.6-16.1 8.6-25.9c.8-2.7 1.7-5.6 2.6-8.6c1.2-4 2.6-8.2 4-12.5c-3.9-4.5-7.4-8.8-10.5-12.7C136.9 303.5 122.5 312 104 312c-17.5 0-30.7-7.4-40.4-16.7c-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4c-2.8-2.7-4.6-3.3-7.1-3.3c-13.3 0-24-10.7-24-24s10.7-24 24-24c17.5 0 30.7 7.4 40.4 16.7c8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4c2.8 2.7 4.6 3.3 7.1 3.3c3.3 0 8.7-1.7 19.4-13.4c5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24c13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7 .1-3.4 .2-5.1 .2c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm208 0c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $8063e68b12ef6db0$export$733efdaec97447be = $8063e68b12ef6db0$export$3c8d5c62d76c33b8;
var $8063e68b12ef6db0$export$9fe0c42ede2dd003 = {
    prefix: "fas",
    iconName: "arrow-down-up-across-line",
    icon: [
        576,
        512,
        [],
        "e4af",
        "M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V288H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H448V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 109.3V224H192 128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 192h64V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192zM448 320H384V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320z"
    ]
};
var $8063e68b12ef6db0$export$faf854a434ce6d0c = {
    prefix: "fas",
    iconName: "spoon",
    icon: [
        512,
        512,
        [
            129348,
            61873,
            "utensil-spoon"
        ],
        "f2e5",
        "M245.8 220.9c-14.5-17.6-21.8-39.2-21.8-60.8C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-21.6 0-43.2-7.3-60.8-21.8L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L245.8 220.9z"
    ]
};
var $8063e68b12ef6db0$export$fb7af5d245fb9053 = $8063e68b12ef6db0$export$faf854a434ce6d0c;
var $8063e68b12ef6db0$export$8b503c1d76716ddd = {
    prefix: "fas",
    iconName: "jar-wheat",
    icon: [
        320,
        512,
        [],
        "e517",
        "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm112 0H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7zm48 117.7c-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7zM112 352H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416H144v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7z"
    ]
};
var $8063e68b12ef6db0$export$dc2cce064a1e70bb = {
    prefix: "fas",
    iconName: "envelopes-bulk",
    icon: [
        576,
        512,
        [
            "mail-bulk"
        ],
        "f674",
        "M96 0C78.3 0 64 14.3 64 32V224h96V192c0-35.3 28.7-64 64-64H448V32c0-17.7-14.3-32-32-32H96zM224 160c-17.7 0-32 14.3-32 32v32h96c35.3 0 64 28.7 64 64V416H544c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H224zm240 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM32 256c-17.7 0-32 14.3-32 32v13L155.1 415.9c1.4 1 3.1 1.6 4.9 1.6s3.5-.6 4.9-1.6L320 301V288c0-17.7-14.3-32-32-32H32zm288 84.8L184 441.6c-6.9 5.1-15.3 7.9-24 7.9s-17-2.8-24-7.9L0 340.8V480c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V340.8z"
    ]
};
var $8063e68b12ef6db0$export$dd24f40c5337e2e1 = $8063e68b12ef6db0$export$dc2cce064a1e70bb;
var $8063e68b12ef6db0$export$61fa9809253098e5 = {
    prefix: "fas",
    iconName: "file-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e4eb",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 384c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm0-48c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $8063e68b12ef6db0$export$bf5674308c61894f = {
    prefix: "fas",
    iconName: "circle-h",
    icon: [
        512,
        512,
        [
            9405,
            "hospital-symbol"
        ],
        "f47e",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM368 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H192l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H320V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$c8a3c78d99c23fed = $8063e68b12ef6db0$export$bf5674308c61894f;
var $8063e68b12ef6db0$export$e1611f373a10a98c = {
    prefix: "fas",
    iconName: "pager",
    icon: [
        512,
        512,
        [
            128223
        ],
        "f815",
        "M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm64 32v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"
    ]
};
var $8063e68b12ef6db0$export$853fd1561789e3bb = {
    prefix: "fas",
    iconName: "address-book",
    icon: [
        512,
        512,
        [
            62138,
            "contact-book"
        ],
        "f2b9",
        "M96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM208 288h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm96-96c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"
    ]
};
var $8063e68b12ef6db0$export$594b5a5d4d2e156b = $8063e68b12ef6db0$export$853fd1561789e3bb;
var $8063e68b12ef6db0$export$eff51ea25b4de135 = {
    prefix: "fas",
    iconName: "strikethrough",
    icon: [
        512,
        512,
        [],
        "f0cc",
        "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z"
    ]
};
var $8063e68b12ef6db0$export$3f85413cb67e7f67 = {
    prefix: "fas",
    iconName: "k",
    icon: [
        320,
        512,
        [
            107
        ],
        "4b",
        "M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2 .7l-155.2 160L64 249V64c0-17.7-14.3-32-32-32S0 46.3 0 64V328 448c0 17.7 14.3 32 32 32s32-14.3 32-32V341l64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z"
    ]
};
var $8063e68b12ef6db0$export$f4d472cf47be4096 = {
    prefix: "fas",
    iconName: "landmark-flag",
    icon: [
        512,
        512,
        [],
        "e51c",
        "M272 0h80c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H272v32H464c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H240V16c0-8.8 7.2-16 16-16h16zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
    ]
};
var $8063e68b12ef6db0$export$c72de95adaca18b8 = {
    prefix: "fas",
    iconName: "pencil",
    icon: [
        512,
        512,
        [
            9999,
            61504,
            "pencil-alt"
        ],
        "f303",
        "M421.7 220.3l-11.3 11.3-22.6 22.6-205 205c-6.6 6.6-14.8 11.5-23.8 14.1L30.8 511c-8.4 2.5-17.5 .2-23.7-6.1S-1.5 489.7 1 481.2L38.7 353.1c2.6-9 7.5-17.2 14.1-23.8l205-205 22.6-22.6 11.3-11.3 33.9 33.9 62.1 62.1 33.9 33.9zM96 353.9l-9.3 9.3c-.9 .9-1.6 2.1-2 3.4l-25.3 86 86-25.3c1.3-.4 2.5-1.1 3.4-2l9.3-9.3H112c-8.8 0-16-7.2-16-16V353.9zM453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-14.5 14.5-22.6 22.6-11.3 11.3-33.9-33.9-62.1-62.1L314.3 67.7l11.3-11.3 22.6-22.6 14.5-14.5c25-25 65.5-25 90.5 0z"
    ]
};
var $8063e68b12ef6db0$export$8210adc172262df = $8063e68b12ef6db0$export$c72de95adaca18b8;
var $8063e68b12ef6db0$export$ae65f96ea7a4078d = {
    prefix: "fas",
    iconName: "backward",
    icon: [
        512,
        512,
        [
            9194
        ],
        "f04a",
        "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3V256v41.7L459.5 440.6zM256 352V256 128 96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V352z"
    ]
};
var $8063e68b12ef6db0$export$f1011352b01c1c0 = {
    prefix: "fas",
    iconName: "caret-right",
    icon: [
        256,
        512,
        [],
        "f0da",
        "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"
    ]
};
var $8063e68b12ef6db0$export$932912e74adb8939 = {
    prefix: "fas",
    iconName: "comments",
    icon: [
        640,
        512,
        [
            128490,
            61670
        ],
        "f086",
        "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.3-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"
    ]
};
var $8063e68b12ef6db0$export$6f95f90dd1f6d86b = {
    prefix: "fas",
    iconName: "paste",
    icon: [
        512,
        512,
        [
            "file-clipboard"
        ],
        "f0ea",
        "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48H215.4C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48V448v16c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V256H416c-17.7 0-32-14.3-32-32V128H320 272zM160 88c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm256 40v96h96l-96-96z"
    ]
};
var $8063e68b12ef6db0$export$ca3229c47de163fa = $8063e68b12ef6db0$export$6f95f90dd1f6d86b;
var $8063e68b12ef6db0$export$37576dfab037d8bf = {
    prefix: "fas",
    iconName: "code-pull-request",
    icon: [
        512,
        512,
        [],
        "e13c",
        "M305.8 2.1C314.4 5.9 320 14.5 320 24V64h16c70.7 0 128 57.3 128 128V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-35.3-28.7-64-64-64H320v40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM104 80c0-13.3-10.7-24-24-24S56 66.7 56 80s10.7 24 24 24s24-10.7 24-24zm8 73.3V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 32.8-19.7 61-48 73.3zM104 432c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zm328 24c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $8063e68b12ef6db0$export$2c5a9d8548d8810e = {
    prefix: "fas",
    iconName: "clipboard-list",
    icon: [
        384,
        512,
        [],
        "f46d",
        "M101.5 64C114.6 26.7 150.2 0 192 0s77.4 26.7 90.5 64H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h37.5zM224 96c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM160 368c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM96 392c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm64-120c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM96 296c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $8063e68b12ef6db0$export$37396c36c76937bc = {
    prefix: "fas",
    iconName: "truck-ramp-box",
    icon: [
        640,
        512,
        [
            "truck-loading"
        ],
        "f4de",
        "M640 0V400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64H640zM576 400c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"
    ]
};
var $8063e68b12ef6db0$export$f00c152db7d44638 = $8063e68b12ef6db0$export$37396c36c76937bc;
var $8063e68b12ef6db0$export$76de2a120043c9f8 = {
    prefix: "fas",
    iconName: "user-check",
    icon: [
        640,
        512,
        [],
        "f4fc",
        "M352 128c0 70.7-57.3 128-128 128s-128-57.3-128-128S153.3 0 224 0s128 57.3 128 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $8063e68b12ef6db0$export$a56b2b0a1073620c = {
    prefix: "fas",
    iconName: "vial-virus",
    icon: [
        512,
        512,
        [],
        "e597",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V384c0 53 43 96 96 96c28.6 0 54.2-12.5 71.8-32.3c.1-14.2 5.6-28.3 16.4-39.1c.2-.2 .1-.6-.2-.6c-30.9 0-56-25.1-56-56s25.1-56 56-56c.3 0 .4-.4 .2-.6c-21.9-21.9-21.9-57.3 0-79.2c2.4-2.4 5-4.6 7.8-6.5V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 96 32zM96 192V96h64v96H96zM216 376c28.8 0 43.2 34.8 22.9 55.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-5.9 55.2 22.9c0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9C444.8 410.8 459.2 376 488 376c13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C410.8 259.2 376 244.8 376 216c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.8 43.2-55.2 22.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2c-13.3 0-24 10.7-24 24s10.7 24 24 24zm104-24c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm88 32c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$57f2bcd070bff91a = {
    prefix: "fas",
    iconName: "sheet-plastic",
    icon: [
        384,
        512,
        [],
        "e571",
        "M0 448c0 35.3 28.7 64 64 64H224V384c0-17.7 14.3-32 32-32H384V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM171.3 75.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm96 32l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM384 384H256V512L384 384z"
    ]
};
var $8063e68b12ef6db0$export$890d5e011054935a = {
    prefix: "fas",
    iconName: "blog",
    icon: [
        512,
        512,
        [],
        "f781",
        "M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144H128v96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48V144z"
    ]
};
var $8063e68b12ef6db0$export$a9174995732e03c5 = {
    prefix: "fas",
    iconName: "user-ninja",
    icon: [
        448,
        512,
        [
            129399
        ],
        "f504",
        "M224 256c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zM0 482.3C0 396 61.3 324.1 142.7 307.6l68.5 91.4c6.4 8.5 19.2 8.5 25.6 0l68.5-91.4C386.7 324.1 448 396 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"
    ]
};
var $8063e68b12ef6db0$export$5709329dd2b70bdc = {
    prefix: "fas",
    iconName: "person-arrow-up-from-line",
    icon: [
        640,
        512,
        [],
        "e539",
        "M192 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM598.6 121.4l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L464 141.3 464 384c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
    ]
};
var $8063e68b12ef6db0$export$4e3fe5b42a6cd494 = {
    prefix: "fas",
    iconName: "scroll-torah",
    icon: [
        640,
        512,
        [
            "torah"
        ],
        "f6a0",
        "M96 480V32C96 14.3 74.5 0 48 0S0 14.3 0 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32zM512 32H128V480H512V32zM592 0c-26.5 0-48 14.3-48 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32V32c0-17.7-21.5-32-48-32zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332H214.3c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332H298.8L320 368.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52H284.8l-30.3 52zm144.9 23.8L383 308h32.8l-16.4-28.2zM415.8 204H383l16.4 28.2L415.8 204zM320 143.6L298.8 180h42.4L320 143.6zM224.2 204l16.4 28.2L257 204H224.2zM257 308l-16.4-28.2L224.2 308H257z"
    ]
};
var $8063e68b12ef6db0$export$54d07baabd8c2acb = $8063e68b12ef6db0$export$4e3fe5b42a6cd494;
var $8063e68b12ef6db0$export$3e1327487ce53231 = {
    prefix: "fas",
    iconName: "broom-ball",
    icon: [
        640,
        512,
        [
            "quidditch",
            "quidditch-broom-ball"
        ],
        "f458",
        "M633.3 12.4c10.8 14 8.3 34.1-5.6 44.9l-144 112-72 56L403 232l28.3 36.3c3.7 4.8 4.4 11.2 1.8 16.7s-8.1 9-14.1 9.1l-48 .9L292.3 194.2l12.5-46.3c1.6-5.9 6.3-10.3 12.3-11.5s12 1.1 15.8 5.8l30.8 39.4 8.7-6.8 72-56 144-112c13.9-10.9 34.1-8.3 44.9 5.6zM269.1 476.3c-55.5 43.4-215 34.2-252.3 31.4c-5.1-.4-9.7-2.9-12.8-7s-4.5-9.1-3.6-14.1c.5-3.2 1.3-7.2 2.2-12.1c3-16.5 10.8-31.6 21.9-44.1l73.5-82.5c3.1-3.5 3.2-8.6 .4-12.3s-7.9-4.7-12-2.6L47.3 353.5c-6.3 3.3-13.4-2.7-11-9.4c14.3-39.9 32.7-76.9 55.5-94.7c57.7-45.1 175.3-35.5 175.3-35.5l78.8 100.9s-19.1 116.4-76.8 161.5zM496 512c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $8063e68b12ef6db0$export$c00c446e6db1605f = $8063e68b12ef6db0$export$3e1327487ce53231;
var $8063e68b12ef6db0$export$791bfe29b97b4d42 = $8063e68b12ef6db0$export$3e1327487ce53231;
var $8063e68b12ef6db0$export$d20aaceb882ca545 = {
    prefix: "fas",
    iconName: "toggle-off",
    icon: [
        576,
        512,
        [],
        "f204",
        "M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H192c-70.7 0-128-57.3-128-128s57.3-128 128-128H384zM576 256c0-106-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192zM192 352c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96s43 96 96 96z"
    ]
};
var $8063e68b12ef6db0$export$2a0fcb66c3d79d00 = {
    prefix: "fas",
    iconName: "box-archive",
    icon: [
        512,
        512,
        [
            "archive"
        ],
        "f187",
        "M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var $8063e68b12ef6db0$export$26b3e1c454273f34 = $8063e68b12ef6db0$export$2a0fcb66c3d79d00;
var $8063e68b12ef6db0$export$bac321083217fd4 = {
    prefix: "fas",
    iconName: "person-drowning",
    icon: [
        576,
        512,
        [],
        "e545",
        "M192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V96.2c0 54.1 23.5 104 62.2 138.3l-21 146.7c7.8 2.1 15.5 3.3 22.8 3.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c12.4 8.5 26.1 14.8 39.7 18l17.7-97.6c10.7-1.2 21.3-3.1 31.9-5.5l105-23.9c17.2-3.9 28-21.1 24.1-38.3s-21.1-28-38.3-24.1L400 216.6c-41 9.3-83.7 7.5-123.7-5.2c-50.2-16-84.3-62.6-84.3-115.3V64zM320 192c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zM306.5 389.9c-11.1-7.9-25.9-7.9-37 0C247 405.4 219.5 416 192 416c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 469.7 159 480 192 480c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 405.2 410.9 416 384 416c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var $8063e68b12ef6db0$export$6cc91ce23eb3fae1 = {
    prefix: "fas",
    iconName: "arrow-down-9-1",
    icon: [
        576,
        512,
        [
            "sort-numeric-desc",
            "sort-numeric-down-alt"
        ],
        "f886",
        "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM352 320c0 17.7 14.3 32 32 32h16v64H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V320c0-17.7-14.3-32-32-32H384c-17.7 0-32 14.3-32 32zm93.7-171.1c-4.2 2-8.8 3.1-13.7 3.1c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32c0 12.8-7.5 23.8-18.3 28.9zm-40.7 54.9l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
    ]
};
var $8063e68b12ef6db0$export$99f058110e2c82a8 = $8063e68b12ef6db0$export$6cc91ce23eb3fae1;
var $8063e68b12ef6db0$export$857385fda7a5a98e = $8063e68b12ef6db0$export$6cc91ce23eb3fae1;
var $8063e68b12ef6db0$export$8eee2c17ff89e724 = {
    prefix: "fas",
    iconName: "face-grin-tongue-squint",
    icon: [
        512,
        512,
        [
            128541,
            "grin-tongue-squint"
        ],
        "f58a",
        "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $8063e68b12ef6db0$export$4edf34c3def09a31 = $8063e68b12ef6db0$export$8eee2c17ff89e724;
var $8063e68b12ef6db0$export$4952c502f544cf85 = {
    prefix: "fas",
    iconName: "spray-can",
    icon: [
        512,
        512,
        [],
        "f5bd",
        "M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96H224c53 0 96 43 96 96V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V256zm240 80c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80s80-35.8 80-80zM320 64c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zM512 64c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM480 192c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm32 64c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM384 192c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$24b8a0147653649a = {
    prefix: "fas",
    iconName: "truck-monster",
    icon: [
        640,
        512,
        [],
        "f63b",
        "M288 64v64H416L368 64H288zM419.2 25.6L496 128h80c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64H288c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H224V48c0-26.5 21.5-48 48-48h96c20.1 0 39.1 9.5 51.2 25.6zM152 256h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C190.1 503.1 180.1 512 168 512H152c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L63.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C40.9 414.1 32 404.1 32 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9c1.7-11.6 11.7-20.6 23.8-20.6zm8 176c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM448.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C510.1 503.1 500.1 512 488 512H472c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C360.9 414.1 352 404.1 352 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM528 384c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48z"
    ]
};
var $8063e68b12ef6db0$export$c7f24bdea332f90a = {
    prefix: "fas",
    iconName: "w",
    icon: [
        576,
        512,
        [
            119
        ],
        "57",
        "M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2C-4.2 58.7 4.2 40.2 20.8 34z"
    ]
};
var $8063e68b12ef6db0$export$11afa141d42099d0 = {
    prefix: "fas",
    iconName: "earth-africa",
    icon: [
        512,
        512,
        [
            127757,
            "globe-africa"
        ],
        "f57c",
        "M177.8 63.2l10 17.4c2.8 4.8 4.2 10.3 4.2 15.9v41.4c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.3-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32v28c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4V318.6c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l14.1 4.7c12.3 4.1 25.7-1.5 31.5-13c3.5-7 11.2-10.8 18.9-9.2l27.4 5.5C432 112.4 351.5 48 256 48c-27.7 0-54 5.4-78.2 15.2zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"
    ]
};
var $8063e68b12ef6db0$export$64af36f3b403a57c = $8063e68b12ef6db0$export$11afa141d42099d0;
var $8063e68b12ef6db0$export$92ab27739d3a91b2 = {
    prefix: "fas",
    iconName: "rainbow",
    icon: [
        640,
        512,
        [
            127752
        ],
        "f75b",
        "M320 96C178.6 96 64 210.6 64 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C0 175.3 143.3 32 320 32s320 143.3 320 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C576 210.6 461.4 96 320 96zm0 192c-35.3 0-64 28.7-64 64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-70.7 57.3-128 128-128s128 57.3 128 128v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-35.3-28.7-64-64-64zM160 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-123.7 100.3-224 224-224s224 100.3 224 224v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-88.4-71.6-160-160-160s-160 71.6-160 160z"
    ]
};
var $8063e68b12ef6db0$export$9429fd8df55155d = {
    prefix: "fas",
    iconName: "circle-notch",
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
    ]
};
var $8063e68b12ef6db0$export$df1e253fc358ade4 = {
    prefix: "fas",
    iconName: "tablet-screen-button",
    icon: [
        448,
        512,
        [
            "tablet-alt"
        ],
        "f3fa",
        "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM256 448c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM384 64H64V384H384V64z"
    ]
};
var $8063e68b12ef6db0$export$db0cac088255eacc = $8063e68b12ef6db0$export$df1e253fc358ade4;
var $8063e68b12ef6db0$export$7bc6e4d977673e69 = {
    prefix: "fas",
    iconName: "paw",
    icon: [
        512,
        512,
        [],
        "f1b0",
        "M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"
    ]
};
var $8063e68b12ef6db0$export$8bb3c4d5c2f50243 = {
    prefix: "fas",
    iconName: "cloud",
    icon: [
        640,
        512,
        [
            9729
        ],
        "f0c2",
        "M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z"
    ]
};
var $8063e68b12ef6db0$export$b6c20c10ddbd9898 = {
    prefix: "fas",
    iconName: "trowel-bricks",
    icon: [
        512,
        512,
        [],
        "e58a",
        "M240.8 4.8C250.3 10.6 256 20.9 256 32v72h89c3.6-13.8 16.1-24 31-24h88c26.5 0 48 21.5 48 48s-21.5 48-48 48H376c-14.9 0-27.4-10.2-31-24H256v72c0 11.1-5.7 21.4-15.2 27.2s-21.2 6.4-31.1 1.4l-192-96C6.8 151.2 0 140.1 0 128s6.8-23.2 17.7-28.6l192-96c9.9-5 21.7-4.4 31.1 1.4zM288 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V256zM32 384h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm192 0H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$ba5dc4287853ecbd = {
    prefix: "fas",
    iconName: "face-flushed",
    icon: [
        512,
        512,
        [
            128563,
            "flushed"
        ],
        "f579",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM176 384c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm-16-88c39.8 0 72-32.2 72-72s-32.2-72-72-72s-72 32.2-72 72s32.2 72 72 72zm264-72c0-39.8-32.2-72-72-72s-72 32.2-72 72s32.2 72 72 72s72-32.2 72-72zm-240 0c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zm192 0c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$dfd2bd012685aeac = $8063e68b12ef6db0$export$ba5dc4287853ecbd;
var $8063e68b12ef6db0$export$684703c93d630cc5 = {
    prefix: "fas",
    iconName: "hospital-user",
    icon: [
        576,
        512,
        [],
        "f80d",
        "M48 0C21.5 0 0 21.5 0 48V256H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v80c0 26.5 21.5 48 48 48H265.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM152 64h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184v24c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V152H112c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16h24V80c0-8.8 7.2-16 16-16zM512 272c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80s80-35.8 80-80zM288 477.1c0 19.3 15.6 34.9 34.9 34.9H541.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H381.1c-51.4 0-93.1 41.7-93.1 93.1z"
    ]
};
var $8063e68b12ef6db0$export$fa95eb7418c0e2b8 = {
    prefix: "fas",
    iconName: "tent-arrow-left-right",
    icon: [
        640,
        512,
        [],
        "e57f",
        "M520.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L521.5 72 118.5 72l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72C34.9 82.7 32 89.2 32 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L118.5 120l402.9 0-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72zM339.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6s14.9 11.1 24.2 11.1H320V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $8063e68b12ef6db0$export$c36fb40057e2c3aa = {
    prefix: "fas",
    iconName: "gavel",
    icon: [
        512,
        512,
        [
            "legal"
        ],
        "f0e3",
        "M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4L325.4 293.4l-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4L272 285.3 226.7 240 168 298.7l-1.4-1.4z"
    ]
};
var $8063e68b12ef6db0$export$59d593c2dacb3781 = $8063e68b12ef6db0$export$c36fb40057e2c3aa;
var $8063e68b12ef6db0$export$8a910017964bb8c2 = {
    prefix: "fas",
    iconName: "binoculars",
    icon: [
        512,
        512,
        [],
        "f1e5",
        "M128 32h32c17.7 0 32 14.3 32 32V96H96V64c0-17.7 14.3-32 32-32zm64 96V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V388.9c0-34.6 9.4-68.6 27.2-98.3C40.9 267.8 49.7 242.4 53 216L60.5 156c2-16 15.6-28 31.8-28H192zm227.8 0c16.1 0 29.8 12 31.8 28L459 216c3.3 26.4 12.1 51.8 25.8 74.6c17.8 29.7 27.2 63.7 27.2 98.3V448c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V128h99.8zM320 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V96H320V64zm-32 64V288H224V128h64z"
    ]
};
var $8063e68b12ef6db0$export$843f63d64e6f7951 = {
    prefix: "fas",
    iconName: "microphone-slash",
    icon: [
        640,
        512,
        [],
        "f131",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L416 300.8V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zM344 430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4z"
    ]
};
var $8063e68b12ef6db0$export$f2adc06617bc0c7 = {
    prefix: "fas",
    iconName: "box-tissue",
    icon: [
        512,
        512,
        [],
        "e05b",
        "M92.5 0H208c40 0 52 24 64 48s24 48 64 48h85.2C436 96 448 108 448 122.8c0 3.4-.7 6.8-1.9 10L409.6 224 384 288H128l-16-64L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0zM79 224l16 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48H384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H418.5l25.6-64H464c26.5 0 48 21.5 48 48V384H0V272c0-26.5 21.5-48 48-48H79zM0 416H512v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V416z"
    ]
};
var $8063e68b12ef6db0$export$f26017bdca99338d = {
    prefix: "fas",
    iconName: "motorcycle",
    icon: [
        640,
        512,
        [
            127949
        ],
        "f21c",
        "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h57.7l16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7H64c-17.7 0-32 14.3-32 32v32h96c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32h70.4c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H459.6c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21H280zM462.7 311.2l28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40h66.4C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104H187.3zM128 384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$e433538b78718fb3 = {
    prefix: "fas",
    iconName: "bell-concierge",
    icon: [
        512,
        512,
        [
            128718,
            "concierge-bell"
        ],
        "f562",
        "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H480c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
    ]
};
var $8063e68b12ef6db0$export$ad92ffbbfbc0fcf3 = $8063e68b12ef6db0$export$e433538b78718fb3;
var $8063e68b12ef6db0$export$85ba06027671d290 = {
    prefix: "fas",
    iconName: "pen-ruler",
    icon: [
        512,
        512,
        [
            "pencil-ruler"
        ],
        "f5ae",
        "M469.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L322.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM44.9 353.2L299.7 98.3 413.7 212.3 158.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2zM249.4 103.4L103.4 249.4 16 161.9c-18.7-18.7-18.7-49.1 0-67.9L94.1 16c18.7-18.7 49.1-18.7 67.9 0l19.8 19.8c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1l45.1 45.1zM408.6 262.6l45.1 45.1c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1L496 350.1c18.7 18.7 18.7 49.1 0 67.9L417.9 496c-18.7 18.7-49.1 18.7-67.9 0l-87.4-87.4L408.6 262.6z"
    ]
};
var $8063e68b12ef6db0$export$e3a7a1affea005f5 = $8063e68b12ef6db0$export$85ba06027671d290;
var $8063e68b12ef6db0$export$804bfc5c390e1a2a = {
    prefix: "fas",
    iconName: "people-arrows",
    icon: [
        640,
        512,
        [
            "people-arrows-left-right"
        ],
        "e068",
        "M192 64c0 35.3-28.7 64-64 64s-64-28.7-64-64S92.7 0 128 0s64 28.7 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c27 0 51 13.4 65.5 34.1c-2.7 1.9-5.2 4-7.5 6.3l-64 64c-21.9 21.9-21.9 57.3 0 79.2L192 391.2V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM576 64c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM431.6 200.4c-2.3-2.3-4.9-4.4-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V391.2l47.6-47.6c21.9-21.9 21.9-57.3 0-79.2l-64-64zM272 240v32h96V240c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V336H272v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2z"
    ]
};
var $8063e68b12ef6db0$export$da01f044c59e3598 = $8063e68b12ef6db0$export$804bfc5c390e1a2a;
var $8063e68b12ef6db0$export$1dc6221efb867885 = {
    prefix: "fas",
    iconName: "mars-and-venus-burst",
    icon: [
        640,
        512,
        [],
        "e523",
        "M504 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39-22.2 22.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59.1 146.7 136.1 158.2c0 .6-.1 1.2-.1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3H352c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l24 0H376c0 13.3 10.7 24 24 24s24-10.7 24-24H400l24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H424v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2-.1-1.8c77-11.6 136.1-78 136.1-158.2c0-31.4-9-60.7-24.7-85.4L560 113.9l39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H504zM400 320c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.1 3.8 9.9 5.1 15.2 3.6C223.6 310.8 208 269.2 208 224c0-60.8 28.3-115 72.4-150.2L220.3 92.1l-29.4-74z"
    ]
};
var $8063e68b12ef6db0$export$5b1d41cdd118ea6d = {
    prefix: "fas",
    iconName: "square-caret-right",
    icon: [
        448,
        512,
        [
            "caret-square-right"
        ],
        "f152",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
    ]
};
var $8063e68b12ef6db0$export$ae86c9de7e0f62fa = $8063e68b12ef6db0$export$5b1d41cdd118ea6d;
var $8063e68b12ef6db0$export$b2a906a5928c6404 = {
    prefix: "fas",
    iconName: "scissors",
    icon: [
        512,
        512,
        [
            9984,
            9986,
            9988,
            "cut"
        ],
        "f0c4",
        "M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM160 112c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM112 448c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $8063e68b12ef6db0$export$66847f2a71b260e7 = $8063e68b12ef6db0$export$b2a906a5928c6404;
var $8063e68b12ef6db0$export$8db7f2f70484e17e = {
    prefix: "fas",
    iconName: "sun-plant-wilt",
    icon: [
        640,
        512,
        [],
        "e57a",
        "M160 0c-6.3 0-12 3.7-14.6 9.5L120.6 64.9 63.9 43.2c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17l21.7 56.7L9.5 145.4C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8L43.2 256.1c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6 .8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9 .8-12.6-3.6-17s-11.1-5.9-17-3.6L199.4 64.9 174.6 9.5C172 3.7 166.3 0 160 0zm0 224c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm32-64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6V176c0-44.2-35.8-80-80-80s-80 35.8-80 80v22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80v21.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6V272c0-17.7 14.3-32 32-32s32 14.3 32 32v8V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H504V280v-8V176z"
    ]
};
var $8063e68b12ef6db0$export$c00f55f36d386cb7 = {
    prefix: "fas",
    iconName: "toilets-portable",
    icon: [
        576,
        512,
        [],
        "e584",
        "M32 0H224c17.7 0 32 14.3 32 32V64H0V32C0 14.3 14.3 0 32 0zM0 96H24 232h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM192 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zM352 0H544c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32zM320 96h24H552h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H368v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM512 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16z"
    ]
};
var $8063e68b12ef6db0$export$a274b02dc75663dc = {
    prefix: "fas",
    iconName: "hockey-puck",
    icon: [
        512,
        512,
        [],
        "f453",
        "M256 256C114.6 256 0 213 0 160s114.6-96 256-96s256 43 256 96s-114.6 96-256 96zm192.3 1.8c24.7-9.3 46.9-21 63.7-35.6V352c0 53-114.6 96-256 96S0 405 0 352V222.3c16.8 14.6 39 26.3 63.7 35.6C114.5 276.9 182.5 288 256 288s141.5-11.1 192.3-30.2z"
    ]
};
var $8063e68b12ef6db0$export$36583f5d3d5a971f = {
    prefix: "fas",
    iconName: "table",
    icon: [
        512,
        512,
        [],
        "f0ce",
        "M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $8063e68b12ef6db0$export$382d3376c7fc7fc5 = {
    prefix: "fas",
    iconName: "magnifying-glass-arrow-right",
    icon: [
        512,
        512,
        [],
        "e521",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM241 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H238.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72z"
    ]
};
var $8063e68b12ef6db0$export$73f2bf302381c86a = {
    prefix: "fas",
    iconName: "tachograph-digital",
    icon: [
        640,
        512,
        [
            "digital-tachograph"
        ],
        "f566",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm32 64H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM64 368c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 320c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zm80-16c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zm48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zm80-16c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zm48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16z"
    ]
};
var $8063e68b12ef6db0$export$b3bf1994f0fefe98 = $8063e68b12ef6db0$export$73f2bf302381c86a;
var $8063e68b12ef6db0$export$b71a093b86e3da1f = {
    prefix: "fas",
    iconName: "users-slash",
    icon: [
        640,
        512,
        [],
        "e073",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9l-25.2-19.7C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5L38.8 5.1zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192H106.7zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c10.5 0 19.5-6 23.9-14.8L324.9 352H261.3zM512 160c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80z"
    ]
};
var $8063e68b12ef6db0$export$57813571c0e10a0a = {
    prefix: "fas",
    iconName: "clover",
    icon: [
        448,
        512,
        [],
        "e139",
        "M173.3 32C139.4 32 112 59.4 112 93.3v4.9c0 12 3.3 23.7 9.4 34l18.8 31.3c1.1 1.8 1.2 3.1 1 4.2c-.2 1.2-.8 2.5-2 3.6s-2.4 1.8-3.6 2c-1 .2-2.4 .1-4.2-1l-31.3-18.8c-10.3-6.2-22-9.4-34-9.4H61.3C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l1.2 1.2c3.4 3.4 3.4 9 0 12.4l-1.2 1.2C6.5 274.9 0 290.5 0 306.7C0 340.6 27.4 368 61.3 368h4.9c12 0 23.7-3.3 34-9.4l31.3-18.8c1.8-1.1 3.1-1.2 4.2-1c1.2 .2 2.5 .8 3.6 2s1.8 2.4 2 3.6c.2 1 .1 2.4-1 4.2l-18.8 31.3c-6.2 10.3-9.4 22-9.4 34v4.9c0 33.8 27.4 61.3 61.3 61.3c16.2 0 31.8-6.5 43.3-17.9l1.2-1.2c3.4-3.4 9-3.4 12.4 0l1.2 1.2c11.5 11.5 27.1 17.9 43.3 17.9c33.8 0 61.3-27.4 61.3-61.3v-4.9c0-12-3.3-23.7-9.4-34l-18.8-31.3c-1.1-1.8-1.2-3.1-1-4.2c.2-1.2 .8-2.5 2-3.6s2.4-1.8 3.6-2c1-.2 2.4-.1 4.2 1l31.3 18.8c10.3 6.2 22 9.4 34 9.4h4.9c33.8 0 61.3-27.4 61.3-61.3c0-16.2-6.5-31.8-17.9-43.3l-1.2-1.2c-3.4-3.4-3.4-9 0-12.4l1.2-1.2c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3h-4.9c-12 0-23.7 3.3-34 9.4l-31.3 18.8c-1.8 1.1-3.1 1.2-4.2 1c-1.2-.2-2.5-.8-3.6-2s-1.8-2.4-2-3.6c-.2-1-.1-2.4 1-4.2l18.8-31.3c6.2-10.3 9.4-22 9.4-34V93.3C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9l-1.2 1.2c-3.4 3.4-9 3.4-12.4 0l-1.2-1.2C205.1 38.5 189.5 32 173.3 32z"
    ]
};
var $8063e68b12ef6db0$export$bb06d4a7bb6736fe = {
    prefix: "fas",
    iconName: "reply",
    icon: [
        512,
        512,
        [
            61714,
            "mail-reply"
        ],
        "f3e5",
        "M205 34.8c11.5 5.1 19 16.6 19 29.2v64H336c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"
    ]
};
var $8063e68b12ef6db0$export$12e45ff70d2646a1 = $8063e68b12ef6db0$export$bb06d4a7bb6736fe;
var $8063e68b12ef6db0$export$cafa834c96ebcb1a = {
    prefix: "fas",
    iconName: "star-and-crescent",
    icon: [
        576,
        512,
        [
            9770
        ],
        "f699",
        "M32 256C32 114.6 146.6 0 288 0c33 0 64.6 6.3 93.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5c-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C352.6 505.7 321 512 288 512C146.6 512 32 397.4 32 256zM407.4 137.4c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L293 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z"
    ]
};
var $8063e68b12ef6db0$export$947ee033a6942aa8 = {
    prefix: "fas",
    iconName: "house-fire",
    icon: [
        640,
        512,
        [],
        "e50c",
        "M288 350.1l0 1.9H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L447.3 128.1c-12.3-1-25 3-34.8 11.7c-35.4 31.6-65.6 67.7-87.3 102.8C304.3 276.5 288 314.9 288 350.1zM453.5 163.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 56.7 24.2 76.9C640 437.9 568.7 512 480 512c-89.7 0-160-74.2-160-161.9c0-26.4 12.7-58.6 32.4-90.6c20-32.4 48.1-66.1 81.4-95.8c5.6-5 14.2-5 19.8 0zM530 433c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"
    ]
};
var $8063e68b12ef6db0$export$814c9edba7b84aa4 = {
    prefix: "fas",
    iconName: "square-minus",
    icon: [
        448,
        512,
        [
            61767,
            "minus-square"
        ],
        "f146",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $8063e68b12ef6db0$export$ffe9387966b3e681 = $8063e68b12ef6db0$export$814c9edba7b84aa4;
var $8063e68b12ef6db0$export$612d3e1afaf45fa5 = {
    prefix: "fas",
    iconName: "helicopter",
    icon: [
        640,
        512,
        [
            128641
        ],
        "f533",
        "M128 32c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H384v64h32c88.4 0 160 71.6 160 160v64c0 17.7-14.3 32-32 32H384 304c-10.1 0-19.6-4.7-25.6-12.8L192 256 47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64H48c10.1 0 19.6 4.7 25.6 12.8L112 128H320V64H160c-17.7 0-32-14.3-32-32zM384 320H512V288c0-53-43-96-96-96H384V320zM630.6 425.4c12.5 12.5 12.5 32.8 0 45.3l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H536.2c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0z"
    ]
};
var $8063e68b12ef6db0$export$b4d344633433e50e = {
    prefix: "fas",
    iconName: "compass",
    icon: [
        512,
        512,
        [
            129517
        ],
        "f14e",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $8063e68b12ef6db0$export$a1ab39cd66c4e50e = {
    prefix: "fas",
    iconName: "square-caret-down",
    icon: [
        448,
        512,
        [
            "caret-square-down"
        ],
        "f150",
        "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
    ]
};
var $8063e68b12ef6db0$export$61aea18df1c84401 = $8063e68b12ef6db0$export$a1ab39cd66c4e50e;
var $8063e68b12ef6db0$export$877d3692c1f94bda = {
    prefix: "fas",
    iconName: "file-circle-question",
    icon: [
        576,
        512,
        [],
        "e4ef",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 384c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm0-48c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"
    ]
};
var $8063e68b12ef6db0$export$94100f4c6ee29932 = {
    prefix: "fas",
    iconName: "laptop-code",
    icon: [
        640,
        512,
        [],
        "f5fc",
        "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $8063e68b12ef6db0$export$c74a20c81b957b6a = {
    prefix: "fas",
    iconName: "swatchbook",
    icon: [
        512,
        512,
        [],
        "f5c3",
        "M0 32C0 14.3 14.3 0 32 0H160c17.7 0 32 14.3 32 32V416c0 53-43 96-96 96s-96-43-96-96V32zM223.6 425.9c.3-3.3 .4-6.6 .4-9.9V154l75.4-75.4c12.5-12.5 32.8-12.5 45.3 0l90.5 90.5c12.5 12.5 12.5 32.8 0 45.3L223.6 425.9zM182.8 512l192-192H480c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H182.8zM128 64H64v64h64V64zM64 192v64h64V192H64zM96 440c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $8063e68b12ef6db0$export$214f9ce665590486 = {
    prefix: "fas",
    iconName: "prescription-bottle",
    icon: [
        384,
        512,
        [],
        "f485",
        "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V416H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V320H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V224H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V128z"
    ]
};
var $8063e68b12ef6db0$export$36e9cf7887265da2 = {
    prefix: "fas",
    iconName: "bars",
    icon: [
        448,
        512,
        [
            "navicon"
        ],
        "f0c9",
        "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$409fa7bcaa0e4cd9 = $8063e68b12ef6db0$export$36e9cf7887265da2;
var $8063e68b12ef6db0$export$be015e72863c3635 = {
    prefix: "fas",
    iconName: "people-group",
    icon: [
        640,
        512,
        [],
        "e533",
        "M184 88c0 30.9-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zM568 88c0 30.9-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56zm8 157.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 160c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z"
    ]
};
var $8063e68b12ef6db0$export$52757ecc5b1e25b9 = {
    prefix: "fas",
    iconName: "hourglass-end",
    icon: [
        384,
        512,
        [
            8987,
            "hourglass-3"
        ],
        "f253",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75z"
    ]
};
var $8063e68b12ef6db0$export$1ec43c81fef8ffd6 = $8063e68b12ef6db0$export$52757ecc5b1e25b9;
var $8063e68b12ef6db0$export$8e521ef33062b00e = {
    prefix: "fas",
    iconName: "heart-crack",
    icon: [
        512,
        512,
        [
            128148,
            "heart-broken"
        ],
        "f7a9",
        "M119.4 44.1c23.3-3.9 46.8-1.9 68.6 5.3l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.8 61.8c28.5-16.7 62.4-23.2 95.7-17.6C461.5 55.6 512 115.2 512 185.1v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z"
    ]
};
var $8063e68b12ef6db0$export$4a565395cb65b282 = $8063e68b12ef6db0$export$8e521ef33062b00e;
var $8063e68b12ef6db0$export$a47a20ab7bde8c67 = {
    prefix: "fas",
    iconName: "square-up-right",
    icon: [
        448,
        512,
        [
            8599,
            "external-link-square-alt"
        ],
        "f360",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM160 160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l40 40-71 71C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l71-71 40 40c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V176c0-8.8-7.2-16-16-16H160z"
    ]
};
var $8063e68b12ef6db0$export$e4cdf2977151ee26 = $8063e68b12ef6db0$export$a47a20ab7bde8c67;
var $8063e68b12ef6db0$export$eca99665af566fe1 = {
    prefix: "fas",
    iconName: "face-kiss-beam",
    icon: [
        512,
        512,
        [
            128537,
            "kiss-beam"
        ],
        "f597",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-84.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $8063e68b12ef6db0$export$d6ff8a73c0812e63 = $8063e68b12ef6db0$export$eca99665af566fe1;
var $8063e68b12ef6db0$export$c03de0cc616e77bb = {
    prefix: "fas",
    iconName: "film",
    icon: [
        512,
        512,
        [
            127902
        ],
        "f008",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM48 368v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H416zM48 240v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H416zM48 112v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H416zM160 128v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H192z"
    ]
};
var $8063e68b12ef6db0$export$46c6347bff3e04a = {
    prefix: "fas",
    iconName: "ruler-horizontal",
    icon: [
        640,
        512,
        [],
        "f547",
        "M0 336c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0c-26.5 0-48 21.5-48 48L0 336z"
    ]
};
var $8063e68b12ef6db0$export$75ce8513e1f1c5c4 = {
    prefix: "fas",
    iconName: "people-robbery",
    icon: [
        576,
        512,
        [],
        "e536",
        "M488.2 59.1C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V174.3c38.1-20 67.3-55.6 78.3-99.6L559 39.8c4.3-17.1-6.1-34.5-23.3-38.8S501.2 7.1 497 24.2l-8.7 34.9zM400 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM80 96c26.5 0 48-21.5 48-48s-21.5-48-48-48S32 21.5 32 48s21.5 48 48 48zm-8 32c-35.3 0-64 28.7-64 64v96l0 .6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352H88V480c0 17.7 14.3 32 32 32s32-14.3 32-32V252.7l13 20.5c5.9 9.2 16.1 14.9 27 14.9h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H209.6l-37.4-58.9C157.6 142 132.1 128 104.7 128H72z"
    ]
};
var $8063e68b12ef6db0$export$1e80f89fe84a215b = {
    prefix: "fas",
    iconName: "lightbulb",
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"
    ]
};
var $8063e68b12ef6db0$export$85a918a11b7643c2 = {
    prefix: "fas",
    iconName: "caret-left",
    icon: [
        256,
        512,
        [],
        "f0d9",
        "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"
    ]
};
var $8063e68b12ef6db0$export$59573943f9eebbd5 = {
    prefix: "fas",
    iconName: "circle-exclamation",
    icon: [
        512,
        512,
        [
            "exclamation-circle"
        ],
        "f06a",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zm32 224c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$220e07e14c5d7e5d = $8063e68b12ef6db0$export$59573943f9eebbd5;
var $8063e68b12ef6db0$export$5e17b20e0f6b132b = {
    prefix: "fas",
    iconName: "school-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e56d",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4l-139 92.7L37.6 126C15.6 130.9 0 150.3 0 172.8V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V172.8c0-22.5-15.6-42-37.6-46.9L476.8 98.1 337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
    ]
};
var $8063e68b12ef6db0$export$ca14f1b4d6afb7aa = {
    prefix: "fas",
    iconName: "arrow-right-from-bracket",
    icon: [
        576,
        512,
        [
            "sign-out"
        ],
        "f08b",
        "M534.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L434.7 224 224 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-53 0-96 43-96 96l0 256c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z"
    ]
};
var $8063e68b12ef6db0$export$33e2b60243ca6d92 = $8063e68b12ef6db0$export$ca14f1b4d6afb7aa;
var $8063e68b12ef6db0$export$aca07924996218d8 = {
    prefix: "fas",
    iconName: "circle-chevron-down",
    icon: [
        512,
        512,
        [
            "chevron-circle-down"
        ],
        "f13a",
        "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"
    ]
};
var $8063e68b12ef6db0$export$9926124d75b2ecab = $8063e68b12ef6db0$export$aca07924996218d8;
var $8063e68b12ef6db0$export$c98fdd5082b333ec = {
    prefix: "fas",
    iconName: "unlock-keyhole",
    icon: [
        448,
        512,
        [
            "unlock-alt"
        ],
        "f13e",
        "M224 64c-44.2 0-80 35.8-80 80v48H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80V144C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3c7.6 16 .8 35.1-15.2 42.6s-35.1 .8-42.6-15.2C283.4 82.6 255.9 64 224 64zm32 320c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64z"
    ]
};
var $8063e68b12ef6db0$export$b19f508797f3d9c3 = $8063e68b12ef6db0$export$c98fdd5082b333ec;
var $8063e68b12ef6db0$export$af51c741ee9cc090 = {
    prefix: "fas",
    iconName: "cloud-showers-heavy",
    icon: [
        576,
        512,
        [],
        "f740",
        "M128 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C96.7 126.1 96 119.1 96 112C96 50.1 146.1 0 208 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H128zm-14.5 33.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm244.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM345.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6z"
    ]
};
var $8063e68b12ef6db0$export$ca47801915e5a685 = {
    prefix: "fas",
    iconName: "headphones-simple",
    icon: [
        512,
        512,
        [
            "headphones-alt"
        ],
        "f58f",
        "M256 80C141.1 80 48 173.1 48 288V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288C0 146.6 114.6 32 256 32s256 114.6 256 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288c0-114.9-93.1-208-208-208zM80 352c0-35.3 28.7-64 64-64h16c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V352zm288-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h16z"
    ]
};
var $8063e68b12ef6db0$export$6f0433fa527dd5be = $8063e68b12ef6db0$export$ca47801915e5a685;
var $8063e68b12ef6db0$export$b2ce5e79d0eccaf8 = {
    prefix: "fas",
    iconName: "sitemap",
    icon: [
        576,
        512,
        [],
        "f0e8",
        "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-8v40H464c30.9 0 56 25.1 56 56v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-4.4-3.6-8-8-8H312v40h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V280H112c-4.4 0-8 3.6-8 8v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-30.9 25.1-56 56-56H264V192h-8c-26.5 0-48-21.5-48-48V80z"
    ]
};
var $8063e68b12ef6db0$export$5f92ac3e804644e3 = {
    prefix: "fas",
    iconName: "circle-dollar-to-slot",
    icon: [
        512,
        512,
        [
            "donate"
        ],
        "f4b9",
        "M326.7 403.7c-22.1 8-45.9 12.3-70.7 12.3s-48.7-4.4-70.7-12.3c-.3-.1-.5-.2-.8-.3c-30-11-56.8-28.7-78.6-51.4C70 314.6 48 263.9 48 208C48 93.1 141.1 0 256 0S464 93.1 464 208c0 55.9-22 106.6-57.9 144c-1 1-2 2.1-3 3.1c-21.4 21.4-47.4 38.1-76.3 48.6zM256 91.9c-11.1 0-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.8 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0 0 0 0 0c-2.2-.7-4.3-1.5-6.4-2.1c-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1V304c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.4-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V112c0-11.1-9-20.1-20.1-20.1zM48 352H64c19.5 25.9 44 47.7 72.2 64H64v32H256 448V416H375.8c28.2-16.3 52.8-38.1 72.2-64h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"
    ]
};
var $8063e68b12ef6db0$export$40050ae52860cde7 = $8063e68b12ef6db0$export$5f92ac3e804644e3;
var $8063e68b12ef6db0$export$5f9bd9f6df021f93 = {
    prefix: "fas",
    iconName: "memory",
    icon: [
        576,
        512,
        [],
        "f538",
        "M64 64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6V320H576V248.6c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64zM576 352H0v64c0 17.7 14.3 32 32 32H80V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h48c17.7 0 32-14.3 32-32V352zM192 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$b372a24046126ad8 = {
    prefix: "fas",
    iconName: "road-spikes",
    icon: [
        640,
        512,
        [],
        "e568",
        "M64 116.8c0-15.8 20.5-22 29.3-8.9L192 256V116.8c0-15.8 20.5-22 29.3-8.9L320 256V116.8c0-15.8 20.5-22 29.3-8.9L448 256V116.8c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7H512 448 384 320 256 192 64V116.8zM32 384H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$e4e44f7b1886fef = {
    prefix: "fas",
    iconName: "fire-burner",
    icon: [
        640,
        512,
        [],
        "e4f1",
        "M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15zM32 288c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32s-14.3 32-32 32v64H544V320c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V288zM320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm160-32c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM192 480c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$6591b1ea509be9da = {
    prefix: "fas",
    iconName: "flag",
    icon: [
        512,
        512,
        [
            127988,
            61725
        ],
        "f024",
        "M64 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32C0 14.3 14.3 0 32 0S64 14.3 64 32zm40.8 302.8c-3 .9-6 1.7-8.8 2.6V13.5C121.5 6.4 153 0 184 0c36.5 0 68.3 9.1 95.6 16.9l1.3 .4C309.4 25.4 333.3 32 360 32c26.8 0 52.9-6.8 73-14.1c9.9-3.6 17.9-7.2 23.4-9.8c2.7-1.3 4.8-2.4 6.2-3.1c.7-.4 1.1-.6 1.4-.8l.2-.1c9.9-5.6 22.1-5.6 31.9 .2S512 20.6 512 32V288c0 12.1-6.8 23.2-17.7 28.6L480 288c14.3 28.6 14.3 28.6 14.3 28.6l0 0 0 0-.1 0-.2 .1-.7 .4c-.6 .3-1.5 .7-2.5 1.2c-2.2 1-5.2 2.4-9 4c-7.7 3.3-18.5 7.6-31.5 11.9C424.5 342.9 388.8 352 352 352c-37 0-65.2-9.4-89-17.3l-1-.3c-24-8-43.7-14.4-70-14.4c-27.5 0-60.1 7-87.2 14.8z"
    ]
};
var $8063e68b12ef6db0$export$3dcd4ca3f7108a82 = {
    prefix: "fas",
    iconName: "hanukiah",
    icon: [
        640,
        512,
        [
            128334
        ],
        "f6e6",
        "M314.2 3.3C309.1 12.1 296 36.6 296 56c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C324.6 1.2 322.4 0 320 0s-4.6 1.2-5.8 3.3zm-288 48C21.1 60.1 8 84.6 8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C36.6 49.2 34.4 48 32 48s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm82.2-52.7C165.1 60.1 152 84.6 152 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zM394.2 51.3C389.1 60.1 376 84.6 376 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm82.2-52.7C517.1 60.1 504 84.6 504 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104zM112 160c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm160 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zM352 144c0-17.7-14.3-32-32-32s-32 14.3-32 32V320H96c-17.7 0-32-14.3-32-32V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 53 43 96 96 96H288v64H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H544c53 0 96-43 96-96V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H352V144z"
    ]
};
var $8063e68b12ef6db0$export$5e19aea195b31816 = {
    prefix: "fas",
    iconName: "feather",
    icon: [
        512,
        512,
        [
            129718
        ],
        "f52d",
        "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h68c49.7 0 97.9-14.4 139-41c11.1-7.2 5.5-23-7.8-23c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3l-32.2 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7C506.4 207.6 512 184.1 512 160c0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330v55.3L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
    ]
};
var $8063e68b12ef6db0$export$2b1464e7557b18eb = {
    prefix: "fas",
    iconName: "volume-low",
    icon: [
        448,
        512,
        [
            128264,
            "volume-down"
        ],
        "f027",
        "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"
    ]
};
var $8063e68b12ef6db0$export$69fdf57632b6cc29 = $8063e68b12ef6db0$export$2b1464e7557b18eb;
var $8063e68b12ef6db0$export$3786a0422a3f33ea = {
    prefix: "fas",
    iconName: "comment-slash",
    icon: [
        640,
        512,
        [],
        "f4b3",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512.9 376.7C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zM64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104-17.9L82.9 161.3C70.7 185.6 64 212.2 64 240z"
    ]
};
var $8063e68b12ef6db0$export$dd9dc9b4227dbe94 = {
    prefix: "fas",
    iconName: "cloud-sun-rain",
    icon: [
        640,
        512,
        [
            127782
        ],
        "f743",
        "M137.9 3c-4.5-3.2-10.3-3.9-15.4-1.8s-8.8 6.7-9.7 12.2L98.7 98.7 13.4 112.8c-5.5 .9-10.1 4.6-12.2 9.7S-.2 133.4 3 137.9l50.3 70.3L3 278.5c-3.2 4.5-3.9 10.3-1.8 15.4s6.7 8.8 12.2 9.7l85.3 14.1L112.8 403c.9 5.5 4.6 10.1 9.7 12.2s10.9 1.4 15.4-1.8l55.2-39.5c-19.9-21.9-32.3-50.8-33.1-82.6c-17.6-10.2-32.2-26.1-40.6-46.3c-20.3-49 3-105.1 52-125.4c29.4-12.2 61.4-8.7 86.7 6.7c13.1-21.8 32.5-39.4 55.8-50.3L303.6 13.4c-.9-5.5-4.6-10.1-9.7-12.2S282.9-.2 278.5 3L208.2 53.3 137.9 3zM291.4 415.9c-2.5 .6-5.1 .6-7.6-.1c1.4 0 2.8 .1 4.2 .1h3.5zm-46.3-260c-17.3-12.2-40.4-15.6-61.5-6.9c-32.7 13.5-48.2 51-34.6 83.6c3.6 8.7 8.9 16.1 15.3 22.2c10.6-39.7 39.9-71.8 77.8-86.4c.8-4.3 1.8-8.4 3-12.5zM277.4 420c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm74.5-116.1c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.3 114.6 402.8 96 368 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96H559.9c44.2 0 80-35.8 80-80z"
    ]
};
var $8063e68b12ef6db0$export$83632d1150d3541f = {
    prefix: "fas",
    iconName: "compress",
    icon: [
        448,
        512,
        [],
        "f066",
        "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V64zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V64zM320 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
    ]
};
var $8063e68b12ef6db0$export$79d4dac715a51fdf = {
    prefix: "fas",
    iconName: "wheat-awn",
    icon: [
        512,
        512,
        [
            "wheat-alt"
        ],
        "e2cd",
        "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L486.5 231c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3z"
    ]
};
var $8063e68b12ef6db0$export$deaf03a29aa05e3a = $8063e68b12ef6db0$export$79d4dac715a51fdf;
var $8063e68b12ef6db0$export$8736909014b15ca9 = {
    prefix: "fas",
    iconName: "ankh",
    icon: [
        320,
        512,
        [
            9765
        ],
        "f644",
        "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1c-5.9 6.2-11.8 11.8-17.4 16.7c-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128zM160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H241.2c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0z"
    ]
};
var $8063e68b12ef6db0$export$bfb254bf3c0bc50b = {
    prefix: "fas",
    iconName: "hands-holding-child",
    icon: [
        640,
        512,
        [],
        "e4fa",
        "M320 80c-22.1 0-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40zm44.7 84.3L375.8 253c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35h-7.6l-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8L255.5 181c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l27.9-23.6C271.3 104.8 295.3 96 320 96s48.7 8.8 67.6 24.7l27.9 23.6c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8l-19.8-16.7zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"
    ]
};
var $8063e68b12ef6db0$export$19eff32c0fd4f99f = {
    prefix: "fas",
    iconName: "asterisk",
    icon: [
        384,
        512,
        [
            10033,
            61545
        ],
        "2a",
        "M192 32c17.7 0 32 14.3 32 32V199.5l111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V312.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5V64c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$5bb6a0c94ad2f4bb = {
    prefix: "fas",
    iconName: "square-check",
    icon: [
        448,
        512,
        [
            9745,
            9989,
            61510,
            "check-square"
        ],
        "f14a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $8063e68b12ef6db0$export$f0c8040f596df7fe = $8063e68b12ef6db0$export$5bb6a0c94ad2f4bb;
var $8063e68b12ef6db0$export$a6f8654bcd49a39f = {
    prefix: "fas",
    iconName: "peseta-sign",
    icon: [
        384,
        512,
        [],
        "e221",
        "M64 32C46.3 32 32 46.3 32 64v96c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 96V448c0 17.7 14.3 32 32 32s32-14.3 32-32V352h96c77.4 0 142-55 156.8-128H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-3.2C334 87 269.4 32 192 32H64zM282.5 160H96V96h96c41.8 0 77.4 26.7 90.5 64zM96 224H282.5c-13.2 37.3-48.7 64-90.5 64H96V224z"
    ]
};
var $8063e68b12ef6db0$export$4805b8d175aeb9fb = {
    prefix: "fas",
    iconName: "heading",
    icon: [
        448,
        512,
        [
            "header"
        ],
        "f1dc",
        "M0 64C0 46.3 14.3 32 32 32H80h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H112V208H336V96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h48 48c17.7 0 32 14.3 32 32s-14.3 32-32 32H400V240 416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H368 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V272H112V416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V240 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $8063e68b12ef6db0$export$579f9604bb10a61a = $8063e68b12ef6db0$export$4805b8d175aeb9fb;
var $8063e68b12ef6db0$export$1a989eb1919c64c1 = {
    prefix: "fas",
    iconName: "ghost",
    icon: [
        384,
        512,
        [
            128123
        ],
        "f6e2",
        "M50.8 452.1L19.2 477.4c-2.1 1.7-4.7 2.6-7.4 2.6C5.3 480 0 474.7 0 468.2V192C0 86 86 0 192 0S384 86 384 192V468.2c0 6.5-5.3 11.8-11.8 11.8c-2.7 0-5.3-.9-7.4-2.6l-31.6-25.3c-3.3-2.7-7.5-4.1-11.8-4.1c-5.9 0-11.5 2.8-15 7.5l-37.6 50.1c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4l-38.4-51.2c-3-4-7.8-6.4-12.8-6.4s-9.8 2.4-12.8 6.4l-38.4 51.2c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L77.6 455.5c-3.6-4.7-9.1-7.5-15-7.5c-4.3 0-8.4 1.5-11.7 4.1zM160 192c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm96 32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$6cfc59842fedbc16 = {
    prefix: "fas",
    iconName: "list",
    icon: [
        512,
        512,
        [
            "list-squares"
        ],
        "f03a",
        "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"
    ]
};
var $8063e68b12ef6db0$export$e3f160fc949c2b9d = $8063e68b12ef6db0$export$6cfc59842fedbc16;
var $8063e68b12ef6db0$export$b627121801cad756 = {
    prefix: "fas",
    iconName: "square-phone-flip",
    icon: [
        448,
        512,
        [
            "phone-square-alt"
        ],
        "f87b",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zm-90.7 96.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"
    ]
};
var $8063e68b12ef6db0$export$a41e77f0de98bba7 = $8063e68b12ef6db0$export$b627121801cad756;
var $8063e68b12ef6db0$export$6675e2bf21fdb87e = {
    prefix: "fas",
    iconName: "cart-plus",
    icon: [
        576,
        512,
        [],
        "f217",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H179.9l-9.1-48h317c14.3 0 26.9-9.5 30.8-23.3l54-192C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm336-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM252 160c0-11 9-20 20-20h44V96c0-11 9-20 20-20s20 9 20 20v44h44c11 0 20 9 20 20s-9 20-20 20H356v44c0 11-9 20-20 20s-20-9-20-20V180H272c-11 0-20-9-20-20z"
    ]
};
var $8063e68b12ef6db0$export$6a66b1b639455bef = {
    prefix: "fas",
    iconName: "gamepad",
    icon: [
        640,
        512,
        [],
        "f11b",
        "M192 64C86 64 0 150 0 256S86 448 192 448H448c106 0 192-86 192-192s-86-192-192-192H192zM496 248c-22.1 0-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40zm-24 56c0 22.1-17.9 40-40 40s-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40zM168 200c0-13.3 10.7-24 24-24s24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V200z"
    ]
};
var $8063e68b12ef6db0$export$aa13d9234890e8d3 = {
    prefix: "fas",
    iconName: "circle-dot",
    icon: [
        512,
        512,
        [
            128280,
            "dot-circle"
        ],
        "f192",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm0-160c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96z"
    ]
};
var $8063e68b12ef6db0$export$92bc269cb244d66a = $8063e68b12ef6db0$export$aa13d9234890e8d3;
var $8063e68b12ef6db0$export$635e4d8cc8428961 = {
    prefix: "fas",
    iconName: "face-dizzy",
    icon: [
        512,
        512,
        [
            "dizzy"
        ],
        "f567",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm0-96c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
var $8063e68b12ef6db0$export$89a2b10dabc487e8 = $8063e68b12ef6db0$export$635e4d8cc8428961;
var $8063e68b12ef6db0$export$1199a8ce85311ab5 = {
    prefix: "fas",
    iconName: "egg",
    icon: [
        384,
        512,
        [
            129370
        ],
        "f7fb",
        "M192 496C86 496 0 410 0 304C0 192 96 16 192 16s192 176 192 288c0 106-86 192-192 192zM156.5 138l0 0 0 0 0 0c5.5-6.9 4.4-17-2.5-22.5s-17-4.4-22.5 2.5L144 128c-12.5-10-12.5-10-12.5-10l0 0 0 0-.1 .1-.2 .2-.6 .8c-.5 .7-1.3 1.7-2.2 3c-1.9 2.6-4.5 6.3-7.7 11c-6.3 9.4-14.6 23-23 39.7C81.1 206.1 64 252.6 64 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.6 14.9-86.1 30.3-116.8c7.6-15.3 15.3-27.7 21-36.3c2.8-4.3 5.2-7.6 6.8-9.8c.8-1.1 1.4-1.9 1.8-2.4l.4-.6 .1-.1 0 0z"
    ]
};
var $8063e68b12ef6db0$export$bf221f0e8296233e = {
    prefix: "fas",
    iconName: "house-medical-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e513",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm22.6-144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
    ]
};
var $8063e68b12ef6db0$export$295287303c0e9c7c = {
    prefix: "fas",
    iconName: "campground",
    icon: [
        576,
        512,
        [
            9978
        ],
        "f6bb",
        "M377 52c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L288 60.8 249 12c-11-13.8-31.2-16-45-5s-16 31.2-5 45l48 60L12.3 405.4C4.3 415.4 0 427.7 0 440.4V464c0 26.5 21.5 48 48 48H288 528c26.5 0 48-21.5 48-48V440.4c0-12.7-4.3-25.1-12.3-35L329 112l48-60zM288 448H168.5L288 291.7 407.5 448H288z"
    ]
};
var $8063e68b12ef6db0$export$e18e05ffa2045d3b = {
    prefix: "fas",
    iconName: "folder-plus",
    icon: [
        512,
        512,
        [],
        "f65e",
        "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H448c35.3 0 64 28.7 64 64V416zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
    ]
};
var $8063e68b12ef6db0$export$65a345b33858a655 = {
    prefix: "fas",
    iconName: "futbol",
    icon: [
        512,
        512,
        [
            9917,
            "futbol-ball",
            "soccer-ball"
        ],
        "f1e3",
        "M417.3 360.1l-71.6-4.8c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-17.6 69.6C289.5 445.8 273 448 256 448s-33.5-2.2-49.2-6.4L189.2 372c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-71.6 4.8c-17.6-27.2-28.5-59.2-30.4-93.6L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15l-26.7-66.6C128 109.2 155.3 89 186.7 76.9l55.2 46c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l55.2-46c31.3 12.1 58.7 32.3 79.6 57.9l-26.7 66.6c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l60.7 38.2c-1.9 34.4-12.8 66.4-30.4 93.6zM256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
    ]
};
var $8063e68b12ef6db0$export$51a344ca0a215620 = $8063e68b12ef6db0$export$65a345b33858a655;
var $8063e68b12ef6db0$export$f4a29712c724ba2d = $8063e68b12ef6db0$export$65a345b33858a655;
var $8063e68b12ef6db0$export$7c8b56f3f296a814 = {
    prefix: "fas",
    iconName: "paintbrush",
    icon: [
        576,
        512,
        [
            128396,
            "paint-brush"
        ],
        "f1fc",
        "M371.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L600.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S549.7-4.4 531.1 9.6L294.4 187.2c-24 18-38.2 46.1-38.4 76.1L371.3 367.1zm-19.6 25.4l-116-104.4C175.9 290.3 128 339.6 128 400c0 3.9 .2 7.8 .6 11.6c1.8 17.5-10.2 36.4-27.8 36.4H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H240c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"
    ]
};
var $8063e68b12ef6db0$export$594db3339e212bc9 = $8063e68b12ef6db0$export$7c8b56f3f296a814;
var $8063e68b12ef6db0$export$7aa08ad5d562578a = {
    prefix: "fas",
    iconName: "lock",
    icon: [
        448,
        512,
        [
            128274
        ],
        "f023",
        "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"
    ]
};
var $8063e68b12ef6db0$export$84666c793cb2a347 = {
    prefix: "fas",
    iconName: "gas-pump",
    icon: [
        512,
        512,
        [
            9981
        ],
        "f52f",
        "M32 64C32 28.7 60.7 0 96 0H256c35.3 0 64 28.7 64 64V256h8c48.6 0 88 39.4 88 88v32c0 13.3 10.7 24 24 24s24-10.7 24-24V222c-27.6-7.1-48-32.2-48-62V96L384 64c-8.8-8.8-8.8-23.2 0-32s23.2-8.8 32 0l77.3 77.3c12 12 18.7 28.3 18.7 45.3V168v24 32V376c0 39.8-32.2 72-72 72s-72-32.2-72-72V344c0-22.1-17.9-40-40-40h-8V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64zM96 80v96c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"
    ]
};
var $8063e68b12ef6db0$export$6e6bd68568c17bbf = {
    prefix: "fas",
    iconName: "hot-tub-person",
    icon: [
        512,
        512,
        [
            "hot-tub"
        ],
        "f593",
        "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L295.8 82.8C280.7 69.1 272 49.7 272 29.2V24zM0 320v16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v64zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm112 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM360 0c-13.3 0-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L407.8 82.8C392.7 69.1 384 49.7 384 29.2V24c0-13.3-10.7-24-24-24zM64 128c35.3 0 64-28.7 64-64S99.3 0 64 0S0 28.7 0 64s28.7 64 64 64z"
    ]
};
var $8063e68b12ef6db0$export$4842af92b516c40b = $8063e68b12ef6db0$export$6e6bd68568c17bbf;
var $8063e68b12ef6db0$export$9a8788ec0e4a9a0b = {
    prefix: "fas",
    iconName: "map-location",
    icon: [
        576,
        512,
        [
            "map-marked"
        ],
        "f59f",
        "M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3V152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7c-2.9 6.8-6.1 13.7-9.6 20.6V503zM15.1 187.3C6 191 0 199.8 0 209.6V480.4c0 17 17.1 28.6 32.9 22.3L160 451.8V200.4c-3.5-6.9-6.7-13.8-9.6-20.6c-5.6-13.2-10.4-27.4-12.8-41.5l-122.6 49zM384 255c-20.5 31.3-42.3 59.6-56.2 77c-20.5 25.6-59.1 25.6-79.6 0c-13.9-17.4-35.7-45.7-56.2-77V449.4l192 54.9V255z"
    ]
};
var $8063e68b12ef6db0$export$df04458e7e32352c = $8063e68b12ef6db0$export$9a8788ec0e4a9a0b;
var $8063e68b12ef6db0$export$70fd6006b4e54a5 = {
    prefix: "fas",
    iconName: "house-flood-water",
    icon: [
        576,
        512,
        [],
        "e50e",
        "M306.8 6.1C295.6-2 280.4-2 269.2 6.1l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192h16v73c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.5-1 3-2 4.5-2.9l-.3-73.2H464c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128zM269.5 309.9C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 389.7 159 400 192 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"
    ]
};
var $8063e68b12ef6db0$export$1744430f718caf6b = {
    prefix: "fas",
    iconName: "tree",
    icon: [
        448,
        512,
        [
            127794
        ],
        "f1bb",
        "M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208H104L30.6 281.4c-4.2 4.2-6.6 10-6.6 16C24 309.9 34.1 320 46.6 320H80L5.4 409.5C1.9 413.7 0 419 0 424.5c0 13 10.5 23.5 23.5 23.5H192v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448H424.5c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L368 320h33.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9z"
    ]
};
var $8063e68b12ef6db0$export$cffe7d85a82d8116 = {
    prefix: "fas",
    iconName: "bridge-lock",
    icon: [
        640,
        512,
        [],
        "e4cc",
        "M32 64c0-17.7 14.3-32 32-32H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H536v64h-8c-61.9 0-112 50.1-112 112v24.6c-9.9 5.8-18.2 14.1-23.8 24.1c-17.6-20-43.4-32.7-72.2-32.7c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96V160h72V96H64C46.3 96 32 81.7 32 64zM408 96v64h80V96H408zm-48 64V96H280v64h80zM152 96v64h80V96H152zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $8063e68b12ef6db0$export$15854c4475080853 = {
    prefix: "fas",
    iconName: "sack-dollar",
    icon: [
        512,
        512,
        [
            128176
        ],
        "f81d",
        "M320 96H192L144.6 24.9C137.5 14.2 145.1 0 157.9 0H354.1c12.8 0 20.4 14.2 13.3 24.9L320 96zM192 128H320c3.8 2.5 8.1 5.3 13 8.4C389.7 172.7 512 250.9 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96C0 250.9 122.3 172.7 179 136.4l0 0 0 0c4.8-3.1 9.2-5.9 13-8.4zm84.1 96c0-11.1-9-20.1-20.1-20.1s-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.8 4.1c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0 0 0 0 0 0 0c-2.2-.8-4.3-1.5-6.3-2.1c-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1V416c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.4-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V224z"
    ]
};
var $8063e68b12ef6db0$export$ba236543926e3569 = {
    prefix: "fas",
    iconName: "pen-to-square",
    icon: [
        512,
        512,
        [
            "edit"
        ],
        "f044",
        "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.8 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"
    ]
};
var $8063e68b12ef6db0$export$7be713e57d023733 = $8063e68b12ef6db0$export$ba236543926e3569;
var $8063e68b12ef6db0$export$6f7218565b1b8d0e = {
    prefix: "fas",
    iconName: "car-side",
    icon: [
        640,
        512,
        [
            128663
        ],
        "f5e4",
        "M171.3 96H224v96H111.3l30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192V96h81.2c9.7 0 18.9 4.4 25 12l67.2 84H272zm256.2 1L428.2 68c-18.2-22.8-45.8-36-75-36H171.3c-39.3 0-74.6 23.9-89.1 60.3L40.6 196.4C16.8 205.8 0 228.9 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-65.2-48.8-119-111.8-127zm-2.9 207c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32c-1.8-5-2.7-10.4-2.7-16c0-26.5 21.5-48 48-48s48 21.5 48 48c0 5.6-1 11-2.7 16zM160 432c-20.9 0-38.7-13.4-45.3-32c-1.8-5-2.7-10.4-2.7-16c0-26.5 21.5-48 48-48s48 21.5 48 48c0 5.6-1 11-2.7 16c-6.6 18.6-24.4 32-45.3 32z"
    ]
};
var $8063e68b12ef6db0$export$cdaf45d4e50ac035 = {
    prefix: "fas",
    iconName: "share-nodes",
    icon: [
        448,
        512,
        [
            "share-alt"
        ],
        "f1e0",
        "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
    ]
};
var $8063e68b12ef6db0$export$f8e8bb0b3aa8c658 = $8063e68b12ef6db0$export$cdaf45d4e50ac035;
var $8063e68b12ef6db0$export$24c21c3ca00f3625 = {
    prefix: "fas",
    iconName: "heart-circle-minus",
    icon: [
        576,
        512,
        [],
        "e4ff",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$703272eebf5e3eea = {
    prefix: "fas",
    iconName: "hourglass-half",
    icon: [
        384,
        512,
        [
            "hourglass-2"
        ],
        "f252",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.2 14.9H112z"
    ]
};
var $8063e68b12ef6db0$export$f1052bbf6bf361c0 = $8063e68b12ef6db0$export$703272eebf5e3eea;
var $8063e68b12ef6db0$export$6a99139787bf9967 = {
    prefix: "fas",
    iconName: "microscope",
    icon: [
        512,
        512,
        [
            128300
        ],
        "f610",
        "M168 32c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32h8c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32h-8c0 17.7-14.3 32-32 32H200c-17.7 0-32-14.3-32-32h-8c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32l8 0zM32 448H320c70.7 0 128-57.3 128-128s-57.3-128-128-128V128c106 0 192 86 192 192c0 49.2-18.5 94-48.9 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm80-64H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$2a9dda2096ce792e = {
    prefix: "fas",
    iconName: "sink",
    icon: [
        512,
        512,
        [],
        "e06d",
        "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32s14.3 32 32 32s32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96V288H160V264c0-30.9-25.1-56-56-56H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v24H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H256 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H400V264c0-4.4 3.6-8 8-8h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H408c-30.9 0-56 25.1-56 56v24H288V96zM480 416V384H32v32c0 53 43 96 96 96H384c53 0 96-43 96-96z"
    ]
};
var $8063e68b12ef6db0$export$b0137b4600e9ab12 = {
    prefix: "fas",
    iconName: "bag-shopping",
    icon: [
        448,
        512,
        [
            "shopping-bag"
        ],
        "f290",
        "M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64v48H160V112zm-48 48H48c-26.5 0-48 21.5-48 48V416c0 53 43 96 96 96H352c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48H336V112C336 50.1 285.9 0 224 0S112 50.1 112 112v48zm24 96c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm200-24c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$5745f8adbc11eb01 = $8063e68b12ef6db0$export$b0137b4600e9ab12;
var $8063e68b12ef6db0$export$cf79d63ad07d943a = {
    prefix: "fas",
    iconName: "arrow-down-z-a",
    icon: [
        576,
        512,
        [
            "sort-alpha-desc",
            "sort-alpha-down-alt"
        ],
        "f881",
        "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 64c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96H352c-17.7 0-32-14.3-32-32zm96 192c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 448H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zM395.8 400h40.4L416 359.6 395.8 400z"
    ]
};
var $8063e68b12ef6db0$export$7caf99612a55d427 = $8063e68b12ef6db0$export$cf79d63ad07d943a;
var $8063e68b12ef6db0$export$e12d23d82d5c8a89 = $8063e68b12ef6db0$export$cf79d63ad07d943a;
var $8063e68b12ef6db0$export$5030322c5fc886d7 = {
    prefix: "fas",
    iconName: "mitten",
    icon: [
        448,
        512,
        [],
        "f7b5",
        "M352 384H64L5.4 178.9C1.8 166.4 0 153.4 0 140.3C0 62.8 62.8 0 140.3 0h3.4c66 0 123.5 44.9 139.5 108.9l31.4 125.8 17.6-20.1C344.8 200.2 362.9 192 382 192h2.8c34.9 0 63.3 28.3 63.3 63.3c0 15.9-6 31.2-16.8 42.9L352 384zM32 448c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V448z"
    ]
};
var $8063e68b12ef6db0$export$49577f913f0fe4d2 = {
    prefix: "fas",
    iconName: "person-rays",
    icon: [
        512,
        512,
        [],
        "e54d",
        "M304 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM248 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L328 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H248zM7 7C16.4-2.3 31.6-2.3 41 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41C-2.3 31.6-2.3 16.4 7 7zM471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7zM7 505c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0zm464 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
    ]
};
var $8063e68b12ef6db0$export$e5a8f011aef571ac = {
    prefix: "fas",
    iconName: "users",
    icon: [
        640,
        512,
        [],
        "f0c0",
        "M144 160c-44.2 0-80-35.8-80-80S99.8 0 144 0s80 35.8 80 80s-35.8 80-80 80zm368 0c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM416 224c0 53-43 96-96 96s-96-43-96-96s43-96 96-96s96 43 96 96zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"
    ]
};
var $8063e68b12ef6db0$export$ed3f2918429d029a = {
    prefix: "fas",
    iconName: "eye-slash",
    icon: [
        640,
        512,
        [],
        "f070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c5.2-11.8 8-24.8 8-38.5c0-53-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zm223.1 298L373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5z"
    ]
};
var $8063e68b12ef6db0$export$a25a266ce0c95019 = {
    prefix: "fas",
    iconName: "flask-vial",
    icon: [
        640,
        512,
        [],
        "e4f3",
        "M175 389.4c-9.8 16-15 34.3-15 53.1c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96V64C14.3 64 0 49.7 0 32S14.3 0 32 0H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V309.9l-49 79.6zM96 64v96h64V64H96zM352 0H480h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V214.9L629.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H261.4c-38.3 0-69.4-31.1-69.4-69.4c0-12.8 3.6-25.4 10.3-36.4L320 214.9V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm32 64V224c0 5.9-1.6 11.7-4.7 16.8L330.5 320h171l-48.8-79.2c-3.1-5-4.7-10.8-4.7-16.8V64H384z"
    ]
};
var $8063e68b12ef6db0$export$f69db0b876f7d753 = {
    prefix: "fas",
    iconName: "hand",
    icon: [
        512,
        512,
        [
            129306,
            9995,
            "hand-paper"
        ],
        "f256",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32z"
    ]
};
var $8063e68b12ef6db0$export$6e6216c8b50471bb = $8063e68b12ef6db0$export$f69db0b876f7d753;
var $8063e68b12ef6db0$export$8de8eb94230028a5 = {
    prefix: "fas",
    iconName: "om",
    icon: [
        512,
        512,
        [
            128329
        ],
        "f679",
        "M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zM115.2 169.6c8-6 17.9-9.6 28.8-9.6c26.5 0 48 21.5 48 48s-21.5 48-48 48H109.8c-7.6 0-13.8 6.2-13.8 13.8c0 1.5 .2 2.9 .7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9H144h16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8c-9.9-10.8-16.6-21.6-20.9-29.7c-2.1-4-3.6-7.3-4.5-9.6c-.5-1.1-.8-2-1-2.5l-.2-.5 0-.1c-2.6-7.8-10.7-12.3-18.7-10.5C4.4 354.2-.9 361.8 .1 370L16 368C.1 370 .1 370 .1 370l0 0 0 0 0 .1 .1 .4c0 .3 .1 .8 .2 1.3c.2 1.1 .4 2.7 .8 4.6c.8 3.9 2 9.4 3.9 15.9c3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64h22.6c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32c-25.7 0-41.4-12.5-51.2-25.6c-5-6.7-8.4-13.4-10.5-18.6c-1.1-2.5-1.8-4.6-2.2-6c-.2-.7-.4-1.2-.5-1.5l-.1-.3 0 0c0 0 0 0 0 0c-1.9-7.3-8.6-12.4-16.2-12.1c-7.6 .3-13.9 5.9-15.1 13.4L336 368c-15.8-2.6-15.8-2.6-15.8-2.6l0 0 0 0 0 .1-.1 .3c0 .3-.1 .6-.2 1.1c-.1 .9-.3 2.1-.4 3.6c-.3 3-.6 7.3-.6 12.4c0 10.1 1.1 23.9 5.8 38.1c4.8 14.3 13.4 29.3 28.6 40.7C368.7 473.3 389.3 480 416 480c53 0 96-43 96-96V288c0-53-43-96-96-96h-5.5c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4H245.2c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-25.2 0-48.5 8.3-67.2 22.4c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4zM280.9 66.7c-6-4-14-3.5-19.5 1.3s-7 12.7-3.7 19.2L272 80c-14.3 7.2-14.3 7.2-14.3 7.2l0 0 0 0 0 .1 .1 .2 .4 .7c.3 .6 .8 1.4 1.4 2.4c1.2 2 2.9 4.8 5.1 8.2c4.4 6.7 11.1 15.5 20 24.4C302.4 141.1 330.3 160 368 160c31.2 0 56.6-10.4 73.9-20.2c8.7-5 15.6-9.9 20.4-13.8c2.4-1.9 4.3-3.6 5.7-4.9c.7-.6 1.3-1.2 1.7-1.6l.6-.5 .2-.2 .1-.1 0 0 0 0c0 0 0 0-22.6-22.6l22.6 22.6c12.5-12.5 12.5-32.8 0-45.3c-12.4-12.4-32.6-12.5-45.1-.2c-.1 .1-.2 .2-.5 .4c-.5 .5-1.5 1.3-2.8 2.4c-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6c-8.4-3.7-15.4-7.5-20.3-10.3c-2.4-1.4-4.3-2.5-5.6-3.3c-.6-.4-1.1-.7-1.4-.9l-.3-.2 0 0 0 0 0 0z"
    ]
};
var $8063e68b12ef6db0$export$2571e33fa6c25993 = {
    prefix: "fas",
    iconName: "worm",
    icon: [
        448,
        512,
        [],
        "e599",
        "M224 96c0-53 43-96 96-96h38.4C407.9 0 448 40.1 448 89.6V176v16V376c0 75.1-60.9 136-136 136s-136-60.9-136-136V296c0-22.1-17.9-40-40-40s-40 17.9-40 40V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V296c0-75.1 60.9-136 136-136s136 60.9 136 136v80c0 22.1 17.9 40 40 40s40-17.9 40-40V192H320c-53 0-96-43-96-96zm144-8c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $8063e68b12ef6db0$export$423555e8708eb4c7 = {
    prefix: "fas",
    iconName: "house-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e50b",
        "M320.7 351.7C329 262.1 404.3 192 496 192c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V480c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32V383.7c0-17.7 14.3-32 32-32h64l.7 0zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $8063e68b12ef6db0$export$cae5752c3e3b6545 = {
    prefix: "fas",
    iconName: "plug",
    icon: [
        384,
        512,
        [
            128268
        ],
        "f1e6",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8C297 398 352 333.4 352 256V224c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $8063e68b12ef6db0$export$877e5ae47a854215 = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [
        512,
        512,
        [],
        "f077",
        "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
    ]
};
var $8063e68b12ef6db0$export$2262d6b626de1120 = {
    prefix: "fas",
    iconName: "hand-spock",
    icon: [
        576,
        512,
        [
            128406
        ],
        "f259",
        "M246.9 23.7C242.3 6.6 224.8-3.5 207.7 1.1s-27.2 22.1-22.6 39.2L238 237.8c2.5 9.2-4.5 18.2-14 18.2c-6.4 0-12-4.2-13.9-10.3L166.6 102.7c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L99.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L156.8 448c43.1 41.1 100.4 64 160 64h10.9 8.2c.1 0 .1-.1 .1-.1s.1-.1 .1-.1c58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6L443.5 247.1c-1.6 5.3-6.4 8.9-12 8.9c-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7L355.1 235.1c-2.6 12.2-13.3 20.9-25.8 20.9c-11.9 0-22.4-8-25.4-19.5l-57-212.8z"
    ]
};
var $8063e68b12ef6db0$export$b85a7300fc7960b6 = {
    prefix: "fas",
    iconName: "stopwatch",
    icon: [
        448,
        512,
        [
            9201
        ],
        "f2f2",
        "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H224 176zm72 192V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$5a54c83033a0a56a = {
    prefix: "fas",
    iconName: "face-kiss",
    icon: [
        512,
        512,
        [
            128535,
            "kiss"
        ],
        "f596",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM208.4 208c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm128 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$c762a77aabf64fd0 = $8063e68b12ef6db0$export$5a54c83033a0a56a;
var $8063e68b12ef6db0$export$834071278537f121 = {
    prefix: "fas",
    iconName: "bridge-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e4cb",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $8063e68b12ef6db0$export$95a7394c24f57943 = {
    prefix: "fas",
    iconName: "face-grin-tongue",
    icon: [
        512,
        512,
        [
            128539,
            "grin-tongue"
        ],
        "f589",
        "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm176.4-16c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $8063e68b12ef6db0$export$ef222816a43a4b3a = $8063e68b12ef6db0$export$95a7394c24f57943;
var $8063e68b12ef6db0$export$a831eedd2f59c62f = {
    prefix: "fas",
    iconName: "chess-bishop",
    icon: [
        320,
        512,
        [
            9821
        ],
        "f43a",
        "M128 0C110.3 0 96 14.3 96 32c0 16.1 11.9 29.4 27.4 31.7C78.4 106.8 8 190 8 288c0 47.4 30.8 72.3 56 84.7V416H256V372.7c25.2-12.5 56-37.4 56-84.7c0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L270.8 154.6c-23.2-38.1-51.8-69.5-74.2-90.9C212.1 61.4 224 48.1 224 32c0-17.7-14.3-32-32-32H128zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $8063e68b12ef6db0$export$1dd161850c5bc64e = {
    prefix: "fas",
    iconName: "face-grin-wink",
    icon: [
        512,
        512,
        [
            "grin-wink"
        ],
        "f58c",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-16.9-79.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM176.4 240c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$2397fcd34eb12177 = $8063e68b12ef6db0$export$1dd161850c5bc64e;
var $8063e68b12ef6db0$export$c9c5b76ec992eab4 = {
    prefix: "fas",
    iconName: "ear-deaf",
    icon: [
        512,
        512,
        [
            "deaf",
            "deafness",
            "hard-of-hearing"
        ],
        "f2a4",
        "M502.6 54.6l-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-320 320l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM240 128c-57.6 0-105.1 43.6-111.3 99.5c-1.9 17.6-17.8 30.2-35.3 28.3s-30.2-17.8-28.3-35.3C74.8 132.5 149.4 64 240 64c97.2 0 176 78.8 176 176c0 46-17.7 87.9-46.6 119.3c-12 13-17.4 24.8-17.4 34.7V400c0 61.9-50.1 112-112 112c-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48v-6.1c0-32.9 17.4-59.6 34.4-78c18.4-20 29.6-46.6 29.6-75.9c0-61.9-50.1-112-112-112zm0 80c-17.7 0-32 14.3-32 32c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32z"
    ]
};
var $8063e68b12ef6db0$export$4b666adf83f0de01 = $8063e68b12ef6db0$export$c9c5b76ec992eab4;
var $8063e68b12ef6db0$export$85c6a9ab2fa2631e = $8063e68b12ef6db0$export$c9c5b76ec992eab4;
var $8063e68b12ef6db0$export$ebecf90a5676e17a = $8063e68b12ef6db0$export$c9c5b76ec992eab4;
var $8063e68b12ef6db0$export$3f22db9ae9b6be1c = {
    prefix: "fas",
    iconName: "road-circle-check",
    icon: [
        640,
        512,
        [],
        "e564",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM640 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zm-76.7-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $8063e68b12ef6db0$export$d9769fb795c2db82 = {
    prefix: "fas",
    iconName: "dice-five",
    icon: [
        448,
        512,
        [
            9860
        ],
        "f523",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 160c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm32 160c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm64-64c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zM352 160c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM320 384c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$97d1903b1e012ff7 = {
    prefix: "fas",
    iconName: "square-rss",
    icon: [
        448,
        512,
        [
            "rss-square"
        ],
        "f143",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 136c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm64 120c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$89c9b1cca2c11484 = $8063e68b12ef6db0$export$97d1903b1e012ff7;
var $8063e68b12ef6db0$export$567a897fc092e403 = {
    prefix: "fas",
    iconName: "land-mine-on",
    icon: [
        640,
        512,
        [],
        "e51b",
        "M344 24V168c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 320c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v32H192V320zm-77.3 90.5c8.1-16.3 24.8-26.5 42.9-26.5H482.3c18.2 0 34.8 10.3 42.9 26.5l27.6 55.2C563.5 487 548 512 524.2 512H115.8c-23.8 0-39.3-25-28.6-46.3l27.6-55.2zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"
    ]
};
var $8063e68b12ef6db0$export$7fddf76ec23943d8 = {
    prefix: "fas",
    iconName: "i-cursor",
    icon: [
        256,
        512,
        [],
        "f246",
        "M.1 29.3C-1.4 47 11.7 62.4 29.3 63.9l8 .7C70.5 67.3 96 95 96 128.3V224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v95.7c0 33.3-25.5 61-58.7 63.8l-8 .7C11.7 449.6-1.4 465 .1 482.7s16.9 30.7 34.5 29.2l8-.7c34.1-2.8 64.2-18.9 85.4-42.9c21.2 24 51.2 40.1 85.4 42.9l8 .7c17.6 1.5 33.1-11.6 34.5-29.2s-11.6-33.1-29.2-34.5l-8-.7C185.5 444.7 160 417 160 383.7V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V128.3c0-33.3 25.5-61 58.7-63.8l8-.7c17.6-1.5 30.7-16.9 29.2-34.5S239-1.4 221.3 .1l-8 .7C179.2 3.6 149.2 19.7 128 43.7c-21.2-24-51.2-40-85.4-42.9l-8-.7C17-1.4 1.6 11.7 .1 29.3z"
    ]
};
var $8063e68b12ef6db0$export$722e92d2d93ffc68 = {
    prefix: "fas",
    iconName: "stamp",
    icon: [
        512,
        512,
        [],
        "f5bf",
        "M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8c10.7 13.8 19.9 29.6 19.9 47c0 29.9-24.3 54.2-54.2 54.2H112C50.1 256 0 306.1 0 368c0 20.9 13.4 38.7 32 45.3V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V413.3c18.6-6.6 32-24.4 32-45.3c0-61.9-50.1-112-112-112H366.2c-29.9 0-54.2-24.3-54.2-54.2zM416 416v32H96V416H416z"
    ]
};
var $8063e68b12ef6db0$export$68b3af7444c89df7 = {
    prefix: "fas",
    iconName: "stairs",
    icon: [
        576,
        512,
        [],
        "e289",
        "M384 64c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v96c0 17.7-14.3 32-32 32H320v96c0 17.7-14.3 32-32 32H192v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V320c0-17.7 14.3-32 32-32h96V192c0-17.7 14.3-32 32-32h96V64z"
    ]
};
var $8063e68b12ef6db0$export$aee03ca0815b7c38 = {
    prefix: "fas",
    iconName: "i",
    icon: [
        320,
        512,
        [
            105
        ],
        "49",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96h96V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V96h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 32z"
    ]
};
var $8063e68b12ef6db0$export$22a9491150c64fef = {
    prefix: "fas",
    iconName: "hryvnia-sign",
    icon: [
        384,
        512,
        [
            8372,
            "hryvnia"
        ],
        "f6f2",
        "M121.9 116.2C138.3 103.1 158.7 96 179.6 96H223c27.1 0 49 21.9 49 49c0 11.5-4 22.4-11.1 31H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H155.5l-50.6 28.9c-1.7 1-3.4 2-5.1 3.1H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H52.3c-2.8 9.9-4.3 20.4-4.3 31c0 62.4 50.6 113 113 113h43.4c35.5 0 70-12.1 97.7-34.3L308 441c13.8-11 16-31.2 5-45s-31.2-16-45-5l-5.9 4.7c-16.4 13.1-36.7 20.2-57.7 20.2H161c-27.1 0-49-21.9-49-49c0-11.5 4-22.4 11.1-31H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H228.5l50.6-28.9c1.7-1 3.4-2 5.1-3.1H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H331.7c2.8-10 4.3-20.4 4.3-31c0-62.4-50.6-113-113-113H179.6c-35.5 0-70 12.1-97.7 34.3L76 71c-13.8 11-16 31.2-5 45s31.2 16 45 5l5.9-4.7z"
    ]
};
var $8063e68b12ef6db0$export$33d5f94bd6f75f59 = $8063e68b12ef6db0$export$22a9491150c64fef;
var $8063e68b12ef6db0$export$6380e2ed6e69d350 = {
    prefix: "fas",
    iconName: "pills",
    icon: [
        576,
        512,
        [],
        "f484",
        "M112 96c-26.5 0-48 21.5-48 48V256h96V144c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112V368c0 61.9-50.1 112-112 112S0 429.9 0 368V144zM554.9 399.4c-7.1 12.3-23.7 13.1-33.8 3.1L333.5 214.9c-10-10-9.3-26.7 3.1-33.8C360 167.7 387.1 160 416 160c88.4 0 160 71.6 160 160c0 28.9-7.7 56-21.1 79.4zm-59.5 59.5C472 472.3 444.9 480 416 480c-88.4 0-160-71.6-160-160c0-28.9 7.7-56 21.1-79.4c7.1-12.3 23.7-13.1 33.8-3.1L498.5 425.1c10 10 9.3 26.7-3.1 33.8z"
    ]
};
var $8063e68b12ef6db0$export$bdbabf493c478cde = {
    prefix: "fas",
    iconName: "face-grin-wide",
    icon: [
        512,
        512,
        [
            128515,
            "grin-alt"
        ],
        "f581",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM383.8 317.8c12.3-3.7 24.3 7 19.2 18.7c-24.5 56.9-81.1 96.7-147 96.7s-122.5-39.8-147-96.7c-5.1-11.8 6.9-22.4 19.2-18.7C166.7 329.4 210.1 336 256 336s89.3-6.6 127.8-18.2zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
    ]
};
var $8063e68b12ef6db0$export$b4abebfe416d36ba = $8063e68b12ef6db0$export$bdbabf493c478cde;
var $8063e68b12ef6db0$export$3a1fa2d16f90d635 = {
    prefix: "fas",
    iconName: "tooth",
    icon: [
        384,
        512,
        [
            129463
        ],
        "f5c9",
        "M154.1 52.1C137.3 39.1 116.7 32 95.5 32C42.7 32 0 74.7 0 127.5v6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2L80.4 460.2c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C160.2 323.7 175 312 192 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5v-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 19.5 15.2c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z"
    ]
};
var $8063e68b12ef6db0$export$6fb446f784f6b9b3 = {
    prefix: "fas",
    iconName: "v",
    icon: [
        448,
        512,
        [
            118
        ],
        "56",
        "M51.7 34.5c16.3-6.8 35 .9 41.8 17.2L224 364.8 354.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7l-160-384c-6.8-16.3 .9-35 17.2-41.8z"
    ]
};
var $8063e68b12ef6db0$export$36cb1885ad7a570f = {
    prefix: "fas",
    iconName: "bicycle",
    icon: [
        640,
        512,
        [
            128690
        ],
        "f206",
        "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h25.7l34.6 64H222.9l-27.4-38C191 99.7 183.7 96 176 96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h43.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h49c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32H312zM458.6 303.7l32.3 59.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-32.3-59.7c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3zM133.2 368h65c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l-24.2 48.5c-9 18.1 4.1 39.4 24.3 39.4zm33.7-48l50.7-101.3 72.9 101.2-.1 .1H166.8zm90.6-128H365.9L317 274.8 257.4 192z"
    ]
};
var $8063e68b12ef6db0$export$76d998742bc186eb = {
    prefix: "fas",
    iconName: "staff-snake",
    icon: [
        384,
        512,
        [
            "rod-asclepius",
            "rod-snake",
            "staff-aesculapius"
        ],
        "e579",
        "M222.6 43.2l-.2 4.8H288c53 0 96 43 96 96s-43 96-96 96H248V160h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H248 220l-4.5 144H256c53 0 96 43 96 96s-43 96-96 96H240V384h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H213l-3.1 99.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1-31H136c-22.1 0-40-17.9-40-40s17.9-40 40-40h36l-1-32H152c-53 0-96-43-96-96c0-47.6 34.6-87.1 80-94.7V256c0 8.8 7.2 16 16 16h16.5L164 128H136 122.6c-9 18.9-28.3 32-50.6 32H56c-30.9 0-56-25.1-56-56S25.1 48 56 48h8 8 89.5l-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16z"
    ]
};
var $8063e68b12ef6db0$export$f2c3e92ee37a8d89 = $8063e68b12ef6db0$export$76d998742bc186eb;
var $8063e68b12ef6db0$export$5d61dcb598296af0 = $8063e68b12ef6db0$export$76d998742bc186eb;
var $8063e68b12ef6db0$export$97c8a2cdba3b7700 = $8063e68b12ef6db0$export$76d998742bc186eb;
var $8063e68b12ef6db0$export$b293ee8fb8e6b0c4 = {
    prefix: "fas",
    iconName: "head-side-cough-slash",
    icon: [
        640,
        512,
        [],
        "e062",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.3 319.8c22.3-2.1 39.7-20.8 39.7-43.7c0-10-3.4-19.6-9.6-27.4l-42-52.6c-8.3-10.3-12.8-23-15-36.1C398.2 69.3 319.2 0 224 0H201.7C157 0 115.7 14.5 82.2 39.2L38.8 5.1zM0 201.7c0 44.8 18.3 91.5 46.5 127.7C56.9 342.8 64 358.8 64 375.8V480c0 17.7 14.3 32 32 32H256c17.7 0 32-14.3 32-32h64c32.8 0 59.9-24.7 63.6-56.6l-9.4-7.4H352c-17.7 0-32-14.3-32-32c0-10.5 5.1-19.9 12.9-25.7L20.8 112.4C7.5 139.3 0 169.6 0 201.7zM632 288c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zm-88 72c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm64 48c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $8063e68b12ef6db0$export$fb6bd43f079f72e2 = {
    prefix: "fas",
    iconName: "truck-medical",
    icon: [
        640,
        512,
        [
            128657,
            "ambulance"
        ],
        "f0f9",
        "M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM208 416c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zm272 48c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zM112 144c0-8.8 7.2-16 16-16h48V80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240v48c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16V192H128c-8.8 0-16-7.2-16-16V144z"
    ]
};
var $8063e68b12ef6db0$export$f5c7042778b51765 = $8063e68b12ef6db0$export$fb6bd43f079f72e2;
var $8063e68b12ef6db0$export$e23367e54f665590 = {
    prefix: "fas",
    iconName: "wheat-awn-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e598",
        "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.6c-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$b23df6bafb174693 = {
    prefix: "fas",
    iconName: "snowman",
    icon: [
        576,
        512,
        [
            9731,
            9924
        ],
        "f7d0",
        "M373.1 140.6c-2 3.9-1.6 8.6 1.2 12c7 8.5 12.9 18.1 17.2 28.4L440 160.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24v19.6l22.5-9.7c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-56 24-73.6 31.5c-.5 9.5-2.1 18.6-4.8 27.3c-1.2 3.8-.1 8 2.8 10.8C428.7 296.9 448 338.2 448 384c0 44.7-18.3 85-47.8 114.1c-9.9 9.7-23.7 13.9-37.5 13.9H213.3c-13.9 0-27.7-4.2-37.5-13.9C146.3 469 128 428.7 128 384c0-45.8 19.3-87.1 50.1-116.3c2.9-2.8 4-6.9 2.8-10.8c-2.7-8.7-4.3-17.9-4.8-27.3l-73.6-31.5-56-24c-12.2-5.2-17.8-19.3-12.6-31.5s19.3-17.8 31.5-12.6L88 139.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24v40.2L184.6 181c4.3-10.3 10.1-19.9 17.2-28.4c2.8-3.4 3.3-8.1 1.2-12C196 127.2 192 112.1 192 96c0-53 43-96 96-96s96 43 96 96c0 16.1-4 31.2-10.9 44.6zM256 96c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm48 128c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm-16 80c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm16 48c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zM320 96c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm-48 24v3.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V120c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ]
};
var $8063e68b12ef6db0$export$55ceb5d0c144580a = {
    prefix: "fas",
    iconName: "mortar-pestle",
    icon: [
        512,
        512,
        [],
        "f5a7",
        "M504.3 11.1C493.3-1.6 474.5-3.7 461 6.2L252.3 160H397.3L502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5zM32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c0 82.5 43.4 147.7 123.9 176.2c-11.1 13.9-19.4 30.3-23.9 48.1C127.6 497.4 142.3 512 160 512H352c17.7 0 32.4-14.6 28.1-31.7c-4.5-17.8-12.8-34.1-23.9-48.1C436.6 403.7 480 338.5 480 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $8063e68b12ef6db0$export$f3e925217e396f44 = {
    prefix: "fas",
    iconName: "road-barrier",
    icon: [
        640,
        512,
        [],
        "e562",
        "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V266.3L149.2 96H64V64c0-17.7-14.3-32-32-32zM405.2 96H330.8l-5.4 10.7L234.8 288h74.3l5.4-10.7L405.2 96zM362.8 288h74.3l5.4-10.7L533.2 96H458.8l-5.4 10.7L362.8 288zM202.8 96l-5.4 10.7L106.8 288h74.3l5.4-10.7L277.2 96H202.8zm288 192H576V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v53.7L490.8 288z"
    ]
};
var $8063e68b12ef6db0$export$51e9b8434982947d = {
    prefix: "fas",
    iconName: "school",
    icon: [
        640,
        512,
        [
            127979
        ],
        "f549",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4l-139 92.7L37.6 126C15.6 130.9 0 150.3 0 172.8V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V172.8c0-22.5-15.6-42-37.6-46.9L476.8 98.1 337.8 5.4zM256 416c0-35.3 28.7-64 64-64s64 28.7 64 64v96H256V416zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V208zM96 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V336zM408 176c0 48.6-39.4 88-88 88s-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88zm-88-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16z"
    ]
};
var $8063e68b12ef6db0$export$4a284575edd6f1af = {
    prefix: "fas",
    iconName: "igloo",
    icon: [
        576,
        512,
        [],
        "f7ae",
        "M320 33.8V160H48.5C100.2 82.8 188.1 32 288 32c10.8 0 21.5 .6 32 1.8zM352 160V39.1C424.9 55.7 487.2 99.8 527.5 160H352zM29.9 192H96V320H0c0-46 10.8-89.4 29.9-128zM192 320H128V192H448V320H384v32H576v80c0 26.5-21.5 48-48 48H352V352c0-35.3-28.7-64-64-64s-64 28.7-64 64V480H48c-26.5 0-48-21.5-48-48V352H192V320zm288 0V192h66.1c19.2 38.6 29.9 82 29.9 128H480z"
    ]
};
var $8063e68b12ef6db0$export$e5a289fb22ffb8cb = {
    prefix: "fas",
    iconName: "joint",
    icon: [
        640,
        512,
        [],
        "f595",
        "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9v11c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43V32zM576 256c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v11zM229.8 360c-4.7-2.3-10-2.7-15.2-2c-37.8 5.6-75.2 14.3-106.9 22.8C81.3 388 58.3 395.1 42 400.4c-8.2 2.7-14.7 4.9-19.2 6.5c-2.3 .8-4 1.4-5.2 1.8l-1.3 .5C6.8 412.5 0 421.4 0 432s6.8 19.5 16.3 22.7l1.3 .5c1.2 .4 3 1.1 5.2 1.8c4.5 1.6 11 3.8 19.2 6.5c16.3 5.4 39.2 12.5 65.7 19.6C160.3 497.3 228.8 512 288 512h67.3c4.1 0 6.3-5.1 3.6-8.3L256.5 380.8c-7.4-8.9-16.5-15.9-26.7-20.8zM445 512h19 51.3c4.1 0 6.3-5.1 3.6-8.3L416.5 380.8C401.3 362.5 378.8 352 355 352H336 288c-1.1 0-2.3 0-3.4 0c-4.1 0-6.2 5.1-3.5 8.3L383.5 483.2C398.7 501.5 421.2 512 445 512zm-3.9-151.7L543.5 483.2c14.6 17.5 35.9 27.9 58.6 28.7c21.1-1.1 37.9-18.6 37.9-39.9V392c0-22.1-17.9-40-40-40H444.7c-4.1 0-6.3 5.1-3.6 8.3z"
    ]
};
var $8063e68b12ef6db0$export$6bce1afb61f2eb66 = {
    prefix: "fas",
    iconName: "angle-right",
    icon: [
        320,
        512,
        [
            8250
        ],
        "f105",
        "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
    ]
};
var $8063e68b12ef6db0$export$5b05f097fa38352a = {
    prefix: "fas",
    iconName: "horse",
    icon: [
        576,
        512,
        [
            128014
        ],
        "f6f0",
        "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C377.3 0 320 57.3 320 128H224 203.2 148.8c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 96c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16z"
    ]
};
var $8063e68b12ef6db0$export$5a2b164552deda9f = {
    prefix: "fas",
    iconName: "q",
    icon: [
        512,
        512,
        [
            113
        ],
        "51",
        "M96 256c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1C403.9 325.8 416 292.3 416 256c0-88.4-71.6-160-160-160S96 167.6 96 256zM376.9 444.6C342 467 300.5 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z"
    ]
};
var $8063e68b12ef6db0$export$9f5c2b0db8eedeac = {
    prefix: "fas",
    iconName: "g",
    icon: [
        448,
        512,
        [
            103
        ],
        "47",
        "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32c0 123.7-100.3 224-224 224S0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z"
    ]
};
var $8063e68b12ef6db0$export$b2d79133c81d6697 = {
    prefix: "fas",
    iconName: "notes-medical",
    icon: [
        512,
        512,
        [],
        "f481",
        "M96 352V96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V293.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7H160c-35.3 0-64-28.7-64-64zM272 128c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H320V144c0-8.8-7.2-16-16-16H272zm24 336c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88H296z"
    ]
};
var $8063e68b12ef6db0$export$a3f1d7f13c202adc = {
    prefix: "fas",
    iconName: "temperature-half",
    icon: [
        320,
        512,
        [
            127777,
            "temperature-2",
            "thermometer-2",
            "thermometer-half"
        ],
        "f2c9",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V200c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $8063e68b12ef6db0$export$8176e649df45b32c = $8063e68b12ef6db0$export$a3f1d7f13c202adc;
var $8063e68b12ef6db0$export$4dd764ac8d512682 = $8063e68b12ef6db0$export$a3f1d7f13c202adc;
var $8063e68b12ef6db0$export$2090f040324b4449 = $8063e68b12ef6db0$export$a3f1d7f13c202adc;
var $8063e68b12ef6db0$export$18659308f17918a5 = {
    prefix: "fas",
    iconName: "dong-sign",
    icon: [
        384,
        512,
        [],
        "e169",
        "M288 32c-17.7 0-32 14.3-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v49.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32V288 128c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32zM256 288c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $8063e68b12ef6db0$export$ba6fd4a436804a48 = {
    prefix: "fas",
    iconName: "capsules",
    icon: [
        576,
        512,
        [],
        "f46b",
        "M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48V256H64V144zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm296.6 64.2c-16-23.3-10-55.3 11.9-71c21.2-15.1 50.5-10.3 66 12.2l67 97.6L361.6 303l-65-94.8zM491 407.7c-.8 .6-1.6 1.1-2.4 1.6l4-2.8c-.5 .4-1 .8-1.6 1.2z"
    ]
};
var $8063e68b12ef6db0$export$48a38da471b097a2 = {
    prefix: "fas",
    iconName: "poo-storm",
    icon: [
        448,
        512,
        [
            "poo-bolt"
        ],
        "f75a",
        "M236.9 .2c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1c0 44.3-35.8 80.1-80 80.1c-1.4 0-2.8 .2-4 .5H128c-35.3 0-64 28.7-64 64c0 12.4 3.5 24 9.7 33.8C31.6 234.3 0 271.5 0 316c0 49.1 38.5 89.2 86.9 91.9c-1.8-2.9-3.4-6.1-4.5-9.4c-6-17.5-.5-36.9 13.6-48.5L238.2 233.6c15.6-12.8 37.9-12.7 53.5 .1s20.3 35.1 11.3 53.4l-26 53.2h16.3c18.1 0 34.3 11.7 40.3 29.2c4.5 13.1 2.6 27.3-4.6 38.4h27c50.8 0 92-41.2 92-92c0-44.5-31.6-81.7-73.7-90.2c6.1-9.8 9.7-21.4 9.7-33.8c0-35.3-28.7-64-64-64h-5.7c3.7-10.2 5.7-21.1 5.7-32.6c0-48.7-36.1-88.9-83.1-95.2zm34.2 259.2c-6-4.6-14.3-4.4-20.1 .4l-133.4 112c-5.2 4.3-7 11.4-4.7 17.7s8.3 10.5 15 10.5h54.7l-42.5 89.1c-3.2 6.8-1.3 14.9 4.7 19.5s14.3 4.4 20.1-.4l133.4-112c5.1-4.3 7-11.4 4.7-17.7s-8.3-10.5-15-10.5H233.3l42.5-89.1c3.2-6.8 1.3-14.9-4.7-19.5z"
    ]
};
var $8063e68b12ef6db0$export$9a24e77f74d9cbd9 = $8063e68b12ef6db0$export$48a38da471b097a2;
var $8063e68b12ef6db0$export$c8a28356e07b9ccb = {
    prefix: "fas",
    iconName: "face-frown-open",
    icon: [
        512,
        512,
        [
            128550,
            "frown-open"
        ],
        "f57a",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM176.4 240c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm-186 174.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8z"
    ]
};
var $8063e68b12ef6db0$export$c4775e66bed5d96 = $8063e68b12ef6db0$export$c8a28356e07b9ccb;
var $8063e68b12ef6db0$export$cdc9f5e7e94e76da = {
    prefix: "fas",
    iconName: "hand-point-up",
    icon: [
        384,
        512,
        [
            9757
        ],
        "f0a6",
        "M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32V240H32V32zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
    ]
};
var $8063e68b12ef6db0$export$608138a7337b5d1a = {
    prefix: "fas",
    iconName: "money-bill",
    icon: [
        576,
        512,
        [],
        "f0d6",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM288 352c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96z"
    ]
};
var $8063e68b12ef6db0$export$4ed9da5c3cca0ef1 = {
    prefix: "fas",
    iconName: "bookmark",
    icon: [
        384,
        512,
        [
            128278,
            61591
        ],
        "f02e",
        "M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"
    ]
};
var $8063e68b12ef6db0$export$97c42b56d462df72 = {
    prefix: "fas",
    iconName: "align-justify",
    icon: [
        448,
        512,
        [],
        "f039",
        "M448 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"
    ]
};
var $8063e68b12ef6db0$export$20932e4d438e4e4c = {
    prefix: "fas",
    iconName: "umbrella-beach",
    icon: [
        576,
        512,
        [
            127958
        ],
        "f5ca",
        "M346.3 271.8l-60.1-21.9L214 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H282.1l64.1-176.2zm121.1-.2l-3.3 9.1 67.7 24.6c18.1 6.6 38-4.2 39.6-23.4c6.5-78.5-23.9-155.5-80.8-208.5c2 8 3.2 16.3 3.4 24.8l.2 6c1.8 57-7.3 113.8-26.8 167.4zM462 99.1c-1.1-34.4-22.5-64.8-54.4-77.4c-.9-.4-1.9-.7-2.8-1.1c-33-11.7-69.8-2.4-93.1 23.8l-4 4.5C272.4 88.3 245 134.2 226.8 184l-3.3 9.1L434 269.7l3.3-9.1c18.1-49.8 26.6-102.5 24.9-155.5l-.2-6zM107.2 112.9c-11.1 15.7-2.8 36.8 15.3 43.4l71 25.8 3.3-9.1c19.5-53.6 49.1-103 87.1-145.5l4-4.5c6.2-6.9 13.1-13 20.5-18.2c-79.6 2.5-154.7 42.2-201.2 108z"
    ]
};
var $8063e68b12ef6db0$export$5e975cb293c48461 = {
    prefix: "fas",
    iconName: "helmet-un",
    icon: [
        512,
        512,
        [],
        "e503",
        "M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240v56.3C0 344.8 39.2 384 87.7 384H200h14.9L343.5 505.4c4.5 4.2 10.4 6.6 16.5 6.6h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H369.5l-1.5-1.5V288h80 32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.5zM320 417.2l-78-73.7L274.4 288H320V417.2zM285.3 103.1l34.7 52V112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112v64c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$554720e3bf74fe90 = {
    prefix: "fas",
    iconName: "bullseye",
    icon: [
        512,
        512,
        [],
        "f140",
        "M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192s192-86 192-192zm64 0c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM256 336c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zm0 64c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm32-144c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$ab07061fe21a3a8e = {
    prefix: "fas",
    iconName: "bacon",
    icon: [
        576,
        512,
        [
            129363
        ],
        "f7e5",
        "M439.2 1.2c11.2-3.2 23.2-.1 31.4 8.1L518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7L37.9 435.2 9.4 406.6c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8zM61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6l0 0 .2-.1 43.1-12.9 23 23c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6L61.8 459z"
    ]
};
var $8063e68b12ef6db0$export$f6dcbf0a940428f4 = {
    prefix: "fas",
    iconName: "hand-point-down",
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M32 480c0 17.7 14.3 32 32 32s32-14.3 32-32V272H32V480zM224 320c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-64 64c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm160-96c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-96-88l0 .6c9.4-5.4 20.3-8.6 32-8.6c13.2 0 25.4 4 35.6 10.8c8.7-24.9 32.5-42.8 60.4-42.8c11.7 0 22.6 3.1 32 8.6V160C384 71.6 312.4 0 224 0H162.3C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149v27c0 35.3 28.7 64 64 64h88c22.1 0 40-17.9 40-40s-17.9-40-40-40H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c39.8 0 72 32.2 72 72z"
    ]
};
var $8063e68b12ef6db0$export$c2af1be14cd87640 = {
    prefix: "fas",
    iconName: "arrow-up-from-bracket",
    icon: [
        448,
        512,
        [],
        "e09a",
        "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 53 43 96 96 96H352c53 0 96-43 96-96V352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352z"
    ]
};
var $8063e68b12ef6db0$export$72b780186370e953 = {
    prefix: "fas",
    iconName: "folder",
    icon: [
        512,
        512,
        [
            128193,
            128447,
            61716,
            "folder-blank"
        ],
        "f07b",
        "M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"
    ]
};
var $8063e68b12ef6db0$export$9ef114244d26da0 = $8063e68b12ef6db0$export$72b780186370e953;
var $8063e68b12ef6db0$export$5e0c19cf315ac1bf = {
    prefix: "fas",
    iconName: "file-waveform",
    icon: [
        384,
        512,
        [
            "file-medical-alt"
        ],
        "f478",
        "M64 0C28.7 0 0 28.7 0 64V288H112c6.1 0 11.6 3.4 14.3 8.8L144 332.2l49.7-99.4c2.7-5.4 8.2-8.8 14.3-8.8s11.6 3.4 14.3 8.8L249.9 288H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-6.1 0-11.6-3.4-14.3-8.8L208 275.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L102.1 320H0V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0z"
    ]
};
var $8063e68b12ef6db0$export$ef02a0f5b39aa61f = $8063e68b12ef6db0$export$5e0c19cf315ac1bf;
var $8063e68b12ef6db0$export$4c4e509518093d6d = {
    prefix: "fas",
    iconName: "radiation",
    icon: [
        512,
        512,
        [],
        "f7b9",
        "M216 186.7c-23.9 13.8-40 39.7-40 69.3L32 256C14.3 256-.2 241.6 2 224.1C10.7 154 47.8 92.7 101.3 52c14.1-10.7 33.8-5.3 42.7 10l72 124.7zM256 336c14.6 0 28.2-3.9 40-10.7l72 124.8c8.8 15.3 3.7 35.1-12.6 41.9c-30.6 12.9-64.2 20-99.4 20s-68.9-7.1-99.4-20c-16.3-6.9-21.4-26.6-12.6-41.9l72-124.8c11.8 6.8 25.4 10.7 40 10.7zm224-80l-144 0c0-29.6-16.1-55.5-40-69.3L368 62c8.8-15.3 28.6-20.7 42.7-10c53.6 40.7 90.6 102 99.4 172.1c2.2 17.5-12.4 31.9-30 31.9zM256 304c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $8063e68b12ef6db0$export$8760a1de19ea40b9 = {
    prefix: "fas",
    iconName: "chart-simple",
    icon: [
        448,
        512,
        [],
        "e473",
        "M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
    ]
};
var $8063e68b12ef6db0$export$aa05fce255a5d269 = {
    prefix: "fas",
    iconName: "mars-stroke",
    icon: [
        512,
        512,
        [
            9894
        ],
        "f229",
        "M376 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L370.3 96.4 345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H376zm88 48h0v0l0 0zM320 304c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112z"
    ]
};
var $8063e68b12ef6db0$export$aa014b06d2d70598 = {
    prefix: "fas",
    iconName: "vial",
    icon: [
        512,
        512,
        [
            129514
        ],
        "f492",
        "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L28.1 342.6C10.1 360.6 0 385 0 410.5V416c0 53 43 96 96 96h5.5c25.5 0 49.9-10.1 67.9-28.1L448 205.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32-96-96-32-32zM205.3 256L352 109.3 402.7 160l-96 96H205.3z"
    ]
};
var $8063e68b12ef6db0$export$dbfb0a9f89ad94a4 = {
    prefix: "fas",
    iconName: "gauge",
    icon: [
        512,
        512,
        [
            "dashboard",
            "gauge-med",
            "tachometer-alt-average"
        ],
        "f624",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM320 352c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm-16 80c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm288 32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM400 144c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $8063e68b12ef6db0$export$b7ce24136743d0f1 = $8063e68b12ef6db0$export$dbfb0a9f89ad94a4;
var $8063e68b12ef6db0$export$f948a9dd257979f3 = $8063e68b12ef6db0$export$dbfb0a9f89ad94a4;
var $8063e68b12ef6db0$export$6f22c345e5a92d1a = $8063e68b12ef6db0$export$dbfb0a9f89ad94a4;
var $8063e68b12ef6db0$export$5325fc72e75360b4 = {
    prefix: "fas",
    iconName: "wand-magic-sparkles",
    icon: [
        576,
        512,
        [
            "magic-wand-sparkles"
        ],
        "e2ca",
        "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"
    ]
};
var $8063e68b12ef6db0$export$c93286938249f0da = $8063e68b12ef6db0$export$5325fc72e75360b4;
var $8063e68b12ef6db0$export$86923e6fe1b42f5e = {
    prefix: "fas",
    iconName: "e",
    icon: [
        320,
        512,
        [
            101
        ],
        "45",
        "M32 32C14.3 32 0 46.3 0 64V256 448c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $8063e68b12ef6db0$export$eff4bdcafd3b8d1c = {
    prefix: "fas",
    iconName: "pen-clip",
    icon: [
        512,
        512,
        [
            "pen-alt"
        ],
        "f305",
        "M453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-52.1 52.1 0 0-1-1 0 0-16-16-96-96-17-17 52.1-52.1c25-25 65.5-25 90.5 0zM241 114.9c-9.4-9.4-24.6-9.4-33.9 0L105 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L173.1 81c28.1-28.1 73.7-28.1 101.8 0L288 94.1l17 17 96 96 16 16 1 1-17 17L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L254.1 128 241 114.9z"
    ]
};
var $8063e68b12ef6db0$export$a3d3e92e430d3beb = $8063e68b12ef6db0$export$eff4bdcafd3b8d1c;
var $8063e68b12ef6db0$export$4f25939fdf728c27 = {
    prefix: "fas",
    iconName: "bridge-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e4ca",
        "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$f5699fa0844e0188 = {
    prefix: "fas",
    iconName: "user",
    icon: [
        448,
        512,
        [
            128100,
            62144
        ],
        "f007",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"
    ]
};
var $8063e68b12ef6db0$export$c8c95c2f9937bf6a = {
    prefix: "fas",
    iconName: "school-circle-check",
    icon: [
        640,
        512,
        [],
        "e56b",
        "M337.8 5.4C327-1.8 313-1.8 302.2 5.4l-139 92.7L37.6 126C15.6 130.9 0 150.3 0 172.8V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V172.8c0-22.5-15.6-42-37.6-46.9L476.8 98.1 337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM640 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"
    ]
};
var $8063e68b12ef6db0$export$3b934e22d1851a3b = {
    prefix: "fas",
    iconName: "dumpster",
    icon: [
        576,
        512,
        [],
        "f793",
        "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0H428.5L402.9 32H304V160zm157.1 0h94c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l25.6 128zM32 192l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H448c0 17.7 14.3 32 32 32s32-14.3 32-32l20-160h12c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4l4-32H32z"
    ]
};
var $8063e68b12ef6db0$export$ecbd233b96906ee1 = {
    prefix: "fas",
    iconName: "van-shuttle",
    icon: [
        640,
        512,
        [
            128656,
            "shuttle-van"
        ],
        "f5b6",
        "M64 104v88h96V96H72c-4.4 0-8 3.6-8 8zm482 88L465.1 96H384v96H546zm-226 0V96H224v96h96zM592 384H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V104C0 64.2 32.2 32 72 32H192 352 465.1c18.9 0 36.8 8.3 49 22.8L625 186.5c9.7 11.5 15 26.1 15 41.2V336c0 26.5-21.5 48-48 48zm-64 0c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM160 432c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
    ]
};
var $8063e68b12ef6db0$export$9d63d851db698c09 = $8063e68b12ef6db0$export$ecbd233b96906ee1;
var $8063e68b12ef6db0$export$d65aef1ed7db1dae = {
    prefix: "fas",
    iconName: "building-user",
    icon: [
        640,
        512,
        [],
        "e4da",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h89.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM576 272c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80s80-35.8 80-80zM352 477.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H445.1c-51.4 0-93.1 41.7-93.1 93.1z"
    ]
};
var $8063e68b12ef6db0$export$2c5163541229363 = {
    prefix: "fas",
    iconName: "square-caret-left",
    icon: [
        448,
        512,
        [
            "caret-square-left"
        ],
        "f191",
        "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
    ]
};
var $8063e68b12ef6db0$export$d0c8ba444f1f9581 = $8063e68b12ef6db0$export$2c5163541229363;
var $8063e68b12ef6db0$export$73801ed54b42fabe = {
    prefix: "fas",
    iconName: "highlighter",
    icon: [
        576,
        512,
        [],
        "f591",
        "M331 315l158.4-215L460.1 70.6 245 229 331 315zm-187 5l0 0V248.3c0-15.3 7.2-29.6 19.5-38.6L436.6 8.4C444 2.9 453 0 462.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L350.4 396.5c-9 12.3-23.4 19.5-38.6 19.5H240l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L144 320zM23 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7H40c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z"
    ]
};
var $8063e68b12ef6db0$export$fa6ecc35e7315db = {
    prefix: "fas",
    iconName: "key",
    icon: [
        512,
        512,
        [
            128273
        ],
        "f084",
        "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zm40-176c-22.1 0-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40z"
    ]
};
var $8063e68b12ef6db0$export$dacae2b4ec565333 = {
    prefix: "fas",
    iconName: "bullhorn",
    icon: [
        512,
        512,
        [
            128226,
            128363
        ],
        "f0a1",
        "M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75H192 160 64c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352l8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V300.4c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4V32zm-64 76.7V240 371.3C357.2 317.8 280.5 288 200.7 288H192V192h8.7c79.8 0 156.5-29.8 215.3-83.3z"
    ]
};
var $8063e68b12ef6db0$export$b1b1cdce4a19c682 = {
    prefix: "fas",
    iconName: "globe",
    icon: [
        512,
        512,
        [
            127760
        ],
        "f0ac",
        "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 21 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"
    ]
};
var $8063e68b12ef6db0$export$20d991385719b5b4 = {
    prefix: "fas",
    iconName: "synagogue",
    icon: [
        640,
        512,
        [
            128333
        ],
        "f69b",
        "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8C469.5 119.7 480 142.2 480 166V280.1 512H464 352V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H176 160V280.1 166c0-23.7 10.5-46.3 28.8-61.5L309.8 3.7zM512 512V244.5l28.1-31.2c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3l63.8 70.9c7.9 8.8 12.3 20.3 12.3 32.1V448c0 35.3-28.7 64-64 64H512zM128 244.5V512H64c-35.3 0-64-28.7-64-64V316.3c0-11.9 4.4-23.3 12.3-32.1l63.8-70.9c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3L128 244.5zM327 124.3c-3.1-5.4-10.9-5.4-13.9 0l-15.9 28.1-32.3-.3c-6.2-.1-10.1 6.7-7 12.1L274.3 192l-16.4 27.8c-3.2 5.4 .7 12.1 7 12.1l32.3-.3L313 259.7c3.1 5.4 10.9 5.4 13.9 0l15.9-28.1 32.3 .3c6.2 .1 10.1-6.7 7-12.1L365.7 192l16.4-27.8c3.2-5.4-.7-12.1-7-12.1l-32.3 .3L327 124.3z"
    ]
};
var $8063e68b12ef6db0$export$f3d75c19191f1688 = {
    prefix: "fas",
    iconName: "person-half-dress",
    icon: [
        320,
        512,
        [],
        "e548",
        "M160 96c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zm8 256V128h6.9c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h0zM58.2 182.3c19.9-33.1 55.3-53.5 93.8-54.3V384h0v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2z"
    ]
};
var $8063e68b12ef6db0$export$4d6835e7175dec24 = {
    prefix: "fas",
    iconName: "road-bridge",
    icon: [
        640,
        512,
        [],
        "e563",
        "M352 0H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM480 200c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24zm24 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V384zM480 40c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-13.3-10.7-24-24-24zM32 96H288v64H248v64h40v96c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416c0-53-43-96-96-96V224H72V160H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm168 64H120v64h80V160z"
    ]
};
var $8063e68b12ef6db0$export$4ac9c4c370f7b157 = {
    prefix: "fas",
    iconName: "location-arrow",
    icon: [
        448,
        512,
        [],
        "f124",
        "M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z"
    ]
};
var $8063e68b12ef6db0$export$a2c1c457834fc6d8 = {
    prefix: "fas",
    iconName: "c",
    icon: [
        384,
        512,
        [
            99
        ],
        "43",
        "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"
    ]
};
var $8063e68b12ef6db0$export$2d33c367b2b091ac = {
    prefix: "fas",
    iconName: "tablet-button",
    icon: [
        448,
        512,
        [],
        "f10a",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 464c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$6f08294ba8a2459c = {
    prefix: "fas",
    iconName: "building-lock",
    icon: [
        576,
        512,
        [],
        "e4d6",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h88.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-23.7 12.9-44.4 32-55.4V272c0-30.5 12.2-58.2 32-78.4V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $8063e68b12ef6db0$export$c9f93c4667edc585 = {
    prefix: "fas",
    iconName: "pizza-slice",
    icon: [
        512,
        512,
        [],
        "f818",
        "M169.7 .9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80c.5 0 1.1 0 1.6 0c176.7 0 320 143.3 320 320c0 .5 0 1.1 0 1.6l44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9zM399.8 410.2c.1-3.4 .2-6.8 .2-10.2c0-159.1-128.9-288-288-288c-3.4 0-6.8 .1-10.2 .2L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L399.8 410.2zM176 272c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm128 64c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM160 384c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$53e23123cc9a6796 = {
    prefix: "fas",
    iconName: "money-bill-wave",
    icon: [
        576,
        512,
        [],
        "f53a",
        "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64H64V352zm64-208c0 35.3-28.7 64-64 64V144h64zM512 304v64H448c0-35.3 28.7-64 64-64zM448 96h64v64c-35.3 0-64-28.7-64-64z"
    ]
};
var $8063e68b12ef6db0$export$2acab8312b7a999b = {
    prefix: "fas",
    iconName: "chart-area",
    icon: [
        512,
        512,
        [
            "area-chart"
        ],
        "f1fe",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm96 288H448c17.7 0 32-14.3 32-32V251.8c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1v84c0 17.7 14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$fc2e595f0e0612cb = $8063e68b12ef6db0$export$2acab8312b7a999b;
var $8063e68b12ef6db0$export$9a3d31c75a465b9a = {
    prefix: "fas",
    iconName: "house-flag",
    icon: [
        640,
        512,
        [],
        "e50d",
        "M480 0c-17.7 0-32 14.3-32 32V192 512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H512c0-17.7-14.3-32-32-32zM416 159L276.8 39.7c-12-10.3-29.7-10.3-41.7 0l-224 192C1 240.4-2.7 254.5 2 267.1S18.6 288 32 288H64V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h64.7l.2 0h-1V159z"
    ]
};
var $8063e68b12ef6db0$export$d7ccc6651f90f7cc = {
    prefix: "fas",
    iconName: "person-circle-minus",
    icon: [
        576,
        512,
        [],
        "e540",
        "M208 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM152 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm424 16c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zm-64 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"
    ]
};
var $8063e68b12ef6db0$export$76f704d256def3c7 = {
    prefix: "fas",
    iconName: "ban",
    icon: [
        512,
        512,
        [
            128683,
            "cancel"
        ],
        "f05e",
        "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"
    ]
};
var $8063e68b12ef6db0$export$6d25ef56192f6d69 = $8063e68b12ef6db0$export$76f704d256def3c7;
var $8063e68b12ef6db0$export$e0ce7d1aba7105e7 = {
    prefix: "fas",
    iconName: "camera-rotate",
    icon: [
        512,
        512,
        [],
        "e0d8",
        "M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM384 256c0 8.8-7.2 16-16 16H291.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L307 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L185 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C193.4 172.7 224 160 256 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3V256zM128 320c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L205 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L327 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C318.6 403.3 288 416 256 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3V320z"
    ]
};
var $8063e68b12ef6db0$export$43832c90c10a7a31 = {
    prefix: "fas",
    iconName: "spray-can-sparkles",
    icon: [
        512,
        512,
        [
            "air-freshener"
        ],
        "f5d0",
        "M96 32v96H224V32c0-17.7-14.3-32-32-32H128C110.3 0 96 14.3 96 32zm0 128c-53 0-96 43-96 96V464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V256c0-53-43-96-96-96H96zm64 256c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80zM384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4C383 51 384 49.4 384 48zm76.4 45.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48c0 1.4 1 3 2.2 3.6L448 64l12.4 29.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224l-12.4-29.8zM448 144c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6z"
    ]
};
var $8063e68b12ef6db0$export$a5e63e89b5ccee83 = $8063e68b12ef6db0$export$43832c90c10a7a31;
var $8063e68b12ef6db0$export$a3b0eb2cd7942125 = {
    prefix: "fas",
    iconName: "star",
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
    ]
};
var $8063e68b12ef6db0$export$cb8434288c91ae83 = {
    prefix: "fas",
    iconName: "repeat",
    icon: [
        512,
        512,
        [
            128257
        ],
        "f363",
        "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160z"
    ]
};
var $8063e68b12ef6db0$export$9d0a89fcd084abb = {
    prefix: "fas",
    iconName: "cross",
    icon: [
        384,
        512,
        [
            128327,
            10013
        ],
        "f654",
        "M176 0c-26.5 0-48 21.5-48 48v80H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h80V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V256h80c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H256V48c0-26.5-21.5-48-48-48H176z"
    ]
};
var $8063e68b12ef6db0$export$6e7cf270cda52323 = {
    prefix: "fas",
    iconName: "box",
    icon: [
        448,
        512,
        [
            128230
        ],
        "f466",
        "M50.7 58.5L0 160H208V32H93.7C75.5 32 58.9 42.3 50.7 58.5zM240 160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240V160zm208 32H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192z"
    ]
};
var $8063e68b12ef6db0$export$63f2d9e5f4689aa8 = {
    prefix: "fas",
    iconName: "venus-mars",
    icon: [
        640,
        512,
        [
            9892
        ],
        "f228",
        "M176 288c61.9 0 112-50.1 112-112s-50.1-112-112-112S64 114.1 64 176s50.1 112 112 112zM352 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H208v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0H616c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"
    ]
};
var $8063e68b12ef6db0$export$e4f903bc63db445 = {
    prefix: "fas",
    iconName: "arrow-pointer",
    icon: [
        320,
        512,
        [
            "mouse-pointer"
        ],
        "f245",
        "M0 55.2V426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320H297.9c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z"
    ]
};
var $8063e68b12ef6db0$export$2e19a69cc26b147 = $8063e68b12ef6db0$export$e4f903bc63db445;
var $8063e68b12ef6db0$export$8d2b1b230601e804 = {
    prefix: "fas",
    iconName: "maximize",
    icon: [
        448,
        512,
        [
            "expand-arrows-alt"
        ],
        "f31e",
        "M168 32H24C10.7 32 0 42.7 0 56V200c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79L81 335 41 295c-6.9-6.9-17.2-8.9-26.2-5.2S0 302.3 0 312V456c0 13.3 10.7 24 24 24H168c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H424c13.3 0 24-10.7 24-24V312c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H280c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S177.7 32 168 32z"
    ]
};
var $8063e68b12ef6db0$export$6219dcd88b5fa6c2 = $8063e68b12ef6db0$export$8d2b1b230601e804;
var $8063e68b12ef6db0$export$bab2cd86f8c65657 = {
    prefix: "fas",
    iconName: "charging-station",
    icon: [
        576,
        512,
        [],
        "f5e7",
        "M96 0C60.7 0 32 28.7 32 64V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32V304h16c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V252.3c32.5-10.2 56-40.5 56-76.3V144c0-8.8-7.2-16-16-16H544V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H480V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16v32c0 35.8 23.5 66.1 56 76.3V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88H320V64c0-35.3-28.7-64-64-64H96zM216.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9H256c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9H96c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z"
    ]
};
var $8063e68b12ef6db0$export$b17d50542d1fc340 = {
    prefix: "fas",
    iconName: "shapes",
    icon: [
        512,
        512,
        [
            "triangle-circle-square"
        ],
        "f61f",
        "M315.4 15.5C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2H384c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160zM288 312V456c0 22.1 17.9 40 40 40H472c22.1 0 40-17.9 40-40V312c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zM128 512c70.7 0 128-57.3 128-128s-57.3-128-128-128S0 313.3 0 384s57.3 128 128 128z"
    ]
};
var $8063e68b12ef6db0$export$34261e5aea24fc1d = $8063e68b12ef6db0$export$b17d50542d1fc340;
var $8063e68b12ef6db0$export$ee94b652453ad208 = {
    prefix: "fas",
    iconName: "shuffle",
    icon: [
        512,
        512,
        [
            128256,
            "random"
        ],
        "f074",
        "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160H352c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6zM164 282.7L204 336l-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c10.1 0 19.6-4.7 25.6-12.8L164 282.7zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8h32V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z"
    ]
};
var $8063e68b12ef6db0$export$8357bf8cc666d5f0 = $8063e68b12ef6db0$export$ee94b652453ad208;
var $8063e68b12ef6db0$export$f48814ae62850c74 = {
    prefix: "fas",
    iconName: "person-running",
    icon: [
        448,
        512,
        [
            127939,
            "running"
        ],
        "f70c",
        "M336 48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM141.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L153.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L254 299l30.9-82.4 5.1 12.3C305 264.7 339.9 288 378.7 288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H378.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L73.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM107.2 352H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5L173 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L107.2 352z"
    ]
};
var $8063e68b12ef6db0$export$5dfd1cb43dc9eadb = $8063e68b12ef6db0$export$f48814ae62850c74;
var $8063e68b12ef6db0$export$7955f08360418647 = {
    prefix: "fas",
    iconName: "mobile-retro",
    icon: [
        320,
        512,
        [],
        "e527",
        "M0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 96v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 352c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm24 56c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zm56-56c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm24 56c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zm56-56c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm24 56c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zM128 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"
    ]
};
var $8063e68b12ef6db0$export$523960de087f5198 = {
    prefix: "fas",
    iconName: "grip-lines-vertical",
    icon: [
        192,
        512,
        [],
        "f7a5",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"
    ]
};
var $8063e68b12ef6db0$export$6daa96b1986e2ef0 = {
    prefix: "fas",
    iconName: "spider",
    icon: [
        576,
        512,
        [
            128375
        ],
        "f717",
        "M190.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L113.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4-80.4-26.8c-2.4-.8-4.3-2.7-5.1-5.1L78.8 128.4C74.6 115.8 61 109 48.4 113.2S29 131 33.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L148.1 256 87.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L33.2 368.4C29 381 35.8 394.6 48.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8-57.4 57.4c-15.6 15.6-20.6 39-12.7 59.7l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5L192 353.9c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L462.9 412c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L427.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L430.4 15.4C425.6 3 411.8-3.2 399.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L368 174.1V160c0-31.8-18.6-59.3-45.5-72.2c-9.1-4.4-18.5 3.3-18.5 13.4V112c0 8.8-7.2 16-16 16s-16-7.2-16-16V101.2c0-10.1-9.4-17.7-18.5-13.4C226.6 100.7 208 128.2 208 160v14.1l-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6z"
    ]
};
var $8063e68b12ef6db0$export$740142a89118fbc0 = {
    prefix: "fas",
    iconName: "hands-bound",
    icon: [
        576,
        512,
        [],
        "e4f9",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V96v59.1 .7V192v21.9c0 14.2 5.1 27.9 14.3 38.7L99.6 352H96c-13.3 0-24 10.7-24 24s10.7 24 24 24h32H256h64H448h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-3.6l85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7V192 155.8v-.7V96 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V96v48.8l-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8c-9.7-5.7-12.1-18.7-5.1-27.5L441 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C329 209.7 320 233.4 320 258.1V320v32H256V320 258.1c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2s-15.2 30.9-4.4 44.5l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5c-8.1 4.8-18.6 2.7-24.2-4.8L64 144.8V96 32zm64 448v32H256V480h64v32H448V480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H448 320 256 128 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h32z"
    ]
};
var $8063e68b12ef6db0$export$a3dced32d48cb1ea = {
    prefix: "fas",
    iconName: "file-invoice-dollar",
    icon: [
        384,
        512,
        [],
        "f571",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V440c0 8.8-7.2 16-16 16s-16-7.2-16-16V422.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V232c0-8.8 7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$f201ba865ea1b8dc = {
    prefix: "fas",
    iconName: "plane-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e556",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$8cf137aceaaf4de0 = {
    prefix: "fas",
    iconName: "x-ray",
    icon: [
        512,
        512,
        [],
        "f497",
        "M0 64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96C14.3 96 0 81.7 0 64zM256 96c-8.8 0-16 7.2-16 16v16H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v32H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H240v32H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v32H152c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.2 24.6l32 48C168.5 412 176 416 184 416H328c8 0 15.5-4 20-10.7l32-48c4.9-7.4 5.4-16.8 1.2-24.6S368.9 320 360 320H272V288h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V224H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V160h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16zM208 384c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zm112-16c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$761e747b06ed2e1f = {
    prefix: "fas",
    iconName: "spell-check",
    icon: [
        640,
        512,
        [],
        "f891",
        "M144 0c-12.9 0-24.6 7.8-29.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L98.7 224h90.7l5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C168.6 7.8 156.9 0 144 0zm18.7 160H125.3L144 115.2 162.7 160zM288 32v96 96c0 17.7 14.3 32 32 32h80c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80H320c-17.7 0-32 14.3-32 32zm96 64H352V64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H352V160zM598.6 310.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L384 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"
    ]
};
var $8063e68b12ef6db0$export$f54d004dd5f1cb5e = {
    prefix: "fas",
    iconName: "slash",
    icon: [
        640,
        512,
        [],
        "f715",
        "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"
    ]
};
var $8063e68b12ef6db0$export$72cf138e5ddda6eb = {
    prefix: "fas",
    iconName: "computer-mouse",
    icon: [
        384,
        512,
        [
            128433,
            "mouse"
        ],
        "f8cc",
        "M0 192H176V0H160C71.6 0 0 71.6 0 160v32zm0 32V352c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V224H192 0zm384-32V160C384 71.6 312.4 0 224 0H208V192H384z"
    ]
};
var $8063e68b12ef6db0$export$198b96b894c66074 = $8063e68b12ef6db0$export$72cf138e5ddda6eb;
var $8063e68b12ef6db0$export$a02c5909359525be = {
    prefix: "fas",
    iconName: "arrow-right-to-bracket",
    icon: [
        512,
        512,
        [
            "sign-in"
        ],
        "f090",
        "M352 96l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
var $8063e68b12ef6db0$export$a55eff0ca4f9c3df = $8063e68b12ef6db0$export$a02c5909359525be;
var $8063e68b12ef6db0$export$b3d636689da4a3e5 = {
    prefix: "fas",
    iconName: "shop-slash",
    icon: [
        640,
        512,
        [
            "store-alt-slash"
        ],
        "e070",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V224H512V376L384 275.7V224H320v1.5L277.2 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L74.1 32.8 38.8 5.1zM36.8 192h85L21 112.5 6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM320 384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V398.5l-64-50.4V384z"
    ]
};
var $8063e68b12ef6db0$export$b932a586f6ff48b4 = $8063e68b12ef6db0$export$b3d636689da4a3e5;
var $8063e68b12ef6db0$export$1bf820d499b6202e = {
    prefix: "fas",
    iconName: "server",
    icon: [
        512,
        512,
        [],
        "f233",
        "M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM344 152c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm96-24c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zM344 408c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm104-24c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$61c2a6b698f55df6 = {
    prefix: "fas",
    iconName: "virus-covid-slash",
    icon: [
        640,
        512,
        [],
        "e4a9",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7H528v16c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H494.4c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6V48h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V81.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 38.8 5.1zM149.2 213.5c-1.5 6-2.7 12.2-3.5 18.5H112V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V280h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2L149.2 213.5z"
    ]
};
var $8063e68b12ef6db0$export$452410c103c2403b = {
    prefix: "fas",
    iconName: "shop-lock",
    icon: [
        640,
        512,
        [],
        "e4a5",
        "M36.8 192H449.6c20.2-19.8 47.9-32 78.4-32c30.5 0 58.1 12.2 78.3 31.9c18.9-1.6 33.7-17.4 33.7-36.7c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM384 224H320V384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 352 224zm144 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $8063e68b12ef6db0$export$f0c28584caa8f4b = {
    prefix: "fas",
    iconName: "hourglass-start",
    icon: [
        384,
        512,
        [
            "hourglass-1"
        ],
        "f251",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM288 437v11H96V437c0-25.5 10.1-49.9 28.1-67.9L192 301.3l67.9 67.9c18 18 28.1 42.4 28.1 67.9z"
    ]
};
var $8063e68b12ef6db0$export$87929336ab5c59cd = $8063e68b12ef6db0$export$f0c28584caa8f4b;
var $8063e68b12ef6db0$export$f35a116a762ef8fc = {
    prefix: "fas",
    iconName: "blender-phone",
    icon: [
        576,
        512,
        [],
        "f6b6",
        "M192 352V48c0-26.5 21.5-48 48-48H534.1c21.1 0 36.4 20.1 30.9 40.4L558.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H549.8l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H523.6l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L480 352H192zm16 32H496c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4 .2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8C81.6-.7 93.8-2.5 103.5 3.5l44 27.2z"
    ]
};
var $8063e68b12ef6db0$export$6c0cfe6d58faf860 = {
    prefix: "fas",
    iconName: "building-wheat",
    icon: [
        640,
        512,
        [],
        "e4db",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm384 80v16c0 44.2-35.8 80-80 80H544V272c0-44.2 35.8-80 80-80h16zm0 128c0 44.2-35.8 80-80 80H544V384c0-44.2 35.8-80 80-80h16v16zm0 112c0 44.2-35.8 80-80 80H544V496c0-44.2 35.8-80 80-80h16v16zM512 496v16H496c-44.2 0-80-35.8-80-80V416h16c44.2 0 80 35.8 80 80zm0-96H496c-44.2 0-80-35.8-80-80V304h16c44.2 0 80 35.8 80 80v16zm0-128v16H496c-44.2 0-80-35.8-80-80V192h16c44.2 0 80 35.8 80 80zM528 32c13.3 0 24 10.7 24 24V160c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24zm96 64v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24zM456 72c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24z"
    ]
};
var $8063e68b12ef6db0$export$9b94ed8d16d281f9 = {
    prefix: "fas",
    iconName: "person-breastfeeding",
    icon: [
        512,
        512,
        [],
        "e53a",
        "M256 160c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80zM468.8 382.8L405.5 462c-16.6 20.7-46.8 24.1-67.5 7.5c-17.6-14.1-22.7-38.1-13.5-57.7l-.7-.1c-38.9-5.6-74.3-25.1-99.7-54.8V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 .8 0 1.6 .1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L59.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7c-4.9-2.8-9.2-6.4-12.6-10.6c-4.6-5.4-7.8-11.7-9.6-18.4c-3.3-12-1.9-25.2 4.8-36.6c.6-1.1 1.3-2.2 2-3.2l67.1-100.6c26.7-40.1 71.7-64.1 119.8-64.1h75.2c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4c2.9 6.7 4.3 13.8 4 20.8c-.3 10.6-4.2 21-11.2 29.4zM352 332c0-24.3-19.7-44-44-44s-44 19.7-44 44s19.7 44 44 44s44-19.7 44-44z"
    ]
};
var $8063e68b12ef6db0$export$a5fd2acfcb5247c6 = {
    prefix: "fas",
    iconName: "right-to-bracket",
    icon: [
        512,
        512,
        [
            "sign-in-alt"
        ],
        "f2f6",
        "M352 96h64c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c53 0 96-43 96-96V128c0-53-43-96-96-96H352c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-7.5 177.4c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22v72H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H160v72c0 9.6 5.7 18.2 14.5 22s19 2 26-4.6l144-136z"
    ]
};
var $8063e68b12ef6db0$export$e6709746115bd2ea = $8063e68b12ef6db0$export$a5fd2acfcb5247c6;
var $8063e68b12ef6db0$export$f89d028573ffc0a6 = {
    prefix: "fas",
    iconName: "venus",
    icon: [
        384,
        512,
        [
            9792
        ],
        "f221",
        "M304 176c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V384H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V349.1z"
    ]
};
var $8063e68b12ef6db0$export$2c31ca0d9bee400f = {
    prefix: "fas",
    iconName: "passport",
    icon: [
        448,
        512,
        [],
        "f5ab",
        "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8h39.1c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8h39.1c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8H279.6zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8H129.3c5.3-31.4 25.8-57.6 53.7-70.8zM352 192c0-70.7-57.3-128-128-128S96 121.3 96 192s57.3 128 128 128s128-57.3 128-128zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
    ]
};
var $8063e68b12ef6db0$export$a6d8e50dcd4b4294 = {
    prefix: "fas",
    iconName: "heart-pulse",
    icon: [
        512,
        512,
        [
            "heartbeat"
        ],
        "f21e",
        "M228.3 469.1L47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4h87c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31H476.3c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9H16c-2.6 0-5 .4-7.3 1.1C3 225.2 0 208.2 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 16.9-2.8 33.5-8.3 49.1z"
    ]
};
var $8063e68b12ef6db0$export$ca880e19206e80aa = $8063e68b12ef6db0$export$a6d8e50dcd4b4294;
var $8063e68b12ef6db0$export$7754cc6d5559ff38 = {
    prefix: "fas",
    iconName: "people-carry-box",
    icon: [
        640,
        512,
        [
            "people-carry"
        ],
        "f4ce",
        "M176 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM144 241.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.3-85.9L66.8 320C54.8 308 48 291.7 48 274.7V186.6c0-32.4 26.2-58.6 58.6-58.6c24.1 0 46.5 12 59.9 32l47.4 71.1 10.1 5V160c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v76.2l10.1-5L473.5 160c13.3-20 35.8-32 59.9-32c32.4 0 58.6 26.2 58.6 58.6v88.1c0 17-6.7 33.3-18.7 45.3l-79.4 79.4-14.3 85.9c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l15.2-90.9c1.6-9.9 6.3-19 13.4-26.1l51-51V241.7l-19 28.5c-4.6 7-11 12.6-18.5 16.3l-59.6 29.8c-2.4 1.3-4.9 2.2-7.6 2.8c-2.6 .6-5.3 .9-7.9 .8H256.7c-2.5 .1-5-.2-7.5-.7c-2.9-.6-5.6-1.6-8.1-3l-59.5-29.8c-7.5-3.7-13.8-9.4-18.5-16.3l-19-28.5zM2.3 468.1L50.1 348.6l49.2 49.2-37.6 94c-6.6 16.4-25.2 24.4-41.6 17.8S-4.3 484.5 2.3 468.1zM512 96c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zm77.9 252.6l47.8 119.5c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-37.6-94 49.2-49.2z"
    ]
};
var $8063e68b12ef6db0$export$35fbd4ff1265acd5 = $8063e68b12ef6db0$export$7754cc6d5559ff38;
var $8063e68b12ef6db0$export$15d012277c3ecf9a = {
    prefix: "fas",
    iconName: "temperature-high",
    icon: [
        512,
        512,
        [],
        "f769",
        "M416 128c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm0 64c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96s43 96 96 96zM96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.2 32 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"
    ]
};
var $8063e68b12ef6db0$export$4a7bb4be15f35178 = {
    prefix: "fas",
    iconName: "microchip",
    icon: [
        512,
        512,
        [],
        "f2db",
        "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V176h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zM160 128H352c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm192 32H160V352H352V160z"
    ]
};
var $8063e68b12ef6db0$export$dc1083dcd1d7b9d6 = {
    prefix: "fas",
    iconName: "crown",
    icon: [
        576,
        512,
        [
            128081
        ],
        "f521",
        "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"
    ]
};
var $8063e68b12ef6db0$export$43d1fa6671908715 = {
    prefix: "fas",
    iconName: "weight-hanging",
    icon: [
        512,
        512,
        [],
        "f5cd",
        "M288 96c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm58.5 32c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512H464c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128H346.5z"
    ]
};
var $8063e68b12ef6db0$export$f4595f012786d346 = {
    prefix: "fas",
    iconName: "xmarks-lines",
    icon: [
        640,
        512,
        [],
        "e59a",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM7 167c-9.4 9.4-9.4 24.6 0 33.9l55 55L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L41 167c-9.4-9.4-24.6-9.4-33.9 0zM265 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55zM455 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
var $8063e68b12ef6db0$export$a20cb90865b6beb8 = {
    prefix: "fas",
    iconName: "file-prescription",
    icon: [
        384,
        512,
        [],
        "f572",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM104 196h72c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V296 216c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20H124v40h52z"
    ]
};
var $8063e68b12ef6db0$export$e521c542d18b85c3 = {
    prefix: "fas",
    iconName: "weight-scale",
    icon: [
        512,
        512,
        [
            "weight"
        ],
        "f496",
        "M384 176c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128zm7.8-112C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H391.8zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"
    ]
};
var $8063e68b12ef6db0$export$cf3bafa68a60bae4 = $8063e68b12ef6db0$export$e521c542d18b85c3;
var $8063e68b12ef6db0$export$3d626cfc365a7e36 = {
    prefix: "fas",
    iconName: "user-group",
    icon: [
        640,
        512,
        [
            128101,
            "user-friends"
        ],
        "f500",
        "M352 128c0 70.7-57.3 128-128 128s-128-57.3-128-128S153.3 0 224 0s128 57.3 128 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"
    ]
};
var $8063e68b12ef6db0$export$46073bec205635d9 = $8063e68b12ef6db0$export$3d626cfc365a7e36;
var $8063e68b12ef6db0$export$fb00fdd8857804c7 = {
    prefix: "fas",
    iconName: "arrow-up-a-z",
    icon: [
        576,
        512,
        [
            "sort-alpha-up"
        ],
        "f15e",
        "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 320c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zM416 32c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 38.8 428.1 32 416 32zM395.8 176L416 135.6 436.2 176H395.8z"
    ]
};
var $8063e68b12ef6db0$export$3c4115b156be730d = $8063e68b12ef6db0$export$fb00fdd8857804c7;
var $8063e68b12ef6db0$export$861b1f13085cf122 = {
    prefix: "fas",
    iconName: "chess-knight",
    icon: [
        384,
        512,
        [
            9822
        ],
        "f441",
        "M32 391.6V416H352V224c0-106-86-192-192-192H12.9C5.8 32 0 37.8 0 44.9c0 2 .5 4 1.4 5.8L16 80 9.4 86.6c-6 6-9.4 14.1-9.4 22.6V242.3c0 13.1 8 24.9 20.1 29.7l46.5 18.6c8.5 3.4 18 3 26.2-1.1l6.6-3.3c8-4 14-11.2 16.5-19.8l8.3-28.9c2.5-8.6 8.4-15.8 16.5-19.8L160 208v40.4c0 24.2-13.7 46.4-35.4 57.2L67.4 334.3C45.7 345.2 32 367.3 32 391.6zM72 148c0 11-9 20-20 20s-20-9-20-20s9-20 20-20s20 9 20 20zM352 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32z"
    ]
};
var $8063e68b12ef6db0$export$67ca89c1ca38d559 = {
    prefix: "fas",
    iconName: "face-laugh-squint",
    icon: [
        512,
        512,
        [
            "laugh-squint"
        ],
        "f59b",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zm36.7-199.4l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 125.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $8063e68b12ef6db0$export$b206e700cf7084e1 = $8063e68b12ef6db0$export$67ca89c1ca38d559;
var $8063e68b12ef6db0$export$76a9413fbe130a53 = {
    prefix: "fas",
    iconName: "wheelchair",
    icon: [
        576,
        512,
        [],
        "f193",
        "M224 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM152.5 247.2c12.4-4.7 18.7-18.5 14-30.9s-18.5-18.7-30.9-14C75.1 225.1 32 283.5 32 352c0 88.4 71.6 160 160 160c61.2 0 114.3-34.3 141.2-84.7c6.2-11.7 1.8-26.2-9.9-32.5s-26.2-1.8-32.5 9.9C272 440 234.8 464 192 464c-61.9 0-112-50.1-112-112c0-47.9 30.1-88.8 72.5-104.8zM291.8 176l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3c-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4h5.1c.4 0 .8 0 1.3 0h94.1c6.7 0 12.6 4.1 15 10.4L434 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H314.2l-9.6-48H368c17.7 0 32-14.3 32-32s-14.3-32-32-32H291.8z"
    ]
};
var $8063e68b12ef6db0$export$a29c8ea43e92771d = {
    prefix: "fas",
    iconName: "circle-arrow-up",
    icon: [
        512,
        512,
        [
            "arrow-circle-up"
        ],
        "f0aa",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM385 215c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V177.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 103c9.4-9.4 24.6-9.4 33.9 0L385 215z"
    ]
};
var $8063e68b12ef6db0$export$a2f6f3baa50af0b1 = $8063e68b12ef6db0$export$a29c8ea43e92771d;
var $8063e68b12ef6db0$export$5cffc34afa81e517 = {
    prefix: "fas",
    iconName: "toggle-on",
    icon: [
        576,
        512,
        [],
        "f205",
        "M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zM384 352c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96z"
    ]
};
var $8063e68b12ef6db0$export$6af1cc5998ca52bc = {
    prefix: "fas",
    iconName: "person-walking",
    icon: [
        320,
        512,
        [
            128694,
            "walking"
        ],
        "f554",
        "M256 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"
    ]
};
var $8063e68b12ef6db0$export$4886811b7174ec35 = $8063e68b12ef6db0$export$6af1cc5998ca52bc;
var $8063e68b12ef6db0$export$be32b10ce70a09df = {
    prefix: "fas",
    iconName: "l",
    icon: [
        320,
        512,
        [
            108
        ],
        "4c",
        "M64 32c17.7 0 32 14.3 32 32V416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$7b24b34ef6cc130c = {
    prefix: "fas",
    iconName: "fire",
    icon: [
        448,
        512,
        [
            128293
        ],
        "f06d",
        "M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-2.8-5.6-5.6-11.2-9.8-16.8l-50.6 58.8s-81.4-103.6-87.1-110.6C133.1 243.8 112 273.2 112 306.8C112 375.4 162.6 416 225.7 416z"
    ]
};
var $8063e68b12ef6db0$export$580ae0d0bbd809fb = {
    prefix: "fas",
    iconName: "bed-pulse",
    icon: [
        640,
        512,
        [
            "procedures"
        ],
        "f487",
        "M483.2 9.6L524 64h92c13.3 0 24 10.7 24 24s-10.7 24-24 24H512c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112H216c-13.3 0-24-10.7-24-24s10.7-24 24-24H352c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM320 160h12.7l20.7 31.1c11.2 16.8 30.6 26.3 50.7 24.8s37.9-13.7 46.5-32L461.9 160H544c53 0 96 43 96 96V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V352H288V192c0-17.7 14.3-32 32-32zM176 320c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $8063e68b12ef6db0$export$5f9e1870e1866dde = $8063e68b12ef6db0$export$580ae0d0bbd809fb;
var $8063e68b12ef6db0$export$76d92e7f30d064c5 = {
    prefix: "fas",
    iconName: "shuttle-space",
    icon: [
        640,
        512,
        [
            "space-shuttle"
        ],
        "f197",
        "M130 480c40.6 0 80.4-11 115.2-31.9L352 384l-224 0 0 96h2zM352 128L245.2 63.9C210.4 43 170.6 32 130 32h-2v96l224 0zM96 128l0-96H80C53.5 32 32 53.5 32 80v48h8c-22.1 0-40 17.9-40 40v16V328v16c0 22.1 17.9 40 40 40H32v48c0 26.5 21.5 48 48 48H96l0-96h8c26.2 0 49.4-12.6 64-32H456c69.3 0 135-22.7 179.2-81.6c6.4-8.5 6.4-20.3 0-28.8C591 182.7 525.3 160 456 160H168c-14.6-19.4-37.8-32-64-32l-8 0zM512 243.6v24.9c0 19.6-15.9 35.6-35.6 35.6c-2.5 0-4.4-2-4.4-4.4V212.4c0-2.5 2-4.4 4.4-4.4c19.6 0 35.6 15.9 35.6 35.6z"
    ]
};
var $8063e68b12ef6db0$export$4d1c12ba2b4ca565 = $8063e68b12ef6db0$export$76d92e7f30d064c5;
var $8063e68b12ef6db0$export$2f203616c892d415 = {
    prefix: "fas",
    iconName: "face-laugh",
    icon: [
        512,
        512,
        [
            "laugh"
        ],
        "f599",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM208.4 192c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm128 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$6c74e314e801a4fe = $8063e68b12ef6db0$export$2f203616c892d415;
var $8063e68b12ef6db0$export$ff7e93418af88b78 = {
    prefix: "fas",
    iconName: "folder-open",
    icon: [
        576,
        512,
        [
            128194,
            128449,
            61717
        ],
        "f07c",
        "M88.7 223.8L0 375.8V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v32H144c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224H544c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480H32c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z"
    ]
};
var $8063e68b12ef6db0$export$2a155a6e20f64134 = {
    prefix: "fas",
    iconName: "heart-circle-plus",
    icon: [
        576,
        512,
        [],
        "e500",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$f54081bdbf6d4eb5 = {
    prefix: "fas",
    iconName: "code-fork",
    icon: [
        448,
        512,
        [],
        "e13b",
        "M80 104c13.3 0 24-10.7 24-24s-10.7-24-24-24S56 66.7 56 80s10.7 24 24 24zm80-24c0 32.8-19.7 61-48 73.3V192c0 17.7 14.3 32 32 32H304c17.7 0 32-14.3 32-32V153.3C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V192c0 53-43 96-96 96H256v70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V288H144c-53 0-96-43-96-96V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zM248 432c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $8063e68b12ef6db0$export$a9947c2888b3c8fd = {
    prefix: "fas",
    iconName: "city",
    icon: [
        640,
        512,
        [
            127961
        ],
        "f64f",
        "M480 48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48V96H224V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V96H112V24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144v96V464c0 26.5 21.5 48 48 48H304h32 96H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H480V48zm96 320v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 416H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM560 256c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32zM256 176v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32zM256 304c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM112 320H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm304-48v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm16 112v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$417391ae30b5922e = {
    prefix: "fas",
    iconName: "microphone-lines",
    icon: [
        384,
        512,
        [
            127897,
            "microphone-alt"
        ],
        "f3c9",
        "M96 96V256c0 53 43 96 96 96s96-43 96-96H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96S96 43 96 96zM320 240v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24z"
    ]
};
var $8063e68b12ef6db0$export$f08ef94fea14f5ac = $8063e68b12ef6db0$export$417391ae30b5922e;
var $8063e68b12ef6db0$export$4894bf28f771e1f3 = {
    prefix: "fas",
    iconName: "pepper-hot",
    icon: [
        512,
        512,
        [
            127798
        ],
        "f816",
        "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 18.5-3.1 36.3-8.9 52.8c-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3H360c-13.3 0-24-10.7-24-24V152c0-13.3-10.7-24-24-24l-17.1 0c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8L419 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zM171.2 345.5L264 160l40 0v80c0 26.5 21.5 48 48 48h76.2l23.9 47.8C372.3 443.9 244.3 512 103.2 512H44.4C19.9 512 0 492.1 0 467.6c0-20.8 14.5-38.8 34.8-43.3l49.8-11.1c37.6-8.4 69.5-33.2 86.7-67.7z"
    ]
};
var $8063e68b12ef6db0$export$db1382cd406cc506 = {
    prefix: "fas",
    iconName: "unlock",
    icon: [
        448,
        512,
        [
            128275
        ],
        "f09c",
        "M144 144c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144V144z"
    ]
};
var $8063e68b12ef6db0$export$dec10d4c2c113312 = {
    prefix: "fas",
    iconName: "colon-sign",
    icon: [
        384,
        512,
        [],
        "e140",
        "M255 39.8c4.3-17.1-6.1-34.5-23.3-38.8S197.2 7.1 193 24.2L181.9 68.6C96.1 87.8 32 164.4 32 256c0 58.1 25.8 110.2 66.7 145.4L81 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l13-52.1c9 3.4 18.4 6.2 28 8.2L177 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l10.4-41.4c33.4-4.4 64.1-17.4 89.8-36.7c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-10.2 7.7-21.7 13.9-34 18.3L321 160c9.4-.3 18.5-4.7 24.6-12.8c10.6-14.1 7.8-34.2-6.4-44.8c-1.1-.8-2.2-1.6-3.3-2.4L351 39.8c4.3-17.1-6.1-34.5-23.3-38.8S293.2 7.1 289 24.2L277.1 71.5c-9.3-2.7-18.8-4.6-28.6-5.9L255 39.8zM163.2 143.3L117.3 326.8C103.9 306.5 96 282.2 96 256c0-48.7 27.2-91 67.2-112.7zm8.6 229.5l61.1-244.6c9.9 .7 19.5 2.5 28.7 5.3l-62 248.1c-9.7-1.9-19-4.8-27.8-8.8z"
    ]
};
var $8063e68b12ef6db0$export$23b086400a31acfe = {
    prefix: "fas",
    iconName: "headset",
    icon: [
        512,
        512,
        [],
        "f590",
        "M256 48C141.1 48 48 141.1 48 256v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V256C0 114.6 114.6 0 256 0S512 114.6 512 256V400.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24H240c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40V256c0-114.9-93.1-208-208-208zM144 208h16c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V272c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h16z"
    ]
};
var $8063e68b12ef6db0$export$4ab2f33219630bad = {
    prefix: "fas",
    iconName: "store-slash",
    icon: [
        640,
        512,
        [],
        "e071",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V384 252.6c-4 1-8 1.8-12.3 2.3l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V350.9L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1l-22.7 36L38.8 5.1zm73.4 218.1c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7zM160 384V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H480c12.9 0 24.8-3.8 34.9-10.3L365.5 384H160z"
    ]
};
var $8063e68b12ef6db0$export$2ffc88a4d31e8ffc = {
    prefix: "fas",
    iconName: "road-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e566",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm22.6-144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
    ]
};
var $8063e68b12ef6db0$export$d6e17c0df8ed1bf7 = {
    prefix: "fas",
    iconName: "user-minus",
    icon: [
        640,
        512,
        [],
        "f503",
        "M352 128c0 70.7-57.3 128-128 128s-128-57.3-128-128S153.3 0 224 0s128 57.3 128 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM472 200H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $8063e68b12ef6db0$export$efc6d53e0dedceee = {
    prefix: "fas",
    iconName: "mars-stroke-up",
    icon: [
        320,
        512,
        [
            9896,
            "mars-stroke-v"
        ],
        "f22a",
        "M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H184v24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H184v24c0 .6 0 1.2-.1 1.8c77 11.6 136.1 78 136.1 158.2c0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2c0-.6-.1-1.2-.1-1.8V168H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V96H96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352c0-53-43-96-96-96s-96 43-96 96s43 96 96 96s96-43 96-96z"
    ]
};
var $8063e68b12ef6db0$export$ed7aa1c25104f333 = $8063e68b12ef6db0$export$efc6d53e0dedceee;
var $8063e68b12ef6db0$export$7df1926e9eef8cc3 = {
    prefix: "fas",
    iconName: "champagne-glasses",
    icon: [
        640,
        512,
        [
            129346,
            "glass-cheers"
        ],
        "f79f",
        "M320 128V49.1L186.6 .3c-11.4-4.2-24 .9-29.5 11.7L71.8 181.1c-30.8 61-8 133.8 48.1 167.4l-28 77.4L32.1 403.9C19.7 399.4 6 405.8 1.4 418.3s1.9 26.3 14.3 30.8l164.6 60.3c12.4 4.5 26.1-1.9 30.6-14.4s-1.9-26.3-14.3-30.8l-59.9-21.9 28-77.3c68.1 11.6 135.7-32.8 150.1-103.6l5.1-24.8 5.1 24.8c14.5 70.8 82 115.2 150.1 103.6l28 77.3-59.9 21.9c-12.4 4.5-18.8 18.3-14.3 30.8s18.2 18.9 30.6 14.4l164.6-60.3c12.4-4.5 18.8-18.3 14.3-30.8s-18.2-18.9-30.6-14.4l-59.9 21.9-28-77.4c56.1-33.6 78.8-106.4 48.1-167.4L482.9 12C477.4 1.1 464.7-3.9 453.4 .3L320 49.1V128h0zm-35.7 44.4L153.9 124.6l36.3-71.9L300.6 93.1l-16.2 79.3zm71.3 0L339.4 93.1 449.8 52.7l36.3 71.9L355.7 172.4z"
    ]
};
var $8063e68b12ef6db0$export$20007d7d74cb98fe = $8063e68b12ef6db0$export$7df1926e9eef8cc3;
var $8063e68b12ef6db0$export$97d84347d71ba297 = {
    prefix: "fas",
    iconName: "clipboard",
    icon: [
        384,
        512,
        [
            128203
        ],
        "f328",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H48C21.5 64 0 85.5 0 112V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H282.5C269.4 26.7 233.8 0 192 0zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm-80 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$8403e4b31e8aa805 = {
    prefix: "fas",
    iconName: "house-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e50a",
        "M320.7 351.7C329 262.1 404.3 192 496 192c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V480c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32V383.7c0-17.7 14.3-32 32-32h64l.7 0zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$929df388c07f293d = {
    prefix: "fas",
    iconName: "file-arrow-up",
    icon: [
        384,
        512,
        [
            "file-upload"
        ],
        "f574",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z"
    ]
};
var $8063e68b12ef6db0$export$dd55ded1264643d2 = $8063e68b12ef6db0$export$929df388c07f293d;
var $8063e68b12ef6db0$export$1642419fe3db2857 = {
    prefix: "fas",
    iconName: "wifi",
    icon: [
        640,
        512,
        [
            "wifi-3",
            "wifi-strong"
        ],
        "f1eb",
        "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $8063e68b12ef6db0$export$2349bb04a04f4b2d = $8063e68b12ef6db0$export$1642419fe3db2857;
var $8063e68b12ef6db0$export$4b3167c852f4c4aa = $8063e68b12ef6db0$export$1642419fe3db2857;
var $8063e68b12ef6db0$export$1ea66a88b8f620c9 = {
    prefix: "fas",
    iconName: "bath",
    icon: [
        512,
        512,
        [
            128705,
            "bathtub"
        ],
        "f2cd",
        "M96 77.3c0-7.3 5.9-13.3 13.3-13.3c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9C130 91.8 128 101.7 128 112c0 19.9 7.2 38 19.2 52c-5.3 9.2-4 21.1 3.8 29c9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9c-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0C66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V77.3zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V464H384v16c0 17.7 14.3 32 32 32s32-14.3 32-32V439.6c19.6-17.6 32-43.1 32-71.6V352H32z"
    ]
};
var $8063e68b12ef6db0$export$40ae013b5e6269d8 = $8063e68b12ef6db0$export$1ea66a88b8f620c9;
var $8063e68b12ef6db0$export$22346afd6a3cddf8 = {
    prefix: "fas",
    iconName: "underline",
    icon: [
        448,
        512,
        [],
        "f0cd",
        "M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $8063e68b12ef6db0$export$3842882ea09b25af = {
    prefix: "fas",
    iconName: "user-pen",
    icon: [
        640,
        512,
        [
            "user-edit"
        ],
        "f4ff",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1H178.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"
    ]
};
var $8063e68b12ef6db0$export$a68a6960fc8eef82 = $8063e68b12ef6db0$export$3842882ea09b25af;
var $8063e68b12ef6db0$export$afa7b53ac8ebcb5d = {
    prefix: "fas",
    iconName: "signature",
    icon: [
        640,
        512,
        [],
        "f5b7",
        "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm-9.2 177l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5V335.6c0-14.1 9.3-26.6 22.8-30.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.3c-.2-2.8-.3-5.6-.3-8.5V368H24zm592 48c13.3 0 24-10.7 24-24s-10.7-24-24-24H305.9c-6.7 16.3-14.2 32.3-22.3 48H616z"
    ]
};
var $8063e68b12ef6db0$export$195780ddabd8e0c6 = {
    prefix: "fas",
    iconName: "stroopwafel",
    icon: [
        512,
        512,
        [],
        "f551",
        "M256 496c132.5 0 240-107.5 240-240S388.5 16 256 16S16 123.5 16 256s107.5 240 240 240zM235.3 76.7L256 97.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 120 324 165.4 357.4 132l-16.7-16.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L380 109.4l8.7-8.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-8.7 8.7 16.7 16.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L380 154.6 346.6 188 392 233.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L414.6 256l20.7 20.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L392 278.6 346.6 324 380 357.4l16.7-16.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L402.6 380l8.7 8.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-8.7-8.7-16.7 16.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L357.4 380 324 346.6 278.6 392l20.7 20.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 414.6l-20.7 20.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 392 188 346.6 154.6 380l16.7 16.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L132 402.6l-8.7 8.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l8.7-8.7L92.7 363.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L132 357.4 165.4 324 120 278.6 99.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.4 256 76.7 235.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L120 233.4 165.4 188 132 154.6l-16.7 16.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L109.4 132l-8.7-8.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l8.7 8.7 16.7-16.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L154.6 132 188 165.4 233.4 120 212.7 99.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM210.6 188L256 233.4 301.4 188 256 142.6 210.6 188zm68 68L324 301.4 369.4 256 324 210.6 278.6 256zM256 278.6L210.6 324 256 369.4 301.4 324 256 278.6zM233.4 256L188 210.6 142.6 256 188 301.4 233.4 256z"
    ]
};
var $8063e68b12ef6db0$export$7e0c7fd2a2e88823 = {
    prefix: "fas",
    iconName: "bold",
    icon: [
        384,
        512,
        [],
        "f032",
        "M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"
    ]
};
var $8063e68b12ef6db0$export$217195c80db39097 = {
    prefix: "fas",
    iconName: "anchor-lock",
    icon: [
        640,
        512,
        [],
        "e4ad",
        "M256 96c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm85.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8 0 15.9-.6 23.6-1.7c-4.8-9-7.6-19.3-7.6-30.3V446.7c-5.2 .9-10.5 1.3-16 1.3H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $8063e68b12ef6db0$export$374e1dce366a2175 = {
    prefix: "fas",
    iconName: "building-ngo",
    icon: [
        384,
        512,
        [],
        "e4d7",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM168 64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184v64h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V80c0-8.8 7.2-16 16-16zM304 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V112zM61.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 132.8V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4z"
    ]
};
var $8063e68b12ef6db0$export$1ff755b523ab2851 = {
    prefix: "fas",
    iconName: "manat-sign",
    icon: [
        384,
        512,
        [],
        "e1d5",
        "M192 32c-17.7 0-32 14.3-32 32V98.7C69.2 113.9 0 192.9 0 288V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-59.6 40.8-109.8 96-124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V164c55.2 14.2 96 64.3 96 124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-95.1-69.2-174.1-160-189.3V64c0-17.7-14.3-32-32-32z"
    ]
};
var $8063e68b12ef6db0$export$6a15ccae09bbaf93 = {
    prefix: "fas",
    iconName: "not-equal",
    icon: [
        448,
        512,
        [],
        "f53e",
        "M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4L337.1 144H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H294.5l-64 96H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H187.8l-65.2 97.7c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4L110.9 368H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H153.5l64-96H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H260.2l65.2-97.7c9.8-14.7 29.7-18.7 44.4-8.9z"
    ]
};
var $8063e68b12ef6db0$export$cf897c3e0abd59e4 = {
    prefix: "fas",
    iconName: "border-top-left",
    icon: [
        448,
        512,
        [
            "border-style"
        ],
        "f853",
        "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-336c0-8.8 7.2-16 16-16l336 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32C35.8 32 0 67.8 0 112L0 448zm160 0c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm192 0c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm-96 0c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm192 0c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zm0-128c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$c2867ca78120d644 = $8063e68b12ef6db0$export$cf897c3e0abd59e4;
var $8063e68b12ef6db0$export$757f50b8af780c19 = {
    prefix: "fas",
    iconName: "map-location-dot",
    icon: [
        576,
        512,
        [
            "map-marked-alt"
        ],
        "f5a0",
        "M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40z"
    ]
};
var $8063e68b12ef6db0$export$a977d47c74d8e86c = $8063e68b12ef6db0$export$757f50b8af780c19;
var $8063e68b12ef6db0$export$859f204e59641ca4 = {
    prefix: "fas",
    iconName: "jedi",
    icon: [
        576,
        512,
        [],
        "f669",
        "M246 315.7l-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9 0 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8L332 351.4c-2.2 .4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1 .2-5 2.8l2.1 61.5C370.6 435.2 416 382.9 416 320c0-37-15.7-70.4-40.8-93.7c-7-6.5-6.5-18.6 1-24.4C410.1 175.5 432 134.3 432 88c0-16.8-2.9-33-8.2-48c-4.6-13 10.2-30 21.4-22c53.5 38 92.7 94.8 107.8 160.7c.5 2.1-.2 4.3-1.7 5.9l-28.4 28.4c-4 4-1.2 10.9 4.5 10.9h26c3.4 0 6.2 2.6 6.3 6c.1 3.3 .2 6.6 .2 10c0 17.5-1.7 34.7-4.8 51.3c-.2 1.2-.9 2.4-1.7 3.3l-46.5 46.5c-4 4-1.2 10.9 4.5 10.9H526c4.6 0 7.7 4.8 5.7 9C487.2 450.5 394.8 512 288 512S88.8 450.5 44.3 361c-2.1-4.2 1-9 5.7-9H64.5c5.7 0 8.6-6.9 4.5-10.9L22.6 294.6c-.9-.9-1.5-2-1.7-3.3C17.7 274.7 16 257.5 16 240c0-3.3 .1-6.7 .2-10c.1-3.4 2.9-6 6.3-6h26c5.7 0 8.6-6.9 4.5-10.9L24.6 184.6c-1.5-1.5-2.2-3.8-1.7-5.9C38.1 112.8 77.3 56 130.8 18c11.3-8 26 8.9 21.4 22c-5.3 15-8.2 31.2-8.2 48c0 46.3 21.9 87.5 55.8 113.9c7.5 5.8 8 17.9 1 24.4C175.7 249.6 160 283 160 320c0 62.9 45.4 115.2 105.1 126l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1L246 356.3c1.3-1.9 .2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z"
    ]
};
var $8063e68b12ef6db0$export$91d747e5aabe6fe8 = {
    prefix: "fas",
    iconName: "square-poll-vertical",
    icon: [
        448,
        512,
        [
            "poll"
        ],
        "f681",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 192c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm64-64c0-17.7 14.3-32 32-32s32 14.3 32 32V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zM320 288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$bc8ca14ab51f93db = $8063e68b12ef6db0$export$91d747e5aabe6fe8;
var $8063e68b12ef6db0$export$47a822c30184e8af = {
    prefix: "fas",
    iconName: "mug-hot",
    icon: [
        512,
        512,
        [
            9749
        ],
        "f7b6",
        "M88 0C74.7 0 64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24zM32 192c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96H288c53 0 96-43 96-96h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H352 32zm352 64h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H384V256zM224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z"
    ]
};
var $8063e68b12ef6db0$export$a44d0c11093d9c1e = {
    prefix: "fas",
    iconName: "car-battery",
    icon: [
        512,
        512,
        [
            "battery-car"
        ],
        "f5df",
        "M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64l16 0zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192zM80 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16z"
    ]
};
var $8063e68b12ef6db0$export$9133165ca669dd4b = $8063e68b12ef6db0$export$a44d0c11093d9c1e;
var $8063e68b12ef6db0$export$b2727de8ccdbb5ec = {
    prefix: "fas",
    iconName: "gift",
    icon: [
        512,
        512,
        [
            127873
        ],
        "f06b",
        "M190.5 68.8L225.3 128H224 152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H438.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40H288h-1.3l34.8-59.2C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40zM32 288V464c0 26.5 21.5 48 48 48H224V288H32zM288 512H432c26.5 0 48-21.5 48-48V288H288V512z"
    ]
};
var $8063e68b12ef6db0$export$4d85df590065572f = {
    prefix: "fas",
    iconName: "dice-two",
    icon: [
        448,
        512,
        [
            9857
        ],
        "f528",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM352 352c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM128 192c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$7b8ce73615739d30 = {
    prefix: "fas",
    iconName: "chess-queen",
    icon: [
        512,
        512,
        [
            9819
        ],
        "f445",
        "M312 56c0-30.9-25.1-56-56-56s-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56zM64 480c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM34 169.4L9.2 185.8C3.5 189.7 0 196.2 0 203.1c0 3.2 .7 6.4 2.2 9.3L104 416H408L509.8 212.4c1.4-2.9 2.2-6.1 2.2-9.3c0-6.9-3.5-13.4-9.2-17.3L478 169.4c-8.2-5.4-19-4.4-26 2.6c-12.9 12.9-30.9 21.9-48 15.5c-17.9-6.7-28.1-20.1-32.8-35.8C367.5 139 357.3 128 344 128H328c-13.3 0-23.9 11.2-29.6 23.2C292.6 163.4 280.6 176 256 176s-36.6-12.6-42.4-24.8c-5.7-12-16.3-23.2-29.6-23.2H168c-13.3 0-23.5 11-27.3 23.7c-4.7 15.6-14.9 29.1-32.8 35.8c-17 6.4-35.1-2.7-48-15.5c-6.9-6.9-17.8-8-25.9-2.6z"
    ]
};
var $8063e68b12ef6db0$export$58d7d709c0a8ca5f = {
    prefix: "fas",
    iconName: "glasses",
    icon: [
        576,
        512,
        [],
        "f530",
        "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3c32.3 0 61.8 6.9 82.8 13.5c10.6 3.3 19.3 6.7 25.4 9.2c3.1 1.3 5.5 2.4 7.3 3.2c.9 .4 1.6 .7 2.1 1l.6 .3 .2 .1 .1 0 0 0 0 0s0 0-6.3 12.7h0l6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7h0c-6.3-12.7-6.3-12.7-6.3-12.7l0 0 0 0 .1 0 .2-.1 .6-.3c.5-.2 1.2-.6 2.1-1c1.8-.8 4.2-1.9 7.3-3.2c6.1-2.6 14.8-5.9 25.4-9.2c21-6.6 50.4-13.5 82.8-13.5c30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1c.3 1.9 .5 3.8 .5 5.7v6.7V352v16c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4V368c0 26.5 21.5 48 48 48h44.3c25.5 0 46.5-19.9 47.9-45.3l2.5-45.6c-2.3-.8-4.9-1.7-7.5-2.5c-17.2-5.4-39.9-10.5-63.6-10.5c-23.7 0-46.2 5.1-63.2 10.5c-3.1 1-5.9 1.9-8.5 2.9zM512 368V325.4c-2.6-.9-5.5-1.9-8.5-2.9c-17-5.4-39.5-10.5-63.2-10.5c-23.7 0-46.4 5.1-63.6 10.5c-2.7 .8-5.2 1.7-7.5 2.5l2.5 45.6c1.4 25.4 22.5 45.3 47.9 45.3H464c26.5 0 48-21.5 48-48z"
    ]
};
var $8063e68b12ef6db0$export$bd301515df6246af = {
    prefix: "fas",
    iconName: "chess-board",
    icon: [
        448,
        512,
        [],
        "f43c",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 64v64h64V96h64v64h64V96h64v64H320v64h64v64H320v64h64v64H320V352H256v64H192V352H128v64H64V352h64V288H64V224h64V160H64V96h64zm64 128h64V160H192v64zm0 64V224H128v64h64zm64 0H192v64h64V288zm0 0h64V224H256v64z"
    ]
};
var $8063e68b12ef6db0$export$5559de5f969b9590 = {
    prefix: "fas",
    iconName: "building-circle-check",
    icon: [
        640,
        512,
        [],
        "e4d2",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM640 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $8063e68b12ef6db0$export$c9dc1583b207b7ff = {
    prefix: "fas",
    iconName: "person-chalkboard",
    icon: [
        640,
        512,
        [],
        "e53d",
        "M192 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V192h56 64 16c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64H576V256H384V224H320v48c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H243.1 177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $8063e68b12ef6db0$export$321e84e6a900c2d6 = {
    prefix: "fas",
    iconName: "mars-stroke-right",
    icon: [
        640,
        512,
        [
            9897,
            "mars-stroke-h"
        ],
        "f22b",
        "M208 368c61.9 0 112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112s50.1 112 112 112zm174.4-88C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152H416V176c0-13.3 10.7-24 24-24s24 10.7 24 24v56h32V176c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V280H464v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H382.4z"
    ]
};
var $8063e68b12ef6db0$export$5cb0daeafbcdabe3 = $8063e68b12ef6db0$export$321e84e6a900c2d6;
var $8063e68b12ef6db0$export$be38a892fe9b4098 = {
    prefix: "fas",
    iconName: "hand-back-fist",
    icon: [
        448,
        512,
        [
            "hand-rock"
        ],
        "f255",
        "M144 0C117.5 0 96 21.5 96 48V96v28.5V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V149.3l-9 7.5C40.4 169 32 187 32 206V244c0 38 16.9 74 46.1 98.3L128 384v96c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V374.7c46.9-19 80-65 80-118.7V176 160 144c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z"
    ]
};
var $8063e68b12ef6db0$export$97a81eba394c8c44 = $8063e68b12ef6db0$export$be38a892fe9b4098;
var $8063e68b12ef6db0$export$66068918abb14406 = {
    prefix: "fas",
    iconName: "square-caret-up",
    icon: [
        448,
        512,
        [
            "caret-square-up"
        ],
        "f151",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
    ]
};
var $8063e68b12ef6db0$export$307ae80b26533ce5 = $8063e68b12ef6db0$export$66068918abb14406;
var $8063e68b12ef6db0$export$b416056e795d2eac = {
    prefix: "fas",
    iconName: "cloud-showers-water",
    icon: [
        576,
        512,
        [],
        "e4e4",
        "M224 0c38.6 0 71.9 22.8 87.2 55.7C325.7 41.1 345.8 32 368 32c38.7 0 71 27.5 78.4 64H448c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64c0-53 43-96 96-96zM140.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm327.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM252.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm103.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $8063e68b12ef6db0$export$b532f5d25de97633 = {
    prefix: "fas",
    iconName: "chart-bar",
    icon: [
        512,
        512,
        [
            "bar-chart"
        ],
        "f080",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$2d5f754a5e5738b = $8063e68b12ef6db0$export$b532f5d25de97633;
var $8063e68b12ef6db0$export$2f78563e14e49916 = {
    prefix: "fas",
    iconName: "hands-bubbles",
    icon: [
        512,
        512,
        [
            "hands-wash"
        ],
        "e05e",
        "M384 64c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm80 160c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zM128 464c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM357.1 157.5c-.3 .7-.7 1.5-1.1 2.2l-17.8 30.9c-11-12.6-27.4-19.8-44.4-19.1l20.7-35.8c6.6-11.5 21.3-15.4 32.8-8.8c10.8 6.2 14.9 19.5 9.9 30.6zm-173.6 47C112.3 227.2 64 293.3 64 368c0 1.5 0 3 .1 4.5C24.3 346.9 0 302.8 0 255.1V131.5c0-13.3 10.7-24 24-24s24 10.7 24 24l0 81.7L164.2 12c6.6-11.5 21.3-15.4 32.8-8.8s15.4 21.3 8.8 32.8l-64 110.9c-2.2 3.8-.9 8.7 2.9 10.9s8.7 .9 10.9-2.9l80-138.6c6.6-11.5 21.3-15.4 32.8-8.8s15.4 21.3 8.8 32.8l-80 138.6c-2.2 3.8-.9 8.7 2.9 10.9s8.7 .9 10.9-2.9L275 76c6.6-11.5 21.3-15.4 32.8-8.8s15.4 21.3 8.8 32.8l-44 76.2-89.1 28.3zM448 483.5c0 12.4-9.4 22.6-21.5 23.9c-.8 .1-1.6 .1-2.5 .1H223.3 216c-22.1 0-42.9-6-60.7-16.5c3-8.5 4.7-17.6 4.7-27c0-38.7-27.5-71-64-78.4c0-.6 0-1.1 0-1.7c0-1.2-.1-2.5-.1-3.7c0-68 44-128.3 108.9-148.9l83.9-26.7c12.6-4 26.1 3 30.1 15.6s-3 26.1-15.6 30.1l-53.8 17.1H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H328c-4.4 0-8 3.6-8 8s3.6 8 8 8H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H328c-4.4 0-8 3.6-8 8s3.6 8 8 8H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H328c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c13.3 0 24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$996b5dea53b124e3 = $8063e68b12ef6db0$export$2f78563e14e49916;
var $8063e68b12ef6db0$export$b2c723344cff0d8 = {
    prefix: "fas",
    iconName: "less-than-equal",
    icon: [
        448,
        512,
        [],
        "f537",
        "M395.9 93.7c16.4-6.6 24.4-25.2 17.8-41.6s-25.2-24.4-41.6-17.8l-320 128C40 167.1 32 178.9 32 192s8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8s-1.4-35-17.8-41.6L150.2 192 395.9 93.7zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $8063e68b12ef6db0$export$17cde74bf6f1ee89 = {
    prefix: "fas",
    iconName: "train",
    icon: [
        448,
        512,
        [
            128646
        ],
        "f238",
        "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zM224 384c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $8063e68b12ef6db0$export$23a892b1a4b994bd = {
    prefix: "fas",
    iconName: "eye-low-vision",
    icon: [
        640,
        512,
        [
            "low-vision"
        ],
        "f2a8",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c5.2-11.8 8-24.8 8-38.5c0-53-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zm223.1 298L83.1 161.5c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8zM34.5 268.3c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2L33.1 247.8c-1.8 6.8-1.3 14 1.4 20.5z"
    ]
};
var $8063e68b12ef6db0$export$7a65d2aa54cb4e93 = $8063e68b12ef6db0$export$23a892b1a4b994bd;
var $8063e68b12ef6db0$export$bfa312207b788ed9 = {
    prefix: "fas",
    iconName: "crow",
    icon: [
        640,
        512,
        [],
        "f520",
        "M456 0c-48.6 0-88 39.4-88 88v29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9L126.1 384H259.2l46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384H352c1.1 0 2.1 0 3.2 0l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192V128v-8l80.5-20.1c8.6-2.1 13.8-10.8 11.6-19.4C629 52 603.4 32 574 32H523.9C507.7 12.5 483.3 0 456 0zm0 112c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $8063e68b12ef6db0$export$e363e74e36cce80c = {
    prefix: "fas",
    iconName: "sailboat",
    icon: [
        576,
        512,
        [],
        "e445",
        "M256 16c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1l224 320c3.4 4.9 3.8 11.3 1.1 16.6s-8.2 8.6-14.2 8.6H272c-8.8 0-16-7.2-16-16V16zM212.1 96.5c7 1.9 11.9 8.2 11.9 15.5V336c0 8.8-7.2 16-16 16H80c-5.7 0-11-3-13.8-8s-2.9-11-.1-16l128-224c3.6-6.3 11-9.4 18-7.5zM5.7 404.3C2.8 394.1 10.5 384 21.1 384H554.9c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512H133C75.6 512 25.3 473.9 9.7 418.7l-4-14.3z"
    ]
};
var $8063e68b12ef6db0$export$eccfff9bfd585652 = {
    prefix: "fas",
    iconName: "window-restore",
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M432 64H208c-8.8 0-16 7.2-16 16V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V320h16c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM0 192c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm64 32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"
    ]
};
var $8063e68b12ef6db0$export$eaf727acca5a35e4 = {
    prefix: "fas",
    iconName: "square-plus",
    icon: [
        448,
        512,
        [
            61846,
            "plus-square"
        ],
        "f0fe",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $8063e68b12ef6db0$export$b6359eebfe900c35 = $8063e68b12ef6db0$export$eaf727acca5a35e4;
var $8063e68b12ef6db0$export$75825a4c2b3375e = {
    prefix: "fas",
    iconName: "torii-gate",
    icon: [
        512,
        512,
        [
            9961
        ],
        "f6a1",
        "M0 80c0 26.5 21.5 48 48 48H64v64h64V128h96v64h64V128h96v64h64V128h16c26.5 0 48-21.5 48-48V0L440.6 23.8C424.3 29.2 407.2 32 390 32H122c-17.2 0-34.3-2.8-50.6-8.2L0 0V80zM64 288V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288H384V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64z"
    ]
};
var $8063e68b12ef6db0$export$fe2358263efac504 = {
    prefix: "fas",
    iconName: "frog",
    icon: [
        576,
        512,
        [],
        "f52e",
        "M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9c0 21.8-11.7 41.9-30.7 52.7L400.8 323.5 493.3 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7c-40.6-40.6-106.3-40.6-146.9-.1L101 324.4c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6 .6l73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2c27.9-18.5 65.9-15.4 90.5 9.2c24.7 24.7 27.7 62.9 9 90.9c-2.6 3.8-5.6 7.5-9 10.9L261.8 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64C0 249.6 127 112.9 289.3 97.5C296.2 60.2 328.8 32 368 32zm0 104c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $8063e68b12ef6db0$export$2124c7628e573b84 = {
    prefix: "fas",
    iconName: "bucket",
    icon: [
        448,
        512,
        [],
        "e4cf",
        "M96 152v8H48v-8C48 68.1 116.1 0 200 0h48c83.9 0 152 68.1 152 152v8H352v-8c0-57.4-46.6-104-104-104H200C142.6 48 96 94.6 96 152zM0 224c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-5.1L388.5 469c-2.6 24.4-23.2 43-47.7 43H107.2c-24.6 0-45.2-18.5-47.7-43L37.1 256H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $8063e68b12ef6db0$export$7e9f0928967e03b = {
    prefix: "fas",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
    ]
};
var $8063e68b12ef6db0$export$eed3c491effe6d12 = {
    prefix: "fas",
    iconName: "microphone",
    icon: [
        384,
        512,
        [],
        "f130",
        "M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"
    ]
};
var $8063e68b12ef6db0$export$1da3b2e53dcafa2d = {
    prefix: "fas",
    iconName: "cow",
    icon: [
        640,
        512,
        [
            128004
        ],
        "f6c8",
        "M96 224v32V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V327.8c9.9 6.6 20.6 12 32 16.1V368c0 8.8 7.2 16 16 16s16-7.2 16-16V351.1c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9V368c0 8.8 7.2 16 16 16s16-7.2 16-16V343.8c11.4-4 22.1-9.4 32-16.1V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256l32 32v49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v14.4l-52.9-74.1C496 86.5 452.4 64 405.9 64H272 256 192 144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4V256 224 184c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160v64zM592 336c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6H361.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9l-23.4-23.4z"
    ]
};
var $8063e68b12ef6db0$export$7de776bdab4e536d = {
    prefix: "fas",
    iconName: "caret-up",
    icon: [
        320,
        512,
        [],
        "f0d8",
        "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
};
var $8063e68b12ef6db0$export$7484ff654cd6474f = {
    prefix: "fas",
    iconName: "screwdriver",
    icon: [
        512,
        512,
        [
            129691
        ],
        "f54a",
        "M465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19v54.1l-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8L353.9 192H408c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7zM121.4 281.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"
    ]
};
var $8063e68b12ef6db0$export$5e30548b7f8eeb95 = {
    prefix: "fas",
    iconName: "folder-closed",
    icon: [
        512,
        512,
        [],
        "e185",
        "M448 480H64c-35.3 0-64-28.7-64-64V192H512V416c0 35.3-28.7 64-64 64zm64-320H0V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H448c35.3 0 64 28.7 64 64z"
    ]
};
var $8063e68b12ef6db0$export$197b9567e88a0b1d = {
    prefix: "fas",
    iconName: "house-tsunami",
    icon: [
        576,
        512,
        [],
        "e515",
        "M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7c16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9c.7 0 1.4 0 2.1-.1c1.8 0 3.7 .1 5.5 .1l0 0c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0c-22.4 15.5-49.9 26.1-77.4 26.1c0 0-.1 0-.1 0c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3c16 7.5 35.1 .6 42.5-15.5s.6-35.1-15.5-42.5C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5zm252-18.1c-8.1 6-12.8 15.5-12.8 25.6V265c1.6 1 3.3 2 4.8 3.1c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c5.8 1.4 11.2 3.4 16.2 6.2c.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72c-11.4-8.6-27.1-8.6-38.5 0l-96 72zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"
    ]
};
var $8063e68b12ef6db0$export$5498258519fc5b72 = {
    prefix: "fas",
    iconName: "square-nfi",
    icon: [
        448,
        512,
        [],
        "e576",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm75.7 64.6C68.8 162.5 64 168.8 64 176V336c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V278.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v64 96c0 8.8 7.2 16 16 16s16-7.2 16-16V256h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"
    ]
};
var $8063e68b12ef6db0$export$cbe485a104805f4f = {
    prefix: "fas",
    iconName: "arrow-up-from-ground-water",
    icon: [
        576,
        512,
        [],
        "e4b5",
        "M288 352c17.7 0 32-14.3 32-32V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM192 192H48c-26.5 0-48 21.5-48 48V425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3V192zm384 48c0-26.5-21.5-48-48-48H384V416.5h0c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9V240z"
    ]
};
var $8063e68b12ef6db0$export$98401bb29cff68e0 = {
    prefix: "fas",
    iconName: "martini-glass",
    icon: [
        512,
        512,
        [
            127864,
            "glass-martini-alt"
        ],
        "f57b",
        "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM173.3 128l-64-64H402.7l-64 64H173.3z"
    ]
};
var $8063e68b12ef6db0$export$2258439b8f4e7acb = $8063e68b12ef6db0$export$98401bb29cff68e0;
var $8063e68b12ef6db0$export$7adaa412bd8eb08f = {
    prefix: "fas",
    iconName: "rotate-left",
    icon: [
        512,
        512,
        [
            "rotate-back",
            "rotate-backward",
            "undo-alt"
        ],
        "f2ea",
        "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"
    ]
};
var $8063e68b12ef6db0$export$9706706f1bc7b12 = $8063e68b12ef6db0$export$7adaa412bd8eb08f;
var $8063e68b12ef6db0$export$4ceb0b05fed961a9 = $8063e68b12ef6db0$export$7adaa412bd8eb08f;
var $8063e68b12ef6db0$export$c8197b992c46c4a6 = $8063e68b12ef6db0$export$7adaa412bd8eb08f;
var $8063e68b12ef6db0$export$ccaa019a3fd4563f = {
    prefix: "fas",
    iconName: "table-columns",
    icon: [
        512,
        512,
        [
            "columns"
        ],
        "f0db",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 64V416H224V160H64zm384 0H288V416H448V160z"
    ]
};
var $8063e68b12ef6db0$export$bb861166644ac28a = $8063e68b12ef6db0$export$ccaa019a3fd4563f;
var $8063e68b12ef6db0$export$4fbda8f64648f3b5 = {
    prefix: "fas",
    iconName: "lemon",
    icon: [
        448,
        512,
        [
            127819
        ],
        "f094",
        "M448 96c0-35.3-28.7-64-64-64c-6.6 0-13 1-19 2.9c-22.5 7-48.1 14.9-71 9c-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416c0 35.3 28.7 64 64 64c6.6 0 13-1 19.1-2.9c22.5-7 48.1-14.9 71-9c75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71c1.9-6 2.9-12.4 2.9-19.1zM212.5 127.4c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9z"
    ]
};
var $8063e68b12ef6db0$export$280300af4baa1a3e = {
    prefix: "fas",
    iconName: "head-side-mask",
    icon: [
        512,
        512,
        [],
        "e063",
        "M0 224.2c0-22.2 3.2-43.6 9.2-63.9l227 165.1C228.5 337.8 224 352.4 224 368V512H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm258.6 77.9L21 129.3C56.7 53 134.2 0 224 0h32c95.2 0 174.2 69.3 189.4 160.1c2.2 13 6.7 25.7 15 36.1l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 4.1-.6 8.1-1.6 11.9H304c-16.9 0-32.5 5.2-45.4 14.1zM352 224c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM256 512V368c0-26.5 21.5-48 48-48H512l-16 48H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H485.3l-10.7 32H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H464l-1.4 4.2c-8.7 26.1-33.2 43.8-60.7 43.8H256z"
    ]
};
var $8063e68b12ef6db0$export$b4c63e9bfc7906f1 = {
    prefix: "fas",
    iconName: "handshake",
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123zM96 128H0V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V128zM48 352c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V128H544zm64 208c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$31ee86ac717db552 = {
    prefix: "fas",
    iconName: "gem",
    icon: [
        512,
        512,
        [
            128142
        ],
        "f3a5",
        "M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.6 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"
    ]
};
var $8063e68b12ef6db0$export$5879d0bca1aa497b = {
    prefix: "fas",
    iconName: "dolly",
    icon: [
        640,
        512,
        [
            "dolly-box"
        ],
        "f472",
        "M32 32C32 14.3 46.3 0 64 0h72.9c27.5 0 52 17.6 60.7 43.8L289.7 320c30.1 .5 56.8 14.9 74 37l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L384 417.7c-.9 52.2-43.5 94.3-96 94.3c-53 0-96-43-96-96c0-30.8 14.5-58.2 37-75.8L136.9 64H64C46.3 64 32 49.7 32 32zM276.8 134.5c-5.5-16.8 3.7-34.9 20.5-40.3L343 79.4l19.8 60.9 60.9-19.8L403.8 59.6l45.7-14.8c16.8-5.5 34.9 3.7 40.3 20.5l49.4 152.2c5.5 16.8-3.7 34.9-20.5 40.3L366.5 307.2c-16.8 5.5-34.9-3.7-40.3-20.5L276.8 134.5z"
    ]
};
var $8063e68b12ef6db0$export$461bbb9e92cc531b = $8063e68b12ef6db0$export$5879d0bca1aa497b;
var $8063e68b12ef6db0$export$c4ab83701fc591a5 = {
    prefix: "fas",
    iconName: "smoking",
    icon: [
        640,
        512,
        [
            128684
        ],
        "f48d",
        "M448 32V43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v11c0 17.7-14.3 32-32 32s-32-14.3-32-32V245c0-12.7-5.1-24.9-14.1-33.9l-21-21C405.9 151.1 384 98.1 384 43V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM576 256V245c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V32c0-17.7 14.3-32 32-32s32 14.3 32 32V43c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1v11c0 17.7-14.3 32-32 32s-32-14.3-32-32zM0 416c0-35.3 28.7-64 64-64H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V416zm224 0v32H384V416H224zm288-64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$e0601b1f239fec74 = {
    prefix: "fas",
    iconName: "minimize",
    icon: [
        512,
        512,
        [
            "compress-arrows-alt"
        ],
        "f78c",
        "M456 224H312c-13.3 0-24-10.7-24-24V56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L442.3 5.7C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8zm0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C466 510 461.1 512 456 512s-10-2-13.7-5.7L369 433l-40 40c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V312c0-13.3 10.7-24 24-24H456zm-256 0c13.3 0 24 10.7 24 24V456c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L69.7 506.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369 39 329c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8H200zM56 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l40-40L5.7 69.7C2 66 0 61.1 0 56s2-10 5.7-13.7L42.3 5.7C46 2 50.9 0 56 0s10 2 13.7 5.7L143 79l40-40c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V200c0 13.3-10.7 24-24 24H56z"
    ]
};
var $8063e68b12ef6db0$export$39205db0ea980efd = $8063e68b12ef6db0$export$e0601b1f239fec74;
var $8063e68b12ef6db0$export$6f9b0bfc012deb25 = {
    prefix: "fas",
    iconName: "monument",
    icon: [
        384,
        512,
        [],
        "f5a6",
        "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.1 5.8 4.6 9.3l40.2 322H55.9L96.1 94c.4-3.5 2-6.8 4.6-9.3l80-80zM152 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zM32 448H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$695fae58f55c3a87 = {
    prefix: "fas",
    iconName: "snowplow",
    icon: [
        640,
        512,
        [],
        "f7d2",
        "M298.9 64l68.6 160H256l-64-64V64H298.9zM445.1 242.7l-87.4-204C347.6 15.3 324.5 0 298.9 0H176c-26.5 0-48 21.5-48 48V160H96c-17.7 0-32 14.3-32 32V298.8C26.2 316.8 0 355.3 0 400c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112c0-17.2-3.9-33.5-10.8-48H512v50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7V320 235.2L633 164c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40V288H448V256.7c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM368 352c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48H368zM144 400c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zm216 24c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm-56-24c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zM200 424c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $8063e68b12ef6db0$export$48b60f1720e09944 = {
    prefix: "fas",
    iconName: "angles-right",
    icon: [
        512,
        512,
        [
            187,
            "angle-double-right"
        ],
        "f101",
        "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
var $8063e68b12ef6db0$export$792931403404faf0 = $8063e68b12ef6db0$export$48b60f1720e09944;
var $8063e68b12ef6db0$export$8ec2f752344b69bd = {
    prefix: "fas",
    iconName: "cannabis",
    icon: [
        512,
        512,
        [],
        "f55f",
        "M256 0c5.3 0 10.3 2.7 13.3 7.1c15.8 23.5 36.7 63.7 49.2 109c7.2 26.4 11.8 55.2 10.4 84c11.5-8.8 23.7-16.7 35.8-23.6c41-23.3 84.4-36.9 112.2-42.5c5.2-1 10.7 .6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7c-9.1 15.9-19.9 31.7-32.4 46.3c27.8 6.6 52.4 17.3 67.2 25.5c5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1c-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V417.2l-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6c-28.9-6.6-54.6-17.6-69.8-26.1c-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5C78.9 296.3 68.1 280.5 59 264.6c-23.4-40.8-37.1-84-42.7-111.7c-1.1-5.2 .6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5c12.1 6.9 24.3 14.7 35.8 23.6c-1.4-28.7 3.1-57.6 10.4-84c12.5-45.3 33.4-85.5 49.2-109c3-4.4 8-7.1 13.3-7.1z"
    ]
};
var $8063e68b12ef6db0$export$86c4e45dc3302d15 = {
    prefix: "fas",
    iconName: "circle-play",
    icon: [
        512,
        512,
        [
            61469,
            "play-circle"
        ],
        "f144",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"
    ]
};
var $8063e68b12ef6db0$export$cf04333781061c5e = $8063e68b12ef6db0$export$86c4e45dc3302d15;
var $8063e68b12ef6db0$export$bed2b0ed4ae45e0d = {
    prefix: "fas",
    iconName: "tablets",
    icon: [
        640,
        512,
        [],
        "f490",
        "M614.3 247c16.3-25 25.7-54.9 25.7-87C640 71.6 568.4 0 480 0c-32.1 0-61.9 9.4-87 25.7c-7.9 5.2-8.5 16.2-1.8 22.9L591.4 248.8c6.7 6.7 17.8 6.2 22.9-1.8zM567 294.3c7.9-5.2 8.5-16.2 1.8-22.9L368.6 71.2c-6.7-6.7-17.8-6.2-22.9 1.8c-16.3 25-25.7 54.9-25.7 87c0 88.4 71.6 160 160 160c32.1 0 61.9-9.4 87-25.7zM301.5 368H18.5c-9.5 0-16.9 8.2-15 17.5C18.9 457.8 83.1 512 160 512s141.1-54.2 156.5-126.5c2-9.3-5.5-17.5-15-17.5zm0-32c9.5 0 16.9-8.2 15-17.5C301.1 246.2 236.9 192 160 192S18.9 246.2 3.5 318.5c-2 9.3 5.5 17.5 15 17.5H301.5z"
    ]
};
var $8063e68b12ef6db0$export$6bad2c9f317b52e5 = {
    prefix: "fas",
    iconName: "ethernet",
    icon: [
        512,
        512,
        [],
        "f796",
        "M0 224V416c0 17.7 14.3 32 32 32H96V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448V160c0-17.7-14.3-32-32-32H384V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32v32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var $8063e68b12ef6db0$export$902a3969bb113dff = {
    prefix: "fas",
    iconName: "euro-sign",
    icon: [
        320,
        512,
        [
            8364,
            "eur",
            "euro"
        ],
        "f153",
        "M48.1 240c-.1 2.7-.1 5.3-.1 8v16c0 2.7 0 5.3 .1 8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H60.3C89.9 419.9 170 480 264 480h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264c-57.9 0-108.2-32.4-133.9-80H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112.2c-.1-2.6-.2-5.3-.2-8V248c0-2.7 .1-5.4 .2-8H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H130.1c25.7-47.6 76-80 133.9-80h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264C170 32 89.9 92.1 60.3 176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48.1z"
    ]
};
var $8063e68b12ef6db0$export$4b859160cfeb12ff = $8063e68b12ef6db0$export$902a3969bb113dff;
var $8063e68b12ef6db0$export$bdabbefede2d3a2 = $8063e68b12ef6db0$export$902a3969bb113dff;
var $8063e68b12ef6db0$export$a339864ee3df7e9a = {
    prefix: "fas",
    iconName: "chair",
    icon: [
        448,
        512,
        [
            129681
        ],
        "f6c0",
        "M248 48V256h48V58.7c23.9 13.8 40 39.7 40 69.3V256h48V128C384 57.3 326.7 0 256 0H192C121.3 0 64 57.3 64 128V256h48V128c0-29.6 16.1-55.5 40-69.3V256h48V48h48zM48 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S20.9 384 32 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32V384H352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C423.2 294.8 412.1 288 400 288H48z"
    ]
};
var $8063e68b12ef6db0$export$c2e9877668862374 = {
    prefix: "fas",
    iconName: "circle-check",
    icon: [
        512,
        512,
        [
            61533,
            "check-circle"
        ],
        "f058",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $8063e68b12ef6db0$export$be9e388158c74f29 = $8063e68b12ef6db0$export$c2e9877668862374;
var $8063e68b12ef6db0$export$229de76dfef2687f = {
    prefix: "fas",
    iconName: "circle-stop",
    icon: [
        512,
        512,
        [
            62094,
            "stop-circle"
        ],
        "f28d",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM192 160H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$47af2aad60ab3e7c = $8063e68b12ef6db0$export$229de76dfef2687f;
var $8063e68b12ef6db0$export$aaaddd2cf7e20f64 = {
    prefix: "fas",
    iconName: "compass-drafting",
    icon: [
        512,
        512,
        [
            "drafting-compass"
        ],
        "f568",
        "M352 96c0 14.3-3.1 27.9-8.8 40.2L396 227.4c-23.7 25.3-54.2 44.1-88.5 53.6L256 192h0 0l-68 117.5c21.5 6.8 44.3 10.5 68.1 10.5c70.7 0 133.8-32.7 174.9-84c11.1-13.8 31.2-16 45-5s16 31.2 5 45C428.1 341.8 347 384 256 384c-35.4 0-69.4-6.4-100.7-18.1L98.7 463.7C94 471.8 87 478.4 78.6 482.6L23.2 510.3c-5 2.5-10.9 2.2-15.6-.7S0 501.5 0 496V440.6c0-8.4 2.2-16.7 6.5-24.1l60-103.7C53.7 301.6 41.8 289.3 31.2 276c-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1l69.4-119.9c-5.6-12.2-8.8-25.8-8.8-40.2c0-53 43-96 96-96s96 43 96 96zm21 297.9c32.6-12.8 62.5-30.8 88.9-52.9l43.7 75.5c4.2 7.3 6.5 15.6 6.5 24.1V496c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-55.4-27.7c-8.4-4.2-15.4-10.8-20.1-18.9L373 393.9zM256 128c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$c8c2b127d13b9d79 = $8063e68b12ef6db0$export$aaaddd2cf7e20f64;
var $8063e68b12ef6db0$export$2eff9f6cbe00a643 = {
    prefix: "fas",
    iconName: "plate-wheat",
    icon: [
        512,
        512,
        [],
        "e55a",
        "M176 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM56 64h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 136H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48zM400 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm80 160v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 176c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80zm-96 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM3.5 347.6C1.6 332.9 13 320 27.8 320H484.2c14.8 0 26.2 12.9 24.4 27.6C502.3 397.8 464.2 437 416 446v2c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-2c-48.2-9-86.3-48.2-92.5-98.4z"
    ]
};
var $8063e68b12ef6db0$export$78792ed87d92a3ad = {
    prefix: "fas",
    iconName: "icicles",
    icon: [
        512,
        512,
        [],
        "f7ad",
        "M75.8 304.8L1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0H482.4C498.8 0 512 13.2 512 29.6c0 1.6-.1 3.3-.4 4.9L434.6 496.1c-1.5 9.2-9.5 15.9-18.8 15.9c-9.2 0-17.1-6.6-18.7-15.6L336 160 307.2 303.9c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1L240 192 210.6 368.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192 115.9 304.3c-2.3 9.2-10.6 15.7-20.1 15.7c-9.3 0-17.5-6.2-20-15.2z"
    ]
};
var $8063e68b12ef6db0$export$d359c2cc7640953c = {
    prefix: "fas",
    iconName: "person-shelter",
    icon: [
        512,
        512,
        [],
        "e54f",
        "M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160V480c0 17.7 14.3 32 32 32s32-14.3 32-32V178.6L256 68.9 448 178.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40zm-8 280V400h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H246.2c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $8063e68b12ef6db0$export$771cf879fba0cf93 = {
    prefix: "fas",
    iconName: "neuter",
    icon: [
        384,
        512,
        [
            9906
        ],
        "f22c",
        "M304 176c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V349.1z"
    ]
};
var $8063e68b12ef6db0$export$a75288855ea05282 = {
    prefix: "fas",
    iconName: "id-badge",
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm96-96c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM144 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$e6789173649caa25 = {
    prefix: "fas",
    iconName: "marker",
    icon: [
        512,
        512,
        [],
        "f5a1",
        "M481 31C445.1-4.8 386.9-4.8 351 31l-15 15L322.9 33C294.8 4.9 249.2 4.9 221.1 33L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L255 66.9c9.4-9.4 24.6-9.4 33.9 0L302.1 80 186.3 195.7 316.3 325.7 481 161c35.9-35.9 35.9-94.1 0-129.9zM293.7 348.3L163.7 218.3 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l64.2-64.2z"
    ]
};
var $8063e68b12ef6db0$export$3f2d51c0547bf984 = {
    prefix: "fas",
    iconName: "face-laugh-beam",
    icon: [
        512,
        512,
        [
            128513,
            "laugh-beam"
        ],
        "f59a",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM101.6 314c-3.7-13.7 7.5-26 21.7-26H388.7c14.2 0 25.4 12.3 21.7 26C392 382 329.8 432 256 432s-136-50-154.4-118zm116-101.2l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $8063e68b12ef6db0$export$a88d1f4073ea9369 = $8063e68b12ef6db0$export$3f2d51c0547bf984;
var $8063e68b12ef6db0$export$2a66e6044c1f7036 = {
    prefix: "fas",
    iconName: "helicopter-symbol",
    icon: [
        512,
        512,
        [],
        "e502",
        "M445.3 224H510C495.6 108.2 403.8 16.4 288 2V66.7C368.4 80.1 431.9 143.6 445.3 224zM510 288H445.3C431.9 368.4 368.4 431.9 288 445.4V510c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510V445.4C143.6 431.9 80.1 368.4 66.7 288H2zm0-64H66.7C80.1 143.6 143.6 80.1 224 66.7V2C108.2 16.4 16.4 108.2 2 224zm206-64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V288h96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H208V160z"
    ]
};
var $8063e68b12ef6db0$export$e119aada7f690d05 = {
    prefix: "fas",
    iconName: "universal-access",
    icon: [
        512,
        512,
        [],
        "f29a",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM161.5 169.9c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3v50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6V235.5c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40z"
    ]
};
var $8063e68b12ef6db0$export$7b69b3617b84259b = {
    prefix: "fas",
    iconName: "circle-chevron-up",
    icon: [
        512,
        512,
        [
            "chevron-circle-up"
        ],
        "f139",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z"
    ]
};
var $8063e68b12ef6db0$export$b786cf5db03f2c36 = $8063e68b12ef6db0$export$7b69b3617b84259b;
var $8063e68b12ef6db0$export$d317bc452442782d = {
    prefix: "fas",
    iconName: "lari-sign",
    icon: [
        384,
        512,
        [],
        "e1c8",
        "M144 32c17.7 0 32 14.3 32 32V96.7c5.3-.4 10.6-.7 16-.7s10.7 .2 16 .7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v49.4c54.9 25.2 95.8 75.5 108.2 136.2c3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.1-29.9-22.5-55.9-45.4-74.3V256c0 17.7-14.3 32-32 32s-32-14.3-32-32V161c-5.2-.7-10.6-1-16-1s-10.8 .3-16 1v95c0 17.7-14.3 32-32 32s-32-14.3-32-32V188.1C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H192 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48.9C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6V64c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$bae30a76735500e1 = {
    prefix: "fas",
    iconName: "volcano",
    icon: [
        512,
        512,
        [
            127755
        ],
        "f770",
        "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM144 352l48.4-24.2c10.2-5.1 21.6-7.8 33-7.8c19.6 0 38.4 7.8 52.2 21.6l32.5 32.5c6.3 6.3 14.9 9.9 23.8 9.9c11.3 0 21.8-5.6 28-15l9.7-14.6-59-66.3c-9.1-10.2-22.2-16.1-35.9-16.1H235.1c-13.7 0-26.8 5.9-35.9 16.1l-59.9 67.4L144 352zm19.4-95.8c18.2-20.5 44.3-32.2 71.8-32.2h41.8c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"
    ]
};
var $8063e68b12ef6db0$export$a1d09c95bee8043b = {
    prefix: "fas",
    iconName: "person-walking-dashed-line-arrow-right",
    icon: [
        640,
        512,
        [],
        "e553",
        "M208 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80zM392 0c-13.3 0-24 10.7-24 24V72c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm24 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM392 320c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V344c0-13.3-10.7-24-24-24zm24 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V440z"
    ]
};
var $8063e68b12ef6db0$export$170c56774c8e7961 = {
    prefix: "fas",
    iconName: "sterling-sign",
    icon: [
        384,
        512,
        [
            163,
            "gbp",
            "pound-sign"
        ],
        "f154",
        "M144 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L249 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C137.5 32 80 89.5 80 160.4V224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H80v44.5c0 17.4-4.7 34.5-13.7 49.4L36.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S52.5 480 64 480H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H120.5l.7-1.1C136.1 390 144 361.5 144 332.5V288H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H144V160.4z"
    ]
};
var $8063e68b12ef6db0$export$3d9479ec1d1ae83e = $8063e68b12ef6db0$export$170c56774c8e7961;
var $8063e68b12ef6db0$export$9ce041dfec8319b = $8063e68b12ef6db0$export$170c56774c8e7961;
var $8063e68b12ef6db0$export$ee194b18f5c6f6b6 = {
    prefix: "fas",
    iconName: "viruses",
    icon: [
        640,
        512,
        [],
        "e076",
        "M192 0c13.3 0 24 10.7 24 24V37.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H346.5c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V346.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H37.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24zm48 224c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm-48-64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm320 80c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $8063e68b12ef6db0$export$8aaca358568da0e0 = {
    prefix: "fas",
    iconName: "square-person-confined",
    icon: [
        448,
        512,
        [],
        "e577",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM256 144c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM240 248c0-30.9 25.1-56 56-56s56 25.1 56 56V350.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L240 306.7V248z"
    ]
};
var $8063e68b12ef6db0$export$48c51dda34e9f04c = {
    prefix: "fas",
    iconName: "user-tie",
    icon: [
        448,
        512,
        [],
        "f508",
        "M224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128S153.3 0 224 0zM209.1 359.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2H224h19.7c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 39.5-161.2c77.2 12 136.3 78.8 136.3 159.4c0 17-13.8 30.7-30.7 30.7H265.1 182.9 30.7C13.8 512 0 498.2 0 481.3c0-80.6 59.1-147.4 136.3-159.4l39.5 161.2 33.4-123.9z"
    ]
};
var $8063e68b12ef6db0$export$5977e8de7e65b20 = {
    prefix: "fas",
    iconName: "arrow-down-long",
    icon: [
        384,
        512,
        [
            "long-arrow-down"
        ],
        "f175",
        "M224 402.7V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V402.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7z"
    ]
};
var $8063e68b12ef6db0$export$52ecf90b62f3f030 = $8063e68b12ef6db0$export$5977e8de7e65b20;
var $8063e68b12ef6db0$export$8a4f323f00a91606 = {
    prefix: "fas",
    iconName: "tent-arrow-down-to-line",
    icon: [
        640,
        512,
        [],
        "e57e",
        "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 122.1 39.9-36c9.9-8.9 25-8.1 33.9 1.8zm122.8 22.6c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160 .7 4.7c17.5 .2 31.6 14.4 31.6 32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H159.6l.7-4.7 24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128zM384 448h76.8L384 320V448z"
    ]
};
var $8063e68b12ef6db0$export$a881f37164b11fbf = {
    prefix: "fas",
    iconName: "certificate",
    icon: [
        512,
        512,
        [],
        "f0a3",
        "M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.3-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z"
    ]
};
var $8063e68b12ef6db0$export$ca6fd367f31ecbc5 = {
    prefix: "fas",
    iconName: "reply-all",
    icon: [
        576,
        512,
        [
            "mail-reply-all"
        ],
        "f122",
        "M117.2 160.4L224 64.3V64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 190.3 0 198.9 0 208s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2v-.3L117.2 255.6C103.7 243.4 96 226.1 96 208s7.7-35.4 21.2-47.6zM352 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V288h32c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176H352V64z"
    ]
};
var $8063e68b12ef6db0$export$8274334f3a2c1841 = $8063e68b12ef6db0$export$ca6fd367f31ecbc5;
var $8063e68b12ef6db0$export$60710f3921019268 = {
    prefix: "fas",
    iconName: "suitcase",
    icon: [
        512,
        512,
        [
            129523
        ],
        "f0f2",
        "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96v32V480H128V128 96zM64 96H96V480H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zM448 480H416V96h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64z"
    ]
};
var $8063e68b12ef6db0$export$f3854553fe688388 = {
    prefix: "fas",
    iconName: "person-skating",
    icon: [
        448,
        512,
        [
            "skating"
        ],
        "f7c5",
        "M448 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM128 128c0-17.7 14.3-32 32-32H319.4c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V349.3l-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17H160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm322.5 95.1c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
    ]
};
var $8063e68b12ef6db0$export$21bd1d54bd4f2c5a = $8063e68b12ef6db0$export$f3854553fe688388;
var $8063e68b12ef6db0$export$3300e4b4d1d1936f = {
    prefix: "fas",
    iconName: "filter-circle-dollar",
    icon: [
        576,
        512,
        [
            "funnel-dollar"
        ],
        "f662",
        "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM576 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM408.8 335.4c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"
    ]
};
var $8063e68b12ef6db0$export$cebe38ad8f0a143d = $8063e68b12ef6db0$export$3300e4b4d1d1936f;
var $8063e68b12ef6db0$export$41dbdadc07a89b05 = {
    prefix: "fas",
    iconName: "camera-retro",
    icon: [
        512,
        512,
        [
            128247
        ],
        "f083",
        "M220.6 121.2L271.1 96 448 96v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64V128H192c9.9 0 19.7-2.3 28.6-6.8zM0 128V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H160V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM344 304c0 48.6-39.4 88-88 88s-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88z"
    ]
};
var $8063e68b12ef6db0$export$a30c52cde32bec7e = {
    prefix: "fas",
    iconName: "circle-arrow-down",
    icon: [
        512,
        512,
        [
            "arrow-circle-down"
        ],
        "f0ab",
        "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM127 297c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l71 71L232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 214.1 71-71c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 409c-9.4 9.4-24.6 9.4-33.9 0L127 297z"
    ]
};
var $8063e68b12ef6db0$export$6cfa36bbb3a057 = $8063e68b12ef6db0$export$a30c52cde32bec7e;
var $8063e68b12ef6db0$export$d796c05153b1255c = {
    prefix: "fas",
    iconName: "file-import",
    icon: [
        512,
        512,
        [
            "arrow-right-to-file"
        ],
        "f56f",
        "M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128V64zm0 224v48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H128zM512 128H384V0L512 128z"
    ]
};
var $8063e68b12ef6db0$export$32f14beaf6294476 = $8063e68b12ef6db0$export$d796c05153b1255c;
var $8063e68b12ef6db0$export$38150b61dfd06fff = {
    prefix: "fas",
    iconName: "square-arrow-up-right",
    icon: [
        448,
        512,
        [
            "external-link-square"
        ],
        "f14c",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z"
    ]
};
var $8063e68b12ef6db0$export$e04d83fed5ebcebf = $8063e68b12ef6db0$export$38150b61dfd06fff;
var $8063e68b12ef6db0$export$9010ed816a8b9c97 = {
    prefix: "fas",
    iconName: "box-open",
    icon: [
        640,
        512,
        [],
        "f49e",
        "M58.9 42.1c3-6.1 9.6-9.6 16.3-8.7L320 64 564.8 33.4c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 217.3c-13.9 4-28.8-1.9-36.2-14.3L320 64 236.6 203c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 170.6c-19.3-5.5-28.8-27.2-19.8-45.1L58.9 42.1zM321.1 128l54.9 91.4c14.9 24.8 44.6 36.6 72.5 28.6L576 211.6v167c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 419.7 64 400.5 64 378.5v-167L191.6 248c27.8 8 57.6-3.8 72.5-28.6L318.9 128h2.2z"
    ]
};
var $8063e68b12ef6db0$export$7c265716d4399676 = {
    prefix: "fas",
    iconName: "scroll",
    icon: [
        576,
        512,
        [
            128220
        ],
        "f70e",
        "M0 80v48c0 17.7 14.3 32 32 32H48 96V80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48V384c0 35.3 28.7 64 64 64s64-28.7 64-64v-5.3c0-32.4 26.3-58.7 58.7-58.7H480V128c0-53-43-96-96-96H112zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16H314.7c-14.7 0-26.7 11.9-26.7 26.7V384c0 53-43 96-96 96H368h96z"
    ]
};
var $8063e68b12ef6db0$export$f9a38ef7b046ab51 = {
    prefix: "fas",
    iconName: "spa",
    icon: [
        576,
        512,
        [],
        "f5bb",
        "M183.1 235.3c33.7 20.7 62.9 48.1 85.8 80.5c7 9.9 13.4 20.3 19.1 31c5.7-10.8 12.1-21.1 19.1-31c22.9-32.4 52.1-59.8 85.8-80.5C437.6 207.8 490.1 192 546 192h9.9c11.1 0 20.1 9 20.1 20.1C576 360.1 456.1 480 308.1 480H288 267.9C119.9 480 0 360.1 0 212.1C0 201 9 192 20.1 192H30c55.9 0 108.4 15.8 153.1 43.3zM301.5 37.6c15.7 16.9 61.1 71.8 84.4 164.6c-38 21.6-71.4 50.8-97.9 85.6c-26.5-34.8-59.9-63.9-97.9-85.6c23.2-92.8 68.6-147.7 84.4-164.6C278 33.9 282.9 32 288 32s10 1.9 13.5 5.6z"
    ]
};
var $8063e68b12ef6db0$export$db853fbb474326cc = {
    prefix: "fas",
    iconName: "location-pin-lock",
    icon: [
        512,
        512,
        [],
        "e51f",
        "M215.7 499.2c11-13.8 25.1-31.7 40.3-52.3V352c0-23.7 12.9-44.4 32-55.4V272c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0C86 0 0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 256c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm208-16c17.7 0 32 14.3 32 32v48H368V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $8063e68b12ef6db0$export$da79f048408b1722 = {
    prefix: "fas",
    iconName: "pause",
    icon: [
        320,
        512,
        [
            9208
        ],
        "f04c",
        "M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z"
    ]
};
var $8063e68b12ef6db0$export$50d11c98c99e3b2d = {
    prefix: "fas",
    iconName: "hill-avalanche",
    icon: [
        640,
        512,
        [],
        "e507",
        "M471.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8c34.4-34.4 34.4-90.1 0-124.4c-27.8-27.8-69.5-33.1-102.6-16c-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C433.2 261.3 448 236.4 448 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C248.3 46.6 229.9 32 208 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L471.7 401.9zM512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm0 128c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM100.3 87C75.1 61.8 32 79.7 32 115.3V432c0 44.2 35.8 80 80 80H428.7c35.6 0 53.5-43.1 28.3-68.3L100.3 87z"
    ]
};
var $8063e68b12ef6db0$export$ac389bf5cc37feb5 = {
    prefix: "fas",
    iconName: "temperature-empty",
    icon: [
        320,
        512,
        [
            "temperature-0",
            "thermometer-0",
            "thermometer-empty"
        ],
        "f2cb",
        "M112 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM160 0C98.1 0 48 50.2 48 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C272 50.2 221.9 0 160 0zm0 416c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
    ]
};
var $8063e68b12ef6db0$export$e99b7d2ccc282383 = $8063e68b12ef6db0$export$ac389bf5cc37feb5;
var $8063e68b12ef6db0$export$4c13a186ecce3b80 = $8063e68b12ef6db0$export$ac389bf5cc37feb5;
var $8063e68b12ef6db0$export$81a2f8298cf523f9 = $8063e68b12ef6db0$export$ac389bf5cc37feb5;
var $8063e68b12ef6db0$export$d59078f6e80b4a67 = {
    prefix: "fas",
    iconName: "bomb",
    icon: [
        512,
        512,
        [
            128163
        ],
        "f1e2",
        "M459.1 52.4L442.6 6.5C440.7 2.6 436.5 0 432.1 0s-8.5 2.6-10.4 6.5L405.2 52.4l-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4c0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2c0-4.6-3-8.9-7.2-10.4L459.1 52.4zm-132.4 53c-12.5-12.5-32.8-12.5-45.3 0l-2.9 2.9C256.5 100.3 232.7 96 208 96C93.1 96 0 189.1 0 304S93.1 512 208 512s208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9c12.5-12.5 12.5-32.8 0-45.3l-80-80zM200 192c-57.4 0-104 46.6-104 104v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-75.1 60.9-136 136-136h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8z"
    ]
};
var $8063e68b12ef6db0$export$5f519e9ac15ab8c3 = {
    prefix: "fas",
    iconName: "registered",
    icon: [
        512,
        512,
        [
            174
        ],
        "f25d",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM160 152c0-13.3 10.7-24 24-24h88c44.2 0 80 35.8 80 80c0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1 .1 26.3-11.9 31.8s-26.3 .1-31.8-11.9L268.9 288H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152zm48 88h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H208v64z"
    ]
};
var $8063e68b12ef6db0$export$6ea408c7266ed557 = {
    prefix: "fas",
    iconName: "address-card",
    icon: [
        576,
        512,
        [
            62140,
            "contact-card",
            "vcard"
        ],
        "f2bb",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm96-96c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm128-32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$4ac51eb0b298b190 = $8063e68b12ef6db0$export$6ea408c7266ed557;
var $8063e68b12ef6db0$export$91228257deb1bf18 = $8063e68b12ef6db0$export$6ea408c7266ed557;
var $8063e68b12ef6db0$export$f4d7840209109993 = {
    prefix: "fas",
    iconName: "scale-unbalanced-flip",
    icon: [
        640,
        512,
        [
            "balance-scale-right"
        ],
        "f516",
        "M117.9 62.4c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l113 37.7C265 15.8 290.7 0 320 0c44.2 0 80 35.8 80 80c0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L366.4 145.2c-4.5 3.2-9.3 5.9-14.4 8.2V480c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-21-9.2-37.2-27-44.2-49l-125.9-42zm396.3 211c-.4-.8-1.3-1.3-2.2-1.3s-1.7 .5-2.2 1.3L435.1 416H588.9L514.2 273.3zM512 224c18.8 0 36 10.4 44.7 27l77.8 148.5c3.1 5.8 6.1 14 5.5 23.8c-.7 12.1-4.8 35.2-24.8 55.1C594.9 498.6 562.2 512 512 512s-82.9-13.4-103.2-33.5c-20-20-24.2-43-24.8-55.1c-.6-9.8 2.5-18 5.5-23.8L467.3 251c8.7-16.6 25.9-27 44.7-27zM128 144c-.9 0-1.7 .5-2.2 1.3L51.1 288H204.9L130.2 145.3c-.4-.8-1.3-1.3-2.2-1.3zm44.7-21l77.8 148.5c3.1 5.8 6.1 14 5.5 23.8c-.7 12.1-4.8 35.2-24.8 55.1C210.9 370.6 178.2 384 128 384s-82.9-13.4-103.2-33.5c-20-20-24.2-43-24.8-55.1c-.6-9.8 2.5-18 5.5-23.8L83.3 123C92 106.4 109.2 96 128 96s36 10.4 44.7 27z"
    ]
};
var $8063e68b12ef6db0$export$2238e05f8920005a = $8063e68b12ef6db0$export$f4d7840209109993;
var $8063e68b12ef6db0$export$34c1e678c32ed646 = {
    prefix: "fas",
    iconName: "subscript",
    icon: [
        512,
        512,
        [],
        "f12c",
        "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32zM480 320c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 361.5 404.3 368 416 368v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V320z"
    ]
};
var $8063e68b12ef6db0$export$99749ac517cbef07 = {
    prefix: "fas",
    iconName: "diamond-turn-right",
    icon: [
        512,
        512,
        [
            "directions"
        ],
        "f5eb",
        "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v56H224c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-8.8 7.2-16 16-16h64v56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"
    ]
};
var $8063e68b12ef6db0$export$6a6973de44442fe5 = $8063e68b12ef6db0$export$99749ac517cbef07;
var $8063e68b12ef6db0$export$ea2986b45ba5d2cf = {
    prefix: "fas",
    iconName: "burst",
    icon: [
        512,
        512,
        [],
        "e4dc",
        "M37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l112 163.3L16.6 233.2C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l103.1 33.4L66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L392.3 312.2l103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8L388.9 198.7l25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7L278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-32.3 99.6L37.6 4.2z"
    ]
};
var $8063e68b12ef6db0$export$6486d62e77b910 = {
    prefix: "fas",
    iconName: "house-laptop",
    icon: [
        640,
        512,
        [
            "laptop-house"
        ],
        "e066",
        "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c6.7 6.2 10.3 14.8 10.3 23.5H336c-19.1 0-36.3 8.4-48 21.7V208c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64V416H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM352 304V448H544V304H352zm-48-16c0-17.7 14.3-32 32-32H560c17.7 0 32 14.3 32 32V448h32c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48H544 352 304c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16h32V288z"
    ]
};
var $8063e68b12ef6db0$export$efd983de5e4d6ad3 = $8063e68b12ef6db0$export$6486d62e77b910;
var $8063e68b12ef6db0$export$5352cbdc070ce8d = {
    prefix: "fas",
    iconName: "face-tired",
    icon: [
        512,
        512,
        [
            128555,
            "tired"
        ],
        "f5c8",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm-31.2-182l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $8063e68b12ef6db0$export$3d016d62cda18371 = $8063e68b12ef6db0$export$5352cbdc070ce8d;
var $8063e68b12ef6db0$export$a822dad6e586ee9e = {
    prefix: "fas",
    iconName: "money-bills",
    icon: [
        640,
        512,
        [],
        "e1f3",
        "M96 96V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm64 160c35.3 0 64 28.7 64 64H160V256zM224 96c0 35.3-28.7 64-64 64V96h64zM576 256v64H512c0-35.3 28.7-64 64-64zM512 96h64v64c-35.3 0-64-28.7-64-64zM448 208c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"
    ]
};
var $8063e68b12ef6db0$export$aa11b8edb09fed14 = {
    prefix: "fas",
    iconName: "smog",
    icon: [
        640,
        512,
        [],
        "f75f",
        "M32 144c0 79.5 64.5 144 144 144H299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0C96.5 0 32 64.5 32 144zM616 368H280c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-64 96H440c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24zM224 392c0-13.3-10.7-24-24-24H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24z"
    ]
};
var $8063e68b12ef6db0$export$e94134641c0e2 = {
    prefix: "fas",
    iconName: "crutch",
    icon: [
        512,
        512,
        [],
        "f7f7",
        "M297.4 9.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0zm-96 144l-34.8 34.8c-12.9 12.9-21.9 29.2-25.8 47.1L116.8 342.9c-1.3 5.9-4.3 11.4-8.6 15.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l98.8-98.8c4.3-4.3 9.7-7.3 15.7-8.6l107.6-23.9c17.8-4 34.1-12.9 47.1-25.8l34.7-34.7c0 0 .1-.1 .1-.1s.1-.1 .1-.1l74.6-74.6-45.3-45.3L336 242.7 269.3 176l52.1-52.1L276.1 78.6l-74.7 74.7zM224 221.3L290.7 288l-12.2 12.2c-4.3 4.3-9.7 7.3-15.7 8.6l-76.7 17 17-76.7c1.3-5.9 4.3-11.4 8.6-15.7L224 221.3z"
    ]
};
var $8063e68b12ef6db0$export$aa4baaed1c60f58d = {
    prefix: "fas",
    iconName: "font-awesome",
    icon: [
        448,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M448 48V384c-63.1 22.5-82.3 32-119.5 32c-62.8 0-86.6-32-149.3-32c-20.6 0-36.6 3.6-51.2 8.2v-64c14.6-4.6 30.6-8.2 51.2-8.2c62.7 0 86.5 32 149.3 32c20.4 0 35.6-3 55.5-9.3v-208c-19.9 6.3-35.1 9.3-55.5 9.3c-62.8 0-86.6-32-149.3-32c-50.8 0-74.9 20.6-115.2 28.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32s32 14.3 32 32V76.7c40.3-8 64.4-28.7 115.2-28.7c62.7 0 86.5 32 149.3 32c37.1 0 56.4-9.5 119.5-32z"
    ]
};
var $8063e68b12ef6db0$export$102c25fde54d4843 = $8063e68b12ef6db0$export$aa4baaed1c60f58d;
var $8063e68b12ef6db0$export$6e20d421a2e0f320 = $8063e68b12ef6db0$export$aa4baaed1c60f58d;
var $8063e68b12ef6db0$export$3507214fff1cc655 = {
    prefix: "fas",
    iconName: "cloud-arrow-up",
    icon: [
        640,
        512,
        [
            62338,
            "cloud-upload",
            "cloud-upload-alt"
        ],
        "f0ee",
        "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"
    ]
};
var $8063e68b12ef6db0$export$a48720e6366f5d9a = $8063e68b12ef6db0$export$3507214fff1cc655;
var $8063e68b12ef6db0$export$e73b3e819b9d14a5 = $8063e68b12ef6db0$export$3507214fff1cc655;
var $8063e68b12ef6db0$export$5c390baea5db4f77 = {
    prefix: "fas",
    iconName: "palette",
    icon: [
        512,
        512,
        [
            127912
        ],
        "f53f",
        "M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm0-96c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$db9f783f15682c4a = {
    prefix: "fas",
    iconName: "arrows-turn-right",
    icon: [
        512,
        512,
        [],
        "e4c0",
        "M329.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L370.7 160H160c-35.3 0-64 28.7-64 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V224C32 153.3 89.3 96 160 96H370.7L329.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm-96 256c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 416H128c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96H274.7l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $8063e68b12ef6db0$export$c8370e53051a657 = {
    prefix: "fas",
    iconName: "vest",
    icon: [
        448,
        512,
        [],
        "e085",
        "M207.1 237.4L151.2 69.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3L226.5 280.6c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V270.5c0-9.5-2.8-18.7-8.1-26.6l-47.9-71.8c-5.3-7.9-8.1-17.1-8.1-26.6V128 54.3 48c0-26.5-21.5-48-48-48h-4.5c-.2 0-.4 0-.6 0c-.4 0-.8 0-1.2 0C311 0 295.7 9.7 285.7 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0c-.4 0-.8 0-1.2 0c-.2 0-.4 0-.6 0H112C85.5 0 64 21.5 64 48v6.3V128v17.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5V464c0 26.5 21.5 48 48 48H176c9.9 0 19-3 26.7-8.1C195.9 492.2 192 478.5 192 464V295.8c0-8.6 1.4-17.1 4.1-25.3l11-33.1zM347.3 356.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-294.6 48l48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"
    ]
};
var $8063e68b12ef6db0$export$fd312949b97346ae = {
    prefix: "fas",
    iconName: "ferry",
    icon: [
        576,
        512,
        [],
        "e4ea",
        "M224 0H352c17.7 0 32 14.3 32 32h75.1c20.6 0 31.6 24.3 18.1 39.8L456 96H120L98.8 71.8C85.3 56.3 96.3 32 116.9 32H192c0-17.7 14.3-32 32-32zM96 128H480c17.7 0 32 14.3 32 32V283.5c0 13.3-4.2 26.3-11.9 37.2l-51.4 71.9c-1.9 1.1-3.7 2.2-5.5 3.5c-15.5 10.7-34 18-51 19.9H375.6c-17.1-1.8-35-9-50.8-19.9c-22.1-15.5-51.6-15.5-73.7 0c-14.8 10.2-32.5 18-50.6 19.9H183.9c-17-1.8-35.6-9.2-51-19.9c-1.8-1.3-3.7-2.4-5.6-3.5L75.9 320.7C68.2 309.8 64 296.8 64 283.5V160c0-17.7 14.3-32 32-32zm32 64v96H448V192H128zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.3-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $8063e68b12ef6db0$export$cfb044c7d35060bb = {
    prefix: "fas",
    iconName: "arrows-down-to-people",
    icon: [
        640,
        512,
        [],
        "e4b9",
        "M144 0c-13.3 0-24 10.7-24 24V142.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24zM360 200c0-22.1-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40s40-17.9 40-40zM184 296c0-22.1-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40s40-17.9 40-40zm312 40c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40zM200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5V400c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V345.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V142.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
    ]
};
var $8063e68b12ef6db0$export$d7b60b8dbd03cfe4 = {
    prefix: "fas",
    iconName: "seedling",
    icon: [
        512,
        512,
        [
            127793,
            "sprout"
        ],
        "f4d8",
        "M512 64c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 78.3 364 32 448 32h32c17.7 0 32 14.3 32 32zM0 128c0-17.7 14.3-32 32-32H64c123.7 0 224 100.3 224 224v32 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C100.3 352 0 251.7 0 128z"
    ]
};
var $8063e68b12ef6db0$export$9f3035e3a8c62323 = $8063e68b12ef6db0$export$d7b60b8dbd03cfe4;
var $8063e68b12ef6db0$export$47d93e9001818ee7 = {
    prefix: "fas",
    iconName: "left-right",
    icon: [
        512,
        512,
        [
            8596,
            "arrows-alt-h"
        ],
        "f337",
        "M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-192 0 0-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-56 192 0 0 56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"
    ]
};
var $8063e68b12ef6db0$export$7937ea574fb1389 = $8063e68b12ef6db0$export$47d93e9001818ee7;
var $8063e68b12ef6db0$export$e81e7f3390fe84fe = {
    prefix: "fas",
    iconName: "boxes-packing",
    icon: [
        640,
        512,
        [],
        "e4c7",
        "M256 48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V253.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H256V48zM571.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V176zm352 80V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256H352zM144 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"
    ]
};
var $8063e68b12ef6db0$export$827fbb87bdbe1028 = {
    prefix: "fas",
    iconName: "circle-arrow-left",
    icon: [
        512,
        512,
        [
            "arrow-circle-left"
        ],
        "f0a8",
        "M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512s256-114.6 256-256zM215 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L392 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-214.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L103 273c-9.4-9.4-9.4-24.6 0-33.9L215 127z"
    ]
};
var $8063e68b12ef6db0$export$728262abb9f58d0a = $8063e68b12ef6db0$export$827fbb87bdbe1028;
var $8063e68b12ef6db0$export$88a8383ecdd39a54 = {
    prefix: "fas",
    iconName: "group-arrows-rotate",
    icon: [
        512,
        512,
        [],
        "e4f6",
        "M201.1 71.9c16.9-5 26.6-22.9 21.5-39.8s-22.9-26.6-39.8-21.5c-21.5 6.4-41.8 15.5-60.6 27C114.3 34 105.4 32 96 32C60.7 32 32 60.7 32 96c0 9.4 2 18.3 5.6 26.3c-11.5 18.7-20.6 39-27 60.6c-5 16.9 4.6 34.8 21.5 39.8s34.8-4.6 39.8-21.5c4.3-14.6 10.4-28.5 17.9-41.4c2 .2 4.1 .3 6.1 .3c35.3 0 64-28.7 64-64c0-2.1-.1-4.1-.3-6.1c12.9-7.5 26.8-13.6 41.4-17.9zm128-61.3c-16.9-5-34.8 4.6-39.8 21.5s4.6 34.8 21.5 39.8c14.6 4.3 28.5 10.4 41.4 17.9c-.2 2-.3 4.1-.3 6.1c0 35.3 28.7 64 64 64c2.1 0 4.1-.1 6.2-.3c7.5 12.9 13.6 26.8 17.9 41.4c5 16.9 22.9 26.6 39.8 21.5s26.6-22.9 21.5-39.8c-6.4-21.5-15.5-41.8-27-60.6c3.6-8 5.6-16.9 5.6-26.3c0-35.3-28.7-64-64-64c-9.4 0-18.3 2-26.3 5.6c-18.7-11.5-39-20.6-60.6-27zM71.9 310.9c-5-16.9-22.9-26.6-39.8-21.5s-26.6 22.9-21.5 39.8c6.4 21.5 15.5 41.8 27 60.6C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64c9.4 0 18.3-2 26.3-5.6c18.7 11.5 39 20.6 60.6 27c16.9 5 34.8-4.6 39.8-21.5s-4.6-34.8-21.5-39.8c-14.6-4.3-28.5-10.4-41.4-17.9c.2-2 .3-4.1 .3-6.2c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.2 .3c-7.5-12.9-13.6-26.8-17.9-41.4zm429.4 18.3c5-16.9-4.6-34.8-21.5-39.8s-34.8 4.6-39.8 21.5c-4.3 14.6-10.4 28.5-17.9 41.4c-2-.2-4.1-.3-6.2-.3c-35.3 0-64 28.7-64 64c0 2.1 .1 4.1 .3 6.2c-12.9 7.5-26.8 13.6-41.4 17.9c-16.9 5-26.6 22.9-21.5 39.8s22.9 26.6 39.8 21.5c21.5-6.4 41.8-15.5 60.6-27c8 3.6 16.9 5.6 26.3 5.6c35.3 0 64-28.7 64-64c0-9.4-2-18.3-5.6-26.3c11.5-18.7 20.6-39 27-60.6zM192.8 256.8c0-15.6 5.6-29.9 14.9-41.1L223 231c6.6 6.6 17.8 1.9 17.8-7.4V163.2c0-5.7-4.7-10.4-10.4-10.4H169.9c-9.3 0-13.9 11.2-7.4 17.8l11.2 11.2c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8c11.8 6 26.3 1.4 32.3-10.4s1.4-26.3-10.4-32.3c-20.8-10.6-34.9-32.2-34.9-57zm93.1-58.6c20.8 10.6 34.9 32.2 34.9 57c0 15.6-5.6 29.9-14.9 41.1L290.6 281c-6.6-6.6-17.8-1.9-17.8 7.4v60.5c0 5.7 4.7 10.4 10.4 10.4h60.5c9.3 0 13.9-11.2 7.4-17.8l-11.2-11.2c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8c-11.8-6-26.3-1.4-32.3 10.4s-1.4 26.3 10.4 32.3z"
    ]
};
var $8063e68b12ef6db0$export$8b89ca3201039376 = {
    prefix: "fas",
    iconName: "bowl-food",
    icon: [
        512,
        512,
        [],
        "e4c6",
        "M0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32H8.6C3.1 214.6 0 203.7 0 192zm0 91.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4z"
    ]
};
var $8063e68b12ef6db0$export$14d66ba7571ae0b9 = {
    prefix: "fas",
    iconName: "candy-cane",
    icon: [
        512,
        512,
        [],
        "f786",
        "M348.8 131.5c3.7-2.3 7.9-3.5 12.2-3.5c12.7 0 23 10.3 23 23v5.6c0 9.9-5.1 19.1-13.5 24.3L30.1 393.7C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4L438.4 289.5c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23L254.1 39.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l26.8-16.8zM298.4 49.8c9.2-5.7 19.1-10.1 29.4-13.1L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9L298.4 49.8zm88.5 52.7l46.2-46.2c8.5 6.5 16.1 14.1 22.6 22.6l-46.2 46.2c-5.1-9.6-13-17.5-22.6-22.6zm28.9 59.3l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c6.2-8.8 10.1-19.1 11-30.1zm-86.1 82.5l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-107.2 67l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zM119.3 375.7l60.4 37.7-30.2 18.9L89.1 394.6l30.2-18.9z"
    ]
};
var $8063e68b12ef6db0$export$4229d00802c33062 = {
    prefix: "fas",
    iconName: "arrow-down-wide-short",
    icon: [
        576,
        512,
        [
            "sort-amount-asc",
            "sort-amount-down"
        ],
        "f160",
        "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320z"
    ]
};
var $8063e68b12ef6db0$export$ddf8b8dd5983367d = $8063e68b12ef6db0$export$4229d00802c33062;
var $8063e68b12ef6db0$export$4b2a02d50e417b5f = $8063e68b12ef6db0$export$4229d00802c33062;
var $8063e68b12ef6db0$export$cdd116afa0309c17 = {
    prefix: "fas",
    iconName: "cloud-bolt",
    icon: [
        512,
        512,
        [
            127785,
            "thunderstorm"
        ],
        "f76c",
        "M0 224c0 53 43 96 96 96h47.2L290 202.5c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L333.7 320H352h64c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm330.1 3.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H281.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"
    ]
};
var $8063e68b12ef6db0$export$bbf9e3d433f8f6de = $8063e68b12ef6db0$export$cdd116afa0309c17;
var $8063e68b12ef6db0$export$ec658c0f040c3e1a = {
    prefix: "fas",
    iconName: "text-slash",
    icon: [
        640,
        512,
        [
            "remove-format"
        ],
        "f87d",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96H503L497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l16-64c2.4-9.6 .2-19.7-5.8-27.5S553.9 32 544 32H376.1h-.3H192c-14.7 0-27.5 10-31 24.2l-9.3 37.3L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96H333.7L301.3 210.8l-94.5-74.1zM243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H309.8l17.6-62.1L272.9 311 243.3 416z"
    ]
};
var $8063e68b12ef6db0$export$d91179f327329532 = $8063e68b12ef6db0$export$ec658c0f040c3e1a;
var $8063e68b12ef6db0$export$6143da800b0e6626 = {
    prefix: "fas",
    iconName: "face-smile-wink",
    icon: [
        512,
        512,
        [
            128521,
            "smile-wink"
        ],
        "f4da",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM208.4 208c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm92.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
    ]
};
var $8063e68b12ef6db0$export$f5dbb37f6801ee3f = $8063e68b12ef6db0$export$6143da800b0e6626;
var $8063e68b12ef6db0$export$f0858dff6e769cf6 = {
    prefix: "fas",
    iconName: "file-word",
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12.1 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"
    ]
};
var $8063e68b12ef6db0$export$c341daeecdea449a = {
    prefix: "fas",
    iconName: "file-powerpoint",
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM136 240h68c42 0 76 34 76 76s-34 76-76 76H160v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V368 264c0-13.3 10.7-24 24-24zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28H160v56h44z"
    ]
};
var $8063e68b12ef6db0$export$672e2f590b189583 = {
    prefix: "fas",
    iconName: "arrows-left-right",
    icon: [
        512,
        512,
        [
            "arrows-h"
        ],
        "f07e",
        "M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
var $8063e68b12ef6db0$export$de517642cdb40354 = $8063e68b12ef6db0$export$672e2f590b189583;
var $8063e68b12ef6db0$export$aa54b16c409e882f = {
    prefix: "fas",
    iconName: "house-lock",
    icon: [
        640,
        512,
        [],
        "e510",
        "M384 480c0 11.7 3.1 22.6 8.6 32H384c-17.7 0-32-14.3-32-32V383.7c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32V480c0 17.7-14.3 32-32 32H96.1c-17.7 0-32-14.3-32-32V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L490.7 166.3C447.2 181.7 416 223.2 416 272v24.6c-19.1 11.1-32 31.7-32 55.4V480zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $8063e68b12ef6db0$export$542a9676c5286e01 = {
    prefix: "fas",
    iconName: "cloud-arrow-down",
    icon: [
        640,
        512,
        [
            62337,
            "cloud-download",
            "cloud-download-alt"
        ],
        "f0ed",
        "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
    ]
};
var $8063e68b12ef6db0$export$b318977f29260464 = $8063e68b12ef6db0$export$542a9676c5286e01;
var $8063e68b12ef6db0$export$351357a14c41f824 = $8063e68b12ef6db0$export$542a9676c5286e01;
var $8063e68b12ef6db0$export$f2819bf60df55912 = {
    prefix: "fas",
    iconName: "children",
    icon: [
        640,
        512,
        [],
        "e4e1",
        "M160 128c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM88 480V400H70.2c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4L57.5 323.3c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.6-37.8L265 378.9c3.5 10.4-4.3 21.1-15.2 21.1H232v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V400H152v80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM480 128c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm-8 256v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.5L395.1 321c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9h12.3c33 0 63.7 16.9 81.2 44.9L619.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L552 300.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H472z"
    ]
};
var $8063e68b12ef6db0$export$49a36efd66df775 = {
    prefix: "fas",
    iconName: "chalkboard",
    icon: [
        576,
        512,
        [
            "blackboard"
        ],
        "f51b",
        "M96 32C60.7 32 32 60.7 32 96V384H96V96l384 0V384h64V96c0-35.3-28.7-64-64-64H96zM224 384v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H416V384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"
    ]
};
var $8063e68b12ef6db0$export$f497e01bf522fd9c = $8063e68b12ef6db0$export$49a36efd66df775;
var $8063e68b12ef6db0$export$ae7fc6b7f0534be9 = {
    prefix: "fas",
    iconName: "user-large-slash",
    icon: [
        640,
        512,
        [
            "user-alt-slash"
        ],
        "f4fa",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L38.8 5.1zM284.3 320h-59C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H528L284.3 320z"
    ]
};
var $8063e68b12ef6db0$export$46185fab4772ada6 = $8063e68b12ef6db0$export$ae7fc6b7f0534be9;
var $8063e68b12ef6db0$export$c6c3bd5f7d9b8bf2 = {
    prefix: "fas",
    iconName: "envelope-open",
    icon: [
        512,
        512,
        [
            62135
        ],
        "f2b6",
        "M64 208.1L256 65.9 448 208.1v47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5V208.1zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V208.1c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0z"
    ]
};
var $8063e68b12ef6db0$export$e99ae494101c5e91 = {
    prefix: "fas",
    iconName: "handshake-simple-slash",
    icon: [
        640,
        512,
        [
            "handshake-alt-slash"
        ],
        "e05f",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.4-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM0 176V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6L41.2 128.5C17.9 131.8 0 151.8 0 176z"
    ]
};
var $8063e68b12ef6db0$export$ca302f956ae9f1bf = $8063e68b12ef6db0$export$e99ae494101c5e91;
var $8063e68b12ef6db0$export$f042d3e458efa721 = {
    prefix: "fas",
    iconName: "mattress-pillow",
    icon: [
        640,
        512,
        [],
        "e525",
        "M256 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H256V64zm32 384H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H288V448zM64 160c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160z"
    ]
};
var $8063e68b12ef6db0$export$b731a51acb74b00c = {
    prefix: "fas",
    iconName: "guarani-sign",
    icon: [
        384,
        512,
        [],
        "e19a",
        "M192 0c-17.7 0-32 14.3-32 32V66.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c90.8-15.2 160-94.2 160-189.3c0-17.7-14.3-32-32-32H224V132c22.1 5.7 41.8 17.1 57.6 32.6c12.6 12.4 32.9 12.2 45.3-.4s12.2-32.9-.5-45.3C299 92 263.5 73.3 224 66.7V32c0-17.7-14.3-32-32-32zM160 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124zM224 380V288h92c-11.6 45-47 80.4-92 92z"
    ]
};
var $8063e68b12ef6db0$export$2fd091cb98dc8ab8 = {
    prefix: "fas",
    iconName: "arrows-rotate",
    icon: [
        512,
        512,
        [
            128472,
            "refresh",
            "sync"
        ],
        "f021",
        "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"
    ]
};
var $8063e68b12ef6db0$export$fd4359e93d7b3d14 = $8063e68b12ef6db0$export$2fd091cb98dc8ab8;
var $8063e68b12ef6db0$export$ff87319002e3dae9 = $8063e68b12ef6db0$export$2fd091cb98dc8ab8;
var $8063e68b12ef6db0$export$d75fb6743634a0a = {
    prefix: "fas",
    iconName: "fire-extinguisher",
    icon: [
        512,
        512,
        [
            129519
        ],
        "f134",
        "M500.3 7.3C507.7 13.3 512 22.4 512 32v96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32C301.5 124.9 292 115.7 289 104H224v34.8c37.8 18 64 56.5 64 101.2V384H64V240c0-44.7 26.2-83.2 64-101.2V110c-36.2 11.1-66 36.9-82.3 70.5c-5.8 11.9-20.2 16.9-32.1 11.1S-3.3 171.4 2.5 159.5C26.7 109.8 72.7 72.6 128 60.4V32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V56h65c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM288 416v32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V416H288zM176 96c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16z"
    ]
};
var $8063e68b12ef6db0$export$64dd1b27affb6572 = {
    prefix: "fas",
    iconName: "cruzeiro-sign",
    icon: [
        448,
        512,
        [],
        "e152",
        "M96 256c0-88.4 71.6-160 160-160c41 0 78.3 15.4 106.7 40.7c13.2 11.8 33.4 10.7 45.2-2.5s10.7-33.4-2.5-45.2c-39.6-35.5-92-57-149.3-57C132.3 32 32 132.3 32 256s100.3 224 224 224c57.4 0 109.7-21.6 149.3-57c13.2-11.8 14.3-32 2.5-45.2s-32-14.3-45.2-2.5C334.3 400.6 297 416 256 416V320v-8.7c0-12.8 10.4-23.3 23.3-23.3c4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7c-12.4 0-24.2 2.6-34.9 7.3c-5.5-4.5-12.6-7.3-20.3-7.3c-17.7 0-32 14.3-32 32v55.3V320v82.7C135.5 378 96 321.6 96 256z"
    ]
};
var $8063e68b12ef6db0$export$7bf8dfe2e6661a54 = {
    prefix: "fas",
    iconName: "greater-than-equal",
    icon: [
        448,
        512,
        [],
        "f532",
        "M52.1 93.7C35.7 87.1 27.7 68.5 34.3 52.1s25.2-24.4 41.6-17.8l320 128C408 167.1 416 178.9 416 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L297.8 192 52.1 93.7zM416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416z"
    ]
};
var $8063e68b12ef6db0$export$36e034ccc72554a9 = {
    prefix: "fas",
    iconName: "shield-halved",
    icon: [
        512,
        512,
        [
            "shield-alt"
        ],
        "f3ed",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.7 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z"
    ]
};
var $8063e68b12ef6db0$export$d6508d18a824f291 = $8063e68b12ef6db0$export$36e034ccc72554a9;
var $8063e68b12ef6db0$export$7fb8daedae341012 = {
    prefix: "fas",
    iconName: "book-atlas",
    icon: [
        448,
        512,
        [
            "atlas"
        ],
        "f558",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM247.4 283.8c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9c-6.2-14.5-10.8-34.3-12.2-56.9h63c-1.5 22.6-6 42.4-12.2 56.9c-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9h31.1c-4.7 27.9-21.4 51.7-44.5 65.9zm0-163.8c23.2 14.2 39.9 38 44.5 65.9H303.5c-1.4-24.7-6.1-47.5-13.4-65.9zM368 192c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128zM145.3 208h31.1c1.4 24.7 6.1 47.5 13.4 65.9c-23.2-14.2-39.9-38-44.5-65.9zm31.1-32H145.3c4.7-27.9 21.4-51.7 44.5-65.9c-7.3 18.3-12 41.1-13.4 65.9zm56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7 .5 7.4 4.2c3.8 3.7 8 10 11.8 18.9c6.2 14.5 10.8 34.3 12.2 56.9h-63c1.5-22.6 6-42.4 12.2-56.9c3.8-8.9 8-15.2 11.8-18.9z"
    ]
};
var $8063e68b12ef6db0$export$380a9050e42fe5d7 = $8063e68b12ef6db0$export$7fb8daedae341012;
var $8063e68b12ef6db0$export$37c67e0b3dc6bd1b = {
    prefix: "fas",
    iconName: "virus",
    icon: [
        512,
        512,
        [],
        "e074",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM272 224c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zm32 104c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $8063e68b12ef6db0$export$74d890536dbd21b7 = {
    prefix: "fas",
    iconName: "envelope-circle-check",
    icon: [
        640,
        512,
        [],
        "e4e8",
        "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0l57.4-43c23.9-59.8 79.7-103.3 146.3-109.8l13.9-10.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176V384c0 35.3 28.7 64 64 64H360.2C335.1 417.6 320 378.5 320 336c0-5.6 .3-11.1 .8-16.6l-26.4 19.8zM640 336c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $8063e68b12ef6db0$export$a137712e11e257dd = {
    prefix: "fas",
    iconName: "layer-group",
    icon: [
        576,
        512,
        [],
        "f5fd",
        "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"
    ]
};
var $8063e68b12ef6db0$export$ab3a06d4b53c0fc0 = {
    prefix: "fas",
    iconName: "arrows-to-dot",
    icon: [
        512,
        512,
        [],
        "e4be",
        "M256 0c17.7 0 32 14.3 32 32V64h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32V32c0-17.7 14.3-32 32-32zM169.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H288v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H192c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224H64V192c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 288c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$d56753dd2eb5c323 = {
    prefix: "fas",
    iconName: "archway",
    icon: [
        512,
        512,
        [],
        "f557",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H96h64V352c0-53 43-96 96-96s96 43 96 96V480h64 64c17.7 0 32-14.3 32-32s-14.3-32-32-32V128H32V416z"
    ]
};
var $8063e68b12ef6db0$export$5e4b6785eedecc1a = {
    prefix: "fas",
    iconName: "heart-circle-check",
    icon: [
        576,
        512,
        [],
        "e4fd",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $8063e68b12ef6db0$export$e824540f5a6a8a57 = {
    prefix: "fas",
    iconName: "house-chimney-crack",
    icon: [
        576,
        512,
        [
            "house-damage"
        ],
        "f6f1",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H326.4L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9L250.6 263.2c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5L230.4 512H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24z"
    ]
};
var $8063e68b12ef6db0$export$8d7e943005ce0b49 = $8063e68b12ef6db0$export$e824540f5a6a8a57;
var $8063e68b12ef6db0$export$7a4a0e4caa1e4e6f = {
    prefix: "fas",
    iconName: "file-zipper",
    icon: [
        384,
        512,
        [
            "file-archive"
        ],
        "f1c6",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm-6.3 71.8c3.7-14 16.4-23.8 30.9-23.8h14.8c14.5 0 27.2 9.7 30.9 23.8l23.5 88.2c1.4 5.4 2.1 10.9 2.1 16.4c0 35.2-28.8 63.7-64 63.7s-64-28.5-64-63.7c0-5.5 .7-11.1 2.1-16.4l23.5-88.2zM112 336c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
    ]
};
var $8063e68b12ef6db0$export$bf2047a9946b5c3f = $8063e68b12ef6db0$export$7a4a0e4caa1e4e6f;
var $8063e68b12ef6db0$export$90b4406457aae8cc = {
    prefix: "fas",
    iconName: "square",
    icon: [
        448,
        512,
        [
            9632,
            9723,
            9724,
            61590
        ],
        "f0c8",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
    ]
};
var $8063e68b12ef6db0$export$a8a0de30198815a3 = {
    prefix: "fas",
    iconName: "martini-glass-empty",
    icon: [
        512,
        512,
        [
            "glass-martini"
        ],
        "f000",
        "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM256 210.7L109.3 64H402.7L256 210.7z"
    ]
};
var $8063e68b12ef6db0$export$e96f280e39af4a91 = $8063e68b12ef6db0$export$a8a0de30198815a3;
var $8063e68b12ef6db0$export$ce96e32767a7dd51 = {
    prefix: "fas",
    iconName: "couch",
    icon: [
        640,
        512,
        [],
        "f4b8",
        "M64 160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H512h32V320 272z"
    ]
};
var $8063e68b12ef6db0$export$66c557f70914132c = {
    prefix: "fas",
    iconName: "cedi-sign",
    icon: [
        384,
        512,
        [],
        "e0df",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V66.7C101.2 81.9 32 160.9 32 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c30.9-5.2 59.2-17.7 83.2-35.8c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-13.2 9.9-28.3 17.3-44.8 21.6V132c16.4 4.2 31.6 11.6 44.8 21.6c14.1 10.6 34.2 7.8 44.8-6.4s7.8-34.2-6.4-44.8c-24-18-52.4-30.6-83.2-35.8V32zM192 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124z"
    ]
};
var $8063e68b12ef6db0$export$16e344bae4d495ed = {
    prefix: "fas",
    iconName: "italic",
    icon: [
        384,
        512,
        [],
        "f033",
        "M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"
    ]
};
var $8063e68b12ef6db0$export$16a3f12c6ae9650 = {
    prefix: "fas",
    iconName: "church",
    icon: [
        640,
        512,
        [
            9962
        ],
        "f51d",
        "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V48H264c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v46.4L183.3 210c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V251.2c0-16.9-8.8-32.5-23.3-41.2L344 142.4V96h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V24zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
    ]
};
var $8063e68b12ef6db0$export$d477129b070e5ac4 = {
    prefix: "fas",
    iconName: "comments-dollar",
    icon: [
        640,
        512,
        [],
        "f653",
        "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM228 72c0-11-9-20-20-20s-20 9-20 20V86c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20V266.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72z"
    ]
};
var $8063e68b12ef6db0$export$a1672d808fbed0bd = {
    prefix: "fas",
    iconName: "democrat",
    icon: [
        640,
        512,
        [],
        "f747",
        "M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8 .7 5.2 2.1L128 45.7 173.8 2.1C175.2 .7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7c2.4 6.5 6.2 18.4 6.2 27.3c0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8H480c61.4 0 101.6 24 126.2 50c12 12.6 19.9 25.2 24.9 34.9c2.5 4.8 4.3 9 5.5 12.1c.6 1.5 1.1 2.8 1.4 3.8c.2 .5 .3 .9 .4 1.3l.1 .5 .1 .2 0 .1 0 0c0 0 0 0-30.2 9.1l30.2-9.1c5.1 16.9-4.5 34.8-21.5 39.8c-16.8 5-34.5-4.4-39.7-21.1l0 0c-.1-.2-.2-.6-.5-1.2c-.5-1.3-1.4-3.4-2.8-6.1c-2.8-5.4-7.4-12.8-14.4-20.1c-4.2-4.4-9.4-9-15.8-13.2V320H192l-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3h-2C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3L87.6 74.6C78.1 67.4 64 53.2 64 32zM448 352h96v64 64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V416H288v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416 352h96H448zm129.4-70.8c0 0 0 0 30.6-9.2l-30.6 9.2 0 0zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zM368.1 208c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z"
    ]
};
var $8063e68b12ef6db0$export$3481c1aa28972f9b = {
    prefix: "fas",
    iconName: "z",
    icon: [
        384,
        512,
        [
            122
        ],
        "5a",
        "M0 64C0 46.3 14.3 32 32 32H352c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96H32C14.3 96 0 81.7 0 64z"
    ]
};
var $8063e68b12ef6db0$export$5ebd3cd0630e3ae7 = {
    prefix: "fas",
    iconName: "person-skiing",
    icon: [
        576,
        512,
        [
            9975,
            "skiing"
        ],
        "f7c9",
        "M508.7 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM34.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L264.7 361.3l46.2-69.2-75.1-75.1c-14.6-14.6-20.4-33.9-18.4-52.1l108.8 52 39.3 39.3c16.2 16.2 18.7 41.5 6 60.6L321.8 391l128.7 66.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L44.9 301.3c-11.8-6.1-16.3-20.6-10.2-32.4zM150.9 65.6L169 74.2l8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 16.9 54.7 26.2c1.5-.7 3.1-1.4 4.7-2.1l83.4-33.4c34.2-13.7 72.8 4.2 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-58.1-29c-11.4-5.7-20-15.7-24.1-27.8l-5.8-17.3-27.3 12.1-6.8 3-6.7-3.2L183.5 116.7l-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5z"
    ]
};
var $8063e68b12ef6db0$export$eae1acab6fb96708 = $8063e68b12ef6db0$export$5ebd3cd0630e3ae7;
var $8063e68b12ef6db0$export$b81a894d5bc3eb17 = {
    prefix: "fas",
    iconName: "road-lock",
    icon: [
        640,
        512,
        [],
        "e567",
        "M288 32H213.2c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2C32 455.5 56.5 480 86.6 480H288V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64h32V352c0-23.7 12.9-44.4 32-55.4V272c0-58.3 44.6-106.2 101.5-111.5L487.1 74.6C478 49.1 453.9 32 426.8 32H352V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zm176 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $8063e68b12ef6db0$export$406fe05808a3753e = {
    prefix: "fas",
    iconName: "a",
    icon: [
        448,
        512,
        [
            97
        ],
        "41",
        "M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L125.3 384H322.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM296 320H152l72-172.8L296 320z"
    ]
};
var $8063e68b12ef6db0$export$4520eb1840c4e110 = {
    prefix: "fas",
    iconName: "temperature-arrow-down",
    icon: [
        512,
        512,
        [
            "temperature-down"
        ],
        "e03f",
        "M96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.1 32 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.1 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zm336-64H448V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352H352c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8z"
    ]
};
var $8063e68b12ef6db0$export$f0b2aca3866f00f6 = $8063e68b12ef6db0$export$4520eb1840c4e110;
var $8063e68b12ef6db0$export$2a9d3e120019c92d = {
    prefix: "fas",
    iconName: "feather-pointed",
    icon: [
        512,
        512,
        [
            "feather-alt"
        ],
        "f56b",
        "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.8-74.8c7.4 4.6 15.3 8.2 23.8 10.5C200.3 452.8 270 454.5 338 409.4c12.2-8.1 5.8-25.4-8.8-25.4l-16.1 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1c4.4-6.4 8.6-12.9 12.6-19.6c6.2-10.3-1.5-23-13.5-23l-38.6 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3C494.5 163 507.8 86.1 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c2.1 7.9 12 9.6 17.8 3.8L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
    ]
};
var $8063e68b12ef6db0$export$68cf766c786bcd78 = $8063e68b12ef6db0$export$2a9d3e120019c92d;
var $8063e68b12ef6db0$export$bcb419f1cd5beac3 = {
    prefix: "fas",
    iconName: "p",
    icon: [
        320,
        512,
        [
            112
        ],
        "50",
        "M32 32H64h96c88.4 0 160 71.6 160 160s-71.6 160-160 160H64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352 320 288 64C0 46.3 14.3 32 32 32zM64 288h96c53 0 96-43 96-96s-43-96-96-96H64V288z"
    ]
};
var $8063e68b12ef6db0$export$bab8f3647c394f48 = {
    prefix: "fas",
    iconName: "snowflake",
    icon: [
        448,
        512,
        [
            10052,
            10054
        ],
        "f2dc",
        "M224 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.7 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3V129.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$d91b374112d4f8c1 = {
    prefix: "fas",
    iconName: "newspaper",
    icon: [
        512,
        512,
        [
            128240
        ],
        "f1ea",
        "M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm0 184c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zM160 400c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"
    ]
};
var $8063e68b12ef6db0$export$d0ccaddca9e06d1e = {
    prefix: "fas",
    iconName: "rectangle-ad",
    icon: [
        576,
        512,
        [
            "ad"
        ],
        "f641",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM229.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328H162.8l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280h42.3L208 237.7zM392 256c-13.3 0-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24s-10.7-24-24-24zm24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v96 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"
    ]
};
var $8063e68b12ef6db0$export$7af266c3465b1ff2 = $8063e68b12ef6db0$export$d0ccaddca9e06d1e;
var $8063e68b12ef6db0$export$2f1e22e081a1ad05 = {
    prefix: "fas",
    iconName: "circle-arrow-right",
    icon: [
        512,
        512,
        [
            "arrow-circle-right"
        ],
        "f0a9",
        "M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zM297 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L120 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l214.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L409 239c9.4 9.4 9.4 24.6 0 33.9L297 385z"
    ]
};
var $8063e68b12ef6db0$export$7d3d828103aa3be7 = $8063e68b12ef6db0$export$2f1e22e081a1ad05;
var $8063e68b12ef6db0$export$fb5ab619c34ea613 = {
    prefix: "fas",
    iconName: "filter-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e17b",
        "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM432 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm59.3-180.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var $8063e68b12ef6db0$export$4982360d3b844c19 = {
    prefix: "fas",
    iconName: "locust",
    icon: [
        640,
        512,
        [],
        "e520",
        "M344 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c98.7 0 180.6 71.4 197 165.4c-9-3.5-18.8-5.4-29-5.4H463.8l-41.8-97.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1L247.1 400h74.5l-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L380 400h80.4l38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L515.6 400H528c44.1 0 79.8-35.7 80-79.7c0-.1 0-.2 0-.3V280C608 143 497 32 360 32H344zm50.5 168l17.1 40H365l29.5-40zm-87.7 38.1l-1.4 1.9H257.1l32.7-41.5 16.9 39.5zM120.8 240C89.4 240 64 265.4 64 296.8c0 15.5 6.3 30 16.9 40.4L158.7 240H120.8zM528 320c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16z"
    ]
};
var $8063e68b12ef6db0$export$4941c5969d5399b = {
    prefix: "fas",
    iconName: "sort",
    icon: [
        320,
        512,
        [
            "unsorted"
        ],
        "f0dc",
        "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"
    ]
};
var $8063e68b12ef6db0$export$418597748f0fe52d = $8063e68b12ef6db0$export$4941c5969d5399b;
var $8063e68b12ef6db0$export$3db8f67cd0fc963b = {
    prefix: "fas",
    iconName: "list-ol",
    icon: [
        512,
        512,
        [
            "list-1-2",
            "list-numeric"
        ],
        "f0cb",
        "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$7e3d894cd55296b = $8063e68b12ef6db0$export$3db8f67cd0fc963b;
var $8063e68b12ef6db0$export$cf51408faadac277 = $8063e68b12ef6db0$export$3db8f67cd0fc963b;
var $8063e68b12ef6db0$export$523180e731928397 = {
    prefix: "fas",
    iconName: "person-dress-burst",
    icon: [
        640,
        512,
        [],
        "e544",
        "M528 48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM390.2 384H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
    ]
};
var $8063e68b12ef6db0$export$eeb59dd1825c6a65 = {
    prefix: "fas",
    iconName: "money-check-dollar",
    icon: [
        576,
        512,
        [
            "money-check-alt"
        ],
        "f53d",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM272 192H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 304c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zM164.1 160v6.3c6.6 1.2 16.6 3.2 21 4.4c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10 3.6-15.4 4.6V352c0 11.1-9 20.1-20.1 20.1s-20.1-9-20.1-20.1v-6.4c-9.5-2.2-21.9-6.4-29.8-9.1c-1.7-.6-3.2-1.1-4.4-1.5c-10.5-3.5-16.1-14.8-12.7-25.3s14.8-16.1 25.3-12.7c2 .7 4.1 1.4 6.4 2.1l0 0 0 0c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.3-4 15.9-5.1v-6c0-11.1 9-20.1 20.1-20.1s20.1 9 20.1 20.1z"
    ]
};
var $8063e68b12ef6db0$export$8c6ccc9745897cb2 = $8063e68b12ef6db0$export$eeb59dd1825c6a65;
var $8063e68b12ef6db0$export$567d5631a7b0599f = {
    prefix: "fas",
    iconName: "vector-square",
    icon: [
        448,
        512,
        [],
        "f5cb",
        "M368 80h32v32H368V80zM352 32c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32V160c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zM96 160c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32V160zM48 400H80v32H48V400zm320 32V400h32v32H368zM48 112V80H80v32H48z"
    ]
};
var $8063e68b12ef6db0$export$d78e8b0681279167 = {
    prefix: "fas",
    iconName: "bread-slice",
    icon: [
        512,
        512,
        [],
        "f7ec",
        "M256 32C192 32 0 64 0 192c0 35.3 28.7 64 64 64V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32z"
    ]
};
var $8063e68b12ef6db0$export$8a7bee49fdf8c954 = {
    prefix: "fas",
    iconName: "language",
    icon: [
        640,
        512,
        [],
        "f1ab",
        "M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z"
    ]
};
var $8063e68b12ef6db0$export$611ae61f02de0aa = {
    prefix: "fas",
    iconName: "face-kiss-wink-heart",
    icon: [
        512,
        512,
        [
            128536,
            "kiss-wink-heart"
        ],
        "f598",
        "M498 339.7c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1c37.2-10.4 73.8 10.1 87.5 44c12.7-1.6 25.1 .4 36.2 5zM296 332c0 6.9-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C258.7 443.1 241.4 448 224 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.3-.2-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM176.4 240c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm194.8-6.4c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
    ]
};
var $8063e68b12ef6db0$export$ebba617701dfb917 = $8063e68b12ef6db0$export$611ae61f02de0aa;
var $8063e68b12ef6db0$export$f253a38d7142e29f = {
    prefix: "fas",
    iconName: "filter",
    icon: [
        512,
        512,
        [],
        "f0b0",
        "M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
    ]
};
var $8063e68b12ef6db0$export$d96973f90e8f6e47 = {
    prefix: "fas",
    iconName: "question",
    icon: [
        320,
        512,
        [
            10067,
            10068,
            61736
        ],
        "3f",
        "M96 96c-17.7 0-32 14.3-32 32s-14.3 32-32 32s-32-14.3-32-32C0 75 43 32 96 32h97c70.1 0 127 56.9 127 127c0 52.4-32.2 99.4-81 118.4l-63 24.5 0 18.1c0 17.7-14.3 32-32 32s-32-14.3-32-32V301.9c0-26.4 16.2-50.1 40.8-59.6l63-24.5C240 208.3 256 185 256 159c0-34.8-28.2-63-63-63H96zm48 384c-22.1 0-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40s-17.9 40-40 40z"
    ]
};
var $8063e68b12ef6db0$export$d0de575ac166712b = {
    prefix: "fas",
    iconName: "file-signature",
    icon: [
        576,
        512,
        [],
        "f573",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V428.7c-2.7 1.1-5.4 2-8.2 2.7l-60.1 15c-3 .7-6 1.2-9 1.4c-.9 .1-1.8 .2-2.7 .2H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 381l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.8 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8h8.9c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7L384 203.6V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM549.8 139.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 321c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 262.7l-71-71L311.9 321z"
    ]
};
var $8063e68b12ef6db0$export$cd7b22f4e6e3834b = {
    prefix: "fas",
    iconName: "up-down-left-right",
    icon: [
        512,
        512,
        [
            "arrows-alt"
        ],
        "f0b2",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96H128V192c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V288h96v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288h96v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H288V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
    ]
};
var $8063e68b12ef6db0$export$3cdabfff52cfc73a = $8063e68b12ef6db0$export$cd7b22f4e6e3834b;
var $8063e68b12ef6db0$export$1ddbaebce033a0d = {
    prefix: "fas",
    iconName: "house-chimney-user",
    icon: [
        576,
        512,
        [],
        "e065",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM288 288c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM176 400c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z"
    ]
};
var $8063e68b12ef6db0$export$97e5ef3e80a0fbef = {
    prefix: "fas",
    iconName: "hand-holding-heart",
    icon: [
        576,
        512,
        [],
        "f4be",
        "M148 76.6C148 34.3 182.3 0 224.6 0c20.3 0 39.8 8.1 54.1 22.4l9.3 9.3 9.3-9.3C311.6 8.1 331.1 0 351.4 0C393.7 0 428 34.3 428 76.6c0 20.3-8.1 39.8-22.4 54.1L302.1 234.1c-7.8 7.8-20.5 7.8-28.3 0L170.4 130.7C156.1 116.4 148 96.9 148 76.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $8063e68b12ef6db0$export$7ee0dbd1e92e2859 = {
    prefix: "fas",
    iconName: "puzzle-piece",
    icon: [
        512,
        512,
        [
            129513
        ],
        "f12e",
        "M192 104.8c0-9.2-5.8-17.3-13.2-22.8C167.2 73.3 160 61.3 160 48c0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34c-7.4 5.5-13.2 13.6-13.2 22.8c0 12.8 10.4 23.2 23.2 23.2H336c26.5 0 48 21.5 48 48v56.8c0 12.8 10.4 23.2 23.2 23.2c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2c-12.8 0-23.2 10.4-23.2 23.2V464c0 26.5-21.5 48-48 48H279.2c-12.8 0-23.2-10.4-23.2-23.2c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8c0 12.8-10.4 23.2-23.2 23.2H48c-26.5 0-48-21.5-48-48V343.2C0 330.4 10.4 320 23.2 320c9.2 0 17.3 5.8 22.8 13.2C54.7 344.8 66.7 352 80 352c26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8C40.5 250.2 32.4 256 23.2 256C10.4 256 0 245.6 0 232.8V176c0-26.5 21.5-48 48-48H168.8c12.8 0 23.2-10.4 23.2-23.2z"
    ]
};
var $8063e68b12ef6db0$export$be069f641c85d0b3 = {
    prefix: "fas",
    iconName: "money-check",
    icon: [
        576,
        512,
        [],
        "f53c",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm48 160H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM376 160h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24z"
    ]
};
var $8063e68b12ef6db0$export$3e4892d8bf919edd = {
    prefix: "fas",
    iconName: "star-half-stroke",
    icon: [
        576,
        512,
        [
            "star-half-alt"
        ],
        "f5c0",
        "M288 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L288.1 86.9l-.1 .3V376.4zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L288.1 439.8 159.8 508.3C149 514 135.9 513.1 126 506s-14.9-19.3-12.9-31.3L137.8 329 33.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L195 150.3 259.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L438.5 329l24.6 145.7z"
    ]
};
var $8063e68b12ef6db0$export$c13575f42532efb3 = $8063e68b12ef6db0$export$3e4892d8bf919edd;
var $8063e68b12ef6db0$export$eba095993e51cc97 = {
    prefix: "fas",
    iconName: "code",
    icon: [
        640,
        512,
        [],
        "f121",
        "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"
    ]
};
var $8063e68b12ef6db0$export$f1304dd34ea2afbd = {
    prefix: "fas",
    iconName: "whiskey-glass",
    icon: [
        512,
        512,
        [
            129347,
            "glass-whiskey"
        ],
        "f7a0",
        "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM87.7 224L69 96H443L424.3 224H87.7z"
    ]
};
var $8063e68b12ef6db0$export$fdec0f5f1a169419 = $8063e68b12ef6db0$export$f1304dd34ea2afbd;
var $8063e68b12ef6db0$export$c49f030b19083ebe = {
    prefix: "fas",
    iconName: "building-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e4d3",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$6a1e4cdbb8ca10c5 = {
    prefix: "fas",
    iconName: "magnifying-glass-chart",
    icon: [
        512,
        512,
        [],
        "e522",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zm-312 8v64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96V280c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $8063e68b12ef6db0$export$5ad84e891223f2c3 = {
    prefix: "fas",
    iconName: "arrow-up-right-from-square",
    icon: [
        448,
        512,
        [
            "external-link"
        ],
        "f08e",
        "M288 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L169.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 141.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H288zM80 64C35.8 64 0 99.8 0 144V400c0 44.2 35.8 80 80 80H336c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var $8063e68b12ef6db0$export$f4c613289034e5ef = $8063e68b12ef6db0$export$5ad84e891223f2c3;
var $8063e68b12ef6db0$export$b1f00c433aabac05 = {
    prefix: "fas",
    iconName: "cubes-stacked",
    icon: [
        448,
        512,
        [],
        "e4e6",
        "M192 64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zM82.7 207c-15.3 8.8-20.5 28.4-11.7 43.7l32 55.4c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-32-55.4c-8.8-15.3-28.4-20.5-43.7-11.7L82.7 207zM288 192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H288zm64 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H352zM160 384v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zM32 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H32z"
    ]
};
var $8063e68b12ef6db0$export$51790ddd26e431bc = {
    prefix: "fas",
    iconName: "won-sign",
    icon: [
        512,
        512,
        [
            8361,
            "krw",
            "won"
        ],
        "f159",
        "M62.4 53.9C56.8 37.1 38.6 28.1 21.9 33.6S-3.9 57.4 1.6 74.1L51.6 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H72.9l56.7 170.1c4.5 13.5 17.4 22.4 31.6 21.9s26.4-10.4 29.8-24.2L233 288h46L321 455.8c3.4 13.8 15.6 23.7 29.8 24.2s27.1-8.4 31.6-21.9L439.1 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l50-149.9c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L392.9 224H329L287 56.2C283.5 42 270.7 32 256 32s-27.5 10-31 24.2L183 224h-64L62.4 53.9zm78 234.1H167l-11.4 45.6L140.4 288zM249 224l7-28.1 7 28.1H249zm96 64h26.6l-15.2 45.6L345 288z"
    ]
};
var $8063e68b12ef6db0$export$2f65e07a45b95b50 = $8063e68b12ef6db0$export$51790ddd26e431bc;
var $8063e68b12ef6db0$export$5a1fd3ed9564d7fa = $8063e68b12ef6db0$export$51790ddd26e431bc;
var $8063e68b12ef6db0$export$1df4e031b8ee4f84 = {
    prefix: "fas",
    iconName: "virus-covid",
    icon: [
        512,
        512,
        [],
        "e4a8",
        "M192 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V81.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92 374.8 80.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L420 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3H464V216c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H430.4c-4.2 30.7-16.3 58.8-34.1 82.3L420 386.1l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L386.1 420l-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1V464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V430.4c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L92 386.1l23.8-23.8C97.9 338.8 85.8 310.7 81.6 280H48v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v16H81.6c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9 80.6 137.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1V48H216c-13.3 0-24-10.7-24-24zm48 200c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm64 104c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $8063e68b12ef6db0$export$299c200ad3db97b4 = {
    prefix: "fas",
    iconName: "austral-sign",
    icon: [
        448,
        512,
        [],
        "e0a9",
        "M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7L122.7 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96L82.7 320H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H56L34.5 435.7c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L125.3 384H322.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8L392 384h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H365.3L352 288h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H325.3L253.5 51.7zM256 224H192l32-76.8L256 224zm-90.7 64H282.7L296 320H152l13.3-32z"
    ]
};
var $8063e68b12ef6db0$export$a2f384a559654618 = {
    prefix: "fas",
    iconName: "f",
    icon: [
        320,
        512,
        [
            102
        ],
        "46",
        "M32 32C14.3 32 0 46.3 0 64V256 448c0 17.7 14.3 32 32 32s32-14.3 32-32V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $8063e68b12ef6db0$export$7c497bae2754a087 = {
    prefix: "fas",
    iconName: "leaf",
    icon: [
        512,
        512,
        [],
        "f06c",
        "M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 216s0 0 0 0c-16.6 0-32.7 1.9-48.3 5.4c-25.9 5.9-49.9 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"
    ]
};
var $8063e68b12ef6db0$export$f224567a4851a5e9 = {
    prefix: "fas",
    iconName: "road",
    icon: [
        576,
        512,
        [
            128739
        ],
        "f018",
        "M256 32H181.2c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480H256V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64H521.4c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32H320V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$9958afcdfece1b58 = {
    prefix: "fas",
    iconName: "taxi",
    icon: [
        512,
        512,
        [
            128662,
            "cab"
        ],
        "f1ba",
        "M192 0c-17.7 0-32 14.3-32 32V64c0 .1 0 .1 0 .2c-38.6 2.2-72.3 27.3-85.2 64.1L39.6 228.8C16.4 238.4 0 261.3 0 288V432v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V432H416v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V432 288c0-26.7-16.4-49.6-39.6-59.2L437.2 128.3c-12.9-36.8-46.6-62-85.2-64.1c0-.1 0-.1 0-.2V32c0-17.7-14.3-32-32-32H192zM165.4 128H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 224H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zM96 352c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm352-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$7bf12d9380f0971b = $8063e68b12ef6db0$export$9958afcdfece1b58;
var $8063e68b12ef6db0$export$55686b1eb7d00307 = {
    prefix: "fas",
    iconName: "person-circle-plus",
    icon: [
        576,
        512,
        [],
        "e541",
        "M208 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM152 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm16-208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"
    ]
};
var $8063e68b12ef6db0$export$1de7b9cf7d1b153b = {
    prefix: "fas",
    iconName: "chart-pie",
    icon: [
        576,
        512,
        [
            "pie-chart"
        ],
        "f200",
        "M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z"
    ]
};
var $8063e68b12ef6db0$export$7877286cd337de81 = $8063e68b12ef6db0$export$1de7b9cf7d1b153b;
var $8063e68b12ef6db0$export$b16dcd08f3da1ba2 = {
    prefix: "fas",
    iconName: "bolt-lightning",
    icon: [
        384,
        512,
        [],
        "e0b7",
        "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $8063e68b12ef6db0$export$2bad98c38bea5994 = {
    prefix: "fas",
    iconName: "sack-xmark",
    icon: [
        512,
        512,
        [],
        "e56a",
        "M192 96H320l47.4-71.1C374.5 14.2 366.9 0 354.1 0H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4l0 0 0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4zM289.9 336l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47z"
    ]
};
var $8063e68b12ef6db0$export$77cb1a465c4fe84 = {
    prefix: "fas",
    iconName: "file-excel",
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
    ]
};
var $8063e68b12ef6db0$export$70fde3f3fdaa6a6a = {
    prefix: "fas",
    iconName: "file-contract",
    icon: [
        384,
        512,
        [],
        "f56c",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z"
    ]
};
var $8063e68b12ef6db0$export$e7af4f0123222b6f = {
    prefix: "fas",
    iconName: "fish-fins",
    icon: [
        576,
        512,
        [],
        "e4f2",
        "M275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.7 4.9S-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.7 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c5.8-9.9 5.8-22.2 0-32.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4zM448 256c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$592422b29ab0a914 = {
    prefix: "fas",
    iconName: "building-flag",
    icon: [
        640,
        512,
        [],
        "e4d5",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM448 0c-17.7 0-32 14.3-32 32V512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480c0-17.7-14.3-32-32-32z"
    ]
};
var $8063e68b12ef6db0$export$3de52eeb00462407 = {
    prefix: "fas",
    iconName: "face-grin-beam",
    icon: [
        512,
        512,
        [
            128516,
            "grin-beam"
        ],
        "f582",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM383.8 317.8c12.3-3.7 24.3 7 19.2 18.7c-24.5 56.9-81.1 96.7-147 96.7s-122.5-39.8-147-96.7c-5.1-11.8 6.9-22.4 19.2-18.7C166.7 329.4 210.1 336 256 336s89.3-6.6 127.8-18.2zm-166.2-89l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
    ]
};
var $8063e68b12ef6db0$export$734da5249381ec7e = $8063e68b12ef6db0$export$3de52eeb00462407;
var $8063e68b12ef6db0$export$887f6345573abcac = {
    prefix: "fas",
    iconName: "object-ungroup",
    icon: [
        640,
        512,
        [],
        "f248",
        "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H328.6C339.6 12.9 360.3 0 384 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V232.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4V232.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4zm192 384c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V352h64v40.6c9.7 5.6 17.8 13.7 23.4 23.4H520.6c5.6-9.7 13.7-17.8 23.4-23.4V279.4c-9.7-5.6-17.8-13.7-23.4-23.4h-46c-5.4-15.4-14.6-28.9-26.5-39.6V192h72.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H311.4z"
    ]
};
var $8063e68b12ef6db0$export$bb45b6b87d1adf27 = {
    prefix: "fas",
    iconName: "poop",
    icon: [
        512,
        512,
        [],
        "f619",
        "M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7C315.8 7.2 352 47.4 352 96c0 11.2-1.9 22-5.5 32H352c35.3 0 64 28.7 64 64c0 19.1-8.4 36.3-21.7 48H408c39.8 0 72 32.2 72 72c0 23.2-11 43.8-28 57c34.1 5.7 60 35.3 60 71c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72c0-35.7 25.9-65.3 60-71c-17-13.2-28-33.8-28-57c0-39.8 32.2-72 72-72h13.7C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64h16.2c44.1-.1 79.8-35.9 79.8-80c0-9.2-1.5-17.9-4.3-26.1c-1.8-5.2-.8-11.1 2.8-15.4z"
    ]
};
var $8063e68b12ef6db0$export$c0b7617de95c0c05 = {
    prefix: "fas",
    iconName: "location-pin",
    icon: [
        384,
        512,
        [
            "map-marker"
        ],
        "f041",
        "M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"
    ]
};
var $8063e68b12ef6db0$export$10d360e4f1a554dd = $8063e68b12ef6db0$export$c0b7617de95c0c05;
var $8063e68b12ef6db0$export$ab1408bfbe914cc9 = {
    prefix: "fas",
    iconName: "kaaba",
    icon: [
        576,
        512,
        [
            128331
        ],
        "f66b",
        "M60 120l228 71.2L516 120 288 48.8 60 120zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112v16 0 21.2L292.8 237.7c-3.1 1-6.4 1-9.5 0L0 149.2V128 112C0 98 9.1 85.6 22.5 81.5l256-80zm23.9 266.8L576 182.8v46.5l-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5L576 262.8V400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400V262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2V182.8l273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"
    ]
};
var $8063e68b12ef6db0$export$c8cc083ccc72b17 = {
    prefix: "fas",
    iconName: "toilet-paper",
    icon: [
        640,
        512,
        [
            129531
        ],
        "f71e",
        "M444.2 0C397.2 49.6 384 126.5 384 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192C64 86 107 0 160 0H444.2zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM144 208c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 16c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm80-16c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $8063e68b12ef6db0$export$aacaf42fba617981 = {
    prefix: "fas",
    iconName: "helmet-safety",
    icon: [
        576,
        512,
        [
            "hard-hat",
            "hat-hard"
        ],
        "f807",
        "M256 32c-17.7 0-32 14.3-32 32v2.3 99.6c0 5.6-4.5 10.1-10.1 10.1c-3.6 0-7-1.9-8.8-5.1L157.1 87C83 123.5 32 199.8 32 288v64H544l0-66.4c-.9-87.2-51.7-162.4-125.1-198.6l-48 83.9c-1.8 3.2-5.2 5.1-8.8 5.1c-5.6 0-10.1-4.5-10.1-10.1V66.3 64c0-17.7-14.3-32-32-32H256zM16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6H16.6z"
    ]
};
var $8063e68b12ef6db0$export$7b72177558a98b6f = $8063e68b12ef6db0$export$aacaf42fba617981;
var $8063e68b12ef6db0$export$c0e235dbf1644a2f = $8063e68b12ef6db0$export$aacaf42fba617981;
var $8063e68b12ef6db0$export$8484041d5b209494 = {
    prefix: "fas",
    iconName: "eject",
    icon: [
        448,
        512,
        [
            9167
        ],
        "f052",
        "M224 32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 320 400 320H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 37.6 210.5 32 224 32zM0 432c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z"
    ]
};
var $8063e68b12ef6db0$export$1fec48c8bdd69c1d = {
    prefix: "fas",
    iconName: "circle-right",
    icon: [
        512,
        512,
        [
            61838,
            "arrow-alt-circle-right"
        ],
        "f35a",
        "M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zm395.3 11.3l-112 112c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8l0-64-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-64c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5l112 112c6.2 6.2 6.2 16.4 0 22.6z"
    ]
};
var $8063e68b12ef6db0$export$88962ffdad8b856d = $8063e68b12ef6db0$export$1fec48c8bdd69c1d;
var $8063e68b12ef6db0$export$9cbf8612c6cadc74 = {
    prefix: "fas",
    iconName: "plane-circle-check",
    icon: [
        640,
        512,
        [],
        "e555",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM640 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $8063e68b12ef6db0$export$a6d72a9a068392b5 = {
    prefix: "fas",
    iconName: "face-rolling-eyes",
    icon: [
        512,
        512,
        [
            128580,
            "meh-rolling-eyes"
        ],
        "f5a5",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-144c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C208.5 175.6 224 198 224 224zm128 64c-35.3 0-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C400.5 175.6 416 198 416 224c0 35.3-28.7 64-64 64z"
    ]
};
var $8063e68b12ef6db0$export$fdc62a1bea767cc2 = $8063e68b12ef6db0$export$a6d72a9a068392b5;
var $8063e68b12ef6db0$export$40cdac24aa94a57a = {
    prefix: "fas",
    iconName: "object-group",
    icon: [
        576,
        512,
        [],
        "f247",
        "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H456.6C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM456.6 96H119.4c-5.6 9.7-13.7 17.8-23.4 23.4V392.6c9.7 5.6 17.8 13.7 23.4 23.4H456.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"
    ]
};
var $8063e68b12ef6db0$export$e022f62a119e1d93 = {
    prefix: "fas",
    iconName: "chart-line",
    icon: [
        512,
        512,
        [
            "line-chart"
        ],
        "f201",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"
    ]
};
var $8063e68b12ef6db0$export$f729617a20de475b = $8063e68b12ef6db0$export$e022f62a119e1d93;
var $8063e68b12ef6db0$export$122c8413a0dc5ff6 = {
    prefix: "fas",
    iconName: "mask-ventilator",
    icon: [
        640,
        512,
        [],
        "e524",
        "M159.1 176C139.4 219.2 128 264.7 128 300.8c0 15.9 2.2 31.4 6.3 46l-31.8-7.9C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H159.1zm26-48H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8c22.7 30.5 55.4 54.1 93.8 66.6V393.3c-19.7-16.4-32-40.3-32-66.9c0-49.5 43-134.4 96-134.4c52.5 0 96 84.9 96 134.4c0 26.7-12.4 50.4-32 66.8v76.6c38-12.6 70.6-36 93.5-66.4l71.6-17.9C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H454.5C419.7 73.8 372.1 32 320 32c-52.6 0-100.2 41.8-134.9 96zm295.6 48H584c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9l-31.8 8c4.2-14.7 6.4-30.1 6.4-46.1c0-36.1-11.6-81.6-31.3-124.8zM288 320V512h64V320c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $8063e68b12ef6db0$export$b4da69a0247f3620 = {
    prefix: "fas",
    iconName: "arrow-right",
    icon: [
        448,
        512,
        [
            8594
        ],
        "f061",
        "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
    ]
};
var $8063e68b12ef6db0$export$905f45f8ffd6b8e5 = {
    prefix: "fas",
    iconName: "signs-post",
    icon: [
        512,
        512,
        [
            "map-signs"
        ],
        "f277",
        "M224 32H64C46.3 32 32 46.3 32 64v64c0 17.7 14.3 32 32 32H441.4c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7H288c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 256c0-17.7-14.3-32-32-32H288V192H224v32H70.6c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7H448c17.7 0 32-14.3 32-32V256zM288 480V384H224v96c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $8063e68b12ef6db0$export$743f4b1071b3333a = $8063e68b12ef6db0$export$905f45f8ffd6b8e5;
var $8063e68b12ef6db0$export$6357093f67788b33 = {
    prefix: "fas",
    iconName: "cash-register",
    icon: [
        512,
        512,
        [],
        "f788",
        "M64 0C46.3 0 32 14.3 32 32V96c0 17.7 14.3 32 32 32h80v32H87c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V378.4c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160H208V128h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H64zM96 48H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm48-216c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm72 24c0-13.3 10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24zm-24 56c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm120-56c0-13.3 10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24zm-24 56c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm120-56c0-13.3 10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24zm-24 56c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $8063e68b12ef6db0$export$c8f8a597ffd676c0 = {
    prefix: "fas",
    iconName: "person-circle-question",
    icon: [
        576,
        512,
        [],
        "e542",
        "M208 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM152 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm0-48c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"
    ]
};
var $8063e68b12ef6db0$export$d762b7b66d5875e1 = {
    prefix: "fas",
    iconName: "h",
    icon: [
        384,
        512,
        [
            104
        ],
        "48",
        "M320 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192L64 192 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0z"
    ]
};
var $8063e68b12ef6db0$export$2305b1a41b3f914 = {
    prefix: "fas",
    iconName: "tarp",
    icon: [
        576,
        512,
        [],
        "e57b",
        "M576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64l352 0 0-128c0-17.7 14.3-32 32-32H576V128zM448 448L576 320H448l0 128zM96 192c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$158a12f36bbecf9 = {
    prefix: "fas",
    iconName: "screwdriver-wrench",
    icon: [
        512,
        512,
        [
            "tools"
        ],
        "f7d9",
        "M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h54.1l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109V104c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16V102.6c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144l0 .8 85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5zM104 432c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$646e4e7a8c6172aa = $8063e68b12ef6db0$export$158a12f36bbecf9;
var $8063e68b12ef6db0$export$9adae865350879af = {
    prefix: "fas",
    iconName: "arrows-to-eye",
    icon: [
        640,
        512,
        [],
        "e4bf",
        "M15 15C24.4 5.7 39.6 5.7 49 15l63 63V40c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H78.1L15 49C5.7 39.6 5.7 24.4 15 15zM133.5 243.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zM591 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63 63H600c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24V40c0-13.3 10.7-24 24-24s24 10.7 24 24V78.1l63-63zM15 497c-9.4-9.4-9.4-24.6 0-33.9l63-63H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V433.9L49 497c-9.4 9.4-24.6 9.4-33.9 0zm576 0l-63-63V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H561.9l63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
    ]
};
var $8063e68b12ef6db0$export$4f3b3144ce966486 = {
    prefix: "fas",
    iconName: "plug-circle-bolt",
    icon: [
        576,
        512,
        [],
        "e55b",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
var $8063e68b12ef6db0$export$e4b51a47a2f8b9db = {
    prefix: "fas",
    iconName: "heart",
    icon: [
        512,
        512,
        [
            128153,
            128154,
            128155,
            128156,
            128420,
            129293,
            129294,
            129505,
            9829,
            10084,
            61578
        ],
        "f004",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
    ]
};
var $8063e68b12ef6db0$export$808b88e8735e31e8 = {
    prefix: "fas",
    iconName: "mars-and-venus",
    icon: [
        512,
        512,
        [
            9893
        ],
        "f224",
        "M337.8 14.8C341.5 5.8 350.3 0 360 0H472c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59.1 146.7-136.1 158.2c0 .6 .1 1.2 .1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l-24 0-24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456H208c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2 .1-1.8C155.1 370.7 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48l0 0h0v0zM256 488h24c0 13.3-10.7 24-24 24s-24-10.7-24-24h24zm96-264c0-53-43-96-96-96s-96 43-96 96s43 96 96 96s96-43 96-96z"
    ]
};
var $8063e68b12ef6db0$export$9a513ee921e8e885 = {
    prefix: "fas",
    iconName: "house-user",
    icon: [
        576,
        512,
        [
            "home-user"
        ],
        "e1b0",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24zM352 224c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zm-96 96c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256z"
    ]
};
var $8063e68b12ef6db0$export$e732fa55ae5bbdf0 = $8063e68b12ef6db0$export$9a513ee921e8e885;
var $8063e68b12ef6db0$export$25e9b29b3f2230b5 = {
    prefix: "fas",
    iconName: "dumpster-fire",
    icon: [
        640,
        512,
        [],
        "f794",
        "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0h58c15.1-18.1 32.1-35.7 50.5-52.1c1.5-1.4 3.2-2.6 4.8-3.8L402.9 32H304V160zm209.9-23.7c17.4-15.8 43.9-16.2 61.7-1.2c-.1-.7-.3-1.4-.5-2.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l12.8 64.2c9.6 1 19 4.9 26.6 11.8c11.7 10.6 23 21.6 33.9 33.1c1.6-1.6 3.3-3.2 5-4.8zM325.2 210.7c3.8-6.2 7.9-12.5 12.3-18.7H32l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H337.6c-31-34.7-49.6-80.6-49.6-129.9c0-35.2 16.3-73.6 37.2-107.4zm128.4-78.9c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 407.9 390.3 480 480 480c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 401c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"
    ]
};
var $8063e68b12ef6db0$export$baa3c215534dbf2a = {
    prefix: "fas",
    iconName: "house-crack",
    icon: [
        576,
        512,
        [],
        "e3b1",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H230.4l-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L288 448l38.4 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z"
    ]
};
var $8063e68b12ef6db0$export$c6e76550bdc0255d = {
    prefix: "fas",
    iconName: "martini-glass-citrus",
    icon: [
        576,
        512,
        [
            "cocktail"
        ],
        "f561",
        "M432 240c53 0 96-43 96-96s-43-96-96-96c-35.5 0-66.6 19.3-83.2 48H296.2C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-27.7 0-53.5-7.8-75.5-21.3l35.4-35.4c12.2 5.6 25.8 8.7 40.1 8.7zM1.8 142.8C5.5 133.8 14.3 128 24 128H392c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-177 177V464h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H208 120c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V345.9L7 169c-6.9-6.9-8.9-17.2-5.2-26.2z"
    ]
};
var $8063e68b12ef6db0$export$4be708f1e41d387b = $8063e68b12ef6db0$export$c6e76550bdc0255d;
var $8063e68b12ef6db0$export$c938968e28178994 = {
    prefix: "fas",
    iconName: "face-surprise",
    icon: [
        512,
        512,
        [
            128558,
            "surprise"
        ],
        "f5c2",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM176.4 240c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM256 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z"
    ]
};
var $8063e68b12ef6db0$export$46647c72213f53ba = $8063e68b12ef6db0$export$c938968e28178994;
var $8063e68b12ef6db0$export$3ee278c67519eeeb = {
    prefix: "fas",
    iconName: "bottle-water",
    icon: [
        256,
        512,
        [],
        "e4c5",
        "M88 0h80c13.3 0 24 10.7 24 24V64H64V24C64 10.7 74.7 0 88 0zM0 151.7c0-15.6 9-29.8 23.2-36.5l24.4-11.4c11-5.1 23-7.8 35.1-7.8h90.6c12.1 0 24.1 2.7 35.1 7.8l24.4 11.4c14.2 6.6 23.2 20.8 23.2 36.5c0 14.4-7.5 27-18.9 34.1c11.5 8.8 18.9 22.6 18.9 38.2c0 16.7-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48c0-16.7 8.5-31.4 21.5-40C8.5 415.4 0 400.7 0 384s8.5-31.4 21.5-40C8.5 335.4 0 320.7 0 304s8.5-31.4 21.5-40C8.5 255.4 0 240.7 0 224c0-15.6 7.4-29.4 18.9-38.2C7.5 178.7 0 166.1 0 151.7zM64 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM80 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
    ]
};
var $8063e68b12ef6db0$export$fbeef2513e05ad08 = {
    prefix: "fas",
    iconName: "circle-pause",
    icon: [
        512,
        512,
        [
            62092,
            "pause-circle"
        ],
        "f28b",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$d8cf08a0362da8db = $8063e68b12ef6db0$export$fbeef2513e05ad08;
var $8063e68b12ef6db0$export$7a494edbf9b65575 = {
    prefix: "fas",
    iconName: "toilet-paper-slash",
    icon: [
        640,
        512,
        [],
        "e072",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-109.7-86C569.9 374 608 291.9 608 192C608 86 565 0 512 0s-96 86-96 192c0 49.1 9.2 93.9 24.4 127.9l-59-46.2c1.6-24.8 2.6-52 2.6-81.6c0-65.5 13.2-142.4 60.2-192H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM66.5 148.4C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512H285.9c22.3 0 45.4-12.1 55.4-36.1c7.4-17.7 17.5-47.2 26-90.6L66.5 148.4zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"
    ]
};
var $8063e68b12ef6db0$export$12de8220d30453a3 = {
    prefix: "fas",
    iconName: "apple-whole",
    icon: [
        448,
        512,
        [
            127822,
            127823,
            "apple-alt"
        ],
        "f5d1",
        "M224 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80H224zM0 288c0-76.3 35.7-160 112-160c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c76.3 0 112 83.7 112 160c0 128-80 224-160 224c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3C80 512 0 416 0 288z"
    ]
};
var $8063e68b12ef6db0$export$bcdd94f3977a0884 = $8063e68b12ef6db0$export$12de8220d30453a3;
var $8063e68b12ef6db0$export$64c1570509eaf40d = {
    prefix: "fas",
    iconName: "kitchen-set",
    icon: [
        576,
        512,
        [],
        "e51a",
        "M240 144c0-53-43-96-96-96s-96 43-96 96s43 96 96 96s96-43 96-96zm44.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16H496c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16H284.4zM144 208c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm256 32c13.3 0 24 10.7 24 24v8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h96v-8c0-13.3 10.7-24 24-24zM288 464V352H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zM48 320h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32h16zM24 464H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $8063e68b12ef6db0$export$eb4c616de6eef46f = {
    prefix: "fas",
    iconName: "r",
    icon: [
        320,
        512,
        [
            114
        ],
        "52",
        "M32 32C14.3 32 0 46.3 0 64V288 448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h95.3L261.8 466.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6L230.1 309.5C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144H32zM176 256H64V96H176c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $8063e68b12ef6db0$export$f9d1c19925fd7fa8 = {
    prefix: "fas",
    iconName: "temperature-quarter",
    icon: [
        320,
        512,
        [
            "temperature-1",
            "thermometer-1",
            "thermometer-quarter"
        ],
        "f2ca",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $8063e68b12ef6db0$export$d4f1cd380bde2129 = $8063e68b12ef6db0$export$f9d1c19925fd7fa8;
var $8063e68b12ef6db0$export$3f77fbe2dabe285b = $8063e68b12ef6db0$export$f9d1c19925fd7fa8;
var $8063e68b12ef6db0$export$ed05754fcbec6e46 = $8063e68b12ef6db0$export$f9d1c19925fd7fa8;
var $8063e68b12ef6db0$export$973ae4f1e4d2ce78 = {
    prefix: "fas",
    iconName: "cube",
    icon: [
        512,
        512,
        [],
        "f1b2",
        "M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6V377.4c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zm32 368.6l160-57.1v-188L288 246.6v188z"
    ]
};
var $8063e68b12ef6db0$export$441bfc8058328ce8 = {
    prefix: "fas",
    iconName: "bitcoin-sign",
    icon: [
        320,
        512,
        [],
        "e0b4",
        "M48 32C48 14.3 62.3 0 80 0s32 14.3 32 32V64h32V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64c0 1.5-.1 3.1-.3 4.5C254.1 82.2 288 125.1 288 176c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H41.7C18.7 448 0 429.3 0 406.3V288 265.7 224 101.6C0 80.8 16.8 64 37.6 64H48V32zM64 224H176c26.5 0 48-21.5 48-48s-21.5-48-48-48H64v96zm112 64H64v96H208c26.5 0 48-21.5 48-48s-21.5-48-48-48H176z"
    ]
};
var $8063e68b12ef6db0$export$2a5c6f182c0cbcb = {
    prefix: "fas",
    iconName: "shield-dog",
    icon: [
        512,
        512,
        [],
        "e573",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64V160h44.2c12.1 0 23.2 6.8 28.6 17.7L320 192h64c8.8 0 16 7.2 16 16v32c0 44.2-35.8 80-80 80H272v50.7c0 7.3-5.9 13.3-13.3 13.3c-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4c0-2.8 .6-5.5 1.9-8l15-30zM160 160h40 8v32 32c0 17.7-14.3 32-32 32s-32-14.3-32-32V176c0-8.8 7.2-16 16-16zm128 48c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $8063e68b12ef6db0$export$b9c649c5e37017f3 = {
    prefix: "fas",
    iconName: "solar-panel",
    icon: [
        640,
        512,
        [],
        "f5ba",
        "M96 0C80.7 0 67.6 10.8 64.6 25.7l-64 320c-1.9 9.4 .6 19.1 6.6 26.6S22.4 384 32 384H288v64H224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H608c9.6 0 18.7-4.3 24.7-11.7s8.5-17.2 6.6-26.6l-64-320C572.4 10.8 559.3 0 544 0H96zm5.4 168L122.2 64h90.4L202.3 168H101.4zm-9.6 48H197.5L187.1 320H71L91.8 216zm153.9 0H394.3l10.4 104H235.3l10.4-104zm196.8 0H548.2L569 320h-116L442.5 216zm96-48H437.7L427.3 64h90.4l20.8 104zm-149.1 0h-139L260.9 64H379.1l10.4 104z"
    ]
};
var $8063e68b12ef6db0$export$84b5acad4436d02a = {
    prefix: "fas",
    iconName: "lock-open",
    icon: [
        576,
        512,
        [],
        "f3c1",
        "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32V144C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V144z"
    ]
};
var $8063e68b12ef6db0$export$c7a833ce065e0ea4 = {
    prefix: "fas",
    iconName: "elevator",
    icon: [
        512,
        512,
        [],
        "e16d",
        "M132.7 4.7l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H208c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H64zm96 192c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zM80 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V400zm192 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V400zM400 272c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM356.7 91.3c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0H304c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l64 64z"
    ]
};
var $8063e68b12ef6db0$export$1b71392d9effbe = {
    prefix: "fas",
    iconName: "money-bill-transfer",
    icon: [
        640,
        512,
        [],
        "e528",
        "M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L384 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l174.1 0L535 41zM105 377l-23 23L256 400c13.3 0 24 10.7 24 24s-10.7 24-24 24L81.9 448l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64H337.9c-3.7 7.2-5.9 15.3-5.9 24c0 28.7 23.3 52 52 52l117.4 0c-4 17 .6 35.5 13.8 48.8c20.3 20.3 53.2 20.3 73.5 0L608 169.5V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24c0-28.7-23.3-52-52-52l-117.4 0c4-17-.6-35.5-13.8-48.8c-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64zm64 64H96v64c35.3 0 64-28.7 64-64zM544 320c-35.3 0-64 28.7-64 64h64V320zM320 352c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96s43 96 96 96z"
    ]
};
var $8063e68b12ef6db0$export$18ab80cba7d5044f = {
    prefix: "fas",
    iconName: "money-bill-trend-up",
    icon: [
        512,
        512,
        [],
        "e529",
        "M470.7 9.4c3 3.1 5.3 6.6 6.9 10.3s2.4 7.8 2.4 12.2l0 .1v0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3L310.6 214.6c-11.8 11.8-30.8 12.6-43.5 1.7L176 138.1 84.8 216.3c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l112-96c12-10.3 29.7-10.3 41.7 0l89.5 76.7L370.7 64H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0c8.8 0 16.8 3.6 22.6 9.3l.1 .1zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $8063e68b12ef6db0$export$30d3e64480aa266b = {
    prefix: "fas",
    iconName: "house-flood-water-circle-arrow-right",
    icon: [
        640,
        512,
        [],
        "e50f",
        "M288 144C288 64.5 223.5 0 144 0S0 64.5 0 144s64.5 144 144 144s144-64.5 144-144zM140.7 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6zM320 144c0 57.3-27.4 108.2-69.8 140.3c11.8-3.6 23-9.4 33-16.2c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.4 78.1 3.4c2.1 1.7 4.2 3.3 6.5 4.9l-.3-84.4H576c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128C407.6-2 392.4-2 381.2 6.1L301 64.4c12.1 23.9 19 50.9 19 79.6zm18.5 165.9c-11.1-7.9-25.9-7.9-37 0C279 325.4 251.5 336 224 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 389.7 191 400 224 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C471.4 325.2 442.9 336 416 336c-27.5 0-55-10.6-77.5-26.1zm0 112c-11.1-7.9-25.9-7.9-37 0C279 437.4 251.5 448 224 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 501.7 191 512 224 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C471.4 437.2 442.9 448 416 448c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var $8063e68b12ef6db0$export$287bdd70ab874659 = {
    prefix: "fas",
    iconName: "square-poll-horizontal",
    icon: [
        448,
        512,
        [
            "poll-h"
        ],
        "f682",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 160c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32zm64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0zM192 352c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$456a238f0144d430 = $8063e68b12ef6db0$export$287bdd70ab874659;
var $8063e68b12ef6db0$export$4280b2387fbdad12 = {
    prefix: "fas",
    iconName: "circle",
    icon: [
        512,
        512,
        [
            128308,
            128309,
            128992,
            128993,
            128994,
            128995,
            128996,
            9679,
            9898,
            9899,
            11044,
            61708,
            61915
        ],
        "f111",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512z"
    ]
};
var $8063e68b12ef6db0$export$662cbc6ed5a3c5e8 = {
    prefix: "fas",
    iconName: "backward-fast",
    icon: [
        512,
        512,
        [
            9198,
            "fast-backward"
        ],
        "f049",
        "M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L288 297.7V416c0 12.4-7.2 23.7-18.4 29s-24.5 3.6-34.1-4.4L64 297.7V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V214.3L235.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S288 83.6 288 96V214.3L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96V416c0 12.4-7.2 23.7-18.4 29z"
    ]
};
var $8063e68b12ef6db0$export$e6246a3279a379b8 = $8063e68b12ef6db0$export$662cbc6ed5a3c5e8;
var $8063e68b12ef6db0$export$a65c441f12cb6bd = {
    prefix: "fas",
    iconName: "recycle",
    icon: [
        576,
        512,
        [
            9842,
            9850,
            9851
        ],
        "f1b8",
        "M206.7 45.1C224.2 17 255 0 288 0s63.8 17 81.3 45.1l38.6 61.7 27-15.6c8.4-4.9 18.9-4.2 26.6 1.7s11.1 15.9 8.6 25.3l-23.4 87.4c-3.4 12.8-16.6 20.4-29.4 17l-87.4-23.4c-9.4-2.5-16.3-10.4-17.6-20s3.4-19.1 11.8-23.9l28.4-16.4L315 79c-5.8-9.3-16-15-27-15s-21.2 5.7-27 15l-17.5 28c-9.2 14.8-28.6 19.5-43.6 10.5c-15.3-9.2-20.2-29.2-10.7-44.4l17.5-28zM461.5 251.9c15-9 34.4-4.3 43.6 10.5l24.4 39.1c9.4 15.1 14.4 32.4 14.6 50.2c.3 53.1-42.7 96.4-95.8 96.4L352 448v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2v32l96.2 0c17.6 0 31.9-14.4 31.8-32c0-5.9-1.7-11.7-4.8-16.7l-24.4-39.1c-9.5-15.2-4.7-35.2 10.7-44.4zm-364.6-31L68 204.2c-8.4-4.9-13.1-14.3-11.8-23.9s8.2-17.5 17.6-20l87.4-23.4c12.8-3.4 26 4.2 29.4 17L214 241.2c2.5 9.4-.9 19.3-8.6 25.3s-18.2 6.6-26.6 1.7l-26.5-15.3-51.5 82.4c-3.1 5-4.8 10.8-4.8 16.7c-.1 17.6 14.2 32 31.8 32l32.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.2 0c-53.1 0-96.1-43.2-95.8-96.4c.1-17.8 5.1-35.1 14.6-50.2l50.3-80.5z"
    ]
};
var $8063e68b12ef6db0$export$94363e983c225a04 = {
    prefix: "fas",
    iconName: "user-astronaut",
    icon: [
        448,
        512,
        [],
        "f4fb",
        "M370.7 96.1C346.1 39.5 289.7 0 224 0S101.9 39.5 77.3 96.1C60.9 97.5 48 111.2 48 128v64c0 16.8 12.9 30.5 29.3 31.9C101.9 280.5 158.3 320 224 320s122.1-39.5 146.7-96.1c16.4-1.4 29.3-15.1 29.3-31.9V128c0-16.8-12.9-30.5-29.3-31.9zM336 144v16c0 53-43 96-96 96H208c-53 0-96-43-96-96V144c0-26.5 21.5-48 48-48H288c26.5 0 48 21.5 48 48zM189.3 162.7l-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zM112.7 316.5C46.7 342.6 0 407 0 482.3C0 498.7 13.3 512 29.7 512H128V448c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64l98.3 0c16.4 0 29.7-13.3 29.7-29.7c0-75.3-46.7-139.7-112.7-165.8C303.9 338.8 265.5 352 224 352s-79.9-13.2-111.3-35.5zM176 448c-8.8 0-16 7.2-16 16v48h32V464c0-8.8-7.2-16-16-16zm96 32c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16z"
    ]
};
var $8063e68b12ef6db0$export$cfee4df0d5df6d21 = {
    prefix: "fas",
    iconName: "plane-slash",
    icon: [
        640,
        512,
        [],
        "e069",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320h73.8c34.2 0 93.7-28 93.7-64c0-35-59.5-64-93.7-64l-116.6 0L297.2 16.1C291.5 6.2 280.9 0 269.4 0H213.2c-10.6 0-18.3 10.2-15.4 20.4l40.3 140.9L38.8 5.1zm2.7 123.6C36 130.6 32 135.9 32 142c0 1.3 .2 2.6 .5 3.9L64 256 32.5 366.1c-.4 1.3-.5 2.6-.5 3.9c0 7.8 6.3 14 14 14H88c5 0 9.8-2.4 12.8-6.4L144 320H246.9l-49 171.6c-2.9 10.2 4.8 20.4 15.4 20.4l56.2 0c11.5 0 22.1-6.2 27.8-16.1l65.3-114.3L41.5 128.7z"
    ]
};
var $8063e68b12ef6db0$export$9c9b2fbddd59047d = {
    prefix: "fas",
    iconName: "trademark",
    icon: [
        640,
        512,
        [
            8482
        ],
        "f25c",
        "M345.6 108.8c-8.3-11-22.7-15.5-35.7-11.2S288 114.2 288 128V384c0 17.7 14.3 32 32 32s32-14.3 32-32V224l86.4 115.2c6 8.1 15.5 12.8 25.6 12.8s19.6-4.7 25.6-12.8L576 224V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-13.8-8.8-26-21.9-30.4s-27.5 .1-35.7 11.2L464 266.7 345.6 108.8zM0 128c0 17.7 14.3 32 32 32H96V384c0 17.7 14.3 32 32 32s32-14.3 32-32V160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 96 0 110.3 0 128z"
    ]
};
var $8063e68b12ef6db0$export$44dee69e3a29b0e = {
    prefix: "fas",
    iconName: "basketball",
    icon: [
        512,
        512,
        [
            127936,
            "basketball-ball"
        ],
        "f434",
        "M86.6 64C119 35.5 158.6 15 202.3 5.6C206 19.1 208 33.3 208 48c0 38.4-13.5 73.7-36.1 101.3L86.6 64zM64 86.6l85.2 85.2C121.7 194.5 86.4 208 48 208c-14.7 0-28.9-2-42.4-5.7C15 158.6 35.5 119 64 86.6zM256 0c64.9 0 124.2 24.2 169.4 64L256 233.4 194.6 172C222.9 138.5 240 95.3 240 48c0-16.2-2-32-5.8-47.1C241.4 .3 248.7 0 256 0zM48 240c47.3 0 90.5-17.1 124-45.4L233.4 256 64 425.4C24.2 380.2 0 320.9 0 256c0-7.3 .3-14.6 .9-21.8C16 238 31.8 240 48 240zm463.1 37.8C496 274 480.2 272 464 272c-47.3 0-90.5 17.1-124 45.4L278.6 256 448 86.6c39.8 45.1 64 104.4 64 169.4c0 7.3-.3 14.6-.9 21.8zm-4.7 31.9C497 353.4 476.5 393 448 425.4l-85.2-85.2C390.3 317.5 425.6 304 464 304c14.7 0 28.9 2 42.4 5.7zM340.1 362.7L425.4 448C393 476.5 353.4 497 309.7 506.4C306 492.9 304 478.7 304 464c0-38.4 13.5-73.7 36.1-101.3zM317.4 340C289.1 373.5 272 416.7 272 464c0 16.2 2 32 5.8 47.1c-7.2 .6-14.5 .9-21.8 .9c-64.9 0-124.2-24.2-169.4-64L256 278.6 317.4 340z"
    ]
};
var $8063e68b12ef6db0$export$36550ab8ffcc5b28 = $8063e68b12ef6db0$export$44dee69e3a29b0e;
var $8063e68b12ef6db0$export$219ccae0e4da3c92 = {
    prefix: "fas",
    iconName: "satellite-dish",
    icon: [
        512,
        512,
        [
            128225
        ],
        "f7c0",
        "M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$72ea8a5e4e86cd69 = {
    prefix: "fas",
    iconName: "circle-up",
    icon: [
        512,
        512,
        [
            61467,
            "arrow-alt-circle-up"
        ],
        "f35b",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm11.3-395.3l112 112c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H304v96c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V256H144c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l112-112c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $8063e68b12ef6db0$export$3747a8ef0995eadf = $8063e68b12ef6db0$export$72ea8a5e4e86cd69;
var $8063e68b12ef6db0$export$da39ed20699ee2d7 = {
    prefix: "fas",
    iconName: "mobile-screen-button",
    icon: [
        384,
        512,
        [
            "mobile-alt"
        ],
        "f3cd",
        "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM224 448c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM304 64H80V384H304V64z"
    ]
};
var $8063e68b12ef6db0$export$e9599bc6cd92234d = $8063e68b12ef6db0$export$da39ed20699ee2d7;
var $8063e68b12ef6db0$export$39461921e738be65 = {
    prefix: "fas",
    iconName: "volume-high",
    icon: [
        640,
        512,
        [
            128266,
            "volume-up"
        ],
        "f028",
        "M533.6 32.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"
    ]
};
var $8063e68b12ef6db0$export$5940d3e475d90cc4 = $8063e68b12ef6db0$export$39461921e738be65;
var $8063e68b12ef6db0$export$9c0b63b698611d06 = {
    prefix: "fas",
    iconName: "users-rays",
    icon: [
        640,
        512,
        [],
        "e593",
        "M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM599 7L527 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72zM320 256c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zM212.1 336c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-.5-1.4-1-2.7-1.6-4c-9.4-22.3-29.8-38.9-54.3-43c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-.8 .1-1.7 .3-2.5 .5c-24.9 5.1-45.1 23-53.4 46.5zM175.8 224c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zM464 224c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
    ]
};
var $8063e68b12ef6db0$export$79204db8777905c8 = {
    prefix: "fas",
    iconName: "wallet",
    icon: [
        512,
        512,
        [],
        "f555",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H448c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM416 336c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$7babcb2c90eb609a = {
    prefix: "fas",
    iconName: "clipboard-check",
    icon: [
        384,
        512,
        [],
        "f46c",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zM307.8 275.8l-128 128c-10.9 10.9-28.7 10.9-39.6 0l-64-64c-10.9-10.9-10.9-28.7 0-39.6s28.7-10.9 39.6 0L160 344.4 268.2 236.2c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6z"
    ]
};
var $8063e68b12ef6db0$export$b8d24c57c9e64933 = {
    prefix: "fas",
    iconName: "file-audio",
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm2 226.3c37.1 22.4 62 63.1 62 109.7s-24.9 87.3-62 109.7c-7.6 4.6-17.4 2.1-22-5.4s-2.1-17.4 5.4-22C269.4 401.5 288 370.9 288 336s-18.6-65.5-46.5-82.3c-7.6-4.6-10-14.4-5.4-22s14.4-10 22-5.4zm-91.9 30.9c6 2.5 9.9 8.3 9.9 14.8V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L113.4 376H80c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h33.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5zm51 34.9c6.6-5.9 16.7-5.3 22.6 1.3C249.8 304.6 256 319.6 256 336s-6.2 31.4-16.3 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c5.1-5.7 8.1-13.1 8.1-21.3s-3.1-15.7-8.1-21.3c-5.9-6.6-5.3-16.7 1.3-22.6z"
    ]
};
var $8063e68b12ef6db0$export$128a6cab12423493 = {
    prefix: "fas",
    iconName: "burger",
    icon: [
        512,
        512,
        [
            "hamburger"
        ],
        "f805",
        "M61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1H61.1zM144 128c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm240 16c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zM272 96c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zM16 304c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48s-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zm16 96c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16v16c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V400z"
    ]
};
var $8063e68b12ef6db0$export$bab3bb9f4f59363 = $8063e68b12ef6db0$export$128a6cab12423493;
var $8063e68b12ef6db0$export$3c6c0c8185296ac5 = {
    prefix: "fas",
    iconName: "wrench",
    icon: [
        512,
        512,
        [
            128295
        ],
        "f0ad",
        "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 456c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $8063e68b12ef6db0$export$f5bfd1271b8b71d1 = {
    prefix: "fas",
    iconName: "bugs",
    icon: [
        640,
        512,
        [],
        "e4d0",
        "M196.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L160 71.7 133.9 14.1C128.4 2 114.1-3.3 102.1 2.1S84.7 21.9 90.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6h-17l-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8s-21.4 15.2-18.8 28.2l8 40C42.7 175.9 52.6 184 64 184H96v23.3l-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C114.7 274.6 135.8 288 160 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L224 207.3V184h32c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L236.3 136h-17c-4.7-11.6-12.7-21.5-22.9-28.6zM528 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L464.8 250c-12.3 1-24.2 5.6-34.1 13.3L416 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L391 322.7 353.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L535.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L598.2 347c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z"
    ]
};
var $8063e68b12ef6db0$export$8bf9e3f7f57d486a = {
    prefix: "fas",
    iconName: "rupee-sign",
    icon: [
        448,
        512,
        [
            8360,
            "rupee"
        ],
        "f156",
        "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256.5 16.4c-.9 6 0 8.7 .4 9.8c.4 1.1 1.4 2.6 4.2 4.9c7.2 5.7 18.7 10 37.9 16.8l1.3 .5c16 5.6 38.7 13.6 55.7 28.1c9.5 8.1 17.9 18.6 23.1 32.3c5.1 13.7 6.1 28.5 3.8 44c-4.2 28.1-20.5 49.3-43.8 60.9c-22.1 11-48.1 12.5-73.2 8l-.2 0 0 0c-9.3-1.8-20.5-5.7-29.3-9c-6-2.3-12.6-4.9-17.7-6.9l0 0c-2.5-1-4.6-1.8-6.3-2.5c-16.5-6.4-24.6-25-18.2-41.4s25-24.6 41.4-18.2c2.6 1 5.2 2 7.9 3.1l0 0c4.8 1.9 9.8 3.9 15.4 6c8.8 3.3 15.3 5.4 18.7 6c15.7 2.8 26.7 .8 32.9-2.3c5-2.5 8-6 9.1-13c1-6.9 .2-10.5-.5-12.3c-.6-1.7-1.8-3.6-4.5-5.9c-6.9-5.8-18.2-10.4-36.9-17l-3-1.1c-15.5-5.4-37-13-53.3-25.9c-9.5-7.5-18.3-17.6-23.7-31c-5.4-13.4-6.6-28-4.4-43.2c8.5-57.1 67-78 116.9-68.9c6.9 1.3 27.3 5.8 35.4 8.4c16.9 5.2 26.3 23.2 21.1 40.1s-23.2 26.3-40.1 21.1c-4.7-1.4-22.3-5.5-27.9-6.5c-14.6-2.7-25.8-.4-32.6 3.2c-6.3 3.3-8.9 7.6-9.5 12z"
    ]
};
var $8063e68b12ef6db0$export$9da25a46cfcb6fa4 = $8063e68b12ef6db0$export$8bf9e3f7f57d486a;
var $8063e68b12ef6db0$export$6440b286d3cbac9b = {
    prefix: "fas",
    iconName: "file-image",
    icon: [
        384,
        512,
        [
            128443
        ],
        "f1c5",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM128 256c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm88 32c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6H216 176 128 80c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l48-80c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l12.8 21.4 48.3-70.2c3-4.3 7.9-6.9 13.2-6.9z"
    ]
};
var $8063e68b12ef6db0$export$d7cf0978afd90002 = {
    prefix: "fas",
    iconName: "circle-question",
    icon: [
        512,
        512,
        [
            62108,
            "question-circle"
        ],
        "f059",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM288 352c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$5ba67d7f2265c1a5 = $8063e68b12ef6db0$export$d7cf0978afd90002;
var $8063e68b12ef6db0$export$6ccbeeccfea6dc8a = {
    prefix: "fas",
    iconName: "plane-departure",
    icon: [
        640,
        512,
        [
            128747
        ],
        "f5b0",
        "M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2H248.4c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48H542.8c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var $8063e68b12ef6db0$export$2cef3f81ad90fb76 = {
    prefix: "fas",
    iconName: "handshake-slash",
    icon: [
        640,
        512,
        [],
        "e060",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.4-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM96 171.6L40.6 128H0V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V171.6zM413.6 421.9L128 196.9V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6zM48 352c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V128H544zm64 208c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$3d177ecdf7fc50ec = {
    prefix: "fas",
    iconName: "book-bookmark",
    icon: [
        448,
        512,
        [],
        "e0bb",
        "M0 96C0 43 43 0 96 0h96V190.7c0 13.4 15.5 20.9 26 12.5L272 160l54 43.2c10.5 8.4 26 .9 26-12.5V0h32 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32z"
    ]
};
var $8063e68b12ef6db0$export$aa054a78ab078db3 = {
    prefix: "fas",
    iconName: "code-branch",
    icon: [
        448,
        512,
        [],
        "f126",
        "M80 104c13.3 0 24-10.7 24-24s-10.7-24-24-24S56 66.7 56 80s10.7 24 24 24zm80-24c0 32.8-19.7 61-48 73.3v87.8c18.8-10.9 40.7-17.1 64-17.1h96c35.3 0 64-28.7 64-64v-6.7C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V160c0 70.7-57.3 128-128 128H176c-35.3 0-64 28.7-64 64v6.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V352 153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm232 0c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zM80 456c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $8063e68b12ef6db0$export$37672611144b857b = {
    prefix: "fas",
    iconName: "hat-cowboy",
    icon: [
        640,
        512,
        [],
        "f8c0",
        "M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.3 0 84.4 152.2 97.9 221.9C447.8 272.1 390.9 288 320 288s-127.8-15.9-169.9-34.1C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z"
    ]
};
var $8063e68b12ef6db0$export$f402c7c97f3383f0 = {
    prefix: "fas",
    iconName: "bridge",
    icon: [
        576,
        512,
        [],
        "e4c8",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H72v64H0V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96s96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96V160H504V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM456 96v64H376V96h80zM328 96v64H248V96h80zM200 96v64H120V96h80z"
    ]
};
var $8063e68b12ef6db0$export$d86c56ab43eb0deb = {
    prefix: "fas",
    iconName: "phone-flip",
    icon: [
        512,
        512,
        [
            128381,
            "phone-alt"
        ],
        "f879",
        "M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448c-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6L207.3 368c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z"
    ]
};
var $8063e68b12ef6db0$export$a07a9b305deebf32 = $8063e68b12ef6db0$export$d86c56ab43eb0deb;
var $8063e68b12ef6db0$export$4a5a13c01d46357c = {
    prefix: "fas",
    iconName: "truck-front",
    icon: [
        512,
        512,
        [],
        "e2b7",
        "M0 80C0 35.8 35.8 0 80 0H432c44.2 0 80 35.8 80 80V368c0 26.2-12.6 49.4-32 64v48c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V432C12.6 417.4 0 394.2 0 368V80zm129.9 72.2L112 224H400l-17.9-71.8C378.5 138 365.7 128 351 128H161c-14.7 0-27.5 10-31 24.2zM128 320c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm288 32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$ab927dada03be4b3 = {
    prefix: "fas",
    iconName: "cat",
    icon: [
        512,
        512,
        [
            128008
        ],
        "f6be",
        "M288 192h17.1c22.1 38.3 63.5 64 110.9 64c11 0 21.8-1.4 32-4v4 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V339.2L248 448h56c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-53 0-96-43-96-96V192.5c0-16.1-12-29.8-28-31.8l-7.9-1C10.5 157.6-1.9 141.6 .2 124s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3v85.3c34.4-51.7 93.2-85.8 160-85.8zm160 26.5v0c-10 3.5-20.8 5.5-32 5.5c-28.4 0-54-12.4-71.6-32h0c-3.7-4.1-7-8.5-9.9-13.2C325.3 164 320 146.6 320 128v0V32 12 10.7C320 4.8 324.7 .1 330.6 0h.2c3.3 0 6.4 1.6 8.4 4.2l0 .1L352 21.3l27.2 36.3L384 64h64l4.8-6.4L480 21.3 492.8 4.3l0-.1c2-2.6 5.1-4.2 8.4-4.2h.2C507.3 .1 512 4.8 512 10.7V12 32v96c0 17.3-4.6 33.6-12.6 47.6c-11.3 19.8-29.6 35.2-51.4 42.9zM400 128c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 16c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16z"
    ]
};
var $8063e68b12ef6db0$export$61add9eca991b5ec = {
    prefix: "fas",
    iconName: "anchor-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e4ab",
        "M256 96c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm85.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$f4419f7b2e53b340 = {
    prefix: "fas",
    iconName: "truck-field",
    icon: [
        640,
        512,
        [],
        "e58d",
        "M32 96c0-35.3 28.7-64 64-64H320c23.7 0 44.4 12.9 55.4 32h51.8c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1 .9 2.1 1.3 3.2H544c35.3 0 64 28.7 64 64v32c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V288c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32V96zM384 224h85.9l-42.7-96H384v96zM160 432c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm368-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48z"
    ]
};
var $8063e68b12ef6db0$export$806c0a45a7ecd6e8 = {
    prefix: "fas",
    iconName: "route",
    icon: [
        512,
        512,
        [],
        "f4d7",
        "M416 256s96-96 96-160c0-53-43-96-96-96s-96 43-96 96c0 29.4 20.2 65.5 42.1 96H320c-53 0-96 43-96 96s43 96 96 96h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H188.6c-6.2 9.6-12.6 18.8-19 27.2c-10.7 14.2-21.3 26.9-30 36.8H416c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h96zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zM149.9 448c21.9-30.5 42.1-66.6 42.1-96c0-53-43-96-96-96s-96 43-96 96c0 64 96 160 96 160s3.5-3.5 9.2-9.6c.4-.4 .7-.8 1.1-1.2c3.3-3.5 7.1-7.8 11.4-12.8c.2-.2 .4-.4 .6-.6c9.4-10.8 20.7-24.6 31.6-39.8zM96 384c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$d4aa151a4554b74e = {
    prefix: "fas",
    iconName: "clipboard-question",
    icon: [
        384,
        512,
        [],
        "e4e3",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zM105.8 229.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 328.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V314.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 416c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$5dd22dcb6e3ed369 = {
    prefix: "fas",
    iconName: "panorama",
    icon: [
        640,
        512,
        [],
        "e209",
        "M45.6 32C20.4 32 0 52.4 0 77.6V434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM160 160c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm208 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z"
    ]
};
var $8063e68b12ef6db0$export$101422b773924276 = {
    prefix: "fas",
    iconName: "comment-medical",
    icon: [
        512,
        512,
        [],
        "f7f5",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM224 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V272H176c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"
    ]
};
var $8063e68b12ef6db0$export$c88ac21fe7c88ae6 = {
    prefix: "fas",
    iconName: "teeth-open",
    icon: [
        576,
        512,
        [],
        "f62f",
        "M96 32C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-53-43-96-96-96H96zM224 96c26.5 0 48 21.5 48 48v56c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V144c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48v56c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V144zM96 128c26.5 0 48 21.5 48 48v24c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V176c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48v24c0 13.3-10.7 24-24 24H456c-13.3 0-24-10.7-24-24V176zM96 480H480c53 0 96-43 96-96V352c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96zm0-64c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48z"
    ]
};
var $8063e68b12ef6db0$export$4b89fabf50a10951 = {
    prefix: "fas",
    iconName: "file-circle-minus",
    icon: [
        576,
        512,
        [],
        "e4ed",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM576 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zm-64 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"
    ]
};
var $8063e68b12ef6db0$export$d55778e3ab6c933f = {
    prefix: "fas",
    iconName: "tags",
    icon: [
        512,
        512,
        [],
        "f02c",
        "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5V80C0 53.5 21.5 32 48 32H197.5c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $8063e68b12ef6db0$export$e06d6607d3577d6e = {
    prefix: "fas",
    iconName: "wine-glass",
    icon: [
        320,
        512,
        [
            127863
        ],
        "f4e3",
        "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H64zM88.1 128l5.3-64H226.6l5.3 64H88.1z"
    ]
};
var $8063e68b12ef6db0$export$dc9cc4280bee320d = {
    prefix: "fas",
    iconName: "forward-fast",
    icon: [
        512,
        512,
        [
            9197,
            "fast-forward"
        ],
        "f050",
        "M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4L224 297.7V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4L448 297.7V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32V214.3L276.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S224 83.6 224 96V214.3L52.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S0 83.6 0 96V416c0 12.4 7.2 23.7 18.4 29z"
    ]
};
var $8063e68b12ef6db0$export$61a8cdc53c2e078d = $8063e68b12ef6db0$export$dc9cc4280bee320d;
var $8063e68b12ef6db0$export$38c072b870a9e4ab = {
    prefix: "fas",
    iconName: "face-meh-blank",
    icon: [
        512,
        512,
        [
            128566,
            "meh-blank"
        ],
        "f5a4",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM208.4 208c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm128 32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$e945435725f71e88 = $8063e68b12ef6db0$export$38c072b870a9e4ab;
var $8063e68b12ef6db0$export$f2cfa036d76f69ab = {
    prefix: "fas",
    iconName: "square-parking",
    icon: [
        448,
        512,
        [
            127359,
            "parking"
        ],
        "f540",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 256h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H192v64zm48 64H192v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"
    ]
};
var $8063e68b12ef6db0$export$fda29c8f99573a4e = $8063e68b12ef6db0$export$f2cfa036d76f69ab;
var $8063e68b12ef6db0$export$58845db8e7e9a199 = {
    prefix: "fas",
    iconName: "house-signal",
    icon: [
        576,
        512,
        [],
        "e012",
        "M314.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c9.7 8.9 12.9 22.9 8.1 35.2S557.2 256 544 256H512V368c0 26.5-21.5 48-48 48H278.1C259.6 350.8 216.8 295.9 160 261.7V256h-9.9c-16.5-9-34-16.2-52.3-21.6c-4.1-12-.8-25.3 8.5-34l208-192zM304 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H304zM24 256c128.1 0 232 103.9 232 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 256c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zM0 376c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24z"
    ]
};
var $8063e68b12ef6db0$export$ee3a02da18715b2 = {
    prefix: "fas",
    iconName: "bars-progress",
    icon: [
        512,
        512,
        [
            "tasks-alt"
        ],
        "f828",
        "M448 160H320V128H448v32zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM448 352v32H192V352H448zM48 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48z"
    ]
};
var $8063e68b12ef6db0$export$bbc0784fc1578f7f = $8063e68b12ef6db0$export$ee3a02da18715b2;
var $8063e68b12ef6db0$export$7a255960242435f6 = {
    prefix: "fas",
    iconName: "faucet-drip",
    icon: [
        512,
        512,
        [
            128688
        ],
        "e006",
        "M224 0c17.7 0 32 14.3 32 32V44l96-12c17.7 0 32 14.3 32 32s-14.3 32-32 32L256 84l-31-3.9-1-.1-1 .1L192 84 96 96C78.3 96 64 81.7 64 64s14.3-32 32-32l96 12V32c0-17.7 14.3-32 32-32zM0 224c0-17.7 14.3-32 32-32h96l22.6-22.6c6-6 14.1-9.4 22.6-9.4H192V116.2l32-4 32 4V160h18.7c8.5 0 16.6 3.4 22.6 9.4L320 192h32c88.4 0 160 71.6 160 160c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32s-14.3-32-32-32H315.9c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48H32c-17.7 0-32-14.3-32-32V224zM436.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z"
    ]
};
var $8063e68b12ef6db0$export$df587aaf7765e1ce = {
    prefix: "fas",
    iconName: "cart-flatbed",
    icon: [
        640,
        512,
        [
            "dolly-flatbed"
        ],
        "f474",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H48c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80C128 35.8 92.2 0 48 0H32zM192 80V272c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H464V176c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L400 163.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V32H240c-26.5 0-48 21.5-48 48z"
    ]
};
var $8063e68b12ef6db0$export$f7c6efb60c53b285 = $8063e68b12ef6db0$export$df587aaf7765e1ce;
var $8063e68b12ef6db0$export$130df7ed74437774 = {
    prefix: "fas",
    iconName: "ban-smoking",
    icon: [
        512,
        512,
        [
            128685,
            "smoking-ban"
        ],
        "f54d",
        "M99.5 144.8L178.7 224l96 96 92.5 92.5C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32H384v32H333.3zm32 32H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H269.3L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM229.5 320l-96-96H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H229.5z"
    ]
};
var $8063e68b12ef6db0$export$e50452a49dec29f = $8063e68b12ef6db0$export$130df7ed74437774;
var $8063e68b12ef6db0$export$5e63e8b85b5f119c = {
    prefix: "fas",
    iconName: "terminal",
    icon: [
        640,
        512,
        [],
        "f120",
        "M41.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 41.4 86.6zM288 416H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H288c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$c93d62849efbdd11 = {
    prefix: "fas",
    iconName: "mobile-button",
    icon: [
        384,
        512,
        [],
        "f10b",
        "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zM192 464c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$86c50f517be57a40 = {
    prefix: "fas",
    iconName: "house-medical-flag",
    icon: [
        640,
        512,
        [],
        "e514",
        "M480 0c17.7 0 32 14.3 32 32H624c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16H512V512H448V192 32c0-17.7 14.3-32 32-32zM276.8 39.7L416 159V512h1l-.2 0H96c-17.7 0-32-14.3-32-32V288H32c-13.4 0-25.4-8.3-30-20.9s-1-26.7 9.2-35.4l224-192c12-10.3 29.7-10.3 41.7 0zM224 208v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"
    ]
};
var $8063e68b12ef6db0$export$1d307c13b511e8e1 = {
    prefix: "fas",
    iconName: "basket-shopping",
    icon: [
        576,
        512,
        [
            "shopping-basket"
        ],
        "f291",
        "M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512H430c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H458.4L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192H171.7L253.3 35.1zM192 304v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$ca6d443595a6578f = $8063e68b12ef6db0$export$1d307c13b511e8e1;
var $8063e68b12ef6db0$export$b88ed5e1e0eac4c6 = {
    prefix: "fas",
    iconName: "tape",
    icon: [
        576,
        512,
        [],
        "f4db",
        "M380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H380.8zM224 352c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96zm64-96c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $8063e68b12ef6db0$export$d3724faf0c559353 = {
    prefix: "fas",
    iconName: "bus-simple",
    icon: [
        448,
        512,
        [
            "bus-alt"
        ],
        "f55e",
        "M224 0C348.8 0 448 35.2 448 80V96 416c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32V96 80C0 35.2 99.2 0 224 0zM64 128V256c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 400c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$40616edfab6d332a = $8063e68b12ef6db0$export$d3724faf0c559353;
var $8063e68b12ef6db0$export$b8c3e79e8c99c95b = {
    prefix: "fas",
    iconName: "eye",
    icon: [
        576,
        512,
        [
            128065
        ],
        "f06e",
        "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z"
    ]
};
var $8063e68b12ef6db0$export$e8ea88c55e55be7c = {
    prefix: "fas",
    iconName: "face-sad-cry",
    icon: [
        512,
        512,
        [
            128557,
            "sad-cry"
        ],
        "f5b3",
        "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V477.8C51.5 433.5 0 350.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 94.8-51.5 177.5-128 221.8V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V493.4zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM208 336v32c0 26.5 21.5 48 48 48s48-21.5 48-48V336c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
    ]
};
var $8063e68b12ef6db0$export$8e924e6bd422cef9 = $8063e68b12ef6db0$export$e8ea88c55e55be7c;
var $8063e68b12ef6db0$export$b6b464c98c009494 = {
    prefix: "fas",
    iconName: "audio-description",
    icon: [
        576,
        512,
        [],
        "f29e",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM213.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9H150.9l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2h42.2zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96H328c-13.3 0-24-10.7-24-24V184zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352z"
    ]
};
var $8063e68b12ef6db0$export$41b1e14a6b0fe11b = {
    prefix: "fas",
    iconName: "person-military-to-person",
    icon: [
        512,
        512,
        [],
        "e54c",
        "M71 12.5c-8.6 1-15 8.2-15 16.8c0 9.3 7.5 16.8 16.7 16.9H184.1c8.8-.1 15.9-7.2 15.9-16V16c0-9.5-8.3-17-17.8-15.9L71 12.5zM189.5 78.1H66.5C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM32 256v32c0 17.7 14.3 32 32 32H192c1.8 0 3.5-.1 5.2-.4L53 208.6C40.1 220.3 32 237.2 32 256zm190.2 42.5c1.1-3.3 1.8-6.8 1.8-10.5V256c0-35.3-28.7-64-64-64H96c-3.7 0-7.4 .3-10.9 .9L222.2 298.5zM384 160c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zm-32 32c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H352zM215.8 450.1c5.2-4.6 8.2-11.1 8.2-18.1s-3-13.5-8.2-18.1l-64-56c-7.1-6.2-17.1-7.7-25.7-3.8S112 366.6 112 376v32l-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0v32c0 9.4 5.5 18 14.1 21.9s18.6 2.4 25.7-3.8l64-56zM288 431.9c0 6.9 3 13.5 8.1 18.1l64 56.4c7.1 6.2 17.1 7.8 25.7 3.9s14.1-12.4 14.1-21.9l0-32.4 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-32c0-9.4-5.5-18-14.1-21.9s-18.6-2.4-25.7 3.8l-64 56c-5.2 4.5-8.2 11.1-8.2 18z"
    ]
};
var $8063e68b12ef6db0$export$348a01df65a66c99 = {
    prefix: "fas",
    iconName: "file-shield",
    icon: [
        576,
        512,
        [],
        "e4f0",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v47l-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"
    ]
};
var $8063e68b12ef6db0$export$3924ab4d3ef9b5ef = {
    prefix: "fas",
    iconName: "user-slash",
    icon: [
        640,
        512,
        [],
        "f506",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c3.9 0 7.6-.7 11-2.1l-261-205.6z"
    ]
};
var $8063e68b12ef6db0$export$8f4567331fb0d3bc = {
    prefix: "fas",
    iconName: "pen",
    icon: [
        512,
        512,
        [
            128394
        ],
        "f304",
        "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"
    ]
};
var $8063e68b12ef6db0$export$5b2f0f631f559d51 = {
    prefix: "fas",
    iconName: "tower-observation",
    icon: [
        512,
        512,
        [],
        "e586",
        "M241.7 3.4c9-4.5 19.6-4.5 28.6 0l160 80c15.8 7.9 22.2 27.1 14.3 42.9C439 137.5 427.7 144 416 144v80c0 17.7-14.3 32-32 32h-4.9l32 192H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H384.5c-.4 0-.8 0-1.1 0H128.6c-.4 0-.8 0-1.1 0H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l32-192H128c-17.7 0-32-14.3-32-32V144c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l160-80zM314.5 448L256 399.2 197.5 448h117zM197.8 256l-4.7 28.3L256 336.8l62.9-52.5L314.2 256H197.8zm-13.9 83.2l-11.2 67L218.5 368l-34.6-28.8zM293.5 368l45.8 38.1-11.2-67L293.5 368zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
    ]
};
var $8063e68b12ef6db0$export$143d0ca7d2200f20 = {
    prefix: "fas",
    iconName: "file-code",
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM265 255l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $8063e68b12ef6db0$export$79046b073b6c584d = {
    prefix: "fas",
    iconName: "signal",
    icon: [
        576,
        512,
        [
            128246,
            "signal-5",
            "signal-perfect"
        ],
        "f012",
        "M544 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM416 96c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM320 224V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zM160 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM64 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$3417071118065933 = $8063e68b12ef6db0$export$79046b073b6c584d;
var $8063e68b12ef6db0$export$1aea50ab3e99cc95 = $8063e68b12ef6db0$export$79046b073b6c584d;
var $8063e68b12ef6db0$export$ce69441578ff2fdb = {
    prefix: "fas",
    iconName: "bus",
    icon: [
        512,
        512,
        [
            128653
        ],
        "f207",
        "M256 0C390.4 0 480 35.2 480 80V96l0 32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32l0 160c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V448H160v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32l0-160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h0V96h0V80C32 35.2 121.6 0 256 0zM96 160v96c0 17.7 14.3 32 32 32H240V128H128c-17.7 0-32 14.3-32 32zM272 288H384c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H272V288zM112 400c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM352 80c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16z"
    ]
};
var $8063e68b12ef6db0$export$742f89ae2f8d6b20 = {
    prefix: "fas",
    iconName: "heart-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e501",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $8063e68b12ef6db0$export$af554427144a7e5c = {
    prefix: "fas",
    iconName: "house-chimney",
    icon: [
        576,
        512,
        [
            63499,
            "home-lg"
        ],
        "e3af",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64 24c0 22.1 17.9 40 40 40h24 32.5c1.4 0 2.8 0 4.2-.1c1.1 .1 2.2 .1 3.3 .1h16c22.1 0 40-17.9 40-40V455.8c.3-2.6 .5-5.3 .5-8.1l-.7-160.2h32z"
    ]
};
var $8063e68b12ef6db0$export$dbab81727ec94698 = $8063e68b12ef6db0$export$af554427144a7e5c;
var $8063e68b12ef6db0$export$703cd98be31ec905 = {
    prefix: "fas",
    iconName: "window-maximize",
    icon: [
        512,
        512,
        [
            128470
        ],
        "f2d0",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$e5f78e87efbb0248 = {
    prefix: "fas",
    iconName: "face-frown",
    icon: [
        512,
        512,
        [
            9785,
            "frown"
        ],
        "f119",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM208.4 208c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm128 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$43b7108508aecc5f = $8063e68b12ef6db0$export$e5f78e87efbb0248;
var $8063e68b12ef6db0$export$8767bafb19515ee4 = {
    prefix: "fas",
    iconName: "prescription",
    icon: [
        448,
        512,
        [],
        "f5b1",
        "M32 0C14.3 0 0 14.3 0 32V192v96c0 17.7 14.3 32 32 32s32-14.3 32-32V224h50.7l128 128L137.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3 393.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352 438.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112C288 50.1 237.9 0 176 0H32zM176 160H64V64H176c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $8063e68b12ef6db0$export$78edc9b98453b6f7 = {
    prefix: "fas",
    iconName: "shop",
    icon: [
        640,
        512,
        [
            "store-alt"
        ],
        "f54f",
        "M36.8 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 224H320V384H128V224H64zm448 0V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224H512z"
    ]
};
var $8063e68b12ef6db0$export$1f1871dab9cec9d8 = $8063e68b12ef6db0$export$78edc9b98453b6f7;
var $8063e68b12ef6db0$export$f62f2879ccaea13f = {
    prefix: "fas",
    iconName: "floppy-disk",
    icon: [
        448,
        512,
        [
            128190,
            128426,
            "save"
        ],
        "f0c7",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z"
    ]
};
var $8063e68b12ef6db0$export$1aaa83ff70706e1e = $8063e68b12ef6db0$export$f62f2879ccaea13f;
var $8063e68b12ef6db0$export$ee4b92e89fe0dfaf = {
    prefix: "fas",
    iconName: "vihara",
    icon: [
        640,
        512,
        [],
        "f6a7",
        "M281 22L305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23 6.3c1.8 .5 3.6 1.1 5.2 2c3.2 1.7 5.9 4 8.1 6.8c3.8 4.9 5.6 11.3 4.7 17.8c-.4 2.8-1.2 5.4-2.5 7.8c-1.7 3.2-4 5.9-6.8 8.1c-4.3 3.2-9.6 5.1-15.1 4.9H480v56.1l6.4 5.1 5.2 4.1c21.1 16.7 45 29.6 70.5 38.1l28.9 9.6c1.6 .5 3.2 1.2 4.6 2c3.1 1.7 5.8 4.1 7.8 6.9s3.5 6.1 4.1 9.6c.5 2.7 .6 5.5 .1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-6.9 7.8s-6.1 3.5-9.6 4.1c-1.6 .3-3.3 .4-5 .4H544v65.9c20.5 22.8 47.4 39.2 77.4 46.7C632 403 640 412.6 640 424c0 13.3-10.7 24-24 24H576v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H24c-13.3 0-24-10.7-24-24c0-11.4 8-21 18.6-23.4c30-7.6 56.9-23.9 77.4-46.7V288H56.6c-1.7 0-3.4-.1-5-.4c-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6 .1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l28.9-9.6c25.5-8.5 49.4-21.4 70.5-38.1l5.2-4.1 6.4-5.1V176 128h-7.5c-5.5 .1-10.8-1.7-15.1-4.9c-2.8-2.1-5.1-4.8-6.8-8.1c-1.2-2.4-2.1-5-2.5-7.8c-.9-6.5 .9-12.8 4.7-17.8c2.1-2.8 4.8-5.1 8.1-6.8c1.6-.8 3.4-1.5 5.2-2l23-6.3C209.2 63.5 247 45.8 281 22zM416 128H320 224v64h72 48 72V128zM160 288v64H296h24 24H480V288H344 320h0H296 160z"
    ]
};
var $8063e68b12ef6db0$export$4d10bcc8d068f454 = {
    prefix: "fas",
    iconName: "scale-unbalanced",
    icon: [
        640,
        512,
        [
            "balance-scale-left"
        ],
        "f515",
        "M522.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S518.6-3.9 501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L117.9 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2V480c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V153.3c21-9.2 37.2-27 44.2-49l125.9-42zm-396.3 211c.4-.8 1.3-1.3 2.2-1.3s1.7 .5 2.2 1.3L204.9 416H51.1l74.7-142.7zM128 224c-18.8 0-36 10.4-44.7 27L5.5 399.5c-3.1 5.8-6.1 14-5.5 23.8c.7 12.1 4.8 35.2 24.8 55.1C45.1 498.6 77.8 512 128 512s82.9-13.4 103.2-33.5c20-20 24.2-43 24.8-55.1c.6-9.8-2.5-18-5.5-23.8L172.7 251c-8.7-16.6-25.9-27-44.7-27zm384-80c.9 0 1.7 .5 2.2 1.3L588.9 288H435.1l74.7-142.7c.4-.8 1.3-1.3 2.2-1.3zm-44.7-21L389.5 271.5c-3.1 5.8-6.1 14-5.5 23.8c.7 12.1 4.8 35.2 24.8 55.1C429.1 370.6 461.8 384 512 384s82.9-13.4 103.2-33.5c20-20 24.2-43 24.8-55.1c.6-9.8-2.5-18-5.5-23.8L556.7 123C548 106.4 530.8 96 512 96s-36 10.4-44.7 27z"
    ]
};
var $8063e68b12ef6db0$export$786cb0c775487f19 = $8063e68b12ef6db0$export$4d10bcc8d068f454;
var $8063e68b12ef6db0$export$f9dd5b1410e95035 = {
    prefix: "fas",
    iconName: "sort-up",
    icon: [
        320,
        512,
        [
            "sort-asc"
        ],
        "f0de",
        "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
};
var $8063e68b12ef6db0$export$e4c8c924b1cc43a7 = $8063e68b12ef6db0$export$f9dd5b1410e95035;
var $8063e68b12ef6db0$export$63ffcb3d4e94cb92 = {
    prefix: "fas",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [
            128172,
            62075,
            "commenting"
        ],
        "f4ad",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm160-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$49ee382a2425e89c = $8063e68b12ef6db0$export$63ffcb3d4e94cb92;
var $8063e68b12ef6db0$export$77a38850ff8b0407 = {
    prefix: "fas",
    iconName: "plant-wilt",
    icon: [
        512,
        512,
        [],
        "e5aa",
        "M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56v13c-29.3 10-48 34.5-48 70.1c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V120C464 53.7 410.3 0 344 0S224 53.7 224 120v21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120v13c-29.3 10-48 34.5-48 70.1C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V248c0-30.9 25.1-56 56-56s56 25.1 56 56v32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V280 248 120z"
    ]
};
var $8063e68b12ef6db0$export$f214f827e0023247 = {
    prefix: "fas",
    iconName: "diamond",
    icon: [
        512,
        512,
        [
            9830
        ],
        "f219",
        "M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"
    ]
};
var $8063e68b12ef6db0$export$5d53da7627754bc6 = {
    prefix: "fas",
    iconName: "face-grin-squint",
    icon: [
        512,
        512,
        [
            128518,
            "grin-squint"
        ],
        "f585",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM383.8 317.8c12.3-3.7 24.3 7 19.2 18.7c-24.5 56.9-81.1 96.7-147 96.7s-122.5-39.8-147-96.7c-5.1-11.8 6.9-22.4 19.2-18.7C166.7 329.4 210.1 336 256 336s89.3-6.6 127.8-18.2zM133.5 146.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
    ]
};
var $8063e68b12ef6db0$export$243ae757907b1580 = $8063e68b12ef6db0$export$5d53da7627754bc6;
var $8063e68b12ef6db0$export$61a67f5f8ab39be = {
    prefix: "fas",
    iconName: "hand-holding-dollar",
    icon: [
        576,
        512,
        [
            "hand-holding-usd"
        ],
        "f4c0",
        "M312 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $8063e68b12ef6db0$export$47d27bc305b59690 = $8063e68b12ef6db0$export$61a67f5f8ab39be;
var $8063e68b12ef6db0$export$b0babe4230e35ebe = {
    prefix: "fas",
    iconName: "bacterium",
    icon: [
        576,
        512,
        [],
        "e05a",
        "M455.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L228 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L135 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .3 0 .1c0 0 0 .1 39.2 3.7l0 0-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2c-12.7 3.6-20.1 16.9-16.5 29.7s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L247 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L403 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L471 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zm-331 332.7l0 0L176 368l-51.9-4.7zM240 320c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zm32-88c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $8063e68b12ef6db0$export$d97ff927c450c87f = {
    prefix: "fas",
    iconName: "hand-pointer",
    icon: [
        448,
        512,
        [],
        "f25a",
        "M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40V188.2c8.5-7.6 19.7-12.2 32-12.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v32 64c0 70.7-57.3 128-128 128l-16 0H240l-.1 0h-5.2c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7V40zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"
    ]
};
var $8063e68b12ef6db0$export$48d1206500db2e9d = {
    prefix: "fas",
    iconName: "drum-steelpan",
    icon: [
        576,
        512,
        [],
        "f56a",
        "M288 32c159.1 0 288 48 288 128V352c0 80-128.9 128-288 128S0 432 0 352V160C0 80 128.9 32 288 32zM528 160c0-9.9-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5c47.1-19.9 55-39.9 55-49.8zM349.2 237.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4C56 130.1 48 150.1 48 160s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8C224.5 87 224 91.5 224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z"
    ]
};
var $8063e68b12ef6db0$export$c578e919f2c5c135 = {
    prefix: "fas",
    iconName: "hand-scissors",
    icon: [
        512,
        512,
        [],
        "f257",
        "M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40l180.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 25.3 19.5 46 44.3 47.9c-7.7 8.5-12.3 19.8-12.3 32.1c0 26.5 21.5 48 48 48l32 0 64 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L336 64c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9l0 .1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208 40 208z"
    ]
};
var $8063e68b12ef6db0$export$a96374faedb12593 = {
    prefix: "fas",
    iconName: "hands-praying",
    icon: [
        640,
        512,
        [
            "praying-hands"
        ],
        "f684",
        "M351.2 4.8c3.2-2 6.6-3.3 10-4.1c4.7-1 9.6-.9 14.1 .1c7.7 1.8 14.8 6.5 19.4 13.6L514.6 194.2c8.8 13.1 13.4 28.6 13.4 44.4v73.5c0 6.9 4.4 13 10.9 15.2l79.2 26.4C631.2 358 640 370.2 640 384v96c0 9.9-4.6 19.3-12.5 25.4s-18.1 8.1-27.7 5.5L431 465.9c-56-14.9-95-65.7-95-123.7V224c0-17.7 14.3-32 32-32s32 14.3 32 32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V219.1c0-7-1.8-13.8-5.3-19.8L340.3 48.1c-1.7-3-2.9-6.1-3.6-9.3c-1-4.7-1-9.6 .1-14.1c1.9-8 6.8-15.2 14.3-19.9zm-62.4 0c7.5 4.6 12.4 11.9 14.3 19.9c1.1 4.6 1.2 9.4 .1 14.1c-.7 3.2-1.9 6.3-3.6 9.3L213.3 199.3c-3.5 6-5.3 12.9-5.3 19.8V304c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32V342.3c0 58-39 108.7-95 123.7l-168.7 45c-9.6 2.6-19.9 .5-27.7-5.5S0 490 0 480V384c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2V238.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6c4.6-1.1 9.4-1.2 14.1-.1c3.5 .8 6.9 2.1 10 4.1z"
    ]
};
var $8063e68b12ef6db0$export$95e08e91b0929943 = $8063e68b12ef6db0$export$a96374faedb12593;
var $8063e68b12ef6db0$export$9c58ddc4b3356f98 = {
    prefix: "fas",
    iconName: "arrow-rotate-right",
    icon: [
        512,
        512,
        [
            8635,
            "arrow-right-rotate",
            "arrow-rotate-forward",
            "redo"
        ],
        "f01e",
        "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"
    ]
};
var $8063e68b12ef6db0$export$ffa1245982c1b28b = $8063e68b12ef6db0$export$9c58ddc4b3356f98;
var $8063e68b12ef6db0$export$89c59b5f47067f4c = $8063e68b12ef6db0$export$9c58ddc4b3356f98;
var $8063e68b12ef6db0$export$3d9f98aa1c24c776 = $8063e68b12ef6db0$export$9c58ddc4b3356f98;
var $8063e68b12ef6db0$export$ae3a453550dec95 = {
    prefix: "fas",
    iconName: "biohazard",
    icon: [
        576,
        512,
        [
            9763
        ],
        "f780",
        "M173.2 0c-1.8 0-3.5 .7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73c-22 2.4-43.8 9.1-64.2 20.5C37.9 232.8 13.3 262.4 .4 296c-.7 1.7-.5 3.7 .5 5.2c2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6c1 1.6 2.6 2.7 4.5 3c36.5 5.9 75.2 .1 109.7-19.2c20.4-11.4 37.4-26.5 50.5-43.8c13.1 17.3 30.1 32.4 50.5 43.8c34.5 19.3 73.3 25.2 109.7 19.2c1.9-.3 3.5-1.4 4.5-3c2.2-3.7 .1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3c1-1.6 1.1-3.5 .5-5.2c-12.9-33.6-37.5-63.2-72.1-82.5c-20.4-11.4-42.2-18.1-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118c-1.3-1.3-3-2-4.8-2c-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM336 272c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM181.7 417.6c6.3-11.8 9.8-25.1 8.6-39.8c-19.5-18-34-41.4-41.2-67.8c-12.5-8.1-26.2-11.8-40-12.4c-9-.4-18.1 .6-27.1 2.7c7.8 57.1 38.7 106.8 82.9 139.4c6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5c2 8.3 5 16.2 9 23.5c6.8 12.4 16.7 23.1 30.1 30.3c13.3-4.1 27.5-6.3 42.2-6.3s28.8 2.2 42.2 6.3c13.4-7.2 23.3-17.9 30.1-30.3c4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zM426.9 310c-7.2 26.4-21.7 49.7-41.2 67.8c-1.2 14.7 2.2 28.1 8.6 39.8c4.3 8 10 15.4 16.8 22.1c44.3-32.6 75.2-82.3 82.9-139.4c-9-2.2-18.1-3.1-27.1-2.7c-13.8 .6-27.5 4.4-40 12.4z"
    ]
};
var $8063e68b12ef6db0$export$14e1096ad1719098 = {
    prefix: "fas",
    iconName: "location-crosshairs",
    icon: [
        512,
        512,
        [
            "location"
        ],
        "f601",
        "M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm128 80c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $8063e68b12ef6db0$export$45e012c32174eb5d = $8063e68b12ef6db0$export$14e1096ad1719098;
var $8063e68b12ef6db0$export$2f8a28204bb4b86f = {
    prefix: "fas",
    iconName: "mars-double",
    icon: [
        640,
        512,
        [
            9891
        ],
        "f227",
        "M312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312zm88 48h0v0l0 0zM288 304c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112zm80 176c97.2 0 176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L599 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H504c-9.7 0-18.5 5.8-22.2 14.8c-1.2 2.9-1.8 6-1.8 9l0 .2v.2c0 6.2 2.5 12.2 7 16.8l33.4 33.4L480 146.7V168c0 22.6-13.6 43.1-34.6 51.7c-.8 .3-1.7 .7-2.5 1C465.7 241.2 480 270.9 480 304c0 61.9-50.1 112-112 112c-5.4 0-10.8-.4-16-1.1c-12.9 20.4-29.1 38.3-48.1 53.1c19.8 7.8 41.4 12 64 12z"
    ]
};
var $8063e68b12ef6db0$export$f31a37ecbfd4e707 = {
    prefix: "fas",
    iconName: "child-dress",
    icon: [
        320,
        512,
        [],
        "e59c",
        "M224 64c0-35.3-28.7-64-64-64S96 28.7 96 64s28.7 64 64 64s64-28.7 64-64zM88 400v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h16v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h17.8c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9C51.6 389.3 59.3 400 70.2 400H88z"
    ]
};
var $8063e68b12ef6db0$export$6ea1decf8bb3513d = {
    prefix: "fas",
    iconName: "users-between-lines",
    icon: [
        640,
        512,
        [],
        "e591",
        "M0 24C0 10.7 10.7 0 24 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zM0 488c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM211.2 160c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM32 320c0-35.3 28.7-64 64-64h96c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32zm461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H493.6zM391.2 290.4c32.1 7.4 58.1 30.9 68.9 61.6c3.5 10 5.5 20.8 5.5 32c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c10.5-29.7 35.3-52.8 66.1-60.9c7.8-2.1 16-3.1 24.5-3.1h96c7.4 0 14.7 .8 21.6 2.4zM563.2 160c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM321.6 256c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $8063e68b12ef6db0$export$895159d10626af74 = {
    prefix: "fas",
    iconName: "lungs-virus",
    icon: [
        640,
        512,
        [],
        "e067",
        "M320 0c17.7 0 32 14.3 32 32V156.2c-8.5-7.6-19.7-12.2-32-12.2s-23.5 4.6-32 12.2V32c0-17.7 14.3-32 32-32zM444.5 195.5c-16.4-16.4-41.8-18.5-60.5-6.1V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c18.7-18.7 18.7-49.1 0-67.9c-1.1-1.1-1.4-2-1.5-2.5c-.1-.8-.1-1.8 .4-2.9s1.2-1.9 1.8-2.3c.5-.3 1.3-.8 2.9-.8c26.5 0 48-21.5 48-48s-21.5-48-48-48c-1.6 0-2.4-.4-2.9-.8c-.6-.4-1.3-1.2-1.8-2.3s-.5-2.2-.4-2.9c.1-.6 .4-1.4 1.5-2.5c18.7-18.7 18.7-49.1 0-67.9zM421.8 421.8c-6.2 6.2-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6zM183.3 491.2l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v24.1c-18.6-12.4-44-10.3-60.5 6.1c-18.7 18.7-18.7 49.1 0 67.9c1.1 1.1 1.4 2 1.5 2.5c.1 .8 .1 1.8-.4 2.9s-1.2 1.9-1.8 2.3c-.5 .3-1.3 .8-2.9 .8c-26.5 0-48 21.5-48 48s21.5 48 48 48c1.6 0 2.4 .4 2.9 .8c.6 .4 1.3 1.2 1.8 2.3s.5 2.2 .4 2.9c-.1 .6-.4 1.4-1.5 2.5c-18.7 18.7-18.7 49.1 0 67.9c10.7 10.7 25.3 15.3 39.2 13.8c-12.8 15.9-30.6 27.7-51.5 32.9zM296 320c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm72 32c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $8063e68b12ef6db0$export$8ac6d81a3d5b40a1 = {
    prefix: "fas",
    iconName: "face-grin-tears",
    icon: [
        640,
        512,
        [
            128514,
            "grin-tears"
        ],
        "f588",
        "M548.6 371.4C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c3.6-8.8 6.5-18.4 8.8-27.5c4.6-18.2 7.7-37 9.3-48.2c3.9-26.5-18.8-49.2-45.2-45.4c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-26.5-3.9-49.2 18.8-45.2 45.4c1.6 11.3 4.6 30 9.3 48.2c2.3 9.1 5.2 18.8 8.8 27.5c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3zM107 254.1c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9zm454.5 87.1c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zm-90.1-9.7c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.4 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM281.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"
    ]
};
var $8063e68b12ef6db0$export$b2f7512221512b5b = $8063e68b12ef6db0$export$8ac6d81a3d5b40a1;
var $8063e68b12ef6db0$export$ddab067855cf34cb = {
    prefix: "fas",
    iconName: "phone",
    icon: [
        512,
        512,
        [
            128222,
            128379
        ],
        "f095",
        "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
    ]
};
var $8063e68b12ef6db0$export$3c70ffe5660af060 = {
    prefix: "fas",
    iconName: "calendar-xmark",
    icon: [
        448,
        512,
        [
            "calendar-times"
        ],
        "f273",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM305 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"
    ]
};
var $8063e68b12ef6db0$export$99b20d7352fbcf08 = $8063e68b12ef6db0$export$3c70ffe5660af060;
var $8063e68b12ef6db0$export$84a2f9476730c40e = {
    prefix: "fas",
    iconName: "child-reaching",
    icon: [
        384,
        512,
        [],
        "e59d",
        "M256 64c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM152.9 169.3c-23.7-8.4-44.5-24.3-58.8-45.8L74.6 94.2C64.8 79.5 45 75.6 30.2 85.4s-18.7 29.7-8.9 44.4L40.9 159c18.1 27.1 42.8 48.4 71.1 62.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384h32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V221.6c29.1-14.2 54.4-36.2 72.7-64.2l18.2-27.9c9.6-14.8 5.4-34.6-9.4-44.3s-34.6-5.5-44.3 9.4L291 122.4c-21.8 33.4-58.9 53.6-98.8 53.6c-12.6 0-24.9-2-36.6-5.8c-.9-.3-1.8-.7-2.7-.9z"
    ]
};
var $8063e68b12ef6db0$export$5b64b916710da7c7 = {
    prefix: "fas",
    iconName: "head-side-virus",
    icon: [
        512,
        512,
        [],
        "e064",
        "M0 224.2C0 100.6 100.2 0 224 0h32c95.2 0 174.2 69.3 189.4 160.1c2.2 13 6.7 25.7 15 36.1l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM240 80c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C161.5 168.1 145 208 112 208c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C184.1 302.5 224 319 224 352c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C318.5 279.9 335 240 368 240c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C295.9 145.5 256 129 256 96c0-8.8-7.2-16-16-16zM216 224c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm72 32c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$f504a6909b677146 = {
    prefix: "fas",
    iconName: "user-gear",
    icon: [
        640,
        512,
        [
            "user-cog"
        ],
        "f4fe",
        "M224 256c-70.7 0-128-57.3-128-128S153.3 0 224 0s128 57.3 128 128s-57.3 128-128 128zm-45.7 48h91.4c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8V454.8c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9V218.2zm92.1 133.5c0-26.5-21.5-48-48.1-48s-48.1 21.5-48.1 48s21.5 48 48.1 48s48.1-21.5 48.1-48z"
    ]
};
var $8063e68b12ef6db0$export$474108c2b86e730e = $8063e68b12ef6db0$export$f504a6909b677146;
var $8063e68b12ef6db0$export$bbbff45e04f4abab = {
    prefix: "fas",
    iconName: "arrow-up-1-9",
    icon: [
        576,
        512,
        [
            "sort-numeric-up"
        ],
        "f163",
        "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM352 64c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V96H384c-17.7 0-32-14.3-32-32zm93.7 300.9c10.8-5.1 18.3-16.2 18.3-28.9c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c4.9 0 9.6-1.1 13.7-3.1zm-40.7 54.9C369.6 408.4 344 375.2 344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
    ]
};
var $8063e68b12ef6db0$export$d213a3ba3cabed48 = $8063e68b12ef6db0$export$bbbff45e04f4abab;
var $8063e68b12ef6db0$export$2c79e1a422528bba = {
    prefix: "fas",
    iconName: "door-closed",
    icon: [
        576,
        512,
        [
            128682
        ],
        "f52a",
        "M96 64c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V448h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 144 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96V64zM384 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$bea811bbf570f05a = {
    prefix: "fas",
    iconName: "shield-virus",
    icon: [
        512,
        512,
        [],
        "e06c",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16zM232 256c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm72 32c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $8063e68b12ef6db0$export$3397c7b4679acccc = {
    prefix: "fas",
    iconName: "dice-six",
    icon: [
        448,
        512,
        [
            9861
        ],
        "f526",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM128 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm32 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM320 192c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm32 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM320 384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$f3858ce1b3218e2 = {
    prefix: "fas",
    iconName: "mosquito-net",
    icon: [
        640,
        512,
        [],
        "e52c",
        "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5L192 380.2l0-44.2c0-4.2 1.7-8.3 4.7-11.3L256 265.4V242.2L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2 .9 12.2l-12.5 37.6L256 160.5V137.9c0-14.9 10.1-27.3 23.8-31V63.7c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2V107c13.7 3.6 23.8 16.1 23.8 31v22.6l45.4-37.8L352.8 85.1c-1.3-4-1-8.4 .9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2 .1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4c-2.7 2.6-5.2 5.4-7.3 8.6c-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5c-21.7 0-40 14.3-45.9 34.1c-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35v23.1l32.4 32.4c-.3 2-.4 4.1-.4 6.2c0 16.7 8.5 31.4 21.5 40c-4 2.6-7.5 5.9-10.6 9.5L320 310.6v50c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50l-32 32 0 41.4c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM512 256c8.8 0 16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H528v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H448v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V400H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V320H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16zm16 112h48V320H528v48zm0 80h48V400H528v48zM448 320v48h48V320H448zm0 80v48h48V400H448z"
    ]
};
var $8063e68b12ef6db0$export$154e99cb34841765 = {
    prefix: "fas",
    iconName: "bridge-water",
    icon: [
        576,
        512,
        [],
        "e4ce",
        "M0 96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32v35.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6V352.5c-12.9 0-25.8 3.9-36.8 11.7c-18 12.4-40.1 20.3-59.2 20.3h0l0-.5V256c0-53-43-96-96-96s-96 43-96 96V384l0 .5c-19 0-41.2-7.9-59.1-20.3c-11.1-7.8-24-11.7-36.9-11.7V227.6C96 190.2 65.8 160 28.4 160C12.7 160 0 147.3 0 131.6V96zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $8063e68b12ef6db0$export$2337c975289bdd84 = {
    prefix: "fas",
    iconName: "person-booth",
    icon: [
        576,
        512,
        [],
        "f756",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64V32zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM224 512c17.7 0 32-14.3 32-32V320H192V480c0 17.7 14.3 32 32 32zM320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6L288.6 409.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4c17.7 0 32-14.3 32-32c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM112 80c0-26.5-21.5-48-48-48S16 53.5 16 80s21.5 48 48 48s48-21.5 48-48zm0 261.3V269.3l4.7 4.7c9 9 21.2 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H157.3l-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6v55.7l0 .9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384l32 42.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V421.3c0-10.4-3.4-20.5-9.6-28.8L112 341.3z"
    ]
};
var $8063e68b12ef6db0$export$d8724cf433389700 = {
    prefix: "fas",
    iconName: "text-width",
    icon: [
        448,
        512,
        [],
        "f035",
        "M32 32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96H192l0 128H176c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256l0-128H384v32c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H224 32zM9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V416H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H128V320c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z"
    ]
};
var $8063e68b12ef6db0$export$7daa48199dcb2ad1 = {
    prefix: "fas",
    iconName: "hat-wizard",
    icon: [
        512,
        512,
        [],
        "f6e8",
        "M64 416L168.6 180.7c15.3-34.4 40.3-63.5 72-83.7l146.9-94c3-1.9 6.5-2.9 10-2.9C407.7 0 416 8.3 416 18.6v1.6c0 2.6-.5 5.1-1.4 7.5L354.8 176.9c-1.9 4.7-2.8 9.7-2.8 14.7c0 5.5 1.2 11 3.4 16.1L448 416H240.9l11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4C237 276.4 230.9 272 224 272s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C148.4 339 144 345.1 144 352s4.4 13 10.9 15.2l40.4 13.5L207.1 416H64zM279.6 141.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2zM32 448H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$8bdfe14ac72a8b17 = {
    prefix: "fas",
    iconName: "pen-fancy",
    icon: [
        512,
        512,
        [
            128395,
            10002
        ],
        "f5ac",
        "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64L193 234.3 373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.4 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"
    ]
};
var $8063e68b12ef6db0$export$f4d483fca19a4604 = {
    prefix: "fas",
    iconName: "person-digging",
    icon: [
        576,
        512,
        [
            "digging"
        ],
        "f85e",
        "M304 64c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM9.8 214.8c5.1-12.2 19.1-18 31.4-12.9L60.7 210l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7 79.3 33.1 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4zm82.8 91.8l112 48c11.8 5 19.4 16.6 19.4 29.4v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V405.1l-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33 32 13.7z"
    ]
};
var $8063e68b12ef6db0$export$7bd93e3343bd5671 = $8063e68b12ef6db0$export$f4d483fca19a4604;
var $8063e68b12ef6db0$export$ed8c149a0ea54bb4 = {
    prefix: "fas",
    iconName: "trash",
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"
    ]
};
var $8063e68b12ef6db0$export$f3a0a4e6723a86d4 = {
    prefix: "fas",
    iconName: "gauge-simple",
    icon: [
        512,
        512,
        [
            "gauge-simple-med",
            "tachometer-average"
        ],
        "f629",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM320 352c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $8063e68b12ef6db0$export$ba8c12ff7cfa2521 = $8063e68b12ef6db0$export$f3a0a4e6723a86d4;
var $8063e68b12ef6db0$export$94fcfd6f6335431b = $8063e68b12ef6db0$export$f3a0a4e6723a86d4;
var $8063e68b12ef6db0$export$6feb44fec53ba30d = {
    prefix: "fas",
    iconName: "book-medical",
    icon: [
        448,
        512,
        [],
        "f7e6",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM208 112v48H160c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h48c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16z"
    ]
};
var $8063e68b12ef6db0$export$dd0ede1713d2d2f9 = {
    prefix: "fas",
    iconName: "poo",
    icon: [
        512,
        512,
        [
            128169
        ],
        "f2fe",
        "M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80H160c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48H104c-39.8 0-72 32.2-72 72c0 23.2 11 43.8 28 57c-34.1 5.7-60 35.3-60 71c0 39.8 32.2 72 72 72H440c39.8 0 72-32.2 72-72c0-35.7-25.9-65.3-60-71c17-13.2 28-33.8 28-57c0-39.8-32.2-72-72-72H394.3c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64h-5.5c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1zM192 320c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm160-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm0 108.3c0 2.4-.7 4.8-2.2 6.7c-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7c0-6.8 5.5-12.3 12.3-12.3H339.7c6.8 0 12.3 5.5 12.3 12.3z"
    ]
};
var $8063e68b12ef6db0$export$54e3a80c9875b74c = {
    prefix: "fas",
    iconName: "quote-right",
    icon: [
        448,
        512,
        [
            8221,
            "quote-right-alt"
        ],
        "f10e",
        "M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72zm-256 0c0 66.3-53.7 120-120 120H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72z"
    ]
};
var $8063e68b12ef6db0$export$dd692f2e88bd4b1a = $8063e68b12ef6db0$export$54e3a80c9875b74c;
var $8063e68b12ef6db0$export$312f2c01c6fedca8 = {
    prefix: "fas",
    iconName: "shirt",
    icon: [
        640,
        512,
        [
            128085,
            "t-shirt",
            "tshirt"
        ],
        "f553",
        "M211.8 0c7.8 0 14.3 5.7 16.7 13.2C240.8 51.9 277.1 80 320 80s79.2-28.1 91.5-66.8C413.9 5.7 420.4 0 428.2 0h12.6c22.5 0 44.2 7.9 61.5 22.3L628.5 127.4c6.6 5.5 10.7 13.5 11.4 22.1s-2.1 17.1-7.8 23.6l-56 64c-11.4 13.1-31.2 14.6-44.6 3.5L480 197.7V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V197.7l-51.5 42.9c-13.3 11.1-33.1 9.6-44.6-3.5l-56-64c-5.7-6.5-8.5-15-7.8-23.6s4.8-16.6 11.4-22.1L137.7 22.3C155 7.9 176.7 0 199.2 0h12.6z"
    ]
};
var $8063e68b12ef6db0$export$144e5f8bc4d705a6 = $8063e68b12ef6db0$export$312f2c01c6fedca8;
var $8063e68b12ef6db0$export$36edce3ba87c2b17 = $8063e68b12ef6db0$export$312f2c01c6fedca8;
var $8063e68b12ef6db0$export$30523a9441a31e97 = {
    prefix: "fas",
    iconName: "cubes",
    icon: [
        576,
        512,
        [],
        "f1b3",
        "M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5V204.7c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7V413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3V294.7c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3V92.5c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2V152.6L392 121v89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4V354.8L256 323.2v95.9l-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1V354.8L528 323.2v90.7c0 3.2-1.9 6-4.8 7.3z"
    ]
};
var $8063e68b12ef6db0$export$89fa217ec5503ac9 = {
    prefix: "fas",
    iconName: "divide",
    icon: [
        448,
        512,
        [
            10135,
            247
        ],
        "f529",
        "M272 96c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm0 320c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM400 288c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H400z"
    ]
};
var $8063e68b12ef6db0$export$c04e864469c1d117 = {
    prefix: "fas",
    iconName: "tenge-sign",
    icon: [
        384,
        512,
        [
            8376,
            "tenge"
        ],
        "f7d7",
        "M0 64C0 46.3 14.3 32 32 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM0 192c0-17.7 14.3-32 32-32H192 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32z"
    ]
};
var $8063e68b12ef6db0$export$af6ebee83047b793 = $8063e68b12ef6db0$export$c04e864469c1d117;
var $8063e68b12ef6db0$export$ad02dd8ca5816958 = {
    prefix: "fas",
    iconName: "headphones",
    icon: [
        512,
        512,
        [
            127911
        ],
        "f025",
        "M256 80C149.9 80 62.4 159.4 49.6 262c9.4-3.8 19.6-6 30.4-6c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48c-44.2 0-80-35.8-80-80V384 336 288C0 146.6 114.6 32 256 32s256 114.6 256 256v48 48 16c0 44.2-35.8 80-80 80c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48c10.8 0 21 2.1 30.4 6C449.6 159.4 362.1 80 256 80z"
    ]
};
var $8063e68b12ef6db0$export$96891bbcda1dbb7b = {
    prefix: "fas",
    iconName: "hands-holding",
    icon: [
        640,
        512,
        [],
        "f4c2",
        "M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z"
    ]
};
var $8063e68b12ef6db0$export$765c446e974b5e59 = {
    prefix: "fas",
    iconName: "hands-clapping",
    icon: [
        576,
        512,
        [],
        "e1a8",
        "M368 16V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm-98.7 7.1l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4zM167 119c9.4-9.4 24.6-9.4 33.9 0L324.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L39 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L87 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zM465.1 484.9c-24.2 14.5-50.9 22.1-77.7 23.1c48.1-39.6 76.6-99 76.6-162.4l0-98.1c8.2-.1 16-6.4 16-16V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4zM456.9 18.7c7.4 4.9 9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48c4.9-7.4 14.8-9.3 22.2-4.4z"
    ]
};
var $8063e68b12ef6db0$export$929518bb4b66a588 = {
    prefix: "fas",
    iconName: "republican",
    icon: [
        640,
        512,
        [],
        "f75e",
        "M0 192C0 103.6 71.6 32 160 32H384c88.4 0 160 71.6 160 160v64H0V192zm415.9-64c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L466 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-138.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L322 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM127.9 128c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L178 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm.1 160H320h96 32 64 32v32 80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80s-80-35.8-80-80V352H448v32 64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V384H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384 288H128z"
    ]
};
var $8063e68b12ef6db0$export$b7fac681e7d09400 = {
    prefix: "fas",
    iconName: "arrow-left",
    icon: [
        448,
        512,
        [
            8592
        ],
        "f060",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
var $8063e68b12ef6db0$export$16c9e0374c346c6e = {
    prefix: "fas",
    iconName: "person-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e543",
        "M208 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM152 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm59.3-180.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var $8063e68b12ef6db0$export$8e90575265a56cfc = {
    prefix: "fas",
    iconName: "ruler",
    icon: [
        512,
        512,
        [
            128207
        ],
        "f545",
        "M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0L17.9 401.9c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 50.7-50.7c18.7-18.7 49.1-18.7 67.9 0l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9L177.9 494.1z"
    ]
};
var $8063e68b12ef6db0$export$e490f662af4d1c78 = {
    prefix: "fas",
    iconName: "align-left",
    icon: [
        448,
        512,
        [],
        "f036",
        "M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H256c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$64bfd48ed353c031 = {
    prefix: "fas",
    iconName: "dice-d6",
    icon: [
        448,
        512,
        [],
        "f6d1",
        "M216.3 2c4.8-2.6 10.5-2.6 15.3 0L422.3 106c5.1 2.8 8.3 8.2 8.3 14s-3.2 11.2-8.3 14L231.7 238c-4.8 2.6-10.5 2.6-15.3 0L25.7 134c-5.1-2.8-8.3-8.2-8.3-14s3.2-11.2 8.3-14L216.3 2zM23.7 170l176 96c5.1 2.8 8.3 8.2 8.3 14V496c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8 .3L8.3 414C3.2 411.2 0 405.9 0 400V184c0-5.6 3-10.9 7.8-13.8s10.9-3 15.8-.3zm400.7 0c5-2.7 11-2.6 15.8 .3s7.8 8.1 7.8 13.8V400c0 5.9-3.2 11.2-8.3 14l-176 96c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8V280c0-5.9 3.2-11.2 8.3-14l176-96z"
    ]
};
var $8063e68b12ef6db0$export$5fbcef35138741a5 = {
    prefix: "fas",
    iconName: "restroom",
    icon: [
        640,
        512,
        [],
        "f7bd",
        "M176 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM120 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V325.2c-8.1 9.2-21.1 13.2-33.5 9.4c-16.9-5.3-26.3-23.2-21-40.1l30.9-99.1C44.9 155.3 82 128 124 128h8c42 0 79.1 27.3 91.6 67.4l30.9 99.1c5.3 16.9-4.1 34.8-21 40.1c-12.4 3.9-25.4-.2-33.5-9.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H120zM320 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM560 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM440 480V384H422.2c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5c-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2C428.4 156.9 467.6 128 512 128s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1c-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1H584v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H504v96c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var $8063e68b12ef6db0$export$bbf24078bd1f73e6 = {
    prefix: "fas",
    iconName: "j",
    icon: [
        320,
        512,
        [
            106
        ],
        "4a",
        "M288 32c17.7 0 32 14.3 32 32V320c0 88.4-71.6 160-160 160S0 408.4 0 320V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 53 43 96 96 96s96-43 96-96V64c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$72b785dcfe44c69b = {
    prefix: "fas",
    iconName: "users-viewfinder",
    icon: [
        640,
        512,
        [],
        "e595",
        "M48 48h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H32C14.3 0 0 14.3 0 32V136c0 13.3 10.7 24 24 24s24-10.7 24-24V48zM175.8 224c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-80-32c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM504 48h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V32c0-17.7-14.3-32-32-32H504c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464V376c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 17.7 14.3 32 32 32H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H48zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H608c17.7 0 32-14.3 32-32V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H504z"
    ]
};
var $8063e68b12ef6db0$export$b44eb38345c6a964 = {
    prefix: "fas",
    iconName: "file-video",
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V288zM300.9 397.9L256 368V304l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"
    ]
};
var $8063e68b12ef6db0$export$c1a3ba061b4f60c4 = {
    prefix: "fas",
    iconName: "up-right-from-square",
    icon: [
        448,
        512,
        [
            "external-link-alt"
        ],
        "f35d",
        "M288 32c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L306.7 128 169.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L352 173.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V64c0-17.7-14.3-32-32-32H288zM80 64C35.8 64 0 99.8 0 144V400c0 44.2 35.8 80 80 80H336c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var $8063e68b12ef6db0$export$d7f107e456ab0306 = $8063e68b12ef6db0$export$c1a3ba061b4f60c4;
var $8063e68b12ef6db0$export$c517dffc18db483f = {
    prefix: "fas",
    iconName: "table-cells",
    icon: [
        512,
        512,
        [
            "th"
        ],
        "f00a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 64v64H64V96h88zm56 0h88v64H208V96zm240 0v64H360V96h88zM64 224h88v64H64V224zm232 0v64H208V224h88zm64 0h88v64H360V224zM152 352v64H64V352h88zm56 0h88v64H208V352zm240 0v64H360V352h88z"
    ]
};
var $8063e68b12ef6db0$export$4d383c83efc0c819 = $8063e68b12ef6db0$export$c517dffc18db483f;
var $8063e68b12ef6db0$export$38611f1c776aba73 = {
    prefix: "fas",
    iconName: "file-pdf",
    icon: [
        384,
        512,
        [],
        "f1c1",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 224H88c30.9 0 56 25.1 56 56s-25.1 56-56 56H80v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V320 240c0-8.8 7.2-16 16-16zm24 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H80v48h8zm72-64c0-8.8 7.2-16 16-16h24c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-8.8 0-16-7.2-16-16V240zm32 112h8c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16h-8v96zm96-128h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H304v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H304v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 240c0-8.8 7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$df8194b081d34b27 = {
    prefix: "fas",
    iconName: "book-bible",
    icon: [
        448,
        512,
        [
            "bible"
        ],
        "f647",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zM208 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272V304c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V192H160c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h48V80z"
    ]
};
var $8063e68b12ef6db0$export$2eac809b0670d139 = $8063e68b12ef6db0$export$df8194b081d34b27;
var $8063e68b12ef6db0$export$9db87eabf605857e = {
    prefix: "fas",
    iconName: "o",
    icon: [
        448,
        512,
        [
            111
        ],
        "4f",
        "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160s160-71.6 160-160s-71.6-160-160-160zM0 256C0 132.3 100.3 32 224 32s224 100.3 224 224s-100.3 224-224 224S0 379.7 0 256z"
    ]
};
var $8063e68b12ef6db0$export$25ea11267429d202 = {
    prefix: "fas",
    iconName: "suitcase-medical",
    icon: [
        512,
        512,
        [
            "medkit"
        ],
        "f0fa",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96v32V480H384V128 96 56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM96 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H96V96zM416 480h32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H416V480zM224 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var $8063e68b12ef6db0$export$e75f02bae5b7d34b = $8063e68b12ef6db0$export$25ea11267429d202;
var $8063e68b12ef6db0$export$597826232327559b = {
    prefix: "fas",
    iconName: "user-secret",
    icon: [
        448,
        512,
        [
            128373
        ],
        "f21b",
        "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 14.3 25 27.1 64.6 35.9c-.4 4-.6 8-.6 12.1c0 17 3.3 33.2 9.3 48H45.4C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4H342.7c6-14.8 9.3-31 9.3-48c0-4.1-.2-8.1-.6-12.1C391 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.7 3.3-8.8 6.1-15.5 6.1zm56 208H267.6c-16.5 0-31.1-10.6-36.3-26.2c-2.3-7-12.2-7-14.5 0c-5.2 15.6-19.9 26.2-36.3 26.2H168c-22.1 0-40-17.9-40-40V169.6c28.2 4.1 61 6.4 96 6.4s67.8-2.3 96-6.4V184c0 22.1-17.9 40-40 40zm-88 96l16 32L176 480 128 288l64 32zm128-32L272 480 240 352l16-32 64-32z"
    ]
};
var $8063e68b12ef6db0$export$743cce3ca4eb1d7d = {
    prefix: "fas",
    iconName: "otter",
    icon: [
        640,
        512,
        [
            129446
        ],
        "f700",
        "M181.5 197.1l12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185c-4.5-3-7.1-8-7.1-13.3V168c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-3.6 0-7.1-.2-10.6-.6v.6c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V336 320c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6V240c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16v32 16 48c0 8.8 7.2 16 16 16s16-7.2 16-16V204.3c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4C576 86.1 640 164.2 640 254.9l0 1.1h0c0 123.7-100.3 224-224 224h-1.1H256h-.6C132 480 32 380 32 256.6V256 216.8c-10.1-14.6-16-32.3-16-51.4V144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24h2.8C44.8 58.2 83.3 32 128 32h64c44.7 0 83.2 26.2 101.2 64H296c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4v21.4c0 1.4 0 2.8-.1 4.3c12-6.2 25.7-9.6 40.1-9.6h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-13.3 0-24 10.7-24 24v8h56.4c-15.2 17-24.4 39.4-24.4 64H320c-42.3 0-78.2-27.4-91-65.3c-5.1 .9-10.3 1.3-15.6 1.3c-14.1 0-27.9-3.3-40.5-9.6zM96 160c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zm144-16c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$27f7383b96c3f4b4 = {
    prefix: "fas",
    iconName: "person-dress",
    icon: [
        320,
        512,
        [
            "female"
        ],
        "f182",
        "M160 96c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zM88 384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3h11.6c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1H232v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H152v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"
    ]
};
var $8063e68b12ef6db0$export$70e8e75e61dd7169 = $8063e68b12ef6db0$export$27f7383b96c3f4b4;
var $8063e68b12ef6db0$export$7a088030853df12c = {
    prefix: "fas",
    iconName: "comment-dollar",
    icon: [
        512,
        512,
        [],
        "f651",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20V329.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z"
    ]
};
var $8063e68b12ef6db0$export$694b7e88782dec12 = {
    prefix: "fas",
    iconName: "business-time",
    icon: [
        640,
        512,
        [
            "briefcase-clock"
        ],
        "f64a",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 352h8.2c32.3-39.1 81.1-64 135.8-64c5.4 0 10.7 .2 16 .7V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM320 352H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H360.2C335.1 449.6 320 410.5 320 368c0-5.4 .2-10.7 .7-16l-.7 0zm320 16c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zM496 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$8b00ae94743552ce = $8063e68b12ef6db0$export$694b7e88782dec12;
var $8063e68b12ef6db0$export$d2bcaf492dfb3817 = {
    prefix: "fas",
    iconName: "table-cells-large",
    icon: [
        512,
        512,
        [
            "th-large"
        ],
        "f009",
        "M448 96V224H288V96H448zm0 192V416H288V288H448zM224 224H64V96H224V224zM64 288H224V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $8063e68b12ef6db0$export$69782f333e90cdc6 = $8063e68b12ef6db0$export$d2bcaf492dfb3817;
var $8063e68b12ef6db0$export$24c764717169f536 = {
    prefix: "fas",
    iconName: "book-tanakh",
    icon: [
        448,
        512,
        [
            "tanakh"
        ],
        "f827",
        "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM138.7 208l13.9 24H124.9l13.9-24zm-13.9-24L97.1 232c-6.2 10.7 1.5 24 13.9 24h55.4l27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48H305c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24H249.6L221.9 64c-6.2-10.7-21.6-10.7-27.7 0l-27.7 48H111c-12.3 0-20 13.3-13.9 24l27.7 48zm27.7 0l27.7-48h55.4l27.7 48-27.7 48H180.3l-27.7-48zm0-48l-13.9 24-13.9-24h27.7zm41.6-24L208 88l13.9 24H194.1zm69.3 24h27.7l-13.9 24-13.9-24zm13.9 72l13.9 24H263.4l13.9-24zm-55.4 48L208 280l-13.9-24h27.7z"
    ]
};
var $8063e68b12ef6db0$export$7fd4a58929315448 = $8063e68b12ef6db0$export$24c764717169f536;
var $8063e68b12ef6db0$export$c377f240bb8b5d74 = {
    prefix: "fas",
    iconName: "phone-volume",
    icon: [
        512,
        512,
        [
            "volume-control-phone"
        ],
        "f2a0",
        "M188.8 39.3c13.8 8.5 19.6 26.8 13.6 42.7L174.2 156c-5.3 14-18.5 22.5-32.4 21l-42.6-4.6c-17.4 54.1-17.4 113.2 0 167.3l42.6-4.6c13.9-1.5 27.1 7 32.4 21L202.4 430c6.1 15.9 .3 34.2-13.6 42.7l-56.4 34.8c-12.4 7.7-28 5.4-38.1-5.5C-31.4 366.1-31.4 145.9 94.3 10C104.4-.9 120.1-3.1 132.5 4.5l56.4 34.8zm218.4-5.5C471.2 86.6 512 166.6 512 256s-40.8 169.4-104.7 222.2c-10.2 8.4-25.3 7-33.8-3.2s-7-25.3 3.2-33.8C430.1 397.1 464 330.5 464 256s-33.9-141.1-87.3-185.2c-10.2-8.4-11.7-23.6-3.2-33.8s23.6-11.7 33.8-3.2zm-64.4 71.4C387.4 140.4 416 194.8 416 256s-28.6 115.6-73.1 150.8c-10.4 8.2-25.5 6.4-33.7-4s-6.4-25.5 4-33.7C346.6 342.7 368 301.8 368 256s-21.4-86.7-54.8-113.1c-10.4-8.2-12.2-23.3-4-33.7s23.3-12.2 33.7-4zm-65.4 71C303.1 193.5 320 222.8 320 256s-16.9 62.5-42.5 79.7c-11 7.4-25.9 4.5-33.3-6.5s-4.5-25.9 6.5-33.3c12.9-8.7 21.3-23.3 21.3-39.9s-8.4-31.2-21.3-39.9c-11-7.4-13.9-22.3-6.5-33.3s22.3-13.9 33.3-6.5z"
    ]
};
var $8063e68b12ef6db0$export$5358d004fa3d3be2 = $8063e68b12ef6db0$export$c377f240bb8b5d74;
var $8063e68b12ef6db0$export$ab6f71fd6878da90 = {
    prefix: "fas",
    iconName: "hat-cowboy-side",
    icon: [
        640,
        512,
        [],
        "f8c1",
        "M463.2 71.3c-2.4-12.8-9.8-24.1-20.7-31.3s-24.2-9.7-36.9-6.8l-216 48c-19.8 4.4-34.7 20.8-37.2 40.9l-8.8 70.6c5.3-.4 10.8-.7 16.5-.7c82.9 0 141.9 55.3 197.5 107.5l0 0c3.1 3 6.3 5.9 9.4 8.8C427.1 364.5 486.9 416 576 416c0 0 64 0 64-48c0-96-112-128-144-128h-1.6L463.2 71.3zM576 448c-102.9 0-171.1-60.5-230.9-116.3l-6.5-6C279.9 270.8 229.9 224 160 224c-57.8 0-97.4 28.6-123.1 63.5C10.7 323 0 363.8 0 384c0 35.3 28.7 64 64 64H576z"
    ]
};
var $8063e68b12ef6db0$export$1204f2d171424659 = {
    prefix: "fas",
    iconName: "clipboard-user",
    icon: [
        384,
        512,
        [],
        "f7f3",
        "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm64 128c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
    ]
};
var $8063e68b12ef6db0$export$60b41e3581d1739a = {
    prefix: "fas",
    iconName: "child",
    icon: [
        320,
        512,
        [],
        "f1ae",
        "M224 64c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM144 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V287.8L59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H144z"
    ]
};
var $8063e68b12ef6db0$export$f0f37dbc60110b10 = {
    prefix: "fas",
    iconName: "lira-sign",
    icon: [
        384,
        512,
        [
            8356
        ],
        "f195",
        "M144 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L249 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C137.5 32 80 89.5 80 160.4V192H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H80v32H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H78c-2.2 10.5-6.1 20.6-11.7 29.9L36.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S52.5 480 64 480H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H120.5l.7-1.1c11.6-19.3 18.9-40.7 21.6-62.9H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H144V256H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H144V160.4z"
    ]
};
var $8063e68b12ef6db0$export$da3f1730d013e224 = {
    prefix: "fas",
    iconName: "satellite",
    icon: [
        512,
        512,
        [
            128752
        ],
        "f7bf",
        "M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5C152.3 230.4 124.9 224 96 224c-31.7 0-61.5 7.7-87.8 21.2c-9 4.7-10.3 16.7-3.1 23.8L112.7 376.7 96.3 393.1c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4L242.9 506.9c7.2 7.2 19.2 5.9 23.8-3.1C280.3 477.5 288 447.7 288 416c0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55L233 7zm159 351l-72.4-72.4 62.1-62.1L454.1 296 392 358.1zM226.3 192.4L153.9 120 216 57.9l72.4 72.4-62.1 62.1z"
    ]
};
var $8063e68b12ef6db0$export$1125ac57be52258c = {
    prefix: "fas",
    iconName: "plane-lock",
    icon: [
        640,
        512,
        [],
        "e558",
        "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7v84.6l101.8 58.2C418 247.6 416 259.6 416 272v24.6c-17.9 10.4-30.3 29.1-31.8 50.9L320 329.1V400l57.6 43.2c4 3 6.4 7.8 6.4 12.8v24 18c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400l0-70.9-171.6 49C10.2 381.1 0 373.4 0 362.8V297.3c0-5.7 3.1-11 8.1-13.9L192 178.3V93.7zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $8063e68b12ef6db0$export$cb61f447f29887e = {
    prefix: "fas",
    iconName: "tag",
    icon: [
        448,
        512,
        [
            127991
        ],
        "f02b",
        "M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 96c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$805cd88398a70581 = {
    prefix: "fas",
    iconName: "comment",
    icon: [
        512,
        512,
        [
            128489,
            61669
        ],
        "f075",
        "M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"
    ]
};
var $8063e68b12ef6db0$export$e4019fe302a972e1 = {
    prefix: "fas",
    iconName: "cake-candles",
    icon: [
        448,
        512,
        [
            127874,
            "birthday-cake",
            "cake"
        ],
        "f1fd",
        "M86.4 5.5L61.8 47.6C58 54.1 56 61.6 56 69.2V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0L189.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zM317.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5L317.8 47.6zM128 176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c-35.3 0-64 28.7-64 64v71c8.3 5.2 18.1 9 28.8 9c13.5 0 27.2-6.1 38.4-13.4c5.4-3.5 9.9-7.1 13-9.7c1.5-1.3 2.7-2.4 3.5-3.1c.4-.4 .7-.6 .8-.8l.1-.1 0 0 0 0s0 0 0 0s0 0 0 0c3.1-3.2 7.4-4.9 11.9-4.8s8.6 2.1 11.6 5.4l0 0 0 0 .1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c3-3.5 7.4-5.4 12-5.4s9 2 12 5.4l.1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c2.9-3.4 7.1-5.3 11.6-5.4s8.7 1.6 11.9 4.8l0 0 0 0 0 0 .1 .1c.2 .2 .4 .4 .8 .8c.8 .7 1.9 1.8 3.5 3.1c3.1 2.6 7.5 6.2 13 9.7c11.2 7.3 24.9 13.4 38.4 13.4c10.7 0 20.5-3.9 28.8-9V288c0-35.3-28.7-64-64-64V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H256V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H128V176zM448 394.6c-8.5 3.3-18.2 5.4-28.8 5.4c-22.5 0-42.4-9.9-55.8-18.6c-4.1-2.7-7.8-5.4-10.9-7.8c-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C201.8 390 182.6 400 160 400s-41.8-10-54.6-18.9c-3.7-2.6-7-5.2-9.8-7.5c-3.1 2.4-6.8 5.1-10.9 7.8C71.2 390.1 51.3 400 28.8 400c-10.6 0-20.3-2.2-28.8-5.4V480c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V394.6z"
    ]
};
var $8063e68b12ef6db0$export$bdcf98f725a7241a = $8063e68b12ef6db0$export$e4019fe302a972e1;
var $8063e68b12ef6db0$export$707bc1c80c0177c1 = $8063e68b12ef6db0$export$e4019fe302a972e1;
var $8063e68b12ef6db0$export$6f095630677adc = {
    prefix: "fas",
    iconName: "envelope",
    icon: [
        512,
        512,
        [
            128386,
            9993,
            61443
        ],
        "f0e0",
        "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
    ]
};
var $8063e68b12ef6db0$export$152ef92a4f9d80a7 = {
    prefix: "fas",
    iconName: "angles-up",
    icon: [
        448,
        512,
        [
            "angle-double-up"
        ],
        "f102",
        "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 361.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 301.3 361.4 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
    ]
};
var $8063e68b12ef6db0$export$9bb51e1a2c07db7c = $8063e68b12ef6db0$export$152ef92a4f9d80a7;
var $8063e68b12ef6db0$export$4b24ca1552f410af = {
    prefix: "fas",
    iconName: "paperclip",
    icon: [
        512,
        512,
        [
            128206
        ],
        "f0c6",
        "M396.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"
    ]
};
var $8063e68b12ef6db0$export$e201217e5046cd15 = {
    prefix: "fas",
    iconName: "arrow-right-to-city",
    icon: [
        640,
        512,
        [],
        "e4b3",
        "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM166.6 153.4l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L146.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H146.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"
    ]
};
var $8063e68b12ef6db0$export$838459d11f3971df = {
    prefix: "fas",
    iconName: "ribbon",
    icon: [
        448,
        512,
        [
            127895
        ],
        "f4d6",
        "M224 96c39.5 0 66.8 12.2 81.9 21.5L245.6 184l79.3 87.4 36.3-40c14.7-16.2 22.8-37.3 22.8-59.1v-27c0-15.6-4.1-30.8-12-44.3L337.7 42C326.4 22.7 307 6.8 282.1 3.5C267.8 1.6 248.4 0 224 0s-43.8 1.6-58 3.5C141 6.8 121.7 22.7 110.4 42L76 101c-7.8 13.4-12 28.7-12 44.3v27c0 21.9 8.1 42.9 22.8 59.1l57.9 63.8L224 382.6 334.2 504.1c6.4 7 16.3 9.7 25.4 6.6l72-24c7.7-2.6 13.6-8.8 15.6-16.7s0-16.2-5.4-22.2L303.3 295.2 224 207.8l-81.9-90.3C157.3 108.2 184.5 96 224 96zM202.4 406.5L123.2 319 6.3 447.9c-5.4 6-7.5 14.4-5.4 22.2s7.9 14.1 15.6 16.7l72 24c9 3 19 .4 25.4-6.6l88.6-97.7z"
    ]
};
var $8063e68b12ef6db0$export$ba9b387e84727819 = {
    prefix: "fas",
    iconName: "lungs",
    icon: [
        640,
        512,
        [
            129729
        ],
        "f604",
        "M320 0c17.7 0 32 14.3 32 32V164.1c0 16.4 8.4 31.7 22.2 40.5l9.8 6.2V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398V325l90.5 57.6c7.5 4.7 17.3 2.5 22.1-4.9s2.5-17.3-4.9-22.1L384 287.1v-.4l-44.1-28.1c-7.3-4.6-13.9-10.1-19.9-16.1c-5.9 6-12.6 11.5-19.9 16.1L256 286.7 161.2 347l-13.5 8.6c0 0 0 0-.1 0c-7.4 4.8-9.6 14.6-4.8 22.1c4.7 7.5 14.6 9.7 22.1 4.9l91.1-58V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v45.5l9.8-6.2c13.8-8.8 22.2-24.1 22.2-40.5V32c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$25218e5886296cb9 = {
    prefix: "fas",
    iconName: "arrow-up-9-1",
    icon: [
        576,
        512,
        [
            "sort-numeric-up-alt"
        ],
        "f887",
        "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM352 320c0-17.7 14.3-32 32-32h48c17.7 0 32 14.3 32 32v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V352H384c-17.7 0-32-14.3-32-32zm93.7-171.1c10.8-5.1 18.3-16.2 18.3-28.9c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c4.9 0 9.6-1.1 13.7-3.1zm-40.7 54.9C369.6 192.4 344 159.2 344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
    ]
};
var $8063e68b12ef6db0$export$d41859f1bbb9e086 = $8063e68b12ef6db0$export$25218e5886296cb9;
var $8063e68b12ef6db0$export$4a157bd81dcd8d80 = {
    prefix: "fas",
    iconName: "litecoin-sign",
    icon: [
        448,
        512,
        [],
        "e1d3",
        "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V213.6L55.2 225.2c-17 4.9-26.8 22.6-22 39.6s22.6 26.8 39.6 22L96 280.1V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V261.9l136.8-39.1c17-4.9 26.8-22.6 22-39.6s-22.6-26.8-39.6-22L160 195.3V64z"
    ]
};
var $8063e68b12ef6db0$export$2b488402ec335d97 = {
    prefix: "fas",
    iconName: "border-none",
    icon: [
        448,
        512,
        [],
        "f850",
        "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zm96 64c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm0-384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zM320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm0-448c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zm0 256c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM224 416c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zm0-320c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zM416 480c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm0-384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM32 32C14.3 32 0 46.3 0 64S14.3 96 32 96s32-14.3 32-32s-14.3-32-32-32zM416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zM224 384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm192-64c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zM32 384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM416 128c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zM32 192c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm192-64c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32z"
    ]
};
var $8063e68b12ef6db0$export$de462dd5a18e80d4 = {
    prefix: "fas",
    iconName: "circle-nodes",
    icon: [
        512,
        512,
        [],
        "e4e2",
        "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"
    ]
};
var $8063e68b12ef6db0$export$ca9e3368f1d9500a = {
    prefix: "fas",
    iconName: "parachute-box",
    icon: [
        512,
        512,
        [],
        "f4cd",
        "M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16H240V320H208c-7 0-13.7 1.5-19.7 4.2L68.2 192H96.5c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192h6L165.2 346.3c-3.3 6.5-5.2 13.9-5.2 21.7v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V368c0-7.8-1.9-15.2-5.2-21.7L487.1 192h6c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16h28.3L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2H272V192H383.5z"
    ]
};
var $8063e68b12ef6db0$export$318208bc30aeebcc = {
    prefix: "fas",
    iconName: "indent",
    icon: [
        448,
        512,
        [],
        "f03c",
        "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"
    ]
};
var $8063e68b12ef6db0$export$40cb0a4a3a74dc03 = {
    prefix: "fas",
    iconName: "truck-field-un",
    icon: [
        640,
        512,
        [],
        "e58e",
        "M96 32C60.7 32 32 60.7 32 96v32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288c0-35.3-28.7-64-64-64h-4.2c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38H375.4C364.4 44.9 343.7 32 320 32H96zm288 96h43.2l42.7 96H384V128zM208 384c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zm272 48c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$b9098a890f61e022 = {
    prefix: "fas",
    iconName: "hourglass",
    icon: [
        384,
        512,
        [
            9203,
            62032,
            "hourglass-empty"
        ],
        "f254",
        "M0 32C0 14.3 14.3 0 32 0H64 320h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V75c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1v11c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V437c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75V64C14.3 64 0 49.7 0 32zM96 64V75c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9V64H96zm0 384H288V437c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9v11z"
    ]
};
var $8063e68b12ef6db0$export$a2f8176a0161e891 = $8063e68b12ef6db0$export$b9098a890f61e022;
var $8063e68b12ef6db0$export$64f9eb99c9749cce = {
    prefix: "fas",
    iconName: "mountain",
    icon: [
        512,
        512,
        [
            127956
        ],
        "f6fc",
        "M256 32c12.5 0 24.1 6.4 30.7 17L503.4 394.4c5.6 8.9 8.6 19.2 8.6 29.7c0 30.9-25 55.9-55.9 55.9H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17zm65 192L256 120.4 176.9 246.5 208 288l48-64h65z"
    ]
};
var $8063e68b12ef6db0$export$9884bf227eeb829 = {
    prefix: "fas",
    iconName: "user-doctor",
    icon: [
        448,
        512,
        [
            "user-md"
        ],
        "f0f0",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $8063e68b12ef6db0$export$ab0d33a2c03f1794 = $8063e68b12ef6db0$export$9884bf227eeb829;
var $8063e68b12ef6db0$export$317f99f46b39906e = {
    prefix: "fas",
    iconName: "circle-info",
    icon: [
        512,
        512,
        [
            "info-circle"
        ],
        "f05a",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-144c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$aa9288aeadf882fa = $8063e68b12ef6db0$export$317f99f46b39906e;
var $8063e68b12ef6db0$export$5d120e8b87ad33f4 = {
    prefix: "fas",
    iconName: "cloud-meatball",
    icon: [
        512,
        512,
        [],
        "f73b",
        "M0 224c0 53 43 96 96 96h44.7c9.5-23.5 32.5-40 59.3-40c2 0 3.9 .1 5.8 .3C217.6 265.5 235.7 256 256 256s38.4 9.5 50.2 24.3c1.9-.2 3.9-.3 5.8-.3c26.9 0 49.9 16.5 59.3 40H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 1 .1 2.1 .1 3.1c-.7-.8-1.4-1.6-2.1-2.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c.7 .7 1.5 1.4 2.3 2.1c-1-.1-2.1-.1-3.1-.1c-17.7 0-32 14.3-32 32s14.3 32 32 32c1 0 2.1-.1 3.1-.1c-.8 .7-1.6 1.3-2.3 2.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3c-.1 1-.1 2.1-.1 3.1c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1c.7 .8 1.3 1.6 2.1 2.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1c1 .1 2.1 .1 3.1 .1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1 .1-3.1 .1c.8-.7 1.6-1.3 2.3-2.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-.7 .7-1.4 1.5-2.1 2.3c.1-1 .1-2.1 .1-3.1zM48 448c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm416 0c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
    ]
};
var $8063e68b12ef6db0$export$84ffbd7161ca2008 = {
    prefix: "fas",
    iconName: "camera",
    icon: [
        512,
        512,
        [
            62258,
            "camera-alt"
        ],
        "f030",
        "M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 384c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96z"
    ]
};
var $8063e68b12ef6db0$export$8872b5664e88e793 = $8063e68b12ef6db0$export$84ffbd7161ca2008;
var $8063e68b12ef6db0$export$f9409a7b020dbec4 = {
    prefix: "fas",
    iconName: "square-virus",
    icon: [
        448,
        512,
        [],
        "e578",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM223.8 93.7c13.3 0 24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24zM192 256c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm88 32c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $8063e68b12ef6db0$export$1439f0d6365138da = {
    prefix: "fas",
    iconName: "meteor",
    icon: [
        512,
        512,
        [
            9732
        ],
        "f753",
        "M493.7 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9zM192 448c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128s-57.3 128-128 128zm0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm16 96c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16z"
    ]
};
var $8063e68b12ef6db0$export$d901d50df5cf8d91 = {
    prefix: "fas",
    iconName: "car-on",
    icon: [
        512,
        512,
        [],
        "e4dd",
        "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM185.8 224H326.2c6.8 0 12.8 4.3 15.1 10.6L360.3 288H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9L82.2 292.4C62.1 300.9 48 320.8 48 344v40 64 32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V448H384v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1zM128 392c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm280-24c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
    ]
};
var $8063e68b12ef6db0$export$26a8fd1143d2d6c0 = {
    prefix: "fas",
    iconName: "sleigh",
    icon: [
        640,
        512,
        [],
        "f7cc",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V256c0 53 43 96 96 96v32h64V352H384v32h64V352c53 0 96-43 96-96V160c17.7 0 32-14.3 32-32s-14.3-32-32-32H512 480c-17.7 0-32 14.3-32 32v41.3c0 30.2-24.5 54.7-54.7 54.7c-75.5 0-145.6-38.9-185.6-102.9l-4.3-6.9C174.2 67.6 125 37.6 70.7 32.7c-2.2-.5-4.4-.7-6.7-.7H55 32zM640 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v8c0 13.3-10.7 24-24 24H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H552c48.6 0 88-39.4 88-88v-8z"
    ]
};
var $8063e68b12ef6db0$export$9a40d582bd4628fb = {
    prefix: "fas",
    iconName: "arrow-down-1-9",
    icon: [
        576,
        512,
        [
            "sort-numeric-asc",
            "sort-numeric-down"
        ],
        "f162",
        "M352 64c0 17.7 14.3 32 32 32h16v64H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V64c0-17.7-14.3-32-32-32H384c-17.7 0-32 14.3-32 32zM160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM445.7 364.9c-4.2 2-8.8 3.1-13.7 3.1c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32c0 12.8-7.5 23.8-18.3 28.9zm-40.7 54.9l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
    ]
};
var $8063e68b12ef6db0$export$a4fb1aa2cdfb18d7 = $8063e68b12ef6db0$export$9a40d582bd4628fb;
var $8063e68b12ef6db0$export$835db7eb35b3c29b = $8063e68b12ef6db0$export$9a40d582bd4628fb;
var $8063e68b12ef6db0$export$b9c3f9a906f96b82 = {
    prefix: "fas",
    iconName: "hand-holding-droplet",
    icon: [
        576,
        512,
        [
            "hand-holding-water"
        ],
        "f4c1",
        "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3V160c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3L275.5 6.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $8063e68b12ef6db0$export$4265371b99d38b95 = $8063e68b12ef6db0$export$b9c3f9a906f96b82;
var $8063e68b12ef6db0$export$efaeddad0a6e901b = {
    prefix: "fas",
    iconName: "water",
    icon: [
        576,
        512,
        [],
        "f773",
        "M269.5 69.9c11.1-7.9 25.9-7.9 37 0C329 85.4 356.5 96 384 96c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 149.7 417 160 384 160c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4C42.8 92.6 61 83.5 75.3 71.6c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 85.2 165.1 96 192 96c27.5 0 55-10.6 77.5-26.1zm37 288C329 373.4 356.5 384 384 384c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 437.7 417 448 384 448c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 373.2 165.1 384 192 384c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0zm0-144C329 229.4 356.5 240 384 240c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 293.7 417 304 384 304c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 229.2 165.1 240 192 240c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $8063e68b12ef6db0$export$5655108e1162ba45 = {
    prefix: "fas",
    iconName: "calendar-check",
    icon: [
        448,
        512,
        [],
        "f274",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"
    ]
};
var $8063e68b12ef6db0$export$983e9c27cac7ed1c = {
    prefix: "fas",
    iconName: "braille",
    icon: [
        640,
        512,
        [],
        "f2a1",
        "M128 96c0 35.3-28.7 64-64 64S0 131.3 0 96S28.7 32 64 32s64 28.7 64 64zm96 176c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm0 48c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM80 416c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 0c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm112 0c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 0c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM64 320c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM224 160c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM480 96c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm112 0c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 0c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM576 272c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm0 48c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm16 96c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 0c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM416 272c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm0 48c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zm16 96c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 0c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64z"
    ]
};
var $8063e68b12ef6db0$export$99cfe064ff0b71c9 = {
    prefix: "fas",
    iconName: "prescription-bottle-medical",
    icon: [
        384,
        512,
        [
            "prescription-bottle-alt"
        ],
        "f486",
        "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM160 240v48H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V352h48c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
    ]
};
var $8063e68b12ef6db0$export$65d1c884b8581d1a = $8063e68b12ef6db0$export$99cfe064ff0b71c9;
var $8063e68b12ef6db0$export$2bebc54c51db6505 = {
    prefix: "fas",
    iconName: "landmark",
    icon: [
        512,
        512,
        [
            127963
        ],
        "f66f",
        "M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l171.8 98.1L448 104l0 .9 47.9 27.4c12.6 7.2 18.8 22 15.1 36s-16.4 23.8-30.9 23.8H32c-14.5 0-27.2-9.8-30.9-23.8s2.5-28.8 15.1-36L64 104.9V104l4.4-1.6L240.1 4.2zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
    ]
};
var $8063e68b12ef6db0$export$d7895f386f8bd8b8 = {
    prefix: "fas",
    iconName: "truck",
    icon: [
        640,
        512,
        [
            128666,
            9951
        ],
        "f0d1",
        "M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM208 416c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zm272 48c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $8063e68b12ef6db0$export$721c101130c40043 = {
    prefix: "fas",
    iconName: "crosshairs",
    icon: [
        512,
        512,
        [],
        "f05b",
        "M256 0c17.7 0 32 14.3 32 32V42.4c93.7 13.9 167.7 88 181.6 181.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H469.6c-13.9 93.7-88 167.7-181.6 181.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V469.6C130.3 455.7 56.3 381.7 42.4 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H42.4C56.3 130.3 130.3 56.3 224 42.4V32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6V384c0-17.7 14.3-32 32-32s32 14.3 32 32v20.6c58.3-12.5 104.1-58.4 116.6-116.6H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h20.6C392.1 165.7 346.3 119.9 288 107.4V128c0 17.7-14.3 32-32 32s-32-14.3-32-32V107.4C165.7 119.9 119.9 165.7 107.4 224H128c17.7 0 32 14.3 32 32s-14.3 32-32 32H107.4zM256 288c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$c48422e9da776c1b = {
    prefix: "fas",
    iconName: "person-cane",
    icon: [
        448,
        512,
        [],
        "e53c",
        "M272 48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm-8 187.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3zM352 376c0-4.4 3.6-8 8-8s8 3.6 8 8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-30.9-25.1-56-56-56s-56 25.1-56 56v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8z"
    ]
};
var $8063e68b12ef6db0$export$e5075400db564e24 = {
    prefix: "fas",
    iconName: "tent",
    icon: [
        576,
        512,
        [],
        "e57d",
        "M269.4 6C280.5-2 295.5-2 306.6 6l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7H416L288 288V512H32c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z"
    ]
};
var $8063e68b12ef6db0$export$750a64470c2e0f3f = {
    prefix: "fas",
    iconName: "vest-patches",
    icon: [
        448,
        512,
        [],
        "e086",
        "M151.2 69.7l55.9 167.7-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3V464c0 14.5 3.9 28.2 10.7 39.9C195 509 185.9 512 176 512H48c-26.5 0-48-21.5-48-48V270.5c0-9.5 2.8-18.7 8.1-26.6l47.9-71.8c5.3-7.9 8.1-17.1 8.1-26.6V128 54.3 48C64 21.5 85.5 0 112 0h4.5c.2 0 .4 0 .6 0c.4 0 .8 0 1.2 0c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0c.4 0 .8 0 1.2 0c.2 0 .4 0 .6 0H336c26.5 0 48 21.5 48 48v6.3V128v17.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V295.8c0-5.2 .8-10.3 2.5-15.2L296.8 69.7C279.4 79.7 255.4 88 224 88s-55.4-8.3-72.8-18.3zM96 456c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288 63.5 303.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271 80.5 255.5c-4.7-4.7-12.3-4.7-17 0zM304 280v8 32c0 8.8 7.2 16 16 16h32 8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $8063e68b12ef6db0$export$f178c8c2ad3cc861 = {
    prefix: "fas",
    iconName: "check-double",
    icon: [
        512,
        512,
        [],
        "f560",
        "M374.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160zm96 128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7 86.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l256-256z"
    ]
};
var $8063e68b12ef6db0$export$43b642fac7053978 = {
    prefix: "fas",
    iconName: "arrow-down-a-z",
    icon: [
        576,
        512,
        [
            "sort-alpha-asc",
            "sort-alpha-down"
        ],
        "f15d",
        "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 320c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 352H352c-17.7 0-32-14.3-32-32zM416 32c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 224H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32zM395.8 176h40.4L416 135.6 395.8 176z"
    ]
};
var $8063e68b12ef6db0$export$cb87697f2fa77cfc = $8063e68b12ef6db0$export$43b642fac7053978;
var $8063e68b12ef6db0$export$7658045270aafde3 = $8063e68b12ef6db0$export$43b642fac7053978;
var $8063e68b12ef6db0$export$6a4ef2ef77625063 = {
    prefix: "fas",
    iconName: "money-bill-wheat",
    icon: [
        512,
        512,
        [],
        "e52a",
        "M176 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zM56 16h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 64 32 53.3 32 40s10.7-24 24-24zM24 88H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24S10.7 88 24 88zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zM400 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zm80 144c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 128c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $8063e68b12ef6db0$export$b3e64f5f68c6623f = {
    prefix: "fas",
    iconName: "cookie",
    icon: [
        512,
        512,
        [
            127850
        ],
        "f563",
        "M247.2 17c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17zM208 208c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$89b706873769c180 = {
    prefix: "fas",
    iconName: "arrow-rotate-left",
    icon: [
        512,
        512,
        [
            8634,
            "arrow-left-rotate",
            "arrow-rotate-back",
            "arrow-rotate-backward",
            "undo"
        ],
        "f0e2",
        "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"
    ]
};
var $8063e68b12ef6db0$export$1aea864c3e1d79b = $8063e68b12ef6db0$export$89b706873769c180;
var $8063e68b12ef6db0$export$a34701878babe5fc = $8063e68b12ef6db0$export$89b706873769c180;
var $8063e68b12ef6db0$export$fce381d12e4535cd = $8063e68b12ef6db0$export$89b706873769c180;
var $8063e68b12ef6db0$export$a5e5ba60b1dfe2b2 = $8063e68b12ef6db0$export$89b706873769c180;
var $8063e68b12ef6db0$export$4cb736b866cbb7ec = {
    prefix: "fas",
    iconName: "hard-drive",
    icon: [
        512,
        512,
        [
            128436,
            "hdd"
        ],
        "f0a0",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V280.4c-17-15.2-39.4-24.4-64-24.4H64c-24.6 0-47 9.2-64 24.4V96zM64 288H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64zM320 416c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm128-32c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $8063e68b12ef6db0$export$62551e9c5ba7093f = $8063e68b12ef6db0$export$4cb736b866cbb7ec;
var $8063e68b12ef6db0$export$8ff56f5ebb8416a0 = {
    prefix: "fas",
    iconName: "face-grin-squint-tears",
    icon: [
        512,
        512,
        [
            129315,
            "grin-squint-tears"
        ],
        "f586",
        "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-6.8 6.8-21.4 12.4-37.4 16.7c-18.5 5-38.8 8.3-50.9 10c-4.9 .8-9.1-2.8-9.5-7.4c-.1-.7 0-1.4 .1-2.1c1.6-11.2 4.6-29.6 9-47c.3-1.3 .7-2.6 1-3.9c4.3-15.9 9.8-30.5 16.7-37.4zm-44.7 19c-1.5 4.8-2.9 9.6-4.1 14.3c-4.8 18.9-8 38.5-9.7 50.3c-4 26.8 18.9 49.7 45.7 45.8c11.9-1.6 31.5-4.8 50.4-9.7c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c4.8-18.9 8-38.5 9.7-50.3c4-26.8-18.9-49.7-45.7-45.8c-11.9 1.6-31.5 4.8-50.4 9.7c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75C158.2-8.3 284.5-22.2 382.2 33.2zM51.5 410.1c18.5-5 38.8-8.3 50.9-10c.4-.1 .7-.1 1-.1c5.1-.2 9.2 4.3 8.4 9.6c-1.7 12.1-5 32.4-10 50.9C97.6 476.4 92 491 85.2 497.8C66 517 34.5 516.6 14.9 497.1s-20-51-.7-70.3c6.8-6.8 21.4-12.4 37.4-16.7zM416.9 209c-4.7-11.9-20.8-11-26.8 .3c-19 35.5-45 70.8-77.5 103.3S244.8 371.1 209.3 390c-11.3 6-12.2 22.1-.3 26.8c57.6 22.9 125.8 11 172.3-35.5s58.4-114.8 35.5-172.3zM87.1 285.1c2 2 4.6 3.2 7.3 3.4l56.1 5.1 5.1 56.1c.3 2.8 1.5 5.4 3.4 7.3c6.3 6.3 17.2 3.6 19.8-4.9l29.7-97.4c3.5-11.6-7.3-22.5-19-19L92 265.3c-8.6 2.6-11.3 13.4-4.9 19.8zM265.3 92l-29.7 97.4c-3.5 11.6 7.3 22.5 19 19l97.4-29.7c8.6-2.6 11.3-13.4 4.9-19.8c-2-2-4.6-3.2-7.3-3.4l-56.1-5.1-5.1-56.1c-.2-2.8-1.5-5.4-3.4-7.3c-6.3-6.3-17.2-3.6-19.8 4.9z"
    ]
};
var $8063e68b12ef6db0$export$542206d6a85f3b42 = $8063e68b12ef6db0$export$8ff56f5ebb8416a0;
var $8063e68b12ef6db0$export$56700074cf37be5c = {
    prefix: "fas",
    iconName: "dumbbell",
    icon: [
        640,
        512,
        [],
        "f44b",
        "M112 96c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32V224v64V416c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32h48V96zm416 0v32h48c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32H528v32c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V288 224 96c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32zM416 224v64H224V224H416z"
    ]
};
var $8063e68b12ef6db0$export$1f7600fa9fdb3978 = {
    prefix: "fas",
    iconName: "rectangle-list",
    icon: [
        576,
        512,
        [
            "list-alt"
        ],
        "f022",
        "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm32-128c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM128 384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"
    ]
};
var $8063e68b12ef6db0$export$c6327a203ffc65a3 = $8063e68b12ef6db0$export$1f7600fa9fdb3978;
var $8063e68b12ef6db0$export$1585b7c3c7109751 = {
    prefix: "fas",
    iconName: "tarp-droplet",
    icon: [
        576,
        512,
        [],
        "e57c",
        "M288 160c-35.3 0-64-26.9-64-60c0-24 33.7-70.1 52.2-93.5c6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128H197.5c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64H512c35.3 0 64 28.7 64 64V352H448c-17.7 0-32 14.3-32 32l0 128L64 512c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zM448 512l0-128H576L448 512zM96 256c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$5d08d08f88a96aac = {
    prefix: "fas",
    iconName: "house-medical-circle-check",
    icon: [
        640,
        512,
        [],
        "e511",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm320 0c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zm-76.7-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $8063e68b12ef6db0$export$c8cd1786449517d3 = {
    prefix: "fas",
    iconName: "person-skiing-nordic",
    icon: [
        576,
        512,
        [
            "skiing-nordic"
        ],
        "f7ca",
        "M336 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM227.2 160c1.9 0 3.8 .1 5.6 .3L201.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9L291.3 464H202.8l41.1-88.1-32.4-20.3c-7.8-4.9-14.7-10.7-20.6-17.3L132.2 464H99.7l54.2-257.6c4.6-1.5 9-4.1 12.7-7.8l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5zM121.4 198.6c.4 .4 .8 .8 1.3 1.2L67 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H159.3c.4 0 .9 0 1.3 0H319.3c.5 0 1 0 1.4 0H504c39.8 0 72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24H434.6l27.6-179.3c10.5-5.2 17.8-16.1 17.8-28.7c0-17.7-14.3-32-32-32H426.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3zm308 89.4L402.3 464H357.8l21.6-75.6c5.9-20.6-2.6-42.6-20.7-53.9L302 299l30.9-82.4 5.1 12.3C353 264.7 387.9 288 426.7 288h2.7z"
    ]
};
var $8063e68b12ef6db0$export$6ea48260d7d09b1b = $8063e68b12ef6db0$export$c8cd1786449517d3;
var $8063e68b12ef6db0$export$16768a660ae3ca9d = {
    prefix: "fas",
    iconName: "calendar-plus",
    icon: [
        448,
        512,
        [],
        "f271",
        "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM224 248c13.3 0 24 10.7 24 24v56h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V376H144c-13.3 0-24-10.7-24-24s10.7-24 24-24h56V272c0-13.3 10.7-24 24-24z"
    ]
};
var $8063e68b12ef6db0$export$9b2dbe133273f284 = {
    prefix: "fas",
    iconName: "plane-arrival",
    icon: [
        640,
        512,
        [
            128748
        ],
        "f5af",
        "M.3 166.9L0 68C0 57.7 9.5 50.1 19.5 52.3l35.6 7.9c10.6 2.3 19.2 9.9 23 20L96 128l127.3 37.6L181.8 20.4C178.9 10.2 186.6 0 197.2 0h40.1c11.6 0 22.2 6.2 27.9 16.3l109 193.8 107.2 31.7c15.9 4.7 30.8 12.5 43.7 22.8l34.4 27.6c24 19.2 18.1 57.3-10.7 68.2c-41.2 15.6-86.2 18.1-128.8 7L121.7 289.8c-11.1-2.9-21.2-8.7-29.3-16.9L9.5 189.4c-5.9-6-9.3-14-9.3-22.5zM32 448H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160-80c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm64 48c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$5ae86b9da9cca3bd = {
    prefix: "fas",
    iconName: "circle-left",
    icon: [
        512,
        512,
        [
            61840,
            "arrow-alt-circle-left"
        ],
        "f359",
        "M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512s256-114.6 256-256zM116.7 244.7l112-112c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8l0 64 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 64c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-112-112c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
var $8063e68b12ef6db0$export$5460a5b11a24996f = $8063e68b12ef6db0$export$5ae86b9da9cca3bd;
var $8063e68b12ef6db0$export$cda326cc3bce41c = {
    prefix: "fas",
    iconName: "train-subway",
    icon: [
        448,
        512,
        [
            "subway"
        ],
        "f239",
        "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 128c0-17.7 14.3-32 32-32h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM272 96h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H272c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM128 352c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm224 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$4cabc8a12d4e2f9 = $8063e68b12ef6db0$export$cda326cc3bce41c;
var $8063e68b12ef6db0$export$dce43b02b3fe0c18 = {
    prefix: "fas",
    iconName: "chart-gantt",
    icon: [
        512,
        512,
        [],
        "e0e4",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm96 64H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$1d2b135cc5a2c852 = {
    prefix: "fas",
    iconName: "indian-rupee-sign",
    icon: [
        320,
        512,
        [
            "indian-rupee",
            "inr"
        ],
        "e1bc",
        "M0 64C0 46.3 14.3 32 32 32H96h16H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H231.8c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H252.4c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H185.3C173 115.7 144.8 96 112 96H96 32C14.3 96 0 81.7 0 64z"
    ]
};
var $8063e68b12ef6db0$export$be886a4def17c565 = $8063e68b12ef6db0$export$1d2b135cc5a2c852;
var $8063e68b12ef6db0$export$12c6d8b3e052490b = $8063e68b12ef6db0$export$1d2b135cc5a2c852;
var $8063e68b12ef6db0$export$c3605731beb92daf = {
    prefix: "fas",
    iconName: "crop-simple",
    icon: [
        512,
        512,
        [
            "crop-alt"
        ],
        "f565",
        "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H128V32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-256c0-35.3-28.7-64-64-64L160 64v64l224 0 0 352z"
    ]
};
var $8063e68b12ef6db0$export$d932915fde4f1010 = $8063e68b12ef6db0$export$c3605731beb92daf;
var $8063e68b12ef6db0$export$a312c7d58dd44a75 = {
    prefix: "fas",
    iconName: "money-bill-1",
    icon: [
        576,
        512,
        [
            "money-bill-alt"
        ],
        "f3d1",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM400 256c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112zM252 208c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"
    ]
};
var $8063e68b12ef6db0$export$a35d573395884c3d = $8063e68b12ef6db0$export$a312c7d58dd44a75;
var $8063e68b12ef6db0$export$1db7e2ee10d36035 = {
    prefix: "fas",
    iconName: "left-long",
    icon: [
        512,
        512,
        [
            "long-arrow-alt-left"
        ],
        "f30a",
        "M177.5 98c-8.8-3.8-19-2-26 4.6l-144 136C2.7 243.1 0 249.4 0 256s2.7 12.9 7.5 17.4l144 136c7 6.6 17.2 8.4 26 4.6s14.5-12.5 14.5-22l0-88 288 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-288 0 0-88c0-9.6-5.7-18.2-14.5-22z"
    ]
};
var $8063e68b12ef6db0$export$a8b3226b2bf323d = $8063e68b12ef6db0$export$1db7e2ee10d36035;
var $8063e68b12ef6db0$export$c062100d54a2da00 = {
    prefix: "fas",
    iconName: "dna",
    icon: [
        448,
        512,
        [
            129516
        ],
        "f471",
        "M416 0c17.7 0 32 14.3 32 32c0 59.8-30.3 107.5-69.4 146.6c-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9l0 0 0 0 0 0-1.6 1c-6 4-11.9 7.9-17.8 11.9c-20.9 14-40.8 27.7-59.3 41.5H283.3c-9.8-7.4-20.1-14.7-30.7-22.1l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6c25 18.1 48.9 37.3 69.4 57.7C417.7 372.5 448 420.2 448 480c0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-59.8 30.3-107.5 69.4-146.6c28-28 62.5-53.5 97.3-77.4c-34.8-23.9-69.3-49.3-97.3-77.4C30.3 139.5 0 91.8 0 32C0 14.3 14.3 0 32 0S64 14.3 64 32H384c0-17.7 14.3-32 32-32zM338.6 384H109.4c-10.1 10.6-18.6 21.3-25.5 32H364.1c-6.8-10.7-15.3-21.4-25.5-32zM109.4 128H338.6c10.1-10.7 18.6-21.3 25.5-32H83.9c6.8 10.7 15.3 21.3 25.5 32zm55.4 48c18.4 13.8 38.4 27.5 59.3 41.5c20.9-14 40.8-27.7 59.3-41.5H164.7z"
    ]
};
var $8063e68b12ef6db0$export$c4ff5306c5470939 = {
    prefix: "fas",
    iconName: "virus-slash",
    icon: [
        640,
        512,
        [],
        "e075",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zm225.8 177c6.9-3.9 14.9-6.1 23.4-6.1c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.7l-69.7-54.6zM107.5 224H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-31.2 23.6-52.7 50-55.7L144.7 210c-9.5 8.5-22.2 14-37.2 14z"
    ]
};
var $8063e68b12ef6db0$export$fee0376c250cdef = {
    prefix: "fas",
    iconName: "minus",
    icon: [
        448,
        512,
        [
            8211,
            8722,
            10134,
            "subtract"
        ],
        "f068",
        "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$f8cb2531ef1fc4a2 = $8063e68b12ef6db0$export$fee0376c250cdef;
var $8063e68b12ef6db0$export$9b027cdb5db3ae5c = {
    prefix: "fas",
    iconName: "child-rifle",
    icon: [
        576,
        512,
        [],
        "e4e0",
        "M176 128c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zm-8 352V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V300.5L260.9 321c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9H169.8c-33 0-63.7 16.9-81.2 44.9L36.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10L104 300.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM448 0H432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16V132.3c-9.6 5.5-16 15.9-16 27.7v32c-17.7 0-32 14.3-32 32V368c0 17.7 14.3 32 32 32h16v96c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H480V325.3l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16H512c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16z"
    ]
};
var $8063e68b12ef6db0$export$442fddbbd741c590 = {
    prefix: "fas",
    iconName: "chess",
    icon: [
        512,
        512,
        [],
        "f439",
        "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H59.4C48.7 96 40 104.7 40 115.4c0 3 .7 5.9 2 8.7c6 12.4 23.8 50.8 32.8 83.9H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h7.7C78 302.9 69.4 352.7 63.1 384H192.9c-6.4-31.3-14.9-81.1-16.6-128H184c13.3 0 24-10.7 24-24s-10.7-24-24-24h-2.8c9-33.2 26.8-71.5 32.8-83.9c1.3-2.7 2-5.6 2-8.7c0-10.7-8.7-19.4-19.4-19.4H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zM25.2 451.4l-8.8 4.4C6.3 460.8 0 471.1 0 482.3C0 498.7 13.3 512 29.7 512H226.3c16.4 0 29.7-13.3 29.7-29.7c0-11.2-6.3-21.5-16.4-26.5l-8.8-4.4c-4.1-2.1-6.8-6.3-6.8-10.9c0-13.5-10.9-24.4-24.4-24.4H56.4C42.9 416 32 426.9 32 440.4c0 4.6-2.6 8.9-6.8 10.9zm279.2 4.4c-10.1 5-16.4 15.3-16.4 26.5c0 16.4 13.3 29.7 29.7 29.7H482.3c16.4 0 29.7-13.3 29.7-29.7c0-11.2-6.3-21.5-16.4-26.5l-8.8-4.4c-4.1-2.1-6.8-6.3-6.8-10.9c0-13.5-10.9-24.4-24.4-24.4H344.4c-13.5 0-24.4 10.9-24.4 24.4c0 4.6-2.6 8.9-6.8 10.9l-8.8 4.4zM304 259.9c0 7.8 2.8 15.3 8 21.1l18.9 21.4c5.4 6.1 8.2 14 8 22.1L337 384H462.5l-2.7-58.7c-.4-8.5 2.6-16.9 8.4-23.1l19.3-21c5.4-5.9 8.5-13.6 8.5-21.7V200c0-4.4-3.6-8-8-8H464c-4.4 0-8 3.6-8 8v16c0 4.4-3.6 8-8 8h-8c-4.4 0-8-3.6-8-8V200c0-4.4-3.6-8-8-8H376c-4.4 0-8 3.6-8 8v16c0 4.4-3.6 8-8 8h-8c-4.4 0-8-3.6-8-8V200c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v59.9zM392 336c-4.4 0-8-3.6-8-8V304c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 4.4-3.6 8-8 8H392z"
    ]
};
var $8063e68b12ef6db0$export$6e5225f0e6c0bacd = {
    prefix: "fas",
    iconName: "arrow-left-long",
    icon: [
        512,
        512,
        [
            "long-arrow-left"
        ],
        "f177",
        "M109.3 288L480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288z"
    ]
};
var $8063e68b12ef6db0$export$80896efc906118b4 = $8063e68b12ef6db0$export$6e5225f0e6c0bacd;
var $8063e68b12ef6db0$export$2bd45e99b9afa947 = {
    prefix: "fas",
    iconName: "plug-circle-check",
    icon: [
        576,
        512,
        [],
        "e55c",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $8063e68b12ef6db0$export$6aab6c3359c2554c = {
    prefix: "fas",
    iconName: "street-view",
    icon: [
        512,
        512,
        [],
        "f21d",
        "M320 64c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zm-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5L318.2 304H320c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H224zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"
    ]
};
var $8063e68b12ef6db0$export$acef3e5c2029d285 = {
    prefix: "fas",
    iconName: "franc-sign",
    icon: [
        320,
        512,
        [],
        "e18f",
        "M80 32C62.3 32 48 46.3 48 64V224v96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
    ]
};
var $8063e68b12ef6db0$export$d94ba52e980ea0f1 = {
    prefix: "fas",
    iconName: "volume-off",
    icon: [
        320,
        512,
        [],
        "f026",
        "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448V64z"
    ]
};
var $8063e68b12ef6db0$export$bc43eb4655c78f49 = {
    prefix: "fas",
    iconName: "hands-asl-interpreting",
    icon: [
        640,
        512,
        [
            "american-sign-language-interpreting",
            "asl-interpreting",
            "hands-american-sign-language-interpreting"
        ],
        "f2a3",
        "M156.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L13.5 189.4C4.6 207.2 0 226.8 0 246.7V256c0 70.7 57.3 128 128 128h72 8v-.3c35.2-2.7 65.4-22.8 82.1-51.7c8.8-15.3 3.6-34.9-11.7-43.7s-34.9-3.6-43.7 11.7c-7 12-19.9 20-34.7 20c-22.1 0-40-17.9-40-40s17.9-40 40-40c14.8 0 27.7 8 34.7 20c8.8 15.3 28.4 20.5 43.7 11.7s20.5-28.4 11.7-43.7c-12.8-22.1-33.6-39.1-58.4-47.1l80.8-22c17-4.6 27.1-22.2 22.5-39.3s-22.2-27.1-39.3-22.5L194.9 124.6l81.6-68c13.6-11.3 15.4-31.5 4.1-45.1S249.1-3.9 235.5 7.4L133.6 92.3l23-46zM483.4 465.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2V256c0-70.7-57.3-128-128-128H440h-8v.3c-35.2 2.7-65.4 22.8-82.1 51.7c-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20c22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20c-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.7-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5l100.7-27.5-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46z"
    ]
};
var $8063e68b12ef6db0$export$23a7517099ab1b86 = $8063e68b12ef6db0$export$bc43eb4655c78f49;
var $8063e68b12ef6db0$export$beb51abfb05a4eca = $8063e68b12ef6db0$export$bc43eb4655c78f49;
var $8063e68b12ef6db0$export$82846008645b0301 = $8063e68b12ef6db0$export$bc43eb4655c78f49;
var $8063e68b12ef6db0$export$ec05accb7226d001 = {
    prefix: "fas",
    iconName: "gear",
    icon: [
        512,
        512,
        [
            9881,
            "cog"
        ],
        "f013",
        "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80z"
    ]
};
var $8063e68b12ef6db0$export$d6298bbfd1912a78 = $8063e68b12ef6db0$export$ec05accb7226d001;
var $8063e68b12ef6db0$export$1d6c5a49025d720b = {
    prefix: "fas",
    iconName: "droplet-slash",
    icon: [
        640,
        512,
        [
            "tint-slash"
        ],
        "f5c7",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L491.5 359.9c3-12.8 4.5-26.2 4.5-39.9c0-74.1-102.3-230.6-150.9-300.7c-12.3-17.7-37.8-17.7-50.1 0c-20.8 30-51.4 75.8-79.6 124.1L38.8 5.1zM144 320c0 97.2 78.8 176 176 176c48.1 0 91.7-19.3 123.5-50.6L170 229.9c-15.6 34.7-26 66.6-26 90.1zm96 0c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$5d6f0943039b898f = $8063e68b12ef6db0$export$1d6c5a49025d720b;
var $8063e68b12ef6db0$export$4999586d7e1087fb = {
    prefix: "fas",
    iconName: "mosque",
    icon: [
        640,
        512,
        [
            128332
        ],
        "f678",
        "M400 0c5 0 9.8 2.4 12.8 6.4c34.7 46.3 78.1 74.9 133.5 111.5l0 0 0 0c5.2 3.4 10.5 7 16 10.6c28.9 19.2 45.7 51.7 45.7 86.1c0 28.6-11.3 54.5-29.8 73.4H221.8c-18.4-19-29.8-44.9-29.8-73.4c0-34.4 16.7-66.9 45.7-86.1c5.4-3.6 10.8-7.1 16-10.6l0 0 0 0C309.1 81.3 352.5 52.7 387.2 6.4c3-4 7.8-6.4 12.8-6.4zM288 512V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H192c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H560V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H448V454c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454v58H288zM70.4 5.2c5.7-4.3 13.5-4.3 19.2 0l16 12C139.8 42.9 160 83.2 160 126v2H0v-2C0 83.2 20.2 42.9 54.4 17.2l16-12zM0 160H160V296.6c-19.1 11.1-32 31.7-32 55.4V480c0 9.6 2.1 18.6 5.8 26.8c-6.6 3.4-14 5.2-21.8 5.2H48c-26.5 0-48-21.5-48-48V176 160z"
    ]
};
var $8063e68b12ef6db0$export$67c7a1518d0715ff = {
    prefix: "fas",
    iconName: "mosquito",
    icon: [
        640,
        512,
        [],
        "e52b",
        "M463.7 505.9c9.8-8.9 10.7-24.3 2.1-34.3l-42.1-49 0-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266.3l0-.3L485.4 387.8C542.4 447.6 640 405.2 640 320.6c0-47.9-34-88.3-79.4-94.2l-153-23.9 40.8-40.9c7.8-7.8 9.4-20.1 3.9-29.8L428.5 90.1l38.2-50.9c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.3-33.2 4.4l-48 63.9c-5.9 7.9-6.6 18.6-1.7 27.2L402.2 140 352 190.3l0-38.2c0-14.9-10.2-27.4-24-31l0-57.2c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 57.2c-13.8 3.6-24 16.1-24 31l0 38.1L237.8 140l22.6-39.5c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.9c-8-10.6-22.8-12.6-33.2-4.4s-12.2 23.5-4.3 34.1l38.2 50.9-23.9 41.7c-5.5 9.7-3.9 22 3.9 29.8l40.8 40.9-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266l0 .3-66.5 86.4c-3.3 4.3-5.1 9.6-5.1 15.1l0 54.7-42.1 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1l0-55.4L288 344.7l0 63.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-63.1 24.3 31.6 0 55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1z"
    ]
};
var $8063e68b12ef6db0$export$f823fee3712b2601 = {
    prefix: "fas",
    iconName: "star-of-david",
    icon: [
        512,
        512,
        [
            10017
        ],
        "f69a",
        "M404.2 309.5L383.1 344h42.3l-21.1-34.5zM371.4 256l-54-88H194.6l-54 88 54 88H317.4l54-88zm65.7 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112H163.3l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112H458.6c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-54-88l21.1 34.5L425.4 168H383.1zM283 112L256 68l-27 44h54zM128.9 168H86.6l21.1 34.5L128.9 168zM107.8 309.5L86.6 344h42.3l-21.1-34.5zM229 400l27 44 27-44H229z"
    ]
};
var $8063e68b12ef6db0$export$842b988dae95ccb8 = {
    prefix: "fas",
    iconName: "person-military-rifle",
    icon: [
        512,
        512,
        [],
        "e54b",
        "M160 39c0-13 10-23.8 22.9-24.9L334.7 1.4C344 .7 352 8 352 17.4V48c0 8.8-7.2 16-16 16H185c-13.8 0-25-11.2-25-25zm17.6 57H334.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16zm228 364.3L352 369.7V480c0 1.3-.1 2.5-.2 3.8L177.5 234.9c16.6-7.1 34.6-10.9 53.3-10.9h50.4c15.9 0 31.3 2.8 45.8 7.9L421.9 67.7c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6 .9c15.3 8.8 20.6 28.4 11.7 43.7L392.6 282c2 2.8 3.9 5.8 5.7 8.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1zM320 512H192c-17.7 0-32-14.3-32-32V369.7l-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.1-128.8c9.4-15.8 21.7-29.3 36-40L331.1 510c-3.5 1.3-7.2 2-11.1 2zM296 320c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $8063e68b12ef6db0$export$c790b41dc166ae13 = {
    prefix: "fas",
    iconName: "cart-shopping",
    icon: [
        576,
        512,
        [
            128722,
            "shopping-cart"
        ],
        "f07a",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H179.9l-9.1-48h317c14.3 0 26.9-9.5 30.8-23.3l54-192C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm336-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48z"
    ]
};
var $8063e68b12ef6db0$export$51da406e5aa1388c = $8063e68b12ef6db0$export$c790b41dc166ae13;
var $8063e68b12ef6db0$export$507e8edd7676b2e9 = {
    prefix: "fas",
    iconName: "vials",
    icon: [
        512,
        512,
        [],
        "f493",
        "M0 64C0 46.3 14.3 32 32 32H88h48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96C14.3 96 0 81.7 0 64zM136 96H88V256h48V96zM288 64c0-17.7 14.3-32 32-32h56 48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96c-17.7 0-32-14.3-32-32zM424 96H376V256h48V96z"
    ]
};
var $8063e68b12ef6db0$export$f193138a7d21971c = {
    prefix: "fas",
    iconName: "plug-circle-plus",
    icon: [
        576,
        512,
        [],
        "e55f",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$c5a9302c8c13c79a = {
    prefix: "fas",
    iconName: "place-of-worship",
    icon: [
        640,
        512,
        [],
        "f67f",
        "M224 109.3V217.6L183.3 242c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V283.2c0-16.9-8.8-32.5-23.3-41.2L416 217.6V109.3c0-8.5-3.4-16.6-9.4-22.6L331.3 11.3c-6.2-6.2-16.4-6.2-22.6 0L233.4 86.6c-6 6-9.4 14.1-9.4 22.6zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
    ]
};
var $8063e68b12ef6db0$export$cacbd95c283996ec = {
    prefix: "fas",
    iconName: "grip-vertical",
    icon: [
        320,
        512,
        [],
        "f58e",
        "M40 352c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zm192 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zM40 320l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM232 192c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zM40 160l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 48c0 22.1 17.9 40 40 40zM232 32c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0z"
    ]
};
var $8063e68b12ef6db0$export$2d3ccb9b2099f3fe = {
    prefix: "fas",
    iconName: "arrow-turn-up",
    icon: [
        384,
        512,
        [
            "level-up"
        ],
        "f148",
        "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z"
    ]
};
var $8063e68b12ef6db0$export$c227d3ba1de97ceb = $8063e68b12ef6db0$export$2d3ccb9b2099f3fe;
var $8063e68b12ef6db0$export$4f39e8dbaf09ea8b = {
    prefix: "fas",
    iconName: "u",
    icon: [
        384,
        512,
        [
            117
        ],
        "55",
        "M32 32c17.7 0 32 14.3 32 32V288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 106-86 192-192 192S0 394 0 288V64C0 46.3 14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$60b44cfa7af18422 = {
    prefix: "fas",
    iconName: "square-root-variable",
    icon: [
        576,
        512,
        [
            "square-root-alt"
        ],
        "f698",
        "M289 24.2C292.5 10 305.3 0 320 0H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H345L239 487.8c-3.2 13-14.2 22.6-27.6 24s-26.1-5.5-32.1-17.5L76.2 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c12.1 0 23.2 6.8 28.6 17.7l73.3 146.6L289 24.2zM393.4 233.4c12.5-12.5 32.8-12.5 45.3 0L480 274.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 320l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $8063e68b12ef6db0$export$28e4b96627e00057 = $8063e68b12ef6db0$export$60b44cfa7af18422;
var $8063e68b12ef6db0$export$95b9968e7fceb821 = {
    prefix: "fas",
    iconName: "clock",
    icon: [
        512,
        512,
        [
            128339,
            "clock-four"
        ],
        "f017",
        "M256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $8063e68b12ef6db0$export$9a575facf1cab48f = $8063e68b12ef6db0$export$95b9968e7fceb821;
var $8063e68b12ef6db0$export$5d2b6a700940df16 = {
    prefix: "fas",
    iconName: "backward-step",
    icon: [
        320,
        512,
        [
            "step-backward"
        ],
        "f048",
        "M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241V96c0-17.7-14.3-32-32-32S0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V271l11.5 9.6 192 160z"
    ]
};
var $8063e68b12ef6db0$export$2884e379aed297d4 = $8063e68b12ef6db0$export$5d2b6a700940df16;
var $8063e68b12ef6db0$export$d7ff2047dbc34562 = {
    prefix: "fas",
    iconName: "pallet",
    icon: [
        640,
        512,
        [],
        "f482",
        "M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 320 544h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H544 320 96 32zm96 64H288v64H128V384zm224 0H512v64H352V384z"
    ]
};
var $8063e68b12ef6db0$export$a0856b225f3b0614 = {
    prefix: "fas",
    iconName: "faucet",
    icon: [
        512,
        512,
        [],
        "e005",
        "M192 96v12L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96-12 31-3.9 1-.1 1 .1 31 3.9 96 12c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12V96c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H132.1c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48H352c17.7 0 32 14.3 32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160H320l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4H256V180.2l-32-4-32 4V224H173.3c-8.5 0-16.6 3.4-22.6 9.4L128 256H32z"
    ]
};
var $8063e68b12ef6db0$export$59669f486ab41d86 = {
    prefix: "fas",
    iconName: "baseball-bat-ball",
    icon: [
        640,
        512,
        [],
        "f432",
        "M550.3 0c-10.9 0-21.4 3.4-30.2 9.8L279.7 184.6c-13.9 10.1-26.8 21.4-38.7 33.8L138.7 325.3c-9.2 9.6-19.3 18.4-30.1 26.3L79.3 372.9c1.3 1.5 2.6 3 3.9 4.7l48 64c1.6 2.2 3.1 4.4 4.4 6.6l27.3-19.9c11.6-8.4 24-15.8 37-21.8l135.3-63.1c16.7-7.8 32.7-17.2 47.6-28.1L619 143.6c13.2-9.6 21-24.9 21-41.2c0-11-3.6-21.8-10.2-30.6L609.6 44.8 591.4 20.6C581.7 7.6 566.5 0 550.3 0zM496 512c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zM57.6 396.8c-10.6-14.1-30.7-17-44.8-6.4s-17 30.7-6.4 44.8l48 64c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-48-64z"
    ]
};
var $8063e68b12ef6db0$export$cb39585371b75720 = {
    prefix: "fas",
    iconName: "s",
    icon: [
        384,
        512,
        [
            115
        ],
        "53",
        "M131.1 105.4c-20.1 8.6-30.8 21.8-33.9 39.4c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3c-16.8-5.6-25.8-23.7-20.3-40.5s23.7-25.8 40.5-20.3c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5-31.5-5.5c7.3-42.5 35.3-71.7 71.8-87.3c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4c17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.1 22.7c-11.2-3-48.2-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z"
    ]
};
var $8063e68b12ef6db0$export$5e239d90ef904a84 = {
    prefix: "fas",
    iconName: "timeline",
    icon: [
        640,
        512,
        [],
        "e29c",
        "M128 120c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm32 49.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288v54.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V169.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160V169.3zM536 96c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zM320 440c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $8063e68b12ef6db0$export$fb61df5d98785fa8 = {
    prefix: "fas",
    iconName: "keyboard",
    icon: [
        576,
        512,
        [
            9000
        ],
        "f11c",
        "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM160 336c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336zM272 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM256 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM368 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM352 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V240zM464 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM448 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$f9395ef707603e40 = {
    prefix: "fas",
    iconName: "caret-down",
    icon: [
        320,
        512,
        [],
        "f0d7",
        "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
    ]
};
var $8063e68b12ef6db0$export$9c73560282dceccd = {
    prefix: "fas",
    iconName: "house-chimney-medical",
    icon: [
        576,
        512,
        [
            "clinic-medical"
        ],
        "f7f2",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM272 192c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H320V208c0-8.8-7.2-16-16-16H272z"
    ]
};
var $8063e68b12ef6db0$export$20d8a680febc7434 = $8063e68b12ef6db0$export$9c73560282dceccd;
var $8063e68b12ef6db0$export$7ed2bad15ae6237f = {
    prefix: "fas",
    iconName: "temperature-three-quarters",
    icon: [
        320,
        512,
        [
            "temperature-3",
            "thermometer-3",
            "thermometer-three-quarters"
        ],
        "f2c8",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V152c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $8063e68b12ef6db0$export$89def3268ed9b4bc = $8063e68b12ef6db0$export$7ed2bad15ae6237f;
var $8063e68b12ef6db0$export$2f653125f4e6463 = $8063e68b12ef6db0$export$7ed2bad15ae6237f;
var $8063e68b12ef6db0$export$6c632d1dc30d4a77 = $8063e68b12ef6db0$export$7ed2bad15ae6237f;
var $8063e68b12ef6db0$export$8867e7da34bb8bf4 = {
    prefix: "fas",
    iconName: "mobile-screen",
    icon: [
        384,
        512,
        [
            "mobile-android-alt"
        ],
        "f3cf",
        "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z"
    ]
};
var $8063e68b12ef6db0$export$cb39d7b468ba5838 = $8063e68b12ef6db0$export$8867e7da34bb8bf4;
var $8063e68b12ef6db0$export$a5f2976a01fdc970 = {
    prefix: "fas",
    iconName: "plane-up",
    icon: [
        512,
        512,
        [],
        "e22d",
        "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3L497.8 278.5c8.9 5.9 14.2 15.9 14.2 26.6v56.7c0 10.9-10.7 18.6-21.1 15.2L320 320v80l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400V320L21.1 377C10.7 380.4 0 372.7 0 361.8V305.1c0-10.7 5.3-20.7 14.2-26.6L192 160V93.7z"
    ]
};
var $8063e68b12ef6db0$export$46d49a6734c4872a = {
    prefix: "fas",
    iconName: "piggy-bank",
    icon: [
        576,
        512,
        [],
        "f4d3",
        "M400 96l0 .7c-5.3-.4-10.6-.7-16-.7H256c-16.5 0-32.5 2.1-47.8 6c-.1-2-.2-4-.2-6c0-53 43-96 96-96s96 43 96 96zm-16 32c3.5 0 7 .1 10.4 .3c4.2 .3 8.4 .7 12.6 1.3C424.6 109.1 450.8 96 480 96h32l-18.8 75.1c15.8 14.8 28.7 32.8 37.5 52.9H544c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H512c-9.1 12.1-19.9 22.9-32 32v64c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H256v32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416c-34.9-26.2-58.7-66.3-63.2-112H68c-37.6 0-68-30.4-68-68s30.4-68 68-68h4c13.3 0 24 10.7 24 24s-10.7 24-24 24H68c-11 0-20 9-20 20s9 20 20 20H99.2c12.1-59.8 57.7-107.5 116.3-122.8c12.9-3.4 26.5-5.2 40.5-5.2H384zm64 136c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $8063e68b12ef6db0$export$e6dadc1155c4ee48 = {
    prefix: "fas",
    iconName: "battery-half",
    icon: [
        576,
        512,
        [
            "battery-3"
        ],
        "f242",
        "M0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176zm80-16c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zm208 32V320H96V192H288z"
    ]
};
var $8063e68b12ef6db0$export$f9138caac2aedaed = $8063e68b12ef6db0$export$e6dadc1155c4ee48;
var $8063e68b12ef6db0$export$28f06bbf9c17c3af = {
    prefix: "fas",
    iconName: "mountain-city",
    icon: [
        640,
        512,
        [],
        "e52e",
        "M336 0c-26.5 0-48 21.5-48 48v92.1l71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-3.5l73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3c-.4 .8-.9 1.6-1.4 2.3H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H568V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H480V48c0-26.5-21.5-48-48-48H336zm32 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM352 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176zm160 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zM224 188.9L283.8 288H223l-48 64-24.6-41.2L224 188.9zm29.4-44.2C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512H413.5c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7z"
    ]
};
var $8063e68b12ef6db0$export$bc5da164799a0e = {
    prefix: "fas",
    iconName: "coins",
    icon: [
        512,
        512,
        [],
        "f51e",
        "M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2l0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5V176c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336V300.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4V304v5.7V336zm32 0V304 278.1c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5V272c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432V396.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"
    ]
};
var $8063e68b12ef6db0$export$8d41d1f1ba3f9217 = {
    prefix: "fas",
    iconName: "khanda",
    icon: [
        576,
        512,
        [
            9772
        ],
        "f66d",
        "M277.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9l0 0 0 0 0 0 0 0-.1 .1-.3 .6c-.3 .5-.7 1.3-1.2 2.3c-1 2-2.6 5-4.4 8.6c-.5 .9-.9 1.9-1.4 2.9C376.9 97.4 400 134 400 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9c1.8 3.7 3.3 6.6 4.4 8.6c.5 1 .9 1.8 1.2 2.3l.3 .6 .1 .1 0 0 0 0c3.6 6.7 2 15-3.8 19.9L304 343.5v19.8l35.6-24.5 41.1-28.2c42.8-29.4 68.4-78 68.4-130c0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5s12.7-7 19.2-3.7L433.1 80c7.2-14.3 7.2-14.3 7.2-14.3l0 0 0 0 .1 0 .3 .2 1 .5c.8 .4 2 1.1 3.5 1.9c2.9 1.7 7 4.1 11.8 7.3c9.6 6.4 22.5 16.1 35.4 29c25.7 25.7 52.7 65.6 52.7 119.3c0 53.1-26.4 100.5-51.2 133.6c-12.6 16.7-25.1 30.3-34.5 39.7c-4.7 4.7-8.7 8.4-11.5 10.9c-1.4 1.3-2.5 2.2-3.3 2.9l-.9 .8-.3 .2-.1 .1 0 0 0 0s0 0-10.2-12.3l10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L304 423.4v28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7V424.1l-40.3 27.7C229.8 463.3 219.9 472 208 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L144 400c-10.2 12.3-10.2 12.3-10.3 12.3l0 0 0 0-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9c-2.8-2.5-6.7-6.2-11.5-10.9c-9.4-9.4-21.9-23-34.5-39.7C58.4 324.5 32 277.1 32 224c0-53.7 26.9-93.6 52.7-119.3c12.9-12.9 25.8-22.6 35.4-29c4.8-3.2 8.9-5.7 11.8-7.3c1.5-.8 2.6-1.5 3.5-1.9l1-.5 .3-.2 .1 0 0 0 0 0s0 0 7.2 14.3l-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C137.2 119 128 149.5 128 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2L272 362.6V343.5l-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9l0 0 0 0 0 0 .1-.1 .3-.6c.3-.5 .7-1.3 1.2-2.3c1-2 2.6-5 4.4-8.6c.5-.9 .9-1.9 1.4-2.9C199.1 254.6 176 218 176 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9c-1.8-3.7-3.3-6.6-4.4-8.6c-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1 0 0 0 0 0 0c-3.6-6.7-2-15 3.8-19.9l48-40zM252.2 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C259 210.2 264 190.9 264 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C317 141.8 312 161.1 312 176s5 34.2 11.8 53.1z"
    ]
};
var $8063e68b12ef6db0$export$ea6970ed5a15feb6 = {
    prefix: "fas",
    iconName: "sliders",
    icon: [
        512,
        512,
        [
            "sliders-h"
        ],
        "f1de",
        "M0 416c0-17.7 14.3-32 32-32l54.7 0c12.3-28.3 40.5-48 73.3-48s61 19.7 73.3 48L480 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-246.7 0c-12.3 28.3-40.5 48-73.3 48s-61-19.7-73.3-48L32 448c-17.7 0-32-14.3-32-32zm192 0c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM384 256c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm-32-80c32.8 0 61 19.7 73.3 48l54.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-54.7 0c-12.3 28.3-40.5 48-73.3 48s-61-19.7-73.3-48L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l246.7 0c12.3-28.3 40.5-48 73.3-48zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32zm73.3 0L480 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-214.7 0c-12.3 28.3-40.5 48-73.3 48s-61-19.7-73.3-48L32 128C14.3 128 0 113.7 0 96S14.3 64 32 64l86.7 0C131 35.7 159.2 16 192 16s61 19.7 73.3 48z"
    ]
};
var $8063e68b12ef6db0$export$94d4dcb523f95563 = $8063e68b12ef6db0$export$ea6970ed5a15feb6;
var $8063e68b12ef6db0$export$54d16fa2e445d3fe = {
    prefix: "fas",
    iconName: "folder-tree",
    icon: [
        576,
        512,
        [],
        "f802",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v96V384c0 35.3 28.7 64 64 64H256V384H64V160H256V96H64V32zM288 192c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V192zm0 288c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V480z"
    ]
};
var $8063e68b12ef6db0$export$882cabd11f4943b8 = {
    prefix: "fas",
    iconName: "network-wired",
    icon: [
        640,
        512,
        [],
        "f6ff",
        "M256 64H384v64H256V64zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v32H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H192V288H448v32H400c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H512V288h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V192h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240zM96 448V384H224v64H96zm320-64H544v64H416V384z"
    ]
};
var $8063e68b12ef6db0$export$184725965b3402dc = {
    prefix: "fas",
    iconName: "map-pin",
    icon: [
        320,
        512,
        [
            128205
        ],
        "f276",
        "M320 144c0 79.5-64.5 144-144 144S32 223.5 32 144S96.5 0 176 0s144 64.5 144 144zM176 80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64zM144 480V317.1c10.4 1.9 21.1 2.9 32 2.9s21.6-1 32-2.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var $8063e68b12ef6db0$export$38d20d399463edf9 = {
    prefix: "fas",
    iconName: "hamsa",
    icon: [
        512,
        512,
        [],
        "f665",
        "M34.6 288H80c8.8 0 16-7.2 16-16V72c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V40c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V72c0-22.1 17.9-40 40-40s40 17.9 40 40V272c0 8.8 7.2 16 16 16h45.4c19.1 0 34.6 15.5 34.6 34.6c0 8.6-3.2 16.9-9 23.3L416.6 441c-41.1 45.2-99.4 71-160.6 71s-119.4-25.8-160.6-71L9 345.9c-5.8-6.4-9-14.7-9-23.3C0 303.5 15.5 288 34.6 288zM256 288c-38.4 0-76.8 35.8-90.6 50.2c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288zm0 96c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$875b6c94a4b00ea8 = {
    prefix: "fas",
    iconName: "cent-sign",
    icon: [
        384,
        512,
        [],
        "e3f5",
        "M224 0c17.7 0 32 14.3 32 32V66.7c30.9 5.2 59.2 17.7 83.2 35.8c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8c-24 18-52.4 30.6-83.2 35.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C101.2 430.1 32 351.1 32 256s69.2-174.1 160-189.3V32c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$f9b579ba06048af = {
    prefix: "fas",
    iconName: "flask",
    icon: [
        448,
        512,
        [],
        "f0c3",
        "M288 0H160 128C110.3 0 96 14.3 96 32s14.3 32 32 32V196.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512H378.6c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zM192 196.8V64h64V196.8c0 23.7 6.6 46.9 19 67.1L309.5 320h-171L173 263.9c12.4-20.2 19-43.4 19-67.1z"
    ]
};
var $8063e68b12ef6db0$export$e7b4c26b5857fe9c = {
    prefix: "fas",
    iconName: "person-pregnant",
    icon: [
        384,
        512,
        [],
        "e31e",
        "M192 96c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zM120 383c-13.8-3.6-24-16.1-24-31V296.9l-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6c4.1-.6 8.2-1 12.5-1h1.1 12.5H192c1.4 0 2.8 .1 4.1 .3c35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32H304 264v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384h-8-8v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V383z"
    ]
};
var $8063e68b12ef6db0$export$76cc39f249b6864e = {
    prefix: "fas",
    iconName: "wand-sparkles",
    icon: [
        512,
        512,
        [],
        "f72b",
        "M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7V176c0 8.8-7.2 16-16 16H384.2c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9C94.3 508 85.3 512 75.8 512c-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7C3.5 453.4 0 445 0 436.2c0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9V272c0-8.8 7.2-16 16-16h34.6c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8L87.7 218.2c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8L72.3 69.8c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM224 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z"
    ]
};
var $8063e68b12ef6db0$export$7480721bf113be3e = {
    prefix: "fas",
    iconName: "ellipsis-vertical",
    icon: [
        128,
        512,
        [
            "ellipsis-v"
        ],
        "f142",
        "M64 360c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zm0-160c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56zM120 96c0 30.9-25.1 56-56 56S8 126.9 8 96S33.1 40 64 40s56 25.1 56 56z"
    ]
};
var $8063e68b12ef6db0$export$e58494c7fcb5380 = $8063e68b12ef6db0$export$7480721bf113be3e;
var $8063e68b12ef6db0$export$3604f15924cf0b98 = {
    prefix: "fas",
    iconName: "ticket",
    icon: [
        576,
        512,
        [
            127903
        ],
        "f145",
        "M64 64C28.7 64 0 92.7 0 128v80c26.5 0 48 21.5 48 48s-21.5 48-48 48v80c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V304c-26.5 0-48-21.5-48-48s21.5-48 48-48V128c0-35.3-28.7-64-64-64H64zm64 96l0 192H448V160H128zm-32 0c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160z"
    ]
};
var $8063e68b12ef6db0$export$a1cca9928dcf9798 = {
    prefix: "fas",
    iconName: "power-off",
    icon: [
        512,
        512,
        [
            9211
        ],
        "f011",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V256c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"
    ]
};
var $8063e68b12ef6db0$export$b356b1dbe7d7f736 = {
    prefix: "fas",
    iconName: "right-long",
    icon: [
        512,
        512,
        [
            "long-arrow-alt-right"
        ],
        "f30b",
        "M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 88L32 208c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l288 0 0 88c0 9.6 5.7 18.2 14.5 22z"
    ]
};
var $8063e68b12ef6db0$export$533e1f578f74c066 = $8063e68b12ef6db0$export$b356b1dbe7d7f736;
var $8063e68b12ef6db0$export$19357abad396e723 = {
    prefix: "fas",
    iconName: "flag-usa",
    icon: [
        512,
        512,
        [],
        "f74d",
        "M63 23.9C59.4 10.1 46.9 0 32 0C14.3 0 0 14.3 0 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V380.1c2-.8 4.8-1.8 8.2-3c8-2.8 19.4-6.6 32.6-10.4C131.9 359 164.5 352 192 352c26.3 0 46 6.4 70 14.4l1 .3c23.8 7.9 51.9 17.3 89 17.3c36.8 0 72.5-9.1 98.1-17.6c13-4.3 23.8-8.7 31.5-11.9c3.8-1.6 6.9-3 9-4c1.1-.5 1.9-.9 2.5-1.2l.7-.4 .2-.1 .1 0 0 0 0 0s0 0-14.3-28.6l14.3 28.6c10.8-5.4 17.7-16.5 17.7-28.6V289.1c-2.2 .8-5 1.8-8.2 3c-8.8 3.1-21.1 7.2-35.5 11.3C439.8 311.5 402.1 320 368 320c-34.1 0-63.9-8.5-91.4-16.4l-.8-.2C247.5 295.3 221.4 288 192 288c-29.7 0-61.9 7.5-87.3 15.3C92.1 307.2 81.5 311 74 313.9c-3.7 1.4-6.7 2.6-8.6 3.5L64 318V283.5c7.9-3 18.7-6.9 31.3-10.8c26.6-8.2 62.4-16.7 96.7-16.7c34.3 0 64.2 8.5 91.8 16.4l.7 .2c28.3 8.1 54.2 15.4 83.5 15.4c29.6 0 63.9-7.5 91.5-15.4c13.6-3.9 25.4-7.8 33.6-10.7c4.1-1.5 7.4-2.7 9.6-3.5c1.1-.4 2-.7 2.5-1l.6-.2 .1-.1 0 0 0 0 0 0 0 0 5.9-2.4V193.1c-2.2 .8-5 1.8-8.2 3c-8.8 3.1-21.1 7.2-35.5 11.3C439.8 215.5 402.1 224 368 224c-34.1 0-63.9-8.5-91.4-16.4l-.8-.2C247.5 199.3 221.4 192 192 192c-29.7 0-61.9 7.5-87.3 15.3C92.1 211.2 81.5 215 74 217.9c-3.7 1.4-6.7 2.6-8.6 3.5L64 222V187.5c7.9-3 18.7-6.9 31.3-10.8c26.6-8.2 62.4-16.7 96.7-16.7c34.3 0 64.2 8.5 91.8 16.4l0 0 .7 .2c28.3 8.1 54.2 15.4 83.5 15.4c29.6 0 63.9-7.5 91.5-15.4c13.6-3.9 25.4-7.8 33.6-10.7c4.1-1.5 7.4-2.7 9.6-3.5c1.1-.4 2-.7 2.5-1l.6-.2 .1-.1 0 0 0 0 0 0 0 0 5.9-2.4V97.1c-2.2 .8-5 1.8-8.2 3c-8.8 3.1-21.1 7.2-35.5 11.3C439.8 119.5 402.1 128 368 128c-34.1 0-63.9-8.5-91.4-16.4l-.8-.2c-6.7-1.9-13.2-3.8-19.7-5.5V72.8c9.6 2.4 18.8 5 27.8 7.6l.7 .2C312.8 88.7 338.7 96 368 96c29.6 0 63.9-7.5 91.5-15.4c13.6-3.9 25.4-7.8 33.6-10.7c4.1-1.5 7.4-2.7 9.6-3.5c1.1-.4 2-.7 2.5-1l.6-.2 .1-.1 0 0 0 0 0 0 0 0 5.9-2.4V32c0-11.4-6.1-21.9-15.9-27.7s-22-5.8-31.9-.2l-.2 .1c-.3 .2-.7 .4-1.4 .8c-1.3 .7-3.4 1.8-6.2 3.1c-5.5 2.6-13.6 6.2-23.4 9.8c-20 7.3-46.2 14.1-73 14.1c-26.7 0-50.6-6.6-79.1-14.8l-1.3-.4C252.3 9.1 220.5 0 184 0C147.3 0 109.8 9 82.6 17.4c-7.2 2.2-13.8 4.4-19.6 6.5zM208 48c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zm-64 8c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zm48 72c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zm-48-8c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$e1046cf83da9b7ef = {
    prefix: "fas",
    iconName: "laptop-file",
    icon: [
        640,
        512,
        [],
        "e51d",
        "M192 0H48C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H162.7c6.6-18.6 24.4-32 45.3-32V272c0-44.2 35.8-80 80-80h32V128H224c-17.7 0-32-14.3-32-32V0zm96 224c-26.5 0-48 21.5-48 48v16 96 32H208c-8.8 0-16 7.2-16 16v16c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V432c0-8.8-7.2-16-16-16H592V288c0-35.3-28.7-64-64-64H320 304 288zm32 64H528V416H304V288h16zM224 0V96h96L224 0z"
    ]
};
var $8063e68b12ef6db0$export$7c85aba0f9624b29 = {
    prefix: "fas",
    iconName: "tty",
    icon: [
        512,
        512,
        [
            "teletype"
        ],
        "f1e4",
        "M472.7 188.8c-8.5 13.8-26.8 19.6-42.7 13.6L356 174.2c-14-5.3-22.5-18.5-21-32.4l4.6-42.6c-54.1-17.4-113.2-17.4-167.3 0l4.6 42.6c1.5 13.9-7 27.1-21 32.4L82 202.4c-15.9 6.1-34.2 .3-42.7-13.6L4.5 132.5c-7.7-12.4-5.4-28 5.5-38.1c135.9-125.8 356.1-125.8 492 0c10.9 10.1 13.2 25.7 5.5 38.1l-34.8 56.4zM32 272c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V272zm0 192c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V464zM96 352h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V272zm64 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V272zm64 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H384c-8.8 0-16-7.2-16-16V368zM336 256h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V272zm16 176h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V464c0-8.8 7.2-16 16-16zM128 464c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V464z"
    ]
};
var $8063e68b12ef6db0$export$14bcd5c43dc736f9 = $8063e68b12ef6db0$export$7c85aba0f9624b29;
var $8063e68b12ef6db0$export$2faddf1690e14e11 = {
    prefix: "fas",
    iconName: "diagram-next",
    icon: [
        512,
        512,
        [],
        "e476",
        "M512 160c0 35.3-28.7 64-64 64H280v64h46.1c21.4 0 32.1 25.9 17 41L273 399c-9.4 9.4-24.6 9.4-33.9 0L169 329c-15.1-15.1-4.4-41 17-41H232V224H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64zM448 416V352H365.3l.4-.4c18.4-18.4 20.4-43.7 11-63.6l71.3 0c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64l71.3 0c-9.4 19.9-7.4 45.2 11 63.6l.4 .4H64v64H210.7l5.7 5.7c21.9 21.9 57.3 21.9 79.2 0l5.7-5.7H448z"
    ]
};
var $8063e68b12ef6db0$export$b16df914812cedbe = {
    prefix: "fas",
    iconName: "person-rifle",
    icon: [
        576,
        512,
        [],
        "e54e",
        "M265.2 192c25.4 0 49.8 7.1 70.8 19.9V512H144V337.7L90.4 428.3c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8L97.7 258.8c24.5-41.4 69-66.8 117.1-66.8h50.4zM320 80c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80zM448 0c8.8 0 16 7.2 16 16V132.3c9.6 5.5 16 15.9 16 27.7V269.3l16-5.3V208c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V352h48c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H484l23 92.1c2.5 10.1-5.1 19.9-15.5 19.9H432c-8.8 0-16-7.2-16-16V400H400c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32V160c0-11.8 6.4-22.2 16-27.7V32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 16z"
    ]
};
var $8063e68b12ef6db0$export$bc50edea6e121df5 = {
    prefix: "fas",
    iconName: "house-medical-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e512",
        "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm0-48c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $8063e68b12ef6db0$export$8e047801a8603af7 = {
    prefix: "fas",
    iconName: "closed-captioning",
    icon: [
        576,
        512,
        [],
        "f20a",
        "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
    ]
};
var $8063e68b12ef6db0$export$baf9f153991b2ea = {
    prefix: "fas",
    iconName: "person-hiking",
    icon: [
        384,
        512,
        [
            "hiking"
        ],
        "f6ec",
        "M288 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM243.3 230.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3l-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4c19 4.8 35.6 16.4 46.4 32.7L305.1 208H336V184c0-13.3 10.7-24 24-24s24 10.7 24 24v55.8c0 .1 0 .2 0 .2s0 .2 0 .2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H296.6c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9L117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L142.9 488.1c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1zm55.5-346L101.4 266.5c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8z"
    ]
};
var $8063e68b12ef6db0$export$b2ab0105a901499e = $8063e68b12ef6db0$export$baf9f153991b2ea;
var $8063e68b12ef6db0$export$6a6f9cba7a1e5fe4 = {
    prefix: "fas",
    iconName: "venus-double",
    icon: [
        640,
        512,
        [
            9890
        ],
        "f226",
        "M192 288c61.9 0 112-50.1 112-112s-50.1-112-112-112S80 114.1 80 176s50.1 112 112 112zM368 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H224v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c14.6-15.6 26.8-33.4 36-53c18.8 14.4 42.4 23 68 23c61.9 0 112-50.1 112-112s-50.1-112-112-112c-25.6 0-49.1 8.6-68 23c-9.3-19.5-21.5-37.4-36-53C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1c-26.6-4.9-51.1-15.7-72-31.1z"
    ]
};
var $8063e68b12ef6db0$export$74f06b41ed2ca28a = {
    prefix: "fas",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320H328 280 200c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM256 128c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
    ]
};
var $8063e68b12ef6db0$export$693bd40950ed2c3a = {
    prefix: "fas",
    iconName: "calculator",
    icon: [
        384,
        512,
        [
            128425
        ],
        "f1ec",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 64H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zM64 224c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32zM64 416c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32zM160 320c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zM288 192c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32zM256 320c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$dace56f632fecf6f = {
    prefix: "fas",
    iconName: "people-pulling",
    icon: [
        576,
        512,
        [],
        "e535",
        "M80 96c26.5 0 48-21.5 48-48s-21.5-48-48-48S32 21.5 32 48s21.5 48 48 48zM64 128c-35.3 0-64 28.7-64 64V320c0 17.7 14.3 32 32 32c9.8 0 18.5-4.4 24.4-11.2L80.4 485.3c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352h15.7l30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2l-57.3-258 116.3 53.8c.5 .3 1.1 .5 1.6 .7c8.6 3.6 18 3.1 25.9-.7c3.4-1.6 6.6-3.9 9.3-6.7c3.1-3.2 5.5-7 7.1-11.4c.1-.3 .2-.7 .3-1l2.5-7.5c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L537 232.7l-15.3-36.8C504.5 154.8 464.3 128 419.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-24.4 10.9-44.6 29-58.1 51.6L157.3 136.9C144.7 131 130.9 128 117 128H64zM464 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM349.7 335.6l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L372.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"
    ]
};
var $8063e68b12ef6db0$export$328a9baf0f9e3405 = {
    prefix: "fas",
    iconName: "n",
    icon: [
        384,
        512,
        [
            110
        ],
        "4e",
        "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32H0zM32 64L56.6 43.5C48 33.2 33.8 29.3 21.1 33.9S0 50.5 0 64l32 0zM352 448l-24.6 20.5c8.6 10.3 22.8 14.2 35.5 9.6s21.1-16.6 21.1-30.1H352zM384 64c0-17.7-14.3-32-32-32s-32 14.3-32 32h64zM64 448V64H0V448H64zM7.4 84.5l320 384 49.2-41-320-384L7.4 84.5zM384 448V64H320V448h64z"
    ]
};
var $8063e68b12ef6db0$export$85cb04eaefaf2d8b = {
    prefix: "fas",
    iconName: "cable-car",
    icon: [
        512,
        512,
        [
            128673,
            57551,
            "tram"
        ],
        "f7da",
        "M288 64c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm-64-8c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM32 288c0-35.3 28.7-64 64-64H232V157.5l-203.1 42c-13 2.7-25.7-5.7-28.4-18.6s5.7-25.7 18.6-28.4l232-48 232-48c13-2.7 25.7 5.7 28.4 18.6s-5.7 25.7-18.6 28.4L280 147.5V224H416c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H96zm112 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H352z"
    ]
};
var $8063e68b12ef6db0$export$a7a36674c079f293 = $8063e68b12ef6db0$export$85cb04eaefaf2d8b;
var $8063e68b12ef6db0$export$a6c308ee087b4ded = {
    prefix: "fas",
    iconName: "cloud-rain",
    icon: [
        512,
        512,
        [
            127783,
            9926
        ],
        "f73d",
        "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm-6.8 52c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L89.2 372zm160 0c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L249.2 372zm124.9 64.6L409.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3z"
    ]
};
var $8063e68b12ef6db0$export$c4c015418a1f24df = {
    prefix: "fas",
    iconName: "building-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e4d4",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $8063e68b12ef6db0$export$6c645741140616af = {
    prefix: "fas",
    iconName: "ship",
    icon: [
        576,
        512,
        [
            128674
        ],
        "f21a",
        "M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V64h48c26.5 0 48 21.5 48 48V240l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48V32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160v90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $8063e68b12ef6db0$export$8f2463c7b2fc6ae4 = {
    prefix: "fas",
    iconName: "arrows-down-to-line",
    icon: [
        640,
        512,
        [],
        "e4b8",
        "M576 416L64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zm22.6-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L512 274.7 512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zm-320-45.3c-12.5-12.5-32.8-12.5-45.3 0L192 274.7 192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7L86.6 233.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3z"
    ]
};
var $8063e68b12ef6db0$export$8f734e51d72ca13a = {
    prefix: "fas",
    iconName: "download",
    icon: [
        512,
        512,
        [],
        "f019",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zM432 456c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $8063e68b12ef6db0$export$92292137ef3cf4c8 = {
    prefix: "fas",
    iconName: "face-grin",
    icon: [
        512,
        512,
        [
            128512,
            "grin"
        ],
        "f580",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM208.4 208c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm128 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$37e1f10b6de76621 = $8063e68b12ef6db0$export$92292137ef3cf4c8;
var $8063e68b12ef6db0$export$bbcc9e0b6022772b = {
    prefix: "fas",
    iconName: "delete-left",
    icon: [
        576,
        512,
        [
            9003,
            "backspace"
        ],
        "f55a",
        "M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $8063e68b12ef6db0$export$e43e3f67102fc526 = $8063e68b12ef6db0$export$bbcc9e0b6022772b;
var $8063e68b12ef6db0$export$1bc3e0ad56dc9eb0 = {
    prefix: "fas",
    iconName: "eye-dropper",
    icon: [
        512,
        512,
        [
            "eye-dropper-empty",
            "eyedropper"
        ],
        "f1fb",
        "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9l-45.3-45.3L143.4 411.3c-3 3-7.1 4.7-11.3 4.7H96V379.9c0-4.2 1.7-8.3 4.7-11.3L221.4 247.9l-45.3-45.3L55.4 323.3z"
    ]
};
var $8063e68b12ef6db0$export$ef304e9b7524c1f9 = $8063e68b12ef6db0$export$1bc3e0ad56dc9eb0;
var $8063e68b12ef6db0$export$91549a375c0b6d25 = $8063e68b12ef6db0$export$1bc3e0ad56dc9eb0;
var $8063e68b12ef6db0$export$8547e9f3a2ddab5b = {
    prefix: "fas",
    iconName: "file-circle-check",
    icon: [
        576,
        512,
        [],
        "e5a0",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM576 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zm-76.7-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $8063e68b12ef6db0$export$a8710cdb23198d53 = {
    prefix: "fas",
    iconName: "forward",
    icon: [
        512,
        512,
        [
            9193
        ],
        "f04e",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3V256v41.7L52.5 440.6zM256 352V256 128 96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29V352z"
    ]
};
var $8063e68b12ef6db0$export$59edacfad04cd121 = {
    prefix: "fas",
    iconName: "mobile",
    icon: [
        384,
        512,
        [
            128241,
            "mobile-android",
            "mobile-phone"
        ],
        "f3ce",
        "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zm80 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$82f602311a698c32 = $8063e68b12ef6db0$export$59edacfad04cd121;
var $8063e68b12ef6db0$export$475a9be8da747e57 = $8063e68b12ef6db0$export$59edacfad04cd121;
var $8063e68b12ef6db0$export$dc130582748497c6 = {
    prefix: "fas",
    iconName: "face-meh",
    icon: [
        512,
        512,
        [
            128528,
            "meh"
        ],
        "f11a",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM176.4 240c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm192-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$6d2db489aaeeecd2 = $8063e68b12ef6db0$export$dc130582748497c6;
var $8063e68b12ef6db0$export$70e29dd05344623e = {
    prefix: "fas",
    iconName: "align-center",
    icon: [
        448,
        512,
        [],
        "f037",
        "M352 64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32z"
    ]
};
var $8063e68b12ef6db0$export$a57d448e8969ce8a = {
    prefix: "fas",
    iconName: "book-skull",
    icon: [
        448,
        512,
        [
            "book-dead"
        ],
        "f6b7",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM320 112c0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2V176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V163.2c19.4-11.7 32-30.3 32-51.2zM208 128c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zm80-16c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zM134.3 209.3c-8.1-3.5-17.5 .3-21 8.4s.3 17.5 8.4 21L199.4 272l-77.7 33.3c-8.1 3.5-11.9 12.9-8.4 21s12.9 11.9 21 8.4L240 289.4l105.7 45.3c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21L280.6 272l77.7-33.3c8.1-3.5 11.9-12.9 8.4-21s-12.9-11.9-21-8.4L240 254.6 134.3 209.3z"
    ]
};
var $8063e68b12ef6db0$export$b98a3f8c3941a74a = $8063e68b12ef6db0$export$a57d448e8969ce8a;
var $8063e68b12ef6db0$export$782ac893fc22249b = {
    prefix: "fas",
    iconName: "id-card",
    icon: [
        576,
        512,
        [
            62147,
            "drivers-license"
        ],
        "f2c2",
        "M0 96l576 0c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 32V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128H0zM64 405.3c0-29.5 23.9-53.3 53.3-53.3H234.7c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 320c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64zM352 208c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16z"
    ]
};
var $8063e68b12ef6db0$export$8359c70e609eff64 = $8063e68b12ef6db0$export$782ac893fc22249b;
var $8063e68b12ef6db0$export$e21cfc4f23776bff = {
    prefix: "fas",
    iconName: "outdent",
    icon: [
        512,
        512,
        [
            "dedent"
        ],
        "f03b",
        "M32 64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 96 32 81.7 32 64zM224 192c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm32 96H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32zM32 448c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zm.2-179.4c-8.2-6.4-8.2-18.9 0-25.3l101.9-79.3c10.5-8.2 25.8-.7 25.8 12.6V335.3c0 13.3-15.3 20.8-25.8 12.6L32.2 268.6z"
    ]
};
var $8063e68b12ef6db0$export$cbffb369d9299db7 = $8063e68b12ef6db0$export$e21cfc4f23776bff;
var $8063e68b12ef6db0$export$3772719b170306e2 = {
    prefix: "fas",
    iconName: "heart-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e4fe",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$dcadc0d67468dfa8 = {
    prefix: "fas",
    iconName: "house",
    icon: [
        576,
        512,
        [
            127968,
            63498,
            63500,
            "home",
            "home-alt",
            "home-lg-alt"
        ],
        "f015",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
    ]
};
var $8063e68b12ef6db0$export$48f10d71ec526479 = $8063e68b12ef6db0$export$dcadc0d67468dfa8;
var $8063e68b12ef6db0$export$279659c4b23dbedb = $8063e68b12ef6db0$export$dcadc0d67468dfa8;
var $8063e68b12ef6db0$export$20d6d52d45f53262 = $8063e68b12ef6db0$export$dcadc0d67468dfa8;
var $8063e68b12ef6db0$export$39be5cb4aed5a521 = {
    prefix: "fas",
    iconName: "calendar-week",
    icon: [
        448,
        512,
        [],
        "f784",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"
    ]
};
var $8063e68b12ef6db0$export$ba2fa38f7bcc6930 = {
    prefix: "fas",
    iconName: "laptop-medical",
    icon: [
        640,
        512,
        [],
        "f812",
        "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM288 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H352v48c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V272H240c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"
    ]
};
var $8063e68b12ef6db0$export$fa30fcd1e0d0d8 = {
    prefix: "fas",
    iconName: "b",
    icon: [
        320,
        512,
        [
            98
        ],
        "42",
        "M32 32C14.3 32 0 46.3 0 64V256 448c0 17.7 14.3 32 32 32H192c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128H32zM160 224H64V96h96c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288h96 32c35.3 0 64 28.7 64 64s-28.7 64-64 64H64V288z"
    ]
};
var $8063e68b12ef6db0$export$56cbcd962389b090 = {
    prefix: "fas",
    iconName: "file-medical",
    icon: [
        384,
        512,
        [],
        "f477",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V352H112c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z"
    ]
};
var $8063e68b12ef6db0$export$d91800b7be5303b0 = {
    prefix: "fas",
    iconName: "dice-one",
    icon: [
        448,
        512,
        [
            9856
        ],
        "f525",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 288c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$d9933d91e1314d02 = {
    prefix: "fas",
    iconName: "kiwi-bird",
    icon: [
        576,
        512,
        [],
        "f535",
        "M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4H448c4.6 0 9.1-.2 13.6-.7l85.3 121.9c4 5.7 11.3 8.2 17.9 6.1s11.2-8.3 11.2-15.3V224c0-70.7-57.3-128-128-128H392.3c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32C86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V410c15.3 3.9 31.4 6 48 6c5.4 0 10.7-.2 16-.7V456c0 13.3 10.7 24 24 24s24-10.7 24-24V405.1c12.4-4.4 24.2-10 35.2-16.7zM448 248c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $8063e68b12ef6db0$export$56b6d3d7d0e67a1c = {
    prefix: "fas",
    iconName: "arrow-right-arrow-left",
    icon: [
        576,
        512,
        [
            8644,
            "exchange"
        ],
        "f0ec",
        "M422.6 278.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 176H64c-17.7 0-32-14.3-32-32s14.3-32 32-32H434.7L377.4 54.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l112 112c12.5 12.5 12.5 32.8 0 45.3l-112 112zm-269.3 224l-112-112c-12.5-12.5-12.5-32.8 0-45.3l112-112c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L141.3 336H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H141.3l57.4 57.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"
    ]
};
var $8063e68b12ef6db0$export$1aab915ca61b734a = $8063e68b12ef6db0$export$56b6d3d7d0e67a1c;
var $8063e68b12ef6db0$export$7f465bf410c6eff7 = {
    prefix: "fas",
    iconName: "rotate-right",
    icon: [
        512,
        512,
        [
            "redo-alt",
            "rotate-forward"
        ],
        "f2f9",
        "M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"
    ]
};
var $8063e68b12ef6db0$export$50c037520c6cfdc1 = $8063e68b12ef6db0$export$7f465bf410c6eff7;
var $8063e68b12ef6db0$export$2507849a0fdd7f64 = $8063e68b12ef6db0$export$7f465bf410c6eff7;
var $8063e68b12ef6db0$export$750d52edc1dafc7 = {
    prefix: "fas",
    iconName: "utensils",
    icon: [
        448,
        512,
        [
            127860,
            61685,
            "cutlery"
        ],
        "f2e7",
        "M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z"
    ]
};
var $8063e68b12ef6db0$export$7034e54a8036c5c8 = $8063e68b12ef6db0$export$750d52edc1dafc7;
var $8063e68b12ef6db0$export$63f4908401ded049 = {
    prefix: "fas",
    iconName: "arrow-up-wide-short",
    icon: [
        576,
        512,
        [
            "sort-amount-up"
        ],
        "f161",
        "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$28ef3e933e4b5364 = $8063e68b12ef6db0$export$63f4908401ded049;
var $8063e68b12ef6db0$export$9b53510cf4010e4d = {
    prefix: "fas",
    iconName: "mill-sign",
    icon: [
        384,
        512,
        [],
        "e1ed",
        "M302.1 42.8c5.9-16.6-2.7-35-19.4-40.9s-35 2.7-40.9 19.4L208 116.1c-5.7 4-11.1 8.5-16 13.5C171.7 108.9 143.3 96 112 96c-19.5 0-37.8 5-53.7 13.7C52.5 101.4 42.9 96 32 96C14.3 96 0 110.3 0 128v80V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-26.5 21.5-48 48-48s48 21.5 48 48v42.5L81.9 469.2c-5.9 16.6 2.7 35 19.4 40.9s35-2.7 40.9-19.4l21.4-60C168.9 441 179.6 448 192 448c17.7 0 32-14.3 32-32V261.5l35.7-100c3.9-1 8.1-1.6 12.3-1.6c26.5 0 48 21.5 48 48V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-58.2-44.3-106-101.1-111.5l19.2-53.8z"
    ]
};
var $8063e68b12ef6db0$export$86079bc65a716451 = {
    prefix: "fas",
    iconName: "bowl-rice",
    icon: [
        512,
        512,
        [],
        "e2eb",
        "M176 56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24zm24 48h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zM56 176H72c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 283.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4zM224 200c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm-96 0c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H104c-13.3 0-24-10.7-24-24s10.7-24 24-24zm216 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H392c-13.3 0-24-10.7-24-24s10.7-24 24-24zM296 32h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $8063e68b12ef6db0$export$138b45e2afb1dfa4 = {
    prefix: "fas",
    iconName: "skull",
    icon: [
        512,
        512,
        [
            128128
        ],
        "f54c",
        "M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9c0 .4 0 .7 0 1.1v64c0 26.5 21.5 48 48 48h48V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c26.5 0 48-21.5 48-48V400c0-.4 0-.7 0-1.1zM224 256c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm128 64c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z"
    ]
};
var $8063e68b12ef6db0$export$fd06ff4ce9799eb0 = {
    prefix: "fas",
    iconName: "tower-broadcast",
    icon: [
        576,
        512,
        [
            "broadcast-tower"
        ],
        "f519",
        "M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44zM555.1 20C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7S489.1 228.4 495.7 212c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84C489.1 27.6 497 9 513.4 2.3s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1s-35.1-.3-42.1-16.5c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2 .3-35.1 16.5-42.1s35.1 .3 42.1 16.5z"
    ]
};
var $8063e68b12ef6db0$export$f68b38d51f5c0ed = $8063e68b12ef6db0$export$fd06ff4ce9799eb0;
var $8063e68b12ef6db0$export$f846b848b3ba3064 = {
    prefix: "fas",
    iconName: "truck-pickup",
    icon: [
        640,
        512,
        [
            128763
        ],
        "f63c",
        "M368.6 96l76.8 96H288V96h80.6zM224 80V192H64c-17.7 0-32 14.3-32 32v64c-17.7 0-32 14.3-32 32s14.3 32 32 32H65.1c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16h66.3c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32V224c0-17.7-14.3-32-32-32H527.4L418.6 56c-12.1-15.2-30.5-24-50-24H272c-26.5 0-48 21.5-48 48zM128 368c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48zm288 0c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48z"
    ]
};
var $8063e68b12ef6db0$export$5608156cc81126e7 = {
    prefix: "fas",
    iconName: "up-long",
    icon: [
        320,
        512,
        [
            "long-arrow-alt-up"
        ],
        "f30c",
        "M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192h88l0 288c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32l0-288h88c9.6 0 18.2-5.7 22-14.5z"
    ]
};
var $8063e68b12ef6db0$export$43c8f2a46326c55f = $8063e68b12ef6db0$export$5608156cc81126e7;
var $8063e68b12ef6db0$export$51577929c676143b = {
    prefix: "fas",
    iconName: "stop",
    icon: [
        384,
        512,
        [
            9209
        ],
        "f04d",
        "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
    ]
};
var $8063e68b12ef6db0$export$e151fe5abf6db993 = {
    prefix: "fas",
    iconName: "code-merge",
    icon: [
        448,
        512,
        [],
        "f387",
        "M80 104c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm32.4 49.2c28-12.4 47.6-40.5 47.6-73.2c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3V358.7C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V272c26.7 20.1 60 32 96 32h86.7c12.3 28.3 40.5 48 73.3 48c44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48H208c-49.9 0-91-38.1-95.6-86.8zM80 456c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zM392 272c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$a9578350255b2b79 = {
    prefix: "fas",
    iconName: "upload",
    icon: [
        512,
        512,
        [],
        "f093",
        "M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $8063e68b12ef6db0$export$4cf54a379be7e59a = {
    prefix: "fas",
    iconName: "hurricane",
    icon: [
        384,
        512,
        [],
        "f751",
        "M0 208C0 104.4 75.7 18.5 174.9 2.6C184 1.2 192 8.6 192 17.9V81.2c0 8.4 6.5 15.3 14.7 16.5C307 112.5 384 199 384 303.4c0 103.6-75.7 189.5-174.9 205.4c-9.2 1.5-17.1-5.9-17.1-15.2V430.2c0-8.4-6.5-15.3-14.7-16.5C77 398.9 0 312.4 0 208zm288 48c0-53-43-96-96-96s-96 43-96 96s43 96 96 96s96-43 96-96zm-96 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$ac54ffffdb218383 = {
    prefix: "fas",
    iconName: "mound",
    icon: [
        576,
        512,
        [],
        "e52d",
        "M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48L144.1 179.2z"
    ]
};
var $8063e68b12ef6db0$export$a3a5de5f6e2513ba = {
    prefix: "fas",
    iconName: "toilet-portable",
    icon: [
        320,
        512,
        [],
        "e583",
        "M0 32V64H320V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zM24 96H0v24V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H272v8c0 13.3 10.7 24 24 24s24-10.7 24-24V120 96H296 24zM256 240v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$84021631df0f831b = {
    prefix: "fas",
    iconName: "compact-disc",
    icon: [
        512,
        512,
        [
            128191,
            128192,
            128440
        ],
        "f51f",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM256 224c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32zm-96 32c0 53 43 96 96 96s96-43 96-96s-43-96-96-96s-96 43-96 96zM96 240c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $8063e68b12ef6db0$export$148bcede94488555 = {
    prefix: "fas",
    iconName: "file-arrow-down",
    icon: [
        384,
        512,
        [
            "file-download"
        ],
        "f56d",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 232V334.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V232c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$1013b9966d758343 = $8063e68b12ef6db0$export$148bcede94488555;
var $8063e68b12ef6db0$export$afb5d0eee7c1bdb = {
    prefix: "fas",
    iconName: "caravan",
    icon: [
        640,
        512,
        [],
        "f8ff",
        "M0 112C0 67.8 35.8 32 80 32H416c88.4 0 160 71.6 160 160V352h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0H288c0 53-43 96-96 96s-96-43-96-96H80c-44.2 0-80-35.8-80-80V112zM320 352H448V256H416c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V160c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32V352zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96zm96 336c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
    ]
};
var $8063e68b12ef6db0$export$1639f087457d4f58 = {
    prefix: "fas",
    iconName: "shield-cat",
    icon: [
        512,
        512,
        [],
        "e572",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4h.2c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3h.2c5.8 0 10.4 4.7 10.4 10.4V272c0 53-43 96-96 96s-96-43-96-96V154.4zM216 288c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16zm96-16c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $8063e68b12ef6db0$export$6869964aa308dd31 = {
    prefix: "fas",
    iconName: "bolt",
    icon: [
        448,
        512,
        [
            9889,
            "zap"
        ],
        "f0e7",
        "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"
    ]
};
var $8063e68b12ef6db0$export$d62abb82664f55ca = $8063e68b12ef6db0$export$6869964aa308dd31;
var $8063e68b12ef6db0$export$b80f542550a05ea7 = {
    prefix: "fas",
    iconName: "glass-water",
    icon: [
        448,
        512,
        [],
        "e4f4",
        "M64 0C55.1 0 46.6 3.7 40.6 10.2s-9.1 15.2-8.5 24.1L60.9 437.7c3 41.9 37.8 74.3 79.8 74.3H307.3c42 0 76.8-32.4 79.8-74.3L415.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S392.9 0 384 0H64zm41 156.5L98.4 64H349.6L343 156.5l-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L105 156.5z"
    ]
};
var $8063e68b12ef6db0$export$b69c6757012a2267 = {
    prefix: "fas",
    iconName: "oil-well",
    icon: [
        576,
        512,
        [],
        "e532",
        "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l24.5 91.4L308.5 167.5l-6.3-18.1C297.7 136.6 285.6 128 272 128s-25.7 8.6-30.2 21.4l-13.6 39L96 222.6V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H406.7L340 257.5l-62.2 16.1L305.3 352H238.7L265 277l-74.6 19.3L137.3 448H96V288.8l337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32H327.7l11.2 32H205.1z"
    ]
};
var $8063e68b12ef6db0$export$4689a147513594a7 = {
    prefix: "fas",
    iconName: "vault",
    icon: [
        576,
        512,
        [],
        "e2c5",
        "M64 0C28.7 0 0 28.7 0 64V416c0 35.3 28.7 64 64 64H80l16 32h64l16-32H400l16 32h64l16-32h16c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 320c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zm0 80c-88.4 0-160-71.6-160-160s71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160zM480 221.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3z"
    ]
};
var $8063e68b12ef6db0$export$a9f5c0b9c1e77a6f = {
    prefix: "fas",
    iconName: "mars",
    icon: [
        448,
        512,
        [
            9794
        ],
        "f222",
        "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8H424c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80l0 0h0v0zM176 416c61.9 0 112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112s50.1 112 112 112z"
    ]
};
var $8063e68b12ef6db0$export$505476859b9691c0 = {
    prefix: "fas",
    iconName: "toilet",
    icon: [
        448,
        512,
        [
            128701
        ],
        "f7d8",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V196.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c14.2 17.7 31.1 31.3 48.5 41.8L65.6 469.9c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H352c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6c-1.8-1.5-3.7-3-5.6-4.4V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM384 256.3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8l0 .1 0 .3zM328.2 384l-.2 .5 0-.5h.2zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$94ef668f5108e431 = {
    prefix: "fas",
    iconName: "plane-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e557",
        "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $8063e68b12ef6db0$export$30f1437f5a4e991d = {
    prefix: "fas",
    iconName: "yen-sign",
    icon: [
        320,
        512,
        [
            165,
            "cny",
            "jpy",
            "rmb",
            "yen"
        ],
        "f157",
        "M58.6 46.2C48.8 31.5 29 27.6 14.2 37.4S-4.4 67 5.4 81.7L100.2 224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V288h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H219.8L314.6 81.7c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.2z"
    ]
};
var $8063e68b12ef6db0$export$268a23eee8f089a2 = $8063e68b12ef6db0$export$30f1437f5a4e991d;
var $8063e68b12ef6db0$export$5460a9192eb79bf5 = $8063e68b12ef6db0$export$30f1437f5a4e991d;
var $8063e68b12ef6db0$export$e2a8016afc962883 = $8063e68b12ef6db0$export$30f1437f5a4e991d;
var $8063e68b12ef6db0$export$cf914b1afb9455a2 = $8063e68b12ef6db0$export$30f1437f5a4e991d;
var $8063e68b12ef6db0$export$1ae0a94c8ba4131a = {
    prefix: "fas",
    iconName: "ruble-sign",
    icon: [
        384,
        512,
        [
            8381,
            "rouble",
            "rub",
            "ruble"
        ],
        "f158",
        "M96 32C78.3 32 64 46.3 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V320H240c79.5 0 144-64.5 144-144s-64.5-144-144-144H96zM240 256H128V96H240c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $8063e68b12ef6db0$export$c5dc3d98c4d8f2a5 = $8063e68b12ef6db0$export$1ae0a94c8ba4131a;
var $8063e68b12ef6db0$export$9c4d936240e1f0b1 = $8063e68b12ef6db0$export$1ae0a94c8ba4131a;
var $8063e68b12ef6db0$export$6c0cf65134387046 = $8063e68b12ef6db0$export$1ae0a94c8ba4131a;
var $8063e68b12ef6db0$export$2fa35dcbc038dbe9 = {
    prefix: "fas",
    iconName: "sun",
    icon: [
        512,
        512,
        [
            9728
        ],
        "f185",
        "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM352 256c0 53-43 96-96 96s-96-43-96-96s43-96 96-96s96 43 96 96zm32 0c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128z"
    ]
};
var $8063e68b12ef6db0$export$790dd5b32282b6fb = {
    prefix: "fas",
    iconName: "guitar",
    icon: [
        512,
        512,
        [],
        "f7a6",
        "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-77.5 77.6c-45.1-29.4-99.3-30.2-131 1.6c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6C-16 328.4-7.6 409.4 47.5 464.5s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c31.8-31.8 31-85.9 1.6-131l77.6-77.6 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM208 352c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $8063e68b12ef6db0$export$600a1b26b33c3d47 = {
    prefix: "fas",
    iconName: "face-laugh-wink",
    icon: [
        512,
        512,
        [
            "laugh-wink"
        ],
        "f59c",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM208.4 192c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm92.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
    ]
};
var $8063e68b12ef6db0$export$77ac40095f39933e = $8063e68b12ef6db0$export$600a1b26b33c3d47;
var $8063e68b12ef6db0$export$5bcca85203ebd1e8 = {
    prefix: "fas",
    iconName: "horse-head",
    icon: [
        512,
        512,
        [],
        "f7ab",
        "M0 464V316.9C0 208.5 68.3 111.8 170.5 75.6L340.2 15.5C361.6 7.9 384 23.8 384 46.4c0 11-5.5 21.2-14.6 27.3L336 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5c-16 16-37.8 25.1-60.5 25.1h-3.4c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4l-.1 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3l0 0c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8H48c-26.5 0-48-21.5-48-48zM328 224c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"
    ]
};
var $8063e68b12ef6db0$export$cd79eeea6201e9d4 = {
    prefix: "fas",
    iconName: "bore-hole",
    icon: [
        512,
        512,
        [],
        "e4c3",
        "M256 0c-17.7 0-32 14.3-32 32V296.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V32c0-17.7-14.3-32-32-32zM48 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H352V352c0 53-43 96-96 96s-96-43-96-96V128H48z"
    ]
};
var $8063e68b12ef6db0$export$5548c3eb51060fa8 = {
    prefix: "fas",
    iconName: "industry",
    icon: [
        512,
        512,
        [],
        "f275",
        "M32 32C14.3 32 0 46.3 0 64V304v48 80c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V304 152.2c0-18.2-19.4-29.7-35.4-21.1L320 215.4V152.2c0-18.2-19.4-29.7-35.4-21.1L128 215.4V64c0-17.7-14.3-32-32-32H32z"
    ]
};
var $8063e68b12ef6db0$export$531badb89cf01312 = {
    prefix: "fas",
    iconName: "circle-down",
    icon: [
        512,
        512,
        [
            61466,
            "arrow-alt-circle-down"
        ],
        "f358",
        "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM244.7 395.3l-112-112c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l64 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 64 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-112 112c-6.2 6.2-16.4 6.2-22.6 0z"
    ]
};
var $8063e68b12ef6db0$export$ff3afbc8c0bc5d59 = $8063e68b12ef6db0$export$531badb89cf01312;
var $8063e68b12ef6db0$export$b9d8fdf63999a76d = {
    prefix: "fas",
    iconName: "arrows-turn-to-dots",
    icon: [
        512,
        512,
        [],
        "e4c1",
        "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM512 384c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM64 64c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64S28.7 64 64 64z"
    ]
};
var $8063e68b12ef6db0$export$6248ec7440b2ffcb = {
    prefix: "fas",
    iconName: "florin-sign",
    icon: [
        384,
        512,
        [],
        "e184",
        "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h80L98.9 396.3c-5 11.9-16.6 19.7-29.5 19.7H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H69.3c38.8 0 73.7-23.3 88.6-59.1L213.3 288H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H240l45.1-108.3c5-11.9 16.6-19.7 29.5-19.7H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H314.7z"
    ]
};
var $8063e68b12ef6db0$export$a51c464b699200ae = {
    prefix: "fas",
    iconName: "arrow-down-short-wide",
    icon: [
        576,
        512,
        [
            "sort-amount-desc",
            "sort-amount-down-alt"
        ],
        "f884",
        "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$93835bc31892b5c3 = $8063e68b12ef6db0$export$a51c464b699200ae;
var $8063e68b12ef6db0$export$e7d80d8c226cb77 = $8063e68b12ef6db0$export$a51c464b699200ae;
var $8063e68b12ef6db0$export$7f24f1bf98af5411 = {
    prefix: "fas",
    iconName: "less-than",
    icon: [
        384,
        512,
        [
            62774
        ],
        "3c",
        "M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z"
    ]
};
var $8063e68b12ef6db0$export$4b5be0142d10f342 = {
    prefix: "fas",
    iconName: "angle-down",
    icon: [
        448,
        512,
        [
            8964
        ],
        "f107",
        "M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
var $8063e68b12ef6db0$export$ec5cfe409de2ed37 = {
    prefix: "fas",
    iconName: "car-tunnel",
    icon: [
        512,
        512,
        [],
        "e4de",
        "M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h64H384h64c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM384 512c-17.7 0-32-14.3-32-32V448H160v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V376c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7H313.6c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6V480c0 17.7-14.3 32-32 32zM190.8 277.5L177 320H335l-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5H198.4c-3.5 0-6.5 2.2-7.6 5.5zM168 408c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm200-24c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $8063e68b12ef6db0$export$3cd04b7c1624f598 = {
    prefix: "fas",
    iconName: "head-side-cough",
    icon: [
        640,
        512,
        [],
        "e061",
        "M0 201.7C0 90.3 90.3 0 201.7 0H224c95.2 0 174.2 69.3 189.4 160.1c2.2 13 6.7 25.7 15 36.1l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H416v32H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c0 35.3-28.7 64-64 64H288c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V375.8c0-17-7.1-33-17.5-46.4C18.3 293.2 0 246.5 0 201.7zM336 224c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm272 88c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm-40 24c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zm-64 48c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zm128 0c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zM608 504c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm-40-72c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$1412f35381064d7d = {
    prefix: "fas",
    iconName: "grip-lines",
    icon: [
        448,
        512,
        [],
        "f7a4",
        "M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"
    ]
};
var $8063e68b12ef6db0$export$aba24ca305bbe8c1 = {
    prefix: "fas",
    iconName: "thumbs-down",
    icon: [
        512,
        512,
        [
            128078,
            61576
        ],
        "f165",
        "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-25.3-19.5-46-44.3-47.9c7.7-8.5 12.3-19.8 12.3-32.1c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 320H96c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64V288c0 17.7 14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$d9b89b5872b67a4f = {
    prefix: "fas",
    iconName: "user-lock",
    icon: [
        640,
        512,
        [],
        "f502",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H392.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7H178.3zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $8063e68b12ef6db0$export$becbc35d3541bcc = {
    prefix: "fas",
    iconName: "arrow-right-long",
    icon: [
        512,
        512,
        [
            "long-arrow-right"
        ],
        "f178",
        "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
var $8063e68b12ef6db0$export$7ec6527cf8651899 = $8063e68b12ef6db0$export$becbc35d3541bcc;
var $8063e68b12ef6db0$export$f6773af4219eebd = {
    prefix: "fas",
    iconName: "anchor-circle-xmark",
    icon: [
        640,
        512,
        [],
        "e4ac",
        "M256 96c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm85.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $8063e68b12ef6db0$export$37fe3659ba7b6b54 = {
    prefix: "fas",
    iconName: "ellipsis",
    icon: [
        448,
        512,
        [
            "ellipsis-h"
        ],
        "f141",
        "M120 256c0 30.9-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56zm160 0c0 30.9-25.1 56-56 56s-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56zm104 56c-30.9 0-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56s-25.1 56-56 56z"
    ]
};
var $8063e68b12ef6db0$export$c9f2fedd4489a2ee = $8063e68b12ef6db0$export$37fe3659ba7b6b54;
var $8063e68b12ef6db0$export$3db75d5ac9e98468 = {
    prefix: "fas",
    iconName: "chess-pawn",
    icon: [
        320,
        512,
        [
            9823
        ],
        "f443",
        "M264 136c0 37.1-19.4 69.6-48.6 88H224c17.7 0 32 14.3 32 32s-14.3 32-32 32c0 96 24 128 24 128H72s24-32 24-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h8.5C75.4 205.6 56 173.1 56 136C56 78.6 102.6 32 160 32s104 46.6 104 104zM32 448H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$f04e7a0f1033a0cd = {
    prefix: "fas",
    iconName: "kit-medical",
    icon: [
        576,
        512,
        [
            "first-aid"
        ],
        "f479",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H96V32H64zm64 0V480H448V32H128zM512 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H480V480h32zM256 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V288H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h48V176z"
    ]
};
var $8063e68b12ef6db0$export$5b01ccb2da4c4387 = $8063e68b12ef6db0$export$f04e7a0f1033a0cd;
var $8063e68b12ef6db0$export$a77a2f6da72f89e3 = {
    prefix: "fas",
    iconName: "person-through-window",
    icon: [
        640,
        512,
        [],
        "e5a9",
        "M64 64l224 0 0 9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2l0 73.8s0 0 0 0H64V64zm288 0l224 0V384H508.3l-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-41-63.1c-.3-.5-.6-1-1-1.4c44.7-29 72.5-79 72.5-133.6l0-9.8zm73 320H379.2l42.7 64H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V400c0 26.5 21.5 48 48 48H308.2l33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L310.5 336l74.6 0 40 48zm-159.5 0H192s0 0 0 0l0-73.8c0-10.2 1.6-20.1 4.7-29.5L265.5 384zM192 128c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48z"
    ]
};
var $8063e68b12ef6db0$export$b34d64c205c732a9 = {
    prefix: "fas",
    iconName: "toolbox",
    icon: [
        512,
        512,
        [
            129520
        ],
        "f552",
        "M176 88v40H336V88c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V88c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56v40h28.1c12.7 0 24.9 5.1 33.9 14.1l51.9 51.9c9 9 14.1 21.2 14.1 33.9V304H384V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H192V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H0V227.9c0-12.7 5.1-24.9 14.1-33.9l51.9-51.9c9-9 21.2-14.1 33.9-14.1H128zM0 416V336H128v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H320v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H512v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z"
    ]
};
var $8063e68b12ef6db0$export$3aa81d0e606b08b6 = {
    prefix: "fas",
    iconName: "hands-holding-circle",
    icon: [
        640,
        512,
        [],
        "e4fb",
        "M320 256c-70.7 0-128-57.3-128-128S249.3 0 320 0s128 57.3 128 128s-57.3 128-128 128zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"
    ]
};
var $8063e68b12ef6db0$export$a18cfac400116d9f = {
    prefix: "fas",
    iconName: "bug",
    icon: [
        512,
        512,
        [],
        "f188",
        "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7 .7 1.3 1.4 1.9 2.1c14.2-7.3 30.4-11.4 47.5-11.4H312c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c0 24.6-5.5 47.8-15.4 68.6c2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6V240c0-8.8-7.2-16-16-16s-16 7.2-16 16V479.2c-34.5-3.4-65.8-17.8-90.3-39.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96.3c1.1-14.1 5-27.5 11.1-39.5c-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $8063e68b12ef6db0$export$3e7437bf6535bef0 = {
    prefix: "fas",
    iconName: "credit-card",
    icon: [
        576,
        512,
        [
            128179,
            62083,
            "credit-card-alt"
        ],
        "f09d",
        "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
    ]
};
var $8063e68b12ef6db0$export$5fffe8e3c36964a2 = $8063e68b12ef6db0$export$3e7437bf6535bef0;
var $8063e68b12ef6db0$export$9eefe7fcdf123b76 = {
    prefix: "fas",
    iconName: "car",
    icon: [
        512,
        512,
        [
            128664,
            "automobile"
        ],
        "f1b9",
        "M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm288 32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$240a6c53cf7ac525 = $8063e68b12ef6db0$export$9eefe7fcdf123b76;
var $8063e68b12ef6db0$export$6638511b28df3be5 = {
    prefix: "fas",
    iconName: "hand-holding-hand",
    icon: [
        576,
        512,
        [],
        "e4f7",
        "M7.8 207.7c-13.1-17.8-9.3-42.8 8.5-55.9L142.9 58.5C166.2 41.3 194.5 32 223.5 32H384 544c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H507.2l-44.9 36c-22.7 18.2-50.9 28-80 28H304 288 224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H183.4L63.7 216.2c-17.8 13.1-42.8 9.3-55.9-8.5zM382.4 160l0 0 .9 0c-.3 0-.6 0-.9 0zM568.2 304.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 453.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 352l0 0-.9 0c.3 0 .6 0 .9 0z"
    ]
};
var $8063e68b12ef6db0$export$cb6e40528b98a5b = {
    prefix: "fas",
    iconName: "book-open-reader",
    icon: [
        512,
        512,
        [
            "book-reader"
        ],
        "f5da",
        "M352 96c0 53-43 96-96 96s-96-43-96-96s43-96 96-96s96 43 96 96zM240 248V512l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32H62.3c63.6 0 125.6 19.6 177.7 56zm32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32V427c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z"
    ]
};
var $8063e68b12ef6db0$export$cee14fe33262fa7d = $8063e68b12ef6db0$export$cb6e40528b98a5b;
var $8063e68b12ef6db0$export$af9eaee7db3ba7a9 = {
    prefix: "fas",
    iconName: "mountain-sun",
    icon: [
        640,
        512,
        [],
        "e52f",
        "M560 160c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zM55.9 512H381.1h75H578.9c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1C0 487 25 512 55.9 512z"
    ]
};
var $8063e68b12ef6db0$export$a63cecc8a4166c49 = {
    prefix: "fas",
    iconName: "arrows-left-right-to-line",
    icon: [
        640,
        512,
        [],
        "e4ba",
        "M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$b06003a02c9055bd = {
    prefix: "fas",
    iconName: "dice-d20",
    icon: [
        512,
        512,
        [],
        "f6cf",
        "M64.7 125.8l53.2 31.9c7.8 4.7 17.8 2 22.2-5.9L217.6 12.1c3-5.4-.9-12.1-7.1-12.1c-1.6 0-3.2 .5-4.6 1.4L63.9 98.8c-9.6 6.6-9.2 20.9 .8 26.9zM32 171.7V295.3c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L56.2 158C45.6 151.6 32 159.3 32 171.7zM326.4 12.1l77.6 139.6c4.4 7.9 14.5 10.6 22.2 5.9l53.2-31.9c10-6 10.4-20.3 .8-26.9L338.1 1.4c-1.4-.9-3-1.4-4.6-1.4c-6.2 0-10.1 6.7-7.1 12.1zM512 171.7c0-12.4-13.6-20.1-24.2-13.7l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4V171.7zm-49.3 246L302.1 436.6c-8.1 .9-14.1 7.8-14.1 15.9v52.8c0 3.7 3 6.8 6.8 6.8c.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5c0-9.3-8.1-16.5-17.3-15.4zM249.2 512c3.7 0 6.8-3 6.8-6.8V452.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4c0 6.5 4 12.3 10.1 14.5l172.7 64c.8 .3 1.6 .4 2.4 .4zM57.7 382.9l170.9 20.2c7.8 .9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L46.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7zm439.6-24.8L418.9 238.1c-6.5-10-21.4-9.6-27.3 .8L306.2 388.5c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20c11.8-1.4 18-14.7 11.5-24.6zm-216.9 11l78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9H199.1c-12.3 0-20 13.3-13.9 23.9l78.4 137.2c3.7 6.4 13 6.4 16.7 0zM190.4 176H353.6c12.2 0 19.9-13.1 14-23.8l-80-144c-2.8-5.1-8.2-8.2-14-8.2h-3.2c-5.8 0-11.2 3.2-14 8.2l-80 144c-5.9 10.7 1.8 23.8 14 23.8z"
    ]
};
var $8063e68b12ef6db0$export$41ce20639e8fef2b = {
    prefix: "fas",
    iconName: "truck-droplet",
    icon: [
        640,
        512,
        [],
        "e58c",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm368-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM208 272c39.8 0 72-29.6 72-66c0-27-39.4-82.9-59.9-110.3c-6.1-8.2-18.1-8.2-24.2 0C175.4 123 136 179 136 206c0 36.5 32.2 66 72 66z"
    ]
};
var $8063e68b12ef6db0$export$e4686afbe882e24a = {
    prefix: "fas",
    iconName: "file-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e5a1",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 384c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm59.3-180.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
    ]
};
var $8063e68b12ef6db0$export$d7a5da41ce01461d = {
    prefix: "fas",
    iconName: "temperature-arrow-up",
    icon: [
        512,
        512,
        [
            "temperature-up"
        ],
        "e040",
        "M96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.1 32 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.3-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.1 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM448 160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V160z"
    ]
};
var $8063e68b12ef6db0$export$872345a0157330a3 = $8063e68b12ef6db0$export$d7a5da41ce01461d;
var $8063e68b12ef6db0$export$b48a5be96314835a = {
    prefix: "fas",
    iconName: "medal",
    icon: [
        512,
        512,
        [
            127941
        ],
        "f5a2",
        "M16 0H144c5.3 0 10.3 2.7 13.3 7.1l81.1 121.6c-49.5 4.1-94 25.6-127.6 58.3L2.7 24.9C-.6 20-.9 13.7 1.9 8.5S10.1 0 16 0zM509.3 24.9L401.2 187.1c-33.5-32.7-78.1-54.2-127.6-58.3L354.7 7.1c3-4.5 8-7.1 13.3-7.1H496c5.9 0 11.3 3.2 14.1 8.5s2.5 11.5-.8 16.4zM432 336c0 97.2-78.8 176-176 176s-176-78.8-176-176s78.8-176 176-176s176 78.8 176 176zM264.4 241.1c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"
    ]
};
var $8063e68b12ef6db0$export$f24e0fce77994d4d = {
    prefix: "fas",
    iconName: "bed",
    icon: [
        640,
        512,
        [
            128716
        ],
        "f236",
        "M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zM176 288c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $8063e68b12ef6db0$export$51e3c5be06a49e32 = {
    prefix: "fas",
    iconName: "square-h",
    icon: [
        448,
        512,
        [
            "h-square"
        ],
        "f0fd",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM336 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H160l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H288V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$f08bbcf8f59eafc2 = $8063e68b12ef6db0$export$51e3c5be06a49e32;
var $8063e68b12ef6db0$export$5c0b4709125e92f8 = {
    prefix: "fas",
    iconName: "podcast",
    icon: [
        448,
        512,
        [],
        "f2ce",
        "M319.4 372c48.5-31.3 80.6-85.9 80.6-148c0-97.2-78.8-176-176-176S48 126.8 48 224c0 62.1 32.1 116.6 80.6 148c1.2 17.3 4 38 7.2 57.1l.2 1C56 395.8 0 316.5 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 92.5-56 171.9-136 206.1l.2-1.1c3.1-19.2 6-39.8 7.2-57zm-2.3-38.1c-1.6-5.7-3.9-11.1-7-16.2c-5.8-9.7-13.5-17-21.9-22.4c19.5-17.6 31.8-43 31.8-71.3c0-53-43-96-96-96s-96 43-96 96c0 28.3 12.3 53.8 31.8 71.3c-8.4 5.4-16.1 12.7-21.9 22.4c-3.1 5.1-5.4 10.5-7 16.2C99.8 307.5 80 268 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 44-19.8 83.5-50.9 109.9zM224 312c32.9 0 64 8.6 64 43.8c0 33-12.9 104.1-20.6 132.9c-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4c-7.8-28.5-20.6-99.7-20.6-132.8c0-35.1 31.1-43.8 64-43.8zm0-32c-30.9 0-56-25.1-56-56s25.1-56 56-56s56 25.1 56 56s-25.1 56-56 56z"
    ]
};
var $8063e68b12ef6db0$export$bf4d97a79734997f = {
    prefix: "fas",
    iconName: "temperature-full",
    icon: [
        320,
        512,
        [
            "temperature-4",
            "thermometer-4",
            "thermometer-full"
        ],
        "f2c7",
        "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $8063e68b12ef6db0$export$db946f8dc50a57ca = $8063e68b12ef6db0$export$bf4d97a79734997f;
var $8063e68b12ef6db0$export$92b2e2293472dd50 = $8063e68b12ef6db0$export$bf4d97a79734997f;
var $8063e68b12ef6db0$export$74e07083cef79a6f = $8063e68b12ef6db0$export$bf4d97a79734997f;
var $8063e68b12ef6db0$export$9b6162797ab1b255 = {
    prefix: "fas",
    iconName: "bell",
    icon: [
        448,
        512,
        [
            128276,
            61602
        ],
        "f0f3",
        "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
    ]
};
var $8063e68b12ef6db0$export$4fa56a54e822dd25 = {
    prefix: "fas",
    iconName: "superscript",
    icon: [
        512,
        512,
        [],
        "f12b",
        "M480 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 73.5 404.3 80 416 80v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V32zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32z"
    ]
};
var $8063e68b12ef6db0$export$12ef959394d63192 = {
    prefix: "fas",
    iconName: "plug-circle-xmark",
    icon: [
        576,
        512,
        [],
        "e560",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $8063e68b12ef6db0$export$aa3c4c1c5a47bf98 = {
    prefix: "fas",
    iconName: "star-of-life",
    icon: [
        512,
        512,
        [],
        "f621",
        "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V172.9l122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.5 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V339.1L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4V32z"
    ]
};
var $8063e68b12ef6db0$export$4c60a3aade08b6c2 = {
    prefix: "fas",
    iconName: "phone-slash",
    icon: [
        640,
        512,
        [],
        "f3dd",
        "M601.2 5.1c10.4-8.2 25.5-6.3 33.7 4.1s6.3 25.5-4.1 33.7l-592 464c-10.4 8.2-25.5 6.3-33.7-4.1s-6.3-25.5 4.1-33.7l155.6-122C101.8 270 64 171.4 64 64c0-18 12.1-33.8 29.5-38.6l88-24c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L208 207.3c12 25.5 27.2 49.2 45 70.7L601.2 5.1zM325.7 343.7c13.7 9.1 28 17.3 43 24.3L409 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C545.8 499.9 530 512 512 512c-104.9 0-201.3-36-277.7-96.4l91.3-72z"
    ]
};
var $8063e68b12ef6db0$export$d1de8d1b815d6a5 = {
    prefix: "fas",
    iconName: "paint-roller",
    icon: [
        512,
        512,
        [],
        "f5aa",
        "M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 352c0-17.7 14.3-32 32-32V304c0-44.2 35.8-80 80-80H416c17.7 0 32-14.3 32-32V160 69.5c37.3 13.2 64 48.7 64 90.5v32c0 53-43 96-96 96H272c-8.8 0-16 7.2-16 16v16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V352z"
    ]
};
var $8063e68b12ef6db0$export$503f458ca5cf64c2 = {
    prefix: "fas",
    iconName: "handshake-angle",
    icon: [
        640,
        512,
        [
            "hands-helping"
        ],
        "f4c4",
        "M543.9 251.4c0-1.1 .1-2.2 .1-3.4c0-48.6-39.4-88-88-88l-40 0H320l-16 0 0 0v16 72c0 22.1-17.9 40-40 40s-40-17.9-40-40V128h.4c4-36 34.5-64 71.6-64H408c2.8 0 5.6 .2 8.3 .5l40.1-40.1c21.9-21.9 57.3-21.9 79.2 0l78.1 78.1c21.9 21.9 21.9 57.3 0 79.2l-69.7 69.7zM192 128V248c0 39.8 32.2 72 72 72s72-32.2 72-72V192h80l40 0c30.9 0 56 25.1 56 56c0 27.2-19.4 49.9-45.2 55c8.2 8.6 13.2 20.2 13.2 33c0 26.5-21.5 48-48 48h-2.7c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48H224c-.9 0-1.8 0-2.7-.1l-37.7 37.7c-21.9 21.9-57.3 21.9-79.2 0L26.3 407.6c-21.9-21.9-21.9-57.3 0-79.2L96 258.7V224c0-53 43-96 96-96z"
    ]
};
var $8063e68b12ef6db0$export$287dbb1632da0d44 = $8063e68b12ef6db0$export$503f458ca5cf64c2;
var $8063e68b12ef6db0$export$90a475e93ff4bb8a = {
    prefix: "fas",
    iconName: "location-dot",
    icon: [
        384,
        512,
        [
            "map-marker-alt"
        ],
        "f3c5",
        "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 256c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z"
    ]
};
var $8063e68b12ef6db0$export$4be92fa780613f93 = $8063e68b12ef6db0$export$90a475e93ff4bb8a;
var $8063e68b12ef6db0$export$cad54bead856a678 = {
    prefix: "fas",
    iconName: "file",
    icon: [
        384,
        512,
        [
            128196,
            128459,
            61462
        ],
        "f15b",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z"
    ]
};
var $8063e68b12ef6db0$export$da07b6bc24a496ca = {
    prefix: "fas",
    iconName: "greater-than",
    icon: [
        384,
        512,
        [
            62769
        ],
        "3e",
        "M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z"
    ]
};
var $8063e68b12ef6db0$export$3fb4da6af843d39f = {
    prefix: "fas",
    iconName: "person-swimming",
    icon: [
        576,
        512,
        [
            127946,
            "swimmer"
        ],
        "f5c4",
        "M309.5 178.4L447.9 297.1c-1.6 .9-3.2 2-4.8 3c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-26.9 0-52.3 6.6-74.5 18.4zM32 160c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64zM306.5 325.9C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $8063e68b12ef6db0$export$67daf2e2f88c1365 = $8063e68b12ef6db0$export$3fb4da6af843d39f;
var $8063e68b12ef6db0$export$9686eff8d817f770 = {
    prefix: "fas",
    iconName: "arrow-down",
    icon: [
        384,
        512,
        [
            8595
        ],
        "f063",
        "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
var $8063e68b12ef6db0$export$cc1b6e60cb98fb90 = {
    prefix: "fas",
    iconName: "droplet",
    icon: [
        384,
        512,
        [
            128167,
            "tint"
        ],
        "f043",
        "M192 496c97.2 0 176-78.8 176-176c0-74.1-102.3-230.6-150.9-300.7c-12.3-17.7-37.8-17.7-50.1 0C118.3 89.4 16 245.9 16 320c0 97.2 78.8 176 176 176zM112 320c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$60dd975bd5938c15 = $8063e68b12ef6db0$export$cc1b6e60cb98fb90;
var $8063e68b12ef6db0$export$e7fc4fe34e767f28 = {
    prefix: "fas",
    iconName: "eraser",
    icon: [
        576,
        512,
        [],
        "f12d",
        "M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H288h9.4H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416H288l-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"
    ]
};
var $8063e68b12ef6db0$export$9c4218a898614082 = {
    prefix: "fas",
    iconName: "earth-americas",
    icon: [
        512,
        512,
        [
            127758,
            "earth",
            "earth-america",
            "globe-americas"
        ],
        "f57d",
        "M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zm48 0c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"
    ]
};
var $8063e68b12ef6db0$export$c2118d3775773870 = $8063e68b12ef6db0$export$9c4218a898614082;
var $8063e68b12ef6db0$export$8b0f3a26397cf632 = $8063e68b12ef6db0$export$9c4218a898614082;
var $8063e68b12ef6db0$export$e96bcc7bde9498db = $8063e68b12ef6db0$export$9c4218a898614082;
var $8063e68b12ef6db0$export$ae02241644924482 = {
    prefix: "fas",
    iconName: "person-burst",
    icon: [
        640,
        512,
        [],
        "e53b",
        "M480 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H465.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L408 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
    ]
};
var $8063e68b12ef6db0$export$a1ab1e69a300089f = {
    prefix: "fas",
    iconName: "dove",
    icon: [
        512,
        512,
        [
            128330
        ],
        "f4ba",
        "M160.8 96.5c14 17 31 30.9 49.5 42.2c25.9 15.8 53.7 25.9 77.7 31.6V138.8C265.8 108.5 250 71.5 248.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8c-13.3 15.4-32.7 44.6-48.4 87.2zM320 144v30.6l0 0v1.3l0 0 0 32.1c-60.8-5.1-185-43.8-219.3-157.2C97.4 40 87.9 32 76.6 32c-7.9 0-15.3 3.9-18.8 11C46.8 65.9 32 112.1 32 176c0 116.9 80.1 180.5 118.4 202.8L11.8 416.6C6.7 418 2.6 421.8 .9 426.8s-.8 10.6 2.3 14.8C21.7 466.2 77.3 512 160 512c3.6 0 7.2-1.2 10-3.5L245.6 448H320c88.4 0 160-71.6 160-160V128l29.9-44.9c1.3-2 2.1-4.4 2.1-6.8c0-6.8-5.5-12.3-12.3-12.3H400c-44.2 0-80 35.8-80 80zm80 16c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16z"
    ]
};
var $8063e68b12ef6db0$export$1344b64f6e922e12 = {
    prefix: "fas",
    iconName: "battery-empty",
    icon: [
        576,
        512,
        [
            "battery-0"
        ],
        "f244",
        "M80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zM64 176c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176z"
    ]
};
var $8063e68b12ef6db0$export$de8d0338927394c1 = $8063e68b12ef6db0$export$1344b64f6e922e12;
var $8063e68b12ef6db0$export$8d36a54dbf1e6bce = {
    prefix: "fas",
    iconName: "socks",
    icon: [
        512,
        512,
        [
            129510
        ],
        "f696",
        "M175.2 476.6c-9.7-18-15.2-38.7-15.2-60.6c0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6V96H128V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2zM128 64H288V48c0-14.5 3.9-28.2 10.7-39.9C291 3 281.9 0 272 0H176c-26.5 0-48 21.5-48 48V64zM320 96V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304V96H320zM512 64V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48V64H512z"
    ]
};
var $8063e68b12ef6db0$export$366b69cbdce46334 = {
    prefix: "fas",
    iconName: "inbox",
    icon: [
        512,
        512,
        [],
        "f01c",
        "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"
    ]
};
var $8063e68b12ef6db0$export$a6f4f4a005d91fbd = {
    prefix: "fas",
    iconName: "section",
    icon: [
        320,
        512,
        [],
        "e447",
        "M96.9 96c2.1-11.6 8.7-19.8 21.1-25.4c13.8-6.2 34.8-8.9 61.2-4.5c8.8 1.4 36.1 7.1 44.1 9.3c17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8c-34.7-5.7-69.4-3.6-98 9.3c-29.8 13.5-52.2 38.6-58 74.1c-.1 .5-.2 1.1-.2 1.6c-2.2 19.7 .3 37.9 8.1 54.1c7.7 16.1 19.4 28 32 36.9c.6 .5 1.3 .9 2 1.4C54.3 194.2 38.5 215.1 33.7 243c-.1 .6-.2 1.1-.2 1.7c-2.3 19.3 .4 37.1 8.4 53c7.9 15.6 19.8 27 32.3 35.5c22.4 15.2 51.9 24 75.4 31l0 0 3.7 1.1c27.2 8.2 46.9 14.6 59.4 23.8c5.5 4 8.2 7.6 9.5 10.9c1.3 3.2 2.6 8.6 .9 18.1c-1.7 10.1-7.7 18-20.7 23.5c-14 6-35.4 8.5-62 4.4c-12.8-2.1-35.1-9.7-54.1-16.2l0 0c-4.3-1.5-8.5-2.9-12.3-4.2c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c2.6 .8 5.7 1.9 9.2 3.1c18.6 6.3 48.5 16.6 67.3 19.6l0 0 .2 0c34.5 5.4 68.8 3.4 97.2-8.7c29.4-12.6 52.5-36.5 58.5-71.5c3.3-19.3 1.9-37.4-5-53.9c-6.3-15-16.4-26.4-27.6-35.2c16.5-13.9 28.5-33.2 32.6-58.2c3.2-19.8 1.9-38.3-4.8-55.1c-6.7-16.8-17.8-29.4-30.2-39c-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25c-6.1-4.4-9.5-8.5-11.4-12.4c-1.8-3.7-3.2-9.3-2.3-18.5zm76.7 208.5c-.2-.1-.4-.1-.6-.2l-1.4-.4c-27.4-8.2-47.9-14.5-61.7-23.8c-6.2-4.2-9.3-7.9-11-11.3c-1.5-3-2.9-7.7-2.1-15.7c1.9-9.7 7.9-17.3 20.5-22.7c14-6 35.4-8.5 62.1-4.3l16.4 2.6c6.3 2.9 11.7 6 16.2 9.5c5.5 4.2 8.4 8.2 10 12.2c1.6 4 2.8 10.4 1.1 20.9c-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3z"
    ]
};
var $8063e68b12ef6db0$export$d262c1f5912046e6 = {
    prefix: "fas",
    iconName: "gauge-high",
    icon: [
        512,
        512,
        [
            62461,
            "tachometer-alt",
            "tachometer-alt-fast"
        ],
        "f625",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM96 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm352-32c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $8063e68b12ef6db0$export$38dd17b9f064c10f = $8063e68b12ef6db0$export$d262c1f5912046e6;
var $8063e68b12ef6db0$export$e99d8b85f35b8ca5 = $8063e68b12ef6db0$export$d262c1f5912046e6;
var $8063e68b12ef6db0$export$f5c53ce8ec380d11 = {
    prefix: "fas",
    iconName: "envelope-open-text",
    icon: [
        512,
        512,
        [],
        "f658",
        "M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM176 160H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$7a76c9d35b42d691 = {
    prefix: "fas",
    iconName: "hospital",
    icon: [
        640,
        512,
        [
            127973,
            62589,
            "hospital-alt",
            "hospital-wide"
        ],
        "f0f8",
        "M192 48c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48V512H368V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H192V48zM48 96H160V512H48c-26.5 0-48-21.5-48-48V320H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V224H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V144c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v48H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V464c0 26.5-21.5 48-48 48H480V96H592zM312 64c-8.8 0-16 7.2-16 16v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152h24c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H344V80c0-8.8-7.2-16-16-16H312z"
    ]
};
var $8063e68b12ef6db0$export$cea7736417b94a3b = $8063e68b12ef6db0$export$7a76c9d35b42d691;
var $8063e68b12ef6db0$export$69c8cc0360f017e8 = $8063e68b12ef6db0$export$7a76c9d35b42d691;
var $8063e68b12ef6db0$export$770be8b3d5776043 = {
    prefix: "fas",
    iconName: "wine-bottle",
    icon: [
        512,
        512,
        [],
        "f72f",
        "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3c-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5-48.8 48.8c-9.2 9.2-11.5 22.9-8.6 35.6c9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5L180.2 153.3c31.9-31.9 76.6-43.1 117.5-33.8c12.6 2.9 26.4 .5 35.5-8.6l48.8-48.8 9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2zM99.3 347.3l65.4 65.4c6.2 6.2 16.4 6.2 22.6 0l97.4-97.4c6.2-6.2 6.2-16.4 0-22.6l-65.4-65.4c-6.2-6.2-16.4-6.2-22.6 0L99.3 324.7c-6.2 6.2-6.2 16.4 0 22.6z"
    ]
};
var $8063e68b12ef6db0$export$5d65c40a109eb09c = {
    prefix: "fas",
    iconName: "chess-rook",
    icon: [
        384,
        512,
        [
            9820
        ],
        "f447",
        "M0 204.2V48c0-8.8 7.2-16 16-16H72c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h56c8.8 0 16 7.2 16 16V204.2c0 12.1-6.8 23.2-17.7 28.6l-28.6 14.3c-10.8 5.4-17.7 16.5-17.5 28.6C322.2 360.7 336 416 336 416H48s13.8-55.3 15.8-140.2c.3-12.1-6.6-23.2-17.5-28.6L17.7 232.8C6.8 227.4 0 216.3 0 204.2zM176 320h32c8.8 0 16-7.2 16-16V256c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 8.8 7.2 16 16 16zM32 448H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$2f8a7938c06a2142 = {
    prefix: "fas",
    iconName: "bars-staggered",
    icon: [
        512,
        512,
        [
            "reorder",
            "stream"
        ],
        "f550",
        "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$75d2bb378a2fc102 = $8063e68b12ef6db0$export$2f8a7938c06a2142;
var $8063e68b12ef6db0$export$ed81ab40fc4e904 = $8063e68b12ef6db0$export$2f8a7938c06a2142;
var $8063e68b12ef6db0$export$45cbd92c28deb2c7 = {
    prefix: "fas",
    iconName: "dharmachakra",
    icon: [
        512,
        512,
        [
            9784
        ],
        "f655",
        "M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.6-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 288c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$9fae219b4d3ce0be = {
    prefix: "fas",
    iconName: "hotdog",
    icon: [
        512,
        512,
        [
            127789
        ],
        "f80f",
        "M488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zM443.3 92.7c-6.2-6.2-16.4-6.2-22.6 0c-12.5 12.5-23.8 15.1-37.5 17.6l-2.5 .4c-13.8 2.5-31.6 5.6-48 22c-16.7 16.7-20.9 36-24.1 50.9l0 0v0l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1c-9.2 9.2-18 10.8-32.7 13.4l0 0-.9 .2c-15.6 2.8-34.9 6.9-54.4 26.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22c16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1c9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4c6.2-6.2 6.2-16.4 0-22.6zM191.2 479.2l288-288L495 207c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L289 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-15.8-15.8zM17 305C6.1 294.1 0 279.4 0 264s6.1-30.1 17-41L223 17C233.9 6.1 248.6 0 264 0s30.1 6.1 41 17l15.8 15.8-288 288L17 305z"
    ]
};
var $8063e68b12ef6db0$export$2ffee5b2bc935c1f = {
    prefix: "fas",
    iconName: "person-walking-with-cane",
    icon: [
        512,
        512,
        [
            "blind"
        ],
        "f29d",
        "M176 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-8.4 32c-36.4 0-69.6 20.5-85.9 53.1L35.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L128 231.6v43.2c0 17 6.7 33.3 18.7 45.3L224 397.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V390.6c0-12.7-5.1-24.9-14.1-33.9L224 306.7V213.3l70.4 93.9c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8L268.8 166.4C250.7 142.2 222.2 128 192 128H167.6zM128.3 346.8L97 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.2-52.8-52.8zM450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L358.9 316.1c-2.8 3.8-6.1 7.3-10.1 10.3c-5 3.8-10.5 6.4-16.2 7.9L450.8 505.1z"
    ]
};
var $8063e68b12ef6db0$export$923de21def6ea9b6 = $8063e68b12ef6db0$export$2ffee5b2bc935c1f;
var $8063e68b12ef6db0$export$5b9205e1042594b7 = {
    prefix: "fas",
    iconName: "drum",
    icon: [
        576,
        512,
        [
            129345
        ],
        "f569",
        "M533.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L402.2 104.5C367.8 98.7 329 96 288 96C146.6 96 32 128 32 208V368c0 31.3 27.4 58.8 72 78.7V344c0-13.3 10.7-24 24-24s24 10.7 24 24V463.4c33 8.9 71.1 14.5 112 16.1V376c0-13.3 10.7-24 24-24s24 10.7 24 24V479.5c40.9-1.6 79-7.2 112-16.1V344c0-13.3 10.7-24 24-24s24 10.7 24 24V446.7c44.6-19.9 72-47.4 72-78.7V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM339.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C490.4 181.8 496 197.4 496 208c0 .8-2.7 17.2-46 35.9C411.1 260.7 354 272 288 272s-123.1-11.3-162-28.1C82.7 225.2 80 208.8 80 208c0-10.6 5.6-26.2 44.4-41.3C162.6 151.9 219.8 144 288 144c18 0 35.1 .5 51.4 1.6z"
    ]
};
var $8063e68b12ef6db0$export$dd52741c60cc638f = {
    prefix: "fas",
    iconName: "ice-cream",
    icon: [
        384,
        512,
        [
            127848
        ],
        "f810",
        "M335.1 160c.6-5.3 .9-10.6 .9-16C336 64.5 271.5 0 192 0S48 64.5 48 144c0 5.4 .3 10.7 .9 16H48c-26.5 0-48 21.5-48 48s21.5 48 48 48h53.5 181H336c26.5 0 48-21.5 48-48s-21.5-48-48-48h-.9zM64 288L168.8 497.7c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3L320 288H64z"
    ]
};
var $8063e68b12ef6db0$export$2a376a9d0d8fee96 = {
    prefix: "fas",
    iconName: "heart-circle-bolt",
    icon: [
        576,
        512,
        [],
        "e4fc",
        "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
var $8063e68b12ef6db0$export$b5698497901d7197 = {
    prefix: "fas",
    iconName: "fax",
    icon: [
        512,
        512,
        [
            128224,
            128439
        ],
        "f1ac",
        "M128 64v96h64V64H386.7L416 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0H192c-35.3 0-64 28.7-64 64zM0 160V480c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm480 32H128V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM256 320c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm160-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM384 448c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm-96-32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$dec46f8df1860e0 = {
    prefix: "fas",
    iconName: "paragraph",
    icon: [
        448,
        512,
        [
            182
        ],
        "f1dd",
        "M192 32h64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352H288V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192c-88.4 0-160-71.6-160-160s71.6-160 160-160z"
    ]
};
var $8063e68b12ef6db0$export$6999832247e52c2b = {
    prefix: "fas",
    iconName: "check-to-slot",
    icon: [
        576,
        512,
        [
            "vote-yea"
        ],
        "f772",
        "M96 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V384H96V80zm313 47c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L409 161c9.4-9.4 9.4-24.6 0-33.9zM0 336c0-26.5 21.5-48 48-48H64V416H512V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336z"
    ]
};
var $8063e68b12ef6db0$export$e87bb3db1608b850 = $8063e68b12ef6db0$export$6999832247e52c2b;
var $8063e68b12ef6db0$export$228008b5e11032fa = {
    prefix: "fas",
    iconName: "star-half",
    icon: [
        576,
        512,
        [
            61731
        ],
        "f089",
        "M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8V0zM429.9 512c1.1 .1 2.1 .1 3.2 0h-3.2z"
    ]
};
var $8063e68b12ef6db0$export$2088efcf62cf3b1 = {
    prefix: "fas",
    iconName: "boxes-stacked",
    icon: [
        576,
        512,
        [
            62625,
            "boxes",
            "boxes-alt"
        ],
        "f468",
        "M160 48c0-26.5 21.5-48 48-48h48V80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V0h48c26.5 0 48 21.5 48 48V176c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48zM48 288H96v80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V288h48c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zm320 0h48v80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V288h48c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48z"
    ]
};
var $8063e68b12ef6db0$export$2007320dd6cde6db = $8063e68b12ef6db0$export$2088efcf62cf3b1;
var $8063e68b12ef6db0$export$e6ef1d896ed63b3e = $8063e68b12ef6db0$export$2088efcf62cf3b1;
var $8063e68b12ef6db0$export$88bc01ff8dbecc55 = {
    prefix: "fas",
    iconName: "link",
    icon: [
        640,
        512,
        [
            128279,
            "chain"
        ],
        "f0c1",
        "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
    ]
};
var $8063e68b12ef6db0$export$b5d071e02a25554f = $8063e68b12ef6db0$export$88bc01ff8dbecc55;
var $8063e68b12ef6db0$export$837bc776b490934d = {
    prefix: "fas",
    iconName: "ear-listen",
    icon: [
        512,
        512,
        [
            "assistive-listening-systems"
        ],
        "f2a2",
        "M398.3 3.4c-15.8-7.9-35-1.5-42.9 14.3c-7.9 15.8-1.5 34.9 14.2 42.9l.4 .2c.4 .2 1.1 .6 2.1 1.2c2 1.2 5 3 8.7 5.6c7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7C441.6 33.2 427.7 22.2 417.3 15c-5.3-3.7-9.7-6.4-13-8.3c-1.6-1-3-1.7-4-2.2c-.5-.3-.9-.5-1.2-.7l-.4-.2-.2-.1-.1 0 0 0c0 0 0 0-14.3 28.6L398.3 3.4zM128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78V400c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112v-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM32 512c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM192 352c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $8063e68b12ef6db0$export$8eeef3dc0035b165 = $8063e68b12ef6db0$export$837bc776b490934d;
var $8063e68b12ef6db0$export$ad95e4f80f98ebe0 = {
    prefix: "fas",
    iconName: "tree-city",
    icon: [
        640,
        512,
        [],
        "e587",
        "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM224 160c0 6-1 11-2 16c20 14 34 38 34 64c0 45-36 80-80 80H160V480c0 18-15 32-32 32c-18 0-32-14-32-32V320H80c-45 0-80-35-80-80c0-26 13-50 33-64c-1-5-1-10-1-16c0-53 42-96 96-96c53 0 96 43 96 96z"
    ]
};
var $8063e68b12ef6db0$export$436587205947bca5 = {
    prefix: "fas",
    iconName: "play",
    icon: [
        384,
        512,
        [
            9654
        ],
        "f04b",
        "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
    ]
};
var $8063e68b12ef6db0$export$a5dc297d3f60936 = {
    prefix: "fas",
    iconName: "font",
    icon: [
        448,
        512,
        [],
        "f031",
        "M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48H303.8l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H390.2L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z"
    ]
};
var $8063e68b12ef6db0$export$fe44d4c71644ea0 = {
    prefix: "fas",
    iconName: "rupiah-sign",
    icon: [
        512,
        512,
        [],
        "e23d",
        "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256-96h80c61.9 0 112 50.1 112 112s-50.1 112-112 112H352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352 192c0-17.7 14.3-32 32-32zm80 160c26.5 0 48-21.5 48-48s-21.5-48-48-48H352v96h48z"
    ]
};
var $8063e68b12ef6db0$export$34c8b97060c09ff = {
    prefix: "fas",
    iconName: "magnifying-glass",
    icon: [
        512,
        512,
        [
            128269,
            "search"
        ],
        "f002",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"
    ]
};
var $8063e68b12ef6db0$export$871a78837687ffe8 = $8063e68b12ef6db0$export$34c8b97060c09ff;
var $8063e68b12ef6db0$export$eabe53838d45ac6a = {
    prefix: "fas",
    iconName: "table-tennis-paddle-ball",
    icon: [
        512,
        512,
        [
            127955,
            "ping-pong-paddle-ball",
            "table-tennis"
        ],
        "f45d",
        "M416 288c-50.1 0-93.6 28.8-114.6 70.8L68.9 126.3l.6-.6 60.1-60.1c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3C471.8 297.6 445 288 416 288zM49.3 151.9L290.1 392.7c-1.4 7.5-2.1 15.3-2.1 23.3c0 23.2 6.2 44.9 16.9 63.7c-3 .2-6.1 .3-9.2 .3H293c-33.9 0-66.5-13.5-90.5-37.5l-9.8-9.8c-13.1-13.1-34.6-12.4-46.8 1.7L88.2 501c-5.8 6.7-14.2 10.7-23 11s-17.5-3.1-23.8-9.4l-32-32C3.1 464.3-.3 455.7 0 446.9s4.3-17.2 11-23l66.6-57.7c14-12.2 14.8-33.7 1.7-46.8l-9.8-9.8C45.5 285.5 32 252.9 32 219v-2.7c0-22.8 6.1-44.9 17.3-64.3zM416 512c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96z"
    ]
};
var $8063e68b12ef6db0$export$ebb246c621751737 = $8063e68b12ef6db0$export$eabe53838d45ac6a;
var $8063e68b12ef6db0$export$f378fbb4e0ef7edf = $8063e68b12ef6db0$export$eabe53838d45ac6a;
var $8063e68b12ef6db0$export$cdcec8ca7ec0d381 = {
    prefix: "fas",
    iconName: "person-dots-from-line",
    icon: [
        576,
        512,
        [
            "diagnoses"
        ],
        "f470",
        "M288 176c48.6 0 88-39.4 88-88s-39.4-88-88-88s-88 39.4-88 88s39.4 88 88 88zM78.7 372.9c15-12.5 50-34.4 97.3-50.1V432H400V322.7c47.3 15.8 82.3 37.7 97.3 50.1c20.4 17 50.6 14.2 67.6-6.1s14.2-50.6-6.1-67.6c-12-10-30.1-22.5-53.2-35C497.2 278.4 481.7 288 464 288c-26.5 0-48-21.5-48-48c0-4.3 .6-8.4 1.6-12.4C379.1 215.9 335.3 208 288 208c-60.2 0-114.9 12.9-160 29.9c0 .7 0 1.4 0 2.1c0 26.5-21.5 48-48 48c-11.8 0-22.7-4.3-31-11.4c-13.1 8.1-23.7 15.9-31.7 22.5c-20.4 17-23.1 47.2-6.1 67.6s47.2 23.1 67.6 6.1zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM272 280c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zm56 104c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zM96 240c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm368 16c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16z"
    ]
};
var $8063e68b12ef6db0$export$68bad2b52a90d1fa = $8063e68b12ef6db0$export$cdcec8ca7ec0d381;
var $8063e68b12ef6db0$export$60430351cdb4ba89 = {
    prefix: "fas",
    iconName: "trash-can-arrow-up",
    icon: [
        448,
        512,
        [
            "trash-restore-alt"
        ],
        "f82a",
        "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
    ]
};
var $8063e68b12ef6db0$export$d075b19b21cb9856 = $8063e68b12ef6db0$export$60430351cdb4ba89;
var $8063e68b12ef6db0$export$58b7558ca9822358 = {
    prefix: "fas",
    iconName: "naira-sign",
    icon: [
        448,
        512,
        [],
        "e1f6",
        "M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H228.2l97.2 145.8c7.8 11.7 22.4 17 35.9 12.9s22.7-16.5 22.7-30.6V320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V256H262.5L122.6 46.3zM305.1 320H320v22.3L305.1 320zM185.5 256H128V169.7L185.5 256z"
    ]
};
var $8063e68b12ef6db0$export$9206260ff0c0c616 = {
    prefix: "fas",
    iconName: "cart-arrow-down",
    icon: [
        576,
        512,
        [],
        "f218",
        "M0 24C0 10.7 10.7 0 24 0H96c11.5 0 21.4 8.2 23.6 19.5L122 32H312V134.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V32H541.8c21.2 0 36.5 20.3 30.8 40.7l-54 192c-3.9 13.8-16.5 23.3-30.8 23.3h-317l9.1 48H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H160c-11.5 0-21.4-8.2-23.6-19.5L76.1 48H24C10.7 48 0 37.3 0 24zM224 464c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zm240 48c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $8063e68b12ef6db0$export$8a322f740d64e9fc = {
    prefix: "fas",
    iconName: "walkie-talkie",
    icon: [
        384,
        512,
        [],
        "f8ef",
        "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144V300.1c0 12.7 5.1 24.9 14.1 33.9l3.9 3.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V371.9c0-12.7 5.1-24.9 14.1-33.9l3.9-3.9c9-9 14.1-21.2 14.1-33.9V144c0-26.5-21.5-48-48-48H320c0-17.7-14.3-32-32-32s-32 14.3-32 32H224c0-17.7-14.3-32-32-32s-32 14.3-32 32H112V24zm0 136H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$27f34878d8ed7a76 = {
    prefix: "fas",
    iconName: "file-pen",
    icon: [
        576,
        512,
        [
            128221,
            "file-edit"
        ],
        "f31c",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V285.7l-86.8 86.8c-10.3 10.3-17.5 23.1-21 37.2l-18.7 74.9c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
    ]
};
var $8063e68b12ef6db0$export$e343e19f1757c5ae = $8063e68b12ef6db0$export$27f34878d8ed7a76;
var $8063e68b12ef6db0$export$32b0cd6133c2742 = {
    prefix: "fas",
    iconName: "receipt",
    icon: [
        384,
        512,
        [
            129534
        ],
        "f543",
        "M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.2-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.2 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"
    ]
};
var $8063e68b12ef6db0$export$3643b719db23d46e = {
    prefix: "fas",
    iconName: "square-pen",
    icon: [
        448,
        512,
        [
            "pen-square",
            "pencil-square"
        ],
        "f14b",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
    ]
};
var $8063e68b12ef6db0$export$fbb231ccb3d960bc = $8063e68b12ef6db0$export$3643b719db23d46e;
var $8063e68b12ef6db0$export$35d253ecd249e771 = $8063e68b12ef6db0$export$3643b719db23d46e;
var $8063e68b12ef6db0$export$957e62a9b80ff4e3 = {
    prefix: "fas",
    iconName: "suitcase-rolling",
    icon: [
        384,
        512,
        [],
        "f5c1",
        "M144 56c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v72H144V56zm176 72H288V56c0-30.9-25.1-56-56-56H152C121.1 0 96 25.1 96 56v72H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64c0 17.7 14.3 32 32 32s32-14.3 32-32H256c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64zM112 224H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$38c8c32017dd9cc = {
    prefix: "fas",
    iconName: "person-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e53f",
        "M208 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM152 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm0-48c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $8063e68b12ef6db0$export$8db9bc521720fccd = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [
        512,
        512,
        [],
        "f078",
        "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
    ]
};
var $8063e68b12ef6db0$export$9338fc4614cfc0cf = {
    prefix: "fas",
    iconName: "battery-full",
    icon: [
        576,
        512,
        [
            128267,
            "battery",
            "battery-5"
        ],
        "f240",
        "M0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176zm80-16c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zm368 32V320H96V192H448z"
    ]
};
var $8063e68b12ef6db0$export$214720d39635cea8 = $8063e68b12ef6db0$export$9338fc4614cfc0cf;
var $8063e68b12ef6db0$export$e426617482c711a7 = $8063e68b12ef6db0$export$9338fc4614cfc0cf;
var $8063e68b12ef6db0$export$8717352b90217272 = {
    prefix: "fas",
    iconName: "skull-crossbones",
    icon: [
        512,
        512,
        [
            128369,
            9760
        ],
        "f714",
        "M400 128c0 44.4-25.4 83.5-64 106.4V256c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V234.4c-38.6-23-64-62.1-64-106.4C112 57.3 176.5 0 256 0s144 57.3 144 128zM200 176c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm144-32c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM35.4 273.7c7.9-15.8 27.1-22.2 42.9-14.3L256 348.2l177.7-88.8c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L327.6 384l134.8 67.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L256 419.8 78.3 508.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L184.4 384 49.7 316.6c-15.8-7.9-22.2-27.1-14.3-42.9z"
    ]
};
var $8063e68b12ef6db0$export$ca4c5b4dcff58860 = {
    prefix: "fas",
    iconName: "code-compare",
    icon: [
        512,
        512,
        [],
        "e13a",
        "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9v40h16c35.3 0 64-28.7 64-64V153.3C371.7 141 352 112.8 352 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V320c0 70.7-57.3 128-128 128H320v40zM456 80c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9V128H176c-35.3 0-64 28.7-64 64V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-70.7 57.3-128 128-128h16V24zM56 432c0 13.3 10.7 24 24 24s24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $8063e68b12ef6db0$export$f8a219cf4f516384 = {
    prefix: "fas",
    iconName: "list-ul",
    icon: [
        512,
        512,
        [
            "list-dots"
        ],
        "f0ca",
        "M64 144c26.5 0 48-21.5 48-48s-21.5-48-48-48S16 69.5 16 96s21.5 48 48 48zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM64 464c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm48-208c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48z"
    ]
};
var $8063e68b12ef6db0$export$e6f4ba30d84fa6ea = $8063e68b12ef6db0$export$f8a219cf4f516384;
var $8063e68b12ef6db0$export$8845cce2a763ee07 = {
    prefix: "fas",
    iconName: "school-lock",
    icon: [
        640,
        512,
        [],
        "e56f",
        "M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0l139 92.7L602.4 126c22 4.9 37.6 24.4 37.6 46.9V272c0-61.9-50.1-112-112-112s-112 50.1-112 112v24.6c-19.1 11.1-32 31.7-32 55.4H320.3l-.3 0c-35.3 0-64 28.7-64 64v96h64v0H48c-26.5 0-48-21.5-48-48V172.8c0-22.5 15.6-42 37.6-46.9L163.2 98.1l139-92.7zM80 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm0 128v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm240-72c48.6 0 88-39.4 88-88s-39.4-88-88-88s-88 39.4-88 88s39.4 88 88 88zm16-120v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 96c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
    ]
};
var $8063e68b12ef6db0$export$f4b64c3a138c1b59 = {
    prefix: "fas",
    iconName: "tower-cell",
    icon: [
        576,
        512,
        [],
        "e585",
        "M62.6 2.3C46.2-4.3 27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3zm450.8 0C497 9 489.1 27.6 495.7 44C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108C548.4 3.6 529.8-4.3 513.4 2.3zM340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2L98.9 466.8c-7.3 16.1-.2 35.1 15.9 42.4s35.1 .2 42.4-15.9L177.7 448H398.3l20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM369.2 384H206.8l14.5-32H354.7l14.5 32zM288 205.3L325.6 288H250.4L288 205.3zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3 .2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6C156 165.8 152 147.4 152 128s4-37.8 11.3-54.4zM456.7 54.4c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6C420 90.2 424 108.6 424 128s-4 37.8-11.3 54.4c-5.3 12.1 .2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z"
    ]
};
var $8063e68b12ef6db0$export$e88ba08d4f4d65b6 = {
    prefix: "fas",
    iconName: "down-long",
    icon: [
        320,
        512,
        [
            "long-arrow-alt-down"
        ],
        "f309",
        "M318 334.5c3.8 8.8 2 19-4.6 26l-136 144c-4.5 4.8-10.8 7.5-17.4 7.5s-12.9-2.7-17.4-7.5l-136-144c-6.6-7-8.4-17.2-4.6-26S14.4 320 24 320h88l0-288c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32l0 288h88c9.6 0 18.2 5.7 22 14.5z"
    ]
};
var $8063e68b12ef6db0$export$8b92530ca6418c2f = $8063e68b12ef6db0$export$e88ba08d4f4d65b6;
var $8063e68b12ef6db0$export$e6fd420a918b43b5 = {
    prefix: "fas",
    iconName: "ranking-star",
    icon: [
        640,
        512,
        [],
        "e561",
        "M353.8 54.1L330.2 6.3c-3.9-8.3-16.1-8.6-20.4 0L286.2 54.1l-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H256zM32 320c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zm416 96v64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H480c-17.7 0-32 14.3-32 32z"
    ]
};
var $8063e68b12ef6db0$export$d5713874f8fefe1b = {
    prefix: "fas",
    iconName: "chess-king",
    icon: [
        448,
        512,
        [
            9818
        ],
        "f43f",
        "M224 0c17.7 0 32 14.3 32 32V48h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H256v48H416c10.3 0 19.9 4.9 26 13.3s7.7 19.1 4.4 28.8L375.1 416H72.9L1.6 202.1C-1.6 192.4 0 181.6 6 173.3s15.7-13.3 26-13.3H192V112H176c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V32c0-17.7 14.3-32 32-32zM32 480c0-17.7 14.3-32 32-32H83.6 364.4 384c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 128 64c-17.7 0-32-14.3-32-32z"
    ]
};
var $8063e68b12ef6db0$export$dcd74f2821882a49 = {
    prefix: "fas",
    iconName: "person-harassing",
    icon: [
        576,
        512,
        [],
        "e549",
        "M192 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM59.4 304.5L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9zM480 240c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM464 344v58.7l-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L408.8 438l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9V344c0-30.9-25.1-56-56-56s-56 25.1-56 56zM288 48c0 8.8 7.2 16 16 16h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm-.8 49.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-48-24z"
    ]
};
var $8063e68b12ef6db0$export$9d355b4e79216962 = {
    prefix: "fas",
    iconName: "brazilian-real-sign",
    icon: [
        512,
        512,
        [],
        "e46c",
        "M400 0c17.7 0 32 14.3 32 32V50.2c12.5 2.3 24.7 6.4 36.2 12.1l10.1 5.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-10.2-5.1c-9.9-5-20.9-7.5-32-7.5h-1.7c-29.8 0-53.9 24.1-53.9 53.9c0 22 13.4 41.8 33.9 50l52 20.8c44.7 17.9 74.1 61.2 74.1 109.4v3.4c0 51.2-33.6 94.6-80 109.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V460.6c-15-3.5-29.4-9.7-42.3-18.3l-23.4-15.6c-14.7-9.8-18.7-29.7-8.9-44.4s29.7-18.7 44.4-8.9L361.2 389c10.8 7.2 23.4 11 36.3 11c27.9 0 50.5-22.6 50.5-50.5v-3.4c0-22-13.4-41.8-33.9-50l-52-20.8C317.3 257.4 288 214.1 288 165.9C288 114 321.5 70 368 54.2V32c0-17.7 14.3-32 32-32zM0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256z"
    ]
};
var $8063e68b12ef6db0$export$8a56136f40511e5d = {
    prefix: "fas",
    iconName: "landmark-dome",
    icon: [
        512,
        512,
        [
            "landmark-alt"
        ],
        "f752",
        "M248 0h16c13.3 0 24 10.7 24 24V34.7C368.4 48.1 431.9 111.6 445.3 192H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h2.7C80.1 111.6 143.6 48.1 224 34.7V24c0-13.3 10.7-24 24-24zM64 288h64V416h40V288h64V416h48V288h64V416h40V288h64V420.3c.6 .3 1.2 .7 1.7 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V288z"
    ]
};
var $8063e68b12ef6db0$export$8b9c180efffc50ab = $8063e68b12ef6db0$export$8a56136f40511e5d;
var $8063e68b12ef6db0$export$8e144ed4d52eef49 = {
    prefix: "fas",
    iconName: "arrow-up",
    icon: [
        384,
        512,
        [
            8593
        ],
        "f062",
        "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
    ]
};
var $8063e68b12ef6db0$export$e0cfed4ba2fe562c = {
    prefix: "fas",
    iconName: "tv",
    icon: [
        640,
        512,
        [
            63717,
            "television",
            "tv-alt"
        ],
        "f26c",
        "M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$9803b0176917be28 = $8063e68b12ef6db0$export$e0cfed4ba2fe562c;
var $8063e68b12ef6db0$export$6aa64ad5a1974ad7 = $8063e68b12ef6db0$export$e0cfed4ba2fe562c;
var $8063e68b12ef6db0$export$ac094c06f566cca3 = {
    prefix: "fas",
    iconName: "shrimp",
    icon: [
        512,
        512,
        [
            129424
        ],
        "e448",
        "M64 32C28.7 32 0 60.7 0 96s28.7 64 64 64h1c3.7 88.9 77 160 167 160h56V128H264 88.8 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zM224 456c0 13.3 10.7 24 24 24h72V407.8l-64.1-22.4c-12.5-4.4-26.2 2.2-30.6 14.7s2.2 26.2 14.7 30.6l4.5 1.6C233 433.9 224 443.9 224 456zm128 23.3c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3v69.9zM472.6 415c24.6-30.3 39.4-68.9 39.4-111c0-12.3-1.3-24.3-3.7-35.9L382.8 355.1c.8 3.4 1.2 7 1.2 10.6c0 4.6-.7 9-1.9 13.1L472.6 415zM336 128H320V320h18.3c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128zM216 192c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$350a84fd0f833f4d = {
    prefix: "fas",
    iconName: "list-check",
    icon: [
        576,
        512,
        [
            "tasks"
        ],
        "f0ae",
        "M184.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L39 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L39 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM256 96c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H288c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H288c-17.7 0-32-14.3-32-32zM192 416c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zM80 464c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $8063e68b12ef6db0$export$2f6d5b2fec286d63 = $8063e68b12ef6db0$export$350a84fd0f833f4d;
var $8063e68b12ef6db0$export$3fe50bd8062cd141 = {
    prefix: "fas",
    iconName: "jug-detergent",
    icon: [
        384,
        512,
        [],
        "e519",
        "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V48h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H88C74.7 96 64 85.3 64 72s10.7-24 24-24h8V24zM0 256c0-70.7 57.3-128 128-128H256c70.7 0 128 57.3 128 128V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm256 0v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $8063e68b12ef6db0$export$9a5c11a5e3d7f1e7 = {
    prefix: "fas",
    iconName: "circle-user",
    icon: [
        512,
        512,
        [
            62142,
            "user-circle"
        ],
        "f2bd",
        "M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM256 272c39.8 0 72-32.2 72-72s-32.2-72-72-72s-72 32.2-72 72s32.2 72 72 72z"
    ]
};
var $8063e68b12ef6db0$export$be7d974e9e0dba1a = $8063e68b12ef6db0$export$9a5c11a5e3d7f1e7;
var $8063e68b12ef6db0$export$d1886bc596424e6c = {
    prefix: "fas",
    iconName: "user-shield",
    icon: [
        640,
        512,
        [],
        "f505",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c1.8 0 3.5-.2 5.3-.5c-76.3-55.1-99.8-141-103.1-200.2c-16.1-4.8-33.1-7.3-50.7-7.3H178.3zm308.8-78.3l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7V273.8L591.4 312z"
    ]
};
var $8063e68b12ef6db0$export$cc58cb0f2257a6a9 = {
    prefix: "fas",
    iconName: "wind",
    icon: [
        512,
        512,
        [],
        "f72e",
        "M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32 14.3-32 32zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$6d2be7c5d395dd16 = {
    prefix: "fas",
    iconName: "car-burst",
    icon: [
        640,
        512,
        [
            "car-crash"
        ],
        "f5e1",
        "M176 8c-6.6 0-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l35.3-32.5 9.5-35.4 10.4-38.6c8-29.9 30.5-52.1 57.9-60.9l41-59.2c11.3-16.3 26.4-28.9 43.5-37.2c-.4-.6-.8-1.2-1.3-1.8c-4.1-5.1-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8zM367.7 161.5l135.6 36.3c6.5 1.8 11.3 7.4 11.8 14.2l4.6 56.5-201.5-54 32.2-46.6c3.8-5.6 10.8-8.1 17.3-6.4zm-69.9-30l-47.9 69.3c-21.6 3-40.3 18.6-46.3 41l-10.4 38.6-16.6 61.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 247.3 66.3-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9L595 388l10.4-38.6c6-22.4-2.5-45.2-19.6-58.7l-6.8-84c-2.7-33.7-26.4-62-59-70.8L384.2 99.7c-32.7-8.8-67.3 4-86.5 31.8zM268.3 308.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17s20.4 16.6 17 29.4s-16.6 20.4-29.4 17zM545 358.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4s16.6-20.4 29.4-17s20.4 16.6 17 29.4z"
    ]
};
var $8063e68b12ef6db0$export$8ff55566398404cd = $8063e68b12ef6db0$export$6d2be7c5d395dd16;
var $8063e68b12ef6db0$export$b8c4c058fe7d193c = {
    prefix: "fas",
    iconName: "y",
    icon: [
        384,
        512,
        [
            121
        ],
        "59",
        "M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6L160 298.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V298.3L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6S336.2 31 326 45.4L192 232.9 58 45.4z"
    ]
};
var $8063e68b12ef6db0$export$22c642403aeeaeaf = {
    prefix: "fas",
    iconName: "person-snowboarding",
    icon: [
        576,
        512,
        [
            127938,
            "snowboarding"
        ],
        "f7ce",
        "M241.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21l86.5 33.1c4.6 1.8 9.4 2.6 14.3 2.6H504c13.3 0 24 10.7 24 24s-10.7 24-24 24H475.8c-10.8 0-21.4-2-31.5-5.8L92.1 371.3c-11.5-4.4-22-11.2-30.8-20L39 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l22.4 8.6c-.8-1.6-1.5-3.2-2.1-4.9c-5.6-16.8 3.5-34.9 20.2-40.5L224 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM171 350.1l159 60.9c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.4-15.9l-52.8-44 0 18.8c0 20.7-13.2 39-32.8 45.5L171 350.1zM464 96c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $8063e68b12ef6db0$export$72683772d587302a = $8063e68b12ef6db0$export$22c642403aeeaeaf;
var $8063e68b12ef6db0$export$27de16299ddd171 = {
    prefix: "fas",
    iconName: "truck-fast",
    icon: [
        640,
        512,
        [
            "shipping-fast"
        ],
        "f48b",
        "M112 0C85.5 0 64 21.5 64 48V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 272c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 240c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 208c8.8 0 16 7.2 16 16s-7.2 16-16 16H64V416c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H112zM544 237.3V256H416V160h50.7L544 237.3zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zm368-48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48z"
    ]
};
var $8063e68b12ef6db0$export$5e419f47aaeb3c05 = $8063e68b12ef6db0$export$27de16299ddd171;
var $8063e68b12ef6db0$export$24228a855c5f6812 = {
    prefix: "fas",
    iconName: "fish",
    icon: [
        576,
        512,
        [
            128031
        ],
        "f578",
        "M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $8063e68b12ef6db0$export$10f5839059d22f7e = {
    prefix: "fas",
    iconName: "user-graduate",
    icon: [
        448,
        512,
        [],
        "f501",
        "M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9V160c0 70.7-57.3 128-128 128s-128-57.3-128-128V102.9L48 93.3v65.1l15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9H16c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4V86.6C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40zM129.1 323.2l83.2 88.4c6.3 6.7 17 6.7 23.3 0l83.2-88.4c73.7 14.9 129.1 80 129.1 158.1c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-78.1 55.5-143.2 129.1-158.1z"
    ]
};
var $8063e68b12ef6db0$export$625fb3848216f28c = {
    prefix: "fas",
    iconName: "circle-half-stroke",
    icon: [
        512,
        512,
        [
            9680,
            "adjust"
        ],
        "f042",
        "M448 256c0-106-86-192-192-192V448c106 0 192-86 192-192zm64 0c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"
    ]
};
var $8063e68b12ef6db0$export$cfa06e4b68edca2d = $8063e68b12ef6db0$export$625fb3848216f28c;
var $8063e68b12ef6db0$export$add3b381ced12554 = {
    prefix: "fas",
    iconName: "clapperboard",
    icon: [
        512,
        512,
        [],
        "e131",
        "M448 32H361.9l-1 1-127 127h92.1l1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128V96c0-15.1-5.3-29.1-14-40l-104 104H512zM294.1 32H201.9l-1 1L73.9 160h92.1l1-1 127-127zM64 32C28.7 32 0 60.7 0 96v64H6.1l1-1 127-127H64zM512 192H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192z"
    ]
};
var $8063e68b12ef6db0$export$55c8e3afd9f6c0b4 = {
    prefix: "fas",
    iconName: "circle-radiation",
    icon: [
        512,
        512,
        [
            9762,
            "radiation-alt"
        ],
        "f7ba",
        "M256 448C150 448 64 362 64 256S150 64 256 64s192 86 192 192s-86 192-192 192zm0 64c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$2f048fa82bbddf6f = $8063e68b12ef6db0$export$55c8e3afd9f6c0b4;
var $8063e68b12ef6db0$export$dc3654cf8a596fbf = {
    prefix: "fas",
    iconName: "baseball",
    icon: [
        512,
        512,
        [
            129358,
            9918,
            "baseball-ball"
        ],
        "f433",
        "M62.7 223.4c-4.8 .4-9.7 .6-14.7 .6c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7c-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7 .7-11.5 .7-17.3c0-16.5-1.9-32.6-5.6-47.9c1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-5.8 0-11.6 .2-17.3 .7c-8.8 .7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2C290 494.8 288 479.6 288 464c0-4.9 .2-9.8 .6-14.7c.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3c0 16.5 1.9 32.6 5.6 47.9c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6C15.4 254.1 31.5 256 48 256c5.8 0 11.6-.2 17.3-.7c8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zM121.3 208c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5c3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9c-45.2 20.8-81.7 57.2-102.5 102.5c-3.7 8-.2 17.5 7.9 21.2s17.5 .2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7c8-3.7 11.6-13.2 7.9-21.2z"
    ]
};
var $8063e68b12ef6db0$export$63a3f8ceae07c7f3 = $8063e68b12ef6db0$export$dc3654cf8a596fbf;
var $8063e68b12ef6db0$export$b024a52a4ccf5e69 = {
    prefix: "fas",
    iconName: "jet-fighter-up",
    icon: [
        512,
        512,
        [],
        "e518",
        "M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7L197.2 112.6c-3.4 8-5.2 16.5-5.2 25.2v77l-144 84V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v56 32 24c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H192v32.7L133.5 468c-3.5 3-5.5 7.4-5.5 12v16c0 8.8 7.2 16 16 16h96V448c0-8.8 7.2-16 16-16s16 7.2 16 16v64h96c8.8 0 16-7.2 16-16V480c0-4.6-2-9-5.5-12L320 416.7V384H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24V368 336 280c0-13.3-10.7-24-24-24s-24 10.7-24 24v18.8l-144-84v-77c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7z"
    ]
};
var $8063e68b12ef6db0$export$59c351869dc27435 = {
    prefix: "fas",
    iconName: "diagram-project",
    icon: [
        576,
        512,
        [
            "project-diagram"
        ],
        "f542",
        "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V96H384V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V160H192v16c0 1.7-.1 3.4-.3 5L272 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V336c0-1.7 .1-3.4 .3-5L144 224H48c-26.5 0-48-21.5-48-48V80z"
    ]
};
var $8063e68b12ef6db0$export$30bf9f5b96509df1 = $8063e68b12ef6db0$export$59c351869dc27435;
var $8063e68b12ef6db0$export$e9bd786d30cb716c = {
    prefix: "fas",
    iconName: "copy",
    icon: [
        512,
        512,
        [],
        "f0c5",
        "M224 0c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224zM64 160c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H288v64H64V224h64V160H64z"
    ]
};
var $8063e68b12ef6db0$export$28cc565c11db6f2e = {
    prefix: "fas",
    iconName: "volume-xmark",
    icon: [
        576,
        512,
        [
            "volume-mute",
            "volume-times"
        ],
        "f6a9",
        "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $8063e68b12ef6db0$export$aa8decd057dfd29b = $8063e68b12ef6db0$export$28cc565c11db6f2e;
var $8063e68b12ef6db0$export$a1c7b36ba71dbeca = $8063e68b12ef6db0$export$28cc565c11db6f2e;
var $8063e68b12ef6db0$export$72e2d874a963de0c = {
    prefix: "fas",
    iconName: "hand-sparkles",
    icon: [
        640,
        512,
        [],
        "e05d",
        "M320 0c17.7 0 32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32V323.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2L478.9 391C460.6 396.3 448 413 448 432c0 18.9 12.5 35.6 30.6 40.9C448.4 497.4 409.9 512 368 512H348.8c-59.6 0-116.9-22.9-160-64L76.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zm-7.3 326.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L288 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L288 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L320 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L320 352l-7.3-25.4zM104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168 90.2 216.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120 69.8 71.7C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7L104 120zM584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7L584 408z"
    ]
};
var $8063e68b12ef6db0$export$eb83fb404127db75 = {
    prefix: "fas",
    iconName: "grip",
    icon: [
        448,
        512,
        [
            "grip-horizontal"
        ],
        "f58d",
        "M128 136c0-22.1-17.9-40-40-40L40 96C17.9 96 0 113.9 0 136l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V136zm0 192c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328z"
    ]
};
var $8063e68b12ef6db0$export$4a45308d6c8decc1 = $8063e68b12ef6db0$export$eb83fb404127db75;
var $8063e68b12ef6db0$export$928280bdd54fa173 = {
    prefix: "fas",
    iconName: "share-from-square",
    icon: [
        576,
        512,
        [
            61509,
            "share-square"
        ],
        "f14d",
        "M384 24c0-9.6 5.7-18.2 14.5-22s19-2 26 4.6l144 136c4.8 4.5 7.5 10.8 7.5 17.4s-2.7 12.9-7.5 17.4l-144 136c-7 6.6-17.2 8.4-26 4.6s-14.5-12.5-14.5-22V224H352 337.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C242.8 374.8 160 333.4 160 240c0-79.5 64.5-144 144-144h80V24zM0 144C0 99.8 35.8 64 80 64H96c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V416c0-17.7 14.3-32 32-32s32 14.3 32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V144z"
    ]
};
var $8063e68b12ef6db0$export$ae9e1434571f373c = $8063e68b12ef6db0$export$928280bdd54fa173;
var $8063e68b12ef6db0$export$e18f576a7b31ba46 = {
    prefix: "fas",
    iconName: "gun",
    icon: [
        576,
        512,
        [],
        "e19b",
        "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H32C14.3 64 0 78.3 0 96V208c0 17.7 14.3 32 32 32H42c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h96c14.7 0 27.5-10 31-24.2L217 352H321.4c23.7 0 44.8-14.9 52.7-37.2L400.9 240H432c8.5 0 16.6-3.4 22.6-9.4L477.3 208H544c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H528V56zM321.4 304H229l16-64h105l-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3zM80 128H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$318ed022991eef56 = {
    prefix: "fas",
    iconName: "square-phone",
    icon: [
        448,
        512,
        [
            "phone-square"
        ],
        "f098",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"
    ]
};
var $8063e68b12ef6db0$export$8ba22605a641ebdf = $8063e68b12ef6db0$export$318ed022991eef56;
var $8063e68b12ef6db0$export$a105e7b44ca0eb9e = {
    prefix: "fas",
    iconName: "plus",
    icon: [
        448,
        512,
        [
            10133,
            61543,
            "add"
        ],
        "2b",
        "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"
    ]
};
var $8063e68b12ef6db0$export$9e8f9a9d4ad32c0f = $8063e68b12ef6db0$export$a105e7b44ca0eb9e;
var $8063e68b12ef6db0$export$1fe4a9976a241685 = {
    prefix: "fas",
    iconName: "expand",
    icon: [
        448,
        512,
        [],
        "f065",
        "M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z"
    ]
};
var $8063e68b12ef6db0$export$9835883ce9d0fe78 = {
    prefix: "fas",
    iconName: "computer",
    icon: [
        640,
        512,
        [],
        "e4e5",
        "M384 96V320H64L64 96H384zM64 32C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64H181.3l-10.7 32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H277.3l-10.7-32H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm464 0c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H528zm16 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16zm32 224c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$e6e44779b2fa1a5c = {
    prefix: "fas",
    iconName: "xmark",
    icon: [
        320,
        512,
        [
            128473,
            10005,
            10006,
            10060,
            215,
            "close",
            "multiply",
            "remove",
            "times"
        ],
        "f00d",
        "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
    ]
};
var $8063e68b12ef6db0$export$23c717133fd81476 = $8063e68b12ef6db0$export$e6e44779b2fa1a5c;
var $8063e68b12ef6db0$export$4ed4ff13d4dbc862 = $8063e68b12ef6db0$export$e6e44779b2fa1a5c;
var $8063e68b12ef6db0$export$34810740c1bd6c54 = $8063e68b12ef6db0$export$e6e44779b2fa1a5c;
var $8063e68b12ef6db0$export$174bd7f477b115b4 = $8063e68b12ef6db0$export$e6e44779b2fa1a5c;
var $8063e68b12ef6db0$export$ff9a43e3a9cb653c = {
    prefix: "fas",
    iconName: "arrows-up-down-left-right",
    icon: [
        512,
        512,
        [
            "arrows"
        ],
        "f047",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4V224H109.3l9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4H224V402.7l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V288H402.7l-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4H288V109.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"
    ]
};
var $8063e68b12ef6db0$export$d5ae09a305d70340 = $8063e68b12ef6db0$export$ff9a43e3a9cb653c;
var $8063e68b12ef6db0$export$fd7622d4b8d3674b = {
    prefix: "fas",
    iconName: "chalkboard-user",
    icon: [
        640,
        512,
        [
            "chalkboard-teacher"
        ],
        "f51c",
        "M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384V320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm0 256c-53 0-96-43-96-96s43-96 96-96s96 43 96 96s-43 96-96 96zm-26.7 32h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"
    ]
};
var $8063e68b12ef6db0$export$443fcf69b0155291 = $8063e68b12ef6db0$export$fd7622d4b8d3674b;
var $8063e68b12ef6db0$export$c8f99b9b5ea83555 = {
    prefix: "fas",
    iconName: "peso-sign",
    icon: [
        384,
        512,
        [],
        "e222",
        "M64 32C46.3 32 32 46.3 32 64v64c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c68.4 0 127.7-39 156.8-96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.7c.5-5.3 .7-10.6 .7-16s-.2-10.7-.7-16h.7c17.7 0 32-14.3 32-32s-14.3-32-32-32H332.8C303.7 71 244.4 32 176 32H64zm190.4 96H96V96h80c30.5 0 58.2 12.2 78.4 32zM96 192H286.9c.7 5.2 1.1 10.6 1.1 16s-.4 10.8-1.1 16H96V192zm158.4 96c-20.2 19.8-47.9 32-78.4 32H96V288H254.4z"
    ]
};
var $8063e68b12ef6db0$export$18ba6a500873dba9 = {
    prefix: "fas",
    iconName: "building-shield",
    icon: [
        576,
        512,
        [],
        "e4d8",
        "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V207l-42.4 17H304 272c-8.8 0-16 7.2-16 16v32 24.2V304c0 .9 .1 1.7 .2 2.6c2.3 58.1 24.1 144.8 98.7 201.5c-5.8 2.5-12.2 3.9-18.9 3.9H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM423.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"
    ]
};
var $8063e68b12ef6db0$export$8afab767536f59ad = {
    prefix: "fas",
    iconName: "baby",
    icon: [
        448,
        512,
        [],
        "f77c",
        "M296 88c0 39.8-32.2 72-72 72s-72-32.2-72-72s32.2-72 72-72s72 32.2 72 72zM39.7 144.5c13-17.9 38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25V288H128V251.7c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8l60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53l60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4l-26-37.2z"
    ]
};
var $8063e68b12ef6db0$export$d7e538fddb81da68 = {
    prefix: "fas",
    iconName: "users-line",
    icon: [
        640,
        512,
        [],
        "e592",
        "M211.2 96c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM32 256c0 17.7 14.3 32 32 32h85.6c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4H96c-35.3 0-64 28.7-64 64zm461.6 32H576c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H448c-11.7 0-22.7 3.1-32.1 8.6c38.1 14.8 67.4 47.3 77.7 87.4zM391.2 226.4c-6.9-1.6-14.2-2.4-21.6-2.4h-96c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32c-10.8-30.7-36.8-54.2-68.9-61.6zM563.2 96c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM321.6 192c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $8063e68b12ef6db0$export$932a67a1b1a7a724 = {
    prefix: "fas",
    iconName: "quote-left",
    icon: [
        448,
        512,
        [
            8220,
            "quote-left-alt"
        ],
        "f10d",
        "M0 216C0 149.7 53.7 96 120 96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320 288 216zm256 0c0-66.3 53.7-120 120-120h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V320 288 216z"
    ]
};
var $8063e68b12ef6db0$export$95bb9ad3aa35c741 = $8063e68b12ef6db0$export$932a67a1b1a7a724;
var $8063e68b12ef6db0$export$e87e41787bbedc98 = {
    prefix: "fas",
    iconName: "tractor",
    icon: [
        640,
        512,
        [
            128668
        ],
        "f722",
        "M96 64c0-35.3 28.7-64 64-64H266.3c26.2 0 49.7 15.9 59.4 40.2L373.7 160H480V126.2c0-24.8 5.8-49.3 16.9-71.6l2.5-5c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.5 5c-6.7 13.3-10.1 28-10.1 42.9V160h56c22.1 0 40 17.9 40 40v45.4c0 16.5-8.5 31.9-22.6 40.7l-43.3 27.1c-14.2-5.9-29.8-9.2-46.1-9.2c-39.3 0-74.1 18.9-96 48H352c0 17.7-14.3 32-32 32h-8.2c-1.7 4.8-3.7 9.5-5.8 14.1l5.8 5.8c12.5 12.5 12.5 32.8 0 45.3l-22.6 22.6c-12.5 12.5-32.8 12.5-45.3 0l-5.8-5.8c-4.6 2.2-9.3 4.1-14.1 5.8V480c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-8.2c-4.8-1.7-9.5-3.7-14.1-5.8l-5.8 5.8c-12.5 12.5-32.8 12.5-45.3 0L40.2 449.1c-12.5-12.5-12.5-32.8 0-45.3l5.8-5.8c-2.2-4.6-4.1-9.3-5.8-14.1H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8.2c1.7-4.8 3.7-9.5 5.8-14.1l-5.8-5.8c-12.5-12.5-12.5-32.8 0-45.3l22.6-22.6c9-9 21.9-11.5 33.1-7.6V192 160 64zm170.3 0H160v96h32H304.7L266.3 64zM176 256c-44.2 0-80 35.8-80 80s35.8 80 80 80s80-35.8 80-80s-35.8-80-80-80zM528 448c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm0 64c-48.6 0-88-39.4-88-88c0-29.8 14.8-56.1 37.4-72c14.3-10.1 31.8-16 50.6-16c2.7 0 5.3 .1 7.9 .3c44.9 4 80.1 41.7 80.1 87.7c0 48.6-39.4 88-88 88z"
    ]
};
var $8063e68b12ef6db0$export$940cea0f5451895c = {
    prefix: "fas",
    iconName: "trash-arrow-up",
    icon: [
        448,
        512,
        [
            "trash-restore"
        ],
        "f829",
        "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
    ]
};
var $8063e68b12ef6db0$export$d32f45a64ed40e8d = $8063e68b12ef6db0$export$940cea0f5451895c;
var $8063e68b12ef6db0$export$fc9f7bd981c34c45 = {
    prefix: "fas",
    iconName: "arrow-down-up-lock",
    icon: [
        640,
        512,
        [],
        "e4b0",
        "M150.6 502.6l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7V288H416V272c0-17.2 3.9-33.5 10.8-48H352V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 109.3V224l-128 0H96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32H96V402.7L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0zM160 192V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64zM288 320V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H288zm240-80c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
};
var $8063e68b12ef6db0$export$4d384ffc907ddaff = {
    prefix: "fas",
    iconName: "lines-leaning",
    icon: [
        448,
        512,
        [],
        "e51e",
        "M222.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zm70.9-41.7c-17.4-2.9-33.9 8.9-36.8 26.3l-64 384c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l64-384c2.9-17.4-8.9-33.9-26.3-36.8zM384 32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32z"
    ]
};
var $8063e68b12ef6db0$export$613f406c1b5802a8 = {
    prefix: "fas",
    iconName: "ruler-combined",
    icon: [
        512,
        512,
        [],
        "f546",
        "M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z"
    ]
};
var $8063e68b12ef6db0$export$da61665fff8aebfe = {
    prefix: "fas",
    iconName: "copyright",
    icon: [
        512,
        512,
        [
            169
        ],
        "f1f9",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"
    ]
};
var $8063e68b12ef6db0$export$a7c5f5e4805fdab = {
    prefix: "fas",
    iconName: "equals",
    icon: [
        448,
        512,
        [
            62764
        ],
        "3d",
        "M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48z"
    ]
};
var $8063e68b12ef6db0$export$db34f7a6de38784f = {
    prefix: "fas",
    iconName: "blender",
    icon: [
        512,
        512,
        [],
        "f517",
        "M0 64C0 28.7 28.7 0 64 0h64 32H470.1c21.1 0 36.4 20.1 30.9 40.4L494.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H485.8l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H459.6l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L416 352H160l-8.7-96H64c-35.3 0-64-28.7-64-64V64zM145.5 192L133.8 64H64V192h81.5zM144 384H432c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM0 64C0 28.7 28.7 0 64 0h64 32H470.1c21.1 0 36.4 20.1 30.9 40.4L494.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H485.8l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H459.6l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L416 352H160l-8.7-96H64c-35.3 0-64-28.7-64-64V64zM145.5 192L133.8 64H64V192h81.5zM144 384H432c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$b4619aeaf0b9d18e = {
    prefix: "fas",
    iconName: "teeth",
    icon: [
        576,
        512,
        [],
        "f62e",
        "M0 128C0 75 43 32 96 32H480c53 0 96 43 96 96V384c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm176 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48zM48 208v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48V312c0-13.3-10.7-24-24-24H200c-13.3 0-24 10.7-24 24v24zm176 48c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-176v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H456c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48z"
    ]
};
var $8063e68b12ef6db0$export$3570be7b68efb8db = {
    prefix: "fas",
    iconName: "shekel-sign",
    icon: [
        448,
        512,
        [
            8362,
            "ils",
            "shekel",
            "sheqel",
            "sheqel-sign"
        ],
        "f20b",
        "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H192c35.3 0 64 28.7 64 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-70.7-57.3-128-128-128H32zM320 480c70.7 0 128-57.3 128-128V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 35.3-28.7 64-64 64H192V192c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32H320z"
    ]
};
var $8063e68b12ef6db0$export$ecadeff45b05a451 = $8063e68b12ef6db0$export$3570be7b68efb8db;
var $8063e68b12ef6db0$export$27e0e10e74d98736 = $8063e68b12ef6db0$export$3570be7b68efb8db;
var $8063e68b12ef6db0$export$28b3b26a80030d4e = $8063e68b12ef6db0$export$3570be7b68efb8db;
var $8063e68b12ef6db0$export$d84993fb5e8c6edd = $8063e68b12ef6db0$export$3570be7b68efb8db;
var $8063e68b12ef6db0$export$fc82fb79180cd17c = {
    prefix: "fas",
    iconName: "map",
    icon: [
        576,
        512,
        [
            128506,
            62072
        ],
        "f279",
        "M384 476.1L192 421.2V35.9L384 90.8V476.1zm32-1.2V88.4L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2V423.6L32.9 474.5C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3z"
    ]
};
var $8063e68b12ef6db0$export$b24d84ed5657d89a = {
    prefix: "fas",
    iconName: "rocket",
    icon: [
        512,
        512,
        [],
        "f135",
        "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40z"
    ]
};
var $8063e68b12ef6db0$export$ed36ad335b36be22 = {
    prefix: "fas",
    iconName: "photo-film",
    icon: [
        640,
        512,
        [
            "photo-video"
        ],
        "f87c",
        "M256 0H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H552c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM64 128h96V384v32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V384H512v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H72zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16z"
    ]
};
var $8063e68b12ef6db0$export$739f6a6a12dfb6ed = $8063e68b12ef6db0$export$ed36ad335b36be22;
var $8063e68b12ef6db0$export$758f1fb3784e4080 = {
    prefix: "fas",
    iconName: "folder-minus",
    icon: [
        512,
        512,
        [],
        "f65d",
        "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
    ]
};
var $8063e68b12ef6db0$export$de59c2657a8ace67 = {
    prefix: "fas",
    iconName: "store",
    icon: [
        576,
        512,
        [],
        "f54e",
        "M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 252.6c-4 1-8 1.8-12.3 2.3z"
    ]
};
var $8063e68b12ef6db0$export$cf36928a9c52e98a = {
    prefix: "fas",
    iconName: "arrow-trend-up",
    icon: [
        576,
        512,
        [],
        "e098",
        "M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V205.3L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160H384z"
    ]
};
var $8063e68b12ef6db0$export$2a44d62160972254 = {
    prefix: "fas",
    iconName: "plug-circle-minus",
    icon: [
        576,
        512,
        [],
        "e55e",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-64 0c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"
    ]
};
var $8063e68b12ef6db0$export$5c1f29f4c7cad367 = {
    prefix: "fas",
    iconName: "sign-hanging",
    icon: [
        512,
        512,
        [
            "sign"
        ],
        "f4d9",
        "M96 0c17.7 0 32 14.3 32 32V64l352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-352 0V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H32C14.3 128 0 113.7 0 96S14.3 64 32 64H64V32C64 14.3 78.3 0 96 0zm96 160H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$d21d0d6c8e9e8bf9 = $8063e68b12ef6db0$export$5c1f29f4c7cad367;
var $8063e68b12ef6db0$export$a527a6267c55a54c = {
    prefix: "fas",
    iconName: "bezier-curve",
    icon: [
        640,
        512,
        [],
        "f55b",
        "M296 136V88h48v48H296zM288 32c-26.5 0-48 21.5-48 48v4H121.6C111.2 62.7 89.3 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36h66.9c-58.9 39.6-98.9 105-104 180H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-3.3c5.9-67 48.5-123.4 107.5-149.1c8.6 12.7 23.2 21.1 39.8 21.1h64c16.6 0 31.1-8.4 39.8-21.1c59 25.7 101.6 82.1 107.5 149.1H496c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-4.5c-5-75-45.1-140.4-104-180h66.9c10.4 21.3 32.3 36 57.6 36c35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36H400V80c0-26.5-21.5-48-48-48H288zM88 376h48v48H88V376zm416 48V376h48v48H504z"
    ]
};
var $8063e68b12ef6db0$export$6b31a1e5968b2378 = {
    prefix: "fas",
    iconName: "bell-slash",
    icon: [
        640,
        512,
        [
            128277,
            61943
        ],
        "f1f6",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6c.5-1.7 .7-3.5 .7-5.4c0-27.6-11-54.1-30.5-73.7L512 320c-20.5-20.5-32-48.3-32-77.3V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V51.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM160 242.7c0 29-11.5 56.8-32 77.3l-1.5 1.5C107 341 96 367.5 96 395.2c0 11.5 9.3 20.8 20.8 20.8H406.2L160 222.1v20.7zM384 448H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
    ]
};
var $8063e68b12ef6db0$export$1c92b67c45a4b4fc = {
    prefix: "fas",
    iconName: "tablet",
    icon: [
        448,
        512,
        [
            "tablet-android"
        ],
        "f3fb",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 432h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$5eddbb7c71278268 = $8063e68b12ef6db0$export$1c92b67c45a4b4fc;
var $8063e68b12ef6db0$export$9b263780a7312c8c = {
    prefix: "fas",
    iconName: "school-flag",
    icon: [
        576,
        512,
        [],
        "e56e",
        "M288 0H400c8.8 0 16 7.2 16 16V64c0 8.8-7.2 16-16 16H320V95.5L410.3 160H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H336V400c0-26.5-21.5-48-48-48s-48 21.5-48 48V512H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H165.7L256 95.5V32c0-17.7 14.3-32 32-32zm48 240c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM80 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm368 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zM80 352c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H80zm384 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H464z"
    ]
};
var $8063e68b12ef6db0$export$d3c2bcfd3b861e4a = {
    prefix: "fas",
    iconName: "fill",
    icon: [
        576,
        512,
        [],
        "f575",
        "M118.6 9.4C106.1-3.1 85.9-3.1 73.4 9.4s-12.5 32.8 0 45.3L154.7 136 62.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L180.1 481.4c37.5 37.5 98.3 37.5 135.8 0L506.3 290.9c28.1-28.1 28.1-73.7 0-101.8L354.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L200 90.7 118.6 9.4zM200 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L245.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L461.1 234.3c3.1 3.1 3.1 8.2 0 11.3L418.7 288H99.5c1.4-5.4 4.2-10.4 8.4-14.6L200 181.3z"
    ]
};
var $8063e68b12ef6db0$export$887340269e6d6cac = {
    prefix: "fas",
    iconName: "angle-up",
    icon: [
        448,
        512,
        [
            8963
        ],
        "f106",
        "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"
    ]
};
var $8063e68b12ef6db0$export$482976e9a4ab10f3 = {
    prefix: "fas",
    iconName: "drumstick-bite",
    icon: [
        512,
        512,
        [],
        "f6d7",
        "M160 265.2c0 8.5-3.4 16.6-9.4 22.6l-26.8 26.8c-12.3 12.3-32.5 11.4-49.4 7.2C69.8 320.6 65 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5c-4.2-16.9-5.2-37.1 7.2-49.4l26.8-26.8c6-6 14.1-9.4 22.6-9.4H336c6.3 0 12.4-.3 18.5-1c11.9-1.2 16.4-15.5 10.8-26c-8.5-15.8-13.3-33.8-13.3-53c0-61.9 50.1-112 112-112c8 0 15.7 .8 23.2 2.4c11.7 2.5 24.1-5.9 22-17.6C494.5 62.5 422.5 0 336 0C238.8 0 160 78.8 160 176v89.2z"
    ]
};
var $8063e68b12ef6db0$export$273296afacf93991 = {
    prefix: "fas",
    iconName: "holly-berry",
    icon: [
        512,
        512,
        [],
        "f7aa",
        "M256 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-80 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM276.8 383.8c1 .1 2.1 .2 3.2 .2c39.8 0 72 32.2 72 72v22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.6 452c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7v-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.9-.8-5.9-1-8.7-.7c4.2 9.7 5.8 20.8 3.7 32.3L275 298.7c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9zM127.6 234.5c-15.5-5.2-31.6 6.4-31.6 22.8v32C96 323.9 67.9 352 33.3 352c-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4C6.2 489.4 22.6 505.8 40.5 501L60 495.6c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8v-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3zM384 144c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48z"
    ]
};
var $8063e68b12ef6db0$export$75702e3e3dd44a44 = {
    prefix: "fas",
    iconName: "chevron-left",
    icon: [
        384,
        512,
        [
            9001
        ],
        "f053",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
    ]
};
var $8063e68b12ef6db0$export$7fc18cf2d526c341 = {
    prefix: "fas",
    iconName: "bacteria",
    icon: [
        640,
        512,
        [],
        "e059",
        "M304.9 .7c-9.6-2.7-19.5 2.8-22.3 12.4l-3.1 11c-7.4-.3-14.9 .4-22.4 2.1c-9 2.1-17.8 4.4-26.2 7l-4.4-10.3c-3.9-9.1-14.5-13.4-23.6-9.5s-13.4 14.5-9.5 23.6l3.6 8.5c-16.5 7.1-31.5 15.1-45.2 23.9L147 62c-5.5-8.3-16.7-10.5-25-5s-10.5 16.7-5 25l5.8 8.7c-13.5 11.2-25.3 23.1-35.5 35.3l-10.1-8.1c-7.8-6.2-19.1-5-25.3 2.8s-5 19.1 2.8 25.3L66 155c-1.6 2.4-3.1 4.8-4.5 7.3c-7.1 11.8-12.8 23.2-17.4 34l-7.4-3c-9.2-3.7-19.7 .8-23.4 10s.8 19.7 10 23.4l8.7 3.5c-.2 .8-.4 1.6-.7 2.3c-2.6 9.4-4.2 17.4-5.3 23.5c-.5 3.1-.9 5.7-1.2 7.7c-.1 1-.2 2-.3 2.7l-.1 1.1 0 .5 0 .2 0 .1c0 0 0 .1 29.4 2.8l0 0-29.4-2.7c-.3 3.8-.4 7.5-.3 11.2l-11 3.1C3.5 285.4-2 295.4 .7 304.9s12.7 15.1 22.3 12.4l10.3-2.9c8 15.5 20.7 28.3 36.4 36.4L66.7 361c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.3-12.4l3.1-11c17.8 .8 34.7-4.1 48.8-13.2l8 8c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-8-8c6.8-10.6 11.3-22.9 12.7-36.2l.1-.6c.2-1.3 .7-3.8 1.7-7.4l.2-.6 9.4 4c9.1 3.9 19.7-.3 23.6-9.5s-.3-19.7-9.5-23.6l-8.5-3.6c7.5-11.1 18.7-23.7 36.5-34.5l1.6 5.6c2.7 9.6 12.7 15.1 22.3 12.4s15.1-12.7 12.4-22.3l-3-10.6c5.2-1.7 10.7-3.2 16.6-4.6c9.7-2.2 18.5-6 26.4-11.1l8 8c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-8-8c9.1-14.3 14-31.2 13.2-48.8l11-3.1c9.6-2.7 15.1-12.7 12.4-22.3S370.6 64 361 66.7l-10.3 2.9c-8.1-15.9-21-28.5-36.4-36.4l2.9-10.3c2.7-9.6-2.8-19.5-12.4-22.3zM106.2 275.8l-37.1-3.4 0 0 37.1 3.4zM128 256c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm96-112c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zm98.7 345c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l3.1-11c7.4 .3 14.9-.4 22.4-2.1c9-2.1 17.8-4.4 26.2-7l4.4 10.3c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-3.6-8.5c16.5-7.1 31.5-15.1 45.2-23.9L493 450c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-5.8-8.7c13.5-11.2 25.3-23.1 35.5-35.3l10.1 8.1c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3L574 357c1.6-2.4 3.1-4.8 4.5-7.3c7.1-11.8 12.8-23.2 17.4-34l7.4 3c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-8.7-3.5c.2-.8 .4-1.6 .7-2.3c2.6-9.4 4.2-17.4 5.3-23.5c.5-3.1 .9-5.7 1.2-7.7c.1-1 .2-2 .3-2.7l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.4-2.8l0 0 29.4 2.7c.3-3.8 .4-7.5 .3-11.2l11-3.1c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-10.3 2.9c-8-15.5-20.7-28.3-36.4-36.4l2.9-10.3c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.2 12.4l-3.1 11c-17.8-.8-34.7 4.1-48.8 13.2l-8-8c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l8 8c-6.8 10.6-11.3 22.9-12.7 36.2l-.1 .6c-.2 1.3-.7 3.8-1.7 7.4l-.2 .6-9.4-4c-9.1-3.9-19.7 .3-23.6 9.5s.3 19.7 9.5 23.6l8.5 3.6c-7.5 11.1-18.7 23.7-36.5 34.5l-1.6-5.6c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l3 10.6c-5.2 1.7-10.7 3.2-16.6 4.6c-9.7 2.2-18.5 6-26.4 11.1l-8-8c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l8 8c-9.1 14.2-14 31.2-13.2 48.8l-11 3.1c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l10.3-2.9c8.1 15.9 21 28.5 36.4 36.4l-3 10.3zM570.9 239.5l0 0-37.1-3.4 37.1 3.4zM384 384c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var $8063e68b12ef6db0$export$54608d0a883fea4d = {
    prefix: "fas",
    iconName: "hand-lizard",
    icon: [
        512,
        512,
        [],
        "f258",
        "M0 112C0 85.5 21.5 64 48 64H160h80 46.5c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8v12 16 48c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V402.2L273.9 352H240 160 112c-26.5 0-48-21.5-48-48s21.5-48 48-48h48 80c26.5 0 48-21.5 48-48s-21.5-48-48-48H160 48c-26.5 0-48-21.5-48-48z"
    ]
};
var $8063e68b12ef6db0$export$c7675a37487adc45 = {
    prefix: "fas",
    iconName: "disease",
    icon: [
        512,
        512,
        [],
        "f7fa",
        "M238.5 53.1C251 39.6 268.6 32 287 32c28.9 0 54.5 18.7 63.2 46.3L366 128.6c7.3 23 25.2 41 48.2 48.3l62.2 19.9c21.2 6.8 35.6 26.5 35.6 48.7c0 17.5-8.9 33.7-23.6 43.1l-85.9 54.8c-10.6 6.8-16.6 18.8-15.7 31.3l2.5 33.9c2.8 38.5-27.7 71.4-66.4 71.4c-13.6 0-26.9-4.2-38.1-12l-48.2-33.6c-14.8-10.3-32.3-15.8-50.3-15.8H170.2c-4.9 0-9.9 .4-14.8 1.2L83.9 432.1c-21.3 3.6-42.8-5.7-54.6-23.9c-11.8-18.1-11.8-41.4 0-59.4L56.5 307c4.9-7.5 7.5-16.3 7.5-25.3c0-9.9-3.2-19.5-9-27.4L11.3 194.6C-6.5 170.3-.7 136.2 24.2 119.2c9.7-6.6 21.2-9.8 32.9-9.1l80.6 4.6c26.1 1.5 51.5-8.7 69.4-27.9l31.5-33.8zM160 256c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm160-48c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zM288 352c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$5000f52ca9819bf5 = {
    prefix: "fas",
    iconName: "briefcase-medical",
    icon: [
        512,
        512,
        [],
        "f469",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm96 152c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var $8063e68b12ef6db0$export$c093cc22e88981c2 = {
    prefix: "fas",
    iconName: "genderless",
    icon: [
        384,
        512,
        [],
        "f22d",
        "M192 368c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112s-50.1 112-112 112zm0 64c97.2 0 176-78.8 176-176s-78.8-176-176-176S16 158.8 16 256s78.8 176 176 176z"
    ]
};
var $8063e68b12ef6db0$export$930de8c26eb20490 = {
    prefix: "fas",
    iconName: "chevron-right",
    icon: [
        384,
        512,
        [
            9002
        ],
        "f054",
        "M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
    ]
};
var $8063e68b12ef6db0$export$cebc76f79478e40e = {
    prefix: "fas",
    iconName: "retweet",
    icon: [
        576,
        512,
        [],
        "f079",
        "M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V192h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 128c0 53 43 96 96 96H272zM304 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 128H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0V192c0-53-43-96-96-96L304 96z"
    ]
};
var $8063e68b12ef6db0$export$ff2b8d5628da5f14 = {
    prefix: "fas",
    iconName: "car-rear",
    icon: [
        512,
        512,
        [
            "car-alt"
        ],
        "f5de",
        "M165.4 96H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 192H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256v80c0 23.7 12.9 44.4 32 55.4V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V400H384v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V391.4c19.1-11.1 32-31.7 32-55.4V256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM208 272h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16zM48 280c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24zm360-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H408c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $8063e68b12ef6db0$export$7937ed2462a665c0 = $8063e68b12ef6db0$export$ff2b8d5628da5f14;
var $8063e68b12ef6db0$export$821aeede187f23c9 = {
    prefix: "fas",
    iconName: "pump-soap",
    icon: [
        448,
        512,
        [],
        "e06b",
        "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360z"
    ]
};
var $8063e68b12ef6db0$export$a714fc79f58cc9ef = {
    prefix: "fas",
    iconName: "video-slash",
    icon: [
        640,
        512,
        [],
        "f4e2",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L448 174.9V192 320v5.8l-32-25.1V128c0-35.3-28.7-64-64-64H113.9L38.8 5.1zM32 128V384c0 35.3 28.7 64 64 64H352c23.4 0 43.9-12.6 55-31.3L32.3 121.5c-.2 2.1-.3 4.3-.3 6.5z"
    ]
};
var $8063e68b12ef6db0$export$acec92052ac2183 = {
    prefix: "fas",
    iconName: "battery-quarter",
    icon: [
        576,
        512,
        [
            "battery-2"
        ],
        "f243",
        "M0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176zm80-16c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zm112 32V320H96V192h96z"
    ]
};
var $8063e68b12ef6db0$export$23ca8a94c555576 = $8063e68b12ef6db0$export$acec92052ac2183;
var $8063e68b12ef6db0$export$11b26516cae2104f = {
    prefix: "fas",
    iconName: "radio",
    icon: [
        512,
        512,
        [
            128251
        ],
        "f8d7",
        "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v4V304 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5L494.8 47zM368 400c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80zM80 256c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM64 320c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 64c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
    ]
};
var $8063e68b12ef6db0$export$3b3ab4d86bad7d26 = {
    prefix: "fas",
    iconName: "baby-carriage",
    icon: [
        512,
        512,
        [
            "carriage-baby"
        ],
        "f77d",
        "M256 192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192zm128-32c0-35.3 28.7-64 64-64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0v64c0 25.2-5.8 50.2-17 73.5s-27.8 44.5-48.6 62.3s-45.5 32-72.7 41.6S253.4 416 224 416s-58.5-5-85.7-14.6s-51.9-23.8-72.7-41.6s-37.3-39-48.6-62.3S0 249.2 0 224l224 0 160 0V160zM80 512c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48zm336-48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48z"
    ]
};
var $8063e68b12ef6db0$export$9f117d92ccd36cf1 = $8063e68b12ef6db0$export$3b3ab4d86bad7d26;
var $8063e68b12ef6db0$export$bf0b19daceaec9c2 = {
    prefix: "fas",
    iconName: "traffic-light",
    icon: [
        320,
        512,
        [
            128678
        ],
        "f637",
        "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 320c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48zm-48-80c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48zM160 64c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48z"
    ]
};
var $8063e68b12ef6db0$export$f576739e9b18ea4f = {
    prefix: "fas",
    iconName: "thermometer",
    icon: [
        512,
        512,
        [],
        "f491",
        "M96 382.1V293.3c0-14.9 5.9-29.1 16.4-39.6l27.3-27.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0C465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L258.3 399.6c-10.5 10.5-24.7 16.4-39.6 16.4H129.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l89-89z"
    ]
};
var $8063e68b12ef6db0$export$248171cb6dad4307 = {
    prefix: "fas",
    iconName: "vr-cardboard",
    icon: [
        640,
        512,
        [],
        "f729",
        "M576 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H184.4c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM224 240c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm256 64c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z"
    ]
};
var $8063e68b12ef6db0$export$bd40d3a3a16fb147 = {
    prefix: "fas",
    iconName: "hand-middle-finger",
    icon: [
        448,
        512,
        [
            128405
        ],
        "f806",
        "M232 0c-22.1 0-40 17.9-40 40V204.2c-8.5-7.6-19.7-12.2-32-12.2c-26.5 0-48 21.5-48 48v7 73c0 8.8-7.2 16-16 16s-16-7.2-16-16V264.3c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334V372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H304c70.7 0 128-57.3 128-128V320 288c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z"
    ]
};
var $8063e68b12ef6db0$export$89a1764fbb7ad2cb = {
    prefix: "fas",
    iconName: "percent",
    icon: [
        384,
        512,
        [
            62101,
            62785,
            "percentage"
        ],
        "25",
        "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128c0-35.3-28.7-64-64-64S0 92.7 0 128s28.7 64 64 64s64-28.7 64-64zM384 384c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $8063e68b12ef6db0$export$89333857fc063a2e = $8063e68b12ef6db0$export$89a1764fbb7ad2cb;
var $8063e68b12ef6db0$export$a06617a1a4ccea67 = {
    prefix: "fas",
    iconName: "truck-moving",
    icon: [
        640,
        512,
        [],
        "f4df",
        "M64 32C28.7 32 0 60.7 0 96V304v80 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16H416h33.6c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H608c17.7 0 32-14.3 32-32V288 272 261.7c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H480V96c0-35.3-28.7-64-64-64H64zM585 256H480V192h48.8c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 432c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zM240 400c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM80 432c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$b7ae54b4078b2060 = {
    prefix: "fas",
    iconName: "glass-water-droplet",
    icon: [
        448,
        512,
        [],
        "e4f5",
        "M64 0C55.1 0 46.6 3.7 40.6 10.2s-9.1 15.2-8.5 24.1L60.9 437.7c3 41.9 37.8 74.3 79.8 74.3H307.3c42 0 76.8-32.4 79.8-74.3L415.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S392.9 0 384 0H64zm51 297.5L98.4 64H349.6L333 297.5 320 304c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0s-43.9 10.1-64 0l-13-6.5zM288 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C193.7 125.9 160 172 160 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"
    ]
};
var $8063e68b12ef6db0$export$e9d85839f7751f01 = {
    prefix: "fas",
    iconName: "display",
    icon: [
        576,
        512,
        [],
        "e163",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V352H64V64H512z"
    ]
};
var $8063e68b12ef6db0$export$b5023c446f10324 = {
    prefix: "fas",
    iconName: "face-smile",
    icon: [
        512,
        512,
        [
            128578,
            "smile"
        ],
        "f118",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM208.4 208c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm128 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$c632b2334f0913bc = $8063e68b12ef6db0$export$b5023c446f10324;
var $8063e68b12ef6db0$export$b6314cdc01bb5c43 = {
    prefix: "fas",
    iconName: "thumbtack",
    icon: [
        384,
        512,
        [
            128204,
            128392,
            "thumb-tack"
        ],
        "f08d",
        "M32 32C32 14.3 46.3 0 64 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H290.5l11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H32c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64H64C46.3 64 32 49.7 32 32zM160 384h64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"
    ]
};
var $8063e68b12ef6db0$export$b63d0c7b519a9aae = $8063e68b12ef6db0$export$b6314cdc01bb5c43;
var $8063e68b12ef6db0$export$29c432d69ccf85a5 = {
    prefix: "fas",
    iconName: "trophy",
    icon: [
        576,
        512,
        [
            127942
        ],
        "f091",
        "M400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H24C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.9C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6h84.4c-5.1 66.3-31.1 111.2-63 142.3z"
    ]
};
var $8063e68b12ef6db0$export$8ecd436ef91fc02e = {
    prefix: "fas",
    iconName: "person-praying",
    icon: [
        448,
        512,
        [
            128720,
            "pray"
        ],
        "f683",
        "M352 64c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64zM232.7 264l22.9 31.5c6.5 8.9 16.3 14.7 27.2 16.1s21.9-1.7 30.4-8.7l88-72c17.1-14 19.6-39.2 5.6-56.3s-39.2-19.6-56.3-5.6l-55.2 45.2-26.2-36C253.6 156.7 228.6 144 202 144c-30.9 0-59.2 17.1-73.6 44.4L79.8 280.9c-20.2 38.5-9.4 85.9 25.6 111.8L158.6 432H72c-22.1 0-40 17.9-40 40s17.9 40 40 40H280c17.3 0 32.6-11.1 38-27.5s-.3-34.4-14.2-44.7L187.7 354l45-90z"
    ]
};
var $8063e68b12ef6db0$export$3b32c982141cad51 = $8063e68b12ef6db0$export$8ecd436ef91fc02e;
var $8063e68b12ef6db0$export$6310f315e1ebbca5 = {
    prefix: "fas",
    iconName: "hammer",
    icon: [
        576,
        512,
        [
            128296
        ],
        "f6e3",
        "M413.5 237.5c-28.2 4.8-58.2-3.6-80-25.4l-38.1-38.1C280.4 159 272 138.8 272 117.6V105.5L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42c24.2 22.8 33.2 55.7 26.6 86L503 183l8-8c9.4-9.4 24.6-9.4 33.9 0l24 24c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-24-24c-9.4-9.4-9.4-24.6 0-33.9l8-8-17.5-17.5zM27.4 377.1L260.9 182.6c3.5 4.9 7.5 9.6 11.8 14l38.1 38.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"
    ]
};
var $8063e68b12ef6db0$export$e49e3cfceea441cc = {
    prefix: "fas",
    iconName: "hand-peace",
    icon: [
        512,
        512,
        [
            9996
        ],
        "f25b",
        "M224 0c17.7 0 32 14.3 32 32V240H192V32c0-17.7 14.3-32 32-32zm96 160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zM93.3 51.2L175.9 240H106.1L34.7 76.8C27.6 60.6 35 41.8 51.2 34.7s35.1 .3 42.1 16.5zm27 221.3l-.2-.5h69.9H216c22.1 0 40 17.9 40 40s-17.9 40-40 40H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H226.3c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363V336c0-32.7 24.6-59.7 56.3-63.5z"
    ]
};
var $8063e68b12ef6db0$export$decde496a29c5b23 = {
    prefix: "fas",
    iconName: "rotate",
    icon: [
        512,
        512,
        [
            128260,
            "sync-alt"
        ],
        "f2f1",
        "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"
    ]
};
var $8063e68b12ef6db0$export$2ff2056be8c281e4 = $8063e68b12ef6db0$export$decde496a29c5b23;
var $8063e68b12ef6db0$export$1025ad641edb49c2 = {
    prefix: "fas",
    iconName: "spinner",
    icon: [
        512,
        512,
        [],
        "f110",
        "M304 48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm0 416c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM48 304c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm464-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM142.9 437c18.7-18.7 18.7-49.1 0-67.9s-49.1-18.7-67.9 0s-18.7 49.1 0 67.9s49.1 18.7 67.9 0zm0-294.2c18.7-18.7 18.7-49.1 0-67.9S93.7 56.2 75 75s-18.7 49.1 0 67.9s49.1 18.7 67.9 0zM369.1 437c18.7 18.7 49.1 18.7 67.9 0s18.7-49.1 0-67.9s-49.1-18.7-67.9 0s-18.7 49.1 0 67.9z"
    ]
};
var $8063e68b12ef6db0$export$30a5bb4ad3fa716c = {
    prefix: "fas",
    iconName: "robot",
    icon: [
        640,
        512,
        [
            129302
        ],
        "f544",
        "M320 0c17.7 0 32 14.3 32 32V96H480c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM264 256c0-22.1-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40s40-17.9 40-40zm152 40c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16z"
    ]
};
var $8063e68b12ef6db0$export$8614cb1326eacd7a = {
    prefix: "fas",
    iconName: "peace",
    icon: [
        512,
        512,
        [
            9774
        ],
        "f67c",
        "M224 445.3V323.5l-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1L224 240.8V66.7C133.2 81.9 64 160.9 64 256c0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5L288 323.5V445.3c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1c0-95.1-69.2-174.1-160-189.3V240.8L422.8 351.1zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"
    ]
};
var $8063e68b12ef6db0$export$4aac79b9ae3cfdb8 = {
    prefix: "fas",
    iconName: "gears",
    icon: [
        640,
        512,
        [
            "cogs"
        ],
        "f085",
        "M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25c-2.3-5.3-4.8-10.5-7.6-15.5L304 89.4c-3-5-6.3-9.9-9.8-14.6c-5.7-7.6-15.7-10.1-24.7-7.1l-28.2 9.3c-10.7-8.8-23-16-36.2-20.9L199 27.1c-1.9-9.3-9.1-16.7-18.5-17.8C173.7 8.4 166.9 8 160 8s-13.7 .4-20.4 1.2c-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9L50.5 67.8c-9-3-19-.5-24.7 7.1c-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6c-3.7 8.7-.9 18.6 6.2 25l22.2 19.8C32.6 161.9 32 168.9 32 176s.6 14.1 1.7 20.9L11.5 216.7c-7.1 6.3-9.9 16.2-6.2 25c2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6c5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8c6.7 .8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1c3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5c3.7-8.7 .9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM208 176c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM504.7 500.5c6.3 7.1 16.2 9.9 25 6.2c5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8c7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2l29.1-6.1c9.3-1.9 16.7-9.1 17.8-18.5c.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5L583.9 307c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7c-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6c-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1 .6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2c-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9c-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2L315.1 313c-9.3 1.9-16.7 9.1-17.8 18.5c-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7c4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6c8.7 3.7 18.6 .9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 400c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $8063e68b12ef6db0$export$af1575770afc9559 = $8063e68b12ef6db0$export$4aac79b9ae3cfdb8;
var $8063e68b12ef6db0$export$e3a174a50618c208 = {
    prefix: "fas",
    iconName: "warehouse",
    icon: [
        640,
        512,
        [],
        "f494",
        "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm488 24l-336 0c-13.3 0-24-10.7-24-24V432H512l0 56c0 13.3-10.7 24-24 24zM128 400V336H512v64H128zm0-96V224H512l0 80H128z"
    ]
};
var $8063e68b12ef6db0$export$bc804c6ab898f610 = {
    prefix: "fas",
    iconName: "arrow-up-right-dots",
    icon: [
        576,
        512,
        [],
        "e4b7",
        "M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H160zM576 80c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM448 208c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM400 384c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm48 80c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm128 0c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM272 384c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm48 80c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM144 512c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM576 336c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zm-48-80c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48z"
    ]
};
var $8063e68b12ef6db0$export$d6f21e17ea797702 = {
    prefix: "fas",
    iconName: "splotch",
    icon: [
        512,
        512,
        [],
        "f5bc",
        "M287.6 .1c-19.7 0-38.3 9.1-50.4 24.6L205.9 64.9c-17.9 23-46 35.6-75.1 33.7L59.1 94c-13.5-.9-26.9 3.2-37.7 11.6C-1.3 123.2-6.7 155.2 8.8 179.4l44.5 69.2c7.1 11 10.8 23.8 10.8 36.8c0 11.9-3.1 23.5-9 33.8L27.4 367.7c-10 17.5-10 39.1 0 56.6c12.1 21.2 36.4 32.3 60.4 27.7l67-13c5.5-1.1 11.2-1.6 16.8-1.6H180c20.9 0 41 7.4 56.9 20.9l45 38.2c11.8 10 26.9 15.6 42.4 15.6c37.8 0 67.7-31.9 65.4-69.6l-3.1-50.6c-1-16.8 6.6-32.9 20.1-42.8l82.5-60.2c14.2-10.4 22.7-27 22.7-44.6c0-23.2-14.5-43.9-36.3-51.8l-58.2-21.2c-24.4-8.9-42.9-29.1-49.7-54.2L349.3 47.4C341.8 19.5 316.5 .1 287.6 .1z"
    ]
};
var $8063e68b12ef6db0$export$fbb22081b65e4f33 = {
    prefix: "fas",
    iconName: "face-grin-hearts",
    icon: [
        512,
        512,
        [
            128525,
            "grin-hearts"
        ],
        "f584",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM383.8 317.8c12.3-3.7 24.3 7 19.2 18.7c-24.5 56.9-81.1 96.7-147 96.7s-122.5-39.8-147-96.7c-5.1-11.8 6.9-22.4 19.2-18.7C166.7 329.4 210.1 336 256 336s89.3-6.6 127.8-18.2zM199.3 129.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
    ]
};
var $8063e68b12ef6db0$export$c56cf0e0c3bc5ed2 = $8063e68b12ef6db0$export$fbb22081b65e4f33;
var $8063e68b12ef6db0$export$2df6451abf70a6ff = {
    prefix: "fas",
    iconName: "dice-four",
    icon: [
        448,
        512,
        [
            9859
        ],
        "f524",
        "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM128 384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zM352 160c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM320 384c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$3bee83bf278fddbe = {
    prefix: "fas",
    iconName: "sim-card",
    icon: [
        384,
        512,
        [],
        "f7c4",
        "M64 0H242.7c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM96 192c-17.7 0-32 14.3-32 32v32h64V192H96zM64 352h80 96 80V288H240 144 64v64zM320 224c0-17.7-14.3-32-32-32H256v64h64V224zM160 192v64h64V192H160zM288 448c17.7 0 32-14.3 32-32V384H256v64h32zM160 384v64h64V384H160zM64 416c0 17.7 14.3 32 32 32h32V384H64v32z"
    ]
};
var $8063e68b12ef6db0$export$7e3f1701aa95ef01 = {
    prefix: "fas",
    iconName: "transgender",
    icon: [
        512,
        512,
        [
            9895,
            "transgender-alt"
        ],
        "f225",
        "M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h96c8.8 0 16 7.2 16 16v96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2V432h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V414.2C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7L58.3 92.3l-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112V16C0 7.2 7.2 0 16 0h96zM352 256c0-53-43-96-96-96s-96 43-96 96s43 96 96 96s96-43 96-96z"
    ]
};
var $8063e68b12ef6db0$export$9c36cf9334c052f = $8063e68b12ef6db0$export$7e3f1701aa95ef01;
var $8063e68b12ef6db0$export$e134ecd00b622a47 = {
    prefix: "fas",
    iconName: "mercury",
    icon: [
        384,
        512,
        [
            9791
        ],
        "f223",
        "M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4V424h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V472H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V398.4C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9C83.7 70.5 74.9 61.7 67.1 52c-11.1-13.8-8.8-33.9 5-45zM80 224c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112z"
    ]
};
var $8063e68b12ef6db0$export$fd4d6cfd52703f50 = {
    prefix: "fas",
    iconName: "arrow-turn-down",
    icon: [
        384,
        512,
        [
            "level-down"
        ],
        "f149",
        "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"
    ]
};
var $8063e68b12ef6db0$export$3794c07e7a666c94 = $8063e68b12ef6db0$export$fd4d6cfd52703f50;
var $8063e68b12ef6db0$export$a75569baaf4a6c3a = {
    prefix: "fas",
    iconName: "person-falling-burst",
    icon: [
        640,
        512,
        [],
        "e547",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2V352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10 1.6-19.8 4.5-29L261.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L222.6 320H224l80 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C341.3 263.1 327.1 256 312 256l-71.5 0-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6l0-9.8zM96 80c0-26.5-21.5-48-48-48S0 53.5 0 80s21.5 48 48 48s48-21.5 48-48zM464 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L508.3 92.1l-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74L343.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7c.1 .3 .1 .6 .2 .8l19.4 0c20.1 0 39.2 7.5 53.8 20.8l18.4 2.9L383 265.3l36.2 48.3c2.1 2.8 3.9 5.7 5.5 8.6L464 286.1z"
    ]
};
var $8063e68b12ef6db0$export$f8db2747dadd48f7 = {
    prefix: "fas",
    iconName: "award",
    icon: [
        384,
        512,
        [],
        "f559",
        "M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7L344.5 83c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7L301 344.5c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2 .8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1 .4 14.2-1.5 20.1-5.4L173.8 5.5zM272 192c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80s80-35.8 80-80zM1.3 441.8L44.4 339.3c.2 .1 .3 .2 .4 .4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7 .2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1 .4-.2 .7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2 .2-.3 .4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"
    ]
};
var $8063e68b12ef6db0$export$68ddda3b30ba09f0 = {
    prefix: "fas",
    iconName: "ticket-simple",
    icon: [
        576,
        512,
        [
            "ticket-alt"
        ],
        "f3ff",
        "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v80c-26.5 0-48 21.5-48 48s21.5 48 48 48v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V304c26.5 0 48-21.5 48-48s-21.5-48-48-48V128z"
    ]
};
var $8063e68b12ef6db0$export$75e38ba471fd89c4 = $8063e68b12ef6db0$export$68ddda3b30ba09f0;
var $8063e68b12ef6db0$export$f26673f8b10c3d46 = {
    prefix: "fas",
    iconName: "building",
    icon: [
        384,
        512,
        [
            127970,
            61687
        ],
        "f1ad",
        "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$2ebd565813951f81 = {
    prefix: "fas",
    iconName: "angles-left",
    icon: [
        512,
        512,
        [
            171,
            "angle-double-left"
        ],
        "f100",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
    ]
};
var $8063e68b12ef6db0$export$21b0833b3cf929a7 = $8063e68b12ef6db0$export$2ebd565813951f81;
var $8063e68b12ef6db0$export$fc19ca0fe15e73bc = {
    prefix: "fas",
    iconName: "qrcode",
    icon: [
        448,
        512,
        [],
        "f029",
        "M48 32C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm80 64v64H64V96h64zM48 288c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48zm80 64v64H64V352h64zM256 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zm64 16h64v64H320V96zm32 352v32h32V448H352zm96 0H416v32h32V448zM416 288v32H352V288H256v96 96h64V384h32v32h96V352 320 288H416z"
    ]
};
var $8063e68b12ef6db0$export$29be1665d1b36a3b = {
    prefix: "fas",
    iconName: "clock-rotate-left",
    icon: [
        512,
        512,
        [
            "history"
        ],
        "f1da",
        "M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"
    ]
};
var $8063e68b12ef6db0$export$76d1986559ca7b7a = $8063e68b12ef6db0$export$29be1665d1b36a3b;
var $8063e68b12ef6db0$export$2ff38f330c834084 = {
    prefix: "fas",
    iconName: "face-grin-beam-sweat",
    icon: [
        512,
        512,
        [
            128517,
            "grin-beam-sweat"
        ],
        "f583",
        "M476.8 126.3c-4.1 1.1-8.4 1.7-12.8 1.7c-26.5 0-48-21-48-47c0-5 1.8-11.3 4.6-18.1c.3-.7 .6-1.4 .9-2.1c9-20.2 26.5-44.9 36-57.5c3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81c0 21.7-14.9 39.8-35.2 45.3zM256 0c51.4 0 99.3 15.2 139.4 41.2c-1.5 3.1-3 6.2-4.3 9.3c-3.4 8-7.1 19-7.1 30.5c0 44.3 36.6 79 80 79c9.6 0 18.8-1.7 27.4-4.8c13.3 30.9 20.6 65 20.6 100.8c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0zM383.8 317.8C345.3 329.4 301.9 336 256 336s-89.3-6.6-127.8-18.2c-12.3-3.7-24.3 7-19.2 18.7c24.5 56.9 81.1 96.7 147 96.7s122.5-39.8 147-96.7c5.1-11.8-6.9-22.4-19.2-18.7zm-166.2-89l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"
    ]
};
var $8063e68b12ef6db0$export$14d0ccc54c5b6826 = $8063e68b12ef6db0$export$2ff38f330c834084;
var $8063e68b12ef6db0$export$364f19abcfac1b0a = {
    prefix: "fas",
    iconName: "file-export",
    icon: [
        640,
        512,
        [
            "arrow-right-from-file"
        ],
        "f56e",
        "M32 64C32 28.7 60.7 0 96 0H256V128c0 17.7 14.3 32 32 32H416V288H248c-13.3 0-24 10.7-24 24s10.7 24 24 24H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM416 336V288H526.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H416zm0-208H288V0L416 128z"
    ]
};
var $8063e68b12ef6db0$export$b9c76255b38e1df1 = $8063e68b12ef6db0$export$364f19abcfac1b0a;
var $8063e68b12ef6db0$export$8241bd5b9163ca12 = {
    prefix: "fas",
    iconName: "shield",
    icon: [
        512,
        512,
        [
            128737,
            "shield-blank"
        ],
        "f132",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.7 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z"
    ]
};
var $8063e68b12ef6db0$export$64f54da8fbaba8ee = $8063e68b12ef6db0$export$8241bd5b9163ca12;
var $8063e68b12ef6db0$export$be9d5060a4bc3b4b = {
    prefix: "fas",
    iconName: "arrow-up-short-wide",
    icon: [
        576,
        512,
        [
            "sort-amount-up-alt"
        ],
        "f885",
        "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
    ]
};
var $8063e68b12ef6db0$export$6e87844b0f151b6a = $8063e68b12ef6db0$export$be9d5060a4bc3b4b;
var $8063e68b12ef6db0$export$2d077da983246a68 = {
    prefix: "fas",
    iconName: "house-medical",
    icon: [
        576,
        512,
        [],
        "e3b2",
        "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
    ]
};
var $8063e68b12ef6db0$export$14c9f1d85e53ae99 = {
    prefix: "fas",
    iconName: "golf-ball-tee",
    icon: [
        384,
        512,
        [
            "golf-ball"
        ],
        "f450",
        "M384 192c0 66.8-34.1 125.6-85.8 160H85.8C34.1 317.6 0 258.8 0 192C0 86 86 0 192 0S384 86 384 192zM242.1 256.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.6-1.1-13.8-3c5.3 11.6 16.9 19.7 30.5 19.7c18.5 0 33.5-15 33.5-33.5c0-13.6-8.1-25.3-19.7-30.5c1.9 4.2 3 8.9 3 13.8zm-52.3-49.3c-4.9 0-9.6-1.1-13.8-3c5.3 11.6 16.9 19.7 30.5 19.7c18.5 0 33.5-15 33.5-33.5c0-13.6-8.1-25.3-19.7-30.5c1.9 4.2 3 8.9 3 13.8c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.6-1.1-13.8-3c5.3 11.6 16.9 19.7 30.5 19.7c18.5 0 33.5-15 33.5-33.5c0-13.6-8.1-25.3-19.7-30.5c1.9 4.2 3 8.9 3 13.8zM96 416c0-17.7 14.3-32 32-32h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H240c-8.8 0-16 7.2-16 16v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V464c0-8.8-7.2-16-16-16H128c-17.7 0-32-14.3-32-32z"
    ]
};
var $8063e68b12ef6db0$export$2251487a9a33c682 = $8063e68b12ef6db0$export$14c9f1d85e53ae99;
var $8063e68b12ef6db0$export$f2b13ad44c03c40f = {
    prefix: "fas",
    iconName: "circle-chevron-left",
    icon: [
        512,
        512,
        [
            "chevron-circle-left"
        ],
        "f137",
        "M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512s256-114.6 256-256zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"
    ]
};
var $8063e68b12ef6db0$export$4a42c8c2451a33fd = $8063e68b12ef6db0$export$f2b13ad44c03c40f;
var $8063e68b12ef6db0$export$792391babe46862d = {
    prefix: "fas",
    iconName: "house-chimney-window",
    icon: [
        576,
        512,
        [],
        "e00d",
        "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM248 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H248z"
    ]
};
var $8063e68b12ef6db0$export$a82594dcc75a49f5 = {
    prefix: "fas",
    iconName: "pen-nib",
    icon: [
        512,
        512,
        [
            10001
        ],
        "f5ad",
        "M368.4 18.3L312.7 74.1 437.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L447.6 18.3c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8L134.7 140.6c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4L164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.8-9.2L288 94.6z"
    ]
};
var $8063e68b12ef6db0$export$89af87b7d6c15adf = {
    prefix: "fas",
    iconName: "tent-arrow-turn-left",
    icon: [
        640,
        512,
        [],
        "e580",
        "M152.1 41.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72C34.9 82.7 32 89.2 32 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L118.5 120 488 120c39.8 0 72 32.2 72 72v40c0 13.3 10.7 24 24 24s24-10.7 24-24V192c0-66.3-53.7-120-120-120L118.5 72l33.5-30.2zM339.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6s14.9 11.1 24.2 11.1H320V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $8063e68b12ef6db0$export$c93b950e845a4ee7 = {
    prefix: "fas",
    iconName: "tents",
    icon: [
        640,
        512,
        [],
        "e582",
        "M396.6 6.5L235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5H608c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-11.5-8.7-27.3-8.7-38.8 0zm-153.2 160c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S22.7 512 32 512H224V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $8063e68b12ef6db0$export$8282f5f5dcf6b009 = {
    prefix: "fas",
    iconName: "wand-magic",
    icon: [
        512,
        512,
        [
            "magic"
        ],
        "f0d0",
        "M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3zM347.6 187.6l105-105L429.4 59.3l-105 105 23.3 23.3z"
    ]
};
var $8063e68b12ef6db0$export$e58f9b502d4dd52d = $8063e68b12ef6db0$export$8282f5f5dcf6b009;
var $8063e68b12ef6db0$export$c6406747800cf702 = {
    prefix: "fas",
    iconName: "dog",
    icon: [
        576,
        512,
        [
            128021
        ],
        "f6d3",
        "M309.6 158.5L332.7 19.8C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80H464 448 426.7l-5.1 30.5-112-64zM416 256.1L416 480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V364.8c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h30 16H303.8L416 256.1zM464 80c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16z"
    ]
};
var $8063e68b12ef6db0$export$28e93ec9f5e2ddf3 = {
    prefix: "fas",
    iconName: "carrot",
    icon: [
        512,
        512,
        [
            129365
        ],
        "f787",
        "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM244.6 136c-40 0-77.1 18.1-101.7 48.2l60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.3-55.3 0 .1L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8l134.7-62.4-52.1-52.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L199.7 433l100.2-46.4c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136z"
    ]
};
var $8063e68b12ef6db0$export$c4c2f69a53bab720 = {
    prefix: "fas",
    iconName: "moon",
    icon: [
        384,
        512,
        [
            127769,
            9214
        ],
        "f186",
        "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
    ]
};
var $8063e68b12ef6db0$export$b86d7336e68a3f57 = {
    prefix: "fas",
    iconName: "wine-glass-empty",
    icon: [
        320,
        512,
        [
            "wine-glass-alt"
        ],
        "f5ce",
        "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H64zM81.9 203.1L93.4 64H226.6l11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z"
    ]
};
var $8063e68b12ef6db0$export$b8ff3fe2b78aef2f = $8063e68b12ef6db0$export$b86d7336e68a3f57;
var $8063e68b12ef6db0$export$549b99473b7201e6 = {
    prefix: "fas",
    iconName: "cheese",
    icon: [
        512,
        512,
        [],
        "f7ef",
        "M512 240.2V256H0c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2zm0 47.8V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288H512z"
    ]
};
var $8063e68b12ef6db0$export$6ec1acbf3f610b8f = {
    prefix: "fas",
    iconName: "yin-yang",
    icon: [
        512,
        512,
        [
            9775
        ],
        "f6ad",
        "M256 64c53 0 96 43 96 96s-43 96-96 96s-96 43-96 96s43 96 96 96C150 448 64 362 64 256S150 64 256 64zm0 448c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm32-352c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$fcb0647a5340b5b8 = {
    prefix: "fas",
    iconName: "music",
    icon: [
        512,
        512,
        [
            127925
        ],
        "f001",
        "M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7v72V368c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V147L192 223.8V432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V200 128c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z"
    ]
};
var $8063e68b12ef6db0$export$d5d870c10bc9f1ce = {
    prefix: "fas",
    iconName: "code-commit",
    icon: [
        640,
        512,
        [],
        "f386",
        "M320 336c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zm156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H163.2C178 151 242.6 96 320 96s142 55 156.8 128H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H476.8z"
    ]
};
var $8063e68b12ef6db0$export$9e9af12b90a1abd2 = {
    prefix: "fas",
    iconName: "temperature-low",
    icon: [
        512,
        512,
        [],
        "f76b",
        "M448 96c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm64 0c0 53-43 96-96 96s-96-43-96-96s43-96 96-96s96 43 96 96zM144 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM192 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
    ]
};
var $8063e68b12ef6db0$export$cf152282d5de300d = {
    prefix: "fas",
    iconName: "person-biking",
    icon: [
        640,
        512,
        [
            128692,
            "biking"
        ],
        "f84a",
        "M400 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H427.2zM200 384c0 39.8-32.2 72-72 72s-72-32.2-72-72s32.2-72 72-72s72 32.2 72 72zm56 0c0-70.7-57.3-128-128-128S0 313.3 0 384s57.3 128 128 128s128-57.3 128-128zm328 0c0 39.8-32.2 72-72 72s-72-32.2-72-72s32.2-72 72-72s72 32.2 72 72zm56 0c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128z"
    ]
};
var $8063e68b12ef6db0$export$a5bcf835dbf9c0b = $8063e68b12ef6db0$export$cf152282d5de300d;
var $8063e68b12ef6db0$export$2a533051418ff4ca = {
    prefix: "fas",
    iconName: "broom",
    icon: [
        640,
        512,
        [
            129529
        ],
        "f51a",
        "M627.6 57.3c14-10.9 16.5-31 5.6-44.9s-31-16.5-44.9-5.6l-144 112-72 56-8.7 6.8-30.8-39.4c-3.7-4.8-9.8-7-15.8-5.8s-10.7 5.7-12.3 11.5l-12.5 46.3L371.1 295l48-.9c6.1-.1 11.5-3.7 14.1-9.1s1.9-11.9-1.8-16.7L403 231.9l8.6-6.7 72-56 144-112zM16.7 507.7c37.4 2.8 196.8 12 252.3-31.4c57.7-45.1 76.8-161.5 76.8-161.5L267.1 213.9s-117.6-9.6-175.3 35.5C69 267.1 50.5 304.1 36.3 344c-2.4 6.7 4.7 12.8 11 9.4L86.2 333c4.1-2.2 9.2-1.1 12 2.6s2.7 8.8-.4 12.3L24.4 430.4C13.2 442.9 5.5 458.1 2.4 474.5c-.9 4.8-1.6 8.9-2.2 12.1c-.9 5 .5 10.1 3.6 14.1s7.7 6.6 12.8 7z"
    ]
};
var $8063e68b12ef6db0$export$7b96388ca2be471b = {
    prefix: "fas",
    iconName: "shield-heart",
    icon: [
        512,
        512,
        [],
        "e574",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
    ]
};
var $8063e68b12ef6db0$export$31f89d8ac1d14ed6 = {
    prefix: "fas",
    iconName: "gopuram",
    icon: [
        512,
        512,
        [],
        "f664",
        "M120 0c13.3 0 24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h48V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8V64v64c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H416V352H384V224H352V128H320v96h32V352h32V512H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H128V352h32V224h32V128H160v96H128V352H96V512H32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32V256c0-17.7 14.3-32 32-32V160c0-17.7 14.3-32 32-32V64 32 24c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32v48h64V304c0-17.7-14.3-32-32-32zm-32-80v32h64V192c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $8063e68b12ef6db0$export$bd931e906edf2f47 = {
    prefix: "fas",
    iconName: "earth-oceania",
    icon: [
        512,
        512,
        [
            "globe-oceania"
        ],
        "e47b",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3H254.8c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 432c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16zM431.2 298.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $8063e68b12ef6db0$export$8ac3f5271448657d = $8063e68b12ef6db0$export$bd931e906edf2f47;
var $8063e68b12ef6db0$export$5a17e58bb7afb1d7 = {
    prefix: "fas",
    iconName: "square-xmark",
    icon: [
        448,
        512,
        [
            10062,
            "times-square",
            "xmark-square"
        ],
        "f2d3",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $8063e68b12ef6db0$export$c0248ac97142ea2a = $8063e68b12ef6db0$export$5a17e58bb7afb1d7;
var $8063e68b12ef6db0$export$9a364781d6b7602b = $8063e68b12ef6db0$export$5a17e58bb7afb1d7;
var $8063e68b12ef6db0$export$c92c903bade56844 = {
    prefix: "fas",
    iconName: "hashtag",
    icon: [
        448,
        512,
        [
            62098
        ],
        "23",
        "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H347.1L325.8 320H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H315.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1z"
    ]
};
var $8063e68b12ef6db0$export$95457ede07b81517 = {
    prefix: "fas",
    iconName: "up-right-and-down-left-from-center",
    icon: [
        512,
        512,
        [
            "expand-alt"
        ],
        "f424",
        "M344 0H488c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM184 496H40c-13.3 0-24-10.7-24-24V328c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"
    ]
};
var $8063e68b12ef6db0$export$bcb8d86a3a1d6eb6 = $8063e68b12ef6db0$export$95457ede07b81517;
var $8063e68b12ef6db0$export$2599126c3a57f727 = {
    prefix: "fas",
    iconName: "oil-can",
    icon: [
        640,
        512,
        [],
        "f613",
        "M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32H144 96 48c-26.5 0-48 21.5-48 48v64.8c0 19 11.2 36.2 28.5 43.9l67.5 30V368c0 26.5 21.5 48 48 48H403.1c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H288V128h32zM96 208v86.1L48 272.8V208H96z"
    ]
};
var $8063e68b12ef6db0$export$6e625d2e7790c860 = {
    prefix: "fas",
    iconName: "t",
    icon: [
        384,
        512,
        [
            116
        ],
        "54",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H160V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H192 32z"
    ]
};
var $8063e68b12ef6db0$export$d4c909619093de2d = {
    prefix: "fas",
    iconName: "hippo",
    icon: [
        640,
        512,
        [
            129435
        ],
        "f6ed",
        "M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2h32c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L564 101.9c7.6 12.2 12 26.7 12 42.1c0 10.2 7.4 18.8 16.7 23c27.9 12.5 47.3 40.5 47.3 73c0 26.2-12.6 49.4-32 64v32c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16V320H480v16c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V318.4c-11.8-2.4-22.7-7.4-32-14.4c-1.5-1.1-2.9-2.3-4.3-3.5c-17-14.7-27.7-36.4-27.7-60.5c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2V352c0 17.7 14.3 32 32 32h32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V372c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12v76c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V329.1L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 155.7 117.2 68 223.8 64.1l.2-.1h7.2H256h32c41.7 0 83.4 12.1 117.2 25.7c1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185c0-13.3-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24s24-10.7 24-24zm88 24c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zM480 144c0-8.8-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16s16-7.2 16-16zm48 16c8.8 0 16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16s7.2 16 16 16z"
    ]
};
var $8063e68b12ef6db0$export$d01ddcc9efe7b149 = {
    prefix: "fas",
    iconName: "chart-column",
    icon: [
        512,
        512,
        [],
        "e0e3",
        "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$a590003279d671b8 = {
    prefix: "fas",
    iconName: "infinity",
    icon: [
        640,
        512,
        [
            8734,
            9854
        ],
        "f534",
        "M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1v29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9V241.1zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1v29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1V241.1c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"
    ]
};
var $8063e68b12ef6db0$export$2db4f9712313eafa = {
    prefix: "fas",
    iconName: "vial-circle-check",
    icon: [
        512,
        512,
        [],
        "e596",
        "M0 64C0 46.3 14.3 32 32 32H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V266.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V96C14.3 96 0 81.7 0 64zM96 96v96h64V96H96zM512 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zm-76.7-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $8063e68b12ef6db0$export$f9a5161975928326 = {
    prefix: "fas",
    iconName: "person-arrow-down-to-line",
    icon: [
        640,
        512,
        [],
        "e538",
        "M192 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM464 64V306.7l-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $8063e68b12ef6db0$export$4f1ce88b2b4cd5cd = {
    prefix: "fas",
    iconName: "voicemail",
    icon: [
        640,
        512,
        [],
        "f897",
        "M144 160c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80zM263.8 320c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144H496c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80H263.8zM496 320c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $8063e68b12ef6db0$export$55145a3dae4f984a = {
    prefix: "fas",
    iconName: "fan",
    icon: [
        512,
        512,
        [],
        "f863",
        "M258.6 0c-1.7 0-3.4 .1-5.1 .5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224H29.4C13.2 224 0 237.2 0 253.4c0 1.7 .1 3.4 .5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480v2.6c0 16.2 13.2 29.4 29.4 29.4c1.7 0 3.4-.1 5.1-.5C344 495 396.4 409.7 381.5 322.7c-2.9-17-8.4-32.9-15.9-47.4L480 288h2.6c16.2 0 29.4-13.2 29.4-29.4c0-1.7-.1-3.4-.5-5.1C495 168 409.7 115.6 322.7 130.5c-17 2.9-32.9 8.4-47.4 15.9L288 32V29.4C288 13.2 274.8 0 258.6 0zM256 288c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$1ae0a37b36ace746 = {
    prefix: "fas",
    iconName: "person-walking-luggage",
    icon: [
        576,
        512,
        [],
        "e554",
        "M432 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM347.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L505 232.7l-15.3-36.8C472.5 154.8 432.3 128 387.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L340.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM256 274.1c-7.7-4.4-17.4-1.8-21.9 5.9l-32 55.4L147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c1.5-2.6 2.6-5.2 3.3-8L261.9 296c4.4-7.7 1.8-17.4-5.9-21.9z"
    ]
};
var $8063e68b12ef6db0$export$e36c32dd5cba9b90 = {
    prefix: "fas",
    iconName: "up-down",
    icon: [
        256,
        512,
        [
            8597,
            11021,
            "arrows-alt-v"
        ],
        "f338",
        "M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160H80V352H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"
    ]
};
var $8063e68b12ef6db0$export$138cb56a3f8f7040 = $8063e68b12ef6db0$export$e36c32dd5cba9b90;
var $8063e68b12ef6db0$export$301c3fab0c4545bd = {
    prefix: "fas",
    iconName: "cloud-moon-rain",
    icon: [
        640,
        512,
        [],
        "f73c",
        "M513.2 0C449 0 395.5 46.5 385.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1c23.2 11 42 29.7 53.1 52.7c4 .4 8.1 .6 12.3 .6c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5zM399.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C273.3 114.6 242.8 96 208 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96H399.9zM117.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3z"
    ]
};
var $8063e68b12ef6db0$export$34f5c36a3e80efa2 = {
    prefix: "fas",
    iconName: "calendar",
    icon: [
        448,
        512,
        [
            128197,
            128198
        ],
        "f133",
        "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
    ]
};
var $8063e68b12ef6db0$export$3a48b9820e92f5ab = {
    prefix: "fas",
    iconName: "trailer",
    icon: [
        640,
        512,
        [],
        "e041",
        "M48 32C21.5 32 0 53.5 0 80V336c0 26.5 21.5 48 48 48H65.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H488h8H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V80c0-26.5-21.5-48-48-48H48zM80 96c8.8 0 16 7.2 16 16l0 131.2c-11.4 5.9-22.2 12.9-32 21V112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7 .2-16 .7L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm112 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zm0-48c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$6d636565b3ec36b4 = {
    prefix: "fas",
    iconName: "bahai",
    icon: [
        576,
        512,
        [
            "haykal"
        ],
        "f666",
        "M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9 .1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4L95.4 410.9c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0zm0 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z"
    ]
};
var $8063e68b12ef6db0$export$5c15e34e0e43f15c = $8063e68b12ef6db0$export$6d636565b3ec36b4;
var $8063e68b12ef6db0$export$303efb6031da122 = {
    prefix: "fas",
    iconName: "sd-card",
    icon: [
        384,
        512,
        [],
        "f7c2",
        "M320 0H141.3C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 88v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$ae1875ba975aa0e9 = {
    prefix: "fas",
    iconName: "dragon",
    icon: [
        640,
        512,
        [
            128009
        ],
        "f6d5",
        "M352 124.5l-51.9-13c-6.5-1.6-11.3-7.1-12-13.8s2.8-13.1 8.7-16.1l40.8-20.4L294.4 28.8c-5.5-4.1-7.8-11.3-5.6-17.9S297.1 0 304 0H416h32 16c30.2 0 58.7 14.2 76.8 38.4l57.6 76.8c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48H538.5c-17 0-33.3-6.7-45.3-18.7L480 160H448v21.5c0 24.8 12.8 47.9 33.8 61.1l106.6 66.6c32.1 20.1 51.6 55.2 51.6 93.1C640 462.9 590.9 512 530.2 512H496 432 32.3c-3.3 0-6.6-.4-9.6-1.4C13.5 507.8 6 501 2.4 492.1C1 488.7 .2 485.2 0 481.4c-.2-3.7 .3-7.3 1.3-10.7c2.8-9.2 9.6-16.7 18.6-20.4c3-1.2 6.2-2 9.5-2.2L433.3 412c8.3-.7 14.7-7.7 14.7-16.1c0-4.3-1.7-8.4-4.7-11.4l-44.4-44.4c-30-30-46.9-70.7-46.9-113.1V181.5v-57zM512 72.3c0-.1 0-.2 0-.3s0-.2 0-.3v.6zm-1.3 7.4L464.3 68.1c-.2 1.3-.3 2.6-.3 3.9c0 13.3 10.7 24 24 24c10.6 0 19.5-6.8 22.7-16.3zM130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87V227c0 32.8 8.4 64.8 24 93H112c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5z"
    ]
};
var $8063e68b12ef6db0$export$cdbdd2118099ae07 = {
    prefix: "fas",
    iconName: "shoe-prints",
    icon: [
        640,
        512,
        [],
        "f54b",
        "M416 0C352.3 0 256 32 256 32V160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0zM128 96c0 35.3 28.7 64 64 64h32V32H192c-35.3 0-64 28.7-64 64zM288 512c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32V480s96.3 32 160 32zM0 416c0 35.3 28.7 64 64 64H96V352H64c-35.3 0-64 28.7-64 64z"
    ]
};
var $8063e68b12ef6db0$export$eeda28b8ca4cb18e = {
    prefix: "fas",
    iconName: "circle-plus",
    icon: [
        512,
        512,
        [
            "plus-circle"
        ],
        "f055",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $8063e68b12ef6db0$export$d9cc3a81499af48c = $8063e68b12ef6db0$export$eeda28b8ca4cb18e;
var $8063e68b12ef6db0$export$4272e56f2429da88 = {
    prefix: "fas",
    iconName: "face-grin-tongue-wink",
    icon: [
        512,
        512,
        [
            128540,
            "grin-tongue-wink"
        ],
        "f58b",
        "M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448V401.1c24.3-17.5 43.6-41.6 55.4-69.6c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c11.7 27.8 30.8 51.7 54.8 69.2V448c0 18.6 5.3 36 14.5 50.8zm20.7-265.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM336 272c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64zM320 402.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V402.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6zM336 232c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $8063e68b12ef6db0$export$58099903d50aefb3 = $8063e68b12ef6db0$export$4272e56f2429da88;
var $8063e68b12ef6db0$export$e6094d25274088ab = {
    prefix: "fas",
    iconName: "hand-holding",
    icon: [
        576,
        512,
        [],
        "f4bd",
        "M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2c.3 0 .6 0 .9 0c0 0 0 0 0 0c-.3 0-.6 0-.9 0z"
    ]
};
var $8063e68b12ef6db0$export$d893dd9509763a17 = {
    prefix: "fas",
    iconName: "plug-circle-exclamation",
    icon: [
        576,
        512,
        [],
        "e55d",
        "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144zm0-48c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm0-192c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$22965c7f4d903953 = {
    prefix: "fas",
    iconName: "link-slash",
    icon: [
        640,
        512,
        [
            "chain-broken",
            "chain-slash",
            "unlink"
        ],
        "f127",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM406.6 416.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3zm-290-228.5L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9z"
    ]
};
var $8063e68b12ef6db0$export$382551e04f32620a = $8063e68b12ef6db0$export$22965c7f4d903953;
var $8063e68b12ef6db0$export$12f09d657be59586 = $8063e68b12ef6db0$export$22965c7f4d903953;
var $8063e68b12ef6db0$export$2f546f7d8ba01e18 = $8063e68b12ef6db0$export$22965c7f4d903953;
var $8063e68b12ef6db0$export$76c1aa4bf9a39458 = {
    prefix: "fas",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M0 448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H224c-53 0-96-43-96-96V160H64c-35.3 0-64 28.7-64 64V448zm224-96H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64z"
    ]
};
var $8063e68b12ef6db0$export$5a200e8504b7367a = {
    prefix: "fas",
    iconName: "person-walking-arrow-loop-left",
    icon: [
        640,
        512,
        [],
        "e551",
        "M208 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm347.7 119c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L461.3 384H480c88.4 0 160-71.6 160-160s-71.6-160-160-160L352 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c53 0 96 43 96 96s-43 96-96 96H461.3l25.4-25.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3l80 80z"
    ]
};
var $8063e68b12ef6db0$export$a0a53d8e3c68e9f1 = {
    prefix: "fas",
    iconName: "arrow-up-z-a",
    icon: [
        576,
        512,
        [
            "sort-alpha-up-alt"
        ],
        "f882",
        "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 64c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zm96 192c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 262.8 428.1 256 416 256zM395.8 400L416 359.6 436.2 400H395.8z"
    ]
};
var $8063e68b12ef6db0$export$95ef20828693fb0f = $8063e68b12ef6db0$export$a0a53d8e3c68e9f1;
var $8063e68b12ef6db0$export$769724fc1434d618 = {
    prefix: "fas",
    iconName: "fire-flame-curved",
    icon: [
        384,
        512,
        [
            "fire-alt"
        ],
        "f7e4",
        "M153.6 29.9l16-21.3C173.6 3.2 180 0 186.7 0C198.4 0 208 9.6 208 21.3V43.5c0 13.1 5.4 25.7 14.9 34.7L307.6 159C356.4 205.6 384 270.2 384 337.7C384 434 306 512 209.7 512H192C86 512 0 426 0 320v-3.8c0-48.8 19.4-95.6 53.9-130.1l3.5-3.5c4.2-4.2 10-6.6 16-6.6C85.9 176 96 186.1 96 198.6V288c0 35.3 28.7 64 64 64s64-28.7 64-64v-3.9c0-18-7.2-35.3-19.9-48l-38.6-38.6c-24-24-37.5-56.7-37.5-90.7c0-27.7 9-54.8 25.6-76.9z"
    ]
};
var $8063e68b12ef6db0$export$70dc26b4926d0b1b = $8063e68b12ef6db0$export$769724fc1434d618;
var $8063e68b12ef6db0$export$6d274258ba4b0089 = {
    prefix: "fas",
    iconName: "tornado",
    icon: [
        448,
        512,
        [
            127786
        ],
        "f76f",
        "M0 32V45.6C0 62.7 1.7 79.6 5 96H357.8c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16C416 10.1 405.9 0 393.4 0H32C14.3 0 0 14.3 0 32zm352.2 96H13.6c12.2 35.9 32.3 68.7 58.8 96H412l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1zm-226 138.2l116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3H445c2-9.8 3-19.9 3-30.1c0-23-5.3-45.5-15.3-65.9H110.2c5.2 3.6 10.5 7 16 10.2zM288 384c10.3 21.4 13.8 45.5 9.9 69l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4c5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c12.8-12.8 23.1-27.7 30.4-43.9H288z"
    ]
};
var $8063e68b12ef6db0$export$430d63b54b1d4009 = {
    prefix: "fas",
    iconName: "file-circle-plus",
    icon: [
        576,
        512,
        [
            58606
        ],
        "e494",
        "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 384c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm16-208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"
    ]
};
var $8063e68b12ef6db0$export$ad3212bc3fa1595b = {
    prefix: "fas",
    iconName: "book-quran",
    icon: [
        448,
        512,
        [
            "quran"
        ],
        "f687",
        "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM274.1 150.2l-8.9 21.4-23.1 1.9c-5.7 .5-8 7.5-3.7 11.2L256 199.8l-5.4 22.6c-1.3 5.5 4.7 9.9 9.6 6.9L280 217.2l19.8 12.1c4.9 3 10.9-1.4 9.6-6.9L304 199.8l17.6-15.1c4.3-3.7 2-10.8-3.7-11.2l-23.1-1.9-8.9-21.4c-2.2-5.3-9.6-5.3-11.8 0zM96 192c0 70.7 57.3 128 128 128c25.6 0 49.5-7.5 69.5-20.5c3.2-2.1 4.5-6.2 3.1-9.7s-5.2-5.6-9-4.8c-6.1 1.2-12.5 1.9-19 1.9c-52.4 0-94.9-42.5-94.9-94.9s42.5-94.9 94.9-94.9c6.5 0 12.8 .7 19 1.9c3.8 .8 7.5-1.3 9-4.8s.2-7.6-3.1-9.7C273.5 71.5 249.6 64 224 64C153.3 64 96 121.3 96 192z"
    ]
};
var $8063e68b12ef6db0$export$46f29ea84ed4c5f1 = $8063e68b12ef6db0$export$ad3212bc3fa1595b;
var $8063e68b12ef6db0$export$12a35719f889cd1 = {
    prefix: "fas",
    iconName: "anchor",
    icon: [
        576,
        512,
        [
            9875
        ],
        "f13d",
        "M256 96c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm85.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c88.4 0 160-71.6 160-160v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56c-9.4-9.4-24.6-9.4-33.9 0l-56 56c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 53-43 96-96 96H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1z"
    ]
};
var $8063e68b12ef6db0$export$93a5eb721c9c0d25 = {
    prefix: "fas",
    iconName: "border-all",
    icon: [
        448,
        512,
        [],
        "f84c",
        "M384 96V224H256V96H384zm0 192V416H256V288H384zM192 224H64V96H192V224zM64 288H192V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $8063e68b12ef6db0$export$67a047c738fb34da = {
    prefix: "fas",
    iconName: "face-angry",
    icon: [
        512,
        512,
        [
            128544,
            "angry"
        ],
        "f556",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM161.3 382.1c-5.4 12.3 8.7 21.6 21.1 16.4c22.4-9.5 47.4-14.8 73.7-14.8s51.3 5.3 73.7 14.8c12.4 5.2 26.5-4.1 21.1-16.4c-16-36.6-52.4-62.1-94.8-62.1s-78.8 25.6-94.8 62.1zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $8063e68b12ef6db0$export$3c96c08e234498c5 = $8063e68b12ef6db0$export$67a047c738fb34da;
var $8063e68b12ef6db0$export$317dde8664f7de71 = {
    prefix: "fas",
    iconName: "cookie-bite",
    icon: [
        512,
        512,
        [],
        "f564",
        "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 208c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$d2caed5e37174c23 = {
    prefix: "fas",
    iconName: "arrow-trend-down",
    icon: [
        576,
        512,
        [],
        "e097",
        "M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352H384z"
    ]
};
var $8063e68b12ef6db0$export$7329a1ca27b90c5b = {
    prefix: "fas",
    iconName: "rss",
    icon: [
        448,
        512,
        [
            "feed"
        ],
        "f09e",
        "M0 64C0 46.3 14.3 32 32 32c229.8 0 416 186.2 416 416c0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96C14.3 96 0 81.7 0 64zM128 416c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM32 160c159.1 0 288 128.9 288 288c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$67ad3d0233cd7b33 = $8063e68b12ef6db0$export$7329a1ca27b90c5b;
var $8063e68b12ef6db0$export$df9bd3777d1154d2 = {
    prefix: "fas",
    iconName: "draw-polygon",
    icon: [
        448,
        512,
        [],
        "f5ee",
        "M96 151.4V360.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c0-.1 .1-.2 .1-.3l-4.5-7.9-32-56 0 0c-1.4 .1-2.8 .1-4.2 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2 .1l0 0 32-56 4.5-7.9-.1-.3H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2 .2 63.7 28.7 63.7 64c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32H328.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 35.3-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z"
    ]
};
var $8063e68b12ef6db0$export$33fb4280dc20f0dd = {
    prefix: "fas",
    iconName: "scale-balanced",
    icon: [
        640,
        512,
        [
            9878,
            "balance-scale"
        ],
        "f24e",
        "M384 32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zM125.8 177.3L51.1 320H204.9L130.2 177.3c-.4-.8-1.3-1.3-2.2-1.3s-1.7 .5-2.2 1.3zM128 128c18.8 0 36 10.4 44.7 27l77.8 148.5c3.1 5.8 6.1 14 5.5 23.8c-.7 12.1-4.8 35.2-24.8 55.1C210.9 402.6 178.2 416 128 416s-82.9-13.4-103.2-33.5c-20-20-24.2-43-24.8-55.1c-.6-9.8 2.5-18 5.5-23.8L83.3 155c8.7-16.6 25.9-27 44.7-27zm384 48c-.9 0-1.7 .5-2.2 1.3L435.1 320H588.9L514.2 177.3c-.4-.8-1.3-1.3-2.2-1.3zm-44.7-21c8.7-16.6 25.9-27 44.7-27s36 10.4 44.7 27l77.8 148.5c3.1 5.8 6.1 14 5.5 23.8c-.7 12.1-4.8 35.2-24.8 55.1C594.9 402.6 562.2 416 512 416s-82.9-13.4-103.2-33.5c-20-20-24.2-43-24.8-55.1c-.6-9.8 2.5-18 5.5-23.8L467.3 155z"
    ]
};
var $8063e68b12ef6db0$export$fec323dcfd81d750 = $8063e68b12ef6db0$export$33fb4280dc20f0dd;
var $8063e68b12ef6db0$export$cc4351eb13da27d8 = {
    prefix: "fas",
    iconName: "gauge-simple-high",
    icon: [
        512,
        512,
        [
            61668,
            "tachometer",
            "tachometer-fast"
        ],
        "f62a",
        "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM320 352c0-15.9-5.8-30.4-15.3-41.6l76.6-147.4c6.1-11.8 1.5-26.3-10.2-32.4s-26.2-1.5-32.4 10.2L262.1 288.3c-2-.2-4-.3-6.1-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $8063e68b12ef6db0$export$362d0f652c3fbca2 = $8063e68b12ef6db0$export$cc4351eb13da27d8;
var $8063e68b12ef6db0$export$375b6a8680f980ed = $8063e68b12ef6db0$export$cc4351eb13da27d8;
var $8063e68b12ef6db0$export$f7f7c15f18cc19a1 = {
    prefix: "fas",
    iconName: "shower",
    icon: [
        512,
        512,
        [
            128703
        ],
        "f2cc",
        "M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.1-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32C44.7 32 0 76.7 0 131.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32V131.9zM256 352c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm64 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm0-128c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm64 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm0-128c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32zm64 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm32-32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$6e6ddc253102e596 = {
    prefix: "fas",
    iconName: "desktop",
    icon: [
        576,
        512,
        [
            128421,
            61704,
            "desktop-alt"
        ],
        "f390",
        "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z"
    ]
};
var $8063e68b12ef6db0$export$ff09a62b9e0fa899 = $8063e68b12ef6db0$export$6e6ddc253102e596;
var $8063e68b12ef6db0$export$bd6a7788954842b5 = {
    prefix: "fas",
    iconName: "m",
    icon: [
        448,
        512,
        [
            109
        ],
        "4d",
        "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32H0zM32 64L58.6 46.2c-7.8-11.7-22.4-17-35.9-12.9S0 49.9 0 64l32 0zM224 352l-26.6 17.8c5.9 8.9 15.9 14.2 26.6 14.2s20.7-5.3 26.6-14.2L224 352zM416 64h32c0-14.1-9.2-26.5-22.7-30.6s-28.1 1.1-35.9 12.9L416 64zM384 448c0 17.7 14.3 32 32 32s32-14.3 32-32H384zM64 448V64H0V448H64zM5.4 81.8l192 288 53.3-35.5-192-288L5.4 81.8zm245.3 288l192-288L389.4 46.2l-192 288 53.3 35.5zM384 64V448h64V64H384z"
    ]
};
var $8063e68b12ef6db0$export$6e989c3c7050dbb = {
    prefix: "fas",
    iconName: "table-list",
    icon: [
        512,
        512,
        [
            "th-list"
        ],
        "f00b",
        "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0v64h64V96H64zm384 0H192v64H448V96zM64 224v64h64V224H64zm384 0H192v64H448V224zM64 352v64h64V352H64zm384 0H192v64H448V352z"
    ]
};
var $8063e68b12ef6db0$export$daf2614a457122c0 = $8063e68b12ef6db0$export$6e989c3c7050dbb;
var $8063e68b12ef6db0$export$435fe17e9d6170d6 = {
    prefix: "fas",
    iconName: "comment-sms",
    icon: [
        512,
        512,
        [
            "sms"
        ],
        "f7cd",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM202.9 176.8c6.5-2.2 13.7 .1 17.9 5.6L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-6.9 4.4-13 10.9-15.2zm173.1 38c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.2-.4-23.7-4.4-32.6-7.4l0 0 0 0c-1.4-.5-2.7-.9-4-1.4c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.7 .6 3.3 1.1 4.9 1.6l0 0 0 0c9.1 3.1 15.6 5.3 22.6 5.5c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6c-9-5.4-17.7-14.7-17.7-29.4c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c10 .2 19.7 2.3 27.9 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.3-1.9-14.1-3.3-20.1-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9zm-272 0c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.3-.4-24.2-4.5-33.2-7.6l0 0 0 0c-1.3-.4-2.5-.8-3.6-1.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.4 .5 2.7 .9 4 1.4l0 0 0 0 0 0c9.5 3.2 16.5 5.6 23.7 5.8c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4 0 0c-7.2-2.2-16.7-5-24.3-9.6C80.8 239 72.1 229.7 72 215c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c9.5 .1 22.2 2.1 31.1 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-6.6-1.8-16.8-3.3-23.3-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9z"
    ]
};
var $8063e68b12ef6db0$export$9dbcc3443daa7323 = $8063e68b12ef6db0$export$435fe17e9d6170d6;
var $8063e68b12ef6db0$export$c9d7ef726d1a8742 = {
    prefix: "fas",
    iconName: "book",
    icon: [
        448,
        512,
        [
            128212
        ],
        "f02d",
        "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$4c17261776a709f2 = {
    prefix: "fas",
    iconName: "user-plus",
    icon: [
        640,
        512,
        [],
        "f234",
        "M352 128c0 70.7-57.3 128-128 128s-128-57.3-128-128S153.3 0 224 0s128 57.3 128 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $8063e68b12ef6db0$export$62b2c752fccc6a9c = {
    prefix: "fas",
    iconName: "check",
    icon: [
        512,
        512,
        [
            10003,
            10004
        ],
        "f00c",
        "M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
    ]
};
var $8063e68b12ef6db0$export$cfb37069d38f379e = {
    prefix: "fas",
    iconName: "battery-three-quarters",
    icon: [
        576,
        512,
        [
            "battery-4"
        ],
        "f241",
        "M0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176zm80-16c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zm272 32V320H96V192H352z"
    ]
};
var $8063e68b12ef6db0$export$35ffefed200d123c = $8063e68b12ef6db0$export$cfb37069d38f379e;
var $8063e68b12ef6db0$export$c9382fa3394ef53a = {
    prefix: "fas",
    iconName: "house-circle-check",
    icon: [
        640,
        512,
        [],
        "e509",
        "M320.7 351.7C329 262.1 404.3 192 496 192c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V480c0 17.7 14.3 32 32 32H192c17.7 0 32-14.3 32-32V383.7c0-17.7 14.3-32 32-32h64l.7 0zM640 368c0-79.5-64.5-144-144-144s-144 64.5-144 144s64.5 144 144 144s144-64.5 144-144zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $8063e68b12ef6db0$export$3cbcd1b7e35945d2 = {
    prefix: "fas",
    iconName: "angle-left",
    icon: [
        320,
        512,
        [
            8249
        ],
        "f104",
        "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
var $8063e68b12ef6db0$export$ff7f40159cadb0ac = {
    prefix: "fas",
    iconName: "diagram-successor",
    icon: [
        512,
        512,
        [],
        "e47a",
        "M512 416l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM64 160l0-64 144 0 16 0 0 64L64 160zm224 0l0-64 80 0c8.8 0 16 7.2 16 16l0 16-38.1 0c-21.4 0-32.1 25.9-17 41L399 239c9.4 9.4 24.6 9.4 33.9 0L503 169c15.1-15.1 4.4-41-17-41L448 128l0-16c0-44.2-35.8-80-80-80L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64z"
    ]
};
var $8063e68b12ef6db0$export$d69fa2b7839ce76 = {
    prefix: "fas",
    iconName: "truck-arrow-right",
    icon: [
        640,
        512,
        [],
        "e58b",
        "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm368-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48zM257 95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H262.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 95z"
    ]
};
var $8063e68b12ef6db0$export$7df274119d2469d1 = {
    prefix: "fas",
    iconName: "arrows-split-up-and-left",
    icon: [
        512,
        512,
        [],
        "e4bc",
        "M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3V384c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64H109.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H224c23.3 0 45.2 6.2 64 17.1V109.3l-41.4 41.4z"
    ]
};
var $8063e68b12ef6db0$export$ca492f58fe30a42f = {
    prefix: "fas",
    iconName: "hand-fist",
    icon: [
        384,
        512,
        [
            9994,
            "fist-raised"
        ],
        "f6de",
        "M160 0c17.7 0 32 14.3 32 32V144H128V32c0-17.7 14.3-32 32-32zM32 64c0-17.7 14.3-32 32-32s32 14.3 32 32v80H32V64zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V64zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V128zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V256c0 52.3-25.1 98.8-64 128v96c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V401.6c-17.3-7.9-33.2-18.8-46.9-32.5L37.5 357.5C13.5 333.5 0 300.9 0 267V240c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
    ]
};
var $8063e68b12ef6db0$export$fa0323a4d7489a8d = $8063e68b12ef6db0$export$ca492f58fe30a42f;
var $8063e68b12ef6db0$export$482eb125aaf0fbc2 = {
    prefix: "fas",
    iconName: "cloud-moon",
    icon: [
        640,
        512,
        [],
        "f6c3",
        "M495.8 0c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.1c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4c-9.3 0-18.4-.7-27.4-1.9c-11.2-22.6-29.8-40.9-52.6-51.7c-2.7-58.5-50.3-105.3-109.2-106.7c-1.7-10.4-2.6-21-2.6-31.8C304 86.1 389.8 0 495.8 0zM447.9 431.9c0 44.2-35.8 80-80 80H96c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var $8063e68b12ef6db0$export$8da450d063b0eb37 = {
    prefix: "fas",
    iconName: "briefcase",
    icon: [
        512,
        512,
        [
            128188
        ],
        "f0b1",
        "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"
    ]
};
var $8063e68b12ef6db0$export$e94ab3a30cf4aca5 = {
    prefix: "fas",
    iconName: "person-falling",
    icon: [
        512,
        512,
        [],
        "e546",
        "M288 0c17.7 0 32 14.3 32 32l0 9.8c0 54.6-27.9 104.6-72.5 133.6l.2 .3L304.5 256l87.5 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L384 320l-96 0h-1.4l92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L164.5 249.2c-2.9 9.2-4.5 19-4.5 29l0 73.8c0 17.7-14.3 32-32 32s-32-14.3-32-32V278.2c0-65.1 39.6-123.7 100.1-147.9C232.3 115.8 256 80.8 256 41.8l0-9.8c0-17.7 14.3-32 32-32zM112 128c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $8063e68b12ef6db0$export$c23fd8b91a7ed48 = {
    prefix: "fas",
    iconName: "image-portrait",
    icon: [
        384,
        512,
        [
            "portrait"
        ],
        "f3e0",
        "M384 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64l0-384zM256 192c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM80 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6z"
    ]
};
var $8063e68b12ef6db0$export$e3d25f819c7ee7d7 = $8063e68b12ef6db0$export$c23fd8b91a7ed48;
var $8063e68b12ef6db0$export$9eec597148166b36 = {
    prefix: "fas",
    iconName: "user-tag",
    icon: [
        640,
        512,
        [],
        "f507",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c10 0 18.8-4.9 24.2-12.5l-99.2-99.2c-14.9-14.9-23.3-35.1-23.3-56.1v-33c-15.9-4.7-32.8-7.2-50.3-7.2H178.3zM384 224c-17.7 0-32 14.3-32 32v82.7c0 17 6.7 33.3 18.7 45.3L478.1 491.3c18.7 18.7 49.1 18.7 67.9 0l73.4-73.4c18.7-18.7 18.7-49.1 0-67.9L512 242.7c-12-12-28.3-18.7-45.3-18.7H384zm72 80c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$7cee7480f25f5289 = {
    prefix: "fas",
    iconName: "rug",
    icon: [
        640,
        512,
        [],
        "e569",
        "M24 64H56 80V88v88 80 80 88 24H56 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V360H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V200H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V112H24C10.7 112 0 101.3 0 88S10.7 64 24 64zm88 0H528V448H112V64zM640 88c0 13.3-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H584 560V424 336 256 176 88 64h24 32c13.3 0 24 10.7 24 24z"
    ]
};
var $8063e68b12ef6db0$export$7adefae4a1be1d97 = {
    prefix: "fas",
    iconName: "earth-europe",
    icon: [
        512,
        512,
        [
            "globe-europe"
        ],
        "f7a2",
        "M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H379.3c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16H454c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.6-15.4H251.4c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $8063e68b12ef6db0$export$5318b8ede86cc96b = $8063e68b12ef6db0$export$7adefae4a1be1d97;
var $8063e68b12ef6db0$export$ab81ff863770d996 = {
    prefix: "fas",
    iconName: "cart-flatbed-suitcase",
    icon: [
        640,
        512,
        [
            "luggage-cart"
        ],
        "f59d",
        "M0 32C0 14.3 14.3 0 32 0H48c44.2 0 80 35.8 80 80V368c0 8.8 7.2 16 16 16H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H541.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32zM432 96V56c0-4.4-3.6-8-8-8H344c-4.4 0-8 3.6-8 8V96h96zM288 96V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56V96 320H288V96zM512 320V96h16c26.5 0 48 21.5 48 48V272c0 26.5-21.5 48-48 48H512zM240 96h16V320H240c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
    ]
};
var $8063e68b12ef6db0$export$bd1e24dd3cde8514 = $8063e68b12ef6db0$export$ab81ff863770d996;
var $8063e68b12ef6db0$export$3896694b3e81fba7 = {
    prefix: "fas",
    iconName: "rectangle-xmark",
    icon: [
        512,
        512,
        [
            62164,
            "rectangle-times",
            "times-rectangle",
            "window-close"
        ],
        "f410",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $8063e68b12ef6db0$export$eaaf26416a51dc1 = $8063e68b12ef6db0$export$3896694b3e81fba7;
var $8063e68b12ef6db0$export$10147c0014152a3f = $8063e68b12ef6db0$export$3896694b3e81fba7;
var $8063e68b12ef6db0$export$18b7775f78a3e16 = $8063e68b12ef6db0$export$3896694b3e81fba7;
var $8063e68b12ef6db0$export$ffc7123046a28ee = {
    prefix: "fas",
    iconName: "baht-sign",
    icon: [
        320,
        512,
        [],
        "e0ac",
        "M144 0c-17.7 0-32 14.3-32 32V64H37.6C16.8 64 0 80.8 0 101.6V224v41.7V288 406.3c0 23 18.7 41.7 41.7 41.7H112v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c61.9 0 112-50.1 112-112c0-40.1-21.1-75.3-52.7-95.1C280.3 222.6 288 200.2 288 176c0-61.9-50.1-112-112-112V32c0-17.7-14.3-32-32-32zM112 128v96H64V128h48zm64 96V128c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-64 64v96H64V288h48zm64 96V288h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H176z"
    ]
};
var $8063e68b12ef6db0$export$8a3071811b2b7979 = {
    prefix: "fas",
    iconName: "book-open",
    icon: [
        576,
        512,
        [
            128214,
            128366
        ],
        "f518",
        "M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C87.5 32 35.1 48.6 9 59.9c-5.6 2.4-9 8-9 14V454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5V73.9c0-6.1-3.4-11.6-9-14C540.9 48.6 488.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11V456c0 11.4 11.7 19.3 22.4 15.5z"
    ]
};
var $8063e68b12ef6db0$export$d3d49030d557a09b = {
    prefix: "fas",
    iconName: "book-journal-whills",
    icon: [
        448,
        512,
        [
            "journal-whills"
        ],
        "f66a",
        "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zm90.4-234.4l-21.2-21.2c-3 10.1-5.1 20.6-5.1 31.6c0 .2 0 .5 .1 .8s.1 .5 .1 .8L165.2 226c2.5 2.1 3.4 5.8 2.3 8.9c-1.3 3-4.1 5.1-7.5 5.1c-1.9-.1-3.8-.8-5.2-2l-23.6-20.6C142.8 267 186.9 304 240 304s97.3-37 108.9-86.6L325.3 238c-1.4 1.2-3.3 2-5.3 2c-2.2-.1-4.4-1.1-6-2.8c-1.3-1.5-1.9-3.4-2-5.2c.1-2.2 1.1-4.4 2.7-6l37.1-32.5c0-.3 0-.5 .1-.8s.1-.5 .1-.8c0-11-2.1-21.5-5.1-31.6l-21.2 21.2c-3.1 3.1-8.1 3.1-11.3 0s-3.1-8.1 0-11.2l26.4-26.5c-10-20.7-26.1-38-46.4-49.2c17 27.1 11 62.8-14 82.6c14.1 14.6 19.1 35.9 13.1 55.2c-5.9 19.4-22 34.1-41.9 38.3l-1.4-34.3 12.6 8.6c.6 .4 1.5 .6 2.3 .6c1.5 0 2.7-.8 3.5-2s.6-2.8-.1-4L260 225.4l18-3.6c1.8-.4 3.1-2.1 3.1-4s-1.4-3.5-3.1-3.9l-18-3.7 8.5-14.3c.8-1.2 .9-2.9 .1-4.1s-2-2-3.5-2l-.1 0c-.7 .1-1.5 .3-2.1 .7l-14.1 9.6L244 87.9c-.1-2.2-1.9-3.9-4-3.9s-3.9 1.6-4 3.9l-4.6 110.8-12-8.1c-1.5-1.1-3.6-.9-5 .4s-1.6 3.4-.8 5l8.6 14.3-18 3.7c-1.8 .4-3.1 2-3.1 3.9s1.4 3.6 3.1 4l18 3.8-8.6 14.2c-.2 .6-.5 1.4-.5 2c0 1.1 .5 2.1 1.2 3c.8 .6 1.8 1 2.8 1c.7 0 1.6-.2 2.2-.6l10.4-7.1-1.4 32.8c-19.9-4.1-36-18.9-41.9-38.3c-6-19.4-1-40.5 13.1-55.2c-25-19.9-31-55.5-14-82.6c-20.1 11.2-36.4 28.5-46.4 49.2l26.4 26.5c3.1 3.1 3.1 8.1 0 11.2s-8.1 3.1-11.2 0z"
    ]
};
var $8063e68b12ef6db0$export$66a0d8d45aab6631 = $8063e68b12ef6db0$export$d3d49030d557a09b;
var $8063e68b12ef6db0$export$74d1f89b5feb9d42 = {
    prefix: "fas",
    iconName: "handcuffs",
    icon: [
        640,
        512,
        [],
        "e4f8",
        "M304 32c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zM192 112c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm-32 16c17.7 0 32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32zm0 320c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96s43 96 96 96zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32s32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0c0-53-43-96-96-96s-96 43-96 96s43 96 96 96s96-43 96-96zM368 64c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm80 48c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$1cbf6e649ce86166 = {
    prefix: "fas",
    iconName: "triangle-exclamation",
    icon: [
        512,
        512,
        [
            9888,
            "exclamation-triangle",
            "warning"
        ],
        "f071",
        "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $8063e68b12ef6db0$export$3d249b63b52cce7c = $8063e68b12ef6db0$export$1cbf6e649ce86166;
var $8063e68b12ef6db0$export$2e470a35c38b096a = $8063e68b12ef6db0$export$1cbf6e649ce86166;
var $8063e68b12ef6db0$export$24680dede86b1883 = {
    prefix: "fas",
    iconName: "database",
    icon: [
        448,
        512,
        [],
        "f1c0",
        "M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432V346.1z"
    ]
};
var $8063e68b12ef6db0$export$c08b4b0e2b0dc027 = {
    prefix: "fas",
    iconName: "share",
    icon: [
        512,
        512,
        [
            "arrow-turn-right",
            "mail-forward"
        ],
        "f064",
        "M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"
    ]
};
var $8063e68b12ef6db0$export$f20385ecfa20c36e = $8063e68b12ef6db0$export$c08b4b0e2b0dc027;
var $8063e68b12ef6db0$export$81df7693d3f2f8da = $8063e68b12ef6db0$export$c08b4b0e2b0dc027;
var $8063e68b12ef6db0$export$8f534e1e0ab75bfe = {
    prefix: "fas",
    iconName: "bottle-droplet",
    icon: [
        256,
        512,
        [],
        "e4c4",
        "M64 0C50.7 0 40 10.7 40 24s10.7 24 24 24c4.4 0 8 3.6 8 8v64.9c0 12.2-7.2 23.1-17.2 30.1C21.7 174.1 0 212.5 0 256V448c0 35.3 28.7 64 64 64H192c35.3 0 64-28.7 64-64V256c0-43.5-21.7-81.9-54.8-105c-10-7-17.2-17.9-17.2-30.1V56c0-4.4 3.6-8 8-8c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 0 0 0H72l0 0 0 0L64 0zm64 382c-26.5 0-48-20.1-48-45c0-16.8 22.1-48.1 36.3-66.4c6-7.8 17.5-7.8 23.5 0C153.9 288.9 176 320.2 176 337c0 24.9-21.5 45-48 45z"
    ]
};
var $8063e68b12ef6db0$export$140d4da0adbaf435 = {
    prefix: "fas",
    iconName: "mask-face",
    icon: [
        640,
        512,
        [],
        "e1d7",
        "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1H144 128 56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H512 496h-9.2c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64zM132.3 346.3l-29.8-7.4C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H96v48c0 45.1 13.4 87.2 36.3 122.3zm405.1-7.4l-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3V176h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9zM192 208c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 48H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
    ]
};
var $8063e68b12ef6db0$export$7ec15a32285f6c22 = {
    prefix: "fas",
    iconName: "hill-rockslide",
    icon: [
        576,
        512,
        [],
        "e508",
        "M252.4 103.8l27 48c2.8 5 8.2 8.2 13.9 8.2l53.3 0c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2H293.4c-5.8 0-11.1 3.1-13.9 8.2l-27 48c-2.7 4.9-2.7 10.8 0 15.7zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87zM504.2 403.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9V309.4c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9v53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM384 288c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$a082af56be9786ae = {
    prefix: "fas",
    iconName: "right-left",
    icon: [
        512,
        512,
        [
            "exchange-alt"
        ],
        "f362",
        "M32 96l320 0V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160L32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 64H480z"
    ]
};
var $8063e68b12ef6db0$export$f6c6fb20d374b128 = $8063e68b12ef6db0$export$a082af56be9786ae;
var $8063e68b12ef6db0$export$b5378818301da1be = {
    prefix: "fas",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [
            61913
        ],
        "f1d8",
        "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L277.3 424.9l-40.1 74.5c-5.2 9.7-16.3 14.6-27 11.9S192 499 192 488V392c0-5.3 1.8-10.5 5.1-14.7L362.4 164.7c2.5-7.1-6.5-14.3-13-8.4L170.4 318.2l-32 28.9 0 0c-9.2 8.3-22.3 10.6-33.8 5.8l-85-35.4C8.4 312.8 .8 302.2 .1 290s5.5-23.7 16.1-29.8l448-256c10.7-6.1 23.9-5.5 34 1.4z"
    ]
};
var $8063e68b12ef6db0$export$79753c2153535b01 = {
    prefix: "fas",
    iconName: "road-circle-exclamation",
    icon: [
        640,
        512,
        [],
        "e565",
        "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 512c-79.5 0-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144zm0-48c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
    ]
};
var $8063e68b12ef6db0$export$1156dc6acb0058bd = {
    prefix: "fas",
    iconName: "dungeon",
    icon: [
        512,
        512,
        [],
        "f6d9",
        "M336.6 156.5c1.3 1.1 2.7 2.2 3.9 3.3c9.3 8.2 23 10.5 33.4 3.6l67.6-45.1c11.4-7.6 14.2-23.2 5.1-33.4C430 66.6 410.9 50.6 389.7 37.6c-11.9-7.3-26.9-1.4-32.1 11.6l-30.5 76.2c-4.5 11.1 .2 23.6 9.5 31.2zM328 36.8c5.1-12.8-1.6-27.4-15-30.5C294.7 2.2 275.6 0 256 0s-38.7 2.2-57 6.4C185.5 9.4 178.8 24 184 36.8l30.3 75.8c4.5 11.3 16.8 17.2 29 16c4.2-.4 8.4-.6 12.7-.6s8.6 .2 12.7 .6c12.1 1.2 24.4-4.7 29-16L328 36.8zM65.5 85c-9.1 10.2-6.3 25.8 5.1 33.4l67.6 45.1c10.3 6.9 24.1 4.6 33.4-3.6c1.3-1.1 2.6-2.3 4-3.3c9.3-7.5 13.9-20.1 9.5-31.2L154.4 49.2c-5.2-12.9-20.3-18.8-32.1-11.6C101.1 50.6 82 66.6 65.5 85zm314 137.1c.9 3.3 1.7 6.6 2.3 10c2.5 13 13 23.9 26.2 23.9h80c13.3 0 24.1-10.8 22.9-24c-2.5-27.2-9.3-53.2-19.7-77.3c-5.5-12.9-21.4-16.6-33.1-8.9l-68.6 45.7c-9.8 6.5-13.2 19.2-10 30.5zM53.9 145.8c-11.6-7.8-27.6-4-33.1 8.9C10.4 178.8 3.6 204.8 1.1 232c-1.2 13.2 9.6 24 22.9 24h80c13.3 0 23.8-10.8 26.2-23.9c.6-3.4 1.4-6.7 2.3-10c3.1-11.4-.2-24-10-30.5L53.9 145.8zM104 288H24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24zm304 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H408zM24 416c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H24zm384 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H408zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224z"
    ]
};
var $8063e68b12ef6db0$export$7370f36a39a38737 = {
    prefix: "fas",
    iconName: "align-right",
    icon: [
        448,
        512,
        [],
        "f038",
        "M448 64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
    ]
};
var $8063e68b12ef6db0$export$52e3e96cd1564779 = {
    prefix: "fas",
    iconName: "money-bill-1-wave",
    icon: [
        576,
        512,
        [
            "money-bill-wave-alt"
        ],
        "f53b",
        "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM128 416H64V352c35.3 0 64 28.7 64 64zM64 224V160h64c0 35.3-28.7 64-64 64zM448 352c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM252 208c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"
    ]
};
var $8063e68b12ef6db0$export$1613858e873cbb3e = $8063e68b12ef6db0$export$52e3e96cd1564779;
var $8063e68b12ef6db0$export$53dd2cacf674142a = {
    prefix: "fas",
    iconName: "life-ring",
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm91 .5c33.7-43.3 53.8-97.8 53.8-157s-20.1-113.6-53.8-157l12.4-12.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L413 53.8C369.6 20.1 315.2 0 256 0S142.4 20.1 99 53.8L86.6 41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L53.8 99C20.1 142.4 0 196.8 0 256s20.1 113.6 53.8 157L41.4 425.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L99 458.2c43.3 33.7 97.8 53.8 157 53.8s113.6-20.1 157-53.8l12.4 12.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L458.2 413zm-45.7-45.7l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM304 256c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48z"
    ]
};
var $8063e68b12ef6db0$export$f9712d0cf5150f0c = {
    prefix: "fas",
    iconName: "hands",
    icon: [
        512,
        512,
        [
            "sign-language",
            "signing"
        ],
        "f2a7",
        "M154.9 162c.3 .7 .7 1.5 1.1 2.2l17.8 30.9c11.1-12.6 27.4-19.8 44.4-19.1l-20.7-35.8c-6.6-11.5-21.3-15.4-32.8-8.8c-10.8 6.2-14.9 19.5-9.9 30.6zm173.6 47C399.7 231.7 448 297.8 448 372.5c0 1.5 0 3-.1 4.5c39.7-25.6 64.1-69.7 64.1-117.4V136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 81.7L347.8 16.5C341.2 5 326.5 1.1 315.1 7.7s-15.4 21.3-8.8 32.8l64 110.9c2.2 3.8 .9 8.7-2.9 10.9s-8.7 .9-10.9-2.9l-80-138.6C269.8 9.3 255.1 5.4 243.6 12s-15.4 21.3-8.8 32.8l80 138.6c2.2 3.8 .9 8.7-2.9 10.9s-8.7 .9-10.9-2.9L237 80.5c-6.6-11.5-21.3-15.4-32.8-8.8s-15.4 21.3-8.8 32.8l44 76.2L328.5 209zM64 488c0 12.4 9.4 22.6 21.5 23.9c.8 .1 1.6 .1 2.5 .1H288.7 296c66.3 0 120-53.7 120-120c0-1.2 0-2.4-.1-3.6c0-1.2 .1-2.5 .1-3.7c0-68-44-128.2-108.9-148.9l-83.9-26.7c-12.6-4-26.1 3-30.1 15.6s3 26.1 15.6 30.1L262.6 272H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H184c4.4 0 8 3.6 8 8s-3.6 8-8 8H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H184c4.4 0 8 3.6 8 8s-3.6 8-8 8H56c-13.3 0-24 10.7-24 24s10.7 24 24 24H184c4.4 0 8 3.6 8 8s-3.6 8-8 8H88c-13.3 0-24 10.7-24 24z"
    ]
};
var $8063e68b12ef6db0$export$20993813350f9671 = $8063e68b12ef6db0$export$f9712d0cf5150f0c;
var $8063e68b12ef6db0$export$5cc0e6f5191f4f02 = $8063e68b12ef6db0$export$f9712d0cf5150f0c;
var $8063e68b12ef6db0$export$80968bcfef6481ca = {
    prefix: "fas",
    iconName: "calendar-day",
    icon: [
        448,
        512,
        [],
        "f783",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"
    ]
};
var $8063e68b12ef6db0$export$5930e9bdfd790d77 = {
    prefix: "fas",
    iconName: "water-ladder",
    icon: [
        576,
        512,
        [
            "ladder-water",
            "swimming-pool"
        ],
        "f5c5",
        "M128 127.7C128 74.9 170.9 32 223.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V224H384V127.7C384 74.9 426.9 32 479.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V361c-1.6 1-3.3 2-4.8 3.1c-18 12.4-40.1 20.3-59.2 20.3h0V288H192v96.5c-19 0-41.2-7.9-59.1-20.3c-1.6-1.1-3.2-2.2-4.9-3.1V127.7zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
    ]
};
var $8063e68b12ef6db0$export$c5ea6eeef2db2b3b = $8063e68b12ef6db0$export$5930e9bdfd790d77;
var $8063e68b12ef6db0$export$4dee691631c67d5c = $8063e68b12ef6db0$export$5930e9bdfd790d77;
var $8063e68b12ef6db0$export$64185f27d82c259f = {
    prefix: "fas",
    iconName: "arrows-up-down",
    icon: [
        320,
        512,
        [
            "arrows-v"
        ],
        "f07d",
        "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"
    ]
};
var $8063e68b12ef6db0$export$cec5f1bc9e068e48 = $8063e68b12ef6db0$export$64185f27d82c259f;
var $8063e68b12ef6db0$export$bd5bd2ef56b793b1 = {
    prefix: "fas",
    iconName: "face-grimace",
    icon: [
        512,
        512,
        [
            128556,
            "grimace"
        ],
        "f57f",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zm96-112h-8V360l55.3 0c-3.8 22.7-23.6 40-47.3 40zm47.3-56L344 344V304h8c23.8 0 43.5 17.3 47.3 40zM328 344H264V304h64v40zm0 56H264V360h64v40zm-80-96v40l-64 0V304h64zm0 56v40H184V360l64 0zm-80-16H112.7c3.8-22.7 23.6-40 47.3-40h8v40zm0 56h-8c-23.8 0-43.5-17.3-47.3-40H168v40zm40.4-192c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm128 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$3d08cd36ac1ef231 = $8063e68b12ef6db0$export$bd5bd2ef56b793b1;
var $8063e68b12ef6db0$export$1482162f7fe04ac = {
    prefix: "fas",
    iconName: "wheelchair-move",
    icon: [
        448,
        512,
        [
            "wheelchair-alt"
        ],
        "e2ce",
        "M416 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM204.5 121.3c-5.4-2.5-11.7-1.9-16.4 1.7l-40.9 30.7c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l40.9-30.7c23.7-17.8 55.3-21 82.1-8.4l90.4 42.5c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224h97.4c30.3 0 53 27.7 47.1 57.4L415.4 422.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288H306.7c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-42.1-19.8zM160 448c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96s43 96 96 96z"
    ]
};
var $8063e68b12ef6db0$export$7db9460785019040 = $8063e68b12ef6db0$export$1482162f7fe04ac;
var $8063e68b12ef6db0$export$b5dc9dd0347bbb6 = {
    prefix: "fas",
    iconName: "turn-down",
    icon: [
        384,
        512,
        [
            10549,
            "level-down-alt"
        ],
        "f3be",
        "M178.3 506.3L40.3 368.3C35 363 32 355.8 32 348.3C32 332.7 44.7 320 60.3 320H144V112c0-8.8-7.2-16-16-16H32C14.3 96 0 81.7 0 64V32C0 14.3 14.3 0 32 0h96c61.9 0 112 50.1 112 112V320h83.7c15.6 0 28.3 12.7 28.3 28.3c0 7.5-3 14.7-8.3 20L205.7 506.3C202 510 197.1 512 192 512s-10-2-13.7-5.7z"
    ]
};
var $8063e68b12ef6db0$export$c07eb6ff5a382cbd = $8063e68b12ef6db0$export$b5dc9dd0347bbb6;
var $8063e68b12ef6db0$export$3e15790fe68c095b = {
    prefix: "fas",
    iconName: "person-walking-arrow-right",
    icon: [
        640,
        512,
        [],
        "e552",
        "M208 96c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80z"
    ]
};
var $8063e68b12ef6db0$export$15da4ef8c0fb20d6 = {
    prefix: "fas",
    iconName: "square-envelope",
    icon: [
        448,
        512,
        [
            "envelope-square"
        ],
        "f199",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM218 271.7L64.2 172.4C66 156.4 79.5 144 96 144H352c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4V336c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V210.4l136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z"
    ]
};
var $8063e68b12ef6db0$export$354e159473e73552 = $8063e68b12ef6db0$export$15da4ef8c0fb20d6;
var $8063e68b12ef6db0$export$4ed8206e6619cc8f = {
    prefix: "fas",
    iconName: "dice",
    icon: [
        640,
        512,
        [
            127922
        ],
        "f522",
        "M252.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-184 184c-15.6 15.6-15.6 40.9 0 56.6l184 184c15.6 15.6 40.9 15.6 56.6 0l184-184c15.6-15.6 15.6-40.9 0-56.6l-184-184zM248 224c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zM96 248c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm128 80c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm128-80c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zM224 72c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24zm96 392c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H472.5c13.4 26.9 8.8 60.5-13.6 82.9L320 413.8V464zm160-88c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $8063e68b12ef6db0$export$5ee2640fe105312d = {
    prefix: "fas",
    iconName: "bowling-ball",
    icon: [
        512,
        512,
        [],
        "f436",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM240 144c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32zm32 64c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32zm-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$97fa4f4c1006ab1 = {
    prefix: "fas",
    iconName: "brain",
    icon: [
        512,
        512,
        [
            129504
        ],
        "f5dc",
        "M184 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56V56c0-30.9 25.1-56 56-56z"
    ]
};
var $8063e68b12ef6db0$export$658a137d3845bca7 = {
    prefix: "fas",
    iconName: "bandage",
    icon: [
        640,
        512,
        [
            129657,
            "band-aid"
        ],
        "f462",
        "M480 416h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H480V416zM448 96H192V416H448V96zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64h96V96H64zM296 208c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zm72 24c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24zm-72 72c0 13.3-10.7 24-24 24s-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24zm72 24c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $8063e68b12ef6db0$export$b14a1014df2fdf46 = $8063e68b12ef6db0$export$658a137d3845bca7;
var $8063e68b12ef6db0$export$23e8b4955c2d951b = {
    prefix: "fas",
    iconName: "calendar-minus",
    icon: [
        448,
        512,
        [],
        "f272",
        "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM312 376c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-13.3 0-24 10.7-24 24s10.7 24 24 24H312z"
    ]
};
var $8063e68b12ef6db0$export$30262489773a79a3 = {
    prefix: "fas",
    iconName: "circle-xmark",
    icon: [
        512,
        512,
        [
            61532,
            "times-circle",
            "xmark-circle"
        ],
        "f057",
        "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $8063e68b12ef6db0$export$ab0ec50720a747eb = $8063e68b12ef6db0$export$30262489773a79a3;
var $8063e68b12ef6db0$export$90ac4096df8efdee = $8063e68b12ef6db0$export$30262489773a79a3;
var $8063e68b12ef6db0$export$de9a67b55dbe819a = {
    prefix: "fas",
    iconName: "gifts",
    icon: [
        640,
        512,
        [],
        "f79c",
        "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H200.6c-5.4-9.4-8.6-20.3-8.6-32V256c0-29.9 20.5-55 48.2-62c1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96H217.8l28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224H344c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24H272c-26.5 0-48 21.5-48 48v80H416V256h32v96H640V272c0-26.5-21.5-48-48-48h-4.1c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zM224 464c0 26.5 21.5 48 48 48H416V384H224v80zm224 48H592c26.5 0 48-21.5 48-48V384H448V512zm96-312c0 13.3-10.7 24-24 24H470.9l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z"
    ]
};
var $8063e68b12ef6db0$export$c402efcf01d5ca07 = {
    prefix: "fas",
    iconName: "hotel",
    icon: [
        512,
        512,
        [
            127976
        ],
        "f594",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H208V448h96v64H480c17.7 0 32-14.3 32-32s-14.3-32-32-32V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V112zM368 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM96 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208zm144-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V208zm-3 152.2c3.3 12.8-7.8 23.8-21 23.8H184c-13.3 0-24.3-10.9-21-23.8c10.6-41.5 48.2-72.2 93-72.2s82.5 30.7 93 72.2z"
    ]
};
var $8063e68b12ef6db0$export$807cdd395fe012cb = {
    prefix: "fas",
    iconName: "earth-asia",
    icon: [
        512,
        512,
        [
            127759,
            "globe-asia"
        ],
        "f57e",
        "M51.7 295.1l31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9h2.3c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4l16.4-40.9C303.4 52.1 280.2 48 256 48C141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM144.5 348.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z"
    ]
};
var $8063e68b12ef6db0$export$796fdfc909e603f4 = $8063e68b12ef6db0$export$807cdd395fe012cb;
var $8063e68b12ef6db0$export$31e6961064ddac7b = {
    prefix: "fas",
    iconName: "id-card-clip",
    icon: [
        576,
        512,
        [
            "id-card-alt"
        ],
        "f47f",
        "M256 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM64 64H192v48c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64zM176 437.3c0 5.9 4.8 10.7 10.7 10.7H389.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H229.3c-29.5 0-53.3 23.9-53.3 53.3zM288 352c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64z"
    ]
};
var $8063e68b12ef6db0$export$dc37ebbac31f6c6c = $8063e68b12ef6db0$export$31e6961064ddac7b;
var $8063e68b12ef6db0$export$f48a3ba52a0a9e56 = {
    prefix: "fas",
    iconName: "magnifying-glass-plus",
    icon: [
        512,
        512,
        [
            "search-plus"
        ],
        "f00e",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
    ]
};
var $8063e68b12ef6db0$export$378f00e6b1a8185 = $8063e68b12ef6db0$export$f48a3ba52a0a9e56;
var $8063e68b12ef6db0$export$47e4e0d519d33497 = {
    prefix: "fas",
    iconName: "thumbs-up",
    icon: [
        512,
        512,
        [
            128077,
            61575
        ],
        "f164",
        "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 25.3-19.5 46-44.3 47.9c7.7 8.5 12.3 19.8 12.3 32.1c0 23.4-16.8 42.9-38.9 47.1c4.4 7.2 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$b00596a09aa07311 = {
    prefix: "fas",
    iconName: "user-clock",
    icon: [
        640,
        512,
        [],
        "f4fd",
        "M224 256c-70.7 0-128-57.3-128-128S153.3 0 224 0s128 57.3 128 128s-57.3 128-128 128zm-45.7 48h91.4c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM640 368c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM496 288c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"
    ]
};
var $8063e68b12ef6db0$export$8846d49caaed1c0a = {
    prefix: "fas",
    iconName: "hand-dots",
    icon: [
        512,
        512,
        [
            "allergies"
        ],
        "f461",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32zM272 336c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zm48 48c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zm80-48c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zM352 448c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16zm-80-16c0 8.8-7.2 16-16 16s-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16zm-80-16c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16z"
    ]
};
var $8063e68b12ef6db0$export$dcae2101babbffff = $8063e68b12ef6db0$export$8846d49caaed1c0a;
var $8063e68b12ef6db0$export$bef39294aed2281a = {
    prefix: "fas",
    iconName: "file-invoice",
    icon: [
        384,
        512,
        [],
        "f570",
        "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v64H288V256H96zM240 416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $8063e68b12ef6db0$export$26a3f9d2784b90d8 = {
    prefix: "fas",
    iconName: "window-minimize",
    icon: [
        512,
        512,
        [
            128469
        ],
        "f2d1",
        "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
    ]
};
var $8063e68b12ef6db0$export$60048819854688c5 = {
    prefix: "fas",
    iconName: "mug-saucer",
    icon: [
        640,
        512,
        [
            "coffee"
        ],
        "f0f4",
        "M96 64c0-17.7 14.3-32 32-32H448h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H480c0 53-43 96-96 96H192c-53 0-96-43-96-96V64zM480 224h32c35.3 0 64-28.7 64-64s-28.7-64-64-64H480V224zM32 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$1d24a9e457278011 = $8063e68b12ef6db0$export$60048819854688c5;
var $8063e68b12ef6db0$export$5824ffe6f8983c83 = {
    prefix: "fas",
    iconName: "brush",
    icon: [
        384,
        512,
        [],
        "f55d",
        "M192 64L160 0H128L96 64 64 0H48C21.5 0 0 21.5 0 48V256H384V48c0-26.5-21.5-48-48-48H224L192 64zM0 288v32c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64V384h64c35.3 0 64-28.7 64-64V288H0zM192 464c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16s-7.2 16-16 16z"
    ]
};
var $8063e68b12ef6db0$export$7b028758c03b9655 = {
    prefix: "fas",
    iconName: "mask",
    icon: [
        576,
        512,
        [],
        "f6fa",
        "M288 64C64 64 0 160 0 272S80 448 176 448h8.4c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4H400c96 0 176-64 176-176s-64-208-288-208zM224 256c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm192 64c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z"
    ]
};
var $8063e68b12ef6db0$export$56d810b9ab2e30bc = {
    prefix: "fas",
    iconName: "magnifying-glass-minus",
    icon: [
        512,
        512,
        [
            "search-minus"
        ],
        "f010",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z"
    ]
};
var $8063e68b12ef6db0$export$efca97eef6a7a17d = $8063e68b12ef6db0$export$56d810b9ab2e30bc;
var $8063e68b12ef6db0$export$a6ad5df9d9f29553 = {
    prefix: "fas",
    iconName: "ruler-vertical",
    icon: [
        256,
        512,
        [],
        "f548",
        "M0 48C0 21.5 21.5 0 48 0H208c26.5 0 48 21.5 48 48V96H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
    ]
};
var $8063e68b12ef6db0$export$50a28538498238f = {
    prefix: "fas",
    iconName: "user-large",
    icon: [
        512,
        512,
        [
            "user-alt"
        ],
        "f406",
        "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0S112 64.5 112 144s64.5 144 144 144zm-94.7 32C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H481.3c17 0 30.7-13.8 30.7-30.7C512 392.2 439.8 320 350.7 320H161.3z"
    ]
};
var $8063e68b12ef6db0$export$ae9b19c2ac726cfc = $8063e68b12ef6db0$export$50a28538498238f;
var $8063e68b12ef6db0$export$d401d4aeba21cdf3 = {
    prefix: "fas",
    iconName: "train-tram",
    icon: [
        448,
        512,
        [
            128650
        ],
        "e5b4",
        "M86.8 48c-12.2 0-23.6 5.5-31.2 15L42.7 79C34.5 89.3 19.4 91 9 82.7S-3 59.4 5.3 49L18 33C34.7 12.2 60 0 86.8 0H361.2c26.7 0 52 12.2 68.7 33l12.8 16c8.3 10.4 6.6 25.5-3.7 33.7s-25.5 6.6-33.7-3.7L392.5 63c-7.6-9.5-19.1-15-31.2-15H248V96h40c53 0 96 43 96 96V352c0 30.6-14.3 57.8-36.6 75.4l65.5 65.5c7.1 7.1 2.1 19.1-7.9 19.1H365.3c-8.5 0-16.6-3.4-22.6-9.4L288 448H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H43c-10 0-15-12.1-7.9-19.1l65.5-65.5C78.3 409.8 64 382.6 64 352V192c0-53 43-96 96-96h40V48H86.8zM160 160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160zm32 192c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zm96 32c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $8063e68b12ef6db0$export$ab9af5aa013d2162 = {
    prefix: "fas",
    iconName: "user-nurse",
    icon: [
        448,
        512,
        [],
        "f82f",
        "M96 128V70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6 .3 5.3 .3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V136c0-2.7 .1-5.4 .3-8H96zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80V160H144v16zM129.1 323.2l83.2 88.4c6.3 6.7 17 6.7 23.3 0l83.2-88.4c73.7 14.9 129.1 80 129.1 158.1c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-78.1 55.5-143.2 129.1-158.1zM208 48V64H192c-4.4 0-8 3.6-8 8V88c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H240V48c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"
    ]
};
var $8063e68b12ef6db0$export$1aa9423ec6b1d609 = {
    prefix: "fas",
    iconName: "syringe",
    icon: [
        512,
        512,
        [
            128137
        ],
        "f48e",
        "M441 7l32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15L417.9 128l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3 .3 .6 .7 1 1l16 16 56 56 56 56 16 16c.3 .3 .6 .6 1 1l-191 191c-10.5 10.5-24.7 16.4-39.6 16.4H97.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V325.3c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"
    ]
};
var $8063e68b12ef6db0$export$dcaadfd9c98e42a1 = {
    prefix: "fas",
    iconName: "cloud-sun",
    icon: [
        640,
        512,
        [
            9925
        ],
        "f6c4",
        "M122.4 1.2C127.6-.9 133.4-.2 137.9 3l70.3 50.3L278.5 3c4.5-3.2 10.3-3.9 15.4-1.8s8.8 6.7 9.7 12.2l14.1 85.3L403 112.8c5.4 .9 10.1 4.6 12.2 9.7s1.4 10.9-1.8 15.4l-38.8 54.3c-2.2-.1-4.3-.2-6.5-.2c-23.2 0-45 6.2-63.8 17c.1-12.5-2.2-25.3-7.3-37.6c-20.3-49-76.4-72.2-125.4-52s-72.2 76.4-52 125.4c18.3 44.3 66 67.5 111.1 56.6c-36.3 18.2-62.8 53.3-69.1 94.9l-23.6 16.9c-4.5 3.2-10.3 3.9-15.4 1.8s-8.8-6.7-9.7-12.2L98.7 317.7 13.4 303.6c-5.5-.9-10.1-4.6-12.2-9.7S-.2 282.9 3 278.5l50.3-70.3L3 137.9c-3.2-4.5-3.9-10.3-1.8-15.4s6.7-8.8 12.2-9.7L98.7 98.7l14.1-85.3c.9-5.5 4.6-10.1 9.7-12.2zM149 232.7c-13.5-32.7 2-70.1 34.6-83.6s70.1 2 83.6 34.6s-2 70.1-34.6 83.6s-70.1-2-83.6-34.6zM639.9 431.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var $8063e68b12ef6db0$export$df6244b0501f2112 = {
    prefix: "fas",
    iconName: "stopwatch-20",
    icon: [
        448,
        512,
        [],
        "e06f",
        "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H176zM288 204c28.7 0 52 23.3 52 52v96c0 28.7-23.3 52-52 52s-52-23.3-52-52V256c0-28.7 23.3-52 52-52zm-12 52v96c0 6.6 5.4 12 12 12s12-5.4 12-12V256c0-6.6-5.4-12-12-12s-12 5.4-12 12zM159.5 244c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9c29 0 52.5 23.5 52.5 52.5v2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9H192c11 0 20 9 20 20s-9 20-20 20H128c-11 0-20-9-20-20V368.3c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.8v-2.2c0-6.9-5.6-12.5-12.5-12.5z"
    ]
};
var $8063e68b12ef6db0$export$7ec6541fee081990 = {
    prefix: "fas",
    iconName: "square-full",
    icon: [
        512,
        512,
        [
            128997,
            128998,
            128999,
            129000,
            129001,
            129002,
            129003,
            11035,
            11036
        ],
        "f45c",
        "M0 0H512V512H0V0z"
    ]
};
var $8063e68b12ef6db0$export$78932e9c9abea6b7 = {
    prefix: "fas",
    iconName: "magnet",
    icon: [
        448,
        512,
        [
            129522
        ],
        "f076",
        "M0 160v96C0 379.7 100.3 480 224 480s224-100.3 224-224V160H320v96c0 53-43 96-96 96s-96-43-96-96V160H0zm0-32H128V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64zm320 0H448V64c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32v64z"
    ]
};
var $8063e68b12ef6db0$export$53583b459a87a01 = {
    prefix: "fas",
    iconName: "jar",
    icon: [
        320,
        512,
        [],
        "e516",
        "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm96 64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96z"
    ]
};
var $8063e68b12ef6db0$export$4a4e034527c933f5 = {
    prefix: "fas",
    iconName: "note-sticky",
    icon: [
        448,
        512,
        [
            62026,
            "sticky-note"
        ],
        "f249",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H290.7c17 0 33.3-6.7 45.3-18.7L429.3 368c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H64zm0 64H384V320H320c-17.7 0-32 14.3-32 32v64H64V96z"
    ]
};
var $8063e68b12ef6db0$export$80889adc5d98bf4a = $8063e68b12ef6db0$export$4a4e034527c933f5;
var $8063e68b12ef6db0$export$fc4dd5feed8df23 = {
    prefix: "fas",
    iconName: "bug-slash",
    icon: [
        640,
        512,
        [],
        "e490",
        "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L477.4 348.9c1.7-9.4 2.6-19 2.6-28.9h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H479.7c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C409.2 164.1 393.1 160 376 160H264c-8.3 0-16.3 1-24 2.8L38.8 5.1zM320 0c-53 0-96 43-96 96v3.6c0 15.7 12.7 28.4 28.4 28.4H387.6c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96zM160.3 256H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6V335.5L166.7 227.3c-3.4 9-5.6 18.7-6.4 28.7zM336 479.2c36.6-3.6 69.7-19.6 94.8-43.8L336 360.7V479.2z"
    ]
};
var $8063e68b12ef6db0$export$1a093e7861c5e48f = {
    prefix: "fas",
    iconName: "arrow-up-from-water-pump",
    icon: [
        576,
        512,
        [],
        "e4b6",
        "M112 0C85.5 0 64 21.5 64 48V256H48c-26.5 0-48 21.5-48 48v96c0 8 2 15.6 5.4 22.2c3.8-1.7 7.8-3.1 12-4.1c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c4.2 1 8.2 2.4 12 4.1C574 415.6 576 408 576 400V304c0-26.5-21.5-48-48-48H480l0-146.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 109.3 416 256H288V48c0-26.5-21.5-48-48-48H112zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"
    ]
};
var $8063e68b12ef6db0$export$5902c007d5703f2d = {
    prefix: "fas",
    iconName: "bone",
    icon: [
        576,
        512,
        [
            129460
        ],
        "f5d7",
        "M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2H384c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80c0 30.4-17 56.9-42 70.4c-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4c0 44.2-35.8 80-80 80c-33.1 0-61.6-20.1-73.7-48.8C415.4 350.9 401.7 336 384 336H192c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80c0-30.4 17-56.9 42-70.4c3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6C17 232.9 0 206.4 0 176c0-44.2 35.8-80 80-80c33.1 0 61.6 20.1 73.7 48.8z"
    ]
};
var $8063e68b12ef6db0$export$c950c1ba7f227d5b = {
    prefix: "fas",
    iconName: "user-injured",
    icon: [
        448,
        512,
        [],
        "f728",
        "M240 80H342.7c-7.9-19.5-20.4-36.5-36.2-49.9L240 80zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80h81.4l91-68.2zM224 256c70.7 0 128-57.3 128-128c0-5.4-.3-10.8-1-16H97c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128zM124 312.4c-9.7 3.1-19.1 7-28 11.7V512H243.7L181.5 408.2 124 312.4zm33-7.2L204.3 384H272c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h82.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3c-7.2 0-14.3 .4-21.3 1.3zM0 482.3C0 498.7 13.3 512 29.7 512H64V345.4C24.9 378.1 0 427.3 0 482.3zM320 464c0-26.5-21.5-48-48-48H223.5l57.1 95.2C303 507.2 320 487.6 320 464z"
    ]
};
var $8063e68b12ef6db0$export$8a5a0dbb2a17e253 = {
    prefix: "fas",
    iconName: "face-sad-tear",
    icon: [
        512,
        512,
        [
            128546,
            "sad-tear"
        ],
        "f5b4",
        "M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zm240 80c0-8.8 7.2-16 16-16c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16zm-80 80c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C179.6 308.6 208 349 208 369c0 26-21.5 47-48 47zM303.6 208c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm-128 32c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$4b5241926f692f91 = $8063e68b12ef6db0$export$8a5a0dbb2a17e253;
var $8063e68b12ef6db0$export$f654c69e66b466c0 = {
    prefix: "fas",
    iconName: "plane",
    icon: [
        576,
        512,
        [],
        "f072",
        "M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"
    ]
};
var $8063e68b12ef6db0$export$51adfe7c9ee4f428 = {
    prefix: "fas",
    iconName: "tent-arrows-down",
    icon: [
        576,
        512,
        [],
        "e581",
        "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V146.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
    ]
};
var $8063e68b12ef6db0$export$de6218b649cbb6a9 = {
    prefix: "fas",
    iconName: "exclamation",
    icon: [
        128,
        512,
        [
            10069,
            10071,
            61738
        ],
        "21",
        "M96 64c0-17.7-14.3-32-32-32S32 46.3 32 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM64 480c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40s17.9 40 40 40z"
    ]
};
var $8063e68b12ef6db0$export$7e05388be208e313 = {
    prefix: "fas",
    iconName: "arrows-spin",
    icon: [
        448,
        512,
        [],
        "e4bb",
        "M224 96c38.4 0 73.7 13.5 101.3 36.1l-32.6 32.6c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H416c8.8 0 16-7.2 16-16V64c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-34 34C331.4 52.6 280.1 32 224 32c-10.9 0-21.5 .8-32 2.3V99.2c10.3-2.1 21-3.2 32-3.2zM100.1 154.7l32.6 32.6c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V64c0-8.8-7.2-16-16-16H32c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l34 34C20.6 148.6 0 199.9 0 256c0 10.9 .8 21.5 2.3 32H67.2c-2.1-10.3-3.2-21-3.2-32c0-38.4 13.5-73.7 36.1-101.3zM445.7 224H380.8c2.1 10.3 3.2 21 3.2 32c0 38.4-13.5 73.7-36.1 101.3l-32.6-32.6c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8V448c0 8.8 7.2 16 16 16H416c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-34-34C427.4 363.4 448 312.1 448 256c0-10.9-.8-21.5-2.3-32zM224 416c-38.4 0-73.7-13.5-101.3-36.1l32.6-32.6c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H32c-8.8 0-16 7.2-16 16l0 112c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l34-34C116.6 459.4 167.9 480 224 480c10.9 0 21.5-.8 32-2.3V412.8c-10.3 2.1-21 3.2-32 3.2z"
    ]
};
var $8063e68b12ef6db0$export$ae64371e02ee8e56 = {
    prefix: "fas",
    iconName: "print",
    icon: [
        512,
        512,
        [
            128424,
            128438,
            9113
        ],
        "f02f",
        "M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zm-16-88c-13.3 0-24-10.7-24-24s10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $8063e68b12ef6db0$export$b458d393151b6960 = {
    prefix: "fas",
    iconName: "turkish-lira-sign",
    icon: [
        448,
        512,
        [
            "try",
            "turkish-lira"
        ],
        "e2bb",
        "M128 32c17.7 0 32 14.3 32 32V99.3L279.2 65.2c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L160 165.9v29.4l119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L160 261.9V416h63.8c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C410.5 399.8 326.1 480 223.8 480H128c-17.7 0-32-14.3-32-32V280.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L96 213.6V184.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L96 117.6V64c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$970dda513e46c41f = $8063e68b12ef6db0$export$b458d393151b6960;
var $8063e68b12ef6db0$export$40e66e5966827199 = $8063e68b12ef6db0$export$b458d393151b6960;
var $8063e68b12ef6db0$export$fb420d3e4d8c6a18 = {
    prefix: "fas",
    iconName: "dollar-sign",
    icon: [
        320,
        512,
        [
            128178,
            61781,
            "dollar",
            "usd"
        ],
        "24",
        "M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c10.6 1.6 42.1 6.7 55.1 10c17.1 4.3 27.5 21.7 23.2 38.9s-21.7 27.5-38.9 23.2c-9.3-2.4-37.6-7-48.9-8.7c-32.1-4.8-59.6-2.4-78.5 4.9c-18.3 7-25.9 16.9-27.9 28c-1.9 10.7-.5 16.8 1.3 20.6c1.9 4 5.6 8.5 12.9 13.4c16.2 10.8 41.1 17.9 73.3 26.7l2.8 .8c28.4 7.7 63.2 17.2 89 34.3c14.1 9.4 27.3 22.1 35.5 39.7c8.3 17.8 10.1 37.8 6.3 59.1c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.2-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.4 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.7 .5-16.8-1.3-20.6c-1.9-4-5.6-8.5-12.9-13.4c-16.2-10.8-41.1-17.9-73.3-26.7l-2.8-.8c-28.4-7.7-63.2-17.2-89-34.3c-14.1-9.4-27.3-22.1-35.5-39.7c-8.3-17.8-10.1-37.8-6.3-59.1C25 114.1 53 89.3 86 76.7c13-5 27.2-8.2 42-10V32c0-17.7 14.3-32 32-32z"
    ]
};
var $8063e68b12ef6db0$export$a4ffb0775547fcdf = $8063e68b12ef6db0$export$fb420d3e4d8c6a18;
var $8063e68b12ef6db0$export$72cca07d38a28589 = $8063e68b12ef6db0$export$fb420d3e4d8c6a18;
var $8063e68b12ef6db0$export$476af662c0c32cbc = {
    prefix: "fas",
    iconName: "x",
    icon: [
        384,
        512,
        [
            120
        ],
        "58",
        "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"
    ]
};
var $8063e68b12ef6db0$export$fa4f1ead37dc1dce = {
    prefix: "fas",
    iconName: "magnifying-glass-dollar",
    icon: [
        512,
        512,
        [
            "search-dollar"
        ],
        "f688",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM228 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"
    ]
};
var $8063e68b12ef6db0$export$65b49a6767630708 = $8063e68b12ef6db0$export$fa4f1ead37dc1dce;
var $8063e68b12ef6db0$export$3a18218720110fc0 = {
    prefix: "fas",
    iconName: "users-gear",
    icon: [
        640,
        512,
        [
            "users-cog"
        ],
        "f509",
        "M144 160c44.2 0 80-35.8 80-80s-35.8-80-80-80S64 35.8 64 80s35.8 80 80 80zm368 0c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H455.2c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3L574.4 311c-8.9-7.6-19.1-13.6-30.4-17.6v-21c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v21c-11.2 4-21.5 10-30.4 17.6l-18.2-10.5c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l18.2 10.5c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-18.2 10.5c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3L449.6 457c8.9 7.6 19.2 13.6 30.4 17.6v21c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-21c11.2-4 21.5-10 30.4-17.6l18.2 10.5c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-18.2-10.5c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l18.2-10.5zM552 384c0 22.1-17.9 40-40 40s-40-17.9-40-40s17.9-40 40-40s40 17.9 40 40z"
    ]
};
var $8063e68b12ef6db0$export$5e0b06753fc69b81 = $8063e68b12ef6db0$export$3a18218720110fc0;
var $8063e68b12ef6db0$export$50b6dcaa9ec03439 = {
    prefix: "fas",
    iconName: "person-military-pointing",
    icon: [
        576,
        512,
        [],
        "e54a",
        "M246.9 14.1C234 15.2 224 26 224 39c0 13.8 11.2 25 25 25H400c8.8 0 16-7.2 16-16V17.4C416 8 408 .7 398.7 1.4L246.9 14.1zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H241.6c-1 5.2-1.6 10.5-1.6 16zM72 224c-22.1 0-40 17.9-40 40s17.9 40 40 40H224v89.4L386.8 230.5c-13.3-4.3-27.3-6.5-41.6-6.5H240 72zm345.7 20.9L246.6 416H416V369.7l53.6 90.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L462.3 290.8c-11.2-18.9-26.6-34.5-44.6-45.9zM224 448v32c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V448H224z"
    ]
};
var $8063e68b12ef6db0$export$a411e7e26cb63d5e = {
    prefix: "fas",
    iconName: "building-columns",
    icon: [
        512,
        512,
        [
            "bank",
            "institution",
            "museum",
            "university"
        ],
        "f19c",
        "M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8.1-3.4-17.2-3.4-25.2 0zM128 224H64V420.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384V416H344V224H280V416H232V224H168V416H128V224zm128-96c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $8063e68b12ef6db0$export$6e379b829ea8b99 = $8063e68b12ef6db0$export$a411e7e26cb63d5e;
var $8063e68b12ef6db0$export$1dba320226a34c1f = $8063e68b12ef6db0$export$a411e7e26cb63d5e;
var $8063e68b12ef6db0$export$9b3953adff472ad2 = $8063e68b12ef6db0$export$a411e7e26cb63d5e;
var $8063e68b12ef6db0$export$f2e1460ebe1a8cb0 = $8063e68b12ef6db0$export$a411e7e26cb63d5e;
var $8063e68b12ef6db0$export$9ff64ffae70e08c0 = {
    prefix: "fas",
    iconName: "umbrella",
    icon: [
        640,
        512,
        [],
        "f0e9",
        "M320 0c17.7 0 32 14.3 32 32V49.7C483.8 63.4 589.7 161 605.9 285.9c2 15.6-17.3 24.4-27.8 12.7C564.1 283 536.8 272 512 272c-38.7 0-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C391 299.5 358.7 272 320 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C199 299.5 166.7 272 128 272c-24.8 0-52.1 11-66.1 26.7c-10.5 11.7-29.8 2.9-27.8-12.7C50.3 161 156.2 63.4 288 49.7V32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2V430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4V316.2c8.5-7.6 19.7-12.2 32-12.2z"
    ]
};
var $8063e68b12ef6db0$export$12ca996a6f686fe1 = {
    prefix: "fas",
    iconName: "trowel",
    icon: [
        512,
        512,
        [],
        "e589",
        "M343.9 213.4L245.3 312l65.4 65.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8 .5-32.2-7.9S-2.1 481.8 1.5 470.5l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4 .5 30.3 8.4L200 266.7l98.6-98.6c-14.3-14.6-14.2-38 .3-52.5l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.5 14.5-37.9 14.6-52.5 .3z"
    ]
};
var $8063e68b12ef6db0$export$56c73b799aac2555 = {
    prefix: "fas",
    iconName: "d",
    icon: [
        384,
        512,
        [
            100
        ],
        "44",
        "M0 64C0 46.3 14.3 32 32 32H160c123.7 0 224 100.3 224 224s-100.3 224-224 224H32c-17.7 0-32-14.3-32-32V64zM64 96V416h96c88.4 0 160-71.6 160-160s-71.6-160-160-160H64z"
    ]
};
var $8063e68b12ef6db0$export$c7e014b7e3ac3d83 = {
    prefix: "fas",
    iconName: "stapler",
    icon: [
        640,
        512,
        [],
        "e5af",
        "M640 299.3V304 432c0 26.5-21.5 48-48 48H512 448 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H448V368H96c-17.7 0-32-14.3-32-32V219.4L33.8 214C14.2 210.5 0 193.5 0 173.7c0-8.9 2.9-17.5 8.2-24.6l35.6-47.5C76.7 57.8 128.2 32 182.9 32c27 0 53.6 6.3 77.8 18.4L586.9 213.5C619.5 229.7 640 263 640 299.3zM448 304V288L128 230.9V304H448z"
    ]
};
var $8063e68b12ef6db0$export$bf5896cc1ce4d55 = {
    prefix: "fas",
    iconName: "masks-theater",
    icon: [
        640,
        512,
        [
            127917,
            "theater-masks"
        ],
        "f630",
        "M399.3 509.7c-58.2-8.8-108.2-72.8-137.6-119.7c-20-31.9-25.1-70.3-19.6-107.7L266.3 118c1.4-9.8 5.1-19.2 12.9-25.2c20.2-15.6 72.4-41.5 185.1-24.5s155.2 57.4 170 78.3c5.7 8 6.5 18.1 5.1 27.9L615.2 338.8c-5.5 37.3-21.5 72.6-49.8 97.2c-41.7 36.1-108 82.5-166.1 73.7zm17.1-277.7c.1-.5 .2-1.1 .3-1.6c3.2-21.8-11.6-42-33.1-45.3s-41.5 11.8-44.7 33.5c-.1 .5-.1 1.1-.2 1.6c-.6 5.4 5.2 8.4 10.3 6.7c9-3 18.8-3.9 28.7-2.4s19.1 5.3 26.8 10.8c4.4 3.1 10.8 2 11.8-3.3zm112.6 22.2c4.4 3.1 10.8 2 11.8-3.3c.1-.5 .2-1.1 .3-1.6c3.2-21.8-11.6-42-33.1-45.3s-41.5 11.8-44.7 33.5c-.1 .5-.1 1.1-.2 1.6c-.6 5.4 5.2 8.4 10.3 6.7c9-3 18.8-3.9 28.7-2.4s19.1 5.3 26.8 10.8zm-11.5 85.2c-28.8 12.8-61.4 17.8-94.9 12.8s-63.2-19.5-87-40.3c-6.3-5.5-16.2-1.7-15.2 6.7c5.9 48.5 43 89.1 93 96.7s97.2-20.2 116.8-64.9c3.4-7.7-5-14.3-12.6-10.9zM240.7 446.9c-58.2 8.8-124.5-37.5-166.1-73.7c-28.3-24.5-44.3-59.8-49.8-97.2L.6 111.8C-.8 102 0 91.9 5.7 83.9C20.5 63 63 22.7 175.7 5.6s164.9 8.9 185.1 24.5c.9 .7 1.7 1.4 2.4 2.1c-52.8 4.8-85.1 21-103.6 35.3c-17 13.1-23 32-25 45.9L215.3 244.7c-2.6 .1-5.2 .4-7.9 .8c-35.2 5.3-61.8 32.7-68.2 66.3c-1.6 8.2 8.3 12.2 14.8 7c15.6-12.4 34.1-21.3 54.7-25.4c-3 38.4 4 78.7 25.9 113.6c6.9 11 15 23.1 24.2 35.4c-5.9 2.1-11.9 3.6-18 4.5zM174.1 157c-1-5.3-7.4-6.4-11.8-3.3c-7.7 5.5-16.8 9.3-26.8 10.8s-19.8 .6-28.7-2.4c-5.1-1.7-10.9 1.3-10.3 6.7c.1 .5 .1 1.1 .2 1.6c3.2 21.8 23.2 36.8 44.7 33.5s36.3-23.5 33.1-45.3c-.1-.5-.2-1.1-.3-1.6z"
    ]
};
var $8063e68b12ef6db0$export$3dbedc487b0159ac = $8063e68b12ef6db0$export$bf5896cc1ce4d55;
var $8063e68b12ef6db0$export$a6df39524c41472c = {
    prefix: "fas",
    iconName: "kip-sign",
    icon: [
        384,
        512,
        [],
        "e1c4",
        "M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4V64c0-17.7-14.3-32-32-32S64 46.3 64 64V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V325.6L299.2 472.3c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L182.5 288H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H182.5L340.8 88.3z"
    ]
};
var $8063e68b12ef6db0$export$b276ec3dc9760d39 = {
    prefix: "fas",
    iconName: "hand-point-left",
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l208 0V96L32 96zM192 288c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm-64-64c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zm88-96l-.6 0c5.4 9.4 8.6 20.3 8.6 32c0 13.2-4 25.4-10.8 35.6c24.9 8.7 42.8 32.5 42.8 60.4c0 11.7-3.1 22.6-8.6 32H352c88.4 0 160-71.6 160-160V226.3c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-27 0c-35.3 0-64 28.7-64 64v88c0 22.1 17.9 40 40 40s40-17.9 40-40V160c0-8.8 7.2-16 16-16s16 7.2 16 16v56c0 39.8-32.2 72-72 72z"
    ]
};
var $8063e68b12ef6db0$export$e8485db4dab0ab30 = {
    prefix: "fas",
    iconName: "handshake-simple",
    icon: [
        640,
        512,
        [
            129309,
            "handshake-alt"
        ],
        "f4c6",
        "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48H48c-26.5 0-48 21.5-48 48V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123z"
    ]
};
var $8063e68b12ef6db0$export$e9aa3c6f9f47aa1a = $8063e68b12ef6db0$export$e8485db4dab0ab30;
var $8063e68b12ef6db0$export$2130e629ab767ab3 = {
    prefix: "fas",
    iconName: "jet-fighter",
    icon: [
        640,
        512,
        [
            "fighter-jet"
        ],
        "f0fb",
        "M160 24c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H280L384 192H500.4c7.7 0 15.3 1.4 22.5 4.1L625 234.4c9 3.4 15 12 15 21.6s-6 18.2-15 21.6L522.9 315.9c-7.2 2.7-14.8 4.1-22.5 4.1H384L280 464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V320H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H82.7c8.5 0 16.6 3.4 22.6 9.4L160 192h32V48h-8c-13.3 0-24-10.7-24-24zM80 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
    ]
};
var $8063e68b12ef6db0$export$102b809faf56e033 = $8063e68b12ef6db0$export$2130e629ab767ab3;
var $8063e68b12ef6db0$export$1bdb0ec5af3fea99 = {
    prefix: "fas",
    iconName: "square-share-nodes",
    icon: [
        448,
        512,
        [
            "share-alt-square"
        ],
        "f1e1",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM384 160c0 35.3-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64z"
    ]
};
var $8063e68b12ef6db0$export$3799c2d8fd7e493b = $8063e68b12ef6db0$export$1bdb0ec5af3fea99;
var $8063e68b12ef6db0$export$3825a842b5afc5aa = {
    prefix: "fas",
    iconName: "barcode",
    icon: [
        512,
        512,
        [],
        "f02a",
        "M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ]
};
var $8063e68b12ef6db0$export$37bd38cf96417095 = {
    prefix: "fas",
    iconName: "plus-minus",
    icon: [
        384,
        512,
        [],
        "e43c",
        "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H160V320c0 17.7 14.3 32 32 32s32-14.3 32-32V208H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V32zM0 480c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
    ]
};
var $8063e68b12ef6db0$export$5c6bd8729527871b = {
    prefix: "fas",
    iconName: "video",
    icon: [
        576,
        512,
        [
            "video-camera"
        ],
        "f03d",
        "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"
    ]
};
var $8063e68b12ef6db0$export$3a530df752193ccf = $8063e68b12ef6db0$export$5c6bd8729527871b;
var $8063e68b12ef6db0$export$874e305fd7920cce = {
    prefix: "fas",
    iconName: "graduation-cap",
    icon: [
        640,
        512,
        [
            127891,
            "mortar-board"
        ],
        "f19d",
        "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"
    ]
};
var $8063e68b12ef6db0$export$dd0a013bf23a9d86 = $8063e68b12ef6db0$export$874e305fd7920cce;
var $8063e68b12ef6db0$export$bb2a6b1b5e852300 = {
    prefix: "fas",
    iconName: "hand-holding-medical",
    icon: [
        576,
        512,
        [],
        "e05c",
        "M224 24V80H168c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h56v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176h56c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H320V24c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zM559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2l.9 0 0 0c-.3 0-.6 0-.9 0z"
    ]
};
var $8063e68b12ef6db0$export$30294c81ac4031ca = {
    prefix: "fas",
    iconName: "person-circle-check",
    icon: [
        576,
        512,
        [],
        "e53e",
        "M208 48c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48zM152 352V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm424 16c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zm-76.7-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $8063e68b12ef6db0$export$314f5cab62fc6968 = {
    prefix: "fas",
    iconName: "turn-up",
    icon: [
        384,
        512,
        [
            10548,
            "level-up-alt"
        ],
        "f3bf",
        "M178.3 5.7L40.3 143.7C35 149 32 156.2 32 163.7C32 179.3 44.7 192 60.3 192H144V400c0 8.8-7.2 16-16 16H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h96c61.9 0 112-50.1 112-112V192h83.7c15.6 0 28.3-12.7 28.3-28.3c0-7.5-3-14.7-8.3-20L205.7 5.7C202 2 197.1 0 192 0s-10 2-13.7 5.7z"
    ]
};
var $8063e68b12ef6db0$export$d6f21a309b179c3d = $8063e68b12ef6db0$export$314f5cab62fc6968;
var $8063e68b12ef6db0$export$da048c47c8dcd50a = {
    fa0: $8063e68b12ef6db0$export$f22454595d96c106,
    fa1: $8063e68b12ef6db0$export$8398cb2addc9e182,
    fa2: $8063e68b12ef6db0$export$ed1a0ff7bd680a1d,
    fa3: $8063e68b12ef6db0$export$74b7ff79ce1818d6,
    fa4: $8063e68b12ef6db0$export$969b2215780d58fd,
    fa5: $8063e68b12ef6db0$export$3919f68a5b3825a9,
    fa6: $8063e68b12ef6db0$export$580ac17b31ffb5c3,
    fa7: $8063e68b12ef6db0$export$ee79cab31be16d23,
    fa8: $8063e68b12ef6db0$export$45d84c4b2c560d2f,
    fa9: $8063e68b12ef6db0$export$a120f1e4223629f2,
    faFillDrip: $8063e68b12ef6db0$export$38320138fc0262d0,
    faArrowsToCircle: $8063e68b12ef6db0$export$917a3d30f6cd766,
    faCircleChevronRight: $8063e68b12ef6db0$export$a39bab13d51abfd0,
    faChevronCircleRight: $8063e68b12ef6db0$export$2a5db4f6eba6f2b,
    faAt: $8063e68b12ef6db0$export$c115e8063ee02632,
    faTrashCan: $8063e68b12ef6db0$export$864bb8d6c21fb792,
    faTrashAlt: $8063e68b12ef6db0$export$88df7ff7eb32f9dc,
    faTextHeight: $8063e68b12ef6db0$export$3313bce3924ea7da,
    faUserXmark: $8063e68b12ef6db0$export$e585697127cda27,
    faUserTimes: $8063e68b12ef6db0$export$45b996d071667753,
    faStethoscope: $8063e68b12ef6db0$export$acb2d72d28cd92d9,
    faMessage: $8063e68b12ef6db0$export$6563a67224e7f879,
    faCommentAlt: $8063e68b12ef6db0$export$6e96904d9af0ec4a,
    faInfo: $8063e68b12ef6db0$export$d469b770895f47ac,
    faDownLeftAndUpRightToCenter: $8063e68b12ef6db0$export$d56736f5800b3f0d,
    faCompressAlt: $8063e68b12ef6db0$export$a05650ebe54bede,
    faExplosion: $8063e68b12ef6db0$export$36b5fbeae4855055,
    faFileLines: $8063e68b12ef6db0$export$ef565d07efe2b5e9,
    faFileAlt: $8063e68b12ef6db0$export$243b47dca32bf0b8,
    faFileText: $8063e68b12ef6db0$export$f466100bf9bf37a5,
    faWaveSquare: $8063e68b12ef6db0$export$c38cf504b3bc58a2,
    faRing: $8063e68b12ef6db0$export$a95486586631edc7,
    faBuildingUn: $8063e68b12ef6db0$export$fbbc7601eb465ac7,
    faDiceThree: $8063e68b12ef6db0$export$221059e0d5fd8958,
    faCalendarDays: $8063e68b12ef6db0$export$31c6cf6f5d38dc0,
    faCalendarAlt: $8063e68b12ef6db0$export$cbc139f33cff356,
    faAnchorCircleCheck: $8063e68b12ef6db0$export$8bce49e6ae597af8,
    faBuildingCircleArrowRight: $8063e68b12ef6db0$export$37584b1a5e175b47,
    faVolleyball: $8063e68b12ef6db0$export$cc519c9529a46c5c,
    faVolleyballBall: $8063e68b12ef6db0$export$a15e6fc8e68a76b0,
    faArrowsUpToLine: $8063e68b12ef6db0$export$159982ce2622211e,
    faSortDown: $8063e68b12ef6db0$export$58e2577a373e7d4,
    faSortDesc: $8063e68b12ef6db0$export$e24f016f5f78af6a,
    faCircleMinus: $8063e68b12ef6db0$export$d0163707993a8110,
    faMinusCircle: $8063e68b12ef6db0$export$f3979b49bf57313c,
    faDoorOpen: $8063e68b12ef6db0$export$41821b9a6fd703de,
    faRightFromBracket: $8063e68b12ef6db0$export$122a80ae0f87f726,
    faSignOutAlt: $8063e68b12ef6db0$export$c844d6923b7096c2,
    faAtom: $8063e68b12ef6db0$export$b5bb295e8ad4ab31,
    faSoap: $8063e68b12ef6db0$export$64f1c53b21f310ac,
    faIcons: $8063e68b12ef6db0$export$7fe2894454d8eb8a,
    faHeartMusicCameraBolt: $8063e68b12ef6db0$export$ec74c13cedb0791d,
    faMicrophoneLinesSlash: $8063e68b12ef6db0$export$4be1b324ac8a71ba,
    faMicrophoneAltSlash: $8063e68b12ef6db0$export$d2a53a388f30780,
    faBridgeCircleCheck: $8063e68b12ef6db0$export$ea908d3d80c57d08,
    faPumpMedical: $8063e68b12ef6db0$export$f1b881c73328720c,
    faFingerprint: $8063e68b12ef6db0$export$614dc068d88655af,
    faHandPointRight: $8063e68b12ef6db0$export$f7bc8714c970afa4,
    faMagnifyingGlassLocation: $8063e68b12ef6db0$export$234a18b2b4d530a3,
    faSearchLocation: $8063e68b12ef6db0$export$c33aba6c251a898a,
    faForwardStep: $8063e68b12ef6db0$export$908d699be6717adc,
    faStepForward: $8063e68b12ef6db0$export$b303329afce5de18,
    faFaceSmileBeam: $8063e68b12ef6db0$export$e3c56ed54f074063,
    faSmileBeam: $8063e68b12ef6db0$export$54ada6dc9690e0ca,
    faFlagCheckered: $8063e68b12ef6db0$export$92fad97e19a9fea,
    faFootball: $8063e68b12ef6db0$export$e15f65e77f717c29,
    faFootballBall: $8063e68b12ef6db0$export$e8fd664711e31704,
    faSchoolCircleExclamation: $8063e68b12ef6db0$export$f629fdee00932a01,
    faCrop: $8063e68b12ef6db0$export$afa58590dfb6fca2,
    faAnglesDown: $8063e68b12ef6db0$export$52783a541b1bb03,
    faAngleDoubleDown: $8063e68b12ef6db0$export$fd504117f273ca92,
    faUsersRectangle: $8063e68b12ef6db0$export$a28757068b9a3a9a,
    faPeopleRoof: $8063e68b12ef6db0$export$b96e695bdcf3f3f5,
    faPeopleLine: $8063e68b12ef6db0$export$d12c2d6def120efe,
    faBeerMugEmpty: $8063e68b12ef6db0$export$b957c27bc5330472,
    faBeer: $8063e68b12ef6db0$export$f74725691538983b,
    faDiagramPredecessor: $8063e68b12ef6db0$export$1852c99deca7bee8,
    faArrowUpLong: $8063e68b12ef6db0$export$92c58defe6e4c5a7,
    faLongArrowUp: $8063e68b12ef6db0$export$ede1d50ec4b01670,
    faFireFlameSimple: $8063e68b12ef6db0$export$9ebfff5c90672059,
    faBurn: $8063e68b12ef6db0$export$80ed4535efc60402,
    faPerson: $8063e68b12ef6db0$export$e6619e43cb090a16,
    faMale: $8063e68b12ef6db0$export$2e21f9dba1630651,
    faLaptop: $8063e68b12ef6db0$export$c2dee3bd177275a2,
    faFileCsv: $8063e68b12ef6db0$export$82cea4f586f6ec9,
    faMenorah: $8063e68b12ef6db0$export$232452c59d77c56e,
    faTruckPlane: $8063e68b12ef6db0$export$e1d5ceed99060d76,
    faRecordVinyl: $8063e68b12ef6db0$export$fe2d5012d9982673,
    faFaceGrinStars: $8063e68b12ef6db0$export$1d1fbac384a76a12,
    faGrinStars: $8063e68b12ef6db0$export$64347a5c8c402ef4,
    faBong: $8063e68b12ef6db0$export$e74974fac77c468e,
    faSpaghettiMonsterFlying: $8063e68b12ef6db0$export$3c8d5c62d76c33b8,
    faPastafarianism: $8063e68b12ef6db0$export$733efdaec97447be,
    faArrowDownUpAcrossLine: $8063e68b12ef6db0$export$9fe0c42ede2dd003,
    faSpoon: $8063e68b12ef6db0$export$faf854a434ce6d0c,
    faUtensilSpoon: $8063e68b12ef6db0$export$fb7af5d245fb9053,
    faJarWheat: $8063e68b12ef6db0$export$8b503c1d76716ddd,
    faEnvelopesBulk: $8063e68b12ef6db0$export$dc2cce064a1e70bb,
    faMailBulk: $8063e68b12ef6db0$export$dd24f40c5337e2e1,
    faFileCircleExclamation: $8063e68b12ef6db0$export$61fa9809253098e5,
    faCircleH: $8063e68b12ef6db0$export$bf5674308c61894f,
    faHospitalSymbol: $8063e68b12ef6db0$export$c8a3c78d99c23fed,
    faPager: $8063e68b12ef6db0$export$e1611f373a10a98c,
    faAddressBook: $8063e68b12ef6db0$export$853fd1561789e3bb,
    faContactBook: $8063e68b12ef6db0$export$594b5a5d4d2e156b,
    faStrikethrough: $8063e68b12ef6db0$export$eff51ea25b4de135,
    faK: $8063e68b12ef6db0$export$3f85413cb67e7f67,
    faLandmarkFlag: $8063e68b12ef6db0$export$f4d472cf47be4096,
    faPencil: $8063e68b12ef6db0$export$c72de95adaca18b8,
    faPencilAlt: $8063e68b12ef6db0$export$8210adc172262df,
    faBackward: $8063e68b12ef6db0$export$ae65f96ea7a4078d,
    faCaretRight: $8063e68b12ef6db0$export$f1011352b01c1c0,
    faComments: $8063e68b12ef6db0$export$932912e74adb8939,
    faPaste: $8063e68b12ef6db0$export$6f95f90dd1f6d86b,
    faFileClipboard: $8063e68b12ef6db0$export$ca3229c47de163fa,
    faCodePullRequest: $8063e68b12ef6db0$export$37576dfab037d8bf,
    faClipboardList: $8063e68b12ef6db0$export$2c5a9d8548d8810e,
    faTruckRampBox: $8063e68b12ef6db0$export$37396c36c76937bc,
    faTruckLoading: $8063e68b12ef6db0$export$f00c152db7d44638,
    faUserCheck: $8063e68b12ef6db0$export$76de2a120043c9f8,
    faVialVirus: $8063e68b12ef6db0$export$a56b2b0a1073620c,
    faSheetPlastic: $8063e68b12ef6db0$export$57f2bcd070bff91a,
    faBlog: $8063e68b12ef6db0$export$890d5e011054935a,
    faUserNinja: $8063e68b12ef6db0$export$a9174995732e03c5,
    faPersonArrowUpFromLine: $8063e68b12ef6db0$export$5709329dd2b70bdc,
    faScrollTorah: $8063e68b12ef6db0$export$4e3fe5b42a6cd494,
    faTorah: $8063e68b12ef6db0$export$54d07baabd8c2acb,
    faBroomBall: $8063e68b12ef6db0$export$3e1327487ce53231,
    faQuidditch: $8063e68b12ef6db0$export$c00c446e6db1605f,
    faQuidditchBroomBall: $8063e68b12ef6db0$export$791bfe29b97b4d42,
    faToggleOff: $8063e68b12ef6db0$export$d20aaceb882ca545,
    faBoxArchive: $8063e68b12ef6db0$export$2a0fcb66c3d79d00,
    faArchive: $8063e68b12ef6db0$export$26b3e1c454273f34,
    faPersonDrowning: $8063e68b12ef6db0$export$bac321083217fd4,
    faArrowDown91: $8063e68b12ef6db0$export$6cc91ce23eb3fae1,
    faSortNumericDesc: $8063e68b12ef6db0$export$99f058110e2c82a8,
    faSortNumericDownAlt: $8063e68b12ef6db0$export$857385fda7a5a98e,
    faFaceGrinTongueSquint: $8063e68b12ef6db0$export$8eee2c17ff89e724,
    faGrinTongueSquint: $8063e68b12ef6db0$export$4edf34c3def09a31,
    faSprayCan: $8063e68b12ef6db0$export$4952c502f544cf85,
    faTruckMonster: $8063e68b12ef6db0$export$24b8a0147653649a,
    faW: $8063e68b12ef6db0$export$c7f24bdea332f90a,
    faEarthAfrica: $8063e68b12ef6db0$export$11afa141d42099d0,
    faGlobeAfrica: $8063e68b12ef6db0$export$64af36f3b403a57c,
    faRainbow: $8063e68b12ef6db0$export$92ab27739d3a91b2,
    faCircleNotch: $8063e68b12ef6db0$export$9429fd8df55155d,
    faTabletScreenButton: $8063e68b12ef6db0$export$df1e253fc358ade4,
    faTabletAlt: $8063e68b12ef6db0$export$db0cac088255eacc,
    faPaw: $8063e68b12ef6db0$export$7bc6e4d977673e69,
    faCloud: $8063e68b12ef6db0$export$8bb3c4d5c2f50243,
    faTrowelBricks: $8063e68b12ef6db0$export$b6c20c10ddbd9898,
    faFaceFlushed: $8063e68b12ef6db0$export$ba5dc4287853ecbd,
    faFlushed: $8063e68b12ef6db0$export$dfd2bd012685aeac,
    faHospitalUser: $8063e68b12ef6db0$export$684703c93d630cc5,
    faTentArrowLeftRight: $8063e68b12ef6db0$export$fa95eb7418c0e2b8,
    faGavel: $8063e68b12ef6db0$export$c36fb40057e2c3aa,
    faLegal: $8063e68b12ef6db0$export$59d593c2dacb3781,
    faBinoculars: $8063e68b12ef6db0$export$8a910017964bb8c2,
    faMicrophoneSlash: $8063e68b12ef6db0$export$843f63d64e6f7951,
    faBoxTissue: $8063e68b12ef6db0$export$f2adc06617bc0c7,
    faMotorcycle: $8063e68b12ef6db0$export$f26017bdca99338d,
    faBellConcierge: $8063e68b12ef6db0$export$e433538b78718fb3,
    faConciergeBell: $8063e68b12ef6db0$export$ad92ffbbfbc0fcf3,
    faPenRuler: $8063e68b12ef6db0$export$85ba06027671d290,
    faPencilRuler: $8063e68b12ef6db0$export$e3a7a1affea005f5,
    faPeopleArrows: $8063e68b12ef6db0$export$804bfc5c390e1a2a,
    faPeopleArrowsLeftRight: $8063e68b12ef6db0$export$da01f044c59e3598,
    faMarsAndVenusBurst: $8063e68b12ef6db0$export$1dc6221efb867885,
    faSquareCaretRight: $8063e68b12ef6db0$export$5b1d41cdd118ea6d,
    faCaretSquareRight: $8063e68b12ef6db0$export$ae86c9de7e0f62fa,
    faScissors: $8063e68b12ef6db0$export$b2a906a5928c6404,
    faCut: $8063e68b12ef6db0$export$66847f2a71b260e7,
    faSunPlantWilt: $8063e68b12ef6db0$export$8db7f2f70484e17e,
    faToiletsPortable: $8063e68b12ef6db0$export$c00f55f36d386cb7,
    faHockeyPuck: $8063e68b12ef6db0$export$a274b02dc75663dc,
    faTable: $8063e68b12ef6db0$export$36583f5d3d5a971f,
    faMagnifyingGlassArrowRight: $8063e68b12ef6db0$export$382d3376c7fc7fc5,
    faTachographDigital: $8063e68b12ef6db0$export$73f2bf302381c86a,
    faDigitalTachograph: $8063e68b12ef6db0$export$b3bf1994f0fefe98,
    faUsersSlash: $8063e68b12ef6db0$export$b71a093b86e3da1f,
    faClover: $8063e68b12ef6db0$export$57813571c0e10a0a,
    faReply: $8063e68b12ef6db0$export$bb06d4a7bb6736fe,
    faMailReply: $8063e68b12ef6db0$export$12e45ff70d2646a1,
    faStarAndCrescent: $8063e68b12ef6db0$export$cafa834c96ebcb1a,
    faHouseFire: $8063e68b12ef6db0$export$947ee033a6942aa8,
    faSquareMinus: $8063e68b12ef6db0$export$814c9edba7b84aa4,
    faMinusSquare: $8063e68b12ef6db0$export$ffe9387966b3e681,
    faHelicopter: $8063e68b12ef6db0$export$612d3e1afaf45fa5,
    faCompass: $8063e68b12ef6db0$export$b4d344633433e50e,
    faSquareCaretDown: $8063e68b12ef6db0$export$a1ab39cd66c4e50e,
    faCaretSquareDown: $8063e68b12ef6db0$export$61aea18df1c84401,
    faFileCircleQuestion: $8063e68b12ef6db0$export$877d3692c1f94bda,
    faLaptopCode: $8063e68b12ef6db0$export$94100f4c6ee29932,
    faSwatchbook: $8063e68b12ef6db0$export$c74a20c81b957b6a,
    faPrescriptionBottle: $8063e68b12ef6db0$export$214f9ce665590486,
    faBars: $8063e68b12ef6db0$export$36e9cf7887265da2,
    faNavicon: $8063e68b12ef6db0$export$409fa7bcaa0e4cd9,
    faPeopleGroup: $8063e68b12ef6db0$export$be015e72863c3635,
    faHourglassEnd: $8063e68b12ef6db0$export$52757ecc5b1e25b9,
    faHourglass3: $8063e68b12ef6db0$export$1ec43c81fef8ffd6,
    faHeartCrack: $8063e68b12ef6db0$export$8e521ef33062b00e,
    faHeartBroken: $8063e68b12ef6db0$export$4a565395cb65b282,
    faSquareUpRight: $8063e68b12ef6db0$export$a47a20ab7bde8c67,
    faExternalLinkSquareAlt: $8063e68b12ef6db0$export$e4cdf2977151ee26,
    faFaceKissBeam: $8063e68b12ef6db0$export$eca99665af566fe1,
    faKissBeam: $8063e68b12ef6db0$export$d6ff8a73c0812e63,
    faFilm: $8063e68b12ef6db0$export$c03de0cc616e77bb,
    faRulerHorizontal: $8063e68b12ef6db0$export$46c6347bff3e04a,
    faPeopleRobbery: $8063e68b12ef6db0$export$75ce8513e1f1c5c4,
    faLightbulb: $8063e68b12ef6db0$export$1e80f89fe84a215b,
    faCaretLeft: $8063e68b12ef6db0$export$85a918a11b7643c2,
    faCircleExclamation: $8063e68b12ef6db0$export$59573943f9eebbd5,
    faExclamationCircle: $8063e68b12ef6db0$export$220e07e14c5d7e5d,
    faSchoolCircleXmark: $8063e68b12ef6db0$export$5e17b20e0f6b132b,
    faArrowRightFromBracket: $8063e68b12ef6db0$export$ca14f1b4d6afb7aa,
    faSignOut: $8063e68b12ef6db0$export$33e2b60243ca6d92,
    faCircleChevronDown: $8063e68b12ef6db0$export$aca07924996218d8,
    faChevronCircleDown: $8063e68b12ef6db0$export$9926124d75b2ecab,
    faUnlockKeyhole: $8063e68b12ef6db0$export$c98fdd5082b333ec,
    faUnlockAlt: $8063e68b12ef6db0$export$b19f508797f3d9c3,
    faCloudShowersHeavy: $8063e68b12ef6db0$export$af51c741ee9cc090,
    faHeadphonesSimple: $8063e68b12ef6db0$export$ca47801915e5a685,
    faHeadphonesAlt: $8063e68b12ef6db0$export$6f0433fa527dd5be,
    faSitemap: $8063e68b12ef6db0$export$b2ce5e79d0eccaf8,
    faCircleDollarToSlot: $8063e68b12ef6db0$export$5f92ac3e804644e3,
    faDonate: $8063e68b12ef6db0$export$40050ae52860cde7,
    faMemory: $8063e68b12ef6db0$export$5f9bd9f6df021f93,
    faRoadSpikes: $8063e68b12ef6db0$export$b372a24046126ad8,
    faFireBurner: $8063e68b12ef6db0$export$e4e44f7b1886fef,
    faFlag: $8063e68b12ef6db0$export$6591b1ea509be9da,
    faHanukiah: $8063e68b12ef6db0$export$3dcd4ca3f7108a82,
    faFeather: $8063e68b12ef6db0$export$5e19aea195b31816,
    faVolumeLow: $8063e68b12ef6db0$export$2b1464e7557b18eb,
    faVolumeDown: $8063e68b12ef6db0$export$69fdf57632b6cc29,
    faCommentSlash: $8063e68b12ef6db0$export$3786a0422a3f33ea,
    faCloudSunRain: $8063e68b12ef6db0$export$dd9dc9b4227dbe94,
    faCompress: $8063e68b12ef6db0$export$83632d1150d3541f,
    faWheatAwn: $8063e68b12ef6db0$export$79d4dac715a51fdf,
    faWheatAlt: $8063e68b12ef6db0$export$deaf03a29aa05e3a,
    faAnkh: $8063e68b12ef6db0$export$8736909014b15ca9,
    faHandsHoldingChild: $8063e68b12ef6db0$export$bfb254bf3c0bc50b,
    faAsterisk: $8063e68b12ef6db0$export$19eff32c0fd4f99f,
    faSquareCheck: $8063e68b12ef6db0$export$5bb6a0c94ad2f4bb,
    faCheckSquare: $8063e68b12ef6db0$export$f0c8040f596df7fe,
    faPesetaSign: $8063e68b12ef6db0$export$a6f8654bcd49a39f,
    faHeading: $8063e68b12ef6db0$export$4805b8d175aeb9fb,
    faHeader: $8063e68b12ef6db0$export$579f9604bb10a61a,
    faGhost: $8063e68b12ef6db0$export$1a989eb1919c64c1,
    faList: $8063e68b12ef6db0$export$6cfc59842fedbc16,
    faListSquares: $8063e68b12ef6db0$export$e3f160fc949c2b9d,
    faSquarePhoneFlip: $8063e68b12ef6db0$export$b627121801cad756,
    faPhoneSquareAlt: $8063e68b12ef6db0$export$a41e77f0de98bba7,
    faCartPlus: $8063e68b12ef6db0$export$6675e2bf21fdb87e,
    faGamepad: $8063e68b12ef6db0$export$6a66b1b639455bef,
    faCircleDot: $8063e68b12ef6db0$export$aa13d9234890e8d3,
    faDotCircle: $8063e68b12ef6db0$export$92bc269cb244d66a,
    faFaceDizzy: $8063e68b12ef6db0$export$635e4d8cc8428961,
    faDizzy: $8063e68b12ef6db0$export$89a2b10dabc487e8,
    faEgg: $8063e68b12ef6db0$export$1199a8ce85311ab5,
    faHouseMedicalCircleXmark: $8063e68b12ef6db0$export$bf221f0e8296233e,
    faCampground: $8063e68b12ef6db0$export$295287303c0e9c7c,
    faFolderPlus: $8063e68b12ef6db0$export$e18e05ffa2045d3b,
    faFutbol: $8063e68b12ef6db0$export$65a345b33858a655,
    faFutbolBall: $8063e68b12ef6db0$export$51a344ca0a215620,
    faSoccerBall: $8063e68b12ef6db0$export$f4a29712c724ba2d,
    faPaintbrush: $8063e68b12ef6db0$export$7c8b56f3f296a814,
    faPaintBrush: $8063e68b12ef6db0$export$594db3339e212bc9,
    faLock: $8063e68b12ef6db0$export$7aa08ad5d562578a,
    faGasPump: $8063e68b12ef6db0$export$84666c793cb2a347,
    faHotTubPerson: $8063e68b12ef6db0$export$6e6bd68568c17bbf,
    faHotTub: $8063e68b12ef6db0$export$4842af92b516c40b,
    faMapLocation: $8063e68b12ef6db0$export$9a8788ec0e4a9a0b,
    faMapMarked: $8063e68b12ef6db0$export$df04458e7e32352c,
    faHouseFloodWater: $8063e68b12ef6db0$export$70fd6006b4e54a5,
    faTree: $8063e68b12ef6db0$export$1744430f718caf6b,
    faBridgeLock: $8063e68b12ef6db0$export$cffe7d85a82d8116,
    faSackDollar: $8063e68b12ef6db0$export$15854c4475080853,
    faPenToSquare: $8063e68b12ef6db0$export$ba236543926e3569,
    faEdit: $8063e68b12ef6db0$export$7be713e57d023733,
    faCarSide: $8063e68b12ef6db0$export$6f7218565b1b8d0e,
    faShareNodes: $8063e68b12ef6db0$export$cdaf45d4e50ac035,
    faShareAlt: $8063e68b12ef6db0$export$f8e8bb0b3aa8c658,
    faHeartCircleMinus: $8063e68b12ef6db0$export$24c21c3ca00f3625,
    faHourglassHalf: $8063e68b12ef6db0$export$703272eebf5e3eea,
    faHourglass2: $8063e68b12ef6db0$export$f1052bbf6bf361c0,
    faMicroscope: $8063e68b12ef6db0$export$6a99139787bf9967,
    faSink: $8063e68b12ef6db0$export$2a9dda2096ce792e,
    faBagShopping: $8063e68b12ef6db0$export$b0137b4600e9ab12,
    faShoppingBag: $8063e68b12ef6db0$export$5745f8adbc11eb01,
    faArrowDownZA: $8063e68b12ef6db0$export$cf79d63ad07d943a,
    faSortAlphaDesc: $8063e68b12ef6db0$export$7caf99612a55d427,
    faSortAlphaDownAlt: $8063e68b12ef6db0$export$e12d23d82d5c8a89,
    faMitten: $8063e68b12ef6db0$export$5030322c5fc886d7,
    faPersonRays: $8063e68b12ef6db0$export$49577f913f0fe4d2,
    faUsers: $8063e68b12ef6db0$export$e5a8f011aef571ac,
    faEyeSlash: $8063e68b12ef6db0$export$ed3f2918429d029a,
    faFlaskVial: $8063e68b12ef6db0$export$a25a266ce0c95019,
    faHand: $8063e68b12ef6db0$export$f69db0b876f7d753,
    faHandPaper: $8063e68b12ef6db0$export$6e6216c8b50471bb,
    faOm: $8063e68b12ef6db0$export$8de8eb94230028a5,
    faWorm: $8063e68b12ef6db0$export$2571e33fa6c25993,
    faHouseCircleXmark: $8063e68b12ef6db0$export$423555e8708eb4c7,
    faPlug: $8063e68b12ef6db0$export$cae5752c3e3b6545,
    faChevronUp: $8063e68b12ef6db0$export$877e5ae47a854215,
    faHandSpock: $8063e68b12ef6db0$export$2262d6b626de1120,
    faStopwatch: $8063e68b12ef6db0$export$b85a7300fc7960b6,
    faFaceKiss: $8063e68b12ef6db0$export$5a54c83033a0a56a,
    faKiss: $8063e68b12ef6db0$export$c762a77aabf64fd0,
    faBridgeCircleXmark: $8063e68b12ef6db0$export$834071278537f121,
    faFaceGrinTongue: $8063e68b12ef6db0$export$95a7394c24f57943,
    faGrinTongue: $8063e68b12ef6db0$export$ef222816a43a4b3a,
    faChessBishop: $8063e68b12ef6db0$export$a831eedd2f59c62f,
    faFaceGrinWink: $8063e68b12ef6db0$export$1dd161850c5bc64e,
    faGrinWink: $8063e68b12ef6db0$export$2397fcd34eb12177,
    faEarDeaf: $8063e68b12ef6db0$export$c9c5b76ec992eab4,
    faDeaf: $8063e68b12ef6db0$export$4b666adf83f0de01,
    faDeafness: $8063e68b12ef6db0$export$85c6a9ab2fa2631e,
    faHardOfHearing: $8063e68b12ef6db0$export$ebecf90a5676e17a,
    faRoadCircleCheck: $8063e68b12ef6db0$export$3f22db9ae9b6be1c,
    faDiceFive: $8063e68b12ef6db0$export$d9769fb795c2db82,
    faSquareRss: $8063e68b12ef6db0$export$97d1903b1e012ff7,
    faRssSquare: $8063e68b12ef6db0$export$89c9b1cca2c11484,
    faLandMineOn: $8063e68b12ef6db0$export$567a897fc092e403,
    faICursor: $8063e68b12ef6db0$export$7fddf76ec23943d8,
    faStamp: $8063e68b12ef6db0$export$722e92d2d93ffc68,
    faStairs: $8063e68b12ef6db0$export$68b3af7444c89df7,
    faI: $8063e68b12ef6db0$export$aee03ca0815b7c38,
    faHryvniaSign: $8063e68b12ef6db0$export$22a9491150c64fef,
    faHryvnia: $8063e68b12ef6db0$export$33d5f94bd6f75f59,
    faPills: $8063e68b12ef6db0$export$6380e2ed6e69d350,
    faFaceGrinWide: $8063e68b12ef6db0$export$bdbabf493c478cde,
    faGrinAlt: $8063e68b12ef6db0$export$b4abebfe416d36ba,
    faTooth: $8063e68b12ef6db0$export$3a1fa2d16f90d635,
    faV: $8063e68b12ef6db0$export$6fb446f784f6b9b3,
    faBicycle: $8063e68b12ef6db0$export$36cb1885ad7a570f,
    faStaffSnake: $8063e68b12ef6db0$export$76d998742bc186eb,
    faRodAsclepius: $8063e68b12ef6db0$export$f2c3e92ee37a8d89,
    faRodSnake: $8063e68b12ef6db0$export$5d61dcb598296af0,
    faStaffAesculapius: $8063e68b12ef6db0$export$97c8a2cdba3b7700,
    faHeadSideCoughSlash: $8063e68b12ef6db0$export$b293ee8fb8e6b0c4,
    faTruckMedical: $8063e68b12ef6db0$export$fb6bd43f079f72e2,
    faAmbulance: $8063e68b12ef6db0$export$f5c7042778b51765,
    faWheatAwnCircleExclamation: $8063e68b12ef6db0$export$e23367e54f665590,
    faSnowman: $8063e68b12ef6db0$export$b23df6bafb174693,
    faMortarPestle: $8063e68b12ef6db0$export$55ceb5d0c144580a,
    faRoadBarrier: $8063e68b12ef6db0$export$f3e925217e396f44,
    faSchool: $8063e68b12ef6db0$export$51e9b8434982947d,
    faIgloo: $8063e68b12ef6db0$export$4a284575edd6f1af,
    faJoint: $8063e68b12ef6db0$export$e5a289fb22ffb8cb,
    faAngleRight: $8063e68b12ef6db0$export$6bce1afb61f2eb66,
    faHorse: $8063e68b12ef6db0$export$5b05f097fa38352a,
    faQ: $8063e68b12ef6db0$export$5a2b164552deda9f,
    faG: $8063e68b12ef6db0$export$9f5c2b0db8eedeac,
    faNotesMedical: $8063e68b12ef6db0$export$b2d79133c81d6697,
    faTemperatureHalf: $8063e68b12ef6db0$export$a3f1d7f13c202adc,
    faTemperature2: $8063e68b12ef6db0$export$8176e649df45b32c,
    faThermometer2: $8063e68b12ef6db0$export$4dd764ac8d512682,
    faThermometerHalf: $8063e68b12ef6db0$export$2090f040324b4449,
    faDongSign: $8063e68b12ef6db0$export$18659308f17918a5,
    faCapsules: $8063e68b12ef6db0$export$ba6fd4a436804a48,
    faPooStorm: $8063e68b12ef6db0$export$48a38da471b097a2,
    faPooBolt: $8063e68b12ef6db0$export$9a24e77f74d9cbd9,
    faFaceFrownOpen: $8063e68b12ef6db0$export$c8a28356e07b9ccb,
    faFrownOpen: $8063e68b12ef6db0$export$c4775e66bed5d96,
    faHandPointUp: $8063e68b12ef6db0$export$cdc9f5e7e94e76da,
    faMoneyBill: $8063e68b12ef6db0$export$608138a7337b5d1a,
    faBookmark: $8063e68b12ef6db0$export$4ed9da5c3cca0ef1,
    faAlignJustify: $8063e68b12ef6db0$export$97c42b56d462df72,
    faUmbrellaBeach: $8063e68b12ef6db0$export$20932e4d438e4e4c,
    faHelmetUn: $8063e68b12ef6db0$export$5e975cb293c48461,
    faBullseye: $8063e68b12ef6db0$export$554720e3bf74fe90,
    faBacon: $8063e68b12ef6db0$export$ab07061fe21a3a8e,
    faHandPointDown: $8063e68b12ef6db0$export$f6dcbf0a940428f4,
    faArrowUpFromBracket: $8063e68b12ef6db0$export$c2af1be14cd87640,
    faFolder: $8063e68b12ef6db0$export$72b780186370e953,
    faFolderBlank: $8063e68b12ef6db0$export$9ef114244d26da0,
    faFileWaveform: $8063e68b12ef6db0$export$5e0c19cf315ac1bf,
    faFileMedicalAlt: $8063e68b12ef6db0$export$ef02a0f5b39aa61f,
    faRadiation: $8063e68b12ef6db0$export$4c4e509518093d6d,
    faChartSimple: $8063e68b12ef6db0$export$8760a1de19ea40b9,
    faMarsStroke: $8063e68b12ef6db0$export$aa05fce255a5d269,
    faVial: $8063e68b12ef6db0$export$aa014b06d2d70598,
    faGauge: $8063e68b12ef6db0$export$dbfb0a9f89ad94a4,
    faDashboard: $8063e68b12ef6db0$export$b7ce24136743d0f1,
    faGaugeMed: $8063e68b12ef6db0$export$f948a9dd257979f3,
    faTachometerAltAverage: $8063e68b12ef6db0$export$6f22c345e5a92d1a,
    faWandMagicSparkles: $8063e68b12ef6db0$export$5325fc72e75360b4,
    faMagicWandSparkles: $8063e68b12ef6db0$export$c93286938249f0da,
    faE: $8063e68b12ef6db0$export$86923e6fe1b42f5e,
    faPenClip: $8063e68b12ef6db0$export$eff4bdcafd3b8d1c,
    faPenAlt: $8063e68b12ef6db0$export$a3d3e92e430d3beb,
    faBridgeCircleExclamation: $8063e68b12ef6db0$export$4f25939fdf728c27,
    faUser: $8063e68b12ef6db0$export$f5699fa0844e0188,
    faSchoolCircleCheck: $8063e68b12ef6db0$export$c8c95c2f9937bf6a,
    faDumpster: $8063e68b12ef6db0$export$3b934e22d1851a3b,
    faVanShuttle: $8063e68b12ef6db0$export$ecbd233b96906ee1,
    faShuttleVan: $8063e68b12ef6db0$export$9d63d851db698c09,
    faBuildingUser: $8063e68b12ef6db0$export$d65aef1ed7db1dae,
    faSquareCaretLeft: $8063e68b12ef6db0$export$2c5163541229363,
    faCaretSquareLeft: $8063e68b12ef6db0$export$d0c8ba444f1f9581,
    faHighlighter: $8063e68b12ef6db0$export$73801ed54b42fabe,
    faKey: $8063e68b12ef6db0$export$fa6ecc35e7315db,
    faBullhorn: $8063e68b12ef6db0$export$dacae2b4ec565333,
    faGlobe: $8063e68b12ef6db0$export$b1b1cdce4a19c682,
    faSynagogue: $8063e68b12ef6db0$export$20d991385719b5b4,
    faPersonHalfDress: $8063e68b12ef6db0$export$f3d75c19191f1688,
    faRoadBridge: $8063e68b12ef6db0$export$4d6835e7175dec24,
    faLocationArrow: $8063e68b12ef6db0$export$4ac9c4c370f7b157,
    faC: $8063e68b12ef6db0$export$a2c1c457834fc6d8,
    faTabletButton: $8063e68b12ef6db0$export$2d33c367b2b091ac,
    faBuildingLock: $8063e68b12ef6db0$export$6f08294ba8a2459c,
    faPizzaSlice: $8063e68b12ef6db0$export$c9f93c4667edc585,
    faMoneyBillWave: $8063e68b12ef6db0$export$53e23123cc9a6796,
    faChartArea: $8063e68b12ef6db0$export$2acab8312b7a999b,
    faAreaChart: $8063e68b12ef6db0$export$fc2e595f0e0612cb,
    faHouseFlag: $8063e68b12ef6db0$export$9a3d31c75a465b9a,
    faPersonCircleMinus: $8063e68b12ef6db0$export$d7ccc6651f90f7cc,
    faBan: $8063e68b12ef6db0$export$76f704d256def3c7,
    faCancel: $8063e68b12ef6db0$export$6d25ef56192f6d69,
    faCameraRotate: $8063e68b12ef6db0$export$e0ce7d1aba7105e7,
    faSprayCanSparkles: $8063e68b12ef6db0$export$43832c90c10a7a31,
    faAirFreshener: $8063e68b12ef6db0$export$a5e63e89b5ccee83,
    faStar: $8063e68b12ef6db0$export$a3b0eb2cd7942125,
    faRepeat: $8063e68b12ef6db0$export$cb8434288c91ae83,
    faCross: $8063e68b12ef6db0$export$9d0a89fcd084abb,
    faBox: $8063e68b12ef6db0$export$6e7cf270cda52323,
    faVenusMars: $8063e68b12ef6db0$export$63f2d9e5f4689aa8,
    faArrowPointer: $8063e68b12ef6db0$export$e4f903bc63db445,
    faMousePointer: $8063e68b12ef6db0$export$2e19a69cc26b147,
    faMaximize: $8063e68b12ef6db0$export$8d2b1b230601e804,
    faExpandArrowsAlt: $8063e68b12ef6db0$export$6219dcd88b5fa6c2,
    faChargingStation: $8063e68b12ef6db0$export$bab2cd86f8c65657,
    faShapes: $8063e68b12ef6db0$export$b17d50542d1fc340,
    faTriangleCircleSquare: $8063e68b12ef6db0$export$34261e5aea24fc1d,
    faShuffle: $8063e68b12ef6db0$export$ee94b652453ad208,
    faRandom: $8063e68b12ef6db0$export$8357bf8cc666d5f0,
    faPersonRunning: $8063e68b12ef6db0$export$f48814ae62850c74,
    faRunning: $8063e68b12ef6db0$export$5dfd1cb43dc9eadb,
    faMobileRetro: $8063e68b12ef6db0$export$7955f08360418647,
    faGripLinesVertical: $8063e68b12ef6db0$export$523960de087f5198,
    faSpider: $8063e68b12ef6db0$export$6daa96b1986e2ef0,
    faHandsBound: $8063e68b12ef6db0$export$740142a89118fbc0,
    faFileInvoiceDollar: $8063e68b12ef6db0$export$a3dced32d48cb1ea,
    faPlaneCircleExclamation: $8063e68b12ef6db0$export$f201ba865ea1b8dc,
    faXRay: $8063e68b12ef6db0$export$8cf137aceaaf4de0,
    faSpellCheck: $8063e68b12ef6db0$export$761e747b06ed2e1f,
    faSlash: $8063e68b12ef6db0$export$f54d004dd5f1cb5e,
    faComputerMouse: $8063e68b12ef6db0$export$72cf138e5ddda6eb,
    faMouse: $8063e68b12ef6db0$export$198b96b894c66074,
    faArrowRightToBracket: $8063e68b12ef6db0$export$a02c5909359525be,
    faSignIn: $8063e68b12ef6db0$export$a55eff0ca4f9c3df,
    faShopSlash: $8063e68b12ef6db0$export$b3d636689da4a3e5,
    faStoreAltSlash: $8063e68b12ef6db0$export$b932a586f6ff48b4,
    faServer: $8063e68b12ef6db0$export$1bf820d499b6202e,
    faVirusCovidSlash: $8063e68b12ef6db0$export$61c2a6b698f55df6,
    faShopLock: $8063e68b12ef6db0$export$452410c103c2403b,
    faHourglassStart: $8063e68b12ef6db0$export$f0c28584caa8f4b,
    faHourglass1: $8063e68b12ef6db0$export$87929336ab5c59cd,
    faBlenderPhone: $8063e68b12ef6db0$export$f35a116a762ef8fc,
    faBuildingWheat: $8063e68b12ef6db0$export$6c0cfe6d58faf860,
    faPersonBreastfeeding: $8063e68b12ef6db0$export$9b94ed8d16d281f9,
    faRightToBracket: $8063e68b12ef6db0$export$a5fd2acfcb5247c6,
    faSignInAlt: $8063e68b12ef6db0$export$e6709746115bd2ea,
    faVenus: $8063e68b12ef6db0$export$f89d028573ffc0a6,
    faPassport: $8063e68b12ef6db0$export$2c31ca0d9bee400f,
    faHeartPulse: $8063e68b12ef6db0$export$a6d8e50dcd4b4294,
    faHeartbeat: $8063e68b12ef6db0$export$ca880e19206e80aa,
    faPeopleCarryBox: $8063e68b12ef6db0$export$7754cc6d5559ff38,
    faPeopleCarry: $8063e68b12ef6db0$export$35fbd4ff1265acd5,
    faTemperatureHigh: $8063e68b12ef6db0$export$15d012277c3ecf9a,
    faMicrochip: $8063e68b12ef6db0$export$4a7bb4be15f35178,
    faCrown: $8063e68b12ef6db0$export$dc1083dcd1d7b9d6,
    faWeightHanging: $8063e68b12ef6db0$export$43d1fa6671908715,
    faXmarksLines: $8063e68b12ef6db0$export$f4595f012786d346,
    faFilePrescription: $8063e68b12ef6db0$export$a20cb90865b6beb8,
    faWeightScale: $8063e68b12ef6db0$export$e521c542d18b85c3,
    faWeight: $8063e68b12ef6db0$export$cf3bafa68a60bae4,
    faUserGroup: $8063e68b12ef6db0$export$3d626cfc365a7e36,
    faUserFriends: $8063e68b12ef6db0$export$46073bec205635d9,
    faArrowUpAZ: $8063e68b12ef6db0$export$fb00fdd8857804c7,
    faSortAlphaUp: $8063e68b12ef6db0$export$3c4115b156be730d,
    faChessKnight: $8063e68b12ef6db0$export$861b1f13085cf122,
    faFaceLaughSquint: $8063e68b12ef6db0$export$67ca89c1ca38d559,
    faLaughSquint: $8063e68b12ef6db0$export$b206e700cf7084e1,
    faWheelchair: $8063e68b12ef6db0$export$76a9413fbe130a53,
    faCircleArrowUp: $8063e68b12ef6db0$export$a29c8ea43e92771d,
    faArrowCircleUp: $8063e68b12ef6db0$export$a2f6f3baa50af0b1,
    faToggleOn: $8063e68b12ef6db0$export$5cffc34afa81e517,
    faPersonWalking: $8063e68b12ef6db0$export$6af1cc5998ca52bc,
    faWalking: $8063e68b12ef6db0$export$4886811b7174ec35,
    faL: $8063e68b12ef6db0$export$be32b10ce70a09df,
    faFire: $8063e68b12ef6db0$export$7b24b34ef6cc130c,
    faBedPulse: $8063e68b12ef6db0$export$580ae0d0bbd809fb,
    faProcedures: $8063e68b12ef6db0$export$5f9e1870e1866dde,
    faShuttleSpace: $8063e68b12ef6db0$export$76d92e7f30d064c5,
    faSpaceShuttle: $8063e68b12ef6db0$export$4d1c12ba2b4ca565,
    faFaceLaugh: $8063e68b12ef6db0$export$2f203616c892d415,
    faLaugh: $8063e68b12ef6db0$export$6c74e314e801a4fe,
    faFolderOpen: $8063e68b12ef6db0$export$ff7e93418af88b78,
    faHeartCirclePlus: $8063e68b12ef6db0$export$2a155a6e20f64134,
    faCodeFork: $8063e68b12ef6db0$export$f54081bdbf6d4eb5,
    faCity: $8063e68b12ef6db0$export$a9947c2888b3c8fd,
    faMicrophoneLines: $8063e68b12ef6db0$export$417391ae30b5922e,
    faMicrophoneAlt: $8063e68b12ef6db0$export$f08ef94fea14f5ac,
    faPepperHot: $8063e68b12ef6db0$export$4894bf28f771e1f3,
    faUnlock: $8063e68b12ef6db0$export$db1382cd406cc506,
    faColonSign: $8063e68b12ef6db0$export$dec10d4c2c113312,
    faHeadset: $8063e68b12ef6db0$export$23b086400a31acfe,
    faStoreSlash: $8063e68b12ef6db0$export$4ab2f33219630bad,
    faRoadCircleXmark: $8063e68b12ef6db0$export$2ffc88a4d31e8ffc,
    faUserMinus: $8063e68b12ef6db0$export$d6e17c0df8ed1bf7,
    faMarsStrokeUp: $8063e68b12ef6db0$export$efc6d53e0dedceee,
    faMarsStrokeV: $8063e68b12ef6db0$export$ed7aa1c25104f333,
    faChampagneGlasses: $8063e68b12ef6db0$export$7df1926e9eef8cc3,
    faGlassCheers: $8063e68b12ef6db0$export$20007d7d74cb98fe,
    faClipboard: $8063e68b12ef6db0$export$97d84347d71ba297,
    faHouseCircleExclamation: $8063e68b12ef6db0$export$8403e4b31e8aa805,
    faFileArrowUp: $8063e68b12ef6db0$export$929df388c07f293d,
    faFileUpload: $8063e68b12ef6db0$export$dd55ded1264643d2,
    faWifi: $8063e68b12ef6db0$export$1642419fe3db2857,
    faWifi3: $8063e68b12ef6db0$export$2349bb04a04f4b2d,
    faWifiStrong: $8063e68b12ef6db0$export$4b3167c852f4c4aa,
    faBath: $8063e68b12ef6db0$export$1ea66a88b8f620c9,
    faBathtub: $8063e68b12ef6db0$export$40ae013b5e6269d8,
    faUnderline: $8063e68b12ef6db0$export$22346afd6a3cddf8,
    faUserPen: $8063e68b12ef6db0$export$3842882ea09b25af,
    faUserEdit: $8063e68b12ef6db0$export$a68a6960fc8eef82,
    faSignature: $8063e68b12ef6db0$export$afa7b53ac8ebcb5d,
    faStroopwafel: $8063e68b12ef6db0$export$195780ddabd8e0c6,
    faBold: $8063e68b12ef6db0$export$7e0c7fd2a2e88823,
    faAnchorLock: $8063e68b12ef6db0$export$217195c80db39097,
    faBuildingNgo: $8063e68b12ef6db0$export$374e1dce366a2175,
    faManatSign: $8063e68b12ef6db0$export$1ff755b523ab2851,
    faNotEqual: $8063e68b12ef6db0$export$6a15ccae09bbaf93,
    faBorderTopLeft: $8063e68b12ef6db0$export$cf897c3e0abd59e4,
    faBorderStyle: $8063e68b12ef6db0$export$c2867ca78120d644,
    faMapLocationDot: $8063e68b12ef6db0$export$757f50b8af780c19,
    faMapMarkedAlt: $8063e68b12ef6db0$export$a977d47c74d8e86c,
    faJedi: $8063e68b12ef6db0$export$859f204e59641ca4,
    faSquarePollVertical: $8063e68b12ef6db0$export$91d747e5aabe6fe8,
    faPoll: $8063e68b12ef6db0$export$bc8ca14ab51f93db,
    faMugHot: $8063e68b12ef6db0$export$47a822c30184e8af,
    faCarBattery: $8063e68b12ef6db0$export$a44d0c11093d9c1e,
    faBatteryCar: $8063e68b12ef6db0$export$9133165ca669dd4b,
    faGift: $8063e68b12ef6db0$export$b2727de8ccdbb5ec,
    faDiceTwo: $8063e68b12ef6db0$export$4d85df590065572f,
    faChessQueen: $8063e68b12ef6db0$export$7b8ce73615739d30,
    faGlasses: $8063e68b12ef6db0$export$58d7d709c0a8ca5f,
    faChessBoard: $8063e68b12ef6db0$export$bd301515df6246af,
    faBuildingCircleCheck: $8063e68b12ef6db0$export$5559de5f969b9590,
    faPersonChalkboard: $8063e68b12ef6db0$export$c9dc1583b207b7ff,
    faMarsStrokeRight: $8063e68b12ef6db0$export$321e84e6a900c2d6,
    faMarsStrokeH: $8063e68b12ef6db0$export$5cb0daeafbcdabe3,
    faHandBackFist: $8063e68b12ef6db0$export$be38a892fe9b4098,
    faHandRock: $8063e68b12ef6db0$export$97a81eba394c8c44,
    faSquareCaretUp: $8063e68b12ef6db0$export$66068918abb14406,
    faCaretSquareUp: $8063e68b12ef6db0$export$307ae80b26533ce5,
    faCloudShowersWater: $8063e68b12ef6db0$export$b416056e795d2eac,
    faChartBar: $8063e68b12ef6db0$export$b532f5d25de97633,
    faBarChart: $8063e68b12ef6db0$export$2d5f754a5e5738b,
    faHandsBubbles: $8063e68b12ef6db0$export$2f78563e14e49916,
    faHandsWash: $8063e68b12ef6db0$export$996b5dea53b124e3,
    faLessThanEqual: $8063e68b12ef6db0$export$b2c723344cff0d8,
    faTrain: $8063e68b12ef6db0$export$17cde74bf6f1ee89,
    faEyeLowVision: $8063e68b12ef6db0$export$23a892b1a4b994bd,
    faLowVision: $8063e68b12ef6db0$export$7a65d2aa54cb4e93,
    faCrow: $8063e68b12ef6db0$export$bfa312207b788ed9,
    faSailboat: $8063e68b12ef6db0$export$e363e74e36cce80c,
    faWindowRestore: $8063e68b12ef6db0$export$eccfff9bfd585652,
    faSquarePlus: $8063e68b12ef6db0$export$eaf727acca5a35e4,
    faPlusSquare: $8063e68b12ef6db0$export$b6359eebfe900c35,
    faToriiGate: $8063e68b12ef6db0$export$75825a4c2b3375e,
    faFrog: $8063e68b12ef6db0$export$fe2358263efac504,
    faBucket: $8063e68b12ef6db0$export$2124c7628e573b84,
    faImage: $8063e68b12ef6db0$export$7e9f0928967e03b,
    faMicrophone: $8063e68b12ef6db0$export$eed3c491effe6d12,
    faCow: $8063e68b12ef6db0$export$1da3b2e53dcafa2d,
    faCaretUp: $8063e68b12ef6db0$export$7de776bdab4e536d,
    faScrewdriver: $8063e68b12ef6db0$export$7484ff654cd6474f,
    faFolderClosed: $8063e68b12ef6db0$export$5e30548b7f8eeb95,
    faHouseTsunami: $8063e68b12ef6db0$export$197b9567e88a0b1d,
    faSquareNfi: $8063e68b12ef6db0$export$5498258519fc5b72,
    faArrowUpFromGroundWater: $8063e68b12ef6db0$export$cbe485a104805f4f,
    faMartiniGlass: $8063e68b12ef6db0$export$98401bb29cff68e0,
    faGlassMartiniAlt: $8063e68b12ef6db0$export$2258439b8f4e7acb,
    faRotateLeft: $8063e68b12ef6db0$export$7adaa412bd8eb08f,
    faRotateBack: $8063e68b12ef6db0$export$9706706f1bc7b12,
    faRotateBackward: $8063e68b12ef6db0$export$4ceb0b05fed961a9,
    faUndoAlt: $8063e68b12ef6db0$export$c8197b992c46c4a6,
    faTableColumns: $8063e68b12ef6db0$export$ccaa019a3fd4563f,
    faColumns: $8063e68b12ef6db0$export$bb861166644ac28a,
    faLemon: $8063e68b12ef6db0$export$4fbda8f64648f3b5,
    faHeadSideMask: $8063e68b12ef6db0$export$280300af4baa1a3e,
    faHandshake: $8063e68b12ef6db0$export$b4c63e9bfc7906f1,
    faGem: $8063e68b12ef6db0$export$31ee86ac717db552,
    faDolly: $8063e68b12ef6db0$export$5879d0bca1aa497b,
    faDollyBox: $8063e68b12ef6db0$export$461bbb9e92cc531b,
    faSmoking: $8063e68b12ef6db0$export$c4ab83701fc591a5,
    faMinimize: $8063e68b12ef6db0$export$e0601b1f239fec74,
    faCompressArrowsAlt: $8063e68b12ef6db0$export$39205db0ea980efd,
    faMonument: $8063e68b12ef6db0$export$6f9b0bfc012deb25,
    faSnowplow: $8063e68b12ef6db0$export$695fae58f55c3a87,
    faAnglesRight: $8063e68b12ef6db0$export$48b60f1720e09944,
    faAngleDoubleRight: $8063e68b12ef6db0$export$792931403404faf0,
    faCannabis: $8063e68b12ef6db0$export$8ec2f752344b69bd,
    faCirclePlay: $8063e68b12ef6db0$export$86c4e45dc3302d15,
    faPlayCircle: $8063e68b12ef6db0$export$cf04333781061c5e,
    faTablets: $8063e68b12ef6db0$export$bed2b0ed4ae45e0d,
    faEthernet: $8063e68b12ef6db0$export$6bad2c9f317b52e5,
    faEuroSign: $8063e68b12ef6db0$export$902a3969bb113dff,
    faEur: $8063e68b12ef6db0$export$4b859160cfeb12ff,
    faEuro: $8063e68b12ef6db0$export$bdabbefede2d3a2,
    faChair: $8063e68b12ef6db0$export$a339864ee3df7e9a,
    faCircleCheck: $8063e68b12ef6db0$export$c2e9877668862374,
    faCheckCircle: $8063e68b12ef6db0$export$be9e388158c74f29,
    faCircleStop: $8063e68b12ef6db0$export$229de76dfef2687f,
    faStopCircle: $8063e68b12ef6db0$export$47af2aad60ab3e7c,
    faCompassDrafting: $8063e68b12ef6db0$export$aaaddd2cf7e20f64,
    faDraftingCompass: $8063e68b12ef6db0$export$c8c2b127d13b9d79,
    faPlateWheat: $8063e68b12ef6db0$export$2eff9f6cbe00a643,
    faIcicles: $8063e68b12ef6db0$export$78792ed87d92a3ad,
    faPersonShelter: $8063e68b12ef6db0$export$d359c2cc7640953c,
    faNeuter: $8063e68b12ef6db0$export$771cf879fba0cf93,
    faIdBadge: $8063e68b12ef6db0$export$a75288855ea05282,
    faMarker: $8063e68b12ef6db0$export$e6789173649caa25,
    faFaceLaughBeam: $8063e68b12ef6db0$export$3f2d51c0547bf984,
    faLaughBeam: $8063e68b12ef6db0$export$a88d1f4073ea9369,
    faHelicopterSymbol: $8063e68b12ef6db0$export$2a66e6044c1f7036,
    faUniversalAccess: $8063e68b12ef6db0$export$e119aada7f690d05,
    faCircleChevronUp: $8063e68b12ef6db0$export$7b69b3617b84259b,
    faChevronCircleUp: $8063e68b12ef6db0$export$b786cf5db03f2c36,
    faLariSign: $8063e68b12ef6db0$export$d317bc452442782d,
    faVolcano: $8063e68b12ef6db0$export$bae30a76735500e1,
    faPersonWalkingDashedLineArrowRight: $8063e68b12ef6db0$export$a1d09c95bee8043b,
    faSterlingSign: $8063e68b12ef6db0$export$170c56774c8e7961,
    faGbp: $8063e68b12ef6db0$export$3d9479ec1d1ae83e,
    faPoundSign: $8063e68b12ef6db0$export$9ce041dfec8319b,
    faViruses: $8063e68b12ef6db0$export$ee194b18f5c6f6b6,
    faSquarePersonConfined: $8063e68b12ef6db0$export$8aaca358568da0e0,
    faUserTie: $8063e68b12ef6db0$export$48c51dda34e9f04c,
    faArrowDownLong: $8063e68b12ef6db0$export$5977e8de7e65b20,
    faLongArrowDown: $8063e68b12ef6db0$export$52ecf90b62f3f030,
    faTentArrowDownToLine: $8063e68b12ef6db0$export$8a4f323f00a91606,
    faCertificate: $8063e68b12ef6db0$export$a881f37164b11fbf,
    faReplyAll: $8063e68b12ef6db0$export$ca6fd367f31ecbc5,
    faMailReplyAll: $8063e68b12ef6db0$export$8274334f3a2c1841,
    faSuitcase: $8063e68b12ef6db0$export$60710f3921019268,
    faPersonSkating: $8063e68b12ef6db0$export$f3854553fe688388,
    faSkating: $8063e68b12ef6db0$export$21bd1d54bd4f2c5a,
    faFilterCircleDollar: $8063e68b12ef6db0$export$3300e4b4d1d1936f,
    faFunnelDollar: $8063e68b12ef6db0$export$cebe38ad8f0a143d,
    faCameraRetro: $8063e68b12ef6db0$export$41dbdadc07a89b05,
    faCircleArrowDown: $8063e68b12ef6db0$export$a30c52cde32bec7e,
    faArrowCircleDown: $8063e68b12ef6db0$export$6cfa36bbb3a057,
    faFileImport: $8063e68b12ef6db0$export$d796c05153b1255c,
    faArrowRightToFile: $8063e68b12ef6db0$export$32f14beaf6294476,
    faSquareArrowUpRight: $8063e68b12ef6db0$export$38150b61dfd06fff,
    faExternalLinkSquare: $8063e68b12ef6db0$export$e04d83fed5ebcebf,
    faBoxOpen: $8063e68b12ef6db0$export$9010ed816a8b9c97,
    faScroll: $8063e68b12ef6db0$export$7c265716d4399676,
    faSpa: $8063e68b12ef6db0$export$f9a38ef7b046ab51,
    faLocationPinLock: $8063e68b12ef6db0$export$db853fbb474326cc,
    faPause: $8063e68b12ef6db0$export$da79f048408b1722,
    faHillAvalanche: $8063e68b12ef6db0$export$50d11c98c99e3b2d,
    faTemperatureEmpty: $8063e68b12ef6db0$export$ac389bf5cc37feb5,
    faTemperature0: $8063e68b12ef6db0$export$e99b7d2ccc282383,
    faThermometer0: $8063e68b12ef6db0$export$4c13a186ecce3b80,
    faThermometerEmpty: $8063e68b12ef6db0$export$81a2f8298cf523f9,
    faBomb: $8063e68b12ef6db0$export$d59078f6e80b4a67,
    faRegistered: $8063e68b12ef6db0$export$5f519e9ac15ab8c3,
    faAddressCard: $8063e68b12ef6db0$export$6ea408c7266ed557,
    faContactCard: $8063e68b12ef6db0$export$4ac51eb0b298b190,
    faVcard: $8063e68b12ef6db0$export$91228257deb1bf18,
    faScaleUnbalancedFlip: $8063e68b12ef6db0$export$f4d7840209109993,
    faBalanceScaleRight: $8063e68b12ef6db0$export$2238e05f8920005a,
    faSubscript: $8063e68b12ef6db0$export$34c1e678c32ed646,
    faDiamondTurnRight: $8063e68b12ef6db0$export$99749ac517cbef07,
    faDirections: $8063e68b12ef6db0$export$6a6973de44442fe5,
    faBurst: $8063e68b12ef6db0$export$ea2986b45ba5d2cf,
    faHouseLaptop: $8063e68b12ef6db0$export$6486d62e77b910,
    faLaptopHouse: $8063e68b12ef6db0$export$efd983de5e4d6ad3,
    faFaceTired: $8063e68b12ef6db0$export$5352cbdc070ce8d,
    faTired: $8063e68b12ef6db0$export$3d016d62cda18371,
    faMoneyBills: $8063e68b12ef6db0$export$a822dad6e586ee9e,
    faSmog: $8063e68b12ef6db0$export$aa11b8edb09fed14,
    faCrutch: $8063e68b12ef6db0$export$e94134641c0e2,
    faFontAwesome: $8063e68b12ef6db0$export$aa4baaed1c60f58d,
    faFontAwesomeFlag: $8063e68b12ef6db0$export$102c25fde54d4843,
    faFontAwesomeLogoFull: $8063e68b12ef6db0$export$6e20d421a2e0f320,
    faCloudArrowUp: $8063e68b12ef6db0$export$3507214fff1cc655,
    faCloudUpload: $8063e68b12ef6db0$export$a48720e6366f5d9a,
    faCloudUploadAlt: $8063e68b12ef6db0$export$e73b3e819b9d14a5,
    faPalette: $8063e68b12ef6db0$export$5c390baea5db4f77,
    faArrowsTurnRight: $8063e68b12ef6db0$export$db9f783f15682c4a,
    faVest: $8063e68b12ef6db0$export$c8370e53051a657,
    faFerry: $8063e68b12ef6db0$export$fd312949b97346ae,
    faArrowsDownToPeople: $8063e68b12ef6db0$export$cfb044c7d35060bb,
    faSeedling: $8063e68b12ef6db0$export$d7b60b8dbd03cfe4,
    faSprout: $8063e68b12ef6db0$export$9f3035e3a8c62323,
    faLeftRight: $8063e68b12ef6db0$export$47d93e9001818ee7,
    faArrowsAltH: $8063e68b12ef6db0$export$7937ea574fb1389,
    faBoxesPacking: $8063e68b12ef6db0$export$e81e7f3390fe84fe,
    faCircleArrowLeft: $8063e68b12ef6db0$export$827fbb87bdbe1028,
    faArrowCircleLeft: $8063e68b12ef6db0$export$728262abb9f58d0a,
    faGroupArrowsRotate: $8063e68b12ef6db0$export$88a8383ecdd39a54,
    faBowlFood: $8063e68b12ef6db0$export$8b89ca3201039376,
    faCandyCane: $8063e68b12ef6db0$export$14d66ba7571ae0b9,
    faArrowDownWideShort: $8063e68b12ef6db0$export$4229d00802c33062,
    faSortAmountAsc: $8063e68b12ef6db0$export$ddf8b8dd5983367d,
    faSortAmountDown: $8063e68b12ef6db0$export$4b2a02d50e417b5f,
    faCloudBolt: $8063e68b12ef6db0$export$cdd116afa0309c17,
    faThunderstorm: $8063e68b12ef6db0$export$bbf9e3d433f8f6de,
    faTextSlash: $8063e68b12ef6db0$export$ec658c0f040c3e1a,
    faRemoveFormat: $8063e68b12ef6db0$export$d91179f327329532,
    faFaceSmileWink: $8063e68b12ef6db0$export$6143da800b0e6626,
    faSmileWink: $8063e68b12ef6db0$export$f5dbb37f6801ee3f,
    faFileWord: $8063e68b12ef6db0$export$f0858dff6e769cf6,
    faFilePowerpoint: $8063e68b12ef6db0$export$c341daeecdea449a,
    faArrowsLeftRight: $8063e68b12ef6db0$export$672e2f590b189583,
    faArrowsH: $8063e68b12ef6db0$export$de517642cdb40354,
    faHouseLock: $8063e68b12ef6db0$export$aa54b16c409e882f,
    faCloudArrowDown: $8063e68b12ef6db0$export$542a9676c5286e01,
    faCloudDownload: $8063e68b12ef6db0$export$b318977f29260464,
    faCloudDownloadAlt: $8063e68b12ef6db0$export$351357a14c41f824,
    faChildren: $8063e68b12ef6db0$export$f2819bf60df55912,
    faChalkboard: $8063e68b12ef6db0$export$49a36efd66df775,
    faBlackboard: $8063e68b12ef6db0$export$f497e01bf522fd9c,
    faUserLargeSlash: $8063e68b12ef6db0$export$ae7fc6b7f0534be9,
    faUserAltSlash: $8063e68b12ef6db0$export$46185fab4772ada6,
    faEnvelopeOpen: $8063e68b12ef6db0$export$c6c3bd5f7d9b8bf2,
    faHandshakeSimpleSlash: $8063e68b12ef6db0$export$e99ae494101c5e91,
    faHandshakeAltSlash: $8063e68b12ef6db0$export$ca302f956ae9f1bf,
    faMattressPillow: $8063e68b12ef6db0$export$f042d3e458efa721,
    faGuaraniSign: $8063e68b12ef6db0$export$b731a51acb74b00c,
    faArrowsRotate: $8063e68b12ef6db0$export$2fd091cb98dc8ab8,
    faRefresh: $8063e68b12ef6db0$export$fd4359e93d7b3d14,
    faSync: $8063e68b12ef6db0$export$ff87319002e3dae9,
    faFireExtinguisher: $8063e68b12ef6db0$export$d75fb6743634a0a,
    faCruzeiroSign: $8063e68b12ef6db0$export$64dd1b27affb6572,
    faGreaterThanEqual: $8063e68b12ef6db0$export$7bf8dfe2e6661a54,
    faShieldHalved: $8063e68b12ef6db0$export$36e034ccc72554a9,
    faShieldAlt: $8063e68b12ef6db0$export$d6508d18a824f291,
    faBookAtlas: $8063e68b12ef6db0$export$7fb8daedae341012,
    faAtlas: $8063e68b12ef6db0$export$380a9050e42fe5d7,
    faVirus: $8063e68b12ef6db0$export$37c67e0b3dc6bd1b,
    faEnvelopeCircleCheck: $8063e68b12ef6db0$export$74d890536dbd21b7,
    faLayerGroup: $8063e68b12ef6db0$export$a137712e11e257dd,
    faArrowsToDot: $8063e68b12ef6db0$export$ab3a06d4b53c0fc0,
    faArchway: $8063e68b12ef6db0$export$d56753dd2eb5c323,
    faHeartCircleCheck: $8063e68b12ef6db0$export$5e4b6785eedecc1a,
    faHouseChimneyCrack: $8063e68b12ef6db0$export$e824540f5a6a8a57,
    faHouseDamage: $8063e68b12ef6db0$export$8d7e943005ce0b49,
    faFileZipper: $8063e68b12ef6db0$export$7a4a0e4caa1e4e6f,
    faFileArchive: $8063e68b12ef6db0$export$bf2047a9946b5c3f,
    faSquare: $8063e68b12ef6db0$export$90b4406457aae8cc,
    faMartiniGlassEmpty: $8063e68b12ef6db0$export$a8a0de30198815a3,
    faGlassMartini: $8063e68b12ef6db0$export$e96f280e39af4a91,
    faCouch: $8063e68b12ef6db0$export$ce96e32767a7dd51,
    faCediSign: $8063e68b12ef6db0$export$66c557f70914132c,
    faItalic: $8063e68b12ef6db0$export$16e344bae4d495ed,
    faChurch: $8063e68b12ef6db0$export$16a3f12c6ae9650,
    faCommentsDollar: $8063e68b12ef6db0$export$d477129b070e5ac4,
    faDemocrat: $8063e68b12ef6db0$export$a1672d808fbed0bd,
    faZ: $8063e68b12ef6db0$export$3481c1aa28972f9b,
    faPersonSkiing: $8063e68b12ef6db0$export$5ebd3cd0630e3ae7,
    faSkiing: $8063e68b12ef6db0$export$eae1acab6fb96708,
    faRoadLock: $8063e68b12ef6db0$export$b81a894d5bc3eb17,
    faA: $8063e68b12ef6db0$export$406fe05808a3753e,
    faTemperatureArrowDown: $8063e68b12ef6db0$export$4520eb1840c4e110,
    faTemperatureDown: $8063e68b12ef6db0$export$f0b2aca3866f00f6,
    faFeatherPointed: $8063e68b12ef6db0$export$2a9d3e120019c92d,
    faFeatherAlt: $8063e68b12ef6db0$export$68cf766c786bcd78,
    faP: $8063e68b12ef6db0$export$bcb419f1cd5beac3,
    faSnowflake: $8063e68b12ef6db0$export$bab8f3647c394f48,
    faNewspaper: $8063e68b12ef6db0$export$d91b374112d4f8c1,
    faRectangleAd: $8063e68b12ef6db0$export$d0ccaddca9e06d1e,
    faAd: $8063e68b12ef6db0$export$7af266c3465b1ff2,
    faCircleArrowRight: $8063e68b12ef6db0$export$2f1e22e081a1ad05,
    faArrowCircleRight: $8063e68b12ef6db0$export$7d3d828103aa3be7,
    faFilterCircleXmark: $8063e68b12ef6db0$export$fb5ab619c34ea613,
    faLocust: $8063e68b12ef6db0$export$4982360d3b844c19,
    faSort: $8063e68b12ef6db0$export$4941c5969d5399b,
    faUnsorted: $8063e68b12ef6db0$export$418597748f0fe52d,
    faListOl: $8063e68b12ef6db0$export$3db8f67cd0fc963b,
    faList12: $8063e68b12ef6db0$export$7e3d894cd55296b,
    faListNumeric: $8063e68b12ef6db0$export$cf51408faadac277,
    faPersonDressBurst: $8063e68b12ef6db0$export$523180e731928397,
    faMoneyCheckDollar: $8063e68b12ef6db0$export$eeb59dd1825c6a65,
    faMoneyCheckAlt: $8063e68b12ef6db0$export$8c6ccc9745897cb2,
    faVectorSquare: $8063e68b12ef6db0$export$567d5631a7b0599f,
    faBreadSlice: $8063e68b12ef6db0$export$d78e8b0681279167,
    faLanguage: $8063e68b12ef6db0$export$8a7bee49fdf8c954,
    faFaceKissWinkHeart: $8063e68b12ef6db0$export$611ae61f02de0aa,
    faKissWinkHeart: $8063e68b12ef6db0$export$ebba617701dfb917,
    faFilter: $8063e68b12ef6db0$export$f253a38d7142e29f,
    faQuestion: $8063e68b12ef6db0$export$d96973f90e8f6e47,
    faFileSignature: $8063e68b12ef6db0$export$d0de575ac166712b,
    faUpDownLeftRight: $8063e68b12ef6db0$export$cd7b22f4e6e3834b,
    faArrowsAlt: $8063e68b12ef6db0$export$3cdabfff52cfc73a,
    faHouseChimneyUser: $8063e68b12ef6db0$export$1ddbaebce033a0d,
    faHandHoldingHeart: $8063e68b12ef6db0$export$97e5ef3e80a0fbef,
    faPuzzlePiece: $8063e68b12ef6db0$export$7ee0dbd1e92e2859,
    faMoneyCheck: $8063e68b12ef6db0$export$be069f641c85d0b3,
    faStarHalfStroke: $8063e68b12ef6db0$export$3e4892d8bf919edd,
    faStarHalfAlt: $8063e68b12ef6db0$export$c13575f42532efb3,
    faCode: $8063e68b12ef6db0$export$eba095993e51cc97,
    faWhiskeyGlass: $8063e68b12ef6db0$export$f1304dd34ea2afbd,
    faGlassWhiskey: $8063e68b12ef6db0$export$fdec0f5f1a169419,
    faBuildingCircleExclamation: $8063e68b12ef6db0$export$c49f030b19083ebe,
    faMagnifyingGlassChart: $8063e68b12ef6db0$export$6a1e4cdbb8ca10c5,
    faArrowUpRightFromSquare: $8063e68b12ef6db0$export$5ad84e891223f2c3,
    faExternalLink: $8063e68b12ef6db0$export$f4c613289034e5ef,
    faCubesStacked: $8063e68b12ef6db0$export$b1f00c433aabac05,
    faWonSign: $8063e68b12ef6db0$export$51790ddd26e431bc,
    faKrw: $8063e68b12ef6db0$export$2f65e07a45b95b50,
    faWon: $8063e68b12ef6db0$export$5a1fd3ed9564d7fa,
    faVirusCovid: $8063e68b12ef6db0$export$1df4e031b8ee4f84,
    faAustralSign: $8063e68b12ef6db0$export$299c200ad3db97b4,
    faF: $8063e68b12ef6db0$export$a2f384a559654618,
    faLeaf: $8063e68b12ef6db0$export$7c497bae2754a087,
    faRoad: $8063e68b12ef6db0$export$f224567a4851a5e9,
    faTaxi: $8063e68b12ef6db0$export$9958afcdfece1b58,
    faCab: $8063e68b12ef6db0$export$7bf12d9380f0971b,
    faPersonCirclePlus: $8063e68b12ef6db0$export$55686b1eb7d00307,
    faChartPie: $8063e68b12ef6db0$export$1de7b9cf7d1b153b,
    faPieChart: $8063e68b12ef6db0$export$7877286cd337de81,
    faBoltLightning: $8063e68b12ef6db0$export$b16dcd08f3da1ba2,
    faSackXmark: $8063e68b12ef6db0$export$2bad98c38bea5994,
    faFileExcel: $8063e68b12ef6db0$export$77cb1a465c4fe84,
    faFileContract: $8063e68b12ef6db0$export$70fde3f3fdaa6a6a,
    faFishFins: $8063e68b12ef6db0$export$e7af4f0123222b6f,
    faBuildingFlag: $8063e68b12ef6db0$export$592422b29ab0a914,
    faFaceGrinBeam: $8063e68b12ef6db0$export$3de52eeb00462407,
    faGrinBeam: $8063e68b12ef6db0$export$734da5249381ec7e,
    faObjectUngroup: $8063e68b12ef6db0$export$887f6345573abcac,
    faPoop: $8063e68b12ef6db0$export$bb45b6b87d1adf27,
    faLocationPin: $8063e68b12ef6db0$export$c0b7617de95c0c05,
    faMapMarker: $8063e68b12ef6db0$export$10d360e4f1a554dd,
    faKaaba: $8063e68b12ef6db0$export$ab1408bfbe914cc9,
    faToiletPaper: $8063e68b12ef6db0$export$c8cc083ccc72b17,
    faHelmetSafety: $8063e68b12ef6db0$export$aacaf42fba617981,
    faHardHat: $8063e68b12ef6db0$export$7b72177558a98b6f,
    faHatHard: $8063e68b12ef6db0$export$c0e235dbf1644a2f,
    faEject: $8063e68b12ef6db0$export$8484041d5b209494,
    faCircleRight: $8063e68b12ef6db0$export$1fec48c8bdd69c1d,
    faArrowAltCircleRight: $8063e68b12ef6db0$export$88962ffdad8b856d,
    faPlaneCircleCheck: $8063e68b12ef6db0$export$9cbf8612c6cadc74,
    faFaceRollingEyes: $8063e68b12ef6db0$export$a6d72a9a068392b5,
    faMehRollingEyes: $8063e68b12ef6db0$export$fdc62a1bea767cc2,
    faObjectGroup: $8063e68b12ef6db0$export$40cdac24aa94a57a,
    faChartLine: $8063e68b12ef6db0$export$e022f62a119e1d93,
    faLineChart: $8063e68b12ef6db0$export$f729617a20de475b,
    faMaskVentilator: $8063e68b12ef6db0$export$122c8413a0dc5ff6,
    faArrowRight: $8063e68b12ef6db0$export$b4da69a0247f3620,
    faSignsPost: $8063e68b12ef6db0$export$905f45f8ffd6b8e5,
    faMapSigns: $8063e68b12ef6db0$export$743f4b1071b3333a,
    faCashRegister: $8063e68b12ef6db0$export$6357093f67788b33,
    faPersonCircleQuestion: $8063e68b12ef6db0$export$c8f8a597ffd676c0,
    faH: $8063e68b12ef6db0$export$d762b7b66d5875e1,
    faTarp: $8063e68b12ef6db0$export$2305b1a41b3f914,
    faScrewdriverWrench: $8063e68b12ef6db0$export$158a12f36bbecf9,
    faTools: $8063e68b12ef6db0$export$646e4e7a8c6172aa,
    faArrowsToEye: $8063e68b12ef6db0$export$9adae865350879af,
    faPlugCircleBolt: $8063e68b12ef6db0$export$4f3b3144ce966486,
    faHeart: $8063e68b12ef6db0$export$e4b51a47a2f8b9db,
    faMarsAndVenus: $8063e68b12ef6db0$export$808b88e8735e31e8,
    faHouseUser: $8063e68b12ef6db0$export$9a513ee921e8e885,
    faHomeUser: $8063e68b12ef6db0$export$e732fa55ae5bbdf0,
    faDumpsterFire: $8063e68b12ef6db0$export$25e9b29b3f2230b5,
    faHouseCrack: $8063e68b12ef6db0$export$baa3c215534dbf2a,
    faMartiniGlassCitrus: $8063e68b12ef6db0$export$c6e76550bdc0255d,
    faCocktail: $8063e68b12ef6db0$export$4be708f1e41d387b,
    faFaceSurprise: $8063e68b12ef6db0$export$c938968e28178994,
    faSurprise: $8063e68b12ef6db0$export$46647c72213f53ba,
    faBottleWater: $8063e68b12ef6db0$export$3ee278c67519eeeb,
    faCirclePause: $8063e68b12ef6db0$export$fbeef2513e05ad08,
    faPauseCircle: $8063e68b12ef6db0$export$d8cf08a0362da8db,
    faToiletPaperSlash: $8063e68b12ef6db0$export$7a494edbf9b65575,
    faAppleWhole: $8063e68b12ef6db0$export$12de8220d30453a3,
    faAppleAlt: $8063e68b12ef6db0$export$bcdd94f3977a0884,
    faKitchenSet: $8063e68b12ef6db0$export$64c1570509eaf40d,
    faR: $8063e68b12ef6db0$export$eb4c616de6eef46f,
    faTemperatureQuarter: $8063e68b12ef6db0$export$f9d1c19925fd7fa8,
    faTemperature1: $8063e68b12ef6db0$export$d4f1cd380bde2129,
    faThermometer1: $8063e68b12ef6db0$export$3f77fbe2dabe285b,
    faThermometerQuarter: $8063e68b12ef6db0$export$ed05754fcbec6e46,
    faCube: $8063e68b12ef6db0$export$973ae4f1e4d2ce78,
    faBitcoinSign: $8063e68b12ef6db0$export$441bfc8058328ce8,
    faShieldDog: $8063e68b12ef6db0$export$2a5c6f182c0cbcb,
    faSolarPanel: $8063e68b12ef6db0$export$b9c649c5e37017f3,
    faLockOpen: $8063e68b12ef6db0$export$84b5acad4436d02a,
    faElevator: $8063e68b12ef6db0$export$c7a833ce065e0ea4,
    faMoneyBillTransfer: $8063e68b12ef6db0$export$1b71392d9effbe,
    faMoneyBillTrendUp: $8063e68b12ef6db0$export$18ab80cba7d5044f,
    faHouseFloodWaterCircleArrowRight: $8063e68b12ef6db0$export$30d3e64480aa266b,
    faSquarePollHorizontal: $8063e68b12ef6db0$export$287bdd70ab874659,
    faPollH: $8063e68b12ef6db0$export$456a238f0144d430,
    faCircle: $8063e68b12ef6db0$export$4280b2387fbdad12,
    faBackwardFast: $8063e68b12ef6db0$export$662cbc6ed5a3c5e8,
    faFastBackward: $8063e68b12ef6db0$export$e6246a3279a379b8,
    faRecycle: $8063e68b12ef6db0$export$a65c441f12cb6bd,
    faUserAstronaut: $8063e68b12ef6db0$export$94363e983c225a04,
    faPlaneSlash: $8063e68b12ef6db0$export$cfee4df0d5df6d21,
    faTrademark: $8063e68b12ef6db0$export$9c9b2fbddd59047d,
    faBasketball: $8063e68b12ef6db0$export$44dee69e3a29b0e,
    faBasketballBall: $8063e68b12ef6db0$export$36550ab8ffcc5b28,
    faSatelliteDish: $8063e68b12ef6db0$export$219ccae0e4da3c92,
    faCircleUp: $8063e68b12ef6db0$export$72ea8a5e4e86cd69,
    faArrowAltCircleUp: $8063e68b12ef6db0$export$3747a8ef0995eadf,
    faMobileScreenButton: $8063e68b12ef6db0$export$da39ed20699ee2d7,
    faMobileAlt: $8063e68b12ef6db0$export$e9599bc6cd92234d,
    faVolumeHigh: $8063e68b12ef6db0$export$39461921e738be65,
    faVolumeUp: $8063e68b12ef6db0$export$5940d3e475d90cc4,
    faUsersRays: $8063e68b12ef6db0$export$9c0b63b698611d06,
    faWallet: $8063e68b12ef6db0$export$79204db8777905c8,
    faClipboardCheck: $8063e68b12ef6db0$export$7babcb2c90eb609a,
    faFileAudio: $8063e68b12ef6db0$export$b8d24c57c9e64933,
    faBurger: $8063e68b12ef6db0$export$128a6cab12423493,
    faHamburger: $8063e68b12ef6db0$export$bab3bb9f4f59363,
    faWrench: $8063e68b12ef6db0$export$3c6c0c8185296ac5,
    faBugs: $8063e68b12ef6db0$export$f5bfd1271b8b71d1,
    faRupeeSign: $8063e68b12ef6db0$export$8bf9e3f7f57d486a,
    faRupee: $8063e68b12ef6db0$export$9da25a46cfcb6fa4,
    faFileImage: $8063e68b12ef6db0$export$6440b286d3cbac9b,
    faCircleQuestion: $8063e68b12ef6db0$export$d7cf0978afd90002,
    faQuestionCircle: $8063e68b12ef6db0$export$5ba67d7f2265c1a5,
    faPlaneDeparture: $8063e68b12ef6db0$export$6ccbeeccfea6dc8a,
    faHandshakeSlash: $8063e68b12ef6db0$export$2cef3f81ad90fb76,
    faBookBookmark: $8063e68b12ef6db0$export$3d177ecdf7fc50ec,
    faCodeBranch: $8063e68b12ef6db0$export$aa054a78ab078db3,
    faHatCowboy: $8063e68b12ef6db0$export$37672611144b857b,
    faBridge: $8063e68b12ef6db0$export$f402c7c97f3383f0,
    faPhoneFlip: $8063e68b12ef6db0$export$d86c56ab43eb0deb,
    faPhoneAlt: $8063e68b12ef6db0$export$a07a9b305deebf32,
    faTruckFront: $8063e68b12ef6db0$export$4a5a13c01d46357c,
    faCat: $8063e68b12ef6db0$export$ab927dada03be4b3,
    faAnchorCircleExclamation: $8063e68b12ef6db0$export$61add9eca991b5ec,
    faTruckField: $8063e68b12ef6db0$export$f4419f7b2e53b340,
    faRoute: $8063e68b12ef6db0$export$806c0a45a7ecd6e8,
    faClipboardQuestion: $8063e68b12ef6db0$export$d4aa151a4554b74e,
    faPanorama: $8063e68b12ef6db0$export$5dd22dcb6e3ed369,
    faCommentMedical: $8063e68b12ef6db0$export$101422b773924276,
    faTeethOpen: $8063e68b12ef6db0$export$c88ac21fe7c88ae6,
    faFileCircleMinus: $8063e68b12ef6db0$export$4b89fabf50a10951,
    faTags: $8063e68b12ef6db0$export$d55778e3ab6c933f,
    faWineGlass: $8063e68b12ef6db0$export$e06d6607d3577d6e,
    faForwardFast: $8063e68b12ef6db0$export$dc9cc4280bee320d,
    faFastForward: $8063e68b12ef6db0$export$61a8cdc53c2e078d,
    faFaceMehBlank: $8063e68b12ef6db0$export$38c072b870a9e4ab,
    faMehBlank: $8063e68b12ef6db0$export$e945435725f71e88,
    faSquareParking: $8063e68b12ef6db0$export$f2cfa036d76f69ab,
    faParking: $8063e68b12ef6db0$export$fda29c8f99573a4e,
    faHouseSignal: $8063e68b12ef6db0$export$58845db8e7e9a199,
    faBarsProgress: $8063e68b12ef6db0$export$ee3a02da18715b2,
    faTasksAlt: $8063e68b12ef6db0$export$bbc0784fc1578f7f,
    faFaucetDrip: $8063e68b12ef6db0$export$7a255960242435f6,
    faCartFlatbed: $8063e68b12ef6db0$export$df587aaf7765e1ce,
    faDollyFlatbed: $8063e68b12ef6db0$export$f7c6efb60c53b285,
    faBanSmoking: $8063e68b12ef6db0$export$130df7ed74437774,
    faSmokingBan: $8063e68b12ef6db0$export$e50452a49dec29f,
    faTerminal: $8063e68b12ef6db0$export$5e63e8b85b5f119c,
    faMobileButton: $8063e68b12ef6db0$export$c93d62849efbdd11,
    faHouseMedicalFlag: $8063e68b12ef6db0$export$86c50f517be57a40,
    faBasketShopping: $8063e68b12ef6db0$export$1d307c13b511e8e1,
    faShoppingBasket: $8063e68b12ef6db0$export$ca6d443595a6578f,
    faTape: $8063e68b12ef6db0$export$b88ed5e1e0eac4c6,
    faBusSimple: $8063e68b12ef6db0$export$d3724faf0c559353,
    faBusAlt: $8063e68b12ef6db0$export$40616edfab6d332a,
    faEye: $8063e68b12ef6db0$export$b8c3e79e8c99c95b,
    faFaceSadCry: $8063e68b12ef6db0$export$e8ea88c55e55be7c,
    faSadCry: $8063e68b12ef6db0$export$8e924e6bd422cef9,
    faAudioDescription: $8063e68b12ef6db0$export$b6b464c98c009494,
    faPersonMilitaryToPerson: $8063e68b12ef6db0$export$41b1e14a6b0fe11b,
    faFileShield: $8063e68b12ef6db0$export$348a01df65a66c99,
    faUserSlash: $8063e68b12ef6db0$export$3924ab4d3ef9b5ef,
    faPen: $8063e68b12ef6db0$export$8f4567331fb0d3bc,
    faTowerObservation: $8063e68b12ef6db0$export$5b2f0f631f559d51,
    faFileCode: $8063e68b12ef6db0$export$143d0ca7d2200f20,
    faSignal: $8063e68b12ef6db0$export$79046b073b6c584d,
    faSignal5: $8063e68b12ef6db0$export$3417071118065933,
    faSignalPerfect: $8063e68b12ef6db0$export$1aea50ab3e99cc95,
    faBus: $8063e68b12ef6db0$export$ce69441578ff2fdb,
    faHeartCircleXmark: $8063e68b12ef6db0$export$742f89ae2f8d6b20,
    faHouseChimney: $8063e68b12ef6db0$export$af554427144a7e5c,
    faHomeLg: $8063e68b12ef6db0$export$dbab81727ec94698,
    faWindowMaximize: $8063e68b12ef6db0$export$703cd98be31ec905,
    faFaceFrown: $8063e68b12ef6db0$export$e5f78e87efbb0248,
    faFrown: $8063e68b12ef6db0$export$43b7108508aecc5f,
    faPrescription: $8063e68b12ef6db0$export$8767bafb19515ee4,
    faShop: $8063e68b12ef6db0$export$78edc9b98453b6f7,
    faStoreAlt: $8063e68b12ef6db0$export$1f1871dab9cec9d8,
    faFloppyDisk: $8063e68b12ef6db0$export$f62f2879ccaea13f,
    faSave: $8063e68b12ef6db0$export$1aaa83ff70706e1e,
    faVihara: $8063e68b12ef6db0$export$ee4b92e89fe0dfaf,
    faScaleUnbalanced: $8063e68b12ef6db0$export$4d10bcc8d068f454,
    faBalanceScaleLeft: $8063e68b12ef6db0$export$786cb0c775487f19,
    faSortUp: $8063e68b12ef6db0$export$f9dd5b1410e95035,
    faSortAsc: $8063e68b12ef6db0$export$e4c8c924b1cc43a7,
    faCommentDots: $8063e68b12ef6db0$export$63ffcb3d4e94cb92,
    faCommenting: $8063e68b12ef6db0$export$49ee382a2425e89c,
    faPlantWilt: $8063e68b12ef6db0$export$77a38850ff8b0407,
    faDiamond: $8063e68b12ef6db0$export$f214f827e0023247,
    faFaceGrinSquint: $8063e68b12ef6db0$export$5d53da7627754bc6,
    faGrinSquint: $8063e68b12ef6db0$export$243ae757907b1580,
    faHandHoldingDollar: $8063e68b12ef6db0$export$61a67f5f8ab39be,
    faHandHoldingUsd: $8063e68b12ef6db0$export$47d27bc305b59690,
    faBacterium: $8063e68b12ef6db0$export$b0babe4230e35ebe,
    faHandPointer: $8063e68b12ef6db0$export$d97ff927c450c87f,
    faDrumSteelpan: $8063e68b12ef6db0$export$48d1206500db2e9d,
    faHandScissors: $8063e68b12ef6db0$export$c578e919f2c5c135,
    faHandsPraying: $8063e68b12ef6db0$export$a96374faedb12593,
    faPrayingHands: $8063e68b12ef6db0$export$95e08e91b0929943,
    faArrowRotateRight: $8063e68b12ef6db0$export$9c58ddc4b3356f98,
    faArrowRightRotate: $8063e68b12ef6db0$export$ffa1245982c1b28b,
    faArrowRotateForward: $8063e68b12ef6db0$export$89c59b5f47067f4c,
    faRedo: $8063e68b12ef6db0$export$3d9f98aa1c24c776,
    faBiohazard: $8063e68b12ef6db0$export$ae3a453550dec95,
    faLocationCrosshairs: $8063e68b12ef6db0$export$14e1096ad1719098,
    faLocation: $8063e68b12ef6db0$export$45e012c32174eb5d,
    faMarsDouble: $8063e68b12ef6db0$export$2f8a28204bb4b86f,
    faChildDress: $8063e68b12ef6db0$export$f31a37ecbfd4e707,
    faUsersBetweenLines: $8063e68b12ef6db0$export$6ea1decf8bb3513d,
    faLungsVirus: $8063e68b12ef6db0$export$895159d10626af74,
    faFaceGrinTears: $8063e68b12ef6db0$export$8ac6d81a3d5b40a1,
    faGrinTears: $8063e68b12ef6db0$export$b2f7512221512b5b,
    faPhone: $8063e68b12ef6db0$export$ddab067855cf34cb,
    faCalendarXmark: $8063e68b12ef6db0$export$3c70ffe5660af060,
    faCalendarTimes: $8063e68b12ef6db0$export$99b20d7352fbcf08,
    faChildReaching: $8063e68b12ef6db0$export$84a2f9476730c40e,
    faHeadSideVirus: $8063e68b12ef6db0$export$5b64b916710da7c7,
    faUserGear: $8063e68b12ef6db0$export$f504a6909b677146,
    faUserCog: $8063e68b12ef6db0$export$474108c2b86e730e,
    faArrowUp19: $8063e68b12ef6db0$export$bbbff45e04f4abab,
    faSortNumericUp: $8063e68b12ef6db0$export$d213a3ba3cabed48,
    faDoorClosed: $8063e68b12ef6db0$export$2c79e1a422528bba,
    faShieldVirus: $8063e68b12ef6db0$export$bea811bbf570f05a,
    faDiceSix: $8063e68b12ef6db0$export$3397c7b4679acccc,
    faMosquitoNet: $8063e68b12ef6db0$export$f3858ce1b3218e2,
    faBridgeWater: $8063e68b12ef6db0$export$154e99cb34841765,
    faPersonBooth: $8063e68b12ef6db0$export$2337c975289bdd84,
    faTextWidth: $8063e68b12ef6db0$export$d8724cf433389700,
    faHatWizard: $8063e68b12ef6db0$export$7daa48199dcb2ad1,
    faPenFancy: $8063e68b12ef6db0$export$8bdfe14ac72a8b17,
    faPersonDigging: $8063e68b12ef6db0$export$f4d483fca19a4604,
    faDigging: $8063e68b12ef6db0$export$7bd93e3343bd5671,
    faTrash: $8063e68b12ef6db0$export$ed8c149a0ea54bb4,
    faGaugeSimple: $8063e68b12ef6db0$export$f3a0a4e6723a86d4,
    faGaugeSimpleMed: $8063e68b12ef6db0$export$ba8c12ff7cfa2521,
    faTachometerAverage: $8063e68b12ef6db0$export$94fcfd6f6335431b,
    faBookMedical: $8063e68b12ef6db0$export$6feb44fec53ba30d,
    faPoo: $8063e68b12ef6db0$export$dd0ede1713d2d2f9,
    faQuoteRight: $8063e68b12ef6db0$export$54e3a80c9875b74c,
    faQuoteRightAlt: $8063e68b12ef6db0$export$dd692f2e88bd4b1a,
    faShirt: $8063e68b12ef6db0$export$312f2c01c6fedca8,
    faTShirt: $8063e68b12ef6db0$export$144e5f8bc4d705a6,
    faTshirt: $8063e68b12ef6db0$export$36edce3ba87c2b17,
    faCubes: $8063e68b12ef6db0$export$30523a9441a31e97,
    faDivide: $8063e68b12ef6db0$export$89fa217ec5503ac9,
    faTengeSign: $8063e68b12ef6db0$export$c04e864469c1d117,
    faTenge: $8063e68b12ef6db0$export$af6ebee83047b793,
    faHeadphones: $8063e68b12ef6db0$export$ad02dd8ca5816958,
    faHandsHolding: $8063e68b12ef6db0$export$96891bbcda1dbb7b,
    faHandsClapping: $8063e68b12ef6db0$export$765c446e974b5e59,
    faRepublican: $8063e68b12ef6db0$export$929518bb4b66a588,
    faArrowLeft: $8063e68b12ef6db0$export$b7fac681e7d09400,
    faPersonCircleXmark: $8063e68b12ef6db0$export$16c9e0374c346c6e,
    faRuler: $8063e68b12ef6db0$export$8e90575265a56cfc,
    faAlignLeft: $8063e68b12ef6db0$export$e490f662af4d1c78,
    faDiceD6: $8063e68b12ef6db0$export$64bfd48ed353c031,
    faRestroom: $8063e68b12ef6db0$export$5fbcef35138741a5,
    faJ: $8063e68b12ef6db0$export$bbf24078bd1f73e6,
    faUsersViewfinder: $8063e68b12ef6db0$export$72b785dcfe44c69b,
    faFileVideo: $8063e68b12ef6db0$export$b44eb38345c6a964,
    faUpRightFromSquare: $8063e68b12ef6db0$export$c1a3ba061b4f60c4,
    faExternalLinkAlt: $8063e68b12ef6db0$export$d7f107e456ab0306,
    faTableCells: $8063e68b12ef6db0$export$c517dffc18db483f,
    faTh: $8063e68b12ef6db0$export$4d383c83efc0c819,
    faFilePdf: $8063e68b12ef6db0$export$38611f1c776aba73,
    faBookBible: $8063e68b12ef6db0$export$df8194b081d34b27,
    faBible: $8063e68b12ef6db0$export$2eac809b0670d139,
    faO: $8063e68b12ef6db0$export$9db87eabf605857e,
    faSuitcaseMedical: $8063e68b12ef6db0$export$25ea11267429d202,
    faMedkit: $8063e68b12ef6db0$export$e75f02bae5b7d34b,
    faUserSecret: $8063e68b12ef6db0$export$597826232327559b,
    faOtter: $8063e68b12ef6db0$export$743cce3ca4eb1d7d,
    faPersonDress: $8063e68b12ef6db0$export$27f7383b96c3f4b4,
    faFemale: $8063e68b12ef6db0$export$70e8e75e61dd7169,
    faCommentDollar: $8063e68b12ef6db0$export$7a088030853df12c,
    faBusinessTime: $8063e68b12ef6db0$export$694b7e88782dec12,
    faBriefcaseClock: $8063e68b12ef6db0$export$8b00ae94743552ce,
    faTableCellsLarge: $8063e68b12ef6db0$export$d2bcaf492dfb3817,
    faThLarge: $8063e68b12ef6db0$export$69782f333e90cdc6,
    faBookTanakh: $8063e68b12ef6db0$export$24c764717169f536,
    faTanakh: $8063e68b12ef6db0$export$7fd4a58929315448,
    faPhoneVolume: $8063e68b12ef6db0$export$c377f240bb8b5d74,
    faVolumeControlPhone: $8063e68b12ef6db0$export$5358d004fa3d3be2,
    faHatCowboySide: $8063e68b12ef6db0$export$ab6f71fd6878da90,
    faClipboardUser: $8063e68b12ef6db0$export$1204f2d171424659,
    faChild: $8063e68b12ef6db0$export$60b41e3581d1739a,
    faLiraSign: $8063e68b12ef6db0$export$f0f37dbc60110b10,
    faSatellite: $8063e68b12ef6db0$export$da3f1730d013e224,
    faPlaneLock: $8063e68b12ef6db0$export$1125ac57be52258c,
    faTag: $8063e68b12ef6db0$export$cb61f447f29887e,
    faComment: $8063e68b12ef6db0$export$805cd88398a70581,
    faCakeCandles: $8063e68b12ef6db0$export$e4019fe302a972e1,
    faBirthdayCake: $8063e68b12ef6db0$export$bdcf98f725a7241a,
    faCake: $8063e68b12ef6db0$export$707bc1c80c0177c1,
    faEnvelope: $8063e68b12ef6db0$export$6f095630677adc,
    faAnglesUp: $8063e68b12ef6db0$export$152ef92a4f9d80a7,
    faAngleDoubleUp: $8063e68b12ef6db0$export$9bb51e1a2c07db7c,
    faPaperclip: $8063e68b12ef6db0$export$4b24ca1552f410af,
    faArrowRightToCity: $8063e68b12ef6db0$export$e201217e5046cd15,
    faRibbon: $8063e68b12ef6db0$export$838459d11f3971df,
    faLungs: $8063e68b12ef6db0$export$ba9b387e84727819,
    faArrowUp91: $8063e68b12ef6db0$export$25218e5886296cb9,
    faSortNumericUpAlt: $8063e68b12ef6db0$export$d41859f1bbb9e086,
    faLitecoinSign: $8063e68b12ef6db0$export$4a157bd81dcd8d80,
    faBorderNone: $8063e68b12ef6db0$export$2b488402ec335d97,
    faCircleNodes: $8063e68b12ef6db0$export$de462dd5a18e80d4,
    faParachuteBox: $8063e68b12ef6db0$export$ca9e3368f1d9500a,
    faIndent: $8063e68b12ef6db0$export$318208bc30aeebcc,
    faTruckFieldUn: $8063e68b12ef6db0$export$40cb0a4a3a74dc03,
    faHourglass: $8063e68b12ef6db0$export$b9098a890f61e022,
    faHourglassEmpty: $8063e68b12ef6db0$export$a2f8176a0161e891,
    faMountain: $8063e68b12ef6db0$export$64f9eb99c9749cce,
    faUserDoctor: $8063e68b12ef6db0$export$9884bf227eeb829,
    faUserMd: $8063e68b12ef6db0$export$ab0d33a2c03f1794,
    faCircleInfo: $8063e68b12ef6db0$export$317f99f46b39906e,
    faInfoCircle: $8063e68b12ef6db0$export$aa9288aeadf882fa,
    faCloudMeatball: $8063e68b12ef6db0$export$5d120e8b87ad33f4,
    faCamera: $8063e68b12ef6db0$export$84ffbd7161ca2008,
    faCameraAlt: $8063e68b12ef6db0$export$8872b5664e88e793,
    faSquareVirus: $8063e68b12ef6db0$export$f9409a7b020dbec4,
    faMeteor: $8063e68b12ef6db0$export$1439f0d6365138da,
    faCarOn: $8063e68b12ef6db0$export$d901d50df5cf8d91,
    faSleigh: $8063e68b12ef6db0$export$26a8fd1143d2d6c0,
    faArrowDown19: $8063e68b12ef6db0$export$9a40d582bd4628fb,
    faSortNumericAsc: $8063e68b12ef6db0$export$a4fb1aa2cdfb18d7,
    faSortNumericDown: $8063e68b12ef6db0$export$835db7eb35b3c29b,
    faHandHoldingDroplet: $8063e68b12ef6db0$export$b9c3f9a906f96b82,
    faHandHoldingWater: $8063e68b12ef6db0$export$4265371b99d38b95,
    faWater: $8063e68b12ef6db0$export$efaeddad0a6e901b,
    faCalendarCheck: $8063e68b12ef6db0$export$5655108e1162ba45,
    faBraille: $8063e68b12ef6db0$export$983e9c27cac7ed1c,
    faPrescriptionBottleMedical: $8063e68b12ef6db0$export$99cfe064ff0b71c9,
    faPrescriptionBottleAlt: $8063e68b12ef6db0$export$65d1c884b8581d1a,
    faLandmark: $8063e68b12ef6db0$export$2bebc54c51db6505,
    faTruck: $8063e68b12ef6db0$export$d7895f386f8bd8b8,
    faCrosshairs: $8063e68b12ef6db0$export$721c101130c40043,
    faPersonCane: $8063e68b12ef6db0$export$c48422e9da776c1b,
    faTent: $8063e68b12ef6db0$export$e5075400db564e24,
    faVestPatches: $8063e68b12ef6db0$export$750a64470c2e0f3f,
    faCheckDouble: $8063e68b12ef6db0$export$f178c8c2ad3cc861,
    faArrowDownAZ: $8063e68b12ef6db0$export$43b642fac7053978,
    faSortAlphaAsc: $8063e68b12ef6db0$export$cb87697f2fa77cfc,
    faSortAlphaDown: $8063e68b12ef6db0$export$7658045270aafde3,
    faMoneyBillWheat: $8063e68b12ef6db0$export$6a4ef2ef77625063,
    faCookie: $8063e68b12ef6db0$export$b3e64f5f68c6623f,
    faArrowRotateLeft: $8063e68b12ef6db0$export$89b706873769c180,
    faArrowLeftRotate: $8063e68b12ef6db0$export$1aea864c3e1d79b,
    faArrowRotateBack: $8063e68b12ef6db0$export$a34701878babe5fc,
    faArrowRotateBackward: $8063e68b12ef6db0$export$fce381d12e4535cd,
    faUndo: $8063e68b12ef6db0$export$a5e5ba60b1dfe2b2,
    faHardDrive: $8063e68b12ef6db0$export$4cb736b866cbb7ec,
    faHdd: $8063e68b12ef6db0$export$62551e9c5ba7093f,
    faFaceGrinSquintTears: $8063e68b12ef6db0$export$8ff56f5ebb8416a0,
    faGrinSquintTears: $8063e68b12ef6db0$export$542206d6a85f3b42,
    faDumbbell: $8063e68b12ef6db0$export$56700074cf37be5c,
    faRectangleList: $8063e68b12ef6db0$export$1f7600fa9fdb3978,
    faListAlt: $8063e68b12ef6db0$export$c6327a203ffc65a3,
    faTarpDroplet: $8063e68b12ef6db0$export$1585b7c3c7109751,
    faHouseMedicalCircleCheck: $8063e68b12ef6db0$export$5d08d08f88a96aac,
    faPersonSkiingNordic: $8063e68b12ef6db0$export$c8cd1786449517d3,
    faSkiingNordic: $8063e68b12ef6db0$export$6ea48260d7d09b1b,
    faCalendarPlus: $8063e68b12ef6db0$export$16768a660ae3ca9d,
    faPlaneArrival: $8063e68b12ef6db0$export$9b2dbe133273f284,
    faCircleLeft: $8063e68b12ef6db0$export$5ae86b9da9cca3bd,
    faArrowAltCircleLeft: $8063e68b12ef6db0$export$5460a5b11a24996f,
    faTrainSubway: $8063e68b12ef6db0$export$cda326cc3bce41c,
    faSubway: $8063e68b12ef6db0$export$4cabc8a12d4e2f9,
    faChartGantt: $8063e68b12ef6db0$export$dce43b02b3fe0c18,
    faIndianRupeeSign: $8063e68b12ef6db0$export$1d2b135cc5a2c852,
    faIndianRupee: $8063e68b12ef6db0$export$be886a4def17c565,
    faInr: $8063e68b12ef6db0$export$12c6d8b3e052490b,
    faCropSimple: $8063e68b12ef6db0$export$c3605731beb92daf,
    faCropAlt: $8063e68b12ef6db0$export$d932915fde4f1010,
    faMoneyBill1: $8063e68b12ef6db0$export$a312c7d58dd44a75,
    faMoneyBillAlt: $8063e68b12ef6db0$export$a35d573395884c3d,
    faLeftLong: $8063e68b12ef6db0$export$1db7e2ee10d36035,
    faLongArrowAltLeft: $8063e68b12ef6db0$export$a8b3226b2bf323d,
    faDna: $8063e68b12ef6db0$export$c062100d54a2da00,
    faVirusSlash: $8063e68b12ef6db0$export$c4ff5306c5470939,
    faMinus: $8063e68b12ef6db0$export$fee0376c250cdef,
    faSubtract: $8063e68b12ef6db0$export$f8cb2531ef1fc4a2,
    faChildRifle: $8063e68b12ef6db0$export$9b027cdb5db3ae5c,
    faChess: $8063e68b12ef6db0$export$442fddbbd741c590,
    faArrowLeftLong: $8063e68b12ef6db0$export$6e5225f0e6c0bacd,
    faLongArrowLeft: $8063e68b12ef6db0$export$80896efc906118b4,
    faPlugCircleCheck: $8063e68b12ef6db0$export$2bd45e99b9afa947,
    faStreetView: $8063e68b12ef6db0$export$6aab6c3359c2554c,
    faFrancSign: $8063e68b12ef6db0$export$acef3e5c2029d285,
    faVolumeOff: $8063e68b12ef6db0$export$d94ba52e980ea0f1,
    faHandsAslInterpreting: $8063e68b12ef6db0$export$bc43eb4655c78f49,
    faAmericanSignLanguageInterpreting: $8063e68b12ef6db0$export$23a7517099ab1b86,
    faAslInterpreting: $8063e68b12ef6db0$export$beb51abfb05a4eca,
    faHandsAmericanSignLanguageInterpreting: $8063e68b12ef6db0$export$82846008645b0301,
    faGear: $8063e68b12ef6db0$export$ec05accb7226d001,
    faCog: $8063e68b12ef6db0$export$d6298bbfd1912a78,
    faDropletSlash: $8063e68b12ef6db0$export$1d6c5a49025d720b,
    faTintSlash: $8063e68b12ef6db0$export$5d6f0943039b898f,
    faMosque: $8063e68b12ef6db0$export$4999586d7e1087fb,
    faMosquito: $8063e68b12ef6db0$export$67c7a1518d0715ff,
    faStarOfDavid: $8063e68b12ef6db0$export$f823fee3712b2601,
    faPersonMilitaryRifle: $8063e68b12ef6db0$export$842b988dae95ccb8,
    faCartShopping: $8063e68b12ef6db0$export$c790b41dc166ae13,
    faShoppingCart: $8063e68b12ef6db0$export$51da406e5aa1388c,
    faVials: $8063e68b12ef6db0$export$507e8edd7676b2e9,
    faPlugCirclePlus: $8063e68b12ef6db0$export$f193138a7d21971c,
    faPlaceOfWorship: $8063e68b12ef6db0$export$c5a9302c8c13c79a,
    faGripVertical: $8063e68b12ef6db0$export$cacbd95c283996ec,
    faArrowTurnUp: $8063e68b12ef6db0$export$2d3ccb9b2099f3fe,
    faLevelUp: $8063e68b12ef6db0$export$c227d3ba1de97ceb,
    faU: $8063e68b12ef6db0$export$4f39e8dbaf09ea8b,
    faSquareRootVariable: $8063e68b12ef6db0$export$60b44cfa7af18422,
    faSquareRootAlt: $8063e68b12ef6db0$export$28e4b96627e00057,
    faClock: $8063e68b12ef6db0$export$95b9968e7fceb821,
    faClockFour: $8063e68b12ef6db0$export$9a575facf1cab48f,
    faBackwardStep: $8063e68b12ef6db0$export$5d2b6a700940df16,
    faStepBackward: $8063e68b12ef6db0$export$2884e379aed297d4,
    faPallet: $8063e68b12ef6db0$export$d7ff2047dbc34562,
    faFaucet: $8063e68b12ef6db0$export$a0856b225f3b0614,
    faBaseballBatBall: $8063e68b12ef6db0$export$59669f486ab41d86,
    faS: $8063e68b12ef6db0$export$cb39585371b75720,
    faTimeline: $8063e68b12ef6db0$export$5e239d90ef904a84,
    faKeyboard: $8063e68b12ef6db0$export$fb61df5d98785fa8,
    faCaretDown: $8063e68b12ef6db0$export$f9395ef707603e40,
    faHouseChimneyMedical: $8063e68b12ef6db0$export$9c73560282dceccd,
    faClinicMedical: $8063e68b12ef6db0$export$20d8a680febc7434,
    faTemperatureThreeQuarters: $8063e68b12ef6db0$export$7ed2bad15ae6237f,
    faTemperature3: $8063e68b12ef6db0$export$89def3268ed9b4bc,
    faThermometer3: $8063e68b12ef6db0$export$2f653125f4e6463,
    faThermometerThreeQuarters: $8063e68b12ef6db0$export$6c632d1dc30d4a77,
    faMobileScreen: $8063e68b12ef6db0$export$8867e7da34bb8bf4,
    faMobileAndroidAlt: $8063e68b12ef6db0$export$cb39d7b468ba5838,
    faPlaneUp: $8063e68b12ef6db0$export$a5f2976a01fdc970,
    faPiggyBank: $8063e68b12ef6db0$export$46d49a6734c4872a,
    faBatteryHalf: $8063e68b12ef6db0$export$e6dadc1155c4ee48,
    faBattery3: $8063e68b12ef6db0$export$f9138caac2aedaed,
    faMountainCity: $8063e68b12ef6db0$export$28f06bbf9c17c3af,
    faCoins: $8063e68b12ef6db0$export$bc5da164799a0e,
    faKhanda: $8063e68b12ef6db0$export$8d41d1f1ba3f9217,
    faSliders: $8063e68b12ef6db0$export$ea6970ed5a15feb6,
    faSlidersH: $8063e68b12ef6db0$export$94d4dcb523f95563,
    faFolderTree: $8063e68b12ef6db0$export$54d16fa2e445d3fe,
    faNetworkWired: $8063e68b12ef6db0$export$882cabd11f4943b8,
    faMapPin: $8063e68b12ef6db0$export$184725965b3402dc,
    faHamsa: $8063e68b12ef6db0$export$38d20d399463edf9,
    faCentSign: $8063e68b12ef6db0$export$875b6c94a4b00ea8,
    faFlask: $8063e68b12ef6db0$export$f9b579ba06048af,
    faPersonPregnant: $8063e68b12ef6db0$export$e7b4c26b5857fe9c,
    faWandSparkles: $8063e68b12ef6db0$export$76cc39f249b6864e,
    faEllipsisVertical: $8063e68b12ef6db0$export$7480721bf113be3e,
    faEllipsisV: $8063e68b12ef6db0$export$e58494c7fcb5380,
    faTicket: $8063e68b12ef6db0$export$3604f15924cf0b98,
    faPowerOff: $8063e68b12ef6db0$export$a1cca9928dcf9798,
    faRightLong: $8063e68b12ef6db0$export$b356b1dbe7d7f736,
    faLongArrowAltRight: $8063e68b12ef6db0$export$533e1f578f74c066,
    faFlagUsa: $8063e68b12ef6db0$export$19357abad396e723,
    faLaptopFile: $8063e68b12ef6db0$export$e1046cf83da9b7ef,
    faTty: $8063e68b12ef6db0$export$7c85aba0f9624b29,
    faTeletype: $8063e68b12ef6db0$export$14bcd5c43dc736f9,
    faDiagramNext: $8063e68b12ef6db0$export$2faddf1690e14e11,
    faPersonRifle: $8063e68b12ef6db0$export$b16df914812cedbe,
    faHouseMedicalCircleExclamation: $8063e68b12ef6db0$export$bc50edea6e121df5,
    faClosedCaptioning: $8063e68b12ef6db0$export$8e047801a8603af7,
    faPersonHiking: $8063e68b12ef6db0$export$baf9f153991b2ea,
    faHiking: $8063e68b12ef6db0$export$b2ab0105a901499e,
    faVenusDouble: $8063e68b12ef6db0$export$6a6f9cba7a1e5fe4,
    faImages: $8063e68b12ef6db0$export$74f06b41ed2ca28a,
    faCalculator: $8063e68b12ef6db0$export$693bd40950ed2c3a,
    faPeoplePulling: $8063e68b12ef6db0$export$dace56f632fecf6f,
    faN: $8063e68b12ef6db0$export$328a9baf0f9e3405,
    faCableCar: $8063e68b12ef6db0$export$85cb04eaefaf2d8b,
    faTram: $8063e68b12ef6db0$export$a7a36674c079f293,
    faCloudRain: $8063e68b12ef6db0$export$a6c308ee087b4ded,
    faBuildingCircleXmark: $8063e68b12ef6db0$export$c4c015418a1f24df,
    faShip: $8063e68b12ef6db0$export$6c645741140616af,
    faArrowsDownToLine: $8063e68b12ef6db0$export$8f2463c7b2fc6ae4,
    faDownload: $8063e68b12ef6db0$export$8f734e51d72ca13a,
    faFaceGrin: $8063e68b12ef6db0$export$92292137ef3cf4c8,
    faGrin: $8063e68b12ef6db0$export$37e1f10b6de76621,
    faDeleteLeft: $8063e68b12ef6db0$export$bbcc9e0b6022772b,
    faBackspace: $8063e68b12ef6db0$export$e43e3f67102fc526,
    faEyeDropper: $8063e68b12ef6db0$export$1bc3e0ad56dc9eb0,
    faEyeDropperEmpty: $8063e68b12ef6db0$export$ef304e9b7524c1f9,
    faEyedropper: $8063e68b12ef6db0$export$91549a375c0b6d25,
    faFileCircleCheck: $8063e68b12ef6db0$export$8547e9f3a2ddab5b,
    faForward: $8063e68b12ef6db0$export$a8710cdb23198d53,
    faMobile: $8063e68b12ef6db0$export$59edacfad04cd121,
    faMobileAndroid: $8063e68b12ef6db0$export$82f602311a698c32,
    faMobilePhone: $8063e68b12ef6db0$export$475a9be8da747e57,
    faFaceMeh: $8063e68b12ef6db0$export$dc130582748497c6,
    faMeh: $8063e68b12ef6db0$export$6d2db489aaeeecd2,
    faAlignCenter: $8063e68b12ef6db0$export$70e29dd05344623e,
    faBookSkull: $8063e68b12ef6db0$export$a57d448e8969ce8a,
    faBookDead: $8063e68b12ef6db0$export$b98a3f8c3941a74a,
    faIdCard: $8063e68b12ef6db0$export$782ac893fc22249b,
    faDriversLicense: $8063e68b12ef6db0$export$8359c70e609eff64,
    faOutdent: $8063e68b12ef6db0$export$e21cfc4f23776bff,
    faDedent: $8063e68b12ef6db0$export$cbffb369d9299db7,
    faHeartCircleExclamation: $8063e68b12ef6db0$export$3772719b170306e2,
    faHouse: $8063e68b12ef6db0$export$dcadc0d67468dfa8,
    faHome: $8063e68b12ef6db0$export$48f10d71ec526479,
    faHomeAlt: $8063e68b12ef6db0$export$279659c4b23dbedb,
    faHomeLgAlt: $8063e68b12ef6db0$export$20d6d52d45f53262,
    faCalendarWeek: $8063e68b12ef6db0$export$39be5cb4aed5a521,
    faLaptopMedical: $8063e68b12ef6db0$export$ba2fa38f7bcc6930,
    faB: $8063e68b12ef6db0$export$fa30fcd1e0d0d8,
    faFileMedical: $8063e68b12ef6db0$export$56cbcd962389b090,
    faDiceOne: $8063e68b12ef6db0$export$d91800b7be5303b0,
    faKiwiBird: $8063e68b12ef6db0$export$d9933d91e1314d02,
    faArrowRightArrowLeft: $8063e68b12ef6db0$export$56b6d3d7d0e67a1c,
    faExchange: $8063e68b12ef6db0$export$1aab915ca61b734a,
    faRotateRight: $8063e68b12ef6db0$export$7f465bf410c6eff7,
    faRedoAlt: $8063e68b12ef6db0$export$50c037520c6cfdc1,
    faRotateForward: $8063e68b12ef6db0$export$2507849a0fdd7f64,
    faUtensils: $8063e68b12ef6db0$export$750d52edc1dafc7,
    faCutlery: $8063e68b12ef6db0$export$7034e54a8036c5c8,
    faArrowUpWideShort: $8063e68b12ef6db0$export$63f4908401ded049,
    faSortAmountUp: $8063e68b12ef6db0$export$28ef3e933e4b5364,
    faMillSign: $8063e68b12ef6db0$export$9b53510cf4010e4d,
    faBowlRice: $8063e68b12ef6db0$export$86079bc65a716451,
    faSkull: $8063e68b12ef6db0$export$138b45e2afb1dfa4,
    faTowerBroadcast: $8063e68b12ef6db0$export$fd06ff4ce9799eb0,
    faBroadcastTower: $8063e68b12ef6db0$export$f68b38d51f5c0ed,
    faTruckPickup: $8063e68b12ef6db0$export$f846b848b3ba3064,
    faUpLong: $8063e68b12ef6db0$export$5608156cc81126e7,
    faLongArrowAltUp: $8063e68b12ef6db0$export$43c8f2a46326c55f,
    faStop: $8063e68b12ef6db0$export$51577929c676143b,
    faCodeMerge: $8063e68b12ef6db0$export$e151fe5abf6db993,
    faUpload: $8063e68b12ef6db0$export$a9578350255b2b79,
    faHurricane: $8063e68b12ef6db0$export$4cf54a379be7e59a,
    faMound: $8063e68b12ef6db0$export$ac54ffffdb218383,
    faToiletPortable: $8063e68b12ef6db0$export$a3a5de5f6e2513ba,
    faCompactDisc: $8063e68b12ef6db0$export$84021631df0f831b,
    faFileArrowDown: $8063e68b12ef6db0$export$148bcede94488555,
    faFileDownload: $8063e68b12ef6db0$export$1013b9966d758343,
    faCaravan: $8063e68b12ef6db0$export$afb5d0eee7c1bdb,
    faShieldCat: $8063e68b12ef6db0$export$1639f087457d4f58,
    faBolt: $8063e68b12ef6db0$export$6869964aa308dd31,
    faZap: $8063e68b12ef6db0$export$d62abb82664f55ca,
    faGlassWater: $8063e68b12ef6db0$export$b80f542550a05ea7,
    faOilWell: $8063e68b12ef6db0$export$b69c6757012a2267,
    faVault: $8063e68b12ef6db0$export$4689a147513594a7,
    faMars: $8063e68b12ef6db0$export$a9f5c0b9c1e77a6f,
    faToilet: $8063e68b12ef6db0$export$505476859b9691c0,
    faPlaneCircleXmark: $8063e68b12ef6db0$export$94ef668f5108e431,
    faYenSign: $8063e68b12ef6db0$export$30f1437f5a4e991d,
    faCny: $8063e68b12ef6db0$export$268a23eee8f089a2,
    faJpy: $8063e68b12ef6db0$export$5460a9192eb79bf5,
    faRmb: $8063e68b12ef6db0$export$e2a8016afc962883,
    faYen: $8063e68b12ef6db0$export$cf914b1afb9455a2,
    faRubleSign: $8063e68b12ef6db0$export$1ae0a94c8ba4131a,
    faRouble: $8063e68b12ef6db0$export$c5dc3d98c4d8f2a5,
    faRub: $8063e68b12ef6db0$export$9c4d936240e1f0b1,
    faRuble: $8063e68b12ef6db0$export$6c0cf65134387046,
    faSun: $8063e68b12ef6db0$export$2fa35dcbc038dbe9,
    faGuitar: $8063e68b12ef6db0$export$790dd5b32282b6fb,
    faFaceLaughWink: $8063e68b12ef6db0$export$600a1b26b33c3d47,
    faLaughWink: $8063e68b12ef6db0$export$77ac40095f39933e,
    faHorseHead: $8063e68b12ef6db0$export$5bcca85203ebd1e8,
    faBoreHole: $8063e68b12ef6db0$export$cd79eeea6201e9d4,
    faIndustry: $8063e68b12ef6db0$export$5548c3eb51060fa8,
    faCircleDown: $8063e68b12ef6db0$export$531badb89cf01312,
    faArrowAltCircleDown: $8063e68b12ef6db0$export$ff3afbc8c0bc5d59,
    faArrowsTurnToDots: $8063e68b12ef6db0$export$b9d8fdf63999a76d,
    faFlorinSign: $8063e68b12ef6db0$export$6248ec7440b2ffcb,
    faArrowDownShortWide: $8063e68b12ef6db0$export$a51c464b699200ae,
    faSortAmountDesc: $8063e68b12ef6db0$export$93835bc31892b5c3,
    faSortAmountDownAlt: $8063e68b12ef6db0$export$e7d80d8c226cb77,
    faLessThan: $8063e68b12ef6db0$export$7f24f1bf98af5411,
    faAngleDown: $8063e68b12ef6db0$export$4b5be0142d10f342,
    faCarTunnel: $8063e68b12ef6db0$export$ec5cfe409de2ed37,
    faHeadSideCough: $8063e68b12ef6db0$export$3cd04b7c1624f598,
    faGripLines: $8063e68b12ef6db0$export$1412f35381064d7d,
    faThumbsDown: $8063e68b12ef6db0$export$aba24ca305bbe8c1,
    faUserLock: $8063e68b12ef6db0$export$d9b89b5872b67a4f,
    faArrowRightLong: $8063e68b12ef6db0$export$becbc35d3541bcc,
    faLongArrowRight: $8063e68b12ef6db0$export$7ec6527cf8651899,
    faAnchorCircleXmark: $8063e68b12ef6db0$export$f6773af4219eebd,
    faEllipsis: $8063e68b12ef6db0$export$37fe3659ba7b6b54,
    faEllipsisH: $8063e68b12ef6db0$export$c9f2fedd4489a2ee,
    faChessPawn: $8063e68b12ef6db0$export$3db75d5ac9e98468,
    faKitMedical: $8063e68b12ef6db0$export$f04e7a0f1033a0cd,
    faFirstAid: $8063e68b12ef6db0$export$5b01ccb2da4c4387,
    faPersonThroughWindow: $8063e68b12ef6db0$export$a77a2f6da72f89e3,
    faToolbox: $8063e68b12ef6db0$export$b34d64c205c732a9,
    faHandsHoldingCircle: $8063e68b12ef6db0$export$3aa81d0e606b08b6,
    faBug: $8063e68b12ef6db0$export$a18cfac400116d9f,
    faCreditCard: $8063e68b12ef6db0$export$3e7437bf6535bef0,
    faCreditCardAlt: $8063e68b12ef6db0$export$5fffe8e3c36964a2,
    faCar: $8063e68b12ef6db0$export$9eefe7fcdf123b76,
    faAutomobile: $8063e68b12ef6db0$export$240a6c53cf7ac525,
    faHandHoldingHand: $8063e68b12ef6db0$export$6638511b28df3be5,
    faBookOpenReader: $8063e68b12ef6db0$export$cb6e40528b98a5b,
    faBookReader: $8063e68b12ef6db0$export$cee14fe33262fa7d,
    faMountainSun: $8063e68b12ef6db0$export$af9eaee7db3ba7a9,
    faArrowsLeftRightToLine: $8063e68b12ef6db0$export$a63cecc8a4166c49,
    faDiceD20: $8063e68b12ef6db0$export$b06003a02c9055bd,
    faTruckDroplet: $8063e68b12ef6db0$export$41ce20639e8fef2b,
    faFileCircleXmark: $8063e68b12ef6db0$export$e4686afbe882e24a,
    faTemperatureArrowUp: $8063e68b12ef6db0$export$d7a5da41ce01461d,
    faTemperatureUp: $8063e68b12ef6db0$export$872345a0157330a3,
    faMedal: $8063e68b12ef6db0$export$b48a5be96314835a,
    faBed: $8063e68b12ef6db0$export$f24e0fce77994d4d,
    faSquareH: $8063e68b12ef6db0$export$51e3c5be06a49e32,
    faHSquare: $8063e68b12ef6db0$export$f08bbcf8f59eafc2,
    faPodcast: $8063e68b12ef6db0$export$5c0b4709125e92f8,
    faTemperatureFull: $8063e68b12ef6db0$export$bf4d97a79734997f,
    faTemperature4: $8063e68b12ef6db0$export$db946f8dc50a57ca,
    faThermometer4: $8063e68b12ef6db0$export$92b2e2293472dd50,
    faThermometerFull: $8063e68b12ef6db0$export$74e07083cef79a6f,
    faBell: $8063e68b12ef6db0$export$9b6162797ab1b255,
    faSuperscript: $8063e68b12ef6db0$export$4fa56a54e822dd25,
    faPlugCircleXmark: $8063e68b12ef6db0$export$12ef959394d63192,
    faStarOfLife: $8063e68b12ef6db0$export$aa3c4c1c5a47bf98,
    faPhoneSlash: $8063e68b12ef6db0$export$4c60a3aade08b6c2,
    faPaintRoller: $8063e68b12ef6db0$export$d1de8d1b815d6a5,
    faHandshakeAngle: $8063e68b12ef6db0$export$503f458ca5cf64c2,
    faHandsHelping: $8063e68b12ef6db0$export$287dbb1632da0d44,
    faLocationDot: $8063e68b12ef6db0$export$90a475e93ff4bb8a,
    faMapMarkerAlt: $8063e68b12ef6db0$export$4be92fa780613f93,
    faFile: $8063e68b12ef6db0$export$cad54bead856a678,
    faGreaterThan: $8063e68b12ef6db0$export$da07b6bc24a496ca,
    faPersonSwimming: $8063e68b12ef6db0$export$3fb4da6af843d39f,
    faSwimmer: $8063e68b12ef6db0$export$67daf2e2f88c1365,
    faArrowDown: $8063e68b12ef6db0$export$9686eff8d817f770,
    faDroplet: $8063e68b12ef6db0$export$cc1b6e60cb98fb90,
    faTint: $8063e68b12ef6db0$export$60dd975bd5938c15,
    faEraser: $8063e68b12ef6db0$export$e7fc4fe34e767f28,
    faEarthAmericas: $8063e68b12ef6db0$export$9c4218a898614082,
    faEarth: $8063e68b12ef6db0$export$c2118d3775773870,
    faEarthAmerica: $8063e68b12ef6db0$export$8b0f3a26397cf632,
    faGlobeAmericas: $8063e68b12ef6db0$export$e96bcc7bde9498db,
    faPersonBurst: $8063e68b12ef6db0$export$ae02241644924482,
    faDove: $8063e68b12ef6db0$export$a1ab1e69a300089f,
    faBatteryEmpty: $8063e68b12ef6db0$export$1344b64f6e922e12,
    faBattery0: $8063e68b12ef6db0$export$de8d0338927394c1,
    faSocks: $8063e68b12ef6db0$export$8d36a54dbf1e6bce,
    faInbox: $8063e68b12ef6db0$export$366b69cbdce46334,
    faSection: $8063e68b12ef6db0$export$a6f4f4a005d91fbd,
    faGaugeHigh: $8063e68b12ef6db0$export$d262c1f5912046e6,
    faTachometerAlt: $8063e68b12ef6db0$export$38dd17b9f064c10f,
    faTachometerAltFast: $8063e68b12ef6db0$export$e99d8b85f35b8ca5,
    faEnvelopeOpenText: $8063e68b12ef6db0$export$f5c53ce8ec380d11,
    faHospital: $8063e68b12ef6db0$export$7a76c9d35b42d691,
    faHospitalAlt: $8063e68b12ef6db0$export$cea7736417b94a3b,
    faHospitalWide: $8063e68b12ef6db0$export$69c8cc0360f017e8,
    faWineBottle: $8063e68b12ef6db0$export$770be8b3d5776043,
    faChessRook: $8063e68b12ef6db0$export$5d65c40a109eb09c,
    faBarsStaggered: $8063e68b12ef6db0$export$2f8a7938c06a2142,
    faReorder: $8063e68b12ef6db0$export$75d2bb378a2fc102,
    faStream: $8063e68b12ef6db0$export$ed81ab40fc4e904,
    faDharmachakra: $8063e68b12ef6db0$export$45cbd92c28deb2c7,
    faHotdog: $8063e68b12ef6db0$export$9fae219b4d3ce0be,
    faPersonWalkingWithCane: $8063e68b12ef6db0$export$2ffee5b2bc935c1f,
    faBlind: $8063e68b12ef6db0$export$923de21def6ea9b6,
    faDrum: $8063e68b12ef6db0$export$5b9205e1042594b7,
    faIceCream: $8063e68b12ef6db0$export$dd52741c60cc638f,
    faHeartCircleBolt: $8063e68b12ef6db0$export$2a376a9d0d8fee96,
    faFax: $8063e68b12ef6db0$export$b5698497901d7197,
    faParagraph: $8063e68b12ef6db0$export$dec46f8df1860e0,
    faCheckToSlot: $8063e68b12ef6db0$export$6999832247e52c2b,
    faVoteYea: $8063e68b12ef6db0$export$e87bb3db1608b850,
    faStarHalf: $8063e68b12ef6db0$export$228008b5e11032fa,
    faBoxesStacked: $8063e68b12ef6db0$export$2088efcf62cf3b1,
    faBoxes: $8063e68b12ef6db0$export$2007320dd6cde6db,
    faBoxesAlt: $8063e68b12ef6db0$export$e6ef1d896ed63b3e,
    faLink: $8063e68b12ef6db0$export$88bc01ff8dbecc55,
    faChain: $8063e68b12ef6db0$export$b5d071e02a25554f,
    faEarListen: $8063e68b12ef6db0$export$837bc776b490934d,
    faAssistiveListeningSystems: $8063e68b12ef6db0$export$8eeef3dc0035b165,
    faTreeCity: $8063e68b12ef6db0$export$ad95e4f80f98ebe0,
    faPlay: $8063e68b12ef6db0$export$436587205947bca5,
    faFont: $8063e68b12ef6db0$export$a5dc297d3f60936,
    faRupiahSign: $8063e68b12ef6db0$export$fe44d4c71644ea0,
    faMagnifyingGlass: $8063e68b12ef6db0$export$34c8b97060c09ff,
    faSearch: $8063e68b12ef6db0$export$871a78837687ffe8,
    faTableTennisPaddleBall: $8063e68b12ef6db0$export$eabe53838d45ac6a,
    faPingPongPaddleBall: $8063e68b12ef6db0$export$ebb246c621751737,
    faTableTennis: $8063e68b12ef6db0$export$f378fbb4e0ef7edf,
    faPersonDotsFromLine: $8063e68b12ef6db0$export$cdcec8ca7ec0d381,
    faDiagnoses: $8063e68b12ef6db0$export$68bad2b52a90d1fa,
    faTrashCanArrowUp: $8063e68b12ef6db0$export$60430351cdb4ba89,
    faTrashRestoreAlt: $8063e68b12ef6db0$export$d075b19b21cb9856,
    faNairaSign: $8063e68b12ef6db0$export$58b7558ca9822358,
    faCartArrowDown: $8063e68b12ef6db0$export$9206260ff0c0c616,
    faWalkieTalkie: $8063e68b12ef6db0$export$8a322f740d64e9fc,
    faFilePen: $8063e68b12ef6db0$export$27f34878d8ed7a76,
    faFileEdit: $8063e68b12ef6db0$export$e343e19f1757c5ae,
    faReceipt: $8063e68b12ef6db0$export$32b0cd6133c2742,
    faSquarePen: $8063e68b12ef6db0$export$3643b719db23d46e,
    faPenSquare: $8063e68b12ef6db0$export$fbb231ccb3d960bc,
    faPencilSquare: $8063e68b12ef6db0$export$35d253ecd249e771,
    faSuitcaseRolling: $8063e68b12ef6db0$export$957e62a9b80ff4e3,
    faPersonCircleExclamation: $8063e68b12ef6db0$export$38c8c32017dd9cc,
    faChevronDown: $8063e68b12ef6db0$export$8db9bc521720fccd,
    faBatteryFull: $8063e68b12ef6db0$export$9338fc4614cfc0cf,
    faBattery: $8063e68b12ef6db0$export$214720d39635cea8,
    faBattery5: $8063e68b12ef6db0$export$e426617482c711a7,
    faSkullCrossbones: $8063e68b12ef6db0$export$8717352b90217272,
    faCodeCompare: $8063e68b12ef6db0$export$ca4c5b4dcff58860,
    faListUl: $8063e68b12ef6db0$export$f8a219cf4f516384,
    faListDots: $8063e68b12ef6db0$export$e6f4ba30d84fa6ea,
    faSchoolLock: $8063e68b12ef6db0$export$8845cce2a763ee07,
    faTowerCell: $8063e68b12ef6db0$export$f4b64c3a138c1b59,
    faDownLong: $8063e68b12ef6db0$export$e88ba08d4f4d65b6,
    faLongArrowAltDown: $8063e68b12ef6db0$export$8b92530ca6418c2f,
    faRankingStar: $8063e68b12ef6db0$export$e6fd420a918b43b5,
    faChessKing: $8063e68b12ef6db0$export$d5713874f8fefe1b,
    faPersonHarassing: $8063e68b12ef6db0$export$dcd74f2821882a49,
    faBrazilianRealSign: $8063e68b12ef6db0$export$9d355b4e79216962,
    faLandmarkDome: $8063e68b12ef6db0$export$8a56136f40511e5d,
    faLandmarkAlt: $8063e68b12ef6db0$export$8b9c180efffc50ab,
    faArrowUp: $8063e68b12ef6db0$export$8e144ed4d52eef49,
    faTv: $8063e68b12ef6db0$export$e0cfed4ba2fe562c,
    faTelevision: $8063e68b12ef6db0$export$9803b0176917be28,
    faTvAlt: $8063e68b12ef6db0$export$6aa64ad5a1974ad7,
    faShrimp: $8063e68b12ef6db0$export$ac094c06f566cca3,
    faListCheck: $8063e68b12ef6db0$export$350a84fd0f833f4d,
    faTasks: $8063e68b12ef6db0$export$2f6d5b2fec286d63,
    faJugDetergent: $8063e68b12ef6db0$export$3fe50bd8062cd141,
    faCircleUser: $8063e68b12ef6db0$export$9a5c11a5e3d7f1e7,
    faUserCircle: $8063e68b12ef6db0$export$be7d974e9e0dba1a,
    faUserShield: $8063e68b12ef6db0$export$d1886bc596424e6c,
    faWind: $8063e68b12ef6db0$export$cc58cb0f2257a6a9,
    faCarBurst: $8063e68b12ef6db0$export$6d2be7c5d395dd16,
    faCarCrash: $8063e68b12ef6db0$export$8ff55566398404cd,
    faY: $8063e68b12ef6db0$export$b8c4c058fe7d193c,
    faPersonSnowboarding: $8063e68b12ef6db0$export$22c642403aeeaeaf,
    faSnowboarding: $8063e68b12ef6db0$export$72683772d587302a,
    faTruckFast: $8063e68b12ef6db0$export$27de16299ddd171,
    faShippingFast: $8063e68b12ef6db0$export$5e419f47aaeb3c05,
    faFish: $8063e68b12ef6db0$export$24228a855c5f6812,
    faUserGraduate: $8063e68b12ef6db0$export$10f5839059d22f7e,
    faCircleHalfStroke: $8063e68b12ef6db0$export$625fb3848216f28c,
    faAdjust: $8063e68b12ef6db0$export$cfa06e4b68edca2d,
    faClapperboard: $8063e68b12ef6db0$export$add3b381ced12554,
    faCircleRadiation: $8063e68b12ef6db0$export$55c8e3afd9f6c0b4,
    faRadiationAlt: $8063e68b12ef6db0$export$2f048fa82bbddf6f,
    faBaseball: $8063e68b12ef6db0$export$dc3654cf8a596fbf,
    faBaseballBall: $8063e68b12ef6db0$export$63a3f8ceae07c7f3,
    faJetFighterUp: $8063e68b12ef6db0$export$b024a52a4ccf5e69,
    faDiagramProject: $8063e68b12ef6db0$export$59c351869dc27435,
    faProjectDiagram: $8063e68b12ef6db0$export$30bf9f5b96509df1,
    faCopy: $8063e68b12ef6db0$export$e9bd786d30cb716c,
    faVolumeXmark: $8063e68b12ef6db0$export$28cc565c11db6f2e,
    faVolumeMute: $8063e68b12ef6db0$export$aa8decd057dfd29b,
    faVolumeTimes: $8063e68b12ef6db0$export$a1c7b36ba71dbeca,
    faHandSparkles: $8063e68b12ef6db0$export$72e2d874a963de0c,
    faGrip: $8063e68b12ef6db0$export$eb83fb404127db75,
    faGripHorizontal: $8063e68b12ef6db0$export$4a45308d6c8decc1,
    faShareFromSquare: $8063e68b12ef6db0$export$928280bdd54fa173,
    faShareSquare: $8063e68b12ef6db0$export$ae9e1434571f373c,
    faGun: $8063e68b12ef6db0$export$e18f576a7b31ba46,
    faSquarePhone: $8063e68b12ef6db0$export$318ed022991eef56,
    faPhoneSquare: $8063e68b12ef6db0$export$8ba22605a641ebdf,
    faPlus: $8063e68b12ef6db0$export$a105e7b44ca0eb9e,
    faAdd: $8063e68b12ef6db0$export$9e8f9a9d4ad32c0f,
    faExpand: $8063e68b12ef6db0$export$1fe4a9976a241685,
    faComputer: $8063e68b12ef6db0$export$9835883ce9d0fe78,
    faXmark: $8063e68b12ef6db0$export$e6e44779b2fa1a5c,
    faClose: $8063e68b12ef6db0$export$23c717133fd81476,
    faMultiply: $8063e68b12ef6db0$export$4ed4ff13d4dbc862,
    faRemove: $8063e68b12ef6db0$export$34810740c1bd6c54,
    faTimes: $8063e68b12ef6db0$export$174bd7f477b115b4,
    faArrowsUpDownLeftRight: $8063e68b12ef6db0$export$ff9a43e3a9cb653c,
    faArrows: $8063e68b12ef6db0$export$d5ae09a305d70340,
    faChalkboardUser: $8063e68b12ef6db0$export$fd7622d4b8d3674b,
    faChalkboardTeacher: $8063e68b12ef6db0$export$443fcf69b0155291,
    faPesoSign: $8063e68b12ef6db0$export$c8f99b9b5ea83555,
    faBuildingShield: $8063e68b12ef6db0$export$18ba6a500873dba9,
    faBaby: $8063e68b12ef6db0$export$8afab767536f59ad,
    faUsersLine: $8063e68b12ef6db0$export$d7e538fddb81da68,
    faQuoteLeft: $8063e68b12ef6db0$export$932a67a1b1a7a724,
    faQuoteLeftAlt: $8063e68b12ef6db0$export$95bb9ad3aa35c741,
    faTractor: $8063e68b12ef6db0$export$e87e41787bbedc98,
    faTrashArrowUp: $8063e68b12ef6db0$export$940cea0f5451895c,
    faTrashRestore: $8063e68b12ef6db0$export$d32f45a64ed40e8d,
    faArrowDownUpLock: $8063e68b12ef6db0$export$fc9f7bd981c34c45,
    faLinesLeaning: $8063e68b12ef6db0$export$4d384ffc907ddaff,
    faRulerCombined: $8063e68b12ef6db0$export$613f406c1b5802a8,
    faCopyright: $8063e68b12ef6db0$export$da61665fff8aebfe,
    faEquals: $8063e68b12ef6db0$export$a7c5f5e4805fdab,
    faBlender: $8063e68b12ef6db0$export$db34f7a6de38784f,
    faTeeth: $8063e68b12ef6db0$export$b4619aeaf0b9d18e,
    faShekelSign: $8063e68b12ef6db0$export$3570be7b68efb8db,
    faIls: $8063e68b12ef6db0$export$ecadeff45b05a451,
    faShekel: $8063e68b12ef6db0$export$27e0e10e74d98736,
    faSheqel: $8063e68b12ef6db0$export$28b3b26a80030d4e,
    faSheqelSign: $8063e68b12ef6db0$export$d84993fb5e8c6edd,
    faMap: $8063e68b12ef6db0$export$fc82fb79180cd17c,
    faRocket: $8063e68b12ef6db0$export$b24d84ed5657d89a,
    faPhotoFilm: $8063e68b12ef6db0$export$ed36ad335b36be22,
    faPhotoVideo: $8063e68b12ef6db0$export$739f6a6a12dfb6ed,
    faFolderMinus: $8063e68b12ef6db0$export$758f1fb3784e4080,
    faStore: $8063e68b12ef6db0$export$de59c2657a8ace67,
    faArrowTrendUp: $8063e68b12ef6db0$export$cf36928a9c52e98a,
    faPlugCircleMinus: $8063e68b12ef6db0$export$2a44d62160972254,
    faSignHanging: $8063e68b12ef6db0$export$5c1f29f4c7cad367,
    faSign: $8063e68b12ef6db0$export$d21d0d6c8e9e8bf9,
    faBezierCurve: $8063e68b12ef6db0$export$a527a6267c55a54c,
    faBellSlash: $8063e68b12ef6db0$export$6b31a1e5968b2378,
    faTablet: $8063e68b12ef6db0$export$1c92b67c45a4b4fc,
    faTabletAndroid: $8063e68b12ef6db0$export$5eddbb7c71278268,
    faSchoolFlag: $8063e68b12ef6db0$export$9b263780a7312c8c,
    faFill: $8063e68b12ef6db0$export$d3c2bcfd3b861e4a,
    faAngleUp: $8063e68b12ef6db0$export$887340269e6d6cac,
    faDrumstickBite: $8063e68b12ef6db0$export$482976e9a4ab10f3,
    faHollyBerry: $8063e68b12ef6db0$export$273296afacf93991,
    faChevronLeft: $8063e68b12ef6db0$export$75702e3e3dd44a44,
    faBacteria: $8063e68b12ef6db0$export$7fc18cf2d526c341,
    faHandLizard: $8063e68b12ef6db0$export$54608d0a883fea4d,
    faDisease: $8063e68b12ef6db0$export$c7675a37487adc45,
    faBriefcaseMedical: $8063e68b12ef6db0$export$5000f52ca9819bf5,
    faGenderless: $8063e68b12ef6db0$export$c093cc22e88981c2,
    faChevronRight: $8063e68b12ef6db0$export$930de8c26eb20490,
    faRetweet: $8063e68b12ef6db0$export$cebc76f79478e40e,
    faCarRear: $8063e68b12ef6db0$export$ff2b8d5628da5f14,
    faCarAlt: $8063e68b12ef6db0$export$7937ed2462a665c0,
    faPumpSoap: $8063e68b12ef6db0$export$821aeede187f23c9,
    faVideoSlash: $8063e68b12ef6db0$export$a714fc79f58cc9ef,
    faBatteryQuarter: $8063e68b12ef6db0$export$acec92052ac2183,
    faBattery2: $8063e68b12ef6db0$export$23ca8a94c555576,
    faRadio: $8063e68b12ef6db0$export$11b26516cae2104f,
    faBabyCarriage: $8063e68b12ef6db0$export$3b3ab4d86bad7d26,
    faCarriageBaby: $8063e68b12ef6db0$export$9f117d92ccd36cf1,
    faTrafficLight: $8063e68b12ef6db0$export$bf0b19daceaec9c2,
    faThermometer: $8063e68b12ef6db0$export$f576739e9b18ea4f,
    faVrCardboard: $8063e68b12ef6db0$export$248171cb6dad4307,
    faHandMiddleFinger: $8063e68b12ef6db0$export$bd40d3a3a16fb147,
    faPercent: $8063e68b12ef6db0$export$89a1764fbb7ad2cb,
    faPercentage: $8063e68b12ef6db0$export$89333857fc063a2e,
    faTruckMoving: $8063e68b12ef6db0$export$a06617a1a4ccea67,
    faGlassWaterDroplet: $8063e68b12ef6db0$export$b7ae54b4078b2060,
    faDisplay: $8063e68b12ef6db0$export$e9d85839f7751f01,
    faFaceSmile: $8063e68b12ef6db0$export$b5023c446f10324,
    faSmile: $8063e68b12ef6db0$export$c632b2334f0913bc,
    faThumbtack: $8063e68b12ef6db0$export$b6314cdc01bb5c43,
    faThumbTack: $8063e68b12ef6db0$export$b63d0c7b519a9aae,
    faTrophy: $8063e68b12ef6db0$export$29c432d69ccf85a5,
    faPersonPraying: $8063e68b12ef6db0$export$8ecd436ef91fc02e,
    faPray: $8063e68b12ef6db0$export$3b32c982141cad51,
    faHammer: $8063e68b12ef6db0$export$6310f315e1ebbca5,
    faHandPeace: $8063e68b12ef6db0$export$e49e3cfceea441cc,
    faRotate: $8063e68b12ef6db0$export$decde496a29c5b23,
    faSyncAlt: $8063e68b12ef6db0$export$2ff2056be8c281e4,
    faSpinner: $8063e68b12ef6db0$export$1025ad641edb49c2,
    faRobot: $8063e68b12ef6db0$export$30a5bb4ad3fa716c,
    faPeace: $8063e68b12ef6db0$export$8614cb1326eacd7a,
    faGears: $8063e68b12ef6db0$export$4aac79b9ae3cfdb8,
    faCogs: $8063e68b12ef6db0$export$af1575770afc9559,
    faWarehouse: $8063e68b12ef6db0$export$e3a174a50618c208,
    faArrowUpRightDots: $8063e68b12ef6db0$export$bc804c6ab898f610,
    faSplotch: $8063e68b12ef6db0$export$d6f21e17ea797702,
    faFaceGrinHearts: $8063e68b12ef6db0$export$fbb22081b65e4f33,
    faGrinHearts: $8063e68b12ef6db0$export$c56cf0e0c3bc5ed2,
    faDiceFour: $8063e68b12ef6db0$export$2df6451abf70a6ff,
    faSimCard: $8063e68b12ef6db0$export$3bee83bf278fddbe,
    faTransgender: $8063e68b12ef6db0$export$7e3f1701aa95ef01,
    faTransgenderAlt: $8063e68b12ef6db0$export$9c36cf9334c052f,
    faMercury: $8063e68b12ef6db0$export$e134ecd00b622a47,
    faArrowTurnDown: $8063e68b12ef6db0$export$fd4d6cfd52703f50,
    faLevelDown: $8063e68b12ef6db0$export$3794c07e7a666c94,
    faPersonFallingBurst: $8063e68b12ef6db0$export$a75569baaf4a6c3a,
    faAward: $8063e68b12ef6db0$export$f8db2747dadd48f7,
    faTicketSimple: $8063e68b12ef6db0$export$68ddda3b30ba09f0,
    faTicketAlt: $8063e68b12ef6db0$export$75e38ba471fd89c4,
    faBuilding: $8063e68b12ef6db0$export$f26673f8b10c3d46,
    faAnglesLeft: $8063e68b12ef6db0$export$2ebd565813951f81,
    faAngleDoubleLeft: $8063e68b12ef6db0$export$21b0833b3cf929a7,
    faQrcode: $8063e68b12ef6db0$export$fc19ca0fe15e73bc,
    faClockRotateLeft: $8063e68b12ef6db0$export$29be1665d1b36a3b,
    faHistory: $8063e68b12ef6db0$export$76d1986559ca7b7a,
    faFaceGrinBeamSweat: $8063e68b12ef6db0$export$2ff38f330c834084,
    faGrinBeamSweat: $8063e68b12ef6db0$export$14d0ccc54c5b6826,
    faFileExport: $8063e68b12ef6db0$export$364f19abcfac1b0a,
    faArrowRightFromFile: $8063e68b12ef6db0$export$b9c76255b38e1df1,
    faShield: $8063e68b12ef6db0$export$8241bd5b9163ca12,
    faShieldBlank: $8063e68b12ef6db0$export$64f54da8fbaba8ee,
    faArrowUpShortWide: $8063e68b12ef6db0$export$be9d5060a4bc3b4b,
    faSortAmountUpAlt: $8063e68b12ef6db0$export$6e87844b0f151b6a,
    faHouseMedical: $8063e68b12ef6db0$export$2d077da983246a68,
    faGolfBallTee: $8063e68b12ef6db0$export$14c9f1d85e53ae99,
    faGolfBall: $8063e68b12ef6db0$export$2251487a9a33c682,
    faCircleChevronLeft: $8063e68b12ef6db0$export$f2b13ad44c03c40f,
    faChevronCircleLeft: $8063e68b12ef6db0$export$4a42c8c2451a33fd,
    faHouseChimneyWindow: $8063e68b12ef6db0$export$792391babe46862d,
    faPenNib: $8063e68b12ef6db0$export$a82594dcc75a49f5,
    faTentArrowTurnLeft: $8063e68b12ef6db0$export$89af87b7d6c15adf,
    faTents: $8063e68b12ef6db0$export$c93b950e845a4ee7,
    faWandMagic: $8063e68b12ef6db0$export$8282f5f5dcf6b009,
    faMagic: $8063e68b12ef6db0$export$e58f9b502d4dd52d,
    faDog: $8063e68b12ef6db0$export$c6406747800cf702,
    faCarrot: $8063e68b12ef6db0$export$28e93ec9f5e2ddf3,
    faMoon: $8063e68b12ef6db0$export$c4c2f69a53bab720,
    faWineGlassEmpty: $8063e68b12ef6db0$export$b86d7336e68a3f57,
    faWineGlassAlt: $8063e68b12ef6db0$export$b8ff3fe2b78aef2f,
    faCheese: $8063e68b12ef6db0$export$549b99473b7201e6,
    faYinYang: $8063e68b12ef6db0$export$6ec1acbf3f610b8f,
    faMusic: $8063e68b12ef6db0$export$fcb0647a5340b5b8,
    faCodeCommit: $8063e68b12ef6db0$export$d5d870c10bc9f1ce,
    faTemperatureLow: $8063e68b12ef6db0$export$9e9af12b90a1abd2,
    faPersonBiking: $8063e68b12ef6db0$export$cf152282d5de300d,
    faBiking: $8063e68b12ef6db0$export$a5bcf835dbf9c0b,
    faBroom: $8063e68b12ef6db0$export$2a533051418ff4ca,
    faShieldHeart: $8063e68b12ef6db0$export$7b96388ca2be471b,
    faGopuram: $8063e68b12ef6db0$export$31f89d8ac1d14ed6,
    faEarthOceania: $8063e68b12ef6db0$export$bd931e906edf2f47,
    faGlobeOceania: $8063e68b12ef6db0$export$8ac3f5271448657d,
    faSquareXmark: $8063e68b12ef6db0$export$5a17e58bb7afb1d7,
    faTimesSquare: $8063e68b12ef6db0$export$c0248ac97142ea2a,
    faXmarkSquare: $8063e68b12ef6db0$export$9a364781d6b7602b,
    faHashtag: $8063e68b12ef6db0$export$c92c903bade56844,
    faUpRightAndDownLeftFromCenter: $8063e68b12ef6db0$export$95457ede07b81517,
    faExpandAlt: $8063e68b12ef6db0$export$bcb8d86a3a1d6eb6,
    faOilCan: $8063e68b12ef6db0$export$2599126c3a57f727,
    faT: $8063e68b12ef6db0$export$6e625d2e7790c860,
    faHippo: $8063e68b12ef6db0$export$d4c909619093de2d,
    faChartColumn: $8063e68b12ef6db0$export$d01ddcc9efe7b149,
    faInfinity: $8063e68b12ef6db0$export$a590003279d671b8,
    faVialCircleCheck: $8063e68b12ef6db0$export$2db4f9712313eafa,
    faPersonArrowDownToLine: $8063e68b12ef6db0$export$f9a5161975928326,
    faVoicemail: $8063e68b12ef6db0$export$4f1ce88b2b4cd5cd,
    faFan: $8063e68b12ef6db0$export$55145a3dae4f984a,
    faPersonWalkingLuggage: $8063e68b12ef6db0$export$1ae0a37b36ace746,
    faUpDown: $8063e68b12ef6db0$export$e36c32dd5cba9b90,
    faArrowsAltV: $8063e68b12ef6db0$export$138cb56a3f8f7040,
    faCloudMoonRain: $8063e68b12ef6db0$export$301c3fab0c4545bd,
    faCalendar: $8063e68b12ef6db0$export$34f5c36a3e80efa2,
    faTrailer: $8063e68b12ef6db0$export$3a48b9820e92f5ab,
    faBahai: $8063e68b12ef6db0$export$6d636565b3ec36b4,
    faHaykal: $8063e68b12ef6db0$export$5c15e34e0e43f15c,
    faSdCard: $8063e68b12ef6db0$export$303efb6031da122,
    faDragon: $8063e68b12ef6db0$export$ae1875ba975aa0e9,
    faShoePrints: $8063e68b12ef6db0$export$cdbdd2118099ae07,
    faCirclePlus: $8063e68b12ef6db0$export$eeda28b8ca4cb18e,
    faPlusCircle: $8063e68b12ef6db0$export$d9cc3a81499af48c,
    faFaceGrinTongueWink: $8063e68b12ef6db0$export$4272e56f2429da88,
    faGrinTongueWink: $8063e68b12ef6db0$export$58099903d50aefb3,
    faHandHolding: $8063e68b12ef6db0$export$e6094d25274088ab,
    faPlugCircleExclamation: $8063e68b12ef6db0$export$d893dd9509763a17,
    faLinkSlash: $8063e68b12ef6db0$export$22965c7f4d903953,
    faChainBroken: $8063e68b12ef6db0$export$382551e04f32620a,
    faChainSlash: $8063e68b12ef6db0$export$12f09d657be59586,
    faUnlink: $8063e68b12ef6db0$export$2f546f7d8ba01e18,
    faClone: $8063e68b12ef6db0$export$76c1aa4bf9a39458,
    faPersonWalkingArrowLoopLeft: $8063e68b12ef6db0$export$5a200e8504b7367a,
    faArrowUpZA: $8063e68b12ef6db0$export$a0a53d8e3c68e9f1,
    faSortAlphaUpAlt: $8063e68b12ef6db0$export$95ef20828693fb0f,
    faFireFlameCurved: $8063e68b12ef6db0$export$769724fc1434d618,
    faFireAlt: $8063e68b12ef6db0$export$70dc26b4926d0b1b,
    faTornado: $8063e68b12ef6db0$export$6d274258ba4b0089,
    faFileCirclePlus: $8063e68b12ef6db0$export$430d63b54b1d4009,
    faBookQuran: $8063e68b12ef6db0$export$ad3212bc3fa1595b,
    faQuran: $8063e68b12ef6db0$export$46f29ea84ed4c5f1,
    faAnchor: $8063e68b12ef6db0$export$12a35719f889cd1,
    faBorderAll: $8063e68b12ef6db0$export$93a5eb721c9c0d25,
    faFaceAngry: $8063e68b12ef6db0$export$67a047c738fb34da,
    faAngry: $8063e68b12ef6db0$export$3c96c08e234498c5,
    faCookieBite: $8063e68b12ef6db0$export$317dde8664f7de71,
    faArrowTrendDown: $8063e68b12ef6db0$export$d2caed5e37174c23,
    faRss: $8063e68b12ef6db0$export$7329a1ca27b90c5b,
    faFeed: $8063e68b12ef6db0$export$67ad3d0233cd7b33,
    faDrawPolygon: $8063e68b12ef6db0$export$df9bd3777d1154d2,
    faScaleBalanced: $8063e68b12ef6db0$export$33fb4280dc20f0dd,
    faBalanceScale: $8063e68b12ef6db0$export$fec323dcfd81d750,
    faGaugeSimpleHigh: $8063e68b12ef6db0$export$cc4351eb13da27d8,
    faTachometer: $8063e68b12ef6db0$export$362d0f652c3fbca2,
    faTachometerFast: $8063e68b12ef6db0$export$375b6a8680f980ed,
    faShower: $8063e68b12ef6db0$export$f7f7c15f18cc19a1,
    faDesktop: $8063e68b12ef6db0$export$6e6ddc253102e596,
    faDesktopAlt: $8063e68b12ef6db0$export$ff09a62b9e0fa899,
    faM: $8063e68b12ef6db0$export$bd6a7788954842b5,
    faTableList: $8063e68b12ef6db0$export$6e989c3c7050dbb,
    faThList: $8063e68b12ef6db0$export$daf2614a457122c0,
    faCommentSms: $8063e68b12ef6db0$export$435fe17e9d6170d6,
    faSms: $8063e68b12ef6db0$export$9dbcc3443daa7323,
    faBook: $8063e68b12ef6db0$export$c9d7ef726d1a8742,
    faUserPlus: $8063e68b12ef6db0$export$4c17261776a709f2,
    faCheck: $8063e68b12ef6db0$export$62b2c752fccc6a9c,
    faBatteryThreeQuarters: $8063e68b12ef6db0$export$cfb37069d38f379e,
    faBattery4: $8063e68b12ef6db0$export$35ffefed200d123c,
    faHouseCircleCheck: $8063e68b12ef6db0$export$c9382fa3394ef53a,
    faAngleLeft: $8063e68b12ef6db0$export$3cbcd1b7e35945d2,
    faDiagramSuccessor: $8063e68b12ef6db0$export$ff7f40159cadb0ac,
    faTruckArrowRight: $8063e68b12ef6db0$export$d69fa2b7839ce76,
    faArrowsSplitUpAndLeft: $8063e68b12ef6db0$export$7df274119d2469d1,
    faHandFist: $8063e68b12ef6db0$export$ca492f58fe30a42f,
    faFistRaised: $8063e68b12ef6db0$export$fa0323a4d7489a8d,
    faCloudMoon: $8063e68b12ef6db0$export$482eb125aaf0fbc2,
    faBriefcase: $8063e68b12ef6db0$export$8da450d063b0eb37,
    faPersonFalling: $8063e68b12ef6db0$export$e94ab3a30cf4aca5,
    faImagePortrait: $8063e68b12ef6db0$export$c23fd8b91a7ed48,
    faPortrait: $8063e68b12ef6db0$export$e3d25f819c7ee7d7,
    faUserTag: $8063e68b12ef6db0$export$9eec597148166b36,
    faRug: $8063e68b12ef6db0$export$7cee7480f25f5289,
    faEarthEurope: $8063e68b12ef6db0$export$7adefae4a1be1d97,
    faGlobeEurope: $8063e68b12ef6db0$export$5318b8ede86cc96b,
    faCartFlatbedSuitcase: $8063e68b12ef6db0$export$ab81ff863770d996,
    faLuggageCart: $8063e68b12ef6db0$export$bd1e24dd3cde8514,
    faRectangleXmark: $8063e68b12ef6db0$export$3896694b3e81fba7,
    faRectangleTimes: $8063e68b12ef6db0$export$eaaf26416a51dc1,
    faTimesRectangle: $8063e68b12ef6db0$export$10147c0014152a3f,
    faWindowClose: $8063e68b12ef6db0$export$18b7775f78a3e16,
    faBahtSign: $8063e68b12ef6db0$export$ffc7123046a28ee,
    faBookOpen: $8063e68b12ef6db0$export$8a3071811b2b7979,
    faBookJournalWhills: $8063e68b12ef6db0$export$d3d49030d557a09b,
    faJournalWhills: $8063e68b12ef6db0$export$66a0d8d45aab6631,
    faHandcuffs: $8063e68b12ef6db0$export$74d1f89b5feb9d42,
    faTriangleExclamation: $8063e68b12ef6db0$export$1cbf6e649ce86166,
    faExclamationTriangle: $8063e68b12ef6db0$export$3d249b63b52cce7c,
    faWarning: $8063e68b12ef6db0$export$2e470a35c38b096a,
    faDatabase: $8063e68b12ef6db0$export$24680dede86b1883,
    faShare: $8063e68b12ef6db0$export$c08b4b0e2b0dc027,
    faArrowTurnRight: $8063e68b12ef6db0$export$f20385ecfa20c36e,
    faMailForward: $8063e68b12ef6db0$export$81df7693d3f2f8da,
    faBottleDroplet: $8063e68b12ef6db0$export$8f534e1e0ab75bfe,
    faMaskFace: $8063e68b12ef6db0$export$140d4da0adbaf435,
    faHillRockslide: $8063e68b12ef6db0$export$7ec15a32285f6c22,
    faRightLeft: $8063e68b12ef6db0$export$a082af56be9786ae,
    faExchangeAlt: $8063e68b12ef6db0$export$f6c6fb20d374b128,
    faPaperPlane: $8063e68b12ef6db0$export$b5378818301da1be,
    faRoadCircleExclamation: $8063e68b12ef6db0$export$79753c2153535b01,
    faDungeon: $8063e68b12ef6db0$export$1156dc6acb0058bd,
    faAlignRight: $8063e68b12ef6db0$export$7370f36a39a38737,
    faMoneyBill1Wave: $8063e68b12ef6db0$export$52e3e96cd1564779,
    faMoneyBillWaveAlt: $8063e68b12ef6db0$export$1613858e873cbb3e,
    faLifeRing: $8063e68b12ef6db0$export$53dd2cacf674142a,
    faHands: $8063e68b12ef6db0$export$f9712d0cf5150f0c,
    faSignLanguage: $8063e68b12ef6db0$export$20993813350f9671,
    faSigning: $8063e68b12ef6db0$export$5cc0e6f5191f4f02,
    faCalendarDay: $8063e68b12ef6db0$export$80968bcfef6481ca,
    faWaterLadder: $8063e68b12ef6db0$export$5930e9bdfd790d77,
    faLadderWater: $8063e68b12ef6db0$export$c5ea6eeef2db2b3b,
    faSwimmingPool: $8063e68b12ef6db0$export$4dee691631c67d5c,
    faArrowsUpDown: $8063e68b12ef6db0$export$64185f27d82c259f,
    faArrowsV: $8063e68b12ef6db0$export$cec5f1bc9e068e48,
    faFaceGrimace: $8063e68b12ef6db0$export$bd5bd2ef56b793b1,
    faGrimace: $8063e68b12ef6db0$export$3d08cd36ac1ef231,
    faWheelchairMove: $8063e68b12ef6db0$export$1482162f7fe04ac,
    faWheelchairAlt: $8063e68b12ef6db0$export$7db9460785019040,
    faTurnDown: $8063e68b12ef6db0$export$b5dc9dd0347bbb6,
    faLevelDownAlt: $8063e68b12ef6db0$export$c07eb6ff5a382cbd,
    faPersonWalkingArrowRight: $8063e68b12ef6db0$export$3e15790fe68c095b,
    faSquareEnvelope: $8063e68b12ef6db0$export$15da4ef8c0fb20d6,
    faEnvelopeSquare: $8063e68b12ef6db0$export$354e159473e73552,
    faDice: $8063e68b12ef6db0$export$4ed8206e6619cc8f,
    faBowlingBall: $8063e68b12ef6db0$export$5ee2640fe105312d,
    faBrain: $8063e68b12ef6db0$export$97fa4f4c1006ab1,
    faBandage: $8063e68b12ef6db0$export$658a137d3845bca7,
    faBandAid: $8063e68b12ef6db0$export$b14a1014df2fdf46,
    faCalendarMinus: $8063e68b12ef6db0$export$23e8b4955c2d951b,
    faCircleXmark: $8063e68b12ef6db0$export$30262489773a79a3,
    faTimesCircle: $8063e68b12ef6db0$export$ab0ec50720a747eb,
    faXmarkCircle: $8063e68b12ef6db0$export$90ac4096df8efdee,
    faGifts: $8063e68b12ef6db0$export$de9a67b55dbe819a,
    faHotel: $8063e68b12ef6db0$export$c402efcf01d5ca07,
    faEarthAsia: $8063e68b12ef6db0$export$807cdd395fe012cb,
    faGlobeAsia: $8063e68b12ef6db0$export$796fdfc909e603f4,
    faIdCardClip: $8063e68b12ef6db0$export$31e6961064ddac7b,
    faIdCardAlt: $8063e68b12ef6db0$export$dc37ebbac31f6c6c,
    faMagnifyingGlassPlus: $8063e68b12ef6db0$export$f48a3ba52a0a9e56,
    faSearchPlus: $8063e68b12ef6db0$export$378f00e6b1a8185,
    faThumbsUp: $8063e68b12ef6db0$export$47e4e0d519d33497,
    faUserClock: $8063e68b12ef6db0$export$b00596a09aa07311,
    faHandDots: $8063e68b12ef6db0$export$8846d49caaed1c0a,
    faAllergies: $8063e68b12ef6db0$export$dcae2101babbffff,
    faFileInvoice: $8063e68b12ef6db0$export$bef39294aed2281a,
    faWindowMinimize: $8063e68b12ef6db0$export$26a3f9d2784b90d8,
    faMugSaucer: $8063e68b12ef6db0$export$60048819854688c5,
    faCoffee: $8063e68b12ef6db0$export$1d24a9e457278011,
    faBrush: $8063e68b12ef6db0$export$5824ffe6f8983c83,
    faMask: $8063e68b12ef6db0$export$7b028758c03b9655,
    faMagnifyingGlassMinus: $8063e68b12ef6db0$export$56d810b9ab2e30bc,
    faSearchMinus: $8063e68b12ef6db0$export$efca97eef6a7a17d,
    faRulerVertical: $8063e68b12ef6db0$export$a6ad5df9d9f29553,
    faUserLarge: $8063e68b12ef6db0$export$50a28538498238f,
    faUserAlt: $8063e68b12ef6db0$export$ae9b19c2ac726cfc,
    faTrainTram: $8063e68b12ef6db0$export$d401d4aeba21cdf3,
    faUserNurse: $8063e68b12ef6db0$export$ab9af5aa013d2162,
    faSyringe: $8063e68b12ef6db0$export$1aa9423ec6b1d609,
    faCloudSun: $8063e68b12ef6db0$export$dcaadfd9c98e42a1,
    faStopwatch20: $8063e68b12ef6db0$export$df6244b0501f2112,
    faSquareFull: $8063e68b12ef6db0$export$7ec6541fee081990,
    faMagnet: $8063e68b12ef6db0$export$78932e9c9abea6b7,
    faJar: $8063e68b12ef6db0$export$53583b459a87a01,
    faNoteSticky: $8063e68b12ef6db0$export$4a4e034527c933f5,
    faStickyNote: $8063e68b12ef6db0$export$80889adc5d98bf4a,
    faBugSlash: $8063e68b12ef6db0$export$fc4dd5feed8df23,
    faArrowUpFromWaterPump: $8063e68b12ef6db0$export$1a093e7861c5e48f,
    faBone: $8063e68b12ef6db0$export$5902c007d5703f2d,
    faUserInjured: $8063e68b12ef6db0$export$c950c1ba7f227d5b,
    faFaceSadTear: $8063e68b12ef6db0$export$8a5a0dbb2a17e253,
    faSadTear: $8063e68b12ef6db0$export$4b5241926f692f91,
    faPlane: $8063e68b12ef6db0$export$f654c69e66b466c0,
    faTentArrowsDown: $8063e68b12ef6db0$export$51adfe7c9ee4f428,
    faExclamation: $8063e68b12ef6db0$export$de6218b649cbb6a9,
    faArrowsSpin: $8063e68b12ef6db0$export$7e05388be208e313,
    faPrint: $8063e68b12ef6db0$export$ae64371e02ee8e56,
    faTurkishLiraSign: $8063e68b12ef6db0$export$b458d393151b6960,
    faTry: $8063e68b12ef6db0$export$970dda513e46c41f,
    faTurkishLira: $8063e68b12ef6db0$export$40e66e5966827199,
    faDollarSign: $8063e68b12ef6db0$export$fb420d3e4d8c6a18,
    faDollar: $8063e68b12ef6db0$export$a4ffb0775547fcdf,
    faUsd: $8063e68b12ef6db0$export$72cca07d38a28589,
    faX: $8063e68b12ef6db0$export$476af662c0c32cbc,
    faMagnifyingGlassDollar: $8063e68b12ef6db0$export$fa4f1ead37dc1dce,
    faSearchDollar: $8063e68b12ef6db0$export$65b49a6767630708,
    faUsersGear: $8063e68b12ef6db0$export$3a18218720110fc0,
    faUsersCog: $8063e68b12ef6db0$export$5e0b06753fc69b81,
    faPersonMilitaryPointing: $8063e68b12ef6db0$export$50b6dcaa9ec03439,
    faBuildingColumns: $8063e68b12ef6db0$export$a411e7e26cb63d5e,
    faBank: $8063e68b12ef6db0$export$6e379b829ea8b99,
    faInstitution: $8063e68b12ef6db0$export$1dba320226a34c1f,
    faMuseum: $8063e68b12ef6db0$export$9b3953adff472ad2,
    faUniversity: $8063e68b12ef6db0$export$f2e1460ebe1a8cb0,
    faUmbrella: $8063e68b12ef6db0$export$9ff64ffae70e08c0,
    faTrowel: $8063e68b12ef6db0$export$12ca996a6f686fe1,
    faD: $8063e68b12ef6db0$export$56c73b799aac2555,
    faStapler: $8063e68b12ef6db0$export$c7e014b7e3ac3d83,
    faMasksTheater: $8063e68b12ef6db0$export$bf5896cc1ce4d55,
    faTheaterMasks: $8063e68b12ef6db0$export$3dbedc487b0159ac,
    faKipSign: $8063e68b12ef6db0$export$a6df39524c41472c,
    faHandPointLeft: $8063e68b12ef6db0$export$b276ec3dc9760d39,
    faHandshakeSimple: $8063e68b12ef6db0$export$e8485db4dab0ab30,
    faHandshakeAlt: $8063e68b12ef6db0$export$e9aa3c6f9f47aa1a,
    faJetFighter: $8063e68b12ef6db0$export$2130e629ab767ab3,
    faFighterJet: $8063e68b12ef6db0$export$102b809faf56e033,
    faSquareShareNodes: $8063e68b12ef6db0$export$1bdb0ec5af3fea99,
    faShareAltSquare: $8063e68b12ef6db0$export$3799c2d8fd7e493b,
    faBarcode: $8063e68b12ef6db0$export$3825a842b5afc5aa,
    faPlusMinus: $8063e68b12ef6db0$export$37bd38cf96417095,
    faVideo: $8063e68b12ef6db0$export$5c6bd8729527871b,
    faVideoCamera: $8063e68b12ef6db0$export$3a530df752193ccf,
    faGraduationCap: $8063e68b12ef6db0$export$874e305fd7920cce,
    faMortarBoard: $8063e68b12ef6db0$export$dd0a013bf23a9d86,
    faHandHoldingMedical: $8063e68b12ef6db0$export$bb2a6b1b5e852300,
    faPersonCircleCheck: $8063e68b12ef6db0$export$30294c81ac4031ca,
    faTurnUp: $8063e68b12ef6db0$export$314f5cab62fc6968,
    faLevelUpAlt: $8063e68b12ef6db0$export$d6f21a309b179c3d
};


(0, $3eb82f4a8c2ab734$export$b839f963c7dc0e34).add((0, $8063e68b12ef6db0$export$62b2c752fccc6a9c), (0, $8063e68b12ef6db0$export$7e9f0928967e03b), (0, $8063e68b12ef6db0$export$b44eb38345c6a964), (0, $8063e68b12ef6db0$export$864bb8d6c21fb792));
const $fbd756dc65caa6ce$var$router = (0, $689dddd804f8aa0f$export$baddd0131ee8c05b)({
    history: (0, $689dddd804f8aa0f$export$7b4942f78e7b8a49)(),
    routes: [
        {
            path: "/",
            component: (0, $fda6e9655def196e$export$2e2bcd8739ae039)
        },
        {
            path: "/data-safety",
            component: (0, $f011be922a1a6f1f$export$2e2bcd8739ae039)
        },
        {
            path: "/ugc",
            component: (0, $adf9be45d142e894$export$2e2bcd8739ae039)
        }
    ]
});
const $fbd756dc65caa6ce$var$app = (0, $NPJVB.createApp)((0, $121eff3ddb6a1cde$export$2e2bcd8739ae039)).component("font-awesome-icon", (0, $04a335241c34e8c3$export$2b9260d4a45c8710));
const $fbd756dc65caa6ce$var$head = (0, $4PQtJ.a)();
$fbd756dc65caa6ce$var$app.use($fbd756dc65caa6ce$var$head);
$fbd756dc65caa6ce$var$app.use($fbd756dc65caa6ce$var$router);
$fbd756dc65caa6ce$var$app.use((0, $6x6HK.VueRecaptchaPlugin), {
    v3SiteKey: "6LfBb9UmAAAAANTZPQqdRE5nVLjhTawo1RBE3MeW"
});
$fbd756dc65caa6ce$var$app.mount("#app");


//# sourceMappingURL=index.7ff8ac53.js.map
